"use strict";

var cov_18skq7nj67 = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\core\\langnames.js";
  var hash = "688cae152f27be0332fed742024874b8fa75c05e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\core\\langnames.js",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 27
        },
        end: {
          line: 21,
          column: 1
        }
      },
      "1": {
        start: {
          line: 5,
          column: 19
        },
        end: {
          line: 5,
          column: 74
        }
      },
      "2": {
        start: {
          line: 5,
          column: 46
        },
        end: {
          line: 5,
          column: 70
        }
      },
      "3": {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 19,
          column: 3
        }
      },
      "4": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 18,
          column: 6
        }
      },
      "5": {
        start: {
          line: 20,
          column: 2
        },
        end: {
          line: 20,
          column: 18
        }
      },
      "6": {
        start: {
          line: 23,
          column: 31
        },
        end: {
          line: 27,
          column: 1
        }
      },
      "7": {
        start: {
          line: 24,
          column: 19
        },
        end: {
          line: 24,
          column: 44
        }
      },
      "8": {
        start: {
          line: 25,
          column: 23
        },
        end: {
          line: 25,
          column: 52
        }
      },
      "9": {
        start: {
          line: 26,
          column: 2
        },
        end: {
          line: 26,
          column: 22
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 27
          },
          end: {
            line: 3,
            column: 28
          }
        },
        loc: {
          start: {
            line: 3,
            column: 45
          },
          end: {
            line: 21,
            column: 1
          }
        },
        line: 3
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 5,
            column: 36
          },
          end: {
            line: 5,
            column: 37
          }
        },
        loc: {
          start: {
            line: 5,
            column: 46
          },
          end: {
            line: 5,
            column: 70
          }
        },
        line: 5
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 23,
            column: 31
          },
          end: {
            line: 23,
            column: 32
          }
        },
        loc: {
          start: {
            line: 23,
            column: 49
          },
          end: {
            line: 27,
            column: 1
          }
        },
        line: 23
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 19,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 19,
            column: 3
          }
        }, {
          start: {
            line: 6,
            column: 2
          },
          end: {
            line: 19,
            column: 3
          }
        }],
        line: 6
      },
      "1": {
        loc: {
          start: {
            line: 25,
            column: 23
          },
          end: {
            line: 25,
            column: 52
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 25,
            column: 34
          },
          end: {
            line: 25,
            column: 45
          }
        }, {
          start: {
            line: 25,
            column: 48
          },
          end: {
            line: 25,
            column: 52
          }
        }],
        line: 25
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "688cae152f27be0332fed742024874b8fa75c05e"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLanguageName = exports.getLanguage = void 0;
var langnames = [{
  pk: 6,
  ang: "Afar",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Afaraf",
  lc: "aa",
  ld: "ltr",
  alt: ["Afaraf", "Danakil", "Denkel", "Adal", "Afar Af", "Qafar", "Baadu (Ba'adu)"],
  cc: ["DJ", "ER", "ET", "US", "CA"]
}, {
  pk: 7,
  ang: "Ghotuo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ghotuo",
  lc: "aaa",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 8,
  ang: "Alumu-Tesu",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Alumu-Tesu",
  lc: "aab",
  ld: "ltr",
  alt: ["Alumu", "Arum-Chessu", "Arum-Tesu"],
  cc: ["NG"]
}, {
  pk: 9,
  ang: "Ari",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ari",
  lc: "aac",
  ld: "ltr",
  alt: ["Serea"],
  cc: ["PG"]
}, {
  pk: 8422,
  ang: "Siraul",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Siraul",
  lc: "aac-x-siraul",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 10,
  ang: "Amal",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Amal",
  lc: "aad",
  ld: "ltr",
  alt: ["Alai"],
  cc: ["PG"]
}, {
  pk: 11,
  ang: "Albanian, Arb\xEBresh\xEB",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Arb\xEBresh\xEB Albanian",
  lc: "aae",
  ld: "ltr",
  alt: ["Arb\xEBresh\xEB", "Molise Albanian"],
  cc: ["GR", "IT"]
}, {
  pk: 12,
  ang: "Aranadan",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Aranadan",
  lc: "aaf",
  ld: "ltr",
  alt: ["Aranatan", "Eranadans"],
  cc: ["IN"]
}, {
  pk: 13,
  ang: "Ambrak",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ambrak",
  lc: "aag",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 14,
  ang: "Arapesh, Abu\u2019",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Abu' Arapesh",
  lc: "aah",
  ld: "ltr",
  alt: ["Ua"],
  cc: ["PG"]
}, {
  pk: 15,
  ang: "Miniafia Oyan",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Arifama-Miniafia",
  lc: "aai",
  ld: "ltr",
  alt: ["Miniafia-Arifama"],
  cc: ["PG"]
}, {
  pk: 16,
  ang: "Ankave",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ankave",
  lc: "aak",
  ld: "ltr",
  alt: ["Angave"],
  cc: ["PG"]
}, {
  pk: 17,
  ang: "Afade",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Afa\u0257\u0259",
  lc: "aal",
  ld: "ltr",
  alt: ["Afadeh", "Affade", "Afada", "Kotoko", "Mogari"],
  cc: ["CM", "NG"]
}, {
  pk: 18,
  ang: "Anamb\xE9",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Anamb\xE9",
  lc: "aan",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 19,
  ang: "Arabic, Algerian Saharan Spoken",
  lr: "Africa",
  gw: false,
  hc: "DZ",
  ln: "\u0644\u0647\u062C\u0629 \u0635\u062D\u0631\u0627\u0648\u064A\u0629",
  lc: "aao",
  ld: "rtl",
  alt: ["Saharan Arabic", "Tamanghasset Arabic", "Tamanrasset Arabic"],
  cc: ["DZ", "EG"]
}, {
  pk: 20,
  ang: "Ar\xE1ra, Par\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Par\xE1 Ar\xE1ra",
  lc: "aap",
  ld: "ltr",
  alt: ["Ar\xE1ra Bravos"],
  cc: ["BR"]
}, {
  pk: 21,
  ang: "Abenaki, Eastern",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Eastern Abnaki",
  lc: "aaq",
  ld: "ltr",
  alt: ["Abenaki", "Eastern Abnaki", "Penobscot"],
  cc: ["US"]
}, {
  pk: 22,
  ang: "Aas\xE1x",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Aas\xE1x",
  lc: "aas",
  ld: "ltr",
  alt: ["As\xE1", "Asak", "Asax", "Assa", "Il Konono", "Lamanik", "Dorobo", "Ndorobo", "Aas\xE1"],
  cc: ["TZ"]
}, {
  pk: 23,
  ang: "Albanian, Arvanitika",
  lr: "Europe",
  gw: false,
  hc: "GR",
  ln: "Arvanitika Albanian",
  lc: "aat",
  ld: "ltr",
  alt: ["Arberichte", "Arvanitic", "Arvanitika"],
  cc: ["GR"]
}, {
  pk: 24,
  ang: "Abau",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Abau",
  lc: "aau",
  ld: "ltr",
  alt: ["Up-river", "Down-river", "Central Abau", "Green River", "Down-river border"],
  cc: ["PG"]
}, {
  pk: 25,
  ang: "Solong",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Solong",
  lc: "aaw",
  ld: "ltr",
  alt: ["Arawe", "Pililo"],
  cc: ["PG"]
}, {
  pk: 26,
  ang: "Mandobo Atas",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mandobo Atas",
  lc: "aax",
  ld: "ltr",
  alt: ["Dumut", "Kambon", "Kwem", "Mandobbo", "Nub", "Wambon", "Kaeti"],
  cc: ["ID"]
}, {
  pk: 27,
  ang: "Amarasi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Amarasi",
  lc: "aaz",
  ld: "ltr",
  alt: ["Ro'is Hero (Kopa)", "Ro'is Tais Nonof", "Kotos", "Ro'is", "Timor Amarasi", "Uab Meto"],
  cc: ["ID"]
}, {
  pk: 28,
  ang: "Abkhaz",
  lr: "Asia",
  gw: false,
  hc: "GE",
  ln: "\u0430\u04A7\u0441\u0443\u0430 \u0431\u044B\u0437\u0448\u04D9\u0430, \u0430\u04A7\u0441\u0448\u04D9\u0430",
  lc: "ab",
  ld: "ltr",
  alt: ["Abxazo"],
  cc: ["GE"]
}, {
  pk: 29,
  ang: "Ab\xE9",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Ab\xE9",
  lc: "aba",
  ld: "ltr",
  alt: ["Kos (Khos)", "Abb\xE9", "Abbey", "Abi"],
  cc: ["CI"]
}, {
  pk: 30,
  ang: "Bankon",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bankon",
  lc: "abb",
  ld: "ltr",
  alt: ["Abaw", "Bo", "Bon"],
  cc: ["CM"]
}, {
  pk: 31,
  ang: "Ayta, Ambala",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Ambala Ayta",
  lc: "abc",
  ld: "ltr",
  alt: ["Ambala Agta", "Ambala Sambal"],
  cc: ["PH"]
}, {
  pk: 32,
  ang: "Manide",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Manide",
  lc: "abd",
  ld: "ltr",
  alt: ["Abiyan", "Camarinas Norte Agta"],
  cc: ["PH"]
}, {
  pk: 33,
  ang: "Abenaki, Western",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Western Abnaki",
  lc: "abe",
  ld: "ltr",
  alt: ["Abenaki", "Abenaqui", "Saint Francis", "Western Abnaki", "St. Francis"],
  cc: ["CA"]
}, {
  pk: 34,
  ang: "Abai Sungai",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Abai Sungai",
  lc: "abf",
  ld: "ltr",
  alt: [],
  cc: ["MY"]
}, {
  pk: 35,
  ang: "Abaga",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Abaga",
  lc: "abg",
  ld: "ltr",
  alt: ["Wagaba"],
  cc: ["PG"]
}, {
  pk: 36,
  ang: "Arabic, Tajiki Spoken",
  lr: "Asia",
  gw: false,
  hc: "TJ",
  ln: "Tajiki Arabic",
  lc: "abh",
  ld: "rtl",
  alt: ["Balkh Arabic", "Arabic", "Bukhara Arabic", "Buxara Arabic", "Central Asian", "Jugari", "Tajiji Arabic"],
  cc: ["AF", "TJ", "UZ"]
}, {
  pk: 37,
  ang: "Abidji",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Abidji",
  lc: "abi",
  ld: "ltr",
  alt: ["Abiji"],
  cc: ["CI"]
}, {
  pk: 38,
  ang: "Lampung Nyo",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lampung Nyo",
  lc: "abl",
  ld: "ltr",
  alt: ["Tulangbawang", "Melinting", "Sukadana", "Lampong"],
  cc: ["ID"]
}, {
  pk: 39,
  ang: "Abanyom",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Abanyom",
  lc: "abm",
  ld: "ltr",
  alt: ["Befun", "Bofon", "Mbofon"],
  cc: ["NG"]
}, {
  pk: 40,
  ang: "Abua",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Abua",
  lc: "abn",
  ld: "ltr",
  alt: ["Otapha (Otabha)", "Abuan"],
  cc: ["NG"]
}, {
  pk: 41,
  ang: "Abon",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Abon",
  lc: "abo",
  ld: "ltr",
  alt: ["Ab\xF5", "Ba'ban"],
  cc: ["NG"]
}, {
  pk: 42,
  ang: "Ayta, Abellen",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Abellen Ayta",
  lc: "abp",
  ld: "ltr",
  alt: ["Abenlen", "Aburlen Negrito", "Ayta Abellen Sambal"],
  cc: ["PH"]
}, {
  pk: 43,
  ang: "Abaza",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0430\u0431\u0430\u0437\u0430",
  lc: "abq",
  ld: "ltr",
  alt: ["Ashkaraua (Ashkar)", "Ashxar", "Abazin", "Abazintsy", "Ashuwa", "Ahuwa"],
  cc: ["RU"]
}, {
  pk: 44,
  ang: "Abron",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Abron",
  lc: "abr",
  ld: "ltr",
  alt: ["Bron", "Doma", "Gyaman"],
  cc: ["GH"]
}, {
  pk: 45,
  ang: "Malay, Ambonese",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ambonese Malay",
  lc: "abs",
  ld: "ltr",
  alt: ["Dobo Malay", "Ambong", "Malayu Ambon", "Moluccan (Maluku) Malay"],
  cc: ["ID", "NL"]
}, {
  pk: 46,
  ang: "Ambulas",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ambulas",
  lc: "abt",
  ld: "ltr",
  alt: ["Abelam", "Abulas"],
  cc: ["PG"]
}, {
  pk: 47,
  ang: "Abure",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Abure",
  lc: "abu",
  ld: "ltr",
  alt: ["Abonwa", "Abour\xE9", "Abule", "Akaplass"],
  cc: ["CI"]
}, {
  pk: 48,
  ang: "Arabic, Baharna Spoken",
  lr: "Asia",
  gw: false,
  hc: "BH",
  ln: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0628\u062D\u0631\u0627\u0646\u064A\u0629",
  lc: "abv",
  ld: "rtl",
  alt: ["Baharna", "Baharnah", "Bahraini Shi'ite Arabic"],
  cc: ["OM", "BH"]
}, {
  pk: 49,
  ang: "Pal",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Pal",
  lc: "abw",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 50,
  ang: "Inabaknon",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Inabaknon",
  lc: "abx",
  ld: "ltr",
  alt: ["Abaknon", "Abaknon Sama", "Capule\xF1o", "Kapul", "Sama"],
  cc: ["PH"]
}, {
  pk: 51,
  ang: "Aneme Wake",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Aneme Wake",
  lc: "aby",
  ld: "ltr",
  alt: ["Abia", "Abie"],
  cc: ["PG"]
}, {
  pk: 52,
  ang: "Abui",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Abui",
  lc: "abz",
  ld: "ltr",
  alt: ["Abui Barat", "Abui Selatan", "Barue", "Namatalaki", "Barawahing"],
  cc: ["ID"]
}, {
  pk: 53,
  ang: "Achagua",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Achagua",
  lc: "aca",
  ld: "ltr",
  alt: ["Ajagua", "Xagua"],
  cc: ["CO"]
}, {
  pk: 54,
  ang: "\xC1nc\xE1",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "\xC1nc\xE1",
  lc: "acb",
  ld: "ltr",
  alt: ["Bunta"],
  cc: ["NG"]
}, {
  pk: 55,
  ang: "Gikyode",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Gikyode",
  lc: "acd",
  ld: "ltr",
  alt: ["Chode", "Gichode", "Kyode"],
  cc: ["GH"]
}, {
  pk: 56,
  ang: "Aceh",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Achinese",
  lc: "ace",
  ld: "ltr",
  alt: ["Pidie (Pedir)", "Timu", "Acehnese", "Achehnese", "Achinese"],
  cc: ["ID"]
}, {
  pk: 57,
  ang: "Saint Lucian Creole French",
  lr: "Americas",
  gw: false,
  hc: "LC",
  ln: "Saint Lucian Creole French",
  lc: "acf",
  ld: "ltr",
  alt: ["Kw\xE8y\xF2l", "Patois", "Patwa", "Grenadian Creole French", "Kw\xE9y\xF2l"],
  cc: ["DM", "TT", "FR", "GF", "US", "LC"]
}, {
  pk: 58,
  ang: "Acholi",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Acoli",
  lc: "ach",
  ld: "ltr",
  alt: ["Chopi", "Dhopaluo (Chope)", "Acoli", "Acooli", "Akoli", "Atscholi", "Dok Acoli", "Gang", "Log Acoli", "Lwo", "Shuli", "Lwoo"],
  cc: ["SS", "UG"]
}, {
  pk: 59,
  ang: "Arabic, Mesopotamian Spoken",
  lr: "Asia",
  gw: false,
  hc: "IQ",
  ln: "\u0644\u0647\u062C\u0629 \u0639\u0631\u0627\u0642\u064A\u0629",
  lc: "acm",
  ld: "rtl",
  alt: ["Arabic", "Furati", "Iraqi Arabic", "Mesopotamian Gelet Arabic", "Mesopotamian Qeltu Arabic", "Arabi", "North Syrian Arabic"],
  cc: ["BE", "FR", "DE", "IR", "IQ", "SY", "US", "YE", "CA", "IT", "KW", "AE"]
}, {
  pk: 7790,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IQ",
  ln: "\u0644\u0647\u062C\u0629 \u0628\u063A\u062F\u0627\u062F\u064A\u0629",
  lc: "acm-x-baghdadi",
  ld: "rtl",
  alt: [],
  cc: []
}, {
  pk: 7787,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Lebanese Arabic",
  lc: "acm-x-lebarabic",
  ld: "rtl",
  alt: [],
  cc: []
}, {
  pk: 60,
  ang: "Achang",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u963F\u660C",
  lc: "acn",
  ld: "ltr",
  alt: ["Husa (Chintaw)", "Xiandao", "Acang", "Ach'ang", "Achung", "Ahchan", "Atsang", "M\xF6nghsa", "Ngacang", "Ngac'ang", "Ngachang", "Ngatsang", "Ngo Chang", "Anchan", "Chung", "Manmaw", "Tai Sa'"],
  cc: ["CN", "MM"]
}, {
  pk: 61,
  ang: "Acipa, Eastern",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Eastern Acipa",
  lc: "acp",
  ld: "ltr",
  alt: ["Bobi", "Randeggi", "Boroma (Taboroma)", "Achipa", "Acipanci", "Sagamuk", "Zubazuba"],
  cc: ["NG"]
}, {
  pk: 62,
  ang: "Arabic, Ta\u2019izzi-Adeni Spoken",
  lr: "Asia",
  gw: false,
  hc: "YE",
  ln: "\u0644\u0647\u062C\u0629 \u062A\u0639\u0632\u064A\u0629-\u0639\u062F\u0646\u064A\u0629",
  lc: "acq",
  ld: "rtl",
  alt: ["Ta'izzi", "Djibouti Arabic", "Southern Yemeni Spoken Arabic"],
  cc: ["DJ", "ER", "ET", "MG", "OM", "SA", "SD", "US", "YE", "KW", "EG", "AE"]
}, {
  pk: 63,
  ang: "Achi",
  lr: "Americas",
  gw: false,
  hc: "GT",
  ln: "Achi",
  lc: "acr",
  ld: "ltr",
  alt: ["Cubulco Achi", "Rabinal Achi"],
  cc: ["GT"]
}, {
  pk: 64,
  ang: "Achterhoeks",
  lr: "Europe",
  gw: false,
  hc: "NL",
  ln: "Achterhoeks",
  lc: "act",
  ld: "ltr",
  alt: ["Aachterhoeks", "Achterhoek"],
  cc: ["NL"]
}, {
  pk: 65,
  ang: "Achuar-Shiwiar",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Achuar-Shiwiar",
  lc: "acu",
  ld: "ltr",
  alt: ["Achual", "Achuale", "Achuar", "Achuara", "Jivaro", "Maina", "Mayna"],
  cc: ["PE", "EC"]
}, {
  pk: 66,
  ang: "Achumawi",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Achumawi",
  lc: "acv",
  ld: "ltr",
  alt: ["Achomawi", "Pitt River"],
  cc: ["US"]
}, {
  pk: 67,
  ang: "Arabic, Hijazi Spoken",
  lr: "Asia",
  gw: false,
  hc: "SA",
  ln: "\u062D\u062C\u0627\u0632\u064A",
  lc: "acw",
  ld: "rtl",
  alt: ["Hijazi", "West Arabian Colloquial Arabic"],
  cc: ["ER", "SA", "US", "JO", "QA", "AE"]
}, {
  pk: 68,
  ang: "Arabic, Omani Spoken",
  lr: "Asia",
  gw: false,
  hc: "OM",
  ln: "\u0644\u0647\u062C\u0629 \u0639\u0645\u0627\u0646\u064A\u0629",
  lc: "acx",
  ld: "rtl",
  alt: ["Omani Hadari Arabic"],
  cc: ["OM", "SA", "KW", "AE"]
}, {
  pk: 69,
  ang: "Arabic, Cypriot Spoken",
  lr: "Asia",
  gw: false,
  hc: "CY",
  ln: "Cypriot Arabic",
  lc: "acy",
  ld: "rtl",
  alt: ["Cypriot Maronite Arabic", "Maronite", "Sanna"],
  cc: ["CY"]
}, {
  pk: 70,
  ang: "Acheron",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Garme",
  lc: "acz",
  ld: "ltr",
  alt: ["Gathuk (Western Acheron)", "Gandok (Eastern Acheron)", "Garong", "Aceron", "Achurun", "Asheron", "Garme"],
  cc: ["SD"]
}, {
  pk: 71,
  ang: "Dangme",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Adangme",
  lc: "ada",
  ld: "ltr",
  alt: ["Ada", "Adangme"],
  cc: ["GH"]
}, {
  pk: 72,
  ang: "Adabe",
  lr: "Asia",
  gw: false,
  hc: "TL",
  ln: "Adabe",
  lc: "adb",
  ld: "ltr",
  alt: ["Raklungu", "Resuk", "Rahesuk", "Ataura", "Atauran", "Atauro", "Atauru", "Raklu Un", "Raklu-Un"],
  cc: ["TL"]
}, {
  pk: 73,
  ang: "Dzodinka",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Dzodinka",
  lc: "add",
  ld: "ltr",
  alt: ["Arderi", "Dzodzinka", "Lidzonka", "Adiri"],
  cc: ["CM", "NG", "SD"]
}, {
  pk: 74,
  ang: "Adele",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Adele",
  lc: "ade",
  ld: "ltr",
  alt: ["Bidire", "Bedere", "Gadre", "Gidire", "Lower Adele", "Upper Adele"],
  cc: ["GH", "TG"]
}, {
  pk: 75,
  ang: "Arabic, Dhofari Spoken",
  lr: "Asia",
  gw: false,
  hc: "OM",
  ln: "\u0644\u0647\u062C\u0629 \u0638\u0641\u0627\u0631\u064A\u0629",
  lc: "adf",
  ld: "rtl",
  alt: ["Dhofari", "Zofari"],
  cc: ["OM"]
}, {
  pk: 76,
  ang: "Andegerebinha",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Andegerebinha",
  lc: "adg",
  ld: "ltr",
  alt: ["Andigibinha", "Antekerrepinhe"],
  cc: ["AU"]
}, {
  pk: 77,
  ang: "Adhola",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Adhola",
  lc: "adh",
  ld: "ltr",
  alt: ["Dhopadhola"],
  cc: ["KE", "UG"]
}, {
  pk: 78,
  ang: "Adi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Adi",
  lc: "adi",
  ld: "ltr",
  alt: ["Abor", "Adi-Bokar", "Bengni-Boga'er", "Boga'er", "Lhoba", "Lho-Pa", "Abhor", "Boga'er Luoba", "Luoba", "Komkar", "Pailibo", "Bokar (Boga'er Luoba)", "Bogaer Luoba"],
  cc: ["CN", "IN"]
}, {
  pk: 7604,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Adi Karnataka",
  lc: "adi-x-adikarna",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7592,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bokar",
  lc: "adi-x-bokar",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7595,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Libo",
  lc: "adi-x-libo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7601,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Ramo",
  lc: "adi-x-ramo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7575,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Zadi Boli",
  lc: "adi-x-zadiboli",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 79,
  ang: "Adioukrou",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Adioukrou",
  lc: "adj",
  ld: "ltr",
  alt: ["Adjukru", "Adyoukrou", "Adyukru", "Ajukru"],
  cc: ["CI"]
}, {
  pk: 80,
  ang: "Adi, Galo",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Galo",
  lc: "adl",
  ld: "ltr",
  alt: ["Adi", "Adi-Gallong", "Adi-Galo", "Gallong", "Galo", "Galong", "Lare", "Pugo", "Karka"],
  cc: ["IN"]
}, {
  pk: 81,
  ang: "Adang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Adang",
  lc: "adn",
  ld: "ltr",
  alt: ["Alor"],
  cc: ["ID"]
}, {
  pk: 82,
  ang: "Abu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Abu",
  lc: "ado",
  ld: "ltr",
  alt: ["Adjora", "Adjoria", "Azao", "Auwa", "Sabu"],
  cc: ["PG"]
}, {
  pk: 83,
  ang: "Adangbe",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Adangbe",
  lc: "adq",
  ld: "ltr",
  alt: ["Adan", "Adantonwi", "Dangbe"],
  cc: ["GH"]
}, {
  pk: 84,
  ang: "Adonara",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Adonara",
  lc: "adr",
  ld: "ltr",
  alt: ["Nusa Tadon", "Sagu", "Vaiverang", "Waiwerang"],
  cc: ["ID"]
}, {
  pk: 8443,
  ang: "Waiwerang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Waiwerang",
  lc: "adr-x-waiwerang",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 85,
  ang: "Adamorobe Sign Language",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Adamorobe Sign Language",
  lc: "ads",
  ld: "ltr",
  alt: ["AdaSL"],
  cc: ["GH"]
}, {
  pk: 86,
  ang: "Adnyamathanha",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Adnyamathanha",
  lc: "adt",
  ld: "ltr",
  alt: ["Ad'n'amadana", "Adynyamathanha", "Anjimatana", "Anjiwatana", "Archualda", "Benbakanjamata", "Binbarnja", "Gadjnjamada", "Jandali", "Kanjimata", "Keydnjmarda", "Mardala", "Nimalda", "Nuralda", "Umbertana", "Unyamootha", "Wailbi", "Wailpi", "Waljbi", "Wipie"],
  cc: ["AU"]
}, {
  pk: 87,
  ang: "Aduge",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Aduge",
  lc: "adu",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 88,
  ang: "Amundava",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Amundava",
  lc: "adw",
  ld: "ltr",
  alt: ["Amundawa"],
  cc: ["BR"]
}, {
  pk: 89,
  ang: "Tibetan, Amdo",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u0F68\u0F0B\u0F58\u0F51\u0F7C\u0F0B\u0F66\u0F90\u0F51\u0F0B",
  lc: "adx",
  ld: "ltr",
  alt: ["Panags", "Sbranag", "Sbanag", "Panang (Banag)", "Panakha", "Banang", "Pananag", "Anduo", "Ngambo"],
  cc: ["CN"]
}, {
  pk: 90,
  ang: "Adyghe",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0410\u0434\u044B\u0433\u0430\u0431\u0437\u044D",
  lc: "ady",
  ld: "ltr",
  alt: ["Natuzaj (Natukhai)", "Abadzex (Abadzakh)", "Temirgoj", "Shapsug (Sapsug)", "Abadzeg", "Bezhedukh (Bzedux)", "Bzhedug", "Chemgui", "Adygey", "West Circassian", "Adygei", "Circassian", "Kiakh", "Kjax", "Lower Circassian", "Cherkes"],
  cc: ["IQ", "IL", "RU", "SY", "US", "JO"]
}, {
  pk: 7788,
  ang: "Adyghe",
  lr: "Asia",
  gw: false,
  hc: "SY",
  ln: "\u0410\u0434\u044B\u0433\u0430\u0431\u0437\u044D",
  lc: "ady-x-syriadyghe",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 91,
  ang: "Adzera",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Adzera",
  lc: "adz",
  ld: "ltr",
  alt: ["Guruf-Ngariawang (Ngariawan)", "Amari", "Tsumanggorun", "Yarus", "Ngarowapum", "Acira", "Atzera", "Azera"],
  cc: ["PG"]
}, {
  pk: 92,
  ang: "Arabic, Tunisian Spoken",
  lr: "Africa",
  gw: false,
  hc: "TN",
  ln: "Tunisian Arabic",
  lc: "aeb",
  ld: "rtl",
  alt: ["Sahil", "Sfax", "South-Eastern Tunisian", "South-Western Tunisian", "Tunis", "North-Western Tunisian", "Tunisian", "Tunisian Arabic", "Tunisian Darija"],
  cc: ["BE", "FR", "DE", "NL", "TN", "IT", "LY"]
}, {
  pk: 93,
  ang: "Arabic, Sa\u2019idi Spoken",
  lr: "Africa",
  gw: false,
  hc: "EG",
  ln: "\u0644\u0647\u062C\u0629 \u0635\u0639\u064A\u062F\u064A\u0629",
  lc: "aec",
  ld: "rtl",
  alt: ["Sa'idi"],
  cc: ["FR", "EG"]
}, {
  pk: 94,
  ang: "Argentine Sign Language",
  lr: "Americas",
  gw: false,
  hc: "AR",
  ln: "Argentine Sign Language",
  lc: "aed",
  ld: "ltr",
  alt: ["C\xF3rdoba Sign Language"],
  cc: ["AR"]
}, {
  pk: 95,
  ang: "Pashai, Northeast",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Northeast Pashai",
  lc: "aee",
  ld: "ltr",
  alt: ["Kurdar", "Chalas (Chilas)", "Pashai"],
  cc: ["AF"]
}, {
  pk: 96,
  ang: "Haeke",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Haeke",
  lc: "aek",
  ld: "ltr",
  alt: ["Aeke", "Baco", "Haeake"],
  cc: ["NC"]
}, {
  pk: 97,
  ang: "Ambele",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Ambele",
  lc: "ael",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 98,
  ang: "Arem",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Arem",
  lc: "aem",
  ld: "ltr",
  alt: ["Chombrau", "Chomrau", "Umo", "A-Rem"],
  cc: ["VN"]
}, {
  pk: 99,
  ang: "Armenian Sign Language",
  lr: "Asia",
  gw: false,
  hc: "AM",
  ln: "Armenian Sign Language",
  lc: "aen",
  ld: "ltr",
  alt: [],
  cc: ["AM"]
}, {
  pk: 100,
  ang: "Aer",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u0622\u06CC\u0631 \u0632\u0628\u0627\u0646",
  lc: "aeq",
  ld: "ltr",
  alt: [],
  cc: ["PK"]
}, {
  pk: 101,
  ang: "Arrernte, Eastern",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Eastern Arrernte",
  lc: "aer",
  ld: "ltr",
  alt: ["Akarre", "Antekerrepenh", "Ikngerripenhe", "Mparntwe Arrernte", "Upper Aranda", "Arunta", "Eastern Aranda"],
  cc: ["AU"]
}, {
  pk: 102,
  ang: "Alsea",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Alsea",
  lc: "aes",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 103,
  ang: "Akeu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u963F\u514B",
  lc: "aeu",
  ld: "ltr",
  alt: ["Aki", "Akui"],
  cc: ["CN"]
}, {
  pk: 104,
  ang: "Ambakich",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ambakich",
  lc: "aew",
  ld: "ltr",
  alt: ["Northern Ambakich (Antanau)", "Southern Ambakich", "Porapora"],
  cc: ["PG"]
}, {
  pk: 105,
  ang: "Amele",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Amele",
  lc: "aey",
  ld: "ltr",
  alt: ["Amale"],
  cc: ["PG"]
}, {
  pk: 7775,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Haya",
  lc: "aey-x-haya",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7770,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Huar",
  lc: "aey-x-huar",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8318,
  ang: "Jagahala",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Jagahala",
  lc: "aey-x-jagalaha",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8423,
  ang: "Ohu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ohu",
  lc: "aey-x-ohu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 106,
  ang: "Aeka",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Aeka",
  lc: "aez",
  ld: "ltr",
  alt: ["Ajeka"],
  cc: ["PG"]
}, {
  pk: 107,
  ang: "Afrikaans",
  lr: "Africa",
  gw: false,
  hc: "ZA",
  ln: "Afrikaans",
  lc: "af",
  ld: "ltr",
  alt: ["Cape Afrikaans (West Cape Afrikaans)"],
  cc: ["GB", "ZA", "US", "ZM", "ZW", "AO", "LS", "SZ", "BW", "NA"]
}, {
  pk: 108,
  ang: "Arabic, Gulf Spoken",
  lr: "Asia",
  gw: false,
  hc: "KW",
  ln: "\u062E\u0644\u064A\u062C\u064A",
  lc: "afb",
  ld: "rtl",
  alt: ["Khamseh", "Al-Has\xE2", "Gulf Arabic", "Khaliji", "Bedawi", "Omani Bedawi Arabic", "Qatari", "Gulf Spoken"],
  cc: ["IR", "OM", "SA", "SD", "US", "YE", "AU", "CA", "KW", "BH", "EG", "QA", "AE"]
}, {
  pk: 109,
  ang: "Andai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Andai",
  lc: "afd",
  ld: "ltr",
  alt: ["Pundungum", "Wangkai"],
  cc: ["PG"]
}, {
  pk: 110,
  ang: "Utugwang-Irungene-Afrike",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Putukwam",
  lc: "afe",
  ld: "ltr",
  alt: ["Afrike (Aferike)", "Mgbenege (Ngbenege)", "Okworogung (Ukworogung)", "Ukwortung (Okorotung)", "Utukwang", "Utugwang (Otukwang)", "Mbe East", "Upper Mbe", "Utumane", "Mbube Eastern", "Irungene (Mbe Afal)", "Ebe Cluster", "Putukwam"],
  cc: ["NG"]
}, {
  pk: 111,
  ang: "Afghan Sign Language",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Afghan Sign Language",
  lc: "afg",
  ld: "ltr",
  alt: ["Afghan Sign", "AFSL"],
  cc: ["AF"]
}, {
  pk: 112,
  ang: "",
  lr: "",
  gw: false,
  hc: "",
  ln: "Afrihili",
  lc: "afh",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 113,
  ang: "Chini",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Akrukay",
  lc: "afi",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 114,
  ang: "Nanubae",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nanubae",
  lc: "afk",
  ld: "ltr",
  alt: ["Aunda", "Kapagmai"],
  cc: ["PG"]
}, {
  pk: 115,
  ang: "Defaka",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Defaka",
  lc: "afn",
  ld: "ltr",
  alt: ["Afakani"],
  cc: ["NG"]
}, {
  pk: 116,
  ang: "Eloyi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Eloyi",
  lc: "afo",
  ld: "ltr",
  alt: ["Mbeji", "Afao", "Afo", "Afu", "Aho", "Epe", "Keffi"],
  cc: ["NG"]
}, {
  pk: 117,
  ang: "Tapei",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tapei",
  lc: "afp",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 118,
  ang: "Afro-Seminole Creole",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Afro-Seminole Creole",
  lc: "afs",
  ld: "ltr",
  alt: ["Mexico Afro-Seminole", "Texas Afro-Seminole", "Afro-Seminol Criollo", "Afro-Seminole", "Black Seminole", "Seminole"],
  cc: ["MX", "US"]
}, {
  pk: 119,
  ang: "Afitti",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Afitti",
  lc: "aft",
  ld: "ltr",
  alt: ["Affitti", "Dinik", "Ditti", "Unietti"],
  cc: ["SD"]
}, {
  pk: 120,
  ang: "Awutu",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Awutu",
  lc: "afu",
  ld: "ltr",
  alt: [],
  cc: ["CN", "GH"]
}, {
  pk: 121,
  ang: "Obokuitai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Obokuitai",
  lc: "afz",
  ld: "ltr",
  alt: ["Aliki", "Ati", "Obogwitai"],
  cc: ["ID"]
}, {
  pk: 122,
  ang: "Aguano",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Aguano",
  lc: "aga",
  ld: "ltr",
  alt: ["Aguanu", "Awano", "Santa Crucino", "Uguano"],
  cc: ["PE"]
}, {
  pk: 123,
  ang: "Legbo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Legbo",
  lc: "agb",
  ld: "ltr",
  alt: ["Gbo", "Igbo", "Imaban", "Itigidi", "Leggbo"],
  cc: ["NG"]
}, {
  pk: 124,
  ang: "Agatu",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Agatu",
  lc: "agc",
  ld: "ltr",
  alt: ["North Idoma", "Ochekwu"],
  cc: ["NG"]
}, {
  pk: 125,
  ang: "Agarabi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Agarabi",
  lc: "agd",
  ld: "ltr",
  alt: ["Agarabe", "Bare"],
  cc: ["PG"]
}, {
  pk: 8465,
  ang: "Agarabi Bus",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Agarabi Bus",
  lc: "agd-x-agarabibus",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8246,
  ang: "Agarabi Kainantu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Agarabi Kainantu",
  lc: "agd-x-agarabkain",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8247,
  ang: "Agarabi Yonki",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Agarabi Yonki",
  lc: "agd-x-agarabyonk",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8467,
  ang: "Agarabi Kona",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Agarabi Kona",
  lc: "agd-x-kona",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8466,
  ang: "Agarabi Name",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Agarabi Name",
  lc: "agd-x-name",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8480,
  ang: "Agarabi Namel",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Agarabi Namel",
  lc: "agd-x-namel",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 126,
  ang: "Angal",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Angal",
  lc: "age",
  ld: "ltr",
  alt: ["East Angal"],
  cc: ["PG"]
}, {
  pk: 127,
  ang: "Arguni",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Arguni",
  lc: "agf",
  ld: "ltr",
  alt: ["Argoeni"],
  cc: ["ID"]
}, {
  pk: 128,
  ang: "Angor",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Angor",
  lc: "agg",
  ld: "ltr",
  alt: ["Nai (Central Angor)", "Samanai (Southern Angor)", "Anggor", "Senagi", "Watapor"],
  cc: ["PG"]
}, {
  pk: 129,
  ang: "Ngelima",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ngelima",
  lc: "agh",
  ld: "ltr",
  alt: ["Buru (Bor)", "Leboro", "Angba", "Bangalema", "Bangelima", "Leangba"],
  cc: ["CD"]
}, {
  pk: 8477,
  ang: "Balema",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Balema",
  lc: "agh-x-balema",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 130,
  ang: "Agariya",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Agariya",
  lc: "agi",
  ld: "ltr",
  alt: ["Agaria", "Agharia", "Agoria"],
  cc: ["IN"]
}, {
  pk: 131,
  ang: "Argobba",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Argobba",
  lc: "agj",
  ld: "ltr",
  alt: ["Aliyu Amba-Ankober", "Shonke-T'allaha"],
  cc: ["ET"]
}, {
  pk: 132,
  ang: "Agta, Isarog",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Isarog Agta",
  lc: "agk",
  ld: "ltr",
  alt: [],
  cc: ["PH"]
}, {
  pk: 133,
  ang: "Fembe",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Fembe",
  lc: "agl",
  ld: "ltr",
  alt: ["Agala", "Sinale"],
  cc: ["PG"]
}, {
  pk: 134,
  ang: "Angaataha",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Angaataha",
  lc: "agm",
  ld: "ltr",
  alt: ["Angaatiya", "Angataha", "Langimar"],
  cc: ["PG"]
}, {
  pk: 135,
  ang: "Agutaynen",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Agutaynen",
  lc: "agn",
  ld: "ltr",
  alt: ["Agutayno", "Agutaynon"],
  cc: ["PH"]
}, {
  pk: 136,
  ang: "Tainae",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tainae",
  lc: "ago",
  ld: "ltr",
  alt: ["Ivori"],
  cc: ["PG"]
}, {
  pk: 137,
  ang: "Aghem",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Aghem",
  lc: "agq",
  ld: "ltr",
  alt: ["Wum", "Yum"],
  cc: ["CM"]
}, {
  pk: 138,
  ang: "Aguaruna",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Aguaruna",
  lc: "agr",
  ld: "ltr",
  alt: ["Aguaj\xFAn", "Ahuaj\xFAn", "Awaj\xFAn"],
  cc: ["PE"]
}, {
  pk: 139,
  ang: "Esimbi",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Esimbi",
  lc: "ags",
  ld: "ltr",
  alt: ["Upper Esimbi", "Lower Esimbi", "Aage", "Age", "Bogen", "Bogue", "Eshimbi", "Essimbi", "Isimbi", "Mburugam", "Simpi"],
  cc: ["CM"]
}, {
  pk: 140,
  ang: "Agta, Central Cagayan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Central Cagayan Agta",
  lc: "agt",
  ld: "ltr",
  alt: ["Labin Agta"],
  cc: ["PH"]
}, {
  pk: 141,
  ang: "Awakateko",
  lr: "Americas",
  gw: false,
  hc: "GT",
  ln: "Aguacateco",
  lc: "agu",
  ld: "ltr",
  alt: ["Aguacatec"],
  cc: ["GT"]
}, {
  pk: 142,
  ang: "Dumagat, Remontado",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Remontado Dumagat",
  lc: "agv",
  ld: "ltr",
  alt: ["Hatang-Kayey", "Remontado Agta", "Sinauna", "Sinauna Tagalog"],
  cc: ["PH"]
}, {
  pk: 143,
  ang: "Kahua",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Kahua",
  lc: "agw",
  ld: "ltr",
  alt: ["Anganiwai", "Anganiwei", "Narihua", "Wanoni"],
  cc: ["SB"]
}, {
  pk: 144,
  ang: "Aghul",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0430\u0433\u044A\u0443\u043B \u0447\u04C0\u0430\u043B",
  lc: "agx",
  ld: "ltr",
  alt: ["Agul", "Fit'e", "Gequn (Burkikhan)", "Koshan (Q'ushan)", "Tsirkhe", "Aghul-ch'al"],
  cc: ["RU"]
}, {
  pk: 145,
  ang: "Alta, Southern",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Southern Alta",
  lc: "agy",
  ld: "ltr",
  alt: ["Baluga", "Ita", "Kabulowan", "Kabuluen", "Kabuluwan", "Kabuluwen", "Pugot"],
  cc: ["PH"]
}, {
  pk: 146,
  ang: "Agta, Mt. Iriga",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Mt. Iriga Agta",
  lc: "agz",
  ld: "ltr",
  alt: ["Lake Buhi West", "Mt. Iriga Negrito", "San Ramon Inagta"],
  cc: ["PH"]
}, {
  pk: 147,
  ang: "Ahanta",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Ahanta",
  lc: "aha",
  ld: "ltr",
  alt: [],
  cc: ["GH"]
}, {
  pk: 148,
  ang: "Axamb",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Axamb",
  lc: "ahb",
  ld: "ltr",
  alt: ["Ahamb"],
  cc: ["VU"]
}, {
  pk: 149,
  ang: "Qimant",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Qimant",
  lc: "ahg",
  ld: "ltr",
  alt: ["Hwarasa (Kara)", "Dembya", "Kemanat", "Kwolasa (Kwolacha)", "Qwarina", "Qwara", "Qimant (Chemant)", "Qemant", "Kimant", "Kemant", "Dembiya (Dambya)", "Kamant", "Kimanteney", "Western Agaw"],
  cc: ["ET"]
}, {
  pk: 150,
  ang: "Aghu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Aghu",
  lc: "ahh",
  ld: "ltr",
  alt: ["Djair", "Dyair"],
  cc: ["ID"]
}, {
  pk: 151,
  ang: "Aizi, Tiagbamrin",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Tiagbamrin Aizi",
  lc: "ahi",
  ld: "ltr",
  alt: ["Ahizi", "L\xE9l\xE9mrin", "Tiagba"],
  cc: ["CI"]
}, {
  pk: 152,
  ang: "Akha",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Akha",
  lc: "ahk",
  ld: "ltr",
  alt: ["Ahka", "Aini", "Aka", "Ak'a", "Ekaw", "Ikaw", "Ikor", "Kaw", "Kha Ko", "Khako", "Khao Kha Ko", "Ko", "Yani", "Hka Ko", "Khao Ikor"],
  cc: ["CN", "LA", "TH", "MM"]
}, {
  pk: 153,
  ang: "Igo",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Igo",
  lc: "ahl",
  ld: "ltr",
  alt: ["Achlo", "Ago", "Ahl\xF5", "Ahlon-Bogo", "Ahonlan", "Anlo"],
  cc: ["TG"]
}, {
  pk: 154,
  ang: "Aizi, Mobumrin",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Mobumrin Aizi",
  lc: "ahm",
  ld: "ltr",
  alt: ["Ahizi"],
  cc: ["CI"]
}, {
  pk: 155,
  ang: "\xC0h\xE0n",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "\xC0h\xE0n",
  lc: "ahn",
  ld: "ltr",
  alt: ["Ahaan"],
  cc: ["NG"]
}, {
  pk: 156,
  ang: "Ahom",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Ahom",
  lc: "aho",
  ld: "ltr",
  alt: ["Tai Ahom"],
  cc: ["IN"]
}, {
  pk: 157,
  ang: "Aizi, Aproumu",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Aproumu Aizi",
  lc: "ahp",
  ld: "ltr",
  alt: ["Ahizi", "Aprou", "Aproumu", "Aprwe", "Oprou"],
  cc: ["CI"]
}, {
  pk: 158,
  ang: "Ahirani",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Ahirani",
  lc: "ahr",
  ld: "ltr",
  alt: ["Ahiri"],
  cc: ["TR", "IN"]
}, {
  pk: 159,
  ang: "Ashe",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ashe",
  lc: "ahs",
  ld: "ltr",
  alt: ["Uchek", "Unorr", "Ala", "Koro Makama", "Koron Ache", "Koron Ala"],
  cc: ["NG"]
}, {
  pk: 160,
  ang: "Ahtena",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Ahtena",
  lc: "aht",
  ld: "ltr",
  alt: ["Ahtna", "Atna", "Copper River", "Mednovskiy"],
  cc: ["US"]
}, {
  pk: 161,
  ang: "Arosi",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Arosi",
  lc: "aia",
  ld: "ltr",
  alt: [],
  cc: ["SB"]
}, {
  pk: 162,
  ang: "Ainu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u827E\u52AA\u8BED (China)",
  lc: "aib",
  ld: "ltr",
  alt: ["Abdal", "Aini", "Aynu"],
  cc: ["CN"]
}, {
  pk: 163,
  ang: "Ainbai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ainbai",
  lc: "aic",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 164,
  ang: "Amara",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Amara",
  lc: "aie",
  ld: "ltr",
  alt: ["Bibling", "Longa"],
  cc: ["PG"]
}, {
  pk: 165,
  ang: "Agi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Agi",
  lc: "aif",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 166,
  ang: "Antigua and Barbuda Creole English",
  lr: "Americas",
  gw: false,
  hc: "AG",
  ln: "Antigua and Barbuda Creole English",
  lc: "aig",
  ld: "ltr",
  alt: ["Barbuda Creole English", "Antiguan Creole English", "Nevis Creole English", "Leeward Caribbean Creole", "Kittitian Creole English", "Sint Maarten Creole English"],
  cc: ["MS", "SX", "US", "AG"]
}, {
  pk: 167,
  ang: "Ai-Cham",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u9526\u8BDD",
  lc: "aih",
  ld: "ltr",
  alt: ["Atsam", "Jiamuhua", "Jin", "Jinhua"],
  cc: ["CN"]
}, {
  pk: 168,
  ang: "Assyrian Neo-Aramaic",
  lr: "Asia",
  gw: false,
  hc: "IQ",
  ln: "\u0710\u072C\u0718\u072A\u071D\u0710",
  lc: "aii",
  ld: "ltr",
  alt: ["Upper Barwari", "Qudshanis", "Van", "Urmi", "Tina", "Tergawar", "Solduz", "Shamezdin", "Sapna (Aradhin)", "Salamas", "Central Assyrian (Anhar)", "Nochiya", "Mar Bishu", "Jilu", "Iranian Koine (General Urmi)", "Inishke", "Gavar", "Dez", "Benatha", "Daudiya", "Urmi Assyrian (Sipurghan)", "Northern Assyrian (Baz)", "Aisorski", "Sooreth", "Assyrianci", "Assyriski", "Lishana Aturaya", "Neo-Syriac", "Suret", "Sureth", "Suryaya Swadaya", "Syriac"],
  cc: ["FR", "DE", "IR", "IQ", "IL", "LB", "GB", "SY", "SE", "TR", "US", "AU", "CA"]
}, {
  pk: 169,
  ang: "Lishanid Noshan",
  lr: "Asia",
  gw: false,
  hc: "IL",
  ln: "\u05DC\u05E9\u05E0\u05D9\u05D3 \u05E0\u05E9\u05DF",
  lc: "aij",
  ld: "rtl",
  alt: ["Galigalu", "Hulani", "Hula'ula", "Jbeli", "Kurdit", "Lishana Did\xE1n", "Shaqlawa", "Ranye", "Arbel (Arbil)"],
  cc: ["IL"]
}, {
  pk: 170,
  ang: "Ake",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ake",
  lc: "aik",
  ld: "ltr",
  alt: ["Aike", "Akye"],
  cc: ["NG"]
}, {
  pk: 171,
  ang: "Aimele",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Aimele",
  lc: "ail",
  ld: "ltr",
  alt: ["Kware"],
  cc: ["PG"]
}, {
  pk: 172,
  ang: "Aimol",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Aimol",
  lc: "aim",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 173,
  ang: "Ainu",
  lr: "Asia",
  gw: false,
  hc: "JP",
  ln: "\u30A2\u30A4\u30CC\u8A9E (Japan)",
  lc: "ain",
  ld: "ltr",
  alt: ["Ainu Itak", "Hokkaido (Ezo)", "Kuril (Shikotan)", "Sakhalin (Saghilin)", "Yezo"],
  cc: ["JP"]
}, {
  pk: 174,
  ang: "Aiton",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Aiton",
  lc: "aio",
  ld: "ltr",
  alt: ["Aitonia"],
  cc: ["IN"]
}, {
  pk: 175,
  ang: "Burumakok",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Burumakok",
  lc: "aip",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 176,
  ang: "Aimaq",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "\u0622\u06CC\u0645\u0627\u0642\u06CC",
  lc: "aiq",
  ld: "ltr",
  alt: ["Barbari", "Berberi", "Chahar-Aimaq", "Char Aimaq", "Timuri", "Yemchidi", "Dzhemshid", "Zohri (Zuri)", "Taimuri (Taimouri)", "Jamshedi", "Jamshidi (Djamchidi)", "Teimuri (Teimurtash)"],
  cc: ["AF", "TJ"]
}, {
  pk: 177,
  ang: "Airoran",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Airoran",
  lc: "air",
  ld: "ltr",
  alt: ["Adora", "Aeroran", "Iriemkena"],
  cc: ["ID"]
}, {
  pk: 178,
  ang: "Amis, Nataoran",
  lr: "Asia",
  gw: false,
  hc: "TW",
  ln: "Nataoran Amis",
  lc: "ais",
  ld: "ltr",
  alt: ["Nataoran", "Natawran", "Tauran", "Sakizaya (Sakiray)", "Sakiraya", "Pokpok", "Kaliyawan (Kaliyuawan)", "Cikosowan", "Ridaw"],
  cc: ["TW"]
}, {
  pk: 179,
  ang: "Aari",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Aari",
  lc: "aiw",
  ld: "ltr",
  alt: ["Aarai", "Ara", "Ari", "Aro", "Shankilla", "Shankilligna", "Shankillinya", "Bako (Baco)", "Biyo (Bio)", "Wubahamer (Ubamer)"],
  cc: ["ET"]
}, {
  pk: 180,
  ang: "Aighon",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Aighon",
  lc: "aix",
  ld: "ltr",
  alt: ["Psokhok", "Bao (Do)", "Apsokok (Psohoh)", "Psokok"],
  cc: ["PG"]
}, {
  pk: 181,
  ang: "Ali",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Ali",
  lc: "aiy",
  ld: "ltr",
  alt: [],
  cc: ["CF"]
}, {
  pk: 182,
  ang: "Aja",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Aja (Sudan)",
  lc: "aja",
  ld: "ltr",
  alt: ["Adja", "Ajja"],
  cc: ["SS"]
}, {
  pk: 183,
  ang: "Aja",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Aja (Benin)",
  lc: "ajg",
  ld: "ltr",
  alt: ["Dogo", "Hwe (Ehoue)", "Sikpi (Shikpi)", "Tado (Tadou)", "Ajagbe", "Hw\xE8"],
  cc: ["BJ", "TG"]
}, {
  pk: 184,
  ang: "Aji\xEB",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Aji\xEB",
  lc: "aji",
  ld: "ltr",
  alt: ["A'jie", "Anjie", "Houailou", "Wai", "Wailu"],
  cc: ["NC"]
}, {
  pk: 185,
  ang: "Andajin",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Andajin",
  lc: "ajn",
  ld: "ltr",
  alt: ["Andidja", "Andidjara"],
  cc: ["AU"]
}, {
  pk: 186,
  ang: "Arabic, South Levantine Spoken",
  lr: "Asia",
  gw: false,
  hc: "JO",
  ln: "South Levantine Arabic",
  lc: "ajp",
  ld: "rtl",
  alt: ["Levantine", "Palestanian-Jordanian Arabic", "Arabic", "Levantine Arabic", "Palestinian-Jordanian", "South Levantine Arabic", "Bedawi"],
  cc: ["ER", "FR", "DE", "IL", "PA", "GT", "OM", "SA", "US", "CA", "JO", "KW", "SV", "AE"]
}, {
  pk: 187,
  ang: "Arabic, Judeo-Tunisian",
  lr: "Asia",
  gw: false,
  hc: "IL",
  ln: "\u05E2\u05E8\u05D1\u05D9\u05EA \u05D9\u05D4\u05D5\u05D3\u05D9\u05EA-\u05D8\u05D5\u05E0\u05D9\u05E1\u05D0\u05D9",
  lc: "ajt",
  ld: "rtl",
  alt: [],
  cc: ["IL"]
}, {
  pk: 188,
  ang: "Arabic, Judeo-Moroccan",
  lr: "Asia",
  gw: false,
  hc: "IL",
  ln: "\u05DE\u05E8\u05D5\u05E7\u05D0\u05D9\u05EA \u05D9\u05D4\u05D5\u05D3\u05D9\u05EA",
  lc: "aju",
  ld: "rtl",
  alt: [],
  cc: ["VE", "IL", "MA", "TN", "ZM"]
}, {
  pk: 189,
  ang: "Amri Karbi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Amri Karbi",
  lc: "ajz",
  ld: "ltr",
  alt: ["Upper Amri", "Lower Amri"],
  cc: ["IN"]
}, {
  pk: 190,
  ang: "Akan",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Akan",
  lc: "ak",
  ld: "ltr",
  alt: ["Ashante Twi", "Bono", "Dankyira", "Fante (Fanti)", "Gomua", "Kwawu (Kwahu)", "Asen", "Twi", "Akyem (Akyem Bosome)", "Mfantse", "Asanti", "Anomabo Fanti", "Akwapi", "Akwapem Twi", "Akuapem (Akuapim)", "Ahafo", "Agona", "Abura Fanti", "Asante (Achanti)"],
  cc: ["GH"]
}, {
  pk: 191,
  ang: "Batak Angkola",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Batak Angkola",
  lc: "akb",
  ld: "ltr",
  alt: ["Anakola"],
  cc: ["ID"]
}, {
  pk: 192,
  ang: "Mpur",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mpur",
  lc: "akc",
  ld: "ltr",
  alt: ["Amberbaken", "Dekwambre", "Ekware"],
  cc: ["ID"]
}, {
  pk: 193,
  ang: "Ukpet-Ehom",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ukpet-Ehom",
  lc: "akd",
  ld: "ltr",
  alt: ["Ehom (Ebeteng)", "Ubeteng", "Ukpet (Akpet)", "Akpet-Ehom"],
  cc: ["NG"]
}, {
  pk: 194,
  ang: "Akawaio",
  lr: "Americas",
  gw: false,
  hc: "GY",
  ln: "Akawaio",
  lc: "ake",
  ld: "ltr",
  alt: ["Acahuayo", "Acewaio", "Akawai", "Akwaio", "Kap\xF3ng", "Patamona", "Ingariko", "Acawayo", "Waic\xE1", "Waika"],
  cc: ["BR", "VE", "GY"]
}, {
  pk: 195,
  ang: "Akpa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Akpa",
  lc: "akf",
  ld: "ltr",
  alt: ["Akweya"],
  cc: ["NG"]
}, {
  pk: 196,
  ang: "Anakalangu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Anakalangu",
  lc: "akg",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 197,
  ang: "Angal Heneng",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Angal Heneng",
  lc: "akh",
  ld: "ltr",
  alt: ["Waola (Wala)", "Agarar", "Katinja", "Wage", "West Angal Heneng", "West Mendi"],
  cc: ["PG"]
}, {
  pk: 198,
  ang: "Aiome",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Aiome",
  lc: "aki",
  ld: "ltr",
  alt: ["Ayom"],
  cc: ["PG"]
}, {
  pk: 199,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IQ",
  ln: "Akkadian",
  lc: "akk",
  ld: "ltr",
  alt: [],
  cc: ["IQ"]
}, {
  pk: 200,
  ang: "Inakeanon",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Aklanon",
  lc: "akl",
  ld: "ltr",
  alt: ["Aklan", "Aklano", "Aklanon-Bisayan", "Panay"],
  cc: ["PH"]
}, {
  pk: 201,
  ang: "Akurio",
  lr: "Americas",
  gw: false,
  hc: "SR",
  ln: "Akurio",
  lc: "ako",
  ld: "ltr",
  alt: ["Akoerio", "Akuliyo", "Akuri", "Akurijo", "Akuriyo", "Oyaricoulet", "Triometesem", "Triometesen", "Wama", "Wayaricuri"],
  cc: ["BR", "SR"]
}, {
  pk: 202,
  ang: "Siwu",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Siwu",
  lc: "akp",
  ld: "ltr",
  alt: ["Lolobi-Akpafu", "Siwusi"],
  cc: ["GH"]
}, {
  pk: 203,
  ang: "Ak",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ak",
  lc: "akq",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 204,
  ang: "Araki",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Araki",
  lc: "akr",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 205,
  ang: "Akaselem",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Akaselem",
  lc: "aks",
  ld: "ltr",
  alt: ["Akasele", "Cemba", "Chamba", "Kamba", "Kasele", "Tchamba"],
  cc: ["TG"]
}, {
  pk: 206,
  ang: "Akolet",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Akolet",
  lc: "akt",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 207,
  ang: "Akum",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Ukum",
  lc: "aku",
  ld: "ltr",
  alt: ["Anyar", "Okum"],
  cc: ["CM"]
}, {
  pk: 208,
  ang: "Akhvakh",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0410\u0448\u0432a\u043B\u044A\u0438 \u043C\u0438\u0446I\u0438",
  lc: "akv",
  ld: "ltr",
  alt: ["Tsegob", "Southern Akhvakh (Tlyanub)", "Aqwalazul", "Ashvado", "Axvax", "Ghahvalal"],
  cc: ["RU"]
}, {
  pk: 209,
  ang: "Akwa",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Akwa",
  lc: "akw",
  ld: "ltr",
  alt: [],
  cc: ["CG"]
}, {
  pk: 210,
  ang: "Alabama",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Alabama",
  lc: "akz",
  ld: "ltr",
  alt: ["Alibamu"],
  cc: ["US"]
}, {
  pk: 211,
  ang: "Alago",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Alago",
  lc: "ala",
  ld: "ltr",
  alt: ["Arago", "Aragu", "Argo", "Idoma Nokwu"],
  cc: ["NG"]
}, {
  pk: 212,
  ang: "Qawasqar",
  lr: "Americas",
  gw: false,
  hc: "CL",
  ln: "Qawasqar",
  lc: "alc",
  ld: "ltr",
  alt: ["Aksan\xE1s (Aksana)", "Alacaluf", "Alacalufe", "Halakwulup", "Kaweskar", "Kawesqar"],
  cc: ["CL"]
}, {
  pk: 213,
  ang: "Alladian",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Alladian",
  lc: "ald",
  ld: "ltr",
  alt: ["Alladyan", "Allagia", "Allagian"],
  cc: ["CI"]
}, {
  pk: 214,
  ang: "Aleut",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Aleut",
  lc: "ale",
  ld: "ltr",
  alt: ["Atkan", "Attuan", "Bering", "Beringov (Atkan)", "Eastern Aleut (Pribilof Aleut)", "Unalaskan", "Unangan", "Unangany", "Western Aleut (Atka)", "Unanghan"],
  cc: ["US"]
}, {
  pk: 215,
  ang: "Alege",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Alege",
  lc: "alf",
  ld: "ltr",
  alt: ["Alegi", "Uge"],
  cc: ["NG"]
}, {
  pk: 216,
  ang: "Alawa",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Alawa",
  lc: "alh",
  ld: "ltr",
  alt: ["Kallana", "Leealowa"],
  cc: ["AU"]
}, {
  pk: 217,
  ang: "Amaimon",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Amaimon",
  lc: "ali",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 218,
  ang: "Alangan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Alangan",
  lc: "alj",
  ld: "ltr",
  alt: [],
  cc: ["PH"]
}, {
  pk: 219,
  ang: "Alak",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Alak",
  lc: "alk",
  ld: "ltr",
  alt: ["Harak", "Hrlak"],
  cc: ["LA"]
}, {
  pk: 220,
  ang: "Allar",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Allar",
  lc: "all",
  ld: "ltr",
  alt: ["Aalan", "Alan", "Alanmar", "Alar", "Allan", "Chatans"],
  cc: ["IN"]
}, {
  pk: 221,
  ang: "Amblong",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Amblong",
  lc: "alm",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 222,
  ang: "Albanian, Gheg",
  lr: "Europe",
  gw: false,
  hc: "RS",
  ln: "Gheg Albanian",
  lc: "aln",
  ld: "ltr",
  alt: ["Northwest", "Southern", "Gheg", "Central", "Northeast", "Geg", "Guegue", "Shopni", "Shqip", "Shqyp"],
  cc: ["BE", "ME", "AL", "RS", "MK", "US"]
}, {
  pk: 223,
  ang: "Larike-Wakasihu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Larike-Wakasihu",
  lc: "alo",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 224,
  ang: "Alune",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Alune",
  lc: "alp",
  ld: "ltr",
  alt: ["Central East Alune (Buriah-Weth-Laturake)", "Central West Alune (Niniari-Piru-Riring-Lumoli)", "North Coastal Alune (Nikulkan-Murnaten-Wakolo)", "South Alune (Rambatu-Manussa-Rumberu)", "Patasiwa Alfoeren", "Sapalewa"],
  cc: ["ID"]
}, {
  pk: 225,
  ang: "Algonquin",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Algonquin",
  lc: "alq",
  ld: "ltr",
  alt: ["Southern Algonquin (Nipissing)", "Northern Algonquin", "Algonkin", "Anishinaabemowin"],
  cc: ["CA"]
}, {
  pk: 226,
  ang: "Alutor",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0410\u043B\u044E\u0442\u043E\u0440\u0441\u043A\u0438\u0439",
  lc: "alr",
  ld: "ltr",
  alt: ["Alutorskij (Alutor Proper)", "Aliutor", "Alyutor", "Olyutor"],
  cc: ["RU"]
}, {
  pk: 227,
  ang: "Albanian, Tosk",
  lr: "Europe",
  gw: false,
  hc: "AL",
  ln: "Tosk Albanian",
  lc: "als",
  ld: "ltr",
  alt: ["Cham (\xC7am)", "Lab (Lab\xEBrisht)", "Northern", "Tosk", "Cham", "Arnaut", "Shkip", "Shqip", "Shqiper\xEB", "Skchip", "Zhgabe", "Arvanitika"],
  cc: ["BE", "GR", "DE", "GB", "AL", "TR", "US", "CA", "IT", "EG"]
}, {
  pk: 228,
  ang: "Altai, Southern",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0413\u043E\u0440\u043D\u043E-\u0430\u043B\u0442\u0430\u0439\u0441\u043A\u0438\u0435",
  lc: "alt",
  ld: "ltr",
  alt: ["Talangit (Chuy)", "Teleut", "Southern Altai", "Talangit-Tolos", "Telengit", "Maina-Kizhi", "Altai Proper (Altai-Kizhi)", "Altaj Kizi", "Altai", "Oirot", "Oyrot"],
  cc: ["RU"]
}, {
  pk: 229,
  ang: "\u2019Are\u2019are",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "'Are'are",
  lc: "alu",
  ld: "ltr",
  alt: ["Are'are", "Marau (Marau Sound)"],
  cc: ["SB"]
}, {
  pk: 230,
  ang: "Alaba-K\u2019abeena",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Alaba-K\u2019abeena",
  lc: "alw",
  ld: "ltr",
  alt: ["K'abeena", "Wanbasana (Alaba)", "Alaaba", "Allaaba", "Halaba", "K'abena", "Qebena"],
  cc: ["ET"]
}, {
  pk: 231,
  ang: "Amol",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Amol",
  lc: "alx",
  ld: "ltr",
  alt: ["Arang Mol", "Alang Mol", "Aru", "Eru"],
  cc: ["PG"]
}, {
  pk: 232,
  ang: "Alyawarr",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Alyawarr",
  lc: "aly",
  ld: "ltr",
  alt: ["Aljawara", "Alyawarra", "Alyawarre", "Iliaura", "Yowera"],
  cc: ["AU"]
}, {
  pk: 233,
  ang: "Alur",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Alur",
  lc: "alz",
  ld: "ltr",
  alt: ["Ngora", "Aloro", "Alua", "Alulu", "Dho Alur", "Jo Alur", "Lur", "Luri"],
  cc: ["CD", "UG"]
}, {
  pk: 234,
  ang: "Amharic",
  lr: "Africa",
  gw: true,
  hc: "ET",
  ln: "\u12A0\u121B\u122D\u129B",
  lc: "am",
  ld: "ltr",
  alt: ["Abyssinian", "Amarigna", "Amarinya", "Amhara", "Ethiopian", "Falasha"],
  cc: ["DJ", "ER", "ET", "DE", "US", "CA", "EG"]
}, {
  pk: 235,
  ang: "Amanay\xE9",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Amanay\xE9",
  lc: "ama",
  ld: "ltr",
  alt: ["Amanage", "Amanaj\xE9", "Amany\xE9", "Manajo", "Manaxo", "Manaze", "Manazo"],
  cc: ["BR"]
}, {
  pk: 236,
  ang: "Ambo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ambo",
  lc: "amb",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 237,
  ang: "Amahuaca",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Amahuaca",
  lc: "amc",
  ld: "ltr",
  alt: ["Amawaca", "Amaw\xE1ka", "Amenguaca", "Sayacu", "Amaguaco", "Amawaka", "Ameuhaque", "Ipitineri", "Sayaco"],
  cc: ["BR", "PE"]
}, {
  pk: 238,
  ang: "Yanesha\u2019",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Yanesha'",
  lc: "ame",
  ld: "ltr",
  alt: ["Amage", "Amagues", "Amaje", "Amajo", "Amoishe", "Amueixa", "Amuese", "Amuetamo", "Lorenzo", "Omage"],
  cc: ["PE"]
}, {
  pk: 239,
  ang: "Hamer-Banna",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Hamer-Banna",
  lc: "amf",
  ld: "ltr",
  alt: ["Amar", "Amarcocche", "Amer", "Ammar", "Bana", "Beshada", "Cocche", "Hamar", "Hamar-Koke", "Hamer", "Hammer", "Hammercoche", "Kara Kerre"],
  cc: ["ET"]
}, {
  pk: 240,
  ang: "Amurdak",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Amurdak",
  lc: "amg",
  ld: "ltr",
  alt: ["Amarak", "Amardak", "A'moordiyu", "Amurag", "Amurdag", "Amurrag", "Amurrak", "Amurtak", "Amuruk", "Mamurug", "Monobar", "Namurug", "Nga:mr:rak", "Nga:mu:rak", "Ngamurag", "Umoreo", "Umoriu", "Umorrdak", "Wardadjbak", "Woraidbug", "Wureidbug"],
  cc: ["AU"]
}, {
  pk: 241,
  ang: "Amis",
  lr: "Asia",
  gw: false,
  hc: "TW",
  ln: "Amis",
  lc: "ami",
  ld: "ltr",
  alt: ["Kwangfu", "Tavalong-Vataan (Kuangfu)", "Taitung", "Southern Amis (Hengch'un Amis)", "Northern Amis (Nanshi Amis)", "Hsiukulan Ami", "Central Amis (Haian Ami)", "Peinan", "Ami", "Amia", "Bakurut", "Lam-Si-Hoan", "Maran", "Pagcah", "Pangcah", "Pangtsah", "Sabari", "Tanah"],
  cc: ["TW"]
}, {
  pk: 242,
  ang: "Amdang",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Amdang",
  lc: "amj",
  ld: "ltr",
  alt: ["Andangti", "Biltine", "Mima", "Mime", "Mututu"],
  cc: ["SD", "TD"]
}, {
  pk: 243,
  ang: "Ambai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ambai",
  lc: "amk",
  ld: "ltr",
  alt: ["Ambai (Wadapi-Laut)", "Ambai-Menawi"],
  cc: ["ID"]
}, {
  pk: 244,
  ang: "War-Jaintia",
  lr: "Asia",
  gw: false,
  hc: "BD",
  ln: "War-Jaintia",
  lc: "aml",
  ld: "ltr",
  alt: ["War-Khasi", "Amwi", "Khasi", "War"],
  cc: ["BD"]
}, {
  pk: 245,
  ang: "Ama",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ama (Papua New Guinea)",
  lc: "amm",
  ld: "ltr",
  alt: ["Sawiyanu"],
  cc: ["PG"]
}, {
  pk: 246,
  ang: "Amanab",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Amanab",
  lc: "amn",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 247,
  ang: "Amo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Amo",
  lc: "amo",
  ld: "ltr",
  alt: ["Amon", "Among", "Ba"],
  cc: ["NG"]
}, {
  pk: 248,
  ang: "Alamblak",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Alamblak",
  lc: "amp",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 249,
  ang: "Amahai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Amahai",
  lc: "amq",
  ld: "ltr",
  alt: ["Amahei"],
  cc: ["ID"]
}, {
  pk: 250,
  ang: "Amarakaeri",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Amarakaeri",
  lc: "amr",
  ld: "ltr",
  alt: ["Amaracaire", "Amarakaire", "Mashco"],
  cc: ["PE"]
}, {
  pk: 251,
  ang: "Amami-Oshima, Southern",
  lr: "Asia",
  gw: false,
  hc: "JP",
  ln: "\u5944\u7F8E\u5927\u5CF6\u5317\u90E8\u65B9\u8A00",
  lc: "ams",
  ld: "ltr",
  alt: ["Southern Amami-Osima"],
  cc: ["JP"]
}, {
  pk: 252,
  ang: "Amto",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Amto",
  lc: "amt",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 253,
  ang: "Amuzgo, Guerrero",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Guerrero Amuzgo",
  lc: "amu",
  ld: "ltr",
  alt: ["Amuzgo del Norte", "Amuzgo del Sur", "Nomndaa", "\xD1omndaa"],
  cc: ["MX"]
}, {
  pk: 254,
  ang: "Ambelau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ambelau",
  lc: "amv",
  ld: "ltr",
  alt: ["Amblau"],
  cc: ["ID"]
}, {
  pk: 255,
  ang: "Western Neo-Aramaic",
  lr: "Asia",
  gw: false,
  hc: "SY",
  ln: "\u0710\u072A\u0721\u071D\u072C",
  lc: "amw",
  ld: "ltr",
  alt: ["Bakh'a (Bax'a)", "Jub-'adin (Jubb 'Adi:n)", "Maalula", "Loghtha Siryanoytha", "Neo-Western Aramaic", "Siryon", "Ma'lu:la", "Ma'lula (Maaloula)"],
  cc: ["SY"]
}, {
  pk: 256,
  ang: "Anmatyerre",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Anmatyerre",
  lc: "amx",
  ld: "ltr",
  alt: ["Anmatjirra", "Anmatyerr", "Kelentheyewelrere", "Western Anmatyerre (Kalenthelkwe)", "Kelenthwelkere"],
  cc: ["AU"]
}, {
  pk: 257,
  ang: "Ami",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Ami",
  lc: "amy",
  ld: "ltr",
  alt: ["Ame", "Amijangal"],
  cc: ["AU"]
}, {
  pk: 258,
  ang: "Aragonese",
  lr: "Europe",
  gw: false,
  hc: "ES",
  ln: "aragon\xE9s",
  lc: "an",
  ld: "ltr",
  alt: ["Altoaragon\xE9s", "Aragoieraz", "Aragon\xE9s", "Fabla Aragonesa", "High Aragonese", "Patu\xE9s", "Grausino", "Western Aragonese (Ansotano)", "Tensino", "Southern Aragonese (Ayerbense)", "Semontan\xE9s", "Pandicuto", "Eastern Aragonese (Benasqu\xE9s)", "Chistabino", "Cheso", "Central Aragonese (Belset\xE1n)", "Bergot\xE9s", "Fobano"],
  cc: ["ES"]
}, {
  pk: 259,
  ang: "Andaqui",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Andaqui",
  lc: "ana",
  ld: "ltr",
  alt: ["Aguanunga", "Andaki", "Churuba"],
  cc: ["CO"]
}, {
  pk: 260,
  ang: "Ngas",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ngas",
  lc: "anc",
  ld: "ltr",
  alt: ["Angas", "Karang", "Kerang", "Hill Angas"],
  cc: ["NG"]
}, {
  pk: 261,
  ang: "Ansus",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ansus",
  lc: "and",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 262,
  ang: "X\xE2r\xE2c\xF9\xF9",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "X\xE2r\xE2c\xF9\xF9",
  lc: "ane",
  ld: "ltr",
  alt: ["Anesu", "Canala", "Haraneu", "Kanala", "Naa X\xE2r\xE2c\xF9\xF9", "Xaracii"],
  cc: ["NC"]
}, {
  pk: 263,
  ang: "Animere",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Animere",
  lc: "anf",
  ld: "ltr",
  alt: ["Anyimere", "Kunda"],
  cc: ["GH"]
}, {
  pk: 264,
  ang: "Old English",
  lr: "Europe",
  gw: false,
  hc: "GB",
  ln: "Old English (ca. 450-1100)",
  lc: "ang",
  ld: "ltr",
  alt: [],
  cc: ["GB"]
}, {
  pk: 265,
  ang: "Nend",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nend",
  lc: "anh",
  ld: "ltr",
  alt: ["Angaua", "Nent"],
  cc: ["PG"]
}, {
  pk: 266,
  ang: "Andi",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0410\u043D\u0434\u0438\u0439\u0441\u043A\u0438\u0439",
  lc: "ani",
  ld: "ltr",
  alt: ["Andii", "Andiy", "Qandisel", "Qwannab", "Ashali", "Chanho", "Gagtl", "Gunho", "Lower Andi/South Andi", "Upper Andi/North Andi (Andi)"],
  cc: ["RU"]
}, {
  pk: 267,
  ang: "Anor",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Anor",
  lc: "anj",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 268,
  ang: "Goemai",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Goemai",
  lc: "ank",
  ld: "ltr",
  alt: ["Ankwai", "Ankwe", "Ankwei", "Kemai"],
  cc: ["NG"]
}, {
  pk: 269,
  ang: "Chin, Anu-Hkongso",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Anu-Hkongso Chin",
  lc: "anl",
  ld: "ltr",
  alt: ["Kaungso", "Kaungtso", "Khaungtso", "Khawngso", "Khong", "Khongso", "No", "Hkongso"],
  cc: ["MM"]
}, {
  pk: 7726,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Khawng Tu",
  lc: "anl-x-khawngtu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 270,
  ang: "Anal",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Anal",
  lc: "anm",
  ld: "ltr",
  alt: ["Namfau", "Mulsom"],
  cc: ["IN", "MM"]
}, {
  pk: 271,
  ang: "Obolo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Obolo",
  lc: "ann",
  ld: "ltr",
  alt: ["Andone", "Andoni", "Andonni"],
  cc: ["NG"]
}, {
  pk: 272,
  ang: "Andoque",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Andoque",
  lc: "ano",
  ld: "ltr",
  alt: ["Andoke", "Businka", "Cha'oie", "Paasi-ah\xE1", "Paasiaja"],
  cc: ["CO"]
}, {
  pk: 273,
  ang: "Angika",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Angika",
  lc: "anp",
  ld: "ltr",
  alt: ["Anga", "Angikar", "Chhika-Chhiki"],
  cc: ["IN"]
}, {
  pk: 274,
  ang: "Jarawa",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Jarawa (India)",
  lc: "anq",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 275,
  ang: "Andh",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Andh",
  lc: "anr",
  ld: "ltr",
  alt: ["Andha", "Andhi"],
  cc: ["IN"]
}, {
  pk: 276,
  ang: "Antakarinya",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Antakarinya",
  lc: "ant",
  ld: "ltr",
  alt: ["Andagarinya"],
  cc: ["AU"]
}, {
  pk: 277,
  ang: "Anuak",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Anuak",
  lc: "anu",
  ld: "ltr",
  alt: ["Anyuak", "Anywa", "Anywak", "Bar", "Burjin", "Jambo", "Miroy", "Moojanga", "Nuro", "Yambo", "Yembo", "Dho Anywaa"],
  cc: ["ET", "SS", "US"]
}, {
  pk: 278,
  ang: "Denya",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Denya",
  lc: "anv",
  ld: "ltr",
  alt: ["Agnang", "Anyah", "Anyan", "Eyan", "Nyang", "Obonya"],
  cc: ["CM"]
}, {
  pk: 279,
  ang: "Anaang",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Anaang",
  lc: "anw",
  ld: "ltr",
  alt: ["Anang"],
  cc: ["NG"]
}, {
  pk: 280,
  ang: "Andra-Hus",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Andra-Hus",
  lc: "anx",
  ld: "ltr",
  alt: ["Ahus", "Ha'us"],
  cc: ["PG"]
}, {
  pk: 281,
  ang: "Anyin",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Anyin",
  lc: "any",
  ld: "ltr",
  alt: ["Agni", "Anyi", "Brosa", "Sanvi", "Aowin (Brissa)"],
  cc: ["CI", "GH"]
}, {
  pk: 282,
  ang: "Anem",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Anem",
  lc: "anz",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 283,
  ang: "Angolar",
  lr: "Africa",
  gw: false,
  hc: "ST",
  ln: "Angolar",
  lc: "aoa",
  ld: "ltr",
  alt: ["Ngola"],
  cc: ["ST"]
}, {
  pk: 284,
  ang: "Abom",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Abom",
  lc: "aob",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 285,
  ang: "Pemon",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "Pemon",
  lc: "aoc",
  ld: "ltr",
  alt: ["Pemong", "Taulip\xE1ng", "Pishauco", "Arecuna (Arekuna)", "Taurepan (Taulipang)", "Taurepang", "Taulipang (Taurepan)", "Purucoto", "Potsawugok", "Kamaragakok", "Jaricuna", "Ingarik\xF3 (Ingaric\xF3)", "Daigok", "Aricuna", "Camaracota (Ipuricoto)"],
  cc: ["BR", "VE", "GY"]
}, {
  pk: 286,
  ang: "Andarum",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Andarum",
  lc: "aod",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 287,
  ang: "Angal Enen",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Angal Enen",
  lc: "aoe",
  ld: "ltr",
  alt: ["South Angal Heneng", "South Mendi"],
  cc: ["PG"]
}, {
  pk: 288,
  ang: "Bragat",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bragat",
  lc: "aof",
  ld: "ltr",
  alt: ["Alauagat", "Yauan"],
  cc: ["PG"]
}, {
  pk: 289,
  ang: "Angoram",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Angoram",
  lc: "aog",
  ld: "ltr",
  alt: ["Olem", "Pondo", "Tjimundo"],
  cc: ["PG"]
}, {
  pk: 290,
  ang: "Anindilyakwa",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Anindilyakwa",
  lc: "aoi",
  ld: "ltr",
  alt: ["Andiljangwa", "Andilyaugwa", "Aninhdhilyagwa", "Enindhilyagwa", "Enindiljaugwa", "Groote Eylandt", "Ingura", "Wanindilyaugwa"],
  cc: ["AU"]
}, {
  pk: 291,
  ang: "Mufian",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mufian",
  lc: "aoj",
  ld: "ltr",
  alt: ["Muhian", "Southern Arapesh", "Filifita (Ilahita)", "Supari"],
  cc: ["PG"]
}, {
  pk: 292,
  ang: "Arh\xF6",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Arh\xF6",
  lc: "aok",
  ld: "ltr",
  alt: ["Aro"],
  cc: ["NC"]
}, {
  pk: 293,
  ang: "Alor",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Alor",
  lc: "aol",
  ld: "ltr",
  alt: ["Alorese", "Baranusa", "Muna"],
  cc: ["ID"]
}, {
  pk: 294,
  ang: "\xD6mie",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "\xD6mie",
  lc: "aom",
  ld: "ltr",
  alt: ["Upper Managalasi"],
  cc: ["PG"]
}, {
  pk: 295,
  ang: "Arapesh, Bumbita",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bumbita Arapesh",
  lc: "aon",
  ld: "ltr",
  alt: ["Bambita Arapesh", "Weri"],
  cc: ["PG"]
}, {
  pk: 7747,
  ang: "Woginara",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Woginara",
  lc: "aon-x-woginara",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 296,
  ang: "Taikat",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Taikat",
  lc: "aos",
  ld: "ltr",
  alt: ["Arso", "Tajkat"],
  cc: ["ID"]
}, {
  pk: 297,
  ang: "Atong",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Atong (India)",
  lc: "aot",
  ld: "ltr",
  alt: ["Attong"],
  cc: ["IN"]
}, {
  pk: 299,
  ang: "Atorada",
  lr: "Americas",
  gw: false,
  hc: "GY",
  ln: "Atorada",
  lc: "aox",
  ld: "ltr",
  alt: ["Atorad", "Atorai", "Ator'ti", "Dauri"],
  cc: ["GY"]
}, {
  pk: 300,
  ang: "Uab Meto",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Uab Meto",
  lc: "aoz",
  ld: "ltr",
  alt: ["Atoni", "Meto", "Orang Gunung", "Timol", "Timor", "Timoreesch", "Timoreezen", "Timorese", "Uab Atoni Pah Meto", "Uab Pah Meto", "Dawan", "Rawan", "Timor Dawan", "Kusa-Manlea (Kusa)", "Amanuban-Amanatun (Amanatun)", "Mollo-Miomafo (Miomafo)", "Mollo", "Manea", "Insanao", "Fatule'u", "Biboki-Insana (Biboki)", "Amfuang", "Amfoan-Fatule'u-Amabi (Amabi)", "Amfoan", "Amanubang", "Manlea"],
  cc: ["ID", "PT"]
}, {
  pk: 301,
  ang: "Sa\u2019a",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Sa'a",
  lc: "apb",
  ld: "ltr",
  alt: ["Apae'aa", "Saa", "South Malaita", "Uki Ni Masi (Ugi)"],
  cc: ["SB"]
}, {
  pk: 7632,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Ulawa",
  lc: "apb-x-ulawa",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 302,
  ang: "Arabic, North Levantine Spoken",
  lr: "Asia",
  gw: false,
  hc: "SY",
  ln: "\u0644\u0647\u062C\u0627\u062A \u0634\u0627\u0645\u064A\u0629",
  lc: "apc",
  ld: "rtl",
  alt: ["Lebanese-Syrian Arabic", "Levantine Arabic", "Syro-Lebanese Arabic", "North Levantine Arabic", "Beqaa Arabic", "Shii", "Standard Leb", "South-Central Lebanese Arabic (Druze Arabic)", "South Lebanese Arabic (Metuali)", "Saida Sunni Arabic", "North-Central Lebanese Arabic (Mount Lebanon Arabic)", "North Lebanese Arabic", "Iqlim-Al-Kharrub Sunni Arabic", "Jdaideh Arabic", "Lebanese"],
  cc: ["FR", "GF", "DE", "IQ", "IL", "LB", "PA", "VC", "CR", "NL", "SA", "SY", "SE", "TR", "US", "YE", "CG", "CA", "GW", "JO", "KW", "LY", "GP", "DO", "EG", "MQ", "QA", "SR", "AE"]
}, {
  pk: 7789,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "SY",
  ln: "Druze Arabic",
  lc: "apc-x-druzearabic",
  ld: "rtl",
  alt: [],
  cc: []
}, {
  pk: 303,
  ang: "Arabic, Sudanese Spoken",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "\u0644\u0647\u062C\u0629 \u0633\u0648\u062F\u0627\u0646\u064A\u0629",
  lc: "apd",
  ld: "rtl",
  alt: ["Khartoum Arabic", "Sudanese Arabic", "North Kordofan Arabic"],
  cc: ["ER", "ET", "FR", "SS", "OM", "NL", "SA", "SD", "US", "YE", "TD", "CA", "LY", "EG", "QA", "AE"]
}, {
  pk: 304,
  ang: "Bukiyip",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bukiyip",
  lc: "ape",
  ld: "ltr",
  alt: ["Bukiy\xFAp", "Bukiyip (Mountain Arapesh)"],
  cc: ["PG"]
}, {
  pk: 305,
  ang: "Agta, Pahanan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Pahanan Agta",
  lc: "apf",
  ld: "ltr",
  alt: ["Palanan Agta"],
  cc: ["PH"]
}, {
  pk: 306,
  ang: "Ampanang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ampanang",
  lc: "apg",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 307,
  ang: "Athpariya",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u0906\u0920\u092A\u0939\u0930\u093F\u092F\u093E\u200E",
  lc: "aph",
  ld: "ltr",
  alt: ["Arthare", "Athapre", "Athpare", "Athpre", "Sanango Ring"],
  cc: ["NP"]
}, {
  pk: 308,
  ang: "Apiak\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Apiak\xE1",
  lc: "api",
  ld: "ltr",
  alt: ["Apiac\xE1", "Apiake"],
  cc: ["BR"]
}, {
  pk: 309,
  ang: "Apache, Jicarilla",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Jicarilla Apache",
  lc: "apj",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 310,
  ang: "Apache, Kiowa",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Kiowa Apache",
  lc: "apk",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 311,
  ang: "Apache, Lipan",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Lipan Apache",
  lc: "apl",
  ld: "ltr",
  alt: ["Lipan"],
  cc: ["US"]
}, {
  pk: 312,
  ang: "Apache, Mescalero-Chiricahua",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Mescalero-Chiricahua Apache",
  lc: "apm",
  ld: "ltr",
  alt: ["Chiricahua", "Mescalero"],
  cc: ["US"]
}, {
  pk: 313,
  ang: "Apinay\xE9",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Apinay\xE9",
  lc: "apn",
  ld: "ltr",
  alt: ["Apinag\xE9", "Apinaj\xE9"],
  cc: ["BR"]
}, {
  pk: 314,
  ang: "Ambul",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ambul",
  lc: "apo",
  ld: "ltr",
  alt: ["Palik"],
  cc: ["PG"]
}, {
  pk: 315,
  ang: "Apma",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Apma",
  lc: "app",
  ld: "ltr",
  alt: ["Central Raga", "Asuk (Asa)", "Suru Rabwanga (Suru Bo)", "Wolwolan (Volvoluana)", "Asu", "Suru Mwerani", "Suru Kavian"],
  cc: ["VU"]
}, {
  pk: 316,
  ang: "Arop-Lokep",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Arop-Lokep",
  lc: "apr",
  ld: "ltr",
  alt: ["Arop-Lukep", "Moromiranga", "Siasi", "Siassi", "Tolokiwa", "Arop (Poono)", "Lokep (Lokewe)"],
  cc: ["PG"]
}, {
  pk: 317,
  ang: "Arop-Sissano",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Arop-Sissano",
  lc: "aps",
  ld: "ltr",
  alt: ["Arop"],
  cc: ["PG"]
}, {
  pk: 318,
  ang: "Apatani",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Apatani",
  lc: "apt",
  ld: "ltr",
  alt: ["Apa"],
  cc: ["IN"]
}, {
  pk: 319,
  ang: "Apurin\xE3",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Apurin\xE3",
  lc: "apu",
  ld: "ltr",
  alt: ["Ipurin\xE3n", "Kangite", "Popengare"],
  cc: ["BR"]
}, {
  pk: 320,
  ang: "Alapmunte",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Alapmunte",
  lc: "apv",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 321,
  ang: "Apache, Western",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Western Apache",
  lc: "apw",
  ld: "ltr",
  alt: ["Coyotero"],
  cc: ["US"]
}, {
  pk: 322,
  ang: "Aputai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Aputai",
  lc: "apx",
  ld: "ltr",
  alt: ["Ilputih", "Opotai", "Tutunohan", "Lurang"],
  cc: ["ID"]
}, {
  pk: 323,
  ang: "Apala\xED",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Apala\xED",
  lc: "apy",
  ld: "ltr",
  alt: ["Apalay", "Aparai"],
  cc: ["BR"]
}, {
  pk: 324,
  ang: "Safeyoka",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Safeyoka",
  lc: "apz",
  ld: "ltr",
  alt: ["Ambari", "Ampale", "Ampeeli-Wojokeso", "Ampele", "Wajakes (Wocokeso)"],
  cc: ["PG"]
}, {
  pk: 325,
  ang: "Archi",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0410\u0440\u0447\u0438\u043D\u0441\u043A\u0438\u0439",
  lc: "aqc",
  ld: "ltr",
  alt: ["Archib", "Archin", "Archintsy", "Archsel", "Arshashdib"],
  cc: ["RU"]
}, {
  pk: 326,
  ang: "Dogon, Ampari",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Ampari Dogon",
  lc: "aqd",
  ld: "ltr",
  alt: ["Ambeenge", "Ampari", "Pignari"],
  cc: ["ML"]
}, {
  pk: 327,
  ang: "Arigidi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Arigidi",
  lc: "aqg",
  ld: "ltr",
  alt: ["North Akoko", "Oke-Agbe", "Udo (Ido)", "\xD2w\xF2n \xD9d\xF2", "\xD2w\xF2n \xC0f\xE1", "\xD2ge (\xD2w\xF2n \xD2g\xE8)", "Igashi (\xCCg\xE0sh\xED)", "Ese (\xD2w\xF2n \xC8s\xE9)", "Er\xFAs\xFA (Erushu)", "Afa (Affa)", "\xD2w\xF2n \xCCg\xE1s\xED", "\xCCg\xE1s\xED"],
  cc: ["NG"]
}, {
  pk: 328,
  ang: "Atohwaim",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Atohwaim",
  lc: "aqm",
  ld: "ltr",
  alt: ["Kaugat"],
  cc: ["ID"]
}, {
  pk: 329,
  ang: "Alta, Northern",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Northern Alta",
  lc: "aqn",
  ld: "ltr",
  alt: ["Baler Negrito", "Ditaylin Alta", "Ditaylin Dumagat", "Edimala"],
  cc: ["PH"]
}, {
  pk: 330,
  ang: "Atakapa",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Atakapa",
  lc: "aqp",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 331,
  ang: "Arh\xE2",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Arh\xE2",
  lc: "aqr",
  ld: "ltr",
  alt: ["Ara"],
  cc: ["NC"]
}, {
  pk: 332,
  ang: "Angait\xE9",
  lr: "Americas",
  gw: false,
  hc: "PY",
  ln: "Angait\xE9",
  lc: "aqt",
  ld: "ltr",
  alt: [],
  cc: ["PY"]
}, {
  pk: 333,
  ang: "Akuntsu",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Akuntsu",
  lc: "aqz",
  ld: "ltr",
  alt: ["Akunsu", "Akuntsun"],
  cc: ["BR"]
}, {
  pk: 334,
  ang: "Arabic",
  lr: "Asia",
  gw: true,
  hc: "SA",
  ln: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
  lc: "ar",
  ld: "rtl",
  alt: [],
  cc: ["SA"]
}, {
  pk: 335,
  ang: "Arabic, Standard",
  lr: "Asia",
  gw: false,
  hc: "SA",
  ln: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0641\u0635\u062D\u0649, \u0639\u0631\u0628\u064A \u0641\u0635\u064A\u062D",
  lc: "arb",
  ld: "rtl",
  alt: ["Al-'Arabiyya", "Al-Fusha", "Literary Arabic", "Modern Standard Arabic (Modern Literary Arabic)", "Quranic Arabic", "Classical Arabic (Koranic Arabic)"],
  cc: ["DZ", "AT", "BD", "CL", "BR", "BB", "KM", "DM", "GR", "ET", "FR", "GF", "DE", "HT", "GH", "IQ", "LB", "MT", "LK", "GB", "JM", "MY", "OM", "NL", "NZ", "PK", "RW", "SA", "SD", "ZA", "CH", "CO", "TN", "AU", "CA", "EC", "GN", "IT", "KW", "DK", "MV", "PT", "UG", "VG", "IN", "SG", "BH", "BI", "EG", "QA", "AE"]
}, {
  pk: 336,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "SY",
  ln: "Official Aramaic (700-300 BCE)",
  lc: "arc",
  ld: "rtl",
  alt: [],
  cc: ["SY"]
}, {
  pk: 337,
  ang: "Arabana",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Arabana",
  lc: "ard",
  ld: "ltr",
  alt: ["Arabunna"],
  cc: ["AU"]
}, {
  pk: 338,
  ang: "Arrarnta, Western",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Western Arrarnta",
  lc: "are",
  ld: "ltr",
  alt: ["Aranda", "Arunta", "Western Aranda", "Akerre (Akara)"],
  cc: ["AU"]
}, {
  pk: 339,
  ang: "Arhuaco",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Arhuaco",
  lc: "arh",
  ld: "ltr",
  alt: ["Aruaco", "Bintucua", "Bintuk", "B\xEDntukua", "Ica", "Ijca", "Ijka", "Ika", "Ikan", "Ike"],
  cc: ["CO"]
}, {
  pk: 340,
  ang: "Arikara",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Arikara",
  lc: "ari",
  ld: "ltr",
  alt: ["Arikaree", "Arikari", "Arikaris", "Ree", "Ris"],
  cc: ["US"]
}, {
  pk: 341,
  ang: "Arapaso",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Arapaso",
  lc: "arj",
  ld: "ltr",
  alt: ["Arapa\xE7o", "Araspaso", "Kone\xE1"],
  cc: ["BR"]
}, {
  pk: 342,
  ang: "Arikap\xFA",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Arikap\xFA",
  lc: "ark",
  ld: "ltr",
  alt: ["Aricap\xFA", "Maxub\xED"],
  cc: ["BR"]
}, {
  pk: 343,
  ang: "Arabela",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Arabela",
  lc: "arl",
  ld: "ltr",
  alt: ["Chiripuno", "Chiripunu"],
  cc: ["PE"]
}, {
  pk: 344,
  ang: "Mapudungun",
  lr: "Americas",
  gw: false,
  hc: "CL",
  ln: "Mapudungun",
  lc: "arn",
  ld: "ltr",
  alt: ["Araucano", "Huilliche", "Manzanero", "Mapuche", "Mapudungu", "Maputongo", "Ranquel", "Moluche (Manzanero)", "Ngoluche"],
  cc: ["CL", "AR"]
}, {
  pk: 345,
  ang: "Araona",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Araona",
  lc: "aro",
  ld: "ltr",
  alt: [],
  cc: ["BO"]
}, {
  pk: 346,
  ang: "Arapaho",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Arapaho",
  lc: "arp",
  ld: "ltr",
  alt: ["Arrapahoe"],
  cc: ["US"]
}, {
  pk: 347,
  ang: "Arabic, Algerian Spoken",
  lr: "Africa",
  gw: false,
  hc: "DZ",
  ln: "\u062F\u0632\u064A\u0631\u064A\u0629",
  lc: "arq",
  ld: "rtl",
  alt: ["Algerian", "Constantine"],
  cc: ["DZ", "BE", "BF", "FR", "ES", "NL", "TN", "US", "CA", "IT", "EG"]
}, {
  pk: 348,
  ang: "Karo",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Karo (Brazil)",
  lc: "arr",
  ld: "ltr",
  alt: ["Ar\xE1ra", "Ar\xE1ra de Rondonia", "Ar\xE1ra do Jiparan\xE1", "Arara-Karo", "Itanga", "Itogapuc", "Itogap\xFAk", "Ntogapid", "Ntogapig", "Ramarama", "Uruku", "Uruk\xFA", "Arara"],
  cc: ["BR"]
}, {
  pk: 349,
  ang: "Arabic, Najdi Spoken",
  lr: "Asia",
  gw: false,
  hc: "SA",
  ln: "\u0627\u0644\u0644\u0647\u062C\u0629 \u0627\u0644\u0646\u062C\u062F\u064A\u0629",
  lc: "ars",
  ld: "rtl",
  alt: ["Bedawi", "North Najdi (Shammar)", "Utaiba", "Sudair", "South Anjdi (Aal Murrah)", "Shammari", "Rwala", "Riyadh", "Haayil", "Rashaayda", "Wild 'Ali", "North Najdi (Bani Khaalid)", "Najran", "Najraan", "Hofuf", "Dafiir", "Central Najdi ('Ajmaan)", "Biishah", "Awaazim", "Al-Qasiim", "Mutair"],
  cc: ["IQ", "SA", "SY", "US", "CA", "JO", "KW", "BH"]
}, {
  pk: 350,
  ang: "Aru\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Aru\xE1 (Amazonas State)",
  lc: "aru",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 351,
  ang: "Arbore",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Arbore",
  lc: "arv",
  ld: "ltr",
  alt: ["Arbora", "Irbore"],
  cc: ["ET"]
}, {
  pk: 352,
  ang: "Arawak",
  lr: "Americas",
  gw: false,
  hc: "SR",
  ln: "Arawak",
  lc: "arw",
  ld: "ltr",
  alt: ["Lokono", "Arowak"],
  cc: ["GF", "VE", "GY", "US", "SR"]
}, {
  pk: 353,
  ang: "Aru\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Aru\xE1 (Rodonia State)",
  lc: "arx",
  ld: "ltr",
  alt: ["Aru\xE1shi (Aruachi)"],
  cc: ["BR"]
}, {
  pk: 7506,
  ang: "Arabic - Dominant Culture Variant",
  lr: "Asia",
  gw: true,
  hc: "SA",
  ln: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629 Dominant Culture Variant",
  lc: "ar-x-dcv",
  ld: "rtl",
  alt: [],
  cc: ["SA"]
}, {
  pk: 354,
  ang: "Arabic, Moroccan Spoken",
  lr: "Africa",
  gw: false,
  hc: "MA",
  ln: "\u0627\u0644\u062F\u0627\u0631\u062C\u0629",
  lc: "ary",
  ld: "rtl",
  alt: ["Colloquial Arabic", "Maghrebi Arabic", "Maghribi", "Moroccan Arabic", "Moroccan Colloquial Arabic", "Moroccan Dareja", "Moroccan Darija", "Moroccan Dereja", "Fez", "Tangier", "Meknes", "Jebelia", "Jebli (Jbala)", "Marrakech"],
  cc: ["DZ", "BE", "FR", "DE", "MA", "ES", "GB", "NL", "US", "CA", "IT", "LY", "GI", "PT"]
}, {
  pk: 355,
  ang: "Arabic, Egyptian Spoken",
  lr: "Africa",
  gw: false,
  hc: "EG",
  ln: "\u0627\u0644\u0644\u063A\u0647 \u0627\u0644\u0645\u0635\u0631\u064A\u0647 \u0627\u0644\u0639\u0627\u0645\u064A\u0647",
  lc: "arz",
  ld: "rtl",
  alt: ["Lower Egypt Arabic", "Masri", "Massry", "Normal Egyptian Arabic", "South Central Delta Arabic"],
  cc: ["DZ", "BE", "FR", "DE", "IQ", "IL", "ES", "GB", "OM", "SA", "SD", "US", "YE", "AU", "JO", "IT", "KW", "LY", "EG", "QA", "AE"]
}, {
  pk: 356,
  ang: "Assamese",
  lr: "Asia",
  gw: true,
  hc: "IN",
  ln: "\u0985\u09B8\u09AE\u09C0\u09AF\u09BC\u09BE",
  lc: "as",
  ld: "ltr",
  alt: ["Asambe", "Asami", "Asamiya", "Jharwa (Pidgin)", "Standard Assamese", "Western Assamese (Kamrupi)"],
  cc: ["BD", "BT", "US", "PF", "IN"]
}, {
  pk: 357,
  ang: "Asu",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Asu",
  lc: "asa",
  ld: "ltr",
  alt: ["Athu", "Casu", "Chasu", "Chiasu", "Kipare"],
  cc: ["KE", "TZ"]
}, {
  pk: 358,
  ang: "Assiniboine",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Assiniboine",
  lc: "asb",
  ld: "ltr",
  alt: ["Hohe"],
  cc: ["US", "CA"]
}, {
  pk: 359,
  ang: "Asmat, Casuarina Coast",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Casuarina Coast Asmat",
  lc: "asc",
  ld: "ltr",
  alt: ["Kaweinag", "Sapan (Safan)"],
  cc: ["ID"]
}, {
  pk: 360,
  ang: "Asas",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Asas",
  lc: "asd",
  ld: "ltr",
  alt: ["Kow"],
  cc: ["PG"]
}, {
  pk: 7768,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kou",
  lc: "asd-x-kou",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 361,
  ang: "American Sign Language",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "American Sign Language",
  lc: "ase",
  ld: "ltr",
  alt: ["Ameslan", "ASL", "Tactile ASL (TASL)"],
  cc: ["ML", "US", "CA"]
}, {
  pk: 8450,
  ang: "Benin Sign Language",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Benin Sign Language",
  lc: "ase-x-beninsl",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8219,
  ang: "Burkina Faso Sign Language",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Burkina Faso Sign Language",
  lc: "ase-x-burkinasl",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7695,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Cameroonian Anglophone Sign Language",
  lc: "ase-x-camanglosl",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7696,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Cameroonian Francophone Sign Language",
  lc: "ase-x-camfrancsl",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8451,
  ang: "Cote d'Ivoire",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Cote d'Ivoire Sign Language",
  lc: "ase-x-cotedivosl",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7697,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Gabonese Sign Language",
  lc: "ase-x-gabonesesl",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8315,
  ang: "Togolese Sign Language",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Togolese Sign Language",
  lc: "ase-x-togolesesl",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 362,
  ang: "Australian Sign Language",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Australian Sign Language",
  lc: "asf",
  ld: "ltr",
  alt: ["Auslan"],
  cc: ["AU"]
}, {
  pk: 363,
  ang: "Cishingini",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Cishingini",
  lc: "asg",
  ld: "ltr",
  alt: ["Agwara Kambari", "Aschingini", "Ashaganna", "Ashingini", "Chisingini", "Kambari", "Kamberchi", "Kamberri", "Yauri", "Maunchi", "Mawanchi"],
  cc: ["NG"]
}, {
  pk: 364,
  ang: "Buruwai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Buruwai",
  lc: "asi",
  ld: "ltr",
  alt: ["Asianara", "Asienara", "Karufa", "Madidwana", "Sabakor"],
  cc: ["ID"]
}, {
  pk: 365,
  ang: "Sari",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Sari",
  lc: "asj",
  ld: "ltr",
  alt: ["Akweto", "Pesaa", "Saari", "Sali"],
  cc: ["CM"]
}, {
  pk: 366,
  ang: "Ashkun",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Ashkun",
  lc: "ask",
  ld: "ltr",
  alt: ["Ashkund", "Wamais", "Wamayi", "Suruviri (Wamai)", "Titin Bajaygul", "Ashuruviri (Kolata)"],
  cc: ["AF"]
}, {
  pk: 367,
  ang: "Asilulu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Asilulu",
  lc: "asl",
  ld: "ltr",
  alt: ["Negeri Lima (Henalima)", "Lima"],
  cc: ["ID"]
}, {
  pk: 8268,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "BW",
  ln: "Botswana Sign Language",
  lc: "asl-x-botswanasl",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 368,
  ang: "Asurini of Xing\xFA",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Xing\xFA Asurin\xED",
  lc: "asn",
  ld: "ltr",
  alt: ["Asurin\xED de Koatinema", "Asurini do Xing\xFA", "Awaet\xE9", "Awat\xE9"],
  cc: ["BR"]
}, {
  pk: 369,
  ang: "Dano",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Dano",
  lc: "aso",
  ld: "ltr",
  alt: ["Asaro", "Upper Asaro"],
  cc: ["PG"]
}, {
  pk: 370,
  ang: "Algerian Sign Language",
  lr: "Africa",
  gw: false,
  hc: "DZ",
  ln: "\u0644\u063A\u0629 \u0627\u0644\u0625\u0634\u0627\u0631\u0629 \u0627\u0644\u062C\u0632\u0627\u0626\u0631",
  lc: "asp",
  ld: "ltr",
  alt: [],
  cc: ["DZ"]
}, {
  pk: 371,
  ang: "Austrian Sign Language",
  lr: "Europe",
  gw: false,
  hc: "AT",
  ln: "Austrian Sign Language",
  lc: "asq",
  ld: "ltr",
  alt: ["\xD6GS", "\xD6sterreichische Geb\xE4rdensprache"],
  cc: ["AT"]
}, {
  pk: 372,
  ang: "Asuri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Asuri",
  lc: "asr",
  ld: "ltr",
  alt: ["Ashree", "Assur", "Asura", "Maleta", "Brijia (Birjia)", "Koranti"],
  cc: ["IN"]
}, {
  pk: 373,
  ang: "Ipulo",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Ipulo",
  lc: "ass",
  ld: "ltr",
  alt: ["Assumbo", "Asumbo", "Badzumbo"],
  cc: ["CM"]
}, {
  pk: 374,
  ang: "Asturian",
  lr: "Europe",
  gw: false,
  hc: "ES",
  ln: "Asturian",
  lc: "ast",
  ld: "ltr",
  alt: ["Asturian-Leonese", "Asturianu", "Astur-Leonese", "Leonese (Lleones)", "Monta\xF1es", "Central Asturian (Bable)"],
  cc: ["ES"]
}, {
  pk: 375,
  ang: "Asurini, Tocantins",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Tocantins Asurini",
  lc: "asu",
  ld: "ltr",
  alt: ["Akwaya", "Assurin\xED", "Asurin\xED", "Asurin\xED do Tocantins", "Asurin\xED do Trocar\xE1"],
  cc: ["BR"]
}, {
  pk: 376,
  ang: "Asoa",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Asoa",
  lc: "asv",
  ld: "ltr",
  alt: ["Asua", "Asuae", "Asuati", "Aka"],
  cc: ["CD"]
}, {
  pk: 377,
  ang: "Australian Aborigines Sign Language",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Australian Aborigines Sign Language",
  lc: "asw",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 378,
  ang: "Muratayak",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Muratayak",
  lc: "asx",
  ld: "ltr",
  alt: ["Murataik"],
  cc: ["PG"]
}, {
  pk: 379,
  ang: "Asmat, Yaosakor",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Yaosakor Asmat",
  lc: "asy",
  ld: "ltr",
  alt: ["Yaosakor"],
  cc: ["ID"]
}, {
  pk: 380,
  ang: "As",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "As",
  lc: "asz",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 381,
  ang: "Pele-Ata",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Pele-Ata",
  lc: "ata",
  ld: "ltr",
  alt: ["Uase", "Uasi", "Uasilau", "Wasi"],
  cc: ["PG"]
}, {
  pk: 382,
  ang: "Zaiwa",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u8F7D\u74E6",
  lc: "atb",
  ld: "ltr",
  alt: ["Aci", "Aji", "Atshi", "Atsi-Maru", "Atzi", "Azi", "Szi", "Tsaiwa", "Xiaoshanhua", "Zi", "Tingzhu", "Bengwa", "Longzhun"],
  cc: ["CN", "MM"]
}, {
  pk: 383,
  ang: "Atsahuaca",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Atsahuaca",
  lc: "atc",
  ld: "ltr",
  alt: [],
  cc: ["PE"]
}, {
  pk: 384,
  ang: "Manobo, Ata",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Ata Manobo",
  lc: "atd",
  ld: "ltr",
  alt: ["Ata of Davao", "Atao Manobo", "Langilan"],
  cc: ["PH"]
}, {
  pk: 7676,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Ata Paquibato Manobo",
  lc: "atd-x-paquib",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 385,
  ang: "Atemble",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Atemble",
  lc: "ate",
  ld: "ltr",
  alt: ["Atemple", "Atemple-Apris"],
  cc: ["PG"]
}, {
  pk: 386,
  ang: "Ivbie North-Okpela-Arhe",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ivbie North-Okpela-Arhe",
  lc: "atg",
  ld: "ltr",
  alt: ["Upella", "Ukpella", "Okpela (Okpella)", "Ivbie North (Ibie North)", "Arhe (Ate)", "Atte"],
  cc: ["NG"]
}, {
  pk: 387,
  ang: "Atti\xE9",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Atti\xE9",
  lc: "ati",
  ld: "ltr",
  alt: ["Akie", "Akye", "Atche", "Atie", "Atshe"],
  cc: ["CI"]
}, {
  pk: 388,
  ang: "Atikamekw",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Atikamekw",
  lc: "atj",
  ld: "ltr",
  alt: ["Atihkamekw", "Atikamek", "Attikamek", "Attimewk", "T\xEAte de Boule"],
  cc: ["CA"]
}, {
  pk: 389,
  ang: "Ati",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Ati",
  lc: "atk",
  ld: "ltr",
  alt: ["Inati"],
  cc: ["PH"]
}, {
  pk: 390,
  ang: "Agta, Mt. Iraya",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Mt. Iraya Agta",
  lc: "atl",
  ld: "ltr",
  alt: ["Inagta of Mt. Iraya", "Itbeg Rugnot", "Lake Buhi", "Rugnot of Lake Buhi East"],
  cc: ["PH"]
}, {
  pk: 391,
  ang: "Ata",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Ata",
  lc: "atm",
  ld: "ltr",
  alt: [],
  cc: ["PH"]
}, {
  pk: 392,
  ang: "Ashtiani",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u0632\u0628\u0627\u0646 \u0622\u0634\u062A\u06CC\u0627\u0646\u06CC",
  lc: "atn",
  ld: "ltr",
  alt: ["Ashtiyani", "Astiani", "Tafresh"],
  cc: ["IR"]
}, {
  pk: 393,
  ang: "Atong",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Atong (Cameroon)",
  lc: "ato",
  ld: "ltr",
  alt: ["Etoh"],
  cc: ["CM"]
}, {
  pk: 394,
  ang: "Atta, Pudtol",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Pudtol Atta",
  lc: "atp",
  ld: "ltr",
  alt: [],
  cc: ["PH"]
}, {
  pk: 395,
  ang: "Aralle-Tabulahan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Aralle-Tabulahan",
  lc: "atq",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 396,
  ang: "Waimiri-Atroar\xED",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Waimiri-Atroari",
  lc: "atr",
  ld: "ltr",
  alt: ["Atroahy", "Atroa\xED", "Atroar\xED", "Atrowari", "Atruah\xED", "Ki'nya", "Jawaperi (Yauaperi)", "Wahmir\xED", "Waimir\xED (Uaimir\xED)"],
  cc: ["BR"]
}, {
  pk: 397,
  ang: "Gros Ventre",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Gros Ventre",
  lc: "ats",
  ld: "ltr",
  alt: ["Ahahnelin", "Ahe", "Ananin", "Atsina", "Fall Indians", "Gros Ventres", "White Clay People"],
  cc: ["US"]
}, {
  pk: 398,
  ang: "Atta, Pamplona",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Pamplona Atta",
  lc: "att",
  ld: "ltr",
  alt: ["Northern Cagayan Negrito"],
  cc: ["PH"]
}, {
  pk: 399,
  ang: "Reel",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Reel",
  lc: "atu",
  ld: "ltr",
  alt: ["Atwot", "Thok Cieng Reel", "Thok Reel", "Cieng Luai", "Cieng Nhyam"],
  cc: ["SS"]
}, {
  pk: 400,
  ang: "Altai, Northern",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0413\u043E\u0440\u043D\u043E-\u0430\u043B\u0442\u0430\u0439\u0441\u043A\u0430\u044F",
  lc: "atv",
  ld: "ltr",
  alt: ["Telengit", "Telengut", "Teleut", "Chalkan", "Kumandy", "Tuba"],
  cc: ["RU"]
}, {
  pk: 401,
  ang: "Atsugewi",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Atsugewi",
  lc: "atw",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 402,
  ang: "Arutani",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Arutani",
  lc: "atx",
  ld: "ltr",
  alt: ["Aoaqui", "Auake", "Auaqu\xE9", "Awake", "Oewaku", "Orotani", "Uruak", "Urutani", "Awak\xE9"],
  cc: ["BR", "VE"]
}, {
  pk: 403,
  ang: "Aneityum",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Aneityum",
  lc: "aty",
  ld: "ltr",
  alt: ["Aneiteum", "Aneiteumese", "Anejom"],
  cc: ["VU"]
}, {
  pk: 404,
  ang: "Arta",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Arta",
  lc: "atz",
  ld: "ltr",
  alt: [],
  cc: ["PH"]
}, {
  pk: 405,
  ang: "Asumboa",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Asumboa",
  lc: "aua",
  ld: "ltr",
  alt: ["Asumbua", "Asumuo"],
  cc: ["SB"]
}, {
  pk: 406,
  ang: "Alugu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Alugu",
  lc: "aub",
  ld: "ltr",
  alt: ["Muji", "Phula", "Phupha"],
  cc: ["CN"]
}, {
  pk: 407,
  ang: "Waorani",
  lr: "Americas",
  gw: false,
  hc: "EC",
  ln: "Waorani",
  lc: "auc",
  ld: "ltr",
  alt: ["Huaorani", "Sabela", "Waodani", "Auca"],
  cc: ["EC"]
}, {
  pk: 408,
  ang: "Anuta",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Anuta",
  lc: "aud",
  ld: "ltr",
  alt: [],
  cc: ["SB"]
}, {
  pk: 409,
  ang: "Aguna",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Aguna",
  lc: "aug",
  ld: "ltr",
  alt: ["Agunaco", "Awuna", "Agunagbe", "Agunan\xFD"],
  cc: ["BJ"]
}, {
  pk: 410,
  ang: "Aushi",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Aushi",
  lc: "auh",
  ld: "ltr",
  alt: ["Avaushi", "Ushi", "Usi", "Uzhili", "Vouaousi", "Uzhil"],
  cc: ["ZM"]
}, {
  pk: 411,
  ang: "Anuki",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Anuki",
  lc: "aui",
  ld: "ltr",
  alt: ["Gabobora"],
  cc: ["PG"]
}, {
  pk: 412,
  ang: "Awjilah",
  lr: "Africa",
  gw: false,
  hc: "LY",
  ln: "\u0644\u063A\u0629 \u0623\u0648\u062C\u0644\u064A\u0629",
  lc: "auj",
  ld: "ltr",
  alt: ["Aoudjila", "Augila", "Aujila", "Awjila"],
  cc: ["LY"]
}, {
  pk: 413,
  ang: "Heyo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Heyo",
  lc: "auk",
  ld: "ltr",
  alt: ["Arima", "Arinua", "Arinwa", "Lolopani", "Ruruhip", "Wan Wan"],
  cc: ["PG"]
}, {
  pk: 414,
  ang: "Aulua",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Aulua",
  lc: "aul",
  ld: "ltr",
  alt: ["Aulua Bay"],
  cc: ["VU"]
}, {
  pk: 415,
  ang: "Asu",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Asu (Nigeria)",
  lc: "aum",
  ld: "ltr",
  alt: ["Abewa", "Ebe"],
  cc: ["NG"]
}, {
  pk: 416,
  ang: "One, Molmo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Molmo One",
  lc: "aun",
  ld: "ltr",
  alt: ["Aunalei", "Molmo", "Onele", "Oni"],
  cc: ["PG"]
}, {
  pk: 417,
  ang: "Auyokawa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Auyokawa",
  lc: "auo",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 418,
  ang: "Makayam",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Makayam",
  lc: "aup",
  ld: "ltr",
  alt: ["Adulu", "Atura", "Makaeyam", "Tirio", "Giribam"],
  cc: ["PG"]
}, {
  pk: 419,
  ang: "Anus",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Anus",
  lc: "auq",
  ld: "ltr",
  alt: ["Korur"],
  cc: ["ID"]
}, {
  pk: 420,
  ang: "Aruek",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Aruek",
  lc: "aur",
  ld: "ltr",
  alt: ["Djang"],
  cc: ["PG"]
}, {
  pk: 421,
  ang: "Austral",
  lr: "Pacific",
  gw: false,
  hc: "PF",
  ln: "Austral",
  lc: "aut",
  ld: "ltr",
  alt: ["Tubuai-Rurutu"],
  cc: ["PF"]
}, {
  pk: 422,
  ang: "Auye",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Auye",
  lc: "auu",
  ld: "ltr",
  alt: ["Auwje"],
  cc: ["ID"]
}, {
  pk: 423,
  ang: "Awyi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Awyi",
  lc: "auw",
  ld: "ltr",
  alt: ["Awje", "Awji", "Awye", "Njao", "Nyao"],
  cc: ["ID"]
}, {
  pk: 424,
  ang: "Awiyaana",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Awiyaana",
  lc: "auy",
  ld: "ltr",
  alt: ["Auyana"],
  cc: ["PG"]
}, {
  pk: 8484,
  ang: "Abomatasa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Abomatasa",
  lc: "auy-x-abomatasa",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8483,
  ang: "Ati",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ati",
  lc: "auy-x-ati",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 425,
  ang: "Arabic, Uzbeki Spoken",
  lr: "Asia",
  gw: false,
  hc: "UZ",
  ln: "Uzbeki Arabic",
  lc: "auz",
  ld: "rtl",
  alt: ["Central Asian Arabic", "Jugari", "Kashkadarya Arabic", "Uzbeki Arabic"],
  cc: ["UZ"]
}, {
  pk: 426,
  ang: "Avaric",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0430\u0432\u0430\u0440 \u043C\u0430\u0446\u04C0, \u043C\u0430\u0433\u04C0\u0430\u0440\u0443\u043B \u043C\u0430\u0446\u04C0",
  lc: "av",
  ld: "ltr",
  alt: ["Avaro", "Dagestani", "Bolmac", "Khundzuri", "Maarul Dagestani", "Qusur", "South-East Avar (Andalal)", "South-West Avar (Batlukh)", "Unkratl", "North Avar (Andian Avar)", "Zaqatala (Char)", "Khunzakh", "Zaqatal (Char)", "Andalal Shulanin", "Karakh", "Hid Keleb", "Hid Kaxib", "Bolmats", "Antsukh (Ancux)", "Antsukh", "Andalal Untib", "Qarakh (Bacadin)"],
  cc: ["AZ", "KZ", "RU", "TM", "UZ"]
}, {
  pk: 427,
  ang: "Avau",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Avau",
  lc: "avb",
  ld: "ltr",
  alt: ["Awau"],
  cc: ["PG"]
}, {
  pk: 428,
  ang: "Alviri-Vidari",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Alviri-Vidari",
  lc: "avd",
  ld: "ltr",
  alt: ["Alvir (Alviri)", "Vidar (Vidari)"],
  cc: ["IR"]
}, {
  pk: 429,
  ang: "Avikam",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Avikam",
  lc: "avi",
  ld: "ltr",
  alt: ["Avekom", "Brinya", "Gbanda", "Kwakwa", "Lahu"],
  cc: ["CI"]
}, {
  pk: 430,
  ang: "",
  lr: "",
  gw: false,
  hc: "",
  ln: "Kotava",
  lc: "avk",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 431,
  ang: "Arabic, Eastern Egyptian Bedawi Spoken",
  lr: "Africa",
  gw: false,
  hc: "EG",
  ln: "\u0644\u0647\u062C\u0629 \u0628\u062F\u0648\u064A\u0629",
  lc: "avl",
  ld: "rtl",
  alt: ["Bedawi", "Levantine Bedawi Arabic", "Levantine Bedawi Spoken Arabic", "Eastern Egyptian Bedawi Arabic", "North Levantine Bedawi Arabic", "Northeast Egyptian Bedawi Arabic", "South Levantine Bedawi Arabic"],
  cc: ["IL", "SY", "EG"]
}, {
  pk: 432,
  ang: "Avatime",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Avatime",
  lc: "avn",
  ld: "ltr",
  alt: ["Afatime", "Sia", "Sideme", "Si-ya"],
  cc: ["GH"]
}, {
  pk: 433,
  ang: "Au",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Au",
  lc: "avt",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 434,
  ang: "Avokaya",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Avokaya",
  lc: "avu",
  ld: "ltr",
  alt: ["Abukeia", "Ajigu (Ajugu)", "Ojiga", "Ojila (Odzila)", "Agamoru", "Odziliwa", "Ajugu (Adjiga)"],
  cc: ["SS"]
}, {
  pk: 435,
  ang: "Av\xE1-Canoeiro",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Av\xE1-Canoeiro",
  lc: "avv",
  ld: "ltr",
  alt: ["Ab\xE1", "Av\xE1", "Awana", "Canoa", "Canoe", "Canoeiros"],
  cc: ["BR"]
}, {
  pk: 436,
  ang: "Awadhi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Awadhi",
  lc: "awa",
  ld: "ltr",
  alt: ["Abadi", "Abohi", "Ambodhi", "Avadhi", "Baiswari", "Kojali", "Kosali", "Abadhi", "Dehati", "Deshi", "Gawnaru", "Koseli", "Chhatisgadhi"],
  cc: ["NP", "IN"]
}, {
  pk: 437,
  ang: "Awa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Awa (Papua New Guinea)",
  lc: "awb",
  ld: "ltr",
  alt: ["Mobuta", "Tauna", "Ilakia", "South Awa"],
  cc: ["PG"]
}, {
  pk: 438,
  ang: "Cicipu",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Cicipu",
  lc: "awc",
  ld: "ltr",
  alt: ["Achipa", "Acipanci", "Western Acipa", "Tizoriyo (Mazarko)", "Tirisino (Karishen)", "Tikumbasi (Kumbashi)", "Tikula (Maburya)", "Tidodimo (Kadedan)", "Ticuhun (Kakihum)", "Tidipo (Kadonho)"],
  cc: ["NG"]
}, {
  pk: 439,
  ang: "Awet\xED",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Awet\xED",
  lc: "awe",
  ld: "ltr",
  alt: ["Arauine", "Arauite", "Aueti", "Aueto", "Auiti", "Awet\xF6"],
  cc: ["BR"]
}, {
  pk: 440,
  ang: "Awbono",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Awbono",
  lc: "awh",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 441,
  ang: "Aekyom",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Aekyom",
  lc: "awi",
  ld: "ltr",
  alt: ["Aiwin", "Akium", "Awin", "West Awin"],
  cc: ["PG"]
}, {
  pk: 442,
  ang: "Awabakal",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Awabakal",
  lc: "awk",
  ld: "ltr",
  alt: ["Awabagal", "Wonarua", "Cameeragal"],
  cc: ["AU"]
}, {
  pk: 443,
  ang: "Arawum",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Arawum",
  lc: "awm",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 444,
  ang: "Awngi",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Awngi",
  lc: "awn",
  ld: "ltr",
  alt: ["Agau", "Agaw", "Agew", "Agow", "Awawar", "Awi", "Awiya", "Damot", "Kumfel", "Kunfel", "Kwollanyoch", "Kunf\xE4l", "Dega", "Kunf\xE4l (Northern Awngi)", "Kwolla"],
  cc: ["ET", "IL"]
}, {
  pk: 445,
  ang: "Awak",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Awak",
  lc: "awo",
  ld: "ltr",
  alt: ["Awok", "Yebu"],
  cc: ["NG"]
}, {
  pk: 446,
  ang: "Awera",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Awera",
  lc: "awr",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 447,
  ang: "Awyu, South",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "South Awyu",
  lc: "aws",
  ld: "ltr",
  alt: ["Jenimu", "Oser", "Siagha", "Sjiagha", "Syiagha", "Yenimu"],
  cc: ["ID"]
}, {
  pk: 448,
  ang: "Arawet\xE9",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Arawet\xE9",
  lc: "awt",
  ld: "ltr",
  alt: ["B\xEFde"],
  cc: ["BR"]
}, {
  pk: 449,
  ang: "Awyu, Central",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Central Awyu",
  lc: "awu",
  ld: "ltr",
  alt: ["Ajau", "Auyu", "Avio", "Awju", "Awya"],
  cc: ["ID"]
}, {
  pk: 450,
  ang: "Awyu, Jair",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Jair Awyu",
  lc: "awv",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 451,
  ang: "Awun",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Awun",
  lc: "aww",
  ld: "ltr",
  alt: ["Awon"],
  cc: ["PG"]
}, {
  pk: 452,
  ang: "Awara",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Awara",
  lc: "awx",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 453,
  ang: "Awyu, Edera",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Edera Awyu",
  lc: "awy",
  ld: "ltr",
  alt: ["Jenimu", "Oser", "Siagha", "Sjiagha", "Syiagha", "Yenimu"],
  cc: ["ID"]
}, {
  pk: 454,
  ang: "Ar\xE1ra, Mato Grosso",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Mato Grosso Ar\xE1ra",
  lc: "axg",
  ld: "ltr",
  alt: ["Arara do Beirad\xE3o", "Arara do Rio Branco"],
  cc: ["BR"]
}, {
  pk: 455,
  ang: "Yaka",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Yaka (Central African Republic)",
  lc: "axk",
  ld: "ltr",
  alt: ["Aka", "Bek\xE1", "Nyoyaka", "Pygm\xE9e de la Lobaye", "Pygm\xE9e de Mongoumba", "Pygm\xE9es de la Sanghas", "Babinga", "Bambenga", "Binga", "M\xF2\xE1ka", "Beka (Bayaka)", "Gbayaka", "Basese (Eastern Aka)", "Bambenzele (Western Aka)", "Moyaka"],
  cc: ["CF", "CG"]
}, {
  pk: 456,
  ang: "Middle Armenian",
  lr: "Asia",
  gw: false,
  hc: "AM",
  ln: "Middle Armenian",
  lc: "axm",
  ld: "ltr",
  alt: [],
  cc: ["AM"]
}, {
  pk: 457,
  ang: "X\xE2r\xE2gur\xE8",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "X\xE2r\xE2gur\xE8",
  lc: "axx",
  ld: "ltr",
  alt: ["Aragure", "Borendy", "Borindi", "Haragure", "Naa Xaragure", "Thio"],
  cc: ["NC"]
}, {
  pk: 458,
  ang: "Aymara",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "aymar aru",
  lc: "ay",
  ld: "ltr",
  alt: [],
  cc: ["BO"]
}, {
  pk: 459,
  ang: "Awar",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Awar",
  lc: "aya",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 460,
  ang: "Gbe, Ayizo",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Ayizo Gbe",
  lc: "ayb",
  ld: "ltr",
  alt: ["Ayizo", "Ayzo", "Ayizo-Kobe", "Ayizo-Seto", "Ayizo-Tori", "Kadagbe (Kada-Gbe)"],
  cc: ["BJ"]
}, {
  pk: 461,
  ang: "Aymara, Southern",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Southern Aymara",
  lc: "ayc",
  ld: "ltr",
  alt: [],
  cc: ["PE"]
}, {
  pk: 462,
  ang: "Ayere",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ayere",
  lc: "aye",
  ld: "ltr",
  alt: ["Uwu"],
  cc: ["NG"]
}, {
  pk: 463,
  ang: "Ginyanga",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Ginyanga",
  lc: "ayg",
  ld: "ltr",
  alt: ["Agnagan", "Genyanga"],
  cc: ["TG"]
}, {
  pk: 7748,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Anyagan",
  lc: "ayg-x-anyagan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 464,
  ang: "Arabic, Hadrami Spoken",
  lr: "Asia",
  gw: false,
  hc: "YE",
  ln: "\u0644\u0647\u062C\u0629 \u062D\u0636\u0631\u0645\u064A\u0629",
  lc: "ayh",
  ld: "rtl",
  alt: ["Hadrami", "Hadromi"],
  cc: ["ER", "YE"]
}, {
  pk: 465,
  ang: "Leyigha",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Leyigha",
  lc: "ayi",
  ld: "ltr",
  alt: ["Asiga", "Ayiga", "Ayigha", "Yigha"],
  cc: ["NG"]
}, {
  pk: 466,
  ang: "Akuku",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Akuku",
  lc: "ayk",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 467,
  ang: "Arabic, Libyan Spoken",
  lr: "Africa",
  gw: false,
  hc: "LY",
  ln: "\u0644\u064A\u0628\u064A",
  lc: "ayl",
  ld: "rtl",
  alt: ["Bedawi", "Libyan Spoken Arabic", "Maghrebi Arabic", "Sulaimitian Arabic", "Libyan Vernacular Arabic", "Western Egyptian Bedawi Spoken Arabic", "Western Egyptian Bedawi Arabic"],
  cc: ["ES", "TN", "US", "CA", "IT", "LY", "EG", "AE"]
}, {
  pk: 468,
  ang: "Arabic, Sanaani Spoken",
  lr: "Asia",
  gw: false,
  hc: "YE",
  ln: "\u0644\u0647\u062C\u0629 \u0635\u0646\u0639\u0627\u0646\u064A\u0629",
  lc: "ayn",
  ld: "rtl",
  alt: ["Northern Yemeni Arabic"],
  cc: ["DJ", "SA", "YE"]
}, {
  pk: 469,
  ang: "Ayoreo",
  lr: "Americas",
  gw: false,
  hc: "PY",
  ln: "Ayoreo",
  lc: "ayo",
  ld: "ltr",
  alt: ["Ayor\xE9", "Moro", "Morotoco", "Pyeta", "Yovai", "Garaygosode", "Guara\xF1oca", "Guidaigosode", "Koroino", "Poturero", "Pyeta Yovai", "Samococio", "Sir\xE1kua", "Takrat", "Totobiegosode", "Yanaigua"],
  cc: ["PY", "BO"]
}, {
  pk: 470,
  ang: "Arabic, North Mesopotamian Spoken",
  lr: "Asia",
  gw: false,
  hc: "IQ",
  ln: "\u0644\u0647\u062C\u0629 \u0645\u0648\u0635\u0644\u064A\u0629",
  lc: "ayp",
  ld: "rtl",
  alt: ["Mesopotamian Qeltu Arabic", "Moslawi", "Syro-Mesopotamian Vernacular Arabic", "Syro-Mesopotamian Arabic"],
  cc: ["IQ"]
}, {
  pk: 471,
  ang: "Ayi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ayi (Papua New Guinea)",
  lc: "ayq",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 472,
  ang: "Aymara, Central",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Central Aymara",
  lc: "ayr",
  ld: "ltr",
  alt: [],
  cc: ["CL", "AR", "PE", "BO"]
}, {
  pk: 473,
  ang: "Ayta, Sorsogon",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Sorsogon Ayta",
  lc: "ays",
  ld: "ltr",
  alt: [],
  cc: ["PH"]
}, {
  pk: 474,
  ang: "Ayta, Magbukun",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Magbukun Ayta",
  lc: "ayt",
  ld: "ltr",
  alt: ["Bataan Ayta", "Bataan Sambal", "Mariveles Ayta"],
  cc: ["PH"]
}, {
  pk: 475,
  ang: "Ayu",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ayu",
  lc: "ayu",
  ld: "ltr",
  alt: ["Aya"],
  cc: ["NG"]
}, {
  pk: 476,
  ang: "Mai Brat",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mai Brat",
  lc: "ayz",
  ld: "ltr",
  alt: ["Ajamaru", "Atinjo", "Ayamaru", "Brat", "Maibrat", "Majbrat", "Maybrat", "Mey Brat"],
  cc: ["ID"]
}, {
  pk: 477,
  ang: "Azerbaijani",
  lr: "Asia",
  gw: false,
  hc: "AZ",
  ln: "az\u0259rbaycan dili",
  lc: "az",
  ld: "ltr",
  alt: [],
  cc: ["AZ"]
}, {
  pk: 478,
  ang: "Azha",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Azha",
  lc: "aza",
  ld: "ltr",
  alt: ["Aji", "Ajiwa", "A'ndze", "A'ntsaozo", "Azan", "Black Phula", "Cowtail Phula", "Golden Phula", "Han Phula", "Hei Phula", "Hua Phula", "Hua Yi", "Jin Phula", "Nimitso", "Niuweiba Phula", "Phula", "Phuphje", "Shaoji Phula", "Sifter Basket Phula"],
  cc: ["CN"]
}, {
  pk: 479,
  ang: "Azerbaijani, South",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "South Azerbaijani",
  lc: "azb",
  ld: "ltr",
  alt: ["Torki", "Azeri", "Inanlu", "Baharlu (Kamesh)", "Afshar", "Afshari (Afsar)", "Shahsavani (Shahseven)", "Aynallu (Inallu)"],
  cc: ["IR", "IQ", "SY", "JO"]
}, {
  pk: 7783,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Afshari",
  lc: "azb-x-afshari",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 480,
  ang: "Nahuatl, Eastern Durango",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Eastern Durango Nahuatl",
  lc: "azd",
  ld: "ltr",
  alt: ["Eastern Durango Aztec", "Meshikan del Este", "Mexicanero del Este", "Nahuat del Este de Durango"],
  cc: ["MX"]
}, {
  pk: 481,
  ang: "Amuzgo, San Pedro Amuzgos",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "San Pedro Amuzgos Amuzgo",
  lc: "azg",
  ld: "ltr",
  alt: ["Amuzgo Bajo del Este", "Amuzgo de San Pedro Amuzgos", "Oaxaca Amuzgo"],
  cc: ["MX"]
}, {
  pk: 482,
  ang: "Azerbaijani, North",
  lr: "Asia",
  gw: false,
  hc: "AZ",
  ln: "Az\u0259rbaycan dili",
  lc: "azj",
  ld: "ltr",
  alt: ["Azerbaydzhani", "Azeri Turk", "Turkler", "Azerbaijan", "Shusha (Karabakh)", "Susa (Karabakh)", "Zakataly (Mugaly)", "Zaqatala (Mugaly)"],
  cc: ["AZ", "DE", "KZ", "TJ", "NL", "TR", "US", "CA", "GE", "KG", "TM", "UZ"]
}, {
  pk: 483,
  ang: "Amuzgo, Ipalapa",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Ipalapa Amuzgo",
  lc: "azm",
  ld: "ltr",
  alt: ["Amuzgo Bajo del Este", "J\xF1unda"],
  cc: ["MX"]
}, {
  pk: 484,
  ang: "Nahuatl, Western Durango",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Western Durango Nahuatl",
  lc: "azn",
  ld: "ltr",
  alt: ["Meshikan del occidente", "Mexicanero del occidente", "Nahuat del Occidente en Durango y Nayarit", "Western Durango Aztec"],
  cc: ["MX"]
}, {
  pk: 485,
  ang: "Awing",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Awing",
  lc: "azo",
  ld: "ltr",
  alt: ["Awi", "Bambuluwe"],
  cc: ["CM"]
}, {
  pk: 486,
  ang: "Atta, Faire",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Faire Atta",
  lc: "azt",
  ld: "ltr",
  alt: ["Southern Atta"],
  cc: ["PH"]
}, {
  pk: 487,
  ang: "Nahuatl, Highland Puebla",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Highland Puebla Nahuatl",
  lc: "azz",
  ld: "ltr",
  alt: ["Mejicano de Zacapoaxtla", "N\xE1huat de la Sierra de Puebla", "Sierra Aztec", "Sierra Puebla N\xE1huatl", "Zacapoaxtla N\xE1huat"],
  cc: ["MX"]
}, {
  pk: 488,
  ang: "Bashkir",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0431\u0430\u0448\u04A1\u043E\u0440\u0442 \u0442\u0435\u043B\u0435",
  lc: "ba",
  ld: "ltr",
  alt: ["Basquort", "Burzhan (Western Bashkir)", "Kuvakan (Mountain Bashkir)", "Yurmaty (Steppe Bashkir)"],
  cc: ["KZ", "TJ", "RU", "KG", "TM", "UZ"]
}, {
  pk: 489,
  ang: "Babatana",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Babatana",
  lc: "baa",
  ld: "ltr",
  alt: ["East Choiseul", "Mbambatana", "Sisiqa", "Sengan (Senga)", "Sengga", "L\xF6maumbi", "Kuboro (Kumboro)", "Avas\xF6", "Sisingga"],
  cc: ["SB"]
}, {
  pk: 490,
  ang: "Bainouk-Gunyu\xF1o",
  lr: "Africa",
  gw: false,
  hc: "GW",
  ln: "Bainouk-Gunyu\xF1o",
  lc: "bab",
  ld: "ltr",
  alt: ["Bagnoun", "Bainuk", "Banhum", "Banyuk", "Banyum", "Banyun", "Banyung", "Elomay", "Elunay", "Gu\xF1uun"],
  cc: ["GW"]
}, {
  pk: 491,
  ang: "Badui",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Badui",
  lc: "bac",
  ld: "ltr",
  alt: ["Baduy", "Bahasa Sunda", "Gajebo"],
  cc: ["ID"]
}, {
  pk: 492,
  ang: "Bar\xE9",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "Bar\xE9",
  lc: "bae",
  ld: "ltr",
  alt: ["Arihini", "Barauana", "Barauna", "Barawana", "Cunipusana", "Ihini", "Maldavaca", "Mitua", "Yavita"],
  cc: ["VE"]
}, {
  pk: 493,
  ang: "Nubaca",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Nubaca",
  lc: "baf",
  ld: "ltr",
  alt: ["Baca", "Bango", "Bongo", "Central Yambassa", "Nu Baca", "Center Nubaca", "K\xE9lend\xE9", "Nibi\xE9g"],
  cc: ["CM"]
}, {
  pk: 494,
  ang: "Tuki",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Tuki",
  lc: "bag",
  ld: "ltr",
  alt: ["Bacenga", "Baki", "Batchenga", "Betsinga", "Betzinga", "Ki", "Oki", "Osa Nanga", "Sanaga", "Tu Ngoro", "Tocenga (Bacenga)", "Wakombe", "Uki", "Tutsingo", "Tukombe", "Tsinga (Batsingo)", "Tonjo (Boudjou)", "Kombe (Bakombe)", "Tiki", "Chinga", "Tumbele", "Mbele", "Bamvele", "Mbere (Bambele)", "Mvele", "Ngoro (Aki)", "Bunju"],
  cc: ["CM"]
}, {
  pk: 495,
  ang: "Bahamas Creole English",
  lr: "Americas",
  gw: false,
  hc: "BS",
  ln: "Bahamas Creole English",
  lc: "bah",
  ld: "ltr",
  alt: ["Bahamian Creole English", "Bahamian Dialect"],
  cc: ["BS", "US"]
}, {
  pk: 496,
  ang: "Barakai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Barakai",
  lc: "baj",
  ld: "ltr",
  alt: ["Workai"],
  cc: ["ID"]
}, {
  pk: 497,
  ang: "Balochi",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u0628\u0644\u0648\u0686\u06CC",
  lc: "bal",
  ld: "ltr",
  alt: [],
  cc: ["PK"]
}, {
  pk: 7566,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Bambara",
  lc: "bam-x-mali",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 498,
  ang: "Bali",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Balinese",
  lc: "ban",
  ld: "ltr",
  alt: ["Balinese", "Klungkung", "Lowland Bali (Badung)", "Karangasem", "Jembrana", "Highland Bali (\"Bali Aga\")", "Gianyar", "Buleleng", "Tabanan"],
  cc: ["ID", "US"]
}, {
  pk: 499,
  ang: "Waimaha",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Waimaha",
  lc: "bao",
  ld: "ltr",
  alt: ["Barazana", "Northern Barasano", "Waimaja", "Bar\xE1", "Barasano", "Eastern Waimaha", "Pamoa Bara"],
  cc: ["BR", "CO"]
}, {
  pk: 500,
  ang: "Bantawa",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u092C\u093E\u0928\u094D\u0924\u0935\u093E",
  lc: "bap",
  ld: "ltr",
  alt: ["Bantaba", "Bantawa Dum", "Bantawa Rai", "Bantawa Yong", "Bantawa Y\xFCng", "Bontawa", "Kirat Khambu", "Kirat Khambu Rai", "Rai", "Amchoke (Western Bantawa)", "Dhankuta (Eastern Bantawa)", "Dilpali (Northern Bantawa)", "Hatuwali (Southern Bantawa)", "Kiranti"],
  cc: ["NP"]
}, {
  pk: 501,
  ang: "Bavarian",
  lr: "Europe",
  gw: false,
  hc: "AT",
  ln: "Bavarian",
  lc: "bar",
  ld: "ltr",
  alt: ["Bairisch", "Bavarian Austrian", "Bayerisch", "Ost-Oberdeutsch", "South Bavarian", "Salzburgish", "North Bavarian (Upper Franconian)", "Central Bavarian (Danube Bavarian)", "South Bavarian (Heanzian)"],
  cc: ["AT", "DE", "IT"]
}, {
  pk: 502,
  ang: "Basaa",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Basa (Cameroon)",
  lc: "bas",
  ld: "ltr",
  alt: ["Basa", "Bassa", "Bicek", "Bikyek", "Bisaa", "Mbele", "Mee", "Mvele", "Northern Mbene", "Tupen"],
  cc: ["CM"]
}, {
  pk: 503,
  ang: "Mbat",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bada (Nigeria)",
  lc: "bau",
  ld: "ltr",
  alt: ["Bada'", "Badanchi", "Badawa", "Bat", "Garaka", "Jar", "Jarawan Kogi", "Kanna", "Mbada", "Mbadawa", "Plains Jarawa", "River Jarawa", "Galamkya (Gidgid)", "Gyanggyang", "Mbat (Gagdi-Gum)"],
  cc: ["NG", "TD"]
}, {
  pk: 504,
  ang: "Vengo",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Vengo",
  lc: "bav",
  ld: "ltr",
  alt: ["Nge", "Ngo", "Nguu", "Ngwa", "Pengo", "Vengi", "Vengoo"],
  cc: ["CM"]
}, {
  pk: 505,
  ang: "Bambili-Bambui",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bambili-Bambui",
  lc: "baw",
  ld: "ltr",
  alt: ["Mbogoe", "Bambili (Mbele)", "Bambui (Mbui)", "Mbili"],
  cc: ["CM"]
}, {
  pk: 506,
  ang: "Bamun",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bamun",
  lc: "bax",
  ld: "ltr",
  alt: ["Bamoum", "Bamum", "Shupamem"],
  cc: ["CM"]
}, {
  pk: 507,
  ang: "Batuley",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Batuley",
  lc: "bay",
  ld: "ltr",
  alt: ["Gwataley", "Watulai"],
  cc: ["ID"]
}, {
  pk: 508,
  ang: "Baatonum",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Baatonum",
  lc: "bba",
  ld: "ltr",
  alt: ["Baatombu", "Baatonu", "Barba", "Barganchi", "Bargawa", "Bargu", "Bariba", "Baruba", "Berba", "Bogung", "Burgu", "Baatonun", "Baatonun-Kwara", "Batonnum", "Borgawa", "Borgu", "Zana"],
  cc: ["BJ", "BF", "NG", "TG"]
}, {
  pk: 509,
  ang: "Barai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Barai",
  lc: "bbb",
  ld: "ltr",
  alt: ["Muguani"],
  cc: ["PG"]
}, {
  pk: 510,
  ang: "Batak Toba",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Batak Toba",
  lc: "bbc",
  ld: "ltr",
  alt: ["Batta", "Toba Batak"],
  cc: ["ID"]
}, {
  pk: 7545,
  ang: "Asahan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Asahan",
  lc: "bbc-x-asahan",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 511,
  ang: "Bau",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bau",
  lc: "bbd",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 512,
  ang: "Bangba",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bangba",
  lc: "bbe",
  ld: "ltr",
  alt: ["Abangba"],
  cc: ["CD"]
}, {
  pk: 513,
  ang: "Baibai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Baibai",
  lc: "bbf",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 514,
  ang: "Barama",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Barama",
  lc: "bbg",
  ld: "ltr",
  alt: ["Bavarama", "Ghibarama", "Gibarama", "Yibarambu"],
  cc: ["GA"]
}, {
  pk: 515,
  ang: "Bugan",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5E03\u7518\u8BED",
  lc: "bbh",
  ld: "ltr",
  alt: ["Bengan", "Bogan", "Bugeng", "Hualo", "Huazu", "Pukan", "Puqeng"],
  cc: ["CN"]
}, {
  pk: 516,
  ang: "Barombi",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Barombi",
  lc: "bbi",
  ld: "ltr",
  alt: ["Balombi", "Barumbi", "Lambi", "Lombe", "Lombi", "Rambi", "Rombi"],
  cc: ["CM"]
}, {
  pk: 517,
  ang: "Ghom\xE1l\xE1\u2019",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Ghom\xE1l\xE1'",
  lc: "bbj",
  ld: "ltr",
  alt: ["Baloum", "Bamileke-Bandjoun", "Bandjoun", "Banjoun-Baham", "Banjun", "Batie", "Mahum", "Mandju", "Monjo", "We", "Te", "Sa", "Pa", "Ngemba (Bamenjou)", "Ghom\xE1l\xE1' South (Dengkwop)", "Mugum", "Yogam", "Meka", "Lang", "Hom", "Ghom\xE1l\xE1' North (Fusap)", "Ghom\xE1l\xE1' Central (Baham)", "Fu'da", "Jo"],
  cc: ["CM"]
}, {
  pk: 518,
  ang: "Babanki",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Babanki",
  lc: "bbk",
  ld: "ltr",
  alt: ["Finge", "Kedjom", "Kejeng", "Kidzem", "Kidzom"],
  cc: ["CM"]
}, {
  pk: 519,
  ang: "Bats",
  lr: "Asia",
  gw: false,
  hc: "GE",
  ln: "\u10D1\u10D0\u10EA\u10D1\u10E3\u10E0\u10D8 \u10D4\u10DC\u10D0",
  lc: "bbl",
  ld: "ltr",
  alt: ["Bac", "Batsaw", "Batsba", "Batsbi", "Batsbiitsy", "Batsi", "Tsova-Tush", "Tush"],
  cc: ["GE"]
}, {
  pk: 520,
  ang: "Babango",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Babango",
  lc: "bbm",
  ld: "ltr",
  alt: ["Mobango"],
  cc: ["CD"]
}, {
  pk: 521,
  ang: "Uneapa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Uneapa",
  lc: "bbn",
  ld: "ltr",
  alt: ["Bali", "Bali-Vitu"],
  cc: ["PG"]
}, {
  pk: 522,
  ang: "Konab\xE9r\xE9",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Northern Bobo Madar\xE9",
  lc: "bbo",
  ld: "ltr",
  alt: ["Black Bobo", "Bobo", "Bobo Fi", "Bobo Fign", "Bobo Fing", "Northern Bobo Madare", "Bobo Da", "Tankire", "Kukoma (Koma)", "San", "Sankuma (Sarokama)"],
  cc: ["BF", "ML"]
}, {
  pk: 523,
  ang: "Banda, West Central",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "West Central Banda",
  lc: "bbp",
  ld: "ltr",
  alt: ["Golo", "Wojo (Hodjo)", "Gbaga-Nord (Gbaga-2)"],
  cc: ["CF", "SD", "TD"]
}, {
  pk: 524,
  ang: "Bamali",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bamali",
  lc: "bbq",
  ld: "ltr",
  alt: ["Chopechop", "Ngoobechop"],
  cc: ["CM"]
}, {
  pk: 525,
  ang: "Girawa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Girawa",
  lc: "bbr",
  ld: "ltr",
  alt: ["Bagasin", "Begasin", "Begesin"],
  cc: ["PG"]
}, {
  pk: 526,
  ang: "Bakpinka",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bakpinka",
  lc: "bbs",
  ld: "ltr",
  alt: ["Begbungba", "Iyongiyong", "Iyoniyong", "Uwet"],
  cc: ["NG"]
}, {
  pk: 527,
  ang: "Mburku",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Mburku",
  lc: "bbt",
  ld: "ltr",
  alt: ["Barke", "Barko", "Burkanawa", "Kariya", "Lipkawa", "Mburkanci", "Wudufu", "Wuufu"],
  cc: ["NG"]
}, {
  pk: 528,
  ang: "Kulung",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kulung (Nigeria)",
  lc: "bbu",
  ld: "ltr",
  alt: ["Bakuli", "Bakulu", "Bakulung", "Bambur", "Kukulung", "Kulu", "Kuluno", "Wo", "Wurkum"],
  cc: ["NG"]
}, {
  pk: 529,
  ang: "Karnai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Karnai",
  lc: "bbv",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 530,
  ang: "Baba",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Baba",
  lc: "bbw",
  ld: "ltr",
  alt: ["Baba 1", "Bapa", "Bapakum", "Papia", "Papiakum", "Supapya'"],
  cc: ["CM"]
}, {
  pk: 531,
  ang: "Bubia",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bubia",
  lc: "bbx",
  ld: "ltr",
  alt: ["Bobe", "Bobea", "Bota", "Ewota", "Wovea"],
  cc: ["CM"]
}, {
  pk: 532,
  ang: "Befang",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Befang",
  lc: "bby",
  ld: "ltr",
  alt: ["Beba-Befang", "Biba-Bifang", "Bifang", "Menchum", "Mukuru", "Usheida", "Okomanjang (Okoromandjang)", "Modelle", "Modeli", "Modele (Aku)", "Iku", "Idele", "Befang (Abefang)", "Beekuru", "Bangwi", "Bangui (Bangwe)", "Ambabiko", "Ushaku (Mokuru)", "Ge"],
  cc: ["CM"]
}, {
  pk: 533,
  ang: "Arabic, Babalia Creole",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Babalia Creole Arabic",
  lc: "bbz",
  ld: "rtl",
  alt: ["Babalia", "Babaliya", "Bubalia"],
  cc: ["TD"]
}, {
  pk: 534,
  ang: "Bai, Central",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u767D\u8BED",
  lc: "bca",
  ld: "ltr",
  alt: ["Labbu", "Minchia", "Minkia", "Nama", "Pai", "Heqing", "Lanping", "Eryuan", "Yunlong"],
  cc: ["CN"]
}, {
  pk: 8218,
  ang: "Bei",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Bei",
  lc: "bca-x-bei",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 535,
  ang: "Bainouk-Samik",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Bainouk-Samik",
  lc: "bcb",
  ld: "ltr",
  alt: [],
  cc: ["SN"]
}, {
  pk: 536,
  ang: "Balochi, Southern",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u0628\u0644\u0648\u0686\u06CC \u0632\u0628\u0627\u0646",
  lc: "bcc",
  ld: "ltr",
  alt: ["Baloci", "Baluchi", "Baluci", "Kechi (Keci)", "Koroshi", "Makrani (Lotuni)", "Zadgaali"],
  cc: ["OM", "PK", "SA", "US", "IN", "QA", "AE"]
}, {
  pk: 537,
  ang: "Babar, North",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "North Babar",
  lc: "bcd",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 538,
  ang: "Bamenyam",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bamenyam",
  lc: "bce",
  ld: "ltr",
  alt: ["Bamenyan", "Mamenyan", "Mengambo", "Pamenyan"],
  cc: ["CM"]
}, {
  pk: 539,
  ang: "Bamu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bamu",
  lc: "bcf",
  ld: "ltr",
  alt: ["Bamu Kiwai", "Lower Bamu", "Upper Bamu (Middle Bamu)"],
  cc: ["PG"]
}, {
  pk: 540,
  ang: "Baga Pokur",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Baga Pokur",
  lc: "bcg",
  ld: "ltr",
  alt: ["Baka", "Binari", "Kalum", "Mborin"],
  cc: ["GN"]
}, {
  pk: 541,
  ang: "Bariai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bariai",
  lc: "bch",
  ld: "ltr",
  alt: ["Kabana"],
  cc: ["PG"]
}, {
  pk: 542,
  ang: "Baoul\xE9",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Baoul\xE9",
  lc: "bci",
  ld: "ltr",
  alt: ["Baule", "Bawule"],
  cc: ["CI"]
}, {
  pk: 543,
  ang: "Bardi",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Bardi",
  lc: "bcj",
  ld: "ltr",
  alt: ["Baadi", "Baardi", "Badi", "Bard"],
  cc: ["AU"]
}, {
  pk: 544,
  ang: "Bunaba",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Bunaba",
  lc: "bck",
  ld: "ltr",
  alt: ["Bunuba", "Punapa", "Punuba"],
  cc: ["AU"]
}, {
  pk: 545,
  ang: "Bikol, Central",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Central Bikol",
  lc: "bcl",
  ld: "ltr",
  alt: ["Bikol", "Central Bicolano"],
  cc: ["PH", "US"]
}, {
  pk: 546,
  ang: "Bannoni",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bannoni",
  lc: "bcm",
  ld: "ltr",
  alt: ["Tsunari"],
  cc: ["PG"]
}, {
  pk: 547,
  ang: "Bali",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bali (Nigeria)",
  lc: "bcn",
  ld: "ltr",
  alt: ["Bibaali", "Ekpali", "Ibaali", "Maya"],
  cc: ["NG"]
}, {
  pk: 548,
  ang: "Kaluli",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kaluli",
  lc: "bco",
  ld: "ltr",
  alt: ["Bosavi"],
  cc: ["PG"]
}, {
  pk: 549,
  ang: "Bali",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bali (Democratic Republic of Congo)",
  lc: "bcp",
  ld: "ltr",
  alt: ["Baali", "Kibaali", "Kibala", "Libaali", "Bakundumu"],
  cc: ["CD"]
}, {
  pk: 550,
  ang: "Bench",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Bench",
  lc: "bcq",
  ld: "ltr",
  alt: ["Dizu", "Ghimarra", "Gimarra", "Gimira", "Mer (Mieru)", "Sce", "Benesho", "Bench (Bencho)", "She (Kaba)"],
  cc: ["ET"]
}, {
  pk: 551,
  ang: "Babine",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Babine",
  lc: "bcr",
  ld: "ltr",
  alt: ["Babine Carrier", "Northern Carrier", "Witsuwit'en", "Babine Proper", "Wetsuset'en"],
  cc: ["CA"]
}, {
  pk: 552,
  ang: "Kohumono",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kohumono",
  lc: "bcs",
  ld: "ltr",
  alt: ["Bahumono", "Ediba", "Ekumuru", "Humono", "Ohumono"],
  cc: ["NG"]
}, {
  pk: 553,
  ang: "Bendi",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bendi",
  lc: "bct",
  ld: "ltr",
  alt: ["Mabeni"],
  cc: ["CD"]
}, {
  pk: 554,
  ang: "Awad Bing",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Awad Bing",
  lc: "bcu",
  ld: "ltr",
  alt: ["Awad Gey", "Bing", "Samang", "Semang", "Sengam", "Yori"],
  cc: ["PG"]
}, {
  pk: 555,
  ang: "Shoo-Minda-Nye",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Shoo-Minda-Nye",
  lc: "bcv",
  ld: "ltr",
  alt: ["Nye (Kunini)", "Shoo (Banda)", "Minda (Jinleri)"],
  cc: ["NG"]
}, {
  pk: 8131,
  ang: "Bandawa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bandawa",
  lc: "bcv-x-bandawa",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 556,
  ang: "Bana",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bana",
  lc: "bcw",
  ld: "ltr",
  alt: ["Baza", "Ka-Bana", "Koma", "Mizeran", "Parole des Bana", "Gili (Guili)"],
  cc: ["CM"]
}, {
  pk: 557,
  ang: "Bacama",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bacama",
  lc: "bcy",
  ld: "ltr",
  alt: ["Abacama", "Bachama", "Bashamma", "Besema", "Bwareba", "Bwatiye", "Gboare", "Opalo (Opolo)", "Central Bwatiye (Demsa)", "Demsa Bata", "Mulyen (Mulwyin)", "Mwulyin"],
  cc: ["NG"]
}, {
  pk: 558,
  ang: "Bainouk-Gunyaamolo",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Bainouk-Gunyaamolo",
  lc: "bcz",
  ld: "ltr",
  alt: ["Bagnoun", "Bainuk", "Banyuk", "Banyum", "Banyun", "Banyung", "Elomay", "Elunay", "Gu\xF1uun \xD1u\xF1"],
  cc: ["GM", "SN"]
}, {
  pk: 559,
  ang: "Bayot",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Bayot",
  lc: "bda",
  ld: "ltr",
  alt: ["Baiot", "Bayote", "Bayotte", "Jola Bayote", "Baiote"],
  cc: ["SN"]
}, {
  pk: 7804,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "GW",
  ln: "Bayote Aramme",
  lc: "bda-x-aramme",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7721,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "GW",
  ln: "Bayote Elia",
  lc: "bda-x-elia",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 560,
  ang: "Basap",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Basap",
  lc: "bdb",
  ld: "ltr",
  alt: ["Bosap"],
  cc: ["ID"]
}, {
  pk: 7879,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Menabur Kecil",
  lc: "bdb-x-menaburkecil",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 561,
  ang: "Ember\xE1-Baud\xF3",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Ember\xE1-Baud\xF3",
  lc: "bdc",
  ld: "ltr",
  alt: ["Baud\xF3", "Catr\xFA"],
  cc: ["CO"]
}, {
  pk: 562,
  ang: "Bunama",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bunama",
  lc: "bdd",
  ld: "ltr",
  alt: ["Kelelegeia", "Meudana", "Kerorogea", "Lomitawa"],
  cc: ["PG"]
}, {
  pk: 563,
  ang: "Bade",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bade",
  lc: "bde",
  ld: "ltr",
  alt: ["Bede", "Gidgid", "Gashua Bade (Mazgarwa)", "Maagwaram", "Magwaram", "Southern Bade (Bade-Kado)", "Western Bade (Amshi)"],
  cc: ["NG"]
}, {
  pk: 564,
  ang: "Biage",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Biage",
  lc: "bdf",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 565,
  ang: "Bonggi",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Bonggi",
  lc: "bdg",
  ld: "ltr",
  alt: ["Bangay", "Banggi", "Banggi Dusun"],
  cc: ["MY"]
}, {
  pk: 566,
  ang: "Baka",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Baka (Sudan)",
  lc: "bdh",
  ld: "ltr",
  alt: ["Tara Baaka", "Tara Baka"],
  cc: ["SS", "SD"]
}, {
  pk: 567,
  ang: "Burun",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Burun",
  lc: "bdi",
  ld: "ltr",
  alt: ["Borun", "Cai", "Lange", "Abuldugu (Bogon)", "Mufwa (Mopo)", "Mughaja (Mugaja)", "Mugo-Mborkoina", "Mumughadja"],
  cc: ["CN", "SD"]
}, {
  pk: 568,
  ang: "Bai",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Bai",
  lc: "bdj",
  ld: "ltr",
  alt: ["Bari"],
  cc: ["SS"]
}, {
  pk: 569,
  ang: "Budukh",
  lr: "Asia",
  gw: false,
  hc: "AZ",
  ln: "Buduq dili",
  lc: "bdk",
  ld: "ltr",
  alt: ["Budug", "Budugi", "Budux", "Bukukhi"],
  cc: ["AZ"]
}, {
  pk: 570,
  ang: "Bajau, Indonesian",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bajo",
  lc: "bdl",
  ld: "ltr",
  alt: ["Badjaw", "Badjo", "Bajao", "Bajo", "Bayo", "Gaj", "Indonesian Bajaw", "Orang Laut", "Sama", "Taurije'ne'", "Togian 1", "Togian 2"],
  cc: ["ID"]
}, {
  pk: 571,
  ang: "Buduma",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Buduma",
  lc: "bdm",
  ld: "ltr",
  alt: ["Boudouma", "Yadena", "Yedima", "Yedina", "Yedana", "Yidana", "Yidena", "Kouri", "Kuri (Kakaa)"],
  cc: ["CM", "NE", "NG", "TD"]
}, {
  pk: 572,
  ang: "Baldemu",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Baldemu",
  lc: "bdn",
  ld: "ltr",
  alt: ["Baldare", "Mbazla"],
  cc: ["CM"]
}, {
  pk: 573,
  ang: "Morom",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Morom",
  lc: "bdo",
  ld: "ltr",
  alt: ["Tar Murba"],
  cc: ["TD"]
}, {
  pk: 574,
  ang: "Bende",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Bende",
  lc: "bdp",
  ld: "ltr",
  alt: ["Kibende", "Si'bende"],
  cc: ["TZ"]
}, {
  pk: 575,
  ang: "Bahnar",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Ti\u1EBFng Ba Na",
  lc: "bdq",
  ld: "ltr",
  alt: ["Bana", "Bahnar Bonom (Bomam)", "Jolong (Gio-Lang)", "Y-Lang", "Alakong (A-La Cong)"],
  cc: ["VN"]
}, {
  pk: 576,
  ang: "Bajau, West Coast",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "West Coast Bajau",
  lc: "bdr",
  ld: "ltr",
  alt: ["Land Bajaw", "West Coast Bajao", "West Coast Bajaw"],
  cc: ["MY"]
}, {
  pk: 577,
  ang: "Burunge",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Burunge",
  lc: "bds",
  ld: "ltr",
  alt: ["Bulunge", "Burungi", "Kiburunge"],
  cc: ["TZ"]
}, {
  pk: 578,
  ang: "Bhogoto",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Bokoto",
  lc: "bdt",
  ld: "ltr",
  alt: ["Bhokoto", "Bogodo", "Bogoto", "Bokodo", "Bokpoto", "Gbaya of Boda (Gbaya de Boda)"],
  cc: ["CF"]
}, {
  pk: 579,
  ang: "Oroko",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Oroko",
  lc: "bdu",
  ld: "ltr",
  alt: ["Bakundu-Balue", "Oroko-East", "Oroko-West", "Lakundu", "Western Kundu", "Nkundu", "Lue", "Lotanga (Batanga)", "Longolo (Ngolo)", "Londo (Balondo Ba Diko)", "Lolue (Babue)", "Lokoko (Bakoko)", "Balondo Ba Nanga", "Ekumbe", "Ekombe (Bekombo)", "Bima", "Bekunde", "Bawo", "Barue", "Kundu", "Lokundu (Bakundu)"],
  cc: ["CM"]
}, {
  pk: 580,
  ang: "Bodo Parja",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bodo Parja",
  lc: "bdv",
  ld: "ltr",
  alt: ["Bodo Paraja", "Harja", "Jhaliya", "Jharia", "Jhodia Parja", "Parajhi", "Parja", "Parjhi", "Parji", "Paroja", "Poroja", "Sodia Parja"],
  cc: ["IN"]
}, {
  pk: 581,
  ang: "Baham",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Baham",
  lc: "bdw",
  ld: "ltr",
  alt: ["Patimuni"],
  cc: ["ID"]
}, {
  pk: 582,
  ang: "Budong-Budong",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Budong-Budong",
  lc: "bdx",
  ld: "ltr",
  alt: ["Bubudong", "Tangkou", "Tongkou"],
  cc: ["ID"]
}, {
  pk: 583,
  ang: "Bandjalang",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Bandjalang",
  lc: "bdy",
  ld: "ltr",
  alt: ["Bandjelang", "Bogganger", "Bundala", "Yugumbe", "Gidabal (Gidhabal)"],
  cc: ["AU"]
}, {
  pk: 584,
  ang: "Badeshi",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u0628\u062F\u06CC\u0634\u06CC \u0632\u0628\u0627\u0646",
  lc: "bdz",
  ld: "ltr",
  alt: ["Badakhshi"],
  cc: ["PK"]
}, {
  pk: 585,
  ang: "Belarusian",
  lr: "Europe",
  gw: false,
  hc: "BY",
  ln: "\u0431\u0435\u043B\u0430\u0440\u0443\u0441\u043A\u0430\u044F \u043C\u043E\u0432\u0430",
  lc: "be",
  ld: "ltr",
  alt: ["Belarusian", "Belorussian", "Bielorussian", "Byelorussian", "White Russian", "White Ruthenian", "Southwest Belarusan (Grodnen-Baranovich)", "Viteb-Mogilev", "Slutska-Mazyrski", "Northeast Belarusan (Polots)", "Slutsko-Mozyr", "Belarussian"],
  cc: ["AZ", "BY", "AR", "DE", "GB", "TJ", "PL", "US", "KG", "TM", "UZ"]
}, {
  pk: 586,
  ang: "Beaver",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Beaver",
  lc: "bea",
  ld: "ltr",
  alt: [],
  cc: ["CA"]
}, {
  pk: 587,
  ang: "Bebele",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bebele",
  lc: "beb",
  ld: "ltr",
  alt: ["Bamvele"],
  cc: ["CM"]
}, {
  pk: 588,
  ang: "Iceve-Maci",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Iceve-Maci",
  lc: "bec",
  ld: "ltr",
  alt: ["Bacheve", "Bechere", "Ocebe", "Ochebe", "Ocheve", "Utse", "Utser", "Utseu", "Oceve", "Oliti-Akwaya", "Oliti (Akwaya Motom)", "Olithi", "Olit", "Matchi", "Motom", "Motomo", "Kwaya", "Ihekwot", "Icheve (Bacheve)", "Beheve", "Bacheve (Baceve)", "Maci (Kwaya)"],
  cc: ["CM", "NG"]
}, {
  pk: 589,
  ang: "Bedoanas",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bedoanas",
  lc: "bed",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 590,
  ang: "Byangsi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Byangsi",
  lc: "bee",
  ld: "ltr",
  alt: ["Bhotia", "Byangkho Lwo", "Byangkhopa", "Byanshi", "Byansi", "Jaba", "Rang", "Saukas", "Shaukas", "Byasi", "Sauka", "Shauka", "Pangjungkho Boli", "Kuti", "Yerjungkhu Boli", "Pang Sungkhu Boli"],
  cc: ["NP", "IN"]
}, {
  pk: 591,
  ang: "Benabena",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Benabena",
  lc: "bef",
  ld: "ltr",
  alt: ["Bena"],
  cc: ["PG"]
}, {
  pk: 592,
  ang: "Belait",
  lr: "Asia",
  gw: false,
  hc: "BN",
  ln: "Belait",
  lc: "beg",
  ld: "ltr",
  alt: ["Balait Jati", "Lemeting", "Meting"],
  cc: ["BN"]
}, {
  pk: 593,
  ang: "Biali",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Biali",
  lc: "beh",
  ld: "ltr",
  alt: ["Bieri", "Bjerb", "Bjeri", "Burba", "Byali", "Porga", "Tihoun", "Tangeta", "Pingou", "Materi", "Dassari", "Gouande"],
  cc: ["BJ", "BF"]
}, {
  pk: 594,
  ang: "Bakati\u2019",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bekati'",
  lc: "bei",
  ld: "ltr",
  alt: ["Bakati Nyam", "Bakati Riok", "Bakatiq", "Bekati"],
  cc: ["ID"]
}, {
  pk: 7958,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Bakati Kamayo",
  lc: "bei-x-bakatikamayo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8094,
  ang: "Dayak Dsa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Dsa",
  lc: "bei-x-dayakdsa",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8093,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Laya",
  lc: "bei-x-dayaklaya",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 595,
  ang: "Bedawiyet",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Beja",
  lc: "bej",
  ld: "ltr",
  alt: ["Beja", "Bedauye", "Bedawiye", "Bedawye", "Bedja", "Bedwi", "Bedya", "Lobat", "Tu Bdhaawi", "Tu-Bedawie", "Bisarin", "Bisharin (Bisariab)", "Hadareb (Hadaareb)", "Hadendoa (Hadendiwa)", "Hadendoa (Hadendowa)", "Hadendowa"],
  cc: ["SD", "EG"]
}, {
  pk: 596,
  ang: "Bebeli",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bebeli",
  lc: "bek",
  ld: "ltr",
  alt: ["Banaule", "Beli", "Benaule", "Kapore"],
  cc: ["PG"]
}, {
  pk: 597,
  ang: "Bemba",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Bemba (Zambia)",
  lc: "bem",
  ld: "ltr",
  alt: ["Chiwemba", "Ichibemba", "Wemba", "Chibemba", "Cibemba", "Lomotua (Lomotwa)", "Lunda (Luapula)"],
  cc: ["TZ", "ZM", "ZW"]
}, {
  pk: 598,
  ang: "Beami",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Beami",
  lc: "beo",
  ld: "ltr",
  alt: ["Bedamini", "Mougulu"],
  cc: ["PG"]
}, {
  pk: 599,
  ang: "Behoa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Besoa",
  lc: "bep",
  ld: "ltr",
  alt: ["Ako"],
  cc: ["ID"]
}, {
  pk: 600,
  ang: "Beembe",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Beembe",
  lc: "beq",
  ld: "ltr",
  alt: ["Bembe", "Kibeembe", "Yari (Kiyari)", "Keenge (Kikeenge)", "kinkeenge"],
  cc: ["CG"]
}, {
  pk: 601,
  ang: "Besme",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Besme",
  lc: "bes",
  ld: "ltr",
  alt: ["Beseme", "Besemme", "Bodor", "Hounar", "Huner", "Unar"],
  cc: ["TD"]
}, {
  pk: 602,
  ang: "B\xE9t\xE9, Guiberoua",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Guiberoua B\xE9te",
  lc: "bet",
  ld: "ltr",
  alt: ["Central B\xE9t\xE9", "Western B\xE9t\xE9", "Guiberoua"],
  cc: ["CI"]
}, {
  pk: 603,
  ang: "Blagar",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Blagar",
  lc: "beu",
  ld: "ltr",
  alt: ["Belagar", "Tarang"],
  cc: ["ID"]
}, {
  pk: 604,
  ang: "B\xE9t\xE9, Daloa",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Daloa B\xE9t\xE9",
  lc: "bev",
  ld: "ltr",
  alt: ["Daloua B\xE9t\xE9", "Northern B\xE9t\xE9"],
  cc: ["CI"]
}, {
  pk: 605,
  ang: "Betawi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Betawi",
  lc: "bew",
  ld: "ltr",
  alt: ["Batavi", "Batawi", "Betawi Malay", "Jakarta Malay", "Melayu Jakarte"],
  cc: ["ID"]
}, {
  pk: 606,
  ang: "Jur Modo",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Jur Modo",
  lc: "bex",
  ld: "ltr",
  alt: ["Jur", "Modo", "Modo (Jur Modo)", "Modo Lali", "Wira"],
  cc: ["SS", "US"]
}, {
  pk: 607,
  ang: "Beli",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Beli (Papua New Guinea)",
  lc: "bey",
  ld: "ltr",
  alt: ["Akuwagel", "Makarim", "Mukili"],
  cc: ["PG"]
}, {
  pk: 608,
  ang: "Bena",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Bena (Tanzania)",
  lc: "bez",
  ld: "ltr",
  alt: ["Ekibena", "Ikibena", "Kibena", "Mavemba", "Sovi", "Twangabita", "Nyikolwe", "Ngaveeta", "Maswamu", "Masitu", "Masakati (Masagati)", "Lupembe", "Ilembula", "Kilavungi (Kilavagi)"],
  cc: ["TZ"]
}, {
  pk: 609,
  ang: "Bari",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Bari",
  lc: "bfa",
  ld: "ltr",
  alt: ["Beri", "Nyangbara (Nyambara)", "Pajulu", "Nypho", "Nyepu (Ngyepu)", "Nyepo", "P\xF6julu (Fadjulu)", "Nyangwara", "Mondari (Mandari)", "Madi", "Ligo (Liggo)", "Fajulu", "Fajelu", "Nyefu", "Mundari"],
  cc: ["SS", "US", "UG"]
}, {
  pk: 610,
  ang: "Bareli, Pauri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Pauri Bareli",
  lc: "bfb",
  ld: "ltr",
  alt: ["Bareli", "Barewali"],
  cc: ["IN"]
}, {
  pk: 611,
  ang: "Bai, Panyi",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5317\u90E8\u65B9\u8A00",
  lc: "bfc",
  ld: "ltr",
  alt: ["Bijang Bai", "Laemae", "Lama", "Leme", "Nujiang", "Lanping"],
  cc: ["CN"]
}, {
  pk: 7556,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Lama",
  lc: "bfc-x-lama",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 612,
  ang: "Bafut",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bafut",
  lc: "bfd",
  ld: "ltr",
  alt: ["Befe", "Bufe", "Fu", "Fut", "Bufe (Afughe)"],
  cc: ["CM"]
}, {
  pk: 613,
  ang: "Betaf",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Betaf",
  lc: "bfe",
  ld: "ltr",
  alt: ["Tena"],
  cc: ["ID"]
}, {
  pk: 614,
  ang: "Bofi",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Bofi",
  lc: "bff",
  ld: "ltr",
  alt: ["Boffi"],
  cc: ["CF"]
}, {
  pk: 615,
  ang: "Kayan, Busang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Busang Kayan",
  lc: "bfg",
  ld: "ltr",
  alt: ["Busang", "Kajan", "Kajang", "Belayan"],
  cc: ["ID"]
}, {
  pk: 616,
  ang: "Blafe",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Blafe",
  lc: "bfh",
  ld: "ltr",
  alt: ["Indorodoro", "Tonda", "Mblafe", "R\xE1nmo"],
  cc: ["PG"]
}, {
  pk: 617,
  ang: "British Sign Language",
  lr: "Europe",
  gw: false,
  hc: "GB",
  ln: "British Sign Language",
  lc: "bfi",
  ld: "ltr",
  alt: ["BSL"],
  cc: ["TT", "GB"]
}, {
  pk: 618,
  ang: "Bafanji",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bafanji",
  lc: "bfj",
  ld: "ltr",
  alt: ["Bafangi", "Bafanyi", "Chufie'", "Nchufie"],
  cc: ["CM"]
}, {
  pk: 619,
  ang: "Ban Khor Sign Language",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Ban Khor Sign Language",
  lc: "bfk",
  ld: "ltr",
  alt: [],
  cc: ["TH"]
}, {
  pk: 620,
  ang: "Banda-Nd\xE9l\xE9",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Banda-Nd\xE9l\xE9",
  lc: "bfl",
  ld: "ltr",
  alt: ["Banda of Nd\xE9l\xE9", "Nyele", "Tambolo", "Ngao (Bandangao)", "Tombaggo", "Tangbago (Tambaggo)", "Tangago", "Ngau", "Junguru (Djingburu)", "Banda-Nd\xE9l\xE9", "Nguru"],
  cc: ["CF", "SS"]
}, {
  pk: 621,
  ang: "Mmen",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mmen",
  lc: "bfm",
  ld: "ltr",
  alt: ["Bafmen", "Bafmeng", "Bafoumeng", "Bafumen", "Mme", "Cha'", "Fungom (Northern Fungom)", "Nyos", "We"],
  cc: ["CM"]
}, {
  pk: 622,
  ang: "Bunak",
  lr: "Asia",
  gw: false,
  hc: "TL",
  ln: "Bunak",
  lc: "bfn",
  ld: "ltr",
  alt: ["Buna'", "Bunake", "Bunaq", "Gae'", "Marae", "Buna"],
  cc: ["ID", "TL"]
}, {
  pk: 623,
  ang: "Birifor, Malba",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Malba Birifor",
  lc: "bfo",
  ld: "ltr",
  alt: ["Birifo", "Malba-Birifor", "Northern Birifor"],
  cc: ["BF"]
}, {
  pk: 624,
  ang: "Beba",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Beba",
  lc: "bfp",
  ld: "ltr",
  alt: ["Babadji", "Baba'zhi", "Batadji", "Bazhi", "Beba'", "Bebadji", "Biba", "Bombe", "Mubadji", "Shishong"],
  cc: ["CM"]
}, {
  pk: 625,
  ang: "Badaga",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Badaga",
  lc: "bfq",
  ld: "ltr",
  alt: ["Badag", "Badagu", "Baduga", "Badugu", "Vadagu"],
  cc: ["IN"]
}, {
  pk: 626,
  ang: "Bazigar",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bazigar",
  lc: "bfr",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 627,
  ang: "Bai, Southern",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5357\u90E8\u65B9\u8A00",
  lc: "bfs",
  ld: "ltr",
  alt: ["Dali", "Xiangyun"],
  cc: ["CN"]
}, {
  pk: 7651,
  ang: "Liuhe Bai",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Liuhe Bai",
  lc: "bfs-x-liuhebai",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 628,
  ang: "Balti",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u0628\u0644\u062A\u06CC",
  lc: "bft",
  ld: "ltr",
  alt: ["Baltistani", "Bhoti of Baltistan", "Sbalt", "Bhotia of Baltistan", "Sbalti"],
  cc: ["PK", "IN"]
}, {
  pk: 629,
  ang: "Gahri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Gahri",
  lc: "bfu",
  ld: "ltr",
  alt: ["Boonan", "Erankad", "Ghara", "Keylong Boli", "Lahuli of Bunan", "Poonan", "Punan"],
  cc: ["CN", "IN"]
}, {
  pk: 630,
  ang: "Bondo",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bondo",
  lc: "bfw",
  ld: "ltr",
  alt: ["Bhonda Bhasha", "Bondo-Poraja", "Nanqa Poroja", "Poraja Katha", "Remo", "Remosum"],
  cc: ["IN"]
}, {
  pk: 631,
  ang: "Bantayanon",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Bantayanon",
  lc: "bfx",
  ld: "ltr",
  alt: [],
  cc: ["PH"]
}, {
  pk: 632,
  ang: "Bagheli",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bagheli",
  lc: "bfy",
  ld: "ltr",
  alt: ["Bagelkhandi", "Bhugelkhud", "Gangai", "Godwani Kawathi", "Kenat", "Kevat Boli", "Kevati", "Kewani", "Kewat", "Kewati", "Kewot", "Kumhari", "Mandal", "Mannadi", "Riwai", "Kawathi", "Rewa"],
  cc: ["IN"]
}, {
  pk: 633,
  ang: "Pahari, Mahasu",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mahasu Pahari",
  lc: "bfz",
  ld: "ltr",
  alt: ["Mahasui", "Rohruri", "Shimla Siraji", "Sodochi", "Baghliani", "Kiunthali", "Lower Mahasu Pahari (Baghati)", "Upper Mahasu Pahari (Rampuri)"],
  cc: ["IN"]
}, {
  pk: 7530,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Baghliani",
  lc: "bfz-x-baghlian",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 634,
  ang: "Bulgarian",
  lr: "Europe",
  gw: false,
  hc: "BG",
  ln: "\u0431\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438 \u0435\u0437\u0438\u043A",
  lc: "bg",
  ld: "ltr",
  alt: ["Balgarski", "Palitiani", "Palityan (Bogomil)", "Pomak (Pomakci)", "Pomakika"],
  cc: ["GR", "DE", "KZ", "ES", "TJ", "TR", "US", "AU", "CA", "KG", "LY", "TM", "UZ", "BG"]
}, {
  pk: 635,
  ang: "Gwamhi-Wuri",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Gwamhi-Wuri",
  lc: "bga",
  ld: "ltr",
  alt: ["Lyase", "Lyase-Ne", "Mba (Kokanawa)", "Wurawa", "Gwamhi (Abaangi)", "Gwamfi Gwamfawa", "Gwamfanci", "Bangawa", "Banganci", "Wuri (Wuranci)"],
  cc: ["NG"]
}, {
  pk: 636,
  ang: "Bobongko",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bobongko",
  lc: "bgb",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 637,
  ang: "Haryanvi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Haryanvi",
  lc: "bgc",
  ld: "ltr",
  alt: ["Bangaru", "Banger", "Bangri", "Bangru", "Chamarwa", "Desari", "Hariani", "Hariyani", "Haryani", "Jatu", "Khadar"],
  cc: ["IN"]
}, {
  pk: 638,
  ang: "Bareli, Rathwi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Rathwi Bareli",
  lc: "bgd",
  ld: "ltr",
  alt: ["Barel", "Pauri", "Pawari", "Pawri", "Rathi", "Rathia"],
  cc: ["IN"]
}, {
  pk: 8334,
  ang: "Pawari",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Pawari",
  lc: "bgd-x-pawari",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 639,
  ang: "Bauria",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bauria",
  lc: "bge",
  ld: "ltr",
  alt: ["Babri", "Badak", "Baori", "Basria", "Bawari", "Bawaria", "Bhoria", "Vaghri"],
  cc: ["IN"]
}, {
  pk: 640,
  ang: "Bangandu",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bangandu",
  lc: "bgf",
  ld: "ltr",
  alt: ["Bagando", "Bangando", "Bangantu", "Southern Bangantu"],
  cc: ["CM", "CG"]
}, {
  pk: 641,
  ang: "Bugun",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bugun",
  lc: "bgg",
  ld: "ltr",
  alt: ["Kho", "Khoa", "Khowa"],
  cc: ["IN"]
}, {
  pk: 642,
  ang: "Giangan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Giangan",
  lc: "bgi",
  ld: "ltr",
  alt: ["Atto", "Bagobo", "Clata", "Eto", "Guanga", "Gulanga", "Jangan"],
  cc: ["PH"]
}, {
  pk: 643,
  ang: "Bangolan",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bangolan",
  lc: "bgj",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 644,
  ang: "Bit",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Bit",
  lc: "bgk",
  ld: "ltr",
  alt: ["Boxing", "Buxing", "Buxing Khmu", "Khabit", "Pasing", "Phsin", "Phsing", "Buxinhua", "Khbit"],
  cc: ["CN", "LA"]
}, {
  pk: 645,
  ang: "Bo",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Bo (Laos)",
  lc: "bgl",
  ld: "ltr",
  alt: [],
  cc: ["LA"]
}, {
  pk: 646,
  ang: "Baga Mboteni",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Baga Mboteni",
  lc: "bgm",
  ld: "ltr",
  alt: [],
  cc: ["GN"]
}, {
  pk: 647,
  ang: "Balochi, Western",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u0628\u0644\u0648\u0686\u06CC \u0632\u0628\u0627\u0646",
  lc: "bgn",
  ld: "ltr",
  alt: ["Baloci", "Baluchi", "Baluci", "Lashari", "Rakhshani (Raxshani)"],
  cc: ["AF", "IR", "PK", "TM"]
}, {
  pk: 648,
  ang: "Baga Koga",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Baga Koga",
  lc: "bgo",
  ld: "ltr",
  alt: ["Baka", "Koba", "Koga"],
  cc: ["GN"]
}, {
  pk: 649,
  ang: "Balochi, Eastern",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u0628\u0644\u0648\u0686\u06CC \u0632\u0628\u0627\u0646",
  lc: "bgp",
  ld: "ltr",
  alt: ["Balochi", "Baloci", "Baluci", "Baluchi", "Eastern Hill Balochi"],
  cc: ["PK", "IN"]
}, {
  pk: 650,
  ang: "Bagri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bagri",
  lc: "bgq",
  ld: "ltr",
  alt: ["Bagria", "Bagris", "Bahgri", "Baorias", "Bawri"],
  cc: ["PK", "IN"]
}, {
  pk: 651,
  ang: "Chin, Bawm",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bawm Chin",
  lc: "bgr",
  ld: "ltr",
  alt: ["Bawn", "Bawng", "Bom", "Boam", "Laisaw", "Langkay"],
  cc: ["BD", "IN", "MM"]
}, {
  pk: 8491,
  ang: "PaNam",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "PaNam",
  lc: "bgr-x-panam",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 652,
  ang: "Tagabawa",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Tagabawa",
  lc: "bgs",
  ld: "ltr",
  alt: ["Tagabawa Bagobo", "Tagabawa Manobo"],
  cc: ["PH"]
}, {
  pk: 653,
  ang: "Bughotu",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Bughotu",
  lc: "bgt",
  ld: "ltr",
  alt: ["Bugota", "Bugoto", "Bugotu", "Mahaga", "Mbughotu"],
  cc: ["SB"]
}, {
  pk: 654,
  ang: "Mbongno",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Mbongno",
  lc: "bgu",
  ld: "ltr",
  alt: ["Bungnu", "Bungun", "Bunu", "Gbunhu", "Kakaba"],
  cc: ["CM", "NG"]
}, {
  pk: 655,
  ang: "Warkay-Bipim",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Warkay-Bipim",
  lc: "bgv",
  ld: "ltr",
  alt: ["Bipim As-So"],
  cc: ["ID"]
}, {
  pk: 656,
  ang: "Bhatri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bhatri",
  lc: "bgw",
  ld: "ltr",
  alt: ["Basturia", "Bhattra", "Bhattri", "Bhottada", "Bhottara"],
  cc: ["IN"]
}, {
  pk: 657,
  ang: "Balkan Gagauz Turkish",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Balkan Gagauz Turkish",
  lc: "bgx",
  ld: "ltr",
  alt: ["Balkan Turkic", "Yuruk (Konyar)", "Gajal", "Yoruk"],
  cc: ["TR"]
}, {
  pk: 658,
  ang: "Benggoi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Benggoi",
  lc: "bgy",
  ld: "ltr",
  alt: ["Bengoi", "Isal", "Kobi-Benggoi", "Uhei Kachlakan", "Uhei-Kaclakin", "Uhei-Kahlakim"],
  cc: ["ID"]
}, {
  pk: 659,
  ang: "Banggai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Banggai",
  lc: "bgz",
  ld: "ltr",
  alt: ["Aki", "Banggaai", "Banggaiy", "Banggay", "Banggaya"],
  cc: ["ID"]
}, {
  pk: 660,
  ang: "Bharia",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bharia",
  lc: "bha",
  ld: "ltr",
  alt: ["Bhar", "Bharat", "Bhumia", "Bhumiya", "Paliha"],
  cc: ["IN"]
}, {
  pk: 661,
  ang: "Bhili",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bhili",
  lc: "bhb",
  ld: "ltr",
  alt: ["Bhagoria", "Bhil", "Bhilbari", "Bhilboli", "Bhilla", "Lengotia", "Vil", "Patelia", "Nahari (Baglani)", "Anarya (Pahadi)", "Kotali (Kotvali)", "Kotwalia"],
  cc: ["IN"]
}, {
  pk: 662,
  ang: "Biga",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Biga",
  lc: "bhc",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 663,
  ang: "Bhadrawahi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bhadrawahi",
  lc: "bhd",
  ld: "ltr",
  alt: ["Baderwali", "Badrohi", "Bahi", "Bhaderbhai Jamu", "Bhaderwali Pahari", "Bhadrava", "Bhadri", "Padari (Padar)"],
  cc: ["IN"]
}, {
  pk: 664,
  ang: "Bhaya",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "Bhaya",
  lc: "bhe",
  ld: "ltr",
  alt: [],
  cc: ["PK"]
}, {
  pk: 665,
  ang: "Odiai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Odiai",
  lc: "bhf",
  ld: "ltr",
  alt: ["Busa", "Uriai"],
  cc: ["PG"]
}, {
  pk: 666,
  ang: "Binandere",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Binandere",
  lc: "bhg",
  ld: "ltr",
  alt: ["Ioma Binandere"],
  cc: ["PG"]
}, {
  pk: 667,
  ang: "Bukharic",
  lr: "Asia",
  gw: false,
  hc: "IL",
  ln: "\u05D1\u05D5\u05DB\u05E8\u05D9\u05EA",
  lc: "bhh",
  ld: "ltr",
  alt: ["Bokharan", "Bokharic", "Bukharan", "Bukharian", "Judeo-Tajik", "Bokharian", "Bukharin"],
  cc: ["IL", "KZ", "US", "KG"]
}, {
  pk: 668,
  ang: "Bhilali",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bhilali",
  lc: "bhi",
  ld: "ltr",
  alt: ["Bhilala", "Parya Bhilali"],
  cc: ["IN"]
}, {
  pk: 669,
  ang: "Bahing",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Bahing",
  lc: "bhj",
  ld: "ltr",
  alt: ["Baying", "Bayung", "Kiranti-Bayung", "Nechali", "Tolacha", "Moblocha", "Hangu"],
  cc: ["NP"]
}, {
  pk: 670,
  ang: "Bimin",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bimin",
  lc: "bhl",
  ld: "ltr",
  alt: ["Nimtep Weng", "Bim"],
  cc: ["PG"]
}, {
  pk: 671,
  ang: "Bathari",
  lr: "Asia",
  gw: false,
  hc: "OM",
  ln: "\u0644\u063A\u0629 \u0628\u0627\u062B\u0627\u0631\u064A\u0629",
  lc: "bhm",
  ld: "ltr",
  alt: ["Batahari", "Bathara", "Bautahari", "Botahari"],
  cc: ["OM"]
}, {
  pk: 672,
  ang: "Bohtan Neo-Aramaic",
  lr: "Asia",
  gw: false,
  hc: "GE",
  ln: "\u0723\u0718\u072A\u072C",
  lc: "bhn",
  ld: "ltr",
  alt: [],
  cc: ["GE"]
}, {
  pk: 673,
  ang: "Bhojpuri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bhojpuri",
  lc: "bho",
  ld: "ltr",
  alt: ["Bajpuri", "Bhojapuri", "Bhozpuri", "Bihari", "Deswali", "Khotla", "Piscimas", "Northern Standard Bhojpuri (Basti)", "Western Standard Bhojpuri (Benarsi)", "Southern Standard Bhojpuri (Kharwari)", "Sheikh Boli", "Sarawaria", "Purbi Boli", "Kashika", "Gorakhpuri", "Bhojpuri Tharu", "Banarsi Boli", "Bangar Boli", "Mallika"],
  cc: ["BD", "DE", "MU", "NP", "US", "IN"]
}, {
  pk: 7568,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Thethi Bhojpuri",
  lc: "bho-x-thethi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 674,
  ang: "Bima",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bima",
  lc: "bhp",
  ld: "ltr",
  alt: ["Bimanese", "Sangar (Sanggar)"],
  cc: ["ID"]
}, {
  pk: 675,
  ang: "Tukang Besi South",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tukang Besi South",
  lc: "bhq",
  ld: "ltr",
  alt: ["Buton", "Tukang-Besi", "Wakatobi", "Bonerate", "Tomea (Tomia)"],
  cc: ["ID"]
}, {
  pk: 676,
  ang: "Malagasy, Bara",
  lr: "Africa",
  gw: false,
  hc: "MG",
  ln: "Bara Malagasy",
  lc: "bhr",
  ld: "ltr",
  alt: [],
  cc: ["MG"]
}, {
  pk: 677,
  ang: "Buwal",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Buwal",
  lc: "bhs",
  ld: "ltr",
  alt: ["Bual", "Ma Buwal"],
  cc: ["CM"]
}, {
  pk: 678,
  ang: "Bhattiyali",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bhattiyali",
  lc: "bht",
  ld: "ltr",
  alt: ["Bhateali", "Bhatiali Pahari", "Bhatiyali"],
  cc: ["IN"]
}, {
  pk: 679,
  ang: "Bhunjia",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bhunjia",
  lc: "bhu",
  ld: "ltr",
  alt: ["Bhumjiya", "Bhunjiya", "Bunjia"],
  cc: ["IN"]
}, {
  pk: 680,
  ang: "Bahau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bahau",
  lc: "bhv",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 681,
  ang: "Biak",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Biak",
  lc: "bhw",
  ld: "ltr",
  alt: ["Mafoor", "Mafoorsch", "Mefoor", "Myfoorsch", "Noefoor", "Noefoorsch", "Nufoor", "Sampori (Mokmer)"],
  cc: ["ID"]
}, {
  pk: 682,
  ang: "Bhalay",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bhalay",
  lc: "bhx",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 683,
  ang: "Bhele",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bhele",
  lc: "bhy",
  ld: "ltr",
  alt: ["Bili", "Ebhele", "Ipere", "Kipere", "Kipili", "Pere", "Peri", "Pili", "Piri", "Bugombe (Ebugombe)"],
  cc: ["CD"]
}, {
  pk: 8476,
  ang: "Bakombe",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bakombe",
  lc: "bhy-x-bakombe",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8280,
  ang: "Bapakombe",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bapakombe",
  lc: "bhy-x-bapakombe",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 684,
  ang: "Bada",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bada (Indonesia)",
  lc: "bhz",
  ld: "ltr",
  alt: ["Bada'", "Tobada'"],
  cc: ["ID"]
}, {
  pk: 685,
  ang: "Bislama",
  lr: "Pacific",
  gw: true,
  hc: "VU",
  ln: "Bislama",
  lc: "bi",
  ld: "ltr",
  alt: ["Bichelamar"],
  cc: ["NC", "SB", "VU"]
}, {
  pk: 686,
  ang: "Badimaya",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Badimaya",
  lc: "bia",
  ld: "ltr",
  alt: ["Parti-Maya", "Widimaya"],
  cc: ["AU"]
}, {
  pk: 687,
  ang: "Bisa",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Bissa",
  lc: "bib",
  ld: "ltr",
  alt: ["Bissa", "Baraka (Eastern Bisa)", "Lebir (Western Bisa)"],
  cc: ["BF", "GH", "TG"]
}, {
  pk: 688,
  ang: "Bikaru",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bikaru",
  lc: "bic",
  ld: "ltr",
  alt: ["Bugalu", "Pikaru"],
  cc: ["PG"]
}, {
  pk: 689,
  ang: "Bidiyo",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Bidiyo",
  lc: "bid",
  ld: "ltr",
  alt: ["Bidio", "Bidiya", "Bidiyo", "Bidiyo-Waana", "Bidyo", "Bigawguno (Tounkoul)", "Oboyguno (Zerli)", "Nalguno (Niergui)", "Garawgino (Kafila)", "Jekkino (Kofilo)"],
  cc: ["TD"]
}, {
  pk: 690,
  ang: "Bepour",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bepour",
  lc: "bie",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 691,
  ang: "Biafada",
  lr: "Africa",
  gw: false,
  hc: "GW",
  ln: "Biafada",
  lc: "bif",
  ld: "ltr",
  alt: ["Bedfola", "Biafar", "Bidyola", "Dfola", "Fada"],
  cc: ["GW"]
}, {
  pk: 692,
  ang: "Biangai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Biangai",
  lc: "big",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 693,
  ang: "Vaghat-Ya-Bijim-Legeri",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Vaghat-Ya-Bijim-Legeri",
  lc: "bij",
  ld: "ltr",
  alt: ["Kwanka", "Tivaghat", "Tiya", "Vaghat (Kadun)", "Ya (Boi)"],
  cc: ["NG"]
}, {
  pk: 694,
  ang: "Bikol",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Bikol",
  lc: "bik",
  ld: "ltr",
  alt: [],
  cc: ["PH"]
}, {
  pk: 695,
  ang: "Bille",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "\u0181ille",
  lc: "bil",
  ld: "ltr",
  alt: ["Bile", "Bili", "Billanchi", "Kunbille"],
  cc: ["NG"]
}, {
  pk: 696,
  ang: "Bimoba",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Bimoba",
  lc: "bim",
  ld: "ltr",
  alt: ["Moar", "Moor"],
  cc: ["GH"]
}, {
  pk: 697,
  ang: "Edo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bini",
  lc: "bin",
  ld: "ltr",
  alt: ["Addo", "Bini", "Oviedo", "Ovioba"],
  cc: ["NG", "CA"]
}, {
  pk: 698,
  ang: "Nai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nai",
  lc: "bio",
  ld: "ltr",
  alt: ["Biaka"],
  cc: ["PG"]
}, {
  pk: 699,
  ang: "Bila",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bila",
  lc: "bip",
  ld: "ltr",
  alt: ["Ebila", "Forest Bira", "Western Bila", "Bombi-Ngbanja", "Nyaku"],
  cc: ["CD"]
}, {
  pk: 700,
  ang: "Bipi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bipi",
  lc: "biq",
  ld: "ltr",
  alt: ["Sisi-Bipi"],
  cc: ["PG"]
}, {
  pk: 701,
  ang: "Bisorio",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bisorio",
  lc: "bir",
  ld: "ltr",
  alt: ["Iniai", "Inyai-Gadio-Bisorio", "Pikaru (Bikaru)"],
  cc: ["PG"]
}, {
  pk: 702,
  ang: "Berinomo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Berinomo",
  lc: "bit",
  ld: "ltr",
  alt: ["Kagiru (Apowasi)"],
  cc: ["PG"]
}, {
  pk: 703,
  ang: "Biete",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Biete",
  lc: "biu",
  ld: "ltr",
  alt: ["Baite", "Bete", "Biate"],
  cc: ["IN"]
}, {
  pk: 704,
  ang: "Birifor, Southern",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Southern Birifor",
  lc: "biv",
  ld: "ltr",
  alt: ["Birifo", "Ghana Birifor"],
  cc: ["GH"]
}, {
  pk: 705,
  ang: "Kol",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Kol (Cameroon)",
  lc: "biw",
  ld: "ltr",
  alt: ["Bekol", "Bikele-Bikay", "Bikele-Bikeng", "Bikeng", "Kol North", "Kol South", "Bikele"],
  cc: ["CM"]
}, {
  pk: 706,
  ang: "Bijori",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bijori",
  lc: "bix",
  ld: "ltr",
  alt: ["Binjhia", "Birijia", "Birjia", "Brijia", "Burja"],
  cc: ["IN"]
}, {
  pk: 707,
  ang: "Birhor",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Birhor",
  lc: "biy",
  ld: "ltr",
  alt: ["Bihor", "Birhar", "Birhore", "Birhul", "Mankidi", "Mankidia", "Mankiria"],
  cc: ["IN"]
}, {
  pk: 708,
  ang: "Baloi",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Baloi",
  lc: "biz",
  ld: "ltr",
  alt: ["Baato Baloi", "Boloi", "Rebu", "Dzamba (Jamba)"],
  cc: ["CD"]
}, {
  pk: 709,
  ang: "Budza",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Budza",
  lc: "bja",
  ld: "ltr",
  alt: ["Budja", "Buja", "Ebuja", "Embudja", "Limbudza", "Mbudja"],
  cc: ["CD"]
}, {
  pk: 710,
  ang: "Bariji",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bariji",
  lc: "bjc",
  ld: "ltr",
  alt: ["Aga Bereho"],
  cc: ["PG"]
}, {
  pk: 711,
  ang: "Biao-Jiao Mien",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6807\u654F\u65B9\u8A00",
  lc: "bje",
  ld: "ltr",
  alt: ["Biao Chao", "Byau Min", "Dongshan Biao Min", "Jiaogong Mian (Chao Kong Meng)", "Shikou", "Dongshan Yao", "Byaumin", "Biaomin", "Biao Min (Ao Yao)", "Biao Mien", "Tsaukongmeng"],
  cc: ["CN"]
}, {
  pk: 712,
  ang: "Barzani Jewish Neo-Aramaic",
  lr: "Asia",
  gw: false,
  hc: "IL",
  ln: "\u05DC\u05E9\u05E0\u05D9\u05D3 \u05D3\u05D9\u05E0\u05DF",
  lc: "bjf",
  ld: "ltr",
  alt: ["Lishan Didan", "Lishan Dideni", "Shahe", "Barzan", "Bijil"],
  cc: ["IL"]
}, {
  pk: 713,
  ang: "Bidyogo",
  lr: "Africa",
  gw: false,
  hc: "GW",
  ln: "Bidyogo",
  lc: "bjg",
  ld: "ltr",
  alt: ["Bijago", "Bijogo", "Bijougot", "Bijuga", "Budjago", "Bugago", "Kamona (Caravela)", "Kasuga", "Kavrama", "Karanguna (Orango)", "Kajoko (Uno)", "Kagbaaga", "Anhaqui (Anhaki)", "Formosa"],
  cc: ["GW"]
}, {
  pk: 714,
  ang: "Bahinemo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bahinemo",
  lc: "bjh",
  ld: "ltr",
  alt: ["Bahenemo", "Gahom", "Inaru", "Wogu", "Yigai"],
  cc: ["PG"]
}, {
  pk: 715,
  ang: "Burji",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Burji",
  lc: "bji",
  ld: "ltr",
  alt: ["Bambala", "Bembala", "Daashi"],
  cc: ["ET", "KE"]
}, {
  pk: 716,
  ang: "Kanauji",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kanauji",
  lc: "bjj",
  ld: "ltr",
  alt: ["Bhakha", "Braj", "Braj Kanauji", "Dehati", "Kannauji"],
  cc: ["IN"]
}, {
  pk: 717,
  ang: "Barok",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Barok",
  lc: "bjk",
  ld: "ltr",
  alt: ["Kanalu", "Kanapit", "Kolube", "Komalu", "Kulubi"],
  cc: ["PG"]
}, {
  pk: 718,
  ang: "Bulu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bulu (Papua New Guinea)",
  lc: "bjl",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 719,
  ang: "Bajelani",
  lr: "Asia",
  gw: false,
  hc: "IQ",
  ln: "\u0632\u0628\u0627\u0646 \u0628\u0627\u062C\u0644\u0627\u0646\u06CC",
  lc: "bjm",
  ld: "ltr",
  alt: ["Bajalani", "Bajoran", "Bejwan", "Chichamachu", "Gurani"],
  cc: ["IQ"]
}, {
  pk: 720,
  ang: "Banjar",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Banjar",
  lc: "bjn",
  ld: "ltr",
  alt: ["Bandjarese", "Banjar Malay", "Banjarese", "Hulu"],
  cc: ["ID"]
}, {
  pk: 7997,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Banjar",
  lc: "bjn-x-dayakbanjar",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7968,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Lebang Hulu",
  lc: "bjn-x-hulu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 721,
  ang: "Banda, Mid-Southern",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Mid-Southern Banda",
  lc: "bjo",
  ld: "ltr",
  alt: ["Banda Central Sud", "Wasa (Ouassa)", "Yacoua", "Yakpa (Bayaka)", "Yakpwa", "Yakwa"],
  cc: ["CF", "SS"]
}, {
  pk: 722,
  ang: "Fanamaket",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Fanamaket",
  lc: "bjp",
  ld: "ltr",
  alt: ["Maket", "Tangga"],
  cc: ["PG"]
}, {
  pk: 723,
  ang: "Binumarien",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Binumarien",
  lc: "bjr",
  ld: "ltr",
  alt: ["Binamarir", "Binumaria"],
  cc: ["PG"]
}, {
  pk: 724,
  ang: "Bajan",
  lr: "Americas",
  gw: false,
  hc: "BB",
  ln: "Bajan",
  lc: "bjs",
  ld: "ltr",
  alt: ["Barbadian Creole English"],
  cc: ["BB"]
}, {
  pk: 725,
  ang: "Balanta-Ganja",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Balanta-Ganja",
  lc: "bjt",
  ld: "ltr",
  alt: ["Alante", "Balanda", "Balant", "Balante", "Ballante", "Belante", "Brassa", "Bulanda", "Fjaa", "Fraase", "Fganja (Ganja)", "Fjaalib (Blip)"],
  cc: ["SN"]
}, {
  pk: 726,
  ang: "Busuu",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Busuu",
  lc: "bju",
  ld: "ltr",
  alt: ["Awa", "Furu"],
  cc: ["CM"]
}, {
  pk: 727,
  ang: "Bedjond",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Bedjond",
  lc: "bjv",
  ld: "ltr",
  alt: ["Bediondo", "Bediondo Mbai", "B\xE9djonde", "Bedjondo", "Mbay Bediondo", "Mbay Bejondo", "Nangnda"],
  cc: ["TD"]
}, {
  pk: 728,
  ang: "Bakw\xE9",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Bakw\xE9",
  lc: "bjw",
  ld: "ltr",
  alt: [],
  cc: ["CI", "AO"]
}, {
  pk: 729,
  ang: "Itneg, Banao",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Banao Itneg",
  lc: "bjx",
  ld: "ltr",
  alt: ["Banao", "Banaw", "Itneg", "Timggian", "Tinguian", "Banao Pikekj", "Gubang Itneg", "Malibcong Banao"],
  cc: ["PH"]
}, {
  pk: 730,
  ang: "Baruga",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Baruga",
  lc: "bjz",
  ld: "ltr",
  alt: ["Tafota Baruga"],
  cc: ["PG"]
}, {
  pk: 731,
  ang: "Kyak",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kyak",
  lc: "bka",
  ld: "ltr",
  alt: ["Bambuka", "Nyakyak"],
  cc: ["NG"]
}, {
  pk: 732,
  ang: "Baka",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Baka (Cameroon)",
  lc: "bkc",
  ld: "ltr",
  alt: ["Babinga", "Bebayaga", "Bebayaka", "Bibaya", "Pygmees Baka", "Pygmees de l'Est"],
  cc: ["CM", "GA"]
}, {
  pk: 733,
  ang: "Binukid",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Binukid",
  lc: "bkd",
  ld: "ltr",
  alt: ["Binukid Manobo", "Bukidnon"],
  cc: ["PH"]
}, {
  pk: 7820,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Talaandig",
  lc: "bkd-x-talaandig",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 734,
  ang: "Beeke",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Beeke",
  lc: "bkf",
  ld: "ltr",
  alt: ["Beke", "Ibeeke"],
  cc: ["CD"]
}, {
  pk: 735,
  ang: "Buraka",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Buraka",
  lc: "bkg",
  ld: "ltr",
  alt: ["Boraka", "Bouraka", "Bolaka"],
  cc: ["CF"]
}, {
  pk: 736,
  ang: "Bakoko",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bakoko",
  lc: "bkh",
  ld: "ltr",
  alt: ["Basoo", "Bisoo (Adiangok)", "Yasug", "Yassuku (Yasoukou)", "Yakalak (Yakalag)", "Yabyang (Yabyang-Yapeke)", "Elog Mpoo", "Yasuku", "Basso", "Basoo D'edea", "Basoo Ba Likol", "Adie (Basoo Ba Die)", "Mbang (Dimbambang)"],
  cc: ["CM"]
}, {
  pk: 737,
  ang: "Baki",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Baki",
  lc: "bki",
  ld: "ltr",
  alt: ["Burumba", "Paki"],
  cc: ["VU"]
}, {
  pk: 738,
  ang: "Pande",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Pande",
  lc: "bkj",
  ld: "ltr",
  alt: ["Ipande", "Ngili", "Pande (Linyeli)", "Njeli", "Ndjeli", "Linzeli", "Bogongo (Bugongo)", "Bukongo"],
  cc: ["CF"]
}, {
  pk: 739,
  ang: "Brokskat",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Brokskat",
  lc: "bkk",
  ld: "ltr",
  alt: ["Brokpa", "Brokpa of Dah-Hanu", "Dokskat", "Kyango"],
  cc: ["IN"]
}, {
  pk: 740,
  ang: "Berik",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Berik",
  lc: "bkl",
  ld: "ltr",
  alt: ["Berick", "Berrik", "Upper Tor"],
  cc: ["ID"]
}, {
  pk: 741,
  ang: "Kom",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Kom (Cameroon)",
  lc: "bkm",
  ld: "ltr",
  alt: ["Bamekon", "Bikom", "Kong", "Nkom", "Mbesa", "Mbizenaku (Itangimbesa)"],
  cc: ["CM"]
}, {
  pk: 742,
  ang: "Bukitan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bukitan",
  lc: "bkn",
  ld: "ltr",
  alt: ["Bakatan", "Bakitan", "Beketan", "Mangkettan", "Manketa", "Pakatan"],
  cc: ["ID", "MY"]
}, {
  pk: 7881,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Punan Blusu",
  lc: "bkn-x-punanblusu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 743,
  ang: "Kwa\u2019",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Kwa'",
  lc: "bko",
  ld: "ltr",
  alt: ["Bakoa", "Bakwa", "Bamileke-Kwa", "Bakoua", "Bekwa'", "Kwa' (Babwa)", "Mipa"],
  cc: ["CM"]
}, {
  pk: 744,
  ang: "Boko",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Boko (Democratic Republic of Congo)",
  lc: "bkp",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 745,
  ang: "Bakair\xED",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Bakair\xED",
  lc: "bkq",
  ld: "ltr",
  alt: ["Bacair\xED", "Kur\xE2"],
  cc: ["BR"]
}, {
  pk: 746,
  ang: "Bakumpai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bakumpai",
  lc: "bkr",
  ld: "ltr",
  alt: ["Bara-Jida", "Mengkatip (Mangkatip)", "Oloh Mengkatip"],
  cc: ["ID"]
}, {
  pk: 747,
  ang: "Sorsoganon, Northern",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Northern Sorsoganon",
  lc: "bks",
  ld: "ltr",
  alt: ["Northern Sorsogon", "Sorsogon Bicolano", "Sorsogon, Masbate", "Masbate", "Sorsogon"],
  cc: ["PH"]
}, {
  pk: 748,
  ang: "Boloki",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Boloki",
  lc: "bkt",
  ld: "ltr",
  alt: ["Baloki", "Boleki", "Buluki", "River Ruki"],
  cc: ["CG", "CD"]
}, {
  pk: 749,
  ang: "Buhid",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Buhid",
  lc: "bku",
  ld: "ltr",
  alt: ["Bangon", "Batangan", "Bukil"],
  cc: ["PH"]
}, {
  pk: 750,
  ang: "Bekwarra",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bekwarra",
  lc: "bkv",
  ld: "ltr",
  alt: ["Bekworra", "Ebekwara", "Yakoro"],
  cc: ["NG"]
}, {
  pk: 751,
  ang: "Bekwel",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Bekwel",
  lc: "bkw",
  ld: "ltr",
  alt: ["Bakwil", "Bekwil", "Okpele", "Bekwie", "Mekwoob", "Esel (Essel)", "Zalagee", "Koolo", "Ebaa", "Mebeeza"],
  cc: ["CM", "GA", "CG"]
}, {
  pk: 752,
  ang: "Baikeno",
  lr: "Asia",
  gw: false,
  hc: "TL",
  ln: "Baikeno",
  lc: "bkx",
  ld: "ltr",
  alt: ["Ambeno", "Ambenu", "Baikenu", "Biqueno", "Lais Meto", "Molok Meto", "Oe Cusi", "Oecusse", "Oecussi", "Oekusi", "Uab Meto", "Uab Pah Meto", "Vaikenu", "Vaikino", "Dawan", "Amnesat", "Nu'af"],
  cc: ["TL"]
}, {
  pk: 753,
  ang: "Bokyi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bokyi",
  lc: "bky",
  ld: "ltr",
  alt: ["Byoki", "Nfua", "Nki", "Okii", "Osikom", "Osukam", "Uki", "Vaaneroki", "Boje (Bojie)", "Wula (Baswo)", "Okundi", "Kecwan", "Irruan (Eerwee)", "Eastern Bokyi (East Boki)", "Basua (Bashua)", "Abo (Abu)", "Erwan"],
  cc: ["CM", "NG"]
}, {
  pk: 754,
  ang: "Bungku",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bungku",
  lc: "bkz",
  ld: "ltr",
  alt: ["Ikinyikiusa", "Nahina", "Tamboeko", "Tambuku", "Tobuco", "Torete (To Rete)"],
  cc: ["ID"]
}, {
  pk: 755,
  ang: "Blackfoot",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Siksika",
  lc: "bla",
  ld: "ltr",
  alt: ["Blackfeet", "Pied Noir", "Pikanii", "Blood (Kainaa)", "Piegan (Peigan)"],
  cc: ["US", "CA"]
}, {
  pk: 756,
  ang: "Bilua",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Bilua",
  lc: "blb",
  ld: "ltr",
  alt: ["Mbilua", "Vella Lavella"],
  cc: ["SB"]
}, {
  pk: 757,
  ang: "Bella Coola",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Bella Coola",
  lc: "blc",
  ld: "ltr",
  alt: [],
  cc: ["CA"]
}, {
  pk: 758,
  ang: "Bolango",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bolango",
  lc: "bld",
  ld: "ltr",
  alt: ["Atinggola-Bolango", "Bolaang Uki", "Bolang-Banka", "Bulanga", "Bulanga-Uki", "Atinggola (Andagile)", "Attingola", "Bolango (Uki)", "Diu", "Kattinggola"],
  cc: ["ID"]
}, {
  pk: 759,
  ang: "Balanta-Kentohe",
  lr: "Africa",
  gw: false,
  hc: "GW",
  ln: "Balanta-Kentohe",
  lc: "ble",
  ld: "ltr",
  alt: ["Alante", "Balanda", "Balant", "Balanta", "Balante", "Ballante", "Belante", "Brassa", "Bulanda", "Frase", "Nhacra (Fora)", "Queuthoe", "Kantohe (Kentohe)"],
  cc: ["CA", "GW"]
}, {
  pk: 7722,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "GW",
  ln: "Balanta Naga",
  lc: "ble-x-balantanaga",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 760,
  ang: "Buol",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Buol",
  lc: "blf",
  ld: "ltr",
  alt: ["Bual", "Bwool", "Bwo'ol", "Dia"],
  cc: ["ID"]
}, {
  pk: 761,
  ang: "Balau",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Balau",
  lc: "blg",
  ld: "ltr",
  alt: ["Bala'u"],
  cc: ["MY"]
}, {
  pk: 762,
  ang: "Kuwaa",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Kuwaa",
  lc: "blh",
  ld: "ltr",
  alt: ["Belle", "Belleh", "Kowaao", "Kwaa"],
  cc: ["LR"]
}, {
  pk: 763,
  ang: "Bolia",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bolia",
  lc: "bli",
  ld: "ltr",
  alt: ["Bokoki", "Bulia"],
  cc: ["CD"]
}, {
  pk: 764,
  ang: "Bolongan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bolongan",
  lc: "blj",
  ld: "ltr",
  alt: ["Bulungan"],
  cc: ["ID"]
}, {
  pk: 765,
  ang: "Pa\u2019o",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Pa'o Karen",
  lc: "blk",
  ld: "ltr",
  alt: ["Black Karen", "Northern Taungthu", "Pa Oh", "Pa-O", "Pa'o Karen", "Pa-U", "Pa'0", "Taungtu", "Southern Pa'o"],
  cc: ["TH", "MM"]
}, {
  pk: 766,
  ang: "Biloxi",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Biloxi",
  lc: "bll",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 767,
  ang: "Beli",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Beli (Sudan)",
  lc: "blm",
  ld: "ltr",
  alt: ["Behli", "Beili", "Beli", "Jur Beli", "Sopi (Supi)"],
  cc: ["SS"]
}, {
  pk: 768,
  ang: "Bikol, Southern Catanduanes",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Southern Catanduanes Bikol",
  lc: "bln",
  ld: "ltr",
  alt: ["Southern Catanduanes Bikolano", "Virac"],
  cc: ["PH"]
}, {
  pk: 769,
  ang: "Anii",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Anii",
  lc: "blo",
  ld: "ltr",
  alt: ["Baseca", "Basila", "Bassila", "Gisida", "Ouinji-Ouinji", "Winji-Winji", "Akpe", "Ounji-Ounji", "Gifolanga (Guiguisso)", "Gipenesulja (P\xE9n\xE9ssoulou)", "Frinyio ka gija (Frignion)", "Gipenelanja (P\xE9n\xE9lan)", "Gisaramangaja", "Gikodowarja (Kodowari)", "Giborokoja (Mboroko)", "Gibayaakuja (Bayaku)", "Agerendebu ka gija (Ag\xE9r\xE9nd\xE9bou)", "Gibodija (Bodi)", "Gideenguja (Dengou)"],
  cc: ["BJ", "TG"]
}, {
  pk: 770,
  ang: "Blablanga",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Blablanga",
  lc: "blp",
  ld: "ltr",
  alt: ["Gema", "Goi"],
  cc: ["SB"]
}, {
  pk: 771,
  ang: "Baluan-Pam",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Baluan-Pam",
  lc: "blq",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 772,
  ang: "Blang",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5E03\u6717\u65B9\u8A00",
  lc: "blr",
  ld: "ltr",
  alt: ["Bulang", "K'ala", "Kawa", "Kontoi", "Plang", "Pula", "Pulang", "Hkawa", "Khon Doi", "K'wa", "Sen Chun", "Wa"],
  cc: ["CN", "MM"]
}, {
  pk: 773,
  ang: "Balaesang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Balaesang",
  lc: "bls",
  ld: "ltr",
  alt: ["Balaisang", "Pajo"],
  cc: ["ID"]
}, {
  pk: 774,
  ang: "Tai Dam",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Tai Dam",
  lc: "blt",
  ld: "ltr",
  alt: ["Black Tai", "Hei Dai", "Jinping Dai", "Tailam", "Tailon", "Tai Noir", "Thai Den", "Tai Do", "T\xE1y-Dam", "Th\xE1i Den", "Tai Mueai", "Tai Muei", "Tai Muoi (Meuay)", "Tay Mueai", "T\xE1y Mu'\xF2'i (Meuay)"],
  cc: ["CN", "FR", "LA", "TH", "US", "VN"]
}, {
  pk: 775,
  ang: "Bolo",
  lr: "Africa",
  gw: false,
  hc: "AO",
  ln: "Bolo",
  lc: "blv",
  ld: "ltr",
  alt: ["Haka", "Libolo", "Lubolo"],
  cc: ["AO"]
}, {
  pk: 776,
  ang: "Balangao",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Balangao",
  lc: "blw",
  ld: "ltr",
  alt: ["Balangao Bontoc", "Balangaw", "Farangao"],
  cc: ["PH"]
}, {
  pk: 777,
  ang: "Ayta, Mag-Indi",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Mag-Indi Ayta",
  lc: "blx",
  ld: "ltr",
  alt: ["Indi Ayta", "Mag-Indi Sambal", "Baluga"],
  cc: ["PH"]
}, {
  pk: 778,
  ang: "Notre",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Notre",
  lc: "bly",
  ld: "ltr",
  alt: ["Bulba", "Burusa", "Nootre"],
  cc: ["BJ"]
}, {
  pk: 779,
  ang: "Balantak",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Balantak",
  lc: "blz",
  ld: "ltr",
  alt: ["Balanta", "Kosian"],
  cc: ["ID"]
}, {
  pk: 780,
  ang: "Bambara",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Bamanankan",
  lc: "bm",
  ld: "ltr",
  alt: ["Bamako", "Bamana", "Bamanakan", "Wassulunke", "Wassulunka", "Wasulunkakan (Maninkakan)", "Ganadugu", "Eastern", "Wasuu", "Wassulu"],
  cc: ["BF", "GM", "ML", "MR", "NE", "SN", "US", "CA", "GN"]
}, {
  pk: 781,
  ang: "Lame",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Lame",
  lc: "bma",
  ld: "ltr",
  alt: ["Rufu", "Ruhu (Rufawa)", "Mbaru (Bambara)", "Gura (Agari)", "Bunberawa", "Bombaro", "Bamburo", "Agbiri", "Bambaro", "Tugura", "Bomberawa"],
  cc: ["NG"]
}, {
  pk: 782,
  ang: "Bembe",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bembe",
  lc: "bmb",
  ld: "ltr",
  alt: ["Beembe", "Ebembe", "Ibembe", "Kibembe"],
  cc: ["TZ", "CD"]
}, {
  pk: 783,
  ang: "Biem",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Biem",
  lc: "bmc",
  ld: "ltr",
  alt: ["Bam"],
  cc: ["PG"]
}, {
  pk: 784,
  ang: "Baga Manduri",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Baga Manduri",
  lc: "bmd",
  ld: "ltr",
  alt: ["Baka", "Maduri", "Mandari", "Mandore", "Mandori", "Manduri"],
  cc: ["GN"]
}, {
  pk: 785,
  ang: "Limassa",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Limassa",
  lc: "bme",
  ld: "ltr",
  alt: ["Bamassa", "Bomasa"],
  cc: ["CF"]
}, {
  pk: 786,
  ang: "Bom",
  lr: "Africa",
  gw: false,
  hc: "SL",
  ln: "Bom",
  lc: "bmf",
  ld: "ltr",
  alt: ["Bome", "Bomo", "Bum"],
  cc: ["SL"]
}, {
  pk: 787,
  ang: "Bamwe",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bamwe",
  lc: "bmg",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 788,
  ang: "Kein",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kein",
  lc: "bmh",
  ld: "ltr",
  alt: ["Bemal", "Kibam", "Sigau", "Sog"],
  cc: ["PG"]
}, {
  pk: 789,
  ang: "Bagirmi",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Bagirmi",
  lc: "bmi",
  ld: "ltr",
  alt: ["Baghirmi", "Bagrimma", "Baguirme", "Barma", "Lis", "Lisi", "Mbarma", "Tar Bagrimma", "Tar Barma"],
  cc: ["TD"]
}, {
  pk: 790,
  ang: "Bote",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Bote-Majhi",
  lc: "bmj",
  ld: "ltr",
  alt: ["Pakhe-Bote", "Pani-Bote"],
  cc: ["NP"]
}, {
  pk: 791,
  ang: "Ghayavi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ghayavi",
  lc: "bmk",
  ld: "ltr",
  alt: ["Boanai", "Boanaki", "Boianaki", "Boinaki", "Galavi"],
  cc: ["PG"]
}, {
  pk: 792,
  ang: "Bomboli",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bomboli",
  lc: "bml",
  ld: "ltr",
  alt: ["Bombongo"],
  cc: ["CD"]
}, {
  pk: 793,
  ang: "Malagasy, Northern Betsimisaraka",
  lr: "Africa",
  gw: false,
  hc: "MG",
  ln: "Northern Betsimisaraka Malagasy",
  lc: "bmm",
  ld: "ltr",
  alt: [],
  cc: ["MG"]
}, {
  pk: 7792,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "MG",
  ln: "Middle Betsimisaraka Malagasy",
  lc: "bmm-x-middlebetsi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 794,
  ang: "Bambalang",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bambalang",
  lc: "bmo",
  ld: "ltr",
  alt: ["Bambolang", "Chirambo", "Chrambo", "Mbawyakum", "Mboyakum", "Tshirambo"],
  cc: ["CM"]
}, {
  pk: 795,
  ang: "Bulgebi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bulgebi",
  lc: "bmp",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 796,
  ang: "Bomu",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Bomu",
  lc: "bmq",
  ld: "ltr",
  alt: ["Bobo Oule", "Boomu", "Bore", "Western Bobo Wule", "Bobo", "Bobo Wule", "Western Bobo Oule", "Western Bwamu", "Western Red", "Mao"],
  cc: ["BF", "ML"]
}, {
  pk: 797,
  ang: "Muinane",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Muinane",
  lc: "bmr",
  ld: "ltr",
  alt: ["Muename", "Muinana", "Muinani"],
  cc: ["CO"]
}, {
  pk: 798,
  ang: "Kanuri, Bilma",
  lr: "Africa",
  gw: false,
  hc: "NE",
  ln: "Bilma Kanuri",
  lc: "bms",
  ld: "ltr",
  alt: ["Bla Bla", "Kanouri", "Kanoury", "Bilma", "Fachi"],
  cc: ["NE"]
}, {
  pk: 799,
  ang: "Biao Mon",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6807\u66FC\u571F\u8BED",
  lc: "bmt",
  ld: "ltr",
  alt: ["Biaoman", "Biao-Mian", "Changping", "Min Yao", "Sida Min Yao", "Shi Mun (Sida Min Yao)", "Biao Mon (Min Yao)"],
  cc: ["CN"]
}, {
  pk: 800,
  ang: "Somba-Siawari",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Somba-Siawari",
  lc: "bmu",
  ld: "ltr",
  alt: ["Bulum", "Burum", "Burum-Mindik", "Mindik", "Siawari"],
  cc: ["PG"]
}, {
  pk: 801,
  ang: "Bum",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bum",
  lc: "bmv",
  ld: "ltr",
  alt: ["Bom"],
  cc: ["CM"]
}, {
  pk: 802,
  ang: "Bomwali",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Bomwali",
  lc: "bmw",
  ld: "ltr",
  alt: ["Bomali", "Boumoali", "Bumali", "Lino", "Sangasanga"],
  cc: ["CM", "CG"]
}, {
  pk: 803,
  ang: "Baimak",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Baimak",
  lc: "bmx",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 804,
  ang: "Baramu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Baramu",
  lc: "bmz",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 805,
  ang: "Bengali, Bangla",
  lr: "Asia",
  gw: true,
  hc: "BD",
  ln: "\u09AC\u09BE\u0982\u09B2\u09BE",
  lc: "bn",
  ld: "ltr",
  alt: ["Bangala", "Bangla-Bhasa", "Siripuria (Kishanganjia)", "Barisal", "Khulna", "Lohari-Malpaharia", "Mymensingh", "Noakhali"],
  cc: ["BD", "FR", "DE", "KE", "LK", "GB", "MY", "OM", "NP", "PK", "SA", "TH", "US", "CA", "IT", "IN", "SG", "MM", "AE"]
}, {
  pk: 806,
  ang: "Bonerate",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bonerate",
  lc: "bna",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 807,
  ang: "Bookan",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Bookan",
  lc: "bnb",
  ld: "ltr",
  alt: ["Baukan Murut", "Tangara'", "Ulun-No-Bokan", "Ulun-No-Bokon", "Tungara", "Tingara", "Tenggaraq", "Tengara (Kinabatangan Murut)", "Tanggaraq", "Bukun", "Bokun", "Bokon", "Boken", "Baukan (Baokan)", "Pingas", "Bokan"],
  cc: ["MY"]
}, {
  pk: 808,
  ang: "Bontok",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Bontok",
  lc: "bnc",
  ld: "ltr",
  alt: [],
  cc: ["PH"]
}, {
  pk: 809,
  ang: "Banda",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Banda (Indonesia)",
  lc: "bnd",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 810,
  ang: "Bintauna",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bintauna",
  lc: "bne",
  ld: "ltr",
  alt: ["Bintaoena", "Bintawoena", "Bitaoena"],
  cc: ["ID"]
}, {
  pk: 811,
  ang: "Masiwang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Masiwang",
  lc: "bnf",
  ld: "ltr",
  alt: ["Bonfia"],
  cc: ["ID"]
}, {
  pk: 812,
  ang: "Benga",
  lr: "Africa",
  gw: false,
  hc: "GQ",
  ln: "Benga",
  lc: "bng",
  ld: "ltr",
  alt: ["Boumba", "Ndowe"],
  cc: ["GQ", "GA"]
}, {
  pk: 813,
  ang: "Bobangi",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bobangi",
  lc: "bni",
  ld: "ltr",
  alt: ["Bubangi", "Dzamba", "Lobobangi", "Rebu", "Bungi"],
  cc: ["CG", "CD"]
}, {
  pk: 814,
  ang: "Tawbuid, Eastern",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Eastern Tawbuid",
  lc: "bnj",
  ld: "ltr",
  alt: ["Bangon", "Barangan", "Batangan", "Binatangan", "Fanawbuid", "Suri", "Tabuid", "Taubuid", "Tiron"],
  cc: ["PH"]
}, {
  pk: 815,
  ang: "Bierebo",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Bierebo",
  lc: "bnk",
  ld: "ltr",
  alt: ["Bonkovia-Yevali"],
  cc: ["VU"]
}, {
  pk: 816,
  ang: "Boon",
  lr: "Africa",
  gw: false,
  hc: "SO",
  ln: "Boon",
  lc: "bnl",
  ld: "ltr",
  alt: ["Af-Boon"],
  cc: ["SO"]
}, {
  pk: 817,
  ang: "Batanga",
  lr: "Africa",
  gw: false,
  hc: "GQ",
  ln: "Batanga",
  lc: "bnm",
  ld: "ltr",
  alt: ["Banoho", "Banoo", "Batanga-Banda", "Noho", "Noku", "Nohu", "Puku", "Poko", "Naka", "Bapuku (Bapuu)", "Bano'o (Banaka)", "Banoko"],
  cc: ["CM", "GQ"]
}, {
  pk: 818,
  ang: "Bunun",
  lr: "Asia",
  gw: false,
  hc: "TW",
  ln: "Bunun",
  lc: "bnn",
  ld: "ltr",
  alt: ["Bubukun", "Bunan", "Bunti", "Bunum", "Vonun", "Vunum", "Vunun", "Vunung", "South Bunun (Ishbukun)", "Takivatan", "Takitudu", "Takibakha", "Takevatan", "Taketodo", "Sibukun", "Sibukaun", "Shibukun (Sibucoon)", "Sivukun", "Central Bunun (Takbanuao)", "North Bunun (Takebakha)"],
  cc: ["TW"]
}, {
  pk: 819,
  ang: "Bantoanon",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Bantoanon",
  lc: "bno",
  ld: "ltr",
  alt: ["Banton", "Calatravanhon", "Odionganon", "Sibalenhon (Sibale)", "Simaranhon"],
  cc: ["PH"]
}, {
  pk: 820,
  ang: "Bola",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bola",
  lc: "bnp",
  ld: "ltr",
  alt: ["Bakovi", "Bola-Bakovi", "Karua", "Mai", "Harua (Garua)", "Xarua"],
  cc: ["PG"]
}, {
  pk: 821,
  ang: "Bantik",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bantik",
  lc: "bnq",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 822,
  ang: "Butmas-Tur",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Butmas-Tur",
  lc: "bnr",
  ld: "ltr",
  alt: ["Ati"],
  cc: ["VU"]
}, {
  pk: 823,
  ang: "Bundeli",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bundeli",
  lc: "bns",
  ld: "ltr",
  alt: ["Bondili", "Bhadauri (Towargarhi)", "Lodhanti (Rathora)"],
  cc: ["IN"]
}, {
  pk: 824,
  ang: "Bentong",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bentong",
  lc: "bnu",
  ld: "ltr",
  alt: ["Bentong-Dentong", "Dentong"],
  cc: ["ID"]
}, {
  pk: 825,
  ang: "Beneraf",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bonerif",
  lc: "bnv",
  ld: "ltr",
  alt: ["Boneraf", "Bonerif"],
  cc: ["ID"]
}, {
  pk: 826,
  ang: "Bisis",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bisis",
  lc: "bnw",
  ld: "ltr",
  alt: ["Yambiyambi"],
  cc: ["PG"]
}, {
  pk: 827,
  ang: "Bangubangu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bangubangu",
  lc: "bnx",
  ld: "ltr",
  alt: ["Bangobango", "Kibangobango", "Nonda", "Sanzi"],
  cc: ["CD"]
}, {
  pk: 828,
  ang: "Bintulu",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Bintulu",
  lc: "bny",
  ld: "ltr",
  alt: [],
  cc: ["MY"]
}, {
  pk: 829,
  ang: "Beezen",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Beezen",
  lc: "bnz",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 830,
  ang: "Tibetan Standard, Tibetan, Central",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u0F56\u0F7C\u0F51\u0F0B\u0F61\u0F72\u0F42",
  lc: "bo",
  ld: "ltr",
  alt: ["Bhokha", "Byokha", "Dbusgtsang", "Phoke", "Tibetan", "U", "Wei", "Weizang", "Zang", "Bod", "Central Tibetan", "Pohbetian", "Poke", "Skad", "Tebilian", "Tibate", "Bod Skad", "Zang Wen", "Nganshuenkuan (Anshuenkuan Nyarong)", "Hanniu", "Utsang", "Tsang", "Panakha-Panags", "Mngahris (Ngari)", "Dru", "Aba (Batang)", "Diaspora Tibetan", "Gtsang (Lhasa)", "Deqing Zang", "Dartsemdo (Tatsienlu)", "Paurong"],
  cc: ["CN", "BT", "NP", "SE", "US", "CA", "IN", "MM"]
}, {
  pk: 831,
  ang: "Bora",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Bora",
  lc: "boa",
  ld: "ltr",
  alt: ["Boro", "Mira\xF1a", "Mir\xE3nia", "Meamuyna"],
  cc: ["BR", "PE", "CO"]
}, {
  pk: 832,
  ang: "Aweer",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Aweer",
  lc: "bob",
  ld: "ltr",
  alt: ["Aweera", "Bon", "Ogoda", "Waboni", "Wata-Bala", "Sanye"],
  cc: ["KE"]
}, {
  pk: 833,
  ang: "Mundabli",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mundabli",
  lc: "boe",
  ld: "ltr",
  alt: ["Buu", "Mufu"],
  cc: ["CM"]
}, {
  pk: 834,
  ang: "Bolon",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Bolon",
  lc: "bof",
  ld: "ltr",
  alt: ["Bo", "Boka", "Boon", "Boron", "White Bolon (Southern Bolon)", "Black Bolon (Northern Bolon)"],
  cc: ["BF", "ML"]
}, {
  pk: 835,
  ang: "Bamako Sign Language",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Bamako Sign Language",
  lc: "bog",
  ld: "ltr",
  alt: [],
  cc: ["ML"]
}, {
  pk: 836,
  ang: "Boma",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Boma",
  lc: "boh",
  ld: "ltr",
  alt: ["Boma Kasai", "Buma"],
  cc: ["CD"]
}, {
  pk: 837,
  ang: "Barbare\xF1o",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Barbare\xF1o",
  lc: "boi",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 838,
  ang: "Anjam",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Anjam",
  lc: "boj",
  ld: "ltr",
  alt: ["Bogadjim", "Bogajim", "Bogati", "Bom", "Lalok"],
  cc: ["PG"]
}, {
  pk: 839,
  ang: "Bonjo",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Bonjo",
  lc: "bok",
  ld: "ltr",
  alt: ["Impfondo", "Mbonzo"],
  cc: ["CG"]
}, {
  pk: 840,
  ang: "Bole",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bole",
  lc: "bol",
  ld: "ltr",
  alt: ["Ampika", "Bolanchi", "Bolawa", "Borpika", "Fika (Anpika)", "Fikankayen"],
  cc: ["NG"]
}, {
  pk: 841,
  ang: "Berom",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Berom",
  lc: "bom",
  ld: "ltr",
  alt: ["Afango", "Berum", "Gbang", "Kibbo", "Kibbun", "Kibo", "Kibyen", "L\xEAm Berom", "Shosho", "Gashish", "Vwang", "Ropp", "Riyom", "Rim", "Zawan", "Kuru", "Gyel", "Foron", "Fan", "Du", "Bachi", "Heikpang"],
  cc: ["NG"]
}, {
  pk: 842,
  ang: "Bine",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bine",
  lc: "bon",
  ld: "ltr",
  alt: ["Oriomo", "Pine", "Boze-Giringarede"],
  cc: ["PG"]
}, {
  pk: 843,
  ang: "Bozo, Tiemac\xE8w\xE8",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Tiemac\xE8w\xE8 Bozo",
  lc: "boo",
  ld: "ltr",
  alt: ["Boso", "Ti\xE9", "Tiema Ciewe", "Ti\xE8ma Ci\xE8w\xE8", "Tiemacewe", "Ti\xE8mac\xE8w\xE8"],
  cc: ["ML"]
}, {
  pk: 844,
  ang: "Bonkiman",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bonkiman",
  lc: "bop",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 845,
  ang: "Bogaya",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bogaya",
  lc: "boq",
  ld: "ltr",
  alt: ["Bogaia", "Pogaya"],
  cc: ["PG"]
}, {
  pk: 846,
  ang: "Bor\xF4ro",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Bor\xF4ro",
  lc: "bor",
  ld: "ltr",
  alt: ["Boe"],
  cc: ["BR"]
}, {
  pk: 847,
  ang: "Bongo",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Bongo",
  lc: "bot",
  ld: "ltr",
  alt: ["Bungu", "Dor"],
  cc: ["SS"]
}, {
  pk: 848,
  ang: "Bondei",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Bondei",
  lc: "bou",
  ld: "ltr",
  alt: ["Bonde", "Kibondei"],
  cc: ["TZ"]
}, {
  pk: 849,
  ang: "Tuwuli",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Tuwuli",
  lc: "bov",
  ld: "ltr",
  alt: ["Bawuli", "Bowili", "Liwuli", "Siwuri", "Tuwili"],
  cc: ["GH"]
}, {
  pk: 850,
  ang: "Rema",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Rema",
  lc: "bow",
  ld: "ltr",
  alt: ["Bothar"],
  cc: ["PG"]
}, {
  pk: 851,
  ang: "Buamu",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Buamu",
  lc: "box",
  ld: "ltr",
  alt: ["Eastern Bobo Oule", "Eastern Bobo Wule", "Red Bobo"],
  cc: ["BF"]
}, {
  pk: 7659,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Bwamu de Dedougou",
  lc: "box-x-dedougou",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 852,
  ang: "Bodo",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Bodo (Central African Republic)",
  lc: "boy",
  ld: "ltr",
  alt: [],
  cc: ["CF"]
}, {
  pk: 853,
  ang: "Bozo, Tieyaxo",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Ti\xE9yaxo Bozo",
  lc: "boz",
  ld: "ltr",
  alt: ["Boso", "T\xE9gu\xE9", "Tie", "Tiemaxo", "Ti\xE9yakho", "Tigemaxo", "Tigu\xE9makho", "Tyeyaxo"],
  cc: ["ML"]
}, {
  pk: 854,
  ang: "Daakaka",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Daakaka",
  lc: "bpa",
  ld: "ltr",
  alt: ["Baiap", "South Ambrym"],
  cc: ["VU"]
}, {
  pk: 855,
  ang: "Banda-Banda",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Banda-Banda",
  lc: "bpd",
  ld: "ltr",
  alt: ["Mbi (Mbiyi)", "Vidri", "Vodere", "Vidiri (Mvedere)", "Vadara", "Ndi (Ndri)", "Gbaga-South (Gbaga 1)", "Bria", "Bereya (Banda de Bria)", "Govoro (Govhoroh)", "Banda of Bria"],
  cc: ["CF", "SS"]
}, {
  pk: 856,
  ang: "Bonggo",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bonggo",
  lc: "bpg",
  ld: "ltr",
  alt: ["Armopa", "Bgu", "Bogu", "Bongo"],
  cc: ["ID"]
}, {
  pk: 857,
  ang: "Botlikh",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0411\u043E\u0442\u043B\u0438\u0445\u0441\u043A\u0438\u0439",
  lc: "bph",
  ld: "ltr",
  alt: ["Botlix", "Buykhadi"],
  cc: ["RU"]
}, {
  pk: 858,
  ang: "Bagupi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bagupi",
  lc: "bpi",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 859,
  ang: "Binji",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Binji",
  lc: "bpj",
  ld: "ltr",
  alt: ["Bindji"],
  cc: ["CD"]
}, {
  pk: 860,
  ang: "Orowe",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Orowe",
  lc: "bpk",
  ld: "ltr",
  alt: ["Abwebwe", "Boewe", "Boewi", "\xD4r\xF4\xEA", "Oroe"],
  cc: ["NC"]
}, {
  pk: 861,
  ang: "Broome Pearling Lugger Pidgin",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Broome Pearling Lugger Pidgin",
  lc: "bpl",
  ld: "ltr",
  alt: ["Broom Creole", "Japanese Pidgin English", "Koepang Talk", "Malay Talk"],
  cc: ["AU"]
}, {
  pk: 862,
  ang: "Biyom",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Biyom",
  lc: "bpm",
  ld: "ltr",
  alt: ["Sasime"],
  cc: ["PG"]
}, {
  pk: 863,
  ang: "Dzao Min",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u85FB\u654F",
  lc: "bpn",
  ld: "ltr",
  alt: ["Ba Pai Yao", "Yao Min", "Yau Min", "Zaomin"],
  cc: ["CN"]
}, {
  pk: 864,
  ang: "Anasi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Anasi",
  lc: "bpo",
  ld: "ltr",
  alt: ["Bapu"],
  cc: ["ID"]
}, {
  pk: 865,
  ang: "Kaure",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kaure",
  lc: "bpp",
  ld: "ltr",
  alt: ["Kaureh"],
  cc: ["ID"]
}, {
  pk: 866,
  ang: "Malay, Banda",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Banda Malay",
  lc: "bpq",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 867,
  ang: "Blaan, Koronadal",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Koronadal Blaan",
  lc: "bpr",
  ld: "ltr",
  alt: ["Baraan", "Bilanes", "Biraan", "Koronadal Bilaan", "Tagalagad"],
  cc: ["PH"]
}, {
  pk: 868,
  ang: "Blaan, Sarangani",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Sarangani Blaan",
  lc: "bps",
  ld: "ltr",
  alt: ["Balud", "Bilaan", "Tumanao"],
  cc: ["PH"]
}, {
  pk: 869,
  ang: "Bongu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bongu",
  lc: "bpu",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 870,
  ang: "Marind, Bian",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bian Marind",
  lc: "bpv",
  ld: "ltr",
  alt: ["Bian", "Boven-Mbian", "Northwest Marind"],
  cc: ["ID"]
}, {
  pk: 871,
  ang: "Bo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bo (Papua New Guinea)",
  lc: "bpw",
  ld: "ltr",
  alt: ["Po", "Sorimi"],
  cc: ["PG"]
}, {
  pk: 872,
  ang: "Bareli, Palya",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Palya Bareli",
  lc: "bpx",
  ld: "ltr",
  alt: ["Pali", "Palodi", "Palya Bareli"],
  cc: ["IN"]
}, {
  pk: 873,
  ang: "Bishnupriya",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bishnupriya",
  lc: "bpy",
  ld: "ltr",
  alt: ["Bishnupuriya", "Bisna Puriya", "Bishnupria Manipuri", "Rajar Gang", "Rajar Gang (Ningthaunai)", "Madai Gang (Leimanai)", "Madai Gang"],
  cc: ["BD", "IN"]
}, {
  pk: 874,
  ang: "Bilba",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bilba",
  lc: "bpz",
  ld: "ltr",
  alt: ["Belubaa", "Bilbaa", "Eastern Rote", "Rote", "Rote Timur", "Roti", "Rotinese", "Lelenuk", "Diu"],
  cc: ["ID"]
}, {
  pk: 875,
  ang: "Tchumbuli",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Tchumbuli",
  lc: "bqa",
  ld: "ltr",
  alt: ["Basa", "Chombulon", "Tchombolo", "Tshummbuli", "Cobecha"],
  cc: ["BJ"]
}, {
  pk: 876,
  ang: "Bagusa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bagusa",
  lc: "bqb",
  ld: "ltr",
  alt: ["Kapeso", "Suaseso"],
  cc: ["ID"]
}, {
  pk: 877,
  ang: "Boko",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Boko (Benin)",
  lc: "bqc",
  ld: "ltr",
  alt: ["Boo", "Bokonya", "Bo'o"],
  cc: ["BJ", "NG"]
}, {
  pk: 878,
  ang: "Bung",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bung",
  lc: "bqd",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 879,
  ang: "Bago-Kusuntu",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Bago-Kusuntu",
  lc: "bqg",
  ld: "ltr",
  alt: ["Koussountou", "Kusuntu"],
  cc: ["TG"]
}, {
  pk: 880,
  ang: "Baima",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u767D\u9A6C\u8BED",
  lc: "bqh",
  ld: "ltr",
  alt: ["Bai Ma", "Pe", "Southern Baima (Pingwu Baima)", "Western Baima (Jiuzhaigou Baima)", "Northern Baima (Wenxian Baima)", "Songpan Baima"],
  cc: ["CN"]
}, {
  pk: 881,
  ang: "Bakhti\xE2ri",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u0628\u062E\u062A\u06CC\u0627\u0631\u06CC",
  lc: "bqi",
  ld: "rtl",
  alt: ["Lori", "Lori-ye Khaveri", "Aligudarz", "Chelgerd/Kuhrang", "Haftgel", "Ize", "Masjed-e Soleiman", "Shahr-e Kord"],
  cc: ["IR"]
}, {
  pk: 882,
  ang: "Bandial",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Bandial",
  lc: "bqj",
  ld: "ltr",
  alt: ["Banjaal", "Eegima", "Eegimaa", "Elun (Hulon)", "Kujireray", "Kuluunaay"],
  cc: ["SN"]
}, {
  pk: 883,
  ang: "Banda-Mbr\xE8s",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Banda-Mbr\xE8s",
  lc: "bqk",
  ld: "ltr",
  alt: ["Banda of Mbr\xE8s", "Banda-Mbre", "Morouba", "Sabanga (Sangbanga)", "Moruba (Maraba)", "Mbere", "Buka (Bouka)", "Wada (Ouadda)", "Mbre (Mbele)"],
  cc: ["CF", "SS"]
}, {
  pk: 884,
  ang: "Bilakura",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bilakura",
  lc: "bql",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 885,
  ang: "Wumboko",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Wumboko",
  lc: "bqm",
  ld: "ltr",
  alt: ["Bamboko", "Bambuku", "Bomboko", "Bumboko", "Mboko", "Womboko"],
  cc: ["CM"]
}, {
  pk: 886,
  ang: "Bulgarian Sign Language",
  lr: "Europe",
  gw: false,
  hc: "BG",
  ln: "Bulgarian Sign Language",
  lc: "bqn",
  ld: "ltr",
  alt: [],
  cc: ["BG"]
}, {
  pk: 887,
  ang: "Balo",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Balo",
  lc: "bqo",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 888,
  ang: "Busa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Busa",
  lc: "bqp",
  ld: "ltr",
  alt: ["Bis\xE3", "Bisay\xE3", "Busa-Bis\xE3", "Busano", "Bussanchi"],
  cc: ["NG"]
}, {
  pk: 889,
  ang: "Biritai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Biritai",
  lc: "bqq",
  ld: "ltr",
  alt: ["Aliki", "Ati", "Biri"],
  cc: ["ID"]
}, {
  pk: 890,
  ang: "Burusu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Burusu",
  lc: "bqr",
  ld: "ltr",
  alt: ["Bulusu"],
  cc: ["ID"]
}, {
  pk: 891,
  ang: "Bosmun",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bosngun",
  lc: "bqs",
  ld: "ltr",
  alt: ["Bosngun"],
  cc: ["PG"]
}, {
  pk: 892,
  ang: "Bamukumbit",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bamukumbit",
  lc: "bqt",
  ld: "ltr",
  alt: ["Bamenkombit", "Bamenkoumbit", "Bamoukoumbit", "Bamunkum", "Bamunkumbit", "Mangkong", "Mankong"],
  cc: ["CM"]
}, {
  pk: 893,
  ang: "Boguru",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Boguru",
  lc: "bqu",
  ld: "ltr",
  alt: ["Buguru", "Kogoro", "Bukur (Bukum)", "Bukuru"],
  cc: ["CD"]
}, {
  pk: 894,
  ang: "Koro Wachi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Koro Wachi",
  lc: "bqv",
  ld: "ltr",
  alt: ["Agere", "Koro Agwe", "Koro Makama", "Koro Myamya", "Miamia", "Miamiya", "Koro Miamia", "Koro Waci (Koro Ache)"],
  cc: ["NG"]
}, {
  pk: 895,
  ang: "Buru",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Buru (Nigeria)",
  lc: "bqw",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 896,
  ang: "Baangi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Baangi",
  lc: "bqx",
  ld: "ltr",
  alt: ["Cibaangi"],
  cc: ["NG"]
}, {
  pk: 897,
  ang: "Bengkala Sign Language",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bengkala Sign Language",
  lc: "bqy",
  ld: "ltr",
  alt: ["Benkala Sign Language", "Kata Kolok"],
  cc: ["ID"]
}, {
  pk: 898,
  ang: "Bakaka",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bakaka",
  lc: "bqz",
  ld: "ltr",
  alt: ["Central Mbo", "Miamilo", "Pendia", "Mwahed", "Manehas (Mvae)", "Kaka", "Kaa", "Baneka (Mwaneka)", "Balondo (Ehobe Belon)", "Bakaka (Ehob Mkaa)", "Bafun (Mbwase Nghuy)", "Babong (Ihobe Mbog)", "Mwahet", "Ihobe Mboong"],
  cc: ["CM"]
}, {
  pk: 899,
  ang: "Breton",
  lr: "Europe",
  gw: false,
  hc: "FR",
  ln: "brezhoneg",
  lc: "br",
  ld: "ltr",
  alt: ["Brezhoneg", "Gwenedeg (Vannetais)", "Kerneveg (Cornouaillais)", "Leoneg (Leonais)", "Tregerieg (Tregorrois)"],
  cc: ["FR"]
}, {
  pk: 900,
  ang: "Braj Bhasha",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Braj",
  lc: "bra",
  ld: "ltr",
  alt: ["Antarvedi", "Bijbhasha", "Braj Bhakha", "Bri", "Brij Bhasha", "Briju", "Bruj"],
  cc: ["IN"]
}, {
  pk: 901,
  ang: "Lave",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Ti\u1EBFng Br\xE2u",
  lc: "brb",
  ld: "ltr",
  alt: ["Braou", "Brou", "Proue", "Brao", "Brau", "Rawe", "Lun", "Ombaa", "Ka-nying", "Jrii", "Hamong"],
  cc: ["LA", "US", "KH"]
}, {
  pk: 902,
  ang: "Baram",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Baraamu",
  lc: "brd",
  ld: "ltr",
  alt: ["Baramu", "Mailung", "Dandagaun"],
  cc: ["NP"]
}, {
  pk: 903,
  ang: "Bera",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bera",
  lc: "brf",
  ld: "ltr",
  alt: ["Plains Bira"],
  cc: ["CD"]
}, {
  pk: 904,
  ang: "Baure",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Baure",
  lc: "brg",
  ld: "ltr",
  alt: [],
  cc: ["BO"]
}, {
  pk: 905,
  ang: "Brahui",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u0628\u0631\u0627\u06C1\u0648\u0626\u064A",
  lc: "brh",
  ld: "ltr",
  alt: ["Birahui", "Biravi", "Brahuiki", "Kur Galli", "Kurd Gali", "Barahui", "Brahudi", "Brahuidi", "Brahuigi", "Jharawan (Jhalawan)"],
  cc: ["AF", "IR", "PK", "TM"]
}, {
  pk: 906,
  ang: "Mokpwe",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mokpwe",
  lc: "bri",
  ld: "ltr",
  alt: ["Bakpwe", "Bakwedi", "Bakwele", "Bakweri", "Bekwiri", "Kwedi", "Kweli", "Kwili", "Kwiri", "Mokpe", "Ujuwa", "Vakweli", "Vambeng"],
  cc: ["CM"]
}, {
  pk: 7793,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bakweri",
  lc: "bri-x-bakweri",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 907,
  ang: "Bieria",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Bieria",
  lc: "brj",
  ld: "ltr",
  alt: ["Bieri", "Wowo", "Vovo (Wowo)"],
  cc: ["VU"]
}, {
  pk: 908,
  ang: "Birwa",
  lr: "Africa",
  gw: false,
  hc: "BW",
  ln: "Birwa",
  lc: "brl",
  ld: "ltr",
  alt: [],
  cc: ["ZW", "BW"]
}, {
  pk: 909,
  ang: "Barambu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Barambu",
  lc: "brm",
  ld: "ltr",
  alt: ["Abarambo", "Amiangba", "Amiangbwa", "Balambu", "Barambo", "Duga"],
  cc: ["CD"]
}, {
  pk: 910,
  ang: "Boruca",
  lr: "Americas",
  gw: false,
  hc: "CR",
  ln: "Boruca",
  lc: "brn",
  ld: "ltr",
  alt: ["Borunca", "Brunca", "Brunka", "Burunca"],
  cc: ["CR"]
}, {
  pk: 911,
  ang: "Brokkat",
  lr: "Asia",
  gw: false,
  hc: "BT",
  ln: "Brokkat",
  lc: "bro",
  ld: "ltr",
  alt: ["Brokskad", "Jokay"],
  cc: ["BT"]
}, {
  pk: 912,
  ang: "Barapasi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Barapasi",
  lc: "brp",
  ld: "ltr",
  alt: ["Baropasi"],
  cc: ["ID"]
}, {
  pk: 913,
  ang: "Breri",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Breri",
  lc: "brq",
  ld: "ltr",
  alt: ["Kuanga"],
  cc: ["PG"]
}, {
  pk: 914,
  ang: "Birao",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Birao",
  lc: "brr",
  ld: "ltr",
  alt: ["Mbirao"],
  cc: ["SB"]
}, {
  pk: 915,
  ang: "Baras",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Baras",
  lc: "brs",
  ld: "ltr",
  alt: ["Ende"],
  cc: ["ID"]
}, {
  pk: 916,
  ang: "Bitare",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bitare",
  lc: "brt",
  ld: "ltr",
  alt: ["Yukutare"],
  cc: ["NG"]
}, {
  pk: 917,
  ang: "Bru, Eastern",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Eastern Bru",
  lc: "bru",
  ld: "ltr",
  alt: ["Bru Tri", "Brou", "Quang Tri Bru", "Van Kieu", "Leun (Kaleu)", "Tri (Chali)", "So Trii", "So Tri", "Leung"],
  cc: ["LA"]
}, {
  pk: 918,
  ang: "Bru, Western",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Western Bru",
  lc: "brv",
  ld: "ltr",
  alt: ["Baru", "B'ru", "Bruu"],
  cc: ["TH"]
}, {
  pk: 919,
  ang: "Bellari",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bellari",
  lc: "brw",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 920,
  ang: "Bodo",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bodo (India)",
  lc: "brx",
  ld: "ltr",
  alt: ["Bara", "Bodi", "Boro", "Boroni", "Kachari", "Mech", "Mechi", "Meci", "Mache"],
  cc: ["NP", "IN"]
}, {
  pk: 921,
  ang: "Burui",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Burui",
  lc: "bry",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 922,
  ang: "Bilbil",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bilbil",
  lc: "brz",
  ld: "ltr",
  alt: ["Bilibil"],
  cc: ["PG"]
}, {
  pk: 923,
  ang: "Bosnian",
  lr: "Europe",
  gw: false,
  hc: "BA",
  ln: "bosanski jezik",
  lc: "bs",
  ld: "ltr",
  alt: ["Ijekav\xEDan", "Ikavian"],
  cc: ["BA", "DE", "ME", "GB", "MK", "US", "CA", "IT", "IE"]
}, {
  pk: 924,
  ang: "Abinomn",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Abinomn",
  lc: "bsa",
  ld: "ltr",
  alt: ["Avinomen", "Foja", "Foya", "Baso"],
  cc: ["ID"]
}, {
  pk: 925,
  ang: "Bisaya, Brunei",
  lr: "Asia",
  gw: false,
  hc: "BN",
  ln: "Brunei Bisaya",
  lc: "bsb",
  ld: "ltr",
  alt: ["Basaya", "Bekiau", "Besaya", "Bisaia", "Bisaya Bukit", "Bisayah", "Dusun", "Jilama Bawang", "Jilama Sungai", "Lorang Bukit", "Southern Bisaya", "Visayak", "Brunei Bisaya", "Sarawak Bisaya", "Sarawak Bisaya (Bisaya')"],
  cc: ["BN", "MY"]
}, {
  pk: 926,
  ang: "Oniyan",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Bassari",
  lc: "bsc",
  ld: "ltr",
  alt: ["Ayan", "Basari", "Biyan", "Oneyan", "Onian", "Tenda Basari", "Wo", "On\xEByan", "K\xEBd", "Oxalac", "Ane", "Southern Bassari"],
  cc: ["GM", "SN", "GN", "GW"]
}, {
  pk: 927,
  ang: "Wushi",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Wushi",
  lc: "bse",
  ld: "ltr",
  alt: ["Babessi", "Cho' Wushike", "Pesii", "Sii", "Vesi"],
  cc: ["CM"]
}, {
  pk: 928,
  ang: "Bauchi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bauchi",
  lc: "bsf",
  ld: "ltr",
  alt: ["Bauci", "Baushi", "Kushi", "Madaka (Adeka)"],
  cc: ["NG"]
}, {
  pk: 929,
  ang: "Bashkardi",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u0632\u0628\u0627\u0646 \u0628\u0634\u0627\u06AF\u0631\u062F\u06CC",
  lc: "bsg",
  ld: "ltr",
  alt: ["Bashaka", "Northern Bashaka", "Southern Bashaka"],
  cc: ["IR"]
}, {
  pk: 930,
  ang: "Kati",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Kati",
  lc: "bsh",
  ld: "ltr",
  alt: ["Bashgali", "Kativiri", "Nuristani", "Western Kativiri (Jadidi)", "Eastern Kativiri (Shekhani)", "Ramgulviri", "Western Kativiri"],
  cc: ["AF", "PK"]
}, {
  pk: 931,
  ang: "Bassossi",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bassossi",
  lc: "bsi",
  ld: "ltr",
  alt: ["Asobse", "Basosi", "Basossi", "Ngen", "Nsose", "Nswase", "Nswose", "Sosi", "Swose", "Mienge (Lower Mbo)"],
  cc: ["CM"]
}, {
  pk: 932,
  ang: "Bangwinji",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bangwinji",
  lc: "bsj",
  ld: "ltr",
  alt: ["Bangjinge", "Bangunji"],
  cc: ["NG"]
}, {
  pk: 933,
  ang: "Burushaski",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u0628\u0631\u0648\u0634\u0633\u06A9\u06CC \u0632\u0628\u0627\u0646",
  lc: "bsk",
  ld: "ltr",
  alt: ["Biltum", "Burucaki", "Burucaski", "Burushaki", "Burushki", "Khajuna", "Kunjut", "Nagar (Nagir)", "Yasin (Werchikwar)"],
  cc: ["PK"]
}, {
  pk: 934,
  ang: "Busami",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Busami",
  lc: "bsm",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 935,
  ang: "Barasana-Eduria",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Barasana-Eduria",
  lc: "bsn",
  ld: "ltr",
  alt: ["Banera yae", "Barasano", "Come masa", "Edulia", "Eduria", "Hanera oka", "Paneroa", "Southern Barasano", "Taibano", "Taiwaeno", "Yebamasa", "Barasana (Comematsa)", "Eduria (Edulia)"],
  cc: ["CO"]
}, {
  pk: 936,
  ang: "Buso",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Buso",
  lc: "bso",
  ld: "ltr",
  alt: ["Bousso", "Busso", "Dam de Bousso"],
  cc: ["TD"]
}, {
  pk: 937,
  ang: "Baga Sitemu",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Baga Sitemu",
  lc: "bsp",
  ld: "ltr",
  alt: ["Baka", "Rio Pongo Baga", "Sitemu\xFA", "Stem Baga", "Tchitem"],
  cc: ["GN"]
}, {
  pk: 938,
  ang: "Bassa",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Bassa",
  lc: "bsq",
  ld: "ltr",
  alt: ["Hwen Gba Kon"],
  cc: ["LR", "SL"]
}, {
  pk: 939,
  ang: "Bassa-Kontagora",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bassa-Kontagora",
  lc: "bsr",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 940,
  ang: "Akoose",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Akoose",
  lc: "bss",
  ld: "ltr",
  alt: ["Akosi", "Bekoose", "Koose", "Kosi", "Nkoosi", "Nkosi", "Elung (Along)", "Mwamenam (Mouamenam)", "Nlong", "Elong"],
  cc: ["CM"]
}, {
  pk: 941,
  ang: "Basketo",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Basketo",
  lc: "bst",
  ld: "ltr",
  alt: ["Baskatta", "Mesketo"],
  cc: ["ET"]
}, {
  pk: 942,
  ang: "Bahonsuai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bahonsuai",
  lc: "bsu",
  ld: "ltr",
  alt: ["Bahoe-soeaai", "Bahonsoewaai"],
  cc: ["ID"]
}, {
  pk: 943,
  ang: "Baiso",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Baiso",
  lc: "bsw",
  ld: "ltr",
  alt: ["Alkali", "Bayso"],
  cc: ["ET"]
}, {
  pk: 944,
  ang: "Yangkam",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Yangkam",
  lc: "bsx",
  ld: "ltr",
  alt: ["Bashar", "Basharawa", "Bashiri", "Yankam"],
  cc: ["NG"]
}, {
  pk: 945,
  ang: "Bisaya, Sabah",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Sabah Bisaya",
  lc: "bsy",
  ld: "ltr",
  alt: ["Basaya", "Besaya", "Bisaia", "Bisayah", "Jilama Bawang", "Jilama Sungai"],
  cc: ["MY"]
}, {
  pk: 946,
  ang: "Bata",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bata",
  lc: "bta",
  ld: "ltr",
  alt: ["Dii", "Gbwata", "Gwate", "Bete", "Birsa", "Bwatiye", "Demsa Bata", "Dunu", "Eastern Bwatiye", "Gboati", "Gbwate", "Song Bata", "Ribaw (Ribow)", "Zumu (Jimo)", "Zomo", "Njoboliyo", "Furo", "Ndeewe (Bata-Ndeewe)", "Garoua (Garua)", "Wadi (Wa'i)"],
  cc: ["CM", "NG"]
}, {
  pk: 947,
  ang: "Bati",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bati (Cameroon)",
  lc: "btc",
  ld: "ltr",
  alt: ["Bati Ba Ngong"],
  cc: ["CM"]
}, {
  pk: 948,
  ang: "Batak Dairi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Batak Dairi",
  lc: "btd",
  ld: "ltr",
  alt: ["Dairi", "Pakpak Dairi"],
  cc: ["ID"]
}, {
  pk: 7709,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Boang",
  lc: "btd-x-boang",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8121,
  ang: "Kelasan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kelasan",
  lc: "btd-x-pakpak",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 949,
  ang: "Gamo-Ningi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Gamo-Ningi",
  lc: "bte",
  ld: "ltr",
  alt: ["Mbotu", "Mbuta", "Gamo (Ba-Buche)", "Buta", "Ba-Mbutu"],
  cc: ["NG"]
}, {
  pk: 950,
  ang: "Birgit",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Birgit",
  lc: "btf",
  ld: "ltr",
  alt: ["Bergit", "Berguid", "Birgid"],
  cc: ["TD"]
}, {
  pk: 951,
  ang: "B\xE9t\xE9, Gagnoa",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Gagnoa B\xE9t\xE9",
  lc: "btg",
  ld: "ltr",
  alt: ["Eastern B\xE9t\xE9", "Gagnoua-B\xE9t\xE9", "Shyen", "Gbadie", "Gbadi (Badie)"],
  cc: ["CI"]
}, {
  pk: 952,
  ang: "Bidayuh, Biatah",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Biatah Bidayuh",
  lc: "bth",
  ld: "ltr",
  alt: ["Bideyu", "Landu", "Lundu", "Pueh", "Bikuab", "Kuap", "Quop", "Sentah", "Sitaang", "Stang (Bisitaang)"],
  cc: ["ID", "MY"]
}, {
  pk: 8067,
  ang: "Dayak Bidayuh Punten",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Bidayuh Punten",
  lc: "bth-x-bidayuhpunten",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 953,
  ang: "Burate",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Burate",
  lc: "bti",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 954,
  ang: "Malay, Bacanese",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bacanese Malay",
  lc: "btj",
  ld: "ltr",
  alt: ["Bacan", "Batjan"],
  cc: ["ID"]
}, {
  pk: 955,
  ang: "Bhatola",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bhatola",
  lc: "btl",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 956,
  ang: "Batak Mandailing",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Batak Mandailing",
  lc: "btm",
  ld: "ltr",
  alt: ["Batta", "Mandailing Batak"],
  cc: ["ID"]
}, {
  pk: 957,
  ang: "Ratagnon",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Ratagnon",
  lc: "btn",
  ld: "ltr",
  alt: ["Aradigi", "Datagnon", "Lactan", "Latagnun", "Latan"],
  cc: ["PH"]
}, {
  pk: 958,
  ang: "Bikol, Rinconada",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Rinconada Bikol",
  lc: "bto",
  ld: "ltr",
  alt: ["Rinconada Bicolano", "Rinconada Bikol", "Bicolano", "Iriga"],
  cc: ["PH"]
}, {
  pk: 959,
  ang: "Budibud",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Budibud",
  lc: "btp",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 960,
  ang: "Batek",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Batek",
  lc: "btq",
  ld: "ltr",
  alt: ["Bateg", "Bateq", "Batok", "Kleb", "Nong", "Tomo", "Batek De' (Deq)", "Batek Nong (Nong)", "Batek Teq (Teq)"],
  cc: ["MY"]
}, {
  pk: 961,
  ang: "Baetora",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Baetora",
  lc: "btr",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 962,
  ang: "Batak Simalungun",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Batak Simalungun",
  lc: "bts",
  ld: "ltr",
  alt: ["Simelungan", "Timur"],
  cc: ["ID"]
}, {
  pk: 8448,
  ang: "Timur Riangkamie",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Timur Riangkamie",
  lc: "bts-x-riangkamie",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 963,
  ang: "Bete-Bendi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bete-Bendi",
  lc: "btt",
  ld: "ltr",
  alt: ["Bette-Bendi", "Dama", "Bete (Bette)", "Mbete"],
  cc: ["NG"]
}, {
  pk: 964,
  ang: "Batu",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Batu",
  lc: "btu",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 965,
  ang: "Bateri",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u0628\u0679\u06CC\u0631\u06CC",
  lc: "btv",
  ld: "ltr",
  alt: ["Batera Kohistani", "Baterawal", "Baterawal Kohistani", "Bateri Kohistani"],
  cc: ["PK"]
}, {
  pk: 966,
  ang: "Butuanon",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Butuanon",
  lc: "btw",
  ld: "ltr",
  alt: [],
  cc: ["PH"]
}, {
  pk: 967,
  ang: "Batak Karo",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Batak Karo",
  lc: "btx",
  ld: "ltr",
  alt: ["Karo Batak"],
  cc: ["ID"]
}, {
  pk: 968,
  ang: "Bobot",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bobot",
  lc: "bty",
  ld: "ltr",
  alt: ["Ahtiago", "Atiahu", "Hatumeten", "Ntau", "Werinama"],
  cc: ["ID"]
}, {
  pk: 969,
  ang: "Batak Alas-Kluet",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Alas",
  lc: "btz",
  ld: "ltr",
  alt: ["Alas-Kluet Batak", "Singkil (Kade-Kade)", "Kluet"],
  cc: ["ID"]
}, {
  pk: 970,
  ang: "Buriat",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0411\u0443\u0440\u044F\u0442\u0441\u043A\u0438\u0439",
  lc: "bua",
  ld: "ltr",
  alt: [],
  cc: ["RU"]
}, {
  pk: 971,
  ang: "Bua",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Bua",
  lc: "bub",
  ld: "ltr",
  alt: ["Ba", "Boa", "Bwa"],
  cc: ["TD"]
}, {
  pk: 972,
  ang: "Bushi",
  lr: "Africa",
  gw: false,
  hc: "YT",
  ln: "Bushi",
  lc: "buc",
  ld: "ltr",
  alt: ["Antalaotra", "Kibuki", "Kibushi", "Sakalava", "Shibushi", "Shibushi Shimaore"],
  cc: ["KM", "MG", "YT"]
}, {
  pk: 973,
  ang: "Ntcham",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Ntcham",
  lc: "bud",
  ld: "ltr",
  alt: ["Basar", "Basare", "Basari", "Bassar", "Bassari", "Ncham", "Tobote", "Dipiitil"],
  cc: ["GH", "TG"]
}, {
  pk: 974,
  ang: "Beothuk",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Beothuk",
  lc: "bue",
  ld: "ltr",
  alt: [],
  cc: ["CA"]
}, {
  pk: 975,
  ang: "Bushoong",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bushoong",
  lc: "buf",
  ld: "ltr",
  alt: ["Bamongo", "Bushong", "Busoong", "Ganga", "Kuba", "Mbale", "Mongo", "Shongo", "Shobwa", "Tsobwa", "Ngende", "Ngombe (Ngombia)", "Pianga (Panga)", "Shoba"],
  cc: ["CD"]
}, {
  pk: 976,
  ang: "Bugis",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Buginese",
  lc: "bug",
  ld: "ltr",
  alt: ["Boegineesche", "Boeginezen", "Bugi", "Buginese", "De'", "Rappang Buginese", "Ugi", "Sawitto (Pinrang)", "Sidenrang", "Sidrap (Alitta)", "Sin", "Soppeng Riaja", "Tanete", "Wara", "Pinrang Utara", "Tompo", "Pare-Pare", "Pangkep (Pangkajene)", "Palakka", "Mare", "Malangke-Ussu", "Luwu (Bua Ponrang)", "Luwu'", "Barru (Nepo)", "Bone (Dua Boccoe)", "Pasangkayu (Ugi Riawa)"],
  cc: ["ID", "MY", "SG"]
}, {
  pk: 8447,
  ang: "Bugissinja",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bugis Sinjai",
  lc: "bug-x-bugissinja",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 977,
  ang: "Bunu, Younuo",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4F18\u8BFA\u8BED",
  lc: "buh",
  ld: "ltr",
  alt: ["Pu No", "Punu", "Younuo", "Yuno", "Yunuo"],
  cc: ["CN"]
}, {
  pk: 978,
  ang: "Bongili",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Bongili",
  lc: "bui",
  ld: "ltr",
  alt: ["Bongiri", "Bungili", "Bungiri"],
  cc: ["CG"]
}, {
  pk: 979,
  ang: "Basa-Gurmana",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Basa-Gurmana",
  lc: "buj",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 980,
  ang: "Bugawac",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bugawac",
  lc: "buk",
  ld: "ltr",
  alt: ["Bukaua", "Bukawac", "Kawa", "Kawac", "Yom Gawac", "Central-Western Bugawac", "Western Bugawac", "Eastern Bugawac", "Central-Eastern Bugawac", "Central Bugawac", "South-Western Bugawac"],
  cc: ["PG"]
}, {
  pk: 981,
  ang: "Bulu",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bulu (Cameroon)",
  lc: "bum",
  ld: "ltr",
  alt: ["Boulou"],
  cc: ["CM"]
}, {
  pk: 982,
  ang: "Sherbro",
  lr: "Africa",
  gw: false,
  hc: "SL",
  ln: "Sherbro",
  lc: "bun",
  ld: "ltr",
  alt: ["Amampa", "Mampa", "Mampwa", "Shiba", "Southern Bullom", "Shenge Sherbro"],
  cc: ["SL"]
}, {
  pk: 983,
  ang: "Terei",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Terei",
  lc: "buo",
  ld: "ltr",
  alt: ["Kugara", "Telei"],
  cc: ["PG"]
}, {
  pk: 984,
  ang: "Busoa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Busoa",
  lc: "bup",
  ld: "ltr",
  alt: ["Bosoa"],
  cc: ["ID"]
}, {
  pk: 985,
  ang: "Brem",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Brem",
  lc: "buq",
  ld: "ltr",
  alt: ["Barem", "Bububun", "Bunabun", "Bunubun"],
  cc: ["PG"]
}, {
  pk: 986,
  ang: "Bokobaru",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bokobaru",
  lc: "bus",
  ld: "ltr",
  alt: ["Busa-Bokobaru", "Bussawa"],
  cc: ["NG"]
}, {
  pk: 987,
  ang: "Bungain",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bungain",
  lc: "but",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 988,
  ang: "Budu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Budu",
  lc: "buu",
  ld: "ltr",
  alt: ["Bodo", "Ebudu", "Ineta (Timoniko)", "Wadimbisa (Isombi)", "West Bafwangada (Bafanio)"],
  cc: ["CD"]
}, {
  pk: 989,
  ang: "Bun",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bun",
  lc: "buv",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 990,
  ang: "Bubi",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Bubi",
  lc: "buw",
  ld: "ltr",
  alt: ["Bhubhi", "Eviia", "Ibhubhi", "Ibubi", "Pove"],
  cc: ["GA"]
}, {
  pk: 991,
  ang: "Boghom",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Boghom",
  lc: "bux",
  ld: "ltr",
  alt: ["Bogghom", "Boghorom", "Bohom", "Bokiyim", "Borrom", "Burma", "Burom", "Burum"],
  cc: ["NG"]
}, {
  pk: 992,
  ang: "Bullom So",
  lr: "Africa",
  gw: false,
  hc: "SL",
  ln: "Bullom So",
  lc: "buy",
  ld: "ltr",
  alt: ["Bolom", "Bulem", "Bullin", "Bullun", "Mandenyi", "Mandingi", "Northern Bullom"],
  cc: ["SL"]
}, {
  pk: 993,
  ang: "Bukwen",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bukwen",
  lc: "buz",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 994,
  ang: "Barein",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Barein",
  lc: "bva",
  ld: "ltr",
  alt: ["Bara\xEFn", "Jelkin", "Sakaya (Dagne)"],
  cc: ["TD"]
}, {
  pk: 995,
  ang: "Bube",
  lr: "Africa",
  gw: false,
  hc: "GQ",
  ln: "Bube",
  lc: "bvb",
  ld: "ltr",
  alt: ["Adeeyah", "Adija", "Bobe", "Boobe", "Boombe", "Bubi", "Ediya", "Fernandian"],
  cc: ["GQ"]
}, {
  pk: 996,
  ang: "Baelelea",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Baelelea",
  lc: "bvc",
  ld: "ltr",
  alt: ["Mbaelelea"],
  cc: ["SB"]
}, {
  pk: 997,
  ang: "Baeggu",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Baeggu",
  lc: "bvd",
  ld: "ltr",
  alt: ["Mbaenggu"],
  cc: ["SB"]
}, {
  pk: 998,
  ang: "Malay, Berau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Berau Malay",
  lc: "bve",
  ld: "ltr",
  alt: ["Berau", "Merau Malay"],
  cc: ["ID"]
}, {
  pk: 999,
  ang: "Boor",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Boor",
  lc: "bvf",
  ld: "ltr",
  alt: ["Bwara", "Damraw"],
  cc: ["TD"]
}, {
  pk: 1000,
  ang: "Bonkeng",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bonkeng",
  lc: "bvg",
  ld: "ltr",
  alt: ["Bongken", "Bonkenge", "Bonkeng-Pendia"],
  cc: ["CM"]
}, {
  pk: 1001,
  ang: "Bure",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bure",
  lc: "bvh",
  ld: "ltr",
  alt: ["Bubure"],
  cc: ["NG"]
}, {
  pk: 1002,
  ang: "Belanda Viri",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Belanda Viri",
  lc: "bvi",
  ld: "ltr",
  alt: ["Belanda", "Biri", "Bviri", "Gamba", "Gumba", "Mbegumba", "Mvegumba", "Viri"],
  cc: ["SS"]
}, {
  pk: 1003,
  ang: "Baan",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Baan",
  lc: "bvj",
  ld: "ltr",
  alt: ["Baan-Ogoi", "Goi", "Ogoi"],
  cc: ["NG"]
}, {
  pk: 1004,
  ang: "Bukat",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bukat",
  lc: "bvk",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 1005,
  ang: "Bolivian Sign Language",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Bolivian Sign Language",
  lc: "bvl",
  ld: "ltr",
  alt: [],
  cc: ["BO"]
}, {
  pk: 1006,
  ang: "Bamunka",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bamunka",
  lc: "bvm",
  ld: "ltr",
  alt: ["Bamunkun", "Mbika", "Muka", "Ndop-Bamunka", "Ngiemekohke"],
  cc: ["CM"]
}, {
  pk: 1007,
  ang: "Buna",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Buna",
  lc: "bvn",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 1008,
  ang: "Bolgo",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Bolgo",
  lc: "bvo",
  ld: "ltr",
  alt: ["Bolgo Dugag (Small Bolgo)", "Bolgo Kubar (Big Bolgo)"],
  cc: ["TD"]
}, {
  pk: 1009,
  ang: "Bumang",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5E03\u8292\u8BED",
  lc: "bvp",
  ld: "ltr",
  alt: ["Manzhang Dai"],
  cc: ["CN"]
}, {
  pk: 1010,
  ang: "Birri",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Birri",
  lc: "bvq",
  ld: "ltr",
  alt: ["Biri", "Bviri", "Viri"],
  cc: ["CF"]
}, {
  pk: 1011,
  ang: "Burarra",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Burarra",
  lc: "bvr",
  ld: "ltr",
  alt: ["Anbarra", "Barera", "Bawera", "Burada", "Bureda", "Burera", "Gidjingaliya Gujingalia", "Gujalabiya", "Gun-Guragone", "Jikai", "Tchikai"],
  cc: ["AU"]
}, {
  pk: 1012,
  ang: "Bati",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bati (Indonesia)",
  lc: "bvt",
  ld: "ltr",
  alt: ["Gah"],
  cc: ["ID"]
}, {
  pk: 1013,
  ang: "Malay, Bukit",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bukit Malay",
  lc: "bvu",
  ld: "ltr",
  alt: ["Bukat", "Bukit", "Meratus"],
  cc: ["ID"]
}, {
  pk: 1014,
  ang: "Boga",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Boga",
  lc: "bvw",
  ld: "ltr",
  alt: ["Boka"],
  cc: ["NG"]
}, {
  pk: 1015,
  ang: "Dibole",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Dibole",
  lc: "bvx",
  ld: "ltr",
  alt: ["Babole", "Southern Bomitaba", "Central Dibole (Kinami)", "Northern Dibole (Dzeke)", "Southern Dibole (Bouanila)"],
  cc: ["CG"]
}, {
  pk: 1016,
  ang: "Baybayanon",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Baybayanon",
  lc: "bvy",
  ld: "ltr",
  alt: ["Leyte", "Utudnon"],
  cc: ["PH"]
}, {
  pk: 1017,
  ang: "Bauzi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bauzi",
  lc: "bvz",
  ld: "ltr",
  alt: ["Baudi", "Baudji", "Baudzi", "Bauri"],
  cc: ["ID"]
}, {
  pk: 1018,
  ang: "Bwatoo",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Bwatoo",
  lc: "bwa",
  ld: "ltr",
  alt: [],
  cc: ["NC"]
}, {
  pk: 1019,
  ang: "Namosi-Naitasiri-Serua",
  lr: "Pacific",
  gw: false,
  hc: "FJ",
  ln: "Namosi-Naitasiri-Serua",
  lc: "bwb",
  ld: "ltr",
  alt: ["Namosi-Naitaasiri-Seerua"],
  cc: ["FJ"]
}, {
  pk: 1020,
  ang: "Bwile",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Bwile",
  lc: "bwc",
  ld: "ltr",
  alt: [],
  cc: ["ZM"]
}, {
  pk: 1021,
  ang: "Bwaidoka",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bwaidoka",
  lc: "bwd",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 1022,
  ang: "Karen, Bwe",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Bwe Karen",
  lc: "bwe",
  ld: "ltr",
  alt: ["Baghi", "Bghai Karen", "Blimaw", "Bwe", "Dareh", "Manaw", "Eastern Bwe Karen", "Western Bwe Karen"],
  cc: ["TH", "MM"]
}, {
  pk: 1023,
  ang: "Boselewa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Boselewa",
  lc: "bwf",
  ld: "ltr",
  alt: ["Bosilewa", "Mwani'u"],
  cc: ["PG"]
}, {
  pk: 1024,
  ang: "Barwe",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Barwe",
  lc: "bwg",
  ld: "ltr",
  alt: ["Balke", "Cibalke"],
  cc: ["MZ"]
}, {
  pk: 1025,
  ang: "Baniwa",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Baniwa",
  lc: "bwi",
  ld: "ltr",
  alt: ["Baniba", "Baniua do I\xE7ana", "Baniva", "Dakenei", "Issana", "Kohoroxitari", "Maniba"],
  cc: ["BR", "VE"]
}, {
  pk: 1026,
  ang: "Bwamu, L\xE1\xE1 L\xE1\xE1",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "L\xE1\xE1 L\xE1\xE1 Bwamu",
  lc: "bwj",
  ld: "ltr",
  alt: ["K\xE0denb\xE0", "Yere"],
  cc: ["BF"]
}, {
  pk: 1027,
  ang: "Bauwaki",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bauwaki",
  lc: "bwk",
  ld: "ltr",
  alt: ["Bawaki"],
  cc: ["PG"]
}, {
  pk: 1028,
  ang: "Bwela",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bwela",
  lc: "bwl",
  ld: "ltr",
  alt: ["Buela", "Lingi"],
  cc: ["CD"]
}, {
  pk: 1029,
  ang: "Biwat",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Biwat",
  lc: "bwm",
  ld: "ltr",
  alt: ["Munduguma", "Mundugumor"],
  cc: ["PG"]
}, {
  pk: 1030,
  ang: "Bunu, Wunai",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5514\u5948",
  lc: "bwn",
  ld: "ltr",
  alt: ["Hm Nai", "Ngnai", "Punu", "Wunai"],
  cc: ["CN"]
}, {
  pk: 1031,
  ang: "Borna",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Boro (Ethiopia)",
  lc: "bwo",
  ld: "ltr",
  alt: ["Boro", "Bworo", "Scinacia", "Bulen-Dibat'e", "Wenbera-Dangur"],
  cc: ["ET"]
}, {
  pk: 1032,
  ang: "Mandobo Bawah",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mandobo Bawah",
  lc: "bwp",
  ld: "ltr",
  alt: ["Dumut", "Kambon", "Mandobbo", "Nub", "Kaeti"],
  cc: ["ID", "PG"]
}, {
  pk: 1033,
  ang: "Bobo Madar\xE9, Southern",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Southern Bobo Madar\xE9",
  lc: "bwq",
  ld: "ltr",
  alt: ["Black Bobo", "Bobo", "Bobo Fi", "Bobo Fing", "Bobo Jula", "Syab\xE9r\xE9 (Sya)", "Zara (Bobo Dioula)"],
  cc: ["BF"]
}, {
  pk: 1034,
  ang: "Bura-Pabir",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bura-Pabir",
  lc: "bwr",
  ld: "ltr",
  alt: ["Babir", "Barburr", "Bourrah", "Burra", "Huve", "Huviya", "Kwojeffa", "Mya Bura", "Pabir", "Hyil Hawul (Bura Hyilhawul)", "Pela (Bura Pela)", "Hill Bura", "Plain Bura"],
  cc: ["NG"]
}, {
  pk: 1035,
  ang: "Bomboma",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bomboma",
  lc: "bws",
  ld: "ltr",
  alt: ["Boba"],
  cc: ["CD"]
}, {
  pk: 1036,
  ang: "Bafaw-Balong",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bafaw-Balong",
  lc: "bwt",
  ld: "ltr",
  alt: ["Ngoe", "Bafaw (Afo)", "Bafo", "Bafowu", "Balon", "Balong (Bai)", "Balung", "Bayi", "Lefo'", "Nho", "Nlong", "Valongi"],
  cc: ["CM"]
}, {
  pk: 1037,
  ang: "Buli",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Buli (Ghana)",
  lc: "bwu",
  ld: "ltr",
  alt: ["Bulisa", "Guresha", "Kanjaga"],
  cc: ["GH"]
}, {
  pk: 1038,
  ang: "Bwa",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bwa",
  lc: "bww",
  ld: "ltr",
  alt: ["Boa", "Boua", "Bua", "Kibua", "Kibwa", "Libenge", "Libwali", "Bati (Baati)", "Leboa-Le"],
  cc: ["CD"]
}, {
  pk: 1039,
  ang: "Bunu, Bu-Nao",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5E03\u52AA\u8BED",
  lc: "bwx",
  ld: "ltr",
  alt: ["Bunao", "Po-Nau", "Punu", "Nau Klau", "Tung Nu", "Pounou", "Nu Mhou", "Naogelao (Baonuo)", "Nao Klao", "Nao Khalo", "Hontou Longlin", "Dongnu (Bunu)", "Bunuo (Pu No)", "Numao (Hong Yao)"],
  cc: ["CN"]
}, {
  pk: 1040,
  ang: "Bwamu, Cwi",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Cwi Bwamu",
  lc: "bwy",
  ld: "ltr",
  alt: ["Coo", "Cwi", "Twi"],
  cc: ["BF"]
}, {
  pk: 1041,
  ang: "Bwisi",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Bwisi",
  lc: "bwz",
  ld: "ltr",
  alt: ["Ibwisi", "Mbwisi"],
  cc: ["GA", "CG"]
}, {
  pk: 1042,
  ang: "Tairaha",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Tairaha",
  lc: "bxa",
  ld: "ltr",
  alt: ["Bwauro", "Rawo (Ravo)", "Haununu (Hauhunu)"],
  cc: ["SB"]
}, {
  pk: 1043,
  ang: "Belanda Bor",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Belanda Bor",
  lc: "bxb",
  ld: "ltr",
  alt: ["De Bor"],
  cc: ["SS"]
}, {
  pk: 1044,
  ang: "Molengue",
  lr: "Africa",
  gw: false,
  hc: "GQ",
  ln: "Molengue",
  lc: "bxc",
  ld: "ltr",
  alt: ["Balengue", "Molendji"],
  cc: ["GQ"]
}, {
  pk: 1045,
  ang: "Pela",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6CE2\u62C9",
  lc: "bxd",
  ld: "ltr",
  alt: ["Bola", "Bula", "Pala", "Polo"],
  cc: ["CN"]
}, {
  pk: 1046,
  ang: "Ongota",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Birale",
  lc: "bxe",
  ld: "ltr",
  alt: ["Ifa", "Birelle", "Shanqilla"],
  cc: ["ET"]
}, {
  pk: 1047,
  ang: "Minigir",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bilur",
  lc: "bxf",
  ld: "ltr",
  alt: ["Birar"],
  cc: ["PG"]
}, {
  pk: 1048,
  ang: "Bangala",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bangala",
  lc: "bxg",
  ld: "ltr",
  alt: ["Ngala"],
  cc: ["SS", "CG", "CD"]
}, {
  pk: 1049,
  ang: "Buhutu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Buhutu",
  lc: "bxh",
  ld: "ltr",
  alt: ["Bohutu", "Buhulu", "Siasiada", "Yaleba"],
  cc: ["PG"]
}, {
  pk: 1050,
  ang: "Bayungu",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Bayungu",
  lc: "bxj",
  ld: "ltr",
  alt: ["Baiong", "Baiung", "Bajungu", "Biong", "Giong", "Mulgarnoo", "Pajungu", "Payungu"],
  cc: ["AU"]
}, {
  pk: 1051,
  ang: "Lubukusu",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Bukusu",
  lc: "bxk",
  ld: "ltr",
  alt: [],
  cc: ["KE", "UG"]
}, {
  pk: 1052,
  ang: "Jalkunan",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Jalkunan",
  lc: "bxl",
  ld: "ltr",
  alt: ["Bl\xE9", "Dyala", "Dyalanu", "Jalkuna"],
  cc: ["BF"]
}, {
  pk: 1053,
  ang: "Buriat, Mongolia",
  lr: "Asia",
  gw: false,
  hc: "MN",
  ln: "Mongolia Buriat",
  lc: "bxm",
  ld: "ltr",
  alt: ["Buriat-Mongolian", "Burraad", "Buryat", "Mongolian Buriat", "Northern Mongolian"],
  cc: ["MN"]
}, {
  pk: 1054,
  ang: "Burduna",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Burduna",
  lc: "bxn",
  ld: "ltr",
  alt: ["Boordoona", "Budina", "Budoona", "Buduna", "Pinneegooroo", "Poodena", "Poordoona", "Purduma", "Purduna"],
  cc: ["AU"]
}, {
  pk: 1055,
  ang: "Barikanchi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Barikanchi",
  lc: "bxo",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 1056,
  ang: "Bebil",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bebil",
  lc: "bxp",
  ld: "ltr",
  alt: ["Bobilis", "Gbigbil"],
  cc: ["CM"]
}, {
  pk: 1057,
  ang: "Beele",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Beele",
  lc: "bxq",
  ld: "ltr",
  alt: ["\xC0b\xE9\xE9l\xE9", "Bele", "Bellawa"],
  cc: ["NG"]
}, {
  pk: 1058,
  ang: "Buriat, Russia",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0411\u0443\u0440\u044F\u0442\u0441\u043A\u0438\u0439",
  lc: "bxr",
  ld: "ltr",
  alt: ["Buriat-Mongolian", "Buryat", "Northern Mongolian", "Selengin", "Bokhan", "Ekhirit-Bulagat"],
  cc: ["RU", "UZ"]
}, {
  pk: 1059,
  ang: "Busam",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Busam",
  lc: "bxs",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 1060,
  ang: "Buriat, China",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5E03\u91CC\u4E9E\u7279\u8A9E",
  lc: "bxu",
  ld: "ltr",
  alt: ["Ba'erhu-Buliyate", "Bargu Buriat", "Buriat-Mongolian", "Buryat", "Northeastern Mongolian", "Northern Mongolian", "Buriat (Buliyate)", "New Bargu (Xin Ba'erhu)", "Old Bargu (Chen Ba'erhu)"],
  cc: ["CN"]
}, {
  pk: 1061,
  ang: "Bankagooma",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Bankagooma",
  lc: "bxw",
  ld: "ltr",
  alt: ["Banka", "Bankagoroma", "Bankaje"],
  cc: ["ML"]
}, {
  pk: 1062,
  ang: "Binahari",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Binahari",
  lc: "bxz",
  ld: "ltr",
  alt: ["Neme (Nemea)"],
  cc: ["PG"]
}, {
  pk: 1063,
  ang: "Batak",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Batak",
  lc: "bya",
  ld: "ltr",
  alt: ["Babuyan", "Palawan Batak", "Tinitianes"],
  cc: ["PH"]
}, {
  pk: 1064,
  ang: "Ubaghara",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ubaghara",
  lc: "byc",
  ld: "ltr",
  alt: ["Utamu", "Utuma (Utama)"],
  cc: ["NG"]
}, {
  pk: 1065,
  ang: "Benyadu\u2019",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Benyadu'",
  lc: "byd",
  ld: "ltr",
  alt: ["Balantian", "Balantiang", "Njadu", "Nyadu (Balantian)"],
  cc: ["ID"]
}, {
  pk: 8090,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Dait",
  lc: "byd-x-dayakdait",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8083,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Pantu",
  lc: "byd-x-dayakpantu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7949,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Suku Dayak Kerabat",
  lc: "byd-x-kerabat",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1066,
  ang: "Pouye",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Pouye",
  lc: "bye",
  ld: "ltr",
  alt: ["Bouye"],
  cc: ["PG"]
}, {
  pk: 1067,
  ang: "Bete",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bete",
  lc: "byf",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 1068,
  ang: "Baygo",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Baygo",
  lc: "byg",
  ld: "ltr",
  alt: ["Baigo", "Bego", "Beigo", "Beko", "B\xE9og\xE9", "Beygo"],
  cc: ["SD"]
}, {
  pk: 1069,
  ang: "Bhujel",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u092D\u0941\u091C\u0947\u0932",
  lc: "byh",
  ld: "ltr",
  alt: ["Bujal", "Bujhel", "Bujheli", "Pukhgyal Ngur", "Western Chepang", "Gharti", "Dhodeni", "Baniyatar", "Kulmun", "Andimul", "Beltar", "Arthumpka", "Chanaute"],
  cc: ["NP"]
}, {
  pk: 1070,
  ang: "Buyu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Buyu",
  lc: "byi",
  ld: "ltr",
  alt: ["Bujwe", "Buyi"],
  cc: ["CD"]
}, {
  pk: 1071,
  ang: "Bina",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bina (Nigeria)",
  lc: "byj",
  ld: "ltr",
  alt: ["Bogana"],
  cc: ["NG"]
}, {
  pk: 1072,
  ang: "Biao",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6807\u8BDD",
  lc: "byk",
  ld: "ltr",
  alt: ["Gang Bau", "Kang Bau", "Kang Beu", "Kang Pau"],
  cc: ["CN"]
}, {
  pk: 1073,
  ang: "Bayono",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bayono",
  lc: "byl",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 1074,
  ang: "Bilen",
  lr: "Africa",
  gw: false,
  hc: "ER",
  ln: "Bilin",
  lc: "byn",
  ld: "ltr",
  alt: ["Balen", "Belen", "Beleni", "Bilayn", "Bilein", "Bileno", "Bilin", "Bogo", "Bogos", "North Agaw", "Senhit", "T'aqwur"],
  cc: ["ER", "ET"]
}, {
  pk: 1075,
  ang: "Biyo",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Biyo",
  lc: "byo",
  ld: "ltr",
  alt: ["Bio", "Biyue", "Piyo"],
  cc: ["CN", "LA"]
}, {
  pk: 1076,
  ang: "Bumaji",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bumaji",
  lc: "byp",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 1077,
  ang: "Yipma",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Baruya",
  lc: "byr",
  ld: "ltr",
  alt: ["Barua", "Yipma", "Usirampia (Wuzuraabya)"],
  cc: ["PG"]
}, {
  pk: 1078,
  ang: "Burak",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Burak",
  lc: "bys",
  ld: "ltr",
  alt: ["Buurak"],
  cc: ["NG"]
}, {
  pk: 1079,
  ang: "Medumba",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Medumba",
  lc: "byv",
  ld: "ltr",
  alt: ["Bagangte", "Bamileke-Medumba", "Bangangte"],
  cc: ["CM"]
}, {
  pk: 1080,
  ang: "Belhariya",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Belhariya",
  lc: "byw",
  ld: "ltr",
  alt: ["Athpagari", "Athpahariya", "Athpare", "Athpariya", "Belhare"],
  cc: ["NP"]
}, {
  pk: 1081,
  ang: "Qaqet",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Qaqet",
  lc: "byx",
  ld: "ltr",
  alt: ["Baining", "Kakat", "Makakat", "Maqaqet"],
  cc: ["PG"]
}, {
  pk: 1082,
  ang: "Banaro",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Banaro",
  lc: "byz",
  ld: "ltr",
  alt: ["Banar", "Banara", "Waran"],
  cc: ["PG"]
}, {
  pk: 1083,
  ang: "Bandi",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Bandi",
  lc: "bza",
  ld: "ltr",
  alt: ["Bande", "Gbande", "Gbandi", "Gbunde"],
  cc: ["LR", "GN"]
}, {
  pk: 1084,
  ang: "Andio",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Andio",
  lc: "bzb",
  ld: "ltr",
  alt: ["Andio'o", "Imbao'o", "Masama", "Bobongko"],
  cc: ["ID"]
}, {
  pk: 1085,
  ang: "Malagasy, Southern Betsimisaraka",
  lr: "Africa",
  gw: false,
  hc: "MG",
  ln: "Southern Betsimisaraka Malagasy",
  lc: "bzc",
  ld: "ltr",
  alt: ["Betsimisaraka Antatsimo Malagasy"],
  cc: ["MG"]
}, {
  pk: 7934,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "MG",
  ln: "Antemoro",
  lc: "bzc-x-antemoro",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1086,
  ang: "Bribri",
  lr: "Americas",
  gw: false,
  hc: "CR",
  ln: "Bribri",
  lc: "bzd",
  ld: "ltr",
  alt: ["Talamanca"],
  cc: ["PA", "CR"]
}, {
  pk: 1087,
  ang: "Bozo, Jenaama",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Jenaama Bozo",
  lc: "bze",
  ld: "ltr",
  alt: ["Boso", "Corogaama", "Djenaama", "Nononke", "Sarkanci", "Sarkawa", "Sorko", "Sorogaama", "Bozo", "Corogama", "Jenaama Bozo", "Jenama", "Sorogama", "Korondougou", "Kotya (Kotyaxo)", "Pondori"],
  cc: ["BF", "ML"]
}, {
  pk: 1088,
  ang: "Boikin",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Boikin",
  lc: "bzf",
  ld: "ltr",
  alt: ["Boiken", "Nucum", "Yengoru"],
  cc: ["PG"]
}, {
  pk: 7752,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Duo",
  lc: "bzf-x-duo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1089,
  ang: "Babuza",
  lr: "Asia",
  gw: false,
  hc: "TW",
  ln: "Babuza",
  lc: "bzg",
  ld: "ltr",
  alt: ["Babusa", "Favorlang", "Favorlangsch", "Jaborlang"],
  cc: ["TW"]
}, {
  pk: 1090,
  ang: "Buang, Mapos",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mapos Buang",
  lc: "bzh",
  ld: "ltr",
  alt: ["Central Buang"],
  cc: ["PG"]
}, {
  pk: 1091,
  ang: "Bisu",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Bisu",
  lc: "bzi",
  ld: "ltr",
  alt: ["Laopin", "Lawa", "Lua", "Mbi", "Mibisu", "Misu", "Pin", "Mbisu", "Dakao", "Huaipa", "Lanmeng"],
  cc: ["TH"]
}, {
  pk: 1092,
  ang: "Belize Kriol English",
  lr: "Americas",
  gw: false,
  hc: "BZ",
  ln: "Belize Kriol English",
  lc: "bzj",
  ld: "ltr",
  alt: ["Kriol"],
  cc: ["BZ"]
}, {
  pk: 1093,
  ang: "Nicaragua Creole English",
  lr: "Americas",
  gw: false,
  hc: "NI",
  ln: "Nicaragua Creole English",
  lc: "bzk",
  ld: "ltr",
  alt: ["M\xEDskito Coast Creole English", "Rama Cay Creole English", "Bluefields Creole English"],
  cc: ["NI"]
}, {
  pk: 1094,
  ang: "Boano",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Boano (Sulawesi)",
  lc: "bzl",
  ld: "ltr",
  alt: ["Boan-diks"],
  cc: ["ID"]
}, {
  pk: 1095,
  ang: "Bolondo",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bolondo",
  lc: "bzm",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 1096,
  ang: "Boano",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Boano (Maluku)",
  lc: "bzn",
  ld: "ltr",
  alt: ["Buano"],
  cc: ["ID"]
}, {
  pk: 1097,
  ang: "Bozaba",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bozaba",
  lc: "bzo",
  ld: "ltr",
  alt: ["Budzaba", "Buzaba"],
  cc: ["CD"]
}, {
  pk: 1098,
  ang: "Kemberano",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kemberano",
  lc: "bzp",
  ld: "ltr",
  alt: ["Arandai", "Kalitami", "Wariagar"],
  cc: ["ID"]
}, {
  pk: 1099,
  ang: "Buli",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Buli (Indonesia)",
  lc: "bzq",
  ld: "ltr",
  alt: ["Wayamli (Jawanli)", "Wajamli"],
  cc: ["ID"]
}, {
  pk: 1100,
  ang: "Biri",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Biri",
  lc: "bzr",
  ld: "ltr",
  alt: ["Wirri"],
  cc: ["AU"]
}, {
  pk: 1101,
  ang: "Brazilian Sign Language",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Brazilian Sign Language",
  lc: "bzs",
  ld: "ltr",
  alt: ["LIBRAS", "LSB", "S\xE3o Paulo Sign Language"],
  cc: ["BR"]
}, {
  pk: 1102,
  ang: "",
  lr: "",
  gw: false,
  hc: "",
  ln: "Brithenig",
  lc: "bzt",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1103,
  ang: "Burmeso",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Burmeso",
  lc: "bzu",
  ld: "ltr",
  alt: ["Boromeso", "Borumesso", "Burumeso", "Manau", "Monao", "Monau", "Taurap"],
  cc: ["ID"]
}, {
  pk: 1104,
  ang: "Naami",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Naami",
  lc: "bzv",
  ld: "ltr",
  alt: ["Yi Be Wu"],
  cc: ["CM"]
}, {
  pk: 1105,
  ang: "Basa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Basa (Nigeria)",
  lc: "bzw",
  ld: "ltr",
  alt: ["Abacha", "Abatsa", "Basa-Benue", "Rubasa", "Rubassa", "Bassa-Komo", "Bassa-Kwomu"],
  cc: ["BJ", "NG"]
}, {
  pk: 1106,
  ang: "Bozo, Kelengaxo",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "K\u025Bl\u025Bngaxo Bozo",
  lc: "bzx",
  ld: "ltr",
  alt: ["Boso", "Hain", "Hainyaxo Bozo", "Hanyaxo", "Kelenga", "K\xE9linga", "K\xE9llingua", "Xan", "Xanyaxo"],
  cc: ["ML"]
}, {
  pk: 1107,
  ang: "Obanliku",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Obanliku",
  lc: "bzy",
  ld: "ltr",
  alt: ["Abanliku", "Bisu (Gayi)"],
  cc: ["CM", "NG"]
}, {
  pk: 1108,
  ang: "Evant",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Evant",
  lc: "bzz",
  ld: "ltr",
  alt: ["Avand", "Balegete", "Belegete", "Ovand", "Ovande", "Ovando"],
  cc: ["CM", "NG"]
}, {
  pk: 1109,
  ang: "Catalan",
  lr: "Europe",
  gw: false,
  hc: "ES",
  ln: "catal\xE0",
  lc: "ca",
  ld: "ltr",
  alt: ["Catal\xE0", "Catalan-Valencian-Balear", "Catalonian", "Algherese Catalan", "Menorquin", "Insular Catalan", "Valenciano", "Valencian (Valenci\xE0)", "Ribagor\xE7an", "Pallarese", "Northwestern Catalan (Aiguavivan)", "Menorqui", "Lleidat\xE0", "Eivissenc", "Central Catalan", "Catalan-Rousillonese (Northern Catal\xE1n)", "Balearic (Balear)", "Mallorqui"],
  cc: ["AR", "FR", "VE", "ES", "AD", "US", "IT"]
}, {
  pk: 1110,
  ang: "Ch\u2019orti\u2019",
  lr: "Americas",
  gw: false,
  hc: "GT",
  ln: "Chort\xED",
  lc: "caa",
  ld: "ltr",
  alt: [],
  cc: ["GT"]
}, {
  pk: 1111,
  ang: "Garifuna",
  lr: "Americas",
  gw: false,
  hc: "HN",
  ln: "Garifuna",
  lc: "cab",
  ld: "ltr",
  alt: ["Caribe", "Central American Carib", "Black Carib", "Moreno", "Gar\xEDfuna", "Eastern Garifuna", "Western Garifuna"],
  cc: ["VC", "GT", "HN", "US", "NI"]
}, {
  pk: 1112,
  ang: "Chuj",
  lr: "Americas",
  gw: false,
  hc: "GT",
  ln: "Chuj",
  lc: "cac",
  ld: "ltr",
  alt: ["Chuh", "Chuhe", "Chuj de San Mateo Ixtat\xE1n", "Chuje", "Chapai"],
  cc: ["GT", "US"]
}, {
  pk: 1113,
  ang: "Caddo",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Caddo",
  lc: "cad",
  ld: "ltr",
  alt: ["Caddoe", "Kado", "Kadohadacho"],
  cc: ["US"]
}, {
  pk: 1114,
  ang: "Laalaa",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Lehar",
  lc: "cae",
  ld: "ltr",
  alt: ["Lehar", "Serer"],
  cc: ["SN"]
}, {
  pk: 1115,
  ang: "Carrier, Southern",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Southern Carrier",
  lc: "caf",
  ld: "ltr",
  alt: ["Cheslatta", "Nautley", "Prince George", "Stellaquo", "Stoney Creek"],
  cc: ["CA"]
}, {
  pk: 1116,
  ang: "Nivacl\xE9",
  lr: "Americas",
  gw: false,
  hc: "PY",
  ln: "Nivacl\xE9",
  lc: "cag",
  ld: "ltr",
  alt: ["Ashlushlay", "Chulupe", "Chulupi", "Churupi", "Axluslay", "Nivakl\xE9", "Chulup\xED", "Churup\xED", "Forest Nivacl\xE9"],
  cc: ["AR", "PY"]
}, {
  pk: 1117,
  ang: "",
  lr: "Americas",
  gw: false,
  hc: "AR",
  ln: "Chan\xE9",
  lc: "caj",
  ld: "ltr",
  alt: [],
  cc: ["AR"]
}, {
  pk: 1118,
  ang: "Kaqchikel",
  lr: "Americas",
  gw: false,
  hc: "GT",
  ln: "Kaqchikel",
  lc: "cak",
  ld: "ltr",
  alt: ["Cakchiquel", "Kaqchiquel", "Western Cakchiquel", "South Central Cakchiquel", "Yepocapa Southwestern Cakchiquel", "Southern Cakchiquel", "Santa Mar\xEDa de Jes\xFAs Cakchiquel (Kach'ab'al)", "Northern Cakchiquel", "Akatenango Soutwestern Cakchiquel", "Eastern Cakchiquel", "Santo Domingo Xenacoj Cakchiquel"],
  cc: ["GT"]
}, {
  pk: 1119,
  ang: "Carolinian",
  lr: "Pacific",
  gw: false,
  hc: "MP",
  ln: "Carolinian",
  lc: "cal",
  ld: "ltr",
  alt: ["Saipan Carolinian", "Southern Carolinian", "Gupallao"],
  cc: ["MP", "US", "FM"]
}, {
  pk: 1120,
  ang: "Cemuh\xEE",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Cemuh\xEE",
  lc: "cam",
  ld: "ltr",
  alt: ["Camuhi", "Camuki", "Tie", "Tyamuhi", "Wagap"],
  cc: ["NC"]
}, {
  pk: 1121,
  ang: "Chambri",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Chambri",
  lc: "can",
  ld: "ltr",
  alt: ["Tchambuli", "Tshamberi"],
  cc: ["PG"]
}, {
  pk: 1122,
  ang: "Ch\xE1cobo",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Ch\xE1cobo",
  lc: "cao",
  ld: "ltr",
  alt: [],
  cc: ["BO"]
}, {
  pk: 1123,
  ang: "Chipaya",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Chipaya",
  lc: "cap",
  ld: "ltr",
  alt: ["Puquina"],
  cc: ["BO"]
}, {
  pk: 1124,
  ang: "Nicobarese, Car",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Car Nicobarese",
  lc: "caq",
  ld: "ltr",
  alt: ["Car", "Pu"],
  cc: ["IN"]
}, {
  pk: 1125,
  ang: "Carib",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "Galibi Carib",
  lc: "car",
  ld: "ltr",
  alt: ["Caribe", "Cari\xF1a", "Kalihna", "Kalinya", "Maraworno", "Marworno", "Galibi", "Kalin'a", "Kari\xF1a", "Kari'nja", "Galib\xED", "Kali'na", "Western Carib", "Aretyry", "Murato (Myrato)", "Tyrewuju (Eastern Carib)"],
  cc: ["BR", "GF", "VE", "GY", "SR"]
}, {
  pk: 1126,
  ang: "Tsiman\xE9",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Tsiman\xE9",
  lc: "cas",
  ld: "ltr",
  alt: ["Chiman\xE9", "Moset\xE9n", "Tsiman\xE9"],
  cc: ["BO"]
}, {
  pk: 1127,
  ang: "Cavine\xF1a",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Cavine\xF1a",
  lc: "cav",
  ld: "ltr",
  alt: [],
  cc: ["BO"]
}, {
  pk: 1128,
  ang: "Callawalla",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Callawalla",
  lc: "caw",
  ld: "ltr",
  alt: ["Callahuaya"],
  cc: ["BO"]
}, {
  pk: 1129,
  ang: "Chiquitano",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Chiquitano",
  lc: "cax",
  ld: "ltr",
  alt: ["Chiquito", "Tarapecosi", "Concepci\xF3n", "San Javier (Javierano)", "Xavierano"],
  cc: ["BO"]
}, {
  pk: 1130,
  ang: "Cayuga",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Cayuga",
  lc: "cay",
  ld: "ltr",
  alt: [],
  cc: ["CA"]
}, {
  pk: 1131,
  ang: "Canichana",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Canichana",
  lc: "caz",
  ld: "ltr",
  alt: ["Kanichana"],
  cc: ["BO"]
}, {
  pk: 1132,
  ang: "Cabiyar\xED",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Cabiyar\xED",
  lc: "cbb",
  ld: "ltr",
  alt: ["Cabiuar\xED", "Cauyar\xED", "Cuyare", "Kabiyar\xED", "Kauyar\xED", "Kawiar\xED", "Kawillary", "Kawiyar\xED"],
  cc: ["CO"]
}, {
  pk: 1133,
  ang: "Carapana",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Carapana",
  lc: "cbc",
  ld: "ltr",
  alt: ["Carapan\xE3", "Mext\xE3", "Carapana-Tapuya", "Karapan\xE1", "Karapan\xE3", "Karapano", "Mi tea", "Mochda", "Moxdoa", "Muxtea"],
  cc: ["BR", "CO"]
}, {
  pk: 1134,
  ang: "Carijona",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Carijona",
  lc: "cbd",
  ld: "ltr",
  alt: ["Carifuna", "Carihona", "Hianacoto-Umaua", "Huaque", "Kaliohona", "Karijona", "Koto", "Omagua", "Umawa"],
  cc: ["CO"]
}, {
  pk: 1135,
  ang: "Chimila",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Chimila",
  lc: "cbg",
  ld: "ltr",
  alt: ["Caca Weranos", "Chimile", "ett E'neka", "San Jorge", "Shimizya", "Simiza"],
  cc: ["CO"]
}, {
  pk: 1136,
  ang: "Chachi",
  lr: "Americas",
  gw: false,
  hc: "EC",
  ln: "Chachi",
  lc: "cbi",
  ld: "ltr",
  alt: ["Cha' Palaachi", "Cha'palaa", "Cha'palaachi"],
  cc: ["EC"]
}, {
  pk: 1137,
  ang: "Ede Cabe",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Ede Cabe",
  lc: "cbj",
  ld: "ltr",
  alt: ["Caabe"],
  cc: ["BJ"]
}, {
  pk: 1138,
  ang: "Chavacano",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Chavacano",
  lc: "cbk",
  ld: "ltr",
  alt: ["Chabacano", "Davawe\xF1o Zamboangue\xF1o (Abakay Spanish)", "Ermita\xF1o (Ermite\xF1o)", "Ternate\xF1o (Ternate\xF1o Chavacano)", "Davawe\xF1o", "Davao Chavacano", "Cotabato Chavacano (Cotabate\xF1o)", "Cavite\xF1o", "Zamboangue\xF1o (Chavacano)", "Davaoe\xF1o"],
  cc: ["MY", "PH"]
}, {
  pk: 1139,
  ang: "Chin, Bualkhaw",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Bualkhaw Chin",
  lc: "cbl",
  ld: "ltr",
  alt: ["Bualkhaw-Chin"],
  cc: ["MM"]
}, {
  pk: 1140,
  ang: "Nyahkur",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Nyahkur",
  lc: "cbn",
  ld: "ltr",
  alt: ["Chao Dong", "Chaodon", "Lawa", "Niakuol", "Niakuoll", "Nyakur", "Chaobon", "Chaobun", "Chaubun"],
  cc: ["TH"]
}, {
  pk: 1141,
  ang: "Izora",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Izora",
  lc: "cbo",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 1142,
  ang: "Tsucuba",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Tsucuba",
  lc: "cbq",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 1143,
  ang: "Cashibo-Cacataibo",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Cashibo-Cacataibo",
  lc: "cbr",
  ld: "ltr",
  alt: ["Cachibo", "Cacibo", "Cahivo", "Caxibo", "Hagueti", "Managua"],
  cc: ["PE"]
}, {
  pk: 1144,
  ang: "Kashinawa",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Cashinahua",
  lc: "cbs",
  ld: "ltr",
  alt: ["Cashinahu\xE1", "Caxinaw\xE1", "Huni Kui", "Juni Kuin", "Kaxinau\xE1", "Kaxinaw\xE1", "Kaxynawa", "Caxinawa", "Kashinahua"],
  cc: ["BR", "PE"]
}, {
  pk: 1145,
  ang: "Chayahuita",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Chayahuita",
  lc: "cbt",
  ld: "ltr",
  alt: ["Balsapuertino", "Cahuapa", "Chawi", "Chayabita", "Chayawita", "Chayhuita", "Paranapura", "Shawi", "Shayabit", "Tshaahui"],
  cc: ["PE"]
}, {
  pk: 1146,
  ang: "Candoshi-Shapra",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Candoshi-Shapra",
  lc: "cbu",
  ld: "ltr",
  alt: ["Candoshi", "Candoxi", "Kandoshi", "Murato", "Chapara (Shapra)"],
  cc: ["PE"]
}, {
  pk: 1147,
  ang: "Cacua",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Cacua",
  lc: "cbv",
  ld: "ltr",
  alt: ["B\xE1da", "Cakua", "Kakua", "K\xE1kwa", "Macu de Cubeo", "Macu de Desano", "Macu de Guanano", "Mac\xFA-Paran\xE1", "Wacara"],
  cc: ["CO"]
}, {
  pk: 1148,
  ang: "Kinabalian",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kinabalian",
  lc: "cbw",
  ld: "ltr",
  alt: ["Bisaya'", "Cabalian"],
  cc: ["PH"]
}, {
  pk: 1149,
  ang: "Carabayo",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Carabayo",
  lc: "cby",
  ld: "ltr",
  alt: ["Yuri", "Amazonas Macusa"],
  cc: ["CO"]
}, {
  pk: 1150,
  ang: "Chamicuro",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Chamicuro",
  lc: "ccc",
  ld: "ltr",
  alt: ["Chamicolo", "Chamicura"],
  cc: ["PE"]
}, {
  pk: 1151,
  ang: "Cafundo Creole",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Cafundo Creole",
  lc: "ccd",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 1152,
  ang: "Chopi",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Chopi",
  lc: "cce",
  ld: "ltr",
  alt: ["Cicopi", "Shichopi", "Shicopi", "Tschopi", "Txitxopi", "Txopi", "Lenge", "Lengue (Kilenge)"],
  cc: ["MZ"]
}, {
  pk: 1153,
  ang: "Samba Daka",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Samba Daka",
  lc: "ccg",
  ld: "ltr",
  alt: ["Chamba Daka", "Daka", "Dakka", "Dekka", "Deng", "Jama", "Nakanyare", "Sama", "Samba", "Tchamba", "Tikk", "Tsamba"],
  cc: ["CM", "NG"]
}, {
  pk: 1154,
  ang: "Atsam",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Atsam",
  lc: "cch",
  ld: "ltr",
  alt: ["Cawai", "Cawe", "Cawi", "Chawai", "Chawe", "Chawi"],
  cc: ["NG"]
}, {
  pk: 1155,
  ang: "Kasanga",
  lr: "Africa",
  gw: false,
  hc: "GW",
  ln: "Kasanga",
  lc: "ccj",
  ld: "ltr",
  alt: ["Haal", "I-Hadja", "Kassanga"],
  cc: ["GW"]
}, {
  pk: 1156,
  ang: "Cutchi-Swahili",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Cutchi-Swahili",
  lc: "ccl",
  ld: "ltr",
  alt: ["Asian Swahili"],
  cc: ["TZ"]
}, {
  pk: 1157,
  ang: "Malaccan Creole Malay",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Malaccan Creole Malay",
  lc: "ccm",
  ld: "ltr",
  alt: ["Chitties Creole Malay"],
  cc: ["MY"]
}, {
  pk: 1158,
  ang: "Chinantec, Comaltepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Comaltepec Chinantec",
  lc: "cco",
  ld: "ltr",
  alt: ["Jmii'"],
  cc: ["MX"]
}, {
  pk: 1159,
  ang: "Chakma",
  lr: "Asia",
  gw: false,
  hc: "BD",
  ln: "Chakma",
  lc: "ccp",
  ld: "ltr",
  alt: ["Sakma", "Sangma", "Takam", "Chakama", "Tsakma", "Daingnet"],
  cc: ["BD", "IN"]
}, {
  pk: 1160,
  ang: "Choni",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Choni",
  lc: "cda",
  ld: "ltr",
  alt: ["Chona", "Chone", "Cone", "Jone", "Zhuoni", "Hbrugchu (Zhouqu)", "Thewo (Diebu)"],
  cc: ["CN"]
}, {
  pk: 1161,
  ang: "Chenchu",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Chenchu",
  lc: "cde",
  ld: "ltr",
  alt: ["Chenchucoolam", "Chenchwar", "Chenswar", "Choncharu"],
  cc: ["IN"]
}, {
  pk: 1162,
  ang: "Chiru",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Chiru",
  lc: "cdf",
  ld: "ltr",
  alt: ["Chhori"],
  cc: ["IN"]
}, {
  pk: 1163,
  ang: "Chamari",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Chamari",
  lc: "cdg",
  ld: "ltr",
  alt: ["Chamar", "Chambhar Boli", "Chambhari"],
  cc: ["IN"]
}, {
  pk: 1164,
  ang: "Chambeali",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Chambeali",
  lc: "cdh",
  ld: "ltr",
  alt: ["Cameali", "Chamaya", "Chambiyali", "Chamiyali Pahari", "Chamya"],
  cc: ["IN"]
}, {
  pk: 1165,
  ang: "Chodri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Chodri",
  lc: "cdi",
  ld: "ltr",
  alt: ["Chaudhari", "Chaudri", "Chodhari", "Choudhara", "Choudhary", "Chowdhary"],
  cc: ["IN"]
}, {
  pk: 1166,
  ang: "Churahi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Churahi",
  lc: "cdj",
  ld: "ltr",
  alt: ["Chaurahi", "Churahi Pahari", "Churai Pahari"],
  cc: ["IN"]
}, {
  pk: 1167,
  ang: "Chepang",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Chepang",
  lc: "cdm",
  ld: "ltr",
  alt: ["Praja Bhasa", "Tsepang"],
  cc: ["NP"]
}, {
  pk: 1168,
  ang: "Chaudangsi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Chaudangsi",
  lc: "cdn",
  ld: "ltr",
  alt: ["Bangba Lo", "Bangbani", "Chanpa Lo", "Chaudans Lo", "Saukas", "Shaukas", "Tsaudangsi"],
  cc: ["NP", "IN"]
}, {
  pk: 1169,
  ang: "Chinese, Min Dong",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u95FD\u4E1C\u8BED",
  lc: "cdo",
  ld: "ltr",
  alt: ["Eastern Min", "Foochow", "Hokchiu", "Min Dong", "Xinghua (Hsinghua)", "Guxhou", "Fuzhou (Foochow)", "Fuchow", "Foochow (Fuzhou)"],
  cc: ["CN", "US"]
}, {
  pk: 1170,
  ang: "Kamuku",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Cinda-Regi-Tiyal",
  lc: "cdr",
  ld: "ltr",
  alt: ["Cinda-Regi-Tiyal", "Tiyar", "Tucipu", "Tu'yara", "Yara", "Regi (tuRegi)", "Kuki (Tiyal)", "Tegina", "Ucinda", "Makangara", "Kuru (uKuru)", "Cinda (Jinda)", "Maruba", "Majinda"],
  cc: ["NG"]
}, {
  pk: 1171,
  ang: "Chadian Sign Language",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Chadian Sign Language",
  lc: "cds",
  ld: "ltr",
  alt: [],
  cc: ["TD"]
}, {
  pk: 1172,
  ang: "Chadong",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u8336\u6D1E\u8A9E",
  lc: "cdy",
  ld: "ltr",
  alt: ["Cha Dong", "Chadonghua", "Chadongyu"],
  cc: ["CN"]
}, {
  pk: 1173,
  ang: "Koda",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Koda",
  lc: "cdz",
  ld: "ltr",
  alt: ["Kaora", "Kora", "Korali", "Korati", "Kore", "Mudi", "Mudikora"],
  cc: ["BD", "IN"]
}, {
  pk: 1174,
  ang: "Chechen",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u043D\u043E\u0445\u0447\u0438\u0439\u043D \u043C\u043E\u0442\u0442",
  lc: "ce",
  ld: "ltr",
  alt: ["Galancho", "Nokchiin Muott", "Nokhchiin", "Akkin (Aux)", "Itumkala (Shatoi)"],
  cc: ["AZ", "AT", "BE", "DE", "KZ", "RU", "TR", "GE", "JO", "KG", "TM", "UZ"]
}, {
  pk: 1175,
  ang: "Chehalis, Lower",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Lower Chehalis",
  lc: "cea",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 1176,
  ang: "Cebuano",
  lr: "Asia",
  gw: true,
  hc: "PH",
  ln: "Cebuano",
  lc: "ceb",
  ld: "ltr",
  alt: ["Binisaya", "Bisayan", "Sebuano", "Sugbuanon", "Sugbuhanon", "Visayan"],
  cc: ["PH", "US"]
}, {
  pk: 8313,
  ang: "Boholano",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Boholano",
  lc: "ceb-x-boholano",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8195,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Siquijodnon",
  lc: "ceb-x-siquijodnon",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1177,
  ang: "Chamacoco",
  lr: "Americas",
  gw: false,
  hc: "PY",
  ln: "Chamacoco",
  lc: "ceg",
  ld: "ltr",
  alt: ["Ishiro", "Jeywo", "Yshyro", "Tomaraho"],
  cc: ["BR", "PY"]
}, {
  pk: 1178,
  ang: "Chin, Eastern Khumi",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Eastern Khumi Chin",
  lc: "cek",
  ld: "ltr",
  alt: ["Ta-aw", "Ta-oo", "Taheunso", "Palyng", "Paru", "Rengsa (Namboi, Nangbwe)", "Uiphaw", "Sangtha", "Tahaensae", "Tao Cha", "Nisay (Nise)", "Kaja", "Aki Along", "Nideun (Amlai)", "Laungtha", "Asang (Kasang)", "Ghu", "Kajauk", "Lemi (Akelong)", "Likhy (Likhaeng)", "Maru"],
  cc: ["MM"]
}, {
  pk: 8079,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Asang Khawngso",
  lc: "cek-x-asangkhawngso",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7537,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Ta-Aw Rengcaa",
  lc: "cek-x-taaw",
  ld: "ltr",
  alt: [],
  cc: ["MM"]
}, {
  pk: 1179,
  ang: "Cen",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Cen",
  lc: "cen",
  ld: "ltr",
  alt: ["Chen", "Icen", "Icen FiForon", "Icen Ibaas", "Ichen"],
  cc: ["NG"]
}, {
  pk: 1180,
  ang: "Cent\xFA\xFAm",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Cent\xFA\xFAm",
  lc: "cet",
  ld: "ltr",
  alt: ["Cen Tuum"],
  cc: ["NG"]
}, {
  pk: 1181,
  ang: "Dikaka",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Dijim-Bwilim",
  lc: "cfa",
  ld: "ltr",
  alt: ["Bwilim (Fitilai)", "Mwana", "Mwomo", "Mwano", "Mona", "Cham", "Dijim (Cam)"],
  cc: ["NG"]
}, {
  pk: 7870,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "D\u01DDjim",
  lc: "cfa-x-dijim",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1182,
  ang: "Cara",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Cara",
  lc: "cfd",
  ld: "ltr",
  alt: ["Chara", "Fakara", "Nfachara", "Pakara", "Tariya", "Tera", "Teriya", "Terri"],
  cc: ["NG"]
}, {
  pk: 1183,
  ang: "Como Karim",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Como Karim",
  lc: "cfg",
  ld: "ltr",
  alt: ["Asom", "Chomo", "Kinzimba", "Kirim", "Kiyu", "Nuadhu", "Shomo Karim", "Shomong"],
  cc: ["NG"]
}, {
  pk: 1184,
  ang: "Chin, Falam",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Falam Chin",
  lc: "cfm",
  ld: "ltr",
  alt: ["Fallam", "Halam Chin", "Hallam", "Tipura", "Falam", "Hallam Chin", "Sim", "Lente (Lyente)", "Zahau-Shimhrin", "Zahau", "Zahao (Lyen-Lyem)", "Yahow", "Tashom", "Taisun (Shunkla)", "Sunkhla", "Chorei", "Ngawn", "Laizo-Shimhrin", "Laizo (Laiso)", "Laizao", "Khualshim (Kwelshin)", "Kalai (Koloi)", "Kaipang", "Hualngo", "Mursum (Molsom)"],
  cc: ["MM"]
}, {
  pk: 7634,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Chorei",
  lc: "cfm-x-chorei",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7594,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kaipeng",
  lc: "cfm-x-kaipeng",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7538,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Tapong",
  lc: "cfm-x-tapong",
  ld: "ltr",
  alt: [],
  cc: ["MM"]
}, {
  pk: 1185,
  ang: "Changriwa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Changriwa",
  lc: "cga",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 1186,
  ang: "Kagayanen",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kagayanen",
  lc: "cgc",
  ld: "ltr",
  alt: ["Cagayano", "Kagay-anen", "Kinagayanen", "Calamian Kagayanen"],
  cc: ["PH"]
}, {
  pk: 1187,
  ang: "Chiga",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Chiga",
  lc: "cgg",
  ld: "ltr",
  alt: ["Ciga", "Kiga", "Nkore-Kiga", "Oluchiga", "Orukiga", "Rukiga", "Runyankore-Rukiga", "RuNyangyezi", "RuSigi", "RuHimba", "RuNyaifwe-Hororo"],
  cc: ["UG"]
}, {
  pk: 8371,
  ang: "Rutwa",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Rutwa",
  lc: "cgg-x-rutwa",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1188,
  ang: "Chocangacakha",
  lr: "Asia",
  gw: false,
  hc: "BT",
  ln: "Chocangacakha",
  lc: "cgk",
  ld: "ltr",
  alt: ["Kursmadkha", "Maphekha", "Rtsamangpa'ikha", "Tsagkaglingpa'ikha"],
  cc: ["BT"]
}, {
  pk: 1189,
  ang: "Chamorro",
  lr: "Pacific",
  gw: false,
  hc: "GU",
  ln: "Chamoru",
  lc: "ch",
  ld: "ltr",
  alt: ["Chamorru", "Tjamoro"],
  cc: ["GU", "US", "FM"]
}, {
  pk: 1190,
  ang: "Chibcha",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Chibcha",
  lc: "chb",
  ld: "ltr",
  alt: [],
  cc: ["CO"]
}, {
  pk: 1191,
  ang: "Catawba",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Catawba",
  lc: "chc",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 1192,
  ang: "Chontal, Highland Oaxaca",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Highland Oaxaca Chontal",
  lc: "chd",
  ld: "ltr",
  alt: ["Chontal de la Sierra de Oaxaca", "Tequistlatec", "Chontal de Oaxaca bajo", "Chontal de Oaxaca alto"],
  cc: ["MX"]
}, {
  pk: 1193,
  ang: "Chontal, Tabasco",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tabasco Chontal",
  lc: "chf",
  ld: "ltr",
  alt: ["Yocot'an", "Chontal de Tabasco del este", "Tamult\xE9 de las S\xE1banas Chontal", "Chontal de Tabasco del norte", "Chontal de Tabasco central", "Chontal de Tabasco del sureste"],
  cc: ["MX"]
}, {
  pk: 1194,
  ang: "Chinook",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Chinook",
  lc: "chh",
  ld: "ltr",
  alt: ["Lower Chinook", "Klatsop (Tlatsop)"],
  cc: ["US"]
}, {
  pk: 1195,
  ang: "Chinantec, Ojitl\xE1n",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Ojitl\xE1n Chinantec",
  lc: "chj",
  ld: "ltr",
  alt: ["Chinantec, Comaltepec", "Chinanteco del Norte", "Chinantec", "Comaltepec"],
  cc: ["MX"]
}, {
  pk: 1196,
  ang: "Chuukese",
  lr: "Pacific",
  gw: false,
  hc: "FM",
  ln: "Chuukese",
  lc: "chk",
  ld: "ltr",
  alt: ["Chuuk", "Lagoon Chuukese", "Ruk", "Truk", "Trukese"],
  cc: ["US", "FM"]
}, {
  pk: 1197,
  ang: "Cahuilla",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Cahuilla",
  lc: "chl",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 1198,
  ang: "Mari",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "Mari (Russia)",
  lc: "chm",
  ld: "ltr",
  alt: [],
  cc: ["RU"]
}, {
  pk: 1199,
  ang: "Chinook Wawa",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Chinook jargon",
  lc: "chn",
  ld: "ltr",
  alt: ["Chinook Jargon", "Chinook Pidgin", "Tsinuk Wawa"],
  cc: ["CA"]
}, {
  pk: 1200,
  ang: "Choctaw",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Choctaw",
  lc: "cho",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 1201,
  ang: "Dene",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Chipewyan",
  lc: "chp",
  ld: "ltr",
  alt: ["D\xEBne S\xFAline"],
  cc: ["CA"]
}, {
  pk: 1202,
  ang: "Chinantec, Quiotepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Quiotepec Chinantec",
  lc: "chq",
  ld: "ltr",
  alt: ["Highland Chinantec", "Yolox Chinanteco"],
  cc: ["MX"]
}, {
  pk: 1203,
  ang: "Cherokee",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Cherokee",
  lc: "chr",
  ld: "ltr",
  alt: ["Tsalagi", "Tslagi", "Upper Cherokee", "Western Cherokee", "Otali (Overhill Cherokee)", "Kituhwa (Middle Cherokee)", "Elati (Eastern Cherokee)", "Lower Cherokee"],
  cc: ["US"]
}, {
  pk: 1204,
  ang: "Chuwabu",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Chuwabu",
  lc: "chw",
  ld: "ltr",
  alt: ["Chichwabo", "Chuwabo", "Chwabo", "Cicuabo", "Cuabo", "Cuwabo", "Echuabo", "Echuwabo", "Txuwabo", "Karungu", "Marale"],
  cc: ["MZ"]
}, {
  pk: 1205,
  ang: "Chantyal",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Chantyal",
  lc: "chx",
  ld: "ltr",
  alt: ["Chantel", "Chantel Kham", "Chhantel", "Khamkura"],
  cc: ["NP"]
}, {
  pk: 1206,
  ang: "Cheyenne",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Cheyenne",
  lc: "chy",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 1207,
  ang: "Chinantec, Ozumac\xEDn",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Ozumac\xEDn Chinantec",
  lc: "chz",
  ld: "ltr",
  alt: ["Chinanteco de Ayotzintepec", "Chinanteco del Sureste Alto", "Juujmii"],
  cc: ["MX"]
}, {
  pk: 1208,
  ang: "Cia-Cia",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Cia-Cia",
  lc: "cia",
  ld: "ltr",
  alt: ["Boetoneezen", "Buton", "Butonese", "Butung", "South Buton", "Southern Butung", "Sampolawa (Mambulu-Laporo)"],
  cc: ["ID"]
}, {
  pk: 1209,
  ang: "Gbe, Ci",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Ci Gbe",
  lc: "cib",
  ld: "ltr",
  alt: ["Ayizo-Ci", "Ci", "Cigbe", "Tchi"],
  cc: ["BJ"]
}, {
  pk: 1210,
  ang: "Chickasaw",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Chickasaw",
  lc: "cic",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 1211,
  ang: "Cineni",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Cineni",
  lc: "cie",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 1212,
  ang: "Chinali",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Chinali",
  lc: "cih",
  ld: "ltr",
  alt: ["Chana", "Channali", "Chinal", "Dagi", "Harijan", "Shipi"],
  cc: ["IN"]
}, {
  pk: 1213,
  ang: "Kinnauri, Chitkuli",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Chitkuli Kinnauri",
  lc: "cik",
  ld: "ltr",
  alt: ["Chitkhuli", "Chitkuli", "Kanauri", "Kinnauri", "Thebarskad", "Ts\xEDhuli", "Tsitkhuli"],
  cc: ["IN"]
}, {
  pk: 1214,
  ang: "Cimbrian",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Cimbrian",
  lc: "cim",
  ld: "ltr",
  alt: ["Tzimbro", "Zimbrisch", "Tredici Communi Cimbrian (Tauch)"],
  cc: ["IT"]
}, {
  pk: 1215,
  ang: "Cinta Larga",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Cinta Larga",
  lc: "cin",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 1216,
  ang: "Chiapanec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Chiapanec",
  lc: "cip",
  ld: "ltr",
  alt: ["Chiapaneco", "Chidigo"],
  cc: ["MX"]
}, {
  pk: 1217,
  ang: "T\xEEr\xEE",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Tiri",
  lc: "cir",
  ld: "ltr",
  alt: ["Ciiri", "Ciri", "Grand Couli", "Ha-Tiri", "Tinrin", "T\xEEr\xEE-M\xE9a", "Xaa Mea", "T\xEEr\xEE", "Hameha", "M\xE9a (Ha Mea)"],
  cc: ["NC"]
}, {
  pk: 1218,
  ang: "Chippewa",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Chippewa",
  lc: "ciw",
  ld: "ltr",
  alt: ["Ojibway", "Ojibwe", "Southwestern Ojibwa", "Upper Michigan-Wisconsin Chippewa"],
  cc: ["US"]
}, {
  pk: 1219,
  ang: "Chaima",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "Chaima",
  lc: "ciy",
  ld: "ltr",
  alt: ["Chayma", "Guaga-Tagare", "Sayma", "Warapiche"],
  cc: ["VE"]
}, {
  pk: 1220,
  ang: "Cham, Western",
  lr: "Asia",
  gw: false,
  hc: "KH",
  ln: "T\xE2y Ch\u0103m",
  lc: "cja",
  ld: "ltr",
  alt: ["Cambodian Cham", "Cham", "New Cham", "Tjam", "Chiem"],
  cc: ["LA", "US", "KH"]
}, {
  pk: 1221,
  ang: "Chru",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Chru",
  lc: "cje",
  ld: "ltr",
  alt: ["Cadoe Loang", "Choru", "Chrau Hma", "Chu", "Chu Ru", "Churu", "Cru", "Kru", "Seyu", "Noang (La-Dang)"],
  cc: ["VN"]
}, {
  pk: 1222,
  ang: "Chehalis, Upper",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Upper Chehalis",
  lc: "cjh",
  ld: "ltr",
  alt: ["Chehalis", "Kwaiailk"],
  cc: ["US"]
}, {
  pk: 1223,
  ang: "Chamalal",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0427\u0430\u043C\u0430\u043B\u0438\u043D\u0441\u043A\u0438\u0439",
  lc: "cji",
  ld: "ltr",
  alt: ["Camalal", "Chamalin", "Kwenkhi", "Gigatl (Hihatl)", "Gakvari (Agvali-Richaganik-Tsumada-Urukh)", "Gadyri (Gachitl-Kvankhi)", "Tsumada"],
  cc: ["RU"]
}, {
  pk: 1224,
  ang: "Cokwe",
  lr: "Africa",
  gw: false,
  hc: "AO",
  ln: "Chokwe",
  lc: "cjk",
  ld: "ltr",
  alt: ["Ciokwe", "Djok", "Kioko", "Quioco", "Shioko", "Tschiokloe", "Tshokwe", "Imo", "Tschiokwe", "Ukhongo", "Ulanda"],
  cc: ["ZM", "AO"]
}, {
  pk: 1225,
  ang: "Cham, Eastern",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "\u0110\xF4ng Ch\u0103m",
  lc: "cjm",
  ld: "ltr",
  alt: ["Bhamam", "Chiem", "Chiem Th\xE0nh", "Tjam"],
  cc: ["VN"]
}, {
  pk: 1226,
  ang: "Chenapian",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Chenapian",
  lc: "cjn",
  ld: "ltr",
  alt: ["Chenap", "Tsenap", "Zenap"],
  cc: ["PG"]
}, {
  pk: 1227,
  ang: "Ash\xE9ninka Pajonal",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Ash\xE9ninka Pajonal",
  lc: "cjo",
  ld: "ltr",
  alt: ["Ash\xE9ninca", "Atsiri", "Pajonal", "Campa"],
  cc: ["PE"]
}, {
  pk: 1228,
  ang: "Cab\xE9car",
  lr: "Americas",
  gw: false,
  hc: "CR",
  ln: "Cab\xE9car",
  lc: "cjp",
  ld: "ltr",
  alt: ["Chirrip\xF3"],
  cc: ["CR"]
}, {
  pk: 1229,
  ang: "Shor",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0428\u043E\u0440\u0441\u043A\u0438\u0439",
  lc: "cjs",
  ld: "ltr",
  alt: ["Aba", "Kondoma Tatar", "Kuznets Tatar", "Mras Tatar", "Shortsy", "Tom-Kuznets Tatar", "Mrassa (Mrasu)"],
  cc: ["RU"]
}, {
  pk: 1230,
  ang: "Chuave",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Chuave",
  lc: "cjv",
  ld: "ltr",
  alt: ["Tjuave", "Sua"],
  cc: ["PG"]
}, {
  pk: 1231,
  ang: "Chinese, Jinyu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u664B\u8BED",
  lc: "cjy",
  ld: "ltr",
  alt: ["Jin", "Jinyu", "Changzhi", "Pingyao"],
  cc: ["CN"]
}, {
  pk: 1232,
  ang: "Kurdish, Central",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u0633\u0648\u0631\u0627\u0646\u06CC",
  lc: "ckb",
  ld: "rtl",
  alt: ["Kordi", "Korkora", "Kurdy", "Mokri", "Sine'i", "Wawa", "Kerkuki", "Warmawa", "Suleimani (Silemani)", "Southern Jafi", "Sanandaji (Sina'i)", "Sineyi", "Xoshnaw", "Pijdari", "Hewleri (Arbili)", "Garmiyani", "Bingird", "Mukri (Kordi)", "Rewandiz"],
  cc: ["IR", "IQ", "US", "JO", "TM"]
}, {
  pk: 1233,
  ang: "Chak",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Chak",
  lc: "ckh",
  ld: "ltr",
  alt: ["Sak", "Tsak", "Ashah", "Thet"],
  cc: ["BD", "MM"]
}, {
  pk: 1234,
  ang: "Kibaku",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Cibak",
  lc: "ckl",
  ld: "ltr",
  alt: ["Chibbak", "Chibbuk", "Chibok", "Chibuk", "Cibuk", "Kibaku", "Kibbaku", "Kikuk", "Kyibaku"],
  cc: ["NG"]
}, {
  pk: 1235,
  ang: "Chin, Kaang",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Kaang Chin",
  lc: "ckn",
  ld: "ltr",
  alt: ["Kang", "Mgan", "M'kaang", "Mkan"],
  cc: ["MM"]
}, {
  pk: 1236,
  ang: "Anufo",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Anufo",
  lc: "cko",
  ld: "ltr",
  alt: ["Chakosi", "Chokosi", "Chokossi", "Kyokosi", "Tiokossi"],
  cc: ["BJ", "GH", "TG"]
}, {
  pk: 1237,
  ang: "Kajakse",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Kajakse",
  lc: "ckq",
  ld: "ltr",
  alt: ["Kadjakse", "Kajeske", "Kawa Tadimini", "Kujarke", "Mini"],
  cc: ["TD"]
}, {
  pk: 1238,
  ang: "Kairak",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kairak",
  lc: "ckr",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 1239,
  ang: "Tayo",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Tayo",
  lc: "cks",
  ld: "ltr",
  alt: ["Patois", "Patois de St-Louis"],
  cc: ["NC"]
}, {
  pk: 1240,
  ang: "Chukchi",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0427\u0443\u043A\u043E\u0442\u0441\u043A\u0438\u0439",
  lc: "ckt",
  ld: "ltr",
  alt: ["Chuchee", "Chukcha", "Chukchee", "Chukot", "Luoravetlan"],
  cc: ["RU"]
}, {
  pk: 1241,
  ang: "Koasati",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Koasati",
  lc: "cku",
  ld: "ltr",
  alt: ["Coushatta"],
  cc: ["US"]
}, {
  pk: 1242,
  ang: "Kavalan",
  lr: "Asia",
  gw: false,
  hc: "TW",
  ln: "Kavalan",
  lc: "ckv",
  ld: "ltr",
  alt: ["Cabaran", "Kabalan", "Kabaran", "Kamalan", "Kavanan", "Kavarauan", "Kbalan", "Kibalan", "Kiwaraw", "Kiwarawa", "Kuvalan", "Kuvarawan", "Kuwarawan", "Kvalan", "Shekwan", "Kareovan (Kareowan)"],
  cc: ["TW"]
}, {
  pk: 1243,
  ang: "Caka",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Caka",
  lc: "ckx",
  ld: "ltr",
  alt: ["Assaka (Adzu Balaka)", "Batanga (Adzu Batanga)"],
  cc: ["CM"]
}, {
  pk: 1244,
  ang: "Cakfem-Mushere",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Cakfem-Mushere",
  lc: "cky",
  ld: "ltr",
  alt: ["Chokfem", "Kadim-Kaban"],
  cc: ["NG"]
}, {
  pk: 1245,
  ang: "Kaqchikel-K\u2019iche\u2019 Mixed Language",
  lr: "Americas",
  gw: false,
  hc: "GT",
  ln: "Cakchiquel-Quich\xE9 Mixed Language",
  lc: "ckz",
  ld: "ltr",
  alt: ["Cauque Mixed Language"],
  cc: ["GT"]
}, {
  pk: 1246,
  ang: "Ron",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ron",
  lc: "cla",
  ld: "ltr",
  alt: ["Chala", "Challa", "Monguna (Maleni)", "Nafunfia", "Daffo-Butura (Lis Ma Run)", "Bokkos (Alis I Run)", "Shagawu"],
  cc: ["NG"]
}, {
  pk: 1247,
  ang: "Chilcotin",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Chilcotin",
  lc: "clc",
  ld: "ltr",
  alt: ["Tzilkotin"],
  cc: ["CA"]
}, {
  pk: 1248,
  ang: "Chaldean Neo-Aramaic",
  lr: "Asia",
  gw: false,
  hc: "IQ",
  ln: "\u0723\u0718\u073C\u072A\u0732\u071D\u072C",
  lc: "cld",
  ld: "ltr",
  alt: ["Fallani", "Fellihi", "Kaldaya", "Kildani", "Lishana Kaldaya", "Modern Chaldean", "Neo-Chaldean", "Soorath", "Soorith", "Suras", "Sureth", "Shirnak-Chizre (Bohtan)"],
  cc: ["DE", "IQ", "NL", "SY", "TR"]
}, {
  pk: 1249,
  ang: "Chinantec, Lealao",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Lealao Chinantec",
  lc: "cle",
  ld: "ltr",
  alt: ["Chinanteco de San Juan Lealao"],
  cc: ["MX"]
}, {
  pk: 1250,
  ang: "Chilisso",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u0686\u06CC\u0644\u06CC\u0633\u0648",
  lc: "clh",
  ld: "ltr",
  alt: ["Chiliss", "Galos"],
  cc: ["PK"]
}, {
  pk: 1251,
  ang: "Chakali",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Chakali",
  lc: "cli",
  ld: "ltr",
  alt: [],
  cc: ["GH"]
}, {
  pk: 1252,
  ang: "Chin, Laitu",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Laitu Chin",
  lc: "clj",
  ld: "ltr",
  alt: ["Daitu", "Hio Bei", "Hle-tu", "Laikhy", "Laitu Kheu", "Ledu", "Leitu", "Dalet Stream (Lawktu)", "Panmyawogyi River (Kawngtu)", "Phuntha Stream (Daaitu)"],
  cc: ["MM"]
}, {
  pk: 1253,
  ang: "Idu-Mishmi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Idu-Mishmi",
  lc: "clk",
  ld: "ltr",
  alt: ["Chulikata", "Idu Lhoba", "Idu Mishmi", "Lhoba", "Lho-Pa", "Yidu", "Ida", "Idu", "Midhi", "Midu", "Yidu Luoba", "Chulikotta"],
  cc: ["CN", "IN"]
}, {
  pk: 1254,
  ang: "Chala",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Chala",
  lc: "cll",
  ld: "ltr",
  alt: ["Cala", "Tshala"],
  cc: ["GH"]
}, {
  pk: 1255,
  ang: "Clallam",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Clallam",
  lc: "clm",
  ld: "ltr",
  alt: ["Klallam", "Na'klallam", "S'klallam"],
  cc: ["US"]
}, {
  pk: 1256,
  ang: "Chontal, Lowland Oaxaca",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Lowland Oaxaca Chontal",
  lc: "clo",
  ld: "ltr",
  alt: ["Chontal de la Costa de Oaxaca", "Chontal de Oaxaca de la costa", "Huamelula Chontal", "Huamelulteco"],
  cc: ["MX"]
}, {
  pk: 1257,
  ang: "Chin, Lautu",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Lautu Chin",
  lc: "clt",
  ld: "ltr",
  alt: ["Lawhtu"],
  cc: ["MM"]
}, {
  pk: 1258,
  ang: "Caluyanun",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Caluyanun",
  lc: "clu",
  ld: "ltr",
  alt: ["Caluyanen", "Caluyanhon"],
  cc: ["PH"]
}, {
  pk: 1259,
  ang: "Chulym",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0427\u0443\u043B\u044B\u043C\u0441\u043A\u0438\u0439",
  lc: "clw",
  ld: "ltr",
  alt: ["Chulim", "Chulym Tatar", "Chulym-Turkish", "Melets Tatar"],
  cc: ["RU"]
}, {
  pk: 1260,
  ang: "Chatino, Eastern Highland",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Eastern Highland Chatino",
  lc: "cly",
  ld: "ltr",
  alt: ["Chatino de la Zona Alta Oriental", "Chatino Oriental Alto", "Lachao-Yolotepec Chatino", "Sierra Oriental Chatino"],
  cc: ["MX"]
}, {
  pk: 1261,
  ang: "Maa",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Maa",
  lc: "cma",
  ld: "ltr",
  alt: ["Chauma", "Che Ma", "Ma Krung", "Ma Ngan", "Ma To", "Ma Xop", "Maaq"],
  cc: ["VN"]
}, {
  pk: 1262,
  ang: "Cerma",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Cerma",
  lc: "cme",
  ld: "ltr",
  alt: ["Gwe", "Gwen", "Kirma", "Guin"],
  cc: ["BF"]
}, {
  pk: 1263,
  ang: "Classical Mongolian",
  lr: "Asia",
  gw: false,
  hc: "MN",
  ln: "Classical Mongolian",
  lc: "cmg",
  ld: "ltr",
  alt: [],
  cc: ["MN"]
}, {
  pk: 1264,
  ang: "Ember\xE1-Cham\xED",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Ember\xE1-Cham\xED",
  lc: "cmi",
  ld: "ltr",
  alt: ["Chami"],
  cc: ["CO"]
}, {
  pk: 1265,
  ang: "Campalagian",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Campalagian",
  lc: "cml",
  ld: "ltr",
  alt: ["Tallumpanuae", "Tasing", "Tjampalagian"],
  cc: ["ID"]
}, {
  pk: 1266,
  ang: "Michigamea",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Michigamea",
  lc: "cmm",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 1267,
  ang: "Chinese, Mandarin",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5B98\u8BDD",
  lc: "cmn",
  ld: "ltr",
  alt: ["Beifang Fangyan", "Guanhua", "Guoyu", "Hanyu", "Huayu", "Northern Chinese", "Putonghua", "Standard Chinese", "Zhongguohua", "Zhongwen", "Tayok", "Hoton", "Hui-Zu", "Hytad", "Khoton", "Qotong", "Xui", "Kuoyu", "Jiangxia Guanhua", "Xibei Guanhua (Northwestern Mandarin)", "Western Mandarin", "Pathee", "Panthe", "Pantha", "Xinan Guanhua (Southwestern Mandarin)", "Panghse", "Jinghuai Guanhua (Eastern Mandarin)", "Hwei", "Hui-Tze", "Huabei Guanhua (Northern Mandarin)", "Ho (Cin Haw)", "Haw", "Lower Yangze Mandarin", "Kokang (Kokant)"],
  cc: ["DZ", "AT", "BS", "BD", "BE", "CL", "BR", "BB", "CN", "BZ", "CU", "DM", "GR", "AR", "FJ", "FR", "DE", "VE", "HU", "JP", "KE", "KI", "KR", "MG", "MU", "LK", "PE", "ES", "CZ", "CR", "CX", "MY", "MZ", "MX", "NP", "NL", "NC", "NZ", "PK", "PY", "HN", "RO", "SC", "ZA", "SB", "CH", "TZ", "CO", "TH", "TV", "TR", "US", "ZM", "ZW", "AU", "BO", "KH", "CA", "AO", "EC", "KP", "IT", "KG", "CC", "LS", "NR", "NI", "FM", "PT", "PG", "LC", "VU", "UZ", "IN", "SG", "MM", "BW", "MQ", "AE"]
}, {
  pk: 7557,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Gesu",
  lc: "cmn-x-gesu",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7562,
  ang: "",
  lr: "Asia",
  gw: true,
  hc: "CN",
  ln: "Oral Mandarin Chinese",
  lc: "cmn-x-omc",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 1268,
  ang: "Mnong, Central",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Central Mnong",
  lc: "cmo",
  ld: "ltr",
  alt: ["Budong", "Bunong", "Phanong", "Phnong", "Phong", "Budang", "Pnong", "Biat (Bhi\xE9t)", "Dih Bri (Di-Pri)", "Pr\xE9h (Pre)"],
  cc: ["KH", "VN"]
}, {
  pk: 1269,
  ang: "Chin, Mro-Khimi",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Mro-Khimi Chin",
  lc: "cmr",
  ld: "ltr",
  alt: ["Awa Khami", "Khimi", "Khumi Awa", "Mro", "Mro Chin", "Vakung", "Wakun", "Wakung", "Aroeng", "Xengna (Hrengna)", "Vakung (Wakung)", "Areung", "Arang (Ahraing Khami)", "Xata"],
  cc: ["MM"]
}, {
  pk: 1270,
  ang: "Messapic",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Messapic",
  lc: "cms",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 1271,
  ang: "Camtho",
  lr: "Africa",
  gw: false,
  hc: "ZA",
  ln: "Camtho",
  lc: "cmt",
  ld: "ltr",
  alt: ["Iscamtho", "Isicamtho", "Tsotsitaal"],
  cc: ["ZA"]
}, {
  pk: 1272,
  ang: "Changthang",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Changthang",
  lc: "cna",
  ld: "ltr",
  alt: ["Byangskat", "Byanskat", "Changs-Skat", "Changtang", "Changtang Ladakhi", "Rong", "Rupshu", "Stotpa", "Upper Ladakhi"],
  cc: ["IN"]
}, {
  pk: 1273,
  ang: "Chin, Chinbon",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Chinbon Chin",
  lc: "cnb",
  ld: "ltr",
  alt: ["Chindwin Chin", "Chinpon", "Oo-pu", "Sho", "Tuishiip", "Tuiship", "Uppu", "\xDCtb\xFC"],
  cc: ["MM"]
}, {
  pk: 1274,
  ang: "C\xF4\xF4ng",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "C\xF4\xF4ng",
  lc: "cnc",
  ld: "ltr",
  alt: ["Khoong", "Xa Coong", "Xa Xam", "Xa Xeng"],
  cc: ["VN"]
}, {
  pk: 1275,
  ang: "Qiang, Northern",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Northern Qiang",
  lc: "cng",
  ld: "ltr",
  alt: ["Ch'iang", "Mawo"],
  cc: ["CN"]
}, {
  pk: 1276,
  ang: "Chin, Haka",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Haka Chin",
  lc: "cnh",
  ld: "ltr",
  alt: ["Baungshe", "Lai", "Lai Hawlh", "Lai Pawi", "Hakha", "Klangklang (Thlantlang)"],
  cc: ["MM"]
}, {
  pk: 1277,
  ang: "Ash\xE1ninka",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Ash\xE1ninka",
  lc: "cni",
  ld: "ltr",
  alt: ["Ash\xE1ninca", "Campa"],
  cc: ["PE"]
}, {
  pk: 1278,
  ang: "Chin, Khumi",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Khumi Chin",
  lc: "cnk",
  ld: "ltr",
  alt: ["Khuni", "Khweymi", "Kami", "Khumi", "Kumi", "Common Khumi", "Kaladan Khumi", "Yangpan", "Eastern Kaladan", "Kaladan", "Pi Chaung", "Southern Paletwa", "Yindi (Yindu)"],
  cc: ["BD", "MM"]
}, {
  pk: 7725,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Kanise Khumi",
  lc: "cnk-x-kanise",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1279,
  ang: "Chinantec, Lalana",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Lalana Chinantec",
  lc: "cnl",
  ld: "ltr",
  alt: ["Chinanteco de San Juan Lalana", "Chinanteco del Sureste Bajo"],
  cc: ["MX"]
}, {
  pk: 1280,
  ang: "Con",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Con",
  lc: "cno",
  ld: "ltr",
  alt: [],
  cc: ["LA"]
}, {
  pk: 1281,
  ang: "Asmat, Central",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Central Asmat",
  lc: "cns",
  ld: "ltr",
  alt: ["Jas", "Manowee", "Yas", "Ajam (Ayam)", "Simai (Simay)"],
  cc: ["ID"]
}, {
  pk: 1282,
  ang: "Chinantec, Tepetotutla",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tepetotutla Chinantec",
  lc: "cnt",
  ld: "ltr",
  alt: ["Chinanteco del Oeste Central Bajo"],
  cc: ["MX"]
}, {
  pk: 1283,
  ang: "Chenoua",
  lr: "Africa",
  gw: false,
  hc: "DZ",
  ln: "\u0644\u0647\u062C\u0629 \u0634\u0646\u0627\u0648\u064A\u0629",
  lc: "cnu",
  ld: "ltr",
  alt: ["Chenoui", "Tachelhit", "Tamazight de l\u2019Atlas blid\xE9en (Beni-Salah)", "Tamenracit", "Beni Menacer (Chleuh)", "Djebel Bissa"],
  cc: ["DZ"]
}, {
  pk: 1284,
  ang: "Chin, Ngawn",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Ngawn Chin",
  lc: "cnw",
  ld: "ltr",
  alt: ["Ngawn", "Ngon", "Ngorn"],
  cc: ["MM"]
}, {
  pk: 1285,
  ang: "Middle Cornish",
  lr: "Europe",
  gw: false,
  hc: "GB",
  ln: "Middle Cornish",
  lc: "cnx",
  ld: "ltr",
  alt: [],
  cc: ["GB"]
}, {
  pk: 1286,
  ang: "Corsican",
  lr: "Europe",
  gw: false,
  hc: "FR",
  ln: "corsu, lingua corsa",
  lc: "co",
  ld: "ltr",
  alt: ["Corse", "Corsi", "Corso", "Corsu", "Cape Cors", "Northern Corsican (Bastia)", "Corsos"],
  cc: ["FR"]
}, {
  pk: 1287,
  ang: "Malay, Cocos Islands",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Cocos Islands Malay",
  lc: "coa",
  ld: "ltr",
  alt: ["Cocos", "Kokos", "Kukus"],
  cc: ["CX", "MY", "CC"]
}, {
  pk: 1288,
  ang: "Chicomuceltec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Chicomuceltec",
  lc: "cob",
  ld: "ltr",
  alt: ["Cakchiquel Mam", "Cac'chiquel Mam", "Chicomulcelteco"],
  cc: ["MX"]
}, {
  pk: 1289,
  ang: "Cocopa",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Cocopa",
  lc: "coc",
  ld: "ltr",
  alt: ["Cocop\xE1", "Cucap\xE1", "Cucup\xE1", "Kikim\xE1", "Kwikap\xE1", "Delta River Yuman", "Kikima", "Kwikapa"],
  cc: ["MX", "US"]
}, {
  pk: 1290,
  ang: "Cocama-Cocamilla",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Cocama-Cocamilla",
  lc: "cod",
  ld: "ltr",
  alt: ["Kokama", "Huallaga", "Pampadeque", "Pandequebo", "Ucayali", "Xibitaoan", "Cocamilla (Kokamilla)", "Pambadeque", "Xibitaona"],
  cc: ["BR", "PE", "CO"]
}, {
  pk: 1291,
  ang: "Koreguaje",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Koreguaje",
  lc: "coe",
  ld: "ltr",
  alt: ["Caquet\xE1", "Chaocha Pai", "Correguaje", "Ko'reuaju"],
  cc: ["CO"]
}, {
  pk: 1292,
  ang: "Colorado",
  lr: "Americas",
  gw: false,
  hc: "EC",
  ln: "Colorado",
  lc: "cof",
  ld: "ltr",
  alt: ["Tsachila", "Tsafiki", "Tsafiqui"],
  cc: ["EC"]
}, {
  pk: 1293,
  ang: "Chong",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "\u0E20\u0E32\u0E29\u0E32\u0E0A\u0E2D\u0E07",
  lc: "cog",
  ld: "ltr",
  alt: ["Chawng", "Shong", "Xong"],
  cc: ["TH", "KH"]
}, {
  pk: 8378,
  ang: "Kola",
  lr: "Asia",
  gw: false,
  hc: "KH",
  ln: "Kola",
  lc: "cog-x-kola",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1294,
  ang: "Chichonyi-Chidzihana-Chikauma",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Chonyi-Dzihana-Kauma",
  lc: "coh",
  ld: "ltr",
  alt: ["Kichonyi", "Chonyi (Chichonyi)", "Jibana (Chidzihana)"],
  cc: ["KE"]
}, {
  pk: 1295,
  ang: "Cochimi",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Cochimi",
  lc: "coj",
  ld: "ltr",
  alt: ["Cadegome\xF1o", "Cadegomo", "Cochetimi", "Cochima", "Cochimtee", "Didiu", "Joaqu\xEDn", "Laimon", "Laymon-Cochimi", "Laymonem", "San", "San Francesco Saverio Mission", "San Francisco Xavier de", "San Javier", "San Xavier", "Vigg\xE9-Biaundo Mission"],
  cc: ["MX"]
}, {
  pk: 1296,
  ang: "Cora, Santa Teresa",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Santa Teresa Cora",
  lc: "cok",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 1297,
  ang: "Columbia-Wenatchi",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Columbia-Wenatchi",
  lc: "col",
  ld: "ltr",
  alt: ["Chelan", "Columbian", "Moses-Colombia", "Moses-Colombia Salish", "Wenatchee", "Wenatchi-Columbia", "Columbia (Columbian)", "Entiat", "Sinkiuse", "Wenatchi (Chelan)"],
  cc: ["US"]
}, {
  pk: 1298,
  ang: "Comanche",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Comanche",
  lc: "com",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 1299,
  ang: "Cof\xE1n",
  lr: "Americas",
  gw: false,
  hc: "EC",
  ln: "Cof\xE1n",
  lc: "con",
  ld: "ltr",
  alt: ["A'i", "A'ingae", "Kofan", "Kofane", "Kof\xE1n"],
  cc: ["CO", "EC"]
}, {
  pk: 1300,
  ang: "Comox",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Comox",
  lc: "coo",
  ld: "ltr",
  alt: ["Comox-Sliammon", "Klahoose", "Mainland Comox (Homalco)"],
  cc: ["CA"]
}, {
  pk: 1301,
  ang: "Coptic",
  lr: "Africa",
  gw: false,
  hc: "EG",
  ln: "\u0644\u063A\u0629 \u0642\u0628\u0637\u064A\u0629",
  lc: "cop",
  ld: "ltr",
  alt: ["Neo-Egyptian"],
  cc: ["EG"]
}, {
  pk: 1302,
  ang: "Caquinte",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Caquinte",
  lc: "cot",
  ld: "ltr",
  alt: ["Caquinte Campa", "Poyenisati", "Cachomashiri"],
  cc: ["PE"]
}, {
  pk: 1303,
  ang: "Wamey",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Wamey",
  lc: "cou",
  ld: "ltr",
  alt: ["Cogniagui", "Conhague", "Koniagi", "Konyagi", "Tenda", "Wamay", "Wamei", "Koniagui"],
  cc: ["SN", "GN"]
}, {
  pk: 1304,
  ang: "Cao Miao",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u8349\u82D7",
  lc: "cov",
  ld: "ltr",
  alt: ["Grass Miao", "Mjiuniang", "Sanjiang Miao"],
  cc: ["CN"]
}, {
  pk: 1305,
  ang: "Cowlitz",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Cowlitz",
  lc: "cow",
  ld: "ltr",
  alt: ["Lower Cowlitz"],
  cc: ["US"]
}, {
  pk: 1306,
  ang: "Nanti",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Nanti",
  lc: "cox",
  ld: "ltr",
  alt: ["Cogapacori", "Kogapakori"],
  cc: ["PE"]
}, {
  pk: 1307,
  ang: "Chocholtec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Chochotec",
  lc: "coz",
  ld: "ltr",
  alt: ["Chocho", "Chocholteco", "Chochon", "Chochonteco", "Chochotec", "Chocholteco del este", "Chocholteco del oeste", "Chocholteco del sur"],
  cc: ["MX"]
}, {
  pk: 1308,
  ang: "Chinantec, Palantla",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Palantla Chinantec",
  lc: "cpa",
  ld: "ltr",
  alt: ["Chinanteco de San Pedro Tlatepuzco"],
  cc: ["MX"]
}, {
  pk: 1309,
  ang: "Ash\xE9ninka, Ucayali-Yur\xFAa",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Ucayali-Yur\xFAa Ash\xE9ninka",
  lc: "cpb",
  ld: "ltr",
  alt: ["Campa", "Kampa", "Ucayali Ash\xE9ninca"],
  cc: ["PE"]
}, {
  pk: 1310,
  ang: "Ajy\xEDninka Apurucayali",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Ajy\xEDninka Apurucayali",
  lc: "cpc",
  ld: "ltr",
  alt: ["Ajy\xE9ninka", "Apurucayali Campa", "Ashaninca", "Ash\xE9ninca Apurucayali", "Axininka Campa", "Campa"],
  cc: ["PE"]
}, {
  pk: 1311,
  ang: "Cappadocian Greek",
  lr: "Europe",
  gw: false,
  hc: "GR",
  ln: "Cappadocian Greek",
  lc: "cpg",
  ld: "ltr",
  alt: ["Pharasa", "Sille", "Mistiot (Misti)", "Western Cappadocian"],
  cc: ["GR"]
}, {
  pk: 1312,
  ang: "Chinese Pidgin English",
  lr: "Pacific",
  gw: false,
  hc: "NR",
  ln: "Chinese Pidgin English",
  lc: "cpi",
  ld: "ltr",
  alt: ["Melanesian-Chinese Mixed Pidgin English"],
  cc: ["NR"]
}, {
  pk: 1313,
  ang: "Cherepon",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Cherepon",
  lc: "cpn",
  ld: "ltr",
  alt: ["Chiripong", "Kyerepong", "Okere"],
  cc: ["GH"]
}, {
  pk: 1314,
  ang: "Kpeego",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Kpeego",
  lc: "cpo",
  ld: "ltr",
  alt: ["Noumou", "Noumoukan", "Numu"],
  cc: ["BF"]
}, {
  pk: 1315,
  ang: "Capiznon",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Capiznon",
  lc: "cps",
  ld: "ltr",
  alt: ["Capisano", "Capise\xF1o"],
  cc: ["PH"]
}, {
  pk: 1316,
  ang: "Ash\xE9ninka, Pichis",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Pichis Ash\xE9ninka",
  lc: "cpu",
  ld: "ltr",
  alt: ["Pichis Ash\xE9ninca", "Pichis Campa"],
  cc: ["BR", "PE"]
}, {
  pk: 1317,
  ang: "Chinese, Pu-Xian",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u8386\u4ED9\u8BDD",
  lc: "cpx",
  ld: "ltr",
  alt: ["Henghua", "Hinghua", "Hsienyu", "Hsinghua", "Putian", "Putten", "Henghua (Hinghua)", "Xinghua (Hinghua)"],
  cc: ["CN"]
}, {
  pk: 1318,
  ang: "Ash\xE9ninka, South Ucayali",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "South Ucayali Ash\xE9ninka",
  lc: "cpy",
  ld: "ltr",
  alt: [],
  cc: ["PE"]
}, {
  pk: 1319,
  ang: "Miao, Chuanqiandian Cluster",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u82D7\u8BED\u5DDD\u9ED4\u6EC7\u65B9\u8A00",
  lc: "cqd",
  ld: "ltr",
  alt: ["Chuanchientien Miao", "Chuanqiandian Miao", "Core Farwestern Hmongic", "Sichuan-Guizhou-Yunnan Miao", "Western Miao", "Hmon"],
  cc: ["CN"]
}, {
  pk: 1320,
  ang: "Quechua, Chilean",
  lr: "Americas",
  gw: false,
  hc: "CL",
  ln: "Chilean Quechua",
  lc: "cqu",
  ld: "ltr",
  alt: [],
  cc: ["CL"]
}, {
  pk: 1321,
  ang: "Cree",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "\u14C0\u1426\u1403\u152D\u140D\u140F\u1423",
  lc: "cr",
  ld: "ltr",
  alt: [],
  cc: ["CA"]
}, {
  pk: 1322,
  ang: "Chara",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Chara",
  lc: "cra",
  ld: "ltr",
  alt: ["Ciara", "Buch'a"],
  cc: ["ET"]
}, {
  pk: 1323,
  ang: "Island Carib",
  lr: "Americas",
  gw: false,
  hc: "GP",
  ln: "Island Carib",
  lc: "crb",
  ld: "ltr",
  alt: [],
  cc: ["GP"]
}, {
  pk: 1324,
  ang: "Lonwolwol",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Lonwolwol",
  lc: "crc",
  ld: "ltr",
  alt: ["Craig Cove", "Fali", "Fanting", "West Ambrym"],
  cc: ["VU"]
}, {
  pk: 1325,
  ang: "Coeur d\u2019Alene",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Coeur d'Alene",
  lc: "crd",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 1326,
  ang: "Michif",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Michif",
  lc: "crg",
  ld: "ltr",
  alt: ["French Cree", "M\xE9tis", "Mitchif"],
  cc: ["US", "CA"]
}, {
  pk: 1327,
  ang: "Crimean Tatar",
  lr: "Europe",
  gw: false,
  hc: "UA",
  ln: "Crimean Tatar",
  lc: "crh",
  ld: "ltr",
  alt: ["Crimean", "Crimean Turkish", "Northern Crimean (Crimean Nogai)", "Steppe Crimean"],
  cc: ["KZ", "TJ", "KG", "UZ", "BG", "UA"]
}, {
  pk: 1328,
  ang: "S\xE3otomense",
  lr: "Africa",
  gw: false,
  hc: "ST",
  ln: "S\xE3otomense",
  lc: "cri",
  ld: "ltr",
  alt: ["Forro", "Santomense", "S\xE3o Tomense"],
  cc: ["GQ", "ST"]
}, {
  pk: 1329,
  ang: "Cree, Southern East",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Southern East Cree",
  lc: "crj",
  ld: "ltr",
  alt: ["Eastern James Bay Cree Southern Dialect", "James Bay Cree Southern Dialect"],
  cc: ["CA"]
}, {
  pk: 1330,
  ang: "Cree, Plains",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Plains Cree",
  lc: "crk",
  ld: "ltr",
  alt: ["Western Cree", "Northern Alberta Cree"],
  cc: ["US", "CA"]
}, {
  pk: 1331,
  ang: "Cree, Northern East",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Northern East Cree",
  lc: "crl",
  ld: "ltr",
  alt: ["Eastern James Bay Cree Northern Dialect", "James Bay Cree Northern"],
  cc: ["CA"]
}, {
  pk: 1332,
  ang: "Cree, Moose",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Moose Cree",
  lc: "crm",
  ld: "ltr",
  alt: ["West Main Cree", "West Shore Cree", "York Cree"],
  cc: ["CA"]
}, {
  pk: 1333,
  ang: "Cora, El Nayar",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "El Nayar Cora",
  lc: "crn",
  ld: "ltr",
  alt: ["Cora de El Nayar", "Cora corape\xF1o", "Cora de Dolores", "Cora de Rosarito", "El Nayar", "Jes\xFAs Mar\xEDa Cora (Cora de Jes\xFAs Mar\xEDa)", "La Mesa del Nayar Cora (Cora mese\xF1o)", "Presidio de los Reyes Cora (Cora preside\xF1o)", "San Francisco Cora (Cora francisque\xF1o)"],
  cc: ["MX", "US"]
}, {
  pk: 1334,
  ang: "Crow",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Crow",
  lc: "cro",
  ld: "ltr",
  alt: ["Apsaalooke"],
  cc: ["US"]
}, {
  pk: 1335,
  ang: "Chorote, Iyo\u2019wujwa",
  lr: "Americas",
  gw: false,
  hc: "AR",
  ln: "Iyo'wujwa Chorote",
  lc: "crq",
  ld: "ltr",
  alt: ["Chorote", "Choroti", "Inkijwas", "I'no'", "Manjuy", "Yofu\xE1ha", "Manjui (Inkijwas)", "Choroti (Chorote)", "Chorote (Iyowujwa)", "Yow\xFAwa"],
  cc: ["AR", "PY"]
}, {
  pk: 1336,
  ang: "Carolina Algonquin",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Carolina Algonquian",
  lc: "crr",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 1337,
  ang: "Seselwa Creole French",
  lr: "Africa",
  gw: false,
  hc: "SC",
  ln: "Seselwa Creole French",
  lc: "crs",
  ld: "ltr",
  alt: ["Creole", "Ilois", "Kreol", "Kreol Seselwa", "Seselwa", "Seychelles Creole French", "Seychellois Creole"],
  cc: ["KE", "GB", "SC", "CA"]
}, {
  pk: 1338,
  ang: "Chorote, Iyojwa\u2019ja",
  lr: "Americas",
  gw: false,
  hc: "AR",
  ln: "Iyojwa'ja Chorote",
  lc: "crt",
  ld: "ltr",
  alt: ["Eklenjuy", "Yofuaha"],
  cc: ["AR"]
}, {
  pk: 1339,
  ang: "Chaura",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Chaura",
  lc: "crv",
  ld: "ltr",
  alt: ["Tutet"],
  cc: ["IN"]
}, {
  pk: 1340,
  ang: "Chrau",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Chrau",
  lc: "crw",
  ld: "ltr",
  alt: ["Chauro", "Choro", "Ro", "Dor (Doro)", "Jro"],
  cc: ["VN"]
}, {
  pk: 1341,
  ang: "Carrier",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Carrier",
  lc: "crx",
  ld: "ltr",
  alt: ["Central Carrier", "Middle River", "Tachie", "Portage", "Necoslie", "Grand Rapids", "Pinchie"],
  cc: ["CA"]
}, {
  pk: 1342,
  ang: "Cori",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Cori",
  lc: "cry",
  ld: "ltr",
  alt: ["Chori"],
  cc: ["NG"]
}, {
  pk: 1343,
  ang: "Cruze\xF1o",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Cruze\xF1o",
  lc: "crz",
  ld: "ltr",
  alt: ["Island Chumash", "Isle\xF1o"],
  cc: ["US"]
}, {
  pk: 1344,
  ang: "Czech",
  lr: "Europe",
  gw: false,
  hc: "CZ",
  ln: "\u010De\u0161tina, \u010Desk\xFD jazyk",
  lc: "cs",
  ld: "ltr",
  alt: ["Bohemian", "Cestina", "Lach (Yalach)"],
  cc: ["AT", "AR", "FR", "GB", "CZ", "SK", "SE", "CH", "US", "AU", "CA"]
}, {
  pk: 1345,
  ang: "Chinantec, Chiltepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Chiltepec Chinantec",
  lc: "csa",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 1346,
  ang: "Kashubian",
  lr: "Europe",
  gw: false,
  hc: "PL",
  ln: "Kashubian",
  lc: "csb",
  ld: "ltr",
  alt: ["Cashubian", "Cassubian", "Kaszubski"],
  cc: ["PL"]
}, {
  pk: 1347,
  ang: "Catalan Sign Language",
  lr: "Europe",
  gw: false,
  hc: "ES",
  ln: "Catalan Sign Language",
  lc: "csc",
  ld: "ltr",
  alt: ["Catalana", "Lengua de Se\xF1as Catalana", "Llengua de Signes", "LSC", "Signos Catalana"],
  cc: ["ES"]
}, {
  pk: 1348,
  ang: "Chiangmai Sign Language",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Chiangmai Sign Language",
  lc: "csd",
  ld: "ltr",
  alt: ["Chiengmai Sign Language"],
  cc: ["TH"]
}, {
  pk: 1349,
  ang: "Czech Sign Language",
  lr: "Europe",
  gw: false,
  hc: "CZ",
  ln: "Czech Sign Language",
  lc: "cse",
  ld: "ltr",
  alt: [],
  cc: ["CZ"]
}, {
  pk: 1350,
  ang: "Cuba Sign Language",
  lr: "Americas",
  gw: false,
  hc: "CU",
  ln: "Cuba Sign Language",
  lc: "csf",
  ld: "ltr",
  alt: [],
  cc: ["CU"]
}, {
  pk: 1351,
  ang: "Chilean Sign Language",
  lr: "Americas",
  gw: false,
  hc: "CL",
  ln: "Chilean Sign Language",
  lc: "csg",
  ld: "ltr",
  alt: ["Lengua de Se\xF1as Chilena", "LSCh"],
  cc: ["CL"]
}, {
  pk: 1352,
  ang: "Chin, Asho",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Asho Chin",
  lc: "csh",
  ld: "ltr",
  alt: ["Khyeng", "Qin", "Sho", "Shoa", "Asho", "Ashu", "Kyang", "Saingbaung", "Kongtu", "Laitu", "Thayetmyo (Thayetmo)"],
  cc: ["BD", "MM"]
}, {
  pk: 1353,
  ang: "Miwok, Coast",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Coast Miwok",
  lc: "csi",
  ld: "ltr",
  alt: ["Huimen", "Marin Miwok", "Bodega"],
  cc: ["US"]
}, {
  pk: 1354,
  ang: "Chin, Songlai",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Songlai Chin",
  lc: "csj",
  ld: "ltr",
  alt: ["Hio", "Mang Um (Song)"],
  cc: ["MM"]
}, {
  pk: 1355,
  ang: "Jola-Kasa",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Jola-Kasa",
  lc: "csk",
  ld: "ltr",
  alt: ["B\xE1cuki", "Casa", "Diola-Kasa", "J\xF3ola-Kaasa", "J\xF3ola-Kasa", "Bliss (Niomoun)", "Esulalu (Esuulaalur)", "Mlomp South", "Oussouye"],
  cc: ["SN"]
}, {
  pk: 1356,
  ang: "Chinese Sign Language",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4E2D\u56FD\u624B\u8BED",
  lc: "csl",
  ld: "ltr",
  alt: ["China Coast Pidgin", "Zhongguo Shouyu", "Southern Chinese Sign Language (Shanghai Sign Language)"],
  cc: ["CN"]
}, {
  pk: 7622,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "North East China Sign Language",
  lc: "csl-x-nechinsl",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1357,
  ang: "Miwok, Central Sierra",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Central Sierra Miwok",
  lc: "csm",
  ld: "ltr",
  alt: ["Eastern Central Sierra Miwok", "Western Central Sierra Miwok"],
  cc: ["US"]
}, {
  pk: 1358,
  ang: "Colombian Sign Language",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Colombian Sign Language",
  lc: "csn",
  ld: "ltr",
  alt: [],
  cc: ["CO"]
}, {
  pk: 1359,
  ang: "Chinantec, Sochiapam",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Sochiapam Chinantec",
  lc: "cso",
  ld: "ltr",
  alt: ["Chinanteco del Oeste", "Sochiapan Chinantec"],
  cc: ["MX"]
}, {
  pk: 1360,
  ang: "Croatia Sign Language",
  lr: "Europe",
  gw: false,
  hc: "HR",
  ln: "Croatia Sign Language",
  lc: "csq",
  ld: "ltr",
  alt: [],
  cc: ["HR", "ME"]
}, {
  pk: 1361,
  ang: "Costa Rican Sign Language",
  lr: "Americas",
  gw: false,
  hc: "CR",
  ln: "Costa Rican Sign Language",
  lc: "csr",
  ld: "ltr",
  alt: [],
  cc: ["CR"]
}, {
  pk: 1362,
  ang: "Ohlone, Southern",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Southern Ohlone",
  lc: "css",
  ld: "ltr",
  alt: ["Mutsun (San Juan Bautista)", "Rumsen (Carmel)", "Runsien", "San Carlos", "Costanoan"],
  cc: ["US"]
}, {
  pk: 1363,
  ang: "Ohlone, Northern",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Northern Ohlone",
  lc: "cst",
  ld: "ltr",
  alt: ["Costanoan", "San Francisco", "Soledad", "East Bay", "Santa Cruz", "Santa Clara"],
  cc: ["US"]
}, {
  pk: 1364,
  ang: "Chin, Sumtu",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Sumtu Chin",
  lc: "csv",
  ld: "ltr",
  alt: ["Ahmyo", "Chang", "Hmyo", "Settu", "Settu Hmyo", "Sungtu"],
  cc: ["MM"]
}, {
  pk: 1365,
  ang: "Cree, Swampy",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Swampy Cree",
  lc: "csw",
  ld: "ltr",
  alt: ["West Main Cree", "West Shore Cree", "York Cree"],
  cc: ["CA"]
}, {
  pk: 1366,
  ang: "Chin, Siyin",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Siyin Chin",
  lc: "csy",
  ld: "ltr",
  alt: ["Siyang", "Siyin", "Sizang"],
  cc: ["MM"]
}, {
  pk: 1367,
  ang: "Coos",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Coos",
  lc: "csz",
  ld: "ltr",
  alt: ["Hanis"],
  cc: ["US"]
}, {
  pk: 1368,
  ang: "Chatino, Tataltepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tataltepec Chatino",
  lc: "cta",
  ld: "ltr",
  alt: ["Chatino Occidental Bajo", "Lowland Chatino"],
  cc: ["MX"]
}, {
  pk: 1369,
  ang: "Chetco",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Chetco",
  lc: "ctc",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 1370,
  ang: "Chin, Tedim",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Tedim Chin",
  lc: "ctd",
  ld: "ltr",
  alt: ["Tedim", "Tiddim", "Kamhau (Kamhao)", "Kamhow"],
  cc: ["MM"]
}, {
  pk: 1371,
  ang: "Chinantec, Tepinapa",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tepinapa Chinantec",
  lc: "cte",
  ld: "ltr",
  alt: ["Chinanteco del Sureste Medio"],
  cc: ["MX"]
}, {
  pk: 1372,
  ang: "Chittagonian",
  lr: "Asia",
  gw: false,
  hc: "BD",
  ln: "Chittagonian",
  lc: "ctg",
  ld: "ltr",
  alt: ["Chatgaiyan Buli", "Chatgaya", "Chittagonian Bengali"],
  cc: ["BD"]
}, {
  pk: 1373,
  ang: "Chin, Thaiphum",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Thaiphum Chin",
  lc: "cth",
  ld: "ltr",
  alt: ["Thui Phum"],
  cc: ["MM"]
}, {
  pk: 1374,
  ang: "Chinantec, Tlacoatzintepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tlacoatzintepec Chinantec",
  lc: "ctl",
  ld: "ltr",
  alt: ["Chinanteco del Noroeste"],
  cc: ["MX"]
}, {
  pk: 1375,
  ang: "Chitimacha",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Chitimacha",
  lc: "ctm",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 1376,
  ang: "Chhintang",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u091B\u093F\u0928\u094D\u0924\u093E\u0919\u094D",
  lc: "ctn",
  ld: "ltr",
  alt: ["Chhintange", "Chintang", "Chintang R\xFBng", "Teli", "Mulgaun", "Sambhugaon"],
  cc: ["NP"]
}, {
  pk: 1377,
  ang: "Ember\xE1-Cat\xEDo",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Ember\xE1-Cat\xEDo",
  lc: "cto",
  ld: "ltr",
  alt: ["Catio", "Embena", "Eyabida", "Katio", "Cat\xEDo", "Epera"],
  cc: ["CO"]
}, {
  pk: 1378,
  ang: "Chatino, Western Highland",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Western Highland Chatino",
  lc: "ctp",
  ld: "ltr",
  alt: ["Cha't-An", "Chatino Central", "Chatino de la Zona Alta Occidental", "Sierra Occidental Chatino", "Panixtlahuaca Chatino", "San Juan Quiahije Chatino", "Yaitepec Chatino"],
  cc: ["MX", "US"]
}, {
  pk: 1379,
  ang: "Bikol, Northern Catanduanes",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Northern Catanduanes Bikol",
  lc: "cts",
  ld: "ltr",
  alt: ["Northern Catanduanes Bicolano", "Pandan"],
  cc: ["PH"]
}, {
  pk: 7861,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Pangyan",
  lc: "cts-x-pangyan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1380,
  ang: "Chetti, Wayanad",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Wayanad Chetti",
  lc: "ctt",
  ld: "ltr",
  alt: ["Chetti", "Chetty"],
  cc: ["IN"]
}, {
  pk: 1381,
  ang: "Chol",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Chol",
  lc: "ctu",
  ld: "ltr",
  alt: ["Ch'ol de Sabanilla", "Chol de Tila (Ch'ol del noroeste)", "Chol de Tumbal\xE1 (Ch'ol del sureste)"],
  cc: ["MX"]
}, {
  pk: 1382,
  ang: "Chatino, Zacatepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Zacatepec Chatino",
  lc: "ctz",
  ld: "ltr",
  alt: ["Chatino de San Marcos Zacatepec", "Chatino de Zacatepec"],
  cc: ["MX"]
}, {
  pk: 1383,
  ang: "Old Church Slavonic, Church Slavonic, Old Bulgarian",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0469\u0437\u044B\u043A\u044A \u0441\u043B\u043E\u0432\u0463\u043D\u044C\u0441\u043A\u044A",
  lc: "cu",
  ld: "ltr",
  alt: [],
  cc: ["RU"]
}, {
  pk: 1384,
  ang: "Cua",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Ti\u1EBFng Co",
  lc: "cua",
  ld: "ltr",
  alt: ["B\xF2ng Mieu", "Bong Miew", "Kor", "Tr\xE0u", "Traw (Dong)", "Dot", "Col", "Cor", "Kol (Co)", "Yot"],
  cc: ["VN"]
}, {
  pk: 1385,
  ang: "Cubeo",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Cubeo",
  lc: "cub",
  ld: "ltr",
  alt: ["Cubeu", "Cuveo", "Hehenawa", "Kobeua", "Kobewa", "Kob\xE9wa", "Kubeo", "Kubewa", "Kubwa", "Pami\xE9", "Pamiwa", "Hipnwa"],
  cc: ["BR", "CO"]
}, {
  pk: 1386,
  ang: "Chinantec, Usila",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Usila Chinantec",
  lc: "cuc",
  ld: "ltr",
  alt: ["Chinanteco del Oeste Central Alto"],
  cc: ["MX"]
}, {
  pk: 1387,
  ang: "Cung",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Cung",
  lc: "cug",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 1388,
  ang: "Gichuka",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Chuka",
  lc: "cuh",
  ld: "ltr",
  alt: ["Chuku", "Suka"],
  cc: ["KE"]
}, {
  pk: 1389,
  ang: "Cuiba",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Cuiba",
  lc: "cui",
  ld: "ltr",
  alt: ["Cuiba-W\xE1monae", "Cuiva", "Hiwi", "Maiben", "Sicuane (Sicuari)", "Tampiwi (Mariposas)", "Masiware (Masiguare)", "Chiripo (Siripu)", "Amaruwa (Amorua)", "Wupiwi"],
  cc: ["VE", "CO"]
}, {
  pk: 1390,
  ang: "Mashco Piro",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Mashco Piro",
  lc: "cuj",
  ld: "ltr",
  alt: ["Cujareno", "Cujare\xF1o", "Mashco"],
  cc: ["PE"]
}, {
  pk: 1391,
  ang: "Kuna, San Blas",
  lr: "Americas",
  gw: false,
  hc: "PA",
  ln: "San Blas Kuna",
  lc: "cuk",
  ld: "ltr",
  alt: ["Cuna", "San Blas Cuna", "Bayano (Alto Bayano)", "Maje"],
  cc: ["PA"]
}, {
  pk: 1392,
  ang: "Kulina",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Culina",
  lc: "cul",
  ld: "ltr",
  alt: ["Corina", "Kul\xEDna", "Kulyna", "Madih\xE1", "Madija", "Kollina", "Kulino", "Kurina"],
  cc: ["BR", "PE"]
}, {
  pk: 1393,
  ang: "Cumanagoto",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "Cumanagoto",
  lc: "cuo",
  ld: "ltr",
  alt: [],
  cc: ["VE"]
}, {
  pk: 1394,
  ang: "Cupe\xF1o",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Cupe\xF1o",
  lc: "cup",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 1395,
  ang: "Cun",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4EE1\u9686\u8A9E",
  lc: "cuq",
  ld: "ltr",
  alt: ["Cunhua", "Cun-Hua", "Ngao Fon"],
  cc: ["CN"]
}, {
  pk: 1396,
  ang: "Chhulung",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Chhulung",
  lc: "cur",
  ld: "ltr",
  alt: ["Chhilling", "Chholung", "Chh\xFBl\xFBng R\xFBng", "Chiling", "Chulung", "Ch\xFCl\xFCng"],
  cc: ["NP"]
}, {
  pk: 1397,
  ang: "Cuicatec, Teutila",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Teutila Cuicatec",
  lc: "cut",
  ld: "ltr",
  alt: ["Cuicateco del norte", "Cuicateco del oriente"],
  cc: ["MX"]
}, {
  pk: 1398,
  ang: "Tai Ya",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u50A3\u96C5\u8BED",
  lc: "cuu",
  ld: "ltr",
  alt: ["Cung", "Daiya", "Huayao Dai", "Multi-colored Waistband Tai", "Tai-Chung", "Tai-Cung", "Ya", "Yuanxin Hongjin Dai", "Huayaodai", "Dai Zhong", "Tai Sai (Dai Sai)", "Tai Chung (Cung)", "Tai Kha (Dai Ka)"],
  cc: ["CN"]
}, {
  pk: 1399,
  ang: "Cuvok",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Cuvok",
  lc: "cuv",
  ld: "ltr",
  alt: ["Tchouvok"],
  cc: ["CM"]
}, {
  pk: 1400,
  ang: "Chukwa",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Chukwa",
  lc: "cuw",
  ld: "ltr",
  alt: ["Cukwa Ring", "Pohing", "Pohing Kha"],
  cc: ["NP"]
}, {
  pk: 1401,
  ang: "Cuicatec, Tepeuxila",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tepeuxila Cuicatec",
  lc: "cux",
  ld: "ltr",
  alt: ["Cuicateco del centro", "Santa Mar\xEDa P\xE1palo"],
  cc: ["MX"]
}, {
  pk: 1402,
  ang: "Chuvash",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0447\u04D1\u0432\u0430\u0448 \u0447\u04D7\u043B\u0445\u0438",
  lc: "cv",
  ld: "ltr",
  alt: ["Bulgar"],
  cc: ["KZ", "TJ", "RU", "KG", "TM", "UZ"]
}, {
  pk: 1403,
  ang: "Chug",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Chug",
  lc: "cvg",
  ld: "ltr",
  alt: ["Chug Monpa", "Chugpa", "Monpa"],
  cc: ["IN"]
}, {
  pk: 1404,
  ang: "Chinantec, Valle Nacional",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Valle Nacional Chinantec",
  lc: "cvn",
  ld: "ltr",
  alt: ["Chinanteco Central Bajo"],
  cc: ["MX"]
}, {
  pk: 1405,
  ang: "Kabwa",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Kabwa",
  lc: "cwa",
  ld: "ltr",
  alt: ["Ekikabhwa", "Ekikabwa", "Kikabwa"],
  cc: ["TZ"]
}, {
  pk: 1406,
  ang: "Maindo",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Maindo",
  lc: "cwb",
  ld: "ltr",
  alt: ["Chwambo", "Badoni", "Mitange"],
  cc: ["MZ"]
}, {
  pk: 1407,
  ang: "Cree, Woods",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Woods Cree",
  lc: "cwd",
  ld: "ltr",
  alt: [],
  cc: ["CA"]
}, {
  pk: 1408,
  ang: "Kwere",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Kwere",
  lc: "cwe",
  ld: "ltr",
  alt: ["Kakwere", "Kikwere", "Kinghwele", "Kwele", "Ngwele", "Ng'were", "Tsinghwele"],
  cc: ["TZ"]
}, {
  pk: 1409,
  ang: "Cheq Wong",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Chewong",
  lc: "cwg",
  ld: "ltr",
  alt: ["Beri", "Ceq Wong", "Che Wong", "Che'wong", "Chuba", "Siwang"],
  cc: ["MY"]
}, {
  pk: 1410,
  ang: "Kuwaataay",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Kuwaataay",
  lc: "cwt",
  ld: "ltr",
  alt: [],
  cc: ["SN"]
}, {
  pk: 1411,
  ang: "Welsh",
  lr: "Europe",
  gw: false,
  hc: "GB",
  ln: "Cymraeg",
  lc: "cy",
  ld: "ltr",
  alt: ["Cymraeg"],
  cc: ["AR", "GB", "NZ", "US", "AU", "CA"]
}, {
  pk: 1412,
  ang: "Chatino, Nopala",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Nopala Chatino",
  lc: "cya",
  ld: "ltr",
  alt: ["Chatino Oriental Bajo"],
  cc: ["MX"]
}, {
  pk: 1413,
  ang: "Cayubaba",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Cayubaba",
  lc: "cyb",
  ld: "ltr",
  alt: ["Cayuvava", "Cayuwaba"],
  cc: ["BO"]
}, {
  pk: 1414,
  ang: "Cuyonon",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Cuyonon",
  lc: "cyo",
  ld: "ltr",
  alt: ["Cuyo", "Cuyono", "Cuyunon", "Kuyonon", "Kuyunon"],
  cc: ["PH"]
}, {
  pk: 1415,
  ang: "Chinese, Huizhou",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5FBD\u5DDE\u8BDD",
  lc: "czh",
  ld: "ltr",
  alt: ["Hui", "Huizhou", "Tunxi"],
  cc: ["CN"]
}, {
  pk: 1416,
  ang: "Knaanic",
  lr: "Europe",
  gw: false,
  hc: "CZ",
  ln: "Knaanic",
  lc: "czk",
  ld: "ltr",
  alt: [],
  cc: ["CZ"]
}, {
  pk: 1417,
  ang: "Chatino, Zenzontepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Zenzontepec Chatino",
  lc: "czn",
  ld: "ltr",
  alt: ["Chatino Occidental Alto", "Northern Chatino"],
  cc: ["MX"]
}, {
  pk: 1418,
  ang: "Chinese, Min Zhong",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u95FD\u4E2D\u8BED",
  lc: "czo",
  ld: "ltr",
  alt: ["Central Min"],
  cc: ["CN"]
}, {
  pk: 1419,
  ang: "Chin, Zotung",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Zotung Chin",
  lc: "czt",
  ld: "ltr",
  alt: ["Yotun", "Zo Mingphuin", "Zobya", "Zotung"],
  cc: ["MM"]
}, {
  pk: 1420,
  ang: "Danish",
  lr: "Europe",
  gw: false,
  hc: "DK",
  ln: "dansk",
  lc: "da",
  ld: "ltr",
  alt: ["D\xE4nisch", "Dansk", "Rigsdansk", "Bornholmsk (Eastern Danish)", "S\xF8nderjysk (Southern Jutlandic)"],
  cc: ["FR", "DE", "GL", "GB", "FO", "NZ", "NO", "SE", "US", "CA", "DK", "IS"]
}, {
  pk: 1421,
  ang: "Dangal\xE9at",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Dangal\xE9at",
  lc: "daa",
  ld: "ltr",
  alt: ["Danal", "Dangal", "Dangla", "Central Dangal\xE9at", "East Dangal\xE9at", "Korbo", "West Dangal\xE9at (Karbo)"],
  cc: ["TD"]
}, {
  pk: 1422,
  ang: "Dambi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Dambi",
  lc: "dac",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 1423,
  ang: "Marik",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Marik",
  lc: "dad",
  ld: "ltr",
  alt: ["Ham"],
  cc: ["PG"]
}, {
  pk: 1424,
  ang: "Duupa",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Duupa",
  lc: "dae",
  ld: "ltr",
  alt: ["Doupa", "Dupa", "Nduupa", "Saa"],
  cc: ["CM"]
}, {
  pk: 1425,
  ang: "Dagbani",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Dagbani",
  lc: "dag",
  ld: "ltr",
  alt: ["Dagbamba", "Dagbane", "Dagomba", "Nanuni (Nanumba)"],
  cc: ["GH", "TG"]
}, {
  pk: 1426,
  ang: "Gwahatike",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gwahatike",
  lc: "dah",
  ld: "ltr",
  alt: ["Dahating", "Gwatike"],
  cc: ["PG"]
}, {
  pk: 1427,
  ang: "Day",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Day",
  lc: "dai",
  ld: "ltr",
  alt: ["Dai"],
  cc: ["TD"]
}, {
  pk: 1428,
  ang: "Daju, Dar Fur",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Dar Fur Daju",
  lc: "daj",
  ld: "ltr",
  alt: ["Beke", "Dagu", "Daju Ferne", "Fininga", "Nyala-Lagowa"],
  cc: ["SD"]
}, {
  pk: 1429,
  ang: "Dakota",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Dakota",
  lc: "dak",
  ld: "ltr",
  alt: ["Sioux", "Nakota (Nakoda)", "Yankton-Yanktonais", "Yankton", "Santee-Sisseton", "Santee", "Dakota (Santee)", "Dakota (Dakhota)", "Nakota (Yankton)"],
  cc: ["US", "CA"]
}, {
  pk: 1430,
  ang: "Dahalo",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Dahalo",
  lc: "dal",
  ld: "ltr",
  alt: ["Guo Garimani", "Sanye"],
  cc: ["KE"]
}, {
  pk: 1431,
  ang: "Damakawa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Damakawa",
  lc: "dam",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 1432,
  ang: "Chin, Daai",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Daai Chin",
  lc: "dao",
  ld: "ltr",
  alt: ["Dai", "Khyo", "Kkhyou", "Yet", "Yindu", "Vet", "Shiip", "Paletwa Daai (Ngxang)", "Mindat Daai (Duk-Msang)", "Matupi Daai (Ma-Tu)", "Kheng", "Kanpetlet Daai (Nghngilo/Yang)", "Mkui"],
  cc: ["MM"]
}, {
  pk: 7536,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Daa Yin Du",
  lc: "dao-x-yindu",
  ld: "ltr",
  alt: [],
  cc: ["MM"]
}, {
  pk: 1433,
  ang: "Maria, Dandami",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Dandami Maria",
  lc: "daq",
  ld: "ltr",
  alt: ["Bastar Koya", "Bison Horn Maria", "Dandami Madiya", "Dhuru", "Madiya", "Maria Gond"],
  cc: ["IN"]
}, {
  pk: 1434,
  ang: "Dargwa",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0414\u0430\u0440\u0433\u0438\u043D\u0441\u043A\u0438\u0439",
  lc: "dar",
  ld: "ltr",
  alt: ["Dargi", "Dargin", "Dargintsy", "Khiurkilinskii", "Uslar", "Kajtak (Kaitak)", "Xajdak", "Urkarax", "Urakha-Akhush", "Ughbug", "Kubachintsy", "Akusha (Akkhusha)", "Kaytak", "Itsari", "Cudaxar (Tsudakhar)", "Chirag", "Kubachi (Kubachin)"],
  cc: ["AZ", "KZ", "RU", "KG", "TM", "UZ"]
}, {
  pk: 1435,
  ang: "Daho-Doo",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Daho-Doo",
  lc: "das",
  ld: "ltr",
  alt: [],
  cc: ["CI"]
}, {
  pk: 1436,
  ang: "Daju, Dar Sila",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Dar Sila Daju",
  lc: "dau",
  ld: "ltr",
  alt: ["Bokor", "Bokorike", "Bokoruge", "Mongo-Sila", "Sula", "Dajou", "Daju"],
  cc: ["SD", "TD"]
}, {
  pk: 1437,
  ang: "Dawida",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Taita",
  lc: "dav",
  ld: "ltr",
  alt: ["Dabida", "Davida", "Kidabida", "Kitaita", "Teita", "Kasigau"],
  cc: ["KE"]
}, {
  pk: 1438,
  ang: "Davawenyo",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Davawenyo",
  lc: "daw",
  ld: "ltr",
  alt: ["Davaoe\xF1o", "Davawe\xF1o", "Matino"],
  cc: ["PH"]
}, {
  pk: 1439,
  ang: "Dayi",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Dayi",
  lc: "dax",
  ld: "ltr",
  alt: ["Dha'i", "Dhay'yi"],
  cc: ["AU"]
}, {
  pk: 7946,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Mali",
  lc: "day-x-dayakmali",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7947,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Sambas",
  lc: "day-x-dayaksambas",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1440,
  ang: "Dao",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dao",
  lc: "daz",
  ld: "ltr",
  alt: ["Maniwo", "X-Ray"],
  cc: ["ID"]
}, {
  pk: 1441,
  ang: "Bangime",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Bangime",
  lc: "dba",
  ld: "ltr",
  alt: ["Bangeri Me", "Bangeri Me Dogon", "Bangerime", "Dyeni", "Elebo", "Noumandan", "Numadaw"],
  cc: ["ML"]
}, {
  pk: 1442,
  ang: "Deno",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Deno",
  lc: "dbb",
  ld: "ltr",
  alt: ["Be", "Denawa", "Denwa"],
  cc: ["NG"]
}, {
  pk: 1443,
  ang: "Dadiya",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Dadiya",
  lc: "dbd",
  ld: "ltr",
  alt: ["Daadiya", "Dadia", "Loodiya", "Tunga (Boleri)"],
  cc: ["NG"]
}, {
  pk: 1444,
  ang: "Dabe",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dabe",
  lc: "dbe",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 1445,
  ang: "Edopi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Edopi",
  lc: "dbf",
  ld: "ltr",
  alt: ["Dosobou", "Dou", "Doufou", "Elopi", "Foi", "Iau", "Turu", "Urundi", "Ururi", "Yau"],
  cc: ["ID"]
}, {
  pk: 1446,
  ang: "Dogon, Dogul Dom",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Dogul Dom Dogon",
  lc: "dbg",
  ld: "ltr",
  alt: ["Dogul-Dom"],
  cc: ["ML"]
}, {
  pk: 1447,
  ang: "Doka",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Doka",
  lc: "dbi",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 1448,
  ang: "Ida\u2019an",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Ida'an",
  lc: "dbj",
  ld: "ltr",
  alt: ["Bulud Upi", "Eraans", "Idaan", "Idahan", "Idan", "Idayan", "Supan", "Subpan (Sungai)", "Begak (Bagahak)"],
  cc: ["MY"]
}, {
  pk: 1449,
  ang: "Dyirbal",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Dyirbal",
  lc: "dbl",
  ld: "ltr",
  alt: ["Djirubal", "Dyiru", "Girramay (Keramai)", "Gulnguy (Gulngay)", "Mamu", "Ngadjan (Ngatjan)"],
  cc: ["AU"]
}, {
  pk: 1450,
  ang: "Duguri",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Duguri",
  lc: "dbm",
  ld: "ltr",
  alt: ["Doori", "Dugarwa", "Duguranchi", "Dugurawa", "Dukuri"],
  cc: ["NG"]
}, {
  pk: 1451,
  ang: "Duriankere",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Duriankere",
  lc: "dbn",
  ld: "ltr",
  alt: ["Duriankari", "Esaro", "Sailen"],
  cc: ["ID"]
}, {
  pk: 1452,
  ang: "Dulbu",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Dulbu",
  lc: "dbo",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 1453,
  ang: "Duwai",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Duwai",
  lc: "dbp",
  ld: "ltr",
  alt: ["Eastern Bade", "Evji"],
  cc: ["NG"]
}, {
  pk: 1454,
  ang: "Daba",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Daba",
  lc: "dbq",
  ld: "ltr",
  alt: ["Dabba"],
  cc: ["CM"]
}, {
  pk: 1455,
  ang: "Dabarre",
  lr: "Africa",
  gw: false,
  hc: "SO",
  ln: "Dabarre",
  lc: "dbr",
  ld: "ltr",
  alt: ["Af-Dabarre", "Iroole (Af-Iroole)"],
  cc: ["SO"]
}, {
  pk: 1456,
  ang: "Dogon, Ben Tey",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Ben Tey Dogon",
  lc: "dbt",
  ld: "ltr",
  alt: [],
  cc: ["ML"]
}, {
  pk: 1457,
  ang: "Dogon, Bondum Dom",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Bondum Dom Dogon",
  lc: "dbu",
  ld: "ltr",
  alt: ["Bondum-Dom", "Dogon, Najamba-Kindige", "Kindjim", "Nadjamba", "Dogon", "Najamba-Kindige"],
  cc: ["ML"]
}, {
  pk: 1458,
  ang: "Dungu",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Dungu",
  lc: "dbv",
  ld: "ltr",
  alt: ["Dungi", "Dunjawa", "Dwingi"],
  cc: ["NG"]
}, {
  pk: 1459,
  ang: "Dogon, Bankan Tey",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Bankan Tey Dogon",
  lc: "dbw",
  ld: "ltr",
  alt: ["Oualo", "Walo"],
  cc: ["ML"]
}, {
  pk: 1460,
  ang: "Dibiyaso",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Dibiyaso",
  lc: "dby",
  ld: "ltr",
  alt: ["Dibiasu", "Pikiwa"],
  cc: ["PG"]
}, {
  pk: 1461,
  ang: "Deccan",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Deccan",
  lc: "dcc",
  ld: "ltr",
  alt: ["Dakini", "Deccani", "Desi", "Kalvadi (Dharwar)"],
  cc: ["IN"]
}, {
  pk: 1462,
  ang: "Dadi Dadi",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Dadi Dadi",
  lc: "dda",
  ld: "ltr",
  alt: ["Dadidadi", "Dardidardi", "Dardi-Dardi", "Tatitati", "Tharrthi-Tharrthi"],
  cc: ["AU"]
}, {
  pk: 1463,
  ang: "Dongotono",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Dongotono",
  lc: "ddd",
  ld: "ltr",
  alt: [],
  cc: ["SS"]
}, {
  pk: 1464,
  ang: "Doondo",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Doondo",
  lc: "dde",
  ld: "ltr",
  alt: ["Dondo", "Kidoondo"],
  cc: ["CG"]
}, {
  pk: 1465,
  ang: "Fataluku",
  lr: "Asia",
  gw: false,
  hc: "TL",
  ln: "Fataluku",
  lc: "ddg",
  ld: "ltr",
  alt: ["Dagada", "Dagaga", "Dagoda'"],
  cc: ["TL"]
}, {
  pk: 1466,
  ang: "Goodenough, West",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "West Goodenough",
  lc: "ddi",
  ld: "ltr",
  alt: ["Giwau", "Miyalabi", "Molata"],
  cc: ["PG"]
}, {
  pk: 7720,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Amoli",
  lc: "ddi-x-amoli",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1467,
  ang: "Jaru",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Jaru",
  lc: "ddj",
  ld: "ltr",
  alt: ["Jaroo", "Tjaru", "Wawari"],
  cc: ["AU", "PG"]
}, {
  pk: 1468,
  ang: "Dendi",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Dendi (Benin)",
  lc: "ddn",
  ld: "ltr",
  alt: ["Dandawa"],
  cc: ["BJ", "NE", "NG"]
}, {
  pk: 1469,
  ang: "Tsez",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0446\u0435\u0437\u0439\u0430\u0441 \u043C\u0435\u0446",
  lc: "ddo",
  ld: "ltr",
  alt: ["Cez", "Didoi", "Tsez", "Tsezy", "Tsuntin", "Sahada"],
  cc: ["RU"]
}, {
  pk: 1470,
  ang: "Dhudhuroa",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Dhudhuroa",
  lc: "ddr",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 1471,
  ang: "Dogon, Donno So",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Donno So Dogon",
  lc: "dds",
  ld: "ltr",
  alt: ["Kamba So", "Donno So", "Kamma So"],
  cc: ["ML"]
}, {
  pk: 1472,
  ang: "Dawera-Daweloor",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dawera-Daweloor",
  lc: "ddw",
  ld: "ltr",
  alt: ["Davelor"],
  cc: ["ID"]
}, {
  pk: 1473,
  ang: "German",
  lr: "Europe",
  gw: false,
  hc: "DE",
  ln: "Deutsch",
  lc: "de",
  ld: "ltr",
  alt: ["Deutsch", "Tedesco", "K\xE4rntnerisch", "Transylvanian"],
  cc: ["AT", "BE", "BR", "DE", "HU", "ES", "CZ", "MX", "NL", "NZ", "PY", "RO", "PL", "ZA", "CH", "SI", "US", "AU", "BO", "CA", "LI", "LU", "DK", "PT", "SG", "NA"]
}, {
  pk: 1474,
  ang: "Dagik",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Dagik",
  lc: "dec",
  ld: "ltr",
  alt: ["Dagig", "Masakin", "Masakin Dagig", "Masakin Gusar", "Thakik", "Tosari", "Adobu", "Arreme"],
  cc: ["SD"]
}, {
  pk: 1475,
  ang: "Dedua",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Dedua",
  lc: "ded",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 1476,
  ang: "Dewoin",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Dewoin",
  lc: "dee",
  ld: "ltr",
  alt: ["De", "Dewoi", "Dey"],
  cc: ["LR"]
}, {
  pk: 1477,
  ang: "Dezfuli",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u06AF\u0648\u06CC\u0634 \u062F\u0632\u0641\u0648\u0644\u06CC",
  lc: "def",
  ld: "ltr",
  alt: ["Dizfuli", "Shushtari"],
  cc: ["IR"]
}, {
  pk: 1478,
  ang: "Degema",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Degema",
  lc: "deg",
  ld: "ltr",
  alt: ["Dekema"],
  cc: ["NG"]
}, {
  pk: 1479,
  ang: "Dehwari",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "Dehwari",
  lc: "deh",
  ld: "ltr",
  alt: ["Deghwari"],
  cc: ["PK"]
}, {
  pk: 1480,
  ang: "Demisa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Demisa",
  lc: "dei",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 1481,
  ang: "Dek",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Dek",
  lc: "dek",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 1482,
  ang: "Delaware",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Delaware",
  lc: "del",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 1483,
  ang: "Dem",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dem",
  lc: "dem",
  ld: "ltr",
  alt: ["Lem", "Ndem"],
  cc: ["ID"]
}, {
  pk: 1484,
  ang: "Slavey",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Slave (Athapascan)",
  lc: "den",
  ld: "ltr",
  alt: [],
  cc: ["CA"]
}, {
  pk: 1485,
  ang: "Dendi",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Dendi (Central African Republic)",
  lc: "deq",
  ld: "ltr",
  alt: [],
  cc: ["CF"]
}, {
  pk: 1486,
  ang: "Deori",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Deori",
  lc: "der",
  ld: "ltr",
  alt: ["Chutiya", "Dari", "Deuri", "Dewri", "Drori"],
  cc: ["IN"]
}, {
  pk: 1487,
  ang: "Desano",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Desano",
  lc: "des",
  ld: "ltr",
  alt: ["Boleka", "Des\xE2na", "Dessano", "Kusibi", "Oregu", "Uina", "Wina", "Wir\xE3", "Des\xE1na", "Dessana", "Kotedia", "Wira"],
  cc: ["BR", "CO"]
}, {
  pk: 1488,
  ang: "Domung",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Domung",
  lc: "dev",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 1489,
  ang: "Dengese",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Dengese",
  lc: "dez",
  ld: "ltr",
  alt: ["Ileo", "Lengese"],
  cc: ["CD"]
}, {
  pk: 1490,
  ang: "Dagaare, Southern",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Southern Dagaare",
  lc: "dga",
  ld: "ltr",
  alt: ["Dagaare", "Dagara", "Dagati", "Degati", "Dogaari", "Southern Dagari"],
  cc: ["GH"]
}, {
  pk: 1491,
  ang: "Dogon, Bunoge",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Bunoge Dogon",
  lc: "dgb",
  ld: "ltr",
  alt: ["Budu-Tagu", "Korandabo"],
  cc: ["ML"]
}, {
  pk: 1492,
  ang: "Agta, Casiguran Dumagat",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Casiguran Dumagat Agta",
  lc: "dgc",
  ld: "ltr",
  alt: [],
  cc: ["PH"]
}, {
  pk: 7863,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Agta-Quirino",
  lc: "dgc-x-agtaquirino",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7814,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Dinapigue Agta",
  lc: "dgc-x-dinapigue",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1493,
  ang: "Dagaari Dioula",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Dagaari Dioula",
  lc: "dgd",
  ld: "ltr",
  alt: ["Dagaari Jula", "Dagari Dyoula", "Jari", "Wala", "Yari"],
  cc: ["BF"]
}, {
  pk: 1494,
  ang: "Degenan",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Degenan",
  lc: "dge",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 1495,
  ang: "Doga",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Doga",
  lc: "dgg",
  ld: "ltr",
  alt: ["Magabara"],
  cc: ["PG"]
}, {
  pk: 1496,
  ang: "Dghwede",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Dghwede",
  lc: "dgh",
  ld: "ltr",
  alt: ["Azaghvana", "Dehoxde", "Hude", "Johode", "Tghuade", "Toghwede", "Traude", "Wa'a", "Zaghvana"],
  cc: ["NG"]
}, {
  pk: 1497,
  ang: "Dagara, Northern",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Northern Dagara",
  lc: "dgi",
  ld: "ltr",
  alt: ["Dagaare", "Dagaari", "Dagari", "Dagati", "Degati", "Dogaari", "Northern Dagaare", "Wule", "Lober (Lobr)", "Nura (Lawra Lobi)"],
  cc: ["BF"]
}, {
  pk: 1498,
  ang: "Dagba",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Dagba",
  lc: "dgk",
  ld: "ltr",
  alt: [],
  cc: ["CF"]
}, {
  pk: 1499,
  ang: "Andaandi",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Andaandi",
  lc: "dgl",
  ld: "ltr",
  alt: ["Dongola", "Dongolawi", "Dongolawi Nubian", "Dongolese"],
  cc: ["SD"]
}, {
  pk: 1500,
  ang: "Dogri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Dogri (individual language)",
  lc: "dgo",
  ld: "ltr",
  alt: ["Dhogaryali", "Dogari", "Dogri Jammu", "Dogri Pahari", "Dogri-Kangri", "Dongari", "Hindi Dogri", "Tokkaru"],
  cc: ["PK", "IN"]
}, {
  pk: 1501,
  ang: "Dogrib",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Dogrib",
  lc: "dgr",
  ld: "ltr",
  alt: ["Central Dogrib", "Weledeh"],
  cc: ["CA"]
}, {
  pk: 1502,
  ang: "Dogoso",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Dogoso",
  lc: "dgs",
  ld: "ltr",
  alt: ["Bambadion-Dogoso", "Bambadion-Dokhosi\xE9", "Black Dogose", "Dorhosi\xE9-Finng", "Dorhosi\xE9-Noirs", "Dorossi\xE9-Fing"],
  cc: ["BF"]
}, {
  pk: 1503,
  ang: "Degaru",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Degaru",
  lc: "dgu",
  ld: "ltr",
  alt: ["Dhekaru"],
  cc: ["IN"]
}, {
  pk: 1504,
  ang: "Daungwurrung",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Daungwurrung",
  lc: "dgw",
  ld: "ltr",
  alt: ["Daung Wurrung", "Dhagung-wurrung", "Taungurong", "Taungurung", "Thagawurung"],
  cc: ["AU"]
}, {
  pk: 1505,
  ang: "Doghoro",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Doghoro",
  lc: "dgx",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 1506,
  ang: "Daga",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Daga",
  lc: "dgz",
  ld: "ltr",
  alt: ["Nawp", "Lower Daga", "Upper Daga"],
  cc: ["PG"]
}, {
  pk: 1507,
  ang: "Dhundari",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Dhundari",
  lc: "dhd",
  ld: "ltr",
  alt: ["Dhundari-Marwari"],
  cc: ["IN"]
}, {
  pk: 7650,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Sindoli",
  lc: "dhd-x-sindoli",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1508,
  ang: "Djangu",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Dhangu",
  lc: "dhg",
  ld: "ltr",
  alt: ["Budalpudal", "Burada", "Buralbural", "Buratha", "Dangu", "Dhangu", "Dhangu'mi", "Warameri", "Waramiri", "War-ramirri", "Warumeri", "Gaalpu (Kalbu)"],
  cc: ["AU"]
}, {
  pk: 1509,
  ang: "Dhimal",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u0927\u093F\u092E\u093E\u0932",
  lc: "dhi",
  ld: "ltr",
  alt: ["Dhemal"],
  cc: ["NP", "IN"]
}, {
  pk: 1510,
  ang: "Dhalandji",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Dhalandji",
  lc: "dhl",
  ld: "ltr",
  alt: ["Dalandji", "Dalendi", "Djalendi", "Talaindji", "Talandi", "Talandji", "Talangee", "Tallainga", "Taloinga", "Thalantji", "Thalanyji"],
  cc: ["AU"]
}, {
  pk: 1511,
  ang: "Dhimba",
  lr: "Africa",
  gw: false,
  hc: "AO",
  ln: "Zemba",
  lc: "dhm",
  ld: "ltr",
  alt: ["Chimba", "Dimba", "Oluthimba", "Otjidhimba", "Simba", "Tjimba", "Zemba", "Himba", "Luzimba"],
  cc: ["AO", "NA"]
}, {
  pk: 1512,
  ang: "Dhanki",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Dhanki",
  lc: "dhn",
  ld: "ltr",
  alt: ["Dangi", "Dangri", "Dangs Bhil", "Dhanka", "Kakachhu-Ki Boli", "Tadvi Bhil"],
  cc: ["IN"]
}, {
  pk: 1513,
  ang: "Dhodia",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Dhodia",
  lc: "dho",
  ld: "ltr",
  alt: ["Dhobi", "Dhore", "Dhori", "Dhowari", "Doria"],
  cc: ["IN"]
}, {
  pk: 1514,
  ang: "Dhargari",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Dhargari",
  lc: "dhr",
  ld: "ltr",
  alt: ["Dal'gari", "Targari", "Tarkarri", "Thargari", "Tharrgari", "Tharrkari"],
  cc: ["AU"]
}, {
  pk: 1515,
  ang: "Dhaiso",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Dhaiso",
  lc: "dhs",
  ld: "ltr",
  alt: ["Daiso", "Daisu", "Kidhaiso", "Segeju"],
  cc: ["TZ"]
}, {
  pk: 1516,
  ang: "Drehu",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Dehu",
  lc: "dhv",
  ld: "ltr",
  alt: ["Dehu", "De'u", "Lifu", "Qene Drehu"],
  cc: ["NC"]
}, {
  pk: 1517,
  ang: "Danuwar",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Dhanwar (Nepal)",
  lc: "dhw",
  ld: "ltr",
  alt: ["Danuwar Rai", "Danwar", "Denwar", "Dhanvar", "Dhanwar", "Kamala Khonch Danuwar", "Panchkhal Danuwar", "Sindhuli Danuwar", "Bakultar Danuwar", "Dukuchhap Danuwar", "Judigaon Danuwar"],
  cc: ["NP"]
}, {
  pk: 1518,
  ang: "Dhungaloo",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Dhungaloo",
  lc: "dhx",
  ld: "ltr",
  alt: ["Dungaloo"],
  cc: ["AU"]
}, {
  pk: 1519,
  ang: "Dia",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Dia",
  lc: "dia",
  ld: "ltr",
  alt: ["Alu", "Galu", "Metru"],
  cc: ["PG"]
}, {
  pk: 1520,
  ang: "Dinka, South Central",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "South Central Dinka",
  lc: "dib",
  ld: "ltr",
  alt: ["Agar", "Central Dinka", "Kwac", "Thany", "Gok (Cok)", "Gauk", "Ciem", "Ciec (Ador)", "Chiech", "Aliap (Aker)", "Aliab", "Ajak", "Cic"],
  cc: ["SS"]
}, {
  pk: 1521,
  ang: "Dida, Lakota",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Lakota Dida",
  lc: "dic",
  ld: "ltr",
  alt: ["Brabori", "Dieko", "Gabo", "Gu\xE9bie", "Satro", "Ziki"],
  cc: ["CI"]
}, {
  pk: 1522,
  ang: "Didinga",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Didinga",
  lc: "did",
  ld: "ltr",
  alt: ["Di'dinga", "Lango", "Toi", "Xaroxa"],
  cc: ["SS"]
}, {
  pk: 1523,
  ang: "Dieri",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Dieri",
  lc: "dif",
  ld: "ltr",
  alt: ["Diyari"],
  cc: ["AU"]
}, {
  pk: 1524,
  ang: "Chidigo",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Digo",
  lc: "dig",
  ld: "ltr",
  alt: ["Kidigo", "Chichifundi", "Chichinondo", "Chigwirani"],
  cc: ["KE", "TZ"]
}, {
  pk: 1525,
  ang: "Kumiai",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Kumiai",
  lc: "dih",
  ld: "ltr",
  alt: ["Campo", "Cochim\xED", "Comeya", "Cuchim\xED", "Diegue\xF1o", "Kamia", "Kamiai", "Kamiyahi", "Kamiyai", "Ki-Miai", "Ko'al", "Ku'ahl", "Kumeyaai", "Kumeyaay", "Kumia", "Kw'aal", "Quemay\xE1", "Tipai'", "Tip\xE1i", "Tip\xE9i", "Digue\xF1o", "Ipai", "Tipai"],
  cc: ["MX"]
}, {
  pk: 1526,
  ang: "Dimbong",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Dimbong",
  lc: "dii",
  ld: "ltr",
  alt: ["Bape", "Bumbong", "Kaalong", "Kalong", "Lakaalong", "Lambong", "Mbong", "Palong"],
  cc: ["CM"]
}, {
  pk: 1527,
  ang: "Dai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dai",
  lc: "dij",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 1528,
  ang: "Dinka, Southwestern",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Southwestern Dinka",
  lc: "dik",
  ld: "ltr",
  alt: ["Western Dinka", "Ajong Thi", "Aguok (Agwok)", "Abiem (Ajong Dit)", "Apwoth", "Makem", "Baliet", "Paliet (Ajak)", "Malwal", "Malual (Atoktou)", "Duliit", "Korok", "Peth", "Bon Shwai", "Apuoth", "Anei", "Akern Jok", "Akany Kok"],
  cc: ["SS"]
}, {
  pk: 1529,
  ang: "Dilling",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Dilling",
  lc: "dil",
  ld: "ltr",
  alt: ["Delen", "Warkimbe"],
  cc: ["SD"]
}, {
  pk: 1530,
  ang: "Dime",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Dime",
  lc: "dim",
  ld: "ltr",
  alt: ["Dima"],
  cc: ["ET"]
}, {
  pk: 1531,
  ang: "Dinka",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Dinka",
  lc: "din",
  ld: "ltr",
  alt: [],
  cc: ["SS"]
}, {
  pk: 1532,
  ang: "Dibo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Dibo",
  lc: "dio",
  ld: "ltr",
  alt: ["Ganagana", "Ganagawa", "Shitako", "Zhitako", "Zitako"],
  cc: ["NG"]
}, {
  pk: 1533,
  ang: "Dinka, Northeastern",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Northeastern Dinka",
  lc: "dip",
  ld: "ltr",
  alt: ["Padang", "White Nile Dinka", "Dinka Ibrahim", "Paloic", "Paloc", "Nyel", "Ngork", "Luac (Luaic)", "Beer", "Bawom", "Ager", "Ageir", "Ageer (Abuya)", "Abiliang (Akoon)", "Bowom", "Ngok-Sobat (Jok)"],
  cc: ["SS"]
}, {
  pk: 1534,
  ang: "Zazaki, Southern",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Dimli (individual language)",
  lc: "diq",
  ld: "ltr",
  alt: ["Dimili", "Southern Zaza", "Zaza", "Zazaca", "Dersimki", "Motki (Moti)", "Hazzu (Hazo)", "Dumbuli (Dumbeli)", "Eastern Zazaki (Central Zazaki)"],
  cc: ["TR"]
}, {
  pk: 1535,
  ang: "Dirim",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Dirim",
  lc: "dir",
  ld: "ltr",
  alt: ["Daka", "Dakka", "Dirin", "Dirrim"],
  cc: ["NG"]
}, {
  pk: 1536,
  ang: "Dimasa",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Dimasa",
  lc: "dis",
  ld: "ltr",
  alt: ["Dimasa Kachari", "Hills Kachari"],
  cc: ["IN"]
}, {
  pk: 1537,
  ang: "Diriku",
  lr: "Africa",
  gw: false,
  hc: "NA",
  ln: "Diriku",
  lc: "diu",
  ld: "ltr",
  alt: ["Diriko", "Mbogedo", "Rugciriku", "Shimbogedu", "Mbogedu"],
  cc: ["AO", "NA"]
}, {
  pk: 1538,
  ang: "Dinka, Northwestern",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Northwestern Dinka",
  lc: "diw",
  ld: "ltr",
  alt: [],
  cc: ["SS", "SD"]
}, {
  pk: 1539,
  ang: "Dixon Reef",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Dixon Reef",
  lc: "dix",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 1540,
  ang: "Diuwe",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Diuwe",
  lc: "diy",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 1541,
  ang: "Ding",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ding",
  lc: "diz",
  ld: "ltr",
  alt: ["Di", "Din", "Dzing"],
  cc: ["CD"]
}, {
  pk: 7799,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kidikidiki",
  lc: "diz-x-kidikidiki",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 1542,
  ang: "Djinba",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Djinba",
  lc: "djb",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 1543,
  ang: "Daju, Dar Daju",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Dar Daju Daju",
  lc: "djc",
  ld: "ltr",
  alt: ["Dadjo", "Dadju", "Dajo", "Dajou", "Daju", "Daju Mongo", "Daju Oum Hadjer", "Gadjira", "Bardangal", "Eref"],
  cc: ["TD"]
}, {
  pk: 1544,
  ang: "Djamindjung",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Djamindjung",
  lc: "djd",
  ld: "ltr",
  alt: ["Jaminjung", "Ngaliwuru (Ngaliwerra)"],
  cc: ["AU"]
}, {
  pk: 1545,
  ang: "Zarma",
  lr: "Africa",
  gw: false,
  hc: "NE",
  ln: "Zarma",
  lc: "dje",
  ld: "ltr",
  alt: ["Adzerma", "Djerma", "Dyabarma", "Dyarma", "Dyerma", "Zabarma", "Zarbarma", "Zarmaci", "Zerma"],
  cc: ["BJ", "GH", "NE", "NG"]
}, {
  pk: 1546,
  ang: "Djinang",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Djinang",
  lc: "dji",
  ld: "ltr",
  alt: ["Jandijinung", "Wulaki (Wurlaki)"],
  cc: ["AU"]
}, {
  pk: 1547,
  ang: "Djeebbana",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Djeebbana",
  lc: "djj",
  ld: "ltr",
  alt: ["Gunavidji"],
  cc: ["AU"]
}, {
  pk: 1548,
  ang: "Aukan",
  lr: "Americas",
  gw: false,
  hc: "SR",
  ln: "Eastern Maroon Creole",
  lc: "djk",
  ld: "ltr",
  alt: ["Businenge Tongo", "Businengee Tongo", "Nenge", "Nenge Tongo", "Nengee", "Nengee Tongo", "Taki-Taki", "Aukan (Aukaans)", "Paramaccan (Pamaka)", "Pamaka", "Okanisi", "Njuk\xE1", "Ndjuk\xE1", "Aluku (Aloekoe)", "Aluku", "\"Djuka\"", "\"Djoeka\"", "Ndyuka"],
  cc: ["GF", "GY", "SR"]
}, {
  pk: 1549,
  ang: "Dogon, Jamsay",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Jamsay Dogon",
  lc: "djm",
  ld: "ltr",
  alt: ["Dyamsay Tegu", "Gamsaj", "Bama", "Pomuru", "Guru", "Domno", "Gono"],
  cc: ["ML"]
}, {
  pk: 1550,
  ang: "Djauan",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Djauan",
  lc: "djn",
  ld: "ltr",
  alt: ["Adowen", "Jawan", "Jawony", "Jawoyn", "Kumertuo"],
  cc: ["AU"]
}, {
  pk: 1551,
  ang: "Jangkang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Jangkang",
  lc: "djo",
  ld: "ltr",
  alt: ["Jangkang proper", "Pompang"],
  cc: ["ID"]
}, {
  pk: 8105,
  ang: "Dayak Ba eih",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Ba eih",
  lc: "djo-x-dayakbaeih",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8109,
  ang: "Dayak Darok",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Darok",
  lc: "djo-x-dayakdarok",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8092,
  ang: "Dayak Kodatn",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Kodatn",
  lc: "djo-x-dayakkodatn",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8016,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Papak",
  lc: "djo-x-dayakpapak",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8089,
  ang: "Dayak Sum",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Sum",
  lc: "djo-x-dayaksum",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8046,
  ang: "Dayak Tinying",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Tinying",
  lc: "djo-x-dayaktinying",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8166,
  ang: "Dayak Meranggau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Meranggau",
  lc: "djo-x-meranggau",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8164,
  ang: "Dayak Pompang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Pompang",
  lc: "djo-x-pompang",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1552,
  ang: "Djambarrpuyngu",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Djambarrpuyngu",
  lc: "djr",
  ld: "ltr",
  alt: ["Djambarbwingu", "Jambapuing", "Jambapuingo"],
  cc: ["AU"]
}, {
  pk: 1553,
  ang: "Kapriman",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kapriman",
  lc: "dju",
  ld: "ltr",
  alt: ["Mugumute", "Wasare"],
  cc: ["PG"]
}, {
  pk: 1554,
  ang: "Dakpakha",
  lr: "Asia",
  gw: false,
  hc: "BT",
  ln: "Dakpakha",
  lc: "dka",
  ld: "ltr",
  alt: [],
  cc: ["BT"]
}, {
  pk: 1555,
  ang: "Dakka",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dakka",
  lc: "dkk",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 1556,
  ang: "Kuijau",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Kuijau",
  lc: "dkr",
  ld: "ltr",
  alt: ["Hill Dusun", "Kijau", "Koijoe", "Kuiyow", "Kujau", "Kuliow", "Kuriyo", "Kwijau", "Menindal", "Menindaq", "Minansut", "Tidung", "Tindal"],
  cc: ["MY"]
}, {
  pk: 1557,
  ang: "Dinka, Southeastern",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Southeastern Dinka",
  lc: "dks",
  ld: "ltr",
  alt: ["Eastern Dinka", "Tuic (Twi)", "Athoc (Athoic)", "Atoc", "Bor (Bor Gok)", "Bor Athoic", "Borathoi", "Nyarueng", "Nyarweng (Narreweng)"],
  cc: ["SS"]
}, {
  pk: 1558,
  ang: "Mazagway",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mazagway",
  lc: "dkx",
  ld: "ltr",
  alt: ["Mazagway-Hidi", "Musgoy", "Mazagway (Daba-Mousgoy)", "Kpala (Daba-Kola)", "Kola"],
  cc: ["CM"]
}, {
  pk: 1559,
  ang: "Dolgan",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0414\u043E\u043B\u0433\u0430\u043D\u0441\u043A\u0438\u0439",
  lc: "dlg",
  ld: "ltr",
  alt: [],
  cc: ["RU"]
}, {
  pk: 1560,
  ang: "Dahalik",
  lr: "Africa",
  gw: false,
  hc: "ER",
  ln: "Dahalik",
  lc: "dlk",
  ld: "ltr",
  alt: [],
  cc: ["ER"]
}, {
  pk: 1561,
  ang: "Dalmatian",
  lr: "Europe",
  gw: false,
  hc: "HR",
  ln: "Dalmatian",
  lc: "dlm",
  ld: "ltr",
  alt: [],
  cc: ["HR"]
}, {
  pk: 1562,
  ang: "Darlong",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Darlong",
  lc: "dln",
  ld: "ltr",
  alt: ["Dalong"],
  cc: ["BD", "IN"]
}, {
  pk: 1563,
  ang: "Duma",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Duma",
  lc: "dma",
  ld: "ltr",
  alt: ["Adouma", "Aduma", "Douma", "Liduma"],
  cc: ["GA"]
}, {
  pk: 1564,
  ang: "Dogon, Mombo",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Mombo Dogon",
  lc: "dmb",
  ld: "ltr",
  alt: ["Kolum-so", "Kolu-so", "Pignari"],
  cc: ["ML"]
}, {
  pk: 1565,
  ang: "Gavak",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gavak",
  lc: "dmc",
  ld: "ltr",
  alt: ["Bosiken", "Boskien"],
  cc: ["PG"]
}, {
  pk: 1566,
  ang: "Dugwor",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Dugwor",
  lc: "dme",
  ld: "ltr",
  alt: ["Dougour", "Memekere", "Mofu-Dugwor", "Tchakidjebe", "Mikere"],
  cc: ["CM"]
}, {
  pk: 1567,
  ang: "Kinabatangan, Upper",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Upper Kinabatangan",
  lc: "dmg",
  ld: "ltr",
  alt: ["Sungai Milian", "Dusun Segama (Saga-i)", "Kalabuan (Kolobuan)", "Segai", "Sinabu' (Sinabu)", "Soghai"],
  cc: ["MY"]
}, {
  pk: 1568,
  ang: "Domaaki",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u0688\u0648\u0645\u0627\u06A9\u06CC",
  lc: "dmk",
  ld: "ltr",
  alt: ["Doma", "Dumaki"],
  cc: ["PK"]
}, {
  pk: 1569,
  ang: "Dameli",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u062F\u0627\u0645\u06CC\u0691\u06CC",
  lc: "dml",
  ld: "ltr",
  alt: ["Damedi", "Damel", "Damia", "Damiabaasha", "Gidoji", "Gudoji"],
  cc: ["PK"]
}, {
  pk: 1570,
  ang: "Dama",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Dama",
  lc: "dmm",
  ld: "ltr",
  alt: [],
  cc: ["CM", "TD"]
}, {
  pk: 1571,
  ang: "Kemedzung",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Kemezung",
  lc: "dmo",
  ld: "ltr",
  alt: ["Dumbo", "Dzumbo", "Kumaju"],
  cc: ["CM"]
}, {
  pk: 1572,
  ang: "Damar, East",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "East Damar",
  lc: "dmr",
  ld: "ltr",
  alt: ["South Damar"],
  cc: ["ID"]
}, {
  pk: 1573,
  ang: "Dampelas",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dampelas",
  lc: "dms",
  ld: "ltr",
  alt: ["Dampelasa", "Dian"],
  cc: ["ID"]
}, {
  pk: 1574,
  ang: "Tebi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dubu",
  lc: "dmu",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 1575,
  ang: "Dumpas",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Dumpas",
  lc: "dmv",
  ld: "ltr",
  alt: ["Doompas"],
  cc: ["MY"]
}, {
  pk: 1576,
  ang: "Mudburra",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Mudburra",
  lc: "dmw",
  ld: "ltr",
  alt: ["Madbara", "Moodburra", "Mootburra", "Mudbara", "Mudbera", "Mudbra", "Mudbura", "Mutpura", "Pinkagama", "Pinkagarna"],
  cc: ["AU"]
}, {
  pk: 1577,
  ang: "Dema",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Dema",
  lc: "dmx",
  ld: "ltr",
  alt: [],
  cc: ["MZ"]
}, {
  pk: 1578,
  ang: "Sowari",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Demta",
  lc: "dmy",
  ld: "ltr",
  alt: ["Muris"],
  cc: ["ID"]
}, {
  pk: 1579,
  ang: "Dani, Upper Grand Valley",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Upper Grand Valley Dani",
  lc: "dna",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 1580,
  ang: "Daonda",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Daonda",
  lc: "dnd",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 1581,
  ang: "Ndendeule",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Ndendeule",
  lc: "dne",
  ld: "ltr",
  alt: ["Kindendeule", "Kindendeuli", "Ndendeuli"],
  cc: ["TZ"]
}, {
  pk: 1582,
  ang: "Dungan",
  lr: "Asia",
  gw: false,
  hc: "KG",
  ln: "Dungan",
  lc: "dng",
  ld: "ltr",
  alt: ["Dzhunyan", "Kwuizwu", "Tungan", "Zwn'jan", "Ganzu (Gansu)", "Shaanxi (Shensi)"],
  cc: ["KZ", "KG", "UZ"]
}, {
  pk: 1583,
  ang: "Dani, Lower Grand Valley",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lower Grand Valley Dani",
  lc: "dni",
  ld: "ltr",
  alt: ["Kurima", "Lower Grand Valley Hitigima (Dani-Kurima)", "Lower Kimbin (Kibin)", "Upper Bele"],
  cc: ["ID"]
}, {
  pk: 1584,
  ang: "Dan",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Dan",
  lc: "dnj",
  ld: "ltr",
  alt: ["Da", "Gio", "Gio-Dan", "Ya", "Yacouba", "Yakuba", "Gyo", "Guio", "Blowo (Western Dan)", "Gweetaawu (Eastern Dan)"],
  cc: ["CI", "LR", "GN"]
}, {
  pk: 1585,
  ang: "Dengka",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dengka",
  lc: "dnk",
  ld: "ltr",
  alt: ["Rote", "Rote Barat", "Roti", "Rotinese", "Western Rote", "Lelain", "Western Dengka", "Eastern Dengka"],
  cc: ["ID"]
}, {
  pk: 1586,
  ang: "Dz\xF9\xF9ngoo",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Dz\xF9\xF9ngoo",
  lc: "dnn",
  ld: "ltr",
  alt: ["Eastern Duun", "Kpango", "Samogho", "Samogo", "Samoro", "Dz\xF9\xF9ngoo (Samogohiri)", "Kpangoo (Samorogouan)", "Kpeengo"],
  cc: ["BF"]
}, {
  pk: 1587,
  ang: "Danaru",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Danaru",
  lc: "dnr",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 1588,
  ang: "Dani, Mid Grand Valley",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mid Grand Valley Dani",
  lc: "dnt",
  ld: "ltr",
  alt: ["Baliem Valley Dani", "Central Grand Valley Dani", "Tulem"],
  cc: ["ID"]
}, {
  pk: 1589,
  ang: "Danau",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Danau",
  lc: "dnu",
  ld: "ltr",
  alt: ["Danaw"],
  cc: ["MM"]
}, {
  pk: 1590,
  ang: "Danu",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Danu",
  lc: "dnv",
  ld: "ltr",
  alt: ["Taruw"],
  cc: ["MM"]
}, {
  pk: 1591,
  ang: "Dani, Western",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Western Dani",
  lc: "dnw",
  ld: "ltr",
  alt: ["Dani Barat", "Ilaga Western Dani", "Laany", "Lani", "Oeringoep", "Timorini"],
  cc: ["ID"]
}, {
  pk: 1592,
  ang: "Den\xED",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Den\xED",
  lc: "dny",
  ld: "ltr",
  alt: ["Dani"],
  cc: ["BR"]
}, {
  pk: 1593,
  ang: "Dom",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Dom",
  lc: "doa",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 1594,
  ang: "Dobu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Dobu",
  lc: "dob",
  ld: "ltr",
  alt: ["Dobuan", "Central Dobu", "Galubwa", "Loboda (Dawada-Siausi)", "Roboda", "Sanaroa"],
  cc: ["PG"]
}, {
  pk: 1595,
  ang: "Dong, Northern",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5317\u4F97\u8A9E",
  lc: "doc",
  ld: "ltr",
  alt: ["Gam", "Kam", "Tong", "Tung", "Tung-Chia"],
  cc: ["CN"]
}, {
  pk: 1596,
  ang: "Doe",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Doe",
  lc: "doe",
  ld: "ltr",
  alt: ["Dohe", "Kidoe"],
  cc: ["TZ"]
}, {
  pk: 1597,
  ang: "Domu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Domu",
  lc: "dof",
  ld: "ltr",
  alt: ["Dom"],
  cc: ["PG"]
}, {
  pk: 1598,
  ang: "Dong",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Dong",
  lc: "doh",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 1599,
  ang: "Dogri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Dogri (macrolanguage)",
  lc: "doi",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 1600,
  ang: "Dondo",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dondo",
  lc: "dok",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 1601,
  ang: "Doso",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Doso",
  lc: "dol",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 1602,
  ang: "Toura",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Toura (Papua New Guinea)",
  lc: "don",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 1603,
  ang: "Dongo",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Dongo",
  lc: "doo",
  ld: "ltr",
  alt: ["Donga", "Dongo Ko"],
  cc: ["CD"]
}, {
  pk: 1604,
  ang: "Lukpa",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Lukpa",
  lc: "dop",
  ld: "ltr",
  alt: ["Legba", "Logba", "Lokpa", "Lugba"],
  cc: ["BJ", "TG"]
}, {
  pk: 1605,
  ang: "Dominican Sign Language",
  lr: "Americas",
  gw: false,
  hc: "DO",
  ln: "Dominican Sign Language",
  lc: "doq",
  ld: "ltr",
  alt: [],
  cc: ["DO"]
}, {
  pk: 1606,
  ang: "Dori\u2019o",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Dori'o",
  lc: "dor",
  ld: "ltr",
  alt: ["Kwarekwareo"],
  cc: ["SB"]
}, {
  pk: 1607,
  ang: "Dogos\xE9",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Dogos\xE9",
  lc: "dos",
  ld: "ltr",
  alt: ["Doghose", "Doghosi\xE9", "Dokhobe", "Dokhosi\xE9", "Dorhossi\xE9", "Dorhosye", "Doro Doghosi\xE9", "Dorob\xE9", "Dorosie", "Doross\xE9"],
  cc: ["BF"]
}, {
  pk: 1608,
  ang: "Dass",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Dass",
  lc: "dot",
  ld: "ltr",
  alt: ["Barawa", "Lukshi (Dekshi)", "Zumbul (Boodla)", "Wandi (Wangday)", "Durr-Baraza (Bandas)", "Dot (Dott)", "Zodi", "Dwat"],
  cc: ["NG"]
}, {
  pk: 1609,
  ang: "Dombe",
  lr: "Africa",
  gw: false,
  hc: "ZW",
  ln: "Tonga",
  lc: "dov",
  ld: "ltr",
  alt: [],
  cc: ["ZW"]
}, {
  pk: 1610,
  ang: "Doyayo",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Doyayo",
  lc: "dow",
  ld: "ltr",
  alt: ["Doayo", "Donyanyo", "Donyayo", "Doohyaayo", "Doowaayo", "Dooyayo", "Dowayayo", "Dowayo", "Doyaayo", "Doyau", "Nomai", "Tunga", "Tungbo", "Tuuno", "Namchi", "Namci", "Namshi", "Teere (Poli)"],
  cc: ["CM"]
}, {
  pk: 1611,
  ang: "Bussa",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Bussa",
  lc: "dox",
  ld: "ltr",
  alt: ["Dobase", "D'oopace", "D'opaasunte", "Gobeze", "Goraze", "Gowase", "Lohu", "Mashelle", "Mashile", "Masholle", "Mosiye", "Musiye", "Orase"],
  cc: ["ET"]
}, {
  pk: 1612,
  ang: "Dompo",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Dompo",
  lc: "doy",
  ld: "ltr",
  alt: ["Dumpo", "Ndmpo"],
  cc: ["GH"]
}, {
  pk: 1613,
  ang: "Dorze",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Dorze",
  lc: "doz",
  ld: "ltr",
  alt: [],
  cc: ["ET"]
}, {
  pk: 1614,
  ang: "Papar",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Papar",
  lc: "dpp",
  ld: "ltr",
  alt: ["Bajau Bukit"],
  cc: ["MY"]
}, {
  pk: 1615,
  ang: "Dair",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Dair",
  lc: "drb",
  ld: "ltr",
  alt: ["Dabab", "Daier", "Thaminyi"],
  cc: ["SD"]
}, {
  pk: 1616,
  ang: "Minderico",
  lr: "Europe",
  gw: false,
  hc: "PT",
  ln: "Minderico",
  lc: "drc",
  ld: "ltr",
  alt: [],
  cc: ["PT"]
}, {
  pk: 1617,
  ang: "Darmiya",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Darmiya",
  lc: "drd",
  ld: "ltr",
  alt: ["Darimiya", "Darmani", "Saukas", "Shaukas"],
  cc: ["NP", "IN"]
}, {
  pk: 1618,
  ang: "Dolpo",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Dolpo",
  lc: "dre",
  ld: "ltr",
  alt: ["Dolkha", "Dolpa Tibetan", "Dolpike", "Phoke Dolpa"],
  cc: ["NP"]
}, {
  pk: 1619,
  ang: "Rungus",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Rungus",
  lc: "drg",
  ld: "ltr",
  alt: ["Dusun Dayak", "Melobong Rungus", "Memagun", "Memogun", "Momogun", "Roongas", "Rungus Dusun", "Gandahon", "Nuluw", "Pilapazan (Central Rungus)", "Rungus Tanga"],
  cc: ["MY"]
}, {
  pk: 8391,
  ang: "Gonsomon",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Gonsomon",
  lc: "drg-x-gonsomon",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1620,
  ang: "C\u2019Lela",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "C'lela",
  lc: "dri",
  ld: "ltr",
  alt: ["Cala-Cala", "Chilala", "Chilela", "Dakakari", "Dakarkari", "Kolela", "Lalawa", "Southern Lela", "Yelmo", "Roma-Na", "Roma", "Lila (Senchi)", "Dabai (Central Lela)", "Adoma (Aroma)", "Northern Lela", "Zuru"],
  cc: ["NG"]
}, {
  pk: 1621,
  ang: "Paakantyi",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Paakantyi",
  lc: "drl",
  ld: "ltr",
  alt: ["Baagandji", "Paakanti", "Paakintyi", "Southern Baagandji", "Milpulo", "Wanyuparlku", "Thangkaali", "Southern Paakantyi", "Pulaali", "Parrintyi (Baarrundji)", "Pantyikali (Bandjigali)", "Nhaawuparlku", "Marrawarra (Maruara)", "Kurnu", "Barindji", "Wilyaali", "Paaruntyi"],
  cc: ["AU"]
}, {
  pk: 1622,
  ang: "Damar, West",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "West Damar",
  lc: "drn",
  ld: "ltr",
  alt: ["North Damar"],
  cc: ["ID"]
}, {
  pk: 1623,
  ang: "Melanau, Daro-Matu",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Daro-Matu Melanau",
  lc: "dro",
  ld: "ltr",
  alt: ["Phaneng", "Ngaleng", "Matu (Langle-Tamtlaih)"],
  cc: ["MY"]
}, {
  pk: 1624,
  ang: "Dura",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Dura",
  lc: "drq",
  ld: "ltr",
  alt: [],
  cc: ["NP"]
}, {
  pk: 1625,
  ang: "Gedeo",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Gedeo",
  lc: "drs",
  ld: "ltr",
  alt: ["Darasa", "Darassa", "Derasa", "Derasanya", "Deresa", "Geddeo"],
  cc: ["ET"]
}, {
  pk: 1626,
  ang: "Drents",
  lr: "Europe",
  gw: false,
  hc: "NL",
  ln: "Drents",
  lc: "drt",
  ld: "ltr",
  alt: ["Drente", "North Drente (Noord-Drents)", "South Drente (Zuid-Drents)"],
  cc: ["NL"]
}, {
  pk: 1627,
  ang: "Rukai",
  lr: "Asia",
  gw: false,
  hc: "TW",
  ln: "Rukai",
  lc: "dru",
  ld: "ltr",
  alt: ["Banga", "Bantalang", "Bantaurang", "Drukay", "Dukai", "Dyokay", "Kadas", "Rutkai", "Sarisen", "Taloma", "Tsalisen", "Tsarisen"],
  cc: ["CN", "TW"]
}, {
  pk: 1628,
  ang: "Darai",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Darai",
  lc: "dry",
  ld: "ltr",
  alt: ["Chitwan", "Tanahun"],
  cc: ["NP"]
}, {
  pk: 1629,
  ang: "Sorbian, Lower",
  lr: "Europe",
  gw: false,
  hc: "DE",
  ln: "Lower Sorbian",
  lc: "dsb",
  ld: "ltr",
  alt: ["Bas Sorabe", "Delnoserbski", "Lluzykie", "Lower Lusatian", "Lusatian", "Luzycki", "Niedersorbisch", "Wendish"],
  cc: ["DE"]
}, {
  pk: 1630,
  ang: "Sign Language of the Netherlands",
  lr: "Europe",
  gw: false,
  hc: "NL",
  ln: "Dutch Sign Language",
  lc: "dse",
  ld: "ltr",
  alt: ["Nederlandse Gebarentaal", "NGT", "SLN"],
  cc: ["NL"]
}, {
  pk: 1631,
  ang: "Daasanach",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Daasanach",
  lc: "dsh",
  ld: "ltr",
  alt: ["Dama", "Dasenech", "Dathanaic", "Dathanaik", "Dathanik", "Dhaasanac", "Gallab", "Galuba", "Gelab", "Geleb", "Geleba", "Gelebinya", "Gelubba", "Gheleba", "Marille", "Merile", "Merille", "Morille", "Reshiat", "Russia", "Shangilla"],
  cc: ["ET", "KE", "SS"]
}, {
  pk: 1632,
  ang: "Disa",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Disa",
  lc: "dsi",
  ld: "ltr",
  alt: [],
  cc: ["TD"]
}, {
  pk: 1633,
  ang: "Danish Sign Language",
  lr: "Europe",
  gw: false,
  hc: "DK",
  ln: "Danish Sign Language",
  lc: "dsl",
  ld: "ltr",
  alt: [],
  cc: ["DK"]
}, {
  pk: 1634,
  ang: "Dusner",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dusner",
  lc: "dsn",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 1635,
  ang: "Desiya",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Desiya",
  lc: "dso",
  ld: "ltr",
  alt: ["Deshia", "Desia", "Desiya Oriya", "Koraput Oriya"],
  cc: ["IN"]
}, {
  pk: 1636,
  ang: "Tadaksahak",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Tadaksahak",
  lc: "dsq",
  ld: "ltr",
  alt: ["Daosahaq", "Daoussahaq", "Daoussak", "Dawsahaq"],
  cc: ["DZ", "ML"]
}, {
  pk: 1637,
  ang: "Daur",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u8FBE\u65A1\u5C14\u8BED",
  lc: "dta",
  ld: "ltr",
  alt: ["Daguor", "Dagur", "Dawar", "Dawo'er", "Tahuerh", "Tahur", "Jiangdong", "Tsitsikhar", "Qiqihar", "Qiqiha'er (Qiqihar)", "Qiqiha'er (Fularji)", "Nemor", "Nawen", "Nantun", "Mokertu", "Buteha (Aihui)", "Mergen", "Butah", "Jingxi", "Buteha (Bataxan)", "Darbin", "Haila'er (Hailar)", "Ili", "Bataxan"],
  cc: ["CN"]
}, {
  pk: 1638,
  ang: "Kadazan, Labuk-Kinabatangan",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Labuk-Kinabatangan Kadazan",
  lc: "dtb",
  ld: "ltr",
  alt: ["Eastern Kadazan", "Labuk Kadazan", "Sogilitan", "Tindakon", "Tompulung", "Labuk", "Lamag Sungai (Sungei)", "Mangkaak (Mangkahak)", "Mangkak", "Mangkok"],
  cc: ["MY"]
}, {
  pk: 1639,
  ang: "Ditidaht",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Ditidaht",
  lc: "dtd",
  ld: "ltr",
  alt: ["Nitinaht", "Nitinat"],
  cc: ["CA"]
}, {
  pk: 1640,
  ang: "Dogon, Ana Tinga",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Ana Tinga Dogon",
  lc: "dti",
  ld: "ltr",
  alt: [],
  cc: ["ML"]
}, {
  pk: 1641,
  ang: "Dogon, Tene Kan",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Tene Kan Dogon",
  lc: "dtk",
  ld: "ltr",
  alt: ["Tene Kan", "Tene Tingi", "Tengu Kan", "Giwnri Kan", "Togo Kan", "Woru Kan (Wolu Kan)"],
  cc: ["ML"]
}, {
  pk: 1642,
  ang: "Dogon, Tomo Kan",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Tomo Kan Dogon",
  lc: "dtm",
  ld: "ltr",
  alt: ["Tomo-Kan", "Tie Bara", "Tienwan Ganda", "Tanwan Bara", "Nienne", "Bongu", "Basara", "Aa Bara", "Aa"],
  cc: ["ML"]
}, {
  pk: 1643,
  ang: "Dogon, Tommo So",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Tommo So Dogon",
  lc: "dto",
  ld: "ltr",
  alt: ["Tombo-So"],
  cc: ["ML"]
}, {
  pk: 1644,
  ang: "Dusun, Central",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Central Dusun",
  lc: "dtp",
  ld: "ltr",
  alt: ["Central Kadazan", "Dusan", "Dusum", "Dusun", "Dusur", "Kadasan", "Kadayan", "Kedayan", "Dusun Sinulihan (Sinulihan)", "Kadazan-Tagaro (Tagaro)", "Menggatal (Kiulu)", "Telipok", "Bundu (Taginambur)"],
  cc: ["MY"]
}, {
  pk: 1645,
  ang: "Lotud",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Lotud",
  lc: "dtr",
  ld: "ltr",
  alt: ["Dusun Lotud", "Suang Lotud"],
  cc: ["MY"]
}, {
  pk: 1646,
  ang: "Dogon, Toro So",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Toro So Dogon",
  lc: "dts",
  ld: "ltr",
  alt: ["Bomu Tegu", "Dogoso", "Ibi", "Youga", "Yorno", "Ireli", "Sangha"],
  cc: ["BF", "ML"]
}, {
  pk: 1647,
  ang: "Dogon, Toro Tegu",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Toro Tegu Dogon",
  lc: "dtt",
  ld: "ltr",
  alt: ["Tandam"],
  cc: ["ML"]
}, {
  pk: 1648,
  ang: "Dogon, Tebul Ure",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Tebul Ure Dogon",
  lc: "dtu",
  ld: "ltr",
  alt: [],
  cc: ["ML"]
}, {
  pk: 1649,
  ang: "Dotyali",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u0921\u094B\u091F\u0947\u0932\u0940",
  lc: "dty",
  ld: "ltr",
  alt: ["Dotali", "Doteli"],
  cc: ["NP"]
}, {
  pk: 1650,
  ang: "Duala",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Duala",
  lc: "dua",
  ld: "ltr",
  alt: ["Diwala", "Dualla", "Dwala", "Dwela", "Sawa", "Koli", "Mungo (Mungu)", "Muungo", "Oli (Ewodi)", "Ouri", "Uli", "Wouri", "Wuri"],
  cc: ["CM"]
}, {
  pk: 1651,
  ang: "Dubli",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Dubli",
  lc: "dub",
  ld: "ltr",
  alt: ["Dubala", "Dubla", "Rathod", "Talavia"],
  cc: ["IN"]
}, {
  pk: 1652,
  ang: "Duna",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Duna",
  lc: "duc",
  ld: "ltr",
  alt: ["Yuna"],
  cc: ["PG"]
}, {
  pk: 1653,
  ang: "Hun-Saare",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Hun-Saare",
  lc: "dud",
  ld: "ltr",
  alt: ["Duka", "Dukanchi", "Dukanci", "Dukawa", "Dukwa", "Western Duka (Es-Saare)", "Eastern Duka (Et-Hun)", "Hun", "Hune"],
  cc: ["NG"]
}, {
  pk: 1654,
  ang: "Agta, Umiray Dumaget",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Umiray Dumaget Agta",
  lc: "due",
  ld: "ltr",
  alt: ["Umiray Agta", "Umirey Dumagat"],
  cc: ["PH"]
}, {
  pk: 1655,
  ang: "Drubea",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Dumbea",
  lc: "duf",
  ld: "ltr",
  alt: ["Diubea", "Dubea", "Naa Drubea", "Naa Dubea", "Ndumbea", "Nraa Drubea"],
  cc: ["NC"]
}, {
  pk: 1656,
  ang: "Chiduruma",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Duruma",
  lc: "dug",
  ld: "ltr",
  alt: ["Wanyika"],
  cc: ["KE"]
}, {
  pk: 1657,
  ang: "Dungra Bhil",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Dungra Bhil",
  lc: "duh",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 1658,
  ang: "Dumun",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Dumun",
  lc: "dui",
  ld: "ltr",
  alt: ["Bai"],
  cc: ["PG"]
}, {
  pk: 1659,
  ang: "Dhuwal",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Dhuwal",
  lc: "duj",
  ld: "ltr",
  alt: ["Dual", "Duala", "Wulamba", "Datiwuy (Daatiwuy)"],
  cc: ["AU"]
}, {
  pk: 1660,
  ang: "Uyajitaya",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Uyajitaya",
  lc: "duk",
  ld: "ltr",
  alt: ["Abowe", "Amito", "Amowe", "Koki", "Uyaji", "Xuyadzitaya", "Yabatia"],
  cc: ["PG"]
}, {
  pk: 8421,
  ang: "Buai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Buai",
  lc: "duk-x-buai",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8420,
  ang: "Duduela",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Duduela",
  lc: "duk-x-duduela",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1661,
  ang: "Agta, Alabat Island",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Alabat Island Agta",
  lc: "dul",
  ld: "ltr",
  alt: ["Alabat Island Dumagat"],
  cc: ["PH"]
}, {
  pk: 1662,
  ang: "Middle Dutch",
  lr: "Europe",
  gw: false,
  hc: "NL",
  ln: "Middle Dutch (ca. 1050-1350)",
  lc: "dum",
  ld: "ltr",
  alt: [],
  cc: ["NL"]
}, {
  pk: 1663,
  ang: "Dusun Deyah",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dusun Deyah",
  lc: "dun",
  ld: "ltr",
  alt: ["Deah", "Dejah"],
  cc: ["ID"]
}, {
  pk: 1664,
  ang: "Agta, Dupaninan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Dupaninan Agta",
  lc: "duo",
  ld: "ltr",
  alt: ["Dupaningan Agta", "Eastern Cagayan Agta", "Roso (Southeast Cagayan)"],
  cc: ["PH"]
}, {
  pk: 1665,
  ang: "Duano",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Duano",
  lc: "dup",
  ld: "ltr",
  alt: ["Desin Dolak", "Desin Duano", "Duano'", "Orang Kuala", "Orang Laut"],
  cc: ["ID", "MY"]
}, {
  pk: 1666,
  ang: "Dusun Malang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dusun Malang",
  lc: "duq",
  ld: "ltr",
  alt: ["Bayan"],
  cc: ["ID"]
}, {
  pk: 8379,
  ang: "Dusun Bayan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dusun Bayan",
  lc: "duq-x-",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1667,
  ang: "Dii",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Dii",
  lc: "dur",
  ld: "ltr",
  alt: ["Dourou", "Durru", "Nyag Dii", "Yag Dii", "Zaa", "Saakye", "Sagzee (Saadje)"],
  cc: ["CM"]
}, {
  pk: 1668,
  ang: "Dumi",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Dumi",
  lc: "dus",
  ld: "ltr",
  alt: ["Dumi Bo'o", "Dumi Bro", "Hopupo Bro", "Lsi Rai", "Ro'do Bo'", "Sotmali"],
  cc: ["NP"]
}, {
  pk: 1669,
  ang: "Drung",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u72EC\u9F99\u8BED",
  lc: "duu",
  ld: "ltr",
  alt: ["Derung", "Qiu", "Rawang", "Tarong", "Thrung", "Trung", "T'rung", "Tulung", "Derung River", "Dulong River (Central Dulongjiang)", "Northern Dulongjiang", "Nu River (Nujiang Dulong)", "Southern Dulongjiang"],
  cc: ["CN", "MM"]
}, {
  pk: 1670,
  ang: "Duvle",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Duvle",
  lc: "duv",
  ld: "ltr",
  alt: ["Duvde", "Duve", "Duvele", "Duvre", "Wiri"],
  cc: ["ID"]
}, {
  pk: 1671,
  ang: "Dusun Witu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dusun Witu",
  lc: "duw",
  ld: "ltr",
  alt: ["Dusun Pepas"],
  cc: ["ID"]
}, {
  pk: 8381,
  ang: "Dusun Pepas",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dusun Pepas",
  lc: "duw-x-dusunpepas",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1672,
  ang: "Duungooma",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Duungooma",
  lc: "dux",
  ld: "ltr",
  alt: ["Du", "Duungo", "Mali Duun", "Samogho", "Samogo", "Samoro", "Western Duun"],
  cc: ["ML"]
}, {
  pk: 1673,
  ang: "Divehi, Dhivehi, Maldivian",
  lr: "Asia",
  gw: false,
  hc: "MV",
  ln: "\u078B\u07A8\u0788\u07AC\u0780\u07A8",
  lc: "dv",
  ld: "rtl",
  alt: ["Dhivehi Bas", "Divehi", "Mahl", "Malikh", "Malki", "Divehi Bas", "Divehli", "Mali", "Maliku Bas (Minicoy Dialect)", "Fuvah Mulaku", "Huvadu", "Mal\xE9", "Maliku Bas"],
  cc: ["FR", "MV", "IN"]
}, {
  pk: 1674,
  ang: "Duau",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Duau",
  lc: "dva",
  ld: "ltr",
  alt: ["Guleguleu (Guragureu)"],
  cc: ["PG"]
}, {
  pk: 1675,
  ang: "Diri",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Diri",
  lc: "dwa",
  ld: "ltr",
  alt: ["Diriya", "Dirya", "Diryawa"],
  cc: ["NG"]
}, {
  pk: 1676,
  ang: "Dawro",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Dawro",
  lc: "dwr",
  ld: "ltr",
  alt: ["Cullo", "Dauro", "Kullo", "Ometay", "Konta (Conta)", "Kusha", "Kucha (Koysha)"],
  cc: ["ET"]
}, {
  pk: 1677,
  ang: "",
  lr: "",
  gw: false,
  hc: "",
  ln: "Dutton World Speedwords",
  lc: "dws",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1678,
  ang: "Dawawa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Dawawa",
  lc: "dww",
  ld: "ltr",
  alt: ["Dawana"],
  cc: ["PG"]
}, {
  pk: 1679,
  ang: "Dyan",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Dyan",
  lc: "dya",
  ld: "ltr",
  alt: ["Dan", "Dian", "Dya", "Dyane", "Dyanu"],
  cc: ["BF"]
}, {
  pk: 1680,
  ang: "S\xE9noufo, Djimini",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Djimini Senoufo",
  lc: "dyi",
  ld: "ltr",
  alt: ["Dyimini", "Jinmini", "Diamala (Djamala)", "Dyamala"],
  cc: ["CI"]
}, {
  pk: 1681,
  ang: "Dogon, Yanda Dom",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Yanda Dom Dogon",
  lc: "dym",
  ld: "ltr",
  alt: [],
  cc: ["ML"]
}, {
  pk: 1682,
  ang: "Jola-Fonyi",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Jola-Fonyi",
  lc: "dyo",
  ld: "ltr",
  alt: ["Diola-Fogny", "Jola", "Jola-Fogny", "Kujamataak", "K\xFAjoolaak Kati Foo\xF1i", "Yola", "Dyola", "J\xF3ola-F\xF3o\xF1i", "K\xFAjoolaak kati K\xFAfoo\xF1aak"],
  cc: ["FR", "GM", "MR", "SN", "GW"]
}, {
  pk: 1683,
  ang: "Jula",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Dyula",
  lc: "dyu",
  ld: "ltr",
  alt: ["Diula", "Djula", "Dyoula", "Dyula", "Jula Kong", "Kong Jula", "Trade Jula"],
  cc: ["BF", "CI", "GH", "ML", "US"]
}, {
  pk: 1684,
  ang: "Dyaabugay",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Dyaabugay",
  lc: "dyy",
  ld: "ltr",
  alt: ["Bulum-Bulum", "Check-Cull", "Chewlie", "Djabugai", "Dyabugay", "Hileman", "Kikonjunkulu", "Kodgotto", "Kokonyungalo", "Koko-Tjumbundji", "Ngarlkajie", "Orlow", "Tjabakai-Thandji", "Tjabogaijanji", "Tjankir", "Tjankun", "Tjapukai", "Tjapunkandji", "Tjunbundji", "Njakali (Nyagali)", "Nyakali"],
  cc: ["AU"]
}, {
  pk: 1685,
  ang: "Dzongkha",
  lr: "Asia",
  gw: false,
  hc: "BT",
  ln: "\u0F62\u0FAB\u0F7C\u0F44\u0F0B\u0F41",
  lc: "dz",
  ld: "ltr",
  alt: ["Bhotia of Bhutan", "Bhotia of Dukpa", "Bhutanese", "Drukha", "Drukke", "Dukpa", "Jonkha", "Rdzongkha", "Zongkhar", "Drukpa", "Hloka", "Lhoskad", "Wang-The (Thimphu-Punakha)"],
  cc: ["BT", "NP", "IN"]
}, {
  pk: 1686,
  ang: "Tunzuii",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Tunzuii",
  lc: "dza",
  ld: "ltr",
  alt: ["Dugusa", "Itunzu"],
  cc: ["NG"]
}, {
  pk: 1687,
  ang: "Dazaga",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Dazaga",
  lc: "dzg",
  ld: "ltr",
  alt: ["Daza", "Toubou", "Tubu", "Dasa", "Dazza", "Kashirda"],
  cc: ["NE", "TD"]
}, {
  pk: 1688,
  ang: "Dzalakha",
  lr: "Asia",
  gw: false,
  hc: "BT",
  ln: "Dzalakha",
  lc: "dzl",
  ld: "ltr",
  alt: ["Dzala", "Dzalamat", "Yangtsebikha"],
  cc: ["BT"]
}, {
  pk: 1689,
  ang: "Dzando",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Dzando",
  lc: "dzn",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 1690,
  ang: "Karenggapa",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Karenggapa",
  lc: "eaa",
  ld: "ltr",
  alt: ["Garanggaba", "Karrengappa", "Kurengappa"],
  cc: ["AU"]
}, {
  pk: 1691,
  ang: "Ebughu",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ebughu",
  lc: "ebg",
  ld: "ltr",
  alt: ["Oron"],
  cc: ["NG"]
}, {
  pk: 1692,
  ang: "Bontok, Eastern",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Eastern Bontok",
  lc: "ebk",
  ld: "ltr",
  alt: ["Eastern Bontoc", "Finallig", "Southern Bontoc"],
  cc: ["PH"]
}, {
  pk: 1693,
  ang: "Teke-Eboo",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Teke-Ebo",
  lc: "ebo",
  ld: "ltr",
  alt: ["Bamboma", "Boma", "Boo", "Bo\xF5", "Central Teke", "Eboo Teke", "Eboom", "Iboo", "Teke-Boma", "Teke-Nzikou"],
  cc: ["CG"]
}, {
  pk: 1694,
  ang: "Ebri\xE9",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Ebri\xE9",
  lc: "ebr",
  ld: "ltr",
  alt: ["Cama", "Caman", "Kyama", "Tchaman", "Tsama", "Tyama"],
  cc: ["CI"]
}, {
  pk: 1695,
  ang: "Kiembu",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Embu",
  lc: "ebu",
  ld: "ltr",
  alt: ["Mbere", "Mbeere (Kimbeere)"],
  cc: ["KE"]
}, {
  pk: 1696,
  ang: "Eteocretan",
  lr: "Europe",
  gw: false,
  hc: "GR",
  ln: "Eteocretan",
  lc: "ecr",
  ld: "ltr",
  alt: [],
  cc: ["GR"]
}, {
  pk: 1697,
  ang: "Ecuadorian Sign Language",
  lr: "Americas",
  gw: false,
  hc: "EC",
  ln: "Ecuadorian Sign Language",
  lc: "ecs",
  ld: "ltr",
  alt: ["Lengua de Se\xF1as de Ecuador", "LSEC"],
  cc: ["EC"]
}, {
  pk: 1698,
  ang: "Eteocypriot",
  lr: "Asia",
  gw: false,
  hc: "CY",
  ln: "Eteocypriot",
  lc: "ecy",
  ld: "ltr",
  alt: [],
  cc: ["CY"]
}, {
  pk: 1699,
  ang: "Ewe",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "E\u028Begbe",
  lc: "ee",
  ld: "ltr",
  alt: ["Ebwe", "Efe", "Eibe", "Eue", "Eve", "Gbe", "Krepe", "Krepi", "Popo", "Vhe", "Ehwe", "Be", "Vlin", "Vo", "Togo", "Ho", "Gbin", "Aveno", "Anglo (Anlo)", "Adan", "Agu", "Awlan"],
  cc: ["BJ", "BF", "GH", "LR", "NG", "US", "TG"]
}, {
  pk: 1700,
  ang: "E",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u8BF6\u8BDD",
  lc: "eee",
  ld: "ltr",
  alt: ["Eahua", "Kjang E", "Wuse Hua", "Wusehua"],
  cc: ["CN"]
}, {
  pk: 1701,
  ang: "Efai",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Efai",
  lc: "efa",
  ld: "ltr",
  alt: ["Effiat"],
  cc: ["NG"]
}, {
  pk: 1702,
  ang: "Efe",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Efe",
  lc: "efe",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 1703,
  ang: "Efik",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Efik",
  lc: "efi",
  ld: "ltr",
  alt: ["Calabar"],
  cc: ["CM", "NG", "US"]
}, {
  pk: 1704,
  ang: "Ega",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Ega",
  lc: "ega",
  ld: "ltr",
  alt: ["Di\xE9s", "Egwa"],
  cc: ["CI"]
}, {
  pk: 1705,
  ang: "Emilian",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Emilian",
  lc: "egl",
  ld: "ltr",
  alt: ["Bolognese", "Ferrarese", "Modenese", "Parmigiano", "Piacentino", "Reggiano"],
  cc: ["IT"]
}, {
  pk: 1706,
  ang: "Eggon",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Eggon",
  lc: "ego",
  ld: "ltr",
  alt: ["Egon", "Hill Mada", "Mada Dutse", "Mada Eggon", "Mo Egon"],
  cc: ["NG"]
}, {
  pk: 1707,
  ang: "Egyptian",
  lr: "Africa",
  gw: false,
  hc: "EG",
  ln: "Egyptian (Ancient)",
  lc: "egy",
  ld: "ltr",
  alt: [],
  cc: ["EG"]
}, {
  pk: 1708,
  ang: "Ehueun",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ehueun",
  lc: "ehu",
  ld: "ltr",
  alt: ["Ekpenmen", "Ekpimi", "Epimi"],
  cc: ["NG"]
}, {
  pk: 1709,
  ang: "Lik",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Eipomek",
  lc: "eip",
  ld: "ltr",
  alt: ["Eipo", "T-Valley"],
  cc: ["ID"]
}, {
  pk: 1710,
  ang: "Eitiep",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Eitiep",
  lc: "eit",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 1711,
  ang: "Askopan",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Askopan",
  lc: "eiv",
  ld: "ltr",
  alt: ["Eivo 1"],
  cc: ["PG"]
}, {
  pk: 1712,
  ang: "Jola-Felupe",
  lr: "Africa",
  gw: false,
  hc: "GW",
  ln: "Ejamat",
  lc: "eja",
  ld: "ltr",
  alt: ["Ediamat", "Ejamat", "Feloup", "Felup", "Felupe", "Floup", "Flup", "Fulup"],
  cc: ["GW"]
}, {
  pk: 1713,
  ang: "Ekajuk",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ekajuk",
  lc: "eka",
  ld: "ltr",
  alt: ["Akajo", "Ebanimbim", "Ekagongho", "Esham", "Mfom"],
  cc: ["NG"]
}, {
  pk: 1714,
  ang: "Ekit",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ekit",
  lc: "eke",
  ld: "ltr",
  alt: ["Eket"],
  cc: ["NG"]
}, {
  pk: 1715,
  ang: "Ekari",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ekari",
  lc: "ekg",
  ld: "ltr",
  alt: ["Ekagi", "Kapauku", "Me Mana", "Mee Mana", "Tapiro", "Mapiya-Kegata", "Yabi (Jabi)", "Mee"],
  cc: ["ID"]
}, {
  pk: 1716,
  ang: "Eki",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Eki",
  lc: "eki",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 1717,
  ang: "Estonian, Standard",
  lr: "Europe",
  gw: false,
  hc: "EE",
  ln: "Standard Estonian",
  lc: "ekk",
  ld: "ltr",
  alt: ["Eesti", "Tartu (Dorpat)", "Tallinn (Reval)", "Tallinn (Northern Estonian)", "Southern Estonian", "Reval", "Muly (Mulgi)", "Tatu"],
  cc: ["EE", "KZ", "GB", "SE", "US", "AU", "CA", "UZ"]
}, {
  pk: 1718,
  ang: "Kol",
  lr: "Asia",
  gw: false,
  hc: "BD",
  ln: "Kol (Bangladesh)",
  lc: "ekl",
  ld: "ltr",
  alt: ["Hor"],
  cc: ["BD"]
}, {
  pk: 1719,
  ang: "Elip",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Elip",
  lc: "ekm",
  ld: "ltr",
  alt: ["Belibi", "Belip", "Central Yambassa", "Libie", "Nulibie", "Nulibi\xE9", "Nukanya", "Nulamba", "Nuyambassa"],
  cc: ["CM"]
}, {
  pk: 1720,
  ang: "Koti",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Koti",
  lc: "eko",
  ld: "ltr",
  alt: ["Angoche", "Angoxe", "Coti", "Ekoti", "Enatthembo (\"Edheidhei\")", "Esangaji", "Sangaje", "\"Etteittei\"", "Esangaje", "Esakaji"],
  cc: ["MZ"]
}, {
  pk: 1721,
  ang: "Ekpeye",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ekpeye",
  lc: "ekp",
  ld: "ltr",
  alt: ["Ekkpahia", "Ekpabya", "Ekpaffia"],
  cc: ["NG"]
}, {
  pk: 1722,
  ang: "Yace",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Yace",
  lc: "ekr",
  ld: "ltr",
  alt: ["Ekpari", "Iyace", "Yatye"],
  cc: ["NG"]
}, {
  pk: 1723,
  ang: "Kayah, Eastern",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Eastern Kayah",
  lc: "eky",
  ld: "ltr",
  alt: ["Karenni", "Karennyi", "Kayah Li", "Kayay", "Red Karen", "Kayah", "Yang Daeng", "Lower Eastern Kayah", "Upper Eastern Kayah"],
  cc: ["TH", "MM"]
}, {
  pk: 1724,
  ang: "Greek (modern)",
  lr: "Europe",
  gw: false,
  hc: "GR",
  ln: "\u03B5\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC",
  lc: "el",
  ld: "ltr",
  alt: ["Ellinika", "Graecae", "Grec", "Greco", "Neo-Hellenic", "Romaic", "Griko", "Tavro-Rumeic", "Mariupol Greek (Crimeo-Rumeic)"],
  cc: ["AT", "CY", "GR", "DE", "KZ", "GB", "AL", "CZ", "NZ", "TR", "US", "AU", "CA", "GE", "IT", "MW"]
}, {
  pk: 1725,
  ang: "Elepi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Elepi",
  lc: "ele",
  ld: "ltr",
  alt: ["Samap"],
  cc: ["PG"]
}, {
  pk: 1726,
  ang: "El Hugeirat",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "El Hugeirat",
  lc: "elh",
  ld: "ltr",
  alt: ["El Hagarat"],
  cc: ["SD"]
}, {
  pk: 1727,
  ang: "Nding",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Nding",
  lc: "eli",
  ld: "ltr",
  alt: [],
  cc: ["SD"]
}, {
  pk: 1728,
  ang: "Elkei",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Elkei",
  lc: "elk",
  ld: "ltr",
  alt: ["Olkoi"],
  cc: ["PG"]
}, {
  pk: 1729,
  ang: "Eleme",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Eleme",
  lc: "elm",
  ld: "ltr",
  alt: ["Nchia", "Odido"],
  cc: ["NG"]
}, {
  pk: 1730,
  ang: "El Molo",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "El Molo",
  lc: "elo",
  ld: "ltr",
  alt: ["Dehes", "Elmolo", "Fura-Pawa", "Ldes", "Ndorobo"],
  cc: ["KE"]
}, {
  pk: 1731,
  ang: "Elu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Elu",
  lc: "elu",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 1732,
  ang: "Elamite",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Elamite",
  lc: "elx",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 1733,
  ang: "Emai-Iuleha-Ora",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Emai-Iuleha-Ora",
  lc: "ema",
  ld: "ltr",
  alt: ["Kunibum"],
  cc: ["NG"]
}, {
  pk: 7824,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Emai",
  lc: "ema-x-emai",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8269,
  ang: "Erah",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Erah",
  lc: "ema-x-erah",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7561,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ora",
  lc: "ema-x-ora",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 1734,
  ang: "Embaloh",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Embaloh",
  lc: "emb",
  ld: "ltr",
  alt: ["Malo", "Maloh", "Matoh", "Mbaloh", "Memaloh", "Palin", "Pari", "Sangau", "Sanggau", "Kalis (Kalis Dayak)", "Kalis Maloh"],
  cc: ["ID"]
}, {
  pk: 8004,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Kalis",
  lc: "emb-x-kalis",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1735,
  ang: "Emerillon",
  lr: "Americas",
  gw: false,
  hc: "GF",
  ln: "Emerillon",
  lc: "eme",
  ld: "ltr",
  alt: ["Emere\xF1on", "Emerilon", "Melejo", "Mereo", "Mereyo", "Teco", "Teko"],
  cc: ["GF"]
}, {
  pk: 1736,
  ang: "Mewahang, Eastern",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Eastern Meohang",
  lc: "emg",
  ld: "ltr",
  alt: ["Eastern Meohang", "Mewahang", "Newahang", "Newahang Jimi", "Newang", "Newange Rai"],
  cc: ["NP"]
}, {
  pk: 1737,
  ang: "Mussau-Emira",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mussau-Emira",
  lc: "emi",
  ld: "ltr",
  alt: ["Emira-Mussau", "Musao", "Musau-Emira", "Mussau"],
  cc: ["PG"]
}, {
  pk: 1738,
  ang: "Maninkakan, Eastern",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Eastern Maninkakan",
  lc: "emk",
  ld: "ltr",
  alt: ["Eastern Malinke", "Kankan Maninka", "Malink\xE9", "Mande", "Maninka", "Southern Maninka", "Madingo", "Mandingo", "Southern Malinke", "Wassulu", "Wassulunke", "Wasulunkakan (Wasolon Maninka)", "Wassulunka", "Maninka-Mori (Mori)", "Gbereduu", "Amana (Kourousa)", "Baliya", "Toron", "Wasuu", "Kankan Mininka"],
  cc: ["LR", "ML", "GN", "SL"]
}, {
  pk: 1739,
  ang: "Mamulique",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Mamulique",
  lc: "emm",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 1740,
  ang: "Eman",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Eman",
  lc: "emn",
  ld: "ltr",
  alt: ["Emane", "Amana", "Amanavil (Aman)", "Amani", "Elaka"],
  cc: ["CM"]
}, {
  pk: 1741,
  ang: "Ember\xE1, Northern",
  lr: "Americas",
  gw: false,
  hc: "PA",
  ln: "Northern Ember\xE1",
  lc: "emp",
  ld: "ltr",
  alt: ["Atrato", "Cholo", "Dari\xE9n", "Dariena", "Eber\xE3", "Eber\xE3 Bed'ea", "Emper\xE3", "Eper\xE3 Pedea", "Panama Embera", "Choc\xF3", "Darien", "Darien Ember\xE1", "Ebera Bedea", "Eer\xE3", "Empera"],
  cc: ["PA", "CO"]
}, {
  pk: 1742,
  ang: "Yupik, Pacific Gulf",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Pacific Gulf Yupik",
  lc: "ems",
  ld: "ltr",
  alt: ["Alutiiq", "Koniag-Chugach", "Pacific Yupik", "Sugcestun", "Suk", "Chugach Eskimo", "South Alaska Eskimo", "Sugpiak Eskimo", "Sugpiaq Eskimo"],
  cc: ["US"]
}, {
  pk: 1743,
  ang: "Muria, Eastern",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Eastern Muria",
  lc: "emu",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 1744,
  ang: "Emplawas",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Emplawas",
  lc: "emw",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 1745,
  ang: "Erromintxela",
  lr: "Europe",
  gw: false,
  hc: "FR",
  ln: "Erromintxela",
  lc: "emx",
  ld: "ltr",
  alt: ["Basque Cal\xF3", "Cal\xF3 Vasco"],
  cc: ["FR"]
}, {
  pk: 1746,
  ang: "",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Epigraphic Mayan",
  lc: "emy",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 1747,
  ang: "English",
  lr: "Europe",
  gw: true,
  hc: "GB",
  ln: "English",
  lc: "en",
  ld: "ltr",
  alt: ["Anglit", "Kiingereza", "Gustavia English", "Saman\xE1 English", "Saint Lucian English", "Noongar", "Noonga", "Newcastle Northumber", "Neo-Nyungar (Noogar)", "Glaswegian", "Brummy", "Birmingham (Brummie)", "Bay Islands English", "Australian Standard English", "Aboriginal English", "African American Vernacular English (AAVE)"],
  cc: ["BD", "BN", "BE", "CL", "BB", "BZ", "CK", "AR", "FJ", "TT", "FR", "GF", "DE", "VE", "GY", "HT", "GL", "GH", "GD", "GG", "KE", "JE", "MT", "LK", "PE", "ES", "GB", "CZ", "CR", "JM", "MY", "MZ", "MH", "NP", "NL", "NZ", "PK", "HN", "RO", "SC", "SD", "SX", "ZA", "SB", "TZ", "CO", "TH", "US", "ZM", "ZW", "AU", "BM", "IM", "CA", "KY", "AO", "EC", "MC", "IT", "CC", "LS", "WS", "LU", "MW", "GI", "FM", "NF", "PG", "LC", "SZ", "UG", "VG", "IN", "SG", "MM", "AG", "AW", "DO", "IE", "BW", "IS", "NA"]
}, {
  pk: 1748,
  ang: "Apali",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Apali",
  lc: "ena",
  ld: "ltr",
  alt: ["Emerum"],
  cc: ["PG"]
}, {
  pk: 1749,
  ang: "Markweeta",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Markweeta",
  lc: "enb",
  ld: "ltr",
  alt: ["Endo-Marakwet", "Marakuet", "Sambirir (Southern Markweeta)", "Endo (Northern Markweeta)"],
  cc: ["KE"]
}, {
  pk: 1750,
  ang: "En",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "En",
  lc: "enc",
  ld: "ltr",
  alt: ["Nung Ven"],
  cc: ["VN"]
}, {
  pk: 1751,
  ang: "Ende",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ende",
  lc: "end",
  ld: "ltr",
  alt: ["Endeh", "Nga'o (Ngao)", "Ja'o", "Ende (Djau)", "West Ende"],
  cc: ["ID"]
}, {
  pk: 1752,
  ang: "Enets, Forest",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u042D\u043D\u0435\u0446\u043A\u0438\u0439",
  lc: "enf",
  ld: "ltr",
  alt: ["Bay Enets", "Pe-Bae", "Yenisei Samoyedic"],
  cc: ["RU"]
}, {
  pk: 1753,
  ang: "Enets, Tundra",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u042D\u043D\u0435\u0446\u043A\u0438\u0439",
  lc: "enh",
  ld: "ltr",
  alt: ["Madu", "Somatu", "Yenisei Samoyedic"],
  cc: ["RU"]
}, {
  pk: 1754,
  ang: "Enlhet",
  lr: "Americas",
  gw: false,
  hc: "PY",
  ln: "Enlhet",
  lc: "enl",
  ld: "ltr",
  alt: [],
  cc: ["PY"]
}, {
  pk: 1755,
  ang: "Middle English",
  lr: "Europe",
  gw: false,
  hc: "GB",
  ln: "Middle English (1100-1500)",
  lc: "enm",
  ld: "ltr",
  alt: [],
  cc: ["GB"]
}, {
  pk: 1756,
  ang: "Engenni",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Engenni",
  lc: "enn",
  ld: "ltr",
  alt: ["Egene", "Ngene", "Zarama"],
  cc: ["NG"]
}, {
  pk: 1757,
  ang: "Enggano",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Enggano",
  lc: "eno",
  ld: "ltr",
  alt: ["Engganese"],
  cc: ["ID"]
}, {
  pk: 1758,
  ang: "Enga",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Enga",
  lc: "enq",
  ld: "ltr",
  alt: ["Caga", "Tchaga", "Tsaga", "Wapi", "Wabag", "Mae (Mai)", "Maramuni (Malamuni)", "Sau (Sau Enga)"],
  cc: ["PG"]
}, {
  pk: 1759,
  ang: "Emem",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Emumu",
  lc: "enr",
  ld: "ltr",
  alt: ["Imimkal", "Kiamerop"],
  cc: ["ID"]
}, {
  pk: 1760,
  ang: "Enu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u897F\u6469\u6D1B",
  lc: "enu",
  ld: "ltr",
  alt: ["Ximoluo"],
  cc: ["CN"]
}, {
  pk: 1761,
  ang: "Enwan",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Enwan (Edu State)",
  lc: "env",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 1762,
  ang: "Enwan",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Enwan (Akwa Ibom State)",
  lc: "enw",
  ld: "ltr",
  alt: ["Oron"],
  cc: ["NG"]
}, {
  pk: 1763,
  ang: "Enxet",
  lr: "Americas",
  gw: false,
  hc: "PY",
  ln: "Enxet",
  lc: "enx",
  ld: "ltr",
  alt: [],
  cc: ["AR", "PY"]
}, {
  pk: 7508,
  ang: "",
  lr: "",
  gw: false,
  hc: "",
  ln: "English demo1",
  lc: "en-x-demo1",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7509,
  ang: "",
  lr: "",
  gw: false,
  hc: "",
  ln: "English demo2",
  lc: "en-x-demo2",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1764,
  ang: "Esperanto",
  lr: "Europe",
  gw: false,
  hc: "PL",
  ln: "Esperanto",
  lc: "eo",
  ld: "ltr",
  alt: ["Eo", "La Lingvo Internacia"],
  cc: ["PL"]
}, {
  pk: 1765,
  ang: "Beti",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Beti (C\xF4te d'Ivoire)",
  lc: "eot",
  ld: "ltr",
  alt: [],
  cc: ["CI"]
}, {
  pk: 1766,
  ang: "Epie",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Epie",
  lc: "epi",
  ld: "ltr",
  alt: ["Epie-Atissa", "Atisa (Atissa)"],
  cc: ["NG"]
}, {
  pk: 1767,
  ang: "Eravallan",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Eravallan",
  lc: "era",
  ld: "ltr",
  alt: ["Ambuvilluvedar", "Villu Vedan", "Vilvedan"],
  cc: ["IN"]
}, {
  pk: 1768,
  ang: "Sie",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Sie",
  lc: "erg",
  ld: "ltr",
  alt: ["Eromanga", "Erramanga", "Erromanga", "Sye", "Sie (Sorung)", "Yoku (Enyau)"],
  cc: ["VU"]
}, {
  pk: 1769,
  ang: "Eruwa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Eruwa",
  lc: "erh",
  ld: "ltr",
  alt: ["Arokwa", "Erakwa"],
  cc: ["NG"]
}, {
  pk: 1770,
  ang: "Ogea",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ogea",
  lc: "eri",
  ld: "ltr",
  alt: ["Erima", "Nuru"],
  cc: ["PG"]
}, {
  pk: 1771,
  ang: "Efate, South",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "South Efate",
  lc: "erk",
  ld: "ltr",
  alt: ["Fate", "Southern Efate"],
  cc: ["VU"]
}, {
  pk: 1772,
  ang: "Horpa",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5C14\u9F9A\u8BED",
  lc: "ero",
  ld: "ltr",
  alt: ["Bawang", "Bopa", "Danba", "Daofuhua", "Dawu", "Ergong", "Geshitsa", "Geshizahua", "Hor", "H\xF3rs\xF3k", "Huo'er", "Nyagrong-Minyag", "Pawang", "Rgu", "rTau", "sTau", "Western Gyarong", "Western Jiarong", "Xinlong-Muya", "Geshitsa (Geshiza)", "Nyagrong-Minyag (Xinlong-Muya)", "sTau (Daofu)"],
  cc: ["CN"]
}, {
  pk: 1773,
  ang: "Ersu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5C14\u82CF",
  lc: "ers",
  ld: "ltr",
  alt: ["Bu'erci", "Bu'erzi", "Bu'erzi Ersu", "Doxu", "Erhsu", "Lizu", "Lusu", "T'osu", "L\xFCz\xFC", "Western Ersu", "Ersu (Eastern Ersu)", "Duoxu (Central Ersu)", "Lisu (Liru)"],
  cc: ["CN"]
}, {
  pk: 1774,
  ang: "Eritai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Eritai",
  lc: "ert",
  ld: "ltr",
  alt: ["Aliki", "Babiruwa", "Babrua", "Babruwa", "Baburiwa", "Barua", "Editode Edai", "Erai", "Eri", "Haya"],
  cc: ["ID"]
}, {
  pk: 1775,
  ang: "Erokwanas",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Erokwanas",
  lc: "erw",
  ld: "ltr",
  alt: ["Darembang"],
  cc: ["ID"]
}, {
  pk: 1776,
  ang: "Spanish",
  lr: "Europe",
  gw: true,
  hc: "ES",
  ln: "espa\xF1ol",
  lc: "es",
  ld: "ltr",
  alt: ["Castilian", "Espa\xF1ol", "Castillan", "Islenyo", "Afro-Yungue\xF1o (Black Spanish)", "Silbo Gomero", "Rioplatense", "Portu\xF1ol", "Portunhol", "Lunfardo", "Llanito (Yanito)", "Isleno (Isle\xF1o)", "Chicano (Cal\xF3)", "Canary Islands Spanish (Isle\xF1o)", "Andaluz", "Andalusian (Andal\xFA)", "American Spanish (Chicano)", "Andalus\xED"],
  cc: ["AT", "BE", "CL", "BR", "BZ", "CU", "AR", "TT", "FR", "GF", "DE", "VE", "HT", "UY", "PA", "PE", "ES", "GB", "CR", "GT", "JM", "MZ", "MX", "NL", "NC", "PY", "HN", "PR", "AD", "SE", "CH", "CO", "US", "AU", "BO", "CA", "AO", "EC", "IT", "LU", "DK", "SV", "NI", "PT", "GP", "AW", "DO", "IE"]
}, {
  pk: 2,
  ang: "Latin American Spanish",
  lr: "Americas",
  gw: true,
  hc: "MX",
  ln: "Espa\xF1ol Latin America",
  lc: "es-419",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 1777,
  ang: "Ese Ejja",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Ese Ejja",
  lc: "ese",
  ld: "ltr",
  alt: ["Ese Eja", "Ese Exa", "Huarayo", "Tiatinagua", "Chama", "Ese'ejja", "Tambopata-Guarayo"],
  cc: ["PE", "BO"]
}, {
  pk: 1778,
  ang: "Eshtehardi",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Eshtehardi",
  lc: "esh",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 1779,
  ang: "Inupiatun, North Alaskan",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "North Alaskan Inupiatun",
  lc: "esi",
  ld: "ltr",
  alt: ["Inupiaq", "Inupiat", "North Alaskan Inupiat", "Eskimo", "Inupiak", "North Alaskan Inuktitut", "West Arctic Inupiatun (Mackenzie Delta Inupiatun)", "Western I\xF1upiaq", "North Slope Inupiatun (Point Barrow Inupiatun)", "North Slope Inupiatun", "Mackenzie Inupiatun"],
  cc: ["US", "CA"]
}, {
  pk: 1780,
  ang: "Inupiatun, Northwest Alaska",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Northwest Alaska Inupiatun",
  lc: "esk",
  ld: "ltr",
  alt: ["Inupiatun", "Northwest Alaska Inupiat", "Eskimo", "Kotzebue Sound Inupiatun", "Northern Malimiut Inupiatun", "Seward Peninsula Inupiatun", "Southern Malimiut Inupiatun", "King Island Inupiatun (Bering Strait Inupiatun)"],
  cc: ["US"]
}, {
  pk: 1781,
  ang: "Egyptian Sign Language",
  lr: "Africa",
  gw: false,
  hc: "EG",
  ln: "\u0644\u063A\u0629 \u0627\u0644\u0625\u0634\u0627\u0631\u0629 \u0627\u0644\u0645\u0635\u0631\u064A\u0629",
  lc: "esl",
  ld: "ltr",
  alt: [],
  cc: ["EG"]
}, {
  pk: 1782,
  ang: "Esuma",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Esuma",
  lc: "esm",
  ld: "ltr",
  alt: [],
  cc: ["CI"]
}, {
  pk: 1783,
  ang: "Salvadoran Sign Language",
  lr: "Americas",
  gw: false,
  hc: "SV",
  ln: "Salvadoran Sign Language",
  lc: "esn",
  ld: "ltr",
  alt: ["El Salvadoran Sign Language", "Lengua de Se\xF1as Salvadore\xF1as", "LESSA"],
  cc: ["SV"]
}, {
  pk: 1784,
  ang: "Estonian Sign Language",
  lr: "Europe",
  gw: false,
  hc: "EE",
  ln: "Estonian Sign Language",
  lc: "eso",
  ld: "ltr",
  alt: ["Viipekeel"],
  cc: ["EE"]
}, {
  pk: 1785,
  ang: "Esselen",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Esselen",
  lc: "esq",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 1786,
  ang: "Yupik, Central Siberian",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Central Siberian Yupik",
  lc: "ess",
  ld: "ltr",
  alt: ["Asiatic Yupik", "Bering Strait", "Siberian Yupik", "Yoit", "Yuit", "Yuk", "Yupik", "Eskimo", "Bering Strait Yupik", "Saint Lawrence Island Eskimo", "Noohalit (Peekit)", "St. Lawrence Island Eskimo"],
  cc: ["US"]
}, {
  pk: 1787,
  ang: "Yupik, Central",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Central Yupik",
  lc: "esu",
  ld: "ltr",
  alt: ["Central Alaskan Yupik", "Kuskokwim Yupik (Bethel Yupik)", "Cup'ik"],
  cc: ["US"]
}, {
  pk: 1788,
  ang: "",
  lr: "",
  gw: false,
  hc: "",
  ln: "Eskayan",
  lc: "esy",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1789,
  ang: "Estonian",
  lr: "Europe",
  gw: false,
  hc: "EE",
  ln: "eesti, eesti keel",
  lc: "et",
  ld: "ltr",
  alt: [],
  cc: ["EE"]
}, {
  pk: 1790,
  ang: "Etebi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Etebi",
  lc: "etb",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 1791,
  ang: "Etchemin",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Etchemin",
  lc: "etc",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 1792,
  ang: "Ethiopian Sign Language",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Ethiopian Sign Language",
  lc: "eth",
  ld: "ltr",
  alt: [],
  cc: ["ET"]
}, {
  pk: 1793,
  ang: "Eton",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Eton (Vanuatu)",
  lc: "etn",
  ld: "ltr",
  alt: ["Eastern Efate", "Epwau"],
  cc: ["VU"]
}, {
  pk: 1794,
  ang: "Eton",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Eton (Cameroon)",
  lc: "eto",
  ld: "ltr",
  alt: ["Iton"],
  cc: ["CM"]
}, {
  pk: 1795,
  ang: "Edolo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Edolo",
  lc: "etr",
  ld: "ltr",
  alt: ["Edolo Ado", "Etolo"],
  cc: ["PG"]
}, {
  pk: 1796,
  ang: "Yekhee",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Yekhee",
  lc: "ets",
  ld: "ltr",
  alt: ["Afenmai", "Etsako", "Etsakor", "Iyekhee", "Kukuruku", "Avianwu (Fugar)", "South Ibie (South Ivbie)", "Uwepa-Uwano (Weppa Wano)"],
  cc: ["NG"]
}, {
  pk: 1797,
  ang: "Etruscan",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Etruscan",
  lc: "ett",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 1798,
  ang: "Ejagham",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ejagham",
  lc: "etu",
  ld: "ltr",
  alt: ["Edjagam", "Ejagam", "Ejaham", "Ejwe", "Ekoi", "Kwa", "Obang", "Southern Ejagham (Abakpa)", "Ekin", "Aqua"],
  cc: ["CM", "NG"]
}, {
  pk: 1799,
  ang: "Iten",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Eten",
  lc: "etx",
  ld: "ltr",
  alt: ["Aten", "Etien", "Jal", "Niten", "Ten"],
  cc: ["NG"]
}, {
  pk: 1800,
  ang: "Semimi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Semimi",
  lc: "etz",
  ld: "ltr",
  alt: ["Etna Bay", "Muri", "Wesrau"],
  cc: ["ID"]
}, {
  pk: 1801,
  ang: "Basque",
  lr: "Europe",
  gw: false,
  hc: "ES",
  ln: "euskara, euskera",
  lc: "eu",
  ld: "ltr",
  alt: ["Euskara", "Euskera", "Vascuense", "Roncalese", "Navarro-Labourdin (Bajo Navarro Occidental)", "Xiberoera", "Western Low Navarrese", "Upper Navarran", "Suletino", "Souletin (Souletino)", "Zuberoera", "Labourdin", "Alto Navarro Septentrional (High Navarrese)", "Guipuzcoano", "Gipuzkera (Gipuzkoan)", "Eastern Low Navarrese", "Biscayan (Vizcaino)", "Benaffarera", "Bajo Navarro Oriental", "Lapurdiera", "Suberoan"],
  cc: ["CL", "FR", "VE", "ES", "US"]
}, {
  pk: 1802,
  ang: "Even",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u042D\u0432\u0435\u043D\u0441\u043A\u0438\u0439",
  lc: "eve",
  ld: "ltr",
  alt: ["Eben", "Ewen", "Ilqan", "Lamut", "Orich"],
  cc: ["RU"]
}, {
  pk: 1803,
  ang: "Uvbie",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Uvbie",
  lc: "evh",
  ld: "ltr",
  alt: ["Effurun", "Evrie", "Uvhria", "Uvwie", "Evhro"],
  cc: ["NG"]
}, {
  pk: 1804,
  ang: "Evenki",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u9102\u6E29\u514B\u8BED",
  lc: "evn",
  ld: "ltr",
  alt: ["Ewenk", "Ewenke", "Ewenki", "Khamnigan", "Owenke", "Solon", "Solong", "Sulong", "Suolun", "Tungus", "Avanki", "Avankil", "Chapogir", "Aoluguya (Olguya)", "Manegir", "Huihe (Hoy)", "Baykit", "Morigele (Mergel)", "Chenba'erhu (Old Bargu)"],
  cc: ["CN"]
}, {
  pk: 1805,
  ang: "Ewondo",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Ewondo",
  lc: "ewo",
  ld: "ltr",
  alt: ["Ewundu", "Jaunde", "Yaounde", "Yaunde", "Badjia (Bakjo)", "Bafeuk", "Bamvele (Mvele)", "Yabekolo (Yebekolo)", "Yesoum", "Yezum"],
  cc: ["CM"]
}, {
  pk: 1806,
  ang: "Extremaduran",
  lr: "Europe",
  gw: false,
  hc: "ES",
  ln: "Extremaduran",
  lc: "ext",
  ld: "ltr",
  alt: ["Barranquian", "Caht\xFAo", "Caht\xFA\xF6", "Ehtreme\xF1u", "Extreme\xF1o", "Barranquenho", "Central Extremaduran (Meyu Ehtreme\xF1u)", "Northern Extremaduran (Artu Ehtreme\xF1u)", "Southern Extremaduran (Bahu Ehtreme\xF1u)"],
  cc: ["ES"]
}, {
  pk: 1807,
  ang: "Eyak",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Eyak",
  lc: "eya",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 1808,
  ang: "Keiyo",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Keiyo",
  lc: "eyo",
  ld: "ltr",
  alt: ["Elgeyo", "Keyo"],
  cc: ["KE"]
}, {
  pk: 1809,
  ang: "Ezaa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ezaa",
  lc: "eza",
  ld: "ltr",
  alt: ["Eza", "Ezza"],
  cc: ["NG"]
}, {
  pk: 1810,
  ang: "Uzekwe",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Uzekwe",
  lc: "eze",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 1811,
  ang: "Persian (Farsi)",
  lr: "Asia",
  gw: true,
  hc: "IR",
  ln: "\u0641\u0627\u0631\u0633\u06CC",
  lc: "fa",
  ld: "rtl",
  alt: [],
  cc: ["IR"]
}, {
  pk: 1812,
  ang: "Fasu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Fasu",
  lc: "faa",
  ld: "ltr",
  alt: ["Kaibu (Kaipu)", "Namome (Namumi)", "Namuni"],
  cc: ["PG"]
}, {
  pk: 1813,
  ang: "Fa d\u2019Ambu",
  lr: "Africa",
  gw: false,
  hc: "GQ",
  ln: "Fa d'Ambu",
  lc: "fab",
  ld: "ltr",
  alt: ["Annobonense", "Annobon\xE9s", "Annobonese"],
  cc: ["GQ"]
}, {
  pk: 1814,
  ang: "Wagi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wagi",
  lc: "fad",
  ld: "ltr",
  alt: ["Foran", "Furan", "Kamba", "Mis-Kemba"],
  cc: ["PG"]
}, {
  pk: 8359,
  ang: "Kamba",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kamba",
  lc: "fad-x-kamba",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1815,
  ang: "Fagani",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Fagani",
  lc: "faf",
  ld: "ltr",
  alt: ["Faghani"],
  cc: ["SB"]
}, {
  pk: 1816,
  ang: "Finongan",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Finongan",
  lc: "fag",
  ld: "ltr",
  alt: ["Finungwan", "Mamaa"],
  cc: ["PG"]
}, {
  pk: 1817,
  ang: "Fali of Baissa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Baissa Fali",
  lc: "fah",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 1818,
  ang: "Faiwol",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Faiwol",
  lc: "fai",
  ld: "ltr",
  alt: ["Angkiyakmin", "Faiwolmin", "Fegolmin", "Wokeimin"],
  cc: ["PG"]
}, {
  pk: 1819,
  ang: "Faita",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Faita",
  lc: "faj",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 1820,
  ang: "Fang",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Fang (Cameroon)",
  lc: "fak",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 1821,
  ang: "Fali, South",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "South Fali",
  lc: "fal",
  ld: "ltr",
  alt: ["Ndoudja", "Kaang", "Toro", "Ram", "Ngoutchoumi", "Kangou (Fali Kangou)", "Bele (Fali du Bele-Fere)", "Fali-Tinguelin (Mango)", "Fali-Bele", "Kangu"],
  cc: ["CM"]
}, {
  pk: 1822,
  ang: "Fam",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Fam",
  lc: "fam",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 1823,
  ang: "Fang",
  lr: "Africa",
  gw: false,
  hc: "GQ",
  ln: "Fang (Equatorial Guinea)",
  lc: "fan",
  ld: "ltr",
  alt: ["Pahouin", "Pamue", "Fang (Okak)", "Mvae (Mvan)", "Mvay", "Ntoumou (Ntumu)", "Okak (Ntumu)"],
  cc: ["CM", "GQ", "GA", "US", "CG"]
}, {
  pk: 8338,
  ang: "Malabo Fang",
  lr: "Africa",
  gw: false,
  hc: "GQ",
  ln: "Malabo Fang",
  lc: "fan-x-malabo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1824,
  ang: "Palor",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Palor",
  lc: "fap",
  ld: "ltr",
  alt: ["Falor", "Palar", "Serer", "Siili", "Siili-Mantine", "Siili-Siili", "Waro", "Ba'ol", "Kajor"],
  cc: ["SN"]
}, {
  pk: 1825,
  ang: "Fataleka",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Fataleka",
  lc: "far",
  ld: "ltr",
  alt: [],
  cc: ["SB"]
}, {
  pk: 7549,
  ang: "Eastern Farsi",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u062F\u0631\u06CC",
  lc: "fas-x-eastfars",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 1826,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Fanti",
  lc: "fat",
  ld: "ltr",
  alt: [],
  cc: ["GH", "LR"]
}, {
  pk: 1827,
  ang: "Fayu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Fayu",
  lc: "fau",
  ld: "ltr",
  alt: ["Sehudate"],
  cc: ["ID"]
}, {
  pk: 1828,
  ang: "Fala",
  lr: "Europe",
  gw: false,
  hc: "ES",
  ln: "Fala",
  lc: "fax",
  ld: "ltr",
  alt: ["A Fala de X\xE1lima", "A Fala do X\xE3lima", "Galaico-Extremaduran", "Chapurre\xE1u"],
  cc: ["ES"]
}, {
  pk: 1829,
  ang: "Fars, Southwestern",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u06AF\u0648\u06CC\u0634 \u062F\u0648\u0627\u0646\u06CC",
  lc: "fay",
  ld: "ltr",
  alt: ["Tajik"],
  cc: ["IR"]
}, {
  pk: 1830,
  ang: "Fars, Northwestern",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Northwestern Fars",
  lc: "faz",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 1831,
  ang: "Bikol, West Albay",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "West Albay Bikol",
  lc: "fbl",
  ld: "ltr",
  alt: ["Bicol", "Bikol", "Ligaoe\xF1o", "Oasnun", "Oasn\xFCn", "Polanguinon"],
  cc: ["PH"]
}, {
  pk: 1832,
  ang: "Quebec Sign Language",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Quebec Sign Language",
  lc: "fcs",
  ld: "ltr",
  alt: ["Langue des Signes", "Langue des Signes du Qu\xE9bec", "Langue Signe Quebecars", "LSQ", "Qu\xE9b\xE9coise"],
  cc: ["CA"]
}, {
  pk: 1833,
  ang: "Feroge",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Feroge",
  lc: "fer",
  ld: "ltr",
  alt: ["Feroghe", "Ferroge", "Kalige", "Kaligi", "Kalike", "Kaliki"],
  cc: ["SS"]
}, {
  pk: 1834,
  ang: "Fula, Fulah, Pulaar, Pular",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Fulfulde, Pulaar, Pular",
  lc: "ff",
  ld: "ltr",
  alt: [],
  cc: ["SN"]
}, {
  pk: 1835,
  ang: "Foia Foia",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Foia Foia",
  lc: "ffi",
  ld: "ltr",
  alt: ["Foiafoia", "Foyafoya"],
  cc: ["PG"]
}, {
  pk: 1836,
  ang: "Fulfulde, Maasina",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Maasina Fulfulde",
  lc: "ffm",
  ld: "ltr",
  alt: ["Fulbe", "Maacina", "Peul", "Macina"],
  cc: ["BF", "GH", "ML", "MR"]
}, {
  pk: 1837,
  ang: "Fongoro",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Fongoro",
  lc: "fgr",
  ld: "ltr",
  alt: ["Gele", "Kole"],
  cc: ["SD", "TD"]
}, {
  pk: 1838,
  ang: "Finnish",
  lr: "Europe",
  gw: false,
  hc: "FI",
  ln: "suomi, suomen kieli",
  lc: "fi",
  ld: "ltr",
  alt: ["Suomi", "Finska", "H\xE4me (Tavast)", "Finnish Karjala", "Savo (Savolax)", "Southeastern Finnish (Finnish Karelian)"],
  cc: ["GB", "NO", "SE", "US", "AU", "FI", "CA"]
}, {
  pk: 1839,
  ang: "Nobiin",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Nobiin",
  lc: "fia",
  ld: "ltr",
  alt: ["Fadicca", "Fadicha", "Fadija", "Fedicca", "Fedija", "Fiadidja", "Fiadidja-Mahas", "Fiyadikkya", "Mahas-Fiadidja", "Nile Nubian", "Sukot", "Mahas-Fiyadikkya", "Mahass", "Mahas (Mahasi)"],
  cc: ["SD", "EG"]
}, {
  pk: 1840,
  ang: "Fyer",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Fyer",
  lc: "fie",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 1841,
  ang: "Filipino",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Filipino",
  lc: "fil",
  ld: "ltr",
  alt: [],
  cc: ["PH"]
}, {
  pk: 1842,
  ang: "Fipa",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Fipa",
  lc: "fip",
  ld: "ltr",
  alt: ["Cifipa", "Fiba", "Icifipa", "Kifipa", "Milanzi (Sukuma)", "Northern Fipa (Kandaasi)", "Sukuuma"],
  cc: ["TZ"]
}, {
  pk: 1843,
  ang: "Firan",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Firan",
  lc: "fir",
  ld: "ltr",
  alt: ["Faran", "Foron", "Yes Firan"],
  cc: ["NG"]
}, {
  pk: 1844,
  ang: "Finnish, Tornedalen",
  lr: "Europe",
  gw: false,
  hc: "SE",
  ln: "Tornedalen Finnish",
  lc: "fit",
  ld: "ltr",
  alt: ["Me\xE4nkieli", "North Finnish", "Tornedalsfinska", "G\xE4llivare Finnish"],
  cc: ["SE"]
}, {
  pk: 1845,
  ang: "Fiwaga",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Fiwaga",
  lc: "fiw",
  ld: "ltr",
  alt: ["Fimaga", "Fiwage"],
  cc: ["PG"]
}, {
  pk: 1846,
  ang: "Fijian",
  lr: "Pacific",
  gw: false,
  hc: "FJ",
  ln: "vosa Vakaviti",
  lc: "fj",
  ld: "ltr",
  alt: ["Eastern Fijian", "Fiji", "Standard Fijian", "Northeast Vanua Levu (Dogotuki Saqani)", "Tavuki", "Tokaimalo", "Southeast Vanua Levu (Baumaa)", "Seaqaaqaa", "Savusavu", "Ono", "Northeast Viti Levu (Lovoni)", "Namena", "Nabalebale", "Mbau", "Labasa", "Korolau", "Kadavu (Nabukelevu)", "Bau (Bauan)", "Central Vanua Levu (Baaravi)", "Nav"],
  cc: ["FJ", "NZ", "SB", "US", "CA", "VU"]
}, {
  pk: 1847,
  ang: "Kirya-Konzel",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kirya-Konz\u0259l",
  lc: "fkk",
  ld: "ltr",
  alt: ["Fali of Kiria", "Fali of Kiriya", "Fali of Kirya", "Fali of Mijilu", "Kirya"],
  cc: ["NG"]
}, {
  pk: 1848,
  ang: "Finnish, Kven",
  lr: "Europe",
  gw: false,
  hc: "NO",
  ln: "Kven Finnish",
  lc: "fkv",
  ld: "ltr",
  alt: ["Kven", "North Finnish"],
  cc: ["NO"]
}, {
  pk: 1849,
  ang: "Kalispel-Pend d\u2019Oreille",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Kalispel-Pend d'Oreille",
  lc: "fla",
  ld: "ltr",
  alt: ["Salish", "Flathead-Kalispel", "Kalispel-Flathead", "Pend D'oreille"],
  cc: ["US"]
}, {
  pk: 1850,
  ang: "Foau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Foau",
  lc: "flh",
  ld: "ltr",
  alt: ["Abawiri", "Doa"],
  cc: ["ID"]
}, {
  pk: 1851,
  ang: "Fali",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Fali",
  lc: "fli",
  ld: "ltr",
  alt: ["Fali of Mubi", "Fali of Muchella", "Vimtim", "Yimtim", "Urambween", "Bwin (Bagira)", "Vin (Uroovin)", "Uvin", "Urahuli", "Ura Madzarin", "Muchella", "Huli (Bahuli)", "Madzarin (Madzara)"],
  cc: ["NG"]
}, {
  pk: 1852,
  ang: "Fali, North",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "North Fali",
  lc: "fll",
  ld: "ltr",
  alt: ["Bossoum (Bonum)", "Bveri (Bori)", "Dourbeye (Fali-Dourbeye)", "Fali du Peske-Bori", "Fali-Bossoum", "Peske"],
  cc: ["CM"]
}, {
  pk: 1853,
  ang: "Fuliiru",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Fuliiru",
  lc: "flr",
  ld: "ltr",
  alt: ["Fulero", "Fuliru", "Kifuliiru"],
  cc: ["CD"]
}, {
  pk: 1854,
  ang: "Flaaitaal",
  lr: "Africa",
  gw: false,
  hc: "ZA",
  ln: "Flaaitaal",
  lc: "fly",
  ld: "ltr",
  alt: ["Flaai Taal", "Fly Taal"],
  cc: ["ZA"]
}, {
  pk: 1855,
  ang: "Fe\u2019fe\u2019",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Fe'fe'",
  lc: "fmp",
  ld: "ltr",
  alt: ["Bafang", "Bamileke-Fe'fe'", "Feefee", "Fe'efe'e", "Fotouni", "Nufi", "Ngam (Bangan)", "Nka' (Banka)", "Ntii (Fondanti)", "Njee-Poantu (Bandja-Babountou)", "Mkwet (Fondjomekwet)", "Nee (Bana)", "La'fi (Balafi)", "Fa' (Bafang)", "Tungi' (Fotouni)"],
  cc: ["CM"]
}, {
  pk: 1856,
  ang: "Muria, Far Western",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Far Western Muria",
  lc: "fmu",
  ld: "ltr",
  alt: ["Gondi", "Koitor Boli", "Koitori"],
  cc: ["IN"]
}, {
  pk: 1857,
  ang: "Pidgin Bantu",
  lr: "Africa",
  gw: false,
  hc: "ZA",
  ln: "Fanagalo",
  lc: "fng",
  ld: "ltr",
  alt: ["Basic Zulu", "Fanagoloi", "Isilololo", "Isipiki", "Lololo", "Piki", "Silunguboi", "Fanagalo", "Fanakalo", "Fanekolo", "Isikula"],
  cc: ["ZA", "ZM"]
}, {
  pk: 1858,
  ang: "Fania",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Fania",
  lc: "fni",
  ld: "ltr",
  alt: ["Fagnia", "Fana", "Fanian", "Fanya", "Fanyan", "Kobe", "Mana"],
  cc: ["SD", "TD"]
}, {
  pk: 1859,
  ang: "Faroese",
  lr: "Europe",
  gw: false,
  hc: "DK",
  ln: "f\xF8royskt",
  lc: "fo",
  ld: "ltr",
  alt: ["F\xF8royskt"],
  cc: ["FO", "DK"]
}, {
  pk: 1860,
  ang: "Foodo",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Foodo",
  lc: "fod",
  ld: "ltr",
  alt: [],
  cc: ["BJ"]
}, {
  pk: 1861,
  ang: "Foi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Foi",
  lc: "foi",
  ld: "ltr",
  alt: ["Mubi River"],
  cc: ["PG"]
}, {
  pk: 1862,
  ang: "Foma",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Foma",
  lc: "fom",
  ld: "ltr",
  alt: ["Fuma", "Lifoma"],
  cc: ["CD"]
}, {
  pk: 1863,
  ang: "Fon",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Fon",
  lc: "fon",
  ld: "ltr",
  alt: ["Dahomeen", "Fongbe", "Djedji", "Fogbe", "Fon-Gbe", "Fonnu", "Agbome", "Arohun", "Gbekon", "Kpase"],
  cc: ["BJ", "GA", "GH", "TG"]
}, {
  pk: 1864,
  ang: "Fore",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Fore",
  lc: "for",
  ld: "ltr",
  alt: ["Pamusa (South Fore)"],
  cc: ["PG"]
}, {
  pk: 8469,
  ang: "Abomatasa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Abomatasa",
  lc: "for-x-abomatasa",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8471,
  ang: "Fore Ati",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Fore Ati",
  lc: "for-x-foreati",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8482,
  ang: "Pamusa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Pamusa",
  lc: "for-x-forepamusa",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8468,
  ang: "Fore Keya",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Fore Keya",
  lc: "for-x-keya",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8470,
  ang: "Fore Pamusa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Fore Pamusa",
  lc: "for-x-pamusa",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1865,
  ang: "Siraya",
  lr: "Asia",
  gw: false,
  hc: "TW",
  ln: "Siraya",
  lc: "fos",
  ld: "ltr",
  alt: ["Lamai", "Takaraya", "Taivoan (Tevorang)", "Makatao (Makattao)", "Tta'o", "Pangsoia-Dolatok", "Baksa", "Formosan", "Pepohoan", "Pepo-Hwan", "Sideia", "Sideis", "Sideisch", "Siraia", "Siraiya"],
  cc: ["TW"]
}, {
  pk: 1866,
  ang: "Equatorial Guinean Pidgin",
  lr: "Africa",
  gw: false,
  hc: "GQ",
  ln: "Fernando Po Creole English",
  lc: "fpe",
  ld: "ltr",
  alt: ["Criollo", "Fernandino", "Fernando Po Krio", "Pichi", "Pichinglis", "Pidgin de Guinea Ecuatorial", "Pidginglis"],
  cc: ["GQ"]
}, {
  pk: 1867,
  ang: "Fas",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Fas",
  lc: "fqs",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 1868,
  ang: "French",
  lr: "Europe",
  gw: true,
  hc: "FR",
  ln: "fran\xE7ais, langue fran\xE7aise",
  lc: "fr",
  ld: "ltr",
  alt: ["Fran\xE7ais", "Franc\xE9s", "Qu\xE9b\xE9cois", "Sous le Vent (Saint Barth\xE9lemy Patois)", "Shippagan", "Serquiais", "Saintongeais", "Norman (Normand)", "Jurassien", "J\xE8rriais", "Franco-Terreneuvien", "Acadian (Acadien)", "Franche-Comtois (Fribourgois)"],
  cc: ["DZ", "AT", "BE", "KM", "DJ", "FR", "GF", "IL", "MG", "MU", "ES", "GB", "NL", "NC", "AD", "SC", "CH", "US", "AU", "TD", "PF", "CA", "MC", "IT", "LU", "PT", "GP", "VU", "BI", "YT", "MQ"]
}, {
  pk: 1869,
  ang: "French, Cajun",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Cajun French",
  lc: "frc",
  ld: "ltr",
  alt: ["Acadian", "Cadien", "Cajan"],
  cc: ["US"]
}, {
  pk: 1870,
  ang: "Fordata",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Fordata",
  lc: "frd",
  ld: "ltr",
  alt: ["Larat", "Vai Fordata", "Vai Sera-Larat-Fordata", "Vai Tnebar", "Vaidida", "Fordata-Larat I", "Molo (Molo-Maru)", "Sera (Seira)"],
  cc: ["ID"]
}, {
  pk: 1871,
  ang: "Frankish",
  lr: "Europe",
  gw: false,
  hc: "DE",
  ln: "Frankish",
  lc: "frk",
  ld: "ltr",
  alt: [],
  cc: ["DE"]
}, {
  pk: 1872,
  ang: "Middle French",
  lr: "Europe",
  gw: false,
  hc: "FR",
  ln: "Middle French (ca. 1400-1600)",
  lc: "frm",
  ld: "ltr",
  alt: [],
  cc: ["FR"]
}, {
  pk: 1873,
  ang: "Old French",
  lr: "Europe",
  gw: false,
  hc: "FR",
  ln: "Old French (842-ca. 1400)",
  lc: "fro",
  ld: "ltr",
  alt: [],
  cc: ["FR"]
}, {
  pk: 1874,
  ang: "Arpitan",
  lr: "Europe",
  gw: false,
  hc: "FR",
  ln: "Arpitan",
  lc: "frp",
  ld: "ltr",
  alt: ["Patois", "Francoproven\xE7al", "Neuchatelais", "Valdotain", "Valle D'aosta (Pato\xE9 Valdoten)", "Faeto (Faetar)", "Valdostano", "Neuch\xE2telois"],
  cc: ["FR"]
}, {
  pk: 1875,
  ang: "Forak",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Forak",
  lc: "frq",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 1876,
  ang: "Frisian, Northern",
  lr: "Europe",
  gw: false,
  hc: "DE",
  ln: "Northern Frisian",
  lc: "frr",
  ld: "ltr",
  alt: ["Nordfriesisch", "Ferring (Fohr-Amrum)", "Mooringa", "Mooringer (Mainland Frisian)", "S\xF6lreng (Sylt)"],
  cc: ["DE"]
}, {
  pk: 1877,
  ang: "Saxon, East Frisian Low",
  lr: "Europe",
  gw: false,
  hc: "DE",
  ln: "Eastern Frisian",
  lc: "frs",
  ld: "ltr",
  alt: ["Ostfriesisch"],
  cc: ["DE"]
}, {
  pk: 1878,
  ang: "Fortsenal",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Fortsenal",
  lc: "frt",
  ld: "ltr",
  alt: ["Kiai"],
  cc: ["VU"]
}, {
  pk: 1879,
  ang: "Finnish Sign Language",
  lr: "Europe",
  gw: false,
  hc: "FI",
  ln: "Finnish Sign Language",
  lc: "fse",
  ld: "ltr",
  alt: ["Viittomakieli"],
  cc: ["FI"]
}, {
  pk: 1880,
  ang: "French Sign Language",
  lr: "Europe",
  gw: false,
  hc: "FR",
  ln: "French Sign Language",
  lc: "fsl",
  ld: "ltr",
  alt: ["FSL", "Langue des Signes Fran\xE7aise", "LSF", "Marseille Sign Language (Southern French Sign Language)"],
  cc: ["FR", "NE", "TG"]
}, {
  pk: 1881,
  ang: "Finland-Swedish Sign Language",
  lr: "Europe",
  gw: false,
  hc: "FI",
  ln: "Finland-Swedish Sign Language",
  lc: "fss",
  ld: "ltr",
  alt: ["Finlandssvenskt Teckenspr\xE5k", "FinSSL", "Suomenruotsalainen Viittomakieli"],
  cc: ["FI"]
}, {
  pk: 1882,
  ang: "Fulfulde, Adamawa",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Adamawa Fulfulde",
  lc: "fub",
  ld: "ltr",
  alt: ["Adamawa Fulani", "Boulbe", "Dzemay", "Eastern Fulani", "Foulfoulde", "Ful", "Fula", "Fulata", "Fulbe", "Mbororo", "Palata", "Peul", "Peulh", "Eastern Fulfulde", "Fillanci", "Fulani", "Fulatanchi", "Fellata", "Biira", "Fula Fulbe", "Nagapelta", "Paldena", "Paldida", "Pelta Hay", "Pladina", "Pule", "Pullo", "Sanyo", "Taareyo", "Zaakosa", "Zemay", "Bilkire (Bilkiri)", "Bilkire Fulani (Bilkiri)", "Nomadic Fulfulde - Mbororoore", "Akuure"],
  cc: ["CM", "FR", "GA", "GH", "NG", "SD", "US", "TD"]
}, {
  pk: 1883,
  ang: "Pulaar",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Pulaar",
  lc: "fuc",
  ld: "ltr",
  alt: ["Fulani", "Fulbe Jeeri", "Fulfulde-Pulaar", "Peul", "Peulh", "Pulaar Fulfulde", "Fulfulde Pulaar", "Haalpulaar", "Peuhl", "Halpulaar", "Tukolor", "Tukulor", "Toucouleur (Haalpulaar)", "Toucouleur (Futa Toro)", "Toucouleur (Fulbe Jeeri)", "Tokilor", "Fulkunda", "Fulakunda", "Fulacunda (Fulakunda)", "Fulacunda (Fula Preto)", "Fulacunda (Fula Forro)", "Fula de Gabu", "Fula Preto"],
  cc: ["FR", "GM", "ML", "MR", "SD", "SN", "US", "GN", "GW"]
}, {
  pk: 1884,
  ang: "Futuna, East",
  lr: "Pacific",
  gw: false,
  hc: "WF",
  ln: "East Futuna",
  lc: "fud",
  ld: "ltr",
  alt: ["Futunian", "East Futunan"],
  cc: ["NC", "WF"]
}, {
  pk: 1885,
  ang: "Fulfulde, Borgu",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Borgu Fulfulde",
  lc: "fue",
  ld: "ltr",
  alt: ["Benin-Togo Fulfulde", "Peul", "Peulh", "Fulani", "Tchabankeere (Caabankeere)", "Bakuure", "Djougoure (Juguure)", "Korakuure"],
  cc: ["BJ", "TG"]
}, {
  pk: 1886,
  ang: "Pular",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Pular",
  lc: "fuf",
  ld: "ltr",
  alt: ["Foula Fouta", "Fouta Dyalon", "Fulbe", "Fulfulde Jalon", "Fullo Fuuta", "Futa Fula", "Futa Jallon", "Jalon", "Fula", "Futa"],
  cc: ["ML", "SN", "US", "GN", "GW", "SL"]
}, {
  pk: 1887,
  ang: "Fulfulde, Western Niger",
  lr: "Africa",
  gw: false,
  hc: "NE",
  ln: "Western Niger Fulfulde",
  lc: "fuh",
  ld: "ltr",
  alt: ["Fulfulde", "Peul", "Peulh", "Western Niger Fulfulde", "Fula", "Fulani", "Fulbe", "Gorgal Fulfulde", "Northeastern Burkina Faso Fulfulde", "Barani (Barain)", "Baraniire", "Seeba-Yaga (Yaaga)", "Tera"],
  cc: ["BF", "NE"]
}, {
  pk: 1888,
  ang: "Fulfulde, Bagirmi",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Bagirmi Fulfulde",
  lc: "fui",
  ld: "ltr",
  alt: ["Baghirmi Peul", "Bagirmi Fula"],
  cc: ["CF", "TD"]
}, {
  pk: 1889,
  ang: "Ko",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Ko",
  lc: "fuj",
  ld: "ltr",
  alt: ["Fungor", "Fungur", "Kau (Ko)"],
  cc: ["SD"]
}, {
  pk: 1890,
  ang: "Fum",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Fum",
  lc: "fum",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 1891,
  ang: "Iat\xEA",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Fulni\xF4",
  lc: "fun",
  ld: "ltr",
  alt: ["Carnij\xF3", "Forni\xF3", "Fulni\xF4", "Furni\xF4", "Yat\xEA"],
  cc: ["BR"]
}, {
  pk: 1892,
  ang: "Fulfulde, Central-Eastern Niger",
  lr: "Africa",
  gw: false,
  hc: "NE",
  ln: "Central-Eastern Niger Fulfulde",
  lc: "fuq",
  ld: "ltr",
  alt: ["Fula", "Fulani", "Fulbe", "Peul", "Peulh"],
  cc: ["NE", "NG"]
}, {
  pk: 1893,
  ang: "Friulian",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Friulian",
  lc: "fur",
  ld: "ltr",
  alt: ["Frioulan", "Frioulian", "Friulano", "Furlan", "Priulian"],
  cc: ["IT"]
}, {
  pk: 1894,
  ang: "Futuna-Aniwa",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Futuna-Aniwa",
  lc: "fut",
  ld: "ltr",
  alt: ["Erronan", "West Futuna-Aniwa", "Aniwa (Anewa)", "West Futuna (Fotuna)"],
  cc: ["VU"]
}, {
  pk: 1895,
  ang: "Furu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Furu",
  lc: "fuu",
  ld: "ltr",
  alt: ["Bagero", "Bagiro", "Baguero", "Baguiro"],
  cc: ["CF", "CD"]
}, {
  pk: 1896,
  ang: "Fulfulde, Nigerian",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Nigerian Fulfulde",
  lc: "fuv",
  ld: "ltr",
  alt: ["Fulbe", "Peul", "Kano-Katsina Fulfulde", "Mbororo", "Woylaare", "Nomadic Fulfulde", "Mbororo (Ako)", "Bororo", "Fulfulde Caka Nigeria", "Bororro (Ako)", "Bororo (Aku)", "Jaafun"],
  cc: ["CM", "CF", "NE", "NG", "TD"]
}, {
  pk: 1897,
  ang: "Fuyug",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Fuyug",
  lc: "fuy",
  ld: "ltr",
  alt: ["Fuyughe", "Mafulu"],
  cc: ["PG"]
}, {
  pk: 1898,
  ang: "Fur",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Fur",
  lc: "fvr",
  ld: "ltr",
  alt: ["Dala", "For", "Fora", "Fordunga", "Forok", "Forta", "Furakang", "Furawi", "Kadirgi", "Konjara", "Korra", "Kungara", "Kurka", "Lali", "Onage", "Yerge", "Four", "Kondjara"],
  cc: ["SD", "TD"]
}, {
  pk: 1899,
  ang: "Fw\xE2i",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Fw\xE2i",
  lc: "fwa",
  ld: "ltr",
  alt: ["Poai", "Yehen", "Yengen"],
  cc: ["NC"]
}, {
  pk: 1900,
  ang: "Fwe",
  lr: "Africa",
  gw: false,
  hc: "NA",
  ln: "Fwe",
  lc: "fwe",
  ld: "ltr",
  alt: [],
  cc: ["NA"]
}, {
  pk: 1901,
  ang: "Western Frisian",
  lr: "Europe",
  gw: false,
  hc: "NL",
  ln: "Frysk",
  lc: "fy",
  ld: "ltr",
  alt: ["Fries", "Frysk", "Westerlauwers Fries", "Klaaifrysk", "S\xFAdhoeksk", "W\xE2ldfrysk"],
  cc: ["NL", "CA"]
}, {
  pk: 1902,
  ang: "Irish",
  lr: "Europe",
  gw: false,
  hc: "IE",
  ln: "Gaeilge",
  lc: "ga",
  ld: "ltr",
  alt: ["Erse", "Gaeilge", "Gaelic Irish", "Donegal (Northern Irish)", "Munster-Leinster (Southern Irish)", "Connacht (Western Irish)"],
  cc: ["US", "CA", "IE"]
}, {
  pk: 1903,
  ang: "Ga",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Ga",
  lc: "gaa",
  ld: "ltr",
  alt: ["Accra", "Acra", "Amina", "Gain"],
  cc: ["BJ", "GH", "TG"]
}, {
  pk: 1904,
  ang: "Gabri",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Gabri",
  lc: "gab",
  ld: "ltr",
  alt: ["Gabere", "Gaberi", "Ngabre", "Southern Gabri"],
  cc: ["TD"]
}, {
  pk: 1905,
  ang: "Great Andamanese, Mixed",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mixed Great Andamanese",
  lc: "gac",
  ld: "ltr",
  alt: ["Andamese"],
  cc: ["IN"]
}, {
  pk: 1906,
  ang: "Gaddang",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Gaddang",
  lc: "gad",
  ld: "ltr",
  alt: ["Cagayan"],
  cc: ["PH"]
}, {
  pk: 1907,
  ang: "Guarequena",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "Guarequena",
  lc: "gae",
  ld: "ltr",
  alt: ["Arequena", "Uerequema", "Urequema", "Warek\xE9na", "Werekena", "Guarekena", "Warekena"],
  cc: ["BR", "VE"]
}, {
  pk: 1908,
  ang: "Gende",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gende",
  lc: "gaf",
  ld: "ltr",
  alt: ["Gendeka", "Gene"],
  cc: ["PG"]
}, {
  pk: 1909,
  ang: "Gagauz",
  lr: "Europe",
  gw: false,
  hc: "MD",
  ln: "Gagauz",
  lc: "gag",
  ld: "ltr",
  alt: ["Gagauzi", "Bulgar Gagauzi", "Maritime Gagauzi"],
  cc: ["KZ", "TR", "MD", "BG"]
}, {
  pk: 1910,
  ang: "Alekano",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Alekano",
  lc: "gah",
  ld: "ltr",
  alt: ["Gafuku", "Gahuku-Gama"],
  cc: ["PG"]
}, {
  pk: 8488,
  ang: "Lapigu Fimito",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Lapigu Fimito",
  lc: "gah-x-lapigufimi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 1911,
  ang: "Mbore",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Borei",
  lc: "gai",
  ld: "ltr",
  alt: ["Borei", "Gamai", "Gamei", "Mborei"],
  cc: ["PG"]
}, {
  pk: 1912,
  ang: "Gadsup",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gadsup",
  lc: "gaj",
  ld: "ltr",
  alt: ["Oyana (Oiyana)"],
  cc: ["PG"]
}, {
  pk: 8192,
  ang: "Kasup Aijuree",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kasup Aiyuree",
  lc: "gaj-x-aiyuree",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7504,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gadsup Ayugam",
  lc: "gaj-x-aygm",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7503,
  ang: "Gadsup Kamu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gadsup Kamu",
  lc: "gaj-x-kamu",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 8191,
  ang: "Kasup Bina",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kasup Bina",
  lc: "gaj-x-kasupbina",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8243,
  ang: "Norikori",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Norikori",
  lc: "gaj-x-norikori",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8354,
  ang: "Gadsup Omaura",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gadsup Omaura",
  lc: "gaj-x-omaura",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7502,
  ang: "Gadsup Urona",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gadsup Urona",
  lc: "gaj-x-urona",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 8372,
  ang: "Wandamo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wandamo",
  lc: "gaj-x-wandamo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7505,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gadsup Yomunka",
  lc: "gaj-x-ymnk",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 1913,
  ang: "Gamkonora",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Gamkonora",
  lc: "gak",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 1914,
  ang: "Galolen",
  lr: "Asia",
  gw: false,
  hc: "TL",
  ln: "Galolen",
  lc: "gal",
  ld: "ltr",
  alt: ["Galoleng", "Iliwaki", "Ilmedu", "Ilwaki", "Lir Talo", "Galole", "Galolem", "Galolin", "Manatutu (Vila)", "Laleia", "Lakloo (Lacl\xF3)", "Ilwaki (Iliwaki)", "Hiay", "Wetar (Iliwaki)", "Ilputih"],
  cc: ["ID", "TL"]
}, {
  pk: 1915,
  ang: "Kandawo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kandawo",
  lc: "gam",
  ld: "ltr",
  alt: ["Narake"],
  cc: ["PG"]
}, {
  pk: 1916,
  ang: "Chinese, Gan",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u8D1B\u8A9E",
  lc: "gan",
  ld: "ltr",
  alt: ["Gan", "Jiangxi hua", "Jiangxinese", "Kan", "Leizi", "Yilu (Yi-Liu)", "Nanchang", "Datong", "Hauiyue", "Dongsui"],
  cc: ["CN"]
}, {
  pk: 1917,
  ang: "Gants",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gants",
  lc: "gao",
  ld: "ltr",
  alt: ["Gaj"],
  cc: ["PG"]
}, {
  pk: 1918,
  ang: "Gal",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gal",
  lc: "gap",
  ld: "ltr",
  alt: ["Baimak", "Weim"],
  cc: ["PG"]
}, {
  pk: 1919,
  ang: "Gata\u2019",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Gata'",
  lc: "gaq",
  ld: "ltr",
  alt: ["Didei", "Dire", "Gataq", "Geta'", "Getaq", "Gta'", "Gta Asa"],
  cc: ["IN"]
}, {
  pk: 1920,
  ang: "Galeya",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Galeya",
  lc: "gar",
  ld: "ltr",
  alt: ["Garea", "Gameta", "Garea (Galeya)"],
  cc: ["PG"]
}, {
  pk: 1921,
  ang: "Garasia, Adiwasi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Adiwasi Garasia",
  lc: "gas",
  ld: "ltr",
  alt: ["Adiwasi Girasia", "Adiwasi Gujarati", "Girasia"],
  cc: ["IN"]
}, {
  pk: 1922,
  ang: "Kenati",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kenati",
  lc: "gat",
  ld: "ltr",
  alt: ["Aziana", "Ganati", "Kenathi"],
  cc: ["PG"]
}, {
  pk: 1923,
  ang: "Gadaba, Mudhili",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mudhili Gadaba",
  lc: "gau",
  ld: "ltr",
  alt: ["Gol Gadaba", "Kondekar", "Kondko"],
  cc: ["IN"]
}, {
  pk: 1924,
  ang: "Nobonob",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nobonob",
  lc: "gaw",
  ld: "ltr",
  alt: ["Butelkud-Guntabak", "Garuh", "Nobanob", "Nobnob", "Ari (A'i)", "Ati"],
  cc: ["PG"]
}, {
  pk: 1925,
  ang: "Oromo, Borana-Arsi-Guji",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Borana-Arsi-Guji Oromo",
  lc: "gax",
  ld: "ltr",
  alt: ["Afan Oromo", "Southern Oromo", "Galla", "Galligna", "Gallinya", "Booran", "Boraan", "Oromo", "Borana (Booran)"],
  cc: ["ET", "KE"]
}, {
  pk: 1926,
  ang: "Gayo",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Gayo",
  lc: "gay",
  ld: "ltr",
  alt: ["Gajo", "Deret", "Lues", "Lut"],
  cc: ["ID"]
}, {
  pk: 1927,
  ang: "Oromo, West Central",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "West Central Oromo",
  lc: "gaz",
  ld: "ltr",
  alt: ["Afan Oromo", "Oromiffa", "Oromoo", "Galla"],
  cc: ["ET", "SD", "US", "EG"]
}, {
  pk: 1928,
  ang: "Gbaya",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Gbaya (Central African Republic)",
  lc: "gba",
  ld: "ltr",
  alt: [],
  cc: ["CF"]
}, {
  pk: 1929,
  ang: "Kaytetye",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Kaytetye",
  lc: "gbb",
  ld: "ltr",
  alt: ["Gaididj", "Kaiditj", "Kaititj"],
  cc: ["AU"]
}, {
  pk: 1930,
  ang: "Karadjeri",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Karadjeri",
  lc: "gbd",
  ld: "ltr",
  alt: ["Garadjiri", "Garadyari", "Gard'are", "Guradjara", "Karrajarri"],
  cc: ["AU"]
}, {
  pk: 1931,
  ang: "Niksek",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Niksek",
  lc: "gbe",
  ld: "ltr",
  alt: ["Sumwari", "Gabiano (Kabiano)", "Meiyari (\"Paka\")"],
  cc: ["PG"]
}, {
  pk: 1932,
  ang: "Gaikundi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gaikundi",
  lc: "gbf",
  ld: "ltr",
  alt: ["Gaikunti"],
  cc: ["PG"]
}, {
  pk: 1933,
  ang: "Gbanziri",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Gbanziri",
  lc: "gbg",
  ld: "ltr",
  alt: ["Gbandere", "Gbanzili"],
  cc: ["CF", "CG"]
}, {
  pk: 1934,
  ang: "Gbe, Defi",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Defi Gbe",
  lc: "gbh",
  ld: "ltr",
  alt: [],
  cc: ["BJ"]
}, {
  pk: 1935,
  ang: "Galela",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Galela",
  lc: "gbi",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 1936,
  ang: "Gadaba, Bodo",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bodo Gadaba",
  lc: "gbj",
  ld: "ltr",
  alt: ["Boi Gadaba", "Gadba", "Gadwa", "Godwa", "Gudwa", "Gutob", "Gutop", "Birong Raji", "Lamtaput", "Kinda Raji", "Koraput"],
  cc: ["IN"]
}, {
  pk: 1937,
  ang: "Gaddi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Gaddi",
  lc: "gbk",
  ld: "ltr",
  alt: ["Bharmauri Bhadi", "Gaddyali", "Gadi", "Gadiali", "Pahari Bharmauri", "Panchi Brahmauri Rajput", "Macleod Ganj"],
  cc: ["IN"]
}, {
  pk: 1938,
  ang: "Gamit",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Gamit",
  lc: "gbl",
  ld: "ltr",
  alt: ["Gamati", "Gameti", "Gamith", "Gamta", "Gamti", "Gavit"],
  cc: ["IN"]
}, {
  pk: 1939,
  ang: "Garhwali",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Garhwali",
  lc: "gbm",
  ld: "ltr",
  alt: ["Gadhavali", "Gadhawala", "Gadwahi", "Gashwali", "Girwali", "Godauli", "Gorwali", "Gurvali", "Pahari Garhwali", "Bangani", "Chandpuri", "Gangadi (Uttarkashi)", "Jaunpuri", "Parvati", "Ravai", "Salani (Pauri)", "Srinagari", "Tehri (Gangapariya)"],
  cc: ["IN"]
}, {
  pk: 1940,
  ang: "Mo\u2019da",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Mo'da",
  lc: "gbn",
  ld: "ltr",
  alt: ["Gbara", "Gberi", "Gweri", "Muda"],
  cc: ["SS"]
}, {
  pk: 1941,
  ang: "Grebo, Northern",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Northern Grebo",
  lc: "gbo",
  ld: "ltr",
  alt: ["E Je (Eh Je)", "Klepo", "Gbepo (Gbeapo)", "Fopo-Bua"],
  cc: ["LR"]
}, {
  pk: 1942,
  ang: "Gbaya-Bossangoa",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Gbaya-Bossangoa",
  lc: "gbp",
  ld: "ltr",
  alt: ["Gbaya de Bosangoa", "Gbaya of Borro", "Gbaya of Bossangoa", "Gbaya-Borro", "Gbea", "Gbeya"],
  cc: ["CF"]
}, {
  pk: 1943,
  ang: "Gbaya-Bozoum",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Gbaya-Bozoum",
  lc: "gbq",
  ld: "ltr",
  alt: ["Gbaya de Bozoum"],
  cc: ["CF"]
}, {
  pk: 1944,
  ang: "Gbagyi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Gbagyi",
  lc: "gbr",
  ld: "ltr",
  alt: ["East Gwari", "Gbagye", "Gwari", "Gwari Matai", "Ibagyi", "Gyange", "Gyengyen", "Ngenge (Genge)"],
  cc: ["NG"]
}, {
  pk: 1945,
  ang: "Gbe, Gbesi",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Gbesi Gbe",
  lc: "gbs",
  ld: "ltr",
  alt: ["Gbokpa"],
  cc: ["BJ"]
}, {
  pk: 1946,
  ang: "Gagadu",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Gagadu",
  lc: "gbu",
  ld: "ltr",
  alt: ["Abdedal", "Abiddul", "Gaagudju", "Kakadu", "Kakakta", "Kakdju", "Kakdjuan"],
  cc: ["AU"]
}, {
  pk: 1947,
  ang: "Gbanu",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Gbanu",
  lc: "gbv",
  ld: "ltr",
  alt: ["Banu", "Baguili", "Budigri (Bidikili)", "Gbagili", "Gbagiri (Bagili)"],
  cc: ["CF"]
}, {
  pk: 1948,
  ang: "Gabi-Gabi",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Gabi-Gabi",
  lc: "gbw",
  ld: "ltr",
  alt: ["Cabee", "Carby", "Carby-carbery", "Dhapil", "Dhipil", "Dippil", "Dipple", "Doon-dooburra", "Doondoora", "Dowarburra", "Dundubara", "Dunduura", "Gabi", "Gabigabi", "Kabbi", "Kabi", "Kabikabi", "Kahby", "Karabi", "Karbi", "Maiba"],
  cc: ["AU"]
}, {
  pk: 1949,
  ang: "Gbe, Eastern Xwla",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Eastern Xwla Gbe",
  lc: "gbx",
  ld: "ltr",
  alt: ["Houla", "Kpla", "Offra", "Ophra", "Phla", "Pla", "Popo", "Xwla"],
  cc: ["BJ"]
}, {
  pk: 1950,
  ang: "Gbari",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Gbari",
  lc: "gby",
  ld: "ltr",
  alt: ["Gbari Yamma", "Gwari Yamma", "Nkwa", "West Gwari", "Wake", "Wi", "Kwange (Agbawi)", "Kangye", "Paiko"],
  cc: ["NG"]
}, {
  pk: 1951,
  ang: "Dari, Zoroastrian",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u06AF\u0648\u06CC\u0634 \u0628\u0647\u062F\u06CC\u0646\u0627\u0646",
  lc: "gbz",
  ld: "ltr",
  alt: ["Gabar", "Gabri"],
  cc: ["IR"]
}, {
  pk: 1952,
  ang: "Mali",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mali",
  lc: "gcc",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 1953,
  ang: "Ganggalida",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Ganggalida",
  lc: "gcd",
  ld: "ltr",
  alt: ["Ganggalita", "Jakula", "Jugula", "Kangkalita", "Yokula", "Yugulda", "Yukala", "Yukulta", "Nguburindi"],
  cc: ["AU"]
}, {
  pk: 1954,
  ang: "Guadeloupean Creole French",
  lr: "Americas",
  gw: false,
  hc: "GP",
  ln: "Guadeloupean Creole French",
  lc: "gcf",
  ld: "ltr",
  alt: ["Kreyol", "Patois", "Patwa", "Marie Galante Creole French"],
  cc: ["GF", "US", "GP", "MQ"]
}, {
  pk: 1955,
  ang: "Grenadian Creole English",
  lr: "Americas",
  gw: false,
  hc: "GD",
  ln: "Grenadian Creole English",
  lc: "gcl",
  ld: "ltr",
  alt: ["Carriacou Creole English"],
  cc: ["GD"]
}, {
  pk: 1956,
  ang: "Gaina",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gaina",
  lc: "gcn",
  ld: "ltr",
  alt: ["Bareji (Baredji)"],
  cc: ["PG"]
}, {
  pk: 1957,
  ang: "Guianese Creole French",
  lr: "Americas",
  gw: false,
  hc: "GF",
  ln: "Guianese Creole French",
  lc: "gcr",
  ld: "ltr",
  alt: ["French Guianese Creole French", "Guyanais", "Guyane", "Guyane Creole", "Patois", "Patwa"],
  cc: ["GF", "US"]
}, {
  pk: 1958,
  ang: "German, Colonia Tovar",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "Colonia Tovar German",
  lc: "gct",
  ld: "ltr",
  alt: ["Alem\xE1n Coloniero", "Patois"],
  cc: ["VE"]
}, {
  pk: 1959,
  ang: "Scottish Gaelic, Gaelic",
  lr: "Europe",
  gw: false,
  hc: "GB",
  ln: "G\xE0idhlig",
  lc: "gd",
  ld: "ltr",
  alt: ["Gaelic", "G\xE0idhlig", "Scots Gaelic"],
  cc: ["GB", "US"]
}, {
  pk: 1960,
  ang: "Lohar, Gade",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Gade Lohar",
  lc: "gda",
  ld: "ltr",
  alt: ["Bagri Lohar", "Belani", "Bhubaliya Lohar", "Chitodi Lohar", "Chittoriya Lohar", "Dhunkuria", "Domba", "Dombiali", "Gadia Lohar", "Gaduliya Lohar", "Gara", "Kanwar Khati", "Lohari", "Lohpitta", "Panchal Lohar", "Rajput Lohar"],
  cc: ["IN"]
}, {
  pk: 1961,
  ang: "Gadaba, Pottangi Ollar",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Pottangi Ollar Gadaba",
  lc: "gdb",
  ld: "ltr",
  alt: ["Allar", "Gadba", "Hallari", "Hollar Gadbas", "Konekor", "Konekor Gadaba", "Mundli", "Ollar Gadaba", "Ollaro", "San Gadaba", "Sano"],
  cc: ["IN"]
}, {
  pk: 1962,
  ang: "Gugu Badhun",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Gugu Badhun",
  lc: "gdc",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 1963,
  ang: "Gedaged",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gedaged",
  lc: "gdd",
  ld: "ltr",
  alt: ["Bel", "Mitebog", "Ragetta", "Rio", "Sek", "Siar", "Siar-Ragetta", "Szeak-Bagili", "Tiara"],
  cc: ["PG"]
}, {
  pk: 1964,
  ang: "Gude",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Gude",
  lc: "gde",
  ld: "ltr",
  alt: ["Cheke", "Goude", "Mapodi", "Mocigin", "Motchekin", "Mubi", "Mudaye", "Shede", "Tchade", "Tcheke", "Mapuda"],
  cc: ["CM", "NG"]
}, {
  pk: 1965,
  ang: "Guduf-Gava",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Guduf-Gava",
  lc: "gdf",
  ld: "ltr",
  alt: ["Afkabiye", "Gudupe", "Cikide (Chikide)", "Gava (Yaghwatadaxa)", "Yawotataxa"],
  cc: ["CM", "NG"]
}, {
  pk: 1966,
  ang: "Ga\u2019dang",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Ga'dang",
  lc: "gdg",
  ld: "ltr",
  alt: ["Baliwon", "Gaddang", "Ginabwal"],
  cc: ["PH"]
}, {
  pk: 1967,
  ang: "Gadjerawang",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Gadjerawang",
  lc: "gdh",
  ld: "ltr",
  alt: ["Kajirrawung"],
  cc: ["AU"]
}, {
  pk: 1968,
  ang: "Gundi",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Gundi",
  lc: "gdi",
  ld: "ltr",
  alt: ["Ngondi", "Ngundi"],
  cc: ["CF", "CG"]
}, {
  pk: 1969,
  ang: "Gurdjar",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Gurdjar",
  lc: "gdj",
  ld: "ltr",
  alt: ["Kurtjjar"],
  cc: ["AU"]
}, {
  pk: 1970,
  ang: "Gadang",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Gadang",
  lc: "gdk",
  ld: "ltr",
  alt: [],
  cc: ["TD"]
}, {
  pk: 1971,
  ang: "Dirasha",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Dirasha",
  lc: "gdl",
  ld: "ltr",
  alt: ["Dhirasha", "Diraasha", "Dirayta", "Gardulla", "Ghidole", "Gidole", "Kusumitta", "Mosiya"],
  cc: ["ET"]
}, {
  pk: 1972,
  ang: "Laal",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Laal",
  lc: "gdm",
  ld: "ltr",
  alt: ["Gori"],
  cc: ["TD"]
}, {
  pk: 1973,
  ang: "Umanakaina",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Umanakaina",
  lc: "gdn",
  ld: "ltr",
  alt: ["Gvede", "Gweda", "Gwede", "Gwedena", "Umanikaina"],
  cc: ["PG"]
}, {
  pk: 1974,
  ang: "Ghodoberi",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0413\u043E\u0434\u043E\u0431\u0435\u0440\u0438\u043D\u0441\u043A\u0438\u0439",
  lc: "gdo",
  ld: "ltr",
  alt: ["Godoberi", "Godoberin", "Zibirkhali"],
  cc: ["RU"]
}, {
  pk: 1975,
  ang: "Mehri",
  lr: "Asia",
  gw: false,
  hc: "YE",
  ln: "\u0644\u063A\u0629 \u0645\u0647\u0631\u064A\u0629",
  lc: "gdq",
  ld: "ltr",
  alt: ["Mahri", "Eastern Mehri (Mehriyot)", "Western Mehri (Mehriyet)"],
  cc: ["OM", "SA", "YE"]
}, {
  pk: 1976,
  ang: "Wipi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wipi",
  lc: "gdr",
  ld: "ltr",
  alt: ["Gidra", "Jibu", "Oriomo", "Kuru (uKuru)", "Woigo"],
  cc: ["PG"]
}, {
  pk: 1977,
  ang: "Ghandruk Sign Language",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Ghandruk Sign Language",
  lc: "gds",
  ld: "ltr",
  alt: [],
  cc: ["NP"]
}, {
  pk: 1978,
  ang: "Gudu",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Gudu",
  lc: "gdu",
  ld: "ltr",
  alt: ["Gudo", "Gutu"],
  cc: ["NG"]
}, {
  pk: 1979,
  ang: "Godwari",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Godwari",
  lc: "gdx",
  ld: "ltr",
  alt: ["Khuni", "Madahaddi", "Sirohi", "Balvi"],
  cc: ["IN"]
}, {
  pk: 1980,
  ang: "Geruma",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Geruma",
  lc: "gea",
  ld: "ltr",
  alt: ["Gerema", "Germa"],
  cc: ["NG"]
}, {
  pk: 1981,
  ang: "Kire",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kire",
  lc: "geb",
  ld: "ltr",
  alt: ["Gire", "Giri", "Kire-Puire"],
  cc: ["PG"]
}, {
  pk: 1982,
  ang: "Grebo, Gboloo",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Gboloo Grebo",
  lc: "gec",
  ld: "ltr",
  alt: ["Gblou Grebo", "Gboloo", "Tuobo"],
  cc: ["LR"]
}, {
  pk: 1983,
  ang: "Gade",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Gade",
  lc: "ged",
  ld: "ltr",
  alt: ["Gede"],
  cc: ["NG"]
}, {
  pk: 1984,
  ang: "Gengle",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Gengle",
  lc: "geg",
  ld: "ltr",
  alt: ["Momu", "Wegele", "Yagele"],
  cc: ["NG"]
}, {
  pk: 1985,
  ang: "Hutterisch",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Hutterite German",
  lc: "geh",
  ld: "ltr",
  alt: ["Carinthian German", "Hutterian German", "Hutterite German", "Tirolean", "Tyrolese"],
  cc: ["US", "CA"]
}, {
  pk: 1986,
  ang: "Gebe",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Gebe",
  lc: "gei",
  ld: "ltr",
  alt: ["Gebi"],
  cc: ["ID"]
}, {
  pk: 1987,
  ang: "Gen",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Gen",
  lc: "gej",
  ld: "ltr",
  alt: ["Ge", "Gegbe", "Gen-Gbe", "Guin", "Mina-Gen", "Popo", "Gebe", "Gliji", "Agoi", "Anexo"],
  cc: ["BJ", "TG"]
}, {
  pk: 1988,
  ang: "Ywom",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Yiwom",
  lc: "gek",
  ld: "ltr",
  alt: ["Gerka", "Gerkanchi", "Gerkawa", "Gurka"],
  cc: ["NG"]
}, {
  pk: 1989,
  ang: "ut-Ma\u2019in",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "ut-Ma'in",
  lc: "gel",
  ld: "ltr",
  alt: ["Fakanchi", "Fakanci", "Fakkanci", "Gelanchi", "Koor (Kulu)", "Kukum", "Kur (Kar)", "Puku", "Ror (Er-Gwar)", "Tudanchi", "Keri-Ni", "Wipsi-Ni", "Jiir (Et-Jiir)", "Zuksun (Et-Zuksun, Zussun)", "Us (Et-Us)", "Kere", "Kelli-Ni", "Kelinci", "Kag (Et-Kag)", "Fere", "Fer (Et-Fer)", "Et-Maror", "Kelanchi"],
  cc: ["NG"]
}, {
  pk: 1990,
  ang: "Geme",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Geme",
  lc: "geq",
  ld: "ltr",
  alt: ["Gueme", "Jeme", "Ngba Geme"],
  cc: ["CF"]
}, {
  pk: 1991,
  ang: "Geser-Gorom",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Geser-Gorom",
  lc: "ges",
  ld: "ltr",
  alt: ["Gesa", "Geser", "Goram", "Goran", "Gorom", "Gorong", "Seram", "Seran", "Seran Laut"],
  cc: ["ID"]
}, {
  pk: 1992,
  ang: "Eviya",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Eviya",
  lc: "gev",
  ld: "ltr",
  alt: [],
  cc: ["GA"]
}, {
  pk: 1993,
  ang: "Gera",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Gera",
  lc: "gew",
  ld: "ltr",
  alt: ["Gerawa"],
  cc: ["NG"]
}, {
  pk: 1994,
  ang: "Garre",
  lr: "Africa",
  gw: false,
  hc: "SO",
  ln: "Garre",
  lc: "gex",
  ld: "ltr",
  alt: ["Af-Garre"],
  cc: ["SO"]
}, {
  pk: 1995,
  ang: "Enya",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Enya",
  lc: "gey",
  ld: "ltr",
  alt: ["Ena", "Genya", "Tsheenya"],
  cc: ["CD"]
}, {
  pk: 1996,
  ang: "Geez",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Geez",
  lc: "gez",
  ld: "ltr",
  alt: ["Ancient Ethiopic", "Ethiopic", "Ge'ez", "Giiz"],
  cc: ["ET"]
}, {
  pk: 1997,
  ang: "Patpatar",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Patpatar",
  lc: "gfk",
  ld: "ltr",
  alt: ["Gelik", "Patpari"],
  cc: ["PG"]
}, {
  pk: 1998,
  ang: "Gafat",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Gafat",
  lc: "gft",
  ld: "ltr",
  alt: [],
  cc: ["ET"]
}, {
  pk: 1999,
  ang: "Gao",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Gao",
  lc: "gga",
  ld: "ltr",
  alt: ["Nggao"],
  cc: ["SB"]
}, {
  pk: 2000,
  ang: "Gbii",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Gbii",
  lc: "ggb",
  ld: "ltr",
  alt: ["Gbee", "Gbi-Dowlu", "Kplor"],
  cc: ["LR"]
}, {
  pk: 2001,
  ang: "Guragone",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Guragone",
  lc: "gge",
  ld: "ltr",
  alt: ["Gorogone", "Gunagoragone", "Gungorogone", "Gun-Guragone", "Gurrgoni", "Gurrogone", "Gutjertabia"],
  cc: ["AU"]
}, {
  pk: 2002,
  ang: "Gurgula",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "Gurgula",
  lc: "ggg",
  ld: "ltr",
  alt: ["Marwari Ghera"],
  cc: ["PK"]
}, {
  pk: 2003,
  ang: "Ganglau",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ganglau",
  lc: "ggl",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2004,
  ang: "Gurung, Eastern",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Eastern Gurung",
  lc: "ggn",
  ld: "ltr",
  alt: ["Daduwa", "Gurung", "Lamjung Gurung", "Gorkha Gurung"],
  cc: ["NP"]
}, {
  pk: 2005,
  ang: "Gondi, Southern",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Southern Gondi",
  lc: "ggo",
  ld: "ltr",
  alt: ["Koi Gondi", "Telugu Gondi", "Nirmal (Adilabad)"],
  cc: ["IN"]
}, {
  pk: 2006,
  ang: "Gitua",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gitua",
  lc: "ggt",
  ld: "ltr",
  alt: ["Gitoa", "Kelana"],
  cc: ["PG"]
}, {
  pk: 2007,
  ang: "Gban",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Gagu",
  lc: "ggu",
  ld: "ltr",
  alt: ["Gagu", "Kago", "Sodua", "Boka", "Touka"],
  cc: ["CI"]
}, {
  pk: 2008,
  ang: "Gogodala",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gogodala",
  lc: "ggw",
  ld: "ltr",
  alt: ["Gogodara"],
  cc: ["PG"]
}, {
  pk: 2009,
  ang: "Ghadam\xE8s",
  lr: "Africa",
  gw: false,
  hc: "LY",
  ln: "\u0644\u0647\u062C\u0629 \u063A\u062F\u0627\u0645\u0633\u064A\u0629",
  lc: "gha",
  ld: "ltr",
  alt: [],
  cc: ["TN", "LY"]
}, {
  pk: 2010,
  ang: "Hiberno-Scottish Gaelic",
  lr: "Europe",
  gw: false,
  hc: "GB",
  ln: "Hiberno-Scottish Gaelic",
  lc: "ghc",
  ld: "ltr",
  alt: [],
  cc: ["GB"]
}, {
  pk: 2011,
  ang: "Ghale, Southern",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Southern Ghale",
  lc: "ghe",
  ld: "ltr",
  alt: ["Galle Gurung", "Lila", "Ril-Lila"],
  cc: ["NP"]
}, {
  pk: 2012,
  ang: "Ghale, Northern",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Northern Ghale",
  lc: "ghh",
  ld: "ltr",
  alt: ["Lila", "Ril-Lila"],
  cc: ["NP"]
}, {
  pk: 2013,
  ang: "Karen, Geko",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Geko Karen",
  lc: "ghk",
  ld: "ltr",
  alt: ["Gaikho", "Gekho", "Gek'o", "Ghekhol", "Ghekhu", "Gheko", "Kakhau", "Kayan", "Kayan Kakhau", "Kekaungdu", "Kekhong", "Keku", "Yathu Gekho", "Geker", "Thaidai (Htideh)"],
  cc: ["MM"]
}, {
  pk: 2014,
  ang: "Ghulfan",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Ghulfan",
  lc: "ghl",
  ld: "ltr",
  alt: ["Gulfan", "Uncunwee", "Wunci", "Wuncimbe"],
  cc: ["SD"]
}, {
  pk: 2015,
  ang: "Ghanongga",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Ghanongga",
  lc: "ghn",
  ld: "ltr",
  alt: ["Ganongga", "Kubokota", "Kumbokota"],
  cc: ["SB"]
}, {
  pk: 2016,
  ang: "Ghomara",
  lr: "Africa",
  gw: false,
  hc: "MA",
  ln: "\u2D56\u2D53\u2D4E\u2D30\u2D54\u2D30",
  lc: "gho",
  ld: "ltr",
  alt: ["Shilha", "Taghumarit", "Tamazight"],
  cc: ["MA"]
}, {
  pk: 2017,
  ang: "Ghera",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "Ghera",
  lc: "ghr",
  ld: "ltr",
  alt: ["Bara", "Sindhi Ghera"],
  cc: ["PK"]
}, {
  pk: 2018,
  ang: "Guhu-Samane",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Guhu-Samane",
  lc: "ghs",
  ld: "ltr",
  alt: ["Bia", "Mid-Waria", "Muri", "Paiawa", "Tahari"],
  cc: ["PG"]
}, {
  pk: 2019,
  ang: "Kuke",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Kuke",
  lc: "ght",
  ld: "ltr",
  alt: ["Bhotte", "Kutang", "Kutang Ghale"],
  cc: ["NP"]
}, {
  pk: 2020,
  ang: "Kitja",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Kitja",
  lc: "gia",
  ld: "ltr",
  alt: ["Gidja", "Kidja"],
  cc: ["AU"]
}, {
  pk: 2021,
  ang: "Gibanawa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Gibanawa",
  lc: "gib",
  ld: "ltr",
  alt: ["Gembanawa", "Gimbanawa", "Jega"],
  cc: ["NG"]
}, {
  pk: 2022,
  ang: "Gail",
  lr: "Africa",
  gw: false,
  hc: "ZA",
  ln: "Gail",
  lc: "gic",
  ld: "ltr",
  alt: [],
  cc: ["ZA"]
}, {
  pk: 2023,
  ang: "Gidar",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Gidar",
  lc: "gid",
  ld: "ltr",
  alt: ["Baynawa", "Gidder", "Guidar", "Kada"],
  cc: ["CM", "TD"]
}, {
  pk: 2024,
  ang: "Goaria",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "Goaria",
  lc: "gig",
  ld: "ltr",
  alt: [],
  cc: ["PK"]
}, {
  pk: 2025,
  ang: "Githabul",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Githabul",
  lc: "gih",
  ld: "ltr",
  alt: ["Gidabul", "Gidjoobal", "Kidabal", "Kidjabal", "Kitabool", "Kita-bool", "Kitapul", "Kittabool", "Kitta-bool", "Kuttibul", "Noowidal"],
  cc: ["AU"]
}, {
  pk: 2026,
  ang: "Kiribati",
  lr: "Pacific",
  gw: false,
  hc: "KI",
  ln: "Gilbertese",
  lc: "gil",
  ld: "ltr",
  alt: ["Gilbertese", "I-Kiribati", "Nui (Nuian)"],
  cc: ["FJ", "KI", "SB", "TV", "US", "NR", "VU"]
}, {
  pk: 2027,
  ang: "Gimi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gimi (Eastern Highlands)",
  lc: "gim",
  ld: "ltr",
  alt: ["West Gimi (Gouno)"],
  cc: ["PG"]
}, {
  pk: 8485,
  ang: "Ibusakava",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ibusakava",
  lc: "gim-x-ibusakava",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8486,
  ang: "Ovavo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ovavo",
  lc: "gim-x-ovavo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2028,
  ang: "Hinukh",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0413\u0438\u043D\u0443\u0445\u0441\u043A\u0438\u0439",
  lc: "gin",
  ld: "ltr",
  alt: ["Ginukh", "Ginukhtsy", "Ginux", "Hinux"],
  cc: ["RU"]
}, {
  pk: 298,
  ang: "A\u2019ou",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4EE1\u4F6C",
  lc: "gio",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7555,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Naza",
  lc: "gio-x-naza",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 2029,
  ang: "Gimi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gimi (West New Britain)",
  lc: "gip",
  ld: "ltr",
  alt: ["Loko"],
  cc: ["PG"]
}, {
  pk: 2030,
  ang: "Gelao, Green",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Hagei",
  lc: "giq",
  ld: "ltr",
  alt: ["Hakei", "Cape Draping Gelao", "Hakhi", "Hoki Gelao", "Klau", "Qau"],
  cc: ["VN"]
}, {
  pk: 2031,
  ang: "Gelao, Red",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "\u7EA2\u4EE1\u4F6C\u8BED",
  lc: "gir",
  ld: "ltr",
  alt: ["Vandu Gelao", "Voa D\xEA"],
  cc: ["VN"]
}, {
  pk: 2032,
  ang: "Giziga, North",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "North Giziga",
  lc: "gis",
  ld: "ltr",
  alt: ["Dogba", "Gisika", "Giziga de", "Guiziga", "Marva", "Mi Marva", "Tchere"],
  cc: ["CM"]
}, {
  pk: 2033,
  ang: "Gitxsan",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Gitxsan",
  lc: "git",
  ld: "ltr",
  alt: ["Giklsan", "Gityskyan", "Gitsken (Western Gitsken)", "Gitxsan (Eastern Gitxsan)"],
  cc: ["CA"]
}, {
  pk: 2034,
  ang: "Mulao",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4EE1\u4F6C",
  lc: "giu",
  ld: "ltr",
  alt: ["Ayo"],
  cc: ["CN"]
}, {
  pk: 2035,
  ang: "Duoluo, White Gelao",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u9752\u4EE1\u4F6C\u8BED",
  lc: "giw",
  ld: "ltr",
  alt: ["Bai Gelo", "White Gelao", "Southwestern Gelao", "Telue", "T\xFA Du", "Tu'lu"],
  cc: ["CN"]
}, {
  pk: 2036,
  ang: "Gilima",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Gilima",
  lc: "gix",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 2037,
  ang: "Giyug",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Giyug",
  lc: "giy",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 2038,
  ang: "Giziga, South",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "South Giziga",
  lc: "giz",
  ld: "ltr",
  alt: ["Gisiga", "Gisika", "Guiziga", "Muturami (Giziga de Moutouroua)", "Muturua", "Mi Mijivin (Giziga de Midjivin)", "Loulou", "Muturwa"],
  cc: ["CM"]
}, {
  pk: 2039,
  ang: "Geji",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Geji",
  lc: "gji",
  ld: "ltr",
  alt: ["Gejawa", "Gezawa", "Kayauri", "Pelu", "Zaranda (Buu)", "Gyaazi", "Geji (Gaejawa)", "Bolu (Magang)"],
  cc: ["NG"]
}, {
  pk: 2040,
  ang: "Koli, Kachi",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "Kachi Koli",
  lc: "gjk",
  ld: "ltr",
  alt: ["Kachi Gujarati", "Katchi", "Kohli", "Kolhi", "Kori", "Kuchi", "Kuchikoli", "Vagaria", "Vaghri", "Vagri (Kachi Meghwar)", "Rabari (Rahabari)"],
  cc: ["PK"]
}, {
  pk: 2041,
  ang: "Gonja",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Gonja",
  lc: "gjn",
  ld: "ltr",
  alt: ["Choruba (Choroba)"],
  cc: ["GH"]
}, {
  pk: 2042,
  ang: "Gujari",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Gujari",
  lc: "gju",
  ld: "ltr",
  alt: ["Gojri", "Gujuri Rajasthani", "Gogri", "Gujar", "Gujer", "Gujjari", "Gujuri", "Gurjar", "Hindki", "Kashmir Gujuri", "Parimu", "Rajasthani Gujuri"],
  cc: ["AF", "PK", "IN"]
}, {
  pk: 7784,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Gujur Rajistani",
  lc: "gju-x-rajistani",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2043,
  ang: "Guya",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Guya",
  lc: "gka",
  ld: "ltr",
  alt: ["Guyarak"],
  cc: ["PG"]
}, {
  pk: 2044,
  ang: "Ndai",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Ndai",
  lc: "gke",
  ld: "ltr",
  alt: ["Galke", "Pormi"],
  cc: ["CM"]
}, {
  pk: 2045,
  ang: "Gokana",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Gokana",
  lc: "gkn",
  ld: "ltr",
  alt: ["Kibangha", "Bodo", "Bomu", "Dere"],
  cc: ["NG"]
}, {
  pk: 2046,
  ang: "Kpelle, Guinea",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Guinea Kpelle",
  lc: "gkp",
  ld: "ltr",
  alt: ["Akpese", "Gbese", "Gerse", "Gerze", "Guerze", "Kpele", "Kpelese", "Kpelesetina", "Kperese", "Kpese", "Kpwessi", "Northern Kpele", "Pessa", "Pessy", "Heghe", "Gbali", "Central Kpelle"],
  cc: ["GN"]
}, {
  pk: 2047,
  ang: "Galician",
  lr: "Europe",
  gw: false,
  hc: "ES",
  ln: "galego",
  lc: "gl",
  ld: "ltr",
  alt: ["Galego", "Gallego", "Rionorese (Rionor\xEAs)", "Guadramilese (Guadramil\xEAs)"],
  cc: ["AR", "ES", "PT"]
}, {
  pk: 2048,
  ang: "Bon Gula",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Bon Gula",
  lc: "glc",
  ld: "ltr",
  alt: ["Bon", "Bon Goula", "Bun", "\xCAeni", "Gula Guera", "Poun", "Taataal"],
  cc: ["TD"]
}, {
  pk: 2049,
  ang: "Nanai",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041D\u0430\u043D\u0430\u0439\u0441\u043A\u0438\u0439",
  lc: "gld",
  ld: "ltr",
  alt: ["Gold", "Goldi", "Hezhe", "Juchen", "Nanay", "Sushen", "Heche", "Nanaj", "Kili", "Kirin", "Qile'en", "Qileng (Kilen)", "Sungari"],
  cc: ["RU"]
}, {
  pk: 2050,
  ang: "Pashai, Northwest",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Northwest Pashai",
  lc: "glh",
  ld: "ltr",
  alt: ["Pashai", "Wadau"],
  cc: ["AF"]
}, {
  pk: 2051,
  ang: "Gula Iro",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Gula Iro",
  lc: "glj",
  ld: "ltr",
  alt: ["Goula d'Iro", "Goula Iro", "Pongaal (Ponaal)"],
  cc: ["TD"]
}, {
  pk: 2052,
  ang: "Gilaki",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u0632\u0628\u0627\u0646 \u06AF\u06CC\u0644\u06A9\u06CC",
  lc: "glk",
  ld: "rtl",
  alt: ["Gelaki", "Gilani", "Guilaki", "Guilani", "Bandar Anzali", "Rudbari", "Rudsari", "Some'e Sarai", "Langerudi", "Fumani", "Lahijani"],
  cc: ["IR"]
}, {
  pk: 2053,
  ang: "Galambu",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Galambu",
  lc: "glo",
  ld: "ltr",
  alt: ["Galambe", "Galambi", "Galembi"],
  cc: ["NG"]
}, {
  pk: 2054,
  ang: "Glaro-Twabo",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Glaro-Twabo",
  lc: "glr",
  ld: "ltr",
  alt: ["Twabo"],
  cc: ["LR"]
}, {
  pk: 2055,
  ang: "Gula",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Gula",
  lc: "glu",
  ld: "ltr",
  alt: ["Bayo", "Goula", "Sara Goula", "Sara Gula", "Kofoy", "Mal\xE9", "Moufa", "Souka", "Toussa"],
  cc: ["TD"]
}, {
  pk: 2056,
  ang: "Glavda",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Glavda",
  lc: "glw",
  ld: "ltr",
  alt: ["Galavda", "Galvaxdaxa", "Gelvaxdaxa", "Guelebda", "Vale", "Gelebda", "Glanda", "Ngoshie (Ngweshe)"],
  cc: ["CM", "NG"]
}, {
  pk: 2057,
  ang: "Gule",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Gule",
  lc: "gly",
  ld: "ltr",
  alt: ["Anej", "Fecakomodiyo", "Hamej"],
  cc: ["SD"]
}, {
  pk: 2058,
  ang: "Gula\u2019alaa",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Gula'alaa",
  lc: "gmb",
  ld: "ltr",
  alt: ["Kwai", "Ngongosila"],
  cc: ["SB"]
}, {
  pk: 2059,
  ang: "M\xE1ghd\xEC",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "M\xE1ghd\xEC",
  lc: "gmd",
  ld: "ltr",
  alt: ["Tala", "Widala"],
  cc: ["NG"]
}, {
  pk: 2060,
  ang: "Magiyi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mag\u0268yi",
  lc: "gmg",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2061,
  ang: "Middle High German",
  lr: "Europe",
  gw: false,
  hc: "DE",
  ln: "Middle High German (ca. 1050-1500)",
  lc: "gmh",
  ld: "ltr",
  alt: [],
  cc: ["DE"]
}, {
  pk: 2062,
  ang: "Middle Low German",
  lr: "Europe",
  gw: false,
  hc: "DE",
  ln: "Middle Low German",
  lc: "gml",
  ld: "ltr",
  alt: [],
  cc: ["DE"]
}, {
  pk: 2063,
  ang: "Gbaya-Mbodomo",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Gbaya-Mbodomo",
  lc: "gmm",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 2064,
  ang: "Gimnime",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Gimnime",
  lc: "gmn",
  ld: "ltr",
  alt: ["Gimbe", "Kadam", "Koma Kadam", "Komlama", "Laame", "Yotubo"],
  cc: ["CM"]
}, {
  pk: 2065,
  ang: "Gumalu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gumalu",
  lc: "gmu",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2066,
  ang: "Gamo",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Gamo",
  lc: "gmv",
  ld: "ltr",
  alt: ["Gemu"],
  cc: ["ET"]
}, {
  pk: 2067,
  ang: "Magoma",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Magoma",
  lc: "gmx",
  ld: "ltr",
  alt: ["Kimagoma"],
  cc: ["TZ"]
}, {
  pk: 2068,
  ang: "Mycenaean Greek",
  lr: "Europe",
  gw: false,
  hc: "GR",
  ln: "Mycenaean Greek",
  lc: "gmy",
  ld: "ltr",
  alt: [],
  cc: ["GR"]
}, {
  pk: 2069,
  ang: "Mgbolizhia",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Mgbolizhia",
  lc: "gmz",
  ld: "ltr",
  alt: ["Mgbo", "Ngbo"],
  cc: ["NG"]
}, {
  pk: 2070,
  ang: "Guaran\xED",
  lr: "Americas",
  gw: false,
  hc: "PY",
  ln: "Ava\xF1e'\u1EBD",
  lc: "gn",
  ld: "ltr",
  alt: [],
  cc: ["PY"]
}, {
  pk: 2071,
  ang: "Kaansa",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Kaansa",
  lc: "gna",
  ld: "ltr",
  alt: ["G\xE3", "Gane", "Kaan", "Kaanse", "K\xE3asa", "Kan", "Kpatogo (Bodoro)", "Padorho", "Padoro", "Gbadogo", "Padogho", "Kpatogoso"],
  cc: ["BF"]
}, {
  pk: 2072,
  ang: "Gangte",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Gangte",
  lc: "gnb",
  ld: "ltr",
  alt: ["Gante"],
  cc: ["IN"]
}, {
  pk: 2073,
  ang: "Guanche",
  lr: "Europe",
  gw: false,
  hc: "ES",
  ln: "Guanche",
  lc: "gnc",
  ld: "ltr",
  alt: [],
  cc: ["ES"]
}, {
  pk: 2074,
  ang: "Zulgo-Gemzek",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Zulgo-Gemzek",
  lc: "gnd",
  ld: "ltr",
  alt: ["Gemjek", "Guemshek", "Zulgo", "Zulgo (Zelgwa)", "Gemzek (Gaduwa)", "Mineo (Minew)", "Zoulgo"],
  cc: ["CM"]
}, {
  pk: 2075,
  ang: "Ganang",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ganang",
  lc: "gne",
  ld: "ltr",
  alt: ["Gashish"],
  cc: ["NG"]
}, {
  pk: 2076,
  ang: "Ngangam",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Ngangam",
  lc: "gng",
  ld: "ltr",
  alt: ["Dye", "Gamgan", "Gangam", "Gangum", "Migangam", "Mijiem", "Nbangam", "Ngangan", "Motiem (Mogou)"],
  cc: ["TG"]
}, {
  pk: 2077,
  ang: "Lere",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Lere",
  lc: "gnh",
  ld: "ltr",
  alt: ["Kuzamani", "Rishuwa", "Si (Kauru)", "SiGana", "Takaya (Taura)", "Gana (Ganawa)"],
  cc: ["NG"]
}, {
  pk: 2078,
  ang: "Gooniyandi",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Gooniyandi",
  lc: "gni",
  ld: "ltr",
  alt: ["Gunian", "Guniandi", "Guniyan", "Guniyandi", "Guniyn", "Konejandi", "Koneyandi", "Kunan", "Kunian", "Kuniyan"],
  cc: ["AU"]
}, {
  pk: 2079,
  ang: "||Gana",
  lr: "Africa",
  gw: false,
  hc: "BW",
  ln: "\u01C1Gana",
  lc: "gnk",
  ld: "ltr",
  alt: ["Dxana", "G||ana-Khwe", "Gxana", "Gxanna", "Kanakhoe", "G||aakhwe (Balanka)", "G||anakhwe (Kanakhoe)", "|Khess\xE1khoe", "G||aa"],
  cc: ["BW"]
}, {
  pk: 2080,
  ang: "Ginuman",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ginuman",
  lc: "gnm",
  ld: "ltr",
  alt: ["Dime"],
  cc: ["PG"]
}, {
  pk: 2081,
  ang: "Gumatj",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Gumatj",
  lc: "gnn",
  ld: "ltr",
  alt: ["Gomadj", "Gumait", "Gumaj"],
  cc: ["AU"]
}, {
  pk: 2082,
  ang: "Gondi, Northern",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Northern Gondi",
  lc: "gno",
  ld: "ltr",
  alt: ["Gaudi", "Ghond", "Godi", "Gondiva", "Gondu", "Gondwadi", "Goondile", "Goudi", "Goudwal", "Chhindwara"],
  cc: ["IN"]
}, {
  pk: 2083,
  ang: "Gana",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Gana",
  lc: "gnq",
  ld: "ltr",
  alt: ["Ganaq", "Keningau Dusun", "Minansut"],
  cc: ["MY"]
}, {
  pk: 2084,
  ang: "Gureng Gureng",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Gureng Gureng",
  lc: "gnr",
  ld: "ltr",
  alt: ["Gureng-Gureng", "Gurreng Gurreng"],
  cc: ["AU"]
}, {
  pk: 2085,
  ang: "Guntai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Guntai",
  lc: "gnt",
  ld: "ltr",
  alt: ["Kan"],
  cc: ["PG"]
}, {
  pk: 2086,
  ang: "Gnau",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gnau",
  lc: "gnu",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2087,
  ang: "Guaran\xED, Western Bolivian",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Western Bolivian Guaran\xED",
  lc: "gnw",
  ld: "ltr",
  alt: ["Simba", "Simba Guaran\xED"],
  cc: ["BO"]
}, {
  pk: 2088,
  ang: "Ganzi",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Ganzi",
  lc: "gnz",
  ld: "ltr",
  alt: [],
  cc: ["CF", "CG"]
}, {
  pk: 2089,
  ang: "Guro",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Guro",
  lc: "goa",
  ld: "ltr",
  alt: ["Baba", "Dalo", "Dipa", "Ku", "Kw\xE9ndr\xE9", "Kweni", "Lo"],
  cc: ["CI"]
}, {
  pk: 2090,
  ang: "Playero",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Playero",
  lc: "gob",
  ld: "ltr",
  alt: ["Pepojivi", "Rio Arauca Guahibo", "Guahibo Playero"],
  cc: ["CO"]
}, {
  pk: 2091,
  ang: "Gorakor",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gorakor",
  lc: "goc",
  ld: "ltr",
  alt: ["Yanta"],
  cc: ["PG"]
}, {
  pk: 2092,
  ang: "Godi\xE9",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Godi\xE9",
  lc: "god",
  ld: "ltr",
  alt: ["Godye"],
  cc: ["CI"]
}, {
  pk: 2093,
  ang: "Gongduk",
  lr: "Asia",
  gw: false,
  hc: "BT",
  ln: "Gongduk",
  lc: "goe",
  ld: "ltr",
  alt: ["Gongdubikha"],
  cc: ["BT"]
}, {
  pk: 2094,
  ang: "Gofa",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Gofa",
  lc: "gof",
  ld: "ltr",
  alt: ["Goffa"],
  cc: ["ET"]
}, {
  pk: 2095,
  ang: "Gogo",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Gogo",
  lc: "gog",
  ld: "ltr",
  alt: ["Chigogo", "Kigogo", "Nyambwa (West Gogo)", "Nyaugogo (Central Gogo)", "Tumba (East Gogo)"],
  cc: ["TZ"]
}, {
  pk: 2096,
  ang: "Old High German",
  lr: "Europe",
  gw: false,
  hc: "DE",
  ln: "Old High German (ca. 750-1050)",
  lc: "goh",
  ld: "ltr",
  alt: [],
  cc: ["DE"]
}, {
  pk: 2097,
  ang: "Gobasi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gobasi",
  lc: "goi",
  ld: "ltr",
  alt: ["Nomad", "Gobasi (Bibo)", "Oibae (Oiba)"],
  cc: ["PG"]
}, {
  pk: 2098,
  ang: "Gowlan",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Gowlan",
  lc: "goj",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 2099,
  ang: "Gowli",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Gowli",
  lc: "gok",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 2100,
  ang: "Gola",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Gola",
  lc: "gol",
  ld: "ltr",
  alt: ["Gula", "Senje (Sene)", "Toldil (Toodii)", "Tee (Tege)", "Deng (Todii)", "De (Deng)", "Managobla (Gobla)"],
  cc: ["LR", "SL"]
}, {
  pk: 2101,
  ang: "Konkani, Goan",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Goan Konkani",
  lc: "gom",
  ld: "ltr",
  alt: ["Goan", "Gomataki", "Konknni", "Southern Kanara", "Goanese", "Bardeskari (Gomantaki)", "Chitpavani (Konkanasths)", "Daldi (Nawaits)", "Kudali (Malvani)", "Mangalore Standard Konkani (Goan)"],
  cc: ["GB", "MZ", "PK", "IN", "AE"]
}, {
  pk: 2102,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Gondi",
  lc: "gon",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 8033,
  ang: "Maria Gond",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Maria Gond",
  lc: "gon-x-mariagond",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2103,
  ang: "Gone Dau",
  lr: "Pacific",
  gw: false,
  hc: "FJ",
  ln: "Gone Dau",
  lc: "goo",
  ld: "ltr",
  alt: ["Gonedau"],
  cc: ["FJ"]
}, {
  pk: 2104,
  ang: "Yeretuar",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Yeretuar",
  lc: "gop",
  ld: "ltr",
  alt: ["Goni", "Umari"],
  cc: ["ID"]
}, {
  pk: 2105,
  ang: "Gorap",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Gorap",
  lc: "goq",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 2106,
  ang: "Gorontalo",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Gorontalo",
  lc: "gor",
  ld: "ltr",
  alt: ["Gorongtalo", "Guarantala", "Gunongtello", "Holontalo", "Hulontalo", "West Gorontalo (Kwandang)", "Limboto (Limbotto)"],
  cc: ["ID"]
}, {
  pk: 2107,
  ang: "Gronings",
  lr: "Europe",
  gw: false,
  hc: "NL",
  ln: "Gronings",
  lc: "gos",
  ld: "ltr",
  alt: ["Groningen", "Grunnings", "Westerwolds (Westerwold)", "West Groningen (West Gronings)", "Groningen-East Frisian (Gronings-Oostfries)", "Veenkoloniaals (Veen Colony)"],
  cc: ["NL"]
}, {
  pk: 2108,
  ang: "Gothic",
  lr: "Europe",
  gw: false,
  hc: "PL",
  ln: "Gothic",
  lc: "got",
  ld: "ltr",
  alt: [],
  cc: ["PL"]
}, {
  pk: 2109,
  ang: "Gavar",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Gavar",
  lc: "gou",
  ld: "ltr",
  alt: ["Gauar", "Gawar", "Gouwar", "Ma-Gavar", "Rtchi"],
  cc: ["CM"]
}, {
  pk: 2110,
  ang: "Gorowa",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Gorowa",
  lc: "gow",
  ld: "ltr",
  alt: ["Goroa"],
  cc: ["TZ"]
}, {
  pk: 2111,
  ang: "Gobu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Gobu",
  lc: "gox",
  ld: "ltr",
  alt: ["Gabou", "Gabu", "Gubu", "Ngobo", "Ngobu"],
  cc: ["CF", "CD"]
}, {
  pk: 2112,
  ang: "Goundo",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Goundo",
  lc: "goy",
  ld: "ltr",
  alt: [],
  cc: ["TD"]
}, {
  pk: 2113,
  ang: "Gozarkhani",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Gozarkhani",
  lc: "goz",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 2114,
  ang: "Gupa-Abawa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Gupa-Abawa",
  lc: "gpa",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 2115,
  ang: "Ghanaian Pidgin English",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Ghanaian Pidgin English",
  lc: "gpe",
  ld: "ltr",
  alt: ["Kroo Brofo", "Kru English", "Pidgin", "Pidgin English"],
  cc: ["GH"]
}, {
  pk: 2116,
  ang: "Taiap",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Taiap",
  lc: "gpn",
  ld: "ltr",
  alt: ["Gapun"],
  cc: ["PG"]
}, {
  pk: 2117,
  ang: "Ga\u2019anda",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ga'anda",
  lc: "gqa",
  ld: "ltr",
  alt: ["Ga'andu", "Ganda", "Makwar", "Mokar"],
  cc: ["NG"]
}, {
  pk: 7871,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ka\u0253\u01DDnda",
  lc: "gqa-x-kabinda",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2118,
  ang: "Guiqiong",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u8CB4\u74CA",
  lc: "gqi",
  ld: "ltr",
  alt: ["Guichong", "Guiqiang", "Yutong"],
  cc: ["CN"]
}, {
  pk: 2119,
  ang: "Guana",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Guana (Brazil)",
  lc: "gqn",
  ld: "ltr",
  alt: ["Chana", "Chuala", "East Paran\xE1", "Equinao", "Kinihinao", "Kinikinao"],
  cc: ["BR"]
}, {
  pk: 2120,
  ang: "Gor",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Gor",
  lc: "gqr",
  ld: "ltr",
  alt: [],
  cc: ["TD", "IN"]
}, {
  pk: 2121,
  ang: "Qau",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u7A3F\u65B9\u8A00",
  lc: "gqu",
  ld: "ltr",
  alt: ["Aqao", "Gao"],
  cc: ["CN"]
}, {
  pk: 2122,
  ang: "Garasia, Rajput",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Rajput Garasia",
  lc: "gra",
  ld: "ltr",
  alt: ["Dhungri Garasia", "Dungari Garasia", "Dungri Grasia", "Girasia", "Grasia", "Nyar", "Rajput Garasia"],
  cc: ["IN"]
}, {
  pk: 2123,
  ang: "Grebo",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Grebo",
  lc: "grb",
  ld: "ltr",
  alt: [],
  cc: ["LR"]
}, {
  pk: 2124,
  ang: "Guruntum-Mbaaru",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Guruntum-Mbaaru",
  lc: "grd",
  ld: "ltr",
  alt: ["Gurdung", "Guruntum"],
  cc: ["NG"]
}, {
  pk: 2125,
  ang: "Madi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Madi",
  lc: "grg",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2126,
  ang: "Gbiri-Niragu",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Gbiri-Niragu",
  lc: "grh",
  ld: "ltr",
  alt: ["Gure-Kahugu", "Tugbiri", "Kagu", "Niragu (Anirago)", "Kapugu", "Kafugu", "Igbiri", "Gura", "Agbiri", "Gbiri (Agari)"],
  cc: ["NG"]
}, {
  pk: 2127,
  ang: "Ghari",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Ghari",
  lc: "gri",
  ld: "ltr",
  alt: ["Gari", "Sughu", "Tangarare", "West Guadalcanal", "Gae (Nggae)", "Geri (Nggeri)", "Ndi (Vaturanga)", "Qae", "Tandai-Nggaria (Tanaghai)"],
  cc: ["SB"]
}, {
  pk: 2128,
  ang: "Grebo, Southern",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Southern Grebo",
  lc: "grj",
  ld: "ltr",
  alt: ["Glebo (Seaside Grebo)"],
  cc: ["LR"]
}, {
  pk: 2129,
  ang: "Kota Marudu Talantang",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Kota Marudu Talantang",
  lc: "grm",
  ld: "ltr",
  alt: [],
  cc: ["MY"]
}, {
  pk: 2130,
  ang: "Groma",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Groma",
  lc: "gro",
  ld: "ltr",
  alt: ["Tromowa"],
  cc: ["CN"]
}, {
  pk: 2131,
  ang: "Gorovu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gorovu",
  lc: "grq",
  ld: "ltr",
  alt: ["Gorova", "Yerani"],
  cc: ["PG"]
}, {
  pk: 2132,
  ang: "Taznatit",
  lr: "Africa",
  gw: false,
  hc: "DZ",
  ln: "\u062A\u0627\u0632\u0646\u0627\u062A\u064A\u062A",
  lc: "grr",
  ld: "rtl",
  alt: ["Zenatiyya", "Tuwat", "Touat (Tuat)", "South Oran", "Gourara (Gurara)"],
  cc: ["DZ"]
}, {
  pk: 8370,
  ang: "Figuig Berber",
  lr: "Africa",
  gw: false,
  hc: "MA",
  ln: "Figuig Berber",
  lc: "grr-x-figuigber",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2133,
  ang: "Gresi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Gresi",
  lc: "grs",
  ld: "ltr",
  alt: ["Glesi", "Gresik", "Klesi"],
  cc: ["ID"]
}, {
  pk: 2134,
  ang: "Garo",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Garo",
  lc: "grt",
  ld: "ltr",
  alt: ["Garrow", "Mande", "Mandi", "Chibok", "A'chick (A'chik)", "Achik", "Am'beng", "Brak", "A'beng (A'bengya)"],
  cc: ["BD", "IN"]
}, {
  pk: 2135,
  ang: "Kistane",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Kistane",
  lc: "gru",
  ld: "ltr",
  alt: ["North Gurage", "Soddo Gurage", "Soddo (Aymallal)", "Kestane", "Gogot", "Goggot", "Aymellel", "Dobi (Dobbi)"],
  cc: ["ET"]
}, {
  pk: 2136,
  ang: "Grebo, Central",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Central Grebo",
  lc: "grv",
  ld: "ltr",
  alt: ["Borobo"],
  cc: ["LR"]
}, {
  pk: 2137,
  ang: "Gweda",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gweda",
  lc: "grw",
  ld: "ltr",
  alt: ["Garuwahi"],
  cc: ["PG"]
}, {
  pk: 2138,
  ang: "Guriaso",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Guriaso",
  lc: "grx",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2139,
  ang: "Grebo, Barclayville",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Barclayville Grebo",
  lc: "gry",
  ld: "ltr",
  alt: ["Wedebo Grebo", "Kplebo"],
  cc: ["LR"]
}, {
  pk: 2140,
  ang: "Guramalum",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Guramalum",
  lc: "grz",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2141,
  ang: "Ghanaian Sign Language",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Ghanaian Sign Language",
  lc: "gse",
  ld: "ltr",
  alt: [],
  cc: ["GH"]
}, {
  pk: 2142,
  ang: "German Sign Language",
  lr: "Europe",
  gw: false,
  hc: "DE",
  ln: "German Sign Language",
  lc: "gsg",
  ld: "ltr",
  alt: ["Deutsche Geb\xE4rdensprache", "Dgs"],
  cc: ["DE"]
}, {
  pk: 2143,
  ang: "Gusilay",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Gusilay",
  lc: "gsl",
  ld: "ltr",
  alt: ["Gusiilaay", "Gusiilay", "Gusilaay", "Kusiilaay", "Kusilay"],
  cc: ["SN"]
}, {
  pk: 2144,
  ang: "Guatemalan Sign Language",
  lr: "Americas",
  gw: false,
  hc: "GT",
  ln: "Guatemalan Sign Language",
  lc: "gsm",
  ld: "ltr",
  alt: ["Lensegua"],
  cc: ["GT"]
}, {
  pk: 2145,
  ang: "Gusan",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gusan",
  lc: "gsn",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2146,
  ang: "Gbaya, Southwest",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Southwest Gbaya",
  lc: "gso",
  ld: "ltr",
  alt: ["Gbaya Sud-Ouest", "Mboundja (Mbunza)", "Biyanda (Bianda)", "Mbusuku", "Mbondomo (Mbodomo)", "Mbakolo (Yasua)", "Buli (Boli)", "Bosoko (Bossouka)", "Bokare (Bokari)"],
  cc: ["CF"]
}, {
  pk: 2147,
  ang: "Wasembo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wasembo",
  lc: "gsp",
  ld: "ltr",
  alt: ["Biapim", "Gusap", "Yankowan"],
  cc: ["PG"]
}, {
  pk: 2148,
  ang: "Greek Sign Language",
  lr: "Europe",
  gw: false,
  hc: "GR",
  ln: "Greek Sign Language",
  lc: "gss",
  ld: "ltr",
  alt: [],
  cc: ["GR"]
}, {
  pk: 2149,
  ang: "German, Swiss",
  lr: "Europe",
  gw: false,
  hc: "CH",
  ln: "Swiss German",
  lc: "gsw",
  ld: "ltr",
  alt: ["Alemannic", "Alemanic", "Alemannisch", "Schwyzerd\xFCtsch", "Alsacien", "Elsaessisch", "Schwytzertuetsch", "Bern (B\xE4rnd\xFCtsch)", "Graubuenden-Grisons (Valserisch)", "High Alemannisch (Hochalemannisch)", "Appenzell"],
  cc: ["AT", "FR", "DE", "GB", "SE", "CH", "US", "LI"]
}, {
  pk: 2150,
  ang: "Guat\xF3",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Guat\xF3",
  lc: "gta",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 2151,
  ang: "Gujarati",
  lr: "Asia",
  gw: true,
  hc: "IN",
  ln: "\u0A97\u0AC1\u0A9C\u0AB0\u0ABE\u0AA4\u0AC0",
  lc: "gu",
  ld: "ltr",
  alt: ["Gujerathi", "Gujerati", "Gujrathi", "Kathiyawadi (Bhawnagari)", "Standard Gujarati (Mumbai Gujarati)", "Sorathi", "Patidari", "Patani", "Gamadia (Ahmedabad Gamadia)", "Naga", "Surati", "Vadodari", "Holadi", "Gohilwadi", "Eastern Broach Gujarati", "Charotari", "Brathela", "Anawla", "Jhalawadi", "Gramya"],
  cc: ["BD", "FJ", "FR", "KE", "MG", "LK", "GB", "MY", "MZ", "OM", "PK", "RW", "SC", "TZ", "US", "ZM", "ZW", "CA", "MW", "MV", "UG", "IN", "SG", "MM", "BH", "BI"]
}, {
  pk: 2152,
  ang: "Shiki",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Shiki",
  lc: "gua",
  ld: "ltr",
  alt: ["Guba", "Gubawa", "Mashiki"],
  cc: ["NG"]
}, {
  pk: 2153,
  ang: "Guajaj\xE1ra",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Guajaj\xE1ra",
  lc: "gub",
  ld: "ltr",
  alt: ["Guazazzara", "Tenetehar", "Teneteh\xE1ra"],
  cc: ["BR"]
}, {
  pk: 2154,
  ang: "Wayuu",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Wayuu",
  lc: "guc",
  ld: "ltr",
  alt: ["Goajiro", "Guajira", "U\xE1ira", "Waiu", "Wayu", "Way\xFAu", "Wayuunaiki"],
  cc: ["VE", "CO"]
}, {
  pk: 2155,
  ang: "Dida, Yocobou\xE9",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Yocobou\xE9 Dida",
  lc: "gud",
  ld: "ltr",
  alt: ["Lozoua (Gakpa)", "Yocoboue", "Yokoubou\xE9", "Goudou", "Guitry", "Kagou\xE9"],
  cc: ["CI"]
}, {
  pk: 2156,
  ang: "Gurinji",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Gurinji",
  lc: "gue",
  ld: "ltr",
  alt: ["Wurlayi", "Wanyjirra (Wandjirra)"],
  cc: ["AU"]
}, {
  pk: 2157,
  ang: "Gupapuyngu",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Gupapuyngu",
  lc: "guf",
  ld: "ltr",
  alt: ["Gobabingo", "Gubabwingu", "Dhuwala"],
  cc: ["AU"]
}, {
  pk: 2158,
  ang: "Guaran\xED, Paraguayan",
  lr: "Americas",
  gw: false,
  hc: "PY",
  ln: "Paraguayan Guaran\xED",
  lc: "gug",
  ld: "ltr",
  alt: ["Ava\xF1e'e", "Jopar\xE1 (Yopar\xE1)"],
  cc: ["PY"]
}, {
  pk: 2159,
  ang: "Guahibo",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Guahibo",
  lc: "guh",
  ld: "ltr",
  alt: ["Goahibo", "Goahiva", "Guaigua", "Guayba", "Wahibo", "Sicuani", "Sikuani", "Hiwi", "Jiwi", "Amorua (Rio Tomo Guahibo)", "Guahibo (Sikuani)", "Vichade\xF1o"],
  cc: ["VE", "CO"]
}, {
  pk: 2160,
  ang: "Guaran\xED, Eastern Bolivian",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Eastern Bolivian Guaran\xED",
  lc: "gui",
  ld: "ltr",
  alt: ["Eastern Bolivian Guaran\xED", "Chabanco", "Chaguanco", "Chawuncu", "Chiriguano", "Western Argentine Guaran\xED", "Guaran\xED Occidental", "Guasurango", "Ava", "Izocenyo", "Izoce\xF1o (Isocenio)", "Izoce\xF1o (Izocenio)"],
  cc: ["AR", "PY", "BO"]
}, {
  pk: 2161,
  ang: "Gumuz",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Gumuz",
  lc: "guk",
  ld: "ltr",
  alt: ["Bega", "Bega-Tse", "Debatsa", "Debuga", "Dehenda", "Gumis", "Gumuzinya", "Mendeya", "Sigumza", "Shankilligna", "Shankillinya", "Shanqilla", "Deguba", "Mandura", "Metemma", "Sese (Saysay)", "Sirba", "Wenbera", "Gunza", "Yaso", "Dukunza", "Dukuna", "Dugunza", "Disoha (Desua)", "Dibate", "Dakunza (Degoja)", "Agalo", "Guba"],
  cc: ["ET", "SD"]
}, {
  pk: 2162,
  ang: "Sea Island Creole English",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Sea Island Creole English",
  lc: "gul",
  ld: "ltr",
  alt: ["Geechee"],
  cc: ["US"]
}, {
  pk: 2163,
  ang: "Guambiano",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Guambiano",
  lc: "gum",
  ld: "ltr",
  alt: ["Guambia", "Moguex"],
  cc: ["CO"]
}, {
  pk: 2164,
  ang: "Guaran\xED, Mby\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Mby\xE1 Guaran\xED",
  lc: "gun",
  ld: "ltr",
  alt: ["Eastern Argentina Guaran\xED", "Mbua", "Mby\xE1", "Bugre", "Mbi\xE1", "Ka'yngua", "Mbya-apytere"],
  cc: ["BR", "AR", "PY"]
}, {
  pk: 2165,
  ang: "Guayabero",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Guayabero",
  lc: "guo",
  ld: "ltr",
  alt: ["Cunim\xEDa", "Jiw", "M\xEDtua", "M\xEDtus"],
  cc: ["CO"]
}, {
  pk: 2166,
  ang: "Gunwinggu",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Gunwinggu",
  lc: "gup",
  ld: "ltr",
  alt: ["Gunawitji", "Gunwinjgu", "Kuninjku", "Mayali", "Gunei (Kune)"],
  cc: ["AU"]
}, {
  pk: 2167,
  ang: "Ach\xE9",
  lr: "Americas",
  gw: false,
  hc: "PY",
  ln: "Ach\xE9",
  lc: "guq",
  ld: "ltr",
  alt: ["Ache-Guayaki", "Axe", "Guaiaqui", "Guayak\xED", "Guoyagui", "Ache gatu", "\xD1acunday River Ache (\"Ache iroll\xE4\")", "Ache pur\xE4", "Ache wa"],
  cc: ["PY"]
}, {
  pk: 2168,
  ang: "Farefare",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Farefare",
  lc: "gur",
  ld: "ltr",
  alt: ["Gurne", "Gurene", "Gurune", "Nabt (Nabdam)", "Talni (Talene)", "Nankanse", "Gudeni", "Nankani (Naani)", "Namnam", "Nabte", "Nabrug", "Nabnam", "Nabit", "Nabdug", "Nabde", "Gudenne", "Zuadeni", "Gurune (Gudeni)"],
  cc: ["BF", "GH"]
}, {
  pk: 2169,
  ang: "Guinean Sign Language",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Guinean Sign Language",
  lc: "gus",
  ld: "ltr",
  alt: [],
  cc: ["GN"]
}, {
  pk: 2170,
  ang: "Mal\xE9ku Ja\xEDka",
  lr: "Americas",
  gw: false,
  hc: "CR",
  ln: "Mal\xE9ku Ja\xEDka",
  lc: "gut",
  ld: "ltr",
  alt: [],
  cc: ["CR"]
}, {
  pk: 2171,
  ang: "Yanomam\xF6",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "Yanomam\xF6",
  lc: "guu",
  ld: "ltr",
  alt: ["Guaharibo", "Shaathari", "Shamatri", "Yanomae", "Yanomami", "Cobari Kobali", "Cobariwa", "Guajaribo", "Shamatari", "Yanomame", "Western Yanomami (Padamo-Orinoco)", "Eastern Yanomami (Parima)"],
  cc: ["BR", "VE"]
}, {
  pk: 2172,
  ang: "Gey",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Gey",
  lc: "guv",
  ld: "ltr",
  alt: ["Gewe", "Gueve"],
  cc: ["CM"]
}, {
  pk: 2173,
  ang: "Gun",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Gun",
  lc: "guw",
  ld: "ltr",
  alt: ["Alada-Gbe", "Egun", "Gu", "Gugbe", "Gun-Alada", "Gungbe", "Gun-Gbe", "Ajra", "Alada (Alada-Gbe)", "Gun (Egun)", "Seto", "Toli"],
  cc: ["BJ", "GA", "NG"]
}, {
  pk: 2174,
  ang: "Gourmanch\xE9ma",
  lr: "Africa",
  gw: false,
  hc: "NE",
  ln: "Gourmanch\xE9ma",
  lc: "gux",
  ld: "ltr",
  alt: ["Goulmacema", "Gourma", "Gourmantche", "Gulimancema", "Gulmancema", "Gurma", "Migulimancema", "Goulmancema", "Goulimancema", "Central Gourmanchema"],
  cc: ["BJ", "BF", "GH", "NE", "NG", "TG"]
}, {
  pk: 7756,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Gourmantche",
  lc: "gux-x-gourmantche",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2175,
  ang: "Ekegusii",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Gusii",
  lc: "guz",
  ld: "ltr",
  alt: ["Guzii", "Kosova", "Kisii"],
  cc: ["KE", "TZ"]
}, {
  pk: 2176,
  ang: "Manx",
  lr: "Europe",
  gw: false,
  hc: "IM",
  ln: "Gaelg, Gailck",
  lc: "gv",
  ld: "ltr",
  alt: ["Gaelg", "Gailck", "Manx Gaelic"],
  cc: ["IM"]
}, {
  pk: 2177,
  ang: "Guana",
  lr: "Americas",
  gw: false,
  hc: "PY",
  ln: "Guana (Paraguay)",
  lc: "gva",
  ld: "ltr",
  alt: ["Cashquiha", "Kaskih\xE1", "Echoaldi (Chararana)", "Echonoana", "Layana (Niguecactemigi)"],
  cc: ["PY"]
}, {
  pk: 2178,
  ang: "Guanano",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Guanano",
  lc: "gvc",
  ld: "ltr",
  alt: ["Anana", "K\xF3tedia", "K\xF3tirya", "Uanana", "Wan\xE2na", "Wanano", "Kotiria", "Uanano", "Wanana"],
  cc: ["BR", "CO"]
}, {
  pk: 2179,
  ang: "Duwet",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Duwet",
  lc: "gve",
  ld: "ltr",
  alt: ["Guwet", "Guwot", "Waing"],
  cc: ["PG"]
}, {
  pk: 2180,
  ang: "Golin",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Golin",
  lc: "gvf",
  ld: "ltr",
  alt: ["Gollum", "Gumine", "Kia (Kiari)"],
  cc: ["PG"]
}, {
  pk: 2181,
  ang: "Guaj\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Guaj\xE1",
  lc: "gvj",
  ld: "ltr",
  alt: ["Aw\xE1", "Aw\xE1 Guaj\xE1", "Ayaya", "Guaxare", "Wazaizara"],
  cc: ["BR"]
}, {
  pk: 2182,
  ang: "Gulay",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Gulay",
  lc: "gvl",
  ld: "ltr",
  alt: ["Goulai", "Goulaye", "Goulei", "Gulai", "Gulei", "Pen (Peni)"],
  cc: ["TD"]
}, {
  pk: 2183,
  ang: "Gurmana",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Gurmana",
  lc: "gvm",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 2184,
  ang: "Kuku-Yalanji",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Kuku-Yalanji",
  lc: "gvn",
  ld: "ltr",
  alt: ["Guguyalanji", "Koko-Yalanji", "Kuku-Yalangi", "Kuku-Biraji", "Kuku-Nyungkul"],
  cc: ["AU"]
}, {
  pk: 2185,
  ang: "Gavi\xE3o do Jiparan\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Gavi\xE3o Do Jiparan\xE1",
  lc: "gvo",
  ld: "ltr",
  alt: ["Dig\xFCt", "Gavi\xE3o do Rond\xF4nia", "Ikolen", "Ik\xF5ro", "Panginey", "Zor\xF3 (Cabe\xE7a Seca)"],
  cc: ["BR"]
}, {
  pk: 2186,
  ang: "Gavi\xE3o, Par\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Par\xE1 Gavi\xE3o",
  lc: "gvp",
  ld: "ltr",
  alt: ["Gavi\xE3o do M\xE3e Maria", "Parakat\xEAj\xEA", "Perkat\xEAj\xEA", "Pukobj\xEA"],
  cc: ["BR"]
}, {
  pk: 2187,
  ang: "Gurung, Western",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Western Gurung",
  lc: "gvr",
  ld: "ltr",
  alt: ["Khas Kura", "Gurung Kura", "Gurung", "Tamu Kyi", "Northwestern Gurung (Kaski Gurung)", "Southern Gurung (Syangja Gurung)"],
  cc: ["BT", "NP"]
}, {
  pk: 2188,
  ang: "Gumawana",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gumawana",
  lc: "gvs",
  ld: "ltr",
  alt: ["Domdom", "Gumasi", "Gumasila", "Kotoita", "Nubogeta"],
  cc: ["PG"]
}, {
  pk: 2189,
  ang: "Mbato",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Mbato",
  lc: "gwa",
  ld: "ltr",
  alt: ["Goaa", "Gwa", "M'bato", "Mbatto", "Mgbato", "N-Batto", "Ogwia", "Potu"],
  cc: ["CI"]
}, {
  pk: 2190,
  ang: "Gwa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Gwa",
  lc: "gwb",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 2191,
  ang: "Kalami",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u06AF\u0627\u0648\u0631\u06CC \u0632\u0628\u0627\u0646",
  lc: "gwc",
  ld: "ltr",
  alt: ["Bashgharik", "Bashkarik", "Baskarik", "Dir Kohistani", "Diri", "Dirwali", "Gaawro", "Garwa", "Garwi", "Gawri", "Gowri", "Kalami Kohistani", "Kohistana", "Kohistani", "Lamuti (Lamti)", "Rajkoti (Patrak)"],
  cc: ["AF", "PK"]
}, {
  pk: 2192,
  ang: "Gawwada",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Gawwada",
  lc: "gwd",
  ld: "ltr",
  alt: ["Gauwada", "Gawata", "Kawwada", "Kawwad'a", "Harso (Worase)", "Gorose (Gorrose)", "Tihinte", "Gollango (Kollanko)", "Dihina (Tihina)", "Gergere (K'ark'arte)", "Korrose"],
  cc: ["ET"]
}, {
  pk: 2193,
  ang: "Gweno",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Gweno",
  lc: "gwe",
  ld: "ltr",
  alt: ["Kigweno"],
  cc: ["TZ"]
}, {
  pk: 2194,
  ang: "Gowro",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u06AF\u0648\u0648\u0631\u0648",
  lc: "gwf",
  ld: "ltr",
  alt: ["Gabar Khel", "Gabaro"],
  cc: ["PK"]
}, {
  pk: 2195,
  ang: "Moo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Moo",
  lc: "gwg",
  ld: "ltr",
  alt: ["Gomu", "Gwom", "Gwomo", "Gwomu", "Ngwaa M\xF3\xF2", "Y\xE1\xE1 M\xF2\xF2"],
  cc: ["NG"]
}, {
  pk: 2196,
  ang: "Gwich\u2019in",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Gwich\u02BCin",
  lc: "gwi",
  ld: "ltr",
  alt: ["Kutchin", "Loucheux", "Tukudh", "Western Canada Gwich'in (Loucheux)", "Fort Yukon Gwich'in", "Takudh"],
  cc: ["US", "CA"]
}, {
  pk: 2197,
  ang: "|Gwi",
  lr: "Africa",
  gw: false,
  hc: "BW",
  ln: "|Gwi",
  lc: "gwj",
  ld: "ltr",
  alt: ["Dcui", "G!wikwe", "G|wikhwe", "Gcwi"],
  cc: ["BW"]
}, {
  pk: 2198,
  ang: "Gwandara",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Gwandara",
  lc: "gwn",
  ld: "ltr",
  alt: ["Kwandara", "Gwandara Southern (Kyan Kyar)", "Gwandara Koro", "Gwandara Karashi", "Gwandara Eastern (Toni)", "Gwandara Gitata"],
  cc: ["NG"]
}, {
  pk: 2199,
  ang: "Gwere",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Gwere",
  lc: "gwr",
  ld: "ltr",
  alt: ["Olugwere"],
  cc: ["UG"]
}, {
  pk: 2200,
  ang: "Gawar-Bati",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Gawar-Bati",
  lc: "gwt",
  ld: "ltr",
  alt: ["Arandui", "Gowari", "Narisati", "Narsati", "Satre", "Gowar-Bati"],
  cc: ["AF"]
}, {
  pk: 2201,
  ang: "Kwini",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Kwini",
  lc: "gww",
  ld: "ltr",
  alt: ["Cuini", "Gunin", "Gwiini", "Kunan", "Wunambal"],
  cc: ["AU"]
}, {
  pk: 2202,
  ang: "Gua",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Gua",
  lc: "gwx",
  ld: "ltr",
  alt: ["Anum-Boso", "Guan", "Gwa", "Anu (Anum)"],
  cc: ["GH"]
}, {
  pk: 2203,
  ang: "W\xE8 Southern",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "W\xE8 Southern",
  lc: "gxx",
  ld: "ltr",
  alt: ["Central Gu\xE9r\xE9", "Gere", "Gu\xE9r\xE9", "Zaa (Zaha)", "Niabo", "Beu (Zarabaon)", "Gboo (Gbobo)", "Neao (Neabo)"],
  cc: ["CI"]
}, {
  pk: 2204,
  ang: "Gbaya, Northwest",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Northwest Gbaya",
  lc: "gya",
  ld: "ltr",
  alt: ["Gbaya", "Gbaya Nord-Ouest", "Baya", "Northwest Gbaya", "Gbaya de Bouar", "Gbaya Kara (Boar)", "Gbeya (Gbea)", "Lai (Lay)", "Ya\xE1yuwee (Kalla)", "Yaiwe"],
  cc: ["CM", "CF", "NG", "SD", "CG"]
}, {
  pk: 2205,
  ang: "Garus",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Garus",
  lc: "gyb",
  ld: "ltr",
  alt: ["Ate", "Em", "Kurupi"],
  cc: ["PG"]
}, {
  pk: 2206,
  ang: "Kayardild",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Kayardild",
  lc: "gyd",
  ld: "ltr",
  alt: ["Gajadilt", "Gajardild", "Gayadilt", "Gayardild", "Kaiadilt", "Malununda"],
  cc: ["AU"]
}, {
  pk: 2207,
  ang: "Gyem",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Gyem",
  lc: "gye",
  ld: "ltr",
  alt: ["Gema", "Gemawa", "Gyemawa"],
  cc: ["NG"]
}, {
  pk: 2208,
  ang: "Gbayi",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Gbayi",
  lc: "gyg",
  ld: "ltr",
  alt: ["Kpasiya"],
  cc: ["CF"]
}, {
  pk: 2209,
  ang: "Gyele",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Gyele",
  lc: "gyi",
  ld: "ltr",
  alt: ["Babinga", "Bagiele", "Bagyele", "Bajele", "Bajeli", "Bako", "Bakola", "Bakuele", "Bekoe", "Bogyel", "Bogyeli", "Bondjiel", "Giele", "Gieli", "Gyeli", "Likoya", "Bagyeli"],
  cc: ["CM"]
}, {
  pk: 2210,
  ang: "Gayil",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Gayil",
  lc: "gyl",
  ld: "ltr",
  alt: ["Gayi", "Gayl", "Gelila", "Northern Ari"],
  cc: ["ET"]
}, {
  pk: 2211,
  ang: "Ng\xE4bere",
  lr: "Americas",
  gw: false,
  hc: "PA",
  ln: "Ng\xE4bere",
  lc: "gym",
  ld: "ltr",
  alt: ["Guaym\xED", "Chiriqui", "Eastern Guaym\xED (Chiriqu\xED)", "Tol\xE9"],
  cc: ["PA", "CR"]
}, {
  pk: 2212,
  ang: "Guyanese Creole English",
  lr: "Americas",
  gw: false,
  hc: "GY",
  ln: "Guyanese Creole English",
  lc: "gyn",
  ld: "ltr",
  alt: ["Creolese", "Guyanese Creole"],
  cc: ["GF", "GY", "US", "SR"]
}, {
  pk: 2213,
  ang: "Guarayu",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Guarayu",
  lc: "gyr",
  ld: "ltr",
  alt: ["Guarayo"],
  cc: ["BO"]
}, {
  pk: 2214,
  ang: "Ganza",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Ganza",
  lc: "gza",
  ld: "ltr",
  alt: ["Gwami", "Koma", "Koma-Ganza"],
  cc: ["ET", "SD"]
}, {
  pk: 2215,
  ang: "Gazi",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Gazi",
  lc: "gzi",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 2216,
  ang: "Gane",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Gane",
  lc: "gzn",
  ld: "ltr",
  alt: ["Gani", "Giman"],
  cc: ["ID"]
}, {
  pk: 2217,
  ang: "Hausa",
  lr: "Africa",
  gw: true,
  hc: "NG",
  ln: "(Hausa) \u0647\u064E\u0648\u064F\u0633\u064E",
  lc: "ha",
  ld: "ltr",
  alt: ["Haoussa", "Hawsa", "Hausawa", "Haussa", "Abakwariga", "Habe", "Kado", "Mgbakpa"],
  cc: ["DZ", "BJ", "CM", "BF", "CF", "GQ", "ET", "GA", "GH", "NE", "NG", "SD", "TG", "TD", "CG", "CA", "GN"]
}, {
  pk: 2218,
  ang: "Han",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Han",
  lc: "haa",
  ld: "ltr",
  alt: ["Dawson", "Han-Kutchin", "Moosehide"],
  cc: ["US", "CA"]
}, {
  pk: 2219,
  ang: "Hanoi Sign Language",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Ng\xF4n ng\u1EEF k\xFD hi\u1EC7u H\xE0 N\u1ED9i",
  lc: "hab",
  ld: "ltr",
  alt: [],
  cc: ["VN"]
}, {
  pk: 2220,
  ang: "Gurani",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u06AF\u06C6\u0631\u0627\u0646\u06CC",
  lc: "hac",
  ld: "ltr",
  alt: ["Gorani", "Hawramani", "Hewrami", "Macho", "Macho-Zwani", "Awromani", "Howrami", "Kakai", "Zengana", "Shabaki", "Kandula", "Gawhara", "Kakai (Macho)", "Hawraman i Luhon", "Bajelani", "Hawrami", "Gurani (Gorani)"],
  cc: ["IR"]
}, {
  pk: 2221,
  ang: "Hatam",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Hatam",
  lc: "had",
  ld: "ltr",
  alt: ["Atam", "Borai", "Hattam", "Mansim", "Moi", "Moi (Moire)"],
  cc: ["ID"]
}, {
  pk: 2222,
  ang: "Oromo, Eastern",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Eastern Oromo",
  lc: "hae",
  ld: "ltr",
  alt: ["Harar", "Harer", "Ittu", "Kwottu", "Qottu", "Qotu Oromo", "Quottu", "Qwottu"],
  cc: ["ET", "CA"]
}, {
  pk: 2223,
  ang: "Haiphong Sign Language",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Ng\xF4n ng\u1EEF k\xFD hi\u1EC7u H\u1EA3i Ph\xF2ng",
  lc: "haf",
  ld: "ltr",
  alt: [],
  cc: ["VN"]
}, {
  pk: 2224,
  ang: "Hanga",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Hanga",
  lc: "hag",
  ld: "ltr",
  alt: ["Anga"],
  cc: ["GH"]
}, {
  pk: 2225,
  ang: "Hahon",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Hahon",
  lc: "hah",
  ld: "ltr",
  alt: ["Hanon"],
  cc: ["PG"]
}, {
  pk: 2226,
  ang: "Haida",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Haida",
  lc: "hai",
  ld: "ltr",
  alt: [],
  cc: ["CA"]
}, {
  pk: 2227,
  ang: "Hajong",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Hajong",
  lc: "haj",
  ld: "ltr",
  alt: ["Hajang", "Haijong", "Hazong", "Banai", "Dalu"],
  cc: ["BD", "IN"]
}, {
  pk: 2228,
  ang: "Chinese, Hakka",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5BA2\u5BB6\u8A9E",
  lc: "hak",
  ld: "ltr",
  alt: ["Hokka", "Ke", "Kechia", "Kejia", "Majiahua", "Tu Guangdonghua", "Xinminhua", "Kehia", "Kek", "Khek", "Ning-Long (Longnan)", "Yue-Tai (Meixian)", "Tingzhou (Min-Ke)", "Taiwan Kejia", "Shixien", "Shigen", "Sanhsien (Shi Xien)", "Pingdong", "Huayang", "Hoiluk", "Hoilluk", "Hailu (Hi-Lu)", "Changting", "Raoping"],
  cc: ["CN", "GF", "GY", "PA", "MU", "PE", "CR", "JM", "MY", "US", "PF", "CA", "SG", "SR"]
}, {
  pk: 2229,
  ang: "Halang",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Halang",
  lc: "hal",
  ld: "ltr",
  alt: ["Koyong", "Salang"],
  cc: ["LA", "VN"]
}, {
  pk: 2230,
  ang: "Hewa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Hewa",
  lc: "ham",
  ld: "ltr",
  alt: ["Sisimin"],
  cc: ["PG"]
}, {
  pk: 2231,
  ang: "Hangaza",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Hangaza",
  lc: "han",
  ld: "ltr",
  alt: ["Kihangaza"],
  cc: ["TZ"]
}, {
  pk: 2232,
  ang: "Hak\xF6",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Haku",
  lc: "hao",
  ld: "ltr",
  alt: ["Haku"],
  cc: ["PG"]
}, {
  pk: 2233,
  ang: "Hupla",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Hupla",
  lc: "hap",
  ld: "ltr",
  alt: ["Soba"],
  cc: ["ID"]
}, {
  pk: 2234,
  ang: "Ha",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Ha",
  lc: "haq",
  ld: "ltr",
  alt: ["Giha", "Ikiha"],
  cc: ["TZ"]
}, {
  pk: 2235,
  ang: "Harari",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Harari",
  lc: "har",
  ld: "ltr",
  alt: ["Adarinnya", "Adere", "Aderinya", "Gey Sinan", "Hararri"],
  cc: ["ET"]
}, {
  pk: 2236,
  ang: "Haisla",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Haisla",
  lc: "has",
  ld: "ltr",
  alt: ["Kitimat (Kitamat)"],
  cc: ["CA"]
}, {
  pk: 2237,
  ang: "Havu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Havu",
  lc: "hav",
  ld: "ltr",
  alt: ["Haavu"],
  cc: ["CD"]
}, {
  pk: 7895,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kihavu Idjui",
  lc: "hav-x-kihavuidjui",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2238,
  ang: "Hawaiian",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Hawaiian",
  lc: "haw",
  ld: "ltr",
  alt: ["Olelo Hawai'i", "Olelo Hawai'i Makuahine"],
  cc: ["US"]
}, {
  pk: 2239,
  ang: "Haida, Southern",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Southern Haida",
  lc: "hax",
  ld: "ltr",
  alt: ["Skidegate"],
  cc: ["CA"]
}, {
  pk: 2240,
  ang: "Haya",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Haya",
  lc: "hay",
  ld: "ltr",
  alt: ["Ekihaya", "Kihaya", "Luhaya", "Ruhaya", "Ziba", "Ganda-Kiaka", "Kyamutwara"],
  cc: ["TZ", "UG"]
}, {
  pk: 2241,
  ang: "Hazaragi",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "\u0622\u0632\u0631\u06AF\u06CC",
  lc: "haz",
  ld: "ltr",
  alt: ["Azargi", "Hazara", "Hezareh", "Hezare'i"],
  cc: ["AF", "PK", "AU"]
}, {
  pk: 2242,
  ang: "Hamba",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Hamba",
  lc: "hba",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 2243,
  ang: "Nya Huba",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Huba",
  lc: "hbb",
  ld: "ltr",
  alt: ["Chobba"],
  cc: ["NG"]
}, {
  pk: 2244,
  ang: "Heiban",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Heiban",
  lc: "hbn",
  ld: "ltr",
  alt: ["Abul", "Ebang"],
  cc: ["SD"]
}, {
  pk: 2245,
  ang: "Hebrew, Ancient",
  lr: "Asia",
  gw: false,
  hc: "IL",
  ln: "Ancient Hebrew",
  lc: "hbo",
  ld: "ltr",
  alt: ["Old Hebrew"],
  cc: ["IL"]
}, {
  pk: 5591,
  ang: "",
  lr: "Europe",
  gw: false,
  hc: "RS",
  ln: "Serbo-Croatian",
  lc: "hbs",
  ld: "ltr",
  alt: [],
  cc: ["RS"]
}, {
  pk: 2246,
  ang: "Habun",
  lr: "Asia",
  gw: false,
  hc: "TL",
  ln: "Habu",
  lc: "hbu",
  ld: "ltr",
  alt: [],
  cc: ["TL"]
}, {
  pk: 2247,
  ang: "Andaman Creole Hindi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Andaman Creole Hindi",
  lc: "hca",
  ld: "ltr",
  alt: ["Andaman Hindi"],
  cc: ["IN"]
}, {
  pk: 2248,
  ang: "Huichol",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Huichol",
  lc: "hch",
  ld: "ltr",
  alt: ["Vixaritari Vaniuqui", "Vizaritari Vaniuki", "Huichol del norte", "Western Huichol", "San Sebasti\xE1n-Santa Catarina (Eastern Huichol)", "San Andr\xE9s Cohamiata (Huichol del oeste)", "Huichol del este", "Huichol del sur"],
  cc: ["MX"]
}, {
  pk: 7944,
  ang: "",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Huicholes del este",
  lc: "hch-x-huicholeste",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2249,
  ang: "Haida, Northern",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Northern Haida",
  lc: "hdn",
  ld: "ltr",
  alt: ["Masset"],
  cc: ["US", "CA"]
}, {
  pk: 2250,
  ang: "Honduras Sign Language",
  lr: "Americas",
  gw: false,
  hc: "HN",
  ln: "Honduras Sign Language",
  lc: "hds",
  ld: "ltr",
  alt: ["Honduran Sign Language", "Lengua de Se\xF1as Hondure\xF1as", "LESHO"],
  cc: ["HN"]
}, {
  pk: 2251,
  ang: "Hadiyya",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Hadiyya",
  lc: "hdy",
  ld: "ltr",
  alt: ["Adea", "Adiya", "Adiye", "Hadia", "Hadiya"],
  cc: ["ET"]
}, {
  pk: 2252,
  ang: "Hebrew (modern)",
  lr: "Asia",
  gw: false,
  hc: "IL",
  ln: "\u05E2\u05D1\u05E8\u05D9\u05EA",
  lc: "he",
  ld: "rtl",
  alt: ["Israeli", "Ivrit", "General Israeli", "Oriental Hebrew (Arabized Hebrew)", "Standard Hebrew (Europeanized Hebrew)", "Yemenite Hebrew"],
  cc: ["ET", "IL", "PA", "GB", "US", "YE", "CA"]
}, {
  pk: 2253,
  ang: "Miao, Northern Qiandong",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5317\u90E8\u571F\u8BED",
  lc: "hea",
  ld: "ltr",
  alt: ["Black Miao", "Central Miao", "Chientung Miao", "East Guizhou Miao", "Gha Ne", "Gha Ne Dlai", "Heh Miao", "Hei Miao", "Hmu", "Northern East Guizhou Miao", "Northern Hmu"],
  cc: ["CN"]
}, {
  pk: 2254,
  ang: "Herd\xE9",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Herd\xE9",
  lc: "hed",
  ld: "ltr",
  alt: ["He'd\xE9", "Ka'do Herd\xE9", "Zime", "Zime of Pala"],
  cc: ["TD"]
}, {
  pk: 2255,
  ang: "Helong",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Helong",
  lc: "heg",
  ld: "ltr",
  alt: ["Helon", "Kupang", "Semau", "Funai (Land Helong)", "Helong Darat (Bolok)", "Helong Pulau (Island Helong)"],
  cc: ["ID"]
}, {
  pk: 2256,
  ang: "Hehe",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Hehe",
  lc: "heh",
  ld: "ltr",
  alt: ["Kihehe"],
  cc: ["TZ"]
}, {
  pk: 2257,
  ang: "Heiltsuk",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Heiltsuk",
  lc: "hei",
  ld: "ltr",
  alt: ["Bella Bella (Northern Heiltsuk)", "Oowekyala"],
  cc: ["CA"]
}, {
  pk: 2258,
  ang: "Hemba",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Hemba",
  lc: "hem",
  ld: "ltr",
  alt: ["Eastern Luba", "Emba", "Kiemba", "Kihemba", "Luba-Hemba"],
  cc: ["CD"]
}, {
  pk: 2259,
  ang: "Hai||om",
  lr: "Africa",
  gw: false,
  hc: "NA",
  ln: "Hai||om",
  lc: "hgm",
  ld: "ltr",
  alt: ["Saan", "San", "Hain||um (Hei||om)", "Kedi (Kedde)", "Keddi", "Heikum", "Heikom", "Heikom Bushman"],
  cc: ["NA"]
}, {
  pk: 2260,
  ang: "Haigwai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Haigwai",
  lc: "hgw",
  ld: "ltr",
  alt: ["Garaghwaghi"],
  cc: ["PG"]
}, {
  pk: 2261,
  ang: "Hoia Hoia",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Hoia Hoia",
  lc: "hhi",
  ld: "ltr",
  alt: ["Hoiahoia", "Ukusi-Koparamio Hoyahoya"],
  cc: ["PG"]
}, {
  pk: 2262,
  ang: "Kerak",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Kerak",
  lc: "hhr",
  ld: "ltr",
  alt: ["Her", "Keerak", "Keeraku"],
  cc: ["SN"]
}, {
  pk: 2263,
  ang: "Hoyahoya",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Hoyahoya",
  lc: "hhy",
  ld: "ltr",
  alt: ["Hoiahoia", "Hoya Hoya", "Matakaia Hoyahoya"],
  cc: ["PG"]
}, {
  pk: 2264,
  ang: "Hindi",
  lr: "Asia",
  gw: true,
  hc: "IN",
  ln: "\u0939\u093F\u0928\u094D\u0926\u0940, \u0939\u093F\u0902\u0926\u0940",
  lc: "hi",
  ld: "ltr",
  alt: ["Khadi Boli", "Khari Boli", "Dakhini", "Hindi-Urdu", "Khariboli"],
  cc: ["BN", "BR", "BT", "AR", "FR", "DE", "KR", "PA", "ES", "GB", "MY", "OM", "NP", "NZ", "ZA", "US", "AU", "CA", "IN", "SG", "MM"]
}, {
  pk: 2265,
  ang: "Lamang",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Lamang",
  lc: "hia",
  ld: "ltr",
  alt: ["Gbuhwe", "Laamang", "Waha", "Central Laamang"],
  cc: ["CM", "NG"]
}, {
  pk: 2266,
  ang: "Hidatsa",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Hidatsa",
  lc: "hid",
  ld: "ltr",
  alt: ["Hinatsa", "Hiraca", "Minitari"],
  cc: ["US"]
}, {
  pk: 2267,
  ang: "Hindi, Fiji",
  lr: "Pacific",
  gw: false,
  hc: "FJ",
  ln: "Fiji Hindi",
  lc: "hif",
  ld: "ltr",
  alt: ["Fiji Hindustani", "Fijian Hindi", "Fijian Hindustani"],
  cc: ["FJ"]
}, {
  pk: 2268,
  ang: "Kamwe",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kamwe",
  lc: "hig",
  ld: "ltr",
  alt: ["Higgi", "Higi", "Hiji", "Vacamwe", "Dakwa (Bazza)", "Humsi", "Modi"],
  cc: ["CM", "NG"]
}, {
  pk: 2269,
  ang: "Pamosu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Pamosu",
  lc: "hih",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2270,
  ang: "Hinduri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Hinduri",
  lc: "hii",
  ld: "ltr",
  alt: ["Handuri"],
  cc: ["IN"]
}, {
  pk: 2271,
  ang: "Hijuk",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Hijuk",
  lc: "hij",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 2272,
  ang: "Seit-Kaitetu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Seit-Kaitetu",
  lc: "hik",
  ld: "ltr",
  alt: ["Hila-Kaitetu", "Seit (Seith)"],
  cc: ["ID"]
}, {
  pk: 2273,
  ang: "Hiligaynon",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Hiligaynon",
  lc: "hil",
  ld: "ltr",
  alt: ["Hiligainon", "Illogo", "Ilonggo", "Kari"],
  cc: ["PH"]
}, {
  pk: 2274,
  ang: "Tsoa",
  lr: "Africa",
  gw: false,
  hc: "BW",
  ln: "Tsoa",
  lc: "hio",
  ld: "ltr",
  alt: ["Chuwau", "Chware", "G||abake", "Gabake-Ntshori", "Haitshuari", "Hiochuwau", "Hiotshuwau", "Kwe", "Kwe-Etshori Kwee", "Kwe-Tshori", "Masarwa", "Sarwa", "Sesarwa", "Tati", "Tati Bushman", "Tshuwau", "Tshwa", "Haitshuwau", "Hiechware"],
  cc: ["ZW", "BW"]
}, {
  pk: 2275,
  ang: "Himarim\xE3",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Himarim\xE3",
  lc: "hir",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 2276,
  ang: "Hittite",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Hittite",
  lc: "hit",
  ld: "ltr",
  alt: [],
  cc: ["TR"]
}, {
  pk: 2277,
  ang: "Hiw",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Hiw",
  lc: "hiw",
  ld: "ltr",
  alt: ["Hiu"],
  cc: ["VU"]
}, {
  pk: 2278,
  ang: "Hixkary\xE1na",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Hixkary\xE1na",
  lc: "hix",
  ld: "ltr",
  alt: ["Chawiyana", "Faruaru", "Hichkaryana", "Hishkaryana", "Hixkariana", "Hyxkaryana", "Kumiyana", "Parucutu", "Parukoto-Charuma", "Sherewyana", "Sokaka", "Wabui", "Xereu", "Xerewyana"],
  cc: ["BR"]
}, {
  pk: 7569,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bhartali Khadiboli",
  lc: "hi-x-bhartali",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7515,
  ang: "Hindi - Dominant Culture Variant",
  lr: "Asia",
  gw: true,
  hc: "IN",
  ln: "\u0939\u093F\u0928\u094D\u0926\u0940, \u0939\u093F\u0902\u0926\u0940 - Dominant Culture Variant",
  lc: "hi-x-dcv",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 7507,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Dehathi Hindi",
  lc: "hi-x-dehathi",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 7648,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Pawani",
  lc: "hi-x-pawani",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7574,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Waradhi",
  lc: "hi-x-waradhi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2279,
  ang: "Haji",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Haji",
  lc: "hji",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 2280,
  ang: "Kahe",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Kahe",
  lc: "hka",
  ld: "ltr",
  alt: ["Kikahe"],
  cc: ["TZ"]
}, {
  pk: 2281,
  ang: "Hunde",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Hunde",
  lc: "hke",
  ld: "ltr",
  alt: ["Kobi", "Rukobi"],
  cc: ["CD"]
}, {
  pk: 8453,
  ang: "Bakobo",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bakobo",
  lc: "hke-x-bakobo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2282,
  ang: "Hunjara-Kaina Ke",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Hunjara-Kaina Ke",
  lc: "hkk",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 8459,
  ang: "Mel",
  lr: "Asia",
  gw: false,
  hc: "KH",
  ln: "Mel",
  lc: "hkn-x-mel",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8302,
  ang: "Mel-Khaonh",
  lr: "Asia",
  gw: false,
  hc: "KH",
  ln: "Mel-Khaonh",
  lc: "hkn-x-melkhaonh",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2283,
  ang: "Hong Kong Sign Language",
  lr: "Asia",
  gw: false,
  hc: "HK",
  ln: "Hong Kong Sign Language",
  lc: "hks",
  ld: "ltr",
  alt: ["HKSL"],
  cc: ["HK"]
}, {
  pk: 2284,
  ang: "Halia",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Halia",
  lc: "hla",
  ld: "ltr",
  alt: ["Tasi", "Touloun (Tulon)", "Tulun"],
  cc: ["PG"]
}, {
  pk: 2285,
  ang: "Halbi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Halbi",
  lc: "hlb",
  ld: "ltr",
  alt: ["Halabi", "Halba", "Halvas", "Halvi", "Mahari", "Kunbi", "Mahari (Mahara)", "Govari of Balaghat", "Bhunjia", "Muri (Muria)", "Kawari"],
  cc: ["IN"]
}, {
  pk: 2286,
  ang: "Halang Doan",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Halang Doan",
  lc: "hld",
  ld: "ltr",
  alt: ["Doan", "Duan", "Halang Duan"],
  cc: ["LA", "VN"]
}, {
  pk: 2287,
  ang: "Hlersu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u52D2\u82CF",
  lc: "hle",
  ld: "ltr",
  alt: ["Lesu", "Sansu", "Shansu"],
  cc: ["CN"]
}, {
  pk: 2288,
  ang: "Chin, Matu",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Matu Chin",
  lc: "hlt",
  ld: "ltr",
  alt: ["Matupi", "Langle-Tamtlaih", "Vuitu", "Valang", "Thui Phum", "Thlangpang (Changpyang)", "Siing", "Phaneng", "Ngala (Batu)", "Haltu", "Doem (Ngatu)", "Ciing (Langle-Tamtlaih)", "Ngaleng"],
  cc: ["MM"]
}, {
  pk: 2289,
  ang: "Hieroglyphic Luwian",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Hieroglyphic Luwian",
  lc: "hlu",
  ld: "ltr",
  alt: [],
  cc: ["TR"]
}, {
  pk: 2290,
  ang: "Miao, Southern Mashan",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u9EBB\u5C71",
  lc: "hma",
  ld: "ltr",
  alt: ["Southern Mashan Hmong"],
  cc: ["CN"]
}, {
  pk: 2291,
  ang: "Songhay, Humburi Senni",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Humburi Senni Songhay",
  lc: "hmb",
  ld: "ltr",
  alt: ["Central Songai", "Humburi Senni Songhay", "Songai", "Songay", "Songay Senni", "Songhai", "Songoi", "Songoy", "Sonrai", "Sonrhai", "Hombori Songhay", "Songhoy", "Marans\xE9", "Marens\xE9 (Korobor\xE9)"],
  cc: ["BF", "ML"]
}, {
  pk: 2292,
  ang: "Miao, Central Huishui",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Central Huishui Hmong",
  lc: "hmc",
  ld: "ltr",
  alt: ["Central Huishui Hmong"],
  cc: ["CN"]
}, {
  pk: 2293,
  ang: "Miao, Large Flowery",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5927\u82B1\u82D7",
  lc: "hmd",
  ld: "ltr",
  alt: ["A-Hmao", "Big Flowery Miao", "Da Hua Bei Miao", "Da Hua Miao", "Diandongbei Miao", "Flowery Miao", "Great Flowery Tribe", "Hua Miao", "Hwa Miao", "Northeastern Dian Miao", "Northeastern Yunnan Miao", "Ta Hwa Miao"],
  cc: ["CN"]
}, {
  pk: 2294,
  ang: "Miao, Eastern Huishui",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Eastern Huishui Hmong",
  lc: "hme",
  ld: "ltr",
  alt: ["Eastern Huishui Hmong"],
  cc: ["CN"]
}, {
  pk: 2295,
  ang: "Hmong Don",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "M\xF4ng Don",
  lc: "hmf",
  ld: "ltr",
  alt: [],
  cc: ["VN"]
}, {
  pk: 2296,
  ang: "Miao, Southwestern Guiyang",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Southwestern Guiyang Hmong",
  lc: "hmg",
  ld: "ltr",
  alt: ["Southwestern Guiyang Hmong"],
  cc: ["CN"]
}, {
  pk: 2297,
  ang: "Miao, Southwestern Huishui",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Southwestern Huishui Hmong",
  lc: "hmh",
  ld: "ltr",
  alt: ["Miao", "Southwestern Huishui Hmong"],
  cc: ["CN"]
}, {
  pk: 2298,
  ang: "Miao, Northern Huishui",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Northern Huishui Hmong",
  lc: "hmi",
  ld: "ltr",
  alt: ["Northern Huishui Hmong"],
  cc: ["CN"]
}, {
  pk: 2299,
  ang: "Ge",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5BB6\u8BED",
  lc: "hmj",
  ld: "ltr",
  alt: ["Chonganjiang Miao", "Ge Jia", "Gedang", "Gedong", "Gedou", "Gedou Miao", "Gedoudiu", "Gedu", "Gejia", "Ge-Mong", "Gho-mhon", "Keh Deo"],
  cc: ["CN"]
}, {
  pk: 2300,
  ang: "Maek",
  lr: "Asia",
  gw: false,
  hc: "KP",
  ln: "Maek",
  lc: "hmk",
  ld: "ltr",
  alt: [],
  cc: ["KP"]
}, {
  pk: 2301,
  ang: "Miao, Luopohe",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u7F57\u6CCA\u6CB3",
  lc: "hml",
  ld: "ltr",
  alt: ["Lobohe Miao", "Luobo River Miao", "Luobohe Hmong", "Luopohe Hmong", "Xi", "Xijia Miao", "Ximahe Miao"],
  cc: ["CN"]
}, {
  pk: 2302,
  ang: "Miao, Central Mashan",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4E2D\u90E8\u571F\u8BED",
  lc: "hmm",
  ld: "ltr",
  alt: ["Central Mashan Hmong"],
  cc: ["CN"]
}, {
  pk: 2303,
  ang: "Hmong",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u56CA\u62EC\u4EE3\u7801",
  lc: "hmn",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 2304,
  ang: "Miao, Northern Mashan",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u9EBB\u5C71",
  lc: "hmp",
  ld: "ltr",
  alt: ["Northern Mashan Hmong"],
  cc: ["CN"]
}, {
  pk: 2305,
  ang: "Miao, Eastern Qiandong",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4E1C\u90E8\u571F\u8BED",
  lc: "hmq",
  ld: "ltr",
  alt: ["Black Miao", "Central Miao", "Chientung Miao", "Eastern East-Guizhou Miao", "Eastern Hmu", "Hei Miao", "Hmu"],
  cc: ["CN"]
}, {
  pk: 2306,
  ang: "Hmar",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Hmar",
  lc: "hmr",
  ld: "ltr",
  alt: ["Hamar", "Hmari", "Mhar"],
  cc: ["IN"]
}, {
  pk: 2307,
  ang: "Miao, Southern Qiandong",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5357\u90E8\u571F\u8BED",
  lc: "hms",
  ld: "ltr",
  alt: ["Black Miao", "Central Miao", "Chientung Miao", "Hei Miao", "Hmu", "Southern East-Guizhou Miao", "Southern Hmu"],
  cc: ["CN"]
}, {
  pk: 2308,
  ang: "Hamtai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Hamtai",
  lc: "hmt",
  ld: "ltr",
  alt: ["Hamday", "Kamea", "Kapau", "Watut", "Kukukuku"],
  cc: ["PG"]
}, {
  pk: 2309,
  ang: "Hamap",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Hamap",
  lc: "hmu",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 2310,
  ang: "Hmong D\xF4",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "M\xF4ng \u0110\u1ECF",
  lc: "hmv",
  ld: "ltr",
  alt: [],
  cc: ["VN"]
}, {
  pk: 7759,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Do",
  lc: "hmv-x-do",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2311,
  ang: "Miao, Western Mashan",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u897F\u90E8\u571F\u8BED",
  lc: "hmw",
  ld: "ltr",
  alt: ["Western Mashan Hmong"],
  cc: ["CN"]
}, {
  pk: 2312,
  ang: "Miao, Southern Guiyang",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Southern Guiyang Hmong",
  lc: "hmy",
  ld: "ltr",
  alt: ["Southern Guiyang Hmong"],
  cc: ["CN"]
}, {
  pk: 2313,
  ang: "Sinicized Miao",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6C49\u82D7\u65B9\u8A00",
  lc: "hmz",
  ld: "ltr",
  alt: ["Biantou Miao", "Changshu Miao", "Curved Comb Miao", "Flat Head Miao", "Han Miao", "Hmong Nzi", "Hmong Sa", "Hmong Sua", "Long Comb Miao", "Lopsided Comb Miao", "Mushu Maio", "Shuixi Miao", "Waishu Miao", "Water Miao", "West of the Water Miao", "Wooden Comb Miao"],
  cc: ["CN"]
}, {
  pk: 2314,
  ang: "Mina",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mina (Cameroon)",
  lc: "hna",
  ld: "ltr",
  alt: ["Jingjing (Dzumdzum)"],
  cc: ["CM"]
}, {
  pk: 2315,
  ang: "Hindko, Southern",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u06C1\u0646\u062F\u06A9\u0648",
  lc: "hnd",
  ld: "ltr",
  alt: ["Attock Hindko (Attock-Haripur Hindko)", "Kohat Hindko (Kohati)", "Peshawar Hindko (Peshawari)"],
  cc: ["PK"]
}, {
  pk: 2316,
  ang: "Chhattisgarhi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Chhattisgarhi",
  lc: "hne",
  ld: "ltr",
  alt: ["Khaltahi", "Laria", "Bhumia", "Gowro", "Bega", "Baigani (Baiga)"],
  cc: ["IN"]
}, {
  pk: 2317,
  ang: "||Ani",
  lr: "Africa",
  gw: false,
  hc: "BW",
  ln: "||Ani",
  lc: "hnh",
  ld: "ltr",
  alt: ["|Anda", "Hand\xE1", "Hand\xE1dam", "Handa-Khwe", "Handakwe-Dam", "Ts'exa", "Ts'\xE9xa"],
  cc: ["BW"]
}, {
  pk: 2318,
  ang: "Hani",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u54C8\u5C3C\u8BED",
  lc: "hni",
  ld: "ltr",
  alt: ["Hanhi", "Hani Proper", "Haw", "Ha Nhi", "H\xE0nh\xEC", "U N\xED", "Uni", "X\xE1 U N\xED", "Xauni"],
  cc: ["CN", "LA"]
}, {
  pk: 7980,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Bu4Du1 Hani",
  lc: "hni-x-Bu4Du1 Hani",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7552,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Bu4du4 Hani",
  lc: "hni-x-budu",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7640,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Longpu Hani",
  lc: "hni-x-longpuha",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2319,
  ang: "Hmong Njua",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Hmong Njua",
  lc: "hnj",
  ld: "ltr",
  alt: ["Blue Hmong", "Blue Meo", "Ching Miao", "Green Hmong", "Green Meo", "Hmong Leng", "Hmong Nzhua", "Hmoob Leeg", "Lu Miao", "Meo Dam", "Meo Lai", "Mong Leng", "Mong Ntsua", "Qing Miao", "Tak Miao", "Miao Tsi"],
  cc: ["GF", "LA", "TH", "US", "MM"]
}, {
  pk: 2320,
  ang: "Hanunoo",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Hanunoo",
  lc: "hnn",
  ld: "ltr",
  alt: ["Hanonoo", "Sorsogonon", "Gubatnon (Gubat)"],
  cc: ["PH"]
}, {
  pk: 2321,
  ang: "Hindko, Northern",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "Northern Hindko",
  lc: "hno",
  ld: "ltr",
  alt: ["Hazara Hindko", "Hindki", "Kagani", "Kaghani"],
  cc: ["PK"]
}, {
  pk: 2322,
  ang: "Hindustani, Sarnami",
  lr: "Americas",
  gw: false,
  hc: "SR",
  ln: "Caribbean Hindustani",
  lc: "hns",
  ld: "ltr",
  alt: ["Aili Gaili", "Sarnami Hindi", "Sarnami Hindustani (Aili Gaili)"],
  cc: ["TT", "GY", "NL", "SX", "SR"]
}, {
  pk: 2323,
  ang: "Hung",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Hung",
  lc: "hnu",
  ld: "ltr",
  alt: ["Cu\xF3i", "K'katiam-Pong-Houk", "Tay Pong", "Xa La Vang", "Poong", "Toum (Tum)", "Pong 2", "Toum Phong", "Pong 1", "Pong (Khong Kheng)", "Phong (Pong)"],
  cc: ["LA"]
}, {
  pk: 2324,
  ang: "Hiri Motu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Hiri Motu",
  lc: "ho",
  ld: "ltr",
  alt: ["Hiri", "Pidgin Motu", "Police Motu"],
  cc: ["PG"]
}, {
  pk: 2325,
  ang: "Hoava",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Hoava",
  lc: "hoa",
  ld: "ltr",
  alt: [],
  cc: ["SB"]
}, {
  pk: 2326,
  ang: "Mari",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mari (Madang Province)",
  lc: "hob",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2327,
  ang: "Ho",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Ho",
  lc: "hoc",
  ld: "ltr",
  alt: ["Bihar Ho", "Lanka Kol"],
  cc: ["BD", "IN"]
}, {
  pk: 2328,
  ang: "Horom",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Horom",
  lc: "hoe",
  ld: "ltr",
  alt: ["Kaleri"],
  cc: ["NG"]
}, {
  pk: 2329,
  ang: "Hoby\xF3t",
  lr: "Asia",
  gw: false,
  hc: "OM",
  ln: "\u0644\u063A\u0629 \u0647\u0648\u0628\u064A\u0648\u062A",
  lc: "hoh",
  ld: "ltr",
  alt: ["Hewby\xF3t", "Hobi", "Kalam Rifi"],
  cc: ["OM", "YE"]
}, {
  pk: 2330,
  ang: "Holikachuk",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Holikachuk",
  lc: "hoi",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 2331,
  ang: "Haroti",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Hadothi",
  lc: "hoj",
  ld: "ltr",
  alt: ["Hadauti", "Hadothi", "Hadoti"],
  cc: ["IN"]
}, {
  pk: 2332,
  ang: "Holu",
  lr: "Africa",
  gw: false,
  hc: "AO",
  ln: "Holu",
  lc: "hol",
  ld: "ltr",
  alt: ["Holo", "Kiholu"],
  cc: ["AO"]
}, {
  pk: 2333,
  ang: "Holoholo",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Holoholo",
  lc: "hoo",
  ld: "ltr",
  alt: ["Guha", "Horohoro", "Kalanga", "Kiholoholo"],
  cc: ["TZ", "CD"]
}, {
  pk: 2334,
  ang: "Hopi",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Hopi",
  lc: "hop",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 2335,
  ang: "Ho Chi Minh City Sign Language",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Ng\xF4n ng\u1EEF k\xFD hi\u1EC7u Th\xE0nh ph\u1ED1 H\u1ED3 Ch\xED Minh",
  lc: "hos",
  ld: "ltr",
  alt: [],
  cc: ["VN"]
}, {
  pk: 2336,
  ang: "Hote",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Hote",
  lc: "hot",
  ld: "ltr",
  alt: ["Ho'tei", "Mal\xEA", "Malei", "Misim (Musim)", "Ombalei"],
  cc: ["PG"]
}, {
  pk: 2337,
  ang: "Hovongan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Hovongan",
  lc: "hov",
  ld: "ltr",
  alt: ["Punan Bungan"],
  cc: ["ID"]
}, {
  pk: 8043,
  ang: "Dayak Punan Uheng",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Punan Uheng",
  lc: "hov-x-punanuheng",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2338,
  ang: "Honi",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Honi",
  lc: "how",
  ld: "ltr",
  alt: ["Haoni", "Ho", "Ouni", "Uni", "Woni"],
  cc: ["CN"]
}, {
  pk: 2339,
  ang: "Holiya",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Holiya",
  lc: "hoy",
  ld: "ltr",
  alt: ["Golari-Kannada", "Holar", "Holari", "Hole", "Holian", "Holu"],
  cc: ["IN"]
}, {
  pk: 2340,
  ang: "Hozo",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Hozo",
  lc: "hoz",
  ld: "ltr",
  alt: ["Begi-Mao"],
  cc: ["ET"]
}, {
  pk: 2341,
  ang: "Hpon",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Hpon",
  lc: "hpo",
  ld: "ltr",
  alt: ["Hp\xF6n", "Megyaw", "Phon", "Ph\xF6n", "Phun", "Samong", "North Hpon", "South Hpon"],
  cc: ["MM"]
}, {
  pk: 2342,
  ang: "Hawaii Sign Language",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Hawai'i Sign Language (HSL)",
  lc: "hps",
  ld: "ltr",
  alt: ["Pidgin Sign Language"],
  cc: ["US"]
}, {
  pk: 2343,
  ang: "Croatian",
  lr: "Europe",
  gw: false,
  hc: "HR",
  ln: "hrvatski jezik",
  lc: "hr",
  ld: "ltr",
  alt: ["Hrvatski", "Molise Croatian", "Shtokavski (Ijekavski)", "Serbian"],
  cc: ["AT", "BA", "HR", "FR", "DE", "MK", "NL", "NZ", "SE", "US", "AU", "CA", "DK"]
}, {
  pk: 2344,
  ang: "Hrangkhol",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Hrangkhol",
  lc: "hra",
  ld: "ltr",
  alt: ["Hrangkol", "Rangkhol"],
  cc: ["IN", "MM"]
}, {
  pk: 2345,
  ang: "Niwer Mil",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Niwer Mil",
  lc: "hrc",
  ld: "ltr",
  alt: ["Tanga", "Tangga"],
  cc: ["PG"]
}, {
  pk: 2346,
  ang: "Hre",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Ti\u1EBFng Hr\xEA",
  lc: "hre",
  ld: "ltr",
  alt: ["Cham-Re", "Chom", "Davach", "Davak", "Moi", "Moi Da Vach", "Moi Luy", "Tachom", "Creq (Kare)", "Kre", "Rabah (Tava)"],
  cc: ["VN"]
}, {
  pk: 2347,
  ang: "Haruku",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Haruku",
  lc: "hrk",
  ld: "ltr",
  alt: ["Kabauw"],
  cc: ["ID"]
}, {
  pk: 2348,
  ang: "Miao, Horned",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u89D2\u82D7\u65B9\u8A00",
  lc: "hrm",
  ld: "ltr",
  alt: ["A-Hmo", "Bai Miao", "Changjiao Miao", "Forest Miao", "Hmong Khua Shua Ndrang", "Hmong Ndong", "Hmong Ndou", "Hmong Sou", "Jiao Miao", "Jiaojiao Miao", "Kha-Nzi", "Longhorn Miao", "Qing Miao", "White Miao"],
  cc: ["CN"]
}, {
  pk: 2349,
  ang: "Haroi",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Haroi",
  lc: "hro",
  ld: "ltr",
  alt: ["Aroi", "Bahnar Cham", "Hoi", "Hroi", "Hroy", "Hrway"],
  cc: ["VN"]
}, {
  pk: 2350,
  ang: "H\xE9rtevin",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "H\xE9rtevin",
  lc: "hrt",
  ld: "ltr",
  alt: ["H\xE9rtevin Proper (Arton)"],
  cc: ["TR"]
}, {
  pk: 2351,
  ang: "Hruso",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Hruso",
  lc: "hru",
  ld: "ltr",
  alt: ["Angka", "Angkae", "Gusso", "Hrusso", "Tenae", "Levai (Bangru)"],
  cc: ["IN"]
}, {
  pk: 7603,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Aka",
  lc: "hru-x-aka",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2352,
  ang: "Warwar Feni",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Warwar Feni",
  lc: "hrw",
  ld: "ltr",
  alt: ["Anir", "Feni", "Tangga"],
  cc: ["PG"]
}, {
  pk: 2353,
  ang: "Hunsrik",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Hunsrik",
  lc: "hrx",
  ld: "ltr",
  alt: ["Hunsriker", "Rio Grand Hunsriker"],
  cc: ["BR"]
}, {
  pk: 2354,
  ang: "Harzani",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u0647\u0631\u0632\u0646\u062F\u06CC\u060C \u0647\u0631\u0632\u0646\u06CC",
  lc: "hrz",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 2355,
  ang: "Sorbian, Upper",
  lr: "Europe",
  gw: false,
  hc: "DE",
  ln: "Upper Sorbian",
  lc: "hsb",
  ld: "ltr",
  alt: ["Haut Sorabe", "Hornjoserbski", "Hornoserbski", "Obersorbisch", "Upper Lusatian", "Wendish"],
  cc: ["DE"]
}, {
  pk: 2356,
  ang: "Hungarian Sign Language",
  lr: "Europe",
  gw: false,
  hc: "HU",
  ln: "Hungarian Sign Language",
  lc: "hsh",
  ld: "ltr",
  alt: ["Magyar Jelnyelv", "Magyarorsz\xE1gi jelnyelv"],
  cc: ["HU"]
}, {
  pk: 2357,
  ang: "Hausa Sign Language",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Hausa Sign Language",
  lc: "hsl",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 2358,
  ang: "Chinese, Xiang",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6E58",
  lc: "hsn",
  ld: "ltr",
  alt: ["Hsiang", "Hunan", "Hunanese", "Xiang", "Yiyang", "Changsha", "Jishou", "Jixu", "Loudi", "Shaoyang", "Xupu"],
  cc: ["CN"]
}, {
  pk: 8444,
  ang: "Miao Liupanshui",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Miao Liupanshui",
  lc: "hsn-x-liupanshui",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2359,
  ang: "Harsusi",
  lr: "Asia",
  gw: false,
  hc: "OM",
  ln: "\u0644\u063A\u0629 \u062D\u0631\u0633\u0648\u0633\u064A\u0629",
  lc: "hss",
  ld: "ltr",
  alt: ["Harsi 'Aforit", "Hersyet"],
  cc: ["OM"]
}, {
  pk: 2360,
  ang: "Haitian, Haitian Creole",
  lr: "Americas",
  gw: false,
  hc: "HT",
  ln: "Krey\xF2l ayisyen",
  lc: "ht",
  ld: "ltr",
  alt: ["Creole", "Haitian Creole"],
  cc: ["CU", "DM", "GF", "HT", "JM", "US", "CA", "GP", "DO", "MQ"]
}, {
  pk: 2361,
  ang: "Huitoto, Minica",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Minica Huitoto",
  lc: "hto",
  ld: "ltr",
  alt: ["Meneca", "Minica"],
  cc: ["CO"]
}, {
  pk: 2362,
  ang: "Hadza",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Hadza",
  lc: "hts",
  ld: "ltr",
  alt: ["Hadzabi", "Hadzapi", "Hatsa", "Kangeju", "Wakindiga", "Tindiga"],
  cc: ["TZ"]
}, {
  pk: 2363,
  ang: "Hitu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Hitu",
  lc: "htu",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 2364,
  ang: "Middle Hittite",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Middle Hittite",
  lc: "htx",
  ld: "ltr",
  alt: [],
  cc: ["TR"]
}, {
  pk: 2365,
  ang: "Hungarian",
  lr: "Europe",
  gw: false,
  hc: "HU",
  ln: "magyar",
  lc: "hu",
  ld: "ltr",
  alt: ["Magyar", "Southern Transdanubian", "Central Transdanubian", "Western Transdanubian", "Tisza\u2013K\xF6r\xF6s", "Sz\xE9kely", "Pal\xF3c", "North-eastern Hungarian", "Mezos\xE9gi", "Cs\xE1ng\xF3", "Southern Great Plains"],
  cc: ["AT", "HR", "FR", "HU", "IL", "GB", "RS", "NZ", "RO", "SK", "SE", "CH", "SI", "US", "AU", "CA", "UA"]
}, {
  pk: 2366,
  ang: "Huambisa",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Huambisa",
  lc: "hub",
  ld: "ltr",
  alt: ["Huambiza", "Wambisa"],
  cc: ["PE"]
}, {
  pk: 2367,
  ang: "\u2021Hua",
  lr: "Africa",
  gw: false,
  hc: "BW",
  ln: "\u01C2Hua",
  lc: "huc",
  ld: "ltr",
  alt: ["|H\xFB", "|Hua", "\u2021Hoa", "\u2021Ho\xE3", "\u2021Hoan", "\u2021Hua-Owani", "\u2021Hua"],
  cc: ["BW"]
}, {
  pk: 2368,
  ang: "Huaulu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Huaulu",
  lc: "hud",
  ld: "ltr",
  alt: ["Alakamat", "Bahasa Asli"],
  cc: ["ID"]
}, {
  pk: 2369,
  ang: "Huave, San Francisco del Mar",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "San Francisco Del Mar Huave",
  lc: "hue",
  ld: "ltr",
  alt: ["Huave del Este"],
  cc: ["MX"]
}, {
  pk: 2370,
  ang: "Humene",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Humene",
  lc: "huf",
  ld: "ltr",
  alt: ["Manukolu", "Lagume (Lakume)"],
  cc: ["PG"]
}, {
  pk: 2371,
  ang: "Huachipaeri",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Huachipaeri",
  lc: "hug",
  ld: "ltr",
  alt: ["Wacipaire", "Mashco", "Toyeri (Toyoeri)", "Tuyuneri"],
  cc: ["PE"]
}, {
  pk: 2372,
  ang: "Huilliche",
  lr: "Americas",
  gw: false,
  hc: "CL",
  ln: "Huilliche",
  lc: "huh",
  ld: "ltr",
  alt: ["Huiliche", "Veliche"],
  cc: ["CL"]
}, {
  pk: 2373,
  ang: "Huli",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Huli",
  lc: "hui",
  ld: "ltr",
  alt: ["Huli-Hulidana", "Huri"],
  cc: ["PG"]
}, {
  pk: 2374,
  ang: "Miao, Northern Guiyang",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Northern Guiyang Hmong",
  lc: "huj",
  ld: "ltr",
  alt: ["Northern Guiyang Hmong"],
  cc: ["CN"]
}, {
  pk: 2375,
  ang: "Hula",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Hula",
  lc: "hul",
  ld: "ltr",
  alt: ["Vula'a"],
  cc: ["PG"]
}, {
  pk: 2376,
  ang: "Hungana",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Hungana",
  lc: "hum",
  ld: "ltr",
  alt: ["Huana", "Hungaan", "Hunganna"],
  cc: ["CD"]
}, {
  pk: 2377,
  ang: "Hu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6237\u8BED",
  lc: "huo",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 2378,
  ang: "Hupa",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Hupa",
  lc: "hup",
  ld: "ltr",
  alt: ["Whilkut"],
  cc: ["US"]
}, {
  pk: 2379,
  ang: "Tsat",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u56DE\u8F89\u8BED",
  lc: "huq",
  ld: "ltr",
  alt: ["Hainan Cham", "Hui", "Huihui", "Sanya Hui", "Utsat", "Utset"],
  cc: ["CN"]
}, {
  pk: 2380,
  ang: "Halkomelem",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Halkomelem",
  lc: "hur",
  ld: "ltr",
  alt: ["Holkomelem", "Downriver", "Island", "Upriver"],
  cc: ["CA"]
}, {
  pk: 2381,
  ang: "Huastec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Huastec",
  lc: "hus",
  ld: "ltr",
  alt: ["Huasteco de Tantoyuca", "Huasteco de Veracruz", "San Luis Potosi Huastec (Potosino Huastec)", "Southeastern Huastec (Huasteco de San Francisco Chontla)"],
  cc: ["MX"]
}, {
  pk: 2382,
  ang: "Humla",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Humla",
  lc: "hut",
  ld: "ltr",
  alt: ["Dangali", "Humli Khyampa", "Phoke", "Humla Bhotia", "Nyinba", "Upper Humla", "La Yakba", "Limi"],
  cc: ["NP"]
}, {
  pk: 2383,
  ang: "Huitoto, Murui",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Murui Huitoto",
  lc: "huu",
  ld: "ltr",
  alt: ["Bue", "Witoto", "Mica"],
  cc: ["PE"]
}, {
  pk: 2384,
  ang: "Huave, San Mateo del Mar",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "San Mateo Del Mar Huave",
  lc: "huv",
  ld: "ltr",
  alt: ["Huave del Oeste"],
  cc: ["MX"]
}, {
  pk: 2385,
  ang: "Huitoto, N\xFCpode",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "N\xFCpode Huitoto",
  lc: "hux",
  ld: "ltr",
  alt: ["Muinane Huitoto", "Nipode Witoto"],
  cc: ["PE"]
}, {
  pk: 2386,
  ang: "Hulaul\xE1",
  lr: "Asia",
  gw: false,
  hc: "IL",
  ln: "\u05D9\u05D4\u05D5\u05D3\u05D9\u05D5\u05EA\u05D0",
  lc: "huy",
  ld: "ltr",
  alt: ["Aramit", "Galiglu", "Hula Hula", "Jabali", "Judeo-Aramaic", "Kurdit", "Lishana Axni", "Lishana Noshan"],
  cc: ["IR", "IL"]
}, {
  pk: 2387,
  ang: "Hunzib",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0413\u0443\u043D\u0437\u0438\u0431\u0441\u043A\u0438\u0439",
  lc: "huz",
  ld: "ltr",
  alt: ["Enzeb", "Gunzib", "Khunzal", "Khunzaly", "Xunzal"],
  cc: ["RU"]
}, {
  pk: 2388,
  ang: "Haitian Vodoun Culture Language",
  lr: "Americas",
  gw: false,
  hc: "HT",
  ln: "Haitian Vodoun Culture Language",
  lc: "hvc",
  ld: "ltr",
  alt: ["Langaj", "Langay"],
  cc: ["HT"]
}, {
  pk: 2389,
  ang: "Huave, San Dionisio del Mar",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "San Dionisio Del Mar Huave",
  lc: "hve",
  ld: "ltr",
  alt: ["Huave del Este"],
  cc: ["MX"]
}, {
  pk: 2390,
  ang: "Haveke",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Haveke",
  lc: "hvk",
  ld: "ltr",
  alt: ["Aveke"],
  cc: ["NC"]
}, {
  pk: 2391,
  ang: "Hawu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sabu",
  lc: "hvn",
  ld: "ltr",
  alt: ["Havunese", "Savu", "Savunese", "Sawu", "Sawunese", "Timu (Dimu)", "Mesara (Mehara)", "Raijua (Raidjua)", "Seba (Heba)"],
  cc: ["ID"]
}, {
  pk: 2392,
  ang: "Huave, Santa Mar\xEDa del Mar",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Santa Mar\xEDa Del Mar Huave",
  lc: "hvv",
  ld: "ltr",
  alt: ["Huave del Oeste"],
  cc: ["MX"]
}, {
  pk: 2393,
  ang: "Wan\xE9",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Wan\xE9",
  lc: "hwa",
  ld: "ltr",
  alt: ["Hwane", "Ngwan\xE9"],
  cc: ["CI"]
}, {
  pk: 2394,
  ang: "Hawai\u2019i Pidgin",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Hawai'i Creole English",
  lc: "hwc",
  ld: "ltr",
  alt: ["Hawai'i Creole", "Hawai'i Creole English", "HCE", "Pidgin"],
  cc: ["US"]
}, {
  pk: 2395,
  ang: "Hwana",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Hwana",
  lc: "hwo",
  ld: "ltr",
  alt: ["Fiterya", "Hona", "Hwona"],
  cc: ["NG"]
}, {
  pk: 2396,
  ang: "Armenian",
  lr: "Asia",
  gw: false,
  hc: "AM",
  ln: "\u0540\u0561\u0575\u0565\u0580\u0565\u0576",
  lc: "hy",
  ld: "ltr",
  alt: ["Armjanski Yazyk", "Ena", "Ermeni Dili", "Ermenice", "Somkhuri", "Armjanski", "Haieren", "Armani", "Er\xE2mani", "Somekhuri", "Armanski", "Erevan (Eriwan)", "Konstantinopel", "Khoi-Salmst (Khvoy)", "Kari", "Jolf\xE2 (Dzhulfa)", "Hamshen (Hamschen)", "Ewdokia (Tokat)", "Crimea (Krim)", "Dschulfa", "Ararat", "Constantinople (Istanbul)", "Astrakhan (Astrachan)", "Astrakh\xE2n", "Artvin (Artwin)", "Dzhulfa (Dschugha)"],
  cc: ["AM", "AZ", "BE", "GR", "AR", "FR", "DE", "IR", "IQ", "KZ", "LB", "GB", "TJ", "NL", "SY", "TR", "US", "AU", "CA", "GE", "IT", "KG", "TM", "UZ", "BG"]
}, {
  pk: 2397,
  ang: "Hya",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Hya",
  lc: "hya",
  ld: "ltr",
  alt: ["Ghye", "Za", "Hwate", "Manta", "Mukta", "Munta"],
  cc: ["CM"]
}, {
  pk: 2398,
  ang: "Herero",
  lr: "Africa",
  gw: false,
  hc: "NA",
  ln: "Otjiherero",
  lc: "hz",
  ld: "ltr",
  alt: ["Ochiherero", "Otjiherero"],
  cc: ["AO", "BW", "NA"]
}, {
  pk: 2399,
  ang: "Interlingua",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Interlingua",
  lc: "ia",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 2400,
  ang: "Iaai",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Iaai",
  lc: "iai",
  ld: "ltr",
  alt: ["Hwen Iaai", "Yai"],
  cc: ["NC"]
}, {
  pk: 2401,
  ang: "Iatmul",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Iatmul",
  lc: "ian",
  ld: "ltr",
  alt: ["Big Sepik", "Gepma Kwudi", "Gepma Kwundi", "Ngepma Kwundi"],
  cc: ["PG"]
}, {
  pk: 2402,
  ang: "Purari",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Purari",
  lc: "iar",
  ld: "ltr",
  alt: ["Evorra", "Maipua", "Namau", "Iai (Namau)"],
  cc: ["PG"]
}, {
  pk: 2403,
  ang: "Iban",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Iban",
  lc: "iba",
  ld: "ltr",
  alt: ["Sea Dayak", "Sekapat", "Sigarau", "Seklau", "Sebaru'", "Ketungau (Air Tabun)", "Sesat", "Kantu'", "Demam", "Banjur", "Maung"],
  cc: ["BN", "ID", "MY"]
}, {
  pk: 8286,
  ang: "Dayak Sangku",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Sangku",
  lc: "iba-x-",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8281,
  ang: "Dayak Barai Penyelompat",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Barai Penyelompat",
  lc: "iba-x-baraipenye",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7959,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Banjur",
  lc: "iba-x-dayakbanjur",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8095,
  ang: "Dayak Bugau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Bugau",
  lc: "iba-x-dayakbugau",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8182,
  ang: "Dayak Bunut",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Bunut",
  lc: "iba-x-dayakbunut",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7981,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Desa",
  lc: "iba-x-dayakdesa",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8015,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Nanga",
  lc: "iba-x-dayaknanga",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8022,
  ang: "Dayak Sebaruk",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Sebaruk",
  lc: "iba-x-dayaksebaruk",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8023,
  ang: "Dayak Sekapat",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Sekapat",
  lc: "iba-x-dayaksekapat",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7975,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Ulu",
  lc: "iba-x-dayakulu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7779,
  ang: "Dayak Desa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Desa",
  lc: "iba-x-desa",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8098,
  ang: "Desa Tempunak",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Desa Tempunak",
  lc: "iba-x-desatempunak",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8294,
  ang: "Dayak Entebang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Entebang",
  lc: "iba-x-entebang",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8026,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Iban Empran",
  lc: "iba-x-ibanempran",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8002,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Kancing'k",
  lc: "iba-x-kancing'k",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8282,
  ang: "Dayak Ketior",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Ketior",
  lc: "iba-x-ketior",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7850,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Ketungau",
  lc: "iba-x-ketungau",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7887,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ketungau Sesaek",
  lc: "iba-x-ketungausesat",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7971,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Randuk",
  lc: "iba-x-randuk",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8284,
  ang: "Dayak Salako",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Salako",
  lc: "iba-x-salako",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8295,
  ang: "Dayak Sangku",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Sangku",
  lc: "iba-x-sangku",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8292,
  ang: "Dayak Sekajang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Sekajang",
  lc: "iba-x-sekajang",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8287,
  ang: "Dayak Selawe",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Selawe",
  lc: "iba-x-selawe",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8288,
  ang: "Dayak Selibong",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Selibong",
  lc: "iba-x-selibong",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8285,
  ang: "Dayak Sepatoi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Sepatoi",
  lc: "iba-x-sepatoi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8283,
  ang: "Dayak Siberuang Sejiram",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Siberuang Sejiram",
  lc: "iba-x-siberuang",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8290,
  ang: "Dayak Sikung",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Sikung",
  lc: "iba-x-sikung",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8289,
  ang: "Dayak Silat Muntak",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Silat Muntak",
  lc: "iba-x-silatmunta",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8291,
  ang: "Dayak Sontas",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Sontas",
  lc: "iba-x-sontas",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7848,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Sungkung",
  lc: "iba-x-sungkung",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8293,
  ang: "Dayak Tadietn",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Tadietn",
  lc: "iba-x-tadietn",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2404,
  ang: "Ibibio",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ibibio",
  lc: "ibb",
  ld: "ltr",
  alt: [],
  cc: ["CM", "GQ", "GH", "NG"]
}, {
  pk: 2405,
  ang: "Iwaidja",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Iwaidja",
  lc: "ibd",
  ld: "ltr",
  alt: ["Eiwaja", "Ibadjo", "Iwaidji", "Iwaydja", "Jiwadja", "Karadjee", "Limba"],
  cc: ["AU"]
}, {
  pk: 2406,
  ang: "Akpes",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Akpes",
  lc: "ibe",
  ld: "ltr",
  alt: ["Ibaram-Efifa", "Esuku (Echuku)", "Akunnu (Akpes)"],
  cc: ["NG"]
}, {
  pk: 2407,
  ang: "Ibanag",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Ibanag",
  lc: "ibg",
  ld: "ltr",
  alt: ["Ybanag"],
  cc: ["PH"]
}, {
  pk: 2408,
  ang: "Ibaloi",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Ibaloi",
  lc: "ibl",
  ld: "ltr",
  alt: ["Benguet-Igorot", "Ibadoy", "Ibaloy", "Igodor", "Inibaloi", "Nabaloi"],
  cc: ["PH"]
}, {
  pk: 2409,
  ang: "Agoi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Agoi",
  lc: "ibm",
  ld: "ltr",
  alt: ["Ibami", "Ro Bambami", "Wa Bambani", "Wagoi"],
  cc: ["NG"]
}, {
  pk: 2410,
  ang: "Ibino",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ibino",
  lc: "ibn",
  ld: "ltr",
  alt: ["Ibeno", "Ibuno"],
  cc: ["NG"]
}, {
  pk: 2411,
  ang: "Ibuoro",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ibuoro",
  lc: "ibr",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 2412,
  ang: "Ibu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ibu",
  lc: "ibu",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 2413,
  ang: "Ibani",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ibani",
  lc: "iby",
  ld: "ltr",
  alt: ["Ubani"],
  cc: ["NG"]
}, {
  pk: 2414,
  ang: "Ede Ica",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Ede Ica",
  lc: "ica",
  ld: "ltr",
  alt: ["Ilodji (Ife)"],
  cc: ["BJ"]
}, {
  pk: 2415,
  ang: "Etkywan",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Etkywan",
  lc: "ich",
  ld: "ltr",
  alt: ["Etekwe", "Icen", "Ichen", "Kentu", "Kyanton", "Kyato", "Nyidu"],
  cc: ["NG"]
}, {
  pk: 2416,
  ang: "Icelandic Sign Language",
  lr: "Europe",
  gw: false,
  hc: "IS",
  ln: "Icelandic Sign Language",
  lc: "icl",
  ld: "ltr",
  alt: [],
  cc: ["IS"]
}, {
  pk: 2417,
  ang: "Islander Creole English",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Islander Creole English",
  lc: "icr",
  ld: "ltr",
  alt: ["Bende", "San Andr\xE9s Creole"],
  cc: ["CO"]
}, {
  pk: 2418,
  ang: "Indonesian",
  lr: "Asia",
  gw: true,
  hc: "ID",
  ln: "Bahasa Indonesia",
  lc: "id",
  ld: "ltr",
  alt: [],
  cc: ["CN", "ID", "MY", "NL", "US", "AU", "CA", "SG"]
}, {
  pk: 2419,
  ang: "Luidakho-Luisukha-Lutirichi",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Idakho-Isukha-Tiriki",
  lc: "ida",
  ld: "ltr",
  alt: ["Idakho-Isukha-Tiriki", "Idakho (Idaxo)", "Isukha (Isuxa)", "Itakho"],
  cc: ["KE"]
}, {
  pk: 7938,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Isukha",
  lc: "ida-x-isukha",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8171,
  ang: "Tiriki",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Tiriki",
  lc: "ida-x-tiriki",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2420,
  ang: "Indo-Portuguese",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Indo-Portuguese",
  lc: "idb",
  ld: "ltr",
  alt: ["Cannanore", "Cochin (Kochi)", "Diu"],
  cc: ["LK", "IN"]
}, {
  pk: 2421,
  ang: "Ajiya",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Idon",
  lc: "idc",
  ld: "ltr",
  alt: ["Ajuli", "Idong", "Misiwa"],
  cc: ["NG"]
}, {
  pk: 2422,
  ang: "Ede Idaca",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Ede Idaca",
  lc: "idd",
  ld: "ltr",
  alt: ["Idaaca", "Idaasa", "Idaatcha", "Id\xE1\xECts\xE0", "Id\xE0\xE1sh\xE0", "Id\xE0\xE1tch\xE0"],
  cc: ["BJ"]
}, {
  pk: 2423,
  ang: "Idere",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Idere",
  lc: "ide",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 2424,
  ang: "Idi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Idi",
  lc: "idi",
  ld: "ltr",
  alt: ["Diblaeg", "Dimisi", "Dimsisi"],
  cc: ["PG"]
}, {
  pk: 2425,
  ang: "Indri",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Indri",
  lc: "idr",
  ld: "ltr",
  alt: ["Yanderika", "Yandirika"],
  cc: ["SS"]
}, {
  pk: 2426,
  ang: "Idesa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Idesa",
  lc: "ids",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 2427,
  ang: "Idat\xE9",
  lr: "Asia",
  gw: false,
  hc: "TL",
  ln: "Idat\xE9",
  lc: "idt",
  ld: "ltr",
  alt: [],
  cc: ["TL"]
}, {
  pk: 2428,
  ang: "Idoma",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Idoma",
  lc: "idu",
  ld: "ltr",
  alt: ["Idoma Central (Akpoto)", "Idoma South (Igumale)", "Idoma West", "Igwaale", "Ijigbam", "Oturkpo"],
  cc: ["NG"]
}, {
  pk: 7516,
  ang: "",
  lr: "Asia",
  gw: true,
  hc: "ID",
  ln: "Bahasa Indonesia - Dominant Culture Variant",
  lc: "id-x-dcv",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 2429,
  ang: "Interlingue",
  lr: "",
  gw: false,
  hc: "",
  ln: "Originally called Occidental; then Interlingue after WWII",
  lc: "ie",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2430,
  ang: "Ifugao, Amganad",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Amganad Ifugao",
  lc: "ifa",
  ld: "ltr",
  alt: ["Amganad", "Ifugaw", "Burnay Ifugao", "Banaue Ifugao"],
  cc: ["PH"]
}, {
  pk: 8383,
  ang: "Mun'ibannawol",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Mun'ibannawol",
  lc: "ifa-x-munibannaw",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2431,
  ang: "Ifugao, Batad",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Batad Ifugao",
  lc: "ifb",
  ld: "ltr",
  alt: ["Batad", "Ifugaw"],
  cc: ["PH"]
}, {
  pk: 2432,
  ang: "If\xE8",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "If\xE8",
  lc: "ife",
  ld: "ltr",
  alt: ["Ana", "Anago", "Ana-Ife", "Baate", "Ede Ife", "Ana-If\xE9"],
  cc: ["BJ", "TG"]
}, {
  pk: 7757,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Ana",
  lc: "ife-x-ana",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2433,
  ang: "Ifugao, Tuwali",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Tuwali Ifugao",
  lc: "ifk",
  ld: "ltr",
  alt: ["Gilipanes", "Ifugaw", "Kiangan Ifugao", "Quiangan"],
  cc: ["PH"]
}, {
  pk: 8384,
  ang: "Yattuca",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Yattuca",
  lc: "ifk-x-yattuca",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2434,
  ang: "Teke-Fuumu",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Teke-Fuumu",
  lc: "ifm",
  ld: "ltr",
  alt: ["Kiteke", "South Central Teke", "Teke du Pool", "Wuumu (Iwuumu)", "Wumbu", "Fuumu (Ifuumu)", "Mfumu"],
  cc: ["CG"]
}, {
  pk: 2435,
  ang: "Ifugao, Mayoyao",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Mayoyao Ifugao",
  lc: "ifu",
  ld: "ltr",
  alt: ["Ifugaw", "Mayaoyaw", "Mayoyao"],
  cc: ["PH"]
}, {
  pk: 2436,
  ang: "Kallahan, Keley-i",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Keley-I Kallahan",
  lc: "ify",
  ld: "ltr",
  alt: ["Antipolo Ifugao", "Hanalulo", "Keley-i", "Keley-i Kalanguya", "Keleyqiq Ifugao", "Ya-Tuka"],
  cc: ["PH"]
}, {
  pk: 7988,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Munkalyon",
  lc: "ify-x-munkalyon",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2437,
  ang: "Igbo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "\xC1s\u1EE5\u0300s\u1EE5\u0300 \u1ECA\u0300gb\xF2",
  lc: "ig",
  ld: "ltr",
  alt: ["Ibo", "Oka (Awka)", "Owerri (Isuama)"],
  cc: ["CM", "GQ", "GH", "NG", "US", "CA"]
}, {
  pk: 2438,
  ang: "Ebira",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ebira",
  lc: "igb",
  ld: "ltr",
  alt: ["Egbira", "Egbura", "Ibara", "Igbarra", "Igbira", "Igbirra", "Katawa", "Kotokori", "Kwotto", "Ika", "Okene (Hima)", "Egu", "Koto (Bira)", "Panda", "Ihima", "Igara (Etuno)", "Biri", "Igu"],
  cc: ["NG"]
}, {
  pk: 7869,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Etuno",
  lc: "igb-x-etuno",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2439,
  ang: "Igede",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Igede",
  lc: "ige",
  ld: "ltr",
  alt: ["Egede", "Oju (Central Igede)"],
  cc: ["NG"]
}, {
  pk: 2440,
  ang: "Igana",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Igana",
  lc: "igg",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2441,
  ang: "Igala",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Igala",
  lc: "igl",
  ld: "ltr",
  alt: ["Igara"],
  cc: ["NG"]
}, {
  pk: 2442,
  ang: "Kanggape",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kanggape",
  lc: "igm",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2443,
  ang: "Ignaciano",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Ignaciano",
  lc: "ign",
  ld: "ltr",
  alt: [],
  cc: ["BO"]
}, {
  pk: 2444,
  ang: "Isebe",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Isebe",
  lc: "igo",
  ld: "ltr",
  alt: ["Balahaim"],
  cc: ["PG"]
}, {
  pk: 2445,
  ang: "",
  lr: "",
  gw: false,
  hc: "",
  ln: "Interglossa",
  lc: "igs",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2446,
  ang: "Igwe",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Igwe",
  lc: "igw",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 8274,
  ang: "Igwe-Sale",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Igwe-Sale",
  lc: "igw-x-sale",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2447,
  ang: "Iha Based Pidgin",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Iha Based Pidgin",
  lc: "ihb",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 2448,
  ang: "Ihievbe",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ihievbe",
  lc: "ihi",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 2449,
  ang: "Iha",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Iha",
  lc: "ihp",
  ld: "ltr",
  alt: ["Kapaur"],
  cc: ["ID"]
}, {
  pk: 2450,
  ang: "Bidhawal",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Bidhawal",
  lc: "ihw",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 2451,
  ang: "Nuosu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\uA188\uA320\uA4BF Nuosuhxop",
  lc: "ii",
  ld: "ltr",
  alt: ["Black Yi", "Liangshan Yi", "Northern Yi", "Nosu Yi", "Sichuan Yi", "Northern Shypnra", "Southern Shypnra", "Suondi (Adu)"],
  cc: ["CN"]
}, {
  pk: 7554,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Baiyi",
  lc: "iii-x-baiyi",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7636,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Gongji Yi",
  lc: "iii-x-gongjiyi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7551,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Luoluo",
  lc: "iii-x-luoluo",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 2452,
  ang: "Izon",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Izon",
  lc: "ijc",
  ld: "ltr",
  alt: ["Central-Western Ijo", "Ijo", "Izo", "Uzo", "Kolokuma-Opokuma", "Kumbo (Kumbowei)", "Bumo (Boma)", "Koluama", "Operemo", "Gbarain", "East Olodiama", "Basan (Bassan)", "East Tarakiri", "Kabo (Kabowei)"],
  cc: ["NG"]
}, {
  pk: 2453,
  ang: "Biseni",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Biseni",
  lc: "ije",
  ld: "ltr",
  alt: ["Amegi", "Buseni", "Northeast Central Ijo"],
  cc: ["NG"]
}, {
  pk: 2454,
  ang: "Ede Ije",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Ede Ije",
  lc: "ijj",
  ld: "ltr",
  alt: ["Holi"],
  cc: ["BJ"]
}, {
  pk: 2455,
  ang: "Kalabari",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kalabari",
  lc: "ijn",
  ld: "ltr",
  alt: [],
  cc: ["GH", "NG"]
}, {
  pk: 2456,
  ang: "Ijo, Southeast",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Southeast Ijo",
  lc: "ijs",
  ld: "ltr",
  alt: ["Brass Ijo", "Brass-Nembe", "Ijaw", "Nembe-Akassa", "Akassa (Akaha)", "Ijo", "Nembe (Nimbe)"],
  cc: ["NG"]
}, {
  pk: 2457,
  ang: "Inupiaq",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "I\xF1upiaq, I\xF1upiatun",
  lc: "ik",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 2458,
  ang: "Inuktitut, Eastern Canadian",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Eastern Canadian Inuktitut",
  lc: "ike",
  ld: "ltr",
  alt: ["Inuit", "Eastern Arctic Eskimo", "Eastern Canadian Eskimo", "Labrador Inuttitut", "Labrador Inuttut (\"Labrador Eskimo\")", "Mittimatalik (\"Baffinland Eskimo\")", "Rigolet Inuttut", "Tarramiut (\"Quebec Eskimo\")"],
  cc: ["CA"]
}, {
  pk: 2459,
  ang: "Iko",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Iko",
  lc: "iki",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 2460,
  ang: "Ika",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ika",
  lc: "ikk",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 2461,
  ang: "Ikulu",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ikulu",
  lc: "ikl",
  ld: "ltr",
  alt: ["Ankulu", "Ikolu"],
  cc: ["NG"]
}, {
  pk: 2462,
  ang: "Olulumo-Ikom",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Olulumo-Ikom",
  lc: "iko",
  ld: "ltr",
  alt: ["Lulumo"],
  cc: ["NG"]
}, {
  pk: 2463,
  ang: "Ikpeshi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ikpeshi",
  lc: "ikp",
  ld: "ltr",
  alt: ["Ekpeshe", "Ikpeshe"],
  cc: ["NG"]
}, {
  pk: 2464,
  ang: "Inuit Sign Language",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Inuit Sign Language",
  lc: "iks",
  ld: "ltr",
  alt: [],
  cc: ["CA"]
}, {
  pk: 2465,
  ang: "Inuinnaqtun",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Inuinnaqtun",
  lc: "ikt",
  ld: "ltr",
  alt: ["Western Canadian Inuit", "Western Canadian Inuktitut", "Copper Inuit", "Copper Inuktitut (\"Copper Eskimo\")", "Caribou Eskimo (Keewatin)", "Siglit (Siglitun)"],
  cc: ["CA"]
}, {
  pk: 2466,
  ang: "Iku-Gora-Ankwa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Iku-Gora-Ankwa",
  lc: "ikv",
  ld: "ltr",
  alt: ["Ekhwa", "Iku"],
  cc: ["NG"]
}, {
  pk: 2467,
  ang: "Ikwere",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ikwere",
  lc: "ikw",
  ld: "ltr",
  alt: ["Ikwerre", "Obio-Akpo"],
  cc: ["NG"]
}, {
  pk: 2468,
  ang: "Ik",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Ik",
  lc: "ikx",
  ld: "ltr",
  alt: ["Icetod", "Icietot", "Ng'ateus", "Ng'ateuso", "Ngulak", "Teus", "Teuso", "Teuth"],
  cc: ["KE", "UG"]
}, {
  pk: 2469,
  ang: "Ikizu",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Ikizu",
  lc: "ikz",
  ld: "ltr",
  alt: ["Ikiikiizu", "Ikikizo", "Ikikizu", "Kiikizu", "Kishashi", "Kisizaki", "Shashi"],
  cc: ["TZ"]
}, {
  pk: 2470,
  ang: "Ile Ape",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ile Ape",
  lc: "ila",
  ld: "ltr",
  alt: ["Nusa Tadon"],
  cc: ["ID"]
}, {
  pk: 2471,
  ang: "Ila",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Ila",
  lc: "ilb",
  ld: "ltr",
  alt: ["Chiila", "Shukulumbwe", "Sukulumbwe"],
  cc: ["ZM"]
}, {
  pk: 2472,
  ang: "Ili Turki",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4F0A\u7281\u571F\u5C14\u514B\u8BED",
  lc: "ili",
  ld: "ltr",
  alt: ["Ili Turk", "Tuerke", "Tu'erke", "T'urk"],
  cc: ["CN"]
}, {
  pk: 2473,
  ang: "Ilongot",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Ilongot",
  lc: "ilk",
  ld: "ltr",
  alt: ["Bugkalut", "Bukalot", "Lingotes", "Ibalao (Ibilao)", "Abaka (Abaca)"],
  cc: ["PH"]
}, {
  pk: 7819,
  ang: "Bukalot",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Bugkalot",
  lc: "ilk-x-bugkalot",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2474,
  ang: "Iranun",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Iranun",
  lc: "ill",
  ld: "ltr",
  alt: ["Illanoan", "Illanoon", "Illanos", "Illanun", "Iranon Maranao", "Iranum", "Lanoon", "Lanun", "Ylanos", "Iranon", "Illanon", "Ilanon", "Ilanum"],
  cc: ["MY", "PH"]
}, {
  pk: 8312,
  ang: "Malaysian Iranun",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Malaysian Iranun",
  lc: "ilm",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2475,
  ang: "Ilocano",
  lr: "Asia",
  gw: true,
  hc: "PH",
  ln: "Iloko",
  lc: "ilo",
  ld: "ltr",
  alt: ["Ilokano", "Iloko"],
  cc: ["PH", "US", "CA"]
}, {
  pk: 8311,
  ang: "Philippine Iranun",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Philippine Iranun",
  lc: "ilp",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2476,
  ang: "International Sign",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "International Sign",
  lc: "ils",
  ld: "ltr",
  alt: ["Gestuno", "International Sign Language"],
  cc: ["IT"]
}, {
  pk: 2477,
  ang: "Ili\u2019uun",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ili'uun",
  lc: "ilu",
  ld: "ltr",
  alt: ["Erai", "Hahutan", "Hahutau", "Ilmaumau", "Limera", "Karbubu", "Ustutun", "Telemar", "Klishatu", "Esulit", "Eray", "Nabar"],
  cc: ["ID"]
}, {
  pk: 2478,
  ang: "Ilue",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ilue",
  lc: "ilv",
  ld: "ltr",
  alt: ["Idua"],
  cc: ["NG"]
}, {
  pk: 2479,
  ang: "Mala Malasar",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mala Malasar",
  lc: "ima",
  ld: "ltr",
  alt: ["Maha Malasar", "Malai Malasar", "Malasir"],
  cc: ["IN"]
}, {
  pk: 2480,
  ang: "Anamgura",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Anamgura",
  lc: "imi",
  ld: "ltr",
  alt: ["Ikundun", "Mindivi"],
  cc: ["PG"]
}, {
  pk: 2481,
  ang: "Miluk",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Miluk",
  lc: "iml",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 2482,
  ang: "Imonda",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Imonda",
  lc: "imn",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2483,
  ang: "Imbongu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Imbongu",
  lc: "imo",
  ld: "ltr",
  alt: ["Au", "Aua", "Awa", "Ibo Ugu", "Imbo Ungo", "Imbo Ungu", "Imbonggo", "Awa (Au)"],
  cc: ["PG"]
}, {
  pk: 2484,
  ang: "Imroing",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Imroing",
  lc: "imr",
  ld: "ltr",
  alt: ["Imroin"],
  cc: ["ID"]
}, {
  pk: 2485,
  ang: "Marsian",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Marsian",
  lc: "ims",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 2486,
  ang: "Milyan",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Milyan",
  lc: "imy",
  ld: "ltr",
  alt: [],
  cc: ["TR"]
}, {
  pk: 2487,
  ang: "Inga",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Inga",
  lc: "inb",
  ld: "ltr",
  alt: ["Highland Inga"],
  cc: ["CO"]
}, {
  pk: 2488,
  ang: "Degexit\u2019an",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Degexit'an",
  lc: "ing",
  ld: "ltr",
  alt: ["Deg Xinag", "Deg Xit'an", "Ingalik", "Ingalit"],
  cc: ["US"]
}, {
  pk: 2489,
  ang: "Ingush",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0418\u043D\u0433\u0443\u0448\u0441\u043A\u0438\u0439",
  lc: "inh",
  ld: "ltr",
  alt: ["Galgay", "Ghalghay", "Ingus", "Kisti", "Kistin"],
  cc: ["KZ", "RU"]
}, {
  pk: 2490,
  ang: "Inga, Jungle",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Jungle Inga",
  lc: "inj",
  ld: "ltr",
  alt: ["Ingano", "Lowland Inga", "Mocoa"],
  cc: ["CO"]
}, {
  pk: 2491,
  ang: "Indonesian Sign Language",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Indonesian Sign Language",
  lc: "inl",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 2492,
  ang: "Minaean",
  lr: "Asia",
  gw: false,
  hc: "YE",
  ln: "Minaean",
  lc: "inm",
  ld: "ltr",
  alt: [],
  cc: ["YE"]
}, {
  pk: 2493,
  ang: "Isinai",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Isinai",
  lc: "inn",
  ld: "ltr",
  alt: ["Inmeas", "Insinai", "Isinay", "Isnay"],
  cc: ["PH"]
}, {
  pk: 2494,
  ang: "Inoke-Yate",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Inoke-Yate",
  lc: "ino",
  ld: "ltr",
  alt: ["Yate"],
  cc: ["PG"]
}, {
  pk: 2495,
  ang: "I\xF1apari",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "I\xF1apari",
  lc: "inp",
  ld: "ltr",
  alt: ["Inamari"],
  cc: ["PE"]
}, {
  pk: 2496,
  ang: "Indian Sign Language",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Indian Sign Language",
  lc: "ins",
  ld: "ltr",
  alt: ["Indo-Pakistani Sign Language", "Urban Indian Sign Language", "Bangalore-Chennai-Hyderabad Sign Language", "Kolkata Sign Language", "Mumbai-Delhi Sign Language"],
  cc: ["BD", "IN"]
}, {
  pk: 7624,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Andra Pradesh Sign Language",
  lc: "ins-x-andrapsl",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7625,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Karnataka Sign Language",
  lc: "ins-x-karnatsl",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7623,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kerala Sign Language",
  lc: "ins-x-keralasl",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7694,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Marathi Sign Language",
  lc: "ins-x-marathisl",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7626,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Tamil Nadu Sign Language",
  lc: "ins-x-tamnadsl",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2497,
  ang: "Intha",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Intha",
  lc: "int",
  ld: "ltr",
  alt: ["Inntha", "Insa", "Naung Ma"],
  cc: ["MM"]
}, {
  pk: 2498,
  ang: "Inese\xF1o",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Inese\xF1o",
  lc: "inz",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 2499,
  ang: "Ido",
  lr: "",
  gw: false,
  hc: "",
  ln: "Ido",
  lc: "io",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2500,
  ang: "Inor",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Inor",
  lc: "ior",
  ld: "ltr",
  alt: ["Ennemor", "Endegeny (Enner)"],
  cc: ["ET"]
}, {
  pk: 2501,
  ang: "Tuma-Irumu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tuma-Irumu",
  lc: "iou",
  ld: "ltr",
  alt: ["Irumu", "Tuma", "Upper Irumu"],
  cc: ["PG"]
}, {
  pk: 2502,
  ang: "Iowa-Oto",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Iowa-Oto",
  lc: "iow",
  ld: "ltr",
  alt: ["Niutaji (Missouri)", "Nyut'chi", "Missouria", "Jiwele", "Oto (Chiwere)", "Ioway", "Iowa (Baxoje)", "Jiwere"],
  cc: ["US"]
}, {
  pk: 2503,
  ang: "Ipili",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ipili",
  lc: "ipi",
  ld: "ltr",
  alt: ["Ipili-Paiela", "Ipili-Payala", "Paiela", "Porgera"],
  cc: ["PG"]
}, {
  pk: 2504,
  ang: "Ipiko",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ipiko",
  lc: "ipo",
  ld: "ltr",
  alt: ["Epai", "Higa", "Ipikoi", "Ibigo", "Eva"],
  cc: ["PG"]
}, {
  pk: 2505,
  ang: "Iquito",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Iquito",
  lc: "iqu",
  ld: "ltr",
  alt: ["Amacacore", "Hamacore", "Ikito", "Iquita", "Puca-Uma", "Quiturran", "Pintuyacu"],
  cc: ["PE"]
}, {
  pk: 2506,
  ang: "Ikwo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ikwo",
  lc: "iqw",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 2507,
  ang: "Yeresiam",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Iresim",
  lc: "ire",
  ld: "ltr",
  alt: ["Beduba"],
  cc: ["ID"]
}, {
  pk: 2508,
  ang: "Irarutu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Irarutu",
  lc: "irh",
  ld: "ltr",
  alt: ["Arguni Bay", "Irahutu", "Irutu", "Kaitero", "Kasira"],
  cc: ["ID"]
}, {
  pk: 2509,
  ang: "Irigwe",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Irigwe",
  lc: "iri",
  ld: "ltr",
  alt: ["Aregwe", "Idafan", "Kwal", "Kwan", "Kwoll", "Miango", "Nnerigwe", "Nyango", "Rigwe"],
  cc: ["NG"]
}, {
  pk: 2510,
  ang: "Iraqw",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Iraqw",
  lc: "irk",
  ld: "ltr",
  alt: ["Erokh", "Iraku", "Kiiraqw", "Mbulunge"],
  cc: ["TZ"]
}, {
  pk: 2511,
  ang: "Ir\xE1ntxe",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Ir\xE1ntxe",
  lc: "irn",
  ld: "ltr",
  alt: ["Iranche", "Menku", "M\xFCnk\xFC (Kenk\xFC)", "Mynky", "Myy", "Ir\xE1ntxe"],
  cc: ["BR"]
}, {
  pk: 2512,
  ang: "Ir",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Ir",
  lc: "irr",
  ld: "ltr",
  alt: ["Yiir", "Yir"],
  cc: ["LA"]
}, {
  pk: 2513,
  ang: "Irula",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Irula",
  lc: "iru",
  ld: "ltr",
  alt: ["Erukala", "Irava", "Irulan", "Irular", "Irular Mozhi", "Irulavan", "Iruliga", "Iruligar", "Kad Chensu", "Korava", "Kasuba", "Vette Kada Irula (Irula Pallar)", "Walayar Irula (Urali Irula)", "Mele Nadu Irula (Southern Irula)", "Irula Urali", "Attapady Irula", "Northern Irula (Kasaba)", "Kasava"],
  cc: ["IN"]
}, {
  pk: 7754,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Iruli Nayak",
  lc: "iru-x-nayak",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2514,
  ang: "Kamberau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kamberau",
  lc: "irx",
  ld: "ltr",
  alt: ["Iria", "Kambrau", "Kamrau"],
  cc: ["ID"]
}, {
  pk: 2515,
  ang: "Iraya",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Iraya",
  lc: "iry",
  ld: "ltr",
  alt: [],
  cc: ["PH"]
}, {
  pk: 2516,
  ang: "Icelandic",
  lr: "Europe",
  gw: false,
  hc: "IS",
  ln: "\xCDslenska",
  lc: "is",
  ld: "ltr",
  alt: ["\xCDslenska"],
  cc: ["US", "CA", "DK", "IS"]
}, {
  pk: 2517,
  ang: "Isabi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Isabi",
  lc: "isa",
  ld: "ltr",
  alt: ["Maruhia"],
  cc: ["PG"]
}, {
  pk: 2518,
  ang: "Isconahua",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Isconahua",
  lc: "isc",
  ld: "ltr",
  alt: ["Iscobaquebu"],
  cc: ["PE"]
}, {
  pk: 2519,
  ang: "Isnag",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Isnag",
  lc: "isd",
  ld: "ltr",
  alt: ["Dibagat-Kabugao-Isneg", "Isneg", "Maragat", "Karagawan (Daragawan)", "Talifugu-Ripang (Tawini)"],
  cc: ["PH"]
}, {
  pk: 2520,
  ang: "Italian Sign Language",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Italian Sign Language",
  lc: "ise",
  ld: "ltr",
  alt: ["Lingua Italiana Dei Segni", "LIS"],
  cc: ["IT"]
}, {
  pk: 2521,
  ang: "Irish Sign Language",
  lr: "Europe",
  gw: false,
  hc: "IE",
  ln: "Irish Sign Language",
  lc: "isg",
  ld: "ltr",
  alt: [],
  cc: ["IE"]
}, {
  pk: 2522,
  ang: "Esan",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Esan",
  lc: "ish",
  ld: "ltr",
  alt: ["Anwain", "Esa", "Isa", "Ubiaja (Ubiaza)", "Ugboha (Owoha)", "Opoji (Ukpozi)", "Ogwa", "Irrua (Uruwa)", "Ewohimi (Ebhoikimi)", "Ewatto (Ebhoato)", "Ekunma", "Ekpoma (Ekpon)", "Egoro (Egholo)", "Ewu (Eilu)", "Uromi (Uronmun)"],
  cc: ["NG"]
}, {
  pk: 2523,
  ang: "Nkem-Nkum",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Nkem-Nkum",
  lc: "isi",
  ld: "ltr",
  alt: ["Ikangdangha", "Ogboja", "Nkum-Iborr", "Nkum (Alladim)", "Nkem (Adagom)", "Ishindede", "Ishiaya", "Igordori", "Ibil", "Ishibori"],
  cc: ["NG"]
}, {
  pk: 2524,
  ang: "Ishkashimi",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "\u0161ko\u0161mi z\u0259v\u016Fk",
  lc: "isk",
  ld: "ltr",
  alt: ["Eshkashimi", "Ishkashim", "Ishkashmi"],
  cc: ["AF", "TJ"]
}, {
  pk: 2525,
  ang: "Masimasi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Masimasi",
  lc: "ism",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 2526,
  ang: "Isanzu",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Isanzu",
  lc: "isn",
  ld: "ltr",
  alt: ["Kiisanzu", "Kinyihanzu", "Kinyisanzu"],
  cc: ["TZ"]
}, {
  pk: 2527,
  ang: "Isoko",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Isoko",
  lc: "iso",
  ld: "ltr",
  alt: ["Biotu", "Igabo", "Sobo", "Owe (Owhe)", "Irri (Iri)", "Iwire (Igbide)", "Ole (Oleh)"],
  cc: ["NG"]
}, {
  pk: 2528,
  ang: "Israeli Sign Language",
  lr: "Asia",
  gw: false,
  hc: "IL",
  ln: "\u05E9\u05E4\u05EA \u05D4\u05E1\u05D9\u05DE\u05E0\u05D9\u05DD \u05D4\u05D9\u05E9\u05E8\u05D0\u05DC\u05D9\u05EA",
  lc: "isr",
  ld: "ltr",
  alt: ["ISL"],
  cc: ["IL"]
}, {
  pk: 2529,
  ang: "Istriot",
  lr: "Europe",
  gw: false,
  hc: "HR",
  ln: "Istriot",
  lc: "ist",
  ld: "ltr",
  alt: [],
  cc: ["HR"]
}, {
  pk: 2530,
  ang: "Isu",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Isu (Menchum Division)",
  lc: "isu",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 2531,
  ang: "Italian",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "italiano",
  lc: "it",
  ld: "ltr",
  alt: ["Italiano"],
  cc: ["AT", "BE", "BR", "FR", "DE", "MT", "GB", "SM", "NC", "NZ", "CH", "SI", "US", "AU", "CA", "MC", "IT", "LI", "LU", "PT"]
}, {
  pk: 2532,
  ang: "Itneg, Binongan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Binongan Itneg",
  lc: "itb",
  ld: "ltr",
  alt: ["Tingguian", "Tinguian"],
  cc: ["PH"]
}, {
  pk: 8223,
  ang: "Southern Tidung",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Southern Tidung",
  lc: "itd",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8237,
  ang: "Dayak Tahol",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Tahol",
  lc: "itd-x-dayaktahol",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2533,
  ang: "Itene",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Itene",
  lc: "ite",
  ld: "ltr",
  alt: ["Iteneo", "Itenez", "More"],
  cc: ["BO"]
}, {
  pk: 2534,
  ang: "Itneg, Inlaod",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Inlaod Itneg",
  lc: "iti",
  ld: "ltr",
  alt: ["Tinggian", "Tinguian"],
  cc: ["PH"]
}, {
  pk: 2535,
  ang: "Judeo-Italian",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Judeo-Italian",
  lc: "itk",
  ld: "ltr",
  alt: ["Italkian"],
  cc: ["IT"]
}, {
  pk: 2536,
  ang: "Itelmen",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0418\u0442\u0435\u043B\u044C\u043C\u0435\u043D\u0441\u043A\u0438\u0439",
  lc: "itl",
  ld: "ltr",
  alt: ["Itelymem", "Kamchadal", "Kamchatka", "Western Itelmen", "Xajrjuzovo"],
  cc: ["RU"]
}, {
  pk: 2537,
  ang: "Itu Mbon Uzo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Itu Mbon Uzo",
  lc: "itm",
  ld: "ltr",
  alt: ["Itu Mbon Uso", "Itu Mbuzo"],
  cc: ["NG"]
}, {
  pk: 2538,
  ang: "Itonama",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Itonama",
  lc: "ito",
  ld: "ltr",
  alt: ["Machoto", "Saramo"],
  cc: ["BO"]
}, {
  pk: 2539,
  ang: "Iteri",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Iteri",
  lc: "itr",
  ld: "ltr",
  alt: ["Alowiemino", "Iyo", "Laro", "Rocky Peak", "Yinibu"],
  cc: ["PG"]
}, {
  pk: 2540,
  ang: "Isekiri",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Isekiri",
  lc: "its",
  ld: "ltr",
  alt: ["Chekiri", "Irhobo", "Iselema-Otu", "Ishekiri", "Iwere", "Jekri", "Selemo", "Shekiri", "Warri"],
  cc: ["NG"]
}, {
  pk: 2541,
  ang: "Itneg, Maeng",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Maeng Itneg",
  lc: "itt",
  ld: "ltr",
  alt: ["Luba-Tiempo Itneg", "Southern Itneg"],
  cc: ["PH"]
}, {
  pk: 2542,
  ang: "Itawit",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Itawit",
  lc: "itv",
  ld: "ltr",
  alt: ["Itawes", "Itawis", "Tawit", "Malaweg (Malaueg)"],
  cc: ["PH"]
}, {
  pk: 2543,
  ang: "Ito",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ito",
  lc: "itw",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 2544,
  ang: "Itik",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Itik",
  lc: "itx",
  ld: "ltr",
  alt: ["Betef", "Borto", "Ittik"],
  cc: ["ID"]
}, {
  pk: 2545,
  ang: "Itneg, Moyadan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Moyadan Itneg",
  lc: "ity",
  ld: "ltr",
  alt: ["Tinggian", "Tinguian"],
  cc: ["PH"]
}, {
  pk: 2546,
  ang: "Itza\u2019",
  lr: "Americas",
  gw: false,
  hc: "GT",
  ln: "Itz\xE1",
  lc: "itz",
  ld: "ltr",
  alt: ["Icaiche Maya", "Maya", "Pet\xE9n Itza' Maya", "Yucatec Maya"],
  cc: ["GT"]
}, {
  pk: 2547,
  ang: "Inuktitut",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "\u1403\u14C4\u1483\u144E\u1450\u1466",
  lc: "iu",
  ld: "ltr",
  alt: [],
  cc: ["CA"]
}, {
  pk: 2548,
  ang: "Iu Mien",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u52C9\u8A9E",
  lc: "ium",
  ld: "ltr",
  alt: ["Ban Yao", "Highland Yao", "Mian", "Mien", "Myen", "Pan Yao", "Yiu Mien", "Youmian", "Man", "Dao Do", "Dao Thanh Phan", "D\xECu", "Kim Mien", "Red Dao", "Yao Kimmien", "Yao Ogang", "Yu Mien", "Dong", "M\xE1n", "Trai", "X\xE1", "Dao Lan Tien", "Dao Lo Gang", "Guoshan Yao"],
  cc: ["CN", "FR", "LA", "TH", "US"]
}, {
  pk: 7761,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Lan Tien Yao",
  lc: "ium-x-lantien",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7898,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Lan Tin",
  lc: "ium-x-lantin",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2549,
  ang: "Ibatan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Ibatan",
  lc: "ivb",
  ld: "ltr",
  alt: ["Babuyan", "Ibataan", "Ivatan"],
  cc: ["PH"]
}, {
  pk: 2550,
  ang: "Ivatan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Ivatan",
  lc: "ivv",
  ld: "ltr",
  alt: [],
  cc: ["PH"]
}, {
  pk: 2551,
  ang: "I-wak",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "I-Wak",
  lc: "iwk",
  ld: "ltr",
  alt: ["Iwaak"],
  cc: ["PH"]
}, {
  pk: 2552,
  ang: "Iwam",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Iwam",
  lc: "iwm",
  ld: "ltr",
  alt: ["May River"],
  cc: ["PG"]
}, {
  pk: 2553,
  ang: "Morop",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Iwur",
  lc: "iwo",
  ld: "ltr",
  alt: ["Iwoer", "Dinmane", "Upper Dintere", "Dintere", "Nemah/Nehayah"],
  cc: ["ID"]
}, {
  pk: 2554,
  ang: "Iwam, Sepik",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sepik Iwam",
  lc: "iws",
  ld: "ltr",
  alt: ["Yawenian"],
  cc: ["PG"]
}, {
  pk: 2555,
  ang: "Ixcatec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Ixcatec",
  lc: "ixc",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 2556,
  ang: "Ixil",
  lr: "Americas",
  gw: false,
  hc: "GT",
  ln: "Ixil",
  lc: "ixl",
  ld: "ltr",
  alt: [],
  cc: ["GT"]
}, {
  pk: 2557,
  ang: "Iyayu",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Iyayu",
  lc: "iya",
  ld: "ltr",
  alt: ["Idoani"],
  cc: ["NG"]
}, {
  pk: 2558,
  ang: "Mesaka",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mesaka",
  lc: "iyo",
  ld: "ltr",
  alt: ["Banagere", "Iyon", "Messaga", "Messaga-Ekol", "Messaka", "Batomo (Babasi)"],
  cc: ["CM"]
}, {
  pk: 2559,
  ang: "Yaka",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Yaka (Congo)",
  lc: "iyx",
  ld: "ltr",
  alt: ["Iyaka", "West Teke"],
  cc: ["GA", "CG", "AO"]
}, {
  pk: 2560,
  ang: "Ingrian",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0418\u0436\u043E\u0440\u0441\u043A\u0438\u0439",
  lc: "izh",
  ld: "ltr",
  alt: ["Ingermanlandian", "Inkeroisen", "Izhor", "Izhorian", "Oredezh (Upper Luzh)"],
  cc: ["RU"]
}, {
  pk: 2561,
  ang: "Izere",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Izere",
  lc: "izr",
  ld: "ltr",
  alt: ["Afizare", "Afizarek", "Afusare", "Feserek", "Fezere", "Fizere", "Hill Jarawa", "Izarek", "Jarawan Dutse", "Jari", "Jos-Zarazon"],
  cc: ["NG"]
}, {
  pk: 2562,
  ang: "Izii",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Izii",
  lc: "izz",
  ld: "ltr",
  alt: ["Izi", "Izzi"],
  cc: ["NG"]
}, {
  pk: 2563,
  ang: "Japanese",
  lr: "Asia",
  gw: false,
  hc: "JP",
  ln: "\u65E5\u672C\u8A9E (\u306B\u307B\u3093\u3054)",
  lc: "ja",
  ld: "ltr",
  alt: ["Zu-zu-ben"],
  cc: ["CN", "AR", "FR", "DE", "JP", "PA", "ES", "MY", "NZ", "US", "AU", "CA", "FM", "PT", "SG", "DO"]
}, {
  pk: 2564,
  ang: "Jamamad\xED",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Jamamad\xED",
  lc: "jaa",
  ld: "ltr",
  alt: ["Canamanti", "Kanamanti", "Madi", "Yamamad\xED", "Jaru\xE1ra (Jarawara)", "Mamoria (Mamori)", "Banaw\xE1", "Kitiya (Banau\xE1)", "Yarawara", "Jaf\xED", "Banawa Yafi", "Banav\xE1", "Cuchudua (Maima)"],
  cc: ["BR"]
}, {
  pk: 2565,
  ang: "Hyam",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Hyam",
  lc: "jab",
  ld: "ltr",
  alt: ["Ham", "Hyamhum", "Jabba", "Jeba"],
  cc: ["NG"]
}, {
  pk: 2566,
  ang: "Jakalteko",
  lr: "Americas",
  gw: false,
  hc: "GT",
  ln: "Popti'",
  lc: "jac",
  ld: "ltr",
  alt: ["Popti'", "Jakalteko del Oeste", "Eastern Jakalteko (Eastern Jacalteco)", "Western Jacalteco", "Western Jakalteko (Western Jacaltec)"],
  cc: ["GT", "US"]
}, {
  pk: 2567,
  ang: "Jahanka",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Jahanka",
  lc: "jad",
  ld: "ltr",
  alt: ["Diakhanke", "Diakkanke", "Dyakanke", "Jahanque", "Jahonque", "Jaxanka"],
  cc: ["GM", "ML", "SN", "GN", "GW"]
}, {
  pk: 2568,
  ang: "Yabem",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yabem",
  lc: "jae",
  ld: "ltr",
  alt: ["Jabim", "Laulabu", "Yabim"],
  cc: ["PG"]
}, {
  pk: 2569,
  ang: "Jara",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Jara",
  lc: "jaf",
  ld: "ltr",
  alt: ["Jera"],
  cc: ["NG"]
}, {
  pk: 2570,
  ang: "Jah Hut",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Jah Hut",
  lc: "jah",
  ld: "ltr",
  alt: ["Jah Het", "Ketiar Krau (Tengganu)", "Ulu Ceres (Cheres)"],
  cc: ["MY"]
}, {
  pk: 2571,
  ang: "Zazao",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Zazao",
  lc: "jaj",
  ld: "ltr",
  alt: ["Jajao", "Kilokaka"],
  cc: ["SB"]
}, {
  pk: 2572,
  ang: "Jakun",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Jakun",
  lc: "jak",
  ld: "ltr",
  alt: ["Jakoon", "Jaku'd", "Jakud'n", "Orang Hulu"],
  cc: ["MY"]
}, {
  pk: 2573,
  ang: "Yalahatan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Yalahatan",
  lc: "jal",
  ld: "ltr",
  alt: ["Atamanu", "Awaiya", "Jahalatan", "Jahalatane"],
  cc: ["ID"]
}, {
  pk: 2574,
  ang: "Jamaican Creole English",
  lr: "Americas",
  gw: false,
  hc: "JM",
  ln: "Jamaican Creole English",
  lc: "jam",
  ld: "ltr",
  alt: ["Southwestern Caribbean Creole English", "Bongo Talk", "Limon Creole English", "Patois", "Patwa", "Quashie Talk"],
  cc: ["BS", "CU", "VE", "PA", "GB", "CR", "JM", "CO"]
}, {
  pk: 2575,
  ang: "Yanyuwa",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yanyuwa",
  lc: "jao",
  ld: "ltr",
  alt: ["Aniula", "Anula", "Anyula", "Janjula", "Leeanuwa", "Wadiri", "Yanula", "Yanyula"],
  cc: ["AU"]
}, {
  pk: 2576,
  ang: "Yaqay",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Yaqay",
  lc: "jaq",
  ld: "ltr",
  alt: ["Jakai", "Jaqai", "Mapi", "Sohur", "Nambiomon-Mabur"],
  cc: ["ID", "AU"]
}, {
  pk: 2577,
  ang: "Javanese, New Caledonian",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "New Caledonian Javanese",
  lc: "jas",
  ld: "ltr",
  alt: [],
  cc: ["NC"]
}, {
  pk: 2578,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Jakati",
  lc: "jat",
  ld: "ltr",
  alt: ["Jat", "Jataki", "Jati", "Jatu", "Kayani", "Musali"],
  cc: ["AF"]
}, {
  pk: 2579,
  ang: "Yaur",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Yaur",
  lc: "jau",
  ld: "ltr",
  alt: ["Jaur"],
  cc: ["ID"]
}, {
  pk: 7524,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Banyumasan",
  lc: "jav-x-banyu",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 7839,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Cirebon",
  lc: "jav-x-cirebon",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7825,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Jawa Timur",
  lc: "jav-x-jawatimur",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 8118,
  ang: "Tegal",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tegal",
  lc: "jav-x-tegal",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2580,
  ang: "Malay, Jambi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Jambi Malay",
  lc: "jax",
  ld: "ltr",
  alt: ["Batin", "Djambi", "Downstream Jambi Malay", "Upstream Jambi Malay"],
  cc: ["ID"]
}, {
  pk: 2581,
  ang: "Yan-nhangu",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yan-nhangu",
  lc: "jay",
  ld: "ltr",
  alt: ["Nangu", "Yanangu"],
  cc: ["AU"]
}, {
  pk: 2582,
  ang: "Jawe",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Jawe",
  lc: "jaz",
  ld: "ltr",
  alt: ["Diahoue", "Njawe", "Oubatch", "Ubach"],
  cc: ["NC"]
}, {
  pk: 2583,
  ang: "Judeo-Berber",
  lr: "Asia",
  gw: false,
  hc: "IL",
  ln: "\u05D1\u05E8\u05D1\u05E8\u05D9\u05EA \u05D9\u05D4\u05D5\u05D3\u05D9\u05EA",
  lc: "jbe",
  ld: "ltr",
  alt: [],
  cc: ["IL"]
}, {
  pk: 2584,
  ang: "Arandai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Arandai",
  lc: "jbj",
  ld: "ltr",
  alt: ["Jaban", "Sebyar", "Yaban", "Dombano (Arandai)"],
  cc: ["ID"]
}, {
  pk: 2585,
  ang: "Barikewa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Barikewa",
  lc: "jbk",
  ld: "ltr",
  alt: ["Iba"],
  cc: ["PG"]
}, {
  pk: 2586,
  ang: "Nafusi",
  lr: "Africa",
  gw: false,
  hc: "LY",
  ln: "\u2D5C\u2D30\u2D4F\u2D3C\u2D53\u2D59\u2D49\u2D5C",
  lc: "jbn",
  ld: "ltr",
  alt: ["Djerbi", "Jabal Nafusi", "Jbel Nafusi", "Jebel Nefusi", "Nefusi", "Tunisian Berber", "Jerba (Djerbi)", "Zwara", "Zuwarah", "Zuraa", "Zuara (Zouara)", "Jerbi (Jerba)", "Jbali-Tamezret (Duwinna)", "Guelili", "Tamezret (Duwinna)"],
  cc: ["TN", "LY"]
}, {
  pk: 2587,
  ang: "",
  lr: "",
  gw: false,
  hc: "",
  ln: "Lojban",
  lc: "jbo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2588,
  ang: "Jofotek-Bromnya",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Jofotek-Bromnya",
  lc: "jbr",
  ld: "ltr",
  alt: ["Jofotek", "Bromnya"],
  cc: ["ID"]
}, {
  pk: 2589,
  ang: "Jabut\xED",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Jabut\xED",
  lc: "jbt",
  ld: "ltr",
  alt: ["Djeoromitxi", "Jabot\xED", "Jeoromitxi", "Yabut\xED"],
  cc: ["BR"]
}, {
  pk: 2590,
  ang: "Jukun Takum",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Jukun Takum",
  lc: "jbu",
  ld: "ltr",
  alt: ["Diyu", "Jukun", "Njikum", "Diyi", "Donga (Akpanzhi)"],
  cc: ["CM"]
}, {
  pk: 8275,
  ang: "Fete",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Fete",
  lc: "jbu-x-fete",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2591,
  ang: "Yawijibaya",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yawijibaya",
  lc: "jbw",
  ld: "ltr",
  alt: ["Bergalgu", "Jadjiba", "Jadjibaia", "Jaudjibaia", "Jaudjibara", "Jaudji-Bara", "Jawadjag", "Jawdjibaia", "Jawdjibara", "Jawdjobara", "Jawutjubar", "Winjawindjagu", "Yaudjibaia", "Yaudjibara", "Yaujibaia", "Yawjibara", "Yawjibarra"],
  cc: ["AU"]
}, {
  pk: 2592,
  ang: "Jamaican Country Sign Language",
  lr: "Americas",
  gw: false,
  hc: "JM",
  ln: "Jamaican Country Sign Language",
  lc: "jcs",
  ld: "ltr",
  alt: ["Country Sign", "Konchri Sain"],
  cc: ["JM"]
}, {
  pk: 2593,
  ang: "Krimchak",
  lr: "Europe",
  gw: false,
  hc: "UA",
  ln: "Krymchak",
  lc: "jct",
  ld: "ltr",
  alt: ["Judeo-Crimean Turkish"],
  cc: ["UA"]
}, {
  pk: 2594,
  ang: "Jad",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Jad",
  lc: "jda",
  ld: "ltr",
  alt: ["Bhotia", "Dzad", "Rongba"],
  cc: ["IN"]
}, {
  pk: 2595,
  ang: "Jadgali",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "Jadgali",
  lc: "jdg",
  ld: "ltr",
  alt: ["Jat", "Jatgali", "Jatki"],
  cc: ["PK"]
}, {
  pk: 2596,
  ang: "Judeo-Tat",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0413\u043E\u0440\u0441\u043A\u043E-\u0435\u0432\u0440\u0435\u0439\u0441\u043A\u0438\u0439",
  lc: "jdt",
  ld: "ltr",
  alt: ["Bik", "Dzhuhuric", "Jewish Tat", "Judeo-Tatic", "Juhur", "Juhuri", "Juwri", "Tati", "Hebrew Tat", "Lahji", "Mountain Jewish", "Musulman Tats", "South Tat", "North Tat"],
  cc: ["IL", "RU"]
}, {
  pk: 2597,
  ang: "Jebero",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Jebero",
  lc: "jeb",
  ld: "ltr",
  alt: ["Chebero", "Shiwilu", "Xebero", "Xihuila"],
  cc: ["PE"]
}, {
  pk: 2598,
  ang: "Jerung",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Jerung",
  lc: "jee",
  ld: "ltr",
  alt: ["Jero", "Jero Mala", "Jerum", "Jerunge", "Jherung", "Zero", "Zero Mala", "Zerum", "Ratnawati (Sindhuli)"],
  cc: ["NP"]
}, {
  pk: 2599,
  ang: "Jeng",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Jeng",
  lc: "jeg",
  ld: "ltr",
  alt: ["Cheng", "Chiengceng"],
  cc: ["LA"]
}, {
  pk: 8388,
  ang: "Lawi",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Lawi",
  lc: "jeg-x-lawi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2600,
  ang: "Jeh",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Jeh",
  lc: "jeh",
  ld: "ltr",
  alt: ["Die", "Gie", "Yeh", "Jeh Bri La (Bri-La)"],
  cc: ["LA", "VN"]
}, {
  pk: 2601,
  ang: "Yei",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Yei",
  lc: "jei",
  ld: "ltr",
  alt: ["Je", "Jei", "Yei-Nan"],
  cc: ["ID", "PG"]
}, {
  pk: 2602,
  ang: "Jeri Kuo",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Jeri Kuo",
  lc: "jek",
  ld: "ltr",
  alt: ["Celle", "Jeli Kuo"],
  cc: ["CI"]
}, {
  pk: 2603,
  ang: "Yelmek",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Yelmek",
  lc: "jel",
  ld: "ltr",
  alt: ["Jab", "Jabsch", "Jelmek", "Jelmik"],
  cc: ["ID"]
}, {
  pk: 2604,
  ang: "Dza",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Dza",
  lc: "jen",
  ld: "ltr",
  alt: ["Janjo", "Jenjo", "Jaule (Joole)", "Laredo (Ardido)"],
  cc: ["NG"]
}, {
  pk: 2605,
  ang: "Jere",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Jere",
  lc: "jer",
  ld: "ltr",
  alt: ["Jeere", "Jera", "Rebina", "Gurrum", "Gusu (Anibau)", "Guzawa, Isanga,", "Ibunu", "Jengre", "Narabunu", "Gusawa", "Jeriyawa", "Anorubuna", "Gesawa", "Ezelle (Azelle)", "Eboze", "Bunu (Anegorom)", "Boze (Anabeze)", "Asanga", "Anosangobari", "Gussum"],
  cc: ["NG"]
}, {
  pk: 2606,
  ang: "Manem",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Manem",
  lc: "jet",
  ld: "ltr",
  alt: ["Jeti", "Skofro", "Wembi", "Yeti"],
  cc: ["ID", "PG"]
}, {
  pk: 2607,
  ang: "Jonkor Bourmataguil",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Jonkor Bourmataguil",
  lc: "jeu",
  ld: "ltr",
  alt: ["Djongor Bourmataguil", "Karakir"],
  cc: ["TD"]
}, {
  pk: 2608,
  ang: "Judeo-Georgian",
  lr: "Asia",
  gw: false,
  hc: "IL",
  ln: "\u05D1\u05E8\u05D1\u05E8\u05D9\u05EA \u05D9\u05D4\u05D5\u05D3\u05D9\u05EA",
  lc: "jge",
  ld: "rtl",
  alt: [],
  cc: ["IL"]
}, {
  pk: 2609,
  ang: "Gwak",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Gwak",
  lc: "jgk",
  ld: "ltr",
  alt: ["Jar", "Jaracin Kasa", "Jaranchi", "Jaranci", "Jarancin Kasa", "Jarawa", "Jarawan Bununu", "Jarawan Kasa"],
  cc: ["NG"]
}, {
  pk: 2610,
  ang: "Ngomba",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Ngomba",
  lc: "jgo",
  ld: "ltr",
  alt: ["Bamileke-Ngomba", "Ndaa", "Nda'a", "Babete (Bamete)"],
  cc: ["CM"]
}, {
  pk: 2611,
  ang: "Jehai",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Jehai",
  lc: "jhi",
  ld: "ltr",
  alt: ["Jahai", "Pangan"],
  cc: ["MY"]
}, {
  pk: 2612,
  ang: "Jhankot Sign Language",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Jhankot Sign Language",
  lc: "jhs",
  ld: "ltr",
  alt: [],
  cc: ["NP"]
}, {
  pk: 2613,
  ang: "Jina",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Jina",
  lc: "jia",
  ld: "ltr",
  alt: ["Zina", "Muxule (Muxuli)", "Ngodeni", "Tchide (Sede)", "Jina (Zine)"],
  cc: ["CM"]
}, {
  pk: 2614,
  ang: "Jibu",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Jibu",
  lc: "jib",
  ld: "ltr",
  alt: ["Jibanci", "Jibawa"],
  cc: ["NG"]
}, {
  pk: 2615,
  ang: "Tol",
  lr: "Americas",
  gw: false,
  hc: "HN",
  ln: "Tol",
  lc: "jic",
  ld: "ltr",
  alt: ["Tolpan", "Xicaque"],
  cc: ["HN"]
}, {
  pk: 2616,
  ang: "Bu",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bu",
  lc: "jid",
  ld: "ltr",
  alt: ["Ibut", "Jida", "Jida-Abu", "Jidda-Abu", "Nakare", "Ninkada (Jida)", "Bu (Abu)"],
  cc: ["NG"]
}, {
  pk: 2617,
  ang: "Jilbe",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Jilbe",
  lc: "jie",
  ld: "ltr",
  alt: ["Zoulbou"],
  cc: ["NG"]
}, {
  pk: 2618,
  ang: "Djingili",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Djingili",
  lc: "jig",
  ld: "ltr",
  alt: ["Chingalee", "Chunguloo", "Djingila", "Djingulu", "Jingali", "Jingulu", "Lee", "Tchingalee", "Tjingilu"],
  cc: ["AU"]
}, {
  pk: 2619,
  ang: "sTodsde",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u9053\u5B5A\u8BED",
  lc: "jih",
  ld: "ltr",
  alt: ["Western Jiarong"],
  cc: ["CN"]
}, {
  pk: 2620,
  ang: "Jiiddu",
  lr: "Africa",
  gw: false,
  hc: "SO",
  ln: "Jiiddu",
  lc: "jii",
  ld: "ltr",
  alt: ["Af-Jiiddu", "Jiddu"],
  cc: ["SO"]
}, {
  pk: 2621,
  ang: "Jilim",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Jilim",
  lc: "jil",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2622,
  ang: "Jimi",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Jimi (Cameroon)",
  lc: "jim",
  ld: "ltr",
  alt: ["Jimjimen", "Um Falin", "Zumu", "Zumo (Zame)", "Wadi (Wa'i)", "Zomo"],
  cc: ["CM"]
}, {
  pk: 2623,
  ang: "Jiamao",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u52A0\u8302",
  lc: "jio",
  ld: "ltr",
  alt: ["Gevou", "Kamau", "Ku vou", "Tai"],
  cc: ["CN"]
}, {
  pk: 2624,
  ang: "Lavrung",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u7EF0\u65AF\u7532\u8BED",
  lc: "jiq",
  ld: "ltr",
  alt: ["Guanyingqiao", "Western Jiarong", "Zhongzhai", "Ere", "Ergali", "Muerzong", "Siyaowu", "Taiyanghe", "Xiaoyili", "Yelong"],
  cc: ["CN"]
}, {
  pk: 2625,
  ang: "Jita",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Jita",
  lc: "jit",
  ld: "ltr",
  alt: ["Echijita", "Ecijita"],
  cc: ["TZ"]
}, {
  pk: 2626,
  ang: "Jinuo, Youle",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6538\u4E50\u57FA\u8BFA\u8BED",
  lc: "jiu",
  ld: "ltr",
  alt: ["Youle"],
  cc: ["CN"]
}, {
  pk: 2627,
  ang: "Shuar",
  lr: "Americas",
  gw: false,
  hc: "EC",
  ln: "Shuar",
  lc: "jiv",
  ld: "ltr",
  alt: ["Chiwaro", "Jivaro", "Shuara", "Xivaro", "Jibaro"],
  cc: ["EC"]
}, {
  pk: 2628,
  ang: "Jinuo, Buyuan",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u8865\u8FDC\u57FA\u8BFA\u8BED",
  lc: "jiy",
  ld: "ltr",
  alt: ["Buyuan", "Jino"],
  cc: ["CN"]
}, {
  pk: 2629,
  ang: "Jejueo",
  lr: "Asia",
  gw: false,
  hc: "KR",
  ln: "Jejueo",
  lc: "jje",
  ld: "ltr",
  alt: [],
  cc: ["KR"]
}, {
  pk: 2630,
  ang: "Bankal",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bankal",
  lc: "jjr",
  ld: "ltr",
  alt: ["Bankala", "Bankalanci", "Baranci", "Jaranchi", "Jaranci", "Jarancin Kasa", "Jarawa", "Jarawan Kasa", "Zhar"],
  cc: ["NG"]
}, {
  pk: 2631,
  ang: "Karen, Mobwa",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Mobwa Karen",
  lc: "jkm",
  ld: "ltr",
  alt: ["Bilichi", "Blimaw", "Maleh", "Mopwa", "Palachi", "Palakhi"],
  cc: ["MM"]
}, {
  pk: 2632,
  ang: "Kubo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kubo",
  lc: "jko",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2633,
  ang: "Karen, Paku",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Paku Karen",
  lc: "jkp",
  ld: "ltr",
  alt: ["Mogpha", "Mogwa", "Monebwa", "Monnepwa", "Mopaga", "Mopha", "Pagu", "Paku", "Thalwepwe"],
  cc: ["MM"]
}, {
  pk: 2634,
  ang: "Koro",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Koro (India)",
  lc: "jkr",
  ld: "ltr",
  alt: ["Aka Koro"],
  cc: ["IN"]
}, {
  pk: 2635,
  ang: "Labir",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Labir",
  lc: "jku",
  ld: "ltr",
  alt: ["Jakanci", "Jaku"],
  cc: ["NG"]
}, {
  pk: 2636,
  ang: "Ngile",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Ngile",
  lc: "jle",
  ld: "ltr",
  alt: ["Daloka", "Darra", "Masakin", "Mesakin", "Taloka", "Masakin Tuwal", "Daloka (Taloka)"],
  cc: ["SD"]
}, {
  pk: 2637,
  ang: "Jamaican Sign Language",
  lr: "Americas",
  gw: false,
  hc: "JM",
  ln: "Jamaican Sign Language",
  lc: "jls",
  ld: "ltr",
  alt: ["JSL"],
  cc: ["JM"]
}, {
  pk: 2638,
  ang: "Dima",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Dima",
  lc: "jma",
  ld: "ltr",
  alt: ["Dimadima", "Jimajima"],
  cc: ["PG"]
}, {
  pk: 2639,
  ang: "Zumbun",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Zumbun",
  lc: "jmb",
  ld: "ltr",
  alt: ["Jimbin", "Jimbinawa"],
  cc: ["NG"]
}, {
  pk: 2640,
  ang: "Machame",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Machame",
  lc: "jmc",
  ld: "ltr",
  alt: ["Kimachame", "Kimashami", "Machambe", "Siha (Shira)", "Ng'uni", "Bosho", "Hai", "Masdama"],
  cc: ["TZ"]
}, {
  pk: 2641,
  ang: "Yamdena",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Yamdena",
  lc: "jmd",
  ld: "ltr",
  alt: ["Jamden", "Jamdena", "Tanemprar lirin", "North Yamdena (Nus Das)", "South Yamdena (Nus Bab)"],
  cc: ["ID"]
}, {
  pk: 2642,
  ang: "Jimi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Jimi (Nigeria)",
  lc: "jmi",
  ld: "ltr",
  alt: ["Bi-Gimu"],
  cc: ["NG"]
}, {
  pk: 2643,
  ang: "Jumli",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Jumli",
  lc: "jml",
  ld: "ltr",
  alt: ["Central Nepali", "Jumla", "Khas Kura", "Sijali", "Singja", "Sinjali", "Paanchsai", "Sinja", "Chaudhabis", "Asi"],
  cc: ["NP"]
}, {
  pk: 2644,
  ang: "Naga, Makuri",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Makuri Naga",
  lc: "jmn",
  ld: "ltr",
  alt: ["Makury Naga", "Shaera", "Makury", "Kyaungphuri (Shu)", "Kyile", "Makhwale", "Saingphule (Saingpuri)", "Shera (Shaera)", "Arale"],
  cc: ["MM"]
}, {
  pk: 2645,
  ang: "Kamara",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Kamara",
  lc: "jmr",
  ld: "ltr",
  alt: [],
  cc: ["GH"]
}, {
  pk: 2646,
  ang: "Mashi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Mashi (Nigeria)",
  lc: "jms",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 2647,
  ang: "Mouwase",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mouwase",
  lc: "jmw",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2648,
  ang: "Mixtec, Western Juxtlahuaca",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Western Juxtlahuaca Mixtec",
  lc: "jmx",
  ld: "ltr",
  alt: ["Coicoy\xE1n Mixtec", "Mixteco del Oeste de Juxtlahuaca", "San Juan Pi\xF1as", "Coicoy\xE1n"],
  cc: ["MX"]
}, {
  pk: 2649,
  ang: "Jangshung",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Jangshung",
  lc: "jna",
  ld: "ltr",
  alt: ["Central Kinnauri", "Jangiam", "Jangrami", "Thebarskad", "Thebor", "Theb\xF6r Skadd", "Zangram", "Zhang-Zhung"],
  cc: ["IN"]
}, {
  pk: 2650,
  ang: "Jandavra",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "Jandavra",
  lc: "jnd",
  ld: "ltr",
  alt: ["Jhandoria"],
  cc: ["PK"]
}, {
  pk: 2651,
  ang: "Yangman",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yangman",
  lc: "jng",
  ld: "ltr",
  alt: ["Dagoman", "Jungman"],
  cc: ["AU"]
}, {
  pk: 2652,
  ang: "Janji",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Janji",
  lc: "jni",
  ld: "ltr",
  alt: ["Ajanji", "Anafejanzi", "Jenji", "Tijanji"],
  cc: ["NG"]
}, {
  pk: 2653,
  ang: "Yemsa",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Yemsa",
  lc: "jnj",
  ld: "ltr",
  alt: ["Yem", "Yemma", "Janjerinya", "Janjero", "Janjor", "Yangaro", "Zinjero"],
  cc: ["ET"]
}, {
  pk: 2654,
  ang: "Rawat",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Rawat",
  lc: "jnl",
  ld: "ltr",
  alt: ["Ban Manus", "Ban Rauts", "Bhulla", "Dzanggali", "Jangali", "Janggali", "Jhangar", "Raji", "Raut"],
  cc: ["NP", "IN"]
}, {
  pk: 2655,
  ang: "Jaunsari",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Jaunsari",
  lc: "jns",
  ld: "ltr",
  alt: ["Jansauri", "Jaunsauri", "Pahari", "Jaunsari-Bawari"],
  cc: ["IN"]
}, {
  pk: 2656,
  ang: "Joba",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Joba",
  lc: "job",
  ld: "ltr",
  alt: ["Kijoba", "Kivira", "Loba"],
  cc: ["TZ", "CD"]
}, {
  pk: 8452,
  ang: "Kivira",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kivira",
  lc: "job-x-kivira",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2657,
  ang: "Wojenaka",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Wojenaka",
  lc: "jod",
  ld: "ltr",
  alt: ["Malink\xE9", "Odienn\xE9 Jula", "Odiennekakan", "Juraba", "Samogo", "Wassulunka", "Wassulunke", "Wasulu (Wassoulounka)"],
  cc: ["CI"]
}, {
  pk: 7511,
  ang: "Jogi",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "Jogi",
  lc: "jog",
  ld: "ltr",
  alt: [],
  cc: ["PK"]
}, {
  pk: 2658,
  ang: "Jordanian Sign Language",
  lr: "Asia",
  gw: false,
  hc: "JO",
  ln: "Jordanian Sign Language",
  lc: "jos",
  ld: "ltr",
  alt: ["LIU", "Lughat il-Ishaarah il-Urduniyyah"],
  cc: ["JO"]
}, {
  pk: 2659,
  ang: "Jowulu",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Jowulu",
  lc: "jow",
  ld: "ltr",
  alt: ["Samogho"],
  cc: ["BF", "ML"]
}, {
  pk: 2660,
  ang: "Jewish Palestinian Aramaic",
  lr: "Asia",
  gw: false,
  hc: "SY",
  ln: "Jewish Palestinian Aramaic",
  lc: "jpa",
  ld: "ltr",
  alt: [],
  cc: ["SY"]
}, {
  pk: 2661,
  ang: "Dzhidi",
  lr: "Asia",
  gw: false,
  hc: "IL",
  ln: "\u05D4\u05E4\u05E8\u05E1\u05D9\u05EA-\u05D9\u05D4\u05D5\u05D3\u05D9\u05EA",
  lc: "jpr",
  ld: "rtl",
  alt: ["Judeo-Persian", "Djudi", "Judi"],
  cc: ["AF", "IR", "IL"]
}, {
  pk: 2662,
  ang: "Jaqaru",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Jaqaru",
  lc: "jqr",
  ld: "ltr",
  alt: ["Aru", "Haqaru", "Haq'aru", "Haqearu", "Cauqui (Cachuy)"],
  cc: ["PE"]
}, {
  pk: 2663,
  ang: "Jarai",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Ti\u1EBFng Gia Rai",
  lc: "jra",
  ld: "ltr",
  alt: ["Chor", "Cho-Rai", "Chrai", "Djarai", "Gia-Rai", "Gio-Rai", "Jorai", "Mthur", "Habau (Ho-Bau)", "Hodrung (Hdrung)"],
  cc: ["KH", "VN"]
}, {
  pk: 2664,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IL",
  ln: "\u05E2\u05E8\u05D1\u05D9\u05EA \u05D9\u05D4\u05D5\u05D3\u05D9\u05EA",
  lc: "jrb",
  ld: "rtl",
  alt: [],
  cc: ["IL"]
}, {
  pk: 2665,
  ang: "Jiru",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Jiru",
  lc: "jrr",
  ld: "ltr",
  alt: ["Atak", "Kir", "Wiyap", "Zhiru"],
  cc: ["NG"]
}, {
  pk: 2666,
  ang: "Jorto",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Jorto",
  lc: "jrt",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 2667,
  ang: "Japreria",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "Japrer\xEDa",
  lc: "jru",
  ld: "ltr",
  alt: ["Yapreria"],
  cc: ["VE"]
}, {
  pk: 2668,
  ang: "Japanese Sign Language",
  lr: "Asia",
  gw: false,
  hc: "JP",
  ln: "\u65E5\u672C\u624B\u8A71",
  lc: "jsl",
  ld: "ltr",
  alt: ["Shuwa", "Temane"],
  cc: ["JP"]
}, {
  pk: 2669,
  ang: "J\xFAma",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "J\xFAma",
  lc: "jua",
  ld: "ltr",
  alt: ["Arara", "Kagwahibm", "Kagwahiph", "Kagwahiv", "Kavahiva", "Kawahip", "Kawaib", "Yum\xE1"],
  cc: ["BR"]
}, {
  pk: 2670,
  ang: "Wannu",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Wannu",
  lc: "jub",
  ld: "ltr",
  alt: ["Abinsi", "Awannu", "Jukun Abinsi", "River Jukun"],
  cc: ["NG"]
}, {
  pk: 2671,
  ang: "Jurchen",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Jurchen",
  lc: "juc",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 2672,
  ang: "Worodougou",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Worodougou",
  lc: "jud",
  ld: "ltr",
  alt: ["Bakokan", "Ouorodougou", "Worodougou Jula", "Worodougoukakan", "Worodugu"],
  cc: ["CI"]
}, {
  pk: 2673,
  ang: "H\xF5ne",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "H\xF5ne",
  lc: "juh",
  ld: "ltr",
  alt: ["Gwana", "Pindiga"],
  cc: ["NG"]
}, {
  pk: 2674,
  ang: "Wapan",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Wapan",
  lc: "juk",
  ld: "ltr",
  alt: ["Jinkum", "Jukon", "Juku", "Juku Junkun", "Jukum", "Jukun Wapan", "Jukun Wukari", "Wakari", "Wap\xE3"],
  cc: ["NG"]
}, {
  pk: 2675,
  ang: "Jirel",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Jirel",
  lc: "jul",
  ld: "ltr",
  alt: ["Jiri", "Jirial", "Ziral"],
  cc: ["NP"]
}, {
  pk: 2676,
  ang: "Jumjum",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Jumjum",
  lc: "jum",
  ld: "ltr",
  alt: ["Berin", "Olga", "Wadega"],
  cc: ["SD"]
}, {
  pk: 2677,
  ang: "Juang",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Juang",
  lc: "jun",
  ld: "ltr",
  alt: ["Patra-Saara", "Patua", "Puttooas"],
  cc: ["IN"]
}, {
  pk: 2678,
  ang: "Jiba",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Jiba",
  lc: "juo",
  ld: "ltr",
  alt: ["Jibe", "Jibi", "Jukun Kona"],
  cc: ["NG"]
}, {
  pk: 2679,
  ang: "Hupd\xEB",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Hupd\xEB",
  lc: "jup",
  ld: "ltr",
  alt: ["Hup", "Hupda", "Jupde", "Ubd\xE9", "Hupd\xE1 Mak\xFA", "Jupd\xE1 Mac\xFA", "Mac\xFA de Tucano", "Mak\xFA-Hupd\xE1", "Hupd\xEB"],
  cc: ["BR", "CO"]
}, {
  pk: 2680,
  ang: "Jur\xFAna",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Jur\xFAna",
  lc: "jur",
  ld: "ltr",
  alt: ["Iuruna", "Jaruna", "Yudya", "Yur\xFAna"],
  cc: ["BR"]
}, {
  pk: 2681,
  ang: "Jumla Sign Language",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Jumla Sign Language",
  lc: "jus",
  ld: "ltr",
  alt: [],
  cc: ["NP"]
}, {
  pk: 2682,
  ang: "Jutish",
  lr: "Europe",
  gw: false,
  hc: "DK",
  ln: "Jutish",
  lc: "jut",
  ld: "ltr",
  alt: ["Jutlandish", "Jysk", "Western Danish"],
  cc: ["DK"]
}, {
  pk: 2683,
  ang: "Ju",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ju",
  lc: "juu",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 2684,
  ang: "W\xE3pha",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "W\xE3pha",
  lc: "juw",
  ld: "ltr",
  alt: ["Wase Tofa"],
  cc: ["NG"]
}, {
  pk: 2685,
  ang: "Juray",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Juray",
  lc: "juy",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 2686,
  ang: "Javanese",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "basa Jawa",
  lc: "jv",
  ld: "ltr",
  alt: ["Djawa", "Cirebon (Cheribon)", "Tjirebon", "Surakarta (Sawlaw)", "Surabaya", "Solo"],
  cc: ["ID", "CX", "NL", "US", "AU", "SG"]
}, {
  pk: 2687,
  ang: "Javindo",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Javindo",
  lc: "jvd",
  ld: "ltr",
  alt: ["Krontjong"],
  cc: ["ID"]
}, {
  pk: 2688,
  ang: "Javanese, Suriname",
  lr: "Americas",
  gw: false,
  hc: "SR",
  ln: "Caribbean Javanese",
  lc: "jvn",
  ld: "ltr",
  alt: ["Suriname Javanese"],
  cc: ["GF", "SR"]
}, {
  pk: 2689,
  ang: "Jwira-Pepesa",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Jwira-Pepesa",
  lc: "jwi",
  ld: "ltr",
  alt: ["Pepesa-Jwira"],
  cc: ["GH"]
}, {
  pk: 2690,
  ang: "Jiarong",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u0F62\u0F92\u0FB1\u0F63\u0F0B\u0F62\u0F7C\u0F44",
  lc: "jya",
  ld: "ltr",
  alt: ["Chiarong", "Gyarong", "Gyarung", "Jarong", "Jyarung", "Keru", "Rgyarong", "Northwestern Jiarong", "Situ (Eastern Jiarong)", "Western Jiarong", "Sidaba (Caodeng)", "Northeastern Jiarong", "Chabao (Central Jiarong)", "Northern Jiarong", "Dazang"],
  cc: ["CN"]
}, {
  pk: 2691,
  ang: "Arabic, Judeo-Yemeni",
  lr: "Asia",
  gw: false,
  hc: "IL",
  ln: "\u05D9\u05D4\u05D5\u05D3\u05D9\u05EA-\u05EA\u05D9\u05DE\u05E0\u05D9\u05EA",
  lc: "jye",
  ld: "rtl",
  alt: ["Judeo-Yemeni", "Yemenite Judeo-Arabic", "Aden", "Be:da", "San'a"],
  cc: ["IL"]
}, {
  pk: 2692,
  ang: "Jaya",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Jaya",
  lc: "jyy",
  ld: "ltr",
  alt: [],
  cc: ["TD"]
}, {
  pk: 2693,
  ang: "Georgian",
  lr: "Asia",
  gw: false,
  hc: "GE",
  ln: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8",
  lc: "ka",
  ld: "ltr",
  alt: ["Common Kartvelian", "Gruzinski", "Kartuli", "Gruzin", "Adzhar (Acharian)", "Fereydan (Ferejdan)", "Kaxetian (Kakhetian)", "Moxev (Mokhev)", "Racha-Lexchxum (Lechkhum)", "Xevsur (Kheysur)"],
  cc: ["AZ", "BE", "FR", "IR", "KZ", "TJ", "TR", "US", "CA", "GE", "KG", "TM", "UZ"]
}, {
  pk: 2694,
  ang: "Karakalpak",
  lr: "Asia",
  gw: false,
  hc: "UZ",
  ln: "Kara-Kalpak",
  lc: "kaa",
  ld: "ltr",
  alt: ["Karaklobuk", "Klobouki", "Tchorny"],
  cc: ["KZ", "KG", "TM", "UZ"]
}, {
  pk: 2695,
  ang: "Kabyle",
  lr: "Africa",
  gw: false,
  hc: "DZ",
  ln: "\u0644\u0647\u062C\u0629 \u0642\u0628\u0627\u0626\u0644\u064A\u0629",
  lc: "kab",
  ld: "ltr",
  alt: ["Amazigh", "Tamazight", "Taqbaylit", "Lesser Kabyle (Tasahlit)"],
  cc: ["DZ", "BE", "FR", "CA"]
}, {
  pk: 8110,
  ang: "Tasahlit",
  lr: "Africa",
  gw: false,
  hc: "DZ",
  ln: "Tasahlit",
  lc: "kab-x-tasahlit",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2696,
  ang: "Jingpho",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Kachin",
  lc: "kac",
  ld: "ltr",
  alt: ["Chingpaw", "Chingp'o", "Dashanhua", "Jinghpaw", "Jingpo", "Marip", "Hkauri", "Xidan", "Shidan (Satanka)", "Nkhumka", "Mengzhi", "Khauri", "Kauri (Gauri)", "Hkaku (Hka-Hku)", "Enkun (Nkhum)", "Dzili (Jili)", "Kauzhika"],
  cc: ["CN", "US", "MM"]
}, {
  pk: 2697,
  ang: "Adara",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Adara",
  lc: "kad",
  ld: "ltr",
  alt: ["Ada (E'da)", "Adara (Kadara)", "Eneje (Aji)", "Misiyen", "Misiyo"],
  cc: ["NG"]
}, {
  pk: 2698,
  ang: "Katso",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5361\u5353",
  lc: "kaf",
  ld: "ltr",
  alt: ["Gazhuo", "Gezhuo", "Kazhuo"],
  cc: ["CN"]
}, {
  pk: 2699,
  ang: "Kajaman",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Kajaman",
  lc: "kag",
  ld: "ltr",
  alt: ["Kayaman", "Kejaman"],
  cc: ["MY"]
}, {
  pk: 2700,
  ang: "Kara",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Kara (Central African Republic)",
  lc: "kah",
  ld: "ltr",
  alt: ["Fer", "Fertit"],
  cc: ["CF", "SD"]
}, {
  pk: 2701,
  ang: "Karekare",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Karekare",
  lc: "kai",
  ld: "ltr",
  alt: ["Karai Karai", "Karaikarai", "Kerekere", "Kerrikerri", "Jalalam (West Karekare)"],
  cc: ["NG"]
}, {
  pk: 2702,
  ang: "Jju",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Jju",
  lc: "kaj",
  ld: "ltr",
  alt: ["Kache", "Kaje", "Kajji"],
  cc: ["NG"]
}, {
  pk: 2703,
  ang: "Kallahan, Kayapa",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kayapa Kallahan",
  lc: "kak",
  ld: "ltr",
  alt: ["Ikalahan", "Kalangoya-Ikalahan", "Kalanguya", "Central Kalanguya (Kayapa)", "Northern Kalanguya (Ambaguio)", "Southern Kalanguya (Santa Fe)"],
  cc: ["PH"]
}, {
  pk: 2704,
  ang: "Kamba",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Kamba (Kenya)",
  lc: "kam",
  ld: "ltr",
  alt: ["Kekamba", "South Kitui"],
  cc: ["KE", "TZ", "UG"]
}, {
  pk: 7774,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Aruvu",
  lc: "kan-x-aruvu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8403,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bavari",
  lc: "kan-x-bavari",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8408,
  ang: "Khacha",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Khacha",
  lc: "kan-x-khacha",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8405,
  ang: "Koungaru",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Koungaru",
  lc: "kan-x-koungaru",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8128,
  ang: "Kudipottila",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kudipottila",
  lc: "kan-x-kudipottila",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8374,
  ang: "Lambadi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Lambadi (Kannada script)",
  lc: "kan-x-lambadi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8129,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Palligaru",
  lc: "kan-x-palligaru",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7773,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Thigularu",
  lc: "kan-x-thigularu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8376,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Waddar (Kannada script)",
  lc: "kan-x-waddar",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8416,
  ang: "Yekalavya",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Yekalavya",
  lc: "kan-x-yekalavya",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2705,
  ang: "Xaasongaxango",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Xaasongaxango",
  lc: "kao",
  ld: "ltr",
  alt: ["Kasonke", "Kasso", "Kasson", "Kassonke", "Khasonke", "Khassonka", "Khassonk\xE9", "Malinke", "Maninka", "Xaasonga", "Xasonga", "Xasonke", "K\xE9ni\xE9ba Maninka", "Jahanka"],
  cc: ["GM", "ML", "SN"]
}, {
  pk: 2706,
  ang: "Bezhta",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0411\u0435\u0436\u0442\u0438\u043D\u0441\u043A\u0438\u0439",
  lc: "kap",
  ld: "ltr",
  alt: ["Bazht'", "Bazht'al", "Bechitin", "Bexita", "Bezheta", "Bezhita", "Bezhituri", "Bezhti", "Kapucha", "Kapuchin", "Kapuchin-Gunzib", "Kapuchuri", "Khvanal", "Kiburabi", "Kupuca", "Bezhta proper"],
  cc: ["RU"]
}, {
  pk: 2707,
  ang: "Capanahua",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Capanahua",
  lc: "kaq",
  ld: "ltr",
  alt: ["Kapanawa"],
  cc: ["PE"]
}, {
  pk: 2708,
  ang: "Katuk\xEDna",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Katuk\xEDna",
  lc: "kav",
  ld: "ltr",
  alt: ["Catuquina", "Katukina do Juta\xED", "Katukina do Rio Bi\xE1", "Pid\xE1-Djap\xE1", "Cutiadapa (Kutia-Dyapa)"],
  cc: ["BR"]
}, {
  pk: 2709,
  ang: "Kawi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kawi",
  lc: "kaw",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 2710,
  ang: "Kao",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kao",
  lc: "kax",
  ld: "ltr",
  alt: ["Kau", "Ka'u"],
  cc: ["ID"]
}, {
  pk: 2711,
  ang: "Kamayur\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Kamayur\xE1",
  lc: "kay",
  ld: "ltr",
  alt: ["Camaiura", "Kamaiur\xE1", "Kamayir\xE1"],
  cc: ["BR"]
}, {
  pk: 7785,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Qazaki",
  lc: "kaz-x-qazaqi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2712,
  ang: "Kaxui\xE2na",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Kaxui\xE2na",
  lc: "kbb",
  ld: "ltr",
  alt: ["Pawiyana (Pawixi)", "Kachuana", "Kashujana", "Kashuyana", "Kax\xFAyana", "Warikiana", "Warikyana"],
  cc: ["BR"]
}, {
  pk: 2713,
  ang: "Kadiw\xE9u",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Kadiw\xE9u",
  lc: "kbc",
  ld: "ltr",
  alt: ["Caduv\xE9o", "Ediu-Adig", "Mbaya-Guaikuru"],
  cc: ["BR"]
}, {
  pk: 2714,
  ang: "Kabardian",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u043A\u044A\u044D\u0431\u044D\u0440\u0434\u0435\u0438\u0431\u0437\u044D",
  lc: "kbd",
  ld: "ltr",
  alt: ["East Circassian", "Kabard", "Kabardino-Cherkes", "Kabardo-Cherkess", "Upper Circassian", "Beslenei (Beslenej)"],
  cc: ["RU", "SA", "UZ"]
}, {
  pk: 2715,
  ang: "Kanju",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Kanju",
  lc: "kbe",
  ld: "ltr",
  alt: ["Gandanju", "Gandju", "Jabuda", "Kaantyu", "Kamdhue", "Kandju", "Kandyu", "Kanyu", "Karnu", "Neogulada", "Yaldiye-Ho"],
  cc: ["AU"]
}, {
  pk: 2716,
  ang: "Khamba",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Khamba",
  lc: "kbg",
  ld: "ltr",
  alt: ["Khamba Khaadi"],
  cc: ["IN"]
}, {
  pk: 2717,
  ang: "Cams\xE1",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Cams\xE1",
  lc: "kbh",
  ld: "ltr",
  alt: ["Cam\xEBnts\xEB\xE1", "Coche", "Kamemtxa", "Kamsa", "Kamse", "Sibundoy", "Sibundoy-Gach\xE9"],
  cc: ["CO"]
}, {
  pk: 2718,
  ang: "Kaptiau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kaptiau",
  lc: "kbi",
  ld: "ltr",
  alt: ["Kapitiauw", "Kaptiauw"],
  cc: ["ID"]
}, {
  pk: 2719,
  ang: "Kari",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kari",
  lc: "kbj",
  ld: "ltr",
  alt: ["Li-Kari-Li"],
  cc: ["CD"]
}, {
  pk: 2720,
  ang: "Koiari, Grass",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Grass Koiari",
  lc: "kbk",
  ld: "ltr",
  alt: ["Koiari", "Hogeri", "Lahada", "Omani"],
  cc: ["PG"]
}, {
  pk: 2721,
  ang: "Kanembu",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Kanembu",
  lc: "kbl",
  ld: "ltr",
  alt: ["Kanambu", "Kanuri"],
  cc: ["NE", "NG", "TD"]
}, {
  pk: 2722,
  ang: "Iwal",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Iwal",
  lc: "kbm",
  ld: "ltr",
  alt: ["Kaiwa"],
  cc: ["PG"]
}, {
  pk: 2723,
  ang: "Kare",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Kare (Central African Republic)",
  lc: "kbn",
  ld: "ltr",
  alt: ["Kali", "Karr\xE9", "Tale (Tali)"],
  cc: ["CM", "CF"]
}, {
  pk: 2724,
  ang: "Keliko",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Keliko",
  lc: "kbo",
  ld: "ltr",
  alt: ["Kaliko-Ma'di", "Ma'di", "Maditi"],
  cc: ["SS", "US"]
}, {
  pk: 2725,
  ang: "Kabiy\xE8",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Kabiy\xE8",
  lc: "kbp",
  ld: "ltr",
  alt: ["Cabrai", "Cabrais", "Kabure", "Kabye", "Kabire", "Lama-Tissi", "Kewe", "Kijang"],
  cc: ["BJ", "GH", "TG"]
}, {
  pk: 2726,
  ang: "Kamano",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kamano",
  lc: "kbq",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2727,
  ang: "Kafa",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Kafa",
  lc: "kbr",
  ld: "ltr",
  alt: ["Caffino", "Kaffa", "Kaficho", "Kefa", "Keffa", "Manjo", "Bosha (Garo)"],
  cc: ["ET"]
}, {
  pk: 2728,
  ang: "Kande",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Kande",
  lc: "kbs",
  ld: "ltr",
  alt: ["Kanda", "Okande"],
  cc: ["GA"]
}, {
  pk: 2729,
  ang: "Abadi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Abadi",
  lc: "kbt",
  ld: "ltr",
  alt: ["Kabadi"],
  cc: ["PG"]
}, {
  pk: 2730,
  ang: "Kabutra",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "Kabutra",
  lc: "kbu",
  ld: "ltr",
  alt: ["Nat", "Natra"],
  cc: ["PK"]
}, {
  pk: 2731,
  ang: "Dera",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dera (Indonesia)",
  lc: "kbv",
  ld: "ltr",
  alt: ["Dra", "Kamberataro", "Mangguar", "Komberatoro"],
  cc: ["ID", "PG"]
}, {
  pk: 2732,
  ang: "Kaiep",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kaiep",
  lc: "kbw",
  ld: "ltr",
  alt: ["Samap"],
  cc: ["PG"]
}, {
  pk: 2733,
  ang: "Ap Ma",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ap Ma",
  lc: "kbx",
  ld: "ltr",
  alt: ["Ap Ma Botin", "Kambot"],
  cc: ["PG"]
}, {
  pk: 2734,
  ang: "Kanuri, Manga",
  lr: "Africa",
  gw: false,
  hc: "NE",
  ln: "Manga Kanuri",
  lc: "kby",
  ld: "ltr",
  alt: ["Kanouri", "Kanoury"],
  cc: ["NE", "NG"]
}, {
  pk: 2735,
  ang: "Duhwa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Duhwa",
  lc: "kbz",
  ld: "ltr",
  alt: ["Kerifa", "Nzuhwi"],
  cc: ["NG"]
}, {
  pk: 2736,
  ang: "Khanty",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0425\u0430\u043D\u0442\u044B\u0439\u0441\u043A\u0438\u0439",
  lc: "kca",
  ld: "ltr",
  alt: ["Hanty", "Khant", "Khanti", "Ostyak", "Xanty", "Vach (Vasyugan)"],
  cc: ["RU"]
}, {
  pk: 8271,
  ang: "Khanty Kazim",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "Khanty Kazim",
  lc: "kca-x-kazim",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2737,
  ang: "Kawacha",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kawacha",
  lc: "kcb",
  ld: "ltr",
  alt: ["Kawatsa"],
  cc: ["PG"]
}, {
  pk: 2738,
  ang: "Lubila",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Lubila",
  lc: "kcc",
  ld: "ltr",
  alt: ["Kabila", "Kabire", "Lubilo", "Ofor", "Ojor"],
  cc: ["NG"]
}, {
  pk: 2739,
  ang: "Kanum, Ngk\xE2lmpw",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ngk\xE2lmpw Kanum",
  lc: "kcd",
  ld: "ltr",
  alt: ["Enkelembu", "Kenume", "Knwne"],
  cc: ["ID", "PG"]
}, {
  pk: 2740,
  ang: "Kaivi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kaivi",
  lc: "kce",
  ld: "ltr",
  alt: ["Kaibi"],
  cc: ["NG"]
}, {
  pk: 2741,
  ang: "Ukaan",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ukaan",
  lc: "kcf",
  ld: "ltr",
  alt: ["AIKA (Ayanran-Ishe-Kakumo-Auga)", "Anyaran", "Ikan", "Kakumo", "Iiagu", "Ujegbe (Ayegbe)", "Iyinno", "Ikaan", "Iisheu", "Ijion (Iinno)"],
  cc: ["NG"]
}, {
  pk: 2742,
  ang: "Tyap",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Tyap",
  lc: "kcg",
  ld: "ltr",
  alt: ["Katab", "Kataf", "Fantwam", "Kpashan", "Sholio (Aholio)", "Techera", "Katab (Atyap)", "Kagoro", "Kafanchan (Fantuan)", "Kachichere (Aticherak)", "Gworok (Agolok)", "Attakad", "Attaka", "Atakat (Atakar)", "Asholio", "Agwot", "Agwolok", "Aguro", "Agorok", "Daroro", "Takat"],
  cc: ["NG"]
}, {
  pk: 7698,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Takad",
  lc: "kcg-x-takad",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2743,
  ang: "Vono",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Vono",
  lc: "kch",
  ld: "ltr",
  alt: ["Kiballo"],
  cc: ["NG"]
}, {
  pk: 2744,
  ang: "Kamantan",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kamantan",
  lc: "kci",
  ld: "ltr",
  alt: ["Angan", "Kamanton"],
  cc: ["NG"]
}, {
  pk: 2745,
  ang: "Kobiana",
  lr: "Africa",
  gw: false,
  hc: "GW",
  ln: "Kobiana",
  lc: "kcj",
  ld: "ltr",
  alt: ["Buy", "Uboi"],
  cc: ["GW"]
}, {
  pk: 2746,
  ang: "Kalanga",
  lr: "Africa",
  gw: false,
  hc: "ZW",
  ln: "Kalanga",
  lc: "kck",
  ld: "ltr",
  alt: ["Chikalanga", "Kalaka", "Sekalaka", "Sekala\xF1a", "Tjikalanga", "Bakaa", "Kalana", "Kanana", "Makalaka", "Wakalanga", "Western Shona", "Nyai (Nyayi)", "Wanyai", "Nyai (Abanyai)", "Lilima (Humbe)", "Banyai", "Limima"],
  cc: ["ZW", "BW"]
}, {
  pk: 2747,
  ang: "Kala",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kela (Papua New Guinea)",
  lc: "kcl",
  ld: "ltr",
  alt: ["Gela", "Kelana", "Laukanu"],
  cc: ["PG"]
}, {
  pk: 2748,
  ang: "Gula",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Gula (Central African Republic)",
  lc: "kcm",
  ld: "ltr",
  alt: ["Goula", "Gula du Mamoun", "Kara", "Kara de Soudan", "Kara of Sudan", "Tar Gula", "Yamegi", "Zura (Koto)", "Gula (Goula)", "Koyo", "Mot-Mar (Moto-Mara)", "Nguru (Bubu)", "Sar (Sara)"],
  cc: ["CF", "SD"]
}, {
  pk: 2749,
  ang: "Nubi",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Nubi",
  lc: "kcn",
  ld: "ltr",
  alt: ["Kinubi", "Ki-Nubi"],
  cc: ["KE", "UG"]
}, {
  pk: 2750,
  ang: "Kinalakna",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kinalakna",
  lc: "kco",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2751,
  ang: "Kanga",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Kanga",
  lc: "kcp",
  ld: "ltr",
  alt: ["Krongo Abdalla"],
  cc: ["SD"]
}, {
  pk: 2752,
  ang: "Kamo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kamo",
  lc: "kcq",
  ld: "ltr",
  alt: ["Kamu", "Ma", "Nubama", "Nyima"],
  cc: ["NG"]
}, {
  pk: 2753,
  ang: "Katla",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Katla",
  lc: "kcr",
  ld: "ltr",
  alt: ["Akalak", "Kalak"],
  cc: ["SD"]
}, {
  pk: 2754,
  ang: "Koenoem",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Koenoem",
  lc: "kcs",
  ld: "ltr",
  alt: ["Kanam"],
  cc: ["NG"]
}, {
  pk: 2755,
  ang: "Kayan",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kaian",
  lc: "kct",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2756,
  ang: "Kami",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Kami (Tanzania)",
  lc: "kcu",
  ld: "ltr",
  alt: [],
  cc: ["TZ"]
}, {
  pk: 2757,
  ang: "Kete",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kete",
  lc: "kcv",
  ld: "ltr",
  alt: ["Kikete", "Lukete"],
  cc: ["CD"]
}, {
  pk: 2758,
  ang: "Kabwari",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kabwari",
  lc: "kcw",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 2759,
  ang: "Kachama-Ganjule",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Kachama-Ganjule",
  lc: "kcx",
  ld: "ltr",
  alt: ["Gats'ame (Gatame)", "Get'eme", "Makka", "Ganjule (Ganjawle)"],
  cc: ["ET"]
}, {
  pk: 2760,
  ang: "Korandje",
  lr: "Africa",
  gw: false,
  hc: "DZ",
  ln: "\u0627\u0644\u0628\u0644\u0628\u0627\u0644\u064A\u0629",
  lc: "kcy",
  ld: "ltr",
  alt: ["Kwarandzyey"],
  cc: ["DZ"]
}, {
  pk: 2761,
  ang: "Konongo",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Konongo",
  lc: "kcz",
  ld: "ltr",
  alt: ["Kikonongo"],
  cc: ["TZ"]
}, {
  pk: 2762,
  ang: "Kutu",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Kutu",
  lc: "kdc",
  ld: "ltr",
  alt: ["Khutu", "Kikutu"],
  cc: ["TZ"]
}, {
  pk: 2763,
  ang: "Yankunytjatjara",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yankunytjatjara",
  lc: "kdd",
  ld: "ltr",
  alt: ["Jangkundjara", "Kulpantja", "Yankunjtjatjarra", "Yankuntatjara"],
  cc: ["AU"]
}, {
  pk: 2764,
  ang: "Makonde",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Makonde",
  lc: "kde",
  ld: "ltr",
  alt: ["Chimakonde", "Chinimakonde", "Cimakonde", "Konde", "Maconde", "Makonda", "Matambwe", "Shimakonde", "Kimakonde", "Matambe", "Mekwengo", "Mawia", "Vamwalu (Mwalu)", "Ndonde", "Vadonde (Donde)", "Vamwambe (Mwambe)", "Mavia", "Mabiha", "Kimawiha", "Vamakonde (Makonde)", "Maviha (Chimaviha)"],
  cc: ["KE", "MZ", "TZ", "YT"]
}, {
  pk: 2765,
  ang: "Mamusi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mamusi",
  lc: "kdf",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2766,
  ang: "Seba",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Seba",
  lc: "kdg",
  ld: "ltr",
  alt: ["Kunda", "Sewa", "Shishi"],
  cc: ["CD"]
}, {
  pk: 2767,
  ang: "Tem",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Tem",
  lc: "kdh",
  ld: "ltr",
  alt: ["Cotocoli", "Kotokoli", "Tembe", "Tim", "Timu", "Temba"],
  cc: ["BJ", "GH", "TG"]
}, {
  pk: 2768,
  ang: "Kumam",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Kumam",
  lc: "kdi",
  ld: "ltr",
  alt: ["Akokolemu", "Akum", "Ikokolemu", "Ikumama", "Kuman", "Kumum"],
  cc: ["UG"]
}, {
  pk: 2769,
  ang: "Ng\u2019akarimojong",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Karamojong",
  lc: "kdj",
  ld: "ltr",
  alt: ["Karimonjong", "Ng'akaramojong", "Dodoth (Dodoth)", "Pian", "Napore", "Jie (Jiye)", "Bokora", "Matheniko"],
  cc: ["UG"]
}, {
  pk: 2770,
  ang: "Num\xE8\xE8",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Num\xE8\xE8",
  lc: "kdk",
  ld: "ltr",
  alt: ["Dialectes de l'Extreme Sud", "Duauru", "Kapone", "Kunie", "Kw\xE9nyi", "Naa Numee", "Naa-Wee", "Touaouru", "Truaru", "Tuauru", "Uen", "Wen", "Xere", "Kwenyii (Kunie)", "Numee (Touaouru)"],
  cc: ["NC"]
}, {
  pk: 2771,
  ang: "Tsikimba",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Tsikimba",
  lc: "kdl",
  ld: "ltr",
  alt: ["Agaushi", "Akimba", "Kambari", "Kamberchi", "Kamberri", "Kimba"],
  cc: ["NG"]
}, {
  pk: 2772,
  ang: "Kagoma",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kagoma",
  lc: "kdm",
  ld: "ltr",
  alt: ["Agoma", "Gwong", "Gyong", "Kwong"],
  cc: ["NG"]
}, {
  pk: 2773,
  ang: "Kunda",
  lr: "Africa",
  gw: false,
  hc: "ZW",
  ln: "Kunda",
  lc: "kdn",
  ld: "ltr",
  alt: ["Chicunda", "Chikunda", "Cikunda"],
  cc: ["MZ", "ZM", "ZW"]
}, {
  pk: 2774,
  ang: "Nikyob-Nindem",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kaningdon-Nindem",
  lc: "kdp",
  ld: "ltr",
  alt: ["Kaningdom-Nindem", "Kaningdon-Nindem", "Kaningkon-Nindem", "Kaninkom-Nindem", "Kaninkon-Nindem", "Ninkyob-Nindem", "Nindem (Inidem)", "Ninkyob (Kaningkom)", "Kaninkon", "Kaningkwom", "Nidem", "Ninkyop"],
  cc: ["NG"]
}, {
  pk: 2775,
  ang: "Koch",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Koch",
  lc: "kdq",
  ld: "ltr",
  alt: ["Koc", "Kocch", "Koce", "Kochboli", "Konch", "Kocha", "Chapra", "Margan", "Margan (Dasgaya)"],
  cc: ["BD", "IN"]
}, {
  pk: 2776,
  ang: "Karaim",
  lr: "Europe",
  gw: false,
  hc: "LT",
  ln: "Karaim",
  lc: "kdr",
  ld: "ltr",
  alt: ["Turkic Karaite", "Karaite", "Trakay (Trakai)", "Halych (Galits)", "Trakai (Trakay)"],
  cc: ["LT"]
}, {
  pk: 2777,
  ang: "Kuy",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "\u0E20\u0E32\u0E29\u0E32\u0E01\u0E39\u0E22",
  lc: "kdt",
  ld: "ltr",
  alt: ["Kuay", "Aouei", "Cuoi", "Dui", "Khamen-Boran", "Kui", "Kuoy", "Old Khmer", "Soai", "Suai", "Suay", "Suei", "Sui", "Suoi", "Kui Souei", "Kuuy", "Nheu", "Kuy Mlor", "Kuy May (Kuy Ma'ay)", "Kuy Antra", "Kuy Anthua", "Kuy Ak", "Chang (Suai Chang)"],
  cc: ["LA", "TH", "KH"]
}, {
  pk: 8307,
  ang: "Kuay Er",
  lr: "Asia",
  gw: false,
  hc: "KH",
  ln: "Kuay Er",
  lc: "kdt-x-kuayer",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8306,
  ang: "Kuay Treu",
  lr: "Asia",
  gw: false,
  hc: "KH",
  ln: "Kuay Treu",
  lc: "kdt-x-kuaytreu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2778,
  ang: "Kadaru",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Kadaru",
  lc: "kdu",
  ld: "ltr",
  alt: ["Kadaro", "Kadero", "Kaderu", "Kodhin", "Kodhinniai", "Kodoro", "Kuldaji (Kendal)", "Kafir (Ka'e)", "Kururu (Tagle)", "Dabatna (Kaaral)", "Kadaru (Kodur)", "Kurtala (Ngokra)"],
  cc: ["SD"]
}, {
  pk: 2779,
  ang: "Koneraw",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Koneraw",
  lc: "kdw",
  ld: "ltr",
  alt: ["Konorau"],
  cc: ["ID"]
}, {
  pk: 2780,
  ang: "Kam",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kam",
  lc: "kdx",
  ld: "ltr",
  alt: ["Nyingwom", "Nyiwom", "Yimwom"],
  cc: ["NG"]
}, {
  pk: 2781,
  ang: "Keijar",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Keder",
  lc: "kdy",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 2782,
  ang: "Kwaja",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Kwaja",
  lc: "kdz",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 2783,
  ang: "Kabuverdianu",
  lr: "Africa",
  gw: false,
  hc: "CV",
  ln: "Kabuverdianu",
  lc: "kea",
  ld: "ltr",
  alt: ["Caboverdiano", "Criol", "Crioulo", "Kriol", "Krioulo", "Krioulu", "Badiu", "Sampadjudu", "Kabuverdianu-Barlavente (Caboverdiano-Barlavento)", "Kabuverdianu-Sotaventu (Caboverdiano-Sotavento)"],
  cc: ["ES", "CA", "CV"]
}, {
  pk: 2784,
  ang: "K\xE9l\xE9",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "K\xE9l\xE9",
  lc: "keb",
  ld: "ltr",
  alt: ["Akele", "Dikele"],
  cc: ["GA", "CG"]
}, {
  pk: 2785,
  ang: "Keiga",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Keiga",
  lc: "kec",
  ld: "ltr",
  alt: ["Aigang", "Keiga-Al-Kheil", "Keiga-Timero", "Yega", "Demik (Rofik)", "Keiga (Aigang)"],
  cc: ["SD"]
}, {
  pk: 2786,
  ang: "Kerewe",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Kerewe",
  lc: "ked",
  ld: "ltr",
  alt: ["Ekikerebe", "Kerebe", "Kikwere"],
  cc: ["TZ"]
}, {
  pk: 2787,
  ang: "Keres, Eastern",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Eastern Keres",
  lc: "kee",
  ld: "ltr",
  alt: ["Eastern Keres Pueblo", "Rio Grande Keresan"],
  cc: ["US"]
}, {
  pk: 2788,
  ang: "Kpessi",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Kpessi",
  lc: "kef",
  ld: "ltr",
  alt: ["Kpesi", "Kp\xE9si", "Kpetchi", "Kp\xE9tsi"],
  cc: ["TG"]
}, {
  pk: 2789,
  ang: "Tese",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Tese",
  lc: "keg",
  ld: "ltr",
  alt: ["Keiga Girru", "Keiga Jirru", "Teis-Umm-Danab"],
  cc: ["SD"]
}, {
  pk: 2790,
  ang: "Keak",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Keak",
  lc: "keh",
  ld: "ltr",
  alt: ["Kwaruwikwundi", "Sepik Plains", "Tshuosh", "Tshwosh"],
  cc: ["PG"]
}, {
  pk: 2791,
  ang: "Kei",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kei",
  lc: "kei",
  ld: "ltr",
  alt: ["Kai", "Saumlaki", "Veveu Evav", "Tanimbar Kei (Atnebar)"],
  cc: ["ID"]
}, {
  pk: 7977,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kei Besar",
  lc: "kei-x-besar",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7978,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kei Kecil",
  lc: "kei-x-kecil",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8418,
  ang: "Tanimbar",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tanimbar",
  lc: "kei-x-tanimbar",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2792,
  ang: "Kadar",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kadar",
  lc: "kej",
  ld: "ltr",
  alt: ["Kada"],
  cc: ["IN"]
}, {
  pk: 2793,
  ang: "Q\u2019eqchi\u2019",
  lr: "Americas",
  gw: false,
  hc: "GT",
  ln: "Kekch\xED",
  lc: "kek",
  ld: "ltr",
  alt: ["Cacch\xE9", "Ketch\xED", "Quecch\xED", "Cacche'", "Kekchi'", "Kekch\xED", "Ketchi'", "Quecchi'", "Alta Verapaz Cob\xE1n"],
  cc: ["BZ", "GT"]
}, {
  pk: 2794,
  ang: "Kela",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kela (Democratic Republic of Congo)",
  lc: "kel",
  ld: "ltr",
  alt: ["Lemba", "Okela"],
  cc: ["CD"]
}, {
  pk: 2795,
  ang: "Kemak",
  lr: "Asia",
  gw: false,
  hc: "TL",
  ln: "Kemak",
  lc: "kem",
  ld: "ltr",
  alt: ["Ema", "Nogo (Nogo-Nogo)"],
  cc: ["TL"]
}, {
  pk: 2796,
  ang: "Kenyang",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Kenyang",
  lc: "ken",
  ld: "ltr",
  alt: ["Banjangi", "Banyang", "Bayangi", "Manyang", "Nyang", "Manyeman", "Upper Kenyang (Haut-Kenyang)", "Upper Balong", "Twii", "Manyemen", "Lower Kenyang (Bas-Kenyang)", "Kitwii", "Bakoni (Kicwe)", "Northern Balong"],
  cc: ["CM"]
}, {
  pk: 2797,
  ang: "Kakwa",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Kakwa",
  lc: "keo",
  ld: "ltr",
  alt: ["Bari Kakwa", "Kakua", "Kakwak", "Kwakwak"],
  cc: ["SS", "UG"]
}, {
  pk: 2798,
  ang: "Kaikadi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kaikadi",
  lc: "kep",
  ld: "ltr",
  alt: ["Kaikadia", "Kaikai", "Kokadi"],
  cc: ["IN"]
}, {
  pk: 2799,
  ang: "Kamar",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kamar",
  lc: "keq",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 2800,
  ang: "Kera",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Kera",
  lc: "ker",
  ld: "ltr",
  alt: [],
  cc: ["CM", "TD"]
}, {
  pk: 2801,
  ang: "Kugbo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kugbo",
  lc: "kes",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 2802,
  ang: "Ket",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041A\u0435\u0442\u0441\u043A\u0438\u0439",
  lc: "ket",
  ld: "ltr",
  alt: ["Imbatski-Ket", "Yenisei Ostyak", "Yenisey Ostiak"],
  cc: ["RU"]
}, {
  pk: 2803,
  ang: "Akebu",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Akebu",
  lc: "keu",
  ld: "ltr",
  alt: ["Ak\xE9bou", "Ekpeebhe", "Gakagba", "Kabu", "K\xE9bou", "Kebu", "Kegberike", "kekpeeke", "kekpeerike"],
  cc: ["TG"]
}, {
  pk: 2804,
  ang: "Kanikkaran",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kanikkaran",
  lc: "kev",
  ld: "ltr",
  alt: ["Kanikkar", "Kannikan", "Kannikaran", "Kannikharan", "Malampashi"],
  cc: ["IN"]
}, {
  pk: 2805,
  ang: "Kewa, West",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "West Kewa",
  lc: "kew",
  ld: "ltr",
  alt: ["Pasuma"],
  cc: ["PG"]
}, {
  pk: 2806,
  ang: "Kukna",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kukna",
  lc: "kex",
  ld: "ltr",
  alt: ["Kanara", "Kanara Konkani", "Kokna", "Kokni"],
  cc: ["IN"]
}, {
  pk: 2807,
  ang: "Kupia",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kupia",
  lc: "key",
  ld: "ltr",
  alt: ["Valmiki"],
  cc: ["IN"]
}, {
  pk: 2808,
  ang: "Kukele",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kukele",
  lc: "kez",
  ld: "ltr",
  alt: ["Bakele", "Ukele"],
  cc: ["NG"]
}, {
  pk: 2809,
  ang: "Kodava",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kodava",
  lc: "kfa",
  ld: "ltr",
  alt: ["Coorge", "Kadagi", "Khurgi", "Kodagu", "Kotagu", "Kurja", "Kurug"],
  cc: ["IN"]
}, {
  pk: 7613,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Korama",
  lc: "kfa-x-korama",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2810,
  ang: "Kolami, Northwestern",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Northwestern Kolami",
  lc: "kfb",
  ld: "ltr",
  alt: ["Kolam", "Kolamboli", "Kolamy", "Kolmi", "Kulme"],
  cc: ["IN"]
}, {
  pk: 2811,
  ang: "Konda-Dora",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Konda-Dora",
  lc: "kfc",
  ld: "ltr",
  alt: ["Porja", "Konda-Dora (Konda)"],
  cc: ["IN"]
}, {
  pk: 8261,
  ang: "Kirad",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kirad",
  lc: "kfc-x-kirad",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2812,
  ang: "Koraga, Korra",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Korra Koraga",
  lc: "kfd",
  ld: "ltr",
  alt: ["Koragar", "Koragara", "Korangi", "Korra", "Ande", "Onti", "Tappu"],
  cc: ["IN"]
}, {
  pk: 2813,
  ang: "Kota",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kota (India)",
  lc: "kfe",
  ld: "ltr",
  alt: ["Kother-Tamil", "Kotta", "Kowe-Adiwasi"],
  cc: ["IN"]
}, {
  pk: 2814,
  ang: "Koya",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Koya",
  lc: "kff",
  ld: "ltr",
  alt: ["Kavor", "Kaya", "Koa", "Koi Gondi", "Koitar", "Koyato", "Koyi", "Raj Koya", "Dorli (Chintoor Koya)", "Korla", "Malkangiri Koya", "Jaganathapuram Koya (Godavari Koya)", "Gommu Koya", "Dorla Koitur", "Dora Koi", "Dor Koi", "Dora", "Dorla Koya", "Podia Koya (Gotte Koya)"],
  cc: ["IN"]
}, {
  pk: 7565,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Koya-Dmorla",
  lc: "kff-x-dmorla",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7771,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Doralakoya",
  lc: "kff-x-doralakoya",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7570,
  ang: "Dorli",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Dorli Koya",
  lc: "kff-x-dorli",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7582,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Gotte Koya",
  lc: "kff-x-gottekoy",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7699,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Rashakoya",
  lc: "kff-x-rashak",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7577,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "W. Godavari Koya",
  lc: "kff-x-westgoda",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2815,
  ang: "Kudiya",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kudiya",
  lc: "kfg",
  ld: "ltr",
  alt: ["Male Kudiya"],
  cc: ["IN"]
}, {
  pk: 2816,
  ang: "Kurichiya",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kurichiya",
  lc: "kfh",
  ld: "ltr",
  alt: ["Kowohans", "Kurichchan", "Kurichchia", "Kurichiyars", "Kuruchans", "Kunnam", "Wayanad"],
  cc: ["IN"]
}, {
  pk: 2817,
  ang: "Kurumba, Kannada",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kannada Kurumba",
  lc: "kfi",
  ld: "ltr",
  alt: ["Canarese", "Korambar", "Kuramwari", "Kuremban", "Kuruba", "Kuruban", "Kurubar", "Kurubas Kuruma", "Kuruman", "Kurumans", "Kurumar", "Kurumban", "Kurumbar", "Kurumbas", "Kurumvari", "Palu Kurumba", "Southern Nonstandard Kannada", "Dharmapuri", "Pudukottai", "Coimbatore"],
  cc: ["IN"]
}, {
  pk: 8124,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Adavi Kuruba",
  lc: "kfi-x-adavkuruba",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7755,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kukke Kuruba",
  lc: "kfi-x-kukkekuruba",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7585,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kurre Kurumba",
  lc: "kfi-x-kurreeku",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7513,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Okhliya",
  lc: "kfi-x-okhl",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 2818,
  ang: "Kemiehua",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u514B\u8511\u8BDD",
  lc: "kfj",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 2819,
  ang: "Kinnauri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kinnauri",
  lc: "kfk",
  ld: "ltr",
  alt: ["Kanaury Anuskad", "Kanawari", "Kanawi", "Kanoreunu Skad", "Kanorin Skad", "Kanorug Skadd", "Kinnaura Yanuskad", "Kinner", "Kinori", "Koonawure", "Kunawari", "Kunawur", "Lower Kinnauri", "Malhesti", "Milchan", "Milchanang", "Milchang", "Tibas Skad"],
  cc: ["PK", "IN"]
}, {
  pk: 2820,
  ang: "Kung",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Kung",
  lc: "kfl",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 2821,
  ang: "Khunsari",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u0632\u0628\u0627\u0646 \u062E\u0648\u0627\u0646\u0633\u0627\u0631\u06CC",
  lc: "kfm",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 2822,
  ang: "Kuk",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Kuk",
  lc: "kfn",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 2823,
  ang: "Koro",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Koro (C\xF4te d'Ivoire)",
  lc: "kfo",
  ld: "ltr",
  alt: ["Koro Jula"],
  cc: ["CI"]
}, {
  pk: 2824,
  ang: "Korwa",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Korwa",
  lc: "kfp",
  ld: "ltr",
  alt: ["Ernga", "Singli"],
  cc: ["IN"]
}, {
  pk: 2825,
  ang: "Korku",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Korku",
  lc: "kfq",
  ld: "ltr",
  alt: ["Bondeya", "Bopchi", "Korki", "Kuri", "Kurku", "Kurku-Ruma", "Mawasi (Muasi)", "Muwasi", "Bouriya"],
  cc: ["IN"]
}, {
  pk: 2826,
  ang: "Kachchi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kachchi",
  lc: "kfr",
  ld: "ltr",
  alt: ["Cuchi", "Cutch", "Kachchhi", "Kachi", "Katch", "Katchi", "Kautchy", "Kutchchi", "Kutchie", "Kacchi", "Cutchi"],
  cc: ["TZ", "MW", "IN"]
}, {
  pk: 2827,
  ang: "Bilaspuri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bilaspuri",
  lc: "kfs",
  ld: "ltr",
  alt: ["Bilaspuri Pahari", "Kahluri", "Kehloori Pahari", "Kehluri", "Pacchmi"],
  cc: ["IN"]
}, {
  pk: 2828,
  ang: "Kanjari",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kanjari",
  lc: "kft",
  ld: "ltr",
  alt: ["Kagari", "Kangar Bhat", "Kangri", "Kanjri"],
  cc: ["IN"]
}, {
  pk: 2829,
  ang: "Katkari",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Katkari",
  lc: "kfu",
  ld: "ltr",
  alt: ["Katakari", "Katari", "Katvadi", "Central Katkari", "Northern Katkari", "Southern Katkari"],
  cc: ["IN"]
}, {
  pk: 2830,
  ang: "Kurmukar",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kurmukar",
  lc: "kfv",
  ld: "ltr",
  alt: ["Kamar", "Karmakar", "Karmokar", "Kumbhakar", "Kumhar", "Umar"],
  cc: ["IN"]
}, {
  pk: 2831,
  ang: "Naga, Kharam",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kharam Naga",
  lc: "kfw",
  ld: "ltr",
  alt: ["Duisalongmei", "Thinglong"],
  cc: ["IN"]
}, {
  pk: 2832,
  ang: "Pahari, Kullu",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kullu Pahari",
  lc: "kfx",
  ld: "ltr",
  alt: ["Kauli", "Kullui", "Kulu Boli", "Kulu Pahari", "Kulvi", "Kulwali", "Pahari", "Pahari Kullu", "Phari Kulu", "Inner Siragi (Inner Seraji)", "Siraji", "Siragi", "Outer Seraji", "Saraji"],
  cc: ["IN"]
}, {
  pk: 7539,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Inner Seraji",
  lc: "kfx-x-innerser",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 7531,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Inner Seraji",
  lc: "kfx-x-InnerSeraji",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 7534,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Outer Seraji",
  lc: "kfx-x-outerser",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 7532,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Outer Seraji",
  lc: "kfx-x-OuterSeraji",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 2833,
  ang: "Kumaoni",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kumaoni",
  lc: "kfy",
  ld: "ltr",
  alt: ["Kamaoni", "Kumau", "Kumauni", "Kumawani", "Kumgoni", "Kumman", "Kunayaoni", "Central Kumaoni", "Northeastern Kumaoni", "Southeastern Kumaoni", "Western Kumaoni"],
  cc: ["NP", "IN"]
}, {
  pk: 7606,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Soriyali",
  lc: "kfy-x-soriyali",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2834,
  ang: "Koromf\xE9",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Koromf\xE9",
  lc: "kfz",
  ld: "ltr",
  alt: ["Fula", "Kuruma", "Kurumfe", "Foula", "Foulse", "Kurum-Korey", "Tellem", "Eastern Koromfe", "Koromba", "Western Koromfe"],
  cc: ["BF"]
}, {
  pk: 7704,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "West Koromf\xE9",
  lc: "kfz-x-wkoromf",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2835,
  ang: "Kongo",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kikongo",
  lc: "kg",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 2836,
  ang: "Koyaga",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Koyaga",
  lc: "kga",
  ld: "ltr",
  alt: ["Koya", "Koyaa", "Koyaga Jula", "Koyagakan", "Koyaka", "Koyara"],
  cc: ["CI"]
}, {
  pk: 2837,
  ang: "Kawe",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kawe",
  lc: "kgb",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 2838,
  ang: "Kasseng",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Kasseng",
  lc: "kgc",
  ld: "ltr",
  alt: ["Kaseng", "Koseng", "Kraseng"],
  cc: ["LA"]
}, {
  pk: 2839,
  ang: "Kataang",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Kataang",
  lc: "kgd",
  ld: "ltr",
  alt: [],
  cc: ["LA"]
}, {
  pk: 2840,
  ang: "Komering",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Komering",
  lc: "kge",
  ld: "ltr",
  alt: ["Kumoring", "Downstream Komering", "Kayu Agung Asli", "Upstream Komering"],
  cc: ["ID"]
}, {
  pk: 2841,
  ang: "Kube",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kube",
  lc: "kgf",
  ld: "ltr",
  alt: ["Hube", "Mongi", "Yoangen (Yoanggeng)"],
  cc: ["PG"]
}, {
  pk: 2842,
  ang: "Kusunda",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Kusunda",
  lc: "kgg",
  ld: "ltr",
  alt: ["Kusanda", "Tanahun", "Rolpa-Dang", "Gorkha"],
  cc: ["NP"]
}, {
  pk: 2843,
  ang: "Selangor Sign Language",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Selangor Sign Language",
  lc: "kgi",
  ld: "ltr",
  alt: ["KLSL", "Kuala Lumpur Sign Language"],
  cc: ["MY"]
}, {
  pk: 2844,
  ang: "Kham",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u0916\u093E\u092E",
  lc: "kgj",
  ld: "ltr",
  alt: ["Gamale"],
  cc: ["NP"]
}, {
  pk: 2845,
  ang: "Kaiw\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Kaiw\xE1",
  lc: "kgk",
  ld: "ltr",
  alt: ["Caingua", "Caiwa", "Cayua", "Kaiova", "Kaiow\xE1", "Kayova", "Kaiw\xE1"],
  cc: ["BR", "AR", "PY"]
}, {
  pk: 2846,
  ang: "Karingani",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Karingani",
  lc: "kgn",
  ld: "ltr",
  alt: ["Keringani"],
  cc: ["IR"]
}, {
  pk: 2847,
  ang: "Krongo",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Krongo",
  lc: "kgo",
  ld: "ltr",
  alt: ["Dimodongo", "Kadumodi", "Korongo", "Kurungu", "Tabanya"],
  cc: ["SD"]
}, {
  pk: 8001,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Krongo Abdalla",
  lc: "kgo-x-krongoabdalla",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2848,
  ang: "Kaingang",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Kaingang",
  lc: "kgp",
  ld: "ltr",
  alt: ["Bugre", "Caingang", "Coroado", "Coroados", "Paran\xE1 Kaingang"],
  cc: ["BR"]
}, {
  pk: 2849,
  ang: "Kamoro",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kamoro",
  lc: "kgq",
  ld: "ltr",
  alt: ["Kamora", "Kaokonau", "Lakahia", "Mukamuga", "Nagramadu", "Nefarpi", "Neferipi", "Umar", "Umari", "Nanesa"],
  cc: ["ID"]
}, {
  pk: 2850,
  ang: "Abun",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Abun",
  lc: "kgr",
  ld: "ltr",
  alt: ["A Nden", "Karon", "Manif", "Yimbun", "Abun Ji (Madik)", "Abun Tat (Karon Pantai)"],
  cc: ["ID"]
}, {
  pk: 8462,
  ang: "Moi Madik",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Moi Madik",
  lc: "kgr-x-madik",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2851,
  ang: "Kumbainggar",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Kumbainggar",
  lc: "kgs",
  ld: "ltr",
  alt: ["Baanbay", "Gambalamam", "Gumbaingari", "Gumbaynggir", "Kumbaingeri"],
  cc: ["AU"]
}, {
  pk: 2852,
  ang: "Somyev",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Somyev",
  lc: "kgt",
  ld: "ltr",
  alt: ["Kila"],
  cc: ["NG"]
}, {
  pk: 2853,
  ang: "Kobol",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kobol",
  lc: "kgu",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2854,
  ang: "Karas",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Karas",
  lc: "kgv",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 2855,
  ang: "Karon Dori",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Karon Dori",
  lc: "kgw",
  ld: "ltr",
  alt: ["Maiyach", "Mari", "Meon"],
  cc: ["ID"]
}, {
  pk: 2856,
  ang: "Kamaru",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kamaru",
  lc: "kgx",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 2857,
  ang: "Kyerung",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5409\u9686",
  lc: "kgy",
  ld: "ltr",
  alt: ["Kyirong", "Gyirong", "Kyirung"],
  cc: ["CN", "NP"]
}, {
  pk: 2858,
  ang: "Khasi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Khasi",
  lc: "kha",
  ld: "ltr",
  alt: ["Cossyah", "Kahasi", "Khasie", "Khasiyas", "Khassee", "Khuchia", "Kyi", "Kassi", "Khasa", "Khashi", "Sohra", "Khasi (Cherrapunji)"],
  cc: ["BD", "IN"]
}, {
  pk: 2859,
  ang: "L\xFC",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u50A3\u4EC2\u8A9E",
  lc: "khb",
  ld: "ltr",
  alt: ["Dai", "Dai Le", "Lue", "Ly", "Pai'i'", "Pai-I", "Shui-Pai-I", "Sipsongpanna Dai", "Tai Lu", "Xishuangbanna Dai", "Shu-Ai-I", "Pai-Yi", "Tai Lue", "Duon", "Nhuon", "Yong", "Jinghong", "Muang Yong"],
  cc: ["CN", "LA", "TH", "US", "MM"]
}, {
  pk: 2860,
  ang: "Tukang Besi North",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tukang Besi North",
  lc: "khc",
  ld: "ltr",
  alt: ["Buton", "Wakatobi", "Wantji", "Kaledupa (Kahedupa)", "Wanci (Wangi- Wangi)", "Wanje", "Wanji"],
  cc: ["ID"]
}, {
  pk: 2861,
  ang: "Kanum, B\xE4di",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "B\xE4di Kanum",
  lc: "khd",
  ld: "ltr",
  alt: ["Enkelembu", "Kenume", "Knwne"],
  cc: ["ID"]
}, {
  pk: 2862,
  ang: "Korowai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Korowai",
  lc: "khe",
  ld: "ltr",
  alt: ["Kolufaup", "South Korowai", "North Korowai"],
  cc: ["ID"]
}, {
  pk: 2863,
  ang: "Khuen",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Khuen",
  lc: "khf",
  ld: "ltr",
  alt: ["Khouen", "Khween", "Kween"],
  cc: ["LA", "US"]
}, {
  pk: 2864,
  ang: "Tibetan, Khams",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u0F41\u0F58\u0F66\u0F0B\u0F66\u0F90\u0F51\u0F0D",
  lc: "khg",
  ld: "ltr",
  alt: ["Kam", "Kang", "Khamba", "Khampa", "Khams", "Khams Bhotia", "Khams-Yal"],
  cc: ["CN", "BT"]
}, {
  pk: 2865,
  ang: "Kehu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kehu",
  lc: "khh",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 2866,
  ang: "Kuturmi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kuturmi",
  lc: "khj",
  ld: "ltr",
  alt: ["Aclo (Aklo)", "Kuturmi West", "Obiro (Kuturmi East)"],
  cc: ["NG"]
}, {
  pk: 2867,
  ang: "Mongolian, Halh",
  lr: "Asia",
  gw: false,
  hc: "MN",
  ln: "Halh Mongolian",
  lc: "khk",
  ld: "ltr",
  alt: ["Central Mongolian", "Khalkha Mongolian", "Mongol", "Halh (Khalkha)", "Khalkha (Halh)", "Darkhat (Darhad)", "Darkhad"],
  cc: ["AT", "CN", "DE", "HU", "MN", "GB", "CZ", "CA", "KP", "KG"]
}, {
  pk: 2868,
  ang: "Lusi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Lusi",
  lc: "khl",
  ld: "ltr",
  alt: ["Kaliai"],
  cc: ["PG"]
}, {
  pk: 2869,
  ang: "Khandesi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Khandesi",
  lc: "khn",
  ld: "ltr",
  alt: ["Dhed Gujari", "Khandeshi", "Khandeshi Bhili", "Khandish", "Maharashtra Bhil", "Kunbi (Kunbau)"],
  cc: ["IN"]
}, {
  pk: 2870,
  ang: "Khotanese",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Khotanese",
  lc: "kho",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 2871,
  ang: "Kapauri",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kapori",
  lc: "khp",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 2872,
  ang: "Songhay, Koyra Chiini",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Koyra Chiini Songhay",
  lc: "khq",
  ld: "ltr",
  alt: ["Songai", "Songay", "Songhai", "Songhay", "Songhoy", "Songoi", "Songoy", "Sonrai", "Sonrhai", "Timbuktu Songhoy", "West Songhoy", "Djenn\xE9 Chiini", "Koyra Chiini"],
  cc: ["LA", "ML"]
}, {
  pk: 2873,
  ang: "Kharia",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kharia",
  lc: "khr",
  ld: "ltr",
  alt: ["Haria", "Khariya", "Kharvi", "Khatria", "Kheria", "Dhelki Kharia", "Dudh Kharia"],
  cc: ["NP", "IN"]
}, {
  pk: 2874,
  ang: "Kasua",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kasua",
  lc: "khs",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2875,
  ang: "Khamti",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Khamti",
  lc: "kht",
  ld: "ltr",
  alt: ["Hkamti", "Khampti", "Kham-Tai", "Khamti Shan", "Khantis", "Tai Kham Ti", "Kam Ti", "Khampti Shan", "Khandi Shan", "Tai Kam Ti", "Tai-Khamti", "Assam Khamti", "Sinkaling Khamti"],
  cc: ["IN", "MM"]
}, {
  pk: 2876,
  ang: "Nkumbi",
  lr: "Africa",
  gw: false,
  hc: "AO",
  ln: "Nkhumbi",
  lc: "khu",
  ld: "ltr",
  alt: ["Khumbi", "Ngumbi", "Nkhumbi", "Ocinkumbi", "Otjingumbi", "Nkumbi-mulondo"],
  cc: ["AO"]
}, {
  pk: 2877,
  ang: "Khvarshi",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0425\u0432\u0430\u0440\u0448\u0438\u043D\u0441\u043A\u0438\u0439",
  lc: "khv",
  ld: "ltr",
  alt: ["Atl'ilqo", "Khvarshin", "Xvarshi proper", "Inxokvari (Inkhokvari)"],
  cc: ["RU"]
}, {
  pk: 2878,
  ang: "Khowar",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u06A9\u0647\u0648\u0648\u0627\u0631",
  lc: "khw",
  ld: "rtl",
  alt: ["Arniya", "Chitrali", "Chitrari", "Citrali", "Kashkari", "Khawar", "Patu", "Qashqari"],
  cc: ["AF", "PK"]
}, {
  pk: 2879,
  ang: "Kanu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kanu",
  lc: "khx",
  ld: "ltr",
  alt: ["Kaanu", "Kano", "Likanu"],
  cc: ["CD"]
}, {
  pk: 2880,
  ang: "Kele",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kele (Democratic Republic of Congo)",
  lc: "khy",
  ld: "ltr",
  alt: ["Ekele", "Kili", "Likelo", "Lokele"],
  cc: ["CD"]
}, {
  pk: 2881,
  ang: "Keapara",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Keapara",
  lc: "khz",
  ld: "ltr",
  alt: ["Keopara", "Kerepunu", "Keapara (Keopara)", "Galoma", "Babaga", "Aroma (Aloma)", "Arona"],
  cc: ["PG"]
}, {
  pk: 7743,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kalo",
  lc: "khz-x-kalo",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2882,
  ang: "Kikuyu, Gikuyu",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "G\u0129k\u0169y\u0169",
  lc: "ki",
  ld: "ltr",
  alt: ["Gekoyo", "Gigikuyu", "Gichugu (Northern Kirinyaga)", "Southern Murang'a", "Southern Gikuyu (Kiambu)", "Nyeri", "Mathira (Karatina)", "Ndia (Southern Kirinyaga)", "Northern Gikuyu (Northern Murang'a)"],
  cc: ["KE", "TZ", "UG"]
}, {
  pk: 2883,
  ang: "Kim",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Kim",
  lc: "kia",
  ld: "ltr",
  alt: ["Gerep (Djouman)", "Kosop (Kim)", "Kwasap", "Kolop (Kilop)", "Jumam", "Garap (\xC9r\xE9)", "Kolobo"],
  cc: ["TD"]
}, {
  pk: 2884,
  ang: "Koalib",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Koalib",
  lc: "kib",
  ld: "ltr",
  alt: ["Abri", "Kawalib", "Kowalib", "Lgalige", "Nirere", "Rere", "Nginyukwur"],
  cc: ["SD"]
}, {
  pk: 2885,
  ang: "Kickapoo",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Kickapoo",
  lc: "kic",
  ld: "ltr",
  alt: ["Kicapoux", "Kicapus", "Kikabeeux", "Kikapaux", "Kikap\xFA", "Quicapause", "Kikapoo"],
  cc: ["US"]
}, {
  pk: 2886,
  ang: "Koshin",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Koshin",
  lc: "kid",
  ld: "ltr",
  alt: ["Kaw", "Kosin"],
  cc: ["CM"]
}, {
  pk: 2887,
  ang: "Kibet",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Kibet",
  lc: "kie",
  ld: "ltr",
  alt: ["Kabentang", "Kibeet", "Kibeit", "Dagel (Daggal)", "Muro", "Murru (Mourro)"],
  cc: ["TD"]
}, {
  pk: 2888,
  ang: "Kham, Eastern Parbate",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Eastern Parbate Kham",
  lc: "kif",
  ld: "ltr",
  alt: ["Eastern Parbate", "Nisel", "Nishel Kham", "Nisi", "Nisi Kham"],
  cc: ["NP"]
}, {
  pk: 2889,
  ang: "Kimaghima",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kimaama",
  lc: "kig",
  ld: "ltr",
  alt: ["Kaladdarsch", "Kimaghama", "Teri-Kalwasch"],
  cc: ["ID"]
}, {
  pk: 2890,
  ang: "Kilmeri",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kilmeri",
  lc: "kih",
  ld: "ltr",
  alt: ["Kilmera", "Eastern Kilmeri (Ossima)", "Western Kilmeri (Isi)"],
  cc: ["PG"]
}, {
  pk: 2891,
  ang: "Kitsai",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Kitsai",
  lc: "kii",
  ld: "ltr",
  alt: ["Kichai"],
  cc: ["US"]
}, {
  pk: 2892,
  ang: "Kilivila",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kilivila",
  lc: "kij",
  ld: "ltr",
  alt: ["Kiriwina"],
  cc: ["PG"]
}, {
  pk: 2893,
  ang: "Kariya",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kariya",
  lc: "kil",
  ld: "ltr",
  alt: ["Kariyu", "Kauyawa", "Lipkawa", "Vinahe", "Wihe"],
  cc: ["NG"]
}, {
  pk: 2894,
  ang: "Karagas",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0422\u043E\u0444\u0430\u043B\u0430\u0440\u0441\u043A\u0438\u0439",
  lc: "kim",
  ld: "ltr",
  alt: ["Kamas", "Karagass", "Sayan Samoyed", "Tofa", "Tofalar"],
  cc: ["RU"]
}, {
  pk: 8478,
  ang: "Biofu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Biofu",
  lc: "kin-x-biofu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8473,
  ang: "Kijovu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kijovu",
  lc: "kin-x-kijovu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8454,
  ang: "Kinyabinza",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kinyabinza",
  lc: "kin-x-kinyabinza",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7955,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kinyamulenge",
  lc: "kin-x-kinyamulenge",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2895,
  ang: "Kiowa",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Kiowa",
  lc: "kio",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 2896,
  ang: "Kham, Sheshi",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Sheshi Kham",
  lc: "kip",
  ld: "ltr",
  alt: ["Sheshi"],
  cc: ["NP"]
}, {
  pk: 2897,
  ang: "Kosare",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kosadle",
  lc: "kiq",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 2898,
  ang: "Kis",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kis",
  lc: "kis",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2899,
  ang: "Agob",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Agob",
  lc: "kit",
  ld: "ltr",
  alt: ["Dabu"],
  cc: ["PG"]
}, {
  pk: 2900,
  ang: "Zazaki, Northern",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Kirmanjki (individual language)",
  lc: "kiu",
  ld: "ltr",
  alt: ["Alevica", "Dersimki", "Dimilki", "Kirmanjki", "Northern Zaza", "So-B\xEA", "Zaza", "Zon\xEA Ma"],
  cc: ["RS", "TR"]
}, {
  pk: 2901,
  ang: "Kimbu",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Kimbu",
  lc: "kiv",
  ld: "ltr",
  alt: ["Ikibungu", "Kikimbu", "Yanzi"],
  cc: ["TZ"]
}, {
  pk: 2902,
  ang: "Kiwai, Northeast",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Northeast Kiwai",
  lc: "kiw",
  ld: "ltr",
  alt: ["Urama-Kope", "Kope (Era River)", "Arigibi (Anigibi)", "Gope"],
  cc: ["PG"]
}, {
  pk: 2903,
  ang: "Naga, Khiamniungan",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Khiamniungan Naga",
  lc: "kix",
  ld: "ltr",
  alt: ["Aoshedd", "Kalyokengnyu", "Khiamngan", "Khiamniungan", "Nokaw", "Tukhemmi", "Welam", "Makware", "Para", "Nokhu", "Noklak", "Ponso", "Thang", "Wolam"],
  cc: ["IN", "MM"]
}, {
  pk: 2904,
  ang: "Kirikiri",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kirikiri",
  lc: "kiy",
  ld: "ltr",
  alt: ["Kirira"],
  cc: ["ID"]
}, {
  pk: 2905,
  ang: "Kisi",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Kisi",
  lc: "kiz",
  ld: "ltr",
  alt: ["Kese", "Kikisi"],
  cc: ["TZ"]
}, {
  pk: 2906,
  ang: "Kwanyama, Kuanyama",
  lr: "Africa",
  gw: false,
  hc: "AO",
  ln: "Kuanyama",
  lc: "kj",
  ld: "ltr",
  alt: ["Cuanhama", "Humba", "Kuanjama", "Kwancama", "Kwanjama", "Ochikwanyama", "Oshikuanjama", "Oshikwanyama", "Oshiwambo Ndonga", "Ovambo", "Oxikuanyama", "Kuanyama", "Otjiwambo", "Owambo"],
  cc: ["AO", "NA"]
}, {
  pk: 2907,
  ang: "Mlap",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mlap",
  lc: "kja",
  ld: "ltr",
  alt: ["Kuangsu-Bonggrang", "Kwangsu-Bonggrang", "Kwansu", "Kwansu-Bonggrang", "Malf"],
  cc: ["ID"]
}, {
  pk: 2908,
  ang: "Q\u2019anjob\u2019al",
  lr: "Americas",
  gw: false,
  hc: "GT",
  ln: "Q'anjob'al",
  lc: "kjb",
  ld: "ltr",
  alt: ["Conob", "Eastern Kanjobal", "Eastern Qanjobal", "Kanhobal", "Qanjobal", "Santa Eulalia Kanjobal"],
  cc: ["GT", "US"]
}, {
  pk: 2909,
  ang: "Konjo, Coastal",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Coastal Konjo",
  lc: "kjc",
  ld: "ltr",
  alt: ["Kondjo", "Tiro", "Konjo Pesisir (Ara)", "Tana Towa", "Tana Toa (Black Konjo)", "Bantaeng (Bonthain)", "Bira", "Kadjang", "Kajang"],
  cc: ["ID"]
}, {
  pk: 2910,
  ang: "Kiwai, Southern",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Southern Kiwai",
  lc: "kjd",
  ld: "ltr",
  alt: ["Kiwai", "Coast Kiwai", "Island Kiwai (Bamu Kiwai)"],
  cc: ["PG"]
}, {
  pk: 2911,
  ang: "Kisar",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kisar",
  lc: "kje",
  ld: "ltr",
  alt: ["Yotowawa"],
  cc: ["ID"]
}, {
  pk: 2912,
  ang: "Khalaj",
  lr: "Asia",
  gw: false,
  hc: "AZ",
  ln: "X\u0259l\u0259c dili",
  lc: "kjf",
  ld: "ltr",
  alt: [],
  cc: ["AZ"]
}, {
  pk: 2913,
  ang: "Khmu",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "\u0E81\u0EB6\u0EA1\u0EAB\u0EA1\u0EB8",
  lc: "kjg",
  ld: "ltr",
  alt: ["Chaman", "Damai", "Damailao", "Damaile", "Kamhmu", "Kammu", "Kamu", "Kemu", "Khamuk", "Khmu'", "Khomu", "Lao Terng", "Mou", "Pouteng", "Theng", "Kmhmu", "Pu Thenh", "Tenh", "Kha Khmu", "Luu", "Tmooy", "Cam Mu", "Kha Cau", "Kho Mu", "Mun Xen", "Xa Cau", "Khroong (Krong)"],
  cc: ["CN", "FR", "LA", "TH", "US"]
}, {
  pk: 2914,
  ang: "Khakas",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0425\u0430\u043A\u0430\u0441\u0441\u043A\u0438\u0439",
  lc: "kjh",
  ld: "ltr",
  alt: ["Abakan Tatar", "Fuy\xFC G\xEFrg\xEFs", "Fuyu Ka'erkezi", "Hakasi", "Khakhas", "Khakhass", "Manchurian Kirghiz", "Yenisei Tatar", "Hakass", "Xakas", "Yenisei", "Yennisej Tatar", "Xaas", "Xyzyl", "Saghai", "Sagai (Sagaj)", "Koibal (Xoibal)", "Khaas", "Kamass (Kamassian)", "Kachin (Kaca)", "Kyzyl (Khyzyzl)"],
  cc: ["RU"]
}, {
  pk: 2915,
  ang: "Zabana",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Zabana",
  lc: "kji",
  ld: "ltr",
  alt: ["Kia"],
  cc: ["SB"]
}, {
  pk: 2916,
  ang: "Khinalugh",
  lr: "Asia",
  gw: false,
  hc: "AZ",
  ln: "X\u0131nal\u0131q dili",
  lc: "kjj",
  ld: "ltr",
  alt: ["Khinalug", "Khinalugi", "Xinalug"],
  cc: ["AZ"]
}, {
  pk: 2917,
  ang: "Konjo, Highland",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Highland Konjo",
  lc: "kjk",
  ld: "ltr",
  alt: ["Konjo Pegunungan", "Konyo"],
  cc: ["ID"]
}, {
  pk: 2918,
  ang: "Kham, Western Parbate",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Western Parbate Kham",
  lc: "kjl",
  ld: "ltr",
  alt: ["Kham-Magar", "Takale Kham", "Western Parbate", "Maikoti", "Thabangi", "Mahatale"],
  cc: ["NP"]
}, {
  pk: 2919,
  ang: "Kh\xE1ng",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Kh\xE1ng",
  lc: "kjm",
  ld: "ltr",
  alt: ["Bren", "Hang", "Khaang", "Ksakautenh", "Pouteng", "Putenh", "Quang Lam", "Tay Hay", "Tayhay", "Teng", "Theng", "Xa", "Xa Ai", "Xa Bung", "Xa Dang", "Xa Don", "Xa Hoc", "X\xE1 Khao", "Xa Xua", "Kh\xE1ng Ai (Sakau)", "Xa Khao", "Kh\xE1ng Clau", "Xa Cau"],
  cc: ["VN"]
}, {
  pk: 2920,
  ang: "Kunjen",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Kunjen",
  lc: "kjn",
  ld: "ltr",
  alt: ["Guguminjen", "Kukumindjen", "Olgel", "Olgol", "Oykangand (Ogondyan)"],
  cc: ["AU"]
}, {
  pk: 2921,
  ang: "Kinnauri, Pahari",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Harijan Kinnauri",
  lc: "kjo",
  ld: "ltr",
  alt: ["Boli", "Chamang Boli", "Lower Kinnauri", "Orasi", "Ores", "Sonar Boli", "Harija", "Harijan Boli", "Harijan", "Kinnauri"],
  cc: ["IN"]
}, {
  pk: 2922,
  ang: "Karen, Pwo Eastern",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Pwo Eastern Karen",
  lc: "kjp",
  ld: "ltr",
  alt: ["Moulmein Pwo Karen", "Phlong", "Phlou", "Pho", "Southern Pwo Karen", "Moulmein", "Tavoy (Southern Pwo Karen)", "Pa'an (Inland Eastern Pwo Karen)", "Kanchanaburi Pwo Karen", "Ratchaburi Pwo Karen (Phetchaburi Pwo Karen)", "Kawkareik (Eastern Border Pwo Karen)"],
  cc: ["AU", "MM"]
}, {
  pk: 2923,
  ang: "Keres, Western",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Western Keres",
  lc: "kjq",
  ld: "ltr",
  alt: ["Western Keres Pueblo", "Acoma", "Laguna"],
  cc: ["US"]
}, {
  pk: 2924,
  ang: "Kurudu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kurudu",
  lc: "kjr",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 2925,
  ang: "Kewa, East",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "East Kewa",
  lc: "kjs",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2926,
  ang: "Karen, Phrae Pwo",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Phrae Pwo Karen",
  lc: "kjt",
  ld: "ltr",
  alt: ["Northeastern Pwo Karen", "Phrae", "Prae", "Pwo Phrae"],
  cc: ["TH"]
}, {
  pk: 2927,
  ang: "Kashaya",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Kashaya",
  lc: "kju",
  ld: "ltr",
  alt: ["Southwestern Pomo"],
  cc: ["US"]
}, {
  pk: 2928,
  ang: "Kaikavian Literary Language",
  lr: "Europe",
  gw: false,
  hc: "HR",
  ln: "Kaikavian Literary Language",
  lc: "kjv",
  ld: "ltr",
  alt: [],
  cc: ["HR"]
}, {
  pk: 2929,
  ang: "Ramopa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ramopa",
  lc: "kjx",
  ld: "ltr",
  alt: ["Keriaka"],
  cc: ["PG"]
}, {
  pk: 2930,
  ang: "Erave",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Erave",
  lc: "kjy",
  ld: "ltr",
  alt: ["Kewa South", "Pole", "South Kewa"],
  cc: ["PG"]
}, {
  pk: 2931,
  ang: "Bumthangkha",
  lr: "Asia",
  gw: false,
  hc: "BT",
  ln: "Bumthangkha",
  lc: "kjz",
  ld: "ltr",
  alt: ["Bhumtam", "Bumtang", "Bumtangkha", "Bumtanp", "Bumthang", "Bumthapkha", "Kebumtamp"],
  cc: ["BT"]
}, {
  pk: 2932,
  ang: "Kazakh",
  lr: "Asia",
  gw: false,
  hc: "KZ",
  ln: "\u049B\u0430\u0437\u0430\u049B \u0442\u0456\u043B\u0456",
  lc: "kk",
  ld: "ltr",
  alt: ["Hazake", "Kazax", "Gazaqi", "Kazakhi", "Kaisak", "Kosach", "Qazaq", "Qazaqi"],
  cc: ["AZ", "CN", "DE", "IR", "KZ", "MN", "TJ", "TR", "US", "CA", "KG", "TM", "UZ"]
}, {
  pk: 2933,
  ang: "Kakanda",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kakanda",
  lc: "kka",
  ld: "ltr",
  alt: ["Adyaktye", "Akanda", "Hyabe"],
  cc: ["NG"]
}, {
  pk: 2934,
  ang: "Kwerisa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kwerisa",
  lc: "kkb",
  ld: "ltr",
  alt: ["Taogwe"],
  cc: ["ID"]
}, {
  pk: 2935,
  ang: "Odoodee",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Odoodee",
  lc: "kkc",
  ld: "ltr",
  alt: ["Nomad", "Ododei", "Tomu", "Tomu River"],
  cc: ["PG"]
}, {
  pk: 2936,
  ang: "Kinuku",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kinuku",
  lc: "kkd",
  ld: "ltr",
  alt: ["Kinuka"],
  cc: ["NG"]
}, {
  pk: 2937,
  ang: "Kakabe",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Kakabe",
  lc: "kke",
  ld: "ltr",
  alt: ["Fulajon Kan", "Fulajonkan", "Jon Kule", "Ourekabakan", "Kankalabe Kakabe", "Kuru-Maninka", "Sokotoro Kakabe", "Wure-Maninka"],
  cc: ["GN"]
}, {
  pk: 2938,
  ang: "Monpa, Kalaktang",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kalaktang Monpa",
  lc: "kkf",
  ld: "ltr",
  alt: ["Southern Monpa", "Tsangla Monpa"],
  cc: ["IN"]
}, {
  pk: 2939,
  ang: "Kalinga, Mabaka Valley",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Mabaka Valley Kalinga",
  lc: "kkg",
  ld: "ltr",
  alt: ["Kal-Uwan", "Mabaka", "Mabaka Itneg"],
  cc: ["PH"]
}, {
  pk: 2940,
  ang: "Kh\xFCn",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Kh\xFCn",
  lc: "kkh",
  ld: "ltr",
  alt: ["Gon Shan", "Hkun", "Khuen", "Khun Shan", "Khyn", "Tai Khun", "Tai-Khuen", "Kang Muang", "Muang Lang"],
  cc: ["TH", "MM"]
}, {
  pk: 2941,
  ang: "Kagulu",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Kagulu",
  lc: "kki",
  ld: "ltr",
  alt: ["Chikagulu", "Kigaguru", "Kikagulu", "Kiningo", "Northern Sagara", "Solwa", "Mangehele", "Tumba"],
  cc: ["TZ"]
}, {
  pk: 2942,
  ang: "Kako",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Kako",
  lc: "kkj",
  ld: "ltr",
  alt: ["Kaka", "Nkoxo", "Yaka", "Mkako"],
  cc: ["CM", "CF", "CG"]
}, {
  pk: 2943,
  ang: "Kokota",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Kokota",
  lc: "kkk",
  ld: "ltr",
  alt: [],
  cc: ["SB"]
}, {
  pk: 2944,
  ang: "Yale, Kosarek",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kosarek Yale",
  lc: "kkl",
  ld: "ltr",
  alt: ["In-lom", "Wanam", "Yale-Kosarek", "Gilika (Kilika)"],
  cc: ["ID"]
}, {
  pk: 2945,
  ang: "Kiong",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kiong",
  lc: "kkm",
  ld: "ltr",
  alt: ["Akayon", "\xC4k\xE4y\xF6n~", "Akoiyang", "Iyoniyong", "Okonyong", "Okoyong"],
  cc: ["NG"]
}, {
  pk: 2946,
  ang: "Kon Keu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Kon Keu",
  lc: "kkn",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 2947,
  ang: "Karko",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Karko",
  lc: "kko",
  ld: "ltr",
  alt: ["Garko", "Karme", "Kithonirishe", "Kasha", "Shifir"],
  cc: ["SD"]
}, {
  pk: 2948,
  ang: "Gugubera",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Gugubera",
  lc: "kkp",
  ld: "ltr",
  alt: ["Berang", "Kok Kaber", "Koko Bera", "Koko Pera", "Kukubera", "Paperyn"],
  cc: ["AU"]
}, {
  pk: 2949,
  ang: "Kaiku",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kaiku",
  lc: "kkq",
  ld: "ltr",
  alt: ["Ikaiku", "Kaiko"],
  cc: ["CD"]
}, {
  pk: 7780,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kikubere",
  lc: "kkq-x-kikubere",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 2950,
  ang: "Kir-Balar",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kir-Balar",
  lc: "kkr",
  ld: "ltr",
  alt: ["Kirr", "Balar (Larbawa)"],
  cc: ["NG"]
}, {
  pk: 2951,
  ang: "Giiwo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Giiwo",
  lc: "kks",
  ld: "ltr",
  alt: ["Bu Giiwo", "Kirfi", "Kirifawa"],
  cc: ["NG"]
}, {
  pk: 2952,
  ang: "Koi",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Koi",
  lc: "kkt",
  ld: "ltr",
  alt: ["Kohi", "Koyee", "Koyu"],
  cc: ["NP"]
}, {
  pk: 2953,
  ang: "Tumi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Tumi",
  lc: "kku",
  ld: "ltr",
  alt: ["Tutumi"],
  cc: ["NG"]
}, {
  pk: 2954,
  ang: "Kangean",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kangean",
  lc: "kkv",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 2955,
  ang: "Teke-Kukuya",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Teke-Kukuya",
  lc: "kkw",
  ld: "ltr",
  alt: ["Chikuya", "Kikuwa", "Koukouya", "Kukua", "Kukwa", "Southern Teke"],
  cc: ["CG"]
}, {
  pk: 2956,
  ang: "Kohin",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kohin",
  lc: "kkx",
  ld: "ltr",
  alt: ["Bahasa Seruyan", "Seruyan"],
  cc: ["ID"]
}, {
  pk: 2957,
  ang: "Guguyimidjir",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Guguyimidjir",
  lc: "kky",
  ld: "ltr",
  alt: ["Gugu Yimijir", "Gugu-Yimidhirr", "Guugu Yimidhirr", "Guugu Yimithirr", "Koko Imudji", "Kukuyimidir"],
  cc: ["AU"]
}, {
  pk: 2958,
  ang: "Kaska",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Kaska",
  lc: "kkz",
  ld: "ltr",
  alt: ["Caska", "Eastern Nahane", "Nahane", "Nahani"],
  cc: ["CA"]
}, {
  pk: 2959,
  ang: "Kalaallisut, Greenlandic",
  lr: "Americas",
  gw: false,
  hc: "GL",
  ln: "kalaallisut, kalaallit oqaasii",
  lc: "kl",
  ld: "ltr",
  alt: ["Greenlandic", "Inuktitut", "Kalaallisut", "\"Polar Eskimo\"", "Iniktun (Inuktun)", "North Greenlandic", "Thule Inuit"],
  cc: ["GL", "DK"]
}, {
  pk: 2960,
  ang: "Klamath-Modoc",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Klamath-Modoc",
  lc: "kla",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 2961,
  ang: "Kiliwa",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Kiliwa",
  lc: "klb",
  ld: "ltr",
  alt: ["Kiliwi", "Quiligua"],
  cc: ["MX"]
}, {
  pk: 2962,
  ang: "Kolbila",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Kolbila",
  lc: "klc",
  ld: "ltr",
  alt: ["Kolbilari", "Kolbili", "Kolbilla", "Kolena", "Zoono"],
  cc: ["CM"]
}, {
  pk: 2963,
  ang: "Gamilaraay",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Gamilaraay",
  lc: "kld",
  ld: "ltr",
  alt: ["Camileroi", "Gamilaroi"],
  cc: ["AU"]
}, {
  pk: 2964,
  ang: "Kulung",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u0915\u0941\u0932\u0941\u0919 (Nepal)",
  lc: "kle",
  ld: "ltr",
  alt: ["Kholung", "Khulung", "Khulunge Rai", "Kulu Ring", "Sotto Ring"],
  cc: ["NP"]
}, {
  pk: 2965,
  ang: "Kendeje",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Kendeje",
  lc: "klf",
  ld: "ltr",
  alt: [],
  cc: ["TD"]
}, {
  pk: 2966,
  ang: "Tagakaulo",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Tagakaulo",
  lc: "klg",
  ld: "ltr",
  alt: ["Kalagan, Tagakaulu", "Kalagan", "Tagakaulu"],
  cc: ["PH"]
}, {
  pk: 2967,
  ang: "Weliki",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Weliki",
  lc: "klh",
  ld: "ltr",
  alt: ["Karangi", "Weleki"],
  cc: ["PG"]
}, {
  pk: 2968,
  ang: "Kalumpang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kalumpang",
  lc: "kli",
  ld: "ltr",
  alt: ["Galumpang", "Maki", "Ma'ki", "Makki", "Mangkir", "Bone Hau (Ta'da)", "Karataun (E'da)"],
  cc: ["ID"]
}, {
  pk: 2969,
  ang: "Khalaj, Turkic",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u0632\u0628\u0627\u0646 \u062E\u0644\u062C\u06CC",
  lc: "klj",
  ld: "ltr",
  alt: ["Khalaj"],
  cc: ["IR"]
}, {
  pk: 2970,
  ang: "Kono",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kono (Nigeria)",
  lc: "klk",
  ld: "ltr",
  alt: ["Konu", "Kwono"],
  cc: ["NG"]
}, {
  pk: 2971,
  ang: "Kalagan, Kagan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kagan Kalagan",
  lc: "kll",
  ld: "ltr",
  alt: ["Kaagan", "Kagan Kalagan"],
  cc: ["PH"]
}, {
  pk: 2972,
  ang: "Migum",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Migum",
  lc: "klm",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2973,
  ang: "Kalenjin",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Kalenjin",
  lc: "kln",
  ld: "ltr",
  alt: [],
  cc: ["KE"]
}, {
  pk: 2974,
  ang: "Kapya",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kapya",
  lc: "klo",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 2975,
  ang: "Kamasa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kamasa",
  lc: "klp",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2976,
  ang: "Rumu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Rumu",
  lc: "klq",
  ld: "ltr",
  alt: ["Dumu", "Kai-Iri", "Kairi", "Kibiri", "Rumuwa", "Tumu"],
  cc: ["PG"]
}, {
  pk: 2977,
  ang: "Khaling",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u0916\u093E\u0932\u093F\u0919",
  lc: "klr",
  ld: "ltr",
  alt: ["Khael Baat", "Khael Bra", "Khalinge Rai", "Khaling Kura", "Northern Khaling", "Southern Khaling"],
  cc: ["NP"]
}, {
  pk: 2978,
  ang: "Kalasha",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u06A9\u0627\u0644\u0627\u0634 \u0632\u0628\u0627\u0646",
  lc: "kls",
  ld: "ltr",
  alt: ["Kalash", "Kalashamon", "Kelash", "Bumboret", "Northern Kalasha (Birir)", "Rumbur", "Southern Kalasha (Urtsun)"],
  cc: ["PK"]
}, {
  pk: 2979,
  ang: "Nukna",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nukna",
  lc: "klt",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2980,
  ang: "Klao",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Klao",
  lc: "klu",
  ld: "ltr",
  alt: ["Klaoh", "Klau", "Kru"],
  cc: ["LR", "SL"]
}, {
  pk: 2981,
  ang: "Maskelynes",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Maskelynes",
  lc: "klv",
  ld: "ltr",
  alt: ["Kuliviu", "Maskelyne Islands", "Uliveo"],
  cc: ["VU"]
}, {
  pk: 2982,
  ang: "Lindu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lindu",
  lc: "klw",
  ld: "ltr",
  alt: ["Lindoe", "Linduan", "Tado"],
  cc: ["ID"]
}, {
  pk: 2983,
  ang: "Koluwawa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Koluwawa",
  lc: "klx",
  ld: "ltr",
  alt: ["Kalokalo"],
  cc: ["PG"]
}, {
  pk: 2984,
  ang: "Kalao",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kalao",
  lc: "kly",
  ld: "ltr",
  alt: ["Kalaotoa", "Lambego"],
  cc: ["ID"]
}, {
  pk: 2985,
  ang: "Kabola",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kabola",
  lc: "klz",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 2986,
  ang: "Khmer",
  lr: "Asia",
  gw: true,
  hc: "KH",
  ln: "\u1781\u17D2\u1798\u17C2\u179A, \u1781\u17C1\u1798\u179A\u1797\u17B6\u179F\u17B6, \u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A",
  lc: "km",
  ld: "ltr",
  alt: ["Cambodian", "Cu Tho", "Cur Cul", "Khmer Nam Bo", "Kho Me", "Khome", "Krom", "Viet Goc Mien", "Battambang Khmer", "Cardamom Khmer", "Khmer Kandal (Central)", "Khmer Keh (Stung Treng)", "Khmer Krom (Southern)"],
  cc: ["FR", "DE", "LA", "GB", "TH", "US", "AU", "KH", "CA"]
}, {
  pk: 2987,
  ang: "Konni",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Konni",
  lc: "kma",
  ld: "ltr",
  alt: ["Koma", "Komung", "Koni"],
  cc: ["GH"]
}, {
  pk: 2988,
  ang: "Kimbundu",
  lr: "Africa",
  gw: false,
  hc: "AO",
  ln: "Kimbundu",
  lc: "kmb",
  ld: "ltr",
  alt: ["Dongo", "Kimbundo", "Kindongo", "Loanda Mbundu", "Loande", "Luanda", "Lunda", "N'bundo", "Nbundu", "Ndongo", "North Mbundu", "Kimbamba", "Njinga (Ginga)", "Jinga", "Mbaka (Ambaquista)", "Mbamba (Bambeiro)"],
  cc: ["AO"]
}, {
  pk: 2989,
  ang: "Dong, Southern",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5357\u4F97\u8A9E",
  lc: "kmc",
  ld: "ltr",
  alt: ["Gam", "Kam", "Tong", "Tung", "Tung-Chia"],
  cc: ["CN"]
}, {
  pk: 2990,
  ang: "Kalinga, Majukayang",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Majukayang Kalinga",
  lc: "kmd",
  ld: "ltr",
  alt: ["Majukayong", "Kalinga", "Madukayang"],
  cc: ["PH"]
}, {
  pk: 7672,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kalinga of San Mariano Isabela",
  lc: "kmd-x-marian",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2991,
  ang: "Bakole",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bakole",
  lc: "kme",
  ld: "ltr",
  alt: ["Bakolle", "Bamusso", "Kole"],
  cc: ["CM"]
}, {
  pk: 2992,
  ang: "Kare",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kare (Papua New Guinea)",
  lc: "kmf",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 2993,
  ang: "K\xE2te",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "K\xE2te",
  lc: "kmg",
  ld: "ltr",
  alt: ["Kai", "K\xE2te Dong", "Magobineng (Bamota)", "Wamora (Wamola)"],
  cc: ["PG"]
}, {
  pk: 2994,
  ang: "Kalam",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kalam",
  lc: "kmh",
  ld: "ltr",
  alt: ["Aforo", "Karam"],
  cc: ["PG"]
}, {
  pk: 2995,
  ang: "Kami",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kami (Nigeria)",
  lc: "kmi",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 2996,
  ang: "Kumarbhag Paharia",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kumarbhag Paharia",
  lc: "kmj",
  ld: "ltr",
  alt: ["Kumar", "Mad", "Maler", "Malti", "Malto", "Maltu", "Paharia", "Pahariya"],
  cc: ["IN"]
}, {
  pk: 2997,
  ang: "Kalinga, Limos",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Limos Kalinga",
  lc: "kmk",
  ld: "ltr",
  alt: ["Limos-Liwan Kalinga", "Northern Kalinga"],
  cc: ["PH"]
}, {
  pk: 7862,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kalinga-Biga",
  lc: "kmk-x-biga",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2998,
  ang: "Kalinga, Tanudan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Tanudan Kalinga",
  lc: "kml",
  ld: "ltr",
  alt: ["Lower Tanudan", "Lower Tanudan Kalinga", "Mangali Kalinga", "Tinaloctoc", "Minangali", "Pinangol"],
  cc: ["PH"]
}, {
  pk: 7749,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Lubo",
  lc: "kml-x-lubo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7666,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kalingnga of San Mariano Isabela",
  lc: "kml-x-marian",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8298,
  ang: "Pangul",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Pangul",
  lc: "kml-x-pangul",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7989,
  ang: "Taluctoc",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Taloctuc",
  lc: "kml-x-taluctoc",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 2999,
  ang: "Kom",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kom (India)",
  lc: "kmm",
  ld: "ltr",
  alt: ["Kom Rem"],
  cc: ["IN"]
}, {
  pk: 3000,
  ang: "Awtuw",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Awtuw",
  lc: "kmn",
  ld: "ltr",
  alt: ["Kamnum"],
  cc: ["PG"]
}, {
  pk: 3001,
  ang: "Kwoma",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kwoma",
  lc: "kmo",
  ld: "ltr",
  alt: ["Kwoma (Washkuk)"],
  cc: ["PG"]
}, {
  pk: 3002,
  ang: "Gimme",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Gimme",
  lc: "kmp",
  ld: "ltr",
  alt: ["Koma Kompana", "Kompana", "Kompara", "Panbe"],
  cc: ["CM"]
}, {
  pk: 3003,
  ang: "Kwama",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Kwama",
  lc: "kmq",
  ld: "ltr",
  alt: ["Afan Mao", "Amam", "Gogwama", "Goma", "Koma of Asosa", "Nokanoka", "North Koma", "Takwama", "T'wa Kwama"],
  cc: ["ET"]
}, {
  pk: 3004,
  ang: "Kurdish, Northern",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Northern Kurdish",
  lc: "kmr",
  ld: "ltr",
  alt: ["\xCAzd\xEEk\xEE", "Kurmanc\xEE", "Kurmanji", "Kurd\xEE", "Badinani", "Bahdini", "Kirmanciya Jori", "Eastern Kurmanji", "Kordi", "Kurdi", "Khorasani", "Khorasani Kurmanji", "Kermanc\xEE", "Kirmanc\xEE", "Hekari", "Shikak\xEE", "Shemdinani", "Northern Kurdish (Kurmanji)", "Mihemed\xEE", "Zakho", "Siliv\xEE", "Khorassani Kurmanji", "Gulli", "Boti (Botani)", "Bayezidi", "Barwari Jor", "Ashiti", "Marashi"],
  cc: ["AM", "AZ", "AT", "BE", "FR", "DE", "IR", "IQ", "KZ", "LB", "GB", "NL", "SY", "TR", "AU", "CA", "GE", "JO", "IT", "KG", "UZ", "BH"]
}, {
  pk: 7786,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Shikaki",
  lc: "kmr-x-shikaki",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3005,
  ang: "Kamasau",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kamasau",
  lc: "kms",
  ld: "ltr",
  alt: ["Wand Tuan"],
  cc: ["PG"]
}, {
  pk: 3006,
  ang: "Kemtuik",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kemtuik",
  lc: "kmt",
  ld: "ltr",
  alt: ["Kamtuk"],
  cc: ["ID"]
}, {
  pk: 3007,
  ang: "Kanite",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kanite",
  lc: "kmu",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3008,
  ang: "Karipuna Creole French",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Karip\xFAna Creole French",
  lc: "kmv",
  ld: "ltr",
  alt: ["Crioulo"],
  cc: ["BR"]
}, {
  pk: 7864,
  ang: "",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Kheuol",
  lc: "kmv-x-kheuol",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7865,
  ang: "",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Patu\xE1",
  lc: "kmv-x-patu\xE1",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3009,
  ang: "Komo",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Komo (Democratic Republic of Congo)",
  lc: "kmw",
  ld: "ltr",
  alt: ["Kikumo", "Kikumu", "Kikuumu", "Kumo", "Kumu", "Kuumu"],
  cc: ["CD"]
}, {
  pk: 8458,
  ang: "Kikumu Lubuto",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kikumu Lubuto",
  lc: "kmw-x-lubuto",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8455,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kikumu Nyiragongo",
  lc: "kmw-x-nyiragongo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8457,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kikumu Punia",
  lc: "kmw-x-punia",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8456,
  ang: "Kikumu Walekale",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kikumu Walekale",
  lc: "kmw-x-walekale",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3010,
  ang: "Waboda",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Waboda",
  lc: "kmx",
  ld: "ltr",
  alt: ["Wabuda"],
  cc: ["PG"]
}, {
  pk: 3011,
  ang: "Koma",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Koma",
  lc: "kmy",
  ld: "ltr",
  alt: ["Kuma", "Yeru", "Youtubo", "Leelu", "Vomni", "Panbe", "Ndera (Doobe)", "Mbeya", "LIU", "Bangru", "Laame", "Zanu", "Doome", "Gomme (Damti)", "Gomnome (Gimbe)", "Koma Damti", "Koma Kadam", "Koma Kampana", "Koma Ndera"],
  cc: ["CM", "NG"]
}, {
  pk: 3012,
  ang: "Khorasani Turkish",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u0632\u0628\u0627\u0646 \u062A\u0631\u06A9\u06CC \u062E\u0631\u0627\u0633\u0627\u0646\u06CC",
  lc: "kmz",
  ld: "ltr",
  alt: ["Quchani", "West Quchani (Northwest Quchani)", "North Quchani (Northeast Quchani)"],
  cc: ["IR"]
}, {
  pk: 3013,
  ang: "Kannada",
  lr: "Asia",
  gw: true,
  hc: "IN",
  ln: "\u0C95\u0CA8\u0CCD\u0CA8\u0CA1",
  lc: "kn",
  ld: "ltr",
  alt: ["Banglori", "Canarese", "Kanarese", "Madrassi", "Bellary", "Gulbarga", "Kumta", "Nanjangud"],
  cc: ["MY", "US", "CA", "IN", "SG"]
}, {
  pk: 3014,
  ang: "Dera",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Dera (Nigeria)",
  lc: "kna",
  ld: "ltr",
  alt: ["Kanakuru"],
  cc: ["NG"]
}, {
  pk: 3015,
  ang: "Kalinga, Lubuagan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Lubuagan Kalinga",
  lc: "knb",
  ld: "ltr",
  alt: ["Balatok-Kalinga (Balatok-Itneg)", "Lubuagan"],
  cc: ["PH"]
}, {
  pk: 8326,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kalinga Balantoy",
  lc: "knb-x-balantoy",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7675,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kalingan Balbalan",
  lc: "knb-x-balbal",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7811,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kalinga Balbalan",
  lc: "knb-x-balbalan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8299,
  ang: "Ibalatok",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Ibalatok",
  lc: "knb-x-ibalatok",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8460,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Karakkad",
  lc: "knb-x-karakkad",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7674,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kalinga Naneng",
  lc: "knb-x-naneng",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8301,
  ang: "Tobog",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Tobog",
  lc: "knb-x-tobog",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7812,
  ang: "Tubo Kalinga",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kalinga Tubo",
  lc: "knb-x-tubo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3016,
  ang: "Kanuri, Central",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Central Kanuri",
  lc: "knc",
  ld: "ltr",
  alt: ["Bornouan", "Bornouans", "Bornu", "Kanouri", "Kanoury", "Kole", "Kolere", "Sirata", "Yerwa Kanuri", "Baribari", "Beriberi", "Aga", "Kabari (Kuvuri)", "Movar (Mavar)", "Yerwa", "Mowor", "Mowor (Movar)", "Mober", "Mobber", "Kaga (Kagama)", "Lare (Lere)"],
  cc: ["CM", "NE", "NG", "SD", "TD"]
}, {
  pk: 3017,
  ang: "Konda",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Konda",
  lc: "knd",
  ld: "ltr",
  alt: ["Ogit", "Yabin", "Yabin-Konda"],
  cc: ["ID"]
}, {
  pk: 3018,
  ang: "Kankanaey",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kankanaey",
  lc: "kne",
  ld: "ltr",
  alt: ["Central Kankanaey", "Kankanai", "Kankanay"],
  cc: ["PH"]
}, {
  pk: 3019,
  ang: "Mankanya",
  lr: "Africa",
  gw: false,
  hc: "GW",
  ln: "Mankanya",
  lc: "knf",
  ld: "ltr",
  alt: ["Bola", "Mancagne", "Mancang", "Mankaa\xF1", "Mankanha", "Uhula", "Uwoh"],
  cc: ["GM", "SN", "GW"]
}, {
  pk: 3020,
  ang: "Koongo",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Koongo",
  lc: "kng",
  ld: "ltr",
  alt: ["Congo", "Kikoongo", "Kikongo", "Kongo-Nseke", "Kiyombe (Cabinda)", "Kizombo", "West Kongo (Fiote)", "South East Kongo", "Nzamba (Dzamba)", "Bwende (Buende)", "Kisikongo", "San Salvador Kongo", "Kindibu", "Kimanyanga", "Kiwoyo (Cabinda)"],
  cc: ["CD", "AO", "UG"]
}, {
  pk: 7795,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kilemfu",
  lc: "kng-x-kilemfu",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 7796,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kindibu",
  lc: "kng-x-kindibu",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 7797,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kitandu",
  lc: "kng-x-kitandu",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 3021,
  ang: "Kanufi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kanufi",
  lc: "kni",
  ld: "ltr",
  alt: ["Karshi"],
  cc: ["NG"]
}, {
  pk: 3022,
  ang: "Akateko",
  lr: "Americas",
  gw: false,
  hc: "GT",
  ln: "Western Kanjobal",
  lc: "knj",
  ld: "ltr",
  alt: ["Acatec", "Acateco", "Conob", "Q'anjob'al", "San Miguel Acat\xE1n Kanjobal", "Western Kanjobal", "Western Q'anjob'al", "Kanjobal de San Miguel Acat\xE1n"],
  cc: ["GT"]
}, {
  pk: 3023,
  ang: "Kuranko",
  lr: "Africa",
  gw: false,
  hc: "SL",
  ln: "Kuranko",
  lc: "knk",
  ld: "ltr",
  alt: ["Sengbe", "Faranah", "Fineriya", "Sankaran"],
  cc: ["GN", "SL"]
}, {
  pk: 3024,
  ang: "Keninjal",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Keninjal",
  lc: "knl",
  ld: "ltr",
  alt: ["Dayak Kaninjal", "Kaninjal", "Kaninjal Dayak"],
  cc: ["ID"]
}, {
  pk: 7901,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Barai",
  lc: "knl-x-dayakbarai",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8034,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Goneh",
  lc: "knl-x-dayakgoneh",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8106,
  ang: "Dayak Penyelompat",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Penyelompat",
  lc: "knl-x-dayakpenyelompat",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7956,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Sekubin",
  lc: "knl-x-dayaksekubin",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7912,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Kebahan",
  lc: "knl-x-kebahan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8108,
  ang: "Dayak Kebahatn Ulak",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Kebahatn Ulak",
  lc: "knl-x-kebahaulak",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8180,
  ang: "Dayak Kenyabur",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Kenyabur",
  lc: "knl-x-kenyabur",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7962,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Kenyilu",
  lc: "knl-x-kenyilu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7964,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Kubin",
  lc: "knl-x-kubin",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7963,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Kubing",
  lc: "knl-x-kubing",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7972,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Ransa",
  lc: "knl-x-ransa",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8321,
  ang: "Dayak Ulu Sekadau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Ulu Sekadau",
  lc: "knl-x-ulusekadau",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3025,
  ang: "Kanamar\xED",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Kanamar\xED",
  lc: "knm",
  ld: "ltr",
  alt: ["Canamar\xED", "Kanamar\xE9", "Txunhu\xE3-Djap\xE1", "Tshom-Djapa (Txunhu\xE3 Dyap\xE1)", "Tsohon-Djapa"],
  cc: ["BR"]
}, {
  pk: 3026,
  ang: "Konkani",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Konkani (individual language)",
  lc: "knn",
  ld: "ltr",
  alt: ["Bankoti", "Central Konkan", "Concorinum", "Cugani", "Kathodi", "Katvadi", "Konkan Standard", "Konkani Mangalorean", "Kunabi", "North Konkan", "Parvari", "Thakura", "Thakua", "Thakri", "Ghati (Maoli)", "Sangamesvari (Bakoti)", "Thakuri (Thakari)", "Parabhi (Damani)", "Mahari (Dhed)", "Holia", "Chitapavani", "Agari of Kolaba", "Kayasthi"],
  cc: ["CA", "IN"]
}, {
  pk: 7649,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Agri",
  lc: "knn-x-agri",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3027,
  ang: "Kono",
  lr: "Africa",
  gw: false,
  hc: "SL",
  ln: "Kono (Sierra Leone)",
  lc: "kno",
  ld: "ltr",
  alt: ["Konnoh", "Nimi Koro", "Toli", "Tankoro", "Soa", "Penguia", "Northern Kono (Sando)", "Mafindo", "Central Kono (Fiama)", "Lei", "Kamara", "Gorama Kono", "Gbense", "Gbane Kando", "Gbane", "Nimi Yama"],
  cc: ["SL"]
}, {
  pk: 3028,
  ang: "Kwanja",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Kwanja",
  lc: "knp",
  ld: "ltr",
  alt: ["Kondja", "Konja", "Twendi", "Sundani (Sun)", "Ndung (Ndungani)", "Njanga (Njang)"],
  cc: ["CM"]
}, {
  pk: 3029,
  ang: "Kintaq",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Kintaq",
  lc: "knq",
  ld: "ltr",
  alt: ["Bong", "Kenta", "Kintak", "Kintaq Bong", "Kintk"],
  cc: ["MY"]
}, {
  pk: 3030,
  ang: "Kaningra",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kaningra",
  lc: "knr",
  ld: "ltr",
  alt: ["Kaningara"],
  cc: ["PG"]
}, {
  pk: 3031,
  ang: "Kensiu",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Kensiu",
  lc: "kns",
  ld: "ltr",
  alt: ["Kenseu", "Kensieu", "Kensiw", "Mendi", "Monik", "Moniq", "Ngok Pa", "Orang Bukit", "Orang Liar", "Belubn", "Kense", "Maniq", "Mawas", "Mengo", "Meni", "Menik", "Moni", "Mos", "Sakai", "Tiong", "Kensiu Batu (Batuq)", "Kedah (Quedah)", "Kentaq Nakil (Nakil)", "Bong", "Jeher (Sakai Tanjong of Temongoh)", "Ijoh (Ijok)", "Kensiu Siong (Siong)"],
  cc: ["MY", "TH"]
}, {
  pk: 3032,
  ang: "Katuk\xEDna, Panoan",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Panoan Katuk\xEDna",
  lc: "knt",
  ld: "ltr",
  alt: ["Catuquina", "Kamannaua", "Katukina do Juru\xE1", "Waninnawa", "Arara-Shawanawa (Shawanawa-Arara)", "Sanainawa (Saninawacana)"],
  cc: ["BR"]
}, {
  pk: 3033,
  ang: "Kono",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Kono (Guinea)",
  lc: "knu",
  ld: "ltr",
  alt: [],
  cc: ["GN"]
}, {
  pk: 3034,
  ang: "Tabo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tabo",
  lc: "knv",
  ld: "ltr",
  alt: ["Waya"],
  cc: ["PG"]
}, {
  pk: 3035,
  ang: "Kung-Ekoka",
  lr: "Africa",
  gw: false,
  hc: "NA",
  ln: "Kung-Ekoka",
  lc: "knw",
  ld: "ltr",
  alt: ["!Hu", "!Ku", "!Kung", "!Xu", "Ekoko-!X\xFB", "Qx\xFB", "!Khung", "!Xun", "!Xung", "Ekoka !Xung", "Ekoka-!X\xFB", "Qx\xFC", "Akhoe"],
  cc: ["NA"]
}, {
  pk: 3036,
  ang: "Kendayan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kendayan",
  lc: "knx",
  ld: "ltr",
  alt: ["Baicit", "Damea", "Kanayatn", "Kendayan Dayak", "Kendayan-Ambawang", "Salako", "Kenayatn", "Salakau", "Selako", "Silakau"],
  cc: ["ID", "MY"]
}, {
  pk: 7621,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bajantri",
  lc: "kn-x-bajantri",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7715,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bedar",
  lc: "kn-x-bedar",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7579,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bhovi",
  lc: "kn-x-bhovi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7643,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Buduga Jangam",
  lc: "kn-x-budugaja",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7580,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bunde Bestaru",
  lc: "kn-x-bundebes",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7608,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Chenna Dasar",
  lc: "kn-x-chennada",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7581,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Chollivala Nayaka",
  lc: "kn-x-cholliva",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8047,
  ang: "Devanga",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Devanga",
  lc: "kn-x-devanga",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7610,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Dombaru",
  lc: "kn-x-dombaru",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7611,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Dravidar",
  lc: "kn-x-dravidar",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7612,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Handi Jogi",
  lc: "kn-x-handijog",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7617,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Jangalu",
  lc: "kn-x-jangalu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8049,
  ang: "Kamashettaru",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kamashettaru",
  lc: "kn-x-kamashettaru",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7583,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kammara",
  lc: "kn-x-kammara",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7670,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Periya",
  lc: "kn-x-periya",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7671,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Rate",
  lc: "kn-x-rate",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7717,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Siddi",
  lc: "kn-x-siddi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7614,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Sillekyatha",
  lc: "kn-x-sillekya",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7589,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Swali",
  lc: "kn-x-swali",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7692,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Takalik",
  lc: "kn-x-takali",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7718,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Vagri",
  lc: "kn-x-vagri",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7706,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Kanayate Ahe",
  lc: "knx-x-ahe",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7952,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Be,aje",
  lc: "knx-x-baajeaje",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7845,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Baape",
  lc: "knx-x-baape",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7843,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Bajanya",
  lc: "knx-x-bajanya",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7844,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Bajare",
  lc: "knx-x-bajare",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7983,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Ahe",
  lc: "knx-x-dayakahe",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8086,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Muara",
  lc: "knx-x-dayakmuara",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7856,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Jawant",
  lc: "knx-x-jawant",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7873,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Punan Gong Solok",
  lc: "knx-x-punangongsolok",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8006,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Ahe",
  lc: "knx-x-redundantahe",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7616,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Yalavaru",
  lc: "kn-x-yalavaru",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7615,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Yeddumarigi",
  lc: "kn-x-yeddumar",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3037,
  ang: "Kanyok",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kanyok",
  lc: "kny",
  ld: "ltr",
  alt: ["Kanioka", "Kanyoka"],
  cc: ["CD"]
}, {
  pk: 3038,
  ang: "Kalams\xE9",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Kalams\xE9",
  lc: "knz",
  ld: "ltr",
  alt: ["Kalems\xE9", "Kalenga", "S\xE0m\xF2m\xE1", "Kalams\xE9", "West Kalams\xE9", "Kasoma (East Kalams\xE9)", "Logremma (Logma)"],
  cc: ["BF", "ML"]
}, {
  pk: 3039,
  ang: "Korean",
  lr: "Asia",
  gw: false,
  hc: "KR",
  ln: "\uD55C\uAD6D\uC5B4, \uC870\uC120\uC5B4",
  lc: "ko",
  ld: "ltr",
  alt: ["Chaoxian", "Hanguohua", "Hanguk Mal", "Hanguk Uh", "Seoul (Kangwondo)", "South P'yong'ando", "South Kyongsangdo", "South Hamgyongdo", "South Chollado", "P'yong'ando (North P'yong'ando)", "Kyongsangdo (North Kyongsangdo)", "Kyonggido", "Hamgyongdo (North Hamgyongdo)", "Ch'ungch'ongdo (North Ch'ungch'ong)", "Chollado (North Chollado)", "South Ch'ungch'ong", "Hangeul"],
  cc: ["BR", "CN", "AR", "FR", "DE", "IR", "JP", "KZ", "KR", "MG", "PA", "ES", "GB", "GT", "MZ", "NL", "NZ", "PY", "HN", "TH", "US", "AU", "CA", "KP", "KG", "TM", "SG", "DO"]
}, {
  pk: 3040,
  ang: "Konomala",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Konomala",
  lc: "koa",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3041,
  ang: "Kodi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kodi",
  lc: "kod",
  ld: "ltr",
  alt: ["Kudi", "Nggaro (Nggaura)"],
  cc: ["ID"]
}, {
  pk: 3042,
  ang: "Kacipo-Balesi",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Kacipo-Balesi",
  lc: "koe",
  ld: "ltr",
  alt: ["Silmamo", "Tsilmano", "Zelmamu", "Zulmamu"],
  cc: ["ET", "SS"]
}, {
  pk: 3043,
  ang: "Kubi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kubi",
  lc: "kof",
  ld: "ltr",
  alt: ["Kuba", "Kubawa"],
  cc: ["NG"]
}, {
  pk: 3044,
  ang: "Kogi",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Cogui",
  lc: "kog",
  ld: "ltr",
  alt: ["Coghui", "Cogui", "Kagaba", "Kaggaba", "Kogui"],
  cc: ["CO"]
}, {
  pk: 3045,
  ang: "Koyo",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Koyo",
  lc: "koh",
  ld: "ltr",
  alt: ["Ekoyo", "Kouyou"],
  cc: ["CG"]
}, {
  pk: 3046,
  ang: "Komi-Permyak",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041A\u043E\u043C\u0438-\u043F\u0435\u0440\u043C\u044F\u0446\u043A\u0438\u0439",
  lc: "koi",
  ld: "ltr",
  alt: ["Kama Permyak", "Komi-Perm", "Komi-Permyat", "Permyak", "North Permyak (Kochin-Kam)", "South Permyak (Inyven)"],
  cc: ["RU"]
}, {
  pk: 3047,
  ang: "Konkani",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Konkani (macrolanguage)",
  lc: "kok",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 3048,
  ang: "Kol",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kol (Papua New Guinea)",
  lc: "kol",
  ld: "ltr",
  alt: ["Kola", "Kole", "Kol (Nakgaktai)"],
  cc: ["PG"]
}, {
  pk: 3049,
  ang: "Konzo",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Konzo",
  lc: "koo",
  ld: "ltr",
  alt: ["Konjo", "Lhukonzo", "Olukonjo", "Olukonzo", "Olhughendera", "Rukonzo (Rukonjo)", "Lusongora", "Sanza (Ekisanza)"],
  cc: ["UG"]
}, {
  pk: 3050,
  ang: "Waube",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Waube",
  lc: "kop",
  ld: "ltr",
  alt: ["Waupe"],
  cc: ["PG"]
}, {
  pk: 3051,
  ang: "Kota",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Kota (Gabon)",
  lc: "koq",
  ld: "ltr",
  alt: ["Ikuta", "Kotu"],
  cc: ["GA", "CG"]
}, {
  pk: 3052,
  ang: "Kosraean",
  lr: "Pacific",
  gw: false,
  hc: "FM",
  ln: "Kosraean",
  lc: "kos",
  ld: "ltr",
  alt: ["Kosrae", "Kusaie"],
  cc: ["US", "NR", "FM"]
}, {
  pk: 3053,
  ang: "Lagwan",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Lagwan",
  lc: "kot",
  ld: "ltr",
  alt: ["Kotoko-Logone", "Lagouane", "Lagwane", "Logone", "Logone-Gana (Kotoko-Gana)"],
  cc: ["CM", "TD"]
}, {
  pk: 3054,
  ang: "Koke",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Koke",
  lc: "kou",
  ld: "ltr",
  alt: ["Khoke"],
  cc: ["TD"]
}, {
  pk: 3055,
  ang: "Kudu-Camo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kudu-Camo",
  lc: "kov",
  ld: "ltr",
  alt: ["Kuda-Chamo", "Kudawa", "Kudu (Kuda)", "Camo (Chamo)"],
  cc: ["NG"]
}, {
  pk: 3056,
  ang: "Kugama",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kugama",
  lc: "kow",
  ld: "ltr",
  alt: ["Kugamma", "Wegam", "Yamale", "Yamalo"],
  cc: ["NG"]
}, {
  pk: 3057,
  ang: "Koyukon",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Koyukon",
  lc: "koy",
  ld: "ltr",
  alt: ["Ten'a", "Upper Koyukon", "Lower Koyukon", "Central Koyukon", "Central Koyukuk River"],
  cc: ["US"]
}, {
  pk: 3058,
  ang: "Korak",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Korak",
  lc: "koz",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3059,
  ang: "Kutto",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kutto",
  lc: "kpa",
  ld: "ltr",
  alt: ["K\xFAtt\xF2"],
  cc: ["NG"]
}, {
  pk: 3060,
  ang: "Kurumba, Mullu",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mullu Kurumba",
  lc: "kpb",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 3061,
  ang: "Curripaco",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Curripaco",
  lc: "kpc",
  ld: "ltr",
  alt: ["Cumata", "Ipeca", "Koripako", "Korispaso", "Kuripako", "Pacu", "Paku-Tapuya", "Palioariene", "Pato Tapuia", "Pato-Tapuya", "Payualiene", "Payuliene", "Karrupaku", "Kuripaco", "Kurripaco", "Waquenia", "Kurripako", "Yaverete-Tapuya", "\xC2ja-Kurri", "\xCAje-Kj\xE9nim", "Enhen", "Korripako (Karupaka)", "\xD4jo-Kj\xE1rru", "Unhun (Cadauapuritana)", "Waliperi (Veliperi)"],
  cc: ["BR", "VE", "CO", "US"]
}, {
  pk: 3062,
  ang: "Koba",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Koba",
  lc: "kpd",
  ld: "ltr",
  alt: ["Southeast Koba"],
  cc: ["ID"]
}, {
  pk: 3063,
  ang: "Kpelle",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Kpelle",
  lc: "kpe",
  ld: "ltr",
  alt: [],
  cc: ["LR"]
}, {
  pk: 3064,
  ang: "Komba",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Komba",
  lc: "kpf",
  ld: "ltr",
  alt: ["Neng Den"],
  cc: ["PG"]
}, {
  pk: 3065,
  ang: "Kapingamarangi",
  lr: "Pacific",
  gw: false,
  hc: "FM",
  ln: "Kapingamarangi",
  lc: "kpg",
  ld: "ltr",
  alt: ["Kirinit"],
  cc: ["FM"]
}, {
  pk: 3066,
  ang: "Kplang",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Kplang",
  lc: "kph",
  ld: "ltr",
  alt: [],
  cc: ["GH"]
}, {
  pk: 3067,
  ang: "Kofei",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kofei",
  lc: "kpi",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3068,
  ang: "Karaj\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Karaj\xE1",
  lc: "kpj",
  ld: "ltr",
  alt: ["Caraiauna", "Chambioa", "Iraru Mahadu", "Ixbyowa", "Karaja do Norte", "Yn\xE3", "Xambio\xE1", "Java\xE9 (Javahe)", "Karaj\xE1"],
  cc: ["BR"]
}, {
  pk: 3069,
  ang: "Kpan",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kpan",
  lc: "kpk",
  ld: "ltr",
  alt: ["Abakan", "Hwaso", "Hwaye", "Ibukwo", "Ikpan", "Kpanten", "Kpwate", "Nyatso", "Nyonyo", "Yorda", "Kyentu", "Kumbo (Kpanzon)", "Donga (Akpanzhi)", "Kentu", "Kente (Etkye)"],
  cc: ["NG"]
}, {
  pk: 3070,
  ang: "Kpala",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kpala",
  lc: "kpl",
  ld: "ltr",
  alt: ["Gbakpwa", "Kpwaala", "Kwala"],
  cc: ["CD"]
}, {
  pk: 3071,
  ang: "Koho",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "K\u01A1ho",
  lc: "kpm",
  ld: "ltr",
  alt: ["Caho", "Co Ho", "Coho", "Kohor", "Tala (To La)", "Tring (Trinh)", "Nop (Tu-Lop)", "Lat", "Lac (Lach)", "Kodu (Co-Don)", "Chil (Kil)", "Xre Nop"],
  cc: ["VN"]
}, {
  pk: 3072,
  ang: "Ikposo",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Ikposo",
  lc: "kpo",
  ld: "ltr",
  alt: ["Akposso", "Kposo", "Iwi (Uwi)", "Litime (Badou)"],
  cc: ["GH", "TG"]
}, {
  pk: 3073,
  ang: "Korupun-Sela",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Korupun-Sela",
  lc: "kpq",
  ld: "ltr",
  alt: ["Kimyal of Korupun", "Korapun", "Korupun (Duram)", "Sisibna (Gobugdua)"],
  cc: ["ID"]
}, {
  pk: 3074,
  ang: "Korafe-Yegha",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Korafe-Yegha",
  lc: "kpr",
  ld: "ltr",
  alt: ["Kailikaili", "Kaire", "Korafi", "Korape", "Kwarafe", "Yegha (Mokorua)"],
  cc: ["PG"]
}, {
  pk: 3075,
  ang: "Tehit",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tehit",
  lc: "kps",
  ld: "ltr",
  alt: ["Kaibus", "Tahit", "Tehid"],
  cc: ["ID"]
}, {
  pk: 8463,
  ang: "Kaigar",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kaigar",
  lc: "kps-x-kaigar",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3076,
  ang: "Karata",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041A\u0430\u0440\u0430\u0442\u0438\u043D\u0441\u043A\u0438\u0439",
  lc: "kpt",
  ld: "ltr",
  alt: ["Karatai", "Karatin", "Kirdi", "Karata proper (Anchix)", "Tokita (Tokitin)", "Ratsitl", "Enkhelo", "Archo", "Chabakaroi"],
  cc: ["RU"]
}, {
  pk: 3077,
  ang: "Kafoa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kafoa",
  lc: "kpu",
  ld: "ltr",
  alt: ["Aikoli", "Fanating", "Jafoo", "Pailelang", "Ruilak"],
  cc: ["ID"]
}, {
  pk: 3078,
  ang: "Komi-Zyrian",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041A\u043E\u0301\u043C\u0438-\u0437\u044B\u0440\u044F\u0301\u043D\u0441\u043A\u0438\u0439",
  lc: "kpv",
  ld: "ltr",
  alt: ["Komi"],
  cc: ["KZ", "RU", "UZ"]
}, {
  pk: 3079,
  ang: "Kobon",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kobon",
  lc: "kpw",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 8349,
  ang: "Kou",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kou",
  lc: "kpw-x-kou",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3080,
  ang: "Koiali, Mountain",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mountain Koiali",
  lc: "kpx",
  ld: "ltr",
  alt: ["Mountain Koiari"],
  cc: ["PG"]
}, {
  pk: 3081,
  ang: "Koryak",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041A\u043E\u0440\u044F\u043A\u0441\u043A\u0438\u0439",
  lc: "kpy",
  ld: "ltr",
  alt: ["Chavchuven", "Nymylan", "Apokinskij (Apukin)", "Cavcuvenskij (Chavchuven)", "Kamenskij (Kamen)"],
  cc: ["RU"]
}, {
  pk: 3082,
  ang: "Kupsapiiny",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Kupsabiny",
  lc: "kpz",
  ld: "ltr",
  alt: ["Kuksabin", "Kupsabiny", "Sapei", "Kongasis", "Kween (Sor)"],
  cc: ["SD", "UG"]
}, {
  pk: 3083,
  ang: "Mum",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mum",
  lc: "kqa",
  ld: "ltr",
  alt: ["Katiati"],
  cc: ["PG"]
}, {
  pk: 3084,
  ang: "Kovai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kovai",
  lc: "kqb",
  ld: "ltr",
  alt: ["Kobai", "Kowai"],
  cc: ["PG"]
}, {
  pk: 3085,
  ang: "Doromu-Koki",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Doromu-Koki",
  lc: "kqc",
  ld: "ltr",
  alt: ["Dorom", "Doromu", "Koki", "Origo"],
  cc: ["PG"]
}, {
  pk: 3086,
  ang: "Koy Sanjaq Surat",
  lr: "Asia",
  gw: false,
  hc: "IQ",
  ln: "\u0723\u0718\u072A\u072C",
  lc: "kqd",
  ld: "ltr",
  alt: ["Koi Sanjaq Soorit", "Koi-Sanjaq Sooret", "Koy Sanjaq Sooret", "Koy Sanjaq Soorit"],
  cc: ["IQ"]
}, {
  pk: 3087,
  ang: "Kalagan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kalagan",
  lc: "kqe",
  ld: "ltr",
  alt: ["Kaagan", "Kalagan, Minuslim", "Kinalagan", "Eastern Kalagan", "Western Kalagan", "Minuslim"],
  cc: ["PH"]
}, {
  pk: 3088,
  ang: "Kakabai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kakabai",
  lc: "kqf",
  ld: "ltr",
  alt: ["Igora"],
  cc: ["PG"]
}, {
  pk: 3089,
  ang: "Khe",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Khe",
  lc: "kqg",
  ld: "ltr",
  alt: ["Bambadion-Kheso", "Kheso"],
  cc: ["BF"]
}, {
  pk: 3090,
  ang: "Kisankasa",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Kisankasa",
  lc: "kqh",
  ld: "ltr",
  alt: ["Dorobo", "Ndorobo"],
  cc: ["TZ"]
}, {
  pk: 3091,
  ang: "Koitabu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Koitabu",
  lc: "kqi",
  ld: "ltr",
  alt: ["Koita"],
  cc: ["PG"]
}, {
  pk: 3092,
  ang: "Koromira",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Koromira",
  lc: "kqj",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3093,
  ang: "Gbe, Kotafon",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Kotafon Gbe",
  lc: "kqk",
  ld: "ltr",
  alt: ["Ko", "Kogbe"],
  cc: ["BJ"]
}, {
  pk: 3094,
  ang: "Kyenele",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kyenele",
  lc: "kql",
  ld: "ltr",
  alt: ["Bulang", "Ke\xF1ele", "Kenen Birang", "Kenying", "Keyele", "Kyenying-Barang", "Miyak"],
  cc: ["PG"]
}, {
  pk: 3095,
  ang: "Khisa",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Khisa",
  lc: "kqm",
  ld: "ltr",
  alt: ["Khi", "Khi Khipa", "Komono", "Kumwenu"],
  cc: ["BF", "CI"]
}, {
  pk: 3096,
  ang: "Kaonde",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Kaonde",
  lc: "kqn",
  ld: "ltr",
  alt: ["Chikahonde", "Chikaonde", "Kawonde", "Luba Kaonde"],
  cc: ["ZM"]
}, {
  pk: 3097,
  ang: "Krahn, Eastern",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Eastern Krahn",
  lc: "kqo",
  ld: "ltr",
  alt: ["Eastern Kran", "Kran", "Gorbo", "Tchien (Chiehn)", "Kanneh"],
  cc: ["LR"]
}, {
  pk: 3098,
  ang: "Kimr\xE9",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Kimr\xE9",
  lc: "kqp",
  ld: "ltr",
  alt: ["Gabri-Kimr\xE9", "Gawra", "Buruwa (Bordo)", "Kimruwa (Kimr\xE9)", "Kim-Ruwa"],
  cc: ["TD"]
}, {
  pk: 3099,
  ang: "Krenak",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Krenak",
  lc: "kqq",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 3100,
  ang: "Kimaragang",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Kimaragang",
  lc: "kqr",
  ld: "ltr",
  alt: ["Kimaragan", "Kimaragangan", "Maragang", "Marigang", "Tandek (Garo)"],
  cc: ["MY"]
}, {
  pk: 8393,
  ang: "Sandayo",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Sandayo",
  lc: "kqr-x-sandayo",
  ld: "ltr",
  alt: [],
  cc: ["ID", "MY"]
}, {
  pk: 8392,
  ang: "Sonsogon",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Sonsogon",
  lc: "kqr-x-sonsogon",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3101,
  ang: "Kissi, Northern",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Northern Kissi",
  lc: "kqs",
  ld: "ltr",
  alt: ["Gizi", "Kisi", "Kisie", "Kissien"],
  cc: ["GN", "SL"]
}, {
  pk: 3102,
  ang: "Kadazan, Klias River",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Klias River Kadazan",
  lc: "kqt",
  ld: "ltr",
  alt: [],
  cc: ["MY"]
}, {
  pk: 3103,
  ang: "Okolod",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Okolod",
  lc: "kqv",
  ld: "ltr",
  alt: ["Kolod", "Kolour", "Kolur", "Okolod Murut"],
  cc: ["ID"]
}, {
  pk: 3104,
  ang: "Kandas",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kandas",
  lc: "kqw",
  ld: "ltr",
  alt: ["King"],
  cc: ["PG"]
}, {
  pk: 3105,
  ang: "Mser",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mser",
  lc: "kqx",
  ld: "ltr",
  alt: ["Kotoko-Kuseri", "Kouseri", "Kousseri", "Kuseri", "Klesem", "Mpade (Makari)", "Shewe (Mani)", "Mser (Kousseri)", "Kalo (Kalakafra)", "Msir"],
  cc: ["CM", "TD"]
}, {
  pk: 3106,
  ang: "Koorete",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Koorete",
  lc: "kqy",
  ld: "ltr",
  alt: ["Amaarro", "Amarro", "Badittu", "Haro", "Harro", "Koore", "Koyra", "Kwera", "Nuna", "Middle Koorete", "North Koorete", "South Koorete"],
  cc: ["ET"]
}, {
  pk: 3107,
  ang: "Korana",
  lr: "Africa",
  gw: false,
  hc: "ZA",
  ln: "Korana",
  lc: "kqz",
  ld: "ltr",
  alt: ["!Kora", "!Ora", "Gorachouqua", "Koranna", "Koraqua"],
  cc: ["ZA"]
}, {
  pk: 3108,
  ang: "Kanuri",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kanuri",
  lc: "kr",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 3109,
  ang: "Kumhali",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Kumhali",
  lc: "kra",
  ld: "ltr",
  alt: ["Kumali", "Kumbale", "Kumhale", "Kumkale", "Gorkha", "Nawalparasi", "Palpa", "Arghakhanchi"],
  cc: ["NP"]
}, {
  pk: 3110,
  ang: "Karkin",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Karkin",
  lc: "krb",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 3111,
  ang: "Karachay-Balkar",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041A\u0430\u0440\u0430\u0447\u0430\u0435\u0432\u043E-\u0431\u0430\u043B\u043A\u0430\u0440\u0441\u043A\u0438\u0439",
  lc: "krc",
  ld: "ltr",
  alt: ["Balqar", "Karacaylar", "Karachai", "Karachaitsy", "Karachayla", "Balkar", "Karachay-Baksan-Chegem"],
  cc: ["KZ", "RU", "US", "KG", "UZ"]
}, {
  pk: 3112,
  ang: "Kairui-Midiki",
  lr: "Asia",
  gw: false,
  hc: "TL",
  ln: "Kairui-Midiki",
  lc: "krd",
  ld: "ltr",
  alt: ["Cairui", "Midiki (Midik)"],
  cc: ["TL"]
}, {
  pk: 3113,
  ang: "Panar\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Panar\xE1",
  lc: "kre",
  ld: "ltr",
  alt: ["Kreen Akarore", "Kren Akarore"],
  cc: ["BR"]
}, {
  pk: 3114,
  ang: "Koro",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Koro (Vanuatu)",
  lc: "krf",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 3115,
  ang: "Kurama",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kurama",
  lc: "krh",
  ld: "ltr",
  alt: ["Akurmi", "Akurumi", "Azumu", "Bagwama", "Bukurumi", "Tikurami"],
  cc: ["NG"]
}, {
  pk: 3116,
  ang: "Krio",
  lr: "Africa",
  gw: false,
  hc: "SL",
  ln: "Krio",
  lc: "kri",
  ld: "ltr",
  alt: ["Creole", "Patois"],
  cc: ["GQ", "GM", "GB", "NL", "SN", "US", "CA", "SL"]
}, {
  pk: 3117,
  ang: "Kinaray-a",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kinaray-A",
  lc: "krj",
  ld: "ltr",
  alt: ["Antique\xF1o", "Ati", "Hamtiknon", "Hinaray-a", "Karay-a", "Kiniray-a", "Panayano", "Sulud", "Guimaras Island (Gimaras)"],
  cc: ["PH"]
}, {
  pk: 3118,
  ang: "Kerek",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041A\u0435\u0440\u0435\u043A\u0441\u043A\u0438\u0439",
  lc: "krk",
  ld: "ltr",
  alt: ["Mainypilgino (Majna-Pil'ginskij)", "Khatyrka (Xatyrskij)"],
  cc: ["RU"]
}, {
  pk: 3119,
  ang: "Karelian",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041A\u0430\u0440\u0435\u043B\u044C\u0441\u043A\u0438\u0439",
  lc: "krl",
  ld: "ltr",
  alt: ["Karelian Proper", "Karely", "Karel'skiy Jazyk", "Severno-Karel'skij", "Sobstvenno-Karel'skij-Jazyk", "Tver (Kalinin)"],
  cc: ["RU", "FI"]
}, {
  pk: 3120,
  ang: "Krim",
  lr: "Africa",
  gw: false,
  hc: "SL",
  ln: "Krim",
  lc: "krm",
  ld: "ltr",
  alt: ["Kim", "Kimi", "Kirim", "Kittim"],
  cc: ["SL"]
}, {
  pk: 3121,
  ang: "Sapo",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Sapo",
  lc: "krn",
  ld: "ltr",
  alt: ["Southern Krahn", "Nomopo (Nimpo)", "Sinkon (Senkon)", "Waya (Wedjah)", "Kabade (Karbardae)"],
  cc: ["LR"]
}, {
  pk: 3122,
  ang: "Korop",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Korop",
  lc: "krp",
  ld: "ltr",
  alt: ["Durop", "Dyurop", "Erorup", "Ododop", "Kurop"],
  cc: ["CM", "NG"]
}, {
  pk: 3123,
  ang: "Kru\u2019ng 2",
  lr: "Asia",
  gw: false,
  hc: "KH",
  ln: "Kru'ng 2",
  lc: "krr",
  ld: "ltr",
  alt: ["Brao Krung", "Kreung", "Lun", "Brao Tanap"],
  cc: ["KH"]
}, {
  pk: 8221,
  ang: "Lun",
  lr: "Asia",
  gw: false,
  hc: "KH",
  ln: "Lun",
  lc: "krr-x-lun",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3124,
  ang: "Kresh",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Kresh",
  lc: "krs",
  ld: "ltr",
  alt: ["Kpala", "Kpara", "Kparla", "Kredj", "Kreich", "Kreish", "Kresh", "Orlo (Woro)", "Naka (Kresh-Boro)", "Gbaya-Ngbongbo (Kresh-Hofra)", "Gbaya-Ndogo (Kresh-Ndogo)"],
  cc: ["SS"]
}, {
  pk: 3125,
  ang: "Kanuri, Tumari",
  lr: "Africa",
  gw: false,
  hc: "NE",
  ln: "Tumari Kanuri",
  lc: "krt",
  ld: "ltr",
  alt: ["Kanambu", "Kanembu", "Kubari (Kuwuri)", "Sugurti (Suwurti)"],
  cc: ["NE"]
}, {
  pk: 3126,
  ang: "Kurux",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kurukh",
  lc: "kru",
  ld: "ltr",
  alt: ["Oraoan", "Uraon", "Birhor", "Kadukali", "Koda", "Kola", "Kuda", "Kunha", "Kunhar", "Kunna", "Kunrukh", "Kunuk", "Kurka", "Morva", "Urang"],
  cc: ["BD", "BT", "IN"]
}, {
  pk: 3127,
  ang: "Kavet",
  lr: "Asia",
  gw: false,
  hc: "KH",
  ln: "Kavet",
  lc: "krv",
  ld: "ltr",
  alt: ["Khvek", "Kowet"],
  cc: ["KH"]
}, {
  pk: 3128,
  ang: "Krahn, Western",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Western Krahn",
  lc: "krw",
  ld: "ltr",
  alt: ["Krahn", "Northern Krahn", "Kran", "Western Kran", "Gborbo (Gbobo)", "Kpeaply", "Gbo", "Gbarzon", "Gbaeson (Gbaison)", "Pewa (Peewa)"],
  cc: ["LR"]
}, {
  pk: 3129,
  ang: "Karon",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Karon",
  lc: "krx",
  ld: "ltr",
  alt: ["Karone", "Karoninka", "Jola-Karone", "Kaloon", "Kouloonaay"],
  cc: ["SN"]
}, {
  pk: 3130,
  ang: "Kryts",
  lr: "Asia",
  gw: false,
  hc: "AZ",
  ln: "Qr\u0131z dili",
  lc: "kry",
  ld: "ltr",
  alt: ["Dzek", "Dzheki", "Katsy", "Kryc", "Kryz", "Kryzy", "Xaput (Khaput)"],
  cc: ["AZ"]
}, {
  pk: 3131,
  ang: "Kanum, Sota",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sota Kanum",
  lc: "krz",
  ld: "ltr",
  alt: ["Enkelembu", "Kenume", "Knwne"],
  cc: ["ID"]
}, {
  pk: 3132,
  ang: "Kashmiri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "\u0915\u0936\u094D\u092E\u0940\u0930\u0940, \u0643\u0634\u0645\u064A\u0631\u064A\u200E",
  lc: "ks",
  ld: "rtl",
  alt: ["Cashmeeree", "Cashmiri", "Kacmiri", "Kaschemiri", "Keshur", "Koshur", "Keshuri", "Kashtwari", "Kathiawari", "Kishtwari (Kashtawari)", "Kistwali", "Poguli"],
  cc: ["PK", "US", "IN"]
}, {
  pk: 3133,
  ang: "Shuwa-Zamani",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Shuwa-Zamani",
  lc: "ksa",
  ld: "ltr",
  alt: ["Kauru", "Kuzamani", "Rishuwa"],
  cc: ["NG"]
}, {
  pk: 3134,
  ang: "Shambala",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Shambala",
  lc: "ksb",
  ld: "ltr",
  alt: ["Kisambaa", "Kishambaa", "Kishambala", "Sambaa", "Sambala", "Sambara", "Schambala", "Shambaa"],
  cc: ["TZ"]
}, {
  pk: 3135,
  ang: "Kalinga, Southern",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Southern Kalinga",
  lc: "ksc",
  ld: "ltr",
  alt: ["Madlango Kalinga", "Tinglayan Kalinga", "Tinglayan"],
  cc: ["PH"]
}, {
  pk: 8297,
  ang: "Isumadel",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Isumadel",
  lc: "ksc-x-isumadel",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7810,
  ang: "Tulgao Kalinga",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kalinga Tulgao",
  lc: "ksc-x-tulgao",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7673,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kalinga Tulgo",
  lc: "ksc-x-tulgo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3136,
  ang: "Kuanua",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kuanua",
  lc: "ksd",
  ld: "ltr",
  alt: ["Blanche Bay", "Gunantuna", "New Britain Language", "Tinata Tuna", "Tolai", "Tuna", "Raluana"],
  cc: ["PG"]
}, {
  pk: 3137,
  ang: "Kuni",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kuni",
  lc: "kse",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3138,
  ang: "Bafia",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Bafia",
  lc: "ksf",
  ld: "ltr",
  alt: ["Bekpak", "Rikpa'", "Ripey"],
  cc: ["CM"]
}, {
  pk: 3139,
  ang: "Kusaghe",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Kusaghe",
  lc: "ksg",
  ld: "ltr",
  alt: ["Kusage", "Kushage"],
  cc: ["SB"]
}, {
  pk: 3140,
  ang: "K\xF6lsch",
  lr: "Europe",
  gw: false,
  hc: "DE",
  ln: "K\xF6lsch",
  lc: "ksh",
  ld: "ltr",
  alt: [],
  cc: ["DE"]
}, {
  pk: 3141,
  ang: "Isaka",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Krisa",
  lc: "ksi",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3142,
  ang: "Uare",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Uare",
  lc: "ksj",
  ld: "ltr",
  alt: ["Kwale", "Uare (Kwale)", "Garihe (Garia)"],
  cc: ["PG"]
}, {
  pk: 3143,
  ang: "Kansa",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Kansa",
  lc: "ksk",
  ld: "ltr",
  alt: ["Kanze", "Kaw", "Konze"],
  cc: ["US"]
}, {
  pk: 3144,
  ang: "Kumalu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kumalu",
  lc: "ksl",
  ld: "ltr",
  alt: ["Kumara"],
  cc: ["PG"]
}, {
  pk: 3145,
  ang: "Kumba",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kumba",
  lc: "ksm",
  ld: "ltr",
  alt: ["Isaro", "Sate", "Yofo"],
  cc: ["NG"]
}, {
  pk: 3146,
  ang: "Kasiguranin",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kasiguranin",
  lc: "ksn",
  ld: "ltr",
  alt: ["Casiguranin"],
  cc: ["PH"]
}, {
  pk: 3147,
  ang: "Kofa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kofa",
  lc: "kso",
  ld: "ltr",
  alt: ["Kota"],
  cc: ["NG"]
}, {
  pk: 3148,
  ang: "Kabba",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Kaba",
  lc: "ksp",
  ld: "ltr",
  alt: ["Kabba", "Sara", "Sara Kaba", "Kaba de Baibokoum", "Kaba de Paoua", "Western Kaba"],
  cc: ["CF", "TD"]
}, {
  pk: 3149,
  ang: "Kwaami",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kwaami",
  lc: "ksq",
  ld: "ltr",
  alt: ["Komawa", "Kwam", "Kwamanchi", "Kwami", "Kwom"],
  cc: ["NG"]
}, {
  pk: 3150,
  ang: "Borong",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Borong",
  lc: "ksr",
  ld: "ltr",
  alt: ["Naama"],
  cc: ["PG"]
}, {
  pk: 3151,
  ang: "Kisi, Southern",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Southern Kisi",
  lc: "kss",
  ld: "ltr",
  alt: ["Gisi", "Gizi", "Kissi", "Kissien", "Kisi"],
  cc: ["LR", "SL"]
}, {
  pk: 8035,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "SL",
  ln: "Southern Kissi",
  lc: "kss-x-southkissi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3152,
  ang: "Winy\xE9",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Winy\xE9",
  lc: "kst",
  ld: "ltr",
  alt: ["K\xF5", "Kols", "Kolsi"],
  cc: ["BF"]
}, {
  pk: 3153,
  ang: "Khamyang",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Khamyang",
  lc: "ksu",
  ld: "ltr",
  alt: ["Khamiyang", "Khamjang", "Shyam", "Tai Khamyang", "Tai Nora"],
  cc: ["IN"]
}, {
  pk: 7602,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Shyam",
  lc: "ksu-x-shyam",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3154,
  ang: "Kusu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kusu",
  lc: "ksv",
  ld: "ltr",
  alt: ["Fuluka", "Kikusu", "Kongola", "Kutsu", "Lokutsu"],
  cc: ["CD"]
}, {
  pk: 3155,
  ang: "Karen, S\u2019gaw",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "S'gaw Karen",
  lc: "ksw",
  ld: "ltr",
  alt: ["Burmese Karen", "Kanyaw", "Kyetho", "Paganyaw", "Pchcknya", "Pwakanyaw", "S'gau", "S'gaw", "S'gaw Kayin", "White Karen", "Yang Khao", "Karen", "White", "Southern dialect of Western Kayah (Dawei)", "Palakhi (Palachi)", "Delta dialect of S'gaw Karen", "Eastern dialect of S'gaw Karen (Pa'an)"],
  cc: ["TH", "US", "MM"]
}, {
  pk: 3156,
  ang: "Kedang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kedang",
  lc: "ksx",
  ld: "ltr",
  alt: ["Dang", "Kdang", "K\xE9dang", "Kedangese"],
  cc: ["ID"]
}, {
  pk: 3157,
  ang: "Kharia Thar",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kharia Thar",
  lc: "ksy",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 3158,
  ang: "Kodaku",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kodaku",
  lc: "ksz",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 3159,
  ang: "Katua",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Katua",
  lc: "kta",
  ld: "ltr",
  alt: ["Ca Tua"],
  cc: ["VN"]
}, {
  pk: 3160,
  ang: "Kambaata",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Kambaata",
  lc: "ktb",
  ld: "ltr",
  alt: ["Donga", "Kambara", "Kambata", "Kemata", "Kembata", "Timbara", "Timbaro (Timbaaro)"],
  cc: ["ET"]
}, {
  pk: 3161,
  ang: "Kholok",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kholok",
  lc: "ktc",
  ld: "ltr",
  alt: ["Kode", "Koode", "Kwoode", "Pia", "Pitiko", "Widala", "Wurkum"],
  cc: ["NG"]
}, {
  pk: 3162,
  ang: "Kokata",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Kokata",
  lc: "ktd",
  ld: "ltr",
  alt: ["Gugada", "Kokatha", "Kokitta", "Koocatho", "Koogurda", "Kugurda", "Kukata", "Madutara", "Maduwonga", "Wanggamadu", "Wongamardu"],
  cc: ["AU"]
}, {
  pk: 3163,
  ang: "Nubri",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Nubri",
  lc: "kte",
  ld: "ltr",
  alt: ["Kutang", "Kutang Bhotia", "Larkye"],
  cc: ["NP"]
}, {
  pk: 3164,
  ang: "Kwami",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kwami",
  lc: "ktf",
  ld: "ltr",
  alt: ["Kikwame", "Kwame"],
  cc: ["CD"]
}, {
  pk: 3165,
  ang: "Karanga",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Karanga",
  lc: "kth",
  ld: "ltr",
  alt: ["Kurunga", "Moyo", "Bakha (Bakhat)", "Baxa", "Faala", "Fala", "Karanga (Kurunga)", "Kashmere (Kachmere)", "Koni\xE9r\xE9 (Kognere)", "Konyare", "Mooyo"],
  cc: ["TD"]
}, {
  pk: 3166,
  ang: "Muyu, North",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "North Muyu",
  lc: "kti",
  ld: "ltr",
  alt: ["Kataut", "Kati-Ninanti", "Niinati", "Ninatie", "North Kati", "North Moejoe", "Yonggom", "Yongkom", "Yongom", "Toemoetoe (Are)", "Kanggewot"],
  cc: ["ID"]
}, {
  pk: 3167,
  ang: "Krumen, Plapo",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Plapo Krumen",
  lc: "ktj",
  ld: "ltr",
  alt: ["Plapo"],
  cc: ["CI"]
}, {
  pk: 3168,
  ang: "Koroshi",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u06A9\u0648\u0631\u0648\u0634\u06CC",
  lc: "ktl",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 3169,
  ang: "Kurti",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kurti",
  lc: "ktm",
  ld: "ltr",
  alt: ["Kuruti", "Kuruti-Pare", "Ndrugul"],
  cc: ["PG"]
}, {
  pk: 3170,
  ang: "Kariti\xE2na",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Kariti\xE2na",
  lc: "ktn",
  ld: "ltr",
  alt: ["Caritiana"],
  cc: ["BR"]
}, {
  pk: 3171,
  ang: "Kuot",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kuot",
  lc: "kto",
  ld: "ltr",
  alt: ["Kuat", "Panaras"],
  cc: ["PG"]
}, {
  pk: 3172,
  ang: "Kaduo",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5361\u591A",
  lc: "ktp",
  ld: "ltr",
  alt: ["Khatu"],
  cc: ["CN"]
}, {
  pk: 3173,
  ang: "Kota Marudu Tinagas",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Kota Marudu Tinagas",
  lc: "ktr",
  ld: "ltr",
  alt: [],
  cc: ["MY"]
}, {
  pk: 3174,
  ang: "Muyu, South",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "South Muyu",
  lc: "kts",
  ld: "ltr",
  alt: ["Digoel", "Digul", "Kati Metomka", "Metomka", "Moejoe", "Ok Bari", "South", "South Kati", "Yonggom", "Yongkom", "Yongom"],
  cc: ["ID"]
}, {
  pk: 3175,
  ang: "Ketum",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ketum",
  lc: "ktt",
  ld: "ltr",
  alt: ["Kitum", "Wambon-Ketum"],
  cc: ["ID"]
}, {
  pk: 3176,
  ang: "Kituba",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kituba (Democratic Republic of Congo)",
  lc: "ktu",
  ld: "ltr",
  alt: ["Kibulamatadi", "Kikongo Commercial", "Kikongo Simplifi\xE9", "Kikongo Ya Leta", "Kikongo-Kutuba", "Kileta"],
  cc: ["CD"]
}, {
  pk: 7794,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kimboma",
  lc: "ktu-x-kimboma",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 7655,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kikongo ya leta",
  lc: "ktu-x-kiyaleta",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 3177,
  ang: "Katu, Eastern",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Eastern Katu",
  lc: "ktv",
  ld: "ltr",
  alt: ["High Katu"],
  cc: ["LA", "VN"]
}, {
  pk: 3178,
  ang: "Kato",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Kato",
  lc: "ktw",
  ld: "ltr",
  alt: ["Batem-Da-Kai-Ee", "Cahto", "Kai Po-Mo", "Tlokeang"],
  cc: ["US"]
}, {
  pk: 3179,
  ang: "Kaxarar\xED",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Kaxarar\xED",
  lc: "ktx",
  ld: "ltr",
  alt: ["Kaxariri"],
  cc: ["BR"]
}, {
  pk: 3180,
  ang: "Kango",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kango (Bas-U\xE9l\xE9 District)",
  lc: "kty",
  ld: "ltr",
  alt: ["Likango"],
  cc: ["CD"]
}, {
  pk: 3181,
  ang: "Ju|\u2019hoan",
  lr: "Africa",
  gw: false,
  hc: "BW",
  ln: "Ju/'hoan",
  lc: "ktz",
  ld: "ltr",
  alt: ["!Xo", "Dobe Kung", "Ju'oasi", "Kung", "Kung-Tsumkwe", "Tsumkwe", "Xaixai", "X\xFB", "Xun", "Zhu'oasi", "Tshumkwe", "Dzu'oasi (Ssu Ghassi)", "Nogau (Agau)", "Zhu'oase"],
  cc: ["BW"]
}, {
  pk: 3182,
  ang: "Kurdish",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Kurd\xEE, \u0643\u0648\u0631\u062F\u06CC\u200E",
  lc: "ku",
  ld: "rtl",
  alt: [],
  cc: ["IR"]
}, {
  pk: 3183,
  ang: "Kutep",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kutep",
  lc: "kub",
  ld: "ltr",
  alt: ["Ati", "Kutev", "Mbarike", "Zumper", "Jompre"],
  cc: ["CM", "NG"]
}, {
  pk: 3184,
  ang: "Kwinsu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kwinsu",
  lc: "kuc",
  ld: "ltr",
  alt: ["Ansudu"],
  cc: ["ID"]
}, {
  pk: 3185,
  ang: "\u2019Auhelawa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "'Auhelawa",
  lc: "kud",
  ld: "ltr",
  alt: ["Kurada", "Nuakata", "Ulada", "Urada"],
  cc: ["PG"]
}, {
  pk: 3186,
  ang: "Kuman",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kuman (Papua New Guinea)",
  lc: "kue",
  ld: "ltr",
  alt: ["Chimbu", "Simbu", "Genogane", "Nagane (Genagane)", "Yongomugl"],
  cc: ["PG"]
}, {
  pk: 3187,
  ang: "Katu, Western",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Western Katu",
  lc: "kuf",
  ld: "ltr",
  alt: [],
  cc: ["LA"]
}, {
  pk: 3188,
  ang: "Kupa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kupa",
  lc: "kug",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 3189,
  ang: "Kushi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kushi",
  lc: "kuh",
  ld: "ltr",
  alt: ["Chong'e", "Goji", "Kushe"],
  cc: ["NG"]
}, {
  pk: 3190,
  ang: "Kuik\xFAro-Kalap\xE1lo",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Kuik\xFAro-Kalap\xE1lo",
  lc: "kui",
  ld: "ltr",
  alt: ["Apalakiri", "Apalaquiri", "Cuicutl", "Guicur\xFA", "Kalapalo", "Kuikuru", "Kurkuro", "Matip\xFA", "Nahukw\xE1"],
  cc: ["BR"]
}, {
  pk: 3191,
  ang: "Kuria",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Kuria",
  lc: "kuj",
  ld: "ltr",
  alt: ["Ekiguria", "Igikuria", "Kikuria", "Kurya", "Egikuria", "Ikikuria", "Kikuria cha juu", "Kikuria cha Mashariki", "Kurye"],
  cc: ["KE", "TZ"]
}, {
  pk: 3192,
  ang: "Kepo\u2019",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kepo'",
  lc: "kuk",
  ld: "ltr",
  alt: ["Kepoq"],
  cc: ["ID"]
}, {
  pk: 3193,
  ang: "Kulere",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kulere",
  lc: "kul",
  ld: "ltr",
  alt: ["Akande", "Akandi", "Kande", "Korom Boye"],
  cc: ["NG"]
}, {
  pk: 3194,
  ang: "Kumyk",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041A\u0443\u043C\u044B\u043A\u0441\u043A\u0438\u0439",
  lc: "kum",
  ld: "ltr",
  alt: ["Kumuk", "Kumuklar", "Kumyki", "Podgorniy", "Terek", "Khaitag"],
  cc: ["KZ", "RU", "TR", "UZ"]
}, {
  pk: 3195,
  ang: "Kunama",
  lr: "Africa",
  gw: false,
  hc: "ER",
  ln: "Kunama",
  lc: "kun",
  ld: "ltr",
  alt: ["Baada", "Baaden", "Baaza", "Baazayn", "Baazen", "Bada", "Baden", "Baza", "Bazen", "Cunama", "Diila", "Setit", "Aymasa (Aaimasa)", "Tiika", "Tika (Lakatakura-Tika)", "Takazze-Setiit (Setiit)", "Sokodasa (Sogadas)", "Sogodas", "Odasa", "Ilit (Iiliit)", "Iliit", "Iilit", "Barka (Berka)", "Bitama (Bitaama)"],
  cc: ["ER", "ET", "SD"]
}, {
  pk: 3196,
  ang: "Kumukio",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kumukio",
  lc: "kuo",
  ld: "ltr",
  alt: ["Kumokio"],
  cc: ["PG"]
}, {
  pk: 3197,
  ang: "Kunimaipa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kunimaipa",
  lc: "kup",
  ld: "ltr",
  alt: ["K\xE2te (Hate)", "Gajili (Gajila)", "Gazili", "Hazili"],
  cc: ["PG"]
}, {
  pk: 3198,
  ang: "Karipuna",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Karipuna",
  lc: "kuq",
  ld: "ltr",
  alt: ["Ah'e", "Caripuna", "Jau-Navo", "Juanauo", "Kagwahiva", "Karipuna de Rond\xF4nia", "Karipuna do Guapor\xE9", "Pama (Pamana)", "Karipun\xE1 de Rond\xF4nia", "Karipun\xE1 do Guapor\xE9"],
  cc: ["BR"]
}, {
  pk: 3199,
  ang: "Kusaal",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Kusaal",
  lc: "kus",
  ld: "ltr",
  alt: ["Koussass\xE9", "Kusale", "Kusasi", "Kusaasi", "Agole (Angole)", "Eastern Kusaal", "Toende (Western Kusaal)", "Tonde (Toende)", "Western Kusaal"],
  cc: ["BF", "GH"]
}, {
  pk: 3200,
  ang: "Kutenai",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Kutenai",
  lc: "kut",
  ld: "ltr",
  alt: ["Kootenai", "Kootenay", "Ktunaxa"],
  cc: ["CA"]
}, {
  pk: 3201,
  ang: "Kuskokwim, Upper",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Upper Kuskokwim",
  lc: "kuu",
  ld: "ltr",
  alt: ["Kolchan", "Mcgrath Ingalik"],
  cc: ["US"]
}, {
  pk: 3202,
  ang: "Kur",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kur",
  lc: "kuv",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3203,
  ang: "Kpagua",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Kpagua",
  lc: "kuw",
  ld: "ltr",
  alt: ["Kpagwa"],
  cc: ["CF"]
}, {
  pk: 3204,
  ang: "Kukatja",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Kukatja",
  lc: "kux",
  ld: "ltr",
  alt: ["Gugadja", "Kukaja"],
  cc: ["AU"]
}, {
  pk: 3205,
  ang: "Kuuku-Ya\u2019u",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Kuuku-Ya'u",
  lc: "kuy",
  ld: "ltr",
  alt: ["Bagadji", "Gugu Yau", "Koko-Ja'o", "Kokoyao", "Pakadji", "Ya'o"],
  cc: ["AU"]
}, {
  pk: 3206,
  ang: "Kunza",
  lr: "Americas",
  gw: false,
  hc: "CL",
  ln: "Kunza",
  lc: "kuz",
  ld: "ltr",
  alt: ["Atacame\xF1o", "Likananta\xED", "Lipe", "Ulipe"],
  cc: ["CL"]
}, {
  pk: 3207,
  ang: "Komi",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u043A\u043E\u043C\u0438 \u043A\u044B\u0432",
  lc: "kv",
  ld: "ltr",
  alt: [],
  cc: ["RU"]
}, {
  pk: 3208,
  ang: "Bagvalal",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0411\u0430\u0433\u0432\u0430\u043B\u0438\u043D\u0441\u043A\u0438\u0439",
  lc: "kva",
  ld: "ltr",
  alt: ["Bagulal", "Bagvalin", "Bagwalal", "Barbalin", "Kvanada", "Kvanadin", "Kvanada-Himerso", "Tlissi-Tlibisho", "Tlondoda-Khushtada"],
  cc: ["RU"]
}, {
  pk: 3209,
  ang: "Kubu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kubu",
  lc: "kvb",
  ld: "ltr",
  alt: ["Orang Hutan", "Orang Rimba", "Jambi"],
  cc: ["ID"]
}, {
  pk: 3210,
  ang: "Kove",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kove",
  lc: "kvc",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3211,
  ang: "Kui",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kui (Indonesia)",
  lc: "kvd",
  ld: "ltr",
  alt: ["Lerabain", "Kiramang (Kramang)", "Kui (Buraga)", "Lerabaing"],
  cc: ["ID"]
}, {
  pk: 3212,
  ang: "Kalabakan",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Kalabakan",
  lc: "kve",
  ld: "ltr",
  alt: ["Kalabakan Murut", "Tawau Murut", "Tidung"],
  cc: ["MY"]
}, {
  pk: 3213,
  ang: "Kabalai",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Kabalai",
  lc: "kvf",
  ld: "ltr",
  alt: ["Gablai", "Kaba-Lai", "Kabalay", "Kabalaye", "Keb-Kaye", "Lai", "Lay"],
  cc: ["TD"]
}, {
  pk: 3214,
  ang: "Kuni-Boazi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kuni-Boazi",
  lc: "kvg",
  ld: "ltr",
  alt: ["Boadji", "Bwadji", "Kuini", "Ingias", "Wamak", "Aewa", "Khoamak", "Sengeze"],
  cc: ["PG"]
}, {
  pk: 3215,
  ang: "Komodo",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Komodo",
  lc: "kvh",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3216,
  ang: "Kwang",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Kwang",
  lc: "kvi",
  ld: "ltr",
  alt: ["Kouang", "Kuang", "Tchagin (Tchakin)", "Mobou (Mobu)", "Modgel", "Ngam (Gam)"],
  cc: ["TD"]
}, {
  pk: 3217,
  ang: "Psikye",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Psikye",
  lc: "kvj",
  ld: "ltr",
  alt: ["Kamsiki", "Kapsiki", "Ptsake", "Wula (Lying)", "Ula-Xangku", "Psikye (Kamu)", "Oula"],
  cc: ["CM", "NG"]
}, {
  pk: 3218,
  ang: "Korean Sign Language",
  lr: "Asia",
  gw: false,
  hc: "KR",
  ln: "Korean Sign Language",
  lc: "kvk",
  ld: "ltr",
  alt: [],
  cc: ["KR"]
}, {
  pk: 3219,
  ang: "Kayaw",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Kayaw",
  lc: "kvl",
  ld: "ltr",
  alt: ["Deleh", "Laku", "Pramano", "Bre", "Brec", "Brek", "Kayaw Brek", "Paret", "Pre", "Pret", "Bwe-Kayaw", "Prek"],
  cc: ["MM"]
}, {
  pk: 3220,
  ang: "Kendem",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Kendem",
  lc: "kvm",
  ld: "ltr",
  alt: ["Bokwa-Kendem"],
  cc: ["CM"]
}, {
  pk: 3221,
  ang: "Kuna, Border",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Border Kuna",
  lc: "kvn",
  ld: "ltr",
  alt: ["Caiman Nuevo", "Colombia Cuna", "Cuna", "Paya-Pucuro", "Kuna de la Frontera", "Long Hair Cuna", "Paya-Pucuro Kuna"],
  cc: ["CO"]
}, {
  pk: 3222,
  ang: "Dobel",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dobel",
  lc: "kvo",
  ld: "ltr",
  alt: ["Doibel", "Kobroor", "Kobro'or", "Sersifar Tannin", "Northern Dobel", "Straits Dobel"],
  cc: ["ID"]
}, {
  pk: 3223,
  ang: "Kompane",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kompane",
  lc: "kvp",
  ld: "ltr",
  alt: ["Komfana", "Kongampani"],
  cc: ["ID"]
}, {
  pk: 3224,
  ang: "Karen, Geba",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Geba Karen",
  lc: "kvq",
  ld: "ltr",
  alt: ["Daneh", "Geba", "Kaba", "Karenbyu", "Kayinbyu", "Kono", "Koo-ong", "Northern Bwe", "Gerkho-Geba", "Sawkho", "Thamitaik (Sawkeepho)"],
  cc: ["MM"]
}, {
  pk: 3225,
  ang: "Kerinci",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kerinci",
  lc: "kvr",
  ld: "ltr",
  alt: ["Kerinchi", "Kinchai"],
  cc: ["ID"]
}, {
  pk: 8096,
  ang: "Talang Mamak",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Talang Mamak",
  lc: "kvr-x-talangmamak",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3226,
  ang: "Kunggara",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Kunggara",
  lc: "kvs",
  ld: "ltr",
  alt: ["Goom-Gharra", "Gunggara", "Kunggera"],
  cc: ["AU"]
}, {
  pk: 3227,
  ang: "Lahta",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Lahta Karen",
  lc: "kvt",
  ld: "ltr",
  alt: ["Kangan", "Kayan Lahta", "Khahta", "Lahta Karen", "Peu", "Taru", "Tarulakhi", "Yan Wohta"],
  cc: ["MM"]
}, {
  pk: 3228,
  ang: "Yinbaw",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Yinbaw Karen",
  lc: "kvu",
  ld: "ltr",
  alt: ["Yeinbaw", "Yinbaw Karen"],
  cc: ["MM"]
}, {
  pk: 3229,
  ang: "Kola",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kola",
  lc: "kvv",
  ld: "ltr",
  alt: ["Kulaha", "Marlasi", "Warilau"],
  cc: ["ID"]
}, {
  pk: 3230,
  ang: "Wersing",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Wersing",
  lc: "kvw",
  ld: "ltr",
  alt: ["Kolana-Wersin", "Warsina", "Wersin", "Langkuru (Mademang)", "Pureman"],
  cc: ["ID"]
}, {
  pk: 3231,
  ang: "Koli, Parkari",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "Parkari Koli",
  lc: "kvx",
  ld: "ltr",
  alt: ["Parkari"],
  cc: ["PK"]
}, {
  pk: 3232,
  ang: "Yintale",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Yintale Karen",
  lc: "kvy",
  ld: "ltr",
  alt: ["Taliak", "Yangatalet", "Yangtadai", "Yintale Karen", "Yintalet", "Bawlake", "Wa Awng"],
  cc: ["MM"]
}, {
  pk: 3233,
  ang: "Tsaukambo",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tsakwambo",
  lc: "kvz",
  ld: "ltr",
  alt: ["Kotog\xFCt", "Tsokwambo"],
  cc: ["ID"]
}, {
  pk: 3234,
  ang: "Cornish",
  lr: "Europe",
  gw: false,
  hc: "GB",
  ln: "Kernewek",
  lc: "kw",
  ld: "ltr",
  alt: ["Curnoack", "Kernewek", "Kernowek"],
  cc: ["GB"]
}, {
  pk: 3235,
  ang: "D\xE2w",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "D\xE2w",
  lc: "kwa",
  ld: "ltr",
  alt: ["Dow", "Kam\xE3", "Kam\xE3 Mak\xFA", "Kamu Maku"],
  cc: ["BR"]
}, {
  pk: 3236,
  ang: "Kwa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kwa",
  lc: "kwb",
  ld: "ltr",
  alt: ["Baa", "Kwah"],
  cc: ["NG"]
}, {
  pk: 3237,
  ang: "Likwala",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Likwala",
  lc: "kwc",
  ld: "ltr",
  alt: ["Ekwala", "Kwala", "Likouala"],
  cc: ["CG"]
}, {
  pk: 3238,
  ang: "Kwaio",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Kwaio",
  lc: "kwd",
  ld: "ltr",
  alt: ["Koio"],
  cc: ["SB"]
}, {
  pk: 3239,
  ang: "Kwerba",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kwerba",
  lc: "kwe",
  ld: "ltr",
  alt: ["Airmati", "Armati", "Koassa", "Mataweja", "Naibedj", "Segar Tor", "Tekutameso"],
  cc: ["ID"]
}, {
  pk: 3240,
  ang: "Kwara\u2019ae",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Kwara'ae",
  lc: "kwf",
  ld: "ltr",
  alt: ["Fiu"],
  cc: ["SB"]
}, {
  pk: 3241,
  ang: "Kaba D\xE9m\xE9, Sara",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Sara Kaba Deme",
  lc: "kwg",
  ld: "ltr",
  alt: ["Kaba 'Dem", "Kaba D\xE9m\xE9", "Kaba Demi", "Sara Kaba Dem", "T\xE0 S\xE0ra", "Boho", "Kuruwer (Kuwar\xE9?)"],
  cc: ["TD"]
}, {
  pk: 3242,
  ang: "Kowiai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kowiai",
  lc: "kwh",
  ld: "ltr",
  alt: ["Aiduma", "Kaiwai", "Kajumerah", "Kayumerah", "Koiwai", "Kuiwai", "Namatote", "Adijaya", "Keroi"],
  cc: ["ID"]
}, {
  pk: 3243,
  ang: "Awa-Cuaiquer",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Awa-Cuaiquer",
  lc: "kwi",
  ld: "ltr",
  alt: ["Awa", "Awa Pit", "Coaiquer", "Cuaiquer", "Kwaiker", "Quaiquer"],
  cc: ["CO", "EC"]
}, {
  pk: 3244,
  ang: "Kwanga",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kwanga",
  lc: "kwj",
  ld: "ltr",
  alt: ["Gawanga", "Kawanga", "Tau (Kubiwat)", "Yubanakor (Daina)", "Bongos (Bongomaise)", "Bongomamsi", "Nambi"],
  cc: ["PG"]
}, {
  pk: 3245,
  ang: "Kwakiutl",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Kwakiutl",
  lc: "kwk",
  ld: "ltr",
  alt: ["Kwagiutl", "Kwak'wala"],
  cc: ["US", "CA"]
}, {
  pk: 3246,
  ang: "Kofyar",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kofyar",
  lc: "kwl",
  ld: "ltr",
  alt: ["Jepel", "Mirriam (Mernyang)", "Mbol", "Kwalla", "Kwagallak (Kwa'alang)", "Kofyar (Kwong)", "Bwol (Bwal)", "Jibyal", "Gworam (Giverom)", "Goram", "Doemak", "Dimmuk (Dimuk)", "Jipal (Jepal)"],
  cc: ["NG"]
}, {
  pk: 3247,
  ang: "Kwambi",
  lr: "Africa",
  gw: false,
  hc: "NA",
  ln: "Kwambi",
  lc: "kwm",
  ld: "ltr",
  alt: [],
  cc: ["NA"]
}, {
  pk: 3248,
  ang: "Kwangali",
  lr: "Africa",
  gw: false,
  hc: "NA",
  ln: "Kwangali",
  lc: "kwn",
  ld: "ltr",
  alt: ["Cuangar", "Kwangare", "Kwangari", "Rukwangali", "Sikwangali", "Shisambyu", "Sambyu (Sambio)", "Sambiu"],
  cc: ["AO", "NA"]
}, {
  pk: 3249,
  ang: "Kwomtari",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kwomtari",
  lc: "kwo",
  ld: "ltr",
  alt: ["Eastern Kwomtari", "Western Kwomtari", "Central Kwomtari"],
  cc: ["PG"]
}, {
  pk: 3250,
  ang: "Kodia",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Kodia",
  lc: "kwp",
  ld: "ltr",
  alt: ["Kwadia", "Kwadya"],
  cc: ["CI"]
}, {
  pk: 3251,
  ang: "Kwer",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kwer",
  lc: "kwr",
  ld: "ltr",
  alt: [],
  cc: ["ID", "PG"]
}, {
  pk: 3252,
  ang: "Kwese",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kwese",
  lc: "kws",
  ld: "ltr",
  alt: ["Kikwese", "Pindi", "Ukwese"],
  cc: ["CD"]
}, {
  pk: 3253,
  ang: "Kwesten",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kwesten",
  lc: "kwt",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3254,
  ang: "Kwakum",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Kwakum",
  lc: "kwu",
  ld: "ltr",
  alt: ["Abakoum", "Abakum", "Akpwakum", "Bakum", "Kpakum", "Pakum", "Baki (Mbaki)", "Beten (Bethen)", "Petem"],
  cc: ["CM"]
}, {
  pk: 3255,
  ang: "Kaba Naa, Sara",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Sara Kaba N\xE1\xE0",
  lc: "kwv",
  ld: "ltr",
  alt: ["Dana", "Kaba Naa", "Kaba Nar", "Sara Kaba", "Denje", "Tie (Tiye)", "Mbanga (Banga)", "Dunje (Dendje)", "Dounje", "Dindje", "Dinje"],
  cc: ["TD"]
}, {
  pk: 3256,
  ang: "Kwinti",
  lr: "Americas",
  gw: false,
  hc: "SR",
  ln: "Kwinti",
  lc: "kww",
  ld: "ltr",
  alt: [],
  cc: ["SR"]
}, {
  pk: 3257,
  ang: "Khirwar",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Khirwar",
  lc: "kwx",
  ld: "ltr",
  alt: ["Kherwari", "Khirwara"],
  cc: ["IN"]
}, {
  pk: 3258,
  ang: "Kongo, San Salvador",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "San Salvador Kongo",
  lc: "kwy",
  ld: "ltr",
  alt: ["Congo", "Kikongo", "Kikoongo", "Kisikongo"],
  cc: ["CD"]
}, {
  pk: 3259,
  ang: "Kairiru",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kairiru",
  lc: "kxa",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3260,
  ang: "Krobu",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Krobu",
  lc: "kxb",
  ld: "ltr",
  alt: ["Krobou"],
  cc: ["CI"]
}, {
  pk: 3261,
  ang: "Konso",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Konso",
  lc: "kxc",
  ld: "ltr",
  alt: ["Af Kareti", "Afa Karatti", "Conso", "Gato", "Karate", "Kareti", "Karatti", "Fasha", "Duuro", "Kholme"],
  cc: ["ET", "KE"]
}, {
  pk: 3262,
  ang: "Brunei",
  lr: "Asia",
  gw: false,
  hc: "BN",
  ln: "Brunei",
  lc: "kxd",
  ld: "ltr",
  alt: ["Brunei-Kadaian", "Orang Bukit", "Karayan", "Kerayan", "Kedyan", "Kedayan (Kadaian)", "Kadyan", "Kadien", "Kadian", "Kadayan", "Kadaian (Kadayan)", "Kedien"],
  cc: ["BN", "MY", "US", "CA"]
}, {
  pk: 3263,
  ang: "Manumanaw",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Manumanaw Karen",
  lc: "kxf",
  ld: "ltr",
  alt: ["Kayah-Munu", "Kay\xE0w", "Man\xF6", "Manu", "Manumanaw Karen", "Monu", "Doloso", "Tawkhu"],
  cc: ["MM"]
}, {
  pk: 3264,
  ang: "Karo",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Karo (Ethiopia)",
  lc: "kxh",
  ld: "ltr",
  alt: ["Cherre", "Kere", "Kerre"],
  cc: ["ET"]
}, {
  pk: 3265,
  ang: "Keningau Murut",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Keningau Murut",
  lc: "kxi",
  ld: "ltr",
  alt: ["Central Murut", "Nabai", "Rabay", "Rabai", "Nabay (Dabai)", "Dabay", "Nebee"],
  cc: ["MY"]
}, {
  pk: 3266,
  ang: "Kulfa",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Kulfa",
  lc: "kxj",
  ld: "ltr",
  alt: ["Kulfe", "Kurmi", "Kaba So", "Bara"],
  cc: ["TD"]
}, {
  pk: 3267,
  ang: "Zayein",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Zayein Karen",
  lc: "kxk",
  ld: "ltr",
  alt: ["Gaungtou", "Khaungtou", "Zayein Karen"],
  cc: ["MM"]
}, {
  pk: 3268,
  ang: "Kurux, Nepali",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u0915\u0941\u0921\u093C\u0941\u0916\u093C",
  lc: "kxl",
  ld: "ltr",
  alt: ["Dhangar", "Jangad", "Janghard", "Jhangad", "Jhanger", "Oraon", "Orau", "Uraon", "Uraw"],
  cc: ["NP"]
}, {
  pk: 3269,
  ang: "Khmer, Northern",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Northern Khmer",
  lc: "kxm",
  ld: "ltr",
  alt: ["Khmer Lue", "Thailand Khmer"],
  cc: ["TH", "KH"]
}, {
  pk: 3270,
  ang: "Melanau, Kanowit-Tanjong",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Kanowit-Tanjong Melanau",
  lc: "kxn",
  ld: "ltr",
  alt: ["Kanowit"],
  cc: ["MY"]
}, {
  pk: 3271,
  ang: "Kano\xE9",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Kano\xE9",
  lc: "kxo",
  ld: "ltr",
  alt: ["Amniap\xE9", "Cano\xE9", "Cano\xEA", "Guarategaja", "Guarat\xE9gaya", "Guaratira", "Kapishan\xE3", "Kapixana", "Kapixan\xE1", "Koaratira"],
  cc: ["BR"]
}, {
  pk: 3272,
  ang: "Koli, Wadiyara",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Wadiyara Koli",
  lc: "kxp",
  ld: "ltr",
  alt: ["Wadaria", "Wadhiara", "Wadiyara Koli", "Mewasi (Mayvasi Koli)", "Tharadari Koli"],
  cc: ["PK", "IN"]
}, {
  pk: 3273,
  ang: "Kanum, Sm\xE4rky",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sm\xE4rky Kanum",
  lc: "kxq",
  ld: "ltr",
  alt: ["Enkelembu", "Kenume", "Knwne"],
  cc: ["ID"]
}, {
  pk: 3274,
  ang: "Koro",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Koro (Papua New Guinea)",
  lc: "kxr",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3275,
  ang: "Kangjia",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5EB7\u5BB6\u8BED",
  lc: "kxs",
  ld: "ltr",
  alt: ["Kangyang Hui"],
  cc: ["CN"]
}, {
  pk: 3276,
  ang: "Koiwat",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Koiwat",
  lc: "kxt",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3277,
  ang: "Kui",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kui (India)",
  lc: "kxu",
  ld: "ltr",
  alt: ["Kanda", "Kandh", "Khondo", "Kodu", "Kodulu", "Kuinga", "Kuy"],
  cc: ["IN"]
}, {
  pk: 3278,
  ang: "Kuvi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kuvi",
  lc: "kxv",
  ld: "ltr",
  alt: ["Jatapu", "Khondh", "Khondi", "Kond", "Kuvi Kond", "Kuvinga", "Kuwi", "Rayagada", "Dongria Khond", "Laxmipur"],
  cc: ["IN"]
}, {
  pk: 3279,
  ang: "Konai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Konai",
  lc: "kxw",
  ld: "ltr",
  alt: ["Mirapmin"],
  cc: ["PG"]
}, {
  pk: 3280,
  ang: "Likuba",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Likuba",
  lc: "kxx",
  ld: "ltr",
  alt: ["Kuba"],
  cc: ["CG"]
}, {
  pk: 3281,
  ang: "Kayong",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Kayong",
  lc: "kxy",
  ld: "ltr",
  alt: ["Ca Giong", "Kagiuong", "Katang"],
  cc: ["VN"]
}, {
  pk: 3282,
  ang: "Kerewo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kerewo",
  lc: "kxz",
  ld: "ltr",
  alt: ["Kerewa", "Kerewa-Goari", "Gibario (Goaribari)"],
  cc: ["PG"]
}, {
  pk: 3283,
  ang: "Kyrgyz",
  lr: "Asia",
  gw: false,
  hc: "KG",
  ln: "\u041A\u044B\u0440\u0433\u044B\u0437\u0447\u0430, \u041A\u044B\u0440\u0433\u044B\u0437 \u0442\u0438\u043B\u0438",
  lc: "ky",
  ld: "ltr",
  alt: ["Kara", "Ke'erkez", "Kirgiz", "Kara-Kirgiz", "Southern Kyrgyz", "Northern Kyrgyz", "Kirghizi"],
  cc: ["CN", "AF", "KZ", "TJ", "TR", "US", "CA", "KG", "TM", "UZ"]
}, {
  pk: 3284,
  ang: "Kwaya",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Kwaya",
  lc: "kya",
  ld: "ltr",
  alt: ["Kikwaya", "Kirori", "Rori", "Luri", "Ruri (Ciruri)", "Kiruri", "Eciruuri", "Eciruri", "Kishyola"],
  cc: ["TZ"]
}, {
  pk: 3285,
  ang: "Kalinga, Butbut",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Butbut Kalinga",
  lc: "kyb",
  ld: "ltr",
  alt: ["Butbut"],
  cc: ["PH"]
}, {
  pk: 3286,
  ang: "Kyaka",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kyaka",
  lc: "kyc",
  ld: "ltr",
  alt: ["Baiyer", "Enga-Kyaka"],
  cc: ["PG"]
}, {
  pk: 3287,
  ang: "Karey",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Karey",
  lc: "kyd",
  ld: "ltr",
  alt: ["Kerei", "Krei"],
  cc: ["ID"]
}, {
  pk: 3288,
  ang: "Krache",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Krache",
  lc: "kye",
  ld: "ltr",
  alt: ["Kaakyi", "Krakye"],
  cc: ["GH"]
}, {
  pk: 3289,
  ang: "Kouya",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Kouya",
  lc: "kyf",
  ld: "ltr",
  alt: ["Kowya", "Kuya", "Sokya"],
  cc: ["CI"]
}, {
  pk: 3290,
  ang: "Keyagana",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Keyagana",
  lc: "kyg",
  ld: "ltr",
  alt: ["Keiagana", "Keigana", "Ke'yagana"],
  cc: ["PG"]
}, {
  pk: 3291,
  ang: "Karok",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Karok",
  lc: "kyh",
  ld: "ltr",
  alt: ["Karuk"],
  cc: ["US"]
}, {
  pk: 3292,
  ang: "Kiput",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Kiput",
  lc: "kyi",
  ld: "ltr",
  alt: ["Long Tutoh (Kuala Tutoh)"],
  cc: ["MY"]
}, {
  pk: 3293,
  ang: "Karao",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Karao",
  lc: "kyj",
  ld: "ltr",
  alt: ["Karaw"],
  cc: ["PH"]
}, {
  pk: 3294,
  ang: "Kamayo",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kamayo",
  lc: "kyk",
  ld: "ltr",
  alt: ["Davawe\xF1o", "Davawenyo", "Kadi", "Kinadi", "Kinamayo"],
  cc: ["PH"]
}, {
  pk: 3295,
  ang: "Kpatili",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Kpatili",
  lc: "kym",
  ld: "ltr",
  alt: ["Kpatere", "Kpatiri", "Ngindere"],
  cc: ["CF"]
}, {
  pk: 3296,
  ang: "Binukidnon, Northern",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Northern Binukidnon",
  lc: "kyn",
  ld: "ltr",
  alt: [],
  cc: ["PH"]
}, {
  pk: 3297,
  ang: "Klon",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kelon",
  lc: "kyo",
  ld: "ltr",
  alt: ["Kalong", "Kelon", "Kolon", "Klon Bring", "Klon Paneia"],
  cc: ["ID"]
}, {
  pk: 3298,
  ang: "Kang",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Kang",
  lc: "kyp",
  ld: "ltr",
  alt: ["Tai Khang"],
  cc: ["LA"]
}, {
  pk: 3299,
  ang: "Kenga",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Kenga",
  lc: "kyq",
  ld: "ltr",
  alt: ["Kenge", "Banala (Tar Banala)", "Banama (Tar Banama)", "Bolong (Tar Bolongo)", "Cenge (Tar Cenge)"],
  cc: ["TD"]
}, {
  pk: 3300,
  ang: "Kuru\xE1ya",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Kuru\xE1ya",
  lc: "kyr",
  ld: "ltr",
  alt: ["Caravare", "Curuaia", "Kuruaia"],
  cc: ["BR"]
}, {
  pk: 3301,
  ang: "Kayan, Baram",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Baram Kayan",
  lc: "kys",
  ld: "ltr",
  alt: ["Baram Kajan"],
  cc: ["MY"]
}, {
  pk: 3302,
  ang: "Kayagar",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kayagar",
  lc: "kyt",
  ld: "ltr",
  alt: ["Kajagar", "Kaygi", "Kaygir", "Wiyagar"],
  cc: ["ID"]
}, {
  pk: 3303,
  ang: "Kayah, Western",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Western Kayah",
  lc: "kyu",
  ld: "ltr",
  alt: ["Karenni", "Karennyi", "Karieng Daeng", "Kayah Li", "Red Karen", "Yang Daeng", "Sounglog", "Southern dialect of Western Kayah", "Northern dialect of Western Kayah", "Dawnnyjekhu", "Chi Kwe", "Dawtama", "Wan Cheh"],
  cc: ["MM"]
}, {
  pk: 3304,
  ang: "Kayort",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Kayort",
  lc: "kyv",
  ld: "ltr",
  alt: [],
  cc: ["NP"]
}, {
  pk: 3305,
  ang: "Kudmali",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kudmali",
  lc: "kyw",
  ld: "ltr",
  alt: ["Bedia", "Dharua", "Khotta", "Kurmali", "Kurmali Thar", "Kurumali"],
  cc: ["IN"]
}, {
  pk: 3306,
  ang: "Rapoisi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Rapoisi",
  lc: "kyx",
  ld: "ltr",
  alt: ["Konua", "Kunua"],
  cc: ["PG"]
}, {
  pk: 3307,
  ang: "Kambaira",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kambaira",
  lc: "kyy",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3308,
  ang: "Kayab\xED",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Kayab\xED",
  lc: "kyz",
  ld: "ltr",
  alt: ["Caiabi", "Kajab\xED", "Maquiri", "Parua"],
  cc: ["BR"]
}, {
  pk: 3309,
  ang: "Karaboro, Western",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Western Karaboro",
  lc: "kza",
  ld: "ltr",
  alt: ["Syer-Tenyer"],
  cc: ["BF"]
}, {
  pk: 3310,
  ang: "Kaibobo",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kaibobo",
  lc: "kzb",
  ld: "ltr",
  alt: ["Kaibubu"],
  cc: ["ID"]
}, {
  pk: 3311,
  ang: "Kulango, Bondoukou",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Bondoukou Kulango",
  lc: "kzc",
  ld: "ltr",
  alt: ["Bonduku", "Kolango", "Kulange", "Kulango", "Nkuraeng", "Nkurange"],
  cc: ["CI", "GH"]
}, {
  pk: 3312,
  ang: "Kadai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kadai",
  lc: "kzd",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3313,
  ang: "Kosena",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kosena",
  lc: "kze",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3314,
  ang: "Kaili, Da\u2019a",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Da'a Kaili",
  lc: "kzf",
  ld: "ltr",
  alt: ["Binggi", "Bunggu", "Da'a", "Pakawa", "Pekava", "Pekawa", "Da'a (Dombu)"],
  cc: ["ID"]
}, {
  pk: 3315,
  ang: "Kikai",
  lr: "Asia",
  gw: false,
  hc: "JP",
  ln: "\u3057\u307E\u3086\u307F\u305F",
  lc: "kzg",
  ld: "ltr",
  alt: [],
  cc: ["JP"]
}, {
  pk: 3316,
  ang: "Kelabit",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Kelabit",
  lc: "kzi",
  ld: "ltr",
  alt: ["Apo Duat", "Kalabit", "Kerabit", "Long Napir", "Tring", "Tabun", "Pa' Umor (spoken in Bario)", "Pa' Mada", "Long Peluan", "Long Lellang", "Bareo (Bario)", "Pa' Dalih"],
  cc: ["ID", "MY"]
}, {
  pk: 3317,
  ang: "Kadazan, Coastal",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Coastal Kadazan",
  lc: "kzj",
  ld: "ltr",
  alt: ["Kadazan Tangaa'", "Membakut Kadazan", "Papar Kadazan", "Penampang Kadazan"],
  cc: ["MY"]
}, {
  pk: 3318,
  ang: "Kayeli",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kayeli",
  lc: "kzl",
  ld: "ltr",
  alt: ["Caeli", "Cajeli", "Gaeli", "Kajeli", "Mumaite", "Leliali (Liliali)", "Lumaete (Lumaiti)", "Lumara"],
  cc: ["ID"]
}, {
  pk: 3319,
  ang: "Kais",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kais",
  lc: "kzm",
  ld: "ltr",
  alt: ["Aiso", "Atori", "Kampung Baru", "Mintamani"],
  cc: ["ID"]
}, {
  pk: 3320,
  ang: "Kokola",
  lr: "Africa",
  gw: false,
  hc: "MW",
  ln: "Kokola",
  lc: "kzn",
  ld: "ltr",
  alt: ["Kokhola"],
  cc: ["MZ", "MW"]
}, {
  pk: 3321,
  ang: "Kaningi",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Kaningi",
  lc: "kzo",
  ld: "ltr",
  alt: ["Bakanike", "Lekaningi"],
  cc: ["GA"]
}, {
  pk: 3322,
  ang: "Kaidipang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kaidipang",
  lc: "kzp",
  ld: "ltr",
  alt: ["Dio", "Kaidipang-Bolangitang", "Bolaang Itang (Bolang-Hitam)", "Bolang-Itam", "Kaidipang (Kaidipan)", "Kodipang"],
  cc: ["ID"]
}, {
  pk: 3323,
  ang: "Kaike",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Kaike",
  lc: "kzq",
  ld: "ltr",
  alt: ["Tarali Kham"],
  cc: ["NP"]
}, {
  pk: 3324,
  ang: "Karang",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Karang",
  lc: "kzr",
  ld: "ltr",
  alt: ["Mbum", "Mbum-East", "Eastern Mbum", "Kareng", "Laka", "Lakka", "Lakka Mbum", "Mbum Bakal", "Nz\xE1k K\xE0r\xE1ng", "Ngumi"],
  cc: ["CM"]
}, {
  pk: 3325,
  ang: "Dusun, Sugut",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Sugut Dusun",
  lc: "kzs",
  ld: "ltr",
  alt: ["Dusun", "Kadayan", "Sugut", "Sugut Kadazan", "Tanggal", "Tilau-Ilau"],
  cc: ["MY"]
}, {
  pk: 3326,
  ang: "Dusun, Tambunan",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Tambunan Dusun",
  lc: "kzt",
  ld: "ltr",
  alt: ["Tambunan"],
  cc: ["MY"]
}, {
  pk: 3327,
  ang: "Kayupulau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kayupulau",
  lc: "kzu",
  ld: "ltr",
  alt: ["Kajupulau"],
  cc: ["ID"]
}, {
  pk: 3328,
  ang: "Komyandaret",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Komyandaret",
  lc: "kzv",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3329,
  ang: "Karir\xED-Xoc\xF3",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Karir\xED-Xoc\xF3",
  lc: "kzw",
  ld: "ltr",
  alt: ["Kamur\xFA (Camuru)", "Kipe\xE1 (Quipea)", "Sabuj\xE1 (Pedra Branca)", "Karir\xED", "Kariri Xuc\xF3", "Kipe\xE1", "Xoc\xF3", "Xok\xF3", "Xok\xF3-Karir\xED", "Xukur\xFA", "Xukuru Kariri"],
  cc: ["BR"]
}, {
  pk: 3330,
  ang: "Kamarian",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kamarian",
  lc: "kzx",
  ld: "ltr",
  alt: ["Kamariang", "Seruawan"],
  cc: ["ID"]
}, {
  pk: 3331,
  ang: "Kango",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kango (Tshopo District)",
  lc: "kzy",
  ld: "ltr",
  alt: ["Dikango", "Kango Pygmy", "Kikango", "Likango", "Dibatchua", "Kibatchua"],
  cc: ["CD"]
}, {
  pk: 3332,
  ang: "Kalabra",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kalabra",
  lc: "kzz",
  ld: "ltr",
  alt: ["Beraur"],
  cc: ["ID"]
}, {
  pk: 3333,
  ang: "Latin",
  lr: "Europe",
  gw: false,
  hc: "VA",
  ln: "latine, lingua latina",
  lc: "la",
  ld: "ltr",
  alt: ["Latina"],
  cc: ["VA"]
}, {
  pk: 3334,
  ang: "Subanen, Southern",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Southern Subanen",
  lc: "laa",
  ld: "ltr",
  alt: ["Lapuyen", "Margosatubig", "Subanen", "Subanun, Lapuyan", "Lapuyan", "Subanun"],
  cc: ["PH"]
}, {
  pk: 3335,
  ang: "Linear A",
  lr: "Europe",
  gw: false,
  hc: "GR",
  ln: "Linear A",
  lc: "lab",
  ld: "ltr",
  alt: [],
  cc: ["GR"]
}, {
  pk: 3336,
  ang: "Lacandon",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Lacandon",
  lc: "lac",
  ld: "ltr",
  alt: ["Lacand\xF3n", "Lacanj\xE1", "Naj\xE1"],
  cc: ["MX"]
}, {
  pk: 3337,
  ang: "Ladino",
  lr: "Asia",
  gw: false,
  hc: "IL",
  ln: "Ladino",
  lc: "lad",
  ld: "ltr",
  alt: ["Dzhudezmo", "Judeo Spanish", "Sefardi", "Spanyol", "Haketia", "Hakitia", "Judyo", "Judezmo (Jidyo)", "Haketiya", "Haquetiya (Haketia)"],
  cc: ["IL", "ES", "TR", "US"]
}, {
  pk: 3338,
  ang: "Pattani",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Pattani",
  lc: "lae",
  ld: "ltr",
  alt: ["Chamba", "Chamba Lahuli", "Changsapa Boli", "Lahuli", "Manchad", "Manchati", "Patni", "Swangla", "Chamba-Lahuli (Western Pattani)"],
  cc: ["IN"]
}, {
  pk: 3339,
  ang: "Lafofa",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Lafofa",
  lc: "laf",
  ld: "ltr",
  alt: ["Tekeim", "Jebel El Amira (El Amira)", "Jebel Tekeim (Jebel)", "Tegem"],
  cc: ["SD"]
}, {
  pk: 3340,
  ang: "Langi",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Langi",
  lc: "lag",
  ld: "ltr",
  alt: ["Kilaangi", "Kilangi", "Kirangi", "Rangi", "Mondo", "Kondoa", "Kolo", "Busi", "Haubi"],
  cc: ["TZ"]
}, {
  pk: 3341,
  ang: "Lahnda",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "Lahnda",
  lc: "lah",
  ld: "ltr",
  alt: [],
  cc: ["PK"]
}, {
  pk: 3342,
  ang: "Lambya",
  lr: "Africa",
  gw: false,
  hc: "MW",
  ln: "Lambya",
  lc: "lai",
  ld: "ltr",
  alt: ["Ichilambya", "Kilambya", "Lambwa", "Rambia", "Icilambya", "Ici-Rambia", "Iramba"],
  cc: ["TZ", "ZM", "MW"]
}, {
  pk: 3343,
  ang: "Lango",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Lango (Uganda)",
  lc: "laj",
  ld: "ltr",
  alt: ["Langi", "Leb-Lango", "Lwo", "Lwoo"],
  cc: ["UG"]
}, {
  pk: 3344,
  ang: "Laka",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Laka (Nigeria)",
  lc: "lak",
  ld: "ltr",
  alt: ["Godogodo", "Lao Habe", "Lau"],
  cc: ["NG"]
}, {
  pk: 3345,
  ang: "Lalia",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lalia",
  lc: "lal",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 3346,
  ang: "Lamba",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lamba",
  lc: "lam",
  ld: "ltr",
  alt: ["Chilamba", "Ichilamba"],
  cc: ["ZM", "CD"]
}, {
  pk: 3347,
  ang: "Laru",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Laru",
  lc: "lan",
  ld: "ltr",
  alt: ["Laranchi", "Larawa", "Laro", "Sengwe"],
  cc: ["NG"]
}, {
  pk: 8377,
  ang: "Lao Nhook",
  lr: "Asia",
  gw: false,
  hc: "KH",
  ln: "Lao Nhook",
  lc: "lao-x-laonhook",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8220,
  ang: "Lao-Vientiane",
  lr: "Asia",
  gw: false,
  hc: "KH",
  ln: "Lao-Vientiane",
  lc: "lao-x-vientiane",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3348,
  ang: "Laka",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Laka (Chad)",
  lc: "lap",
  ld: "ltr",
  alt: ["Kabba Laka"],
  cc: ["CF", "TD"]
}, {
  pk: 3349,
  ang: "Qabiao",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Qabiao",
  lc: "laq",
  ld: "ltr",
  alt: ["Bendi Lolo", "Ka Bao", "Ka Biao", "Kabeo", "Man La Qua", "Phubyau", "Pu Beo", "Pu P\xE9o", "Pubiao", "Pupeo", "Qabiau", "Qaqiau", "Lolo", "Pen Ti"],
  cc: ["VN"]
}, {
  pk: 3350,
  ang: "Larteh",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Larteh",
  lc: "lar",
  ld: "ltr",
  alt: ["Gua", "Late", "Lete"],
  cc: ["GH"]
}, {
  pk: 3351,
  ang: "Lama",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Lama (Togo)",
  lc: "las",
  ld: "ltr",
  alt: ["Lamba", "Losso", "Kande (Kante)", "Kadjala (Kadjalla)"],
  cc: ["TG"]
}, {
  pk: 3352,
  ang: "Laba",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Laba",
  lc: "lau",
  ld: "ltr",
  alt: ["Kedi", "South Loloda"],
  cc: ["ID"]
}, {
  pk: 3353,
  ang: "Lauje",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lauje",
  lc: "law",
  ld: "ltr",
  alt: ["Laudje", "Tinombo", "Ampibabo (Ampibabo-Lauje)"],
  cc: ["ID"]
}, {
  pk: 3354,
  ang: "Tiwa",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Tiwa",
  lc: "lax",
  ld: "ltr",
  alt: ["Dowyan", "Lalung"],
  cc: ["IN"]
}, {
  pk: 3355,
  ang: "Bai, Lama",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Lama Bai",
  lc: "lay",
  ld: "ltr",
  alt: ["Lan-Bi Bai", "Northern Bai"],
  cc: ["CN"]
}, {
  pk: 3356,
  ang: "Luxembourgish, Letzeburgesch",
  lr: "Europe",
  gw: false,
  hc: "LU",
  ln: "L\xEBtzebuergesch",
  lc: "lb",
  ld: "ltr",
  alt: ["Letzburgisch", "L\xEBtzebuergesch", "Luxemburgian", "Moselle Franconian", "Frankish", "Platt", "Luxembourgish", "Luxemburgish"],
  cc: ["BE", "FR", "DE", "US", "LU"]
}, {
  pk: 3357,
  ang: "Label",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Label",
  lc: "lbb",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3358,
  ang: "Lakkia",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u62C9\u73C8\u8BED",
  lc: "lbc",
  ld: "ltr",
  alt: ["Chashan Yao", "Lajia", "Laka", "Lakia", "Lakja", "Lakkja", "Tai Laka", "Tea Mountain Yao"],
  cc: ["CN"]
}, {
  pk: 3359,
  ang: "Lak",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041B\u0430\u043A\u0441\u043A\u0438\u0439",
  lc: "lbe",
  ld: "ltr",
  alt: ["Kazikumukhtsy", "Laki", "Vicxin (Vitskhin)", "Arakul", "Vixlin (Vikhlin)", "Shandi", "Shali", "Pervotsovkrin", "Kumux (Kumkh)", "Kayalin-Mashikin", "Balxar-Calakan (Balkar-Tsalakan)"],
  cc: ["AZ", "RU", "TM", "UZ"]
}, {
  pk: 3360,
  ang: "Tinani",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Tinani",
  lc: "lbf",
  ld: "ltr",
  alt: ["Bhotia of Lahul", "Gondla", "Lahauli", "Lahuli Tinan", "Rangloi", "Gondhla", "Lahuli", "Teenan", "Tinan Lahuli"],
  cc: ["IN"]
}, {
  pk: 3361,
  ang: "Laopang",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Laopang",
  lc: "lbg",
  ld: "ltr",
  alt: ["Laopa"],
  cc: ["CN", "LA"]
}, {
  pk: 3362,
  ang: "La\u2019bi",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "La'bi",
  lc: "lbi",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 3363,
  ang: "Ladakhi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Ladakhi",
  lc: "lbj",
  ld: "ltr",
  alt: ["Ladak", "Ladaphi", "Ladhakhi", "Ladwags", "Ladakh Skat", "Sham", "Shamma (Lower Ladakhi)", "Shamskat", "Leh (Central Ladakhi)"],
  cc: ["CN", "PK", "IN"]
}, {
  pk: 3364,
  ang: "Bontok, Central",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Central Bontok",
  lc: "lbk",
  ld: "ltr",
  alt: ["Bontoc", "Bontoc Igorot", "Central"],
  cc: ["PH"]
}, {
  pk: 3365,
  ang: "Bikol, Libon",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Libon Bikol",
  lc: "lbl",
  ld: "ltr",
  alt: ["Libonge\xF1o"],
  cc: ["PH"]
}, {
  pk: 3366,
  ang: "Lodhi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Lodhi",
  lc: "lbm",
  ld: "ltr",
  alt: ["Lodha", "Lodi", "Lohi", "Lozi"],
  cc: ["IN"]
}, {
  pk: 3367,
  ang: "Lamet",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Lamet",
  lc: "lbn",
  ld: "ltr",
  alt: ["Kha Lamet", "Khamed", "Lemet", "Rmeet", "Kamet"],
  cc: ["LA", "TH", "US"]
}, {
  pk: 3368,
  ang: "Laven",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Laven",
  lc: "lbo",
  ld: "ltr",
  alt: ["Boloven", "Boriwen", "Jaru", "Jru'", "Jruq", "Laweenjru", "Loven"],
  cc: ["LA", "US"]
}, {
  pk: 8437,
  ang: "Laven Champasak",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Laven Champasak",
  lc: "lbo-x-champasak",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8430,
  ang: "Laven Xekong",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Laven Xekong",
  lc: "lbo-x-lavenxekon",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3369,
  ang: "Wampar",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wampar",
  lc: "lbq",
  ld: "ltr",
  alt: ["Laewamba", "Laewomba", "Laiwomba"],
  cc: ["PG"]
}, {
  pk: 3370,
  ang: "Lohorung",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Lohorung",
  lc: "lbr",
  ld: "ltr",
  alt: ["Lohorong", "Lohrung", "Lohrung Khanawa", "Lorung", "Northern Lorung", "Biksit (Bikshi)"],
  cc: ["NP"]
}, {
  pk: 3371,
  ang: "Libyan Sign Language",
  lr: "Africa",
  gw: false,
  hc: "LY",
  ln: "\u0644\u063A\u0629 \u0627\u0644\u0625\u0634\u0627\u0631\u0629 \u0627\u0644\u0644\u064A\u0628\u064A\u0629",
  lc: "lbs",
  ld: "ltr",
  alt: [],
  cc: ["LY"]
}, {
  pk: 3372,
  ang: "Lachi",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Lachi",
  lc: "lbt",
  ld: "ltr",
  alt: ["I To", "Ku Te", "La Chi", "Laji", "Lati", "Lipuljo", "Tai Lati", "Y Mia", "Y Poong", "Y To", "C\xF9 Te", "Cu-T\xEA", "Lach\xED", "Lipulio", "Mia", "Y", "Y P\xED", "Y P\xF3ng", "Lipuliongtco (Flowery Lachi)", "Lipute (Bag Lachi)", "Liputi\xF5 (Black Lachi)", "Lipuke (Red Lachi)", "Liputcio (Han Lachi)", "Lipupi (Long-Haired Lachi)"],
  cc: ["CN", "VN"]
}, {
  pk: 3373,
  ang: "Labu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Labu",
  lc: "lbu",
  ld: "ltr",
  alt: ["Hapa", "Labu'"],
  cc: ["PG"]
}, {
  pk: 3374,
  ang: "Lavatbura-Lamusong",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Lavatbura-Lamusong",
  lc: "lbv",
  ld: "ltr",
  alt: ["Lamasong", "Lamusong (Lamasong)"],
  cc: ["PG"]
}, {
  pk: 3375,
  ang: "Tolaki",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tolaki",
  lc: "lbw",
  ld: "ltr",
  alt: ["Laki", "Lolaki", "Tokia", "Tololaki", "To'olaki", "Asera (Asera Wanua)", "Kioki", "Kolaka", "Konawe (Kendari)", "Mekongga (Bingkokak)", "Noie", "Tambuoki", "Wiwirano (Nohina)"],
  cc: ["ID"]
}, {
  pk: 3376,
  ang: "Lawangan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lawangan",
  lc: "lbx",
  ld: "ltr",
  alt: ["Luwangan", "Northeast Barito", "Karau (Beloh)", "Pasir", "Bantian (Bentian)", "Bakoi (Lampung)", "Bawu (Bawo)"],
  cc: ["ID"]
}, {
  pk: 8380,
  ang: "Dayak Bantian",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Bantian",
  lc: "lbx-x-bantian",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8240,
  ang: "Capur Acu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Capur Acu",
  lc: "lbx-x-capuracu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7831,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Benua",
  lc: "lbx-x-dayakbenua",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7832,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Pasir",
  lc: "lbx-x-dayakpasir",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8082,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Paus",
  lc: "lbx-x-dayakpaus",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7919,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Long Benuang",
  lc: "lbx-x-lomgbenuang",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7965,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Mantarap Kabut",
  lc: "lbx-x-mantarapkabut",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3377,
  ang: "Lamu-Lamu",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Lamu-Lamu",
  lc: "lby",
  ld: "ltr",
  alt: ["Lamalama", "Lama-Lama", "Lamulamul", "Mba Rumbathama"],
  cc: ["AU"]
}, {
  pk: 3378,
  ang: "Lardil",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Lardil",
  lc: "lbz",
  ld: "ltr",
  alt: ["Kunana", "Ladil", "Laierdila", "Lardill"],
  cc: ["AU"]
}, {
  pk: 3379,
  ang: "Legenyem",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Legenyem",
  lc: "lcc",
  ld: "ltr",
  alt: ["Laganyan"],
  cc: ["ID"]
}, {
  pk: 3380,
  ang: "Lola",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lola",
  lc: "lcd",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3381,
  ang: "Sekak",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Loncong",
  lc: "lce",
  ld: "ltr",
  alt: ["Lonchong", "Lontjong", "Orang Laut", "Sawang", "Seka", "Sekah"],
  cc: ["ID"]
}, {
  pk: 3382,
  ang: "Lubu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lubu",
  lc: "lcf",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3383,
  ang: "Lucazi",
  lr: "Africa",
  gw: false,
  hc: "AO",
  ln: "Luchazi",
  lc: "lch",
  ld: "ltr",
  alt: ["Chiluchazi", "Lujash", "Lujazi", "Lutchaz", "Lutshase", "Luxage", "Ponda", "Cujazi", "Lujasi"],
  cc: ["ZM", "AO", "NA"]
}, {
  pk: 3384,
  ang: "Lisela",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lisela",
  lc: "lcl",
  ld: "ltr",
  alt: ["Buru", "Li Enyorot", "Liet Enjorot", "North Buru", "Wayapo", "Lisela (Licela)", "Licella"],
  cc: ["ID"]
}, {
  pk: 3385,
  ang: "Tungag",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tungag",
  lc: "lcm",
  ld: "ltr",
  alt: ["Dang", "Lavangai", "Toangai", "Tungak"],
  cc: ["PG"]
}, {
  pk: 3386,
  ang: "Lawa, Western",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Western Lawa",
  lc: "lcp",
  ld: "ltr",
  alt: ["Lava", "Lav\xFCa", "Luwa", "L'wa", "Mae Hong Son Lawa", "Mountain Lawa", "Omphai Lawa", "Lua", "La-up", "Northern Western Lawa", "Omphai"],
  cc: ["CN", "TH"]
}, {
  pk: 3387,
  ang: "Luhu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Luhu",
  lc: "lcq",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3388,
  ang: "Lisabata-Nuniali",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lisabata-Nuniali",
  lc: "lcs",
  ld: "ltr",
  alt: ["Lisabata", "Noniali"],
  cc: ["ID"]
}, {
  pk: 3389,
  ang: "Kla-Dan",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Kla-Dan",
  lc: "lda",
  ld: "ltr",
  alt: [],
  cc: ["CI"]
}, {
  pk: 3390,
  ang: "Duya",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Du\u0303ya",
  lc: "ldb",
  ld: "ltr",
  alt: ["Adong", "Idun", "Jaba Duya", "Jaba Lunga", "Lungu", "Ungu"],
  cc: ["NG"]
}, {
  pk: 3391,
  ang: "Lenyima",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Lenyima",
  lc: "ldg",
  ld: "ltr",
  alt: ["Anyima", "Inyima"],
  cc: ["NG"]
}, {
  pk: 3392,
  ang: "Lamja-Dengsa-Tola",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Lamja-Dengsa-Tola",
  lc: "ldh",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 3393,
  ang: "Laari",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Laari",
  lc: "ldi",
  ld: "ltr",
  alt: ["Kilari", "Ladi", "Lari", "Ghaangala (Hangala)", "Laari de Kinkala", "Kighaangala", "Laari de Biiza"],
  cc: ["CG"]
}, {
  pk: 3394,
  ang: "Lemoro",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Lemoro",
  lc: "ldj",
  ld: "ltr",
  alt: ["Anemoro", "Anowuru", "Emoro", "Limoro", "Limorro"],
  cc: ["NG"]
}, {
  pk: 3395,
  ang: "Leelau",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Leelau",
  lc: "ldk",
  ld: "ltr",
  alt: ["Lelo", "Munga", "Munga Lelau"],
  cc: ["NG"]
}, {
  pk: 3396,
  ang: "Kaan",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ka\u0303a\u0303n",
  lc: "ldl",
  ld: "ltr",
  alt: ["Kan", "Libbo"],
  cc: ["NG"]
}, {
  pk: 3397,
  ang: "Landoma",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Landoma",
  lc: "ldm",
  ld: "ltr",
  alt: ["Cocoli", "Landouman", "Landuma", "Tyapi", "Tyopi", "Tiapi (Tapessi)"],
  cc: ["GN"]
}, {
  pk: 3398,
  ang: "",
  lr: "",
  gw: false,
  hc: "",
  ln: "L\xE1adan",
  lc: "ldn",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3399,
  ang: "Loo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Loo",
  lc: "ldo",
  ld: "ltr",
  alt: ["Loh", "Shungo", "Shunhu"],
  cc: ["NG"]
}, {
  pk: 3400,
  ang: "Tso",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Tso",
  lc: "ldp",
  ld: "ltr",
  alt: ["Cibbo", "Cuyi Ts\xF3", "Kitta", "Lotsu-Piri", "Pire", "Piri", "Ts\xF3b\xF3"],
  cc: ["NG"]
}, {
  pk: 3401,
  ang: "Lufu",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Lufu",
  lc: "ldq",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 3402,
  ang: "Lega-Shabunda",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lega-Shabunda",
  lc: "lea",
  ld: "ltr",
  alt: ["Igonzabale", "Ileka-Igonzabale", "Kirega", "Leka-Igonzabale", "Rega", "Kinyamunsange (Pangi)"],
  cc: ["CD"]
}, {
  pk: 3403,
  ang: "Lala-Bisa",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Lala-Bisa",
  lc: "leb",
  ld: "ltr",
  alt: ["Biza-Lala", "Ichibisa", "Wisa", "Wiza", "Kambonsenga", "Bisa (Biisa)", "Ambo (Bambo)", "Bisa (Ichibisa)", "Lala (Ichilala)"],
  cc: ["ZM"]
}, {
  pk: 3404,
  ang: "Leco",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Leco",
  lc: "lec",
  ld: "ltr",
  alt: ["Leko", "Rik'a"],
  cc: ["BO"]
}, {
  pk: 3405,
  ang: "Lendu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lendu",
  lc: "led",
  ld: "ltr",
  alt: ["Bale", "Balendru", "Batha", "Bbadha", "Bbaledha", "Hema-Nord", "Kihema-Nord", "Kilendu", "Ddralo (Ddradha)", "Djadha (Jidha)", "Njawlo (Njawdha)"],
  cc: ["CD", "UG"]
}, {
  pk: 3406,
  ang: "Ly\xE9l\xE9",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Ly\xE9l\xE9",
  lc: "lee",
  ld: "ltr",
  alt: ["Lele", "Southern Ly\xE9l\xE9 (Reo)"],
  cc: ["BF"]
}, {
  pk: 3407,
  ang: "Lelemi",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Lelemi",
  lc: "lef",
  ld: "ltr",
  alt: ["Buem", "Lafana", "Lefana"],
  cc: ["GH", "TG"]
}, {
  pk: 3408,
  ang: "Lenje",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Lenje",
  lc: "leh",
  ld: "ltr",
  alt: ["Chilenje", "Chinamukuni", "Ciina", "Lengi", "Lenji", "Mukuni", "Twa (Lukanga)"],
  cc: ["ZM"]
}, {
  pk: 3409,
  ang: "Lemio",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Lemio",
  lc: "lei",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3410,
  ang: "Lengola",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lengola",
  lc: "lej",
  ld: "ltr",
  alt: ["Lengora"],
  cc: ["CD"]
}, {
  pk: 3411,
  ang: "Leipon",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Leipon",
  lc: "lek",
  ld: "ltr",
  alt: ["Pityilu"],
  cc: ["PG"]
}, {
  pk: 3412,
  ang: "Lele",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lele (Democratic Republic of Congo)",
  lc: "lel",
  ld: "ltr",
  alt: ["Bashilele", "Usilele"],
  cc: ["CD"]
}, {
  pk: 3413,
  ang: "Nomaande",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Nomaande",
  lc: "lem",
  ld: "ltr",
  alt: ["Lemande", "Mande", "Mandi", "Noomaante", "Numand", "Pimenc"],
  cc: ["CM"]
}, {
  pk: 3414,
  ang: "Lenca",
  lr: "Americas",
  gw: false,
  hc: "HN",
  ln: "Lenca",
  lc: "len",
  ld: "ltr",
  alt: [],
  cc: ["HN"]
}, {
  pk: 3415,
  ang: "Leti",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Leti (Cameroon)",
  lc: "leo",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 3416,
  ang: "Lepcha",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Lepcha",
  lc: "lep",
  ld: "ltr",
  alt: ["Lapcha", "N\xFCnpa", "Rong", "Rongke", "Rongpa", "Lapche"],
  cc: ["BT", "NP", "IN"]
}, {
  pk: 3417,
  ang: "Lembena",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Lembena",
  lc: "leq",
  ld: "ltr",
  alt: ["Lembena Pii", "Nanimba Pii", "Uyalipa Pii", "Wapi Pii"],
  cc: ["PG"]
}, {
  pk: 3418,
  ang: "Lenkau",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Lenkau",
  lc: "ler",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3419,
  ang: "Lese",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lese",
  lc: "les",
  ld: "ltr",
  alt: ["Balese", "Lesa", "Lesse", "Lissi", "Mbuti", "Walisi", "Vukutu (Obi)", "Vonkutu", "Arumbi (Upstream Lese)", "Ndese (Lese Dese)"],
  cc: ["CD"]
}, {
  pk: 3420,
  ang: "Amio-Gelimi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Lesing-Gelimi",
  lc: "let",
  ld: "ltr",
  alt: ["Amio", "Atui", "Lesing-Atui", "Lesing-Gelimi", "Poronga"],
  cc: ["PG"]
}, {
  pk: 3421,
  ang: "Kara",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kara (Papua New Guinea)",
  lc: "leu",
  ld: "ltr",
  alt: ["Lemusmus", "Lauan-Nonopai", "Luburua", "Ngavalus-Lossuk"],
  cc: ["PG"]
}, {
  pk: 3422,
  ang: "Pantar, Western",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lamma",
  lc: "lev",
  ld: "ltr",
  alt: ["Lamma'", "Lemma", "Pantar Barat", "Tubbe"],
  cc: ["ID"]
}, {
  pk: 3423,
  ang: "Kaili, Ledo",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ledo Kaili",
  lc: "lew",
  ld: "ltr",
  alt: ["Paloesch", "Palu", "Rai (Sindue-Tawaili)", "Ado (Pakuli)", "Doi (Kayu Malue)", "Edo (Sidondo)", "Ija (Sigi)", "Ledo (Palu)", "Raio (Kori)", "To ri Io", "Mamboro", "Torio", "Tawaili-Sindue", "Tara (Parigi)", "Tado (Ri Io)", "Taa (Palolo)", "Ta'a (Dolago-Sausu)", "Sibalaya", "Sausu", "Toriu"],
  cc: ["ID"]
}, {
  pk: 3424,
  ang: "Luang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Luang",
  lc: "lex",
  ld: "ltr",
  alt: ["Letri Lgona", "Lgona", "Literi Lagona", "Wetan (Wetang)"],
  cc: ["ID"]
}, {
  pk: 3425,
  ang: "Lemolang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lemolang",
  lc: "ley",
  ld: "ltr",
  alt: ["Baebunta", "Limola", "Limolang"],
  cc: ["ID"]
}, {
  pk: 3426,
  ang: "Lezgi",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041B\u0435\u0437\u0433\u0438\u043D\u0441\u043A\u0438\u0439",
  lc: "lez",
  ld: "ltr",
  alt: ["Kiurinty", "Lezghi", "Lezgian", "Kiurinsty", "Giliar", "Quba (Kuba)", "Yarki", "Samur (Akhty)", "Qurush", "Qurah", "Kiuri (Gelkhen)", "G\xFCne", "Fiy", "Doquzpara", "Dashagyl-Filfil", "Jaba"],
  cc: ["AZ", "KZ", "RU", "KG", "TM", "UZ"]
}, {
  pk: 3427,
  ang: "Lefa",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Lefa",
  lc: "lfa",
  ld: "ltr",
  alt: ["Balom", "Fak", "Lefa'", "Cama (Tempanye)", "Letia", "Tingong"],
  cc: ["CM"]
}, {
  pk: 3428,
  ang: "",
  lr: "",
  gw: false,
  hc: "",
  ln: "Lingua Franca Nova",
  lc: "lfn",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3429,
  ang: "Ganda",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Luganda",
  lc: "lg",
  ld: "ltr",
  alt: ["Diopa (Ludiopa)", "Kooki (Olukooki)", "Sese (Olusese)", "Vuma (Luvuma)"],
  cc: ["KE", "TZ", "US", "CA", "UG"]
}, {
  pk: 3430,
  ang: "Lungga",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Lungga",
  lc: "lga",
  ld: "ltr",
  alt: ["Luqa"],
  cc: ["SB"]
}, {
  pk: 3431,
  ang: "Laghu",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Laghu",
  lc: "lgb",
  ld: "ltr",
  alt: ["Katova", "Lagu"],
  cc: ["SB"]
}, {
  pk: 3432,
  ang: "Lugbara",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Lugbara",
  lc: "lgg",
  ld: "ltr",
  alt: ["High Lugbara", "Arua (Standard Lugbara)", "Terego (Omugo)"],
  cc: ["UG"]
}, {
  pk: 3433,
  ang: "Laghuu",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Laghuu",
  lc: "lgh",
  ld: "ltr",
  alt: ["Laopa", "X\xE1 Ph\xF3"],
  cc: ["VN"]
}, {
  pk: 3434,
  ang: "Lengilu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lengilu",
  lc: "lgi",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3435,
  ang: "Neverver",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Lingarak",
  lc: "lgk",
  ld: "ltr",
  alt: ["Bushman's Bay", "Nevwervwer", "Wuli", "Mindu"],
  cc: ["VU"]
}, {
  pk: 3436,
  ang: "Wala",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Wala",
  lc: "lgl",
  ld: "ltr",
  alt: ["Langalanga"],
  cc: ["SB"]
}, {
  pk: 3437,
  ang: "Lega-Mwenga",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lega-Mwenga",
  lc: "lgm",
  ld: "ltr",
  alt: ["Ileka Ishile", "Ishile", "Kilega", "Kirega", "Leka-Shile", "Leka-Sile", "Rega", "Shile"],
  cc: ["CD"]
}, {
  pk: 7842,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kinangozi",
  lc: "lgm-x-kinangozi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7778,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kirega",
  lc: "lgm-x-kirega",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3438,
  ang: "Opuuo",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Opuuo",
  lc: "lgn",
  ld: "ltr",
  alt: ["Ansita", "Ciita", "Cita", "Kina", "Kwina", "Opo", "Opo-Shita", "Opuo", "Shiita", "Shita", "Langa", "Shitta", "Kusgilo", "Baruun", "Buldit (Barun)"],
  cc: ["ET"]
}, {
  pk: 3439,
  ang: "Logba",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Logba",
  lc: "lgq",
  ld: "ltr",
  alt: ["Ikpana"],
  cc: ["GH"]
}, {
  pk: 3440,
  ang: "Lengo",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Lengo",
  lc: "lgr",
  ld: "ltr",
  alt: ["Doku", "Ruavatu", "Tadhimboko", "Ghaimuta (Ghua)"],
  cc: ["SB"]
}, {
  pk: 3441,
  ang: "Pahi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Pahi",
  lc: "lgt",
  ld: "ltr",
  alt: ["Lugitama", "Riahoma", "Wansum"],
  cc: ["PG"]
}, {
  pk: 3442,
  ang: "Longgu",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Longgu",
  lc: "lgu",
  ld: "ltr",
  alt: ["Logu"],
  cc: ["SB"]
}, {
  pk: 7767,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Lougwau",
  lc: "lgw",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3443,
  ang: "Ligenza",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ligenza",
  lc: "lgz",
  ld: "ltr",
  alt: ["Digenja", "Gendja", "Gendza-Bali"],
  cc: ["CD"]
}, {
  pk: 3444,
  ang: "Laha",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Laha (Viet Nam)",
  lc: "lha",
  ld: "ltr",
  alt: ["Khl\xE1", "Khl\xE1 Don", "Khl\xE1 Dung", "Khl\xE1 Phlao", "Kl\xE1 Dong", "La Ha Ung", "Liik", "X\xE1 Chien", "X\xE1 Khao", "X\xE1 Lay"],
  cc: ["VN"]
}, {
  pk: 3445,
  ang: "Laha",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Laha (Indonesia)",
  lc: "lhh",
  ld: "ltr",
  alt: ["Central Ambon"],
  cc: ["ID"]
}, {
  pk: 3446,
  ang: "Lahu Shi",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u62C9\u795C\u897F\u8BED",
  lc: "lhi",
  ld: "ltr",
  alt: ["Kur", "Kwi", "Lahu Xi", "Shi", "Yellow Lahu", "Kui", "!Kwi", "Bakeo", "Banlan"],
  cc: ["CN", "LA", "TH", "US", "MM"]
}, {
  pk: 3447,
  ang: "Lohar, Lahul",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Lahul Lohar",
  lc: "lhl",
  ld: "ltr",
  alt: ["Garas", "Lohar"],
  cc: ["IN"]
}, {
  pk: 3448,
  ang: "Lhomi",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u0932\u094D\u0939\u094B\u092E\u0940",
  lc: "lhm",
  ld: "ltr",
  alt: ["Lhoket", "Shing Saapa", "Syingsaaba", "Bho Te bhasha", "Kar Bhote", "Kath Bhote"],
  cc: ["NP"]
}, {
  pk: 3449,
  ang: "Lahanan",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Lahanan",
  lc: "lhn",
  ld: "ltr",
  alt: ["Lanan", "Lanun"],
  cc: ["MY"]
}, {
  pk: 3450,
  ang: "Lhokpu",
  lr: "Asia",
  gw: false,
  hc: "BT",
  ln: "Lhokpu",
  lc: "lhp",
  ld: "ltr",
  alt: ["Lhobikha", "Taba-Damey-Bikha"],
  cc: ["BT"]
}, {
  pk: 3451,
  ang: "Lo-Toga",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Lo-Toga",
  lc: "lht",
  ld: "ltr",
  alt: ["Loh-Toga", "Lo", "Toga"],
  cc: ["VU"]
}, {
  pk: 3452,
  ang: "Lahu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u62C9\u795C\u8BED",
  lc: "lhu",
  ld: "ltr",
  alt: ["Kaixien", "Kucong", "Kutsong", "Lahuna", "Laku", "Lohei", "Moso", "Muhso", "Mussar", "Musso", "Mussuh", "Namen", "Museu", "Launa", "Muhsur", "Musser", "Mooso", "Musser Dam", "Southern Lahu", "Red Lahu", "Nyi (Musseh Daeng)", "Nyi (Musse Daeng)", "Nyi (Luhishi)", "Na (Black Lahu)", "Musseh Daeng", "Luhushi", "Loheirn", "Lahu Phung (White Lahu)", "Khucong", "Northern Lahu"],
  cc: ["CN", "LA", "TH", "MM"]
}, {
  pk: 3453,
  ang: "Limburgish, Limburgan, Limburger",
  lr: "Europe",
  gw: false,
  hc: "NL",
  ln: "Limburgs",
  lc: "li",
  ld: "ltr",
  alt: ["Limberger", "Limburgan", "Limburgian", "Limburgic", "Limburgs", "Limburgs Plat"],
  cc: ["NL"]
}, {
  pk: 3454,
  ang: "Limba, West-Central",
  lr: "Africa",
  gw: false,
  hc: "SL",
  ln: "West-Central Limba",
  lc: "lia",
  ld: "ltr",
  alt: ["Yimba", "Yumba", "Central Limba (Gbongogbo)", "Tamiso", "Tonko", "Western Limba (Sela)"],
  cc: ["GN", "SL"]
}, {
  pk: 3455,
  ang: "Likum",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Likum",
  lc: "lib",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3456,
  ang: "Hlai",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u9ECE\u8BED",
  lc: "lic",
  ld: "ltr",
  alt: ["Bli", "Dai", "Day", "Dli", "Klai", "La", "Lai", "Le", "Li", "Loi", "Slai", "Tongshi-Qiandui-Baocheng", "Local Li", "Zwn", "Bendi (Baisha-Yuanmen)", "Meifu (Moifau)", "Ha (Luohua-Hayan-Baoxian)", "Qi (Gei)"],
  cc: ["CN"]
}, {
  pk: 3457,
  ang: "Nyindrou",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nyindrou",
  lc: "lid",
  ld: "ltr",
  alt: ["Lindau", "Lindrou", "Nyada", "Salien"],
  cc: ["PG"]
}, {
  pk: 3458,
  ang: "Likila",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Likila",
  lc: "lie",
  ld: "ltr",
  alt: ["Balobo", "Bangela"],
  cc: ["CD"]
}, {
  pk: 3459,
  ang: "Limbu",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u0932\u093F\u092E\u094D\u092C\u0942",
  lc: "lif",
  ld: "ltr",
  alt: ["Limbo", "Limboo", "Lumbu", "Chaubise (Charkhole)", "Chhathar", "Chhatthare (Chatthare)", "Tamorkhole (Taplejunge)", "Yanggrokke (Yanggruppe)"],
  cc: ["BT", "NP", "IN"]
}, {
  pk: 3460,
  ang: "Ligbi",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Ligbi",
  lc: "lig",
  ld: "ltr",
  alt: ["Banda", "Jogo", "Ligwi", "Nigbi", "Nigwi", "Tuba", "Dzowo", "Namasa", "Tsie", "Weela", "Weila", "Wiila", "Atumfuor (Atumfuor-Kasa)", "Dwera (Manji-Kasa)", "Hwela (Vwela)"],
  cc: ["GH"]
}, {
  pk: 3461,
  ang: "Lihir",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Lihir",
  lc: "lih",
  ld: "ltr",
  alt: ["Lir"],
  cc: ["PG"]
}, {
  pk: 3462,
  ang: "Ligurian",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Ligurian",
  lc: "lij",
  ld: "ltr",
  alt: ["Ligure", "Zen\xE9ize", "Genoese (Genoan)", "Genovese", "Mon\xE9gasque (Munegasc)", "Ventimigliese"],
  cc: ["MC", "IT"]
}, {
  pk: 3463,
  ang: "Lika",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lika",
  lc: "lik",
  ld: "ltr",
  alt: ["Kpongo", "Mabiti", "Toriko", "Lik\xF3 (Ik\xF3)", "Lilik\xE1 (Lik\xE1)"],
  cc: ["CD"]
}, {
  pk: 3464,
  ang: "Lillooet",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Lillooet",
  lc: "lil",
  ld: "ltr",
  alt: ["St'at'imcets", "Upper Lillooet", "Lower Lillooet"],
  cc: ["CA"]
}, {
  pk: 3465,
  ang: "Liki",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Liki",
  lc: "lio",
  ld: "ltr",
  alt: ["Moar"],
  cc: ["ID"]
}, {
  pk: 3466,
  ang: "Sekpele",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Sekpele",
  lc: "lip",
  ld: "ltr",
  alt: ["Bosele", "Mu"],
  cc: ["GH"]
}, {
  pk: 3467,
  ang: "Libido",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Libido",
  lc: "liq",
  ld: "ltr",
  alt: ["Marako", "Maraqo"],
  cc: ["ET"]
}, {
  pk: 3468,
  ang: "Liberian English",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Liberian English",
  lc: "lir",
  ld: "ltr",
  alt: ["Liberian Pidgin English"],
  cc: ["LR"]
}, {
  pk: 3469,
  ang: "Lisu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5088\u50F3\u8BED",
  lc: "lis",
  ld: "ltr",
  alt: ["Chedi", "Cheli", "Chung", "Khae", "Leisu", "Leshuoopa", "Lesuo", "Li", "Li-Hsaw", "Lip'a", "Lisaw", "Li-Shaw", "Lishu", "Liso", "Lissu", "Loisu", "Lusu", "Lu-Tzu", "Yao Yen", "Yaw Yin", "Yaw-Yen", "Yeh-Jen", "Central Lisu", "Yeh-Jeh", "Hwa Lisu (Flowery Lisu)", "Ninglang Lisu", "Northern Lisu", "Shibacha Lisu", "Hei Lisu (Black Lisu)", "Dechang Lisu", "Black Lisu", "Bai Lisu (White Lisu)", "Nujiang Lisu", "Hua Lisu (Flowery Lisu)"],
  cc: ["CN", "TH", "MM"]
}, {
  pk: 8077,
  ang: "Flowery Lisu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Hua Lisu",
  lc: "lis-x-hualisu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3470,
  ang: "Logorik",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Logorik",
  lc: "liu",
  ld: "ltr",
  alt: ["Tallau (Talau)", "Talo"],
  cc: ["SD"]
}, {
  pk: 3471,
  ang: "Liv",
  lr: "Europe",
  gw: false,
  hc: "LV",
  ln: "Liv",
  lc: "liv",
  ld: "ltr",
  alt: ["Liv\xF5 kel", "Livonian", "Eastern Livonian (Vidzeme)", "Raandalist", "Western Livonian (Kurzeme)"],
  cc: ["LV"]
}, {
  pk: 3472,
  ang: "Col",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Col",
  lc: "liw",
  ld: "ltr",
  alt: ["Cul", "Sindang", "Beliti; Lubuk Linggau", "Lembak Delapan"],
  cc: ["ID"]
}, {
  pk: 7540,
  ang: "Lembak Delapan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lembak Delapan",
  lc: "liw-x-lembak",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3473,
  ang: "Liabuku",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Liabuku",
  lc: "lix",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3474,
  ang: "Banda-Bambari",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Banda-Bambari",
  lc: "liy",
  ld: "ltr",
  alt: ["Banda of Bambari", "Banda-Linda", "Ngapo (Ngapu)", "Joto (Jeto)"],
  cc: ["CF"]
}, {
  pk: 3475,
  ang: "Libinza",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Libinza",
  lc: "liz",
  ld: "ltr",
  alt: ["Libinja"],
  cc: ["CD"]
}, {
  pk: 3476,
  ang: "Rampi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Rampi",
  lc: "lje",
  ld: "ltr",
  alt: ["Ha'uwa", "Leboni", "Rampi-Leboni", "Rampi (Lambu)"],
  cc: ["ID"]
}, {
  pk: 3477,
  ang: "Laiyolo",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Laiyolo",
  lc: "lji",
  ld: "ltr",
  alt: ["Da'ang", "Laiyolo (Lajolo)", "Layolo", "Loa'", "Lowa", "Barang-Barang (Loa)"],
  cc: ["ID"]
}, {
  pk: 3478,
  ang: "Li\u2019o",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Li'o",
  lc: "ljl",
  ld: "ltr",
  alt: ["Aku", "Lio", "Lionese", "Tanah Kunu"],
  cc: ["ID"]
}, {
  pk: 3479,
  ang: "Lampung Api",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lampung Api",
  lc: "ljp",
  ld: "ltr",
  alt: ["Api", "Lampong", "Lampung Pesisir", "Southern Pesisir", "Njo", "Western Lampung", "Daya", "Kru'i", "Krui (Kroe)"],
  cc: ["BN", "ID"]
}, {
  pk: 7976,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lampung Pesisir",
  lc: "ljp-x-lampungpesisir",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3480,
  ang: "Yirandali",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yirandali",
  lc: "ljw",
  ld: "ltr",
  alt: ["Dalebura", "Dal-leyburra", "Irendely", "Pooroga", "Yerrundulli", "Yerrunthully"],
  cc: ["AU"]
}, {
  pk: 3481,
  ang: "Lakalei",
  lr: "Asia",
  gw: false,
  hc: "TL",
  ln: "Lakalei",
  lc: "lka",
  ld: "ltr",
  alt: [],
  cc: ["TL"]
}, {
  pk: 3482,
  ang: "Lukabaras",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Kabras",
  lc: "lkb",
  ld: "ltr",
  alt: ["Kabras"],
  cc: ["KE"]
}, {
  pk: 3483,
  ang: "Kucong",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Kucong",
  lc: "lkc",
  ld: "ltr",
  alt: ["Cosung", "Lahlu"],
  cc: ["CN", "VN"]
}, {
  pk: 3484,
  ang: "Lakond\xEA",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Lakond\xEA",
  lc: "lkd",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 3485,
  ang: "Kenye",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Kenyi",
  lc: "lke",
  ld: "ltr",
  alt: ["Lukenhe", "Lukenye", "Lukenyi", "Lukenye-Lukooli", "Lukenye-Ludebede"],
  cc: ["UG"]
}, {
  pk: 3486,
  ang: "Lakha",
  lr: "Asia",
  gw: false,
  hc: "BT",
  ln: "Lakha",
  lc: "lkh",
  ld: "ltr",
  alt: ["Tshangkha"],
  cc: ["BT"]
}, {
  pk: 3487,
  ang: "Laki",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u0644\u06D5\u06A9\u06CC",
  lc: "lki",
  ld: "rtl",
  alt: ["Alaki"],
  cc: ["IR", "IQ"]
}, {
  pk: 3488,
  ang: "Remun",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Remun",
  lc: "lkj",
  ld: "ltr",
  alt: ["Millikin"],
  cc: ["MY"]
}, {
  pk: 3489,
  ang: "Laeko-Libuat",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Laeko-Libuat",
  lc: "lkl",
  ld: "ltr",
  alt: ["Laeko", "Laeko-Limbuat"],
  cc: ["PG"]
}, {
  pk: 3490,
  ang: "Lakon",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Lakon",
  lc: "lkn",
  ld: "ltr",
  alt: ["Lakona Bay", "West Gaua", "Qatareu", "Togla", "Vure"],
  cc: ["VU"]
}, {
  pk: 3491,
  ang: "Olukhayo",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Khayo",
  lc: "lko",
  ld: "ltr",
  alt: ["Khayo", "Xaayo"],
  cc: ["KE"]
}, {
  pk: 3492,
  ang: "P\xE4ri",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "P\xE4ri",
  lc: "lkr",
  ld: "ltr",
  alt: ["Lokoro"],
  cc: ["SS"]
}, {
  pk: 3493,
  ang: "Olushisa",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Kisa",
  lc: "lks",
  ld: "ltr",
  alt: ["Kisa"],
  cc: ["KE"]
}, {
  pk: 3494,
  ang: "Lakota",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Lakota",
  lc: "lkt",
  ld: "ltr",
  alt: ["Lakhota", "Teton", "Lakotiyapi", "Brul\xE9"],
  cc: ["US", "CA"]
}, {
  pk: 3495,
  ang: "Lokoya",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Lokoya",
  lc: "lky",
  ld: "ltr",
  alt: ["Ellyria", "Koyo", "Loirya", "Lokoiya", "Lokoja", "Loquia", "Lowoi", "Oirya", "Owoi", "Oxoriok"],
  cc: ["SS"]
}, {
  pk: 3496,
  ang: "Lala-Roba",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Lala-Roba",
  lc: "lla",
  ld: "ltr",
  alt: ["Gworam", "Lala (Lalla)", "Roba (Robba)"],
  cc: ["NG"]
}, {
  pk: 3497,
  ang: "Lolo",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Lolo",
  lc: "llb",
  ld: "ltr",
  alt: ["Ilolo"],
  cc: ["MZ"]
}, {
  pk: 3498,
  ang: "Lele",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Lele (Guinea)",
  lc: "llc",
  ld: "ltr",
  alt: ["Kassadou Lele (South Lele)", "Kounte Lele (Central Lele)", "Tangalto Lele (East Lele)", "Yombiro Lele (North Lele)"],
  cc: ["GN"]
}, {
  pk: 3499,
  ang: "Ladin",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Ladin",
  lc: "lld",
  ld: "ltr",
  alt: ["Dolomite", "Rhaeto-Romance", "Nonese", "Badiotto (Gadertalisch)", "Parlata Trentina", "Nonesh", "Nones (Nones Blot)", "Marebbano (Ennebergisch)", "Gardenese (Gr\xF6dnerisch)", "Gr\xFCdno"],
  cc: ["IT"]
}, {
  pk: 3500,
  ang: "Lele",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Lele (Papua New Guinea)",
  lc: "lle",
  ld: "ltr",
  alt: ["Elu-Kara", "Hai", "Lele Hai", "Manus", "Moanus", "Usiai"],
  cc: ["PG"]
}, {
  pk: 3501,
  ang: "Lole",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lole",
  lc: "llg",
  ld: "ltr",
  alt: ["Ba'a", "Ba\xE4", "Central Rote", "Loleh", "Rote", "Rote Tengah", "Roti", "Rotinese", "North Lole", "South Lole"],
  cc: ["ID"]
}, {
  pk: 3502,
  ang: "Lamu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Lamu",
  lc: "llh",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 3503,
  ang: "Teke-Laali",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Teke-Laali",
  lc: "lli",
  ld: "ltr",
  alt: ["Ilaali"],
  cc: ["CG"]
}, {
  pk: 3504,
  ang: "Lilau",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Lilau",
  lc: "lll",
  ld: "ltr",
  alt: ["Ngaimbom"],
  cc: ["PG"]
}, {
  pk: 3505,
  ang: "Lasalimu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lasalimu",
  lc: "llm",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3506,
  ang: "Lele",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Lele (Chad)",
  lc: "lln",
  ld: "ltr",
  alt: [],
  cc: ["TD"]
}, {
  pk: 3507,
  ang: "Khlor",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Khlor",
  lc: "llo",
  ld: "ltr",
  alt: ["Klor", "Lor"],
  cc: ["LA"]
}, {
  pk: 3508,
  ang: "Efate, North",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "North Efate",
  lc: "llp",
  ld: "ltr",
  alt: ["Nakanamanga", "Nguna (Guna)", "Ngunese", "Tongoa"],
  cc: ["VU"]
}, {
  pk: 3509,
  ang: "Lolak",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lolak",
  lc: "llq",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3510,
  ang: "Lithuanian Sign Language",
  lr: "Europe",
  gw: false,
  hc: "LT",
  ln: "Lithuanian Sign Language",
  lc: "lls",
  ld: "ltr",
  alt: [],
  cc: ["LT"]
}, {
  pk: 3511,
  ang: "Lau",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Lau",
  lc: "llu",
  ld: "ltr",
  alt: ["Dai (Ndai)"],
  cc: ["SB"]
}, {
  pk: 3512,
  ang: "Lauan",
  lr: "Pacific",
  gw: false,
  hc: "FJ",
  ln: "Lauan",
  lc: "llx",
  ld: "ltr",
  alt: [],
  cc: ["FJ"]
}, {
  pk: 3513,
  ang: "Limba, East",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "East Limba",
  lc: "lma",
  ld: "ltr",
  alt: ["Yimba", "Yumba", "Warawara", "Southern Limba (Biriwa-Saroko-Kalantuba-Sunko)", "Northern Limba (Ke-Woya-Yaka)"],
  cc: ["GN", "SL"]
}, {
  pk: 3514,
  ang: "Merei",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Merei",
  lc: "lmb",
  ld: "ltr",
  alt: ["Lametin"],
  cc: ["VU"]
}, {
  pk: 3515,
  ang: "Lumun",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Lumun",
  lc: "lmd",
  ld: "ltr",
  alt: ["Kuku-Lumun", "Lomon"],
  cc: ["SD"]
}, {
  pk: 3516,
  ang: "P\xE9v\xE9",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "P\xE9v\xE9",
  lc: "lme",
  ld: "ltr",
  alt: ["Ka'do", "Lam\xE9", "Ka'do Pev\xE9", "Zime", "Kado", "Doe (Dou\xE9)"],
  cc: ["CM", "TD"]
}, {
  pk: 3517,
  ang: "Lembata, South",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "South Lembata",
  lc: "lmf",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3518,
  ang: "Lamogai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Lamogai",
  lc: "lmg",
  ld: "ltr",
  alt: ["Akiuru", "Mulakaino", "Ibanga (Ivanga)", "Pulie-Rauto (Rauto)", "Roto"],
  cc: ["PG"]
}, {
  pk: 3519,
  ang: "Mugali",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Lambichhong",
  lc: "lmh",
  ld: "ltr",
  alt: ["Lambicchong", "Lambichong", "Lambitshong", "Phangduwali Mugali", "Phangdhuwali"],
  cc: ["NP"]
}, {
  pk: 3520,
  ang: "Lombi",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lombi",
  lc: "lmi",
  ld: "ltr",
  alt: ["Lumbi", "Odyalombito", "Rombi", "Rumli"],
  cc: ["CD"]
}, {
  pk: 3521,
  ang: "Lembata, West",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "West Lembata",
  lc: "lmj",
  ld: "ltr",
  alt: ["Labalekan", "Mingar"],
  cc: ["ID"]
}, {
  pk: 3522,
  ang: "Lamkang",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Lamkang",
  lc: "lmk",
  ld: "ltr",
  alt: ["Lamkaang", "Hiroi-Lamgang", "Lamgang"],
  cc: ["IN"]
}, {
  pk: 3523,
  ang: "Hano",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Hano",
  lc: "lml",
  ld: "ltr",
  alt: ["Bwatvenua", "Lamalanga", "North Raga", "Qatvenua", "Raga", "Vunmarama", "Nggasai (Kasai)"],
  cc: ["VU"]
}, {
  pk: 3524,
  ang: "Lambadi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Lambadi",
  lc: "lmn",
  ld: "ltr",
  alt: ["Bangala", "Banjara", "Banjori", "Banjuri", "Brinjari", "Gohar-Herkeri", "Goola", "Gormati", "Gurmarti", "Kora", "Labhani", "Labhani Muka", "Lamadi", "Lamani", "Lambani", "Lambara", "Lavani", "Lemadi", "Lumadale", "Singali", "Sugali", "Sukali", "Tanda", "Vanjari", "Wanji", "Andhra Pradesh Lamani (Telugu Lamani)", "Karnataka Lamani (Mysore Lamani)"],
  cc: ["IN"]
}, {
  pk: 8396,
  ang: "Anjara",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Anjara",
  lc: "lmn-x-anjara",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3525,
  ang: "Lombard",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Lombard",
  lc: "lmo",
  ld: "ltr",
  alt: ["Lombardo", "Ticinese (Tessinian)", "Western Lombard (Nicosia)", "Ticinese (Ticino)", "Ticines", "San Fratello", "Piazza Armerina", "Novara", "Ticinees", "Ticino"],
  cc: ["CH", "IT"]
}, {
  pk: 3526,
  ang: "Limbum",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Limbum",
  lc: "lmp",
  ld: "ltr",
  alt: ["Bojiin", "Limbom", "Llimbumi", "Ndzungle", "Ndzungli", "Njungene", "Nsungali", "Nsungli", "Nsungni", "Wimbum"],
  cc: ["CM"]
}, {
  pk: 3527,
  ang: "Lamatuka",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lamatuka",
  lc: "lmq",
  ld: "ltr",
  alt: ["Lamatoka"],
  cc: ["ID"]
}, {
  pk: 3528,
  ang: "Lamalera",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lamalera",
  lc: "lmr",
  ld: "ltr",
  alt: ["Kawela", "Lebatukan", "Mulan"],
  cc: ["ID"]
}, {
  pk: 3529,
  ang: "Lamenu",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Lamenu",
  lc: "lmu",
  ld: "ltr",
  alt: ["Lamen", "Lewo", "Varmali", "Galokumali", "Galoparua"],
  cc: ["VU"]
}, {
  pk: 3530,
  ang: "Lomaiviti",
  lr: "Pacific",
  gw: false,
  hc: "FJ",
  ln: "Lomaiviti",
  lc: "lmv",
  ld: "ltr",
  alt: [],
  cc: ["FJ"]
}, {
  pk: 3531,
  ang: "Miwok, Lake",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Lake Miwok",
  lc: "lmw",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 3532,
  ang: "Laimbue",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Laimbue",
  lc: "lmx",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 3533,
  ang: "Lamboya",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lamboya",
  lc: "lmy",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3534,
  ang: "Lumbee",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Lumbee",
  lc: "lmz",
  ld: "ltr",
  alt: ["Croatan"],
  cc: ["US"]
}, {
  pk: 3535,
  ang: "Lingala",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ling\xE1la",
  lc: "ln",
  ld: "ltr",
  alt: ["Ngala"],
  cc: ["BE", "CF", "SS", "US", "CG", "CD", "CA", "AO", "UG"]
}, {
  pk: 3536,
  ang: "Langbashe",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Langbashe",
  lc: "lna",
  ld: "ltr",
  alt: ["Langbase", "Langbashi", "Langbwasse", "Langwasi"],
  cc: ["CF"]
}, {
  pk: 3537,
  ang: "Mbalanhu",
  lr: "Africa",
  gw: false,
  hc: "NA",
  ln: "Mbalanhu",
  lc: "lnb",
  ld: "ltr",
  alt: ["Mbaanhu", "Mbalantu", "Mbaluntu"],
  cc: ["NA"]
}, {
  pk: 3538,
  ang: "Lun Bawang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lundayeh",
  lc: "lnd",
  ld: "ltr",
  alt: ["Lun Daya", "Lun Dayoh", "Lundaya", "Southern Murut", "Lundaya Putuk", "Lundayeh", "Lun Dayeh", "Lun Lod", "Lun-Bawang", "Lun Ba", "Trusan (Lawas)", "Sarawak Murut", "Lun Bawang (Long Bawan)", "Limbang", "Lun Bawang (Sarawak Murut)"],
  cc: ["ID", "MY"]
}, {
  pk: 8112,
  ang: "Dayak Tabun",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Tabun",
  lc: "lnd-x-dayaktabun",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3539,
  ang: "Langobardic",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Langobardic",
  lc: "lng",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 3540,
  ang: "Lanoh",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Lanoh",
  lc: "lnh",
  ld: "ltr",
  alt: ["Jengjeng"],
  cc: ["MY"]
}, {
  pk: 3541,
  ang: "Daantanai\u2019",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Daantanai'",
  lc: "lni",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3542,
  ang: "Banda, South Central",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "South Central Banda",
  lc: "lnl",
  ld: "ltr",
  alt: ["Ngubu", "Langba (Lagba)", "Ngbugu (Ngbougou)"],
  cc: ["CF"]
}, {
  pk: 3543,
  ang: "Langam",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Langam",
  lc: "lnm",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3544,
  ang: "Lorediakarkar",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Lorediakarkar",
  lc: "lnn",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 3545,
  ang: "Lango",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Lango (Sudan)",
  lc: "lno",
  ld: "ltr",
  alt: ["Madial Lorwama (Okolie)", "Lokwaa", "Ketebo", "Logire (Imotong)", "Logir"],
  cc: ["SS"]
}, {
  pk: 3546,
  ang: "Lamnso\u2019",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Lamnso'",
  lc: "lns",
  ld: "ltr",
  alt: ["Bansaw", "Banso", "Banso'", "Lamnsok", "Lamso", "Nsaw", "Nsho'", "Nso", "Nso'", "Panso"],
  cc: ["CM", "NG"]
}, {
  pk: 3547,
  ang: "Longuda",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Longuda",
  lc: "lnu",
  ld: "ltr",
  alt: ["Languda", "Longura", "Nunguda", "Nungura", "Nunguraba", "Plain", "Turuba", "Nya Tariya (Taraba)", "Nya Gwanda (Gwandaba)", "Nya Guyuwa (Guyuk)", "Nya Dele (Jessu)", "Nya Ceriya (Banjiram)", "Cirimba"],
  cc: ["NG"]
}, {
  pk: 3548,
  ang: "Lonzo",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lonzo",
  lc: "lnz",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 7798,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kilonzo",
  lc: "lnz-x-kilonzo",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 3549,
  ang: "Laotian",
  lr: "Asia",
  gw: true,
  hc: "LA",
  ln: "\u0E9E\u0EB2\u0EAA\u0EB2\u0EA5\u0EB2\u0EA7",
  lc: "lo",
  ld: "ltr",
  alt: ["Eastern Thai", "L\xE0o", "Lao Kao", "Lao Wiang", "Lao-Lum", "Lao-Noi", "Lao-Tai", "Laotian", "Laotian Tai", "Lum Lao", "Phou Lao", "Rong Kong", "Tai Lao", "Savannakhet (Suwannakhet)", "Vientiane (Wiang Jan)"],
  cc: ["AR", "FR", "LA", "US", "KH", "CA", "MM"]
}, {
  pk: 3550,
  ang: "Loloda",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Loloda",
  lc: "loa",
  ld: "ltr",
  alt: ["Loda", "North Loloda"],
  cc: ["ID"]
}, {
  pk: 3551,
  ang: "Lobi",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Lobi",
  lc: "lob",
  ld: "ltr",
  alt: ["Lobiri", "Miwa"],
  cc: ["BF", "GH"]
}, {
  pk: 3552,
  ang: "Inonhan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Inonhan",
  lc: "loc",
  ld: "ltr",
  alt: ["Loocnon", "Unhan"],
  cc: ["PH"]
}, {
  pk: 3553,
  ang: "Saluan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Saluan",
  lc: "loe",
  ld: "ltr",
  alt: ["Loinang", "Loindang", "Madi", "Mondono", "Luwuk", "Kohumama'", "Lingketeng", "Loinang (Baloa')", "Kintom-Pagimana-Boalemo"],
  cc: ["ID"]
}, {
  pk: 3554,
  ang: "Logol",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Logol",
  lc: "lof",
  ld: "ltr",
  alt: ["Lukha"],
  cc: ["SD"]
}, {
  pk: 3555,
  ang: "Logo",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Logo",
  lc: "log",
  ld: "ltr",
  alt: ["Logoti", "Obileba", "Ogambi (Northern Logo)", "Ogamaru", "Obilebha (Obelebha)", "Lolya", "Bhagira (Bagela)", "Bari (Bari-Logo)", "Bariti"],
  cc: ["SS", "CD"]
}, {
  pk: 3556,
  ang: "Narim",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Narim",
  lc: "loh",
  ld: "ltr",
  alt: ["Lariim", "Larim", "Lariminit", "Larimo", "Longarim", "Nariim"],
  cc: ["SS"]
}, {
  pk: 3557,
  ang: "Loma",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Loma (C\xF4te d'Ivoire)",
  lc: "loi",
  ld: "ltr",
  alt: ["Lomakka", "Lomapo", "Lomasse", "Malinke"],
  cc: ["CI"]
}, {
  pk: 3558,
  ang: "Lou",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Lou",
  lc: "loj",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3559,
  ang: "Loko",
  lr: "Africa",
  gw: false,
  hc: "SL",
  ln: "Loko",
  lc: "lok",
  ld: "ltr",
  alt: ["Landogo"],
  cc: ["GN", "SL"]
}, {
  pk: 3560,
  ang: "Mongo-Nkundu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Mongo-Lotwa",
  lc: "lol",
  ld: "ltr",
  alt: ["Lomongo", "Mongo", "Lokwala", "Titu", "South Nkundo", "Panga (Buli)", "Nkundu", "Nkundo (Lolo)", "Lonkundu", "Yalima (Y)", "Lokonda", "Kutu (Bakutu)", "Konda (Ekonda)", "Ipanga", "Ekonda Mongo (Lomongo)", "Bukala (Kala)", "Lonkundo", "Longo (Bolongo)"],
  cc: ["CD"]
}, {
  pk: 7731,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Besongo",
  lc: "lol-x-besongo",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 7741,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bilangi",
  lc: "lol-x-bilangi",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 7739,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Boangi",
  lc: "lol-x-boangi",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 7737,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bokatola",
  lc: "lol-x-bokatola",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 7921,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Booli",
  lc: "lol-x-booli",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7922,
  ang: "Bukala",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bukala",
  lc: "lol-x-bukala",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7923,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Emoma",
  lc: "lol-x-emoma",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7924,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ikongo",
  lc: "lol-x-ikongo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7925,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Iyembe",
  lc: "lol-x-iyembe",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7732,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Langondjo",
  lc: "lol-x-langondjo",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 7926,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lionje",
  lc: "lol-x-lionje",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7738,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lokatola de Duali",
  lc: "lol-x-lokatoladeduali",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 7652,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lokonda",
  lc: "lol-x-lokonda",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 7736,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lokolnua",
  lc: "lol-x-lokulnua",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 7735,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Londjolo",
  lc: "lol-x-londjolo",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 7927,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Longo",
  lc: "lol-x-longo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7928,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Longombe",
  lc: "lol-x-longombe",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7734,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lontomba",
  lc: "lol-x-lontomba",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 7733,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Losanga",
  lc: "lol-x-losanga",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 7653,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lotswa North",
  lc: "lol-x-lotswano",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7654,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lotswa South",
  lc: "lol-x-lotswaso",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7740,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lotunube",
  lc: "lol-x-lotunube",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 7564,
  ang: "Mongo-Lotwa North",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Mongo-Lotwa North",
  lc: "lol-x-lotwanor",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 7563,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Mongo-Lotwa South",
  lc: "lol-x-lotwasou",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 7742,
  ang: "Loubala",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Loubala",
  lc: "lol-x-loubala",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 3561,
  ang: "Loma",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Loma (Liberia)",
  lc: "lom",
  ld: "ltr",
  alt: ["Loghoma", "Looma", "Lorma", "Toa", "Bouze", "Busy", "Buzi", "Briama (Bulima)", "Buluiema", "Bulyama", "Gbunde (Bonde)", "Wubomai (Wubomei)", "Ziema (Siama)"],
  cc: ["LR"]
}, {
  pk: 3562,
  ang: "Lomwe, Malawi",
  lr: "Africa",
  gw: false,
  hc: "MW",
  ln: "Malawi Lomwe",
  lc: "lon",
  ld: "ltr",
  alt: ["Anguru", "Elhomwe", "Nguru", "Mihavane", "Muhavani"],
  cc: ["MW"]
}, {
  pk: 3563,
  ang: "Lombo",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lombo",
  lc: "loo",
  ld: "ltr",
  alt: ["Olombo", "Turumbu", "Ulumbu"],
  cc: ["CD"]
}, {
  pk: 3564,
  ang: "Lopa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Lopa",
  lc: "lop",
  ld: "ltr",
  alt: ["Djiri", "Kirikjir", "Lupa", "Ollaran", "Urcibar", "Ollop"],
  cc: ["NG"]
}, {
  pk: 3565,
  ang: "Lobala",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lobala",
  lc: "loq",
  ld: "ltr",
  alt: ["Likoka"],
  cc: ["CG", "CD"]
}, {
  pk: 7942,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Likoka",
  lc: "loq-x-likoka",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7943,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lokoka",
  lc: "loq-x-lokoka",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3566,
  ang: "T\xE9\xE9n",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "T\xE9\xE9n",
  lc: "lor",
  ld: "ltr",
  alt: ["Loghon", "Lorhon", "Nabe", "Tegesie", "T\xE9nh\xE9"],
  cc: ["BF", "CI"]
}, {
  pk: 3567,
  ang: "Loniu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Loniu",
  lc: "los",
  ld: "ltr",
  alt: ["Lonio", "Ndroku"],
  cc: ["PG"]
}, {
  pk: 3568,
  ang: "Otuho",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Otuho",
  lc: "lot",
  ld: "ltr",
  alt: ["Latooka", "Lattuka", "Latuko", "Lotuho", "Lotuka", "Lotuko", "Lotuxo", "Olotorit", "Otuxo", "Lowudo (Lauda)", "Logiri (Logir)", "Lomya (Lomia)", "Loudo"],
  cc: ["SS"]
}, {
  pk: 3569,
  ang: "Louisiana Creole",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Louisiana Creole French",
  lc: "lou",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 3570,
  ang: "Lopi",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6C34\u7530",
  lc: "lov",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 3571,
  ang: "Lobu, Tampias",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Tampias Lobu",
  lc: "low",
  ld: "ltr",
  alt: [],
  cc: ["MY"]
}, {
  pk: 3572,
  ang: "Lhowa",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u0932\u094D\u0939\u094B\u0935\u093E",
  lc: "loy",
  ld: "ltr",
  alt: ["Glo Skad", "Lhopa", "Lo Montang", "Loba", "Lopa", "Lowa", "Loyu", "Mustangi", "Upper Mustang (Loke)", "Bhoti Gurung", "Baragaun", "Baragaunle (Baragaon)"],
  cc: ["NP"]
}, {
  pk: 3573,
  ang: "Lozi",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Lozi",
  lc: "loz",
  ld: "ltr",
  alt: ["Kololo", "Rotse", "Rozi", "Rutse", "Tozvi", "Rotvi"],
  cc: ["ZM", "ZW", "AO", "BW", "NA"]
}, {
  pk: 3574,
  ang: "Lelepa",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Lelepa",
  lc: "lpa",
  ld: "ltr",
  alt: ["Havannah Harbour"],
  cc: ["VU"]
}, {
  pk: 3575,
  ang: "Lepki",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lepki",
  lc: "lpe",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3576,
  ang: "Naga, Long Phuri",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Long Phuri Naga",
  lc: "lpn",
  ld: "ltr",
  alt: ["Amimi Naga", "Longpfuri", "Longpfuru", "Mimi"],
  cc: ["MM"]
}, {
  pk: 3577,
  ang: "Lipo",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u91CC\u6CFC",
  lc: "lpo",
  ld: "ltr",
  alt: ["Central Lisu", "Eastern Lisu", "Lolongo", "Eastern Lipo", "Western Lipo"],
  cc: ["CN"]
}, {
  pk: 3578,
  ang: "Lopit",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Lopit",
  lc: "lpx",
  ld: "ltr",
  alt: ["Lafiit", "Lafit", "Lafite", "Lofit", "Lopid", "Loppit", "Lolongo", "Logonowati", "Iboni", "Mura"],
  cc: ["SS"]
}, {
  pk: 3579,
  ang: "Bakati\u2019, Rara",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Rara Bakati'",
  lc: "lra",
  ld: "ltr",
  alt: ["Bekati' Kendayan", "Bekati' Nyam-Pelayo", "Bekatiq", "Lara'", "Luru", "Bina'e"],
  cc: ["ID", "MY"]
}, {
  pk: 8085,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Suruh",
  lc: "lra-x-dayaksuruh",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3580,
  ang: "Luri, Northern",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u0644\u064F\u0631\u06CC",
  lc: "lrc",
  ld: "rtl",
  alt: ["Luristani", "Khorramabadi", "Mahali (Rural)", "Cagani", "Borujerdi", "Bala-Gariva'i", "Andimeshki", "Nahavandi"],
  cc: ["IR"]
}, {
  pk: 3581,
  ang: "Laurentian",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Laurentian",
  lc: "lre",
  ld: "ltr",
  alt: [],
  cc: ["CA"]
}, {
  pk: 3582,
  ang: "Laragia",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Laragia",
  lc: "lrg",
  ld: "ltr",
  alt: ["Gulumirrgin", "Laragiya", "Larakia", "Larakiya"],
  cc: ["AU"]
}, {
  pk: 3583,
  ang: "Olumarachi",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Marachi",
  lc: "lri",
  ld: "ltr",
  alt: [],
  cc: ["KE"]
}, {
  pk: 3584,
  ang: "Loarki",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "Loarki",
  lc: "lrk",
  ld: "ltr",
  alt: [],
  cc: ["PK"]
}, {
  pk: 3585,
  ang: "Lari",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u0627\u0686\u0645\u06CC",
  lc: "lrl",
  ld: "rtl",
  alt: ["Larestani"],
  cc: ["IR"]
}, {
  pk: 3586,
  ang: "Olumarama",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Marama",
  lc: "lrm",
  ld: "ltr",
  alt: [],
  cc: ["KE"]
}, {
  pk: 3587,
  ang: "Lorang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lorang",
  lc: "lrn",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3588,
  ang: "Laro",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Laro",
  lc: "lro",
  ld: "ltr",
  alt: ["Laru", "Leera", "Liira", "Ngwullaro", "Yillaro", "Yidundili-Yigoromany", "Yilaru"],
  cc: ["SD"]
}, {
  pk: 3589,
  ang: "Yamphu, Southern",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Southern Yamphu",
  lc: "lrr",
  ld: "ltr",
  alt: ["Lohorong", "Lohrung", "Lohrung Khap", "Lohrung Khate", "Southern Lohorung", "Southern Lorung", "Yakkhaba Lorung", "Yamphu", "Yamphe Kha", "Gessa", "Yakkhaba", "Yakkhaba Khap", "Yamphe (Newahang Yamphe)"],
  cc: ["NP"]
}, {
  pk: 3590,
  ang: "Malay, Larantuka",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Larantuka Malay",
  lc: "lrt",
  ld: "ltr",
  alt: ["Bahasa Nagi", "Ende Malay", "Melayu Larantuka", "Nagi"],
  cc: ["ID"]
}, {
  pk: 3591,
  ang: "Larevat",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Larevat",
  lc: "lrv",
  ld: "ltr",
  alt: ["Laravat"],
  cc: ["VU"]
}, {
  pk: 3592,
  ang: "Lemerig",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Lemerig",
  lc: "lrz",
  ld: "ltr",
  alt: ["Bek", "Leon", "P\xE4k", "Sasar"],
  cc: ["VU"]
}, {
  pk: 3593,
  ang: "Lasgerdi",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Lasgerdi",
  lc: "lsa",
  ld: "ltr",
  alt: ["L\xE4sgerdi", "Lasjerdi", "L\xE4sjerdi"],
  cc: ["IR"]
}, {
  pk: 3594,
  ang: "Lishana Deni",
  lr: "Asia",
  gw: false,
  hc: "IL",
  ln: "\u05DC\u05E9\u05E0\u05D0 \u05D3\u05E0\u05D9",
  lc: "lsd",
  ld: "rtl",
  alt: ["Judeo-Aramaic", "Kurdit", "Lishan Hozaye", "Lishan Hudaye", "Shukho", "Barashe"],
  cc: ["IL"]
}, {
  pk: 3595,
  ang: "Lusengo",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lusengo",
  lc: "lse",
  ld: "ltr",
  alt: ["Losengo", "Loleko", "Eleku", "Iliku (Eleko)", "Kele", "Leko", "Leku", "Lipoto (Ingundji)"],
  cc: ["CD"]
}, {
  pk: 3596,
  ang: "Lyons Sign Language",
  lr: "Europe",
  gw: false,
  hc: "FR",
  ln: "Lyons Sign Language",
  lc: "lsg",
  ld: "ltr",
  alt: [],
  cc: ["FR"]
}, {
  pk: 3597,
  ang: "Lish",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Lish",
  lc: "lsh",
  ld: "ltr",
  alt: ["Lish Monpa", "Lishpa", "Monpa"],
  cc: ["IN"]
}, {
  pk: 3598,
  ang: "Lashi",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Lashi",
  lc: "lsi",
  ld: "ltr",
  alt: ["Acye", "Chashanhua", "Lachikwaw", "Laji", "Laqi", "Lasi", "Leqi", "Leshi", "Letsi", "Ac'ye", "Chashan", "Lacid", "Lacik", "Lashi-Maru", "Lechi"],
  cc: ["CN", "MM"]
}, {
  pk: 3599,
  ang: "Latvian Sign Language",
  lr: "Europe",
  gw: false,
  hc: "LV",
  ln: "Latvian Sign Language",
  lc: "lsl",
  ld: "ltr",
  alt: [],
  cc: ["LV"]
}, {
  pk: 3600,
  ang: "Saamia",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Saamia",
  lc: "lsm",
  ld: "ltr",
  alt: ["Bagwe", "Bassamia", "Gwe (Lugwe)", "Saamia (Samia)"],
  cc: ["UG"]
}, {
  pk: 3601,
  ang: "Laos Sign Language",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Laos Sign Language",
  lc: "lso",
  ld: "ltr",
  alt: [],
  cc: ["LA"]
}, {
  pk: 3602,
  ang: "Panamanian Sign Language",
  lr: "Americas",
  gw: false,
  hc: "PA",
  ln: "Panamanian Sign Language",
  lc: "lsp",
  ld: "ltr",
  alt: ["Lengua de se\xF1as paname\xF1as"],
  cc: ["PA"]
}, {
  pk: 3603,
  ang: "Aruop",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Aruop",
  lc: "lsr",
  ld: "ltr",
  alt: ["Lauisaranga", "Lau'u"],
  cc: ["PG"]
}, {
  pk: 3604,
  ang: "Lasi",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "Lasi",
  lc: "lss",
  ld: "ltr",
  alt: ["Lassi"],
  cc: ["PK"]
}, {
  pk: 3605,
  ang: "Trinidad and Tobago Sign Language",
  lr: "Americas",
  gw: false,
  hc: "TT",
  ln: "Trinidad and Tobago Sign Language",
  lc: "lst",
  ld: "ltr",
  alt: ["Trinidad Sign Language", "TSL", "TTSL"],
  cc: ["TT"]
}, {
  pk: 3606,
  ang: "Mauritian Sign Language",
  lr: "Africa",
  gw: false,
  hc: "MU",
  ln: "Mauritian Sign Language",
  lc: "lsy",
  ld: "ltr",
  alt: [],
  cc: ["MU"]
}, {
  pk: 3607,
  ang: "Lithuanian",
  lr: "Europe",
  gw: false,
  hc: "LT",
  ln: "lietuvi\u0173 kalba",
  lc: "lt",
  ld: "ltr",
  alt: ["Lietuvi", "Lietuviskai", "Litauische", "Litewski", "Litovskiy", "Aukstaitiskai", "Zhemaitish", "Zemaitiskai", "Zemaitis", "Zemachiai", "Shamaitish (Lowland Lithuanian)", "Samogitian", "Dzukish (Dzukiskai)", "Aukshtaitish (Aukshtaichiai)", "Highland Lithuanian"],
  cc: ["DE", "KZ", "LV", "PL", "US", "CA", "LT", "UZ"]
}, {
  pk: 3608,
  ang: "Late Middle Chinese",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Late Middle Chinese",
  lc: "ltc",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 3609,
  ang: "Latgalian",
  lr: "Europe",
  gw: false,
  hc: "LV",
  ln: "Latgalian",
  lc: "ltg",
  ld: "ltr",
  alt: ["Latgalie\u0161u", "High Latvian"],
  cc: ["LV"]
}, {
  pk: 3610,
  ang: "Leti",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Leti (Indonesia)",
  lc: "lti",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3611,
  ang: "Latund\xEA",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Latund\xEA",
  lc: "ltn",
  ld: "ltr",
  alt: ["Leitodu"],
  cc: ["BR"]
}, {
  pk: 3612,
  ang: "Olutsotso",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Tsotso",
  lc: "lto",
  ld: "ltr",
  alt: ["Tsotso"],
  cc: ["KE"]
}, {
  pk: 3613,
  ang: "Lutachoni",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Tachoni",
  lc: "lts",
  ld: "ltr",
  alt: ["Tachoni", "Tatsoni"],
  cc: ["KE"]
}, {
  pk: 3614,
  ang: "Latu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Latu",
  lc: "ltu",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3615,
  ang: "Luba-Katanga",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Tshiluba",
  lc: "lu",
  ld: "ltr",
  alt: ["Kiluba", "Luba-Shaba"],
  cc: ["CD"]
}, {
  pk: 3616,
  ang: "Luba-Kasai",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Luba-Lulua",
  lc: "lua",
  ld: "ltr",
  alt: ["Luba-Lulua", "Luva", "Tshiluba", "Western Luba"],
  cc: ["US", "CD"]
}, {
  pk: 3617,
  ang: "Aringa",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Aringa",
  lc: "luc",
  ld: "ltr",
  alt: ["Low Lugbara"],
  cc: ["SS", "UG"]
}, {
  pk: 3618,
  ang: "Ludian",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041B\u044E\u0434\u0438\u043A\u043E\u0432\u0441\u043A\u043E\u0435 \u043D\u0430\u0440\u0435\u0447\u0438\u0435",
  lc: "lud",
  ld: "ltr",
  alt: ["Ludic", "L\xFC\xFCdi", "L\xFC\xFCdikiel", "Lyudic", "Lyudikovian"],
  cc: ["RU"]
}, {
  pk: 3619,
  ang: "Luvale",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Luvale",
  lc: "lue",
  ld: "ltr",
  alt: ["Chiluvale", "Lovale", "Lubale", "Luena", "Lwena"],
  cc: ["ZM", "AO"]
}, {
  pk: 3620,
  ang: "Luise\xF1o",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Luiseno",
  lc: "lui",
  ld: "ltr",
  alt: ["Ajachemem", "Luise\xF1o", "Juane\xF1o (Acgachemem)", "Agachemem", "Ajachema"],
  cc: ["US"]
}, {
  pk: 3621,
  ang: "Luna",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Luna",
  lc: "luj",
  ld: "ltr",
  alt: ["Inkongo", "Kuba", "Northern Luba"],
  cc: ["CD"]
}, {
  pk: 3622,
  ang: "Lunanakha",
  lr: "Asia",
  gw: false,
  hc: "BT",
  ln: "Lunanakha",
  lc: "luk",
  ld: "ltr",
  alt: [],
  cc: ["BT"]
}, {
  pk: 3623,
  ang: "Olu\u2019bo",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Olu'bo",
  lc: "lul",
  ld: "ltr",
  alt: ["Lolubo", "Luluba", "Lulubo", "Olubogo", "Oluboti", "Ondoe"],
  cc: ["SS", "SB", "UG"]
}, {
  pk: 3624,
  ang: "Luimbi",
  lr: "Africa",
  gw: false,
  hc: "AO",
  ln: "Luimbi",
  lc: "lum",
  ld: "ltr",
  alt: ["Chiluimbi", "Luimbe", "Lwimbe", "Lwimbi"],
  cc: ["AO"]
}, {
  pk: 3625,
  ang: "Lunda",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Lunda",
  lc: "lun",
  ld: "ltr",
  alt: ["Chilunda", "Ruund", "Kosa (Koosa)", "Lunda Ndembu"],
  cc: ["ZM", "AO"]
}, {
  pk: 3626,
  ang: "Dholuo",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Luo (Kenya and Tanzania)",
  lc: "luo",
  ld: "ltr",
  alt: ["Kavirondo Luo", "Nilotic Kavirondo", "Kavirondo", "Kidjaluo"],
  cc: ["KE", "TZ", "US"]
}, {
  pk: 3627,
  ang: "Lumbu",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Lumbu",
  lc: "lup",
  ld: "ltr",
  alt: ["Ilumbu", "Baloumbou"],
  cc: ["GA", "CG"]
}, {
  pk: 3628,
  ang: "Lucumi",
  lr: "Americas",
  gw: false,
  hc: "CU",
  ln: "Lucumi",
  lc: "luq",
  ld: "ltr",
  alt: [],
  cc: ["CU"]
}, {
  pk: 3629,
  ang: "Laura",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Laura",
  lc: "lur",
  ld: "ltr",
  alt: ["Laora", "Mbukambero (Bukambero)"],
  cc: ["ID"]
}, {
  pk: 3630,
  ang: "Mizo",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Lushai",
  lc: "lus",
  ld: "ltr",
  alt: ["Hualngo", "Lei", "Lusai", "Lushei", "Sailau", "Whelngo", "Duhlian Twang", "Lukhai", "Lusago", "Lusei", "Le"],
  cc: ["BD", "IN", "MM"]
}, {
  pk: 3631,
  ang: "Lushootseed",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Lushootseed",
  lc: "lut",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 3632,
  ang: "Lumba-Yakkha",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Lumba-Yakkha",
  lc: "luu",
  ld: "ltr",
  alt: ["Yakkhaba Cea"],
  cc: ["NP"]
}, {
  pk: 3633,
  ang: "Luwati",
  lr: "Asia",
  gw: false,
  hc: "OM",
  ln: "Luwati",
  lc: "luv",
  ld: "ltr",
  alt: [],
  cc: ["OM"]
}, {
  pk: 3634,
  ang: "Luo",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Luo (Cameroon)",
  lc: "luw",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 3635,
  ang: "Luyia",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Luyia",
  lc: "luy",
  ld: "ltr",
  alt: [],
  cc: ["KE"]
}, {
  pk: 3636,
  ang: "Luri, Southern",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u0644\u064F\u0631\u06CC",
  lc: "luz",
  ld: "ltr",
  alt: ["Lor", "Lori", "Lori-ye Jonubi", "Lur", "Boyerahmadi", "Kohgiluyeh", "Shuli", "Yasuji (Yasichi)"],
  cc: ["IR"]
}, {
  pk: 3637,
  ang: "Latvian",
  lr: "Europe",
  gw: false,
  hc: "LV",
  ln: "latvie\u0161u valoda",
  lc: "lv",
  ld: "ltr",
  alt: [],
  cc: ["LV"]
}, {
  pk: 3638,
  ang: "Makuva",
  lr: "Asia",
  gw: false,
  hc: "TL",
  ln: "Maku'a",
  lc: "lva",
  ld: "ltr",
  alt: ["Lovaea", "Lovaia", "L\xF3vaia", "Maku\u2019a", "Makuwa"],
  cc: ["TL"]
}, {
  pk: 3639,
  ang: "Lavukaleve",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Lavukaleve",
  lc: "lvk",
  ld: "ltr",
  alt: ["Laube", "Laumbe", "Russell Island"],
  cc: ["SB"]
}, {
  pk: 3640,
  ang: "Latvian, Standard",
  lr: "Europe",
  gw: false,
  hc: "LV",
  ln: "Standard Latvian",
  lc: "lvs",
  ld: "ltr",
  alt: ["Lettisch", "Lettish"],
  cc: ["DE", "KZ", "GB", "LV", "SE", "US", "AU", "CA", "UZ"]
}, {
  pk: 3641,
  ang: "Levuka",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Levuka",
  lc: "lvu",
  ld: "ltr",
  alt: ["Lembata", "Lewokukun", "Lewuka", "Painara"],
  cc: ["ID"]
}, {
  pk: 3642,
  ang: "Lwalu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Lwalu",
  lc: "lwa",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 3643,
  ang: "Lewo Eleng",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lewo Eleng",
  lc: "lwe",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3644,
  ang: "Oluwanga",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Wanga",
  lc: "lwg",
  ld: "ltr",
  alt: ["Hanga", "Kawanga", "Luhanga", "Oluhanga"],
  cc: ["KE"]
}, {
  pk: 3645,
  ang: "Lachi, White",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "White Lachi",
  lc: "lwh",
  ld: "ltr",
  alt: ["Lipup\xF5", "White Lachi"],
  cc: ["VN"]
}, {
  pk: 3646,
  ang: "Lawa, Eastern",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "\u0E20\u0E32\u0E29\u0E32\u0E40\u0E25\u0E2D\u0E40\u0E27\u0E37\u0E2D\u0E30\u0E15\u0E30\u0E27\u0E31\u0E19\u0E2D\u0E2D\u0E01",
  lc: "lwl",
  ld: "ltr",
  alt: ["Bo Luang Lawa", "Lua", "Bo Luang", "Bo Sangae"],
  cc: ["TH"]
}, {
  pk: 3647,
  ang: "Laomian",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Laomian",
  lc: "lwm",
  ld: "ltr",
  alt: ["Bisu", "Guba", "Lawmeh"],
  cc: ["CN"]
}, {
  pk: 3648,
  ang: "Luwo",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Luwo",
  lc: "lwo",
  ld: "ltr",
  alt: ["Dhe Luwo", "Dhe Lwo", "Giur", "Jo Lwo", "Jur Lwo", "Lwo"],
  cc: ["SS"]
}, {
  pk: 3649,
  ang: "Lewotobi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lewotobi",
  lc: "lwt",
  ld: "ltr",
  alt: ["Southwest Lamaholot"],
  cc: ["ID"]
}, {
  pk: 3650,
  ang: "Lawu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Lawu",
  lc: "lwu",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 3651,
  ang: "Lewo",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Lewo",
  lc: "lww",
  ld: "ltr",
  alt: ["Varsu"],
  cc: ["VU"]
}, {
  pk: 3652,
  ang: "Layakha",
  lr: "Asia",
  gw: false,
  hc: "BT",
  ln: "Layakha",
  lc: "lya",
  ld: "ltr",
  alt: [],
  cc: ["BT"]
}, {
  pk: 3653,
  ang: "Lyngngam",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Lyngngam",
  lc: "lyg",
  ld: "ltr",
  alt: ["Megam", "Khasi", "Lyngam", "Lyngym"],
  cc: ["IN"]
}, {
  pk: 3654,
  ang: "Luyana",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Luyana",
  lc: "lyn",
  ld: "ltr",
  alt: ["Esiluyana", "Louyi", "Lui", "Luyi", "Rouyi", "Kwanga"],
  cc: ["ZM", "AO", "BW"]
}, {
  pk: 3655,
  ang: "Literary Chinese",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Literary Chinese",
  lc: "lzh",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 3656,
  ang: "Litzlitz",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Litzlitz",
  lc: "lzl",
  ld: "ltr",
  alt: ["Lagalag", "Litzlitz-Visele", "Lolnarrong", "Naman", "Netensal"],
  cc: ["VU"]
}, {
  pk: 3657,
  ang: "Naga, Leinong",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Leinong Naga",
  lc: "lzn",
  ld: "ltr",
  alt: ["Htang Ngan", "Htangan", "Lainong Naga", "Lenaung Naga", "Yao Dyang (Northern Leinong)", "Zau Dyang", "Southern Leinong"],
  cc: ["MM"]
}, {
  pk: 3658,
  ang: "Laz",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Laz",
  lc: "lzz",
  ld: "ltr",
  alt: ["Chan", "Chanuri", "Chanzan", "Laze", "Zan", "Vice-Arxava (Vital-Arkhava)", "Xopa (Hopa)", "Chxala (Ckhala)"],
  cc: ["TR"]
}, {
  pk: 3659,
  ang: "Mazatec, San Jer\xF3nimo Tec\xF3atl",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "San Jer\xF3nimo Tec\xF3atl Mazatec",
  lc: "maa",
  ld: "ltr",
  alt: ["Mazateco de San Antonio Eloxochitl\xE1n", "Mazateco de San Jer\xF3nimo Tec\xF3atl", "Mazateco del Oeste", "Northern Highland Mazatec", "San Antonio Eloxochitl\xE1n Mazatec", "San Francisco Huehuetl\xE1n Mazatec", "San Jer\xF3nimo Tec\xF3atl Mazatec", "San Lorenzo Cuanecuiltitla Mazatec", "San Lucas Zoquiapan Mazatec", "San Pedro Ocopetatillo Mazatec", "Santa Ana Ateixtlahuaca Mazatec", "Santa Cruz Acatepec Mazatec"],
  cc: ["MX"]
}, {
  pk: 3660,
  ang: "Mixtec, Yutanduchi",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Yutanduchi Mixtec",
  lc: "mab",
  ld: "ltr",
  alt: ["Mixteco de Yutanduchi", "Mixteco de Yutanduchi de Guerrero", "Southern Nochixtlan Mixtec"],
  cc: ["MX"]
}, {
  pk: 3661,
  ang: "Madura",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Madurese",
  lc: "mad",
  ld: "ltr",
  alt: ["Basa Mathura", "Madhura", "Madurese", "Bawean (Babean)", "Pamekesan (Pamekasan)", "Boyanese", "Bhebien", "Bangkalan (Bangkalon)", "Bawean (Boyanese)"],
  cc: ["ID", "SG"]
}, {
  pk: 3662,
  ang: "Bo-Rukul",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Bo-Rukul",
  lc: "mae",
  ld: "ltr",
  alt: ["Mabo-Barkul", "Mabo-Barukul", "Kaleri"],
  cc: ["NG"]
}, {
  pk: 3663,
  ang: "Mafa",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mafa",
  lc: "maf",
  ld: "ltr",
  alt: ["Mofa", "Natakan", "Matakam", "Bula", "Bulahai", "Central Mafa (Koza)", "East Mafa (Roua)", "Ldamtsai", "Mavoumay", "Mokola", "Ouzal", "Soulede", "West Mafa (Magoumaz)"],
  cc: ["CM", "NG"]
}, {
  pk: 3664,
  ang: "Magahi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Magahi",
  lc: "mag",
  ld: "ltr",
  alt: ["Bihari", "Magadhi", "Magaya", "Maghai", "Maghaya", "Maghori", "Magi", "Magodhi", "Megahi", "Central Magahi"],
  cc: ["IN"]
}, {
  pk: 3665,
  ang: "Maithili",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Maithili",
  lc: "mai",
  ld: "ltr",
  alt: ["Apabhramsa", "Bihari", "Maitili", "Maitli", "Methli", "Tirahutia", "Tirhuti", "Tirhutia", "Kortha Bihari", "Standard Maithili", "Kortha", "Central Colloquial Maithili (Sotipura)", "Eastern Maithili (Khotta)", "Bajjika", "Thenthi"],
  cc: ["NP", "IN"]
}, {
  pk: 7753,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Dehati Bhojouri",
  lc: "mai-x-dehati",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3666,
  ang: "Mazatec, Jalapa de D\xEDaz",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Jalapa De D\xEDaz Mazatec",
  lc: "maj",
  ld: "ltr",
  alt: ["Lowland Mazatec", "Mazateco de San Felipe Jalapa de D\xEDaz", "Mazateco del Este Bajo"],
  cc: ["MX"]
}, {
  pk: 3667,
  ang: "Makasar",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Makasar",
  lc: "mak",
  ld: "ltr",
  alt: ["Goa", "Macassar", "Macassarese", "Makassa", "Makassaarsche", "Makassarese", "Mangasara", "Mengkasara", "Taena", "Tena", "Gowa (Goa)", "Lakiung", "Turatea (Jeneponto)"],
  cc: ["ID"]
}, {
  pk: 3668,
  ang: "Mam",
  lr: "Americas",
  gw: false,
  hc: "GT",
  ln: "Mam",
  lc: "mam",
  ld: "ltr",
  alt: ["Huehuetenango Mam", "Todos Santos Mam", "Western Mam", "Tacana Mam", "Tacan\xE1 Mam", "Tacanec (Mame)", "Tacanec (Mam\xE9)", "Tacaneco", "Til\xF3", "Southern Mam (Mam Quetzalteco)", "Mam Occidental", "Tajumulco", "San Juan Ostuncalco Mam", "Ostuncalco Mam", "Mam Marquense", "Mam del sur", "Mam del Soconusco", "Mam del norte", "Mam de la Sierra", "Mam de la frontera", "Central Mam (Comitancillo Mam)", "Quetzaltenango Mam", "San Marcos Comitancillas Mam"],
  cc: ["GT", "US"]
}, {
  pk: 3669,
  ang: "Mandingo",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Mandingo",
  lc: "man",
  ld: "ltr",
  alt: [],
  cc: ["ML"]
}, {
  pk: 3670,
  ang: "Mazatec, Chiquihuitl\xE1n",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Chiquihuitl\xE1n Mazatec",
  lc: "maq",
  ld: "ltr",
  alt: ["Mazateco de San Juan Chiquihuitl\xE1n", "Mazateco del Sur"],
  cc: ["MX"]
}, {
  pk: 7571,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Gondhali",
  lc: "mar-x-ghondali",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7587,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Maratha/Beda",
  lc: "mar-x-maratha",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8262,
  ang: "Malayamaratian",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mayalamarathian",
  lc: "mar-x-mayalamarat",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3671,
  ang: "Maasai",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Masai",
  lc: "mas",
  ld: "ltr",
  alt: ["Masai", "Kimaasai", "Lumbwa", "Maa", "Parakuyo (Baraguyu)", "Arusa (Arusha)", "Arusha (Il-Arusha)", "L-Arusha", "Moitanik (Wuasinkishu)"],
  cc: ["KE", "TZ"]
}, {
  pk: 3672,
  ang: "Matlatzinca, San Francisco",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "San Francisco Matlatzinca",
  lc: "mat",
  ld: "ltr",
  alt: ["Matlatzinca", "Matlatzinca de San Francisco de los Ranchos"],
  cc: ["MX"]
}, {
  pk: 3673,
  ang: "Mazatec, Huautla",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Huautla Mazatec",
  lc: "mau",
  ld: "ltr",
  alt: ["Highland Mazatec", "Mazateco de Huautla de Jimenez", "Mazateco de la Sierra", "Mazateco del Centro", "Mazateco de presa alto", "Mazateco del norte"],
  cc: ["MX"]
}, {
  pk: 3674,
  ang: "Sater\xE9-Maw\xE9",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Sater\xE9-Maw\xE9",
  lc: "mav",
  ld: "ltr",
  alt: ["Andira", "Arapium", "Mabue", "Maragua", "Mau\xE9", "Maw\xE9", "Satar\xE9"],
  cc: ["BR"]
}, {
  pk: 3675,
  ang: "Mampruli",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Mampruli",
  lc: "maw",
  ld: "ltr",
  alt: ["Mamprule", "Manpelle", "Ngmamperli"],
  cc: ["GH", "TG"]
}, {
  pk: 3676,
  ang: "Malay, North Moluccan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "North Moluccan Malay",
  lc: "max",
  ld: "ltr",
  alt: ["Ternate Malay"],
  cc: ["ID"]
}, {
  pk: 3677,
  ang: "Mazahua, Central",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Central Mazahua",
  lc: "maz",
  ld: "ltr",
  alt: ["Mazahua de oriente"],
  cc: ["MX"]
}, {
  pk: 3678,
  ang: "Higaonon",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Higaonon",
  lc: "mba",
  ld: "ltr",
  alt: ["Higaunon", "Misamis Higaonon Manobo"],
  cc: ["PH"]
}, {
  pk: 3679,
  ang: "Manobo, Western Bukidnon",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Western Bukidnon Manobo",
  lc: "mbb",
  ld: "ltr",
  alt: [],
  cc: ["PH"]
}, {
  pk: 7817,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Arumanen",
  lc: "mbb-x-arumanen",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8264,
  ang: "Kiriyenteken",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kiriyenteken",
  lc: "mbb-x-kiriyenteken",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8193,
  ang: "Pulangiyen",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Pulangiyen",
  lc: "mbb-x-pulangiyan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8122,
  ang: "Manobo Pulangiyen",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Manobo Pulangiyen",
  lc: "mbb-x-pulangiyen",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3680,
  ang: "Macushi",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Macushi",
  lc: "mbc",
  ld: "ltr",
  alt: ["Macusi", "Makusi", "Makuxi", "Teueia", "Teweya", "Macussi"],
  cc: ["BR", "VE", "GY"]
}, {
  pk: 3681,
  ang: "Manobo, Dibabawon",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Dibabawon Manobo",
  lc: "mbd",
  ld: "ltr",
  alt: ["Debabaon", "Dibabaon", "Mandaya"],
  cc: ["PH"]
}, {
  pk: 3682,
  ang: "Malay, Baba",
  lr: "Asia",
  gw: false,
  hc: "SG",
  ln: "Baba Malay",
  lc: "mbf",
  ld: "ltr",
  alt: ["Chinese Malay", "Straits Malay", "Baba"],
  cc: ["MY", "SG"]
}, {
  pk: 3683,
  ang: "Mangseng",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mangseng",
  lc: "mbh",
  ld: "ltr",
  alt: ["Mangsing", "Masegi", "Maseki", "Marapu"],
  cc: ["PG"]
}, {
  pk: 3684,
  ang: "Manobo, Ilianen",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Ilianen Manobo",
  lc: "mbi",
  ld: "ltr",
  alt: ["Ilianen", "Arakan", "Pulangiyan"],
  cc: ["PH"]
}, {
  pk: 3685,
  ang: "Nad\xEBb",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Nad\xEBb",
  lc: "mbj",
  ld: "ltr",
  alt: ["Anod\xF6ub", "Kabari", "Kabori", "Mak\xFA Nad\xEBb", "Makunad\xF6b\xF6", "Nadeb Macu", "Nad\xF6b\xF6", "Xiriwai", "Xuriwai"],
  cc: ["BR"]
}, {
  pk: 3686,
  ang: "Malol",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Malol",
  lc: "mbk",
  ld: "ltr",
  alt: ["Malolo", "Malon"],
  cc: ["PG"]
}, {
  pk: 3687,
  ang: "Maxakal\xED",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Maxakal\xED",
  lc: "mbl",
  ld: "ltr",
  alt: ["Caposho", "Cumanasho", "Macuni", "Monaxo", "Monocho"],
  cc: ["BR"]
}, {
  pk: 3688,
  ang: "Ombamba",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Ombamba",
  lc: "mbm",
  ld: "ltr",
  alt: ["Lembaamba", "Mbaama", "Mbama", "Mbamba", "Obamba"],
  cc: ["GA", "CG"]
}, {
  pk: 3689,
  ang: "Macagu\xE1n",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Macagu\xE1n",
  lc: "mbn",
  ld: "ltr",
  alt: ["Agualinda Guahibo", "Hitn\xFC", "Macaguane", "Macaguane-Hitnu"],
  cc: ["CO"]
}, {
  pk: 3690,
  ang: "Mbo",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mbo (Cameroon)",
  lc: "mbo",
  ld: "ltr",
  alt: ["Mboo", "Sambo", "Bareko (Ehow Mba)", "Santchou (Nla Mboo)", "Minahe", "Kekem (Nlembuu)", "Melong (Eho Mbo)"],
  cc: ["CM"]
}, {
  pk: 3691,
  ang: "Malayo",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Malayo",
  lc: "mbp",
  ld: "ltr",
  alt: ["Arosario", "Arsario", "Damana", "Guamaca", "Guamaka", "Maracasero", "Marocasero", "Sanc\xE1", "Sanja", "Sanka", "Wiwa"],
  cc: ["CO"]
}, {
  pk: 3692,
  ang: "Maisin",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Maisin",
  lc: "mbq",
  ld: "ltr",
  alt: ["Maisan"],
  cc: ["PG"]
}, {
  pk: 3693,
  ang: "Nukak Mak\xFA",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Nukak Mak\xFA",
  lc: "mbr",
  ld: "ltr",
  alt: ["Guaviare", "Maczsa", "Nukak"],
  cc: ["CO"]
}, {
  pk: 3694,
  ang: "Manobo, Sarangani",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Sarangani Manobo",
  lc: "mbs",
  ld: "ltr",
  alt: [],
  cc: ["PH"]
}, {
  pk: 3695,
  ang: "Manobo, Matigsalug",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Tigwa, Tigwahanen",
  lc: "mbt",
  ld: "ltr",
  alt: ["Matig-Salug Manobo"],
  cc: ["PH"]
}, {
  pk: 7821,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kulamanen",
  lc: "mbt-x-kulamanen",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7529,
  ang: "Tigwa, Tigwahanen",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Tigwa, Tigwahanen",
  lc: "mbt-x-tigwa",
  ld: "ltr",
  alt: [],
  cc: ["PH"]
}, {
  pk: 7710,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Tala Ingod Manobo",
  lc: "mbt-x-tingod",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3696,
  ang: "Mbula-Bwazza",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Mbula-Bwazza",
  lc: "mbu",
  ld: "ltr",
  alt: ["Gwamba (Nkono)", "Taumbo", "Tambo (Begel)", "kunBegel", "Bwazza (Bare)", "Bwa'za", "Bwaza", "Bere", "Bakopi (kunBuko)", "kunBwazza"],
  cc: ["NG"]
}, {
  pk: 3697,
  ang: "Mbulungish",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Mbulungish",
  lc: "mbv",
  ld: "ltr",
  alt: ["Baga For\xE9", "Baga Monson", "Black Baga", "Bulunits", "Longich", "Monshon"],
  cc: ["GN"]
}, {
  pk: 3698,
  ang: "Maring",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Maring",
  lc: "mbw",
  ld: "ltr",
  alt: ["Mareng", "Yoadabe-Watoare"],
  cc: ["PG"]
}, {
  pk: 3699,
  ang: "Mari",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mari (East Sepik Province)",
  lc: "mbx",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3700,
  ang: "Memoni",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "Memoni",
  lc: "mby",
  ld: "ltr",
  alt: [],
  cc: ["PK", "IN"]
}, {
  pk: 3701,
  ang: "Mixtec, Amoltepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Amoltepec Mixtec",
  lc: "mbz",
  ld: "ltr",
  alt: ["Mixteco de Amoltepec", "Western Sola de Vega Mixtec"],
  cc: ["MX"]
}, {
  pk: 3702,
  ang: "Maka",
  lr: "Americas",
  gw: false,
  hc: "PY",
  ln: "Maca",
  lc: "mca",
  ld: "ltr",
  alt: ["Enimaca", "Enimaga", "Mac\xE1", "Mak\xE1", "Mak'\xE1"],
  cc: ["PY"]
}, {
  pk: 3703,
  ang: "Machiguenga",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Machiguenga",
  lc: "mcb",
  ld: "ltr",
  alt: ["Ma\xF1aries", "Matsiganga", "Matsigenka"],
  cc: ["PE"]
}, {
  pk: 3704,
  ang: "Bitur",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bitur",
  lc: "mcc",
  ld: "ltr",
  alt: ["Bituri", "Dudi", "Mutum", "Paswam"],
  cc: ["PG"]
}, {
  pk: 3705,
  ang: "Sharanahua",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Sharanahua",
  lc: "mcd",
  ld: "ltr",
  alt: ["Acre Arara", "Arara do Acre", "Shawanau\xE1", "Marinahua (Marinawa)", "Marinahua (Marin\xE1wa)", "Mastanahua"],
  cc: ["BR", "PE"]
}, {
  pk: 3706,
  ang: "Mixtec, Itundujia",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Itundujia Mixtec",
  lc: "mce",
  ld: "ltr",
  alt: ["Eastern Putla Mixtec", "Mixteco de Santa Cruz Itundujia"],
  cc: ["MX"]
}, {
  pk: 3707,
  ang: "Mats\xE9s",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Mats\xE9s",
  lc: "mcf",
  ld: "ltr",
  alt: ["Matse", "Mayoruna", "Magirona", "Majuruna", "Matses-Mayoruna", "Maxirona", "Maxuruna", "Mayiruna", "Mayuzuna"],
  cc: ["BR", "PE"]
}, {
  pk: 3708,
  ang: "Mapoyo",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "Mapoyo",
  lc: "mcg",
  ld: "ltr",
  alt: ["Mapayo", "Mapoye", "Mopoi", "Nepoye", "Wanai"],
  cc: ["VE"]
}, {
  pk: 3709,
  ang: "Maquiritari",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "Maquiritari",
  lc: "mch",
  ld: "ltr",
  alt: ["Makiritare", "Maquiritai", "Pawana", "Soto", "Yeku\xE1na", "Maiongong", "Ye'cuana", "Yekuana", "Mayongong (Ye'cuana)", "De'cuana (Wainungomo)"],
  cc: ["BR", "VE"]
}, {
  pk: 3710,
  ang: "Mesem",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mese",
  lc: "mci",
  ld: "ltr",
  alt: ["Mese", "Momalili"],
  cc: ["PG"]
}, {
  pk: 3711,
  ang: "Mvanip",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Mvanip",
  lc: "mcj",
  ld: "ltr",
  alt: ["Magu", "Mvanlip", "Mvano", "Mvanon", "Mvan\xF6p"],
  cc: ["NG"]
}, {
  pk: 3712,
  ang: "Mbunda",
  lr: "Africa",
  gw: false,
  hc: "AO",
  ln: "Mbunda",
  lc: "mck",
  ld: "ltr",
  alt: ["Chimbunda", "Mbuunda", "Gimbunda", "Kimbunda"],
  cc: ["ZM", "AO"]
}, {
  pk: 3713,
  ang: "Macaguaje",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Macaguaje",
  lc: "mcl",
  ld: "ltr",
  alt: [],
  cc: ["CO"]
}, {
  pk: 3714,
  ang: "Malaccan Creole Portuguese",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Malaccan Creole Portuguese",
  lc: "mcm",
  ld: "ltr",
  alt: ["Bahasa Geragau", "Bahasa Serani", "Kristang", "Luso-Malay", "Malaccan", "Malaqueiro", "Malaquenho", "Malaquense", "Malaqu\xEAs", "Malayo-Portuguese", "Malaysian Creole Portuguese", "Papia Cristao", "Papia Kristang", "Portugu\xEAs de Malaca", "Portuguese Patois", "Serani"],
  cc: ["MY"]
}, {
  pk: 3715,
  ang: "Masana",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Masana",
  lc: "mcn",
  ld: "ltr",
  alt: ["Masa", "Massa", "Banana", "Ham", "Yagwa (Yagoua)", "Wina (Viri)", "Budugum", "Walia (Walya)", "Gumay (Goumaye)", "Guissey", "Gizay (Guissey)", "Gizay (Gisey)", "Bugudum (Budugum)", "Walya"],
  cc: ["CM", "TD"]
}, {
  pk: 3716,
  ang: "Mixe, Coatl\xE1n",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Coatl\xE1n Mixe",
  lc: "mco",
  ld: "ltr",
  alt: ["Southeastern Mixe", "Camotl\xE1n Mixe", "Coatl\xE1n Mixe"],
  cc: ["MX"]
}, {
  pk: 3717,
  ang: "Makaa",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Makaa",
  lc: "mcp",
  ld: "ltr",
  alt: ["Mekaa", "South Makaa", "South Mekaa", "Bebent (Bebende)", "Shekunda", "Biken", "Bemina", "Besep", "Bewil"],
  cc: ["CM"]
}, {
  pk: 3718,
  ang: "Ese",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ese",
  lc: "mcq",
  ld: "ltr",
  alt: ["Managalasi", "Managulasi", "Numba"],
  cc: ["PG"]
}, {
  pk: 8253,
  ang: "Akabafa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Akabafa",
  lc: "mcq-x-akabafa",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3719,
  ang: "Menya",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Menya",
  lc: "mcr",
  ld: "ltr",
  alt: ["Menyama"],
  cc: ["PG"]
}, {
  pk: 3720,
  ang: "Mambai",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mambai",
  lc: "mcs",
  ld: "ltr",
  alt: ["Mamgbay", "Mamgbei", "Manbai", "Mangbai", "Mangbei", "Mongbay", "Mangba\xEF de Bipar\xE9", "Momboi"],
  cc: ["CM", "TD"]
}, {
  pk: 3721,
  ang: "Mengisa",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mengisa",
  lc: "mct",
  ld: "ltr",
  alt: ["Mangisa", "Mengisa-Njowe", "Leti", "Njowe"],
  cc: ["CM"]
}, {
  pk: 3722,
  ang: "Mambila, Cameroon",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Cameroon Mambila",
  lc: "mcu",
  ld: "ltr",
  alt: ["Bang", "Bea", "Ble", "Juli", "Lagubi", "Mambere", "Mambilla", "Nor", "Tagbo", "Tongbo", "Torbi", "Sunu Torbi (Torbi)", "Ju Naare (Mambila de Gembu)", "Langa"],
  cc: ["CM"]
}, {
  pk: 3723,
  ang: "Minanibai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Minanibai",
  lc: "mcv",
  ld: "ltr",
  alt: ["Eme-Eme", "Hei", "Pepeha"],
  cc: ["PG"]
}, {
  pk: 3724,
  ang: "Mawa",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Mawa (Chad)",
  lc: "mcw",
  ld: "ltr",
  alt: ["Mahwa"],
  cc: ["TD"]
}, {
  pk: 3725,
  ang: "Mpiemo",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Mpiemo",
  lc: "mcx",
  ld: "ltr",
  alt: ["Bimu", "Mbimou", "Mbimu", "Mbyemo", "Mpo", "Jasua (Jasoa)", "Bidjuki (Bidjouki)", "Jasoa (Jasua)"],
  cc: ["CM", "CF"]
}, {
  pk: 3726,
  ang: "Watut, South",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "South Watut",
  lc: "mcy",
  ld: "ltr",
  alt: ["Dangal (Danggal)", "Maralango (Maralangko)"],
  cc: ["PG"]
}, {
  pk: 3727,
  ang: "Mawan",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mawan",
  lc: "mcz",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3728,
  ang: "Mada",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Mada (Nigeria)",
  lc: "mda",
  ld: "ltr",
  alt: ["Madda", "Yidda"],
  cc: ["NG"]
}, {
  pk: 3729,
  ang: "Morigi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Morigi",
  lc: "mdb",
  ld: "ltr",
  alt: ["Dabura", "Morigi Island", "Turama River Kiwai", "Wariadai"],
  cc: ["PG"]
}, {
  pk: 3730,
  ang: "Male",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Male (Papua New Guinea)",
  lc: "mdc",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3731,
  ang: "Mbum",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mbum",
  lc: "mdd",
  ld: "ltr",
  alt: ["Buna", "Mboumtiba", "Wuna", "Pono", "Gbete (Byrre)", "Vana", "West Mbum", "Ripere", "Pere", "Mboum (Bum)", "Kepere", "Kpere"],
  cc: ["CM", "CF", "TD"]
}, {
  pk: 3732,
  ang: "Maba",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Maba (Chad)",
  lc: "mde",
  ld: "ltr",
  alt: ["Borgu", "Bura Mabang", "Kana Mabang", "Mabaa", "Mabak", "Mabang", "Ouaddai", "Ouaddaien", "Wadai", "Waddayen", "Kabartu", "Kodroy", "Kondongo"],
  cc: ["SD", "TD"]
}, {
  pk: 3733,
  ang: "Moksha",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041C\u043E\u043A\u0448\u0430\u043D\u0441\u043A\u0438\u0439",
  lc: "mdf",
  ld: "ltr",
  alt: ["Mokshan", "Mordoff", "Mordov", "Mordvin-Moksha"],
  cc: ["RU"]
}, {
  pk: 3734,
  ang: "Massalat",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Masalit",
  lc: "mdg",
  ld: "ltr",
  alt: [],
  cc: ["TD"]
}, {
  pk: 3735,
  ang: "Maguindanaon",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Maguindanaon",
  lc: "mdh",
  ld: "ltr",
  alt: ["Magindanaon", "Magindanaw", "Magindanawn", "Maguindanaw"],
  cc: ["PH"]
}, {
  pk: 7758,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Dananao",
  lc: "mdh-x-dananao",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3736,
  ang: "Mamvu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Mamvu",
  lc: "mdi",
  ld: "ltr",
  alt: ["Momvu", "Mamvu (Momfu)"],
  cc: ["CD"]
}, {
  pk: 3737,
  ang: "Mangbetu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Mangbetu",
  lc: "mdj",
  ld: "ltr",
  alt: ["Amangbetu", "Kingbetu", "Mambetto", "Mangbettu", "Nemangbetu", "Popoi", "Meje (Medje)", "Aberu", "Makere", "Meegye"],
  cc: ["CD", "UG"]
}, {
  pk: 3738,
  ang: "Mangbutu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Mangbutu",
  lc: "mdk",
  ld: "ltr",
  alt: ["Mangu-Ngutu", "Mombuttu", "Wambutu", "Angwe (Andali)"],
  cc: ["CD"]
}, {
  pk: 3739,
  ang: "Maltese Sign Language",
  lr: "Europe",
  gw: false,
  hc: "MT",
  ln: "Maltese Sign Language",
  lc: "mdl",
  ld: "ltr",
  alt: [],
  cc: ["MT"]
}, {
  pk: 3740,
  ang: "Mayogo",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Mayogo",
  lc: "mdm",
  ld: "ltr",
  alt: ["Maigo", "Maiko", "Majugu", "Mayko", "Mayugo", "Mabozo", "Madipia (Mabodese)", "Madjedje", "Magbai"],
  cc: ["CD"]
}, {
  pk: 3741,
  ang: "Mbati",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Mbati",
  lc: "mdn",
  ld: "ltr",
  alt: ["Isongo", "Issongo", "Lisongo", "Lissongo", "Songo"],
  cc: ["CF"]
}, {
  pk: 3742,
  ang: "Mbala",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Mbala",
  lc: "mdp",
  ld: "ltr",
  alt: ["Gimbala", "Rumbala"],
  cc: ["CD"]
}, {
  pk: 3743,
  ang: "Mbole",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Mbole",
  lc: "mdq",
  ld: "ltr",
  alt: ["Nkimbe (Nkembe)"],
  cc: ["CD"]
}, {
  pk: 3744,
  ang: "Mandar",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mandar",
  lc: "mdr",
  ld: "ltr",
  alt: ["Andian", "Mandharsche", "Manjar", "Balanipa (Napo-Tinambung)", "Sendana (Cenrana)", "Tjendana"],
  cc: ["ID"]
}, {
  pk: 3745,
  ang: "Maria",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Maria (Papua New Guinea)",
  lc: "mds",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3746,
  ang: "Mbere",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Mbere",
  lc: "mdt",
  ld: "ltr",
  alt: ["Limbede", "Mb\xE9d\xE9", "Mb\xE9t\xE9", "Ambede"],
  cc: ["GA", "CG"]
}, {
  pk: 3747,
  ang: "Mboko",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Mboko",
  lc: "mdu",
  ld: "ltr",
  alt: ["Mboxo", "Mbuku"],
  cc: ["CG"]
}, {
  pk: 3748,
  ang: "Mixtec, Santa Luc\xEDa Monteverde",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Santa Luc\xEDa Monteverde Mixtec",
  lc: "mdv",
  ld: "ltr",
  alt: ["Mixteco de Santa Luc\xEDa Monteverde", "Mixteco de Yosonot\xFA"],
  cc: ["MX"]
}, {
  pk: 3749,
  ang: "Mbosi",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Mbosi",
  lc: "mdw",
  ld: "ltr",
  alt: ["Embosi", "Mboshe", "Mboshi"],
  cc: ["CG"]
}, {
  pk: 3750,
  ang: "Dizin",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Dizin",
  lc: "mdx",
  ld: "ltr",
  alt: ["Dizi-Maji", "Dizinog", "Dizinya", "Maji", "Majinya", "Sizi", "Twoyu"],
  cc: ["ET"]
}, {
  pk: 3751,
  ang: "Male",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Male (Ethiopia)",
  lc: "mdy",
  ld: "ltr",
  alt: ["Maale"],
  cc: ["ET"]
}, {
  pk: 3752,
  ang: "Suru\xED do Par\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Suru\xED Do Par\xE1",
  lc: "mdz",
  ld: "ltr",
  alt: ["Aikewara", "Akewara", "Akewere", "Sororos", "Suru\xED", "Mudj\xE9tira", "Mudjet\xEDre", "Mudjet\xEDre-Suru\xED"],
  cc: ["BR"]
}, {
  pk: 3753,
  ang: "Menka",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Menka",
  lc: "mea",
  ld: "ltr",
  alt: ["Mamwoh", "Wando Bando"],
  cc: ["CM"]
}, {
  pk: 3754,
  ang: "Ikobi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ikobi",
  lc: "meb",
  ld: "ltr",
  alt: ["Ikobi Kairi", "Kasere", "Kopo-Monia", "Wailemi", "Dukemi", "Upper Kikori Kaser", "Upper Turama-Kaser"],
  cc: ["PG"]
}, {
  pk: 3755,
  ang: "Mara",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Mara",
  lc: "mec",
  ld: "ltr",
  alt: ["Leelalwarra", "Leelawarra", "Mala", "Marra"],
  cc: ["AU"]
}, {
  pk: 3756,
  ang: "Melpa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Melpa",
  lc: "med",
  ld: "ltr",
  alt: ["Hagen", "Tembagla (Temboka)"],
  cc: ["PG"]
}, {
  pk: 3757,
  ang: "Mengen",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mengen",
  lc: "mee",
  ld: "ltr",
  alt: ["Poeng", "Bush Mengen (Inland Mengen)", "Longueinga", "Maenge", "North Coast Mengen (Maeng)", "Orford", "South Coast Mengen (Poeng)"],
  cc: ["PG"]
}, {
  pk: 3758,
  ang: "Megam",
  lr: "Asia",
  gw: false,
  hc: "BD",
  ln: "Megam",
  lc: "mef",
  ld: "ltr",
  alt: ["Migam", "Negam"],
  cc: ["BD"]
}, {
  pk: 3759,
  ang: "Mixtec, Southwestern Tlaxiaco",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Southwestern Tlaxiaco Mixtec",
  lc: "meh",
  ld: "ltr",
  alt: ["Mixteco de Santiago Nuyoo", "Mixteco del Suroeste de Tlaxiaco", "Nuyoo Mixtec", "Southeastern Ocotepec Mixtec"],
  cc: ["MX"]
}, {
  pk: 3760,
  ang: "Midob",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Midob",
  lc: "mei",
  ld: "ltr",
  alt: ["Meidob", "Midobi", "Tid", "Tidda", "Tid-N-Aal", "Shelkota (Shalkota)", "Urrti (Uurti)"],
  cc: ["SD"]
}, {
  pk: 3761,
  ang: "Meyah",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Meyah",
  lc: "mej",
  ld: "ltr",
  alt: ["Arfak", "Mansibaber", "Meah", "Meax", "Mejach", "Mejah", "Meyach"],
  cc: ["ID"]
}, {
  pk: 3762,
  ang: "Mekeo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mekeo",
  lc: "mek",
  ld: "ltr",
  alt: ["Mekeo-Kovio", "Northwest Mekeo (Kovio)"],
  cc: ["PG"]
}, {
  pk: 8472,
  ang: "North Mekio Upstream",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "North Mekio Upstream",
  lc: "mek-x-nmekioupst",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8319,
  ang: "North Mekeo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "North Mekeo",
  lc: "mek-x-northmekeo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3763,
  ang: "Melanau, Central",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Central Melanau",
  lc: "mel",
  ld: "ltr",
  alt: ["Belana'u", "Milanau", "Milano", "Oga", "Oya", "Mukah", "Dalat (Dalad)", "Oya'", "Mukah-Oya (Muka)"],
  cc: ["MY"]
}, {
  pk: 3764,
  ang: "Mangala",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Mangala",
  lc: "mem",
  ld: "ltr",
  alt: ["Djawali", "Djuwali", "Jiwali", "Jiwarli", "Koalgurdi", "Manala", "Mangalaa", "Mangarla", "Minala", "Yalmbau"],
  cc: ["AU"]
}, {
  pk: 3765,
  ang: "Mende",
  lr: "Africa",
  gw: false,
  hc: "SL",
  ln: "Mende (Sierra Leone)",
  lc: "men",
  ld: "ltr",
  alt: ["Boumpe", "Hulo", "Kossa", "Kosso"],
  cc: ["LR", "US", "SL"]
}, {
  pk: 3766,
  ang: "Malay, Kedah",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Kedah Malay",
  lc: "meo",
  ld: "ltr",
  alt: ["Satun Malay", "Kedah Malay"],
  cc: ["MY"]
}, {
  pk: 3767,
  ang: "Miriwung",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Miriwung",
  lc: "mep",
  ld: "ltr",
  alt: ["Merong", "Miriwoong", "Miriwun", "Mirung"],
  cc: ["AU"]
}, {
  pk: 3768,
  ang: "Merey",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Merey",
  lc: "meq",
  ld: "ltr",
  alt: ["Mere", "Meri", "Mofu de M\xE9ri"],
  cc: ["CM"]
}, {
  pk: 3769,
  ang: "Kim\xEE\xEEru",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Meru",
  lc: "mer",
  ld: "ltr",
  alt: ["Meru (Beik)"],
  cc: ["KE"]
}, {
  pk: 3770,
  ang: "Masmaje",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Masmaje",
  lc: "mes",
  ld: "ltr",
  alt: ["Masmadje", "Mesmedje"],
  cc: ["TD"]
}, {
  pk: 3771,
  ang: "Mato",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mato",
  lc: "met",
  ld: "ltr",
  alt: ["Nenaya", "Nengaya", "Nineia", "Ramuk", "Tabares"],
  cc: ["PG"]
}, {
  pk: 3772,
  ang: "Motu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Motu",
  lc: "meu",
  ld: "ltr",
  alt: ["Pure Motu", "True Motu"],
  cc: ["PG"]
}, {
  pk: 3773,
  ang: "Mano",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Mano",
  lc: "mev",
  ld: "ltr",
  alt: ["Maa", "Mah", "Manon", "Mawe"],
  cc: ["LR", "GN"]
}, {
  pk: 3774,
  ang: "Maaka",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Maaka",
  lc: "mew",
  ld: "ltr",
  alt: ["Maga", "Magha", "Maha", "Maka"],
  cc: ["NG"]
}, {
  pk: 3775,
  ang: "Hassaniyya",
  lr: "Africa",
  gw: false,
  hc: "MR",
  ln: "\u062D\u0633\u0627\u0646\u064A\u0629",
  lc: "mey",
  ld: "rtl",
  alt: ["Hasanya", "Hassani", "Maure", "Mauri", "Moor", "Sahrawi", "Sulaka", "Hassaniya", "Suraka", "Suraxx\xE9", "Hasanya Arabic", "Hassania", "Hassaniyya Arabic", "Klem El Bithan", "Hasaniya"],
  cc: ["DZ", "FR", "ML", "MR", "MA", "NE", "US", "TD", "CA", "LY"]
}, {
  pk: 3776,
  ang: "Menominee",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Menominee",
  lc: "mez",
  ld: "ltr",
  alt: ["Menomini"],
  cc: ["US"]
}, {
  pk: 3777,
  ang: "Malay, Pattani",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Pattani Malay",
  lc: "mfa",
  ld: "ltr",
  alt: ["Thai Islam"],
  cc: ["TH"]
}, {
  pk: 3778,
  ang: "Bangka",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bangka",
  lc: "mfb",
  ld: "ltr",
  alt: ["Capital City", "Urban", "South Bangka", "Port", "North Bangka", "Mapor", "Central Bangka", "Lom (Belom)"],
  cc: ["ID"]
}, {
  pk: 3779,
  ang: "Mba",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Mba",
  lc: "mfc",
  ld: "ltr",
  alt: ["Kimbanga", "Manga"],
  cc: ["CD"]
}, {
  pk: 3780,
  ang: "Mendankwe-Nkwen",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mendankwe-Nkwen",
  lc: "mfd",
  ld: "ltr",
  alt: ["Mendankwe", "Mendankwe (Bamenda)", "Nkwen (Bafreng)", "Munda"],
  cc: ["CM"]
}, {
  pk: 3781,
  ang: "Morisyen",
  lr: "Africa",
  gw: false,
  hc: "MU",
  ln: "Morisyen",
  lc: "mfe",
  ld: "ltr",
  alt: ["Kreol", "Kreole", "Maurisyen", "Mauritian", "Mauritius Creole French", "Maurysen"],
  cc: ["FR", "KE", "MU", "GB", "ZA", "CA"]
}, {
  pk: 3782,
  ang: "Naki",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Naki",
  lc: "mff",
  ld: "ltr",
  alt: ["Bunaki", "Mekaf", "Munkaf", "Nkap"],
  cc: ["CM"]
}, {
  pk: 3783,
  ang: "Mogofin",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Mogofin",
  lc: "mfg",
  ld: "ltr",
  alt: ["Mixifore"],
  cc: ["GN"]
}, {
  pk: 3784,
  ang: "Matal",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Matal",
  lc: "mfh",
  ld: "ltr",
  alt: ["Balda", "Mouktele", "Muktele", "Muktile"],
  cc: ["CM"]
}, {
  pk: 3785,
  ang: "Wandala",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Wandala",
  lc: "mfi",
  ld: "ltr",
  alt: ["Mandara Montagnard", "Ndara", "Malgwa", "Wandala (Mandara)", "Mura (Duwe)", "Mora Brousse", "Malgo", "Kirdi-Mora", "Gamergu", "Gamargu (Gamergu)", "Gamargu (Gamergou)", "Mora Massif"],
  cc: ["CM", "NG"]
}, {
  pk: 3786,
  ang: "Mefele",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mefele",
  lc: "mfj",
  ld: "ltr",
  alt: ["Boulahay", "Bula", "Bulahai", "Muhura (Mouhour)", "Serak (Sirak)", "Shugule (Chougoule)"],
  cc: ["CM"]
}, {
  pk: 3787,
  ang: "Mofu, North",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "North Mofu",
  lc: "mfk",
  ld: "ltr",
  alt: ["Douvangar", "Mofu-Douvangar", "Mofu-Nord", "Douroun (Durum)", "Wazan (Wazang)", "Mofu de Douroum"],
  cc: ["CM"]
}, {
  pk: 3788,
  ang: "Putai",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Putai",
  lc: "mfl",
  ld: "ltr",
  alt: ["Marghi West"],
  cc: ["NG"]
}, {
  pk: 3789,
  ang: "Marghi South",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Marghi South",
  lc: "mfm",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 3790,
  ang: "Mbembe, Cross River",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Cross River Mbembe",
  lc: "mfn",
  ld: "ltr",
  alt: ["Ekokoma", "Ifunubwa", "Oderiga", "Ofunobwam", "Okam", "Wakande", "Ekama (Ekamu)", "Ofombonga (Ewumbonga)", "Ohana-Onyen", "Okom (Eghom)", "Osophong", "Osopong (Ezopong)"],
  cc: ["NG"]
}, {
  pk: 3791,
  ang: "Mbe",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Mbe",
  lc: "mfo",
  ld: "ltr",
  alt: ["Ketuen", "Western Mbube", "Ekumtak"],
  cc: ["NG"]
}, {
  pk: 3792,
  ang: "Malay, Makassar",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Makassar Malay",
  lc: "mfp",
  ld: "ltr",
  alt: ["Macassarese Malay", "Makassarese Malay", "Sulsel Indonesian", "Ujung Pandang Indonesian"],
  cc: ["ID"]
}, {
  pk: 3793,
  ang: "Moba",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Moba",
  lc: "mfq",
  ld: "ltr",
  alt: ["Ben", "Moa", "Moab", "Moare", "Lok", "Yanbann"],
  cc: ["BF", "TG"]
}, {
  pk: 7723,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Mual",
  lc: "mfq-x-mual",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3794,
  ang: "Marithiel",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Marithiel",
  lc: "mfr",
  ld: "ltr",
  alt: ["Berringen", "Maridhiel", "Maridhiyel", "Marithiyel", "Bringen", "Brinken", "Mare-Ammu (Mari-Ammu)"],
  cc: ["AU"]
}, {
  pk: 3795,
  ang: "Mexican Sign Language",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Mexican Sign Language",
  lc: "mfs",
  ld: "ltr",
  alt: ["Lengua de Se\xF1as Mexicana", "Lenguaje de las Manos", "Lenguaje de Se\xF1as de M\xE9xico", "Lenguaje de Se\xF1as Mexicano", "Lenguaje de Signos Mexicano", "Lenguaje Manual Mexicana", "LSM"],
  cc: ["MX"]
}, {
  pk: 3796,
  ang: "Mokerang",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mokerang",
  lc: "mft",
  ld: "ltr",
  alt: ["Mokareng", "Mokoreng"],
  cc: ["PG"]
}, {
  pk: 3797,
  ang: "Mbwela",
  lr: "Africa",
  gw: false,
  hc: "AO",
  ln: "Mbwela",
  lc: "mfu",
  ld: "ltr",
  alt: ["Ambuela", "Ambuella", "Mbuela", "Mbwera", "Shimbwera"],
  cc: ["AO"]
}, {
  pk: 3798,
  ang: "Mandjak",
  lr: "Africa",
  gw: false,
  hc: "GW",
  ln: "Mandjak",
  lc: "mfv",
  ld: "ltr",
  alt: ["Kanyop", "Mandjaque", "Mandyak", "Manjaca", "Manjack", "Manjaco", "Manjacu", "Manjiak", "Ndyak", "Manjaku", "Mendyako", "Majak", "Manjaaku", "Manjak", "Ndjak", "Bok (Babok)", "Sara", "Yu (Pecixe)", "Ubok", "Tsaam", "Siis", "Pulhilh", "Lund (Ulund)", "Likes-Utsia (Baraa)", "Kalkus", "Cur (Churo)", "Bok (Kabok)"],
  cc: ["FR", "GM", "SN", "GW"]
}, {
  pk: 3799,
  ang: "Melo",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Melo",
  lc: "mfx",
  ld: "ltr",
  alt: ["Malo"],
  cc: ["ET"]
}, {
  pk: 3800,
  ang: "Mayo",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Mayo",
  lc: "mfy",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 3801,
  ang: "Mabaan",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Mabaan",
  lc: "mfz",
  ld: "ltr",
  alt: ["Barga", "Gura", "Maaban", "Meban", "Southern Burun", "Tonko", "Tungan", "Ulu"],
  cc: ["ET", "SS"]
}, {
  pk: 3802,
  ang: "Malagasy",
  lr: "Africa",
  gw: false,
  hc: "MG",
  ln: "fiteny malagasy",
  lc: "mg",
  ld: "ltr",
  alt: [],
  cc: ["MG"]
}, {
  pk: 3803,
  ang: "Middle Irish",
  lr: "Europe",
  gw: false,
  hc: "IE",
  ln: "Middle Irish (900-1200)",
  lc: "mga",
  ld: "ltr",
  alt: [],
  cc: ["IE"]
}, {
  pk: 3804,
  ang: "Mararit",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Mararit",
  lc: "mgb",
  ld: "ltr",
  alt: ["Abiri", "Abiyi", "Ebiri", "Mararet", "Merarit", "Abou Charib (Abu Sharib)", "Abu Sharin"],
  cc: ["SD", "TD"]
}, {
  pk: 3805,
  ang: "Morokodo",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Morokodo",
  lc: "mgc",
  ld: "ltr",
  alt: ["Ma'di"],
  cc: ["SS"]
}, {
  pk: 3806,
  ang: "Moru",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Moru",
  lc: "mgd",
  ld: "ltr",
  alt: ["Kala Moru", "Wa'di"],
  cc: ["SS", "US", "UG"]
}, {
  pk: 3807,
  ang: "Mango",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Mango",
  lc: "mge",
  ld: "ltr",
  alt: ["Doba", "Mbay Doba", "Mongo"],
  cc: ["TD"]
}, {
  pk: 3808,
  ang: "Maklew",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Maklew",
  lc: "mgf",
  ld: "ltr",
  alt: ["Makleu"],
  cc: ["ID"]
}, {
  pk: 3809,
  ang: "Mpumpong",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mpumpong",
  lc: "mgg",
  ld: "ltr",
  alt: ["Bombo", "Mbombo", "Mpompo", "Mpongmpong", "Mpopo", "Mpumpoo", "Pongpong", "Mbobyeng (Pobyeng)", "Northern Bangantu", "Nkumabem", "Mpomam (Boman)", "Mezime", "Menzime (Medzime)", "Mboman", "Kunabembe (Konabem)", "Kunabeeb", "Konabembe", "Bangantu", "Bageto (Baagato)", "Mendzime"],
  cc: ["CM"]
}, {
  pk: 3810,
  ang: "Makhuwa-Meetto",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Makhuwa-Meetto",
  lc: "mgh",
  ld: "ltr",
  alt: ["Emeto", "Imeetto", "Meto", "M\xEAto", "Metto", "Imakua", "Kimakua", "Makhua", "Makoa", "Makua", "Makuwa", "Maquoua", "Mato", "Medo (Emeto)"],
  cc: ["KM", "MZ", "TZ", "ZW", "YT"]
}, {
  pk: 3811,
  ang: "Lijili",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Lijili",
  lc: "mgi",
  ld: "ltr",
  alt: ["Koro Lafia", "Koro of Lafia", "Ligili", "Megili", "Mijili"],
  cc: ["NG"]
}, {
  pk: 3812,
  ang: "Abureni",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Abureni",
  lc: "mgj",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 3813,
  ang: "Mawes",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mawes",
  lc: "mgk",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3814,
  ang: "Maleu-Kilenge",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Maleu-Kilenge",
  lc: "mgl",
  ld: "ltr",
  alt: ["Idne", "Kilenge (Kaitarolea)"],
  cc: ["PG"]
}, {
  pk: 3815,
  ang: "Mambae",
  lr: "Asia",
  gw: false,
  hc: "TL",
  ln: "Mambae",
  lc: "mgm",
  ld: "ltr",
  alt: ["Manbae"],
  cc: ["TL"]
}, {
  pk: 3816,
  ang: "Mbangi",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Mbangi",
  lc: "mgn",
  ld: "ltr",
  alt: ["Mbangui"],
  cc: ["CF"]
}, {
  pk: 3817,
  ang: "Meta\u2019",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Meta'",
  lc: "mgo",
  ld: "ltr",
  alt: ["Bameta", "Batibo", "Chubo", "Menemo-Mogamo", "Metta", "Mitaa", "Moghamo-Menemo", "Muta", "Widikum-Tadkon", "Widekum", "Uta'", "Tiwirkum", "Muywi", "Menemo (Bameta)", "Kugwe", "Iyirikum", "Besi", "Moghamo (Batibo)"],
  cc: ["CM"]
}, {
  pk: 3818,
  ang: "Magar, Eastern",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Eastern Magar",
  lc: "mgp",
  ld: "ltr",
  alt: ["Magari", "Magarkura", "Mangari", "Manggar", "Tanahu", "Nawalparasi", "Gorkha"],
  cc: ["BT", "NP", "IN"]
}, {
  pk: 3819,
  ang: "Malila",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Malila",
  lc: "mgq",
  ld: "ltr",
  alt: ["Ishimalilia", "Kimalila", "Malilia", "Shimalilia"],
  cc: ["TZ"]
}, {
  pk: 3820,
  ang: "Mambwe-Lungu",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Mambwe-Lungu",
  lc: "mgr",
  ld: "ltr",
  alt: ["Ichirungu", "Icilungu", "Icimambwe", "Kilungu", "Kimambwe", "Kirungu", "Lungu (Adong)", "Lungu (Cilungu)", "Mambwe (Ichimambwe)", "Fipa-Mambwe (Kifipa cha Kimambwe)"],
  cc: ["TZ", "ZM"]
}, {
  pk: 3821,
  ang: "Manda",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Manda",
  lc: "mgs",
  ld: "ltr",
  alt: ["Kimanda", "Kinyasa", "Nyasa", "Matumba"],
  cc: ["TZ"]
}, {
  pk: 3822,
  ang: "Mongol",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mongol",
  lc: "mgt",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3823,
  ang: "Mailu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mailu",
  lc: "mgu",
  ld: "ltr",
  alt: ["Magi"],
  cc: ["PG"]
}, {
  pk: 8366,
  ang: "Derebai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Derebai",
  lc: "mgu-x-derebai",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3824,
  ang: "Matengo",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Matengo",
  lc: "mgv",
  ld: "ltr",
  alt: ["Chimatengo", "Kimatengo"],
  cc: ["MZ", "TZ"]
}, {
  pk: 3825,
  ang: "Matumbi",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Matumbi",
  lc: "mgw",
  ld: "ltr",
  alt: ["Kimatumbi", "Kimatuumbi"],
  cc: ["TZ"]
}, {
  pk: 3826,
  ang: "Mbunga",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Mbunga",
  lc: "mgy",
  ld: "ltr",
  alt: ["Kimbunga"],
  cc: ["TZ"]
}, {
  pk: 3827,
  ang: "Mbugwe",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Mbugwe",
  lc: "mgz",
  ld: "ltr",
  alt: ["Kimbugwe", "Mbuwe"],
  cc: ["TZ"]
}, {
  pk: 3828,
  ang: "Marshallese",
  lr: "Pacific",
  gw: false,
  hc: "MH",
  ln: "Kajin M\u0327aje\u013C",
  lc: "mh",
  ld: "ltr",
  alt: ["Ebon"],
  cc: ["MH", "US", "NR"]
}, {
  pk: 3829,
  ang: "Manda",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Manda (India)",
  lc: "mha",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 3830,
  ang: "Mahongwe",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Mahongwe",
  lc: "mhb",
  ld: "ltr",
  alt: [],
  cc: ["GA"]
}, {
  pk: 3831,
  ang: "Mocho",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Mocho",
  lc: "mhc",
  ld: "ltr",
  alt: ["Motocintleco", "Qato'k", "Tuzanteco (Muchu')"],
  cc: ["MX"]
}, {
  pk: 3832,
  ang: "Mbugu",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Mbugu",
  lc: "mhd",
  ld: "ltr",
  alt: ["Kibwyo", "Kimbugu", "Ma'a", "Mbougou", "Wa Maathi", "Wama'a", "Cha ndani", "Cha kawaida"],
  cc: ["TZ"]
}, {
  pk: 3833,
  ang: "Mah Meri",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Besisi",
  lc: "mhe",
  ld: "ltr",
  alt: ["Cellate", "Betise' (Betisek)"],
  cc: ["MY"]
}, {
  pk: 3834,
  ang: "Mamaa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mamaa",
  lc: "mhf",
  ld: "ltr",
  alt: ["Doloman", "Mama"],
  cc: ["PG"]
}, {
  pk: 3835,
  ang: "Margu",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Margu",
  lc: "mhg",
  ld: "ltr",
  alt: ["Ajokoot", "Croker", "Island", "Jaako", "Marrgu", "Raffles Bay", "Terrutong", "Terutong", "Yaako", "Yako"],
  cc: ["AU"]
}, {
  pk: 3836,
  ang: "Ma\u2019di",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Ma'di",
  lc: "mhi",
  ld: "ltr",
  alt: ["Ma'adi", "Ma'diti", "Ma'di Ti", "Adjumani (Oyuwi)", "Burulo"],
  cc: ["SS", "UG"]
}, {
  pk: 3837,
  ang: "Mogholi",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Mogholi",
  lc: "mhj",
  ld: "ltr",
  alt: ["Moghol", "Mogol", "Mogul", "Mongul"],
  cc: ["AF"]
}, {
  pk: 3838,
  ang: "Mungaka",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mungaka",
  lc: "mhk",
  ld: "ltr",
  alt: ["Bali", "Li", "Munga'ka", "Ngaaka", "Nga'ka", "Bali Nyonga (Bali)", "Nde (Bandeng)", "Ti (Bati)"],
  cc: ["CM"]
}, {
  pk: 3839,
  ang: "Mauwake",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mauwake",
  lc: "mhl",
  ld: "ltr",
  alt: ["Mawake", "Ulingan"],
  cc: ["PG"]
}, {
  pk: 3840,
  ang: "Makhuwa-Moniga",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Makhuwa-Moniga",
  lc: "mhm",
  ld: "ltr",
  alt: ["Emakhuwa-Emoniga", "Emoniga", "Moniga"],
  cc: ["MZ"]
}, {
  pk: 3841,
  ang: "M\xF3cheno",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "M\xF3cheno",
  lc: "mhn",
  ld: "ltr",
  alt: ["Frassilongo (Gereut)", "Pal\xFA (Palai)", "Fierozzo (Florutz)"],
  cc: ["IT"]
}, {
  pk: 3842,
  ang: "Mashi",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Mashi (Zambia)",
  lc: "mho",
  ld: "ltr",
  alt: ["Kamaxi", "Masi"],
  cc: ["ZM", "NA"]
}, {
  pk: 3843,
  ang: "Malay, Balinese",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Balinese Malay",
  lc: "mhp",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3844,
  ang: "Mandan",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Mandan",
  lc: "mhq",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 3845,
  ang: "Mari, Meadow",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0412\u043E\u0441\u0442\u043E\u0447\u043D\u044B\u0439 \u041C\u0430\u0440\u0438\u0439\u0441\u043A\u0438\u0439",
  lc: "mhr",
  ld: "ltr",
  alt: ["Cheremis", "Eastern Mari", "Low Mari", "Lugovo Mari", "Mari", "Mari-Woods", "Sernur-Morkin", "Volga", "Yoshkar-Olin", "Grassland Mari (Meadow Mari)"],
  cc: ["KZ", "TJ", "RU", "TM", "UZ"]
}, {
  pk: 3846,
  ang: "Buru",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Buru (Indonesia)",
  lc: "mhs",
  ld: "ltr",
  alt: ["Boeroe", "Buruese", "Wae Geren", "Wae Sama (Waesama)", "Tomahu", "Masarete (South Buru)", "Fogi (Li Emteban)", "Central Buru (Rana)", "Wae Kabo"],
  cc: ["ID"]
}, {
  pk: 3847,
  ang: "Mandahuaca",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "Mandahuaca",
  lc: "mht",
  ld: "ltr",
  alt: ["Arihini", "Cunipusana", "Ihini", "Maldavaca", "Mandauaca", "Mandawaka", "Mitua", "Yavita"],
  cc: ["BR", "VE"]
}, {
  pk: 3848,
  ang: "Digaro-Mishmi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Digaro-Mishmi",
  lc: "mhu",
  ld: "ltr",
  alt: ["Darang", "Darang Dengyu", "Digaro", "Darang Deng", "Mishmi", "Taaon", "Taraon", "Taying"],
  cc: ["CN", "IN"]
}, {
  pk: 3849,
  ang: "Mbukushu",
  lr: "Africa",
  gw: false,
  hc: "NA",
  ln: "Mbukushu",
  lc: "mhw",
  ld: "ltr",
  alt: ["Cusso", "Gova", "Kuso", "Mambukush", "Mampukush", "Mbukuhu", "Mbukushi", "Thimbukushu", "Kusso", "Thimukushu"],
  cc: ["ZM", "AO", "BW", "NA"]
}, {
  pk: 3850,
  ang: "Lhao Vo",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Lhao Vo",
  lc: "mhx",
  ld: "ltr",
  alt: ["Diso", "Lang'e", "Langwa", "Laungaw", "Laungwaw", "Lawng", "Liangsu", "Malu", "Matu", "Nyky", "Zi", "Lang", "Langsu", "Lhaovo", "Mulu"],
  cc: ["CN", "MM"]
}, {
  pk: 3851,
  ang: "Ma\u2019anyan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ma'anyan",
  lc: "mhy",
  ld: "ltr",
  alt: ["Ma'anjan", "Maanyak Dayak", "Samihim (Buluh Kuning)", "Sihong (Siong)"],
  cc: ["ID"]
}, {
  pk: 7900,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Balangan",
  lc: "mhy-x-balangan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3852,
  ang: "Mor",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mor (Mor Islands)",
  lc: "mhz",
  ld: "ltr",
  alt: ["Austronesian Mor"],
  cc: ["ID"]
}, {
  pk: 3853,
  ang: "M\u0101ori",
  lr: "Pacific",
  gw: false,
  hc: "NZ",
  ln: "te reo M\u0101ori",
  lc: "mi",
  ld: "ltr",
  alt: ["New Zealand Maori"],
  cc: ["NZ", "TO", "US", "AU"]
}, {
  pk: 3854,
  ang: "Miami",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Miami",
  lc: "mia",
  ld: "ltr",
  alt: ["Illinois", "Miami-Illinois", "Miami-Myaamia", "Peoria"],
  cc: ["US"]
}, {
  pk: 3855,
  ang: "Mixtec, Atatl\xE1huca",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Atatl\xE1huca Mixtec",
  lc: "mib",
  ld: "ltr",
  alt: ["Mixteco de San Esteban Atatl\xE1huca", "South Central Tlaxiaco Mixtec"],
  cc: ["MX"]
}, {
  pk: 3856,
  ang: "Micmac",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Mi'kmaq",
  lc: "mic",
  ld: "ltr",
  alt: ["Mi'gmaq", "Miigmao", "Mi'kmaq", "Restigouche", "Mi'gmaw", "Mi'kmaw"],
  cc: ["US", "CA"]
}, {
  pk: 3857,
  ang: "Mandaic",
  lr: "Asia",
  gw: false,
  hc: "IQ",
  ln: "\u0631\u0637\u0646\u0629",
  lc: "mid",
  ld: "ltr",
  alt: ["Mandaean", "Mandi", "Mandini", "Modern Mandaic", "Neo-Mandaic", "Sabean", "Sabe'in", "Subbi", "Shushtar (Shustar)", "Ahwaz (Ahvaz)"],
  cc: ["IQ"]
}, {
  pk: 3858,
  ang: "Mixtec, Ocotepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Ocotepec Mixtec",
  lc: "mie",
  ld: "ltr",
  alt: ["Mixteco de Santo Tom\xE1s Ocotepec", "Mixteco de Sierra Sur Noroeste", "Ocotepec Mixtec"],
  cc: ["MX"]
}, {
  pk: 3859,
  ang: "Mofu-Gudur",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mofu-Gudur",
  lc: "mif",
  ld: "ltr",
  alt: ["Mofou", "Mofou de Goudour", "Mofu South", "Mofu-Sud", "Massagal (Massakal)"],
  cc: ["CM"]
}, {
  pk: 3860,
  ang: "Mixtec, San Miguel el Grande",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "San Miguel El Grande Mixtec",
  lc: "mig",
  ld: "ltr",
  alt: ["Mixteco de San Pedro Molinos", "Mixteco del Sur Bajo"],
  cc: ["MX"]
}, {
  pk: 3861,
  ang: "Mixtec, Chayuco",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Chayuco Mixtec",
  lc: "mih",
  ld: "ltr",
  alt: ["Eastern Jamiltepec-Chayuco Mixtec", "Mixteco de Chayucu", "Mecho\xE1n"],
  cc: ["MX"]
}, {
  pk: 3862,
  ang: "Mixtec, Chigmecatitl\xE1n",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Chigmecatitl\xE1n Mixtec",
  lc: "mii",
  ld: "ltr",
  alt: ["Central Puebla Mixtec", "Mixteco de la Frontera Puebla-Oaxaca", "Mixteco de Santa Mar\xEDa Chigmecatitl\xE1n"],
  cc: ["MX"]
}, {
  pk: 3863,
  ang: "Mungbam",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Abar",
  lc: "mij",
  ld: "ltr",
  alt: ["Abar", "Ngun", "Biya", "Missong", "Munken"],
  cc: ["CM"]
}, {
  pk: 3864,
  ang: "Mikasuki",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Mikasuki",
  lc: "mik",
  ld: "ltr",
  alt: ["Miccosukee", "Mikasuki Seminole"],
  cc: ["US"]
}, {
  pk: 3865,
  ang: "Mixtec, Pe\xF1oles",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Pe\xF1oles Mixtec",
  lc: "mil",
  ld: "ltr",
  alt: ["Eastern Mixtec", "Mixteco de Santa Mar\xEDa Pe\xF1oles"],
  cc: ["MX"]
}, {
  pk: 3866,
  ang: "Mixtec, Alacatlatzala",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Alacatlatzala Mixtec",
  lc: "mim",
  ld: "ltr",
  alt: ["Highland Guerrero Mixtec", "Mixteco de Alacatlatzala", "To'on Savi", "Potoichan (Ocuapa)", "Cuatzoquitengo", "Atlamajalcingo del Monte", "Cahuatache Tototepec"],
  cc: ["MX"]
}, {
  pk: 3867,
  ang: "Minangkabau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Minangkabau",
  lc: "min",
  ld: "ltr",
  alt: ["Minang", "Padang", "Aneuk Jamee (Jamee)", "Pancuang Soal (Muko-Muko)", "Penghulu"],
  cc: ["ID"]
}, {
  pk: 3868,
  ang: "Mixtec, Pinotepa Nacional",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Pinotepa Nacional Mixtec",
  lc: "mio",
  ld: "ltr",
  alt: ["Coastal Mixtec", "Lowland Jicaltepec Mixtec", "Mixteco de Pinotepa Nacional", "Western Jamiltepec Mixtec"],
  cc: ["MX"]
}, {
  pk: 3869,
  ang: "Mixtec, Apasco-Apoala",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Apasco-Apoala Mixtec",
  lc: "mip",
  ld: "ltr",
  alt: ["Apasco Mixtec", "Apoala Mixtec", "Mixteco de Santiago Apoala", "Northern Nochixtl\xE1n Mixtec"],
  cc: ["MX"]
}, {
  pk: 3870,
  ang: "M\xEDskito",
  lr: "Americas",
  gw: false,
  hc: "NI",
  ln: "M\xEDskito",
  lc: "miq",
  ld: "ltr",
  alt: ["Marquito", "M\xEDskitu", "M\xEDsquito", "Mosquito", "Baymuna (Baldam)", "Baymunana", "Cabo (Kabo)", "Honduran M\xEDskito (Mam)", "Tawira (Tauira)", "Wanki (Wangki)"],
  cc: ["HN", "US", "NI"]
}, {
  pk: 3871,
  ang: "Mixe, Isthmus",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Isthmus Mixe",
  lc: "mir",
  ld: "ltr",
  alt: ["Eastern Mixe", "Guichicovi Mixe", "Mixe del Istmo"],
  cc: ["MX"]
}, {
  pk: 3872,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Uncoded languages",
  lc: "mis",
  ld: "ltr",
  alt: [],
  cc: ["CN", "GY", "LA", "SS", "NP", "KH"]
}, {
  pk: 3873,
  ang: "Mixtec, Southern Puebla",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Southern Puebla Mixtec",
  lc: "mit",
  ld: "ltr",
  alt: ["Acatl\xE1n Mixtec", "Mixteco de la Frontera Puebla-Oaxaca", "Mixteco del Sur de Puebla"],
  cc: ["MX"]
}, {
  pk: 3874,
  ang: "Mixtec, Cacaloxtepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Cacaloxtepec Mixtec",
  lc: "miu",
  ld: "ltr",
  alt: ["Huajuapan Mixtec", "Mixteco de Cacaloxtepec"],
  cc: ["MX"]
}, {
  pk: 3875,
  ang: "Akoye",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Akoye",
  lc: "miw",
  ld: "ltr",
  alt: ["Akoinkake", "Akoyi", "Angoya", "Lohiki", "Mai-Hea-Ri", "Maihiri", "Obi"],
  cc: ["PG"]
}, {
  pk: 3876,
  ang: "Mixtec, Mixtepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Mixtepec Mixtec",
  lc: "mix",
  ld: "ltr",
  alt: ["Eastern Juxtlahuaca Mixtec", "Mixteco de Oeste Central", "Mixteco de San Juan Mixtepec"],
  cc: ["MX", "US"]
}, {
  pk: 3877,
  ang: "Mixtec, Ayutla",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Ayutla Mixtec",
  lc: "miy",
  ld: "ltr",
  alt: ["Coastal Guerrero Mixtec", "Mixteco de Ayutla"],
  cc: ["MX"]
}, {
  pk: 3878,
  ang: "Mixtec, Coatzospan",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Coatzospan Mixtec",
  lc: "miz",
  ld: "ltr",
  alt: ["Mixteco de Coatz\xF3span", "Mixteco de San Juan Coatzospan", "Teotitl\xE1n Mixtec"],
  cc: ["MX"]
}, {
  pk: 3879,
  ang: "Mixtec, San Juan Colorado",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "San Juan Colorado Mixtec",
  lc: "mjc",
  ld: "ltr",
  alt: ["Mixteco de Oaxaca de la Costa Noroeste", "Mixteco de San Juan Colorado"],
  cc: ["MX"]
}, {
  pk: 3880,
  ang: "Maidu, Northwest",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Northwest Maidu",
  lc: "mjd",
  ld: "ltr",
  alt: ["Concow", "Hol\xF3lupai", "Konkau", "Konkow", "Maiduan", "Meidoo", "Michopdo", "N\xE1kum", "Secumne", "Sekumne", "Tsamak", "Yuba", "Digger"],
  cc: ["US"]
}, {
  pk: 3881,
  ang: "Tu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u571F\u65CF\u8BED",
  lc: "mjg",
  ld: "ltr",
  alt: ["Mongor", "Mongour", "Monguor", "Naringhol", "Huzhu (Halchighol)", "Minhe (Mangghuer)", "Mongghul"],
  cc: ["CN"]
}, {
  pk: 3882,
  ang: "Mwera",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Mwera",
  lc: "mjh",
  ld: "ltr",
  alt: ["Kimwera", "Nyanza", "Nyasa"],
  cc: ["TZ"]
}, {
  pk: 3883,
  ang: "Kim Mun",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u91D1\u95E8\u65B9\u8A00",
  lc: "mji",
  ld: "ltr",
  alt: ["Chasan Yao", "Gem Mun", "Hainan Miao", "Jim Mun", "Jinmen", "Kem Mun", "Kimmun", "Lan Tin", "Lowland Yao", "Man Lantien", "Men", "Mun", "Shanzi Yao", "Man Lan-Tien", "Coc Mun", "Dao Ao Dai", "Dao Lam Dinh", "Dao Quan Trang", "Dao Thanh Y", "Great Tunic Yao", "Lan Ten", "Lantin", "Red Trouser Yao", "Dao Ho"],
  cc: ["CN", "LA", "US"]
}, {
  pk: 8168,
  ang: "Dao Ao Dai",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Dao Ao Dai",
  lc: "mji-x-daoaodai",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8387,
  ang: "Lanten",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Lanten",
  lc: "mji-x-lanten",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 3884,
  ang: "Mawak",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mawak",
  lc: "mjj",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3885,
  ang: "Matukar",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Matukar",
  lc: "mjk",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3886,
  ang: "Mandeali",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mandeali",
  lc: "mjl",
  ld: "ltr",
  alt: ["Mandi", "Pahari Mandiyali"],
  cc: ["IN"]
}, {
  pk: 3887,
  ang: "Medebur",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Medebur",
  lc: "mjm",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3888,
  ang: "Ma",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ma (Papua New Guinea)",
  lc: "mjn",
  ld: "ltr",
  alt: ["Mawam", "Mina"],
  cc: ["PG"]
}, {
  pk: 3889,
  ang: "Malankuravan",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Malankuravan",
  lc: "mjo",
  ld: "ltr",
  alt: ["Mala Koravan", "Malaikuravan", "Malakkuravan", "Male Kuravan"],
  cc: ["IN"]
}, {
  pk: 3890,
  ang: "Malapandaram",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Malapandaram",
  lc: "mjp",
  ld: "ltr",
  alt: ["Hill Pantaram", "Malapantaram", "Malepantaram", "Pandaram Basha"],
  cc: ["IN"]
}, {
  pk: 3891,
  ang: "Malaryan",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Malaryan",
  lc: "mjq",
  ld: "ltr",
  alt: ["Arayans", "Karingal", "Malai Arayan", "Malayarayan", "Malayarayar", "Male Arayans", "Maley Arayan", "Vazhiyammar"],
  cc: ["IN"]
}, {
  pk: 3892,
  ang: "Malavedan",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Malavedan",
  lc: "mjr",
  ld: "ltr",
  alt: ["Malai Vedan", "Malavetan", "Towetan", "Veda Bhasha", "Vedans", "Vettava Bhasha"],
  cc: ["IN"]
}, {
  pk: 3893,
  ang: "Miship",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Miship",
  lc: "mjs",
  ld: "ltr",
  alt: ["Chip", "Cip", "Ship"],
  cc: ["NG"]
}, {
  pk: 3894,
  ang: "Sauria Paharia",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Sauria Paharia",
  lc: "mjt",
  ld: "ltr",
  alt: ["Malatri", "Maler", "Malti", "Maltu", "Sawriya Malto", "Litipara (Chatgam)"],
  cc: ["IN"]
}, {
  pk: 3895,
  ang: "Manna-Dora",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Manna-Dora",
  lc: "mju",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 3896,
  ang: "Mannan",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mannan",
  lc: "mjv",
  ld: "ltr",
  alt: ["Mannan Pasha", "Manne", "Mannyod"],
  cc: ["IN"]
}, {
  pk: 3897,
  ang: "Karbi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Karbi",
  lc: "mjw",
  ld: "ltr",
  alt: ["Arleng Alam", "Karbi Karbak", "Manchati", "Nihang", "Puta", "Mikir", "Mikiri", "Rongkhang", "Chingthang (Jynthong)", "Mirlong", "Rong Kethang (Rengkhang)"],
  cc: ["IN"]
}, {
  pk: 3898,
  ang: "Mahali",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mahali",
  lc: "mjx",
  ld: "ltr",
  alt: ["Mahili", "Mahle", "Mahli"],
  cc: ["IN"]
}, {
  pk: 3899,
  ang: "Mahican",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Mahican",
  lc: "mjy",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 3900,
  ang: "Majhi",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Majhi",
  lc: "mjz",
  ld: "ltr",
  alt: ["Manjhi", "Sitkha", "Manthali", "Rajgaun"],
  cc: ["NP", "IN"]
}, {
  pk: 3901,
  ang: "Macedonian",
  lr: "Europe",
  gw: false,
  hc: "MK",
  ln: "\u043C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438 \u0458\u0430\u0437\u0438\u043A",
  lc: "mk",
  ld: "ltr",
  alt: ["Macedonian Slavic", "Makedonski"],
  cc: ["GR", "DE", "AL", "MK", "US", "AU", "CA", "IT", "BG"]
}, {
  pk: 3902,
  ang: "Mbre",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Mbre",
  lc: "mka",
  ld: "ltr",
  alt: ["Bere", "Bre", "Pre", "Pre Pisia"],
  cc: ["CI"]
}, {
  pk: 3903,
  ang: "Mal Paharia",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mal Paharia",
  lc: "mkb",
  ld: "ltr",
  alt: ["Dehri", "Mad", "Mader", "Mal", "Mal Pahariya", "Maler", "Malpaharia", "Malti", "Malto", "Maltu", "Manlati", "Mar", "Marpaharia", "Maw", "Mawdo", "Mawer", "Mawer Nondi", "Paharia", "Parsi"],
  cc: ["IN"]
}, {
  pk: 3904,
  ang: "Siliput",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Siliput",
  lc: "mkc",
  ld: "ltr",
  alt: ["Mai", "Maimai", "Sokorok"],
  cc: ["PG"]
}, {
  pk: 3905,
  ang: "Mawchi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mawchi",
  lc: "mke",
  ld: "ltr",
  alt: ["Mavchi", "Mawachi", "Mawchi Bhil", "Mowchi"],
  cc: ["IN"]
}, {
  pk: 3906,
  ang: "Miya",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Miya",
  lc: "mkf",
  ld: "ltr",
  alt: ["Miyawa", "Muya"],
  cc: ["NG"]
}, {
  pk: 3907,
  ang: "Mak",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u83AB\u8BED (China)",
  lc: "mkg",
  ld: "ltr",
  alt: ["Mochiahua", "Mohua", "Mo-Hua", "Mojiahua", "Ching (Cham)"],
  cc: ["CN"]
}, {
  pk: 3908,
  ang: "Dhatki",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u068C\u06AA\u062A\u064A",
  lc: "mki",
  ld: "ltr",
  alt: ["Thar", "Dhati"],
  cc: ["PK"]
}, {
  pk: 3909,
  ang: "Mokilese",
  lr: "Pacific",
  gw: false,
  hc: "FM",
  ln: "Mokilese",
  lc: "mkj",
  ld: "ltr",
  alt: ["Mokil", "Mwoakilese", "Mwoakiloa"],
  cc: ["US", "FM"]
}, {
  pk: 3910,
  ang: "Byep",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Byep",
  lc: "mkk",
  ld: "ltr",
  alt: ["Makya", "Meka", "Mekae", "Mekay", "Mekey", "Mekye", "Mika", "Moka", "North Makaa", "Bindafum", "Besep (Besha)"],
  cc: ["CM"]
}, {
  pk: 3911,
  ang: "Mokole",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Mokole",
  lc: "mkl",
  ld: "ltr",
  alt: ["F\xE9ri", "Mokoll\xE9", "Mokwale"],
  cc: ["BJ"]
}, {
  pk: 3912,
  ang: "Moklen",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Moklen",
  lc: "mkm",
  ld: "ltr",
  alt: ["Chau Pok"],
  cc: ["TH"]
}, {
  pk: 3913,
  ang: "Malay, Kupang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kupang Malay",
  lc: "mkn",
  ld: "ltr",
  alt: ["Basa Kupang"],
  cc: ["ID"]
}, {
  pk: 3914,
  ang: "Mingang Doso",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Mingang Doso",
  lc: "mko",
  ld: "ltr",
  alt: ["Doso", "Munga Doso", "Ngwai Mung\xE0n"],
  cc: ["NG"]
}, {
  pk: 3915,
  ang: "Moikodi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Moikodi",
  lc: "mkp",
  ld: "ltr",
  alt: ["Doriri"],
  cc: ["PG"]
}, {
  pk: 3916,
  ang: "Bay Miwok",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Bay Miwok",
  lc: "mkq",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 3917,
  ang: "Malas",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Malas",
  lc: "mkr",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3918,
  ang: "Mixtec, Silacayoapan",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Silacayoapan Mixtec",
  lc: "mks",
  ld: "ltr",
  alt: [],
  cc: ["MX", "US"]
}, {
  pk: 3919,
  ang: "Vamale",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Vamale",
  lc: "mkt",
  ld: "ltr",
  alt: ["Moaeke", "Pamale"],
  cc: ["NC"]
}, {
  pk: 3920,
  ang: "Maninka, Konyanka",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Konyanka Maninka",
  lc: "mku",
  ld: "ltr",
  alt: ["Konya", "Konyakakan", "Konyanka", "Gbeeka", "Karagba", "Woroduu", "Gbasando"],
  cc: ["GN"]
}, {
  pk: 3921,
  ang: "Mafea",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Mafea",
  lc: "mkv",
  ld: "ltr",
  alt: ["Mavea"],
  cc: ["VU"]
}, {
  pk: 3922,
  ang: "Kituba",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Kituba (Congo)",
  lc: "mkw",
  ld: "ltr",
  alt: ["Kikoongo", "Munukutuba"],
  cc: ["CG"]
}, {
  pk: 3923,
  ang: "Manobo, Kinamiging",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kinamiging Manobo",
  lc: "mkx",
  ld: "ltr",
  alt: ["Cinamiguin", "Kamigin", "Kinamigin", "Manobo"],
  cc: ["PH"]
}, {
  pk: 3924,
  ang: "Makian, East",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "East Makian",
  lc: "mky",
  ld: "ltr",
  alt: ["Makian Dalam", "Makian Timur", "Kayoa (Kajoa)"],
  cc: ["ID"]
}, {
  pk: 3925,
  ang: "Makasae",
  lr: "Asia",
  gw: false,
  hc: "TL",
  ln: "Makasae",
  lc: "mkz",
  ld: "ltr",
  alt: ["Ma'asae", "Macassai", "Makasai", "Maksae", "Maklere"],
  cc: ["TL"]
}, {
  pk: 3926,
  ang: "Malayalam",
  lr: "Asia",
  gw: true,
  hc: "IN",
  ln: "\u0D2E\u0D32\u0D2F\u0D3E\u0D33\u0D02",
  lc: "ml",
  ld: "ltr",
  alt: ["Alealum", "Malayalani", "Malayali", "Malean", "Maliyad", "Mallealle", "Mopla", "Malayal", "Kasargod", "Moplah (Mapilla)"],
  cc: ["IL", "LK", "MY", "OM", "US", "CA", "KW", "MV", "IN", "SG", "MM", "BH", "QA", "AE"]
}, {
  pk: 3927,
  ang: "Malo",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Malo",
  lc: "mla",
  ld: "ltr",
  alt: ["Avunatari (North Malo)", "Tamambo", "Ataripoe (South Malo)"],
  cc: ["VU"]
}, {
  pk: 3928,
  ang: "Mbule",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mbule",
  lc: "mlb",
  ld: "ltr",
  alt: ["Dumbule", "Mbola"],
  cc: ["CM"]
}, {
  pk: 3929,
  ang: "Cao Lan",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Cao Lan",
  lc: "mlc",
  ld: "ltr",
  alt: ["Cao", "Caolan", "Lan-S\xE1n Chi", "San Chay", "San Chi", "S\xE1n-Chi", "M\xE1n", "Man Cao-Lan"],
  cc: ["VN"]
}, {
  pk: 3930,
  ang: "Manambu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Manambu",
  lc: "mle",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3931,
  ang: "Mal",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Mal",
  lc: "mlf",
  ld: "ltr",
  alt: ["Htin", "Khatin", "Thin", "Tin", "T'in", "Ht'in"],
  cc: ["LA"]
}, {
  pk: 3932,
  ang: "Mape",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mape",
  lc: "mlh",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3933,
  ang: "Malimpung",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Malimpung",
  lc: "mli",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3934,
  ang: "Miltu",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Miltu",
  lc: "mlj",
  ld: "ltr",
  alt: ["Miltou"],
  cc: ["TD"]
}, {
  pk: 3935,
  ang: "Kiwilwana",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Ilwana",
  lc: "mlk",
  ld: "ltr",
  alt: ["Ilwana"],
  cc: ["KE"]
}, {
  pk: 3936,
  ang: "Malua Bay",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Malua Bay",
  lc: "mll",
  ld: "ltr",
  alt: ["Espiegle Bay", "Middle Nambas"],
  cc: ["VU"]
}, {
  pk: 3937,
  ang: "Mulam",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4EEB\u4F6C",
  lc: "mlm",
  ld: "ltr",
  alt: ["Abo", "Kyam", "Molao", "Mulao", "Mulao Miao", "Muliao", "Mulou"],
  cc: ["CN"]
}, {
  pk: 3938,
  ang: "Malango",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Malango",
  lc: "mln",
  ld: "ltr",
  alt: ["Teha"],
  cc: ["SB"]
}, {
  pk: 3939,
  ang: "Mlomp",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Mlomp",
  lc: "mlo",
  ld: "ltr",
  alt: ["Gulompaay", "Mlomp North"],
  cc: ["SN"]
}, {
  pk: 3940,
  ang: "Bargam",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bargam",
  lc: "mlp",
  ld: "ltr",
  alt: ["Mugil", "Saker"],
  cc: ["PG"]
}, {
  pk: 3941,
  ang: "Maninkakan, Western",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Western Maninkakan",
  lc: "mlq",
  ld: "ltr",
  alt: ["Malinka", "Northwestern Maninka", "Western Malinke", "Maninga", "Maninka-Western", "Kyakanke", "Diakkanke", "Jahanka (Diakhanke)", "Jahanque", "Jahonque"],
  cc: ["BF", "ML", "SN", "US"]
}, {
  pk: 3942,
  ang: "Vame",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Vame",
  lc: "mlr",
  ld: "ltr",
  alt: ["Maslava", "Hurzo"],
  cc: ["CM"]
}, {
  pk: 3943,
  ang: "Masalit",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Masalit",
  lc: "mls",
  ld: "ltr",
  alt: ["Kana Masaraka", "Kaana Masala", "Masale", "Masara", "Masaraka", "Massolit", "Masaltang"],
  cc: ["SD", "TD"]
}, {
  pk: 3944,
  ang: "To\u2019abaita",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "To'abaita",
  lc: "mlu",
  ld: "ltr",
  alt: ["Malu", "Malu'u", "To'ambaita", "Toqabaqita"],
  cc: ["SB"]
}, {
  pk: 3945,
  ang: "Mwotlap",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Motlav",
  lc: "mlv",
  ld: "ltr",
  alt: ["Motalava", "Dagmel", "Valuwa"],
  cc: ["VU"]
}, {
  pk: 3946,
  ang: "Moloko",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Moloko",
  lc: "mlw",
  ld: "ltr",
  alt: ["Mokyo", "Molko", "Molkoa", "Molkwo", "Molokwo"],
  cc: ["CM"]
}, {
  pk: 3947,
  ang: "Na\u2019ahai",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Malfaxal",
  lc: "mlx",
  ld: "ltr",
  alt: ["Malvaxal-Toman Island", "Taman", "Tomman", "Milip", "Orierh (Na'ahai)", "Toman"],
  cc: ["VU"]
}, {
  pk: 3948,
  ang: "Malaynon",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Malaynon",
  lc: "mlz",
  ld: "ltr",
  alt: [],
  cc: ["PH"]
}, {
  pk: 3949,
  ang: "Mama",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Mama",
  lc: "mma",
  ld: "ltr",
  alt: ["Kantana", "Kwarra"],
  cc: ["NG"]
}, {
  pk: 3950,
  ang: "Momina",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Momina",
  lc: "mmb",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 3951,
  ang: "Mazahua, Michoac\xE1n",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Michoac\xE1n Mazahua",
  lc: "mmc",
  ld: "ltr",
  alt: ["Mazahua de occidente"],
  cc: ["MX"]
}, {
  pk: 3952,
  ang: "Maonan",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6BDB\u5357\u8BED",
  lc: "mmd",
  ld: "ltr",
  alt: ["Ai Nan"],
  cc: ["CN"]
}, {
  pk: 3953,
  ang: "Mae",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Mae",
  lc: "mme",
  ld: "ltr",
  alt: ["Dirak"],
  cc: ["VU"]
}, {
  pk: 3954,
  ang: "Mundat",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Mundat",
  lc: "mmf",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 3955,
  ang: "Ambrym, North",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "North Ambrym",
  lc: "mmg",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 3956,
  ang: "Mehin\xE1ku",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Mehin\xE1ku",
  lc: "mmh",
  ld: "ltr",
  alt: ["Mahinaku", "Mehinaco", "Mehinako", "Minaco", "Waur\xE1-kum\xE1"],
  cc: ["BR"]
}, {
  pk: 3957,
  ang: "Musar",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Musar",
  lc: "mmi",
  ld: "ltr",
  alt: ["Aregerek"],
  cc: ["PG"]
}, {
  pk: 3958,
  ang: "Majhwar",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Majhwar",
  lc: "mmj",
  ld: "ltr",
  alt: ["Majhvar", "Manjhi", "Manjhia"],
  cc: ["IN"]
}, {
  pk: 3959,
  ang: "Mukha-Dora",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mukha-Dora",
  lc: "mmk",
  ld: "ltr",
  alt: ["Conta-Reddi", "Mukha Dhora", "Nooka Dora", "Reddi", "Reddi-Dora", "Riddi"],
  cc: ["IN"]
}, {
  pk: 3960,
  ang: "Man Met",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u514B\u8511\u8BDD",
  lc: "mml",
  ld: "ltr",
  alt: ["Manmi"],
  cc: ["CN"]
}, {
  pk: 3961,
  ang: "Maii",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Maii",
  lc: "mmm",
  ld: "ltr",
  alt: ["Mae-Morae", "Mafilau", "Mkir"],
  cc: ["VU"]
}, {
  pk: 3962,
  ang: "Mamanwa",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Mamanwa",
  lc: "mmn",
  ld: "ltr",
  alt: ["Mamanwa Negrito", "Minamanwa"],
  cc: ["PH"]
}, {
  pk: 3963,
  ang: "Buang, Mangga",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mangga Buang",
  lc: "mmo",
  ld: "ltr",
  alt: ["Kaidemui", "Manga Buang"],
  cc: ["PG"]
}, {
  pk: 3964,
  ang: "Siawi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Siawi",
  lc: "mmp",
  ld: "ltr",
  alt: ["Musa", "Musan", "Siafli", "Siwai"],
  cc: ["PG"]
}, {
  pk: 3965,
  ang: "Musak",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Musak",
  lc: "mmq",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3966,
  ang: "Miao, Western Xiangxi",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u897F\u90E8\u6B21\u65B9\u8A00",
  lc: "mmr",
  ld: "ltr",
  alt: ["Eastern Miao", "Ghao-Xong", "Hsianghsi Miao", "Meo Do", "Northern Miao", "Red Meo", "Red Miao", "West Hunan Miao", "Western Ghao-Xong", "Western West-Hunan Miao"],
  cc: ["CN"]
}, {
  pk: 3967,
  ang: "Malalamai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Malalamai",
  lc: "mmt",
  ld: "ltr",
  alt: ["Bonga", "Garpunei"],
  cc: ["PG"]
}, {
  pk: 3968,
  ang: "Mmaala",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mmaala",
  lc: "mmu",
  ld: "ltr",
  alt: ["Benyi", "Central Yambassa", "Mmala", "Numaala", "Nukitia", "Nuenie"],
  cc: ["CM"]
}, {
  pk: 3969,
  ang: "Miriti",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Miriti",
  lc: "mmv",
  ld: "ltr",
  alt: ["Miriti Tapuyo", "Miriti-Tapuia", "Mirity-Tapuya", "Neeno\xE1"],
  cc: ["BR"]
}, {
  pk: 3970,
  ang: "Emae",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Emae",
  lc: "mmw",
  ld: "ltr",
  alt: ["Emai", "Emwae", "Mae", "Mai", "Mwae"],
  cc: ["VU"]
}, {
  pk: 3971,
  ang: "Madak",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Madak",
  lc: "mmx",
  ld: "ltr",
  alt: ["Mandak"],
  cc: ["PG"]
}, {
  pk: 3972,
  ang: "Migaama",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Migaama",
  lc: "mmy",
  ld: "ltr",
  alt: ["Dionkor", "Djonkor", "Djonkor Abou", "Dyongor", "Jongor", "Migama", "Telfane", "Dambiya (Ndambiya)"],
  cc: ["TD"]
}, {
  pk: 3973,
  ang: "Mabaale",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Mabaale",
  lc: "mmz",
  ld: "ltr",
  alt: ["Lomabaale", "Mabale", "Mbali", "Lobo (Balobo)", "Mbinga", "Banza"],
  cc: ["CD"]
}, {
  pk: 3974,
  ang: "Mongolian",
  lr: "Asia",
  gw: true,
  hc: "MN",
  ln: "\u041C\u043E\u043D\u0433\u043E\u043B \u0445\u044D\u043B",
  lc: "mn",
  ld: "ltr",
  alt: [],
  cc: ["MN"]
}, {
  pk: 3975,
  ang: "Mbula",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mbula",
  lc: "mna",
  ld: "ltr",
  alt: ["Mangaaba", "Mangaava", "Mangaawa", "Mangap", "Mangap-Mbula", "Mbula (Central Mbula)"],
  cc: ["PG"]
}, {
  pk: 3976,
  ang: "Muna",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Muna",
  lc: "mnb",
  ld: "ltr",
  alt: ["Wuna", "Laompo", "Standard Muna (Northern Muna)", "Gu", "Mawasangka", "Tiworo (Eastern Muna)", "Lakudo", "Katobengke", "Kadatua", "Burukene", "Kapontori"],
  cc: ["ID"]
}, {
  pk: 3977,
  ang: "Manchu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6EE1\u8BED",
  lc: "mnc",
  ld: "ltr",
  alt: ["Man", "Alechuxa", "Bala", "Jing", "Lalin"],
  cc: ["CN"]
}, {
  pk: 3978,
  ang: "Mond\xE9",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Mond\xE9",
  lc: "mnd",
  ld: "ltr",
  alt: ["Salam\xE3i", "Salamaik\xE3", "Sanamaica", "Sanamaik\xE1", "Sanamayk\xE3"],
  cc: ["BR"]
}, {
  pk: 3979,
  ang: "Naba",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Naba",
  lc: "mne",
  ld: "ltr",
  alt: ["Ma", "Bilala (Bilaala)", "Medogo (Modogo)", "Mud", "Mage", "Kuka (Kouka)", "Boulala", "Lisi", "Bulala"],
  cc: ["TD"]
}, {
  pk: 3980,
  ang: "Mundani",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mundani",
  lc: "mnf",
  ld: "ltr",
  alt: ["Bamumbo (Bamumbu)", "Iguambo (Igumbo)", "Nko (Nkong)"],
  cc: ["CM"]
}, {
  pk: 3981,
  ang: "Mnong, Eastern",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Eastern Mnong",
  lc: "mng",
  ld: "ltr",
  alt: ["Mnong Gar (Gar)", "Rolom", "Rolam", "Mnong Rolom (Ralam)", "Rlam"],
  cc: ["VN"]
}, {
  pk: 3982,
  ang: "Mono",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Mono (Democratic Republic of Congo)",
  lc: "mnh",
  ld: "ltr",
  alt: ["Amono"],
  cc: ["CD"]
}, {
  pk: 3983,
  ang: "Meitei",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Manipuri",
  lc: "mni",
  ld: "ltr",
  alt: ["Meetei", "Meithei", "Kathe", "Kathi", "Meiteilon", "Meiteiron", "Meithe", "Menipuri", "Mitei", "Mithe", "Ponna", "Panan", "Loi (Chakpa)", "Pangan (Pangal)", "Pangal (Manipuri Muslim)", "Hindu Meitei", "Panal"],
  cc: ["BD", "IN", "MM"]
}, {
  pk: 3984,
  ang: "Munji",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Munji",
  lc: "mnj",
  ld: "ltr",
  alt: ["Munjigi", "Munjiwar"],
  cc: ["AF"]
}, {
  pk: 3985,
  ang: "Mandinka",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Mandinka",
  lc: "mnk",
  ld: "ltr",
  alt: ["Mand\xE9", "Manding", "Mandingo", "Mandinque", "Soc\xE9", "Mandinga", "Mandingue", "Mande"],
  cc: ["BJ", "FR", "GM", "GH", "SN", "US", "GW"]
}, {
  pk: 3986,
  ang: "Tiale",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Tiale",
  lc: "mnl",
  ld: "ltr",
  alt: ["Malmariv"],
  cc: ["VU"]
}, {
  pk: 3987,
  ang: "Mapena",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mapena",
  lc: "mnm",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 3988,
  ang: "Mnong, Southern",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Southern Mnong",
  lc: "mnn",
  ld: "ltr",
  alt: [],
  cc: ["VN"]
}, {
  pk: 3989,
  ang: "Chinese, Min Bei",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u95FD\u5317",
  lc: "mnp",
  ld: "ltr",
  alt: ["Min Pei", "Northern Min", "Hokchia (Hockchew)"],
  cc: ["CN", "SG"]
}, {
  pk: 3990,
  ang: "Minriq",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Minriq",
  lc: "mnq",
  ld: "ltr",
  alt: ["Mendriq", "Menraq", "Menrik", "Menriq"],
  cc: ["MY"]
}, {
  pk: 3991,
  ang: "Mono",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Mono (USA)",
  lc: "mnr",
  ld: "ltr",
  alt: ["Eastern Mono", "Western Mono"],
  cc: ["US"]
}, {
  pk: 3992,
  ang: "Mansi",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041C\u0430\u043D\u0441\u0438\u0439\u0441\u043A\u0438\u0439",
  lc: "mns",
  ld: "ltr",
  alt: ["Mansiy", "Vogul", "Vogulich", "Voguly", "Sos'va", "Sosyvin", "Western Mansi", "Vagily", "Sygva", "Western Vogul (Lower Lozyvin)", "Ob'", "Northern Vogul (Northern Mansi)", "Middle Lozyvin", "Kondin", "Eastern Vogul (Eastern Mansi)", "Upper Lozyvin", "Pelym"],
  cc: ["RU"]
}, {
  pk: 3993,
  ang: "Mer",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mer",
  lc: "mnu",
  ld: "ltr",
  alt: ["Muri"],
  cc: ["ID"]
}, {
  pk: 3994,
  ang: "Rennell-Bellona",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Rennell-Bellona",
  lc: "mnv",
  ld: "ltr",
  alt: ["Rennell", "Rennellese-Bellonese", "Bellonese", "Mugiki", "Munggava (Mugaba)", "Mungiki (Bellona)"],
  cc: ["SB"]
}, {
  pk: 3995,
  ang: "Mon",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Mon",
  lc: "mnw",
  ld: "ltr",
  alt: ["Aleng", "Mou", "Mun", "Peguan", "Raman", "Rman", "Rmen", "Talaing", "Taleng", "Teguan", "Pegu (Mon Tang)", "Southern Mon", "Mon Te", "Martaban-Moulmein (Central Mon)", "Northern Mon", "Ye (Mon Nya)"],
  cc: ["TH", "MM"]
}, {
  pk: 3996,
  ang: "Manikion",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Manikion",
  lc: "mnx",
  ld: "ltr",
  alt: ["Mantion", "Sogh", "Sougb"],
  cc: ["ID"]
}, {
  pk: 3997,
  ang: "Manyawa",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Manyawa",
  lc: "mny",
  ld: "ltr",
  alt: [],
  cc: ["MZ"]
}, {
  pk: 3998,
  ang: "Moni",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Moni",
  lc: "mnz",
  ld: "ltr",
  alt: ["Djonggunu", "Jonggunu", "Migani", "Awembak (Awembiak)"],
  cc: ["ID"]
}, {
  pk: 3999,
  ang: "Mwan",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Mwan",
  lc: "moa",
  ld: "ltr",
  alt: ["Mona", "Mouan", "Muan", "Muana", "Mwa"],
  cc: ["CI"]
}, {
  pk: 4000,
  ang: "Mocov\xED",
  lr: "Americas",
  gw: false,
  hc: "AR",
  ln: "Mocov\xED",
  lc: "moc",
  ld: "ltr",
  alt: ["Mbocob\xED", "Mocob\xED"],
  cc: ["AR"]
}, {
  pk: 4001,
  ang: "Mobilian",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Mobilian",
  lc: "mod",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 4002,
  ang: "Montagnais",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Montagnais",
  lc: "moe",
  ld: "ltr",
  alt: ["Innu", "Innu Aimun", "Western Montagnais"],
  cc: ["CA"]
}, {
  pk: 4003,
  ang: "Mongondow",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mongondow",
  lc: "mog",
  ld: "ltr",
  alt: ["Bolang-Mogondo", "Minahassa", "Mongondou", "Passi"],
  cc: ["ID"]
}, {
  pk: 7707,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Boroko",
  lc: "mog-x-boroko",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4004,
  ang: "Mohawk",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Mohawk",
  lc: "moh",
  ld: "ltr",
  alt: ["Kanien'k\xE9ha"],
  cc: ["US", "CA"]
}, {
  pk: 4005,
  ang: "Mboi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Mboi",
  lc: "moi",
  ld: "ltr",
  alt: ["Gena", "Mboire", "Mboyi"],
  cc: ["NG"]
}, {
  pk: 4006,
  ang: "Monzombo",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Monzombo",
  lc: "moj",
  ld: "ltr",
  alt: ["Mono-Jembo", "Monzumbo", "Mondjembo", "Munzombo"],
  cc: ["CF", "CG"]
}, {
  pk: 4007,
  ang: "Morori",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Morori",
  lc: "mok",
  ld: "ltr",
  alt: ["Marori", "Moaraeri", "Moraori", "Morari"],
  cc: ["ID"]
}, {
  pk: 4008,
  ang: "Mangue",
  lr: "Americas",
  gw: false,
  hc: "NI",
  ln: "Mangue",
  lc: "mom",
  ld: "ltr",
  alt: ["Monimbo"],
  cc: ["NI"]
}, {
  pk: 4009,
  ang: "Monom",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Monom",
  lc: "moo",
  ld: "ltr",
  alt: ["Bonom", "Menam", "Monam"],
  cc: ["VN"]
}, {
  pk: 4010,
  ang: "Maya, Mop\xE1n",
  lr: "Americas",
  gw: false,
  hc: "BZ",
  ln: "Mop\xE1n Maya",
  lc: "mop",
  ld: "ltr",
  alt: ["Maya Mop\xE1n", "Mopane"],
  cc: ["BZ", "GT"]
}, {
  pk: 4011,
  ang: "Mor",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mor (Bomberai Peninsula)",
  lc: "moq",
  ld: "ltr",
  alt: ["Mor2"],
  cc: ["ID"]
}, {
  pk: 4012,
  ang: "Moro",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Moro",
  lc: "mor",
  ld: "ltr",
  alt: ["Dhimorong", "Umm Gabralla (Toberelda)", "Umm Dorein (Longorban)"],
  cc: ["SD"]
}, {
  pk: 4013,
  ang: "M\xF2or\xE9",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Mossi",
  lc: "mos",
  ld: "ltr",
  alt: ["Mole", "Moose", "More", "Moshi", "Mossi", "Zaore (Joore)", "Yanga (Jaan)", "Yana (Jaan)", "Yan", "Yam", "Yaan", "Ouagadougou", "Timbou"],
  cc: ["BJ", "BF", "GH", "ML", "NE", "US", "TG", "CA"]
}, {
  pk: 4014,
  ang: "Bar\xED",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Bar\xED",
  lc: "mot",
  ld: "ltr",
  alt: ["Barira", "Cunausaya", "Dobocubi", "Motil\xF3n", "Motilone"],
  cc: ["VE", "CO", "US"]
}, {
  pk: 4015,
  ang: "Mogum",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Mogum",
  lc: "mou",
  ld: "ltr",
  alt: ["Mogoum", "Kofa (Koffa)", "Mogum D\xE9l\xE9"],
  cc: ["TD"]
}, {
  pk: 4016,
  ang: "Mohave",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Mohave",
  lc: "mov",
  ld: "ltr",
  alt: ["Mojave"],
  cc: ["US"]
}, {
  pk: 4017,
  ang: "Moi",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Moi (Congo)",
  lc: "mow",
  ld: "ltr",
  alt: [],
  cc: ["CG"]
}, {
  pk: 4018,
  ang: "Molima",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Molima",
  lc: "mox",
  ld: "ltr",
  alt: ["Ebadidi", "Fagululu", "Salakahadi", "Tola'ai"],
  cc: ["PG"]
}, {
  pk: 4019,
  ang: "Shekkacho",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Shekkacho",
  lc: "moy",
  ld: "ltr",
  alt: ["Mocha", "Shakacho", "Shekka"],
  cc: ["ET"]
}, {
  pk: 4020,
  ang: "Mokilko",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Mokilko",
  lc: "moz",
  ld: "ltr",
  alt: ["Diongor Guera", "Djonkor Guera", "Dyongor Guera", "Gergiko", "Guerguiko", "Jonkor-Gera", "Mokoulou", "Mokulu", "Doliki"],
  cc: ["TD"]
}, {
  pk: 4021,
  ang: "Mpoto",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Mpoto",
  lc: "mpa",
  ld: "ltr",
  alt: ["Chimpoto", "Kimpoto", "Kinyasa", "Nyasa"],
  cc: ["TZ"]
}, {
  pk: 4022,
  ang: "Mullukmulluk",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Mullukmulluk",
  lc: "mpb",
  ld: "ltr",
  alt: ["Malagmalag", "Malak-Malak", "Ngolak-Wonga", "Nguluwongga"],
  cc: ["AU"]
}, {
  pk: 4023,
  ang: "Mangarayi",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Mangarayi",
  lc: "mpc",
  ld: "ltr",
  alt: ["Mangarai", "Mangarrayi", "Manggarai", "Mungarai", "Mungerry", "Ngarrabadji"],
  cc: ["AU"]
}, {
  pk: 4024,
  ang: "Machinere",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Machinere",
  lc: "mpd",
  ld: "ltr",
  alt: ["Machineri", "Manchineri", "Maniten\xE9re", "Manitener\xED", "Maxin\xE9ri"],
  cc: ["BR"]
}, {
  pk: 4025,
  ang: "Majang",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Majang",
  lc: "mpe",
  ld: "ltr",
  alt: ["Ajo", "Ato Majang", "Ato Majanger-Onk", "Majanjiro", "Masango", "Masongo", "Ojanjur", "Tama"],
  cc: ["ET"]
}, {
  pk: 4026,
  ang: "Marba",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Marba",
  lc: "mpg",
  ld: "ltr",
  alt: ["Azumeina", "Kolong", "Kulung", "Maraba", "Monogoy"],
  cc: ["TD"]
}, {
  pk: 4027,
  ang: "Maung",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Maung",
  lc: "mph",
  ld: "ltr",
  alt: ["Gunmarung", "Gun-Marung", "Mawng", "Mawung"],
  cc: ["AU"]
}, {
  pk: 4028,
  ang: "Mpade",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mpade",
  lc: "mpi",
  ld: "ltr",
  alt: ["Makari", "Makary", "Makary Kotoko", "Kotoko-Makari", "Mpade (Makari)", "Shewe (Mani)"],
  cc: ["CM", "TD"]
}, {
  pk: 4029,
  ang: "Martu Wangka",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Martu Wangka",
  lc: "mpj",
  ld: "ltr",
  alt: ["Mardo", "Targudi", "Manyjilyjarra", "Yulparitja (Yilparitja)", "Yulparija", "Yulbaridja", "Wangkajunga (Wangkajungka)", "Puditara (Budidjara)", "Manyjilyjara (Mantjiltjara)", "Gardudjara", "Kartutjara", "Putujara", "Kartujarra (Gagudjara)", "Kardutjarra", "Kardutjara", "Kadaddjara", "Kiadjara"],
  cc: ["AU"]
}, {
  pk: 4030,
  ang: "Mbara",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Mbara (Chad)",
  lc: "mpk",
  ld: "ltr",
  alt: ["G'kelendeg", "G'kelendeng", "Guelengdeng", "Massa de Guelengdeng"],
  cc: ["TD"]
}, {
  pk: 4031,
  ang: "Watut, Middle",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Middle Watut",
  lc: "mpl",
  ld: "ltr",
  alt: ["Maraliinan", "Maralinan", "Silisili", "Watut"],
  cc: ["PG"]
}, {
  pk: 4032,
  ang: "Mixtec, Yosond\xFAa",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Yosond\xFAa Mixtec",
  lc: "mpm",
  ld: "ltr",
  alt: ["Mixteco de Santiago Yosond\xFAa", "Southern Tlaxiaco Mixtec"],
  cc: ["MX"]
}, {
  pk: 4033,
  ang: "Mindiri",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mindiri",
  lc: "mpn",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4034,
  ang: "Miu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Miu",
  lc: "mpo",
  ld: "ltr",
  alt: ["Myu"],
  cc: ["PG"]
}, {
  pk: 4035,
  ang: "Migabac",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Migabac",
  lc: "mpp",
  ld: "ltr",
  alt: ["Migaba'"],
  cc: ["PG"]
}, {
  pk: 4036,
  ang: "Mat\xEDs",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Mat\xEDs",
  lc: "mpq",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 4037,
  ang: "Vangunu",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Vangunu",
  lc: "mpr",
  ld: "ltr",
  alt: ["Bareke (Mbareke)"],
  cc: ["SB"]
}, {
  pk: 7630,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Bareke",
  lc: "mpr-x-bareke",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4038,
  ang: "Dadibi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Dadibi",
  lc: "mps",
  ld: "ltr",
  alt: ["Daribi", "Karimui"],
  cc: ["PG"]
}, {
  pk: 4039,
  ang: "Mian",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mian",
  lc: "mpt",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4040,
  ang: "Makur\xE1p",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Makur\xE1p",
  lc: "mpu",
  ld: "ltr",
  alt: ["Macur\xE1p", "Macurapi", "Makur\xE1pi", "Massaka"],
  cc: ["BR"]
}, {
  pk: 4041,
  ang: "Mungkip",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mungkip",
  lc: "mpv",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4042,
  ang: "Mapidian",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Mapidian",
  lc: "mpw",
  ld: "ltr",
  alt: ["Mahuayana", "Maiopitian", "Maopityan"],
  cc: ["BR"]
}, {
  pk: 4043,
  ang: "Misima-Panaeati",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Misima-Panaeati",
  lc: "mpx",
  ld: "ltr",
  alt: ["Misiman", "Misima-Paneati", "Panaeati", "Panaieti", "Panayeti", "Paneate", "Paneyate", "Nasikwabw (Tokunu)"],
  cc: ["PG"]
}, {
  pk: 4044,
  ang: "Mpi",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Mpi",
  lc: "mpz",
  ld: "ltr",
  alt: ["Kaw", "Ban Sakoen", "Ban Dong"],
  cc: ["TH"]
}, {
  pk: 4045,
  ang: "Maba",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Maba (Indonesia)",
  lc: "mqa",
  ld: "ltr",
  alt: ["Bitjoli", "Ingli"],
  cc: ["ID"]
}, {
  pk: 4046,
  ang: "Mbuko",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mbuko",
  lc: "mqb",
  ld: "ltr",
  alt: ["Mbokou", "Mboku", "Mbuku"],
  cc: ["CM"]
}, {
  pk: 4047,
  ang: "Mangole",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mangole",
  lc: "mqc",
  ld: "ltr",
  alt: ["Mangoli", "Sula Mangoli"],
  cc: ["ID"]
}, {
  pk: 4048,
  ang: "Matepi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Matepi",
  lc: "mqe",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4049,
  ang: "Momuna",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Momuna",
  lc: "mqf",
  ld: "ltr",
  alt: ["Somage", "Somahai", "Sumohai"],
  cc: ["ID"]
}, {
  pk: 4050,
  ang: "Malay, Kota Bangun Kutai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kota Bangun Kutai Malay",
  lc: "mqg",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 4051,
  ang: "Mixtec, Tlazoyaltepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tlazoyaltepec Mixtec",
  lc: "mqh",
  ld: "ltr",
  alt: ["Mixteco Bajo de Valles", "Mixteco de Santiago Tlazoyaltepec"],
  cc: ["MX"]
}, {
  pk: 4052,
  ang: "Mariri",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mariri",
  lc: "mqi",
  ld: "ltr",
  alt: ["Mairiri"],
  cc: ["ID"]
}, {
  pk: 4053,
  ang: "Mamasa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mamasa",
  lc: "mqj",
  ld: "ltr",
  alt: ["Mamasa Toraja", "Binuang-Paki-Batetanga-Anteapi", "Patta' Binuang", "Pattae' (Binuang)", "Southern Mamasa", "Tae'"],
  cc: ["ID"]
}, {
  pk: 4054,
  ang: "Manobo, Rajah Kabunsuwan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Rajah Kabunsuwan Manobo",
  lc: "mqk",
  ld: "ltr",
  alt: ["Rajah Kabungsuan Manobo"],
  cc: ["PH"]
}, {
  pk: 4055,
  ang: "Mbelime",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Mbelime",
  lc: "mql",
  ld: "ltr",
  alt: ["Mb\xE8lim\xE8", "Mbilme", "M\u2019Berm\xE8", "Niende", "Niend\xE9", "Niendi", "Nyende"],
  cc: ["BJ"]
}, {
  pk: 4056,
  ang: "Marquesan, South",
  lr: "Pacific",
  gw: false,
  hc: "PF",
  ln: "South Marquesan",
  lc: "mqm",
  ld: "ltr",
  alt: ["Tahuata"],
  cc: ["PF"]
}, {
  pk: 4057,
  ang: "Moronene",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Moronene",
  lc: "mqn",
  ld: "ltr",
  alt: ["Maronene", "Wita Ea (Poleang)", "Rumbia", "Tokotu'a (Kabaena)"],
  cc: ["ID"]
}, {
  pk: 4058,
  ang: "Modole",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Modole",
  lc: "mqo",
  ld: "ltr",
  alt: ["Madole"],
  cc: ["ID"]
}, {
  pk: 4059,
  ang: "Manipa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Manipa",
  lc: "mqp",
  ld: "ltr",
  alt: ["Soow Huhelia"],
  cc: ["ID"]
}, {
  pk: 4060,
  ang: "Minokok",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Minokok",
  lc: "mqq",
  ld: "ltr",
  alt: [],
  cc: ["MY"]
}, {
  pk: 4061,
  ang: "Mander",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mander",
  lc: "mqr",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 4062,
  ang: "Makian, West",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "West Makian",
  lc: "mqs",
  ld: "ltr",
  alt: ["Makian Barat", "Makian Luar"],
  cc: ["ID"]
}, {
  pk: 4063,
  ang: "Mok",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "\u0E20\u0E32\u0E29\u0E32\u0E21\u0E4A\u0E2D\u0E01",
  lc: "mqt",
  ld: "ltr",
  alt: ["Amok", "Hsen-Hsum", "Muak", "Muak Sa-aak"],
  cc: ["TH"]
}, {
  pk: 4064,
  ang: "Mandari",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Mandari",
  lc: "mqu",
  ld: "ltr",
  alt: ["Chir", "Kir", "Mondari", "Mundari", "Shir"],
  cc: ["SS"]
}, {
  pk: 4065,
  ang: "Mosimo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mosimo",
  lc: "mqv",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4066,
  ang: "Murupi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Murupi",
  lc: "mqw",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4067,
  ang: "Mamuju",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mamuju",
  lc: "mqx",
  ld: "ltr",
  alt: ["Mamoedjoe", "Mamoedjoesch", "Mamudju", "Udai"],
  cc: ["ID"]
}, {
  pk: 4068,
  ang: "Manggarai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Manggarai",
  lc: "mqy",
  ld: "ltr",
  alt: ["Central Manggarai (Ruteng)"],
  cc: ["ID"]
}, {
  pk: 4069,
  ang: "Pano",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Pano",
  lc: "mqz",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4070,
  ang: "Marathi (Mar\u0101\u1E6Dh\u012B)",
  lr: "Asia",
  gw: true,
  hc: "IN",
  ln: "\u092E\u0930\u093E\u0920\u0940",
  lc: "mr",
  ld: "ltr",
  alt: ["Maharashtra", "Maharathi", "Malhatee", "Marthi", "Muruthu", "Kosti", "Kudali", "Gawdi of Goa", "Nagpuri Marathi", "Kasargod"],
  cc: ["IL", "US", "ZW", "CA", "IN"]
}, {
  pk: 4071,
  ang: "Mlabri",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "\u0E20\u0E32\u0E29\u0E32\u0E21\u0E25\u0E32\u0E1A\u0E23\u0E35",
  lc: "mra",
  ld: "ltr",
  alt: ["Ma Ku", "Mabri", "Mla", "Mla-Bri", "Mrabri", "Yellow Leaf", "Yumbri", "Luang", "Mla Bri", "Phi Thong"],
  cc: ["LA", "TH"]
}, {
  pk: 4072,
  ang: "Marino",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Marino",
  lc: "mrb",
  ld: "ltr",
  alt: ["Naone", "North Maewo", "Sunwadia"],
  cc: ["VU"]
}, {
  pk: 4073,
  ang: "Maricopa",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Maricopa",
  lc: "mrc",
  ld: "ltr",
  alt: ["Cocomaricopa", "Piipaash"],
  cc: ["US"]
}, {
  pk: 4074,
  ang: "Magar, Western",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Western Magar",
  lc: "mrd",
  ld: "ltr",
  alt: ["Magar", "Magari", "Mangar", "Mangari", "Palpa", "Syangja"],
  cc: ["NP"]
}, {
  pk: 4075,
  ang: "Martha's Vineyeard Sign Language",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Martha's Vineyard Sign Language",
  lc: "mre",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 4076,
  ang: "Elseng",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Elseng",
  lc: "mrf",
  ld: "ltr",
  alt: ["Djanggu", "Janggu", "Sawa", "Tabu", "Morwap"],
  cc: ["ID"]
}, {
  pk: 4077,
  ang: "Mising",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mising",
  lc: "mrg",
  ld: "ltr",
  alt: ["Miri", "Takam"],
  cc: ["IN"]
}, {
  pk: 4078,
  ang: "Chin, Mara",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mara Chin",
  lc: "mrh",
  ld: "ltr",
  alt: ["Mara", "Maram", "Mira", "Zao", "Tlongsai (Tlosai-Siaha)"],
  cc: ["IN", "MM"]
}, {
  pk: 4079,
  ang: "Mari, Hill",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041A\u044B\u0440\u044B\u043A \u043C\u0430\u0440\u044B",
  lc: "mrj",
  ld: "ltr",
  alt: ["Cheremis", "Gorno-Mariy", "High Mari", "Mari-Hills", "Western Mari"],
  cc: ["RU"]
}, {
  pk: 4080,
  ang: "Hmwaveke",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Hmwaveke",
  lc: "mrk",
  ld: "ltr",
  alt: ["Ceta", "Faa Ceta", "Moaveke"],
  cc: ["NC"]
}, {
  pk: 4081,
  ang: "Mortlockese",
  lr: "Pacific",
  gw: false,
  hc: "FM",
  ln: "Mortlockese",
  lc: "mrl",
  ld: "ltr",
  alt: ["Mortlock", "Nomoi"],
  cc: ["FM"]
}, {
  pk: 4082,
  ang: "Mwerlap",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Merlav",
  lc: "mrm",
  ld: "ltr",
  alt: ["Merelava", "Merlav", "Merlav-Merig", "Mwerig (Merig)", "West Merelava"],
  cc: ["VU"]
}, {
  pk: 4083,
  ang: "Cheke Holo",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Cheke Holo",
  lc: "mrn",
  ld: "ltr",
  alt: ["A'ara", "Holo", "Kubonitu", "Hograno (Hogirano)", "Maringe (Maringhe)"],
  cc: ["SB"]
}, {
  pk: 4084,
  ang: "Mru",
  lr: "Asia",
  gw: false,
  hc: "BD",
  ln: "Mru",
  lc: "mro",
  ld: "ltr",
  alt: ["Maru", "Mrung", "Mro", "Niopheng", "Dak", "Launghu", "Mrucha", "Mrusa", "Taung Mru", "Sungma", "Sungma/Launghu", "Pongmi", "Tamsa", "Dowpreng", "Anok", "Dowpreng (Doumrong)"],
  cc: ["BD", "MM"]
}, {
  pk: 4085,
  ang: "Morouas",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Morouas",
  lc: "mrp",
  ld: "ltr",
  alt: ["Moruas"],
  cc: ["VU"]
}, {
  pk: 4086,
  ang: "Marquesan, North",
  lr: "Pacific",
  gw: false,
  hc: "PF",
  ln: "North Marquesan",
  lc: "mrq",
  ld: "ltr",
  alt: ["Eo 'Enana"],
  cc: ["US", "PF"]
}, {
  pk: 4087,
  ang: "Maria",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Maria (India)",
  lc: "mrr",
  ld: "ltr",
  alt: ["Hill Maria", "Madi", "Madia", "Madiya", "Modh", "Modi", "Bhamani Maria (Bhamani)", "Abujmariya", "Abujmaria (Abujhmadia)", "Abujmar Maria", "Abujhmaria"],
  cc: ["IN"]
}, {
  pk: 4088,
  ang: "Maragus",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Maragus",
  lc: "mrs",
  ld: "ltr",
  alt: ["Maragaus", "Tape", "Tobah"],
  cc: ["VU"]
}, {
  pk: 4089,
  ang: "Marghi Central",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Marghi Central",
  lc: "mrt",
  ld: "ltr",
  alt: ["Marghi", "Margi", "Lassa (Babal)", "Madube (Gwara)", "Mulgwe (Malgwa)", "Gulak (Dzerngu)"],
  cc: ["NG"]
}, {
  pk: 4090,
  ang: "Mono",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mono (Cameroon)",
  lc: "mru",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 4091,
  ang: "Mangareva",
  lr: "Pacific",
  gw: false,
  hc: "PF",
  ln: "Mangareva",
  lc: "mrv",
  ld: "ltr",
  alt: ["Mangarevan"],
  cc: ["PF"]
}, {
  pk: 4092,
  ang: "Maranao",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Maranao",
  lc: "mrw",
  ld: "ltr",
  alt: ["Maranaw", "Ranao"],
  cc: ["PH"]
}, {
  pk: 4093,
  ang: "Dineor",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Maremgi",
  lc: "mrx",
  ld: "ltr",
  alt: ["Marengge"],
  cc: ["ID"]
}, {
  pk: 7679,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Junu Marathi",
  lc: "mr-x-junu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7572,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Nagpuri Marathi",
  lc: "mr-x-nagpuri",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4094,
  ang: "Mandaya",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Mandaya",
  lc: "mry",
  ld: "ltr",
  alt: ["Davawenyo", "Cataelano", "Sangab", "Mangaragan Mandaya", "Carraga Mandaya", "Cateelenyo", "Manay Mandayan", "Karaga"],
  cc: ["PH"]
}, {
  pk: 8385,
  ang: "Manay",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Manay",
  lc: "mry-x-manay",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4095,
  ang: "Marind",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Marind",
  lc: "mrz",
  ld: "ltr",
  alt: ["Holifoersch"],
  cc: ["ID"]
}, {
  pk: 4096,
  ang: "Malay",
  lr: "Asia",
  gw: true,
  hc: "MY",
  ln: "bahasa Melayu, \u0628\u0647\u0627\u0633 \u0645\u0644\u0627\u064A\u0648\u200E",
  lc: "ms",
  ld: "ltr",
  alt: [],
  cc: ["MY"]
}, {
  pk: 4097,
  ang: "Masbatenyo",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Masbatenyo",
  lc: "msb",
  ld: "ltr",
  alt: ["Masbate\xF1o", "Minasbate"],
  cc: ["PH"]
}, {
  pk: 4098,
  ang: "Maninka, Sankaran",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Sankaran Maninka",
  lc: "msc",
  ld: "ltr",
  alt: ["Faranah", "Sankarankan"],
  cc: ["GN"]
}, {
  pk: 4099,
  ang: "Yucatec Maya Sign Language",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Yucatec Maya Sign Language",
  lc: "msd",
  ld: "ltr",
  alt: ["Nohya Sign Language"],
  cc: ["MX"]
}, {
  pk: 4100,
  ang: "Musey",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Musey",
  lc: "mse",
  ld: "ltr",
  alt: ["Bananna", "Bananna Ho", "Ho", "Mosi", "Moussei", "Musaya", "Musei", "Museyna", "Musiina", "Musoi", "Mussoi", "Mussoy", "Bananna Ho Ho"],
  cc: ["CM", "TD"]
}, {
  pk: 4101,
  ang: "Mekwei",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mekwei",
  lc: "msf",
  ld: "ltr",
  alt: ["Demenggong-Waibron-Bano", "Menggei", "Menggwei", "Moi", "Mooi", "Munggai", "Mungge", "Munkei", "Waipu"],
  cc: ["ID"]
}, {
  pk: 4102,
  ang: "Moraid",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Moraid",
  lc: "msg",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 4103,
  ang: "Malagasy, Masikoro",
  lr: "Africa",
  gw: false,
  hc: "MG",
  ln: "Masikoro Malagasy",
  lc: "msh",
  ld: "ltr",
  alt: [],
  cc: ["MG"]
}, {
  pk: 4104,
  ang: "Malay, Sabah",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Sabah Malay",
  lc: "msi",
  ld: "ltr",
  alt: ["Bazaar Malay", "Pasar Malay"],
  cc: ["MY"]
}, {
  pk: 4105,
  ang: "Ma",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ma (Democratic Republic of Congo)",
  lc: "msj",
  ld: "ltr",
  alt: ["Madi", "Madyo"],
  cc: ["CD"]
}, {
  pk: 4106,
  ang: "Mansaka",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Mansaka",
  lc: "msk",
  ld: "ltr",
  alt: ["Mandaya Mansaka"],
  cc: ["PH"]
}, {
  pk: 4107,
  ang: "Molof",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Molof",
  lc: "msl",
  ld: "ltr",
  alt: ["Poule"],
  cc: ["ID"]
}, {
  pk: 4108,
  ang: "Manobo, Agusan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Agusan Manobo",
  lc: "msm",
  ld: "ltr",
  alt: ["Agusan", "Omayamnon", "Surigao"],
  cc: ["PH"]
}, {
  pk: 7816,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Agusanen - Bunawan",
  lc: "msm-x-bunawan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8194,
  ang: "Bunawanon",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Bunawanon",
  lc: "msm-x-bunawanon",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7815,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Agusanen - Loreto",
  lc: "msm-x-loreto",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8017,
  ang: "Manguangan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Manguangan",
  lc: "msm-x-manguangan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7867,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Pangyan",
  lc: "msm-x-pangyan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7860,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Talacogon",
  lc: "msm-x-talacogon",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7667,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Umayam",
  lc: "msm-x-umayam",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7644,
  ang: "Umayamnon",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Umayamnon",
  lc: "msm-x-umayamno",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4109,
  ang: "Vur\xEBs",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Vur\xEBs",
  lc: "msn",
  ld: "ltr",
  alt: ["Vuras", "Vur\xEBs", "Mosina", "Mwesen (Mosin)"],
  cc: ["VU"]
}, {
  pk: 4110,
  ang: "Mombum",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mombum",
  lc: "mso",
  ld: "ltr",
  alt: ["Kemelom", "Kemelomsch", "Komolom"],
  cc: ["ID"]
}, {
  pk: 4111,
  ang: "Caac",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Caac",
  lc: "msq",
  ld: "ltr",
  alt: ["Caaac", "Caawac", "Moenebeng", "Mwelebeng", "La Conception (St. Louis)", "Pou\xE9bo (Pwebo)"],
  cc: ["NC"]
}, {
  pk: 4112,
  ang: "Mongolian Sign Language",
  lr: "Asia",
  gw: false,
  hc: "MN",
  ln: "Mongolian Sign Language",
  lc: "msr",
  ld: "ltr",
  alt: [],
  cc: ["MN"]
}, {
  pk: 4113,
  ang: "Masela, West",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "West Masela",
  lc: "mss",
  ld: "ltr",
  alt: ["West Marsela"],
  cc: ["ID"]
}, {
  pk: 4114,
  ang: "Musom",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Musom",
  lc: "msu",
  ld: "ltr",
  alt: ["Misatik"],
  cc: ["PG"]
}, {
  pk: 4115,
  ang: "Maslam",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Maslam",
  lc: "msv",
  ld: "ltr",
  alt: ["Kotoko-Maltam", "Maltam", "Maslam (Maltam)", "Sao (Sahu)"],
  cc: ["CM", "TD"]
}, {
  pk: 4116,
  ang: "Mansoanka",
  lr: "Africa",
  gw: false,
  hc: "GW",
  ln: "Mansoanka",
  lc: "msw",
  ld: "ltr",
  alt: ["Kunant", "Kunante", "Maswanka", "Sua"],
  cc: ["GM", "GW"]
}, {
  pk: 4117,
  ang: "Moresada",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Moresada",
  lc: "msx",
  ld: "ltr",
  alt: ["Murisapa", "Murusapa-Sarewa"],
  cc: ["PG"]
}, {
  pk: 7526,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "bahasa Melayu - Dominant Culture Variant",
  lc: "ms-x-dcv",
  ld: "ltr",
  alt: [],
  cc: ["MY"]
}, {
  pk: 4118,
  ang: "Aruamu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Aruamu",
  lc: "msy",
  ld: "ltr",
  alt: ["Ariawiai", "Makarub", "Makarup", "Mikarew", "Mikarew-Ariaw", "Mikarup"],
  cc: ["PG"]
}, {
  pk: 4119,
  ang: "Momare",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Momare",
  lc: "msz",
  ld: "ltr",
  alt: ["Momale", "Momole", "Mumare"],
  cc: ["PG"]
}, {
  pk: 4120,
  ang: "Maltese",
  lr: "Europe",
  gw: false,
  hc: "MT",
  ln: "Malti",
  lc: "mt",
  ld: "ltr",
  alt: ["Malti"],
  cc: ["MT", "TN", "US", "AU", "CA", "IT", "LY"]
}, {
  pk: 4121,
  ang: "Manobo, Cotabato",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Cotabato Manobo",
  lc: "mta",
  ld: "ltr",
  alt: ["Dulangan Manobo"],
  cc: ["PH"]
}, {
  pk: 8328,
  ang: "Sulit Manobo",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Sulit Manobo",
  lc: "mta-x-sulitmanob",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8320,
  ang: "Tasaday",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Tasaday",
  lc: "mta-x-tasaday",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4122,
  ang: "Anyin Morofo",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Anyin Morofo",
  lc: "mtb",
  ld: "ltr",
  alt: ["Morofo"],
  cc: ["CI"]
}, {
  pk: 4123,
  ang: "Munit",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Munit",
  lc: "mtc",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4124,
  ang: "Mualang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mualang",
  lc: "mtd",
  ld: "ltr",
  alt: ["Mualang Ili'", "Mualang Ulu"],
  cc: ["ID"]
}, {
  pk: 4125,
  ang: "Mono",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Mono (Solomon Islands)",
  lc: "mte",
  ld: "ltr",
  alt: ["Mono-Alu", "Alu (Alo)"],
  cc: ["SB"]
}, {
  pk: 4126,
  ang: "Murik",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Murik (Papua New Guinea)",
  lc: "mtf",
  ld: "ltr",
  alt: ["Nor", "Nor-Murik Lakes"],
  cc: ["PG"]
}, {
  pk: 4127,
  ang: "Una",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Una",
  lc: "mtg",
  ld: "ltr",
  alt: ["Goliath", "Langda", "Mt. Goliath", "Oranje-Gebergte"],
  cc: ["ID"]
}, {
  pk: 4128,
  ang: "Munggui",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Munggui",
  lc: "mth",
  ld: "ltr",
  alt: ["Natabui"],
  cc: ["ID"]
}, {
  pk: 4129,
  ang: "Maiwa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Maiwa (Papua New Guinea)",
  lc: "mti",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 8254,
  ang: "Mawae Nage",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mawae Nage",
  lc: "mti-x-mawaenage",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4130,
  ang: "Moskona",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Moskona",
  lc: "mtj",
  ld: "ltr",
  alt: ["Meninggo", "Meningo", "Meyah", "Sabena"],
  cc: ["ID"]
}, {
  pk: 4131,
  ang: "Mbo\u2019",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mbe'",
  lc: "mtk",
  ld: "ltr",
  alt: ["Mbaw", "Mbe'"],
  cc: ["CM"]
}, {
  pk: 4132,
  ang: "Montol",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Montol",
  lc: "mtl",
  ld: "ltr",
  alt: ["Baltap", "Montal", "Teel"],
  cc: ["NG"]
}, {
  pk: 4133,
  ang: "Mator",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "Mator",
  lc: "mtm",
  ld: "ltr",
  alt: [],
  cc: ["RU"]
}, {
  pk: 4134,
  ang: "Matagalpa",
  lr: "Americas",
  gw: false,
  hc: "NI",
  ln: "Matagalpa",
  lc: "mtn",
  ld: "ltr",
  alt: ["Pantasmas"],
  cc: ["NI"]
}, {
  pk: 4135,
  ang: "Mixe, Totontepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Totontepec Mixe",
  lc: "mto",
  ld: "ltr",
  alt: ["Ayuk", "Mixe Alto del Norte", "Northwestern Mixe"],
  cc: ["MX"]
}, {
  pk: 4136,
  ang: "Wich\xED Lhamt\xE9s Nocten",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Wich\xED Lhamt\xE9s Nocten",
  lc: "mtp",
  ld: "ltr",
  alt: ["Nocten", "Noctenes", "Oktenai", "Mataco Nocten", "Bolivian", "Noct\xE9n", "Mataco"],
  cc: ["AR", "BO"]
}, {
  pk: 4137,
  ang: "Muong",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Ti\u1EBFng M\u01B0\u1EDDng",
  lc: "mtq",
  ld: "ltr",
  alt: ["Ao T\xE1 (Au T\xE1)", "Boi Bi (Moi Bi)"],
  cc: ["VN"]
}, {
  pk: 4138,
  ang: "Mewari",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mewari",
  lc: "mtr",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 4139,
  ang: "Yora",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Yora",
  lc: "mts",
  ld: "ltr",
  alt: ["Manu Park Panoan", "Nahua", "Parquenahua", "Yoranahua", "Yura"],
  cc: ["PE"]
}, {
  pk: 4140,
  ang: "Mota",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Mota",
  lc: "mtt",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 4141,
  ang: "Mixtec, Tututepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tututepec Mixtec",
  lc: "mtu",
  ld: "ltr",
  alt: ["Mixteco de San Pedro Tututepec", "Mixteco de Villa de Tututepec", "Santa Mar\xEDa Acatepec"],
  cc: ["MX"]
}, {
  pk: 4142,
  ang: "Asaro\u2019o",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Asaro'o",
  lc: "mtv",
  ld: "ltr",
  alt: ["Morafa", "Molet"],
  cc: ["PG"]
}, {
  pk: 4143,
  ang: "Binukidnon, Southern",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Southern Binukidnon",
  lc: "mtw",
  ld: "ltr",
  alt: ["Bukidnon"],
  cc: ["PH"]
}, {
  pk: 4144,
  ang: "Mixtec, Tida\xE1",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tida\xE1 Mixtec",
  lc: "mtx",
  ld: "ltr",
  alt: ["Mixteco de San Pedro Tida\xE1", "Mixteco de Tida\xE1", "North Central Nochixtl\xE1n Mixtec"],
  cc: ["MX"]
}, {
  pk: 4145,
  ang: "Nabi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nabi",
  lc: "mty",
  ld: "ltr",
  alt: ["Metan", "Mitang"],
  cc: ["PG"]
}, {
  pk: 4146,
  ang: "Mundang",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Mundang",
  lc: "mua",
  ld: "ltr",
  alt: ["Kaele", "Marhay", "Moundan", "Musemban", "Nda", "Yasing", "Zasing (Torrock-Ka\xE9l\xE9)", "Yassing", "Zazing", "Kabi (Kieziere)", "Jasing", "Imbara", "Imbana (Bana)", "Zasing (Djasing)", "Mbana"],
  cc: ["CM", "TD"]
}, {
  pk: 4147,
  ang: "Mubi",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Mubi",
  lc: "mub",
  ld: "ltr",
  alt: ["Moubi"],
  cc: ["TD"]
}, {
  pk: 4148,
  ang: "Ajumbu",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Ajumbu",
  lc: "muc",
  ld: "ltr",
  alt: ["Ajuh Mbuh", "Lung (Mesem)"],
  cc: ["CM"]
}, {
  pk: 4149,
  ang: "Aleut, Mednyj",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0410\u043B\u0435\u0443\u0442\u0441\u043A\u043E-\u043C\u0435\u0434\u043D\u043E\u0432\u0441\u043A\u0438\u0439",
  lc: "mud",
  ld: "ltr",
  alt: ["Attuan", "Copper", "Copper Island Aleut", "Copper Island Attuan", "Creolized Attuan", "Medny"],
  cc: ["RU"]
}, {
  pk: 4150,
  ang: "Media Lengua",
  lr: "Americas",
  gw: false,
  hc: "EC",
  ln: "Media Lengua",
  lc: "mue",
  ld: "ltr",
  alt: [],
  cc: ["EC"]
}, {
  pk: 4151,
  ang: "Musgu",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Musgu",
  lc: "mug",
  ld: "ltr",
  alt: ["Mousgou", "Mousgoun", "Munjuk", "Musgum", "Musuk", "Mouloui", "Mulwi", "Pouss", "Vulum (Mulwi-Mogroum)", "Vulum (Mulwi)", "Pus", "Muzuk (Mousgoum de Guirvidig)", "Muzuk (Guirvidig)", "Mpus (Mousgoum de Pouss)", "Mousgoum de Guirvidik", "Mousgoum de Guirvidig", "Maniling (Mani-Iling)", "Beege (Jafga)", "Musgum-Pouss", "Vlum"],
  cc: ["CM", "TD"]
}, {
  pk: 4152,
  ang: "M\xFCnd\xFC",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "M\xFCnd\xFC",
  lc: "muh",
  ld: "ltr",
  alt: ["Mondo", "Mountou", "Mundo", "Mondu"],
  cc: ["SS"]
}, {
  pk: 4153,
  ang: "Musi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Musi",
  lc: "mui",
  ld: "ltr",
  alt: ["Palembangnese", "Coastal Malay", "Rawas; Palembang", "Pegagan", "Palembang Lama", "Musi Sekayu", "Meranjat", "Kelingi", "Burai", "Belide", "Lematang Ilir"],
  cc: ["ID"]
}, {
  pk: 4154,
  ang: "Mabire",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Mabire",
  lc: "muj",
  ld: "ltr",
  alt: [],
  cc: ["TD"]
}, {
  pk: 4155,
  ang: "Mugom",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Mugom",
  lc: "muk",
  ld: "ltr",
  alt: ["Mugu", "Mugum", "Mugomba", "Mumbai-kat", "Mugom (Moe-ket)", "Karmai-kat", "Kar-ket", "Karmarong (Karani)"],
  cc: ["NP"]
}, {
  pk: 4156,
  ang: "",
  lr: "",
  gw: false,
  hc: "",
  ln: "Multiple languages",
  lc: "mul",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4157,
  ang: "Maiwala",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Maiwala",
  lc: "mum",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4158,
  ang: "Nyong",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Nyong",
  lc: "muo",
  ld: "ltr",
  alt: ["Daganonga", "Daganyonga", "Mubako", "Mumbake", "Ndagam", "Samba Bali", "Chukkol", "Nyoking", "Peti", "Teteka", "Yapeli"],
  cc: ["CM", "NG"]
}, {
  pk: 4159,
  ang: "Malvi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Malvi",
  lc: "mup",
  ld: "ltr",
  alt: ["Malavi", "Mallow", "Malwada", "Malwi", "Ujjaini", "Umadwadi", "Sondwari (Sondhwadi)", "Soudhwari", "Ujjaini (Avanthika)", "Rajawadi"],
  cc: ["IN"]
}, {
  pk: 4160,
  ang: "Miao, Eastern Xiangxi",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4E1C\u90E8\u6B21\u65B9\u8A00",
  lc: "muq",
  ld: "ltr",
  alt: ["Eastern Ghao-Xong", "Eastern Miao", "Eastern West-Hunan Miao", "Ghao-Xong", "Hsianghsi Miao", "Meo Do", "Northern Miao", "Red Meo", "Red Miao"],
  cc: ["CN"]
}, {
  pk: 4161,
  ang: "Murle",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Murle",
  lc: "mur",
  ld: "ltr",
  alt: ["Ajibba", "Beir", "Merule", "Mourle", "Murele", "Murule", "Adkibba", "Agiba", "Murelei", "Ngalam", "Olam (Bangalam)"],
  cc: ["ET", "SS"]
}, {
  pk: 4162,
  ang: "Muskogee",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Creek",
  lc: "mus",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 4163,
  ang: "Muria, Western",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Western Muria",
  lc: "mut",
  ld: "ltr",
  alt: ["Jhoria", "Mudia", "Muria Gondi"],
  cc: ["IN"]
}, {
  pk: 4164,
  ang: "Yaaku",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Yaaku",
  lc: "muu",
  ld: "ltr",
  alt: ["Mogogodo", "Mukogodo", "Mukoquodo", "Siegu", "Yaakua", "Yiaku", "Ndorobo", "Ntorobo", "Palaung", "Shwe"],
  cc: ["KE"]
}, {
  pk: 4165,
  ang: "Muthuvan",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Muthuvan",
  lc: "muv",
  ld: "ltr",
  alt: ["Mudavan", "Muduva", "Muduvan", "Muduvar", "Mutuvar", "Eastern Muthuvan (Pandi Muthuvan)", "Nattu Muthuvan", "Tamil Muthuvan", "Western Muthuvan (Malayalam Muthuvan)"],
  cc: ["IN"]
}, {
  pk: 4166,
  ang: "Bo-Ung",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bo-Ung",
  lc: "mux",
  ld: "ltr",
  alt: ["Mboung", "Tembalo (Tembaglo)", "Ku Waru", "Miyemu (Miyem)"],
  cc: ["PG"]
}, {
  pk: 4167,
  ang: "Muyang",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Muyang",
  lc: "muy",
  ld: "ltr",
  alt: ["Mouyenge", "Mouyengue", "Muyenge", "Myau", "Myenge"],
  cc: ["CM"]
}, {
  pk: 4168,
  ang: "Mursi",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Mursi",
  lc: "muz",
  ld: "ltr",
  alt: ["Dama", "Merdu", "Meritu", "Murzi", "Murzu"],
  cc: ["ET"]
}, {
  pk: 4169,
  ang: "Manam",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Manam",
  lc: "mva",
  ld: "ltr",
  alt: ["Manum"],
  cc: ["PG"]
}, {
  pk: 8479,
  ang: "Wanir",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wanir",
  lc: "mva-x-wanir",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4170,
  ang: "Mattole",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Mattole",
  lc: "mvb",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 4171,
  ang: "Mamboru",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mamboru",
  lc: "mvd",
  ld: "ltr",
  alt: ["Memboro"],
  cc: ["ID"]
}, {
  pk: 4172,
  ang: "Marwari",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u0645\u0627\u0631\u0648\u0627\u0631\u064A (Pakistan)",
  lc: "mve",
  ld: "ltr",
  alt: ["Jaiselmer", "Marawar", "Merwari", "Rajasthani"],
  cc: ["PK"]
}, {
  pk: 4173,
  ang: "Mongolian, Peripheral",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5468\u8FB9\u8499\u53E4\u8BED",
  lc: "mvf",
  ld: "ltr",
  alt: ["Inner Mongolian", "Menggu", "Monggol", "Mongol", "Southern-Eastern Mongolian", "Kharachin", "Uzemchin", "Urat", "Ujumchin (Ujumuchin)", "Tumut (Tumet)", "Shilingol (Ujumchin)", "Qahar", "Ordos (E'erduosite)", "Naiman", "Khorchin", "Kharchin-Tumut", "Kharchin", "Keshikten", "Jirim (Gorlos)", "Balin", "Chahar (Chaha'er)", "Jalait", "Jirim (Khorchin)", "Jostu (Eastern Tumut)", "Jostu (Kharachin)", "Jo-Uda (Bairin)", "Kalaqin", "Ke'erqin", "Chakhar"],
  cc: ["CN", "US"]
}, {
  pk: 4174,
  ang: "Mixtec, Yucua\xF1e",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Yucua\xF1e Mixtec",
  lc: "mvg",
  ld: "ltr",
  alt: ["Mixteco de San Bartolom\xE9 Yucua\xF1e", "Mixteco del Sureste Central"],
  cc: ["MX"]
}, {
  pk: 4175,
  ang: "Mulgi",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Mulgi",
  lc: "mvh",
  ld: "ltr",
  alt: [],
  cc: ["TD"]
}, {
  pk: 4176,
  ang: "Miyako",
  lr: "Asia",
  gw: false,
  hc: "JP",
  ln: "\u5BAE\u53E4\u53E3",
  lc: "mvi",
  ld: "ltr",
  alt: ["Miyako-Jima (Hirara)", "Ogami"],
  cc: ["JP"]
}, {
  pk: 4177,
  ang: "Mekmek",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mekmek",
  lc: "mvk",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4178,
  ang: "Muya",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6728\u96C5\u8BED",
  lc: "mvm",
  ld: "ltr",
  alt: ["Boba", "Manyak", "Menya", "Minyag", "Minyak", "Miyao", "Munya", "Eastern Muya", "Western Muya"],
  cc: ["CN"]
}, {
  pk: 4179,
  ang: "Minaveha",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Minaveha",
  lc: "mvn",
  ld: "ltr",
  alt: ["Kukuya"],
  cc: ["PG"]
}, {
  pk: 4180,
  ang: "Marovo",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Marovo",
  lc: "mvo",
  ld: "ltr",
  alt: [],
  cc: ["SB"]
}, {
  pk: 4181,
  ang: "Duri",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Duri",
  lc: "mvp",
  ld: "ltr",
  alt: ["Masenrempulu", "Massenrempulu", "Benteng Alla", "Cakke-Kalosi", "Baraka"],
  cc: ["ID"]
}, {
  pk: 4182,
  ang: "Moere",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Moere",
  lc: "mvq",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4183,
  ang: "Marau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Marau",
  lc: "mvr",
  ld: "ltr",
  alt: ["Warabori (Natabui)", "Warembori"],
  cc: ["ID"]
}, {
  pk: 4184,
  ang: "Massep",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Massep",
  lc: "mvs",
  ld: "ltr",
  alt: ["Masep", "Potafa", "Wotaf"],
  cc: ["ID"]
}, {
  pk: 4185,
  ang: "Mpotovoro",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Mpotovoro",
  lc: "mvt",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 4186,
  ang: "Marfa",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Marfa",
  lc: "mvu",
  ld: "ltr",
  alt: ["Marba"],
  cc: ["TD"]
}, {
  pk: 4187,
  ang: "Tagal Murut",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Tagal Murut",
  lc: "mvv",
  ld: "ltr",
  alt: ["Semambu", "Semembu", "Sumambuq", "Sumambu-Tagal", "Tagal (North Borneo Murut)", "Tagul", "Sapulot Murut (Sapulut Murut)", "Saralir", "Sed\xE1lir", "Sumambu (Semambu)", "Taggal", "Rundum (Arundum)", "Sumambu (Semembu)", "Pentjangan", "Pensiangan Murut (Lagunan Murut)", "Meligan", "Mauligan", "Maligan (Bol Murut)", "Lumbis", "Bole Murut", "Alumbis (Loembis)", "Sabah Muru", "Salalir (Sadalir)"],
  cc: ["MY"]
}, {
  pk: 8044,
  ang: "Punan Lepaga",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Punan Lepaga",
  lc: "mvv-x-punanlepaga",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4188,
  ang: "Machinga",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Machinga",
  lc: "mvw",
  ld: "ltr",
  alt: [],
  cc: ["TZ"]
}, {
  pk: 4189,
  ang: "Meoswar",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Meoswar",
  lc: "mvx",
  ld: "ltr",
  alt: ["War"],
  cc: ["ID"]
}, {
  pk: 4190,
  ang: "Kohistani, Indus",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u06A9\u0648\u06C1\u0633\u062A\u0627\u0646\u06CC \u0632\u0628\u0627\u0646",
  lc: "mvy",
  ld: "ltr",
  alt: ["Khili", "Kohistani", "Kohiste", "Mair", "Maiy\xE3", "Maiyon", "Shuthun", "Pattan", "Seo", "Manzari", "Indus (Jijal)", "Duber-Kandia (Khili)", "Mani"],
  cc: ["PK"]
}, {
  pk: 4191,
  ang: "Mesqan",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Mesqan",
  lc: "mvz",
  ld: "ltr",
  alt: ["Masqan", "Meskan"],
  cc: ["ET"]
}, {
  pk: 4192,
  ang: "Mwatebu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mwatebu",
  lc: "mwa",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4193,
  ang: "Juwal",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Juwal",
  lc: "mwb",
  ld: "ltr",
  alt: ["Mambe", "Tumara", "Tumaru"],
  cc: ["PG"]
}, {
  pk: 4194,
  ang: "Are",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Are",
  lc: "mwc",
  ld: "ltr",
  alt: ["Mukawa"],
  cc: ["PG"]
}, {
  pk: 4195,
  ang: "Mwera",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Chimwera",
  lc: "mwe",
  ld: "ltr",
  alt: ["Chimwera", "Cimwera", "Kimwera", "Mwela"],
  cc: ["TZ"]
}, {
  pk: 4196,
  ang: "Murrinh-Patha",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Murrinh-Patha",
  lc: "mwf",
  ld: "ltr",
  alt: ["Garama", "Murinbada", "Murinbata", "Murrinhpatha"],
  cc: ["AU"]
}, {
  pk: 4197,
  ang: "Aiklep",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Aiklep",
  lc: "mwg",
  ld: "ltr",
  alt: ["Agerlep", "Eklep", "Kaul", "Moewehafen"],
  cc: ["PG"]
}, {
  pk: 4198,
  ang: "Mouk-Aria",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mouk-Aria",
  lc: "mwh",
  ld: "ltr",
  alt: ["Aria-Mouk", "Mouk (Mok)"],
  cc: ["PG"]
}, {
  pk: 4199,
  ang: "Ninde",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Labo",
  lc: "mwi",
  ld: "ltr",
  alt: ["Labo", "Mewun"],
  cc: ["VU"]
}, {
  pk: 4200,
  ang: "Maninkakan, Kita",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Kita Maninkakan",
  lc: "mwk",
  ld: "ltr",
  alt: ["Central Malinke", "Kita Maninka", "Malinke", "Sagabari", "Bag\xE8", "Biriko (Birgo)", "Kita"],
  cc: ["ML"]
}, {
  pk: 4201,
  ang: "Mirandese",
  lr: "Europe",
  gw: false,
  hc: "PT",
  ln: "Mirandese",
  lc: "mwl",
  ld: "ltr",
  alt: ["Mirand\xEAs", "Sendin\xEAs", "Mirandese Central (Miranadese Normal)", "Mirand\xE9s Meridional (Mirand\xE9s Sendin\xEAs)", "Mirand\xE9s Setentrional (Mirand\xE9s Raiano)"],
  cc: ["PT", "SR"]
}, {
  pk: 4202,
  ang: "Sar",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Sar",
  lc: "mwm",
  ld: "ltr",
  alt: ["Sara", "Sara Madjingay", "Madjingay", "Madjingaye", "Majingai (Madja Ngai)", "Majinngay"],
  cc: ["TD"]
}, {
  pk: 7853,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Nar",
  lc: "mwm-x-nar",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4203,
  ang: "Nyamwanga",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Nyamwanga",
  lc: "mwn",
  ld: "ltr",
  alt: ["Chinyamwanga", "Kinamwanga", "Kinyamwanga", "Mwanga", "Namwanga", "Ichinamwanga", "Inamwanga", "Tambo (Tembo)"],
  cc: ["TZ", "ZM"]
}, {
  pk: 4204,
  ang: "Maewo, Central",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Central Maewo",
  lc: "mwo",
  ld: "ltr",
  alt: ["Maewo", "Sungwadaga"],
  cc: ["VU"]
}, {
  pk: 4205,
  ang: "Kala Lagaw Ya",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Kala Lagaw Ya",
  lc: "mwp",
  ld: "ltr",
  alt: ["Central Torres Strait", "Kala Lagau Langgus", "Kala Lagaw", "Kala Yagaw Ya", "Langus", "Mabuiag", "Yagar Yagar"],
  cc: ["AU"]
}, {
  pk: 4206,
  ang: "Chin, M\xFC\xFCn",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "M\xFCn Chin",
  lc: "mwq",
  ld: "ltr",
  alt: ["Cho", "K'cho Chin", "Mindat", "M\xFCn", "M\xFC\xFCn", "Ng'men (Hletlong)", "Hmong-K'cha", "Hngiyung"],
  cc: ["MM"]
}, {
  pk: 7724,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Cho Rah",
  lc: "mwq-x-chora",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8461,
  ang: "Ni-Se",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Ni-Se",
  lc: "mwq-x-nise",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4207,
  ang: "Marwari",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Marwari",
  lc: "mwr",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 4208,
  ang: "Mwimbi-Muthambi",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Mwimbi-Muthambi",
  lc: "mws",
  ld: "ltr",
  alt: ["Mwimbi (Kimwimbi)"],
  cc: ["KE"]
}, {
  pk: 4209,
  ang: "Moken",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Moken",
  lc: "mwt",
  ld: "ltr",
  alt: ["Basing", "Chau Ko'", "Lawta", "Mawken", "Orang Laut", "Salon", "Salong", "Selong", "Selung", "Dung", "Jadiak", "Jait (Ja-It)", "Moklen"],
  cc: ["TH", "MM"]
}, {
  pk: 4210,
  ang: "Mentawai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mentawai",
  lc: "mwv",
  ld: "ltr",
  alt: ["Mentawei", "Mentawi", "Pagai"],
  cc: ["ID"]
}, {
  pk: 4211,
  ang: "Hmong Daw",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u767D\u82D7\u65B9\u8A00",
  lc: "mww",
  ld: "ltr",
  alt: ["Bai Miao", "Banded Arm Hmong", "Hmong Dleu", "Hmong Qua Mpa", "Meo Do", "Meo Kao", "Mong Do", "Mong Trang", "Pe Miao", "Peh Miao", "Striped Arm Hmong", "Striped Hmong", "White Hmong", "White Meo", "White Miao", "Hmong Der", "Hmoob Dawb", "Chuan Miao", "M\xE1n Tr\xE1ng", "Miao Lai", "Hmong Gu Mba (Hmong Qua Mba)", "Hmong Xi (Meo Do)"],
  cc: ["CN", "FR", "LA", "US", "MM"]
}, {
  pk: 4212,
  ang: "Mediak",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Mediak",
  lc: "mwx",
  ld: "ltr",
  alt: ["Dorobo", "Ndorobo"],
  cc: ["TZ"]
}, {
  pk: 4213,
  ang: "Moingi",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Moingi",
  lc: "mwz",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 4214,
  ang: "Mixtec, Northwest Oaxaca",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Northwest Oaxaca Mixtec",
  lc: "mxa",
  ld: "ltr",
  alt: ["Mixteco de Yucun\xE1", "Mixteco del Noroeste", "Mixteco del Noroeste de Oaxaca"],
  cc: ["MX"]
}, {
  pk: 4215,
  ang: "Mixtec, Tezoatl\xE1n",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tezoatl\xE1n Mixtec",
  lc: "mxb",
  ld: "ltr",
  alt: ["Mixteco de Tezoatl\xE1n de Segura y Luna"],
  cc: ["MX"]
}, {
  pk: 4216,
  ang: "Manyika",
  lr: "Africa",
  gw: false,
  hc: "ZW",
  ln: "Manyika",
  lc: "mxc",
  ld: "ltr",
  alt: ["Manika", "Bamanyeka", "Wamanyika", "Wanyika", "Bocha (Boka)"],
  cc: ["MZ", "ZW"]
}, {
  pk: 4217,
  ang: "Modang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Modang",
  lc: "mxd",
  ld: "ltr",
  alt: ["Long We", "Kelingan (Long Wai)"],
  cc: ["ID"]
}, {
  pk: 4218,
  ang: "Mele-Fila",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Mele-Fila",
  lc: "mxe",
  ld: "ltr",
  alt: ["Fila-Mele", "Ifara-Mele", "Mele", "Fila (Efira)", "Fira"],
  cc: ["VU"]
}, {
  pk: 4219,
  ang: "Malgbe",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Malgbe",
  lc: "mxf",
  ld: "ltr",
  alt: ["Goulfei", "Gulfe", "Gulfei", "Malbe", "Malgwe", "Ngwalkwe", "Sanbalbe", "Goulfey", "Kotoko-Gulfei", "Douguia (Dugiya)", "Malgbe (Goulfei)"],
  cc: ["CM", "TD"]
}, {
  pk: 4220,
  ang: "Mbangala",
  lr: "Africa",
  gw: false,
  hc: "AO",
  ln: "Mbangala",
  lc: "mxg",
  ld: "ltr",
  alt: ["Bangala", "Cimbangala"],
  cc: ["AO"]
}, {
  pk: 4221,
  ang: "Mvuba",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Mvuba",
  lc: "mxh",
  ld: "ltr",
  alt: ["Bambuba", "Bamvuba", "Mbuba", "Mvuba-A", "Obiye"],
  cc: ["CD"]
}, {
  pk: 4222,
  ang: "",
  lr: "Europe",
  gw: false,
  hc: "ES",
  ln: "Mozarabic",
  lc: "mxi",
  ld: "rtl",
  alt: [],
  cc: ["ES"]
}, {
  pk: 4223,
  ang: "Miju-Mishmi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Miju-Mishmi",
  lc: "mxj",
  ld: "ltr",
  alt: ["Kaman", "Keman", "Miji", "Mishmi", "Eastern Mishmi", "Geman Dend", "Geman Deng"],
  cc: ["CN", "IN"]
}, {
  pk: 4224,
  ang: "Monumbo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Monumbo",
  lc: "mxk",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4225,
  ang: "Gbe, Maxi",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Maxi Gbe",
  lc: "mxl",
  ld: "ltr",
  alt: ["Maxi", "Maxi-Gbe"],
  cc: ["BJ", "TG"]
}, {
  pk: 4226,
  ang: "Meramera",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Meramera",
  lc: "mxm",
  ld: "ltr",
  alt: ["Ubili"],
  cc: ["PG"]
}, {
  pk: 4227,
  ang: "Moi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Moi (Indonesia)",
  lc: "mxn",
  ld: "ltr",
  alt: ["Mekwei", "Mooi", "Mosana"],
  cc: ["ID"]
}, {
  pk: 8464,
  ang: "Moi Kelin",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Moi Kelin",
  lc: "mxn-x-moikelin",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4228,
  ang: "Mbowe",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Mbowe",
  lc: "mxo",
  ld: "ltr",
  alt: ["Esimbowe"],
  cc: ["ZM"]
}, {
  pk: 4229,
  ang: "Mixe, Tlahuitoltepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tlahuitoltepec Mixe",
  lc: "mxp",
  ld: "ltr",
  alt: ["Mixe Alto del Centro", "West Central Mixe"],
  cc: ["MX"]
}, {
  pk: 4230,
  ang: "Mixe, Juquila",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Juquila Mixe",
  lc: "mxq",
  ld: "ltr",
  alt: ["South Central Mixe", "Juquila Mixe", "Ocotepec Mixe"],
  cc: ["MX"]
}, {
  pk: 4231,
  ang: "Murik",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Murik (Malaysia)",
  lc: "mxr",
  ld: "ltr",
  alt: ["Long Banyok (Banyok)", "Long Semiang (Semiang)"],
  cc: ["MY"]
}, {
  pk: 4232,
  ang: "Mixtec, Huitepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Huitepec Mixtec",
  lc: "mxs",
  ld: "ltr",
  alt: ["Mixteco de Huitepec", "Mixteco de San Antonio Huitepec", "Mixteco de Zaachila"],
  cc: ["MX"]
}, {
  pk: 4233,
  ang: "Mixtec, Jamiltepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Jamiltepec Mixtec",
  lc: "mxt",
  ld: "ltr",
  alt: ["Eastern Jamiltepec-San Cristobal Mixtec", "Mixteco de Jamiltepec", "Mixteco de Oaxaca de Costa Central Baja", "Mixteco de Santa Mar\xEDa Huazolotitl\xE1n"],
  cc: ["MX"]
}, {
  pk: 4234,
  ang: "Mada",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mada (Cameroon)",
  lc: "mxu",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 4235,
  ang: "Mixtec, Metlat\xF3noc",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Metlat\xF3noc Mixtec",
  lc: "mxv",
  ld: "ltr",
  alt: [],
  cc: ["MX", "US"]
}, {
  pk: 4236,
  ang: "Namo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Namo",
  lc: "mxw",
  ld: "ltr",
  alt: ["Dorro", "Mari"],
  cc: ["PG"]
}, {
  pk: 4237,
  ang: "Mahou",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Mahou",
  lc: "mxx",
  ld: "ltr",
  alt: ["Mahu", "Maou", "Mau", "Mauka", "Mauke", "Baralaka (Barala)"],
  cc: ["CI"]
}, {
  pk: 4238,
  ang: "Mixtec, Southeastern Nochixtl\xE1n",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Southeastern Nochixtl\xE1n Mixtec",
  lc: "mxy",
  ld: "ltr",
  alt: ["Mixteco de Santo Domingo Nuxa\xE1", "Mixteco del Sureste de Nochixtl\xE1n", "San Andr\xE9s Nuxi\xF1o Mixtec", "Santa In\xE9s de Zaragoza Mixtec", "Santo Domingo Nuxa\xE1 Mixtec"],
  cc: ["MX"]
}, {
  pk: 4239,
  ang: "Masela, Central",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Central Masela",
  lc: "mxz",
  ld: "ltr",
  alt: ["Central Marsela", "Marsela-South Babar"],
  cc: ["ID"]
}, {
  pk: 4240,
  ang: "Burmese",
  lr: "Asia",
  gw: true,
  hc: "MM",
  ln: "\u1017\u1019\u102C\u1005\u102C",
  lc: "my",
  ld: "ltr",
  alt: ["Bama", "Bamachaka", "Myanmar", "Myen", "Yangon Burmese", "Mergui", "Mandalay Burmese", "Beik (Merguese)", "Bamar"],
  cc: ["BD", "DE", "LA", "GB", "MY", "TH", "US", "AU", "KH", "CA", "IN", "MM"]
}, {
  pk: 4241,
  ang: "Mbay",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Mbay",
  lc: "myb",
  ld: "ltr",
  alt: ["Mbai", "Mbay Moissala", "Moissala Mbai", "Sara Mbai", "Ngoka (Mbang)", "Kan (Mbay-Kan)"],
  cc: ["CM", "CF", "NG", "TD"]
}, {
  pk: 4242,
  ang: "Mayeka",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Mayeka",
  lc: "myc",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 4243,
  ang: "Maramba",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Maramba",
  lc: "myd",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4244,
  ang: "Myene",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Myene",
  lc: "mye",
  ld: "ltr",
  alt: ["Pangwe", "Pongou\xE9", "Rungu", "Orungu (Rongo)", "Npongwe", "Npongu\xE9", "Nkomi (N'komi)", "Mpungwe", "Galwa (Galloa)", "Galua", "Galoa", "Dyumba", "Adyumba", "Ajumba (Adjumba)", "Mpongwe (Mpongou\xE9)"],
  cc: ["GA"]
}, {
  pk: 4245,
  ang: "Bambassi",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Bambassi",
  lc: "myf",
  ld: "ltr",
  alt: ["Amam", "Bambeshi", "Didessa", "Fadiro", "Northern Mao", "Siggoyo"],
  cc: ["ET"]
}, {
  pk: 4246,
  ang: "Manta",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Manta",
  lc: "myg",
  ld: "ltr",
  alt: ["Anta", "Banta", "Bantakpa", "Kisam", "Menta", "Tinta"],
  cc: ["CM"]
}, {
  pk: 4247,
  ang: "Makah",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Makah",
  lc: "myh",
  ld: "ltr",
  alt: ["Kweedishchaaht", "Kwe-Nee-Chee-Aht"],
  cc: ["US"]
}, {
  pk: 4248,
  ang: "Mina",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mina (India)",
  lc: "myi",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 4249,
  ang: "Mangayat",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Mangayat",
  lc: "myj",
  ld: "ltr",
  alt: ["Buga", "Mangaya", "Mongaiyat"],
  cc: ["SS"]
}, {
  pk: 4250,
  ang: "S\xE9noufo, Mamara",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Mamara Senoufo",
  lc: "myk",
  ld: "ltr",
  alt: ["Mamara", "Mianka", "Minianka", "Miniyanka", "Minya", "Minyanka", "Tupiire"],
  cc: ["ML"]
}, {
  pk: 4251,
  ang: "Moma",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Moma",
  lc: "myl",
  ld: "ltr",
  alt: ["Kulawi"],
  cc: ["ID"]
}, {
  pk: 4252,
  ang: "Me\u2019en",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Me'en",
  lc: "mym",
  ld: "ltr",
  alt: ["Mekan", "Men", "Meqan", "Mie'en", "Mieken", "Koruwo", "Podi", "Bodi (Mela)", "Banio"],
  cc: ["ET"]
}, {
  pk: 4253,
  ang: "Anfillo",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Anfillo",
  lc: "myo",
  ld: "ltr",
  alt: ["Southern Mao"],
  cc: ["ET"]
}, {
  pk: 4254,
  ang: "Pirah\xE3",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Pirah\xE3",
  lc: "myp",
  ld: "ltr",
  alt: ["M\xFAra-Pirah\xE3", "M\xFAra"],
  cc: ["BR"]
}, {
  pk: 4255,
  ang: "Muniche",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Muniche",
  lc: "myr",
  ld: "ltr",
  alt: ["Munichi", "Munichino", "Otanabe", "Otanave"],
  cc: ["PE"]
}, {
  pk: 4256,
  ang: "Munduruk\xFA",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Munduruk\xFA",
  lc: "myu",
  ld: "ltr",
  alt: ["Caras-Pretas", "Monjoroku", "Mundurucu", "Paiquize", "Pari", "Weidyenye"],
  cc: ["BR"]
}, {
  pk: 4257,
  ang: "Erzya",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u042D\u0440\u0437\u044F\u0301\u043D\u0441\u043A\u0438\u0439",
  lc: "myv",
  ld: "ltr",
  alt: ["Erzia", "Mordvin", "Mordvin-Erzya"],
  cc: ["AZ", "KZ", "TJ", "RU", "KG", "TM", "UZ"]
}, {
  pk: 4258,
  ang: "Muyuw",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Muyuw",
  lc: "myw",
  ld: "ltr",
  alt: ["Murua", "Murua Dukwayasi", "Murua Kaulae", "Muruwa", "Muyu", "Muyua", "Muyuwa", "Lougaw (Gawa)"],
  cc: ["PG"]
}, {
  pk: 7769,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Lougwau",
  lc: "myw-x-lougwau",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4259,
  ang: "Masaaba",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Masaaba",
  lc: "myx",
  ld: "ltr",
  alt: ["Gisu", "Lugisu", "Lumasaaba", "Masaba", "Lubuuya (Buuya)", "Ludadiri (Dadiri)", "Lufumbo", "Luteza", "Luwalasi", "Luyobo"],
  cc: ["UG"]
}, {
  pk: 4260,
  ang: "Macuna",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Macuna",
  lc: "myy",
  ld: "ltr",
  alt: ["Baigana", "Buhagana", "Jepa-Matsi", "Makuna", "Paneroa", "Wuh\xE1na", "Yebamas\xE3", "Yehp\xE1 Majs\xE1", "Yep\xE1 Maxs\xE3", "Yep\xE1-Mahs\xE1", "Emoa", "Ide", "Roea", "Suroa", "Tabotiro Jejea", "Umua", "Yeba"],
  cc: ["BR", "CO"]
}, {
  pk: 4261,
  ang: "Mandaic, Classical",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Classical Mandaic",
  lc: "myz",
  ld: "ltr",
  alt: ["Classical Mandaean"],
  cc: ["IR"]
}, {
  pk: 4262,
  ang: "Mixtec, Santa Mar\xEDa Zacatepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Santa Mar\xEDa Zacatepec Mixtec",
  lc: "mza",
  ld: "ltr",
  alt: ["Mixteco de Santa Mar\xEDa Zacatepec", "Southern Putla Mixtec", "Tu'un Va'a", "Zacatepec Mixtec", "Tacuate"],
  cc: ["MX"]
}, {
  pk: 4263,
  ang: "Tumzabt",
  lr: "Africa",
  gw: false,
  hc: "DZ",
  ln: "\u062A\u0648\u0646\u0698\u0627\u0628\u062A",
  lc: "mzb",
  ld: "rtl",
  alt: ["Ghardaia", "Mozabite", "Mzab", "Mzabi"],
  cc: ["DZ", "FR"]
}, {
  pk: 4264,
  ang: "Madagascar Sign Language",
  lr: "Africa",
  gw: false,
  hc: "MG",
  ln: "Madagascar Sign Language",
  lc: "mzc",
  ld: "ltr",
  alt: [],
  cc: ["MG"]
}, {
  pk: 4265,
  ang: "Malimba",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Malimba",
  lc: "mzd",
  ld: "ltr",
  alt: ["Lemba", "Limba", "Mudima", "Mulimba"],
  cc: ["CM"]
}, {
  pk: 4266,
  ang: "Morawa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Morawa",
  lc: "mze",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4267,
  ang: "",
  lr: "",
  gw: false,
  hc: "",
  ln: "Monastic Sign Language",
  lc: "mzg",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4268,
  ang: "Wich\xED Lhamt\xE9s G\xFCisnay",
  lr: "Americas",
  gw: false,
  hc: "AR",
  ln: "Wich\xED Lhamt\xE9s G\xFCisnay",
  lc: "mzh",
  ld: "ltr",
  alt: ["G\xFCisnay", "Mataco", "Mataco G\xFCisnay", "Mataco Pilcomayo"],
  cc: ["AR", "PY"]
}, {
  pk: 4269,
  ang: "Mazatec, Ixcatl\xE1n",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Ixcatl\xE1n Mazatec",
  lc: "mzi",
  ld: "ltr",
  alt: ["Mazateco de presa bajo", "Mazateco de San Pedro Ixcatl\xE1n"],
  cc: ["MX"]
}, {
  pk: 4270,
  ang: "Manya",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Manya",
  lc: "mzj",
  ld: "ltr",
  alt: ["Mandingo", "Maniya", "Manya Kan", "Koinyaka"],
  cc: ["LR", "GN"]
}, {
  pk: 4271,
  ang: "Mambila, Nigeria",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Nigeria Mambila",
  lc: "mzk",
  ld: "ltr",
  alt: ["Bang", "Lagubi", "Mabila", "Mambere", "Mambilla", "Nor", "Nor Tagbo", "Tongbo"],
  cc: ["NG"]
}, {
  pk: 4272,
  ang: "Mixe, Mazatl\xE1n",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Mazatl\xE1n Mixe",
  lc: "mzl",
  ld: "ltr",
  alt: ["East Central Mixe", "Tutla Mixe"],
  cc: ["MX"]
}, {
  pk: 4273,
  ang: "Mumuye",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Mumuye",
  lc: "mzm",
  ld: "ltr",
  alt: ["Yoro", "Zinna (Zing)", "Gola (Bajama)", "Yaa"],
  cc: ["CM", "NG"]
}, {
  pk: 4274,
  ang: "Mazanderani",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u0632\u0628\u0627\u0646 \u0645\u0627\u0632\u0646\u062F\u0631\u0627\u0646\u06CC",
  lc: "mzn",
  ld: "rtl",
  alt: ["Gilaki", "Tabri", "Gorgani"],
  cc: ["IR"]
}, {
  pk: 4275,
  ang: "Matipuhy",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Matipuhy",
  lc: "mzo",
  ld: "ltr",
  alt: ["Nahuku\xE1 (Nafukw\xE1)", "Nahukwa", "Nahuqua", "Nakukwa", "Mariape-Nahuqua", "Matipu"],
  cc: ["BR"]
}, {
  pk: 4276,
  ang: "Movima",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Movima",
  lc: "mzp",
  ld: "ltr",
  alt: [],
  cc: ["BO"]
}, {
  pk: 4277,
  ang: "Mori Atas",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mori Atas",
  lc: "mzq",
  ld: "ltr",
  alt: ["Berg-Tomori", "Boven-Mori", "Upper Mori", "West Mori", "Ulu Uwoi", "Zuid-Mori", "Tambee (Ajo)", "Tambee", "Molongkuni", "Molio'a", "Impo", "South Mori"],
  cc: ["ID"]
}, {
  pk: 4278,
  ang: "Mar\xFAbo",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Mar\xFAbo",
  lc: "mzr",
  ld: "ltr",
  alt: ["Kaniu\xE1", "Marova", "Maruba"],
  cc: ["BR"]
}, {
  pk: 4279,
  ang: "Macanese",
  lr: "Asia",
  gw: false,
  hc: "MO",
  ln: "Macanese",
  lc: "mzs",
  ld: "ltr",
  alt: ["Macaense", "Macao Creole Portuguese", "Makista", "Patu\xE1"],
  cc: ["MO"]
}, {
  pk: 4280,
  ang: "Mintil",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Mintil",
  lc: "mzt",
  ld: "ltr",
  alt: ["Mitil"],
  cc: ["MY"]
}, {
  pk: 4281,
  ang: "Inapang",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Inapang",
  lc: "mzu",
  ld: "ltr",
  alt: ["Midsivindi"],
  cc: ["PG"]
}, {
  pk: 4282,
  ang: "Mandja",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Manza",
  lc: "mzv",
  ld: "ltr",
  alt: ["Manja"],
  cc: ["CF"]
}, {
  pk: 4283,
  ang: "Deg",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Deg",
  lc: "mzw",
  ld: "ltr",
  alt: ["Aculo", "Buro", "Degha", "Janela", "Mmfo", "Mo", "Buru"],
  cc: ["GH"]
}, {
  pk: 4284,
  ang: "Mawayana",
  lr: "Americas",
  gw: false,
  hc: "GY",
  ln: "Mawayana",
  lc: "mzx",
  ld: "ltr",
  alt: [],
  cc: ["GY"]
}, {
  pk: 4285,
  ang: "Mozambican Sign Language",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Mozambican Sign Language",
  lc: "mzy",
  ld: "ltr",
  alt: [],
  cc: ["MZ"]
}, {
  pk: 4286,
  ang: "Maiadomu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Maiadomu",
  lc: "mzz",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4287,
  ang: "Nauru",
  lr: "Pacific",
  gw: false,
  hc: "NR",
  ln: "Ekakair\u0169 Naoero",
  lc: "na",
  ld: "ltr",
  alt: [],
  cc: ["NR"]
}, {
  pk: 4288,
  ang: "Namla",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Namla",
  lc: "naa",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 4289,
  ang: "Nambiku\xE1ra, Southern",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Southern Nambiku\xE1ra",
  lc: "nab",
  ld: "ltr",
  alt: ["Alaketesu", "Anunsu", "Nambikwara", "Nambiquara", "Saxwentesu", "Wakalitesu"],
  cc: ["BR"]
}, {
  pk: 4290,
  ang: "Narak",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Narak",
  lc: "nac",
  ld: "ltr",
  alt: ["Ganja"],
  cc: ["PG"]
}, {
  pk: 4291,
  ang: "Nijadali",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Nijadali",
  lc: "nad",
  ld: "ltr",
  alt: ["Bailko", "Balgu", "Balygu", "Jauna", "Paljgu", "Palyku", "Njijapali", "Nyiyabali", "Nyiypali"],
  cc: ["AU"]
}, {
  pk: 4292,
  ang: "Nabak",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nabak",
  lc: "naf",
  ld: "ltr",
  alt: ["Naba", "Wain"],
  cc: ["PG"]
}, {
  pk: 8355,
  ang: "Nabak Lower",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nabak Lower",
  lc: "naf-x-lowernabak",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4293,
  ang: "Naga Pidgin",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Naga Pidgin",
  lc: "nag",
  ld: "ltr",
  alt: ["Bodo", "Kachari Bengali", "Naga Creole Assamese", "Naga-Assamese"],
  cc: ["IN"]
}, {
  pk: 4294,
  ang: "Nalu",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Nalu",
  lc: "naj",
  ld: "ltr",
  alt: ["Nalou"],
  cc: ["GN", "GW"]
}, {
  pk: 4295,
  ang: "Nakanai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nakanai",
  lc: "nak",
  ld: "ltr",
  alt: ["Nakonai", "Bileki (Lakalai)", "Vere (Tarobi)", "Vele", "Ubae (Babata)", "Muku", "Mamuga", "Losa (Auka)", "Loso"],
  cc: ["PG"]
}, {
  pk: 4296,
  ang: "Nalik",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nalik",
  lc: "nal",
  ld: "ltr",
  alt: ["Fesoa", "Fessoa", "Lugagon"],
  cc: ["PG"]
}, {
  pk: 4297,
  ang: "Ngan\u2019gityemerri",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Ngan'gityemerri",
  lc: "nam",
  ld: "ltr",
  alt: ["Moil", "Ngangi-Tjemerri", "Ngankikurrunkurr", "Nangikurrunggurr (Nangikurunggurr)", "Ngenkikurrunggur", "Ngan'gimerri", "Ngangikarangurr", "Ngan'giwumirri (Ngangi-Wumeri)"],
  cc: ["AU"]
}, {
  pk: 4298,
  ang: "Chinese, Min Nan",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u95FD\u5357\u8BED",
  lc: "nan",
  ld: "ltr",
  alt: ["Min Nan", "Minnan", "Southern Min", "Min Nam", "Tiuchiu", "Taechew", "Taiwanese (Amoy)", "Techu", "Teochew (Chaochow)", "Teochiu", "Teochow", "Shantou (Swatow)", "Tiu Chiu", "Xiamen", "Wenchang", "Xiamen (Amoy)", "Zhangzhou (Changchew)", "Fujianese", "Sanso", "Chaenzo", "Choushan", "Fukien", "Hainan", "Hainan (Hainanese)", "Qiongwen Hua", "Hokkien (Fujian)", "Leizhou (Lei Hua)", "Quanzhou (Chinchew)", "Li Hua", "Hokkien (Amoy)", "Chao-Shan (Chaozhou)"],
  cc: ["CL", "CN", "AR", "JP", "PE", "CR", "MY", "PH", "US", "CA", "SG"]
}, {
  pk: 7702,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Hokkien",
  lc: "nan-x-hokien",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 7703,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Teochiu",
  lc: "nan-x-teochi",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 4299,
  ang: "Naaba",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Naaba",
  lc: "nao",
  ld: "ltr",
  alt: ["Naapaa", "Naba", "Nawa Sherpa"],
  cc: ["NP"]
}, {
  pk: 4300,
  ang: "Napoletano-Calabrese",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Neapolitan",
  lc: "nap",
  ld: "ltr",
  alt: ["Neapolitan-Calabrese", "Tirrenic", "Northern Calabrese-Lucano (Basilicatan)", "Napoletano (Neapolitan)", "Lucanian"],
  cc: ["IT"]
}, {
  pk: 4301,
  ang: "Khoekhoe",
  lr: "Africa",
  gw: false,
  hc: "NA",
  ln: "Khoekhoe",
  lc: "naq",
  ld: "ltr",
  alt: ["Berdama", "Bergdamara", "Dama", "Damaqua", "Damara", "Kakuya Bushman Nasie", "Khoekhoegowab", "Namakwa", "Naman", "Namaqua", "Rooi Nasie", "Tama", "Tamakwa", "Tamma", "Hottentot", "Kupkaferrn", "Kupkaffer", "Kakuya Bushman", "Maqua", "Nasie", "Khoekhoegowap", "Khoekhoe", "Khoeknoegowap", "Khoi"],
  cc: ["ZA", "BW", "NA"]
}, {
  pk: 4302,
  ang: "Iguta",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Iguta",
  lc: "nar",
  ld: "ltr",
  alt: ["Anaguta"],
  cc: ["NG"]
}, {
  pk: 4303,
  ang: "Naasioi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Naasioi",
  lc: "nas",
  ld: "ltr",
  alt: ["Kieta", "Orami (Guava)", "Pirung (Naasioi)"],
  cc: ["PG"]
}, {
  pk: 4304,
  ang: "Cahungwarya",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ca\u0331hungwa\u0331rya\u0331",
  lc: "nat",
  ld: "ltr",
  alt: ["Ingwe", "Ingwo", "Ngwe", "Ngwoi", "Nkwoi", "Ungwe"],
  cc: ["NG"]
}, {
  pk: 4305,
  ang: "Nawuri",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Nawuri",
  lc: "naw",
  ld: "ltr",
  alt: [],
  cc: ["GH"]
}, {
  pk: 4306,
  ang: "Nakwi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nakwi",
  lc: "nax",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4307,
  ang: "Narrinyeri",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Narrinyeri",
  lc: "nay",
  ld: "ltr",
  alt: ["Ngarinyeri", "Ngarrindjeri", "Yaralde"],
  cc: ["AU"]
}, {
  pk: 4308,
  ang: "Nahuatl, Coatepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Coatepec Nahuatl",
  lc: "naz",
  ld: "ltr",
  alt: ["Coatepec Aztec", "N\xE1huatl de Coatepec"],
  cc: ["MX"]
}, {
  pk: 4309,
  ang: "Norwegian Bokm\xE5l",
  lr: "Europe",
  gw: false,
  hc: "NO",
  ln: "Norsk bokm\xE5l",
  lc: "nb",
  ld: "ltr",
  alt: [],
  cc: ["NO"]
}, {
  pk: 4310,
  ang: "Nyemba",
  lr: "Africa",
  gw: false,
  hc: "AO",
  ln: "Nyemba",
  lc: "nba",
  ld: "ltr",
  alt: ["Gangela", "Ganguela", "Ganguella", "Ngangela", "Nhemba"],
  cc: ["AO", "NA"]
}, {
  pk: 4311,
  ang: "Ndoe",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ndoe",
  lc: "nbb",
  ld: "ltr",
  alt: ["Ekparabong (Akparabong)", "Balep (Anep)", "Anyep"],
  cc: ["NG"]
}, {
  pk: 4312,
  ang: "Naga, Chang",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Chang Naga",
  lc: "nbc",
  ld: "ltr",
  alt: ["Chang", "Changyanguh", "Machongrr", "Mochumi", "Mochungrr", "Mojung"],
  cc: ["IN"]
}, {
  pk: 4313,
  ang: "Ngbinda",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ngbinda",
  lc: "nbd",
  ld: "ltr",
  alt: ["Bangbinda", "Bungbinda"],
  cc: ["CD"]
}, {
  pk: 4314,
  ang: "Naga, Konyak",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Konyak Naga",
  lc: "nbe",
  ld: "ltr",
  alt: ["Kanyak", "Konyak", "Kun", "Longkhai (Lungkhai)", "Lonwa", "Lungkhi"],
  cc: ["IN", "MM"]
}, {
  pk: 4315,
  ang: "Ngamo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ngamo",
  lc: "nbh",
  ld: "ltr",
  alt: ["Gamawa", "Gamo"],
  cc: ["NG"]
}, {
  pk: 4316,
  ang: "Naga, Mao",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mao Naga",
  lc: "nbi",
  ld: "ltr",
  alt: ["Emela", "Imemai", "Maikel", "Mao", "Memi", "Sopfomo", "Sopvoma", "Southern Angami", "Spowama"],
  cc: ["IN"]
}, {
  pk: 4317,
  ang: "Ngarinman",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Ngarinman",
  lc: "nbj",
  ld: "ltr",
  alt: ["Airiman", "Hainman", "Ngaiman", "Ngarinyman", "Ngrarmun", "Bilinara (Pilinara)"],
  cc: ["AU"]
}, {
  pk: 4318,
  ang: "Nake",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nake",
  lc: "nbk",
  ld: "ltr",
  alt: ["Ale"],
  cc: ["PG"]
}, {
  pk: 4319,
  ang: "Ngbaka Ma\u2019bo",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Ngbaka Ma'bo",
  lc: "nbm",
  ld: "ltr",
  alt: ["Bouaka", "Bwaka", "Gbaka", "Gwaka", "Ma'bo", "Mbacca", "Mbaka", "Mbwaka", "Nbwaka", "Ngbaka Limba", "Gbala"],
  cc: ["CF", "CG"]
}, {
  pk: 4320,
  ang: "Kuri",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kuri",
  lc: "nbn",
  ld: "ltr",
  alt: ["Modan"],
  cc: ["ID"]
}, {
  pk: 4321,
  ang: "Nkukoli",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Nkukoli",
  lc: "nbo",
  ld: "ltr",
  alt: ["Ekuri", "Lokoli", "Lokukoli", "Nkokolle"],
  cc: ["NG"]
}, {
  pk: 4322,
  ang: "Nnam",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Nnam",
  lc: "nbp",
  ld: "ltr",
  alt: ["Ndem"],
  cc: ["NG"]
}, {
  pk: 4323,
  ang: "Nggem",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Nggem",
  lc: "nbq",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 4324,
  ang: "Numana-Nunku-Gbantu-Numbu",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Numana-Nunku-Gbantu-Numbu",
  lc: "nbr",
  ld: "ltr",
  alt: ["Sanga", "Kurmi", "Numana (Arak)", "Nimana", "Inmwen", "Gbantu (Gwanto)", "Aninka (Gwantu)", "Ninka"],
  cc: ["NG"]
}, {
  pk: 4325,
  ang: "Namibian Sign Language",
  lr: "Africa",
  gw: false,
  hc: "NA",
  ln: "Namibian Sign Language",
  lc: "nbs",
  ld: "ltr",
  alt: [],
  cc: ["NA"]
}, {
  pk: 4326,
  ang: "Na",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Na",
  lc: "nbt",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 7600,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Nah",
  lc: "nbt-x-nah",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4327,
  ang: "Naga, Rongmei",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Rongmei Naga",
  lc: "nbu",
  ld: "ltr",
  alt: ["Kabui", "Maruongmai", "Nruanghmei", "Rongmai", "Rongmei"],
  cc: ["IN"]
}, {
  pk: 4328,
  ang: "Ngamambo",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Ngamambo",
  lc: "nbv",
  ld: "ltr",
  alt: ["Bafuchu", "Banja", "Mbu", "Mungyen", "Nga", "Ngembo"],
  cc: ["CM"]
}, {
  pk: 4329,
  ang: "Ngbandi, Southern",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Southern Ngbandi",
  lc: "nbw",
  ld: "ltr",
  alt: ["Mbati", "Mongbandi", "Mongwandi", "Ngbandi-Ngiri", "Ngbandi-Sud", "Ngwandi"],
  cc: ["CG", "CD"]
}, {
  pk: 4330,
  ang: "Ningera",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ningera",
  lc: "nby",
  ld: "ltr",
  alt: ["Nagira", "Negira", "Ninggera"],
  cc: ["PG"]
}, {
  pk: 4331,
  ang: "Iyo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Iyo",
  lc: "nca",
  ld: "ltr",
  alt: ["Bure", "Nabu", "Naho", "Ndo"],
  cc: ["PG"]
}, {
  pk: 4332,
  ang: "Nicobarese, Central",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Central Nicobarese",
  lc: "ncb",
  ld: "ltr",
  alt: ["Nicobar", "Camorta (Kamorta)", "Katchal (Kachel)", "Nancowry (Nancoury)", "Tehnu", "Trinkut (Trinkat)"],
  cc: ["IN"]
}, {
  pk: 4333,
  ang: "Ponam",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ponam",
  lc: "ncc",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4334,
  ang: "Nachering",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Nachering",
  lc: "ncd",
  ld: "ltr",
  alt: ["Bangdel T\xFBm", "Bangdile", "Mathsereng", "Nacchhering", "Nacering Ra", "Nachering T\xFBm", "Nachiring", "Nasring", "Sotange", "Rakhali", "Bangdele (Achero)", "Hachero", "Hangkula"],
  cc: ["NP"]
}, {
  pk: 4335,
  ang: "Yale",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yale",
  lc: "nce",
  ld: "ltr",
  alt: ["Nagatman", "Yade", "Yar\xEB"],
  cc: ["PG"]
}, {
  pk: 4336,
  ang: "Notsi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Notsi",
  lc: "ncf",
  ld: "ltr",
  alt: ["Nochi"],
  cc: ["PG"]
}, {
  pk: 4337,
  ang: "Nisga\u2019a",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Nisga'a",
  lc: "ncg",
  ld: "ltr",
  alt: ["Nass", "Nisgha", "Nishga", "Nisk'a", "Nisqa'a"],
  cc: ["CA"]
}, {
  pk: 4338,
  ang: "Nahuatl, Central Huasteca",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Central Huasteca Nahuatl",
  lc: "nch",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 4339,
  ang: "Classical Nahuatl",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Classical Nahuatl",
  lc: "nci",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 4340,
  ang: "Nahuatl, Northern Puebla",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Northern Puebla Nahuatl",
  lc: "ncj",
  ld: "ltr",
  alt: ["N\xE1huatl del Norte de Puebla", "North Puebla Aztec"],
  cc: ["MX"]
}, {
  pk: 4341,
  ang: "Nakara",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Nakara",
  lc: "nck",
  ld: "ltr",
  alt: ["Kokori", "Nagara", "Nakkara"],
  cc: ["AU"]
}, {
  pk: 4342,
  ang: "Nahuatl, Michoac\xE1n",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Michoac\xE1n Nahuatl",
  lc: "ncl",
  ld: "ltr",
  alt: ["Mexicano", "Michoacan Aztec", "Nahual de Michoac\xE1n"],
  cc: ["MX"]
}, {
  pk: 4343,
  ang: "Nambo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nambo",
  lc: "ncm",
  ld: "ltr",
  alt: ["Arufe", "Nambu", "Namna", "Namna (Nama)"],
  cc: ["PG"]
}, {
  pk: 4344,
  ang: "Nauna",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nauna",
  lc: "ncn",
  ld: "ltr",
  alt: ["Naune"],
  cc: ["PG"]
}, {
  pk: 4345,
  ang: "Sibe",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sibe",
  lc: "nco",
  ld: "ltr",
  alt: ["Sibe-Nagovisi", "Tobe\u2019laaki\u2019", "To'mau", "Teleipi", "Laagasi'", "Welipe'"],
  cc: ["PG"]
}, {
  pk: 4346,
  ang: "Ndaktup",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Ndaktup",
  lc: "ncp",
  ld: "ltr",
  alt: ["Bitui (Bitwi)"],
  cc: ["CM"]
}, {
  pk: 4347,
  ang: "Ncane",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Ncane",
  lc: "ncr",
  ld: "ltr",
  alt: ["Cane", "Nchane", "Nchaney", "Ntshanti", "Mungong (Mungom)"],
  cc: ["CM"]
}, {
  pk: 4348,
  ang: "Nicaraguan Sign Language",
  lr: "Americas",
  gw: false,
  hc: "NI",
  ln: "Nicaraguan Sign Language",
  lc: "ncs",
  ld: "ltr",
  alt: ["Idioma de Se\xF1as de Nicaragua"],
  cc: ["NI"]
}, {
  pk: 4349,
  ang: "Naga, Chothe",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Chothe Naga",
  lc: "nct",
  ld: "ltr",
  alt: ["Chawte", "Chote", "Chothe", "Chowte"],
  cc: ["IN"]
}, {
  pk: 4350,
  ang: "Chumburung",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Chumburung",
  lc: "ncu",
  ld: "ltr",
  alt: ["Kyongborong", "Nchimburu", "Nchummuru", "Gurubi", "Southern Chumburung (Bejamse)", "Yeji (Yedji)", "Chinderi", "Borae", "Lonto", "Northern Chumburung (Banda)"],
  cc: ["GH"]
}, {
  pk: 4351,
  ang: "Nahuatl, Central Puebla",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Central Puebla Nahuatl",
  lc: "ncx",
  ld: "ltr",
  alt: ["Central Puebla Aztec", "N\xE1huatl del Suroeste de Puebla", "Southwestern Puebla Nahuatl"],
  cc: ["MX"]
}, {
  pk: 4352,
  ang: "Natchez",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Natchez",
  lc: "ncz",
  ld: "ltr",
  alt: ["Taensa"],
  cc: ["US"]
}, {
  pk: 4353,
  ang: "Northern Ndebele",
  lr: "Africa",
  gw: false,
  hc: "ZW",
  ln: "isiNdebele",
  lc: "nd",
  ld: "ltr",
  alt: ["Isinde'bele", "Northern Ndebele", "Sindebele", "Tabele", "Tebele"],
  cc: ["ZM", "ZW", "BW"]
}, {
  pk: 4354,
  ang: "Ndasa",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Ndasa",
  lc: "nda",
  ld: "ltr",
  alt: ["Andasa", "Ndash", "Ndassa"],
  cc: ["GA", "CG"]
}, {
  pk: 4355,
  ang: "Kenswei Nsei",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Kenswei Nsei",
  lc: "ndb",
  ld: "ltr",
  alt: ["Befi", "Calebasses", "Kensense", "Kenswey Nsey", "Melamba", "Mesing", "Ndop-Bamessing", "Veteng", "Vetweng"],
  cc: ["CM"]
}, {
  pk: 4356,
  ang: "Ndau",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Ndau",
  lc: "ndc",
  ld: "ltr",
  alt: ["Chindau", "Ndzawu", "Njao", "Sofala", "Southeast Shona", "Watonga", "Ndau (Cindau)", "Senji", "Shanga (Changa)", "Tonga (Abatonga)", "Vadanda", "Watande", "Xanga", "Gova (Cigova)", "Mashanga", "Wadondo", "Chixanga", "Ndanda", "Batoka", "Batonga", "Changa (Chichanga)", "Dondo (Chibabava)", "Chisenji", "Cidondo", "Cimashanga", "Cindanda", "Danda (Cidanda)", "Atonga", "Chichanga"],
  cc: ["MZ", "TH", "ZW"]
}, {
  pk: 4357,
  ang: "Nde-Nsele-Nta",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Nde-Nsele-Nta",
  lc: "ndd",
  ld: "ltr",
  alt: ["Nde (Befon)", "Udom", "Nsele (Nselle)", "Mbenkpe", "Ekamtulufu", "Atam", "Nta (Afunatam)", "Mbofon"],
  cc: ["NG"]
}, {
  pk: 4358,
  ang: "Nadruvian",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "Nadruvian",
  lc: "ndf",
  ld: "ltr",
  alt: [],
  cc: ["RU"]
}, {
  pk: 4359,
  ang: "Ndengereko",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Ndengereko",
  lc: "ndg",
  ld: "ltr",
  alt: ["Kindengereko", "Kingengereko", "Ndengeleko"],
  cc: ["TZ"]
}, {
  pk: 4360,
  ang: "Ndali",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Ndali",
  lc: "ndh",
  ld: "ltr",
  alt: ["Chindali", "Cindali", "Icindali", "Ici-Ndali", "Kindali", "Ndari", "Sukwa"],
  cc: ["TZ", "MW"]
}, {
  pk: 8203,
  ang: "Chisukwa",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Chisukwa",
  lc: "ndh-x-chisukwa",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4361,
  ang: "Samba Leko",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Samba Leko",
  lc: "ndi",
  ld: "ltr",
  alt: ["Chamba Leeko", "Samba", "Chamba Leko", "Lego", "Leko", "Lekon", "Ndi", "Samba Leeko", "Suntai", "Ndii", "Deenu (Koola)", "Samba Leko (Laeko)"],
  cc: ["CM", "NG"]
}, {
  pk: 4362,
  ang: "Ndamba",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Ndamba",
  lc: "ndj",
  ld: "ltr",
  alt: ["Kindamba"],
  cc: ["TZ"]
}, {
  pk: 4363,
  ang: "Ndaka",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ndaka",
  lc: "ndk",
  ld: "ltr",
  alt: ["Indaaka", "Ndaaka"],
  cc: ["CD"]
}, {
  pk: 4364,
  ang: "Ndolo",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ndolo",
  lc: "ndl",
  ld: "ltr",
  alt: ["Mosange", "Ndoolo", "Tando"],
  cc: ["CD"]
}, {
  pk: 4365,
  ang: "Ndam",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Ndam",
  lc: "ndm",
  ld: "ltr",
  alt: ["Dam", "Ndamm", "Ndam Dik (Northern Ndam)", "Ndam-Ndam (Southern Ndam)"],
  cc: ["TD"]
}, {
  pk: 4366,
  ang: "Ngundi",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Ngundi",
  lc: "ndn",
  ld: "ltr",
  alt: ["Ingundi", "Ngondi"],
  cc: ["CG"]
}, {
  pk: 4367,
  ang: "Ndo",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Ndo",
  lc: "ndp",
  ld: "ltr",
  alt: ["Ke'bu", "Ndu", "Oke'bu", "Kebu", "Mombi", "Avere", "Ndo Oke'bu", "Oke'bu (Kebu)", "Aviritu", "Avari (Avere)", "Avari (Avare)", "Membi (Meembi)", "Membitu"],
  cc: ["UG"]
}, {
  pk: 4368,
  ang: "Ndombe",
  lr: "Africa",
  gw: false,
  hc: "AO",
  ln: "Ndombe",
  lc: "ndq",
  ld: "ltr",
  alt: ["Dombe"],
  cc: ["AO"]
}, {
  pk: 4369,
  ang: "Ndoola",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ndoola",
  lc: "ndr",
  ld: "ltr",
  alt: ["Njoyame", "Nundoro", "Ndola"],
  cc: ["CM", "NG"]
}, {
  pk: 4370,
  ang: "Saxon, Low",
  lr: "Europe",
  gw: false,
  hc: "DE",
  ln: "Low German",
  lc: "nds",
  ld: "ltr",
  alt: ["Low German", "Nedderd\xFCtsch", "Neddersassisch", "Nedersaksisch", "Niedersaechsisch", "Plattdeutsch", "Plattd\xFC\xFCtsch", "Maerkisch-Brandenburgisch", "Ostf\xE4lisch", "Mecklenburg-Anterior Pomerania (Mecklenburgisch-Vorpommersch)", "Mark-Brandenburg (East Prussian)", "Holsteinisch", "Eastphalian (Ostfaelisch)", "M\xE4rkisch-Brandenburgisch"],
  cc: ["DE", "NL"]
}, {
  pk: 4371,
  ang: "Ndunga",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ndunga",
  lc: "ndt",
  ld: "ltr",
  alt: ["Bondonga", "Modunga", "Mondugu", "Mondunga"],
  cc: ["CD"]
}, {
  pk: 4372,
  ang: "Dugun",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Dugun",
  lc: "ndu",
  ld: "ltr",
  alt: ["Pani", "Panon", "Pa'non", "Saa"],
  cc: ["CM"]
}, {
  pk: 4373,
  ang: "Ndut",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Ndut",
  lc: "ndv",
  ld: "ltr",
  alt: ["Ndoute"],
  cc: ["SN"]
}, {
  pk: 4374,
  ang: "Ndobo",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ndobo",
  lc: "ndw",
  ld: "ltr",
  alt: ["Ndoobo"],
  cc: ["CD"]
}, {
  pk: 4375,
  ang: "Nduga",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Nduga",
  lc: "ndx",
  ld: "ltr",
  alt: ["Dauwa", "Dawa", "Ndauwa", "Ndugwa", "Pesecham", "Pesechem", "Pesegem"],
  cc: ["ID"]
}, {
  pk: 4376,
  ang: "Lutos",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Lutos",
  lc: "ndy",
  ld: "ltr",
  alt: ["Ndoukwa", "Wada (Wad)", "Ruto (Louto)", "Routo", "Rito", "Nduga (Ngougua)", "Lutos (Louto)", "Luto", "Nduka (Ndouka)"],
  cc: ["CF", "TD"]
}, {
  pk: 4377,
  ang: "Ndogo",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Ndogo",
  lc: "ndz",
  ld: "ltr",
  alt: [],
  cc: ["SS"]
}, {
  pk: 4378,
  ang: "Nepali",
  lr: "Asia",
  gw: true,
  hc: "NP",
  ln: "\u0928\u0947\u092A\u093E\u0932\u0940",
  lc: "ne",
  ld: "ltr",
  alt: [],
  cc: ["NP"]
}, {
  pk: 4379,
  ang: "Ngad\u2019a, Eastern",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Eastern Ngad'a",
  lc: "nea",
  ld: "ltr",
  alt: ["Southeast Ngada"],
  cc: ["ID"]
}, {
  pk: 4380,
  ang: "Toura",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Toura (C\xF4te d'Ivoire)",
  lc: "neb",
  ld: "ltr",
  alt: ["Tura", "Ween", "Guse"],
  cc: ["CI"]
}, {
  pk: 4381,
  ang: "Nedebang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Nedebang",
  lc: "nec",
  ld: "ltr",
  alt: ["Balungada", "Klamu", "N\xE9debang"],
  cc: ["ID"]
}, {
  pk: 4382,
  ang: "Nde-Gbite",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Nde-Gbite",
  lc: "ned",
  ld: "ltr",
  alt: ["Biti", "B\xF6t\xF6"],
  cc: ["NG"]
}, {
  pk: 4383,
  ang: "N\xEAl\xEAmwa-Nixumwak",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "N\xEAl\xEAmwa-Nixumwak",
  lc: "nee",
  ld: "ltr",
  alt: ["Fwa-Goumak", "Koumac", "Nelemwa (Nelema)", "Nixumwak (Fwa Kumak)"],
  cc: ["NC"]
}, {
  pk: 4384,
  ang: "Nefamese",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Nefamese",
  lc: "nef",
  ld: "ltr",
  alt: ["Arunamese"],
  cc: ["IN"]
}, {
  pk: 4385,
  ang: "Negidal",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041D\u0435\u0433\u0438\u0434\u0430\u043B\u044C\u0441\u043A\u0438\u0439",
  lc: "neg",
  ld: "ltr",
  alt: ["El'kan Beye", "Elkembey", "Ilkan Beye", "Neghidal", "Negidaly"],
  cc: ["RU"]
}, {
  pk: 4386,
  ang: "Nyenkha",
  lr: "Asia",
  gw: false,
  hc: "BT",
  ln: "Nyenkha",
  lc: "neh",
  ld: "ltr",
  alt: ["Henkha", "Lap", "Mangdhika", "Mangsdekha"],
  cc: ["BT"]
}, {
  pk: 4387,
  ang: "Neo Hittite",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Neo-Hittite",
  lc: "nei",
  ld: "ltr",
  alt: [],
  cc: ["TR"]
}, {
  pk: 4388,
  ang: "Neko",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Neko",
  lc: "nej",
  ld: "ltr",
  alt: ["Yarete"],
  cc: ["PG"]
}, {
  pk: 4389,
  ang: "Neku",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Neku",
  lc: "nek",
  ld: "ltr",
  alt: [],
  cc: ["NC"]
}, {
  pk: 4390,
  ang: "Nemi",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Nemi",
  lc: "nem",
  ld: "ltr",
  alt: ["East Coast Nemi", "West Coast Nemi"],
  cc: ["NC"]
}, {
  pk: 4391,
  ang: "Nengone",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Nengone",
  lc: "nen",
  ld: "ltr",
  alt: ["Iwatenu", "Pene Nengone"],
  cc: ["NC"]
}, {
  pk: 4392,
  ang: "N\xE1-Meo",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "N\xE1-Meo",
  lc: "neo",
  ld: "ltr",
  alt: [],
  cc: ["VN"]
}, {
  pk: 7591,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Pahari",
  lc: "nep-x-pahari",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4393,
  ang: "Mixe, North Central",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "North Central Mixe",
  lc: "neq",
  ld: "ltr",
  alt: ["Atitl\xE1n Mixe", "Mixe de Atitl\xE1n", "Northeastern Mixe", "Mixistlan", "Zacatepec", "Olotepec", "Cotzoc\xF3n Mixe", "Puxmetec\xE1n", "Mixe de San Juan Cotzoc\xF3n"],
  cc: ["MX"]
}, {
  pk: 4394,
  ang: "Yahadian",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Yahadian",
  lc: "ner",
  ld: "ltr",
  alt: ["Jahadian", "Yabin Yahadian"],
  cc: ["ID"]
}, {
  pk: 4395,
  ang: "Kinnauri, Bhoti",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bhoti Kinnauri",
  lc: "nes",
  ld: "ltr",
  alt: ["Bhotea of Upper Kinnauri", "Bod-Skad", "Bud-Kat", "Myamkat", "Myamskad", "Nyamkat", "Nyamskad", "Puh", "Sangs-Rgyas", "Sangyas"],
  cc: ["IN"]
}, {
  pk: 4396,
  ang: "Nete",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nete",
  lc: "net",
  ld: "ltr",
  alt: ["Iniai", "Malamauda", "Malaumanda"],
  cc: ["PG"]
}, {
  pk: 4397,
  ang: "",
  lr: "",
  gw: false,
  hc: "",
  ln: "Neo",
  lc: "neu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4398,
  ang: "Nyaheun",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Nyaheun",
  lc: "nev",
  ld: "ltr",
  alt: ["Hin", "Hoen", "Hun", "Nha Heun", "Nia Hoen", "Niahon", "Nyah Heuny", "Nyah\xF6n", "Yaheun"],
  cc: ["LA"]
}, {
  pk: 4399,
  ang: "Newar",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u0928\u0947\u0935\u093E\u0903 \u092D\u093E\u092F\u094D",
  lc: "new",
  ld: "ltr",
  alt: ["Nepal Bhasa", "Newaah Bhaaye", "Newal Bhaye", "Badikhel Pahari", "Dolkhali (Dolakha)", "Kathmandu-Patan-Kirtipur", "Pahri", "Pyang Gaon", "Sindhupalchok Pahri (Pahari)"],
  cc: ["NP"]
}, {
  pk: 4400,
  ang: "Neme",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Neme",
  lc: "nex",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4401,
  ang: "Neyo",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Neyo",
  lc: "ney",
  ld: "ltr",
  alt: ["Gwibwen", "Towi"],
  cc: ["CI"]
}, {
  pk: 4402,
  ang: "Nez Perce",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Nez Perce",
  lc: "nez",
  ld: "ltr",
  alt: ["Nuumiipuutimt", "Nuumiipuut\xEDmt", "Downriver", "Upriver"],
  cc: ["US"]
}, {
  pk: 4403,
  ang: "Dhao",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dhao",
  lc: "nfa",
  ld: "ltr",
  alt: ["Dao", "Kahore", "Ndao", "Ndaonese", "Ndaundau"],
  cc: ["ID"]
}, {
  pk: 4404,
  ang: "Ahwai",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ahwai",
  lc: "nfd",
  ld: "ltr",
  alt: ["Nyeng (Hanyeng)", "Shakara (Isakara)", "Ndun (Indun)", "Nandu", "Tari", "Ningon"],
  cc: ["NG"]
}, {
  pk: 4405,
  ang: "\xC4iwoo",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Ayiwo",
  lc: "nfl",
  ld: "ltr",
  alt: ["A\xEFwo", "Gnivo", "Lomlom", "Naaude", "Nifilole", "Nivo", "Reef Islands", "Reefs"],
  cc: ["SB"]
}, {
  pk: 4406,
  ang: "Nafaanra",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Nafaanra",
  lc: "nfr",
  ld: "ltr",
  alt: ["Banda", "Dzama", "Gambo", "Nafaara", "Nafana", "Pantera-Fantera"],
  cc: ["GH"]
}, {
  pk: 4407,
  ang: "Mfumte",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mfumte",
  lc: "nfu",
  ld: "ltr",
  alt: ["Nfumte", "Koffa (Kofa)", "Lus"],
  cc: ["CM"]
}, {
  pk: 4408,
  ang: "Ndonga",
  lr: "Africa",
  gw: false,
  hc: "NA",
  ln: "Owambo",
  lc: "ng",
  ld: "ltr",
  alt: ["Ambo", "Ochindonga", "Oshindonga", "Osindonga", "Otjiwambo", "Owambo"],
  cc: ["AO", "NA"]
}, {
  pk: 4409,
  ang: "Ngbaka",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ngbaka",
  lc: "nga",
  ld: "ltr",
  alt: ["Ngbaka Gbaya", "Ngbaka Minangende"],
  cc: ["CF", "CG", "CD"]
}, {
  pk: 4410,
  ang: "Ngbandi, Northern",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Northern Ngbandi",
  lc: "ngb",
  ld: "ltr",
  alt: ["Baza", "Mongwandi", "Ngwandi"],
  cc: ["CF", "CD"]
}, {
  pk: 4411,
  ang: "Ngombe",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ngombe (Democratic Republic of Congo)",
  lc: "ngc",
  ld: "ltr",
  alt: ["Lingombe", "Libinja", "Binja (Binza)", "Libindja"],
  cc: ["CD"]
}, {
  pk: 7939,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bodjenga",
  lc: "ngc-x-bodjenga",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7954,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bondjale",
  lc: "ngc-x-bondjale",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7940,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Muwera",
  lc: "ngc-x-muwera",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4412,
  ang: "Ngando",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Ngando (Central African Republic)",
  lc: "ngd",
  ld: "ltr",
  alt: ["Bagandou", "Bangandou", "Bodzanga", "Dingando", "Ngando-Kota", "Dikota (Kota)"],
  cc: ["CF"]
}, {
  pk: 4413,
  ang: "Ngemba",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Ngemba",
  lc: "nge",
  ld: "ltr",
  alt: ["Megimba", "Mogimba", "Ngomba", "Nguemba", "Mbotu", "Nkune", "Njong (Banjong)", "Mundum 2", "Mundum 1", "Mukohn", "Mbutu (Alamatu)", "Mbrerewi (Bamundum 1)", "Shomba (Almatson)", "Mangkunge (Bande)", "Bandeng", "Bande'", "Bamechom", "Bambutu", "Bagangu (Akum)", "Anyang (Bamundum 2)", "Mankon (Bida)", "Alatening (Alatining)"],
  cc: ["CM"]
}, {
  pk: 4414,
  ang: "Ngbaka Manza",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Ngbaka Manza",
  lc: "ngg",
  ld: "ltr",
  alt: [],
  cc: ["CF", "PG"]
}, {
  pk: 4415,
  ang: "N|u",
  lr: "Africa",
  gw: false,
  hc: "ZA",
  ln: "N|u",
  lc: "ngh",
  ld: "ltr",
  alt: ["\u2021Khomani", "Nghuki", "Ng'uki", "N|u", "Ng||-|e", "|Ing|ke", "||Kxau", "||Ng!ke (||Ng)", "|'Auni"],
  cc: ["ZA"]
}, {
  pk: 4416,
  ang: "Ngizim",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ng\u0259z\u0259m",
  lc: "ngi",
  ld: "ltr",
  alt: ["Ngezzim", "Ngizmawa"],
  cc: ["NG"]
}, {
  pk: 4417,
  ang: "Ngie",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Ngie",
  lc: "ngj",
  ld: "ltr",
  alt: ["Angie", "Baminge", "Baninge", "Mingi", "Ugie", "Ungie", "Mengum"],
  cc: ["CM"]
}, {
  pk: 4418,
  ang: "Dalabon",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Dalabon",
  lc: "ngk",
  ld: "ltr",
  alt: ["Bouin", "Boun", "Buan", "Buin", "Buwan", "Gundangbon", "Nalabon", "Ngalabon", "Ngalkbon"],
  cc: ["AU"]
}, {
  pk: 4419,
  ang: "Lomwe",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Lomwe",
  lc: "ngl",
  ld: "ltr",
  alt: ["Acilowe", "Alomwe", "Chilowe", "Cilowe", "Elomwe", "Ilomwe", "Ingulu", "Lomue", "Mihavane", "Mihavani", "Mihawani", "Ngulu", "Nguru", "Walomwe", "Western Makua"],
  cc: ["MZ", "MW"]
}, {
  pk: 4420,
  ang: "Ngatik Men\u2019s Creole",
  lr: "Pacific",
  gw: false,
  hc: "FM",
  ln: "Ngatik Men's Creole",
  lc: "ngm",
  ld: "ltr",
  alt: ["Ngatikese", "Ngatikese Men's Language"],
  cc: ["FM"]
}, {
  pk: 4421,
  ang: "Ngwo",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Ngwo",
  lc: "ngn",
  ld: "ltr",
  alt: ["Ngunu", "Ngwo (Miguhni)", "Nguni", "Ikweri (Ekperi)", "Basa (Bassa)"],
  cc: ["CM"]
}, {
  pk: 4422,
  ang: "Ngoni",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Ngoni",
  lc: "ngo",
  ld: "ltr",
  alt: ["Angoni", "Chingoni", "Kingoni", "Kisutu", "Sutu"],
  cc: ["TZ"]
}, {
  pk: 4423,
  ang: "Ngulu",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Ngulu",
  lc: "ngp",
  ld: "ltr",
  alt: ["Geja", "Kingulu", "Nguru", "Wayomba"],
  cc: ["TZ"]
}, {
  pk: 4424,
  ang: "Ngoreme",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Ngurimi",
  lc: "ngq",
  ld: "ltr",
  alt: ["Dengurume", "Ikingurimi", "Kingoreme", "Ngruimi", "Ngurimi", "Nguruimi"],
  cc: ["TZ"]
}, {
  pk: 4425,
  ang: "Engdewu",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Engdewu",
  lc: "ngr",
  ld: "ltr",
  alt: ["Nagu", "Nangu"],
  cc: ["SB"]
}, {
  pk: 4426,
  ang: "Gvoko",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Gvoko",
  lc: "ngs",
  ld: "ltr",
  alt: ["Gavoko", "Gevoko", "Ghboko", "Kuvoko", "Ngoshe-Ndhang", "Ngoshi", "Ngossi", "Nggweshe", "Ngoshe Sama", "Ngweshe-Ndaghan"],
  cc: ["CM", "NG"]
}, {
  pk: 4427,
  ang: "Ngeq",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Ngeq",
  lc: "ngt",
  ld: "ltr",
  alt: ["Kriang", "Ngae", "Nge'", "Ngeh", "Nkriang"],
  cc: ["LA"]
}, {
  pk: 4428,
  ang: "Nahuatl, Guerrero",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Guerrero Nahuatl",
  lc: "ngu",
  ld: "ltr",
  alt: ["Guerrero Aztec", "N\xE1huatl de Guerrero"],
  cc: ["MX"]
}, {
  pk: 4429,
  ang: "Ngwaba",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ngwaba",
  lc: "ngw",
  ld: "ltr",
  alt: ["Goba", "Gombi"],
  cc: ["NG"]
}, {
  pk: 4430,
  ang: "Nggwahyi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Nggwahyi",
  lc: "ngx",
  ld: "ltr",
  alt: ["Ngwaxi", "Ngwohi"],
  cc: ["NG"]
}, {
  pk: 4431,
  ang: "Tibea",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Tibea",
  lc: "ngy",
  ld: "ltr",
  alt: ["Djanti", "Minjanti", "Ngayaba", "Njanti", "Nyabea", "Zangnte"],
  cc: ["CM"]
}, {
  pk: 4432,
  ang: "Ngungwel",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Ngungwel",
  lc: "ngz",
  ld: "ltr",
  alt: ["Engungwel", "Ngangoulou", "Ngungulu", "Northeastern Teke", "Mpu (Mpumpum)"],
  cc: ["CG"]
}, {
  pk: 4433,
  ang: "Nhanda",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Nhanda",
  lc: "nha",
  ld: "ltr",
  alt: ["Nanda", "Nanta", "Nhanta", "Nubda", "Nunta"],
  cc: ["AU"]
}, {
  pk: 4434,
  ang: "Beng",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Beng",
  lc: "nhb",
  ld: "ltr",
  alt: ["Ben", "Gan", "Ngain", "Ngan", "Ngen", "Ngin", "Nguin"],
  cc: ["CI"]
}, {
  pk: 4435,
  ang: "Nahuatl, Tabasco",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tabasco Nahuatl",
  lc: "nhc",
  ld: "ltr",
  alt: ["Tabasco Aztec"],
  cc: ["MX"]
}, {
  pk: 4436,
  ang: "Guaran\xED, Ava",
  lr: "Americas",
  gw: false,
  hc: "PY",
  ln: "Chirip\xE1",
  lc: "nhd",
  ld: "ltr",
  alt: ["Apytare", "Ava Guaran\xED", "\xD1andeva", "Nhandeva", "Tsirip\xE1", "Txirip\xE1", "Guaran\xED", "Nandeva", "Ava", "Chirip\xE1"],
  cc: ["BR", "PY"]
}, {
  pk: 4437,
  ang: "Nahuatl, Eastern Huasteca",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Eastern Huasteca Nahuatl",
  lc: "nhe",
  ld: "ltr",
  alt: ["Eastern Huasteca Aztec", "N\xE1huatl de Hidalgo", "N\xE1huatl de la Huasteca Oriental", "Southeastern Huasteca Nahuatl"],
  cc: ["MX"]
}, {
  pk: 4438,
  ang: "Nhuwala",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Nhuwala",
  lc: "nhf",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 4439,
  ang: "Nahuatl, Tetelcingo",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tetelcingo Nahuatl",
  lc: "nhg",
  ld: "ltr",
  alt: ["Tetelcingo Aztec"],
  cc: ["MX"]
}, {
  pk: 4440,
  ang: "Nahari",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Nahari",
  lc: "nhh",
  ld: "ltr",
  alt: ["Nahali"],
  cc: ["IN"]
}, {
  pk: 4441,
  ang: "Nahuatl, Zacatl\xE1n-Ahuacatl\xE1n-Tepetzintla",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Zacatl\xE1n-Ahuacatl\xE1n-Tepetzintla Nahuatl",
  lc: "nhi",
  ld: "ltr",
  alt: ["Ahuacatl\xE1n and Tepetzintla", "Ahuacatl\xE1n y Tepetzintla", "Aztec of Zacatl\xE1n", "N\xE1huatl de Zacatl\xE1n", "Tenango Nahuatl", "Tlalitzlipa Nahuatl", "Zacatl\xE1n-Ahuacatl\xE1n-Tepetzintla Nahuatl"],
  cc: ["MX", "US"]
}, {
  pk: 4442,
  ang: "Nahuatl, Isthmus-Cosoleacaque",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Isthmus-Cosoleacaque Nahuatl",
  lc: "nhk",
  ld: "ltr",
  alt: ["Cosoleacaque Aztec", "N\xE1huatl del Istmo-Cosoleacaque"],
  cc: ["MX"]
}, {
  pk: 4443,
  ang: "Nahuatl, Morelos",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Morelos Nahuatl",
  lc: "nhm",
  ld: "ltr",
  alt: ["N\xE1huatl de Cuentepec"],
  cc: ["MX"]
}, {
  pk: 4444,
  ang: "Nahuatl, Central",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Central Nahuatl",
  lc: "nhn",
  ld: "ltr",
  alt: ["Central Aztec", "N\xE1huatl del Centro", "Tlaxcala-Puebla Nahuatl"],
  cc: ["MX"]
}, {
  pk: 4445,
  ang: "Takuu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Takuu",
  lc: "nho",
  ld: "ltr",
  alt: ["Mortlock", "Taku", "Tau", "Tauu"],
  cc: ["PG"]
}, {
  pk: 4446,
  ang: "Nahuatl, Isthmus-Pajapan",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Isthmus-Pajapan Nahuatl",
  lc: "nhp",
  ld: "ltr",
  alt: ["N\xE1huat de Pajapan"],
  cc: ["MX"]
}, {
  pk: 4447,
  ang: "Nahuatl, Huaxcaleca",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Huaxcaleca Nahuatl",
  lc: "nhq",
  ld: "ltr",
  alt: ["Huaxcaleca Aztec", "N\xE1huatl de Chichiquila"],
  cc: ["MX"]
}, {
  pk: 4448,
  ang: "Naro",
  lr: "Africa",
  gw: false,
  hc: "BW",
  ln: "Naro",
  lc: "nhr",
  ld: "ltr",
  alt: ["||Ai||e", "||Ai||en", "||Aikwe", "||Aisan", "|Aikwe", "Nharo", "Nharon", "Nhauru", "Nhaurun", "Qabekhoe (!Kabbakwe)", "Tsaukwe", "Ts'aokhoe (Tsaokhwe)", "Qabekho", "N|hai-Ntse'e (N||hai)", "|Anekwe", "|Amkwe", "!Gingkwe", "Ts'ao"],
  cc: ["BW"]
}, {
  pk: 4449,
  ang: "Nahuatl, Ometepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Ometepec Nahuatl",
  lc: "nht",
  ld: "ltr",
  alt: ["Ometepec Aztec"],
  cc: ["MX"]
}, {
  pk: 4450,
  ang: "Noone",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Noone",
  lc: "nhu",
  ld: "ltr",
  alt: ["Nooni"],
  cc: ["CM"]
}, {
  pk: 4451,
  ang: "Nahuatl, Temascaltepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Temascaltepec Nahuatl",
  lc: "nhv",
  ld: "ltr",
  alt: ["Almomoloya N\xE1huatl", "Temascaltepec Aztec"],
  cc: ["MX"]
}, {
  pk: 4452,
  ang: "Nahuatl, Western Huasteca",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Western Huasteca Nahuatl",
  lc: "nhw",
  ld: "ltr",
  alt: ["N\xE1huatl de la Huasteca Occidental", "N\xE1huatl de Tamazunchale", "Western Huasteca Aztec", "Western Huasteca N\xE1huatl"],
  cc: ["MX"]
}, {
  pk: 4453,
  ang: "Nahuatl, Isthmus-Mecayapan",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Isthmus-Mecayapan Nahuatl",
  lc: "nhx",
  ld: "ltr",
  alt: ["Isthmus Aztec-Mecayapan", "N\xE1huat de Mecayapan"],
  cc: ["MX"]
}, {
  pk: 4454,
  ang: "Nahuatl, Northern Oaxaca",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Northern Oaxaca Nahuatl",
  lc: "nhy",
  ld: "ltr",
  alt: ["N\xE1huatl del Norte de Oaxaca"],
  cc: ["MX"]
}, {
  pk: 4455,
  ang: "Nahuatl, Santa Mar\xEDa la Alta",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Santa Mar\xEDa La Alta Nahuatl",
  lc: "nhz",
  ld: "ltr",
  alt: ["N\xE1huatl de Santa Mar\xEDa la Alta"],
  cc: ["MX"]
}, {
  pk: 4456,
  ang: "Nias",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Nias",
  lc: "nia",
  ld: "ltr",
  alt: ["Nias Selatan", "North Nias (Gunung Sitoli)", "West Nias", "Northwest Nias", "Central Nias", "South Nias"],
  cc: ["ID"]
}, {
  pk: 7857,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Telo",
  lc: "nia-x-telo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7830,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Teluk Dalam",
  lc: "nia-x-telukdalam",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4457,
  ang: "Nakame",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nakame",
  lc: "nib",
  ld: "ltr",
  alt: ["North Nakame", "South Nakame"],
  cc: ["PG"]
}, {
  pk: 4458,
  ang: "Ngandi",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Ngandi",
  lc: "nid",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 4459,
  ang: "Niellim",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Niellim",
  lc: "nie",
  ld: "ltr",
  alt: ["Lua", "Mjillem", "Nielim", "Nyilem", "Cuni", "Tchini (Cini)"],
  cc: ["TD"]
}, {
  pk: 4460,
  ang: "Nek",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nek",
  lc: "nif",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4461,
  ang: "Nyiha, Tanzania",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Nyiha (Tanzania)",
  lc: "nih",
  ld: "ltr",
  alt: ["Ishinyiha", "Isinyixa", "Kinyiha", "Nyika", "Nyixa", "Shinyiha", "Mbozi", "Sumbawanga"],
  cc: ["TZ"]
}, {
  pk: 4462,
  ang: "Nii",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nii",
  lc: "nii",
  ld: "ltr",
  alt: ["Ek Nii"],
  cc: ["PG"]
}, {
  pk: 4463,
  ang: "Ngaju",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ngaju",
  lc: "nij",
  ld: "ltr",
  alt: ["Biadju", "Dayak Ngaju", "Ngadju", "Ngaju Dayak", "Southwest Barito", "Sampit", "Ba'amang (Bara-Bare)", "Kahayan Kapuas", "Katingan Ngaju", "Katingan Ngawa", "Mantangai (Oloh Mangtangai)"],
  cc: ["ID"]
}, {
  pk: 8202,
  ang: "Dayak Bulik",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Bulik",
  lc: "nij-x-dayakbulik",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7918,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Mali",
  lc: "nij-x-dayakmali",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7951,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Tengon",
  lc: "nij-x-dayaktengon",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8000,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Kahayan",
  lc: "nij-x-kahayan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7999,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Kapuas",
  lc: "nij-x-kapuas",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7994,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Katingan",
  lc: "nij-x-katingan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8115,
  ang: "Katingan Hilir",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Katingan Hilir",
  lc: "nij-x-katinganhilir",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8114,
  ang: "Katingan Hulu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Katingan Hulu",
  lc: "nij-x-katinganhulu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8116,
  ang: "Katingan Tengah",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Katingan Tengah",
  lc: "nij-x-katingantengah",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8336,
  ang: "Menuhing Tehang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Menuhing Tehang",
  lc: "nij-x-menuhing",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8014,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Nyadupm",
  lc: "nij-x-nyadupm",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8341,
  ang: "Samba Danum",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Samba Danum",
  lc: "nij-x-sambadanum",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4464,
  ang: "Nicobarese, Southern",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Southern Nicobarese",
  lc: "nik",
  ld: "ltr",
  alt: ["Nicobara", "Condul (Kondul)"],
  cc: ["IN"]
}, {
  pk: 4465,
  ang: "Nilamba",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Nilamba",
  lc: "nim",
  ld: "ltr",
  alt: ["Ikinilamba", "Ikiniramba", "Ilamba", "Kinilamba", "Kiniramba", "Nilyamba", "Niramba", "Nyilamba"],
  cc: ["TZ"]
}, {
  pk: 4466,
  ang: "Ninzo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ninzo",
  lc: "nin",
  ld: "ltr",
  alt: ["Akiza", "Amar Tita", "Ancha", "Fadan Wate", "Gbhu D Amar Randfa", "Hate", "Incha", "Kwasu", "Nunzo"],
  cc: ["NG"]
}, {
  pk: 4467,
  ang: "Nganasan",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041D\u0433\u0430\u043D\u0430\u0441\u0430\u043D\u0441\u043A\u0438\u0439",
  lc: "nio",
  ld: "ltr",
  alt: ["Nya", "Tavgi Samoyed", "Avam (West)"],
  cc: ["RU"]
}, {
  pk: 4468,
  ang: "Nandi",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Nandi",
  lc: "niq",
  ld: "ltr",
  alt: ["Cemual", "Naandi"],
  cc: ["KE"]
}, {
  pk: 4469,
  ang: "Nimboran",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Nimboran",
  lc: "nir",
  ld: "ltr",
  alt: ["Nambrong"],
  cc: ["ID"]
}, {
  pk: 4470,
  ang: "Nimi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nimi",
  lc: "nis",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4471,
  ang: "Kolami, Southeastern",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Southeastern Kolami",
  lc: "nit",
  ld: "ltr",
  alt: ["Metla-Kinwat"],
  cc: ["IN"]
}, {
  pk: 4472,
  ang: "Niue",
  lr: "Pacific",
  gw: false,
  hc: "NU",
  ln: "Niuean",
  lc: "niu",
  ld: "ltr",
  alt: ["Niuean", "Niuefekai"],
  cc: ["CK", "NU", "NZ", "TO", "US"]
}, {
  pk: 4473,
  ang: "Gilyak",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041D\u0438\u0432\u0445\u0441\u043A\u0438\u0439",
  lc: "niv",
  ld: "ltr",
  alt: ["Nivkh", "Nivkhi"],
  cc: ["RU"]
}, {
  pk: 4474,
  ang: "Nimo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nimo",
  lc: "niw",
  ld: "ltr",
  alt: ["Nimo-Wasawai"],
  cc: ["PG"]
}, {
  pk: 4475,
  ang: "Hema",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Hema",
  lc: "nix",
  ld: "ltr",
  alt: ["Congo Nyoro", "Hema-Sud", "Kihema", "Nyoro", "Oruhuma", "Runyoro", "Southern Hema"],
  cc: ["CD", "UG"]
}, {
  pk: 4476,
  ang: "Ngiti",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ngiti",
  lc: "niy",
  ld: "ltr",
  alt: ["Bindi", "Druna", "Kingeti", "Kingiti", "Lendu-Sud", "Ngeti"],
  cc: ["CD"]
}, {
  pk: 4477,
  ang: "Ningil",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ningil",
  lc: "niz",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4478,
  ang: "Nzanyi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Nzanyi",
  lc: "nja",
  ld: "ltr",
  alt: ["Jeng", "Kobochi", "Kobotshi", "Mzangyim", "Njanyi", "Njegn", "Njei", "Njeng", "Njeny", "Nzangi", "Zani", "Zany", "Jenge", "Njeing"],
  cc: ["CM", "NG"]
}, {
  pk: 4479,
  ang: "Naga, Nocte",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Nocte Naga",
  lc: "njb",
  ld: "ltr",
  alt: ["Borduria", "Jaipuria", "Mohongia", "Namsangia", "Nocte", "Nokte", "Paniduria", "Khapa", "Ponthai (Lamlak)"],
  cc: ["IN"]
}, {
  pk: 4480,
  ang: "Ndonde Hamba",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Ndonde Hamba",
  lc: "njd",
  ld: "ltr",
  alt: ["Chindonde", "Chindonde Hamba", "Kimawanda", "Kindonde Hamba", "Mawanda", "Ndomde"],
  cc: ["TZ"]
}, {
  pk: 4481,
  ang: "Naga, Lotha",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Lotha Naga",
  lc: "njh",
  ld: "ltr",
  alt: ["Chizima", "Choimi", "Hlota", "Lhota", "Lotha", "Lutha", "Miklai", "Tsindir", "Tsontsii"],
  cc: ["IN"]
}, {
  pk: 4482,
  ang: "Gudanji",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Gudanji",
  lc: "nji",
  ld: "ltr",
  alt: ["Kurdanji", "Ngarnga", "Binbinka"],
  cc: ["AU"]
}, {
  pk: 4483,
  ang: "Njen",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Njen",
  lc: "njj",
  ld: "ltr",
  alt: ["Nen", "Nyen", "Nzin"],
  cc: ["CM"]
}, {
  pk: 4484,
  ang: "Njalgulgule",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Njalgulgule",
  lc: "njl",
  ld: "ltr",
  alt: ["Bege", "Begi", "Beko", "Ngulgule", "Njangulgule", "Nyolge", "Nyoolne"],
  cc: ["SS"]
}, {
  pk: 4485,
  ang: "Naga, Angami",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Angami Naga",
  lc: "njm",
  ld: "ltr",
  alt: ["Angamis", "Gnamei", "Monr", "Ngami", "Tendydie", "Tsanglo", "Tsoghami", "Tsugumi", "Chakroma (Western Angami)", "Tengima (Kohima)"],
  cc: ["IN"]
}, {
  pk: 4486,
  ang: "Naga, Liangmai",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Liangmai Naga",
  lc: "njn",
  ld: "ltr",
  alt: ["Kacha", "Liangmai", "Liangmei", "Liyang", "Lyangmay", "Lyengmai"],
  cc: ["IN"]
}, {
  pk: 4487,
  ang: "Naga, Ao",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Ao Naga",
  lc: "njo",
  ld: "ltr",
  alt: ["Ao", "Aorr", "Cholimi", "Hatigoria", "Nowgong", "Paimi", "Uri", "Chongli (Chungli)", "Dordar (Yacham)"],
  cc: ["IN"]
}, {
  pk: 4488,
  ang: "Njerep",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Njerep",
  lc: "njr",
  ld: "ltr",
  alt: ["Njerup"],
  cc: ["NG"]
}, {
  pk: 4489,
  ang: "Nisa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Nisa",
  lc: "njs",
  ld: "ltr",
  alt: ["Bonefa", "Kerema"],
  cc: ["ID"]
}, {
  pk: 4490,
  ang: "Ndyuka-Trio Pidgin",
  lr: "Americas",
  gw: false,
  hc: "SR",
  ln: "Ndyuka-Trio Pidgin",
  lc: "njt",
  ld: "ltr",
  alt: [],
  cc: ["SR"]
}, {
  pk: 4491,
  ang: "Kunyi",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Kunyi",
  lc: "njx",
  ld: "ltr",
  alt: ["Kikunyi", "Kugni", "Nyaanga (Kinyaanga)"],
  cc: ["CG"]
}, {
  pk: 4492,
  ang: "Njyem",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Njyem",
  lc: "njy",
  ld: "ltr",
  alt: ["Djem", "Dzem", "Ndjem", "Ndjeme", "Ndzem", "Ngyeme", "Njem", "Nyem", "Njeme"],
  cc: ["CM"]
}, {
  pk: 4493,
  ang: "Nyishi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Nyishi",
  lc: "njz",
  ld: "ltr",
  alt: ["Dafla", "Daphla", "Lel", "Nil", "Nishi", "Nisi", "Nissi", "Nyising"],
  cc: ["IN"]
}, {
  pk: 7593,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Hill Miri",
  lc: "njz-x-hillmiri",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4494,
  ang: "Nkoya",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Nkoya",
  lc: "nka",
  ld: "ltr",
  alt: ["Shinkoya", "Mbowela (Mbwela)", "Mbwera", "Shimbwera"],
  cc: ["ZM"]
}, {
  pk: 4495,
  ang: "Naga, Khoibu",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Khoibu Naga",
  lc: "nkb",
  ld: "ltr",
  alt: ["Khoibu", "Khoibu Maring", "Khoibu Maring Naga"],
  cc: ["IN"]
}, {
  pk: 4496,
  ang: "Nkongho",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Nkongho",
  lc: "nkc",
  ld: "ltr",
  alt: ["Kinkwa", "Lekongo", "Upper Mbo"],
  cc: ["CM"]
}, {
  pk: 4497,
  ang: "Koireng",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Koireng",
  lc: "nkd",
  ld: "ltr",
  alt: ["Koirng", "Kolren", "Koren", "Kwoireng", "Liangmai", "Liangmei", "Liyang", "Liyangmai", "Lyengmai", "Quoireng"],
  cc: ["IN"]
}, {
  pk: 4498,
  ang: "Duke",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Duke",
  lc: "nke",
  ld: "ltr",
  alt: ["Kolombangara", "Ndughore", "Nduke"],
  cc: ["SB"]
}, {
  pk: 4499,
  ang: "Naga, Inpui",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Inpui Naga",
  lc: "nkf",
  ld: "ltr",
  alt: ["Kabui", "Kabui Naga", "Kapwi", "Koboi", "Kubai"],
  cc: ["IN"]
}, {
  pk: 4500,
  ang: "Nekgini",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nekgini",
  lc: "nkg",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4501,
  ang: "Naga, Khezha",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Khezha Naga",
  lc: "nkh",
  ld: "ltr",
  alt: ["Kezami", "Khezhama"],
  cc: ["IN"]
}, {
  pk: 4502,
  ang: "Naga, Thangal",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Thangal Naga",
  lc: "nki",
  ld: "ltr",
  alt: ["Khoirao", "Khoirao Naga", "Koirao", "Kolya", "Mayangkhang", "Miyang-Khang", "Ngari", "Thangal", "Thanggal", "Tukaimi"],
  cc: ["IN"]
}, {
  pk: 4503,
  ang: "Nakai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Nakai",
  lc: "nkj",
  ld: "ltr",
  alt: ["Na'ai", "Nagai", "Na'i"],
  cc: ["ID"]
}, {
  pk: 4504,
  ang: "Nokuku",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Nokuku",
  lc: "nkk",
  ld: "ltr",
  alt: ["Nogugu"],
  cc: ["VU"]
}, {
  pk: 4505,
  ang: "Namat",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Namat",
  lc: "nkm",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4506,
  ang: "Nkangala",
  lr: "Africa",
  gw: false,
  hc: "AO",
  ln: "Nkangala",
  lc: "nkn",
  ld: "ltr",
  alt: ["Cangala", "Ngangala"],
  cc: ["AO"]
}, {
  pk: 4507,
  ang: "Nkonya",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Nkonya",
  lc: "nko",
  ld: "ltr",
  alt: [],
  cc: ["GH"]
}, {
  pk: 4508,
  ang: "Niuatoputapu",
  lr: "Pacific",
  gw: false,
  hc: "TO",
  ln: "Niuatoputapu",
  lc: "nkp",
  ld: "ltr",
  alt: [],
  cc: ["TO"]
}, {
  pk: 4509,
  ang: "Nkami",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Nkami",
  lc: "nkq",
  ld: "ltr",
  alt: [],
  cc: ["GH"]
}, {
  pk: 4510,
  ang: "Nukuoro",
  lr: "Pacific",
  gw: false,
  hc: "FM",
  ln: "Nukuoro",
  lc: "nkr",
  ld: "ltr",
  alt: ["Nuguor", "Nukoro"],
  cc: ["US", "FM"]
}, {
  pk: 4511,
  ang: "Asmat, North",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "North Asmat",
  lc: "nks",
  ld: "ltr",
  alt: ["Keenok"],
  cc: ["ID"]
}, {
  pk: 4512,
  ang: "Nyika, Kinyika",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Nyika",
  lc: "nkt",
  ld: "ltr",
  alt: ["Kinyiha", "Kinyika"],
  cc: ["TZ"]
}, {
  pk: 4513,
  ang: "Kulango, Bouna",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Bouna Kulango",
  lc: "nku",
  ld: "ltr",
  alt: ["Koulango", "Kulange", "Nkuraeng", "Nkurange", "Bouna Koulango", "Buna Kulango"],
  cc: ["CI"]
}, {
  pk: 4514,
  ang: "Nyika",
  lr: "Africa",
  gw: false,
  hc: "MW",
  ln: "Nyika (Malawi and Zambia)",
  lc: "nkv",
  ld: "ltr",
  alt: ["Chinyika", "Kinyika"],
  cc: ["ZM", "MW"]
}, {
  pk: 4515,
  ang: "Nkutu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Nkutu",
  lc: "nkw",
  ld: "ltr",
  alt: ["Bankutu", "Nkuchu", "Nkutshu", "Lokalo (Kalo)", "Saka (Losaka)"],
  cc: ["CD"]
}, {
  pk: 4516,
  ang: "Nkoroo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Nkoroo",
  lc: "nkx",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 4517,
  ang: "Nkari",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Nkari",
  lc: "nkz",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 4518,
  ang: "Dutch",
  lr: "Europe",
  gw: false,
  hc: "NL",
  ln: "Nederlands, Vlaams",
  lc: "nl",
  ld: "ltr",
  alt: ["Nederlands", "Vlaams", "Hollands", "Antwerps", "Northern North Hollandish (Westfries)"],
  cc: ["AT", "FR", "DE", "GB", "NL", "NZ", "RW", "SX", "ZA", "SE", "CH", "US", "AU", "CA", "LU", "DK", "AW", "SR"]
}, {
  pk: 4519,
  ang: "Ngombale",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Ngombale",
  lc: "nla",
  ld: "ltr",
  alt: ["Bamileke-Ngombale", "Babadjou (Basso)", "Bamessingue (Bassing)", "Nchobela"],
  cc: ["CM"]
}, {
  pk: 4520,
  ang: "Nalca",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Nalca",
  lc: "nlc",
  ld: "ltr",
  alt: ["Hmanggona", "Hmonono", "Kimjal", "Naltje", "Naltya"],
  cc: ["ID"]
}, {
  pk: 4521,
  ang: "Nyala",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "East Nyala",
  lc: "nle",
  ld: "ltr",
  alt: ["East", "East Nyala"],
  cc: ["KE"]
}, {
  pk: 4522,
  ang: "Gela",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Gela",
  lc: "nlg",
  ld: "ltr",
  alt: ["Florida Islands", "Nggela", "Central Gela", "Gela Pile", "Sandfly"],
  cc: ["SB"]
}, {
  pk: 4523,
  ang: "Grangali",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "\u0646\u0646\u06AF\u0644\u0627\u0645\u06CC",
  lc: "nli",
  ld: "ltr",
  alt: ["Gelangali", "Jumiaki", "Zemiaki (Zamyaki)", "Nangalami (Ningalami)"],
  cc: ["AF"]
}, {
  pk: 4524,
  ang: "Nyali",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Nyali",
  lc: "nlj",
  ld: "ltr",
  alt: ["Huku", "Linyali", "North Nyali", "Nyali-Kilo", "Nyari"],
  cc: ["CD"]
}, {
  pk: 4525,
  ang: "Yali, Ninia",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ninia Yali",
  lc: "nlk",
  ld: "ltr",
  alt: ["Jal\xE8", "Jaly", "Ninia", "North Ngalik", "Southern Yali", "Yali Selatan"],
  cc: ["ID"]
}, {
  pk: 4526,
  ang: "Nihali",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Nihali",
  lc: "nll",
  ld: "ltr",
  alt: ["Nihal"],
  cc: ["IN"]
}, {
  pk: 4527,
  ang: "Ngul",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ngul",
  lc: "nlo",
  ld: "ltr",
  alt: ["Ingul", "Ngoli", "Nguli", "Ngulu"],
  cc: ["CD"]
}, {
  pk: 8474,
  ang: "Bangholu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Bangholu",
  lc: "nlo-x-bangholu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7957,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ngwi",
  lc: "nlo-x-ngwi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4528,
  ang: "Naga, Lao",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Lao Naga",
  lc: "nlq",
  ld: "ltr",
  alt: ["Law", "Loh"],
  cc: ["MM"]
}, {
  pk: 4529,
  ang: "Nchumbulu",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Nchumbulu",
  lc: "nlu",
  ld: "ltr",
  alt: [],
  cc: ["GH"]
}, {
  pk: 4530,
  ang: "Nahuatl, Orizaba",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Orizaba Nahuatl",
  lc: "nlv",
  ld: "ltr",
  alt: ["N\xE1huatl de la Sierra de Zongolica", "Orizaba Aztec", "Ixhuatlancillo Nahuatl"],
  cc: ["MX"]
}, {
  pk: 4531,
  ang: "Nahali",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Nahali",
  lc: "nlx",
  ld: "ltr",
  alt: ["Kalto", "Nahal", "Nahale", "Nahalia"],
  cc: ["IN"]
}, {
  pk: 4532,
  ang: "Nyamal",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Nyamal",
  lc: "nly",
  ld: "ltr",
  alt: ["Gnamo", "Namel", "Njamal", "Njamarl", "Nyamel"],
  cc: ["AU"]
}, {
  pk: 4533,
  ang: "Nal\xF6go",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Nal\xF6go",
  lc: "nlz",
  ld: "ltr",
  alt: ["Nalrgo", "Nea", "Southern Santa Cruz"],
  cc: ["SB"]
}, {
  pk: 4534,
  ang: "Naga, Maram",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Maram Naga",
  lc: "nma",
  ld: "ltr",
  alt: ["Maram", "Ngatan", "T. Khullen", "Willong Circle", "Maram Khullen Circle"],
  cc: ["IN"]
}, {
  pk: 4535,
  ang: "V\u2019\xEBnen Taut",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Big Nambas",
  lc: "nmb",
  ld: "ltr",
  alt: ["Big Nambas"],
  cc: ["VU"]
}, {
  pk: 4536,
  ang: "Ngam",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Ngam",
  lc: "nmc",
  ld: "ltr",
  alt: ["Ngama", "Ngahm", "Ngamh", "Sarngam"],
  cc: ["CF", "TD"]
}, {
  pk: 4537,
  ang: "Ndumu",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Ndumu",
  lc: "nmd",
  ld: "ltr",
  alt: ["Bandoumou", "Doumbou", "Dumbu", "Lendumu", "Mindoumou", "Mindumbu", "Minduumo", "Ndumbo", "Ndumbu", "Nduumo", "Ondoumbo", "Ondumbo"],
  cc: ["GA", "CG"]
}, {
  pk: 4538,
  ang: "Naga, Mzieme",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mzieme Naga",
  lc: "nme",
  ld: "ltr",
  alt: ["Mzieme", "Northern Zeme"],
  cc: ["IN"]
}, {
  pk: 4539,
  ang: "Naga, Tangkhul",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Tangkhul Naga (India)",
  lc: "nmf",
  ld: "ltr",
  alt: ["Champhung", "Luhuppa", "Luppa", "Tagkhul", "Tangkhul", "Thangkhulm"],
  cc: ["IN", "MM"]
}, {
  pk: 4540,
  ang: "Kwasio",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Kwasio",
  lc: "nmg",
  ld: "ltr",
  alt: ["Bujeba", "Mabea", "Mgoumba", "Ngoumba", "Bisio", "Mvumbo (Mekuk)"],
  cc: ["CM", "GQ"]
}, {
  pk: 4541,
  ang: "Naga, Monsang",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Monsang Naga",
  lc: "nmh",
  ld: "ltr",
  alt: ["Mawshang", "Moshang", "Mushang"],
  cc: ["IN"]
}, {
  pk: 4542,
  ang: "Nyam",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Nyam",
  lc: "nmi",
  ld: "ltr",
  alt: ["Nyambolo"],
  cc: ["NG"]
}, {
  pk: 4543,
  ang: "Ngombe",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Ngombe (Central African Republic)",
  lc: "nmj",
  ld: "ltr",
  alt: ["Bagando-Ngombe", "Bangando-Ngombe", "Ngombe-Kaka"],
  cc: ["CF"]
}, {
  pk: 4544,
  ang: "Namakura",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Namakura",
  lc: "nmk",
  ld: "ltr",
  alt: ["Namakir", "Makura (Emwae Island)"],
  cc: ["VU"]
}, {
  pk: 4545,
  ang: "Ndemli",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Ndemli",
  lc: "nml",
  ld: "ltr",
  alt: ["Bandem", "Bayong", "Ndemba"],
  cc: ["CM"]
}, {
  pk: 4546,
  ang: "Nyeshangte",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u0919\u094D\u200D\u092F\u0947\u0936\u094D\u092F\u093E\u0919\u094D\u200D\u0924\u0947",
  lc: "nmm",
  ld: "ltr",
  alt: ["Manang Ke", "Manange", "Manangi", "Nyeshang", "Nyeshangte", "Nyishang", "Manangbhot", "Pisang"],
  cc: ["NP"]
}, {
  pk: 4547,
  ang: "!X\xF3\xF5",
  lr: "Africa",
  gw: false,
  hc: "BW",
  ln: "!X\xF3\xF5",
  lc: "nmn",
  ld: "ltr",
  alt: ["Ng|amani", "Tsasi", "Ng|u|ei", "Ng|u|en (||U||en)", "Noosan", "Nu||en", "Nusan (Ng|usan)", "Nu-San", "Xatia (|Eikusi)", "!Kwi", "Ng|u||en (||U||en)", "Vaalpens", "Kattea", "Katia", "Kakia (Masarwa)", "Auni (|Auni)", "|U||en", "|Nu||en", "|Auo", "Khatia", "|Kusi"],
  cc: ["ZA", "BW"]
}, {
  pk: 4548,
  ang: "Naga, Moyon",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Moyon Naga",
  lc: "nmo",
  ld: "ltr",
  alt: ["Mayol", "Mayon Naga", "Moyon"],
  cc: ["IN"]
}, {
  pk: 7729,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Tang Shang Naga",
  lc: "nmo-x-tangshang",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4549,
  ang: "Nambya",
  lr: "Africa",
  gw: false,
  hc: "ZW",
  ln: "Nambya",
  lc: "nmq",
  ld: "ltr",
  alt: ["Chinambya", "Nambzya", "Nanzva"],
  cc: ["ZW"]
}, {
  pk: 4550,
  ang: "Nimbari",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Nimbari",
  lc: "nmr",
  ld: "ltr",
  alt: ["Bari", "Niamniam", "Nimbari-Kebi", "Nyamnyam", "Nyam-Nyam du Mayo-Kebi"],
  cc: ["CM"]
}, {
  pk: 4551,
  ang: "Letemboi",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Letemboi",
  lc: "nms",
  ld: "ltr",
  alt: ["Small Nambas"],
  cc: ["VU"]
}, {
  pk: 4552,
  ang: "Namonuito",
  lr: "Pacific",
  gw: false,
  hc: "FM",
  ln: "Namonuito",
  lc: "nmt",
  ld: "ltr",
  alt: ["Namon Weite"],
  cc: ["FM"]
}, {
  pk: 4553,
  ang: "Maidu, Northeast",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Northeast Maidu",
  lc: "nmu",
  ld: "ltr",
  alt: ["Mountain Maidu"],
  cc: ["US"]
}, {
  pk: 4554,
  ang: "Rifao",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nimoa",
  lc: "nmw",
  ld: "ltr",
  alt: ["Nimowa"],
  cc: ["PG"]
}, {
  pk: 4555,
  ang: "Nama",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nama (Papua New Guinea)",
  lc: "nmx",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4556,
  ang: "Namuyi",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u7D0D\u6728\u4F9D\u8A9E",
  lc: "nmy",
  ld: "ltr",
  alt: ["Naimuci", "Naimuzi", "Western Namuyi", "Eastern Namuyi"],
  cc: ["CN"]
}, {
  pk: 4557,
  ang: "Nawdm",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Nawdm",
  lc: "nmz",
  ld: "ltr",
  alt: ["Naoudem", "Naudm", "Nawdam", "Losso", "Losu", "West Nawdm (Baga)", "Tenega", "Koka", "Central Nawdm (Bana')", "East Nawdm (Siou Canton)"],
  cc: ["GH", "TG"]
}, {
  pk: 4558,
  ang: "Norwegian Nynorsk",
  lr: "Europe",
  gw: false,
  hc: "SE",
  ln: "Norsk nynorsk",
  lc: "nn",
  ld: "ltr",
  alt: [],
  cc: ["GB", "SE", "US", "CA", "EC", "DK", "IS"]
}, {
  pk: 4559,
  ang: "Nyangumarta",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Nyangumarta",
  lc: "nna",
  ld: "ltr",
  alt: ["Nyangumarda", "Nyangumata"],
  cc: ["AU"]
}, {
  pk: 4560,
  ang: "Nande",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Nande",
  lc: "nnb",
  ld: "ltr",
  alt: ["Banande", "Bayira", "Kinande", "Nandi", "Ndande", "Northern Nande", "Orundande", "Mate (Ekimate)", "Tangi (Ekitangi)", "Swaga (Ekikira)", "Songola", "Yira (Ekiyira)", "Shu (Ekishu)", "Kumbule (Ekikumbule)", "Ekiswaga", "Ekisongoora (Nyangala)", "Sanza (Ekisanza)"],
  cc: ["CD", "UG"]
}, {
  pk: 8475,
  ang: "Kinyabwito",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kinyabwito",
  lc: "nnb-x-kinyabwito",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4561,
  ang: "Nancere",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Nancere",
  lc: "nnc",
  ld: "ltr",
  alt: ["Nanchere", "Nangcere", "Nangjere", "Nangtchere", "Nanjeri", "Nantcere", "Bolo", "Kwale", "Mire", "Nancere du Centre"],
  cc: ["TD"]
}, {
  pk: 4562,
  ang: "Ambae, West",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "West Ambae",
  lc: "nnd",
  ld: "ltr",
  alt: ["Duidui", "Opa", "Nduindui (Duindui)"],
  cc: ["VU"]
}, {
  pk: 4563,
  ang: "Ngandyera",
  lr: "Africa",
  gw: false,
  hc: "AO",
  ln: "Ngandyera",
  lc: "nne",
  ld: "ltr",
  alt: [],
  cc: ["AO"]
}, {
  pk: 4564,
  ang: "Ngaing",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ngaing",
  lc: "nnf",
  ld: "ltr",
  alt: ["Mailang", "Sor", "Central Ngaing", "Eastern Ngaing", "Western Ngaing"],
  cc: ["PG"]
}, {
  pk: 4565,
  ang: "Naga, Maring",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Maring Naga",
  lc: "nng",
  ld: "ltr",
  alt: ["Maring"],
  cc: ["IN"]
}, {
  pk: 4566,
  ang: "Ngiemboon",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Ngiemboon",
  lc: "nnh",
  ld: "ltr",
  alt: ["Bamileke-Ngiemboon", "Bamileke-Ngyemboon", "Nguemba", "Ngyemboon", "Bamougong", "Bangang", "Balessing", "Batang"],
  cc: ["CM"]
}, {
  pk: 4567,
  ang: "Nuaulu, North",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "North Nuaulu",
  lc: "nni",
  ld: "ltr",
  alt: ["Fatakai", "Nuaulu", "Patakai"],
  cc: ["ID"]
}, {
  pk: 4568,
  ang: "Nyangatom",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Nyangatom",
  lc: "nnj",
  ld: "ltr",
  alt: ["Dongiro", "Donyiro", "Idongiro", "Inyangatom"],
  cc: ["ET", "SS"]
}, {
  pk: 4569,
  ang: "Nankina",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nankina",
  lc: "nnk",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4570,
  ang: "Naga, Northern Rengma",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Northern Rengma Naga",
  lc: "nnl",
  ld: "ltr",
  alt: ["Northern Rengma", "Ntenyi", "Ntenyi Naga", "Nthenyi"],
  cc: ["IN"]
}, {
  pk: 4571,
  ang: "Namia",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Namia",
  lc: "nnm",
  ld: "ltr",
  alt: ["Edawapi", "Lujere", "Namie", "Nemia", "Yellow River"],
  cc: ["PG"]
}, {
  pk: 4572,
  ang: "Ngete",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Ngete",
  lc: "nnn",
  ld: "ltr",
  alt: ["Ka'do Nguet\xE9", "Nge'd\xE9", "Nguet\xE9", "Nguett\xE9", "Zime"],
  cc: ["TD"]
}, {
  pk: 4573,
  ang: "Naga, Wancho",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Wancho Naga",
  lc: "nnp",
  ld: "ltr",
  alt: ["Banpara Naga", "Joboka", "Jokoba", "Wancho", "Bor Muthun (Bor Mutonia)", "Kulung Muthun (Mithan)"],
  cc: ["IN"]
}, {
  pk: 4574,
  ang: "Ngindo",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Ngindo",
  lc: "nnq",
  ld: "ltr",
  alt: ["Kingindo", "Magingo", "Njindo"],
  cc: ["TZ"]
}, {
  pk: 4575,
  ang: "Narungga",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Narungga",
  lc: "nnr",
  ld: "ltr",
  alt: ["Nanunga", "Naranga", "Narangga", "Narranga", "Narranggu", "Narrangu", "Adjabdurah (Adjahdurah)"],
  cc: ["AU"]
}, {
  pk: 4576,
  ang: "Ningye",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ningye",
  lc: "nns",
  ld: "ltr",
  alt: ["Ningeshe"],
  cc: ["NG"]
}, {
  pk: 4577,
  ang: "Nanticoke",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Nanticoke",
  lc: "nnt",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 4578,
  ang: "Dwang",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Dwang",
  lc: "nnu",
  ld: "ltr",
  alt: ["Dwan", "Nchumunu", "Bekye", "Kenyen"],
  cc: ["GH"]
}, {
  pk: 4579,
  ang: "Nuni, Southern",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Southern Nuni",
  lc: "nnw",
  ld: "ltr",
  alt: ["Nibulu", "Nouni", "Nounouma", "Nuna", "Nune", "Nunuma", "Nuruma", "Basinyari (Sundoni)"],
  cc: ["BF"]
}, {
  pk: 4580,
  ang: "Nda\u2019nda\u2019",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Nda'nda'",
  lc: "nnz",
  ld: "ltr",
  alt: ["Bamileke-Nda'nda'", "Undimeha (East Nda'nda')", "Ungameha (South Nda'nda')", "West Nda'nda'"],
  cc: ["CM"]
}, {
  pk: 4581,
  ang: "Norwegian",
  lr: "Europe",
  gw: false,
  hc: "NO",
  ln: "Norsk",
  lc: "no",
  ld: "ltr",
  alt: ["Riksm\xE5l"],
  cc: ["NO"]
}, {
  pk: 4582,
  ang: "Woun Meu",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Woun Meu",
  lc: "noa",
  ld: "ltr",
  alt: ["Waumeo", "Waun Meo", "Chanco", "Chocama", "Noanama", "Noenama", "Nonama", "Wounmeu"],
  cc: ["PA", "CO"]
}, {
  pk: 4583,
  ang: "Nuk",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nuk",
  lc: "noc",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4584,
  ang: "Thai, Northern",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Northern Thai",
  lc: "nod",
  ld: "ltr",
  alt: ["Lan Na", "Lanatai", "Lanna", "Lannatai", "Muang", "Myang", "Youanne", "Youon", "Yuan", "Kam Mu'ang", "Kamm\xFCang", "Kammyang", "Khon", "Khon Meang", "Khon Myang", "La Nya", "Mu'ang", "Mung", "Northern Thai", "Payap", "Phayap", "Phyap", "Tai Nya", "Tai Yon", "Tai Yuan", "Western Laotian"],
  cc: ["LA", "TH"]
}, {
  pk: 4585,
  ang: "Nimadi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Nimadi",
  lc: "noe",
  ld: "ltr",
  alt: ["Nemadi", "Nimari", "Nimiadi"],
  cc: ["IN"]
}, {
  pk: 4586,
  ang: "Nomane",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nomane",
  lc: "nof",
  ld: "ltr",
  alt: ["Siar/Siarha (Kiari)", "Gomla", "Kewo-Meba (Nomane)", "Meine"],
  cc: ["PG"]
}, {
  pk: 4587,
  ang: "Nogai",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041D\u043E\u0433\u0430\u0439\u0441\u043A\u0438\u0439",
  lc: "nog",
  ld: "ltr",
  alt: ["Karanogai", "Kubanogai", "Nogaitsy", "Nogalar", "Nogay", "Noghai", "Noghay", "Noghaylar", "White Nogai (Kuba)", "Black Nogai (Kara)"],
  cc: ["RU"]
}, {
  pk: 4588,
  ang: "Nomu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nomu",
  lc: "noh",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4589,
  ang: "Noiri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Noiri",
  lc: "noi",
  ld: "ltr",
  alt: ["Barutiya"],
  cc: ["IN"]
}, {
  pk: 4590,
  ang: "Nonuya",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Nonuya",
  lc: "noj",
  ld: "ltr",
  alt: [],
  cc: ["CO"]
}, {
  pk: 4591,
  ang: "Nooksack",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Nooksack",
  lc: "nok",
  ld: "ltr",
  alt: ["Nootsack"],
  cc: ["US"]
}, {
  pk: 4592,
  ang: "Nomlaki",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Nomlaki",
  lc: "nol",
  ld: "ltr",
  alt: ["Central Wintun", "Wintu", "Wintun"],
  cc: ["US"]
}, {
  pk: 4593,
  ang: "Nocam\xE1n",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Nocam\xE1n",
  lc: "nom",
  ld: "ltr",
  alt: [],
  cc: ["PE"]
}, {
  pk: 4594,
  ang: "Old Norse",
  lr: "Europe",
  gw: false,
  hc: "NO",
  ln: "Norr\u0153nt m\xE1l",
  lc: "non",
  ld: "ltr",
  alt: [],
  cc: ["NO"]
}, {
  pk: 4595,
  ang: "Numanggang",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Numanggang",
  lc: "nop",
  ld: "ltr",
  alt: ["Boana", "Kai", "Manggang", "Ngain", "Numangan", "Numangang", "Sugu"],
  cc: ["PG"]
}, {
  pk: 4596,
  ang: "Ngongo",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ngongo",
  lc: "noq",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 4597,
  ang: "Nisu, Eastern",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4E1C\u5C3C\u82CF\u8BED",
  lc: "nos",
  ld: "ltr",
  alt: ["Shiping-Jianshui Nisu", "Shiping-Jianshui Yi"],
  cc: ["CN", "LA"]
}, {
  pk: 4598,
  ang: "Nomatsiguenga",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Nomatsiguenga",
  lc: "not",
  ld: "ltr",
  alt: ["Nomatsiguenga Campa"],
  cc: ["PE"]
}, {
  pk: 4599,
  ang: "Ewage-Notu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ewage-Notu",
  lc: "nou",
  ld: "ltr",
  alt: ["Okeina", "Okena", "Yega (Gona)"],
  cc: ["PG"]
}, {
  pk: 4600,
  ang: "",
  lr: "",
  gw: false,
  hc: "",
  ln: "Novial",
  lc: "nov",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4601,
  ang: "Nyambo",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Nyambo",
  lc: "now",
  ld: "ltr",
  alt: ["Ekinyambo", "Karagwe", "Kinyambo", "Ragwe", "Rukaragwe", "Runyambo", "Ururagwe"],
  cc: ["TZ"]
}, {
  pk: 4602,
  ang: "Noy",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Noy",
  lc: "noy",
  ld: "ltr",
  alt: ["Loo"],
  cc: ["TD"]
}, {
  pk: 4603,
  ang: "Nayi",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Nayi",
  lc: "noz",
  ld: "ltr",
  alt: ["Na'o"],
  cc: ["ET"]
}, {
  pk: 4604,
  ang: "Nar Phu",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Nar Phu",
  lc: "npa",
  ld: "ltr",
  alt: ["Nar-Phu", "Nar (Lower Nar)", "Nar-M\xE4", "Phu (Nar-T\xF6)", "Upper Nar"],
  cc: ["NP"]
}, {
  pk: 4605,
  ang: "Nupbikha",
  lr: "Asia",
  gw: false,
  hc: "BT",
  ln: "Nupbikha",
  lc: "npb",
  ld: "ltr",
  alt: ["Trongsakha"],
  cc: ["BT"]
}, {
  pk: 4606,
  ang: "Naga, Ponyo-Gongwang",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Ponyo-Gongwang Naga",
  lc: "npg",
  ld: "ltr",
  alt: ["Gongvan", "Manauk", "Mannok", "Pounyu", "Saplow", "Solo", "Tsawlaw"],
  cc: ["MM"]
}, {
  pk: 4607,
  ang: "Naga, Phom",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Phom Naga",
  lc: "nph",
  ld: "ltr",
  alt: ["Assiringia", "Chingmengu", "Phom", "Phon", "Tamlu", "Tamlu Naga"],
  cc: ["IN"]
}, {
  pk: 4608,
  ang: "Nepali",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u0928\u0947\u092A\u093E\u0932\u0940 (individual language)",
  lc: "npi",
  ld: "ltr",
  alt: ["Eastern Pahari", "Gurkhali", "Khaskura", "Lhotshammikha", "Nepalese", "Parbatiya", "Eastern Pahadi", "Parbate", "Darchulali (Darjula)", "Darchuli (Darjula)", "Baitadeli (Baitadi)", "Bajurali (Bajura)"],
  cc: ["BD", "BN", "BT", "MY", "NP", "TH", "US", "CA", "IN", "MM"]
}, {
  pk: 4609,
  ang: "Nahuatl, Southeastern Puebla",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Southeastern Puebla Nahuatl",
  lc: "npl",
  ld: "ltr",
  alt: ["N\xE1huatl del Sureste de Puebla", "Tehuac\xE1n N\xE1huatl"],
  cc: ["MX", "US"]
}, {
  pk: 4610,
  ang: "Mondropolon",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mondropolon",
  lc: "npn",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4611,
  ang: "Naga, Pochuri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Pochuri Naga",
  lc: "npo",
  ld: "ltr",
  alt: ["Eastern Rengma", "Meluri", "Pochuri", "Pochury"],
  cc: ["IN"]
}, {
  pk: 4612,
  ang: "Nipsan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Nipsan",
  lc: "nps",
  ld: "ltr",
  alt: ["Southern Jale", "Yale-Nipsan"],
  cc: ["ID"]
}, {
  pk: 4613,
  ang: "Naga, Puimei",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Puimei Naga",
  lc: "npu",
  ld: "ltr",
  alt: ["Puimei"],
  cc: ["IN"]
}, {
  pk: 4614,
  ang: "Napu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Napu",
  lc: "npy",
  ld: "ltr",
  alt: ["Pekurehua"],
  cc: ["ID"]
}, {
  pk: 4615,
  ang: "Nago, Southern",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Southern Nago",
  lc: "nqg",
  ld: "ltr",
  alt: ["Ede Nago", "Nago", "Nagot", "Nagots"],
  cc: ["BJ"]
}, {
  pk: 4616,
  ang: "Ede Nago, Kura",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Kura Ede Nago",
  lc: "nqk",
  ld: "ltr",
  alt: ["Nago"],
  cc: ["BJ"]
}, {
  pk: 4617,
  ang: "Ndom",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ndom",
  lc: "nqm",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 4618,
  ang: "Nen",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nen",
  lc: "nqn",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4619,
  ang: "N\u2019ko",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "N'Ko",
  lc: "nqo",
  ld: "rtl",
  alt: [],
  cc: ["GN"]
}, {
  pk: 4620,
  ang: "Naga, Kyan-Karyaw",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Kyan-Karyaw Naga",
  lc: "nqq",
  ld: "ltr",
  alt: ["Chen", "Kaiyaw", "Kayaw", "Kayu"],
  cc: ["MM"]
}, {
  pk: 4621,
  ang: "Naga, Akyaung Ari",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Akyaung Ari Naga",
  lc: "nqy",
  ld: "ltr",
  alt: ["Ngachan"],
  cc: ["MM"]
}, {
  pk: 4622,
  ang: "Southern Ndebele",
  lr: "Africa",
  gw: false,
  hc: "ZA",
  ln: "isiNdebele",
  lc: "nr",
  ld: "ltr",
  alt: ["Ndzundza", "Nrebele", "Transvaal Ndebele"],
  cc: ["ZA"]
}, {
  pk: 4623,
  ang: "Ngom",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Ngom",
  lc: "nra",
  ld: "ltr",
  alt: ["Angom", "Bangom", "Bangomo", "Ongom", "Ungom", "Ngomo"],
  cc: ["GA", "CG"]
}, {
  pk: 4624,
  ang: "Nara",
  lr: "Africa",
  gw: false,
  hc: "ER",
  ln: "Nara",
  lc: "nrb",
  ld: "ltr",
  alt: ["Barea", "Baria", "Barya", "Koyta", "Mogareb", "Santora", "Higir"],
  cc: ["ER", "ET"]
}, {
  pk: 4625,
  ang: "Noric",
  lr: "Europe",
  gw: false,
  hc: "AT",
  ln: "Norisch",
  lc: "nrc",
  ld: "ltr",
  alt: [],
  cc: ["AT"]
}, {
  pk: 4626,
  ang: "Naga, Southern Rengma",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Southern Rengma Naga",
  lc: "nre",
  ld: "ltr",
  alt: ["Injang", "Moiyui", "Mon", "Mozhumi", "Nzong", "Nzonyu", "Rengma", "Southern Rengma", "Unza", "Western Rengma", "Azonyu (Nzonyu)"],
  cc: ["IN"]
}, {
  pk: 4627,
  ang: "J\xE8rriais",
  lr: "Europe",
  gw: false,
  hc: "JE",
  ln: "J\xE8rriais",
  lc: "nrf",
  ld: "ltr",
  alt: [],
  cc: ["JE"]
}, {
  pk: 4628,
  ang: "Narango",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Narango",
  lc: "nrg",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 4629,
  ang: "Naga, Chokri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Chokri Naga",
  lc: "nri",
  ld: "ltr",
  alt: ["Chakhesang", "Chakrima Naga", "Chakru", "Chokri", "Eastern Angami"],
  cc: ["IN"]
}, {
  pk: 4630,
  ang: "Ngarla",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Ngarla",
  lc: "nrk",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 4631,
  ang: "Ngarluma",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Ngarluma",
  lc: "nrl",
  ld: "ltr",
  alt: ["Gnalluma", "Gnalouma", "Ngallooma", "Ngaluma"],
  cc: ["AU"]
}, {
  pk: 4632,
  ang: "Narom",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Narom",
  lc: "nrm",
  ld: "ltr",
  alt: ["Narum", "Miri'", "Bakong", "Dali'"],
  cc: ["MY"]
}, {
  pk: 4633,
  ang: "Norn",
  lr: "Europe",
  gw: false,
  hc: "GB",
  ln: "Norn",
  lc: "nrn",
  ld: "ltr",
  alt: [],
  cc: ["GB"]
}, {
  pk: 4634,
  ang: "North Picene",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "North Picene",
  lc: "nrp",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 4635,
  ang: "Northern Kalapuya",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Northern Kalapuya",
  lc: "nrt",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 4636,
  ang: "Narua",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4E1C\u90E8\u65B9\u8A00",
  lc: "nru",
  ld: "ltr",
  alt: ["Eastern Naxi", "Moso", "Mosso", "Mosuo", "Na", "Naru", "Nazu"],
  cc: ["CN"]
}, {
  pk: 4637,
  ang: "Lala",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Lala",
  lc: "nrz",
  ld: "ltr",
  alt: ["Ala'ala", "Nara", "Pokau"],
  cc: ["PG"]
}, {
  pk: 4638,
  ang: "Naga, Sangtam",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Sangtam Naga",
  lc: "nsa",
  ld: "ltr",
  alt: ["Isachanure", "Lophomi", "Sangtam", "Pirr (Northern Sangtam)", "Purr (Southern Sangtam)", "Thukumi (Central Sangtam)"],
  cc: ["IN"]
}, {
  pk: 4639,
  ang: "Nshi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Nshi",
  lc: "nsc",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 4640,
  ang: "Nisu, Southern",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5357\u5C3C\u82CF\u8BED",
  lc: "nsd",
  ld: "ltr",
  alt: ["Yuan-Mo Yi", "Yuanyang Nisu", "Mojiang Nisu"],
  cc: ["CN"]
}, {
  pk: 4641,
  ang: "Nsenga",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Nsenga",
  lc: "nse",
  ld: "ltr",
  alt: ["Chinsenga", "Senga", "Ngoni (Mpezeni)"],
  cc: ["MZ", "ZM"]
}, {
  pk: 4642,
  ang: "Nisu, Northwestern",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Northwestern Nisu",
  lc: "nsf",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 4643,
  ang: "Ngasa",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Ngasa",
  lc: "nsg",
  ld: "ltr",
  alt: ["Kingasa", "Ongamo", "Shaka"],
  cc: ["TZ"]
}, {
  pk: 4644,
  ang: "Ngoshie",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Ngoshie",
  lc: "nsh",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 4645,
  ang: "Nigerian Sign Language",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Nigerian Sign Language",
  lc: "nsi",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 4646,
  ang: "Naskapi",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Naskapi",
  lc: "nsk",
  ld: "ltr",
  alt: ["Innu Aimun", "Iyuw Iyimuuun", "Eastern Naskapi (Natuashish)", "Western Naskapi (Kawawachikamach)"],
  cc: ["CA"]
}, {
  pk: 4647,
  ang: "Norwegian Sign Language",
  lr: "Europe",
  gw: false,
  hc: "NO",
  ln: "Norwegian Sign Language",
  lc: "nsl",
  ld: "ltr",
  alt: [],
  cc: ["NO"]
}, {
  pk: 4648,
  ang: "Naga, Sumi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Sumi Naga",
  lc: "nsm",
  ld: "ltr",
  alt: ["Sema", "Simi", "Sumi", "Dayang (Western Sumi)"],
  cc: ["IN"]
}, {
  pk: 4649,
  ang: "Nehan",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nehan",
  lc: "nsn",
  ld: "ltr",
  alt: ["Nihan", "Nissan", "Pinipel (Pinipin)"],
  cc: ["PG"]
}, {
  pk: 4650,
  ang: "Sotho, Northern",
  lr: "Africa",
  gw: false,
  hc: "ZA",
  ln: "Pedi",
  lc: "nso",
  ld: "ltr",
  alt: ["Pedi", "Sepedi", "Transvaal Sotho", "Tau", "Thephalaborwa", "Pula", "Phalaborwa (Phalaburwa)", "Masemola (Masemula)", "Lubedu", "Lovedu", "Gananwa (Hananwa)", "Kxaxa", "Kutswe", "Koni (Kone)", "Khutswe (Khutswi)", "Kgaga (Khaga)", "Xananwa", "Dzwabo (Thabine-Roka-Nareng)", "Lobedu (Khelobedu)"],
  cc: ["ZA", "ZW", "BW"]
}, {
  pk: 4651,
  ang: "Nepalese Sign Language",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u0928\u0947\u092A\u093E\u0932\u0940 \u0938\u093E\u0902\u0915\u0947\u0924\u093F\u0915 \u092D\u093E\u0937\u093E",
  lc: "nsp",
  ld: "ltr",
  alt: ["Nepali Sign Language"],
  cc: ["NP"]
}, {
  pk: 4652,
  ang: "Miwok, Northern Sierra",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Northern Sierra Miwok",
  lc: "nsq",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 4653,
  ang: "Maritime Sign Language",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Maritime Sign Language",
  lc: "nsr",
  ld: "ltr",
  alt: ["Nova Scotian Sign Language"],
  cc: ["CA"]
}, {
  pk: 4654,
  ang: "Nali",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nali",
  lc: "nss",
  ld: "ltr",
  alt: ["Yiru"],
  cc: ["PG"]
}, {
  pk: 4655,
  ang: "Naga, Tase",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Tase Naga",
  lc: "nst",
  ld: "ltr",
  alt: ["Cham Chang", "Rangpan", "Tangshang", "Tasey", "Haimi", "Hawa", "Heimi", "Kuwa", "Pangmi", "Pangwa", "Rangpang", "Tangwa", "Ronrang (Poerah)", "Yasa", "Raqsa", "Nukpa", "Ngemu", "Thamkok", "Mungray (Morang)", "Nokpa", "Sanke", "Sechu", "Shechu", "Tulum", "Wanga", "Wangoo", "Mosang (Hewa)", "Gaha (Halum)", "Shangge", "Champhang (Thamphang)", "Asen (Aasen)", "Bote (Bongtai)", "Butay", "Hansin", "Chamkok (Tamko)", "Miti", "Cholim (Tawlum)", "Chuyo (Wanggu)", "Gakat (Wakka)", "Have (Havoy)", "Higsho", "Higtsii", "Hteinpa", "Kimsing (Chamchang)", "Longphi (Longkhi)", "Chamchang (Kimsing)"],
  cc: ["MM"]
}, {
  pk: 7533,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Muklom",
  lc: "nst-x-muklom",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 8078,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Ran Se Naga",
  lc: "nst-x-ransenaga",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7764,
  ang: "Sangwan, Shangwan",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Sangwan",
  lc: "nst-x-sangwan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7765,
  ang: "She Ju",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Shechu",
  lc: "nst-x-sheju",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7750,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Shekyu",
  lc: "nst-x-shekyu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4656,
  ang: "Nahuatl, Sierra Negra",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Sierra Negra Nahuatl",
  lc: "nsu",
  ld: "ltr",
  alt: ["N\xE1huatl de la Sierra Negra", "Coyomeapan", "Zoquitlan"],
  cc: ["MX"]
}, {
  pk: 4657,
  ang: "Nisu, Southwestern",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u897F\u5357\u5C3C\u82CF\u8BED",
  lc: "nsv",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 4658,
  ang: "Navut",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Navut",
  lc: "nsw",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 4659,
  ang: "Songo",
  lr: "Africa",
  gw: false,
  hc: "AO",
  ln: "Songo",
  lc: "nsx",
  ld: "ltr",
  alt: ["Sungu"],
  cc: ["AO"]
}, {
  pk: 4660,
  ang: "Nasal",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Nasal",
  lc: "nsy",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 4661,
  ang: "Nisenan",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Nisenan",
  lc: "nsz",
  ld: "ltr",
  alt: ["Neeshenam", "Nishinam", "Pujuni", "Southern Maidu", "Wapumni"],
  cc: ["US"]
}, {
  pk: 8224,
  ang: "Northern Tidung",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Northern Tidung",
  lc: "ntd",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4662,
  ang: "Nathembo",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Nathembo",
  lc: "nte",
  ld: "ltr",
  alt: ["Esakaji", "Sakaji", "Sanagage", "Sangaji", "Sankaji", "Theithei"],
  cc: ["MZ"]
}, {
  pk: 4663,
  ang: "Natioro",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Natioro",
  lc: "nti",
  ld: "ltr",
  alt: ["Koo'ra", "Natjoro", "Natyoro"],
  cc: ["BF"]
}, {
  pk: 4664,
  ang: "Ngaanyatjarra",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Ngaanyatjarra",
  lc: "ntj",
  ld: "ltr",
  alt: ["Ngaanjatjarra", "Ngaanyatjara", "Nyanganyatjara"],
  cc: ["AU"]
}, {
  pk: 4665,
  ang: "Ikoma-Nata-Isenye",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Ikoma-Nata-Isenye",
  lc: "ntk",
  ld: "ltr",
  alt: ["Kiikoma", "Kinatta", "Natta", "Kiissenye Ikisenyi", "Nata (Kinata)", "Issenye", "Isenye (Isenyi)", "Ikoma (Kiikoma)", "Kiisenye"],
  cc: ["TZ"]
}, {
  pk: 4666,
  ang: "Nateni",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Nateni",
  lc: "ntm",
  ld: "ltr",
  alt: ["Okoni (Okoma)", "Tayari (Tayaba)", "Nateni (Natemba)", "Kunteni (Kuntemba)"],
  cc: ["BJ"]
}, {
  pk: 4667,
  ang: "Ntomba",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ntomba",
  lc: "nto",
  ld: "ltr",
  alt: ["Luntumba", "Ntomba-Bolia", "Ntumba", "Nkole"],
  cc: ["CD"]
}, {
  pk: 4668,
  ang: "Tepehuan, Northern",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Northern Tepehuan",
  lc: "ntp",
  ld: "ltr",
  alt: ["Tepehu\xE1n del Norte"],
  cc: ["MX"]
}, {
  pk: 4669,
  ang: "Delo",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Delo",
  lc: "ntr",
  ld: "ltr",
  alt: ["Ntribou", "Ntribu"],
  cc: ["GH"]
}, {
  pk: 4670,
  ang: "Nat\xFCgu",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Nat\xFCgu",
  lc: "ntu",
  ld: "ltr",
  alt: ["Nambakaeng\xF6", "Natqgu", "Northern Santa Cruz", "Ndeni (Deni)"],
  cc: ["SB"]
}, {
  pk: 4671,
  ang: "Nottoway",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Nottoway",
  lc: "ntw",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 4672,
  ang: "Naga, Tangkhul",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Tangkhul Naga (Myanmar)",
  lc: "ntx",
  ld: "ltr",
  alt: ["Somara"],
  cc: ["MM"]
}, {
  pk: 4673,
  ang: "Mantsi",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Mantsi",
  lc: "nty",
  ld: "ltr",
  alt: ["Black Lolo", "Flowery Lolo", "Lolo", "Red Mantsi"],
  cc: ["VN"]
}, {
  pk: 4674,
  ang: "Natanzi",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u0632\u0628\u0627\u0646 \u0646\u0637\u0646\u0632\u06CC",
  lc: "ntz",
  ld: "ltr",
  alt: ["Farizandi", "Yarani (Yarandi)"],
  cc: ["IR"]
}, {
  pk: 4675,
  ang: "Yuanga",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Yuanga",
  lc: "nua",
  ld: "ltr",
  alt: ["Bond\xE9", "Gomen", "Nua", "Nyua", "Nyuaanga", "Yuaanga", "Zwanga", "Paimboas", "Thuanga (Gomen)", "Juanga (Bond\xE9)"],
  cc: ["NC"]
}, {
  pk: 4676,
  ang: "Nukuini",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Nukuini",
  lc: "nuc",
  ld: "ltr",
  alt: ["Cuyanawa", "Nukini", "Nuquini"],
  cc: ["BR"]
}, {
  pk: 4677,
  ang: "Ngala",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ngala",
  lc: "nud",
  ld: "ltr",
  alt: ["Kara", "Sogap", "Swagup"],
  cc: ["PG"]
}, {
  pk: 4678,
  ang: "Ngundu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ngundu",
  lc: "nue",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 4679,
  ang: "Nusu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6012\u82CF\u8BED",
  lc: "nuf",
  ld: "ltr",
  alt: ["Nang Tsu", "No Tso", "No Tsu", "Naw", "No", "No Pha", "No Shi", "Nu", "Central Nusu (Miangu/Laomudeng)", "Northern Nusu (Wawa)", "Southern Nusu (Puluo)", "Tuoping", "Yuoduoluo"],
  cc: ["CN"]
}, {
  pk: 4680,
  ang: "Ndunda",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ndunda",
  lc: "nuh",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 4681,
  ang: "Kombe",
  lr: "Africa",
  gw: false,
  hc: "GQ",
  ln: "Ngumbi",
  lc: "nui",
  ld: "ltr",
  alt: ["Combe"],
  cc: ["CM", "GQ"]
}, {
  pk: 4682,
  ang: "Nyole",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Nyole",
  lc: "nuj",
  ld: "ltr",
  alt: ["Lunyole", "Nyule", "Nyuli", "Hadyo (Luhadyo)", "Wesa (Luwesa)", "Menya (Lumenya)", "Sabi (Lusabi)"],
  cc: ["UG"]
}, {
  pk: 4683,
  ang: "Nuu-chah-nulth",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Nuu-chah-nulth",
  lc: "nuk",
  ld: "ltr",
  alt: ["Aht", "Nootka", "Nutka", "Quuquu'aca", "T'aat'aaqsapa", "Westcoast"],
  cc: ["CA"]
}, {
  pk: 4684,
  ang: "Nusa Laut",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Nusa Laut",
  lc: "nul",
  ld: "ltr",
  alt: ["Nusalaut"],
  cc: ["ID"]
}, {
  pk: 4685,
  ang: "Niuafo\u2019ou",
  lr: "Pacific",
  gw: false,
  hc: "TO",
  ln: "Niuafo'ou",
  lc: "num",
  ld: "ltr",
  alt: [],
  cc: ["TO"]
}, {
  pk: 4686,
  ang: "Anong",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "\u963F\u4FAC\u8BED",
  lc: "nun",
  ld: "ltr",
  alt: ["Anoong", "Anu", "Fuch'ye", "Khanung", "Khupang", "Kwingsang", "Kwinp'ang", "Lu", "Lutze", "Lutzu", "Nu", "Nung", "Fuchve", "Khingpang", "Naw", "Nawpha"],
  cc: ["CN", "MM"]
}, {
  pk: 4687,
  ang: "Ngu\xF4n",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Ti\u1EBFng Ngu\u1ED3n",
  lc: "nuo",
  ld: "ltr",
  alt: ["Ngouan"],
  cc: ["LA", "VN"]
}, {
  pk: 4688,
  ang: "Nupe-Nupe-Tako",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Nupe-Nupe-Tako",
  lc: "nup",
  ld: "ltr",
  alt: ["Nufawa", "Nupeci", "Nupecidji", "Nupenchi", "Nupencizi", "Takpa", "Nupe Tako (Bassa Nge)", "Tapa", "Nupecizi", "Nife", "Anuperi", "Anupe", "Anupecwayi", "Tappah", "Nupe Central (Ampeyi)"],
  cc: ["NG"]
}, {
  pk: 4689,
  ang: "Nukumanu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nukumanu",
  lc: "nuq",
  ld: "ltr",
  alt: ["Tasman"],
  cc: ["PG"]
}, {
  pk: 4690,
  ang: "Nukuria",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nukuria",
  lc: "nur",
  ld: "ltr",
  alt: ["Fead", "Nahoa", "Nukeria"],
  cc: ["PG"]
}, {
  pk: 4691,
  ang: "Nuer",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Nuer",
  lc: "nus",
  ld: "ltr",
  alt: ["Naath", "Naadh", "Lou (Lau)", "Thiang (Bul)", "Leik", "Laak", "Kany", "Jikany", "Jikain", "Jagai", "Gawaar", "Eastern Nuer (Abigar)", "Eastern Jikany (Jekaing)", "Dor (Door)", "Door", "Thognaath (Thok Nath)", "Ji"],
  cc: ["ET", "SS", "US"]
}, {
  pk: 7559,
  ang: "Northern Nung",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Northern Nung",
  lc: "nut-x-north",
  ld: "ltr",
  alt: [],
  cc: ["VN"]
}, {
  pk: 4692,
  ang: "Nung",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Ti\u1EBFng N\xF9ng (Viet Nam)",
  lc: "nut-x-south",
  ld: "ltr",
  alt: ["Nong", "Bu-Nong", "Highland Nung", "Tai Nung", "Tay", "T\xE0y N\xF9ng", "N\xF9ng Phan Sl\xECnh (N\xF9ng Fan Slihng)", "N\xF9ng Q\xFAy Rin (Guiren)"],
  cc: ["VN"]
}, {
  pk: 7751,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Xu\xF2ng Giay",
  lc: "nut-x-xuong",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4693,
  ang: "Ngbundu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ngbundu",
  lc: "nuu",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 4694,
  ang: "Nuni, Northern",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Northern Nuni",
  lc: "nuv",
  ld: "ltr",
  alt: ["Nibulu", "Nouni", "Nounouma", "Nuna", "Nune", "Nunuma", "Nuruma"],
  cc: ["BF"]
}, {
  pk: 8314,
  ang: "Extreme Northen Nuni",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Extreme Northern Nuni",
  lc: "nuv-x-extrnornuni",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4695,
  ang: "Nguluwan",
  lr: "Pacific",
  gw: false,
  hc: "FM",
  ln: "Nguluwan",
  lc: "nuw",
  ld: "ltr",
  alt: [],
  cc: ["FM"]
}, {
  pk: 4696,
  ang: "Mehek",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mehek",
  lc: "nux",
  ld: "ltr",
  alt: ["Driafleisuma", "Indinogosima", "Me'ek"],
  cc: ["PG"]
}, {
  pk: 4697,
  ang: "Nunggubuyu",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Nunggubuyu",
  lc: "nuy",
  ld: "ltr",
  alt: ["Nunggubuju", "Wubuy", "Yingkwira"],
  cc: ["AU"]
}, {
  pk: 4698,
  ang: "Nahuatl, Tlamacazapa",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tlamacazapa Nahuatl",
  lc: "nuz",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 4699,
  ang: "Navajo, Navaho",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Din\xE9 bizaad",
  lc: "nv",
  ld: "ltr",
  alt: ["Navaho"],
  cc: ["US"]
}, {
  pk: 4700,
  ang: "Nasarian",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Nasarian",
  lc: "nvh",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 4701,
  ang: "Namiae",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Namiae",
  lc: "nvm",
  ld: "ltr",
  alt: ["Namiai"],
  cc: ["PG"]
}, {
  pk: 4702,
  ang: "Nyokon",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Nyokon",
  lc: "nvo",
  ld: "ltr",
  alt: ["Fung", "Hung", "Ni Nyo'o", "Nyo'on"],
  cc: ["CM"]
}, {
  pk: 4703,
  ang: "Nawathinehena",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Nawathinehena",
  lc: "nwa",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 4704,
  ang: "Nyabwa",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Nyabwa",
  lc: "nwb",
  ld: "ltr",
  alt: ["Nyaboa", "Nyabwa-Ny\xE9d\xE9bwa", "Nyedebwa (Ni\xE9d\xE9boua)"],
  cc: ["CI"]
}, {
  pk: 4705,
  ang: "Classical Newari",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u092A\u0941\u0932\u093E\u0902 \u092D\u093E\u092F\u094D",
  lc: "nwc",
  ld: "ltr",
  alt: [],
  cc: ["NP"]
}, {
  pk: 4706,
  ang: "Ngwe",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Ngwe",
  lc: "nwe",
  ld: "ltr",
  alt: ["Bamileke-Ngwe", "Fomopea", "Fontem", "Nwe", "Nweh"],
  cc: ["CM"]
}, {
  pk: 4707,
  ang: "Tanna, Southwest",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Southwest Tanna",
  lc: "nwi",
  ld: "ltr",
  alt: ["Naha", "Yahurmene", "Narpaimene", "Siporo", "Vaha"],
  cc: ["VU"]
}, {
  pk: 4708,
  ang: "Nyamusa-Molo",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Nyamusa-Molo",
  lc: "nwm",
  ld: "ltr",
  alt: ["Nyamusa"],
  cc: ["SS"]
}, {
  pk: 4709,
  ang: "Nawaru",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nawaru",
  lc: "nwr",
  ld: "ltr",
  alt: ["Sirio"],
  cc: ["PG"]
}, {
  pk: 4710,
  ang: "Middle Newar",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Middle Newar",
  lc: "nwx",
  ld: "ltr",
  alt: [],
  cc: ["NP"]
}, {
  pk: 4711,
  ang: "Nottoway-Meherrin",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Nottoway-Meherrin",
  lc: "nwy",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 4712,
  ang: "Nauete",
  lr: "Asia",
  gw: false,
  hc: "TL",
  ln: "Nauete",
  lc: "nxa",
  ld: "ltr",
  alt: ["Na\xF3ti", "Naueti", "Nauhete", "Nauote", "Nauoti"],
  cc: ["TL"]
}, {
  pk: 4713,
  ang: "Ngando",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ngando (Democratic Republic of Congo)",
  lc: "nxd",
  ld: "ltr",
  alt: ["Longandu", "Ngandu"],
  cc: ["CD"]
}, {
  pk: 4714,
  ang: "Nage",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Nage",
  lc: "nxe",
  ld: "ltr",
  alt: ["Nag\xE9", "Nage-Keo"],
  cc: ["ID"]
}, {
  pk: 4715,
  ang: "Ngad\u2019a",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ngad'a",
  lc: "nxg",
  ld: "ltr",
  alt: ["Badjava", "Bajava", "Nad'a", "Nga'da", "Ngadha", "Rokka"],
  cc: ["ID"]
}, {
  pk: 4716,
  ang: "Nindi",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Nindi",
  lc: "nxi",
  ld: "ltr",
  alt: ["Kinindi"],
  cc: ["TZ"]
}, {
  pk: 4717,
  ang: "Naga, Koki",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Koki Naga",
  lc: "nxk",
  ld: "ltr",
  alt: ["Konke"],
  cc: ["MM"]
}, {
  pk: 4718,
  ang: "Nuaulu, South",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "South Nuaulu",
  lc: "nxl",
  ld: "ltr",
  alt: ["Fatakai", "Nuaulu", "Patakai"],
  cc: ["ID"]
}, {
  pk: 4719,
  ang: "Numidian",
  lr: "Africa",
  gw: false,
  hc: "DZ",
  ln: "Numidian",
  lc: "nxm",
  ld: "ltr",
  alt: [],
  cc: ["DZ"]
}, {
  pk: 4720,
  ang: "Ndambono",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Ndambomo",
  lc: "nxo",
  ld: "ltr",
  alt: [],
  cc: ["GA"]
}, {
  pk: 4721,
  ang: "Naxi",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u897F\u90E8\u65B9\u8A00",
  lc: "nxq",
  ld: "ltr",
  alt: ["Lomi", "Mu", "Nahsi", "Nakhi", "Naqxi", "Nasi", "Moso", "Mosso", "Mo-Su"],
  cc: ["CN"]
}, {
  pk: 7635,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Malimasa",
  lc: "nxq-x-malimasa",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4722,
  ang: "Ninggerum",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ninggerum",
  lc: "nxr",
  ld: "ltr",
  alt: ["Kasiwa", "Kativa", "Muyu", "Ninggeroem", "Ninggirum", "Ninggrum", "Orgwo", "Niyium", "Obgwo", "Tedi"],
  cc: ["ID", "PG"]
}, {
  pk: 4723,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Narau",
  lc: "nxu",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 4724,
  ang: "Nafri",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Nafri",
  lc: "nxx",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 4725,
  ang: "Chichewa, Chewa, Nyanja",
  lr: "Africa",
  gw: false,
  hc: "MW",
  ln: "chiChe\u0175a, chinyanja",
  lc: "ny",
  ld: "ltr",
  alt: ["Chewa", "Chinyanja", "Manganja (Waganga)", "Chewa (Cheva)", "Waganga", "Sheva", "Peta (Cipeta)", "Peta (Chipeta)", "Nyanja (Cinyanja)", "Ngoni (Cingoni)", "Maravi", "Marave", "Chewa (Cewa)", "Malawi", "Kunda", "Cipeta", "Angoni", "Chingoni (Ngoni)", "Manganja (Cimanganja)", "Cicewa"],
  cc: ["MZ", "TZ", "ZM", "ZW", "MW", "SZ"]
}, {
  pk: 8442,
  ang: "Nyanja",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Nyanja",
  lc: "nya-x-nyanja",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4726,
  ang: "Nyangbo",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Nyangbo",
  lc: "nyb",
  ld: "ltr",
  alt: ["Tutrugbu"],
  cc: ["GH"]
}, {
  pk: 4727,
  ang: "Nyanga-li",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Nyanga-li",
  lc: "nyc",
  ld: "ltr",
  alt: ["Linyanga-le"],
  cc: ["CD"]
}, {
  pk: 4728,
  ang: "Olunyole",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Nyore",
  lc: "nyd",
  ld: "ltr",
  alt: ["Lunyole", "Nyole", "Nyoole", "Nyore", "Olunyore"],
  cc: ["KE"]
}, {
  pk: 4729,
  ang: "Nyengo",
  lr: "Africa",
  gw: false,
  hc: "AO",
  ln: "Nyengo",
  lc: "nye",
  ld: "ltr",
  alt: ["Nhengo"],
  cc: ["AO"]
}, {
  pk: 4730,
  ang: "Kigiryama",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Giryama",
  lc: "nyf",
  ld: "ltr",
  alt: ["Agiryama", "Giriama", "Kigiriama", "Kinyika", "Nika", "Nyika", "Kauma (Chikauma)", "Ribe (Rihe)"],
  cc: ["KE"]
}, {
  pk: 4731,
  ang: "Nyindu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Nyindu",
  lc: "nyg",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 4732,
  ang: "Nyigina",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Nyigina",
  lc: "nyh",
  ld: "ltr",
  alt: ["Njigina", "Nyikina"],
  cc: ["AU"]
}, {
  pk: 4733,
  ang: "Ama",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Ama (Sudan)",
  lc: "nyi",
  ld: "ltr",
  alt: ["Inyimang", "Nyima", "Nyiman", "Nyuwing", "Mandal (Male)"],
  cc: ["SD"]
}, {
  pk: 4734,
  ang: "Nyanga",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Nyanga",
  lc: "nyj",
  ld: "ltr",
  alt: ["Inyanga"],
  cc: ["CD"]
}, {
  pk: 7708,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kikobo",
  lc: "nyj-x-kikobo",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 7781,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kitiri",
  lc: "nyj-x-kitiri",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 4735,
  ang: "Nyaneka",
  lr: "Africa",
  gw: false,
  hc: "AO",
  ln: "Nyaneka",
  lc: "nyk",
  ld: "ltr",
  alt: ["Lunyaneka", "Nhaneca", "Nhaneka", "Olunyaneka", "Muila", "Olumuila", "Ngambwe (Olungambwe)", "Cilenge", "Mwila (Huila)", "Humbi", "Handa", "Cilenge-Musa", "Cipungu"],
  cc: ["AO"]
}, {
  pk: 4736,
  ang: "Nyeu",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Nyeu",
  lc: "nyl",
  ld: "ltr",
  alt: ["Yeu", "Yoe"],
  cc: ["TH"]
}, {
  pk: 4737,
  ang: "Nyamwezi",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Nyamwezi",
  lc: "nym",
  ld: "ltr",
  alt: ["Kinyamwesi", "Kinyamwezi", "Namwezi", "Nyamwesi", "Konongo", "Mweri (Kiya)", "Sumbwa", "Takama (Garaganza)"],
  cc: ["TZ"]
}, {
  pk: 4738,
  ang: "Nyankore",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Nyankole",
  lc: "nyn",
  ld: "ltr",
  alt: ["Nkole", "Nyankole", "Olunyankole", "Ulunyankole", "Ulunyankore"],
  cc: ["RW", "TZ", "UG", "BI"]
}, {
  pk: 8256,
  ang: "Runyaruguru",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Runyaruguru",
  lc: "nyn-x-runyaruguru",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4739,
  ang: "Nyoro",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Nyoro",
  lc: "nyo",
  ld: "ltr",
  alt: ["Runyoro", "Orunyoro (Nyoro)"],
  cc: ["UG"]
}, {
  pk: 4740,
  ang: "Nyang\u2019i",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Nyang'i",
  lc: "nyp",
  ld: "ltr",
  alt: ["Gyangiya", "Ngangea", "Ngapore", "Ngiangeya", "Niporen", "Nipori", "Nuangeya", "Nyangeya", "Nyang'ia", "Nyangiya", "Nyuangia", "Upale"],
  cc: ["UG"]
}, {
  pk: 4741,
  ang: "Nayini",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u0632\u0628\u0627\u0646 \u0646\u0627\u0626\u06CC\u0646\u06CC",
  lc: "nyq",
  ld: "ltr",
  alt: ["Biyabanak", "Khuri", "Anarak"],
  cc: ["IR"]
}, {
  pk: 4742,
  ang: "Nyiha, Malawi",
  lr: "Africa",
  gw: false,
  hc: "MW",
  ln: "Nyiha (Malawi)",
  lc: "nyr",
  ld: "ltr",
  alt: ["Kinyiha", "Shinyiha"],
  cc: ["MW"]
}, {
  pk: 4743,
  ang: "Nyunga",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Nyunga",
  lc: "nys",
  ld: "ltr",
  alt: ["Neo-Nyunga", "Nyungar"],
  cc: ["AU"]
}, {
  pk: 4744,
  ang: "Nyungwe",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Nyungwe",
  lc: "nyu",
  ld: "ltr",
  alt: ["Chinyungwi", "Cinyungwe", "Nyongwe", "Teta", "Tete", "Yungwe"],
  cc: ["MZ", "ZW"]
}, {
  pk: 4745,
  ang: "Nyaw",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Nyaw",
  lc: "nyw",
  ld: "ltr",
  alt: ["Jo", "Nyo", "Nyoh", "Yo"],
  cc: ["LA", "TH"]
}, {
  pk: 4746,
  ang: "Nyakyusa-Ngonde",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Nyakyusa-Ngonde",
  lc: "nyy",
  ld: "ltr",
  alt: ["Ikingonde", "Ikinyikyusa", "Kinyakyusa", "Konde", "Mombe", "Nkhonde", "Nyakusa", "Nyekyosa", "Sochile", "Sokile", "Ikinyakyusa", "Kinyakyusa-Ngonde", "Nyikyusa", "Sokili", "Seria", "Selya (Salya)", "Mwamba (Lungulu)"],
  cc: ["TZ", "MW"]
}, {
  pk: 4747,
  ang: "Mbembe, Tigon",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Tigon Mbembe",
  lc: "nza",
  ld: "ltr",
  alt: ["Akonto", "Tigon", "Tigong", "Tigum", "Tigun", "Tikun", "Akwanto", "Noale", "Tigim", "Tukun", "Ashuku (Kitsipki)", "Izare", "Nama (Dama)", "Namu", "Ndzale", "Njari", "Nsare", "Nzare (Izale)"],
  cc: ["CM", "NG"]
}, {
  pk: 4748,
  ang: "Njebi",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Njebi",
  lc: "nzb",
  ld: "ltr",
  alt: ["Binzabi", "Injebi", "Ndjabi", "Njabi", "Njevi", "Nzebi", "Yinjebi", "Bandzabi", "Ndjevi"],
  cc: ["GA", "CG"]
}, {
  pk: 4749,
  ang: "Nzema",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Nzima",
  lc: "nzi",
  ld: "ltr",
  alt: ["Appolo", "Nzima", "Evalue"],
  cc: ["GH"]
}, {
  pk: 4750,
  ang: "Nzakara",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Nzakara",
  lc: "nzk",
  ld: "ltr",
  alt: ["Ansakara", "N'sakara", "Sakara", "Zakara"],
  cc: ["CF"]
}, {
  pk: 4751,
  ang: "Naga, Zeme",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Zeme Naga",
  lc: "nzm",
  ld: "ltr",
  alt: ["Arung", "Empui", "Jeme", "Kacha", "Kachcha", "Kutcha", "Mezama", "Sangrima", "Sengima", "Zemi"],
  cc: ["IN"]
}, {
  pk: 4752,
  ang: "New Zealand Sign Language",
  lr: "Pacific",
  gw: false,
  hc: "NZ",
  ln: "New Zealand Sign Language",
  lc: "nzs",
  ld: "ltr",
  alt: ["NZSL"],
  cc: ["NZ"]
}, {
  pk: 4753,
  ang: "Teke-Nzikou",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Teke-Nzikou",
  lc: "nzu",
  ld: "ltr",
  alt: ["Njiunjiu", "Teke-Eboo"],
  cc: ["CG"]
}, {
  pk: 4754,
  ang: "Nzakambay",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Nzakambay",
  lc: "nzy",
  ld: "ltr",
  alt: ["Mbay", "Nzak Mbai", "Nzak Mbay", "Nzakmbay", "Mboum", "Mbum", "Mbum Nzakambay", "Njakambai", "Nzaka Mbay", "Gonge (Ngonge)", "Zoli"],
  cc: ["CM", "TD"]
}, {
  pk: 4755,
  ang: "Dogon, Nanga Dama",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Nanga Dama Dogon",
  lc: "nzz",
  ld: "ltr",
  alt: ["Nanga Dogon"],
  cc: ["ML"]
}, {
  pk: 4756,
  ang: "Orok",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041E\u0440\u043E\u043A\u0441\u043A\u0438\u0439",
  lc: "oaa",
  ld: "ltr",
  alt: ["Oroc", "Uilta", "Ujlta", "Ulta", "Poronaisk (Southern Orok)", "Val-Nogliki (Nogliki-Val)", "Northern Orok"],
  cc: ["RU"]
}, {
  pk: 4757,
  ang: "Oroch",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041E\u0440\u043E\u0447\u0441\u043A\u0438\u0439",
  lc: "oac",
  ld: "ltr",
  alt: ["Orochi", "Tez (Tazy)"],
  cc: ["RU"]
}, {
  pk: 4758,
  ang: "Old Aramaic",
  lr: "Asia",
  gw: false,
  hc: "SY",
  ln: "Old Aramaic (up to 700 BCE)",
  lc: "oar",
  ld: "ltr",
  alt: [],
  cc: ["SY"]
}, {
  pk: 4759,
  ang: "Old Avar",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "Old Avar",
  lc: "oav",
  ld: "ltr",
  alt: [],
  cc: ["RU"]
}, {
  pk: 4760,
  ang: "Obispe\xF1o",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Obispe\xF1o",
  lc: "obi",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 4761,
  ang: "Bontok, Southern",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Southern Bontok",
  lc: "obk",
  ld: "ltr",
  alt: ["Bontoc", "Southern Bontoc"],
  cc: ["PH"]
}, {
  pk: 4762,
  ang: "Oblo",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Oblo",
  lc: "obl",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 4763,
  ang: "Moabite",
  lr: "Asia",
  gw: false,
  hc: "JO",
  ln: "Moabite",
  lc: "obm",
  ld: "ltr",
  alt: [],
  cc: ["JO"]
}, {
  pk: 4764,
  ang: "Manobo, Obo",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Obo Manobo",
  lc: "obo",
  ld: "ltr",
  alt: ["Bagobo", "Kidapawan Manobo", "Obo Bagobo", "Arakan Manobo", "Magpet Manobo", "Marilog"],
  cc: ["PH"]
}, {
  pk: 4765,
  ang: "Old Burmese",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Old Burmese",
  lc: "obr",
  ld: "ltr",
  alt: [],
  cc: ["MM"]
}, {
  pk: 4766,
  ang: "Old Breton",
  lr: "Europe",
  gw: false,
  hc: "FR",
  ln: "Old Breton",
  lc: "obt",
  ld: "ltr",
  alt: [],
  cc: ["FR"]
}, {
  pk: 4767,
  ang: "Obulom",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Obulom",
  lc: "obu",
  ld: "ltr",
  alt: ["Abuloma"],
  cc: ["NG"]
}, {
  pk: 4768,
  ang: "Occitan",
  lr: "Europe",
  gw: false,
  hc: "FR",
  ln: "occitan, lenga d'\xF2c",
  lc: "oc",
  ld: "ltr",
  alt: ["Aran\xE9s", "Aran\xE9s Occit\xE1n", "Aranese", "Arnais", "Gasc\xF3n", "Occitani", "Proven\xE7al", "Provenzale", "Auvergnat (Auverne)", "Proven\xE7al (Alpine Proven\xE7al)", "Mistralien", "Prouven\xE7au", "Lengadoucian", "Languedocien (Langadoc)", "Auvernhas", "Languedoc", "Limousin (Lemosin)", "Aranese Occit\xE1n"],
  cc: ["FR", "ES", "MC"]
}, {
  pk: 4769,
  ang: "Ocaina",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Ocaina",
  lc: "oca",
  ld: "ltr",
  alt: ["Okaina"],
  cc: ["PE"]
}, {
  pk: 4770,
  ang: "Old Chinese",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Old Chinese",
  lc: "och",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 4771,
  ang: "Old Cornish",
  lr: "Europe",
  gw: false,
  hc: "GB",
  ln: "Old Cornish",
  lc: "oco",
  ld: "ltr",
  alt: [],
  cc: ["GB"]
}, {
  pk: 4772,
  ang: "Matlatzinca, Atzingo",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Atzingo Matlatzinca",
  lc: "ocu",
  ld: "ltr",
  alt: ["Atzinteco", "Ocuiltec", "Ocuilteco", "Tlahuica", "Tlahura"],
  cc: ["MX"]
}, {
  pk: 4773,
  ang: "Odut",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Odut",
  lc: "oda",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 4774,
  ang: "Od-Rajput",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Od",
  lc: "odk",
  ld: "ltr",
  alt: ["Oad", "Odki"],
  cc: ["PK", "IN"]
}, {
  pk: 4775,
  ang: "Old Dutch",
  lr: "Europe",
  gw: false,
  hc: "NL",
  ln: "Old Dutch",
  lc: "odt",
  ld: "ltr",
  alt: [],
  cc: ["NL"]
}, {
  pk: 4776,
  ang: "Odual",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Odual",
  lc: "odu",
  ld: "ltr",
  alt: ["Saka", "Arughunya"],
  cc: ["NG"]
}, {
  pk: 4777,
  ang: "Ofo",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Ofo",
  lc: "ofo",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 4778,
  ang: "Old Frisian",
  lr: "Europe",
  gw: false,
  hc: "NL",
  ln: "Old Frisian",
  lc: "ofs",
  ld: "ltr",
  alt: [],
  cc: ["NL"]
}, {
  pk: 4779,
  ang: "Efutop",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Efutop",
  lc: "ofu",
  ld: "ltr",
  alt: ["Agbaragba"],
  cc: ["NG"]
}, {
  pk: 4780,
  ang: "Ogbia",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ogbia",
  lc: "ogb",
  ld: "ltr",
  alt: ["Ogbinya", "Agholo (Kolo)"],
  cc: ["NG"]
}, {
  pk: 4781,
  ang: "Ogbah",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ogbah",
  lc: "ogc",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 4782,
  ang: "Old Georgian",
  lr: "Asia",
  gw: false,
  hc: "GE",
  ln: "\u10A4\u10AC\u10A0\u10C2 \u10B5\u10A0\u10B0\u10A7\u10B3\u10AA\u10A8",
  lc: "oge",
  ld: "ltr",
  alt: [],
  cc: ["GE"]
}, {
  pk: 4783,
  ang: "Ogbogolo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ogbogolo",
  lc: "ogg",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 4784,
  ang: "Khana",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Khana",
  lc: "ogo",
  ld: "ltr",
  alt: ["Ogoni", "Babbe", "Nyo-Kana"],
  cc: ["NG"]
}, {
  pk: 4785,
  ang: "Ogbronuagum",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ogbronuagum",
  lc: "ogu",
  ld: "ltr",
  alt: ["Bukuma"],
  cc: ["NG"]
}, {
  pk: 4786,
  ang: "Old Hittite",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Old Hittite",
  lc: "oht",
  ld: "ltr",
  alt: [],
  cc: ["TR"]
}, {
  pk: 4787,
  ang: "Old Hungarian",
  lr: "Europe",
  gw: false,
  hc: "HU",
  ln: "Old Hungarian",
  lc: "ohu",
  ld: "ltr",
  alt: [],
  cc: ["HU"]
}, {
  pk: 4788,
  ang: "Oirata",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Oirata",
  lc: "oia",
  ld: "ltr",
  alt: ["Maaro"],
  cc: ["ID"]
}, {
  pk: 4789,
  ang: "One, Inebu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Inebu One",
  lc: "oin",
  ld: "ltr",
  alt: ["Aunalei", "Inebu", "Onele", "Oni"],
  cc: ["PG"]
}, {
  pk: 4790,
  ang: "Ojibwe, Ojibwa",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "\u140A\u14C2\u1511\u14C8\u142F\u14A7\u140E\u14D0",
  lc: "oj",
  ld: "ltr",
  alt: [],
  cc: ["CA"]
}, {
  pk: 4791,
  ang: "Ojibwa, Northwestern",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Northwestern Ojibwa",
  lc: "ojb",
  ld: "ltr",
  alt: ["Northern Ojibwa", "Ojibway", "Ojibwe", "Berens River Ojibwa (Saulteaux)"],
  cc: ["CA"]
}, {
  pk: 4792,
  ang: "Ojibwa, Central",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Central Ojibwa",
  lc: "ojc",
  ld: "ltr",
  alt: ["Central Ojibwe", "Ojibway", "Ojibwe"],
  cc: ["CA"]
}, {
  pk: 4793,
  ang: "Ojibwa, Eastern",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Eastern Ojibwa",
  lc: "ojg",
  ld: "ltr",
  alt: ["Ojibway", "Ojibwe"],
  cc: ["CA"]
}, {
  pk: 4794,
  ang: "Old Japanese",
  lr: "Asia",
  gw: false,
  hc: "JP",
  ln: "\u4E0A\u4EE3\u65E5\u672C\u8A9E",
  lc: "ojp",
  ld: "ltr",
  alt: [],
  cc: ["JP"]
}, {
  pk: 4795,
  ang: "Ojibwa, Severn",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Severn Ojibwa",
  lc: "ojs",
  ld: "ltr",
  alt: ["Cree", "Northern Ojibwa", "Ojibway", "Ojibwe", "Ojicree", "Oji-Cree"],
  cc: ["CA"]
}, {
  pk: 4796,
  ang: "Ontong Java",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Ontong Java",
  lc: "ojv",
  ld: "ltr",
  alt: ["Leuangiua", "Lord Howe", "Luangiua", "Luaniua"],
  cc: ["SB"]
}, {
  pk: 4797,
  ang: "Ojibwa, Western",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Western Ojibwa",
  lc: "ojw",
  ld: "ltr",
  alt: ["Ojibway", "Ojibwe", "Plains Ojibway", "Saulteaux"],
  cc: ["CA"]
}, {
  pk: 4798,
  ang: "Okanagan",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Okanagan",
  lc: "oka",
  ld: "ltr",
  alt: ["Okanagan-Colville", "Okanagon", "Okanogan"],
  cc: ["US", "CA"]
}, {
  pk: 4799,
  ang: "Okobo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Okobo",
  lc: "okb",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 4800,
  ang: "Okodia",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Okodia",
  lc: "okd",
  ld: "ltr",
  alt: ["Okordia"],
  cc: ["NG"]
}, {
  pk: 4801,
  ang: "Okpe",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Okpe (Southwestern Edo)",
  lc: "oke",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 4802,
  ang: "Koresh-e Rostam",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Koresh-e Rostam",
  lc: "okh",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 4803,
  ang: "Okiek",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Okiek",
  lc: "oki",
  ld: "ltr",
  alt: ["Akie", "Akiek", "Kinare", "Ogiek", "Ndorobo", "Sogoo (Sokoo)"],
  cc: ["KE"]
}, {
  pk: 4804,
  ang: "One, Kwamtim",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kwamtim One",
  lc: "okk",
  ld: "ltr",
  alt: ["Aunalei", "Kuamtim", "Kwamtim", "Oni"],
  cc: ["PG"]
}, {
  pk: 4805,
  ang: "Old Kentish Sign Language",
  lr: "Europe",
  gw: false,
  hc: "GB",
  ln: "Old Kentish Sign Language",
  lc: "okl",
  ld: "ltr",
  alt: [],
  cc: ["GB"]
}, {
  pk: 4806,
  ang: "Middle Korean (10th-16th cent.)",
  lr: "Asia",
  gw: false,
  hc: "KP",
  ln: "\uC911\uC138\uAD6D\uC5B4",
  lc: "okm",
  ld: "ltr",
  alt: [],
  cc: ["KP"]
}, {
  pk: 4807,
  ang: "Oki-No-Erabu",
  lr: "Asia",
  gw: false,
  hc: "JP",
  ln: "\u5CF6\u30E0\u30CB",
  lc: "okn",
  ld: "ltr",
  alt: [],
  cc: ["JP"]
}, {
  pk: 4808,
  ang: "",
  lr: "",
  gw: false,
  hc: "",
  ln: "Old Korean (3rd-9th cent.)",
  lc: "oko",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4809,
  ang: "Kirike",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kirike",
  lc: "okr",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 4810,
  ang: "Oko-Eni-Osayen",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Oko-Eni-Osayen",
  lc: "oks",
  ld: "ltr",
  alt: ["Ogori-Magongo", "Osayen (Magongo)", "Uku", "Osanyin", "Oko (Ogori)"],
  cc: ["NG"]
}, {
  pk: 4811,
  ang: "Oku",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Oku",
  lc: "oku",
  ld: "ltr",
  alt: ["Bvukoo", "Ebkuo", "Ekpwo", "Kuo", "Ukfwo", "Uku"],
  cc: ["CM"]
}, {
  pk: 4812,
  ang: "Orokaiva",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Orokaiva",
  lc: "okv",
  ld: "ltr",
  alt: ["Etija (Sohe)", "Ihane", "Sose", "Ehija (Ifane)"],
  cc: ["PG"]
}, {
  pk: 4813,
  ang: "Okpe",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Okpe (Northwestern Edo)",
  lc: "okx",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 4814,
  ang: "Walungge",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Walungge",
  lc: "ola",
  ld: "ltr",
  alt: ["Halung", "Halungge", "Walongchung Gola", "Walung", "Walungchung Gola", "Walunggi Keccya", "Olangchung Gola (Upper Tamar River)", "Topke Gola (Mewa River)", "Ghunsa River"],
  cc: ["NP"]
}, {
  pk: 4815,
  ang: "Mochi",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Mochi",
  lc: "old",
  ld: "ltr",
  alt: ["Kimochi", "Kimoshi", "Moshi", "Mosi"],
  cc: ["TZ"]
}, {
  pk: 4816,
  ang: "Olekha",
  lr: "Asia",
  gw: false,
  hc: "BT",
  ln: "Olekha",
  lc: "ole",
  ld: "ltr",
  alt: ["Black Mountain Language", "Monkha", "Monpa", "Ole M\xF6npa"],
  cc: ["BT"]
}, {
  pk: 4817,
  ang: "Olkol",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Olkol",
  lc: "olk",
  ld: "ltr",
  alt: ["Koka-ollugul", "Koko Olkol", "Koko Olkolo", "Koko-olkol", "Olcoola", "Olgolo", "Ol'kol", "Olkulo", "Ulkulu", "Wulgulu"],
  cc: ["AU"]
}, {
  pk: 4818,
  ang: "Oloma",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Oloma",
  lc: "olm",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 4819,
  ang: "Livvi-Karelian",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041B\u0438\u0432\u0432\u0438\u043A\u043E\u0432\u0441\u043A\u043E\u0435 \u043D\u0430\u0440\u0435\u0447\u0438\u0435",
  lc: "olo",
  ld: "ltr",
  alt: ["Aunus", "Livvikovian", "Olonets", "Olonetsian", "Karelian", "Livvikovskij Jazyk", "Southern Olonetsian"],
  cc: ["RU"]
}, {
  pk: 4820,
  ang: "Olrat",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Olrat",
  lc: "olr",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 4821,
  ang: "Old Lithuanian",
  lr: "Europe",
  gw: false,
  hc: "LT",
  ln: "Old Lithuanian",
  lc: "olt",
  ld: "ltr",
  alt: [],
  cc: ["LT"]
}, {
  pk: 4822,
  ang: "Oromo",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Afaan Oromoo",
  lc: "om",
  ld: "ltr",
  alt: [],
  cc: ["ET"]
}, {
  pk: 4823,
  ang: "Omaha-Ponca",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Omaha-Ponca",
  lc: "oma",
  ld: "ltr",
  alt: ["Mahairi", "Ponka", "Ppankka", "Umanhan"],
  cc: ["US"]
}, {
  pk: 4824,
  ang: "Ambae, East",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "East Ambae",
  lc: "omb",
  ld: "ltr",
  alt: ["Aoba", "Northeast Ambae", "Northeast Aoba", "Oba", "Omba", "Walurigi", "Lolsiwoi", "Lombaha (Lobaha)", "Lolokaro (Lolokara)"],
  cc: ["VU"]
}, {
  pk: 4825,
  ang: "Mochica",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Mochica",
  lc: "omc",
  ld: "ltr",
  alt: [],
  cc: ["PE"]
}, {
  pk: 4826,
  ang: "Omagua",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Omagua",
  lc: "omg",
  ld: "ltr",
  alt: ["Agua", "Anapia", "Ariana", "Cambeba", "Cambela", "Campeba", "Canga-Peba", "Compeva", "Janbeba", "Macanipa", "Omagua-Yete", "Pariana", "Umaua", "Yhuata", "Cambeeba", "Kambeba", "Paguana (Paguara)", "Aizuare (Aissuari)", "Curacirari (Curazicari)", "Curucicuri (Curuzicari)"],
  cc: ["PE"]
}, {
  pk: 4827,
  ang: "Omi",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Omi",
  lc: "omi",
  ld: "ltr",
  alt: ["Kaliko-Omi"],
  cc: ["CD"]
}, {
  pk: 4828,
  ang: "Omok",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041E\u043C\u043E\u043A\u0441\u043A\u0438\u0439 \u044F\u0437\u044B\u043A",
  lc: "omk",
  ld: "ltr",
  alt: [],
  cc: ["RU"]
}, {
  pk: 4829,
  ang: "Ombo",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ombo",
  lc: "oml",
  ld: "ltr",
  alt: ["Hombo", "Loombo", "Songola", "Mbuli (Mbole)"],
  cc: ["CD"]
}, {
  pk: 4830,
  ang: "Minoan",
  lr: "Europe",
  gw: false,
  hc: "GR",
  ln: "Minoan",
  lc: "omn",
  ld: "ltr",
  alt: [],
  cc: ["GR"]
}, {
  pk: 4831,
  ang: "Utarmbung",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Utarmbung",
  lc: "omo",
  ld: "ltr",
  alt: ["Osum"],
  cc: ["PG"]
}, {
  pk: 4832,
  ang: "Old Manipuri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Old Manipuri",
  lc: "omp",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 4833,
  ang: "Old Marathi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Old Marathi",
  lc: "omr",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 4834,
  ang: "Omotik",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Omotik",
  lc: "omt",
  ld: "ltr",
  alt: ["Laamoot", "Omotic", "Ndorobo"],
  cc: ["KE"]
}, {
  pk: 4835,
  ang: "Tairora, South",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "South Tairora",
  lc: "omw",
  ld: "ltr",
  alt: ["Haaviqinra-Oraura (Habina-Oraura)", "Omwunra-Toqura (Obura-To'okena)", "Vaira-Ntosara (Baira)", "Veqaura (Meauna)", "Vinaata-Konkompira (Pinata-Konkombira)", "Aatasaara (Atakara)"],
  cc: ["PG"]
}, {
  pk: 8244,
  ang: "Bonta",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bonta",
  lc: "omw-x-bonta",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8245,
  ang: "Marawak",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Marawak",
  lc: "omw-x-marawak",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8241,
  ang: "Obura",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Obura",
  lc: "omw-x-obura",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8242,
  ang: "Tookena",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tookena",
  lc: "omw-x-tookena",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4836,
  ang: "Old Mon",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Old Mon",
  lc: "omx",
  ld: "ltr",
  alt: [],
  cc: ["MM"]
}, {
  pk: 4837,
  ang: "Lingao",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u81E8\u9AD8\u8A9E",
  lc: "onb",
  ld: "ltr",
  alt: ["B\xEA", "Limkow", "Linkow", "Ongbe", "Ong-Be", "Vo Limkou", "Lincheng (Lingao Proper-Dengmai)"],
  cc: ["CN"]
}, {
  pk: 4838,
  ang: "Oneida",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Oneida",
  lc: "one",
  ld: "ltr",
  alt: [],
  cc: ["US", "CA"]
}, {
  pk: 4839,
  ang: "Olo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Olo",
  lc: "ong",
  ld: "ltr",
  alt: ["Orlei", "Wapi (South Olo)", "Wape", "Pay", "Payi (North Olo)"],
  cc: ["PG"]
}, {
  pk: 4840,
  ang: "Onin",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Onin",
  lc: "oni",
  ld: "ltr",
  alt: ["Onim"],
  cc: ["ID"]
}, {
  pk: 4841,
  ang: "Onjob",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Onjob",
  lc: "onj",
  ld: "ltr",
  alt: ["Onjab"],
  cc: ["PG"]
}, {
  pk: 4842,
  ang: "One, Kabore",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kabore One",
  lc: "onk",
  ld: "ltr",
  alt: ["Aunalei", "Kabore", "Onele", "Oni"],
  cc: ["PG"]
}, {
  pk: 4843,
  ang: "Onobasulu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Onobasulu",
  lc: "onn",
  ld: "ltr",
  alt: ["Onabasulu"],
  cc: ["PG"]
}, {
  pk: 4844,
  ang: "Onondaga",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Onondaga",
  lc: "ono",
  ld: "ltr",
  alt: ["Onandaga"],
  cc: ["US", "CA"]
}, {
  pk: 4845,
  ang: "Sartang",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Sartang",
  lc: "onp",
  ld: "ltr",
  alt: ["Bootpa", "But Monpa", "But Pa", "Matchopa"],
  cc: ["IN"]
}, {
  pk: 4846,
  ang: "One, Northern",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Northern One",
  lc: "onr",
  ld: "ltr",
  alt: ["Aunalei", "Onele", "Oni"],
  cc: ["PG"]
}, {
  pk: 4847,
  ang: "Ono",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ono",
  lc: "ons",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4848,
  ang: "Ontenu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ontenu",
  lc: "ont",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4849,
  ang: "Unua",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Unua",
  lc: "onu",
  ld: "ltr",
  alt: ["Onua", "Pangkumu"],
  cc: ["VU"]
}, {
  pk: 4850,
  ang: "Old Nubian",
  lr: "Africa",
  gw: false,
  hc: "EG",
  ln: "Old Nubian",
  lc: "onw",
  ld: "ltr",
  alt: [],
  cc: ["EG"]
}, {
  pk: 4851,
  ang: "Onin Based Pidgin",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Onin Based Pidgin",
  lc: "onx",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 4852,
  ang: "Tohono O\u2019odham",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Tohono O'odham",
  lc: "ood",
  ld: "ltr",
  alt: ["Nebome", "Nevome", "O'odham", "O'othham", "Papago-Pima", "Upper Piman", "Tohono O'odam (\"Papago\")", "Akimel O'odham (Pima)", "Papago"],
  cc: ["US", "CA"]
}, {
  pk: 4853,
  ang: "Ong",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Ong",
  lc: "oog",
  ld: "ltr",
  alt: ["Hantong", "Tong"],
  cc: ["LA"]
}, {
  pk: 4854,
  ang: "\xD6\xF1ge",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "\xD6nge",
  lc: "oon",
  ld: "ltr",
  alt: ["Ong"],
  cc: ["IN"]
}, {
  pk: 4855,
  ang: "Oorlams",
  lr: "Africa",
  gw: false,
  hc: "ZA",
  ln: "Oorlams",
  lc: "oor",
  ld: "ltr",
  alt: [],
  cc: ["ZA"]
}, {
  pk: 4856,
  ang: "Old Ossetic",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "Old Ossetic",
  lc: "oos",
  ld: "ltr",
  alt: [],
  cc: ["RU"]
}, {
  pk: 4857,
  ang: "Okpamheri",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Okpamheri",
  lc: "opa",
  ld: "ltr",
  alt: ["Somorika", "Semolika", "Okulosho (Okurosho)", "Emhalhe (Emarle)", "Ibilo"],
  cc: ["NG"]
}, {
  pk: 4858,
  ang: "Kopkaka",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kopkaka",
  lc: "opk",
  ld: "ltr",
  alt: ["Kopka"],
  cc: ["ID"]
}, {
  pk: 4859,
  ang: "Oksapmin",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Oksapmin",
  lc: "opm",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4860,
  ang: "Opao",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Opao",
  lc: "opo",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4861,
  ang: "Ofay\xE9",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Ofay\xE9",
  lc: "opy",
  ld: "ltr",
  alt: ["Ofai\xE9-Xavante", "Ofay\xE9-Xavante", "Opai\xE9-Shavante", "Opay\xE9"],
  cc: ["BR"]
}, {
  pk: 4862,
  ang: "Oriya",
  lr: "Asia",
  gw: true,
  hc: "IN",
  ln: "\u0B13\u0B21\u0B3C\u0B3F\u0B06",
  lc: "or",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 4863,
  ang: "Oroha",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Oroha",
  lc: "ora",
  ld: "ltr",
  alt: ["Mara Ma-Siki", "Oraha"],
  cc: ["SB"]
}, {
  pk: 4864,
  ang: "Orma",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Orma",
  lc: "orc",
  ld: "ltr",
  alt: ["Uardai", "Wadai", "Warday", "Munyo (Korokoro)", "Munyo Yaya", "Waata (Sanye)"],
  cc: ["KE"]
}, {
  pk: 4865,
  ang: "Orej\xF3n",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Orej\xF3n",
  lc: "ore",
  ld: "ltr",
  alt: ["Coto", "Koto", "Mai Ja", "Orechon", "Oregon", "Payagua", "Tutapi"],
  cc: ["PE"]
}, {
  pk: 4866,
  ang: "Oring",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Oring",
  lc: "org",
  ld: "ltr",
  alt: ["Koring", "Orri", "Orrin", "Orringorrin", "Ufia (Utonkon)", "Ufiom (Effium)"],
  cc: ["NG"]
}, {
  pk: 4867,
  ang: "Oroqen",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u9102\u4F26\u6625\u8BED",
  lc: "orh",
  ld: "ltr",
  alt: ["Olunchun", "Orochen", "Orochon", "Oronchon", "Ulunchun", "Birarchen", "Kumarchen", "Selpechen"],
  cc: ["CN"]
}, {
  pk: 4868,
  ang: "Orang Kanaq",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Orang Kanaq",
  lc: "orn",
  ld: "ltr",
  alt: ["Kanaq"],
  cc: ["MY"]
}, {
  pk: 4869,
  ang: "Orokolo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Orokolo",
  lc: "oro",
  ld: "ltr",
  alt: ["Bailala", "Haira", "Kairu-Kaura", "Muro", "Muru", "Vailala", "West Elema"],
  cc: ["PG"]
}, {
  pk: 4870,
  ang: "Oruma",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Oruma",
  lc: "orr",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 4871,
  ang: "Orang Seletar",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Orang Seletar",
  lc: "ors",
  ld: "ltr",
  alt: ["Orang Laut"],
  cc: ["MY", "SG"]
}, {
  pk: 7646,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Suku Laut; Orang Laut",
  lc: "ors-x-oranglau",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4872,
  ang: "Oriya, Adivasi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Adivasi Oriya",
  lc: "ort",
  ld: "ltr",
  alt: ["Adiwasi Oriya", "Kotia Oriya", "Kotiya", "Tribal Oriya"],
  cc: ["IN"]
}, {
  pk: 4873,
  ang: "Ormuri",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u0627\u0648\u0631\u0645\u0691\u06CC",
  lc: "oru",
  ld: "ltr",
  alt: ["Baraks", "Bargista", "Oormuri", "Ormui", "Baraki", "Ormur", "Urmuri"],
  cc: ["PK"]
}, {
  pk: 4874,
  ang: "Old Russian",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0414\u0440\u0435\u0432\u043D\u0435\u0440\u0443\u0441\u0441\u043A\u0438\u0439 \u044F\u0437\u044B\u043A",
  lc: "orv",
  ld: "ltr",
  alt: [],
  cc: ["RU"]
}, {
  pk: 4875,
  ang: "Oro Win",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Oro Win",
  lc: "orw",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 4876,
  ang: "Oro",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Oro",
  lc: "orx",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 4877,
  ang: "Oriya",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Oriya (individual language)",
  lc: "ory",
  ld: "ltr",
  alt: ["Odisha", "Odri", "Odrum", "Oliya", "Uriya", "Utkali", "Vadiya", "Yudhia", "Standard Oriya", "Western Oriya (Sambalpuri)", "Mughalbandi (Oriya Proper)"],
  cc: ["BD", "US", "IN", "MM"]
}, {
  pk: 8010,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Amanatya",
  lc: "ory-x-amanatya",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4878,
  ang: "Ormu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ormu",
  lc: "orz",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 8204,
  ang: "Raran'kwa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Raran'kwa",
  lc: "orz-x-rarankwa",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4879,
  ang: "Ossetian, Ossetic",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0438\u0440\u043E\u043D \xE6\u0432\u0437\u0430\u0433",
  lc: "os",
  ld: "ltr",
  alt: ["Osetin", "Ossete", "Digor (Digorian)", "Digoron", "Dogor", "Kudar (South Osetin)"],
  cc: ["AZ", "KZ", "TJ", "RU", "TR", "GE", "KG", "TM", "UZ"]
}, {
  pk: 4880,
  ang: "Osage",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Osage",
  lc: "osa",
  ld: "ltr",
  alt: ["Wazhazhe"],
  cc: ["US"]
}, {
  pk: 4881,
  ang: "Oscan",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Oscan",
  lc: "osc",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 4882,
  ang: "Osing",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Osing",
  lc: "osi",
  ld: "ltr",
  alt: ["Banyuwangi"],
  cc: ["ID"]
}, {
  pk: 4883,
  ang: "Ososo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ososo",
  lc: "oso",
  ld: "ltr",
  alt: [],
  cc: ["CM", "NG"]
}, {
  pk: 4884,
  ang: "Old Spanish",
  lr: "Europe",
  gw: false,
  hc: "ES",
  ln: "Romance Castellano",
  lc: "osp",
  ld: "ltr",
  alt: [],
  cc: ["ES"]
}, {
  pk: 4885,
  ang: "Osatu",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Osatu",
  lc: "ost",
  ld: "ltr",
  alt: ["Ihatum", "Ossatu"],
  cc: ["CM"]
}, {
  pk: 4886,
  ang: "One, Southern",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Southern One",
  lc: "osu",
  ld: "ltr",
  alt: ["Aunalei", "Onele", "Oni"],
  cc: ["PG"]
}, {
  pk: 4887,
  ang: "Old Saxon",
  lr: "Europe",
  gw: false,
  hc: "DE",
  ln: "Sahsisk",
  lc: "osx",
  ld: "ltr",
  alt: [],
  cc: ["DE"]
}, {
  pk: 4888,
  ang: "Ottoman Turkish (1500-1928)",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Osmanl\u0131 T\xFCrk\xE7esi",
  lc: "ota",
  ld: "ltr",
  alt: [],
  cc: ["TR"]
}, {
  pk: 4889,
  ang: "Old Tibetan",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Old Tibetan",
  lc: "otb",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 4890,
  ang: "Ot Danum",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ot Danum",
  lc: "otd",
  ld: "ltr",
  alt: ["Malahoi", "Uud Danum", "Ot Murung 1 (Murung 1)", "Punan Ratah", "Sarawai (Melawi)", "Sebaung", "Ulu Ai' (Da'an)"],
  cc: ["ID"]
}, {
  pk: 8139,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Belaban",
  lc: "otd-x-belaban",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7902,
  ang: "Dayak Uud Danum",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Uud Danum",
  lc: "otd-x-dayakdohoi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7899,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Limbai",
  lc: "otd-x-dayaklimbai",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8239,
  ang: "Dohoy",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dohoy",
  lc: "otd-x-dohoy",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8303,
  ang: "Kadorih",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kadorih",
  lc: "otd-x-kadori",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8196,
  ang: "Dayak Kadorih",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Kadorih",
  lc: "otd-x-kadorih",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 8340,
  ang: "Mahalat",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mahalat",
  lc: "otd-x-mahalat",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8041,
  ang: "Dayak Oruun Da'an",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Oruung Da'an",
  lc: "otd-x-oruundaan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8066,
  ang: "Dayak Pangin Daan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Pangin Daan",
  lc: "otd-x-pangindaan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7828,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Punan Kuhi",
  lc: "otd-x-punankuhi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8339,
  ang: "Rangsa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Rangsa",
  lc: "otd-x-rangsa",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7950,
  ang: "Uud Danum Ambalau Serawai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Uud Danum Ambalau Serawai",
  lc: "otd-x-uudanumwkali",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4891,
  ang: "Otomi, Mezquital",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Mezquital Otomi",
  lc: "ote",
  ld: "ltr",
  alt: ["H\xF1ah\xF1u", "Otom\xED del Valle del Mezquital"],
  cc: ["MX"]
}, {
  pk: 4892,
  ang: "Old Turkic",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Old Turkic",
  lc: "otk",
  ld: "ltr",
  alt: [],
  cc: ["TR"]
}, {
  pk: 4893,
  ang: "Otomi, Tilapa",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tilapa Otomi",
  lc: "otl",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 4894,
  ang: "Otomi, Eastern Highland",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Eastern Highland Otomi",
  lc: "otm",
  ld: "ltr",
  alt: ["Eastern Otomi", "Otom\xED de Huehuetla", "Otom\xED de la Sierra", "Otomi de la Sierra Madre Oriental", "Otomi de la Sierra Oriental", "Otom\xED del Oriente", "Sierra Oriental Otomi", "Yuhu"],
  cc: ["MX"]
}, {
  pk: 4895,
  ang: "Otomi, Tenango",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tenango Otomi",
  lc: "otn",
  ld: "ltr",
  alt: ["Otom\xED de Tenango"],
  cc: ["MX"]
}, {
  pk: 4896,
  ang: "Otomi, Quer\xE9taro",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Quer\xE9taro Otomi",
  lc: "otq",
  ld: "ltr",
  alt: ["H\xF1oh\xF1o", "Northwestern Otomi", "Otom\xED de Quer\xE9taro", "Western Otomi"],
  cc: ["MX"]
}, {
  pk: 4897,
  ang: "Otoro",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Otoro",
  lc: "otr",
  ld: "ltr",
  alt: ["Dhitoro", "Kawama", "Kawarma", "Litoro", "Utoro", "Dogoridi", "Dorobe", "Dugujur", "Dukwara"],
  cc: ["SD"]
}, {
  pk: 4898,
  ang: "Otomi, Estado de M\xE9xico",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Estado de M\xE9xico Otomi",
  lc: "ots",
  ld: "ltr",
  alt: ["H\xF1atho", "Otom\xED de San Felipe Santiago", "Otom\xED del Estado de M\xE9xico", "State of Mexico Otomi", "San Felipe Santiago Otom\xED"],
  cc: ["MX"]
}, {
  pk: 4899,
  ang: "Otomi, Temoaya",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Temoaya Otomi",
  lc: "ott",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 4900,
  ang: "Ottawa",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Ottawa",
  lc: "otw",
  ld: "ltr",
  alt: ["Odawa", "Ojibway", "Ojibwe", "Chippewa", "Eastern Ojibwa"],
  cc: ["CA"]
}, {
  pk: 4901,
  ang: "Otomi, Texcatepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Texcatepec Otomi",
  lc: "otx",
  ld: "ltr",
  alt: ["Northeastern Otom\xED", "Otom\xED de Texcatepec"],
  cc: ["MX"]
}, {
  pk: 4902,
  ang: "Old Tamil",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Old Tamil",
  lc: "oty",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 4903,
  ang: "Otomi, Ixtenco",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Ixtenco Otomi",
  lc: "otz",
  ld: "ltr",
  alt: ["Otom\xED de Ixtenco", "Southeastern Otom\xED"],
  cc: ["MX"]
}, {
  pk: 4904,
  ang: "Tagargrent",
  lr: "Africa",
  gw: false,
  hc: "DZ",
  ln: "\u0627\u0644\u0644\u0647\u062C\u0629 \u0627\u0644\u0623\u0645\u0627\u0632\u064A\u063A\u064A\u0629 \u0627\u0644\u0648\u0631\u0642\u0644\u064A\u0629",
  lc: "oua",
  ld: "ltr",
  alt: ["Ouargla", "Ouargli", "Wargla", "Ouedghir (Wadi)"],
  cc: ["DZ"]
}, {
  pk: 4905,
  ang: "Glio-Oubi",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Glio-Oubi",
  lc: "oub",
  ld: "ltr",
  alt: ["Oubi", "Ubi"],
  cc: ["LR"]
}, {
  pk: 4906,
  ang: "Oune",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Oune",
  lc: "oue",
  ld: "ltr",
  alt: ["Dapera", "Eivo 3", "Ounge"],
  cc: ["PG"]
}, {
  pk: 4907,
  ang: "Old Uighur",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u56DE\u9E58\u8BED",
  lc: "oui",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 4908,
  ang: "Owiniga",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Owiniga",
  lc: "owi",
  ld: "ltr",
  alt: ["Bero", "Samo", "Taina"],
  cc: ["PG"]
}, {
  pk: 4909,
  ang: "Old Welsh",
  lr: "Europe",
  gw: false,
  hc: "GB",
  ln: "Old Welsh",
  lc: "owl",
  ld: "ltr",
  alt: [],
  cc: ["GB"]
}, {
  pk: 4910,
  ang: "Oy",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Oy",
  lc: "oyb",
  ld: "ltr",
  alt: ["Huei", "Oi"],
  cc: ["LA"]
}, {
  pk: 4911,
  ang: "Oyda",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Oyda",
  lc: "oyd",
  ld: "ltr",
  alt: [],
  cc: ["ET"]
}, {
  pk: 4912,
  ang: "Wayampi",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Wayampi",
  lc: "oym",
  ld: "ltr",
  alt: ["Guaiapi", "Guayapi", "Oiamp\xED", "Oyamp\xED", "Oyamp\xEDk", "Oyanp\xEDk", "Waiampi", "Wai\xE3pi", "Wajapae", "Wajapuku", "Wayapae", "Way\xE3pi", "Oiampipucu", "Oyampipuku", "Oiumpian", "Oyap\xED", "Wajapi", "Wayapi", "Amapari Wayampi", "Jari", "Oiyapoque"],
  cc: ["BR", "GF"]
}, {
  pk: 4913,
  ang: "Oya\u2019oya",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Oya'oya",
  lc: "oyy",
  ld: "ltr",
  alt: ["Daiomuni", "Kuiaro", "Loani", "Simagahi"],
  cc: ["PG"]
}, {
  pk: 4914,
  ang: "Koonzime",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Koonzime",
  lc: "ozm",
  ld: "ltr",
  alt: ["Djimu", "Dzimou", "Kooncimo", "Koozhime", "Koozime", "Zimu", "Nzime (Koonzime)", "Bajwe'e", "Badwe'e (Badjoue)"],
  cc: ["CM", "CG"]
}, {
  pk: 7719,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Nzime",
  lc: "ozm-x-nzime",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4915,
  ang: "Panjabi, Punjabi",
  lr: "Asia",
  gw: true,
  hc: "IN",
  ln: "\u0A2A\u0A70\u0A1C\u0A3E\u0A2C\u0A40, \u067E\u0646\u062C\u0627\u0628\u06CC\u200E",
  lc: "pa",
  ld: "ltr",
  alt: ["Eastern Punjabi", "Gurmukhi", "Gurumukhi", "Bhatti", "Bhatyiana (Bhatneri)"],
  cc: ["BD", "FJ", "AF", "FR", "KE", "LK", "GB", "MY", "OM", "NP", "PK", "TZ", "TH", "US", "CA", "KW", "DK", "IN", "SG", "MM", "AE"]
}, {
  pk: 4916,
  ang: "Parec\xEDs",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Parec\xEDs",
  lc: "pab",
  ld: "ltr",
  alt: ["Arit\xED", "Haliti", "Pare\xE1s", "Pares\xED", "Paress\xED"],
  cc: ["BR"]
}, {
  pk: 4917,
  ang: "Pacoh",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Pacoh",
  lc: "pac",
  ld: "ltr",
  alt: ["Bo River Van Kieu", "Pokoh", "Paco", "Kanah", "Pahi (Ba-Hi)", "Ka'do"],
  cc: ["LA", "VN"]
}, {
  pk: 4918,
  ang: "Paumar\xED",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Paumar\xED",
  lc: "pad",
  ld: "ltr",
  alt: ["Purupur\xFA", "Kurukuru (Curucuru)", "Paumarm (Pammari)"],
  cc: ["BR"]
}, {
  pk: 4919,
  ang: "Pagibete",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Pagibete",
  lc: "pae",
  ld: "ltr",
  alt: ["Apagibete", "Apagibeti", "Apakabeti", "Apakibeti", "Pagabete", "Egezon", "Gezon", "Ndundusana (Egejo)", "Egezo"],
  cc: ["CD"]
}, {
  pk: 4920,
  ang: "Paranaw\xE1t",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Paranaw\xE1t",
  lc: "paf",
  ld: "ltr",
  alt: ["Majubim", "Paranauat", "Pawat\xE9"],
  cc: ["BR"]
}, {
  pk: 4921,
  ang: "Pangasinan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Pangasinan",
  lc: "pag",
  ld: "ltr",
  alt: [],
  cc: ["PH", "US"]
}, {
  pk: 4922,
  ang: "Tenharim",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Tenharim",
  lc: "pah",
  ld: "ltr",
  alt: ["Kawaib", "Tenharem", "Tenharin", "Diah\xF3i (Giahoi)", "Jahui", "Jiahui", "Kagwahiv (Kawaib)", "Tenharim (Tenharem)"],
  cc: ["BR"]
}, {
  pk: 4923,
  ang: "Pe",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Pe",
  lc: "pai",
  ld: "ltr",
  alt: ["Dalong"],
  cc: ["NG"]
}, {
  pk: 4924,
  ang: "Parakan\xE3",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Parakan\xE3",
  lc: "pak",
  ld: "ltr",
  alt: ["Awaet\xE9", "Parakan\xE2n", "Parocana"],
  cc: ["BR"]
}, {
  pk: 4925,
  ang: "Pahlavi",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Pahlavi",
  lc: "pal",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 4926,
  ang: "Pampangan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Pampanga",
  lc: "pam",
  ld: "ltr",
  alt: ["Kapampangan", "Pampango", "Pampangue\xF1o"],
  cc: ["PH", "US", "CA"]
}, {
  pk: 4927,
  ang: "Paiute, Northern",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Northern Paiute",
  lc: "pao",
  ld: "ltr",
  alt: ["Paviotso", "North Northern Paiute (Mcdermitt)", "South Northern Paiute (Yerington-Schurz)"],
  cc: ["US"]
}, {
  pk: 4928,
  ang: "Papiamentu",
  lr: "Americas",
  gw: false,
  hc: "CW",
  ln: "Papiamento",
  lc: "pap",
  ld: "ltr",
  alt: ["Papiam", "Papiamentoe", "Papiamen", "Papiamento", "Cura\xE7ole\xF1o", "Curassese", "Papiments", "Papia Mentaie"],
  cc: ["DE", "NL", "SX", "CA", "CW"]
}, {
  pk: 4929,
  ang: "Parya",
  lr: "Asia",
  gw: false,
  hc: "TJ",
  ln: "Parya",
  lc: "paq",
  ld: "ltr",
  alt: ["Afghana-Yi Nasfurush", "Afghana-Yi Siyarui", "Laghmani", "Pbharya"],
  cc: ["AF", "TJ"]
}, {
  pk: 7782,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Parya Leghmani",
  lc: "paq-x-leghmani",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4930,
  ang: "Timbisha",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Panamint",
  lc: "par",
  ld: "ltr",
  alt: ["Coso", "Koso", "Koso Shoshone", "Panamint Shoshone", "T\xFCmpisa Shoshoni"],
  cc: ["US"]
}, {
  pk: 4931,
  ang: "Papasena",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Papasena",
  lc: "pas",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 4932,
  ang: "Papitalai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Papitalai",
  lc: "pat",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4933,
  ang: "Palauan",
  lr: "Pacific",
  gw: false,
  hc: "PW",
  ln: "Palauan",
  lc: "pau",
  ld: "ltr",
  alt: ["Belauan"],
  cc: ["PW", "US"]
}, {
  pk: 4934,
  ang: "Paka\xE1snovos",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Paka\xE1snovos",
  lc: "pav",
  ld: "ltr",
  alt: ["Jaru", "Oro Wari", "Pacaas-Novos", "Pacahanovo", "Pakaanova", "Pakaanovas", "Uomo", "Wari"],
  cc: ["BR"]
}, {
  pk: 4935,
  ang: "Pawnee",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Pawnee",
  lc: "paw",
  ld: "ltr",
  alt: ["Skiri (Skidi)"],
  cc: ["US"]
}, {
  pk: 4936,
  ang: "Pankarar\xE9",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Pankarar\xE9",
  lc: "pax",
  ld: "ltr",
  alt: ["Pankar\xE9"],
  cc: ["BR"]
}, {
  pk: 4937,
  ang: "Pech",
  lr: "Americas",
  gw: false,
  hc: "HN",
  ln: "Pech",
  lc: "pay",
  ld: "ltr",
  alt: ["Seco"],
  cc: ["HN"]
}, {
  pk: 4938,
  ang: "Pankarar\xFA",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Pankarar\xFA",
  lc: "paz",
  ld: "ltr",
  alt: ["Pancar\xE9", "Pancaru", "Pankarar\xE1", "Pankaravu", "Pankaroru", "Pankar\xFA"],
  cc: ["BR"]
}, {
  pk: 4939,
  ang: "P\xE1ez",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "P\xE1ez",
  lc: "pbb",
  ld: "ltr",
  alt: ["Paniquita (Panikita)"],
  cc: ["CO"]
}, {
  pk: 4940,
  ang: "Patamona",
  lr: "Americas",
  gw: false,
  hc: "GY",
  ln: "Patamona",
  lc: "pbc",
  ld: "ltr",
  alt: ["Eremagok", "Ingariko", "Kapon"],
  cc: ["BR", "GY"]
}, {
  pk: 4941,
  ang: "Popoloca, Mezontla",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Mezontla Popoloca",
  lc: "pbe",
  ld: "ltr",
  alt: ["Los Reyes Metzontla Popoloca", "Southern Popoloca"],
  cc: ["MX"]
}, {
  pk: 4942,
  ang: "Popoloca, Coyotepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Coyotepec Popoloca",
  lc: "pbf",
  ld: "ltr",
  alt: ["San Mateo Zoyamazalco Popoloca", "San Vicente Coyotepec Popoloca"],
  cc: ["MX"]
}, {
  pk: 4943,
  ang: "Paraujano",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "Paraujano",
  lc: "pbg",
  ld: "ltr",
  alt: ["A\xF1\xFA", "Anun", "Parahujano"],
  cc: ["VE"]
}, {
  pk: 4944,
  ang: "E\u2019\xF1apa Woromaipu",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "E'\xF1apa Woromaipu",
  lc: "pbh",
  ld: "ltr",
  alt: ["Abira", "E\xF1apa", "E\xF1epa", "Eye", "Panare", "Panari"],
  cc: ["VE"]
}, {
  pk: 4945,
  ang: "Parkwa",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Parkwa",
  lc: "pbi",
  ld: "ltr",
  alt: ["Gwadi Parekwa", "Kudala", "Padogo", "Padokwa", "Paduko", "Parekwa", "Pawdawkwa", "Podogo", "Podokwo"],
  cc: ["CM"]
}, {
  pk: 4946,
  ang: "Mak",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Mak (Nigeria)",
  lc: "pbl",
  ld: "ltr",
  alt: ["Leemak", "Lemak", "Panyam", "Zo"],
  cc: ["NG"]
}, {
  pk: 4947,
  ang: "Kpasham",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kpasam",
  lc: "pbn",
  ld: "ltr",
  alt: ["Balo", "Kpasam", "Maya", "Nyisam", "Passam"],
  cc: ["NG"]
}, {
  pk: 4948,
  ang: "Papel",
  lr: "Africa",
  gw: false,
  hc: "GW",
  ln: "Papel",
  lc: "pbo",
  ld: "ltr",
  alt: ["Moium", "Oium", "Papei", "Pepel"],
  cc: ["SN", "GW"]
}, {
  pk: 4949,
  ang: "Badyara",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Badyara",
  lc: "pbp",
  ld: "ltr",
  alt: ["Badara", "Badian", "Badjara", "Badyaranke", "Bigola", "Gola", "Pajade", "Pajadinka", "Badyarank\xE9", "Kanjad", "Badjarank\xE9", "Bajara"],
  cc: ["SN", "GN", "GW"]
}, {
  pk: 4950,
  ang: "Pangwa",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Pangwa",
  lc: "pbr",
  ld: "ltr",
  alt: ["Ekipangwa", "Kipangwa", "Kimwela"],
  cc: ["TZ"]
}, {
  pk: 4951,
  ang: "Pame, Central",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Central Pame",
  lc: "pbs",
  ld: "ltr",
  alt: ["Chichimeca", "Pame de Santa Mar\xEDa Acapulco", "Pame del Centro", "Southern Pame", "Xi'oi"],
  cc: ["MX"]
}, {
  pk: 4952,
  ang: "Pashto, Southern",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "\u067E\u069A\u062A\u0648",
  lc: "pbt",
  ld: "ltr",
  alt: ["Paktu", "Pashtu", "Afghani", "Pushto", "Pushtu", "Quetta-Kandahar Pashto", "Durani", "Afghan", "Pakhtoo", "Pakhtu"],
  cc: ["AF", "IR", "GB", "PK", "TM", "UZ"]
}, {
  pk: 4953,
  ang: "Pashto, Northern",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u06CC\u0648\u0633\u0641\u0632\u0626\u06CC \u067E\u069A\u062A\u0648",
  lc: "pbu",
  ld: "ltr",
  alt: ["Pakhtoo", "Pashtu", "Passtoo", "Pushto", "Pusto", "Afghan", "Eastern Afghan Pashto", "Pakhtu", "Paktu", "Sharqi", "Pakhto", "Yousafzai Pashto", "Yusufzai Pashto", "Khogyani"],
  cc: ["AF", "PK", "TR", "US", "AE"]
}, {
  pk: 4954,
  ang: "Pnar",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Pnar",
  lc: "pbv",
  ld: "ltr",
  alt: ["Jaintia (Synteng)"],
  cc: ["BD", "IN"]
}, {
  pk: 4955,
  ang: "Pyu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Pyu (Papua New Guinea)",
  lc: "pby",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4956,
  ang: "Popoloca, Santa In\xE9s Ahuatempan",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Santa In\xE9s Ahuatempan Popoloca",
  lc: "pca",
  ld: "ltr",
  alt: ["Popoloca de Santa In\xE9s Ahuatempan", "Popoloca del Poniente"],
  cc: ["MX"]
}, {
  pk: 4957,
  ang: "Pear",
  lr: "Asia",
  gw: false,
  hc: "KH",
  ln: "Pear",
  lc: "pcb",
  ld: "ltr",
  alt: [],
  cc: ["KH"]
}, {
  pk: 4958,
  ang: "Bouyei",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5E03\u4F9D\u8BED",
  lc: "pcc",
  ld: "ltr",
  alt: ["Bo-I", "Bui", "Buyei", "Buyi", "Buyui", "Chung-Chia", "Dioi", "Giay", "Pui", "Pu-I", "Pujai", "Pu-Jui", "Puyi", "Puyoi", "Shuihu", "Tujia", "Zhongjia", "Bo-Y", "Chang Ch\xE1", "Chung Cha", "C\xF9i Chu", "Dang", "Giai", "Giang", "Gi\xE1y", "Nhaang", "Niang", "Nyang", "Pau Thin", "P\xFA N\xE0", "Pu-Nam", "Sa", "Trong Ggia", "Tu-D\xECn", "Xa Chung Ch\xE1", "Yai", "Yay", "Central Guizhou", "Western Guizhou", "Tu-D\xED", "Southern Guizhou", "Qianzhong (Bouyei 2)", "Qianxi (Bouyei 3)", "Qiannan (Bouyei 1)"],
  cc: ["CN", "LA"]
}, {
  pk: 8490,
  ang: "Giay Nhan",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Giay Nhan",
  lc: "pcc-x-giaynhan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4959,
  ang: "Picard",
  lr: "Europe",
  gw: false,
  hc: "FR",
  ln: "Picard",
  lc: "pcd",
  ld: "ltr",
  alt: ["Chtimi", "Rouchi", "Amienois (Amies)"],
  cc: ["FR"]
}, {
  pk: 4960,
  ang: "Palaung, Ruching",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Ruching Palaung",
  lc: "pce",
  ld: "ltr",
  alt: ["Bulai", "Da'ang", "Dlang", "Ngwe Palaung", "Palay", "Pale Palaung", "Pulei", "Silver Palaung", "Southern Ta'ang", "Di-Ang", "Southern Palaung", "Ta-Ang", "Rulai"],
  cc: ["CN", "MM"]
}, {
  pk: 4961,
  ang: "Paliyan",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Paliyan",
  lc: "pcf",
  ld: "ltr",
  alt: ["Makkal", "Malai Paliyar", "Palani", "Palaya", "Palayan", "Paliyar", "Palleyan", "Palliyar", "Poliyar", "Seramar", "Tamil", "Karavazhi", "Mala Pulayan (Hill Pulaya)"],
  cc: ["IN"]
}, {
  pk: 4962,
  ang: "Paniya",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Paniya",
  lc: "pcg",
  ld: "ltr",
  alt: ["Nil", "Paniyan", "Panyah"],
  cc: ["IN"]
}, {
  pk: 4963,
  ang: "Pardhan",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Pardhan",
  lc: "pch",
  ld: "ltr",
  alt: ["Pradhan", "Pradhani"],
  cc: ["IN"]
}, {
  pk: 4964,
  ang: "Duruwa",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Duruwa",
  lc: "pci",
  ld: "ltr",
  alt: ["Dhruva", "Dhurwa", "Durva", "Paraja", "Parajhi", "Parjhi", "Parji", "Tagara", "Thakara", "Tugara"],
  cc: ["IN"]
}, {
  pk: 4965,
  ang: "Parenga",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Parenga",
  lc: "pcj",
  ld: "ltr",
  alt: ["Gorum", "Gorum Sama", "Pareng", "Parenga Parja", "Parengi", "Parenji", "Poroja"],
  cc: ["IN"]
}, {
  pk: 4966,
  ang: "Chin, Paite",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Paite Chin",
  lc: "pck",
  ld: "ltr",
  alt: ["Haithe", "Paithe", "Parte", "Zoukam", "Dimpi", "Tuichiap", "Telzang (Teizang)", "Sihzang", "Saizang", "Lamzang", "Dim", "Dapzal (Dapzar)", "Bukpi (Bukpui)", "Lousau"],
  cc: ["IN"]
}, {
  pk: 4967,
  ang: "Pardhi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Pardhi",
  lc: "pcl",
  ld: "ltr",
  alt: ["Bahelia", "Chita Pardhi", "Lango Pardhi", "Paidia", "Paradi", "Paria", "Phans Pardhi", "Takankar", "Takia"],
  cc: ["IN"]
}, {
  pk: 8395,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Thakan",
  lc: "pcl-x-thakan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4968,
  ang: "Pidgin, Nigerian",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Nigerian Pidgin",
  lc: "pcm",
  ld: "ltr",
  alt: ["Broken English", "Brokin", "Brokun", "Nigerian Creole English", "Nigerian Pidgin English"],
  cc: ["NG", "US"]
}, {
  pk: 4969,
  ang: "Piti",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Piti",
  lc: "pcn",
  ld: "ltr",
  alt: ["Abisi", "Bisi", "Pitti", "Riban (Ribam)"],
  cc: ["NG"]
}, {
  pk: 4970,
  ang: "Pacahuara",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Pacahuara",
  lc: "pcp",
  ld: "ltr",
  alt: ["Pacawara"],
  cc: ["BO"]
}, {
  pk: 4971,
  ang: "Pyapun",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Pyapun",
  lc: "pcw",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 4972,
  ang: "Anam",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Anam",
  lc: "pda",
  ld: "ltr",
  alt: ["Pondoma"],
  cc: ["PG"]
}, {
  pk: 4973,
  ang: "German, Pennsylvania",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Pennsylvania German",
  lc: "pdc",
  ld: "ltr",
  alt: ["Pennsylvanisch", "Pennsylvania Deitsh", "Pennsylvanish", "Amish Pennsylvania German (Plain Pennsylvania German)", "Pensylvanisch Deitsch", "Non-Amish Pennsylvania German (Non-Plain Pennsylvania German)", "Non-Amish Pennsylvania German (Pennsylvanisch Deitsch)"],
  cc: ["US", "CA"]
}, {
  pk: 4974,
  ang: "Pa Di",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Pa Di",
  lc: "pdi",
  ld: "ltr",
  alt: ["Padi"],
  cc: ["CN"]
}, {
  pk: 4975,
  ang: "Fedan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Podena",
  lc: "pdn",
  ld: "ltr",
  alt: ["Podena"],
  cc: ["ID"]
}, {
  pk: 4976,
  ang: "Padoe",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Padoe",
  lc: "pdo",
  ld: "ltr",
  alt: ["Alalao", "Pado-e", "Pado\xE9", "South Mori", "Central Padoe", "Western Padoe"],
  cc: ["ID"]
}, {
  pk: 4977,
  ang: "Plautdietsch",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Plautdietsch",
  lc: "pdt",
  ld: "ltr",
  alt: ["German", "Mennonite German", "Mennoniten Platt"],
  cc: ["BZ", "DE", "MX", "PY", "US", "BO", "CA"]
}, {
  pk: 4978,
  ang: "Kayan",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Kayan",
  lc: "pdu",
  ld: "ltr",
  alt: ["Kayang", "Lahwi", "Long-Necked Karen", "Padaung Karen", "Kayan Kangan (Yeinbaw)", "Kayan Lahwi", "Standard Pekon", "Yinbaw"],
  cc: ["TH", "MM"]
}, {
  pk: 4979,
  ang: "Indonesian, Peranakan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Peranakan Indonesian",
  lc: "pea",
  ld: "ltr",
  alt: ["Baba Indonesian", "Chinese Indonesian", "Peranakan"],
  cc: ["ID"]
}, {
  pk: 4980,
  ang: "Pomo, Eastern",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Eastern Pomo",
  lc: "peb",
  ld: "ltr",
  alt: ["Clear Lake Pomo"],
  cc: ["US"]
}, {
  pk: 4981,
  ang: "Mala",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mala (Papua New Guinea)",
  lc: "ped",
  ld: "ltr",
  alt: ["Alam", "Banara", "Dagoi", "Dagui", "Hatzfeldhafen", "Malala", "Pai", "Pay"],
  cc: ["PG"]
}, {
  pk: 4982,
  ang: "Taje",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Taje",
  lc: "pee",
  ld: "ltr",
  alt: ["Andje", "Lole", "Petapa"],
  cc: ["ID"]
}, {
  pk: 4983,
  ang: "Pomo, Northeastern",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Northeastern Pomo",
  lc: "pef",
  ld: "ltr",
  alt: ["Salt Pomo"],
  cc: ["US"]
}, {
  pk: 4984,
  ang: "Pengo",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Pengo",
  lc: "peg",
  ld: "ltr",
  alt: ["Hengo", "Pengu"],
  cc: ["IN"]
}, {
  pk: 4985,
  ang: "Bonan",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4FDD\u5B89\u8BED",
  lc: "peh",
  ld: "ltr",
  alt: ["Bao'an", "Baonan", "Boan", "Paoan", "Paongan", "Dajiahe", "Dakheczjha", "Jishishan (Dahejia)", "Tongren (Tungyen)"],
  cc: ["CN"]
}, {
  pk: 4986,
  ang: "Chichimeco-Jonaz",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Chichimeca-Jonaz",
  lc: "pei",
  ld: "ltr",
  alt: ["Meco", "Pame de Chichimeca-Jonaz"],
  cc: ["MX"]
}, {
  pk: 4987,
  ang: "Pomo, Northern",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Northern Pomo",
  lc: "pej",
  ld: "ltr",
  alt: ["Guidiville", "Sherwood Valley"],
  cc: ["US"]
}, {
  pk: 4988,
  ang: "Penchal",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Penchal",
  lc: "pek",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 4989,
  ang: "Pekal",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Pekal",
  lc: "pel",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 4990,
  ang: "Phende",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Phende",
  lc: "pem",
  ld: "ltr",
  alt: ["Gipende", "Giphende", "Pende", "Pindi", "Pinji"],
  cc: ["CD"]
}, {
  pk: 7800,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Gipende Gatundu",
  lc: "pem-x-gipendega",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 7801,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Gipende Gungu",
  lc: "pem-x-gipendegu",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 7872,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kipindi",
  lc: "pem-x-pindi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4991,
  ang: "Old Persian",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Old Persian (ca. 600-400 B.C.)",
  lc: "peo",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 4992,
  ang: "Kunja",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kunja",
  lc: "pep",
  ld: "ltr",
  alt: ["Lower Morehead", "Peremka", "Thundai-Kanza", "K\xE1m\xE1", "K\xE1nch\xE1"],
  cc: ["PG"]
}, {
  pk: 4993,
  ang: "Pomo, Southern",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Southern Pomo",
  lc: "peq",
  ld: "ltr",
  alt: ["Gallinom\xE9ro"],
  cc: ["US"]
}, {
  pk: 4994,
  ang: "Persian, Iranian",
  lr: "Asia",
  gw: true,
  hc: "IR",
  ln: "\u0641\u0627\u0631\u0633\u06CC",
  lc: "pes",
  ld: "rtl",
  alt: ["Persian", "New Persian", "Parsi", "West Persian", "Old Shirazi", "Abadani", "Yazdi", "Tehrani", "Shahrudi Kazeruni", "Mashadi (Meshed)", "Mahalhamadani", "Ketabi", "Esfahani", "Bandari", "Shirazjahromi", "Western"],
  cc: ["AZ", "AT", "BE", "GR", "AF", "FR", "DE", "IR", "IQ", "IL", "ES", "GB", "OM", "NL", "NZ", "PK", "SY", "TR", "US", "YE", "AU", "CA", "IT", "KW", "DK", "TM", "UZ", "BH", "QA", "AE"]
}, {
  pk: 4995,
  ang: "Petats",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Petats",
  lc: "pex",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7745,
  ang: "Matsungan",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Maysungan",
  lc: "pex-x-matsungan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4996,
  ang: "Petjo",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Petjo",
  lc: "pey",
  ld: "ltr",
  alt: ["Peco'", "Pecok", "Petjoh"],
  cc: ["ID"]
}, {
  pk: 4997,
  ang: "Penan, Eastern",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Eastern Penan",
  lc: "pez",
  ld: "ltr",
  alt: ["Punan", "Penan Gang (Gang)", "Penan Silat", "Penan Nibong", "Sipeng (Speng)", "Nibong (Nibon)", "Jelalong Penan", "Bok Penan (Bok)", "Penan Lusong (Lusong)", "Penan Lanying"],
  cc: ["BN", "MY"]
}, {
  pk: 8230,
  ang: "Long Iman",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Long Iman",
  lc: "pez-x-longiman",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 4998,
  ang: "P\xE1\xE1fang",
  lr: "Pacific",
  gw: false,
  hc: "FM",
  ln: "P\xE1\xE1fang",
  lc: "pfa",
  ld: "ltr",
  alt: [],
  cc: ["FM"]
}, {
  pk: 4999,
  ang: "Peere",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Peere",
  lc: "pfe",
  ld: "ltr",
  alt: ["Kotofo", "Kotopo", "Kotpojo", "Koutin", "Koutine", "Kutine", "Kutinn", "Patapori", "Peer", "Potopo", "Potopore", "Pare", "Kpotopo", "Dan Muure (Kotofo)", "Zongbi (Djonbi)"],
  cc: ["CM", "NG"]
}, {
  pk: 5000,
  ang: "Pfaelzisch",
  lr: "Europe",
  gw: false,
  hc: "DE",
  ln: "Pfaelzisch",
  lc: "pfl",
  ld: "ltr",
  alt: ["Pf\xE4lzisch", "Pf\xE4lzische"],
  cc: ["DE"]
}, {
  pk: 5001,
  ang: "Arabic, Sudanese Creole",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Sudanese Creole Arabic",
  lc: "pga",
  ld: "rtl",
  alt: ["Juba Arabic", "Pidgin Arabic", "Southern Sudan Arabic"],
  cc: ["SS", "TD"]
}, {
  pk: 5002,
  ang: "G\u0101ndh\u0101r\u012B",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "G\u0101ndh\u0101r\u012B",
  lc: "pgd",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 5003,
  ang: "Pangwali",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Pangwali",
  lc: "pgg",
  ld: "ltr",
  alt: ["Pahari", "Pangi", "Pangwali Pahari"],
  cc: ["IN"]
}, {
  pk: 5004,
  ang: "Pagi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Pagi",
  lc: "pgi",
  ld: "ltr",
  alt: ["Bembi", "Pagei", "Eastern Pagi (Imbinis)", "Western Pagi (Bewani)"],
  cc: ["PG"]
}, {
  pk: 5005,
  ang: "Rerep",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Rerep",
  lc: "pgk",
  ld: "ltr",
  alt: ["Pangkumu", "Pangkumu Bay"],
  cc: ["VU"]
}, {
  pk: 5006,
  ang: "Primitive Irish",
  lr: "Europe",
  gw: false,
  hc: "IE",
  ln: "Gaeilge \xC1rsa",
  lc: "pgl",
  ld: "ltr",
  alt: [],
  cc: ["IE"]
}, {
  pk: 5007,
  ang: "Paelignian",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Paelignian",
  lc: "pgn",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 5008,
  ang: "Pangseng",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Pangseng",
  lc: "pgs",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 5009,
  ang: "Pagu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Pagu",
  lc: "pgu",
  ld: "ltr",
  alt: ["Pago", "Pagoe", "Toliwiku (Toliliko)"],
  cc: ["ID"]
}, {
  pk: 5010,
  ang: "Pa-Hng",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Pa-Hng",
  lc: "pha",
  ld: "ltr",
  alt: ["Baheng", "Bahengmai", "Man Pa Seng", "Meo Lai", "Pa Hng", "Pa Ngng", "Pa Then", "Paheng", "T\xF3ng", "P\xE0 Hung", "P\xE0 Then", "Northern Pa-Hng", "Southern Pa-Hng"],
  cc: ["CN", "VN"]
}, {
  pk: 8170,
  ang: "Pa Than",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Pa Than",
  lc: "pha-x-pathan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5011,
  ang: "Phudagi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Phudagi",
  lc: "phd",
  ld: "ltr",
  alt: ["Vadval"],
  cc: ["IN"]
}, {
  pk: 5012,
  ang: "Phuong",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Phuong",
  lc: "phg",
  ld: "ltr",
  alt: ["Phuang", "Phuong Catang"],
  cc: ["VN"]
}, {
  pk: 5013,
  ang: "Phula",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Phukha",
  lc: "phh",
  ld: "ltr",
  alt: ["Fu Khla", "Phu Khla", "Ph\xF9 L\xE1", "Ph\xF9 L\xE1 H\xE1n", "Phu Kha", "Phu La"],
  cc: ["CN", "VN"]
}, {
  pk: 5014,
  ang: "Phake",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Phake",
  lc: "phk",
  ld: "ltr",
  alt: ["Faake", "Phakey", "Phakial"],
  cc: ["IN"]
}, {
  pk: 5015,
  ang: "Palula",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u067E\u06BE\u0627\u0644\u0648\u0644\u06C1 \u0632\u0628\u0627\u0646",
  lc: "phl",
  ld: "ltr",
  alt: ["Biyori", "Dangarikwar", "Palola", "Phalulo", "Northern Palula"],
  cc: ["PK"]
}, {
  pk: 5016,
  ang: "Phimbi",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Phimbi",
  lc: "phm",
  ld: "ltr",
  alt: ["Pimbi"],
  cc: ["MZ"]
}, {
  pk: 5017,
  ang: "Phoenician",
  lr: "Asia",
  gw: false,
  hc: "LB",
  ln: "Phoenician",
  lc: "phn",
  ld: "ltr",
  alt: [],
  cc: ["LB"]
}, {
  pk: 5018,
  ang: "Phunoi",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Phunoi",
  lc: "pho",
  ld: "ltr",
  alt: ["Phounoy", "Phu Noi", "Punoi", "Sinsali"],
  cc: ["LA", "TH"]
}, {
  pk: 8386,
  ang: "Tai He",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Tai He",
  lc: "pho-x-taihe",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5019,
  ang: "Phana\u2019",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Phana'",
  lc: "phq",
  ld: "ltr",
  alt: ["Bana'", "Pana'"],
  cc: ["CN", "LA"]
}, {
  pk: 5020,
  ang: "Pahari-Potwari",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u067E\u0648\u0679\u06BE\u0648\u0627\u0631\u06CC",
  lc: "phr",
  ld: "ltr",
  alt: ["Dhundi-Kairali", "Pothohari", "Potohari", "Potwari", "Punchhi (Poonchi)", "Pahari (Dhundi-Kairali)", "Pothwari (Potwari)"],
  cc: ["PK", "IN"]
}, {
  pk: 5021,
  ang: "Phu Thai",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Phu Thai",
  lc: "pht",
  ld: "ltr",
  alt: ["Phutai", "Putai", "Puthay", "Phuu Thai", "Puthai"],
  cc: ["LA", "TH"]
}, {
  pk: 5022,
  ang: "Phuan",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Phuan",
  lc: "phu",
  ld: "ltr",
  alt: ["Lao Phuan", "Phu Un"],
  cc: ["LA", "TH"]
}, {
  pk: 5023,
  ang: "Pahlavani",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Pahlavani",
  lc: "phv",
  ld: "ltr",
  alt: [],
  cc: ["AF"]
}, {
  pk: 5024,
  ang: "Phangduwali",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Phangduwali",
  lc: "phw",
  ld: "ltr",
  alt: ["Phangduvali", "Phangduwali Poti"],
  cc: ["NP"]
}, {
  pk: 5025,
  ang: "P\u0101li",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "\u092A\u093E\u0934\u093F",
  lc: "pi",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 5026,
  ang: "Pima Bajo",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Pima Bajo",
  lc: "pia",
  ld: "ltr",
  alt: ["Lower Piman", "Mountain Pima", "N\xE9vome", "Chihuahua Pima Bajo (Lower Piman)", "Pima del este", "Pima del norte", "Pima del sur", "Sonora Pima Bajo"],
  cc: ["MX"]
}, {
  pk: 5027,
  ang: "Yine",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Yine",
  lc: "pib",
  ld: "ltr",
  alt: ["Chontaquiro", "Contaquiro", "Pira", "Pirro", "Simiranch", "Piro", "Simirinche"],
  cc: ["PE"]
}, {
  pk: 5028,
  ang: "Pinji",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Pinji",
  lc: "pic",
  ld: "ltr",
  alt: ["Apindje", "Apindji", "Apinji", "Gapinji"],
  cc: ["GA"]
}, {
  pk: 5029,
  ang: "Piaroa",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "Piaroa",
  lc: "pid",
  ld: "ltr",
  alt: ["Adole", "Ature", "Guagua", "Kuakua", "Maco", "Quaqua Dearuwa", "Wo'tiheh", "Dearwa", "Deruwa", "Uhothha", "Uwotj\xFCja"],
  cc: ["VE", "CO"]
}, {
  pk: 5030,
  ang: "Piro",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Piro",
  lc: "pie",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 5031,
  ang: "Pingelapese",
  lr: "Pacific",
  gw: false,
  hc: "FM",
  ln: "Pingelapese",
  lc: "pif",
  ld: "ltr",
  alt: ["Pingelap", "Pingilapese"],
  cc: ["FM"]
}, {
  pk: 5032,
  ang: "Pisabo",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Pisabo",
  lc: "pig",
  ld: "ltr",
  alt: ["Pisagua", "Pisahua"],
  cc: ["PE"]
}, {
  pk: 5033,
  ang: "Pitcairn-Norfolk",
  lr: "Pacific",
  gw: false,
  hc: "NF",
  ln: "Pitcairn-Norfolk",
  lc: "pih",
  ld: "ltr",
  alt: ["Pitcairn English", "Norfolkese", "Norfolk English"],
  cc: ["AU", "PF", "NF"]
}, {
  pk: 5034,
  ang: "Pini",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Pini",
  lc: "pii",
  ld: "ltr",
  alt: ["Bini", "Birni", "Piniritjara", "Pirniritjara"],
  cc: ["AU"]
}, {
  pk: 5035,
  ang: "Yom",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Yom",
  lc: "pil",
  ld: "ltr",
  alt: ["Kpilakpila", "Pilapila", "Taneka", "Tangerem"],
  cc: ["BJ"]
}, {
  pk: 5036,
  ang: "Powhatan",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Powhatan",
  lc: "pim",
  ld: "ltr",
  alt: ["Virginia Algonkian", "Virginia Algonquian"],
  cc: ["US"]
}, {
  pk: 5037,
  ang: "Piame",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Piame",
  lc: "pin",
  ld: "ltr",
  alt: ["Biami"],
  cc: ["PG"]
}, {
  pk: 5038,
  ang: "Piapoco",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Piapoco",
  lc: "pio",
  ld: "ltr",
  alt: ["Amarizado", "Dzaze", "Enegua", "Kuipaco", "Piapoko Dej\xE1", "Wen\xE9wika", "Yapoco"],
  cc: ["VE", "CO", "US"]
}, {
  pk: 5039,
  ang: "Pipero",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Pipero",
  lc: "pip",
  ld: "ltr",
  alt: ["Filiya", "Pipero"],
  cc: ["NG"]
}, {
  pk: 5040,
  ang: "Piratapuyo",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Piratapuyo",
  lc: "pir",
  ld: "ltr",
  alt: ["Pira-Tapuya", "Uaiana", "Uaicana", "Uaikena", "Uainana", "Waikhara", "Waikino", "Waina", "Urubu-Tapuya"],
  cc: ["BR", "CO"]
}, {
  pk: 5041,
  ang: "Pijin",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Pijin",
  lc: "pis",
  ld: "ltr",
  alt: ["Neo-Solomonic", "Solomons Pidgin"],
  cc: ["FJ", "SB"]
}, {
  pk: 5042,
  ang: "Pintupi-Luritja",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Pintupi-Luritja",
  lc: "piu",
  ld: "ltr",
  alt: ["Binddibu", "Loridja", "Pintubi", "Pintupi"],
  cc: ["AU"]
}, {
  pk: 5043,
  ang: "Vaeakau-Taumako",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Pileni",
  lc: "piv",
  ld: "ltr",
  alt: ["Pilheni", "Taumako (Duff)"],
  cc: ["SB"]
}, {
  pk: 5044,
  ang: "Pimbwe",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Pimbwe",
  lc: "piw",
  ld: "ltr",
  alt: ["Cipimbwe", "Ichipimbwe", "Kipimbwe"],
  cc: ["TZ"]
}, {
  pk: 5045,
  ang: "Piu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Piu",
  lc: "pix",
  ld: "ltr",
  alt: ["Kuruko", "Lanzog", "Sanbiau"],
  cc: ["PG"]
}, {
  pk: 5046,
  ang: "Piya-Kwonci",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Piya-Kwonci",
  lc: "piy",
  ld: "ltr",
  alt: ["Ambandi", "Pia", "Pitiko", "Wurkum"],
  cc: ["NG"]
}, {
  pk: 8273,
  ang: "Wurkum",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Wurkum",
  lc: "piy-x-wurkum",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5047,
  ang: "Pije",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Pije",
  lc: "piz",
  ld: "ltr",
  alt: ["Pindje", "Pinje"],
  cc: ["NC"]
}, {
  pk: 5048,
  ang: "Pitjantjatjara",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Pitjantjatjara",
  lc: "pjt",
  ld: "ltr",
  alt: ["Pitjantjara", "Pitjantjatjara (Pithantjatjarra)", "Yankunytjatjara"],
  cc: ["AU"]
}, {
  pk: 5049,
  ang: "Ardham\u0101gadh\u012B Pr\u0101krit",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Ardham\u0101gadh\u012B Pr\u0101krit",
  lc: "pka",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 5050,
  ang: "Kipfokomo",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Pokomo",
  lc: "pkb",
  ld: "ltr",
  alt: ["Kipokomo", "Lower Pokomo", "Malachini", "Pfokomo", "Upper Pokomo"],
  cc: ["KE"]
}, {
  pk: 5051,
  ang: "Paekche",
  lr: "Asia",
  gw: false,
  hc: "KP",
  ln: "\uBC31\uC81C\uC5B4",
  lc: "pkc",
  ld: "ltr",
  alt: [],
  cc: ["KP"]
}, {
  pk: 5052,
  ang: "Pak-Tong",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Pak-Tong",
  lc: "pkg",
  ld: "ltr",
  alt: ["Tong-Pak"],
  cc: ["PG"]
}, {
  pk: 5053,
  ang: "Pangkhua",
  lr: "Asia",
  gw: false,
  hc: "BD",
  ln: "Pankhu",
  lc: "pkh",
  ld: "ltr",
  alt: ["Pankho", "Panko", "Paang", "Pang", "Pang Khua", "Pankhua", "Pankua"],
  cc: ["BD"]
}, {
  pk: 5054,
  ang: "Pakanha",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Pakanha",
  lc: "pkn",
  ld: "ltr",
  alt: ["Bakanha"],
  cc: ["AU"]
}, {
  pk: 5055,
  ang: "P\xF6koot",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "P\xF6koot",
  lc: "pko",
  ld: "ltr",
  alt: ["Pakot", "P\xF6kot", "Suk", "Pokot", "East Pokot", "West Pokot"],
  cc: ["KE", "UG"]
}, {
  pk: 5056,
  ang: "Pukapuka",
  lr: "Pacific",
  gw: false,
  hc: "CK",
  ln: "Pukapuka",
  lc: "pkp",
  ld: "ltr",
  alt: ["Bukabukan", "Pukapukan"],
  cc: ["CK", "NZ", "PF"]
}, {
  pk: 5057,
  ang: "Kurumba, Attapady",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Attapady Kurumba",
  lc: "pkr",
  ld: "ltr",
  alt: ["Kurumba", "Pal Kurumba"],
  cc: ["IN"]
}, {
  pk: 5058,
  ang: "Pakistan Sign Language",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "Pakistan Sign Language",
  lc: "pks",
  ld: "ltr",
  alt: ["Isharon Ki Zubann"],
  cc: ["PK"]
}, {
  pk: 5059,
  ang: "Maleng",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Maleng",
  lc: "pkt",
  ld: "ltr",
  alt: ["Maleng Kari", "Pakatan (Kha Pakatan)", "Malieng (Pa Leng)", "Maleng Bro", "Dan Hoa", "Kha Phong (Kha Nam Om)"],
  cc: ["LA"]
}, {
  pk: 5060,
  ang: "Paku",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Paku",
  lc: "pku",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 5061,
  ang: "Polish",
  lr: "Europe",
  gw: false,
  hc: "PL",
  ln: "j\u0119zyk polski, polszczyzna",
  lc: "pl",
  ld: "ltr",
  alt: ["Polski", "Polnisch"],
  cc: ["AT", "BR", "AR", "FR", "DE", "VE", "IL", "KZ", "ES", "GB", "CZ", "LV", "NZ", "PL", "SE", "US", "AU", "CA", "IT", "KG", "LT", "DK", "UZ", "IE", "UA"]
}, {
  pk: 5062,
  ang: "Miani",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Miani",
  lc: "pla",
  ld: "ltr",
  alt: ["Bonaputa-Mopu", "Miani North", "Tani"],
  cc: ["PG"]
}, {
  pk: 8368,
  ang: "Miani North",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Miani North",
  lc: "pla-x-mianinorth",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5063,
  ang: "Polonombauk",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Polonombauk",
  lc: "plb",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 5064,
  ang: "Palawano, Central",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Central Palawano",
  lc: "plc",
  ld: "ltr",
  alt: ["Palawanen", "Palawe\xF1o", "Quezon Palawano"],
  cc: ["PH"]
}, {
  pk: 7813,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Palawan Taot Bato",
  lc: "plc-x-taotbato",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5065,
  ang: "Polari",
  lr: "Europe",
  gw: false,
  hc: "GB",
  ln: "Polari",
  lc: "pld",
  ld: "ltr",
  alt: ["Palari", "Palarie", "Parlare", "Parlary", "Parlyaree"],
  cc: ["GB"]
}, {
  pk: 5066,
  ang: "Palu\u2019e",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Palu'e",
  lc: "ple",
  ld: "ltr",
  alt: ["Lu'a", "Paluqe"],
  cc: ["ID"]
}, {
  pk: 5067,
  ang: "Pilag\xE1",
  lr: "Americas",
  gw: false,
  hc: "AR",
  ln: "Pilag\xE1",
  lc: "plg",
  ld: "ltr",
  alt: ["Pilaca", "Chaco Pilag\xE1 (Toba Sur)", "Toba del Oeste", "Toba-Pilag\xE1 (Sombrero Negro)"],
  cc: ["AR", "PY"]
}, {
  pk: 5068,
  ang: "Paulohi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Paulohi",
  lc: "plh",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 5069,
  ang: "Polci",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Polci",
  lc: "plj",
  ld: "ltr",
  alt: ["Palchi", "Palci", "Polchi", "Langas (Lundur)", "Posa", "Polshi", "Polci (Palci)", "Nyamzax", "Zul (Barma)", "Dra", "Dir (Baram Dutse)", "Diir", "Baram (Barang)", "Mbarmi", "Mbaram"],
  cc: ["NG"]
}, {
  pk: 5070,
  ang: "Shina, Kohistani",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u0634\u06CC\u0646\u0627 \u0632\u0628\u0627\u0646",
  lc: "plk",
  ld: "ltr",
  alt: ["Kohistani", "Kohistyo", "Palasi-Kohistani"],
  cc: ["PK"]
}, {
  pk: 5071,
  ang: "Palaung, Shwe",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Shwe Palaung",
  lc: "pll",
  ld: "ltr",
  alt: ["Golden Palaung", "Liang Palaung", "Shwe", "Liang", "Red Da'ang", "Shwe Palaung", "Ta-Ang Palaung", "Ta'ang Samlung", "Ywama"],
  cc: ["CN", "MM"]
}, {
  pk: 5072,
  ang: "Palenquero",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Palenquero",
  lc: "pln",
  ld: "ltr",
  alt: ["Lengua", "Palenque"],
  cc: ["CO"]
}, {
  pk: 5073,
  ang: "Popoluca, Oluta",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Oluta Popoluca",
  lc: "plo",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 5074,
  ang: "Palaic",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Palaic",
  lc: "plq",
  ld: "ltr",
  alt: [],
  cc: ["TR"]
}, {
  pk: 5075,
  ang: "S\xE9noufo, Palaka",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Palaka Senoufo",
  lc: "plr",
  ld: "ltr",
  alt: ["Kpalagha", "Palaka", "Palara", "Pallakha", "Pilara"],
  cc: ["CI"]
}, {
  pk: 5076,
  ang: "Popoloca, San Marcos Tlacoyalco",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "San Marcos Tlacoyalco Popoloca",
  lc: "pls",
  ld: "ltr",
  alt: ["Northern Popoloca", "Popoloca de San Marcos Tlalcoyalco", "Popoluca del Norte"],
  cc: ["MX"]
}, {
  pk: 5077,
  ang: "Malagasy, Plateau",
  lr: "Africa",
  gw: true,
  hc: "MG",
  ln: "Plateau Malagasy",
  lc: "plt",
  ld: "ltr",
  alt: ["Malgache", "Official Malagasy", "Plateau Malagasy", "Standard Malagasy", "Vakinankaritra", "Merina"],
  cc: ["KM", "FR", "MG", "MU", "US", "CA", "YT"]
}, {
  pk: 7931,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "MG",
  ln: "Ikongo Tanala",
  lc: "plt-x-ikongotanala",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7933,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "MG",
  ln: "Southern Betsileo",
  lc: "plt-x-sbetsileo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7730,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "MG",
  ln: "Sihanaka",
  lc: "plt-x-sihanaka",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7930,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "MG",
  ln: "Tanala",
  lc: "plt-x-tanala",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7932,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "MG",
  ln: "Zafimaniry",
  lc: "plt-x-zafimaniry",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5078,
  ang: "Palik\xFAr",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Palik\xFAr",
  lc: "plu",
  ld: "ltr",
  alt: ["Paikwene", "Palicur", "Palijur", "Palikour", "Palincur", "Paricores", "Paricuria", "Parikurene", "Parinkur-lene"],
  cc: ["BR", "GF"]
}, {
  pk: 5079,
  ang: "Palawano, Southwest",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Southwest Palawano",
  lc: "plv",
  ld: "ltr",
  alt: [],
  cc: ["PH"]
}, {
  pk: 7678,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Tao't Bato",
  lc: "plv-x-taotba",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5080,
  ang: "Palawano, Brooke\u2019s Point",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Brooke's Point Palawano",
  lc: "plw",
  ld: "ltr",
  alt: ["Brooke's Point Palawan", "Palawan", "Palawanun", "Palawe\xF1o", "South Palawano (Bugsuk Palawano)"],
  cc: ["PH"]
}, {
  pk: 5081,
  ang: "Bolyu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5DF4\u7409\u8BED",
  lc: "ply",
  ld: "ltr",
  alt: ["Baliu", "Lai", "Lailai", "Paliu", "Palju", "Polyu"],
  cc: ["CN"]
}, {
  pk: 5082,
  ang: "Paluan",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Paluan",
  lc: "plz",
  ld: "ltr",
  alt: ["Paluan (Peluan)", "Pandewan (Pandewan Murut)", "Makaheeliga (Makialiga)"],
  cc: ["MY"]
}, {
  pk: 5083,
  ang: "Paama",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Paama",
  lc: "pma",
  ld: "ltr",
  alt: ["Paama-Lopevi", "Paamese", "Pauma"],
  cc: ["VU"]
}, {
  pk: 5084,
  ang: "Pambia",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Pambia",
  lc: "pmb",
  ld: "ltr",
  alt: ["Apambia"],
  cc: ["CD"]
}, {
  pk: 5085,
  ang: "Pwaamei",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Pwaamei",
  lc: "pme",
  ld: "ltr",
  alt: ["Poamei", "Pwamei", "Hnaaka", "Yaak (Zaak)"],
  cc: ["NC"]
}, {
  pk: 5086,
  ang: "Pamona",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Pamona",
  lc: "pmf",
  ld: "ltr",
  alt: ["Baree", "Bare'e", "Poso", "Tobalo", "Tobao", "Tobau (Bare'e)", "Taa (Topotaa)", "Laiwonu (Iba)", "Rapangkaka (Aria)"],
  cc: ["ID"]
}, {
  pk: 7826,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Wana",
  lc: "pmf-x-wana",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5087,
  ang: "M\u0101h\u0101r\u0101\u1E63\u1E6Dri Pr\u0101krit",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "\u092E\u0939\u093E\u0930\u093E\u0937\u094D\u091F\u094D\u0930\u0940 \u092A\u094D\u0930\u093E\u0915\u0943\u0924",
  lc: "pmh",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 5088,
  ang: "Pumi, Northern",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u666E\u7C73\u8BED",
  lc: "pmi",
  ld: "ltr",
  alt: ["Ch'rame", "Pimi", "P'\xF6mi", "Primmi", "P'rome", "Pruumi", "P'umi"],
  cc: ["CN"]
}, {
  pk: 5089,
  ang: "Pumi, Southern",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5357\u666E\u7C73\u8BED",
  lc: "pmj",
  ld: "ltr",
  alt: ["Pimi", "P'\xF6mi", "Primmi", "P'rome", "Pruumi", "P'umi"],
  cc: ["CN"]
}, {
  pk: 5090,
  ang: "Pamlico",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Pamlico",
  lc: "pmk",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 5091,
  ang: "Pol",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Pomo",
  lc: "pmm",
  ld: "ltr",
  alt: ["Congo Pol", "Pori", "Pul", "Azom (Asom)", "Pori Asom", "Pori Kinda (Kinda)"],
  cc: ["CM", "CG"]
}, {
  pk: 5092,
  ang: "Pam",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Pam",
  lc: "pmn",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 5093,
  ang: "Pom",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Pom",
  lc: "pmo",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 8344,
  ang: "Miosindi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Miosindi",
  lc: "pmo-x-miosindi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8342,
  ang: "Serewen",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Serewen",
  lc: "pmo-x-serewen",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5094,
  ang: "Pame, Northern",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Northern Pame",
  lc: "pmq",
  ld: "ltr",
  alt: ["Pame del Norte", "Xi'iuy"],
  cc: ["MX"]
}, {
  pk: 5095,
  ang: "Paynamar",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Paynamar",
  lc: "pmr",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5096,
  ang: "Piemontese",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Piemontese",
  lc: "pms",
  ld: "ltr",
  alt: ["Piedmontese", "Piemont\xE8is", "High Piemontese (Alto Piemontese)", "Low Piemontese (Basso Piemontese)"],
  cc: ["IT"]
}, {
  pk: 5097,
  ang: "Tuamotuan",
  lr: "Pacific",
  gw: false,
  hc: "PF",
  ln: "Tuamotuan",
  lc: "pmt",
  ld: "ltr",
  alt: ["Pa'umotu", "Fangatau (Tupitimoake)", "Parata (Putahi)"],
  cc: ["PF"]
}, {
  pk: 5098,
  ang: "Miwok, Plains",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Plains Miwok",
  lc: "pmw",
  ld: "ltr",
  alt: ["Valley Miwok"],
  cc: ["US"]
}, {
  pk: 5099,
  ang: "Naga, Poumei",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Poumei Naga",
  lc: "pmx",
  ld: "ltr",
  alt: ["Paumei", "Pomai", "Pome", "Poumei"],
  cc: ["IN"]
}, {
  pk: 5100,
  ang: "Malay, Papuan",
  lr: "Asia",
  gw: true,
  hc: "ID",
  ln: "Papuan Malay",
  lc: "pmy",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 5101,
  ang: "Penan, Bah-Biau",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Punan Bah-Biau",
  lc: "pna",
  ld: "ltr",
  alt: ["Bah-Biau", "Punan", "Punan Bah (Punan Ba)"],
  cc: ["MY"]
}, {
  pk: 7874,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Punan Halanga",
  lc: "pna-x-punanhalanga",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5102,
  ang: "Punjabi, Western",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u0644\u06C1\u0646\u062F\u0627 \u067E\u0646\u062C\u0627\u0628\u06CC",
  lc: "pnb",
  ld: "ltr",
  alt: ["Hindki", "Lahanda", "Lahnda", "Lahndi", "Western Punjabi", "Lahori"],
  cc: ["BE", "FR", "GB", "PK", "LY", "IN"]
}, {
  pk: 5103,
  ang: "Pannei",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Pannei",
  lc: "pnc",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 5104,
  ang: "Penan, Western",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Western Penan",
  lc: "pne",
  ld: "ltr",
  alt: ["Nibon", "Punan", "Penan Gang (Gang)", "Penan Lusong (Lusong)", "Bok Penan (Bok)", "Sipeng (Speng)"],
  cc: ["MY"]
}, {
  pk: 5105,
  ang: "Pangu",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Pongu",
  lc: "png",
  ld: "ltr",
  alt: ["Arringeu", "Pongo", "Pongu", "Tarin", "Waga"],
  cc: ["NG"]
}, {
  pk: 5106,
  ang: "Penrhyn",
  lr: "Pacific",
  gw: false,
  hc: "CK",
  ln: "Penrhyn",
  lc: "pnh",
  ld: "ltr",
  alt: ["Mangarongaro", "Penrhynese", "Tongareva"],
  cc: ["CK"]
}, {
  pk: 5107,
  ang: "Aoheng",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Aoheng",
  lc: "pni",
  ld: "ltr",
  alt: ["Penihing"],
  cc: ["ID"]
}, {
  pk: 5108,
  ang: "Paunaka",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Paunaka",
  lc: "pnk",
  ld: "ltr",
  alt: ["Pauna"],
  cc: ["BO"]
}, {
  pk: 5109,
  ang: "Paleni",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Paleni",
  lc: "pnl",
  ld: "ltr",
  alt: [],
  cc: ["BF"]
}, {
  pk: 5110,
  ang: "Punan Batu 1",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Punan Batu 1",
  lc: "pnm",
  ld: "ltr",
  alt: [],
  cc: ["MY"]
}, {
  pk: 5111,
  ang: "Pinai-Hagahai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Pinai-Hagahai",
  lc: "pnn",
  ld: "ltr",
  alt: ["Aramo", "Hagahai", "Miamia", "Pinaye", "Wapi"],
  cc: ["PG"]
}, {
  pk: 5112,
  ang: "Pancana",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Pancana",
  lc: "pnp",
  ld: "ltr",
  alt: ["Pantjana", "Kalende (Lawele)", "Kapontori (Akido)"],
  cc: ["ID"]
}, {
  pk: 5113,
  ang: "Pana",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Pana (Burkina Faso)",
  lc: "pnq",
  ld: "ltr",
  alt: ["Sama", "Pana North"],
  cc: ["BF", "ML"]
}, {
  pk: 5114,
  ang: "Panim",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Panim",
  lc: "pnr",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5115,
  ang: "Ponosakan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ponosakan",
  lc: "pns",
  ld: "ltr",
  alt: ["Ponasakan"],
  cc: ["ID"]
}, {
  pk: 5116,
  ang: "Pontic",
  lr: "Europe",
  gw: false,
  hc: "GR",
  ln: "Pontic",
  lc: "pnt",
  ld: "ltr",
  alt: ["Pontic Greek"],
  cc: ["GR"]
}, {
  pk: 5117,
  ang: "Bunu, Jiongnai",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u70AF\u5948",
  lc: "pnu",
  ld: "ltr",
  alt: ["Hualan Yao", "Jiongnai", "Jiongnaihua", "Kiong Nai", "Punu", "Qiungnai"],
  cc: ["CN"]
}, {
  pk: 5118,
  ang: "Pinigura",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Pinigura",
  lc: "pnv",
  ld: "ltr",
  alt: ["Binigura", "Pinikura"],
  cc: ["AU"]
}, {
  pk: 5119,
  ang: "Panytyima",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Panytyima",
  lc: "pnw",
  ld: "ltr",
  alt: ["Bandjima", "Banjima", "Pandjima", "Panjima", "Panjtjima", "Panyjima"],
  cc: ["AU"]
}, {
  pk: 5120,
  ang: "Phong-Kniang",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Phong-Kniang",
  lc: "pnx",
  ld: "ltr",
  alt: ["Keneng", "Kenieng", "Khaniang", "Lao Phong", "Pong 3"],
  cc: ["LA"]
}, {
  pk: 5121,
  ang: "Pinyin",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Pinyin",
  lc: "pny",
  ld: "ltr",
  alt: ["Bapinyi", "Pelimpo"],
  cc: ["CM"]
}, {
  pk: 5122,
  ang: "Pana",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Pana",
  lc: "pnz",
  ld: "ltr",
  alt: [],
  cc: ["CF", "TD"]
}, {
  pk: 5123,
  ang: "Poqomam",
  lr: "Americas",
  gw: false,
  hc: "GT",
  ln: "Poqomam",
  lc: "poc",
  ld: "ltr",
  alt: ["Pocom\xE1n", "Pokomam", "Eastern Poqomam", "Southern Poqomam (Pal\xEDn Pocomam)", "Central Poqomam"],
  cc: ["GT"]
}, {
  pk: 5124,
  ang: "Popoloca, San Juan Atzingo",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "San Juan Atzingo Popoloca",
  lc: "poe",
  ld: "ltr",
  alt: ["Atzingo Popoloca", "Eastern Popoloca", "Ngigua", "Popoloca de San Juan Atzingo", "Popoloca del Oriente", "Southern Popoloca"],
  cc: ["MX"]
}, {
  pk: 5125,
  ang: "Poke",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Poke",
  lc: "pof",
  ld: "ltr",
  alt: ["Puki", "Tofoke", "Topoke", "Tovoke"],
  cc: ["CD"]
}, {
  pk: 5126,
  ang: "Potigu\xE1ra",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Potigu\xE1ra",
  lc: "pog",
  ld: "ltr",
  alt: ["Pitonara"],
  cc: ["BR"]
}, {
  pk: 5127,
  ang: "Poqomchi\u2019",
  lr: "Americas",
  gw: false,
  hc: "GT",
  ln: "Poqomchi'",
  lc: "poh",
  ld: "ltr",
  alt: ["Pocomch\xED", "Poconch\xED", "Pokomch\xED", "Pokonch\xED", "Tactic Pokomch\xED", "Santa Cruz Verapaz Poqomchi", "Western Poqomchi", "Eastern Poqomchi"],
  cc: ["GT"]
}, {
  pk: 5128,
  ang: "Popoluca, Highland",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Highland Popoluca",
  lc: "poi",
  ld: "ltr",
  alt: ["Popoluca de la Sierra"],
  cc: ["MX"]
}, {
  pk: 5129,
  ang: "Pokang\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Pokang\xE1",
  lc: "pok",
  ld: "ltr",
  alt: ["Bar\xE1", "Bara Sona", "Barasano", "Bar\xE1-Tukano", "Pakang", "Pokang\xE1-Tapuya", "Waip\xEDn\xF5mak\xE3"],
  cc: ["BR"]
}, {
  pk: 5130,
  ang: "Pomo, Southeastern",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Southeastern Pomo",
  lc: "pom",
  ld: "ltr",
  alt: ["Lower Lake Pomo"],
  cc: ["US"]
}, {
  pk: 5131,
  ang: "Pohnpeian",
  lr: "Pacific",
  gw: false,
  hc: "FM",
  ln: "Pohnpeian",
  lc: "pon",
  ld: "ltr",
  alt: [],
  cc: ["US", "FM"]
}, {
  pk: 5132,
  ang: "Pomo, Central",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Central Pomo",
  lc: "poo",
  ld: "ltr",
  alt: ["Ballo-Kai-Pomo", "Cabanapo", "Habenapo", "H'hana", "K\xE1binapek", "Khabenapo", "Khana", "Kulanapan", "Kulanapo", "Venaambakaia", "Venambakaiia", "Yokaia"],
  cc: ["US"]
}, {
  pk: 5133,
  ang: "Pwapw\xE2",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Pwapw\xE2",
  lc: "pop",
  ld: "ltr",
  alt: ["Poapoa"],
  cc: ["NC"]
}, {
  pk: 5134,
  ang: "Popoluca, Texistepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Texistepec Popoluca",
  lc: "poq",
  ld: "ltr",
  alt: ["Texistepec"],
  cc: ["MX"]
}, {
  pk: 5135,
  ang: "Popoluca, Sayula",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Sayula Popoluca",
  lc: "pos",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 5136,
  ang: "Potawatomi",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Potawatomi",
  lc: "pot",
  ld: "ltr",
  alt: ["Pottawottomi", "Pottawotomi"],
  cc: ["US", "CA"]
}, {
  pk: 5137,
  ang: "Crioulo, Upper Guinea",
  lr: "Africa",
  gw: false,
  hc: "GW",
  ln: "Upper Guinea Crioulo",
  lc: "pov",
  ld: "ltr",
  alt: ["Guinea-Bissau Creole", "Kiryol", "Kriulo", "Portuguese Creole"],
  cc: ["GM", "NL", "SN", "GW"]
}, {
  pk: 5138,
  ang: "Popoloca, San Felipe Otlaltepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "San Felipe Otlaltepec Popoloca",
  lc: "pow",
  ld: "ltr",
  alt: ["Popoloca de San Felipe Otlaltepec", "Popoloca del Poniente", "Western Popoloca", "Huejonapan", "Santa Mar\xEDa Nativitas"],
  cc: ["MX"]
}, {
  pk: 5139,
  ang: "Polabian",
  lr: "Europe",
  gw: false,
  hc: "PL",
  ln: "J\u0119zyk po\u0142abski",
  lc: "pox",
  ld: "ltr",
  alt: [],
  cc: ["PL"]
}, {
  pk: 5140,
  ang: "Pogolo",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Pogolo",
  lc: "poy",
  ld: "ltr",
  alt: ["Chipogolo", "Chipogoro", "Pogolu", "Pogora", "Shpogolu"],
  cc: ["TZ"]
}, {
  pk: 5141,
  ang: "Pao",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Pao",
  lc: "ppa",
  ld: "ltr",
  alt: ["Pabra"],
  cc: ["IN"]
}, {
  pk: 5142,
  ang: "Papi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Papi",
  lc: "ppe",
  ld: "ltr",
  alt: ["Paupe"],
  cc: ["PG"]
}, {
  pk: 5143,
  ang: "Paipai",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Paipai",
  lc: "ppi",
  ld: "ltr",
  alt: ["Akwa'ala"],
  cc: ["MX"]
}, {
  pk: 5144,
  ang: "Uma",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Uma",
  lc: "ppk",
  ld: "ltr",
  alt: ["Koro", "Oema", "Pipikoro", "Tolee' (Eastern Uma)", "Kantewu (Central Uma)", "Winatu (Northern Uma)", "Western Uma", "Benggaulu (Bingkolu)", "Ompa", "Southern Uma (Aria)", "Tobaku (Dompa)"],
  cc: ["ID"]
}, {
  pk: 5145,
  ang: "Pipil",
  lr: "Americas",
  gw: false,
  hc: "SV",
  ln: "Pipil",
  lc: "ppl",
  ld: "ltr",
  alt: ["Nahuat", "Nawat", "Nicarao"],
  cc: ["SV"]
}, {
  pk: 5146,
  ang: "Papuma",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Papuma",
  lc: "ppm",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 5147,
  ang: "Papapana",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Papapana",
  lc: "ppn",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5148,
  ang: "Folopa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Folopa",
  lc: "ppo",
  ld: "ltr",
  alt: ["Foraba", "Podoba", "Podopa", "Bara (Harahu)", "Harahui", "Mamisa", "Ro (Keai)", "Sesa (Ibukairu)", "Songu", "Suri", "Worugl"],
  cc: ["PG"]
}, {
  pk: 5149,
  ang: "Pelende",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Pelende",
  lc: "ppp",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 5150,
  ang: "Pei",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Pei",
  lc: "ppq",
  ld: "ltr",
  alt: ["Pai"],
  cc: ["PG"]
}, {
  pk: 5151,
  ang: "Popoloca, San Lu\xEDs Temalacayuca",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "San Lu\xEDs Temalacayuca Popoloca",
  lc: "pps",
  ld: "ltr",
  alt: ["Popoloca de San Luis Temalacayuca"],
  cc: ["MX"]
}, {
  pk: 5152,
  ang: "Pare",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Pare",
  lc: "ppt",
  ld: "ltr",
  alt: ["Akium-Pare"],
  cc: ["PG"]
}, {
  pk: 5153,
  ang: "Pa\u2019a",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Pa'a",
  lc: "pqa",
  ld: "ltr",
  alt: ["Afa", "Afanci", "Fa'awa", "Foni", "Fucaka", "Pa'awa", "Pala"],
  cc: ["NG"]
}, {
  pk: 5154,
  ang: "Malecite-Passamaquoddy",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Malecite-Passamaquoddy",
  lc: "pqm",
  ld: "ltr",
  alt: ["Maliseet-Passamaquoddy", "Malecite (Maliseet)"],
  cc: ["US", "CA"]
}, {
  pk: 5155,
  ang: "Lua\u2019",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Lua'",
  lc: "prb",
  ld: "ltr",
  alt: ["East Pua Pray", "Pray 2"],
  cc: ["TH"]
}, {
  pk: 5156,
  ang: "Parachi",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Parachi",
  lc: "prc",
  ld: "ltr",
  alt: ["Pachaghan", "Shutul"],
  cc: ["AF"]
}, {
  pk: 5157,
  ang: "Parsi-Dari",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Parsi-Dari",
  lc: "prd",
  ld: "ltr",
  alt: ["Parsee", "Parsee-Dari", "Parsi"],
  cc: ["IR"]
}, {
  pk: 5158,
  ang: "Principense",
  lr: "Africa",
  gw: false,
  hc: "ST",
  ln: "Principense",
  lc: "pre",
  ld: "ltr",
  alt: ["Lun'gwiye", "Monc\xF3"],
  cc: ["ST"]
}, {
  pk: 5159,
  ang: "Paranan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Paranan",
  lc: "prf",
  ld: "ltr",
  alt: ["Palanenyo"],
  cc: ["PH"]
}, {
  pk: 5160,
  ang: "Prussian",
  lr: "Europe",
  gw: false,
  hc: "PL",
  ln: "Prussian",
  lc: "prg",
  ld: "ltr",
  alt: ["Old Prussian"],
  cc: ["PL"]
}, {
  pk: 5161,
  ang: "Porohanon",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Porohanon",
  lc: "prh",
  ld: "ltr",
  alt: ["Camotes"],
  cc: ["PH"]
}, {
  pk: 5162,
  ang: "Paic\xEE",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Paic\xEE",
  lc: "pri",
  ld: "ltr",
  alt: ["Ci", "Paaci", "Pati", "Ponerihouen"],
  cc: ["NC"]
}, {
  pk: 5163,
  ang: "Wa, Parauk",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Parauk",
  lc: "prk",
  ld: "ltr",
  alt: ["Baraog", "Baroke", "Buliu", "Bulu", "Burao", "Phalok", "Praok", "Standard Wa", "Kawn Mau", "Kok Lah", "Khui Ma", "Kha Lax", "Kawng Lang", "Ien", "Kawn Poih", "La Dah", "Kawn Jiem", "Kawn Cawng", "Kaung Sang", "Kang Seu", "Ang Krax", "Kawn Rao", "Ai Cheung", "Ai Swa", "Hom", "Alwa", "Awm Plawk", "Banhong", "Bible Wa", "Caong Naong", "Cuan", "Dazhai", "Aishuai"],
  cc: ["CN", "MM"]
}, {
  pk: 5164,
  ang: "Peruvian Sign Language",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Peruvian Sign Language",
  lc: "prl",
  ld: "ltr",
  alt: [],
  cc: ["PE"]
}, {
  pk: 5165,
  ang: "Kibiri",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kibiri",
  lc: "prm",
  ld: "ltr",
  alt: ["Gibiri", "Polome", "Aird Hills (Kibiri)"],
  cc: ["PG"]
}, {
  pk: 5166,
  ang: "Prasuni",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "V\xE2s\u2019i-vari",
  lc: "prn",
  ld: "ltr",
  alt: ["Parun", "Prasun", "Veron", "Verou", "Veruni", "Wasi-Veri", "Ushut", "Lower Prasun (Pashki)", "Upper Wasi-Weri (Ishtivi)"],
  cc: ["AF"]
}, {
  pk: 5167,
  ang: "Old Proven\xE7al (to 1500)",
  lr: "Europe",
  gw: false,
  hc: "FR",
  ln: "Occitan ancian",
  lc: "pro",
  ld: "ltr",
  alt: [],
  cc: ["FR"]
}, {
  pk: 5168,
  ang: "Parsi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Parsi",
  lc: "prp",
  ld: "ltr",
  alt: ["Parsee"],
  cc: ["GB", "IN"]
}, {
  pk: 5169,
  ang: "Ash\xE9ninka Peren\xE9",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Ash\xE9ninka Peren\xE9",
  lc: "prq",
  ld: "ltr",
  alt: ["Ash\xE9ninca Peren\xE9", "Peren\xE9 Campa"],
  cc: ["PE"]
}, {
  pk: 5170,
  ang: "Dari",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "\u062F\u0631\u06CC",
  lc: "prs",
  ld: "ltr",
  alt: ["Afghan Persian", "East Farsi", "Farsi", "Parsi", "Persian", "Tajik", "Tajiki", "Badakhshi", "Madaglashti", "Tangshew (Tangshuri)"],
  cc: ["BE", "AF", "FR", "DE", "IR", "GB", "NL", "PK", "US", "CA", "IT", "AE"]
}, {
  pk: 5171,
  ang: "Prai",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Phai",
  lc: "prt",
  ld: "ltr",
  alt: ["Lao Mai", "Thin", "Ban Wen", "Pray 3"],
  cc: ["LA", "TH"]
}, {
  pk: 5172,
  ang: "Puragi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Puragi",
  lc: "pru",
  ld: "ltr",
  alt: ["Mogao"],
  cc: ["ID"]
}, {
  pk: 5173,
  ang: "Parawen",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Parawen",
  lc: "prw",
  ld: "ltr",
  alt: ["Para"],
  cc: ["PG"]
}, {
  pk: 5174,
  ang: "Purik",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Purik",
  lc: "prx",
  ld: "ltr",
  alt: ["Burig", "Burigskat", "Purigskad", "Purik Bhotia", "Purki"],
  cc: ["CN", "IN"]
}, {
  pk: 5176,
  ang: "Providencia Sign Language",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Providencia Sign Language",
  lc: "prz",
  ld: "ltr",
  alt: [],
  cc: ["CO"]
}, {
  pk: 5177,
  ang: "Pashto, Pushto",
  lr: "Asia",
  gw: true,
  hc: "AF",
  ln: "\u067E\u069A\u062A\u0648",
  lc: "ps",
  ld: "rtl",
  alt: [],
  cc: ["AF"]
}, {
  pk: 5178,
  ang: "Awyu, Asue",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Asue Awyu",
  lc: "psa",
  ld: "ltr",
  alt: ["Miaro", "Miaro Awyu", "Pisa"],
  cc: ["ID"]
}, {
  pk: 5179,
  ang: "Persian Sign Language",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Persian Sign Language",
  lc: "psc",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 5180,
  ang: "Plains Indian Sign Language",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Plains Indian Sign Language",
  lc: "psd",
  ld: "ltr",
  alt: ["Plains Sign Language", "Far Northern Plains Indian Sign Language", "North Central Plains Indian Sign Language"],
  cc: ["US"]
}, {
  pk: 5181,
  ang: "Malay, Central",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Central Malay",
  lc: "pse",
  ld: "ltr",
  alt: ["Besemah", "Midden Maleisch", "Kisam", "Semenda", "Lematang Ulu", "Kikim", "Benakat", "Rambang"],
  cc: ["ID"]
}, {
  pk: 7542,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bengkulu",
  lc: "pse-x-bengkulu",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 7647,
  ang: "Suku Original",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Suku Asli",
  lc: "pse-x-riauasli",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7541,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Serawai",
  lc: "pse-x-serawai",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 5182,
  ang: "Penang Sign Language",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Penang Sign Language",
  lc: "psg",
  ld: "ltr",
  alt: [],
  cc: ["MY"]
}, {
  pk: 5183,
  ang: "Pashai, Southwest",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Southwest Pashai",
  lc: "psh",
  ld: "ltr",
  alt: ["Pashai"],
  cc: ["AF"]
}, {
  pk: 5184,
  ang: "Pashai, Southeast",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Southeast Pashai",
  lc: "psi",
  ld: "ltr",
  alt: ["Pashai"],
  cc: ["AF"]
}, {
  pk: 5185,
  ang: "Puerto Rican Sign Language",
  lr: "Americas",
  gw: false,
  hc: "PR",
  ln: "Puerto Rican Sign Language",
  lc: "psl",
  ld: "ltr",
  alt: ["PRSL"],
  cc: ["PR"]
}, {
  pk: 5186,
  ang: "Pauserna",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Pauserna",
  lc: "psm",
  ld: "ltr",
  alt: ["Guarayu-Ta", "Paucerne", "Pauserna-Guarasugw\xE9"],
  cc: ["BO"]
}, {
  pk: 5187,
  ang: "Panasuan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Panasuan",
  lc: "psn",
  ld: "ltr",
  alt: ["To Pamosean", "To Panasean"],
  cc: ["ID"]
}, {
  pk: 5188,
  ang: "Polish Sign Language",
  lr: "Europe",
  gw: false,
  hc: "PL",
  ln: "Polish Sign Language",
  lc: "pso",
  ld: "ltr",
  alt: [],
  cc: ["PL"]
}, {
  pk: 5189,
  ang: "Philippine Sign Language",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Philippine Sign Language",
  lc: "psp",
  ld: "ltr",
  alt: ["Filipino Sign Language", "FSL", "Local Sign Language"],
  cc: ["PH"]
}, {
  pk: 5190,
  ang: "Pasi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Pasi",
  lc: "psq",
  ld: "ltr",
  alt: ["Besi"],
  cc: ["PG"]
}, {
  pk: 5191,
  ang: "Portuguese Sign Language",
  lr: "Europe",
  gw: false,
  hc: "PT",
  ln: "Portuguese Sign Language",
  lc: "psr",
  ld: "ltr",
  alt: ["Lingua Gestual Portuguesa"],
  cc: ["PT"]
}, {
  pk: 5192,
  ang: "Kaulong",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kaulong",
  lc: "pss",
  ld: "ltr",
  alt: ["Kowlong", "Pasismanua"],
  cc: ["PG"]
}, {
  pk: 5193,
  ang: "Pashto, Central",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u0645\u0646\u0681\u0646\u06CD \u067E\u069A\u062A\u0648",
  lc: "pst",
  ld: "ltr",
  alt: ["Bannu", "Bannuchi (Bannochi)", "Waciri (Waziri)"],
  cc: ["PK"]
}, {
  pk: 5194,
  ang: "Sauraseni Pr\u0101krit",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "\u015Aaurasen\u012B Pr\u0101k\u1E5Bt",
  lc: "psu",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 5195,
  ang: "Port Sandwich",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Port Sandwich",
  lc: "psw",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 5196,
  ang: "Portuguese",
  lr: "Europe",
  gw: true,
  hc: "PT",
  ln: "portugu\xEAs",
  lc: "pt",
  ld: "ltr",
  alt: ["Portugu\xEAs", "Alentejan (Alentejano)", "Minhotan (Minhoto)", "Uruguayan Portuguese", "Transmontan (Transmontano)", "Portu\xF1ol", "Portunhol", "Madeirese (Madeirense)", "Brazilian Portuguese", "Beiran (Beir\xE3o)", "Algarvian (Algarvio)", "Azorean (A\xE7oriano)"],
  cc: ["PT"]
}, {
  pk: 5197,
  ang: "Pai Tavytera",
  lr: "Americas",
  gw: false,
  hc: "PY",
  ln: "Pai Tavytera",
  lc: "pta",
  ld: "ltr",
  alt: ["Ava", "Pai", "Tavytera"],
  cc: ["PY"]
}, {
  pk: 4,
  ang: "Brazilian Portuguese",
  lr: "Americas",
  gw: true,
  hc: "BR",
  ln: "Portugu\xEAs",
  lc: "pt-br",
  ld: "ltr",
  alt: ["Portugu\xEAs", "Alentejan (Alentejano)", "Minhotan (Minhoto)", "Uruguayan Portuguese", "Transmontan (Transmontano)", "Portu\xF1ol", "Portunhol", "Madeirese (Madeirense)", "Brazilian Portuguese", "Beiran (Beir\xE3o)", "Algarvian (Algarvio)", "Azorean (A\xE7oriano)"],
  cc: ["AT", "BE", "BR", "AR", "FR", "GF", "DE", "VE", "GY", "IL", "JE", "ES", "GB", "VC", "JM", "MZ", "NL", "PY", "AD", "ZA", "CH", "SN", "US", "ZM", "ZW", "AU", "CG", "BO", "CA", "AO", "GW", "IT", "LU", "MW", "PT", "SR"]
}, {
  pk: 5198,
  ang: "Patax\xF3 H\xE3-Ha-H\xE3e",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Patax\xF3 H\xE3-Ha-H\xE3e",
  lc: "pth",
  ld: "ltr",
  alt: ["Patash\xF3", "Pataxi", "Patax\xF3", "Patax\xF3-H\xE3ha\xE3i", "Patox\xF3"],
  cc: ["BR"]
}, {
  pk: 5199,
  ang: "Pintiini",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Pintiini",
  lc: "pti",
  ld: "ltr",
  alt: ["Pindiini", "Wangada", "Wanggaji", "Wangkatja", "Wonga", "Wongai-I", "Wonggaii"],
  cc: ["AU"]
}, {
  pk: 5200,
  ang: "Patani",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Patani",
  lc: "ptn",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 5201,
  ang: "Zo\u2019\xE9",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Zo'\xE9",
  lc: "pto",
  ld: "ltr",
  alt: ["Bur\xE9", "Poturujara", "Putur\xFA", "Tup\xED of Cuminapanema"],
  cc: ["BR"]
}, {
  pk: 5202,
  ang: "Patep",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Patep",
  lc: "ptp",
  ld: "ltr",
  alt: ["Ptep"],
  cc: ["PG"]
}, {
  pk: 5203,
  ang: "Pattapu",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Pattapu",
  lc: "ptq",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 5204,
  ang: "Piamatsina",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Piamatsina",
  lc: "ptr",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 5205,
  ang: "Enrekang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Enrekang",
  lc: "ptt",
  ld: "ltr",
  alt: ["Endekan", "Endekan Timur", "Pattinjo (Letta-Batulappa-Kassa)"],
  cc: ["ID"]
}, {
  pk: 5206,
  ang: "Bambam",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bambam",
  lc: "ptu",
  ld: "ltr",
  alt: ["Pitu Uluna Salu", "Pitu-Ulunna-Salu", "Pattae'", "Salu Mokanam", "Bambam Hulu", "Mehalaan"],
  cc: ["ID"]
}, {
  pk: 5207,
  ang: "Port Vato",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Port Vato",
  lc: "ptv",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 5208,
  ang: "Pentlatch",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Pentlatch",
  lc: "ptw",
  ld: "ltr",
  alt: [],
  cc: ["CA"]
}, {
  pk: 5209,
  ang: "Pathiya",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Pathiya",
  lc: "pty",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 5210,
  ang: "Purepecha, Western Highland",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Western Highland Purepecha",
  lc: "pua",
  ld: "ltr",
  alt: ["P\u2019orhe", "P\u2019orh\xE9pecha", "P\u2019urhe", "P\u2019urh\xE9pecha", "Pur\xE9pecha de la Meseta", "Pur\xE9pecha de las Sierras", "Pur\xE9pecha del Oeste de Sierra Occidental", "Tarascan", "Tarasco", "Angahu\xE1n", "Arantepacua", "Ca\xF1ada de los Once Pueblos", "Cantera", "Cheran", "Nur\xEDo", "Pamatacuaro"],
  cc: ["MX"]
}, {
  pk: 5211,
  ang: "Purum",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Purum",
  lc: "pub",
  ld: "ltr",
  alt: ["Puram"],
  cc: ["IN"]
}, {
  pk: 5212,
  ang: "Punan Merap",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Punan Merap",
  lc: "puc",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 7876,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kayan Merap",
  lc: "puc-x-kayanmerap",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8259,
  ang: "Naha Kramu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Naha Kramu",
  lc: "puc-x-nahakramu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8231,
  ang: "Tang La'an",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tang La'an",
  lc: "puc-x-tanglaan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5213,
  ang: "Punan Aput",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Punan Aput",
  lc: "pud",
  ld: "ltr",
  alt: ["Aput"],
  cc: ["ID"]
}, {
  pk: 7880,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Punan Birun",
  lc: "pud-x-punanbirun",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8226,
  ang: "Punan Metut",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Punan Metut",
  lc: "pud-x-punanmetut",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5214,
  ang: "Punan Merah",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Punan Merah",
  lc: "puf",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 8229,
  ang: "Mirau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mirau",
  lc: "puf-x-mirau",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5215,
  ang: "Phuie",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Phuie",
  lc: "pug",
  ld: "ltr",
  alt: ["Buguli", "Buguri", "Phuien", "Puguli", "Pwa", "Pwe", "Pwie", "Pwien", "Pwo"],
  cc: ["BF"]
}, {
  pk: 5216,
  ang: "Puinave",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Puinave",
  lc: "pui",
  ld: "ltr",
  alt: ["Puinare", "Wanse"],
  cc: ["VE", "CO", "US"]
}, {
  pk: 5217,
  ang: "Punan Tubu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Punan Tubu",
  lc: "puj",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 8045,
  ang: "Punan Bila Bekajuk",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Punan Bila Bekayuk",
  lc: "puj-x-bilabekayuk",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8258,
  ang: "Bintuan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Bintuan",
  lc: "puj-x-bintuan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8042,
  ang: "Dayak Linoh Sempayan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Linoh Sempayan",
  lc: "puj-x-linohsempayan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8234,
  ang: "Long Lihi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Long Lihi",
  lc: "puj-x-longlihi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8064,
  ang: "Punan Long Pada",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Punan Long Pada",
  lc: "puj-x-longpada",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8233,
  ang: "Long Ranau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Long Ranau",
  lc: "puj-x-longranau",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8235,
  ang: "Long Titi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Long Titi",
  lc: "puj-x-longtiti",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8236,
  ang: "Menabur Besar",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Menabur Besar",
  lc: "puj-x-menaburbes",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7878,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Punan Bengalan",
  lc: "puj-x-punanbengalan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7841,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Punan Mentarang",
  lc: "puj-x-punanmentarang",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7882,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Punan Semeriot",
  lc: "puj-x-punansemeriot",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8238,
  ang: "Rian Tubu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Rian Tubu",
  lc: "puj-x-riantubu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8257,
  ang: "Sebaing",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sebaing",
  lc: "puj-x-sebaing",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5218,
  ang: "Pu Ko",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Pu Ko",
  lc: "puk",
  ld: "ltr",
  alt: ["Poko"],
  cc: ["LA"]
}, {
  pk: 5219,
  ang: "Puma",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u092A\u0941\u092E\u093E",
  lc: "pum",
  ld: "ltr",
  alt: ["Puma Kala", "Puma La", "Puma Pima"],
  cc: ["NP"]
}, {
  pk: 5220,
  ang: "Puoc",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Puoc",
  lc: "puo",
  ld: "ltr",
  alt: ["Kha Niang", "Kha Puhoc", "Ksing Mul", "Lao Muh", "Pou Hok", "Puhoc", "Puok", "Xin Mul", "Xing Mun", "Xingmoun", "Xinh Mul", "Mun", "Pua", "Sing", "Xinh-Mun"],
  cc: ["LA", "VN"]
}, {
  pk: 5221,
  ang: "Pulabu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Pulabu",
  lc: "pup",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5222,
  ang: "Puquina",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Puquina",
  lc: "puq",
  ld: "ltr",
  alt: [],
  cc: ["PE"]
}, {
  pk: 5223,
  ang: "Purubor\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Purubor\xE1",
  lc: "pur",
  ld: "ltr",
  alt: ["Aur\xE3", "Burubora", "Cujubi", "Kuyubi", "Miguelenho", "Migueleno", "Pumbora", "Purobor\xE1", "Puruba"],
  cc: ["BR"]
}, {
  pk: 5224,
  ang: "Putoh",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Putoh",
  lc: "put",
  ld: "ltr",
  alt: ["Putuk"],
  cc: ["ID"]
}, {
  pk: 7877,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Abai",
  lc: "put-x-dayakabai",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5225,
  ang: "Punu",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Punu",
  lc: "puu",
  ld: "ltr",
  alt: ["Ipounou", "Ipunu", "Pouno", "Puno", "Yipunu"],
  cc: ["GA", "CG"]
}, {
  pk: 5226,
  ang: "Puluwatese",
  lr: "Pacific",
  gw: false,
  hc: "FM",
  ln: "Puluwatese",
  lc: "puw",
  ld: "ltr",
  alt: ["Puluwat"],
  cc: ["FM"]
}, {
  pk: 5227,
  ang: "Puare",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Puare",
  lc: "pux",
  ld: "ltr",
  alt: ["Bkwala"],
  cc: ["PG"]
}, {
  pk: 5228,
  ang: "Purisime\xF1o",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Purisime\xF1o",
  lc: "puy",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 5229,
  ang: "Pawaia",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Pawaia",
  lc: "pwa",
  ld: "ltr",
  alt: ["Pavaia", "Sira", "Tudahwe", "Yasa", "Uri", "Aurama (Turoha)"],
  cc: ["PG"]
}, {
  pk: 5230,
  ang: "Panawa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Panawa",
  lc: "pwb",
  ld: "ltr",
  alt: ["Bugel", "Bujiye"],
  cc: ["NG"]
}, {
  pk: 5231,
  ang: "Gapapaiwa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gapapaiwa",
  lc: "pwg",
  ld: "ltr",
  alt: ["Gapa", "Manape", "Paiwa", "East Gapa", "West Paiwa"],
  cc: ["PG"]
}, {
  pk: 5232,
  ang: "Patwin",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Patwin",
  lc: "pwi",
  ld: "ltr",
  alt: ["Southern Wintun", "Wintu"],
  cc: ["US"]
}, {
  pk: 5233,
  ang: "Molbog",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Molbog",
  lc: "pwm",
  ld: "ltr",
  alt: ["Balabak", "Molbog Palawan", "Balabac Island", "Banggi Island", "Southern Palawan"],
  cc: ["MY", "PH"]
}, {
  pk: 5234,
  ang: "Paiwan",
  lr: "Asia",
  gw: false,
  hc: "TW",
  ln: "Paiwan",
  lc: "pwn",
  ld: "ltr",
  alt: ["Butanglu", "Kadas", "Kale-Whan", "Kapiangan", "Katausan", "Li-Li-Sha", "Paiuan", "Payowan", "Samobi", "Samohai", "Saprek", "Stimul", "Tamari"],
  cc: ["TW"]
}, {
  pk: 5235,
  ang: "Karen, Pwo Western",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Pwo Western Karen",
  lc: "pwo",
  ld: "ltr",
  alt: ["Bassein Pwo Karen", "Delta Pwo Karen", "Mon Karen", "Mutheit", "Phlong", "Phlong Sho", "Pho", "Talaing Karen"],
  cc: ["MM"]
}, {
  pk: 5236,
  ang: "Powari",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Powari",
  lc: "pwr",
  ld: "ltr",
  alt: ["Khalari", "Marari", "Bhoyari", "Lodhi", "Vyneganga Powari", "Kumbhari", "Koshti", "Govari of Seoni", "Bohoyeri", "Bhuria", "Bhoyaroo", "Bhoyar Powari (Bhomiyari)", "Bhuiyar"],
  cc: ["IN"]
}, {
  pk: 5237,
  ang: "Karen, Pwo Northern",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Pwo Northern Karen",
  lc: "pww",
  ld: "ltr",
  alt: ["Phlong", "Omkoi (Hod)"],
  cc: ["TH"]
}, {
  pk: 5238,
  ang: "Mixe, Quetzaltepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Quetzaltepec Mixe",
  lc: "pxm",
  ld: "ltr",
  alt: ["Central Mixe", "Mixe Alto del Sur"],
  cc: ["MX"]
}, {
  pk: 5239,
  ang: "Krumen, Pye",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Pye Krumen",
  lc: "pye",
  ld: "ltr",
  alt: ["Kroumen", "Northeastern Krumen", "Southeastern Krumen", "Pie (Pie-Pli-Mahon-Kuse-Gblapo-Henekwe)", "Pye", "Wluwe-Hawlo (Haoulo)", "Yrewe (Giriwe)"],
  cc: ["CI"]
}, {
  pk: 5240,
  ang: "Fyam",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Fyam",
  lc: "pym",
  ld: "ltr",
  alt: ["Fem", "Fyem", "Genawa", "Gyem", "Gyema", "Paiem", "Pem", "Pyem"],
  cc: ["NG"]
}, {
  pk: 5241,
  ang: "Poyan\xE1wa",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Poyan\xE1wa",
  lc: "pyn",
  ld: "ltr",
  alt: ["Poian\xE1ua", "Puinahua"],
  cc: ["BR"]
}, {
  pk: 5242,
  ang: "Paraguayan Sign Language",
  lr: "Americas",
  gw: false,
  hc: "PY",
  ln: "Paraguayan Sign Language",
  lc: "pys",
  ld: "ltr",
  alt: ["Lengua de Se\xF1as del Paraguay", "Lengua de se\xF1as paraguaya", "LSPY"],
  cc: ["PY"]
}, {
  pk: 5243,
  ang: "Puyuma",
  lr: "Asia",
  gw: false,
  hc: "TW",
  ln: "Puyuma",
  lc: "pyu",
  ld: "ltr",
  alt: ["Kadas", "Panapanayan", "Pelam", "Pilam", "Piyuma", "Tipun"],
  cc: ["TW"]
}, {
  pk: 5244,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Pyu (Myanmar)",
  lc: "pyx",
  ld: "ltr",
  alt: [],
  cc: ["MM"]
}, {
  pk: 5245,
  ang: "Pyen",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Pyen",
  lc: "pyy",
  ld: "ltr",
  alt: ["Hpyin"],
  cc: ["MM"]
}, {
  pk: 5246,
  ang: "Naga, Para",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Para Naga",
  lc: "pzn",
  ld: "ltr",
  alt: ["Bara Naga", "Jejara Naga", "Parasar"],
  cc: ["MM"]
}, {
  pk: 8363,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Neko",
  lc: "qaa-x-0123f0",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8365,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Duduela",
  lc: "qaa-x-1e034f",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8300,
  ang: "Ibaloi",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Ibalantoy",
  lc: "qaa-x-249d36",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8367,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Miani",
  lc: "qaa-x-2a8b78",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8350,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kou",
  lc: "qaa-x-3e7fd4",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8356,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kosena",
  lc: "qaa-x-4265f7",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8102,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Sisang",
  lc: "qaa-x-657797",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8362,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kwato",
  lc: "qaa-x-6d23fd",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8364,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nigum",
  lc: "qaa-x-6d5fd9",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8360,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wamas",
  lc: "qaa-x-6e8874",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8101,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Paus",
  lc: "qaa-x-ac3d56",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8369,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kuni",
  lc: "qaa-x-b25a78",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8346,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Logea",
  lc: "qaa-x-e4f23d",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5247,
  ang: "Quechua",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Runa Simi, Kichwa",
  lc: "qu",
  ld: "ltr",
  alt: [],
  cc: ["PE"]
}, {
  pk: 5248,
  ang: "Quapaw",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Quapaw",
  lc: "qua",
  ld: "ltr",
  alt: ["Alkansea", "Arkansas", "Capa", "Ogaxpa"],
  cc: ["US"]
}, {
  pk: 5249,
  ang: "Quechua, Huallaga Hu\xE1nuco",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Huallaga Hu\xE1nuco Quechua",
  lc: "qub",
  ld: "ltr",
  alt: [],
  cc: ["PE"]
}, {
  pk: 5250,
  ang: "K\u2019iche\u2019",
  lr: "Americas",
  gw: false,
  hc: "GT",
  ln: "K'iche'",
  lc: "quc",
  ld: "ltr",
  alt: ["Central K'iche'", "Central Quich\xE9", "Chiquel", "Qach'abel", "Quich\xE9", "Eastern Kich\xE9", "West Central Kich\xE9", "San Andr\xE9s Kich\xE9", "Cun\xE9n Kich\xE9", "Joyabaj Kich\xE9"],
  cc: ["GT"]
}, {
  pk: 5251,
  ang: "Quichua, Calder\xF3n Highland",
  lr: "Americas",
  gw: false,
  hc: "EC",
  ln: "Calder\xF3n Highland Quichua",
  lc: "qud",
  ld: "ltr",
  alt: ["Calder\xF3n Quichua", "Cayambe Quichua", "Pichincha Quichua"],
  cc: ["EC"]
}, {
  pk: 5252,
  ang: "Quechua, Lambayeque",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Lambayeque Quechua",
  lc: "quf",
  ld: "ltr",
  alt: ["Ferre\xF1afe"],
  cc: ["PE"]
}, {
  pk: 5253,
  ang: "Quichua, Chimborazo Highland",
  lr: "Americas",
  gw: false,
  hc: "EC",
  ln: "Chimborazo Highland Quichua",
  lc: "qug",
  ld: "ltr",
  alt: [],
  cc: ["EC"]
}, {
  pk: 5254,
  ang: "Quechua, South Bolivian",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "South Bolivian Quechua",
  lc: "quh",
  ld: "ltr",
  alt: ["Central Bolivian Quechua", "Quechua Boliviano", "Northwest Jujuy", "Northwest Jujuy (Colla)", "Potos\xED"],
  cc: ["CL", "AR", "US", "BO"]
}, {
  pk: 5255,
  ang: "Quileute",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Quileute",
  lc: "qui",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 5256,
  ang: "Quechua, Chachapoyas",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Chachapoyas Quechua",
  lc: "quk",
  ld: "ltr",
  alt: ["Amazonas", "La Jalca (South Chachapoyas)", "Lamud (West Chachapoyas)", "Grenada-Mendoza (East Chachapoyas)", "Llakwash Chachapoyas"],
  cc: ["PE"]
}, {
  pk: 5257,
  ang: "Quechua, North Bolivian",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "North Bolivian Quechua",
  lc: "qul",
  ld: "ltr",
  alt: ["North La Paz Quechua", "Chuma"],
  cc: ["BO"]
}, {
  pk: 5258,
  ang: "Sipakapense",
  lr: "Americas",
  gw: false,
  hc: "GT",
  ln: "Sipacapense",
  lc: "qum",
  ld: "ltr",
  alt: ["Sipacapa Quich\xE9", "Sipacape\xF1o", "Sipacapense"],
  cc: ["GT"]
}, {
  pk: 5259,
  ang: "Quinault",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Quinault",
  lc: "qun",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 5260,
  ang: "Quechua, Southern Pastaza",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Southern Pastaza Quechua",
  lc: "qup",
  ld: "ltr",
  alt: ["Inga"],
  cc: ["PE"]
}, {
  pk: 5261,
  ang: "Quinqui",
  lr: "Europe",
  gw: false,
  hc: "ES",
  ln: "Quinqui",
  lc: "quq",
  ld: "ltr",
  alt: [],
  cc: ["ES"]
}, {
  pk: 5262,
  ang: "Quechua, Chaupihuaranga",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Yanahuanca Pasco Quechua",
  lc: "qur",
  ld: "ltr",
  alt: ["Daniel Carrion", "Yanahuanca Pasco Quechua"],
  cc: ["PE"]
}, {
  pk: 5263,
  ang: "Quichua, Santiago del Estero",
  lr: "Americas",
  gw: false,
  hc: "AR",
  ln: "Santiago del Estero Quichua",
  lc: "qus",
  ld: "ltr",
  alt: ["Santiague\xF1o Quichua", "Santiagueno Quichua"],
  cc: ["AR"]
}, {
  pk: 5264,
  ang: "Sakapulteko",
  lr: "Americas",
  gw: false,
  hc: "GT",
  ln: "Sacapulteco",
  lc: "quv",
  ld: "ltr",
  alt: ["Sacapulas K'iche'"],
  cc: ["GT"]
}, {
  pk: 5265,
  ang: "Quichua, Tena Lowland",
  lr: "Americas",
  gw: false,
  hc: "EC",
  ln: "Tena Lowland Quichua",
  lc: "quw",
  ld: "ltr",
  alt: ["Napo Kichwa", "Yumbo"],
  cc: ["EC"]
}, {
  pk: 5266,
  ang: "Quechua, Yauyos",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Yauyos Quechua",
  lc: "qux",
  ld: "ltr",
  alt: ["Az\xE1ngaro-Huang\xE1scar-Chocos (Huang\xE1scar)", "Madean-Vi\xF1ac (Made\xE1n)", "Tana-Lincha (Lincha)", "Tom\xE1s-Alis (Alis)"],
  cc: ["PE"]
}, {
  pk: 5267,
  ang: "Quechua, Ayacucho",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Ayacucho Quechua",
  lc: "quy",
  ld: "ltr",
  alt: ["Chanka"],
  cc: ["PE"]
}, {
  pk: 5268,
  ang: "Quechua, Cusco",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Cusco Quechua",
  lc: "quz",
  ld: "ltr",
  alt: ["Cuzco", "Cuzco Quechua", "Qheswa", "Quechua Cusco", "Quechua de Cusco-Collao", "Quechua Qosqo-Qollaw", "Runasimi Qusqu Qullaw", "Caylloma Quechua", "Puno Quechua", "Eastern Apur\xEDmac Quechua"],
  cc: ["PE"]
}, {
  pk: 5269,
  ang: "Quechua, Ambo-Pasco",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Ambo-Pasco Quechua",
  lc: "qva",
  ld: "ltr",
  alt: ["San Rafael-Huariaca Quechua"],
  cc: ["PE"]
}, {
  pk: 5270,
  ang: "Quechua, Cajamarca",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Cajamarca Quechua",
  lc: "qvc",
  ld: "ltr",
  alt: ["Eastern Cajamarca", "Western Cajamarca"],
  cc: ["PE"]
}, {
  pk: 5271,
  ang: "Quechua, Eastern Apur\xEDmac",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Eastern Apur\xEDmac Quechua",
  lc: "qve",
  ld: "ltr",
  alt: ["Apur\xEDmac Quechua", "Quechua del Este de Apur\xEDmac", "Abancay", "Antabamba", "Cotabambas"],
  cc: ["PE"]
}, {
  pk: 5272,
  ang: "Quechua, Huamal\xEDes-Dos de Mayo Hu\xE1nuco",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Huamal\xEDes-Dos de Mayo Hu\xE1nuco Quechua",
  lc: "qvh",
  ld: "ltr",
  alt: [],
  cc: ["PE"]
}, {
  pk: 5273,
  ang: "Quichua, Imbabura Highland",
  lr: "Americas",
  gw: false,
  hc: "EC",
  ln: "Imbabura Highland Quichua",
  lc: "qvi",
  ld: "ltr",
  alt: ["Otavalo Quichua"],
  cc: ["EC"]
}, {
  pk: 5274,
  ang: "Quichua, Loja Highland",
  lr: "Americas",
  gw: false,
  hc: "EC",
  ln: "Loja Highland Quichua",
  lc: "qvj",
  ld: "ltr",
  alt: ["Loja Quichua", "Saraguro Quichua"],
  cc: ["EC"]
}, {
  pk: 5275,
  ang: "Quechua, Cajatambo North Lima",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Cajatambo North Lima Quechua",
  lc: "qvl",
  ld: "ltr",
  alt: [],
  cc: ["PE"]
}, {
  pk: 5276,
  ang: "Quechua, Margos-Yarowilca-Lauricocha",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Margos-Yarowilca-Lauricocha Quechua",
  lc: "qvm",
  ld: "ltr",
  alt: [],
  cc: ["PE"]
}, {
  pk: 5277,
  ang: "Quechua, North Jun\xEDn",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "North Jun\xEDn Quechua",
  lc: "qvn",
  ld: "ltr",
  alt: ["Jun\xEDn Quechua", "Tarma-Jun\xEDn Quechua"],
  cc: ["PE"]
}, {
  pk: 5278,
  ang: "Quechua, Napo Lowland",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Napo Lowland Quechua",
  lc: "qvo",
  ld: "ltr",
  alt: ["Lowland Napo Quechua", "Ingano", "Lowland Napo Quichua", "Napo Quichua", "Kicho", "Napo", "Napo Kichua", "Napo Lowland Quichua", "Quijo", "Quixo", "Runa Shimi", "Santa Rosa Quechua", "Santarrosino", "Yumbo"],
  cc: ["PE", "CO", "EC"]
}, {
  pk: 5279,
  ang: "Quechua, Pacaraos",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Pacaraos Quechua",
  lc: "qvp",
  ld: "ltr",
  alt: [],
  cc: ["PE"]
}, {
  pk: 5280,
  ang: "Quechua, San Mart\xEDn",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "San Mart\xEDn Quechua",
  lc: "qvs",
  ld: "ltr",
  alt: ["Lama", "Lamano", "Lamista", "Lamisto", "Motil\xF3n", "Ucayali"],
  cc: ["PE"]
}, {
  pk: 5281,
  ang: "Quechua, Huaylla Wanca",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Huaylla Wanca Quechua",
  lc: "qvw",
  ld: "ltr",
  alt: ["Huanca Huaylla Quechua", "Southern Huancayo Quechua", "Huaycha", "Waycha (Central Huancayo)"],
  cc: ["PE"]
}, {
  pk: 5282,
  ang: "Queyu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5374\u57DF\u8BED",
  lc: "qvy",
  ld: "ltr",
  alt: ["Choyo", "Zhaba"],
  cc: ["CN"]
}, {
  pk: 5283,
  ang: "Quichua, Northern Pastaza",
  lr: "Americas",
  gw: false,
  hc: "EC",
  ln: "Northern Pastaza Quichua",
  lc: "qvz",
  ld: "ltr",
  alt: ["Alama", "Bobonaza Quichua", "Canelos Quichua", "Pastaza Quichua", "Sarayacu Quichua", "Bobonaza"],
  cc: ["PE", "EC"]
}, {
  pk: 5284,
  ang: "Quechua, Corongo Ancash",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Corongo Ancash Quechua",
  lc: "qwa",
  ld: "ltr",
  alt: [],
  cc: ["PE"]
}, {
  pk: 5285,
  ang: "Classical Quechua",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Classical Quechua",
  lc: "qwc",
  ld: "ltr",
  alt: [],
  cc: ["PE"]
}, {
  pk: 5286,
  ang: "Quechua, Huaylas Ancash",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Huaylas Ancash Quechua",
  lc: "qwh",
  ld: "ltr",
  alt: ["Huaraz Quechua", "Huailas (Huaylas)"],
  cc: ["PE"]
}, {
  pk: 5287,
  ang: "Kuman",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "Kuman (Russia)",
  lc: "qwm",
  ld: "ltr",
  alt: [],
  cc: ["RU"]
}, {
  pk: 5288,
  ang: "Quechua, Sihuas Ancash",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Sihuas Ancash Quechua",
  lc: "qws",
  ld: "ltr",
  alt: [],
  cc: ["PE"]
}, {
  pk: 5289,
  ang: "Kwalhioqua-Tlatskanai",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Kwalhioqua-Tlatskanai",
  lc: "qwt",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 5290,
  ang: "Quechua, Chiqui\xE1n Ancash",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Chiqui\xE1n Ancash Quechua",
  lc: "qxa",
  ld: "ltr",
  alt: [],
  cc: ["PE"]
}, {
  pk: 5291,
  ang: "Quechua, Chincha",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Chincha Quechua",
  lc: "qxc",
  ld: "ltr",
  alt: [],
  cc: ["PE"]
}, {
  pk: 5292,
  ang: "Quechua, Panao Hu\xE1nuco",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Panao Hu\xE1nuco Quechua",
  lc: "qxh",
  ld: "ltr",
  alt: ["Pachitea Quechua"],
  cc: ["PE"]
}, {
  pk: 5293,
  ang: "Quichua, Salasaca Highland",
  lr: "Americas",
  gw: false,
  hc: "EC",
  ln: "Salasaca Highland Quichua",
  lc: "qxl",
  ld: "ltr",
  alt: ["Salasaca Quichua", "Tungurahua Highland Quichua", "Tungurahua Quichua"],
  cc: ["EC"]
}, {
  pk: 5294,
  ang: "Quechua, Northern Conchucos Ancash",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Northern Conchucos Ancash Quechua",
  lc: "qxn",
  ld: "ltr",
  alt: ["Conchucos Quechua", "Northern Conchucos Quechua"],
  cc: ["PE"]
}, {
  pk: 5295,
  ang: "Quechua, Southern Conchucos Ancash",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Southern Conchucos Ancash Quechua",
  lc: "qxo",
  ld: "ltr",
  alt: ["Conchucos Quechua", "Southern Conchucos Quechua"],
  cc: ["PE"]
}, {
  pk: 5296,
  ang: "Quechua, Puno",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Puno Quechua",
  lc: "qxp",
  ld: "ltr",
  alt: ["Quechua Collao", "Quechua Qollaw", "Cailloma Quechua", "North Bolivian Quechua"],
  cc: ["PE"]
}, {
  pk: 5297,
  ang: "Kashkay",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u0632\u0628\u0627\u0646 \u062A\u0631\u06A9\u06CC \u0642\u0634\u0642\u0627\u06CC\u06CC",
  lc: "qxq",
  ld: "rtl",
  alt: ["Kashkai", "Qashqa'i", "Qashqay"],
  cc: ["IR"]
}, {
  pk: 5298,
  ang: "Quichua, Ca\xF1ar Highland",
  lr: "Americas",
  gw: false,
  hc: "EC",
  ln: "Ca\xF1ar Highland Quichua",
  lc: "qxr",
  ld: "ltr",
  alt: [],
  cc: ["EC"]
}, {
  pk: 5299,
  ang: "Qiang, Southern",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Southern Qiang",
  lc: "qxs",
  ld: "ltr",
  alt: ["Ch'iang", "Dajishan (Daqishan)"],
  cc: ["CN"]
}, {
  pk: 5300,
  ang: "Quechua, Santa Ana de Tusi Pasco",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Santa Ana de Tusi Pasco Quechua",
  lc: "qxt",
  ld: "ltr",
  alt: [],
  cc: ["PE"]
}, {
  pk: 5301,
  ang: "Quechua, Arequipa-La Uni\xF3n",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Arequipa-La Uni\xF3n Quechua",
  lc: "qxu",
  ld: "ltr",
  alt: ["Arequipa Quechua", "Cotahuasi Quechua", "Antabamba (Apur\xEDmac)"],
  cc: ["PE"]
}, {
  pk: 5302,
  ang: "Quechua, Jauja Wanca",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Jauja Wanca Quechua",
  lc: "qxw",
  ld: "ltr",
  alt: ["Huanca Jauja Quechua", "Shausha Wanka Quechua"],
  cc: ["PE"]
}, {
  pk: 5303,
  ang: "",
  lr: "",
  gw: false,
  hc: "",
  ln: "Quenya",
  lc: "qya",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5304,
  ang: "Quiripi",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Quiripi",
  lc: "qyp",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 5305,
  ang: "Dungmali",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Dungmali",
  lc: "raa",
  ld: "ltr",
  alt: ["Arthare", "Arthare-Khesang", "Dungmali P\xFBk", "Dungmali-Bantawa", "Khesange", "Khesang (Khesange)"],
  cc: ["NP"]
}, {
  pk: 5306,
  ang: "Chamling",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u091A\u093E\u092E\u094D\u0932\u093F\u0919",
  lc: "rab",
  ld: "ltr",
  alt: ["Camling", "Chamlinge Rai", "Rodong", "Ratanchhali", "Halesi", "Balamtali"],
  cc: ["NP"]
}, {
  pk: 5307,
  ang: "Rasawa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Rasawa",
  lc: "rac",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 5308,
  ang: "Rade",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Rade",
  lc: "rad",
  ld: "ltr",
  alt: ["De", "E-De", "Edeh", "Rde", "Rhade", "Adham (A-Dham)", "Kodrao (Kdrao)", "Ndhur (Mdhur)", "Rde Kpa (Kpa)"],
  cc: ["KH", "VN"]
}, {
  pk: 5309,
  ang: "Mewahang, Western",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Western Meohang",
  lc: "raf",
  ld: "ltr",
  alt: ["Mewahang", "Newahang", "Newahang Jimi", "Newang", "Newange Rai", "Western Meohang", "Bala (Balali)"],
  cc: ["NP"]
}, {
  pk: 5310,
  ang: "Lulogooli",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Logooli",
  lc: "rag",
  ld: "ltr",
  alt: ["Llogole", "Llugule", "Logooli", "Lugooli", "Luragoli", "Maragoli", "Maragooli", "Ragoli", "Uluragooli"],
  cc: ["KE"]
}, {
  pk: 5311,
  ang: "Rabha",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Rabha",
  lc: "rah",
  ld: "ltr",
  alt: ["Rava", "Maitaria (Maitoria)", "Maituri", "Rangdania (Rongdani)"],
  cc: ["IN"]
}, {
  pk: 5312,
  ang: "Ramoaaina",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ramoaaina",
  lc: "rai",
  ld: "ltr",
  alt: ["Duke of York", "Ramuaina", "South Islands", "Ulu", "Molot (Main Island)", "Makada", "Alawa", "Aalawa (Aalawaa)", "Mioko"],
  cc: ["PG"]
}, {
  pk: 5313,
  ang: "Rajasthani",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "\u0930\u093E\u091C\u0938\u094D\u0925\u093E\u0928\u0940",
  lc: "raj",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 5314,
  ang: "Tulu-Bohuai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tulu-Bohuai",
  lc: "rak",
  ld: "ltr",
  alt: ["Bohuai-Tulu", "Bowai", "Pahavai", "Pelipowai", "Pohuai", "Tulun", "Tulu (Tjudun)"],
  cc: ["PG"]
}, {
  pk: 5315,
  ang: "Ralte",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Ralte",
  lc: "ral",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 5316,
  ang: "Canela",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Canela",
  lc: "ram",
  ld: "ltr",
  alt: ["Kanela", "Apaniekra", "Apanjekra (Apanhecra)"],
  cc: ["BR"]
}, {
  pk: 5317,
  ang: "Riantana",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Riantana",
  lc: "ran",
  ld: "ltr",
  alt: ["Kimaam"],
  cc: ["ID"]
}, {
  pk: 5318,
  ang: "Rao",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Rao",
  lc: "rao",
  ld: "ltr",
  alt: ["Annaberg", "Rao Breri"],
  cc: ["PG"]
}, {
  pk: 5319,
  ang: "Rapa Nui",
  lr: "Americas",
  gw: false,
  hc: "CL",
  ln: "Rapanui",
  lc: "rap",
  ld: "ltr",
  alt: ["Easter Island", "Pascuense", "Rapanui"],
  cc: ["CL"]
}, {
  pk: 5320,
  ang: "Saam",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Saam",
  lc: "raq",
  ld: "ltr",
  alt: ["Saam Rai", "Saama Kha", "Samakha"],
  cc: ["NP"]
}, {
  pk: 5321,
  ang: "Rarotongan",
  lr: "Pacific",
  gw: false,
  hc: "CK",
  ln: "Rarotongan",
  lc: "rar",
  ld: "ltr",
  alt: ["Cook Island", "Cook Islands Maori", "Kuki Airani", "Maori", "Rarotongan-Mangaian", "Rarotonga"],
  cc: ["CK", "NZ", "US", "PF"]
}, {
  pk: 5322,
  ang: "Tegali",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Tegali",
  lc: "ras",
  ld: "ltr",
  alt: ["Tagale", "Tegele", "Tekele", "Togole", "Tingal (Kajaja)", "Rashad (Kom)", "Ngakom", "Kajakja", "Kome"],
  cc: ["SD"]
}, {
  pk: 5323,
  ang: "Razajerdi",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Razajerdi",
  lc: "rat",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 5324,
  ang: "Raute",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Raute",
  lc: "rau",
  ld: "ltr",
  alt: ["Boto boli", "Khamchi", "Raji", "Rajwar", "Rautya", "Rautye"],
  cc: ["NP"]
}, {
  pk: 5325,
  ang: "Sampang",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Sampang",
  lc: "rav",
  ld: "ltr",
  alt: ["Sampang Gun", "Sampang Gung", "Sampang Kha", "Sampange Rai", "Sangpang", "Sangpang G\xEEn", "Sangpang Gun", "Sangpang Kha"],
  cc: ["NP"]
}, {
  pk: 5326,
  ang: "Rawang",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Rawang",
  lc: "raw",
  ld: "ltr",
  alt: ["Chiutse", "Ch'opa", "Ganung-Rawang", "Hkanung", "Kiutze", "Taron", "Nung", "Nung Rawang", "Eastern Tangsar (Changgong)", "Western Tangsar (Langdaqgong)", "Renyinchi", "Northern Lungmi", "Matwang", "Khrangkhu/Thininglong (Southern Lungmi)", "Kyaikhu (Dangraq-Mashang)", "Drung", "Daru-Jerwang"],
  cc: ["CN", "MM"]
}, {
  pk: 5327,
  ang: "Rang",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Rang",
  lc: "rax",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 5328,
  ang: "Rapa",
  lr: "Pacific",
  gw: false,
  hc: "PF",
  ln: "Rapa",
  lc: "ray",
  ld: "ltr",
  alt: ["Rapan"],
  cc: ["PF"]
}, {
  pk: 5329,
  ang: "Rahambuu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Rahambuu",
  lc: "raz",
  ld: "ltr",
  alt: ["Lellewao", "Lellewau", "Noihe", "Wiaoe", "Wiau"],
  cc: ["ID"]
}, {
  pk: 5330,
  ang: "Palaung, Rumai",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Rumai Palaung",
  lc: "rbb",
  ld: "ltr",
  alt: ["Humai", "Rumai", "Ta'ang", "Ngwe Palaung", "Rumai Humai", "Shan Rumai", "Silver Palaung", "Ta'ang Rumai", "Tai Rumai"],
  cc: ["CN", "MM"]
}, {
  pk: 5331,
  ang: "Bontok, Northern",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Northern Bontok",
  lc: "rbk",
  ld: "ltr",
  alt: ["Bontoc", "Bontoc, Central", "Bontoc, Northern", "Central", "Northern"],
  cc: ["PH"]
}, {
  pk: 5332,
  ang: "Bikol, Miraya",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Miraya Bikol",
  lc: "rbl",
  ld: "ltr",
  alt: ["Bikol", "Daraga"],
  cc: ["PH"]
}, {
  pk: 5333,
  ang: "Barababaraba",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Barababaraba",
  lc: "rbp",
  ld: "ltr",
  alt: ["Baraba Baraba", "Baraba-Baraba", "Baraparapa", "Barappur", "Bareber Bareber", "Barrababarraba", "Barraba-Barraba", "Beraba-Beraba", "Birraba-Birraba", "Boorabirraba", "Booraboora", "Boora-Boora", "Boort", "Burabura", "Burappa", "Burapper", "Bureba", "Burrabura-ba", "Burraburburaba", "Burrappa", "Burrapper", "Burreba-Burreba", "Karraba", "Perapa-Perapa"],
  cc: ["AU"]
}, {
  pk: 5334,
  ang: "R\xE9union Creole French",
  lr: "Africa",
  gw: false,
  hc: "RE",
  ln: "R\xE9union Creole French",
  lc: "rcf",
  ld: "ltr",
  alt: [],
  cc: ["KM", "FR", "MG", "RE", "YT"]
}, {
  pk: 5335,
  ang: "Rudbari",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Rudbari",
  lc: "rdb",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 5336,
  ang: "Rerau",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Rerau",
  lc: "rea",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5337,
  ang: "Rembong",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Rembong",
  lc: "reb",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 5338,
  ang: "Kayan, Rejang",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Rejang Kayan",
  lc: "ree",
  ld: "ltr",
  alt: ["Rejang Kajan", "Long Kehobo (Uma Poh)"],
  cc: ["MY"]
}, {
  pk: 7829,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Punan Lisum",
  lc: "ree-x-punanlisum",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5339,
  ang: "Kara",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Kara (Tanzania)",
  lc: "reg",
  ld: "ltr",
  alt: ["Kikara", "Kiregi"],
  cc: ["TZ"]
}, {
  pk: 5340,
  ang: "Reli",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Reli",
  lc: "rei",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 5341,
  ang: "Rejang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Rejang",
  lc: "rej",
  ld: "ltr",
  alt: ["Djang", "Kepahiang (Kebanagung)", "Musi (Curup)", "Pasisir", "Rawas"],
  cc: ["ID"]
}, {
  pk: 5342,
  ang: "Rendille",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Rendille",
  lc: "rel",
  ld: "ltr",
  alt: ["Randile", "Rendile"],
  cc: ["KE"]
}, {
  pk: 5343,
  ang: "Rengao",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Rengao",
  lc: "ren",
  ld: "ltr",
  alt: ["Ro-Ngao"],
  cc: ["VN"]
}, {
  pk: 5344,
  ang: "Reshe",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Reshe",
  lc: "res",
  ld: "ltr",
  alt: ["Bareshe", "Gunga", "Gunganchi", "Tsureja", "Tsureshe", "Yaurawa"],
  cc: ["NG"]
}, {
  pk: 5345,
  ang: "Reta",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Retta",
  lc: "ret",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 5346,
  ang: "Reyesano",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Reyesano",
  lc: "rey",
  ld: "ltr",
  alt: ["San Borjano"],
  cc: ["BO"]
}, {
  pk: 5347,
  ang: "Roria",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Roria",
  lc: "rga",
  ld: "ltr",
  alt: ["Mores"],
  cc: ["VU"]
}, {
  pk: 5348,
  ang: "Romano-Greek",
  lr: "Europe",
  gw: false,
  hc: "GR",
  ln: "Romano-Greek",
  lc: "rge",
  ld: "ltr",
  alt: ["Hellenoromani"],
  cc: ["GR"]
}, {
  pk: 5349,
  ang: "Rangkas",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Rangkas",
  lc: "rgk",
  ld: "ltr",
  alt: ["Canpa", "Chyanam", "Johari", "Kyonam", "Saukas", "Saukiya Khun", "Shaukas"],
  cc: ["IN"]
}, {
  pk: 5350,
  ang: "Romagnol",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Romagnol",
  lc: "rgn",
  ld: "ltr",
  alt: ["Emiliano-Romagnolo"],
  cc: ["SM", "IT"]
}, {
  pk: 5351,
  ang: "Res\xEDgaro",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Res\xEDgaro",
  lc: "rgr",
  ld: "ltr",
  alt: ["Res\xEDgero"],
  cc: ["PE"]
}, {
  pk: 5352,
  ang: "Roglai, Southern",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Southern Roglai",
  lc: "rgs",
  ld: "ltr",
  alt: [],
  cc: ["VN"]
}, {
  pk: 5353,
  ang: "Rikou",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ringgou",
  lc: "rgu",
  ld: "ltr",
  alt: ["Eastern Rote", "Ringgou", "Rote", "Rote Timur", "Roti", "Rotinese", "Landu", "Oe Pao (Oepao)"],
  cc: ["ID"]
}, {
  pk: 5354,
  ang: "Rohingya",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Rohingya",
  lc: "rhg",
  ld: "ltr",
  alt: ["Rohinja"],
  cc: ["MM"]
}, {
  pk: 5355,
  ang: "Yahang",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yahang",
  lc: "rhp",
  ld: "ltr",
  alt: ["Ruruhi'ip", "Ruruhip", "Ya'unk"],
  cc: ["PG"]
}, {
  pk: 5356,
  ang: "Riang",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Riang (India)",
  lc: "ria",
  ld: "ltr",
  alt: ["Kau Bru", "Reang", "Tipra"],
  cc: ["BD", "IN"]
}, {
  pk: 5357,
  ang: "Rien",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Rien",
  lc: "rie",
  ld: "ltr",
  alt: [],
  cc: ["LA"]
}, {
  pk: 5358,
  ang: "Tarifit",
  lr: "Africa",
  gw: false,
  hc: "MA",
  ln: "\u2D5C\u2D30\u2D54\u2D49\u2D3C\u2D49\u2D5C",
  lc: "rif",
  ld: "ltr",
  alt: ["Fifia", "Northern Shilha", "Rif", "Riff", "Rifi", "Ruafa", "Shilha", "Tirifie", "Rif Berber", "Rife\xF1o", "Rifia", "Rifiya", "Tamazight", "Tamazight n Arrif", "Tarifiyt", "Tarifyt Berber", "Ayt Settut", "Ayt Urishesh", "Iznasen (Beni Snassen)", "Iznacen (Beni Iznassen)", "Iqeraayen", "Igzennayen", "Icebdanen", "Ibeqquyen", "Ayt Waryaghar", "Ayt Tuzin", "Ayt Tamsaman", "Ayt Saaid", "Ayt Mezduy", "Ayt Ittef", "Ayt Buyahyi", "Ayt Aamart", "Ayt Tfarsit"],
  cc: ["DZ", "FR", "MA"]
}, {
  pk: 5359,
  ang: "Riang",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Riang (Myanmar)",
  lc: "ril",
  ld: "ltr",
  alt: ["Black Karen", "Black Riang", "Black Yang", "Liang Sek", "Riang-Lang", "Yang", "Yang Wan Kun", "Yanglam", "Yin", "Yin Kya", "Yin Net", "Yinnet", "Xiaochanggou", "Liang", "Yinja", "Yang Sek", "Red Riang", "Liang Palaung", "De'ang", "Na'ang", "Xiaoan'gou"],
  cc: ["CN", "MM"]
}, {
  pk: 5360,
  ang: "Nyaturu",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Nyaturu",
  lc: "rim",
  ld: "ltr",
  alt: ["Keremi", "Kinyaturu", "Kiremi", "Kirimi", "Limi", "Remi", "Rimi", "Turu", "Girwana (Rimi)"],
  cc: ["TZ"]
}, {
  pk: 5361,
  ang: "Nungu",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Nungu",
  lc: "rin",
  ld: "ltr",
  alt: ["Lindiri", "Rendre", "Rindiri"],
  cc: ["NG"]
}, {
  pk: 5362,
  ang: "Ribun",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ribun",
  lc: "rir",
  ld: "ltr",
  alt: ["Bekidoh"],
  cc: ["ID"]
}, {
  pk: 8091,
  ang: "Dayak Mali Peruan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Mali Peruan",
  lc: "rir-x-dayakmaliperuan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7897,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Mudu",
  lc: "rir-x-dayakmudu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8025,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Sami",
  lc: "rir-x-dayaksami",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5363,
  ang: "Ritarungo",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Ritarungo",
  lc: "rit",
  ld: "ltr",
  alt: ["Ridarngo", "Ridharrngu", "Ritarnugu", "Ritharrngu", "Wagelak", "Wawilag"],
  cc: ["AU"]
}, {
  pk: 5364,
  ang: "Riung",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Riung",
  lc: "riu",
  ld: "ltr",
  alt: ["Far Eastern Manggarai"],
  cc: ["ID"]
}, {
  pk: 5365,
  ang: "Rajong",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Rajong",
  lc: "rjg",
  ld: "ltr",
  alt: ["Razong"],
  cc: ["ID"]
}, {
  pk: 5366,
  ang: "Raji",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Raji",
  lc: "rji",
  ld: "ltr",
  alt: ["Ban Raji", "Janggali", "Rajibar", "Rawati", "Rjya", "Naukule", "Purbiya", "Barh Bandale"],
  cc: ["NP"]
}, {
  pk: 5367,
  ang: "Rajbanshi",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Rajbanshi",
  lc: "rjs",
  ld: "ltr",
  alt: ["Gangai", "Koch", "Koche", "Rajbansi"],
  cc: ["NP"]
}, {
  pk: 5368,
  ang: "Kraol",
  lr: "Asia",
  gw: false,
  hc: "KH",
  ln: "Kraol",
  lc: "rka",
  ld: "ltr",
  alt: [],
  cc: ["KH"]
}, {
  pk: 8390,
  ang: "T'moan",
  lr: "Asia",
  gw: false,
  hc: "KH",
  ln: "T'moan",
  lc: "rka-x-tmoan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5369,
  ang: "Rikbaktsa",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Rikbaktsa",
  lc: "rkb",
  ld: "ltr",
  alt: ["Aripaktsa", "Canoeiro", "Erikbatsa", "Erikpatsa"],
  cc: ["BR"]
}, {
  pk: 5370,
  ang: "Rakahanga-Manihiki",
  lr: "Pacific",
  gw: false,
  hc: "CK",
  ln: "Rakahanga-Manihiki",
  lc: "rkh",
  ld: "ltr",
  alt: ["Manihiki-Rakahanga"],
  cc: ["CK", "NZ"]
}, {
  pk: 5371,
  ang: "Rakhine",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Rakhine",
  lc: "rki",
  ld: "ltr",
  alt: ["Mogh", "Rakkhaine", "Arakanese", "Yanbe", "Kyaukphyu", "Yangbye (Rambree)", "Yangye", "Yanbye", "Sitwe", "Sittwe (Akyab)", "Man Aung (Chebuda Island)", "Mrauk-U"],
  cc: ["BD", "IN", "MM"]
}, {
  pk: 7597,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Marmas",
  lc: "rki-x-marmas",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5372,
  ang: "Marka",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Marka",
  lc: "rkm",
  ld: "ltr",
  alt: ["Marka Dafing", "Dafing", "Marka-Dafin", "Meka"],
  cc: ["BF", "ML"]
}, {
  pk: 5373,
  ang: "Rangpuri",
  lr: "Asia",
  gw: false,
  hc: "BD",
  ln: "Rangpuri",
  lc: "rkt",
  ld: "ltr",
  alt: ["Anchalit Bangla", "Bahe Bangla", "Kamta", "Polia", "Goalparia", "Kamtapuri", "Koch Rajbanshi", "Rajbangsi", "Rajbanshi", "Rajbansi", "Rajbongshi"],
  cc: ["BD"]
}, {
  pk: 5374,
  ang: "Romansh",
  lr: "Europe",
  gw: false,
  hc: "CH",
  ln: "rumantsch grischun",
  lc: "rm",
  ld: "ltr",
  alt: ["Rhaeto-Romance", "Rheto-Romance", "Romanche", "Romansh", "Rumantsch", "Puter (Upper Engadine)", "Surmiran (Albula)", "Sursilvan (Surselva)", "Sutsilvan (Hinterrhein)", "Vallader (Lower Engadine)", "Vorderrhein"],
  cc: ["CH", "IT"]
}, {
  pk: 5375,
  ang: "Rama",
  lr: "Americas",
  gw: false,
  hc: "NI",
  ln: "Rama",
  lc: "rma",
  ld: "ltr",
  alt: [],
  cc: ["NI"]
}, {
  pk: 5376,
  ang: "Rembarunga",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Rembarunga",
  lc: "rmb",
  ld: "ltr",
  alt: ["Kaltuy", "Rainbargo", "Rembarranga", "Rembarrunga"],
  cc: ["AU"]
}, {
  pk: 5377,
  ang: "Romani, Carpathian",
  lr: "Europe",
  gw: false,
  hc: "CZ",
  ln: "Carpathian Romani",
  lc: "rmc",
  ld: "ltr",
  alt: ["Bashaldo", "Hungarian-Slovak Romani", "Romungro", "Selice Romani"],
  cc: ["CY", "HU", "GB", "CZ", "RO", "PL", "SK"]
}, {
  pk: 5378,
  ang: "Angloromani",
  lr: "Europe",
  gw: false,
  hc: "GB",
  ln: "Angloromani",
  lc: "rme",
  ld: "ltr",
  alt: ["English Romani", "Pogadi Chib", "Posh `N' Posh", "Romani English", "Romanichal", "Romanis"],
  cc: ["GB", "AU"]
}, {
  pk: 5379,
  ang: "Romani, Kalo Finnish",
  lr: "Europe",
  gw: false,
  hc: "FI",
  ln: "Kalo Finnish Romani",
  lc: "rmf",
  ld: "ltr",
  alt: ["F\xEDntika R\xF3mma", "Gypsy", "Kal\xE9"],
  cc: ["SE", "FI"]
}, {
  pk: 5380,
  ang: "Norwegian, Traveller",
  lr: "Europe",
  gw: false,
  hc: "NO",
  ln: "Traveller Norwegian",
  lc: "rmg",
  ld: "ltr",
  alt: ["Norwegian Traveller", "Rodi"],
  cc: ["NO"]
}, {
  pk: 5381,
  ang: "Murkim",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Murkim",
  lc: "rmh",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 5382,
  ang: "Lomavren",
  lr: "Asia",
  gw: false,
  hc: "AM",
  ln: "Lomavren",
  lc: "rmi",
  ld: "ltr",
  alt: ["Armenian Bosa", "Armenian Bosha", "Bosa", "Bosha", "Arnebuab Bisa"],
  cc: ["AM"]
}, {
  pk: 5383,
  ang: "Romkun",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Romkun",
  lc: "rmk",
  ld: "ltr",
  alt: ["Romkuin"],
  cc: ["PG"]
}, {
  pk: 5384,
  ang: "Romani, Baltic",
  lr: "Europe",
  gw: false,
  hc: "PL",
  ln: "Baltic Romani",
  lc: "rml",
  ld: "ltr",
  alt: ["Latvian Romani (Lettish Romani)"],
  cc: ["LV", "PL"]
}, {
  pk: 5385,
  ang: "Roma",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Roma",
  lc: "rmm",
  ld: "ltr",
  alt: ["Romang"],
  cc: ["ID"]
}, {
  pk: 5386,
  ang: "Romani, Balkan",
  lr: "Europe",
  gw: false,
  hc: "RS",
  ln: "Balkan Romani",
  lc: "rmn",
  ld: "ltr",
  alt: ["Gypsy", "Be\xE1s", "Cig\xE1ny", "Roma", "Arlija (Erli)", "Urs\xE1ri (Usari)"],
  cc: ["GR", "AF", "FR", "IR", "RS", "MK", "SI", "TR", "AU", "IT", "MD", "BG", "UA"]
}, {
  pk: 5387,
  ang: "Romani, Sinte",
  lr: "Europe",
  gw: false,
  hc: "RS",
  ln: "Sinte Romani",
  lc: "rmo",
  ld: "ltr",
  alt: ["Rommanes", "Sinti", "Tsigane", "Sint\xED", "Ziguener", "Manouche (Manuche)", "Manuche (Manouche)", "Manush"],
  cc: ["AT", "HR", "FR", "KZ", "RS", "NL", "CH", "CA", "IT"]
}, {
  pk: 5388,
  ang: "Rempi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Rempi",
  lc: "rmp",
  ld: "ltr",
  alt: ["A'e", "Erempi", "Rempin"],
  cc: ["PG"]
}, {
  pk: 5389,
  ang: "Cal\xF3",
  lr: "Europe",
  gw: false,
  hc: "ES",
  ln: "Cal\xF3",
  lc: "rmq",
  ld: "ltr",
  alt: ["Gitano", "Iberian Romani", "Hispanoromani", "Cal\xE3o", "Lusitano-Romani", "Portuguese Cal\xE3o (Cal\xE3o)"],
  cc: ["BR", "FR", "ES", "PT"]
}, {
  pk: 7518,
  ang: "Hungarian Ardilean Bayash",
  lr: "Europe",
  gw: false,
  hc: "HU",
  ln: "Hungarian Ardilean Bayash",
  lc: "rmr-x-bha",
  ld: "ltr",
  alt: [],
  cc: ["HU"]
}, {
  pk: 7519,
  ang: "",
  lr: "Europe",
  gw: false,
  hc: "HU",
  ln: "Hungarian Muntean Bayash",
  lc: "rmr-x-bhm",
  ld: "ltr",
  alt: [],
  cc: ["HU"]
}, {
  pk: 7517,
  ang: "",
  lr: "Europe",
  gw: false,
  hc: "HR",
  ln: "South Slavic Ardilean Bayash",
  lc: "rmr-x-bsa",
  ld: "ltr",
  alt: [],
  cc: ["HR"]
}, {
  pk: 7521,
  ang: "",
  lr: "Europe",
  gw: false,
  hc: "HR",
  ln: "Slavic Ludari Bayash",
  lc: "rmr-x-bsl",
  ld: "ltr",
  alt: [],
  cc: ["HR"]
}, {
  pk: 5390,
  ang: "Romanian Sign Language",
  lr: "Europe",
  gw: false,
  hc: "RO",
  ln: "Romanian Sign Language",
  lc: "rms",
  ld: "ltr",
  alt: ["Limbaj Mimico-Gestual Romanesc"],
  cc: ["RO"]
}, {
  pk: 5391,
  ang: "Domari",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u0632\u0628\u0627\u0646 \u062F\u0648\u0645\u0631\u06CC",
  lc: "rmt",
  ld: "ltr",
  alt: ["Ghorbati", "Near-Eastern Gypsy", "Dom", "Domra Magu Hiya", "Middle Eastern Romani", "Gypsy", "Luti", "Mehtar", "Tsigene", "Kurbati (Ghorbati)", "Nawar (Ghagar)"],
  cc: ["AF", "IR", "IQ", "IL", "SY", "TR", "JO", "LY", "UZ", "EG"]
}, {
  pk: 8308,
  ang: "Domari",
  lr: "Asia",
  gw: false,
  hc: "JO",
  ln: "Domari",
  lc: "rmt-JO-domari",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5392,
  ang: "Romani, Tavringer",
  lr: "Europe",
  gw: false,
  hc: "SE",
  ln: "Tavringer Romani",
  lc: "rmu",
  ld: "ltr",
  alt: ["Resande Romani", "Rommani", "Svensk Rommani", "Traveller Swedish"],
  cc: ["SE"]
}, {
  pk: 5393,
  ang: "",
  lr: "",
  gw: false,
  hc: "",
  ln: "Romanova",
  lc: "rmv",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5394,
  ang: "Romani, Welsh",
  lr: "Europe",
  gw: false,
  hc: "GB",
  ln: "Welsh Romani",
  lc: "rmw",
  ld: "ltr",
  alt: [],
  cc: ["GB"]
}, {
  pk: 5395,
  ang: "Romam",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "R\u01A1-m\u0103m",
  lc: "rmx",
  ld: "ltr",
  alt: ["Ro Mam"],
  cc: ["VN"]
}, {
  pk: 5396,
  ang: "Romani, Vlax",
  lr: "Europe",
  gw: false,
  hc: "RO",
  ln: "Vlax Romani",
  lc: "rmy",
  ld: "ltr",
  alt: ["Danubian", "Gypsy", "Tsigene", "Vlax", "Rom", "Romenes", "Tsigane", "Roman\xE9s", "Tsingani", "Romanese", "Vlax Romany", "Zigenare", "Machvano (Machvanmcko)", "South Albani", "Sinto", "Sievemakers", "Machwaya", "Lovari (Lovar\xEDcko)", "Kelderash\xEDcko", "Kalderash (Coppersmith)", "Serbo-Bosnian (Machvano)", "Gurbet", "Grekurja (Greco)", "Eastern Vlax Romani (Bisa)", "Churari (Churar\xEDcko)", "Arli", "Kalderash (Kaldar\xE1ri)"],
  cc: ["DZ", "BE", "BA", "BR", "AR", "FR", "DE", "GB", "AL", "NL", "NZ", "PK", "NO", "RO", "ZA", "SE", "CO", "US", "AU", "CA", "IT", "PT"]
}, {
  pk: 7523,
  ang: "",
  lr: "Europe",
  gw: false,
  hc: "RS",
  ln: "Vlach \u010Cergarski",
  lc: "rmy-x-vc",
  ld: "ltr",
  alt: [],
  cc: ["RS"]
}, {
  pk: 7520,
  ang: "",
  lr: "Europe",
  gw: false,
  hc: "RS",
  ln: "Vlach Gurbert",
  lc: "rmy-x-vg",
  ld: "ltr",
  alt: [],
  cc: ["RS"]
}, {
  pk: 7522,
  ang: "",
  lr: "Europe",
  gw: false,
  hc: "HR",
  ln: "Vlach Western Arli",
  lc: "rmy-x-vwa",
  ld: "ltr",
  alt: [],
  cc: ["HR"]
}, {
  pk: 5397,
  ang: "Marma",
  lr: "Asia",
  gw: false,
  hc: "BD",
  ln: "Marma",
  lc: "rmz",
  ld: "ltr",
  alt: ["Mogh"],
  cc: ["BD"]
}, {
  pk: 5398,
  ang: "Kirundi",
  lr: "Africa",
  gw: false,
  hc: "BI",
  ln: "Ikirundi",
  lc: "rn",
  ld: "ltr",
  alt: ["Urundi", "Ikinyabweru", "Ikiyogoma", "Ikiragane", "Ikibo", "Igisoni", "Ikirundi", "Ikimoso (Urumoso)"],
  cc: ["KE", "RW", "TZ", "CA", "UG", "BI"]
}, {
  pk: 5399,
  ang: "Ruund",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ruund",
  lc: "rnd",
  ld: "ltr",
  alt: ["Chilu Wunda", "Muatiamvua", "Northern Lunda", "Ruwund", "Chiluwunda", "Lunda Kambove", "Lunda-Kamboro", "Luwunda"],
  cc: ["CD"]
}, {
  pk: 5400,
  ang: "Ronga",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Ronga",
  lc: "rng",
  ld: "ltr",
  alt: ["Gironga", "Shironga", "Xironga"],
  cc: ["MZ", "ZA"]
}, {
  pk: 5401,
  ang: "Ranglong",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Ranglong",
  lc: "rnl",
  ld: "ltr",
  alt: ["Ronglong"],
  cc: ["IN"]
}, {
  pk: 5402,
  ang: "Roon",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Roon",
  lc: "rnn",
  ld: "ltr",
  alt: ["Ron"],
  cc: ["ID"]
}, {
  pk: 5403,
  ang: "Rongpo",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Rongpo",
  lc: "rnp",
  ld: "ltr",
  alt: ["Rang Po Bhasa", "Rangkas", "Rangpa", "Manchhi Bhassa", "Marchha", "Marchha Pahari", "Tolchha"],
  cc: ["IN"]
}, {
  pk: 5404,
  ang: "Rungwa",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Rungwa",
  lc: "rnw",
  ld: "ltr",
  alt: ["Ichirungwa", "Icilungwa", "Kirungwa", "Lungwa", "Runga"],
  cc: ["TZ"]
}, {
  pk: 5405,
  ang: "Romanian",
  lr: "Europe",
  gw: false,
  hc: "RO",
  ln: "limba rom\xE2n\u0103",
  lc: "ro",
  ld: "ltr",
  alt: ["Daco-Romanian", "Rumanian", "Moldavan", "Roumanian", "Daco-Rumanian", "Muntenian (Muntean)", "Muntenian (Walachian)", "Oltenia-Lesser Wallachia (Oltean)", "Walachian", "Boyash Romanian"],
  cc: ["AZ", "BE", "FR", "VE", "HU", "IL", "ES", "GB", "NZ", "RO", "TR", "US", "AU", "CA", "IT", "MD", "TM", "UZ", "IE"]
}, {
  pk: 5406,
  ang: "Tae\u2019",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tae'",
  lc: "rob",
  ld: "ltr",
  alt: ["East Toraja", "Luwu'", "Luwu-Rongkong", "Rongkong-Luwu", "Tae' Tae'", "Taeq", "Toraja Timur", "Toware", "Masamba", "Northeast Luwu (Bone-Bone)"],
  cc: ["ID"]
}, {
  pk: 5407,
  ang: "Roglai, Cacgia",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Cacgia Roglai",
  lc: "roc",
  ld: "ltr",
  alt: ["Ra-Glai"],
  cc: ["VN"]
}, {
  pk: 5408,
  ang: "Rogo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "t\xF2R\xF3g\xF3",
  lc: "rod",
  ld: "ltr",
  alt: ["Burogo", "Shiyabe", "toRogo", "Toshiyabe", "Ucanja Kamuku", "Urogo"],
  cc: ["NG"]
}, {
  pk: 5409,
  ang: "Ronji",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ronji",
  lc: "roe",
  ld: "ltr",
  alt: ["Gali", "Roinji"],
  cc: ["PG"]
}, {
  pk: 5410,
  ang: "Rombo",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Rombo",
  lc: "rof",
  ld: "ltr",
  alt: ["Kirombo", "Usseri"],
  cc: ["TZ"]
}, {
  pk: 5411,
  ang: "Roglai, Northern",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Ti\u1EBFng Ra Glai",
  lc: "rog",
  ld: "ltr",
  alt: ["Adlai", "La-Oang", "Noang", "Radlai", "Ra-Glai", "Rang Glai", "Rayglay"],
  cc: ["VN"]
}, {
  pk: 5412,
  ang: "Romblomanon",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Romblomanon",
  lc: "rol",
  ld: "ltr",
  alt: ["Bisaya'", "Sibuyanon"],
  cc: ["PH"]
}, {
  pk: 5413,
  ang: "Romany",
  lr: "Europe",
  gw: false,
  hc: "RO",
  ln: "Romany",
  lc: "rom",
  ld: "ltr",
  alt: [],
  cc: ["RO"]
}, {
  pk: 5414,
  ang: "Rotokas",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Rotokas",
  lc: "roo",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5415,
  ang: "Kriol",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Kriol",
  lc: "rop",
  ld: "ltr",
  alt: ["Roper-Bamyili Creole", "Roper River Kriol (Roper River Pidgin)"],
  cc: ["AU"]
}, {
  pk: 5416,
  ang: "Rongga",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Rongga",
  lc: "ror",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 5417,
  ang: "Runga",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Runga",
  lc: "rou",
  ld: "ltr",
  alt: ["Ayki", "Aykindang", "Rounga", "Runga de Ndele", "Roungo"],
  cc: ["CF", "TD"]
}, {
  pk: 5418,
  ang: "Dela-Oenale",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dela-Oenale",
  lc: "row",
  ld: "ltr",
  alt: ["Delha", "Oe Nale", "Rote", "Rote Barat", "Roti", "Rotinese", "Western Rote", "Dela (Delha)", "Oenale (Oe Nale)"],
  cc: ["ID"]
}, {
  pk: 5419,
  ang: "Repanbitip",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Repanbitip",
  lc: "rpn",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 5420,
  ang: "Rapting",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Rapting",
  lc: "rpt",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5421,
  ang: "Ririo",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Ririo",
  lc: "rri",
  ld: "ltr",
  alt: [],
  cc: ["SB"]
}, {
  pk: 5422,
  ang: "Waima",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Waima",
  lc: "rro",
  ld: "ltr",
  alt: ["Paitana"],
  cc: ["PG"]
}, {
  pk: 5423,
  ang: "Arritinngithigh",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Arritinngithigh",
  lc: "rrt",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 5424,
  ang: "Romano-Serbian",
  lr: "Europe",
  gw: false,
  hc: "RS",
  ln: "Romano-Serbian",
  lc: "rsb",
  ld: "ltr",
  alt: ["Tent Gypsy"],
  cc: ["RS"]
}, {
  pk: 5425,
  ang: "Russian Sign Language",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439 \u0436\u0435\u0441\u0442\u043E\u0432\u044B\u0439 \u044F\u0437\u044B\u043A",
  lc: "rsl",
  ld: "ltr",
  alt: [],
  cc: ["BY", "KZ", "TJ", "RU", "KG", "MD", "TM", "UZ"]
}, {
  pk: 5426,
  ang: "Chin, Rungtu",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Rungtu Chin",
  lc: "rtc",
  ld: "ltr",
  alt: ["Thaungtha"],
  cc: ["MM"]
}, {
  pk: 5427,
  ang: "Ratahan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ratahan",
  lc: "rth",
  ld: "ltr",
  alt: ["Bentenan", "Pasan", "Toratan"],
  cc: ["ID"]
}, {
  pk: 7543,
  ang: "Pasan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Pasan",
  lc: "rth-x-pasan",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 5428,
  ang: "Rotuman",
  lr: "Pacific",
  gw: false,
  hc: "FJ",
  ln: "Rotuman",
  lc: "rtm",
  ld: "ltr",
  alt: ["Rotuna", "Rutuman"],
  cc: ["FJ"]
}, {
  pk: 5429,
  ang: "Yurats",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "Yurats",
  lc: "rts",
  ld: "ltr",
  alt: [],
  cc: ["RU"]
}, {
  pk: 5430,
  ang: "Rathawi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Rathawi",
  lc: "rtw",
  ld: "ltr",
  alt: ["Bal-La", "Kohelia", "Rathwi"],
  cc: ["IN"]
}, {
  pk: 5431,
  ang: "Russian",
  lr: "Europe",
  gw: true,
  hc: "RU",
  ln: "\u0420\u0443\u0441\u0441\u043A\u0438\u0439",
  lc: "ru",
  ld: "ltr",
  alt: ["Eluosi", "Olossu", "Russ", "Russki", "Russit"],
  cc: ["AZ", "AT", "BE", "BY", "CL", "CN", "CU", "CY", "AR", "EE", "FR", "DE", "VE", "HU", "IL", "KZ", "MG", "PE", "GB", "CZ", "TJ", "LV", "MZ", "NL", "NZ", "PL", "RU", "SE", "US", "AU", "FI", "CA", "GE", "KP", "IT", "KG", "LT", "MD", "TM", "UZ", "BG", "IE", "UA"]
}, {
  pk: 5432,
  ang: "Gungu",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Gungu",
  lc: "rub",
  ld: "ltr",
  alt: ["Lugungu", "Rugungu"],
  cc: ["UG"]
}, {
  pk: 5433,
  ang: "Ruuli",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Ruuli",
  lc: "ruc",
  ld: "ltr",
  alt: ["Luduuli", "Ruluuli", "Ruluuli-Runyala", "Rurulim", "Runyala"],
  cc: ["UG"]
}, {
  pk: 5434,
  ang: "Rusyn",
  lr: "Europe",
  gw: false,
  hc: "UA",
  ln: "Rusyn",
  lc: "rue",
  ld: "ltr",
  alt: ["Carpathian", "Carpatho-Rusyn", "Lemkovschina", "Rusynski"],
  cc: ["PL", "UA"]
}, {
  pk: 5435,
  ang: "Luguru",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Luguru",
  lc: "ruf",
  ld: "ltr",
  alt: ["Guru", "Ikiruguru", "Kiluguru", "Kiruguru", "Lughuru", "Lugulu", "Ruguru"],
  cc: ["TZ"]
}, {
  pk: 5436,
  ang: "Roviana",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Roviana",
  lc: "rug",
  ld: "ltr",
  alt: ["Robiana", "Rubiana", "Ruviana"],
  cc: ["SB"]
}, {
  pk: 5437,
  ang: "Ruga",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Ruga",
  lc: "ruh",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 5438,
  ang: "Rufiji",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Rufiji",
  lc: "rui",
  ld: "ltr",
  alt: ["Fiji", "Kiruihi", "Ruihi"],
  cc: ["TZ"]
}, {
  pk: 5439,
  ang: "Kuce",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Che",
  lc: "ruk",
  ld: "ltr",
  alt: ["Bache", "Sale"],
  cc: ["NG"]
}, {
  pk: 5440,
  ang: "Romanian, Istro",
  lr: "Europe",
  gw: false,
  hc: "HR",
  ln: "Istro Romanian",
  lc: "ruo",
  ld: "ltr",
  alt: ["Istro-Romanian"],
  cc: ["HR"]
}, {
  pk: 5441,
  ang: "Aromanian",
  lr: "Europe",
  gw: false,
  hc: "GR",
  ln: "Macedo-Romanian",
  lc: "rup",
  ld: "ltr",
  alt: ["Armina", "Aromunian", "Arumanian", "Arumun", "Macedo Romanian", "Macedo-Rumanian", "Vlach", "Macedo", "Romanian", "Macedo Romania"],
  cc: ["GR", "AL"]
}, {
  pk: 5442,
  ang: "Romanian, Megleno",
  lr: "Europe",
  gw: false,
  hc: "GR",
  ln: "Megleno Romanian",
  lc: "ruq",
  ld: "ltr",
  alt: ["Meglenite", "Meglenitic"],
  cc: ["GR"]
}, {
  pk: 5443,
  ang: "Rutul",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0420\u0443\u0442\u0443\u043B\u044C\u0441\u043A\u0438\u0439",
  lc: "rut",
  ld: "ltr",
  alt: ["Chal", "Mukhad", "Myhynnynydy-ch'el", "Rutal", "Rutultsy", "Rutuly", "North Rutul (Asar-Kala)", "Vrush", "Shinaz", "Muxrek", "Luchek", "Khnov", "Ixrek", "South Rutul (Borch)"],
  cc: ["AZ", "RU"]
}, {
  pk: 5444,
  ang: "Lobu, Lanas",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Lanas Lobu",
  lc: "ruu",
  ld: "ltr",
  alt: ["Keningau Lobu", "Roomarrows", "Rumanau (Romanau)", "Rumanau Alab"],
  cc: ["MY"]
}, {
  pk: 5445,
  ang: "Mala",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Mala (Nigeria)",
  lc: "ruy",
  ld: "ltr",
  alt: ["Amala", "Rumaiya", "Tumala"],
  cc: ["NG"]
}, {
  pk: 5446,
  ang: "Ruma",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ruma",
  lc: "ruz",
  ld: "ltr",
  alt: ["Bagwama", "Rurama", "Turama"],
  cc: ["NG"]
}, {
  pk: 5447,
  ang: "Kinyarwanda",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ikinyarwanda",
  lc: "rw",
  ld: "ltr",
  alt: ["Ruanda", "Ikinyarwanda", "Orunyarwanda", "Rwandan", "Urunyaruanda", "Runyarwanda", "Shobyo", "Ululera", "Tshiga", "Rutwa (Twa)", "Ndogo", "Ndara", "Mulenge (Kinyamulenge)", "Kiga", "Ikinyanduga", "Ikigoyi", "Igikiga (Igishiru)", "Bwisha (Kinyabwisha)", "Hutu (Hera)", "Gitwa", "Lera", "Tshogo"],
  cc: ["RW", "TZ", "US", "CD", "CA", "UG", "BI"]
}, {
  pk: 5448,
  ang: "Rawo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Rawo",
  lc: "rwa",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5449,
  ang: "Rwa",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Rwa",
  lc: "rwk",
  ld: "ltr",
  alt: ["Kirwa", "Kirwo", "Rwo", "Kihai (Meru)"],
  cc: ["TZ"]
}, {
  pk: 5450,
  ang: "Amba",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Amba (Uganda)",
  lc: "rwm",
  ld: "ltr",
  alt: ["Hambo", "Humu", "Kuamba", "Kwamba", "Ruwenzori Kibira", "Rwamba", "Bulebule", "Hamba", "Ku-Amba", "Lubulebule", "Lwamba", "Suwa (Kusuwa)", "Kigumu (Hamba)", "Kyanzi (Kihyanzi)"],
  cc: ["UG"]
}, {
  pk: 5451,
  ang: "Rawa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Rawa",
  lc: "rwo",
  ld: "ltr",
  alt: ["Erawa", "Erewa"],
  cc: ["PG"]
}, {
  pk: 7656,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Karo",
  lc: "rwo-x-karo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5452,
  ang: "Marwari",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Marwari (India)",
  lc: "rwr",
  ld: "ltr",
  alt: ["Marvadi", "Marvari", "Marwadi", "Rajasthani", "Jaisalmeri", "Standard Marwari (Jodhpuri)"],
  cc: ["IN"]
}, {
  pk: 7777,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kinyabwisha",
  lc: "rw-x-kinyabwisha",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 5453,
  ang: "Ngardi",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Ngardi",
  lc: "rxd",
  ld: "ltr",
  alt: ["Boonara", "Bunara", "Buruwatung", "Kolo", "Kukuruba", "Manggai", "Munga", "Ngadi", "Ngari", "Nyardi", "Panara", "Puruwantung", "Waiangadi", "Waiangara", "Waiangari", "Wain-gara", "Walmala", "Wanayaga", "Warangari", "Waringari", "Wommana", "Woneiga"],
  cc: ["AU"]
}, {
  pk: 5454,
  ang: "Karuwali",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Karuwali",
  lc: "rxw",
  ld: "ltr",
  alt: ["Gara-wali", "Goore", "Karawalla", "Karorinje", "Kuriwalu", "Kurrawulla"],
  cc: ["AU"]
}, {
  pk: 5455,
  ang: "Amami-Oshima, Northern",
  lr: "Asia",
  gw: false,
  hc: "JP",
  ln: "\u5944\u7F8E\u5927\u5CF6\u5357\u90E8\u65B9\u8A00",
  lc: "ryn",
  ld: "ltr",
  alt: ["Northern Amami-Osima", "Oosima", "Oshima", "Osima"],
  cc: ["JP"]
}, {
  pk: 5456,
  ang: "Yaeyama",
  lr: "Asia",
  gw: false,
  hc: "JP",
  ln: "\u516B\u91CD\u5C71\u7269\u8A00",
  lc: "rys",
  ld: "ltr",
  alt: ["Yayeyama"],
  cc: ["JP"]
}, {
  pk: 5457,
  ang: "Okinawan, Central",
  lr: "Asia",
  gw: false,
  hc: "JP",
  ln: "\u6C96\u7E04\u53E3/\u30A6\u30C1\u30CA\u30FC\u30B0\u30C1",
  lc: "ryu",
  ld: "ltr",
  alt: ["Luchu"],
  cc: ["JP", "US", "BO"]
}, {
  pk: 5458,
  ang: "Sanskrit (Sa\u1E41sk\u1E5Bta)",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "\u0938\u0902\u0938\u094D\u0915\u0943\u0924\u092E\u094D",
  lc: "sa",
  ld: "ltr",
  alt: ["Deva Bhasha", "Deva vani", "Sanskrit bhasha"],
  cc: ["IN"]
}, {
  pk: 5459,
  ang: "Saba",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Saba",
  lc: "saa",
  ld: "ltr",
  alt: ["Jelkung"],
  cc: ["TD"]
}, {
  pk: 5460,
  ang: "Buglere",
  lr: "Americas",
  gw: false,
  hc: "PA",
  ln: "Buglere",
  lc: "sab",
  ld: "ltr",
  alt: ["Bobota", "Bocota", "Bofota", "Bogota", "Bokota", "Bukueta", "Murire", "Nortenyo", "Veraguas Sabanero"],
  cc: ["PA"]
}, {
  pk: 5461,
  ang: "Meskwaki",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Meskwaki",
  lc: "sac",
  ld: "ltr",
  alt: ["Sac and Fox", "Sauk-Fox"],
  cc: ["US"]
}, {
  pk: 5462,
  ang: "Sandawe",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Sandawe",
  lc: "sad",
  ld: "ltr",
  alt: ["Kisandawe", "Sandaui", "Sandaweeki", "Sandwe", "Eastern Sandawe", "Western Sandawe"],
  cc: ["TZ"]
}, {
  pk: 5463,
  ang: "Saban\xEA",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Saban\xEA",
  lc: "sae",
  ld: "ltr",
  alt: ["Saban\xEAs Sabones", "Sowainte"],
  cc: ["BR"]
}, {
  pk: 5464,
  ang: "Safaliba",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Safaliba",
  lc: "saf",
  ld: "ltr",
  alt: ["Safalaba", "Safalba", "Safali"],
  cc: ["GH"]
}, {
  pk: 5465,
  ang: "Yakut",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u042F\u043A\u0443\u0442\u0441\u043A\u0438\u0439",
  lc: "sah",
  ld: "ltr",
  alt: ["Sakha", "Yakut-Sakha", "Dolgan", "Middlekolymskyi", "Olemkinskyi", "Vilyiskyi"],
  cc: ["CN", "RU"]
}, {
  pk: 5466,
  ang: "Sahu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sahu",
  lc: "saj",
  ld: "ltr",
  alt: ["Sahu'u", "Sau", "Sa'u", "Pa'disua (Palisua)"],
  cc: ["ID"]
}, {
  pk: 5467,
  ang: "Sake",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Sake",
  lc: "sak",
  ld: "ltr",
  alt: ["Asake", "Shake"],
  cc: ["GA"]
}, {
  pk: 5468,
  ang: "Samaritan Aramaic",
  lr: "Asia",
  gw: false,
  hc: "PS",
  ln: "Samaritan Aramaic",
  lc: "sam",
  ld: "ltr",
  alt: [],
  cc: ["PS"]
}, {
  pk: 5469,
  ang: "Sause",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sause",
  lc: "sao",
  ld: "ltr",
  alt: ["Seuce"],
  cc: ["ID"]
}, {
  pk: 5470,
  ang: "Samburu",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Samburu",
  lc: "saq",
  ld: "ltr",
  alt: ["Burkeneji", "E Lokop", "Lokop", "Nkutuk", "Sambur", "Sampur", "Njemps", "Chamus (Ilcamus)"],
  cc: ["KE"]
}, {
  pk: 5471,
  ang: "Sasak",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sasak",
  lc: "sas",
  ld: "ltr",
  alt: ["Lombok", "Ngeno-Ngene (Central East Sasak)", "Ngeto-Ngete (Northeast Sasak)", "Mriak-Mriku (Central South Sasak)", "Meno-Mene (Central Sasak)", "Kuto-Kute (North Sasak)", "Central West Sasak"],
  cc: ["ID"]
}, {
  pk: 5472,
  ang: "Santhali",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Santali",
  lc: "sat",
  ld: "ltr",
  alt: ["Har", "Hor", "Sandal", "Sangtal", "Santal", "Satar", "Sonthal", "Samtali", "Santhiali", "Sentali", "Sainti", "Santhal", "Mahali (Mahle)", "Karmali (Khole)"],
  cc: ["BD", "BT", "NP", "IN"]
}, {
  pk: 5473,
  ang: "Saleman",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Saleman",
  lc: "sau",
  ld: "ltr",
  alt: ["Hatue", "Sawai", "Seleman", "Wahai"],
  cc: ["ID"]
}, {
  pk: 5474,
  ang: "Saafi-Saafi",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Saafi-Saafi",
  lc: "sav",
  ld: "ltr",
  alt: ["Saafi", "Safen", "Safi", "Sereer Saafen", "Serere-Saafen", "Serer-Safen", "Sindia", "Boukhou", "Diobass", "Hasab", "Sebikotane"],
  cc: ["SN"]
}, {
  pk: 5475,
  ang: "Sawi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sawi",
  lc: "saw",
  ld: "ltr",
  alt: ["Aejauroh", "Sawuy"],
  cc: ["ID"]
}, {
  pk: 8316,
  ang: "Sawi Erary",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sawi Erary",
  lc: "saw-x-erary",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8322,
  ang: "Sawi Ayamon",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sawi Ayamon",
  lc: "saw-x-sawiayamon",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8324,
  ang: "Sawi Erary",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sawi Erary",
  lc: "saw-x-sawierary",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5476,
  ang: "Sa",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Sa",
  lc: "sax",
  ld: "ltr",
  alt: ["Saa", "Ponorwal (South Raga)"],
  cc: ["VU"]
}, {
  pk: 5477,
  ang: "Saya",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Zaar",
  lc: "say",
  ld: "ltr",
  alt: ["Sayanci", "Sayara", "Sayawa", "Seiyara", "Seya", "Vikzar", "Kal", "Zaar (Gambar Leere)", "Vigzar", "Sugudi", "Sigidi (Segiddi)", "Sigdi", "Lusa"],
  cc: ["NG"]
}, {
  pk: 5478,
  ang: "Saurashtra",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Saurashtra",
  lc: "saz",
  ld: "ltr",
  alt: ["Patnuli", "Saurashtri", "Sourashtra", "Sowrashtra"],
  cc: ["IN"]
}, {
  pk: 5479,
  ang: "Ngambay",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Ngambay",
  lc: "sba",
  ld: "ltr",
  alt: ["Gamba", "Gambai", "Gambaye", "Gamb-Lai", "Sara", "Sara Ngambai", "Gamblai", "Murum (Mouroum)", "Bemar (Daba de Gor\xE9)"],
  cc: ["SD", "TD"]
}, {
  pk: 5480,
  ang: "Simbo",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Simbo",
  lc: "sbb",
  ld: "ltr",
  alt: ["Madeggusu", "Mandeghughusu", "Sibo"],
  cc: ["SB"]
}, {
  pk: 5481,
  ang: "Kele",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kele (Papua New Guinea)",
  lc: "sbc",
  ld: "ltr",
  alt: ["Gele'"],
  cc: ["PG"]
}, {
  pk: 5482,
  ang: "Samo, Southern",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Southern Samo",
  lc: "sbd",
  ld: "ltr",
  alt: ["San", "Sane", "Nyaana", "Toma (Makaa)"],
  cc: ["BF"]
}, {
  pk: 5483,
  ang: "Saliba",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Saliba",
  lc: "sbe",
  ld: "ltr",
  alt: ["Loga"],
  cc: ["PG"]
}, {
  pk: 5484,
  ang: "Shabo",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Chabu",
  lc: "sbf",
  ld: "ltr",
  alt: ["Sabu", "Mekeyer", "Mikair", "Mikeyir", "Shako"],
  cc: ["ET"]
}, {
  pk: 5485,
  ang: "Seget",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Seget",
  lc: "sbg",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 5486,
  ang: "Sori-Harengan",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sori-Harengan",
  lc: "sbh",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5487,
  ang: "Seti",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Seti",
  lc: "sbi",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5488,
  ang: "Surbakhal",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Surbakhal",
  lc: "sbj",
  ld: "ltr",
  alt: ["Sourbakhal"],
  cc: ["TD"]
}, {
  pk: 5489,
  ang: "Safwa",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Safwa",
  lc: "sbk",
  ld: "ltr",
  alt: ["Cisafwa", "Ishisafwa", "Kisafwa", "Shisafwa", "Mbwila (Ulenje)", "Central Safwa", "Guruka (Shisafwa)"],
  cc: ["TZ"]
}, {
  pk: 5490,
  ang: "Sambal, Botolan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Botolan Sambal",
  lc: "sbl",
  ld: "ltr",
  alt: ["Aeta Negrito", "Ayta Hambali", "Botolan Zambal", "Ayta Hambali (Hambali Botolan)", "Sambali Botolan"],
  cc: ["PH"]
}, {
  pk: 5491,
  ang: "Sagala",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Sagala",
  lc: "sbm",
  ld: "ltr",
  alt: ["Kisagala", "Kisagara", "Sagara", "Southern Kisagala", "Kondoa (Solwe)", "Kwiva", "Nkwifiya (Kwifa)"],
  cc: ["TZ"]
}, {
  pk: 5492,
  ang: "Sindhi Bhil",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u0633\u0646\u062F\u06BE\u06CC \u0632\u0628\u0627\u0646",
  lc: "sbn",
  ld: "ltr",
  alt: [],
  cc: ["PK"]
}, {
  pk: 5493,
  ang: "Sab\xFCm",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Sab\xFCm",
  lc: "sbo",
  ld: "ltr",
  alt: [],
  cc: ["MY"]
}, {
  pk: 5494,
  ang: "Sangu",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Sangu",
  lc: "sbp",
  ld: "ltr",
  alt: ["Eshisango", "Kisangu", "Lori", "Rori", "Sangi", "Sango", "Shisango", "Central Sangu", "Eastern Sangu (Mahango)", "Northern Sangu", "South-Central Sangu (Kapunga)", "Western Sangu (Kilambo)"],
  cc: ["TZ"]
}, {
  pk: 5495,
  ang: "Sileibi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sileibi",
  lc: "sbq",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5496,
  ang: "Sembakung Murut",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sembakung Murut",
  lc: "sbr",
  ld: "ltr",
  alt: ["Sembakoeng", "Sembakong", "Simbakong", "Tingalun", "Tinggalan", "Tinggalum", "Tidoeng", "Tidong", "Tidung"],
  cc: ["ID", "MY"]
}, {
  pk: 7884,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Sane",
  lc: "sbr-x-dayaksane",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7885,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Mudu",
  lc: "sbr-x-mudu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7886,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Senganan",
  lc: "sbr-x-senganan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5497,
  ang: "Kuhane",
  lr: "Africa",
  gw: false,
  hc: "NA",
  ln: "Subiya",
  lc: "sbs",
  ld: "ltr",
  alt: ["Chikuhane", "Echisubia", "Kuahane", "Kwahane", "Sesubea", "Subia", "Supia", "Chikuahane", "Chikwahane", "Ciikuhane", "Mbalangwe"],
  cc: ["ZM", "BW", "NA"]
}, {
  pk: 7807,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "BW",
  ln: "Chiikuhane",
  lc: "sbs-x-chiikuhane",
  ld: "ltr",
  alt: [],
  cc: ["BW"]
}, {
  pk: 5498,
  ang: "Kimki",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kimki",
  lc: "sbt",
  ld: "ltr",
  alt: ["Aipki", "Kimgi", "Sukubatom", "Sukubatong"],
  cc: ["ID"]
}, {
  pk: 5499,
  ang: "Stod Bhoti",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Stod Bhoti",
  lc: "sbu",
  ld: "ltr",
  alt: ["Lahul Bhoti", "Stod-Kad", "Tod", "Tod-Kad", "Mayari", "Stod (Kolong)", "Khoksar (Khoksar Bhoti)", "Mayar (Mayar Bhoti)"],
  cc: ["IN"]
}, {
  pk: 5500,
  ang: "Sabine",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Sabine",
  lc: "sbv",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 5501,
  ang: "Simba",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Simba",
  lc: "sbw",
  ld: "ltr",
  alt: ["Nsindak"],
  cc: ["GA"]
}, {
  pk: 5502,
  ang: "Seberuang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Seberuang",
  lc: "sbx",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 7547,
  ang: "Desa Kayan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Desa Kayan",
  lc: "sbx-x-desa",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 5503,
  ang: "Soli",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Soli",
  lc: "sby",
  ld: "ltr",
  alt: ["Chisoli"],
  cc: ["ZM"]
}, {
  pk: 5504,
  ang: "Sara Kaba",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Sara Kaba",
  lc: "sbz",
  ld: "ltr",
  alt: ["Ta Sara"],
  cc: ["CF"]
}, {
  pk: 5505,
  ang: "Sardinian",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "sardu",
  lc: "sc",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 5506,
  ang: "Chut",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Chut",
  lc: "scb",
  ld: "ltr",
  alt: ["Salang", "Ruc (Kha Mu Gia)", "Tac Cui"],
  cc: ["LA", "VN"]
}, {
  pk: 5507,
  ang: "Dongxiang",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4E1C\u4E61\u8BED",
  lc: "sce",
  ld: "ltr",
  alt: ["Santa", "Tung", "Tunghsiang", "Suonanba (Xiaonan)"],
  cc: ["CN"]
}, {
  pk: 5508,
  ang: "San Miguel Creole French",
  lr: "Americas",
  gw: false,
  hc: "PA",
  ln: "San Miguel Creole French",
  lc: "scf",
  ld: "ltr",
  alt: [],
  cc: ["PA"]
}, {
  pk: 5509,
  ang: "Sanggau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sanggau",
  lc: "scg",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 7945,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Cupang Sembilan Domong",
  lc: "scg-x-cupangsembilan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8088,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Dosatn",
  lc: "scg-x-dayakdosatn",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8104,
  ang: "Dayak Katarak",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Katarak",
  lc: "scg-x-dayakkatarak",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7904,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Koman",
  lc: "scg-x-dayakkoman",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8155,
  ang: "Dayak Mentrap",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Mentrap",
  lc: "scg-x-dayakmentrap",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8161,
  ang: "Dayak Tebang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Tebang",
  lc: "scg-x-dayaktebang",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7890,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Koman",
  lc: "scg-x-koman",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8013,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Lebang Hilir",
  lc: "scg-x-lebanghilir",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8099,
  ang: "Linoh",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Linoh",
  lc: "scg-x-linoh",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7905,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Mayau",
  lc: "scg-x-mayau",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7889,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sekujam",
  lc: "scg-x-sekuiam",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7960,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Semerawai",
  lc: "scg-x-semerawai",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5510,
  ang: "Sakachep",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Sakachep",
  lc: "sch",
  ld: "ltr",
  alt: ["Sankechep", "Thangkachep"],
  cc: ["IN"]
}, {
  pk: 5511,
  ang: "Sri Lankan Creole Malay",
  lr: "Asia",
  gw: false,
  hc: "LK",
  ln: "Sri Lankan Creole Malay",
  lc: "sci",
  ld: "ltr",
  alt: ["Java Jati", "Melayu Bahasa", "Sri Lankan Malay"],
  cc: ["LK"]
}, {
  pk: 5512,
  ang: "Sadri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Sadri",
  lc: "sck",
  ld: "ltr",
  alt: ["Chota Nagpuri", "Dikku Kaji", "Ganwari", "Gauuari", "Goari", "Jharkhandhi", "Nagpuri", "Nagpuria", "Sadan", "Sadana", "Sadani", "Sadari", "Sadati", "Sadhan", "Sadhari", "Sadna", "Sadrik", "Santri", "Siddri", "Sradri"],
  cc: ["BD", "NP", "IN"]
}, {
  pk: 5513,
  ang: "Shina",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u0634\u06CC\u0646\u0627",
  lc: "scl",
  ld: "ltr",
  alt: ["Shinaki", "Sina", "Brokpa", "Harban", "Tangir", "Sazin", "Satpara", "Rondu", "Punial", "Hunza-Nagar", "Bunji", "Kharmangi", "Astori (Astor)", "Haramosh", "Chilasi Kohistani (Chilas)", "Darel", "Dras", "Gilgit", "Gilgiti (Bagrote)"],
  cc: ["AF", "PK", "IN"]
}, {
  pk: 5514,
  ang: "Sicilian",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Sicilian",
  lc: "scn",
  ld: "ltr",
  alt: ["Calabro-Sicilian", "Sicilianu", "Siculu", "Trapani", "Western Sicilian (Central-Western Agrigentino)", "Palermo"],
  cc: ["IT"]
}, {
  pk: 5515,
  ang: "Scots",
  lr: "Europe",
  gw: false,
  hc: "GB",
  ln: "Scots",
  lc: "sco",
  ld: "ltr",
  alt: [],
  cc: ["GB"]
}, {
  pk: 5516,
  ang: "Helambu Sherpa",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Helambu Sherpa",
  lc: "scp",
  ld: "ltr",
  alt: ["Hyolmo", "Yholmo", "Yohlmu Tam", "Yolmo", "Lamjung Yohlmo", "LangDang Yohlmo"],
  cc: ["NP"]
}, {
  pk: 5517,
  ang: "Sa\u2019och",
  lr: "Asia",
  gw: false,
  hc: "KH",
  ln: "Sa'och",
  lc: "scq",
  ld: "ltr",
  alt: ["Saotch", "Sauch"],
  cc: ["KH"]
}, {
  pk: 5518,
  ang: "Slavey, North",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "North Slavey",
  lc: "scs",
  ld: "ltr",
  alt: ["Dene", "Den\xE9", "Mackenzian", "Slave", "Mountain Slavey"],
  cc: ["CA"]
}, {
  pk: 5519,
  ang: "Shumcho",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Shumcho",
  lc: "scu",
  ld: "ltr",
  alt: ["Central Kinnauri", "Shumcu", "Sumcho", "Sumchu", "Sumtsu", "Thebarskad", "Thebor", "Theb\xF6r Skadd"],
  cc: ["IN"]
}, {
  pk: 5520,
  ang: "Sheni",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Sheni",
  lc: "scv",
  ld: "ltr",
  alt: ["Shaini", "Shani", "Shenanci"],
  cc: ["NG"]
}, {
  pk: 5521,
  ang: "Sha",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Sha",
  lc: "scw",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 5522,
  ang: "Sicel",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Sicel",
  lc: "scx",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 5523,
  ang: "Sindhi",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u0938\u093F\u0928\u094D\u0927\u0940, \u0633\u0646\u068C\u064A\u060C \u0633\u0646\u062F\u06BE\u06CC\u200E",
  lc: "sd",
  ld: "ltr",
  alt: ["Vicholo (Central Sindhi)", "Vicholi", "Sindhi Musalmani (Muslim Sindhi)", "Shikari Bhil", "Dukslinu (Hindu Sindhi)", "Katiawari Kachi"],
  cc: ["AF", "GB", "MY", "OM", "PK", "US", "CA", "IN", "SG", "AE"]
}, {
  pk: 5524,
  ang: "Toraja-Sa\u2019dan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Toraja-Sa'dan",
  lc: "sda",
  ld: "ltr",
  alt: ["Sada", "Sadan", "Sa'dan", "Sadang", "Sa'dansche", "South Toraja", "Tae'", "Taeq", "Toradja", "Makale (Tallulembangna)", "West Toraja", "Toraja Barat (Mappa-Pana)", "Rantepao (Kesu')"],
  cc: ["ID"]
}, {
  pk: 5525,
  ang: "Shabak",
  lr: "Asia",
  gw: false,
  hc: "IQ",
  ln: "\u0634\u06D5\u0628\u06D5\u06A9\u06CC",
  lc: "sdb",
  ld: "ltr",
  alt: [],
  cc: ["IQ"]
}, {
  pk: 5526,
  ang: "Sardinian, Sassarese",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Sassarese Sardinian",
  lc: "sdc",
  ld: "ltr",
  alt: ["Northwestern Sardinian", "Sassarese"],
  cc: ["IT"]
}, {
  pk: 5527,
  ang: "Surubu",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kuvori",
  lc: "sde",
  ld: "ltr",
  alt: ["Fiti", "Skrubu", "Srubu", "Zurubu"],
  cc: ["NG"]
}, {
  pk: 5528,
  ang: "Sarli",
  lr: "Asia",
  gw: false,
  hc: "IQ",
  ln: "\u0633\u0627\u0631\u0644\u06CC",
  lc: "sdf",
  ld: "ltr",
  alt: ["Sarliya"],
  cc: ["IQ"]
}, {
  pk: 5529,
  ang: "Savi",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Savi",
  lc: "sdg",
  ld: "ltr",
  alt: ["Sau", "Sawi"],
  cc: ["AF"]
}, {
  pk: 5530,
  ang: "Kurdish, Southern",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u06A9\u0648\u0631\u062F\u06CC \u062E\u0648\u0627\u0631\u06AF",
  lc: "sdh",
  ld: "ltr",
  alt: ["Bayray", "Feyli", "Garrusi (Bijari)", "Kalhori", "Kermanshahi (Kermanshani)", "Kolyai", "Kordali", "Luri", "Maleksh ahi (Maleksh ay)", "Malekshahi (Maleksh ay)", "Sanjabi"],
  cc: ["IR"]
}, {
  pk: 7665,
  ang: "Kalhori",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u06AF\u0648\u06CC\u0634\u200C\u0647\u0627\u06CC \u062C\u0646\u0648\u0628\u06CC \u06A9\u0631\u062F\u06CC",
  lc: "sdh-x-kalhori",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5531,
  ang: "Suundi",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Suundi",
  lc: "sdj",
  ld: "ltr",
  alt: ["Kissoundi", "Kisuundi", "Suundi de Kimongo", "Kisuundi kya Mayama", "Kisuundi kya Ngwaari", "Kisuundi kya Nkeleke"],
  cc: ["CG"]
}, {
  pk: 5532,
  ang: "Sos Kundi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sos Kundi",
  lc: "sdk",
  ld: "ltr",
  alt: ["Agbane", "Agbanekundi", "Akbana", "Soskundi"],
  cc: ["PG"]
}, {
  pk: 5533,
  ang: "Saudi Arabian Sign Language",
  lr: "Asia",
  gw: false,
  hc: "SA",
  ln: "\u0644\u063A\u0629 \u0627\u0644\u0625\u0634\u0627\u0631\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629",
  lc: "sdl",
  ld: "ltr",
  alt: [],
  cc: ["SA"]
}, {
  pk: 5534,
  ang: "Semandang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Semandang",
  lc: "sdm",
  ld: "ltr",
  alt: ["Kualan-Semandang", "Komi"],
  cc: ["ID"]
}, {
  pk: 8159,
  ang: "Dayak Beginci",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Beginci",
  lc: "sdm-x-beginci",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8145,
  ang: "Dayak Bihak",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Bihak",
  lc: "sdm-x-dayakbihak",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8158,
  ang: "Dayak Gerai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Gerai",
  lc: "sdm-x-dayakgerai",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8190,
  ang: "Dayak Kualant",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Kualant",
  lc: "sdm-x-kualant",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8160,
  ang: "Dayak Pangkalan Suka",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Pangkalan Suka",
  lc: "sdm-x-pangkalsuka",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8329,
  ang: "Dayak Sekucing Kualan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Sekucing Kualan",
  lc: "sdm-x-sekucngkua",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5535,
  ang: "Sardinian, Gallurese",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Gallurese Sardinian",
  lc: "sdn",
  ld: "ltr",
  alt: ["Gallurese", "Northeastern Sardinian"],
  cc: ["IT"]
}, {
  pk: 5536,
  ang: "Bidayuh, Bukar-Sadong",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Bukar-Sadung Bidayuh",
  lc: "sdo",
  ld: "ltr",
  alt: ["Buka", "Bukar", "Bukar Sadung Bidayah", "Sabutan", "Sadong", "Serian", "Tebakang", "Sadung", "Bideyu", "Bukar Bidayuh (Bidayah)", "Bukar Sadung Bidayuh"],
  cc: ["ID", "MY"]
}, {
  pk: 8107,
  ang: "Dayak Tatoong",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Tatoong",
  lc: "sdo-x-dayaktatoong",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7909,
  ang: "Dayak Ntuka",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Ntuka",
  lc: "sdo-x-mentukar",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5537,
  ang: "Sherdukpen",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Sherdukpen",
  lc: "sdp",
  ld: "ltr",
  alt: ["Ngnok"],
  cc: ["IN"]
}, {
  pk: 5538,
  ang: "Sadri, Oraon",
  lr: "Asia",
  gw: false,
  hc: "BD",
  ln: "Oraon Sadri",
  lc: "sdr",
  ld: "ltr",
  alt: [],
  cc: ["BD"]
}, {
  pk: 5539,
  ang: "Sarudu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sarudu",
  lc: "sdu",
  ld: "ltr",
  alt: ["Doda'", "Kulu (Lariang)"],
  cc: ["ID"]
}, {
  pk: 5540,
  ang: "Melanau, Sibu",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Sibu Melanau",
  lc: "sdx",
  ld: "ltr",
  alt: ["Seduan-Banyok", "Siduan", "Siduani"],
  cc: ["MY"]
}, {
  pk: 5541,
  ang: "Sallands",
  lr: "Europe",
  gw: false,
  hc: "NL",
  ln: "Sallands",
  lc: "sdz",
  ld: "ltr",
  alt: ["Sallan", "Salland"],
  cc: ["NL"]
}, {
  pk: 5542,
  ang: "Northern Sami",
  lr: "Europe",
  gw: false,
  hc: "NO",
  ln: "Davvis\xE1megiella",
  lc: "se",
  ld: "ltr",
  alt: ["Davvin", "Northern Lapp", "Saame", "Same", "Lapp", "Northern Saami", "Saami", "S\xE1megiella", "Samic", "Northern Lappish", "Norwegian Lapp", "Norwegian Saami"],
  cc: ["NO", "SE", "FI"]
}, {
  pk: 5543,
  ang: "Semai",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Semai",
  lc: "sea",
  ld: "ltr",
  alt: ["Sengoi", "Seng'oi", "Senoi", "Central Sakai", "Cameron (Cameron Highlands)", "Gopeng", "Parit", "Tanjung Malim", "Tapah (Jalan Pahang)", "Ulu Kampar (Kampar)"],
  cc: ["MY"]
}, {
  pk: 5544,
  ang: "S\xE9noufo, Shempire",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Shempire Senoufo",
  lc: "seb",
  ld: "ltr",
  alt: ["Shenpire", "Syempire", "Gbajere"],
  cc: ["CI"]
}, {
  pk: 5545,
  ang: "Sechelt",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Sechelt",
  lc: "sec",
  ld: "ltr",
  alt: [],
  cc: ["CA"]
}, {
  pk: 5546,
  ang: "Sedang",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Ti\u1EBFng X\u01A1 \u0110\u0103ng",
  lc: "sed",
  ld: "ltr",
  alt: ["Cadong", "Dang", "Hadang", "Hdang", "Hotea", "Hoteang", "Kmrang", "Rotea", "Roteang", "Tang", "Xa", "Xodang"],
  cc: ["LA", "VN"]
}, {
  pk: 5547,
  ang: "Seneca",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Seneca",
  lc: "see",
  ld: "ltr",
  alt: [],
  cc: ["US", "CA"]
}, {
  pk: 5548,
  ang: "S\xE9noufo, Cebaara",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Cebaara Senoufo",
  lc: "sef",
  ld: "ltr",
  alt: ["Senadi", "Senari", "Syenere", "Tiebaara", "Tyebala", "Kandere (Tengrela)", "Takpasyeeri (Messeni)", "Tagbari (Mbengui-Niell\xE9)"],
  cc: ["CI"]
}, {
  pk: 5549,
  ang: "Segeju",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Segeju",
  lc: "seg",
  ld: "ltr",
  alt: ["Kisegeju", "Sageju", "Sengeju"],
  cc: ["TZ"]
}, {
  pk: 5550,
  ang: "Sena",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Sena",
  lc: "seh",
  ld: "ltr",
  alt: ["Chisena", "Cisena", "Podzo (Chipodzo)", "Shiputhsu", "Sare", "Puthsu", "Phodzo", "North Sena", "Cipodzo", "Caia (Care)", "Bangwe (South Sena)", "Rue (Chirue)"],
  cc: ["MZ", "ZW"]
}, {
  pk: 5551,
  ang: "Seri",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Seri",
  lc: "sei",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 5552,
  ang: "Sekani",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Sekani",
  lc: "sek",
  ld: "ltr",
  alt: [],
  cc: ["CA"]
}, {
  pk: 5553,
  ang: "Selkup",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0421\u0435\u043B\u044C\u043A\u0443\u043F\u0441\u043A\u0438\u0439",
  lc: "sel",
  ld: "ltr",
  alt: ["Central Selkups", "Chumyl' Khumyt", "Northern Selkups", "Ostyak Samoyed", "Sh\xF6l Khumyt", "Sh\xF6sh Gulla", "Syusugulla", "Tym (Kety)", "Narym (Central Selkup)", "Srednyaya Ob-Ket (Southern Sel'kup)", "Taz (Northern Sel'kup)", "Tazov-Baishyan"],
  cc: ["RU"]
}, {
  pk: 5554,
  ang: "S\xE9noufo, Nanerig\xE9",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Nanerig\xE9 S\xE9noufo",
  lc: "sen",
  ld: "ltr",
  alt: ["Naani", "Nandereke", "Nanderg\xE9", "Nanerg\xE9", "Nanergu\xE9"],
  cc: ["BF"]
}, {
  pk: 5555,
  ang: "Suarmin",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Suarmin",
  lc: "seo",
  ld: "ltr",
  alt: ["Akiapmin", "Duranmin"],
  cc: ["PG"]
}, {
  pk: 5556,
  ang: "S\xE9noufo, S\xECc\xECt\xE9",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "S\xECc\xECt\xE9 S\xE9noufo",
  lc: "sep",
  ld: "ltr",
  alt: ["S\xECc\xECr\xE9", "S\xECc\xECt\xE9", "S\xECp\xEC\xECt\xE9", "Sucite", "Tagba"],
  cc: ["BF"]
}, {
  pk: 5557,
  ang: "S\xE9noufo, Senara",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Senara S\xE9noufo",
  lc: "seq",
  ld: "ltr",
  alt: ["Niangolo", "S\xE9noufo"],
  cc: ["BF"]
}, {
  pk: 5558,
  ang: "Serrano",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Serrano",
  lc: "ser",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 5559,
  ang: "Songhay, Koyraboro Senni",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Koyraboro Senni Songhai",
  lc: "ses",
  ld: "ltr",
  alt: ["East Songhay", "Gao Songhay", "Koroboro Senni", "Koyra Senni", "Koyra Senni Songhay", "Songai", "Songay", "Songay Senni", "Songhai", "Songhay", "Songoi", "Songoy", "Sonrai", "Sonrhai", "Gao", "Fulan Kirya"],
  cc: ["BJ", "BF", "GH", "ML", "NE"]
}, {
  pk: 5560,
  ang: "Sentani",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sentani",
  lc: "set",
  ld: "ltr",
  alt: ["Buyaka"],
  cc: ["ID"]
}, {
  pk: 8030,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Central Sentani",
  lc: "set-x-csentani",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 8031,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "East Sentani",
  lc: "set-x-esentani",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 8032,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "West Sentani",
  lc: "set-x-wsentani",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 5561,
  ang: "Serui-Laut",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Serui-Laut",
  lc: "seu",
  ld: "ltr",
  alt: ["Arui"],
  cc: ["ID"]
}, {
  pk: 5562,
  ang: "S\xE9noufo, Nyarafolo",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Nyarafolo Senoufo",
  lc: "sev",
  ld: "ltr",
  alt: ["Niarafolo"],
  cc: ["CI"]
}, {
  pk: 5563,
  ang: "Sewa Bay",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sewa Bay",
  lc: "sew",
  ld: "ltr",
  alt: ["Duau Pwata"],
  cc: ["PG"]
}, {
  pk: 8249,
  ang: "Bokera",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bokera",
  lc: "sew-x-bokera",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8251,
  ang: "Darubia",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Darubia",
  lc: "sew-x-darubia",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8250,
  ang: "Miadeba",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Miadeba",
  lc: "sew-x-miadeba",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8252,
  ang: "Sawataitai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sawataitai",
  lc: "sew-x-sawataitai",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5564,
  ang: "Secoya",
  lr: "Americas",
  gw: false,
  hc: "EC",
  ln: "Secoya",
  lc: "sey",
  ld: "ltr",
  alt: ["Encabellao", "Pioj\xE9"],
  cc: ["PE", "EC"]
}, {
  pk: 5565,
  ang: "Chin, Senthang",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Senthang Chin",
  lc: "sez",
  ld: "ltr",
  alt: ["Hsemtang", "Sakta", "Surkhua/Lungrang", "Shoneshi (Shonshe)", "Phaipha", "Lei-Um", "Khuapi", "Central Senthang (Bungzung)", "Shonshe"],
  cc: ["MM"]
}, {
  pk: 5566,
  ang: "French Belgian Sign Language",
  lr: "Europe",
  gw: false,
  hc: "BE",
  ln: "Langue des signes de Belgique Francophone",
  lc: "sfb",
  ld: "ltr",
  alt: ["Langue des Signes Belge Francophone", "LSBF", "LSFB"],
  cc: ["BE"]
}, {
  pk: 5567,
  ang: "Subanen, Eastern",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Eastern Subanen",
  lc: "sfe",
  ld: "ltr",
  alt: ["Guinselugnen"],
  cc: ["PH"]
}, {
  pk: 5568,
  ang: "Miao, Small Flowery",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5C0F\u82B1\u82D7",
  lc: "sfm",
  ld: "ltr",
  alt: ["Atse", "Ghab-Mvb Ghab-Svd", "Ghuab-Hmongb Ghuab-Soud", "Hsiao Hwa Miao", "Xiao Hua Miao"],
  cc: ["CN"]
}, {
  pk: 5569,
  ang: "South African Sign Language",
  lr: "Africa",
  gw: false,
  hc: "ZA",
  ln: "South African Sign Language",
  lc: "sfs",
  ld: "ltr",
  alt: [],
  cc: ["ZA"]
}, {
  pk: 5570,
  ang: "Sehwi",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Sehwi",
  lc: "sfw",
  ld: "ltr",
  alt: ["Asahyue", "Sefwi"],
  cc: ["GH"]
}, {
  pk: 5571,
  ang: "Sango",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "y\xE2ng\xE2 t\xEE s\xE4ng\xF6",
  lc: "sg",
  ld: "ltr",
  alt: ["Sangho"],
  cc: ["CF", "TD", "CG"]
}, {
  pk: 5572,
  ang: "Old Irish",
  lr: "Europe",
  gw: false,
  hc: "IE",
  ln: "Old Irish (to 900)",
  lc: "sga",
  ld: "ltr",
  alt: [],
  cc: ["IE"]
}, {
  pk: 5573,
  ang: "Ayta, Mag-antsi",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Mag-antsi Ayta",
  lc: "sgb",
  ld: "ltr",
  alt: ["Mag-Anchi Sambal", "Ayta", "Mag-Anchi"],
  cc: ["PH"]
}, {
  pk: 5574,
  ang: "Kipsigis",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Kipsigis",
  lc: "sgc",
  ld: "ltr",
  alt: ["Kipsiikis", "Kipsikiis", "Kipsikis"],
  cc: ["KE"]
}, {
  pk: 7868,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Tobak",
  lc: "sgc-x-dayaktobak",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5575,
  ang: "Surigaonon",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Surigaonon",
  lc: "sgd",
  ld: "ltr",
  alt: ["Waya-Waya"],
  cc: ["PH"]
}, {
  pk: 5576,
  ang: "Segai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Segai",
  lc: "sge",
  ld: "ltr",
  alt: ["Ga'ay", "Segayi"],
  cc: ["ID"]
}, {
  pk: 7827,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Punan Kelai",
  lc: "sge-x-punankelai",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5577,
  ang: "Swiss-German Sign Language",
  lr: "Europe",
  gw: false,
  hc: "CH",
  ln: "Swiss-German Sign Language",
  lc: "sgg",
  ld: "ltr",
  alt: ["Nat\xFCrliche Geb\xE4rde"],
  cc: ["CH"]
}, {
  pk: 5578,
  ang: "Shughni",
  lr: "Asia",
  gw: false,
  hc: "TJ",
  ln: "Shughni",
  lc: "sgh",
  ld: "ltr",
  alt: ["Khughnani", "Khughni", "Khughnoni", "Khugnone", "Shighnani", "Shighni", "Shughnani", "Shughnoni", "Shugni", "Shugnan-Rushan", "Rushani (Oroshani)", "Shughni (Khugni)", "Khuf", "Shugan", "Shugnan", "Roshani", "Roshan", "Khufi (Chuf)", "Bartangi (Bartang)", "Rushan", "Oroshor (Roshorvi)"],
  cc: ["AF", "TJ"]
}, {
  pk: 8222,
  ang: "Rushani",
  lr: "Asia",
  gw: false,
  hc: "TJ",
  ln: "Rushani",
  lc: "sgh-x-rushani",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5579,
  ang: "Suga",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Suga",
  lc: "sgi",
  ld: "ltr",
  alt: ["Galim", "Ssuga", "Jemjem", "Njemnjem", "Nyamnyam"],
  cc: ["CM"]
}, {
  pk: 5580,
  ang: "Surgujia",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Surgujia",
  lc: "sgj",
  ld: "ltr",
  alt: ["Suraji", "Surguja", "Surgujia-Chhattisgarhi", "Surjugia"],
  cc: ["IN"]
}, {
  pk: 5581,
  ang: "Sangkong",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6851\u5B54",
  lc: "sgk",
  ld: "ltr",
  alt: ["Buxia"],
  cc: ["CN"]
}, {
  pk: 8037,
  ang: "",
  lr: "Americas",
  gw: false,
  hc: "PY",
  ln: "Home Sign Asuncion 1",
  lc: "sgn-PY-asuncion1",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8172,
  ang: "SUN Homesign Ciudad del Ests 1",
  lr: "Americas",
  gw: false,
  hc: "PY",
  ln: "SUN Homesign Ciudad del Ests 1",
  lc: "sgn-PY-Sun-ciudaddests1",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8119,
  ang: "Symbolic Universal Notation",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Symbolic Universal Notation",
  lc: "sgn-US-symbunot",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8036,
  ang: "",
  lr: "Americas",
  gw: false,
  hc: "UY",
  ln: "Home Sign Montevideo 1",
  lc: "sgn-UY-montevideo1",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8174,
  ang: "Homesign Aurangabad 1",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Homesign Aurangabad 1",
  lc: "sgn-x-aurangabad 1",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5582,
  ang: "Singpho",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Singpho",
  lc: "sgp",
  ld: "ltr",
  alt: ["Jingphaw", "Kachin", "Sing-Fo"],
  cc: ["IN"]
}, {
  pk: 5583,
  ang: "Sangisari",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u0632\u0628\u0627\u0646 \u0633\u0646\u06AF\u0633\u0631\u06CC",
  lc: "sgr",
  ld: "ltr",
  alt: ["Mahdi Shahri", "Mehdishahri", "Sangesari", "S\xE4nges\xE4ri", "Sangsari", "S\xE4ngsari", "S\xE4ngs\xE4ri", "Sengiseri", "Sengsari", "Shahmirzadi"],
  cc: ["IR"]
}, {
  pk: 5584,
  ang: "Samogitian",
  lr: "Europe",
  gw: false,
  hc: "LT",
  ln: "Samogitian",
  lc: "sgs",
  ld: "ltr",
  alt: [],
  cc: ["LT"]
}, {
  pk: 5585,
  ang: "Brokpake",
  lr: "Asia",
  gw: false,
  hc: "BT",
  ln: "Brokpake",
  lc: "sgt",
  ld: "ltr",
  alt: ["Brokpa", "Dakpa", "Damilo", "Dap", "Drokpakay", "Jobikha", "Mera Sagtengpa", "Meragsagstengkha", "Mira Sagtengpa", "Sagtengpa"],
  cc: ["BT"]
}, {
  pk: 5586,
  ang: "Salas",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Salas",
  lc: "sgu",
  ld: "ltr",
  alt: ["Lenkaitahe", "Liambata", "Salas Gunung"],
  cc: ["ID"]
}, {
  pk: 5587,
  ang: "Sebat Bet Gurage",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Sebat Bet Gurage",
  lc: "sgw",
  ld: "ltr",
  alt: ["Central West Gurage", "Gouraghie", "Guragie", "Gurague", "West Gurage", "Chaha (Cheha)", "Ezha (Eza)", "Gumer (Gwemarra)", "Gyeto", "Izha"],
  cc: ["ET"]
}, {
  pk: 7822,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Muher",
  lc: "sgw-x-muher",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5588,
  ang: "Sierra Leone Sign Language",
  lr: "Africa",
  gw: false,
  hc: "SL",
  ln: "Sierra Leone Sign Language",
  lc: "sgx",
  ld: "ltr",
  alt: [],
  cc: ["SL"]
}, {
  pk: 5589,
  ang: "Sanglechi",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Sanglechi",
  lc: "sgy",
  ld: "ltr",
  alt: ["Dargi"],
  cc: ["AF"]
}, {
  pk: 5590,
  ang: "Sursurunga",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sursurunga",
  lc: "sgz",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5592,
  ang: "Shall-Zwall",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Shall-Zwall",
  lc: "sha",
  ld: "ltr",
  alt: ["Shall (Shal)"],
  cc: ["NG"]
}, {
  pk: 5593,
  ang: "Ninam",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Ninam",
  lc: "shb",
  ld: "ltr",
  alt: ["Xirixana", "Yanam", "Shiriana", "Uraricaa-Paragua", "Southern Ninam (Mukajai)", "Northern Ninam (Shiriana)", "Shirishana"],
  cc: ["BR", "VE"]
}, {
  pk: 5594,
  ang: "Sonde",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Sonde",
  lc: "shc",
  ld: "ltr",
  alt: ["Kisonde", "Kisoonde", "Soonde"],
  cc: ["CD"]
}, {
  pk: 5595,
  ang: "Kundal Shahi",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "Kundal Shahi",
  lc: "shd",
  ld: "rtl",
  alt: ["Rawri"],
  cc: ["PK"]
}, {
  pk: 5596,
  ang: "Sheko",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Sheko",
  lc: "she",
  ld: "ltr",
  alt: ["Shak", "Shekka", "Shekko", "Tschako"],
  cc: ["ET"]
}, {
  pk: 5597,
  ang: "Shua",
  lr: "Africa",
  gw: false,
  hc: "BW",
  ln: "Shua",
  lc: "shg",
  ld: "ltr",
  alt: ["Mashuakwe", "Tshumakwe", "Danisis", "Tshidi-Khwe (Shete Tsere)", "Shua-Khwe (Mashuakwe)", "Madinnisane", "N|oo", "Madenasse", "Madenassa", "Gan\xE1di", "Demisa", "|Xaise (|Ais)", "|Taise", "|Oree-Khwe (|Koree-Khoe)", "|Oree", "N|oo-Khwe (N||ookhwe)", "|Haise", "|Hais", "||'Aiye (|Aaye)", "Danisi (Danisa)"],
  cc: ["BW"]
}, {
  pk: 5598,
  ang: "Shoshoni",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Shoshoni",
  lc: "shh",
  ld: "ltr",
  alt: ["Gosiute (Goshute)"],
  cc: ["US"]
}, {
  pk: 5599,
  ang: "Tachelhit",
  lr: "Africa",
  gw: false,
  hc: "MA",
  ln: "\u2D5C\u2D30\u2D59\u2D53\u2D59\u2D59\u2D49\u2D5C",
  lc: "shi",
  ld: "ltr",
  alt: ["Shilha", "Southern Shilha", "Tachilhit", "Tashelhait", "Tashelhayt", "Tashelhit", "Tasoussit", "Soussiya", "Susiya", "Tashelheyt", "Tashilheet", "Sus", "Susiua (Sousse)"],
  cc: ["DZ", "FR", "MA"]
}, {
  pk: 5600,
  ang: "Caning",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Caning",
  lc: "shj",
  ld: "ltr",
  alt: [],
  cc: ["SD"]
}, {
  pk: 5601,
  ang: "Shilluk",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Shilluk",
  lc: "shk",
  ld: "ltr",
  alt: ["Chulla", "Colo", "Dhocolo", "Shulla"],
  cc: ["SS", "US"]
}, {
  pk: 5602,
  ang: "Shendu",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Shendu",
  lc: "shl",
  ld: "ltr",
  alt: ["Khieng", "Khyen", "Sandu", "Shandu"],
  cc: ["BD", "IN"]
}, {
  pk: 5603,
  ang: "Shahrudi",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Shahrudi",
  lc: "shm",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 5604,
  ang: "Shan",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Shan",
  lc: "shn",
  ld: "ltr",
  alt: ["Dehong", "Burmese Shan", "Great Thai", "Sam", "Sha", "Shan Bama", "Tai Long", "Tai Luang", "Tai Shan", "Tai Yai", "Thai Yai", "Ngeo", "Ngiao", "Ngiaw", "Ngio", "Ngiow", "Tai Yay", "Thai Yay", "Southern Shan State", "Tai Khe", "Northern Shan State", "Mae Hong Son", "Tai Mao (Mao Shan)", "Nge\""],
  cc: ["LA", "TH", "MM"]
}, {
  pk: 5605,
  ang: "Shanga",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Shanga",
  lc: "sho",
  ld: "ltr",
  alt: ["Shonga", "Shongawa"],
  cc: ["NG"]
}, {
  pk: 5606,
  ang: "Shipibo-Conibo",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Shipibo-Conibo",
  lc: "shp",
  ld: "ltr",
  alt: ["Xitibo", "Conibo (Coniba)", "Setebo", "Setibo", "Shetebo (Manoita)", "Shipibo (Alto Ucayali)"],
  cc: ["PE"]
}, {
  pk: 5607,
  ang: "Sala",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Sala",
  lc: "shq",
  ld: "ltr",
  alt: [],
  cc: ["ZM"]
}, {
  pk: 5608,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Shi",
  lc: "shr",
  ld: "ltr",
  alt: ["Mashi", "Hwindja (Lwindja)"],
  cc: ["CD"]
}, {
  pk: 8493,
  ang: "Hwindja",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Hwindja",
  lc: "shr-x-hwindja",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8206,
  ang: "Kigweshegweshe",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kigweshegweshe",
  lc: "shr-x-kigweshe",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7892,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kilinjalinja",
  lc: "shr-x-kilinjalinja",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7893,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kizibaziba",
  lc: "shr-x-kizibaziba",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7896,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Longe-Longe",
  lc: "shr-x-longelonge",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5609,
  ang: "Shuswap",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Shuswap",
  lc: "shs",
  ld: "ltr",
  alt: ["Secwepemc", "Secwepemcts\xEDn"],
  cc: ["CA"]
}, {
  pk: 5610,
  ang: "Shasta",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Shasta",
  lc: "sht",
  ld: "ltr",
  alt: ["Sastean", "Shastan"],
  cc: ["US"]
}, {
  pk: 5611,
  ang: "Arabic, Chadian Spoken",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Chadian Arabic",
  lc: "shu",
  ld: "rtl",
  alt: ["Arabe Choa", "Chadian Spoken Arabic", "Choa", "Shoa", "Shoa Arabic", "Shua", "Chadic Arabic", "Shuwa Arabic", "Chadian Arabic", "Shua Arabic", "Chad Arabic", "Chowa", "L'arabe du Tchad", "Suwa"],
  cc: ["NG", "TD"]
}, {
  pk: 5612,
  ang: "Shehri",
  lr: "Asia",
  gw: false,
  hc: "OM",
  ln: "\u0644\u063A\u0629 \u0634\u062D\u0631\u064A\u0629",
  lc: "shv",
  ld: "ltr",
  alt: ["Ehkili", "Geblet", "Jibali", "Qarawi", "Sehri", "Shahari", "Sheret"],
  cc: ["OM", "SA"]
}, {
  pk: 5613,
  ang: "Shwai",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Shwai",
  lc: "shw",
  ld: "ltr",
  alt: ["Ludumor", "Shirumba", "Shuway", "Cerumba (Shirumba)"],
  cc: ["SD"]
}, {
  pk: 5614,
  ang: "She",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5C71\u5BA2\u8A71",
  lc: "shx",
  ld: "ltr",
  alt: ["Huo Nte", "Lianhua (Western She)", "Luofu (Eastern She)"],
  cc: ["CN"]
}, {
  pk: 5615,
  ang: "Tachawit",
  lr: "Africa",
  gw: false,
  hc: "DZ",
  ln: "\u0644\u0647\u062C\u0629 \u0634\u0627\u0648\u064A\u0629",
  lc: "shy",
  ld: "ltr",
  alt: ["Chaouia", "Chawi", "Shawia", "Shawiya", "Tacawit"],
  cc: ["DZ", "BE", "FR", "TN", "IT"]
}, {
  pk: 5616,
  ang: "S\xE9noufo, Syenara",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Syenara Senoufo",
  lc: "shz",
  ld: "ltr",
  alt: ["Senare", "Senari", "Shenara", "Syenara"],
  cc: ["ML"]
}, {
  pk: 5617,
  ang: "Sinhala, Sinhalese",
  lr: "Asia",
  gw: false,
  hc: "LK",
  ln: "\u0DC3\u0DD2\u0D82\u0DC4\u0DBD",
  lc: "si",
  ld: "ltr",
  alt: ["Cingalese", "Singhala", "Singhalese", "Chingalese"],
  cc: ["LK", "GB", "MY", "OM", "TH", "US", "CA", "IT", "MV", "SG", "QA", "AE"]
}, {
  pk: 5618,
  ang: "Saami, Akkala",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0411\u0430\u0431\u0438\u043D\u0441\u043A\u0438\u0439",
  lc: "sia",
  ld: "ltr",
  alt: ["Ahkkil", "Babino", "Babinsk"],
  cc: ["RU"]
}, {
  pk: 5619,
  ang: "Sebop",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Sebop",
  lc: "sib",
  ld: "ltr",
  alt: ["Cebop", "Sabup", "Sebob", "Sibop", "Bah Malei (Ba Mali)", "Long Ekang (Long Ikang)"],
  cc: ["MY"]
}, {
  pk: 5620,
  ang: "Sidamo",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Sidamo",
  lc: "sid",
  ld: "ltr",
  alt: ["Sidaama", "Sidaamu Afoo", "Sidaminya", "Sid\xE1mo 'Af\xF3"],
  cc: ["ET"]
}, {
  pk: 5621,
  ang: "Simaa",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Simaa",
  lc: "sie",
  ld: "ltr",
  alt: [],
  cc: ["ZM"]
}, {
  pk: 5622,
  ang: "Siamou",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Siamou",
  lc: "sif",
  ld: "ltr",
  alt: ["Seme", "S\xE9mu", "Si\xE9mou", "Siemu", "Sy\xE9mou", "Bandougou"],
  cc: ["BF"]
}, {
  pk: 5623,
  ang: "Paasaal",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Paasaal",
  lc: "sig",
  ld: "ltr",
  alt: ["Funsile", "Pasaale", "Pasaale Sisaala", "Southern Sisaala"],
  cc: ["GH"]
}, {
  pk: 5624,
  ang: "S\xEEsh\xEB\xEB",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Zire",
  lc: "sih",
  ld: "ltr",
  alt: ["Ner\xEB", "Siche", "Sirhe", "Yirhe", "Yirhee", "Ziche", "Zira"],
  cc: ["NC"]
}, {
  pk: 5625,
  ang: "Shom Peng",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Shom Peng",
  lc: "sii",
  ld: "ltr",
  alt: ["Shobang", "Shom Pen", "Shompen", "Shompeng"],
  cc: ["IN"]
}, {
  pk: 5626,
  ang: "Numbami",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Numbami",
  lc: "sij",
  ld: "ltr",
  alt: ["Siboma", "Sipoma"],
  cc: ["PG"]
}, {
  pk: 5627,
  ang: "Sikiana",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Sikiana",
  lc: "sik",
  ld: "ltr",
  alt: ["Chikena", "Chiquena", "Chiquiana", "Shikiana", "Siki\xE2na", "Sik\xEFiyana", "Xikiyana", "Xikujana", "Sikiuyana", "Sikiyana", "Tshikiana"],
  cc: ["BR"]
}, {
  pk: 5628,
  ang: "Sisaala, Tumulung",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Tumulung Sisaala",
  lc: "sil",
  ld: "ltr",
  alt: ["Hissala", "Isaalung", "Issala", "Sisai", "Sisala Tumu", "Gil Bagale (Galebagla)"],
  cc: ["GH"]
}, {
  pk: 5629,
  ang: "Mende",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mende (Papua New Guinea)",
  lc: "sim",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5630,
  ang: "Sikkimese",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Sikkimese",
  lc: "sip",
  ld: "ltr",
  alt: ["Dandzongka", "Danjongka", "Danyouka", "Denjong", "Denjongkha", "Denjongpa", "Denjonka", "Denjonke", "Lachengpa", "Lachungpa", "Sikami", "Sikkim Bhotia", "Sikkim Bhutia"],
  cc: ["BT", "IN"]
}, {
  pk: 5631,
  ang: "Sonia",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sonia",
  lc: "siq",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5632,
  ang: "Siri",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Siri",
  lc: "sir",
  ld: "ltr",
  alt: ["Sirawa"],
  cc: ["NG"]
}, {
  pk: 5633,
  ang: "Siuslaw",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Siuslaw",
  lc: "sis",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 5634,
  ang: "Sinagen",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sinagen",
  lc: "siu",
  ld: "ltr",
  alt: ["Metru"],
  cc: ["PG"]
}, {
  pk: 5635,
  ang: "Sumariup",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sumariup",
  lc: "siv",
  ld: "ltr",
  alt: ["Latoma", "Sogoba"],
  cc: ["PG"]
}, {
  pk: 5636,
  ang: "Siwai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Siwai",
  lc: "siw",
  ld: "ltr",
  alt: ["Baitsi (Sigisigero)"],
  cc: ["PG"]
}, {
  pk: 5637,
  ang: "Sumau",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sumau",
  lc: "six",
  ld: "ltr",
  alt: ["Garia", "Kari", "Sumau-Garia"],
  cc: ["PG"]
}, {
  pk: 5638,
  ang: "Sivandi",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u0632\u0648\u0648\u0622\u0646 \u0626 \u0633\u06CC\u0648\u0646\u062F\u06CC",
  lc: "siy",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 5639,
  ang: "Siwi",
  lr: "Africa",
  gw: false,
  hc: "EG",
  ln: "\u062A\u0627\u0633\u064A\u0648\u064A\u062A",
  lc: "siz",
  ld: "ltr",
  alt: ["Oasis Berber", "Sioua", "Siwa", "Zenati"],
  cc: ["EG"]
}, {
  pk: 5640,
  ang: "Epena",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Epena",
  lc: "sja",
  ld: "ltr",
  alt: ["Cholo", "Embera", "Ember\xE1-Saija", "Epen\xE1 Saija", "Saija", "Southern Empera", "Epen\xE1", "Ep\xE9na Ped\xE9e", "Southern Embera", "Epena Saija", "Southern Epena", "Basurud\xF3"],
  cc: ["CO"]
}, {
  pk: 5641,
  ang: "Sajau Basap",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sajau Basap",
  lc: "sjb",
  ld: "ltr",
  alt: ["Sajau", "Sujau"],
  cc: ["ID"]
}, {
  pk: 7875,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Punan Pelan Cau",
  lc: "sjb-x-pelancau",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5642,
  ang: "Saami, Kildin",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041A\u0438\u043B\u044C\u0434\u0438\u043D\u0441\u043A\u0438\u0439 \u0441\u0430\u0430\u043C\u0441\u043A\u0438\u0439",
  lc: "sjd",
  ld: "ltr",
  alt: ["Saam", "Saami", "Kildin Lappish", "Lapp"],
  cc: ["RU"]
}, {
  pk: 5643,
  ang: "Saami, Pite",
  lr: "Europe",
  gw: false,
  hc: "SE",
  ln: "Pite Sami",
  lc: "sje",
  ld: "ltr",
  alt: ["Pite", "Lapp", "Arjeplog Saami", "Saami"],
  cc: ["SE"]
}, {
  pk: 5644,
  ang: "Assangori",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Assangori",
  lc: "sjg",
  ld: "ltr",
  alt: ["Asong", "Assoungor", "Asungore", "Azanguri", "Bognak-Asungorung", "Madungore", "Soungor", "Sungor"],
  cc: ["SD", "TD"]
}, {
  pk: 5645,
  ang: "Kemi Sami",
  lr: "Europe",
  gw: false,
  hc: "FI",
  ln: "Kemi Sami",
  lc: "sjk",
  ld: "ltr",
  alt: [],
  cc: ["FI"]
}, {
  pk: 5646,
  ang: "Miji",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Sajalong",
  lc: "sjl",
  ld: "ltr",
  alt: ["Dammai", "Dhammai", "Namrei"],
  cc: ["IN"]
}, {
  pk: 5647,
  ang: "Mapun",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Mapun",
  lc: "sjm",
  ld: "ltr",
  alt: ["Bajau Kagayan", "Cagayan de Sulu", "Jama Mapun", "Kagayan", "Orang Cagayan", "Sama Mapun", "Cagayan", "Cagayanen", "Cagayano", "Orang"],
  cc: ["MY", "PH"]
}, {
  pk: 5648,
  ang: "",
  lr: "",
  gw: false,
  hc: "",
  ln: "Sindarin",
  lc: "sjn",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5649,
  ang: "Xibe",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u9521\u4F2F\u8BED",
  lc: "sjo",
  ld: "ltr",
  alt: ["Sibe", "Sibin", "Sibo", "Xibo"],
  cc: ["CN"]
}, {
  pk: 5650,
  ang: "Surjapuri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Surjapuri",
  lc: "sjp",
  ld: "ltr",
  alt: ["Sura"],
  cc: ["IN"]
}, {
  pk: 5651,
  ang: "Siar-Lak",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Siar-Lak",
  lc: "sjr",
  ld: "ltr",
  alt: ["Lak", "Lamassa", "Lambom"],
  cc: ["PG"]
}, {
  pk: 5652,
  ang: "Senhaja Berber",
  lr: "Africa",
  gw: false,
  hc: "MA",
  ln: "\u0623\u0645\u0627\u0632\u064A\u063A\u064A\u0629 \u0635\u0646\u0647\u0627\u062C\u0629",
  lc: "sjs",
  ld: "ltr",
  alt: ["Beni Seddat", "Tagsut", "Quetama (Ketama)", "Beni Mesdui", "Beni Jennus", "Beni Buensar", "Beni Bechir", "Beni Ahmed", "Sarcat", "Senhaja de Srair", "Senhajiya", "Shilha", "Shilha Barbarya", "Shilha n Jbala", "Tajeblit", "Tamazight", "Tamazight n Jbala", "Tasenhajit"],
  cc: ["MA"]
}, {
  pk: 5653,
  ang: "Saami, Ter",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0419\u043E\u043A\u0430\u043D\u044C\u0433\u0441\u043A\u043E-\u0441\u0430\u0430\u043C\u0441\u043A\u0438\u0439",
  lc: "sjt",
  ld: "ltr",
  alt: ["Saam", "Lapp", "Ter Lappish"],
  cc: ["RU"]
}, {
  pk: 5654,
  ang: "Saami, Ume",
  lr: "Europe",
  gw: false,
  hc: "SE",
  ln: "Ume Sami",
  lc: "sju",
  ld: "ltr",
  alt: ["Saami", "Ume", "Lapp"],
  cc: ["SE"]
}, {
  pk: 5655,
  ang: "Shawnee",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Shawnee",
  lc: "sjw",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 5656,
  ang: "Slovak",
  lr: "Europe",
  gw: false,
  hc: "SK",
  ln: "sloven\u010Dina, slovensk\xFD jazyk",
  lc: "sk",
  ld: "ltr",
  alt: ["Slovakian", "Slovencina"],
  cc: ["AR", "CZ", "PL", "SK", "SE", "US", "AU", "CA"]
}, {
  pk: 5657,
  ang: "Skagit",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Skagit",
  lc: "ska",
  ld: "ltr",
  alt: ["Swinomish", "Northern Lushootseed"],
  cc: ["US"]
}, {
  pk: 5658,
  ang: "Saek",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Saek",
  lc: "skb",
  ld: "ltr",
  alt: ["Sek", "Set", "Tai Sek"],
  cc: ["LA"]
}, {
  pk: 5659,
  ang: "Ma Manda",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ma Manda",
  lc: "skc",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5660,
  ang: "Miwok, Southern Sierra",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Southern Sierra Miwok",
  lc: "skd",
  ld: "ltr",
  alt: ["Meewoc", "Mewoc", "Miwoc", "Miwokan", "Mok\xE9lumne", "Moquelumnan", "San Raphael", "Talatui", "Talutui", "Yosemite"],
  cc: ["US"]
}, {
  pk: 5661,
  ang: "Seke",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Seke (Vanuatu)",
  lc: "ske",
  ld: "ltr",
  alt: ["Ske"],
  cc: ["VU"]
}, {
  pk: 5662,
  ang: "Sakirabi\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Sakirabi\xE1",
  lc: "skf",
  ld: "ltr",
  alt: ["Mek\xE9m", "Mekens", "Sakirabi\xE1k", "Sakirabi\xE1p", "Sakirabi\xE1t", "Sakirap", "Sakiriabar", "Sakurabiat"],
  cc: ["BR"]
}, {
  pk: 5663,
  ang: "Malagasy, Sakalava",
  lr: "Africa",
  gw: false,
  hc: "MG",
  ln: "Sakalava Malagasy",
  lc: "skg",
  ld: "ltr",
  alt: ["Northern Boina Sakalava", "Southern Boina Sakalava"],
  cc: ["MG"]
}, {
  pk: 7935,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "MG",
  ln: "Sakalava Ananalava",
  lc: "skg-x-ananalava",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7936,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "MG",
  ln: "Sakalava Besalampy",
  lc: "skg-x-besalampy",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7937,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "MG",
  ln: "Vezo",
  lc: "skg-x-vezo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5664,
  ang: "Sikule",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sikule",
  lc: "skh",
  ld: "ltr",
  alt: ["Sichule", "Sikhule", "Wali Banuah"],
  cc: ["ID"]
}, {
  pk: 5665,
  ang: "Sika",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sika",
  lc: "ski",
  ld: "ltr",
  alt: ["Krowe", "Maumere", "Sara Sikka", "Sikka", "Sikkanese", "Sikka Natar (Kanga\xE9)", "South Coast Sikka", "Sara Krowe (Central Sikka)"],
  cc: ["ID"]
}, {
  pk: 5666,
  ang: "Seke",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Seke (Nepal)",
  lc: "skj",
  ld: "ltr",
  alt: ["Tangbe", "Tetang", "Chuksang"],
  cc: ["NP"]
}, {
  pk: 5667,
  ang: "Sok",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Sok",
  lc: "skk",
  ld: "ltr",
  alt: ["Sork"],
  cc: ["LA"]
}, {
  pk: 5668,
  ang: "Kutong",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kutong",
  lc: "skm",
  ld: "ltr",
  alt: ["Dinangat", "Akwawin", "Iyot", "Kamdaran"],
  cc: ["PG"]
}, {
  pk: 5669,
  ang: "Subanon, Kolibugan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kolibugan Subanon",
  lc: "skn",
  ld: "ltr",
  alt: ["Calibugan", "Kalibugan", "Kolibugan"],
  cc: ["PH"]
}, {
  pk: 5670,
  ang: "Seko Tengah",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Seko Tengah",
  lc: "sko",
  ld: "ltr",
  alt: ["Pewanean", "Pewaneang", "Pohoneang", "Seko"],
  cc: ["ID"]
}, {
  pk: 5671,
  ang: "Sekapan",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Sekapan",
  lc: "skp",
  ld: "ltr",
  alt: ["Sekepan"],
  cc: ["MY"]
}, {
  pk: 5672,
  ang: "Sininkere",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Sininkere",
  lc: "skq",
  ld: "ltr",
  alt: ["Silanke", "Silinkere"],
  cc: ["BF"]
}, {
  pk: 5673,
  ang: "Saraiki",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u0633\u0631\u0627\u0626\u06CC\u06A9\u06CC",
  lc: "skr",
  ld: "ltr",
  alt: ["Bahawalpuri", "Mutani", "Reasati", "Riasati", "Siraiki", "Southern Panjabi", "Riasiti"],
  cc: ["PK"]
}, {
  pk: 5674,
  ang: "Maia",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Maia",
  lc: "sks",
  ld: "ltr",
  alt: ["Banar", "Maya", "Pila", "Saki", "Suaro", "Turutap", "Yakiba"],
  cc: ["PG"]
}, {
  pk: 5675,
  ang: "Sakata",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Sakata",
  lc: "skt",
  ld: "ltr",
  alt: ["Kisakata", "Lesa", "Odual", "Saka", "Bai (Kibai)", "Dja", "Djia (Dia)", "Kidjia"],
  cc: ["CD"]
}, {
  pk: 5676,
  ang: "Sakao",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Sakao",
  lc: "sku",
  ld: "ltr",
  alt: ["Hog Harbour", "Klep", "N'kep", "Sakau", "Santo"],
  cc: ["VU"]
}, {
  pk: 5677,
  ang: "Skou",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Skou",
  lc: "skv",
  ld: "ltr",
  alt: ["Sekol", "Sekou", "Sko", "Skouw", "Skow", "Sukou", "Te Mawo", "Tumawo"],
  cc: ["ID"]
}, {
  pk: 8389,
  ang: "Moso",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Moso",
  lc: "skv-x-moso",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5678,
  ang: "Seko Padang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Seko Padang",
  lc: "skx",
  ld: "ltr",
  alt: ["Seko", "Wono", "Hono' (Wono)"],
  cc: ["ID"]
}, {
  pk: 5679,
  ang: "Sikaiana",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Sikaiana",
  lc: "sky",
  ld: "ltr",
  alt: ["Sikayana"],
  cc: ["SB"]
}, {
  pk: 5680,
  ang: "Sekar",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sekar",
  lc: "skz",
  ld: "ltr",
  alt: ["Seka"],
  cc: ["ID"]
}, {
  pk: 5681,
  ang: "Slovene",
  lr: "Europe",
  gw: false,
  hc: "SI",
  ln: "slovenski jezik, sloven\u0161\u010Dina",
  lc: "sl",
  ld: "ltr",
  alt: ["Windisch", "Slovenscina"],
  cc: ["AT", "AR", "DE", "NZ", "SE", "SI", "US", "AU", "CA", "IT"]
}, {
  pk: 5682,
  ang: "S\xE1liba",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "S\xE1liba",
  lc: "slc",
  ld: "ltr",
  alt: ["S\xE1liva"],
  cc: ["VE", "CO"]
}, {
  pk: 5683,
  ang: "Sissala",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Sissala",
  lc: "sld",
  ld: "ltr",
  alt: ["Sisaali"],
  cc: ["BF"]
}, {
  pk: 5684,
  ang: "Sholaga",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Sholaga",
  lc: "sle",
  ld: "ltr",
  alt: ["Kadu Sholigar", "Sholanayika", "Sholiga", "Sholigar", "Solaga", "Solanayakkans", "Soliga"],
  cc: ["IN"]
}, {
  pk: 5685,
  ang: "Swiss-Italian Sign Language",
  lr: "Europe",
  gw: false,
  hc: "CH",
  ln: "Swiss-Italian Sign Language",
  lc: "slf",
  ld: "ltr",
  alt: [],
  cc: ["CH"]
}, {
  pk: 5686,
  ang: "Selungai Murut",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Selungai Murut",
  lc: "slg",
  ld: "ltr",
  alt: ["Murut"],
  cc: ["ID", "MY"]
}, {
  pk: 5687,
  ang: "Salish, Southern Puget Sound",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Southern Puget Sound Salish",
  lc: "slh",
  ld: "ltr",
  alt: ["Southern Lushootseed"],
  cc: ["US"]
}, {
  pk: 5688,
  ang: "Silesian, Lower",
  lr: "Europe",
  gw: false,
  hc: "PL",
  ln: "Lower Silesian",
  lc: "sli",
  ld: "ltr",
  alt: ["Upper Schlesisch"],
  cc: ["PL"]
}, {
  pk: 5689,
  ang: "Salum\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Salum\xE1",
  lc: "slj",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 5690,
  ang: "Salt-Yui",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Salt-Yui",
  lc: "sll",
  ld: "ltr",
  alt: ["Iui", "Salt", "Salt-Iui", "Yui"],
  cc: ["PG"]
}, {
  pk: 5691,
  ang: "Sama, Pangutaran",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Pangutaran Sama",
  lc: "slm",
  ld: "ltr",
  alt: ["Siyama"],
  cc: ["PH"]
}, {
  pk: 5692,
  ang: "Salinan",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Salinan",
  lc: "sln",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 5693,
  ang: "Lamaholot",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lamaholot",
  lc: "slp",
  ld: "ltr",
  alt: ["Solor", "Solorese", "Tanjung Bunda", "Lamaholot (Ile Mandiri)", "West Lamaholot (Muhang)", "Taka", "Ritaebang", "Pukaunu", "Lewolaga", "Larantuka"],
  cc: ["ID"]
}, {
  pk: 5694,
  ang: "Salar",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6492\u62C9\u8BED",
  lc: "slr",
  ld: "ltr",
  alt: ["Sala", "Ili"],
  cc: ["CN"]
}, {
  pk: 5695,
  ang: "Singapore Sign Language",
  lr: "Asia",
  gw: false,
  hc: "SG",
  ln: "Singapore Sign Language",
  lc: "sls",
  ld: "ltr",
  alt: ["Contact Signing (Pidgin Signed English)", "Natural Sign Language"],
  cc: ["SG"]
}, {
  pk: 5696,
  ang: "Sila",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Sila",
  lc: "slt",
  ld: "ltr",
  alt: ["Asong", "Sida", "Kha Pai"],
  cc: ["LA"]
}, {
  pk: 5697,
  ang: "Selaru",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Selaru",
  lc: "slu",
  ld: "ltr",
  alt: ["Salaru"],
  cc: ["ID"]
}, {
  pk: 5698,
  ang: "Sialum",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sialum",
  lc: "slw",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5699,
  ang: "Salampasu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Salampasu",
  lc: "slx",
  ld: "ltr",
  alt: ["Chisalampasu"],
  cc: ["CD"]
}, {
  pk: 5700,
  ang: "Selayar",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Selayar",
  lc: "sly",
  ld: "ltr",
  alt: ["Salajar", "Salayar", "Salayer", "Saleier", "Siladja", "Silajara"],
  cc: ["ID"]
}, {
  pk: 5701,
  ang: "Ma\u2019ya",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ma'ya",
  lc: "slz",
  ld: "ltr",
  alt: ["Sailolof", "Salawati", "Samate", "Batanta Island"],
  cc: ["ID"]
}, {
  pk: 5702,
  ang: "Samoan",
  lr: "Pacific",
  gw: false,
  hc: "WS",
  ln: "gagana fa'a Samoa",
  lc: "sm",
  ld: "ltr",
  alt: ["Gagana Samoa"],
  cc: ["FJ", "NZ", "TK", "TV", "US", "WS", "VU"]
}, {
  pk: 5703,
  ang: "Saami, South",
  lr: "Europe",
  gw: false,
  hc: "SE",
  ln: "Southern Sami",
  lc: "sma",
  ld: "ltr",
  alt: ["Saami", "Same", "Samic", "Northern Lappish", "Norwegian Lapp", "Southern Lapp", "Lapp"],
  cc: ["NO", "SE"]
}, {
  pk: 5704,
  ang: "Simbari",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Simbari",
  lc: "smb",
  ld: "ltr",
  alt: ["Chimbari"],
  cc: ["PG"]
}, {
  pk: 5705,
  ang: "Som",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Som",
  lc: "smc",
  ld: "ltr",
  alt: ["Dinanget", "Somm"],
  cc: ["PG"]
}, {
  pk: 5706,
  ang: "Sama",
  lr: "Africa",
  gw: false,
  hc: "AO",
  ln: "Sama",
  lc: "smd",
  ld: "ltr",
  alt: ["Kissama", "Quissama"],
  cc: ["AO"]
}, {
  pk: 5707,
  ang: "Auwe",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Auwe",
  lc: "smf",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5708,
  ang: "Simbali",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Simbali",
  lc: "smg",
  ld: "ltr",
  alt: ["Asimbali"],
  cc: ["PG"]
}, {
  pk: 5709,
  ang: "Samei",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6492\u6885\u8BED",
  lc: "smh",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 5710,
  ang: "Saami, Lule",
  lr: "Europe",
  gw: false,
  hc: "SE",
  ln: "Lule Sami",
  lc: "smj",
  ld: "ltr",
  alt: ["Lule", "Saame", "Saami", "Lapp"],
  cc: ["NO", "SE"]
}, {
  pk: 5711,
  ang: "Bolinao",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Bolinao",
  lc: "smk",
  ld: "ltr",
  alt: ["Bino-Bolinao", "Binubolinao", "Binubulinao", "Bolinao Sambal", "Bolinao Zambal", "Bulinaw", "Sambal Bolinao"],
  cc: ["PH"]
}, {
  pk: 8296,
  ang: "Bol-Anons",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Bol-Anons",
  lc: "smk-x-Bolanons",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5712,
  ang: "Sama, Central",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Central Sama",
  lc: "sml",
  ld: "ltr",
  alt: ["Central Sinama", "Orang Laut", "Sama Dilaut", "Siasi Sama", "Sinama", "Bajaw", "Sama Deya", "Sama Siasi", "Sama Tabawan", "Sama Laminusa"],
  cc: ["MY", "PH"]
}, {
  pk: 5713,
  ang: "Musasa",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Musasa",
  lc: "smm",
  ld: "ltr",
  alt: ["Musahar", "Rishaidep", "Bantar"],
  cc: ["NP"]
}, {
  pk: 5714,
  ang: "Saami, Inari",
  lr: "Europe",
  gw: false,
  hc: "FI",
  ln: "Inari Sami",
  lc: "smn",
  ld: "ltr",
  alt: ["Anar", "Saam", "Saame", "S\xE1mi", "Samic", "Finnish Lapp", "Inari Lappish", "Lapp"],
  cc: ["FI"]
}, {
  pk: 5715,
  ang: "Samaritan",
  lr: "Asia",
  gw: false,
  hc: "PS",
  ln: "Samaritan",
  lc: "smp",
  ld: "ltr",
  alt: ["Samaritan Hebrew"],
  cc: ["PS"]
}, {
  pk: 5716,
  ang: "Samo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Samo",
  lc: "smq",
  ld: "ltr",
  alt: ["Daba", "Nomad", "Supei"],
  cc: ["PG"]
}, {
  pk: 5717,
  ang: "Simeulue",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Simeulue",
  lc: "smr",
  ld: "ltr",
  alt: ["Long Bano", "Simalur", "Simeulo\xEB", "Simulul"],
  cc: ["ID"]
}, {
  pk: 5718,
  ang: "Saami, Skolt",
  lr: "Europe",
  gw: false,
  hc: "FI",
  ln: "Skolt Sami",
  lc: "sms",
  ld: "ltr",
  alt: ["Kolta", "Koltta", "Lopar", "Russian Lapp", "Saame", "Same", "Skolt Lappish", "Lapp", "Saam", "Skolt"],
  cc: ["FI"]
}, {
  pk: 5719,
  ang: "Simte",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Simte",
  lc: "smt",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 5720,
  ang: "Somray",
  lr: "Asia",
  gw: false,
  hc: "KH",
  ln: "Somray",
  lc: "smu",
  ld: "ltr",
  alt: [],
  cc: ["KH"]
}, {
  pk: 5721,
  ang: "Samvedi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Samvedi",
  lc: "smv",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 5722,
  ang: "Sumbawa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sumbawa",
  lc: "smw",
  ld: "ltr",
  alt: ["Semawa", "Sumbawarese"],
  cc: ["ID"]
}, {
  pk: 5723,
  ang: "Samba",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Samba",
  lc: "smx",
  ld: "ltr",
  alt: ["Shankadi", "Tsaam", "Tsamba", "Usamba"],
  cc: ["CD"]
}, {
  pk: 5724,
  ang: "Semnani",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u0632\u0628\u0627\u0646 \u0633\u0645\u0646\u0627\u0646\u06CC",
  lc: "smy",
  ld: "ltr",
  alt: ["Simnani"],
  cc: ["IR"]
}, {
  pk: 5725,
  ang: "Simeku",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Simeku",
  lc: "smz",
  ld: "ltr",
  alt: ["Koopei (Kopei)", "Korpei", "Mainoki (Mainoke)"],
  cc: ["PG"]
}, {
  pk: 5726,
  ang: "Shona",
  lr: "Africa",
  gw: false,
  hc: "ZW",
  ln: "chiShona",
  lc: "sn",
  ld: "ltr",
  alt: ["Chishona", "Zezuru", "Swina", "Mazizuru", "Vazezuru", "Wakorikori", "Zezuru (Bazezuru)", "Shangwe", "Northern Shona", "Korikori", "Korekore (Goba)", "Karanga (Chikaranga)", "Gowa", "Gova", "Bazuzura", "Wazezuru", "Makorekore"],
  cc: ["MZ", "ZA", "ZM", "ZW", "CA", "BW"]
}, {
  pk: 5727,
  ang: "Sebuyau",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Sebuyau",
  lc: "snb",
  ld: "ltr",
  alt: ["Sabuyan", "Sabuyau", "Sibuian", "Sibuyan", "Sibuyau"],
  cc: ["MY"]
}, {
  pk: 5728,
  ang: "Sinaugoro",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sinaugoro",
  lc: "snc",
  ld: "ltr",
  alt: ["Sinagoro", "Wiga", "Babagarupu", "Tubulamo"],
  cc: ["PG"]
}, {
  pk: 7688,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Boku",
  lc: "snc-x-boku",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7687,
  ang: "Taboro Sinaugoro",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Taboro",
  lc: "snc-x-taboro",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5729,
  ang: "Bidayuh, Bau",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Bau Bidayuh",
  lc: "sne",
  ld: "ltr",
  alt: ["Bau-Jagoi", "Jaggoi", "Sarawak Dayak", "Singgi", "Singhi", "Serambau (Serambo)", "Singgie", "Taup (Tahup)", "Serambu", "Grogo (Grogoh)", "Singai (Bisingai)", "Singgai"],
  cc: ["MY"]
}, {
  pk: 7910,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Tengoh",
  lc: "sne-x-dayaktengoh",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7903,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Bidayuh Jagoi",
  lc: "sne-x-jagoibabang",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5730,
  ang: "Noon",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Noon",
  lc: "snf",
  ld: "ltr",
  alt: ["Non", "None", "Serer", "Serer-Noon"],
  cc: ["SN"]
}, {
  pk: 5731,
  ang: "Sanga",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Sanga (Democratic Republic of Congo)",
  lc: "sng",
  ld: "ltr",
  alt: ["Luba-Garenganze", "Luba-Sanga", "Southern Luba"],
  cc: ["CD"]
}, {
  pk: 5732,
  ang: "Shinabo",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Shinabo",
  lc: "snh",
  ld: "ltr",
  alt: [],
  cc: ["BO"]
}, {
  pk: 5733,
  ang: "Sango, Riverain",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Riverain Sango",
  lc: "snj",
  ld: "ltr",
  alt: [],
  cc: ["CF"]
}, {
  pk: 5734,
  ang: "Soninke",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Soninke",
  lc: "snk",
  ld: "ltr",
  alt: ["Sarakole", "Sarakule", "Sarakulle", "Saraxuli", "Maraka", "Marka", "Sarakolle", "Serahule", "Aswanek", "Aswanik", "Ceddo", "Cheddo", "Gangara", "Genger", "Kwara", "Markaajo", "Markakan", "Sarangkole", "Sarangkolle", "Sebbe", "Soninkanxanne", "Sooninke", "Wakkore", "Wankara", "Kinxenna", "Aser", "Azer (Adjer)", "Geriga (Giriga)", "Silabe", "Toubakai", "Wakore"],
  cc: ["BF", "GM", "ML", "MR", "SN", "US", "GW"]
}, {
  pk: 5735,
  ang: "Sangil",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Sangil",
  lc: "snl",
  ld: "ltr",
  alt: ["Sanggil", "Sangir\xE9", "Sarangani"],
  cc: ["PH"]
}, {
  pk: 5736,
  ang: "Ma\u2019di, Southern",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Southern Ma'di",
  lc: "snm",
  ld: "ltr",
  alt: ["Southern Ma'di"],
  cc: ["UG"]
}, {
  pk: 5737,
  ang: "Siona",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Siona",
  lc: "snn",
  ld: "ltr",
  alt: ["Ceona", "Ganteya", "Ganteyabain", "Kan\xFA", "Koka", "Pioche-Sioni", "Pioje", "Sioni", "Zeona", "Baicoca"],
  cc: ["CO", "EC"]
}, {
  pk: 5738,
  ang: "Snohomish",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Snohomish",
  lc: "sno",
  ld: "ltr",
  alt: ["Northern Lushootseed (Northern Puget Sound Salish)"],
  cc: ["US"]
}, {
  pk: 5739,
  ang: "Siane",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Siane",
  lc: "snp",
  ld: "ltr",
  alt: ["Siani"],
  cc: ["PG"]
}, {
  pk: 8487,
  ang: "Wandodavarasa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wandodavarasa",
  lc: "snp-x-wandodavar",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5740,
  ang: "Sangu",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Sangu (Gabon)",
  lc: "snq",
  ld: "ltr",
  alt: ["Chango", "Isangu", "Shango", "Yisangou", "Yisangu"],
  cc: ["GA"]
}, {
  pk: 5741,
  ang: "Sihan",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sihan",
  lc: "snr",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5742,
  ang: "Nahavaq",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "South West Bay",
  lc: "sns",
  ld: "ltr",
  alt: ["Labo", "Lamangkau", "Na'ahai", "Nahapa", "Seniang", "Sinesip"],
  cc: ["VU"]
}, {
  pk: 5743,
  ang: "Viid",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Senggi",
  lc: "snu",
  ld: "ltr",
  alt: ["Senggi"],
  cc: ["ID"]
}, {
  pk: 5744,
  ang: "Sa\u2019ban",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Sa'ban",
  lc: "snv",
  ld: "ltr",
  alt: ["Merau"],
  cc: ["ID", "MY"]
}, {
  pk: 8060,
  ang: "Dayak Long Bila",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Long Bila",
  lc: "snv-x-longbila",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5745,
  ang: "Selee",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Selee",
  lc: "snw",
  ld: "ltr",
  alt: ["Sele", "Sentrokofi"],
  cc: ["GH"]
}, {
  pk: 5746,
  ang: "Sam",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sam",
  lc: "snx",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5747,
  ang: "Saniyo-Hiyewe",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Saniyo-Hiyewe",
  lc: "sny",
  ld: "ltr",
  alt: ["Hiyowe (Hiowe)", "Saniyo (Sanio)"],
  cc: ["PG"]
}, {
  pk: 5748,
  ang: "Sinsauru",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sinsauru",
  lc: "snz",
  ld: "ltr",
  alt: ["Kow"],
  cc: ["PG"]
}, {
  pk: 5749,
  ang: "Somali",
  lr: "Africa",
  gw: false,
  hc: "SO",
  ln: "Soomaaliga, af Soomaali",
  lc: "so",
  ld: "ltr",
  alt: ["Common Somali", "Standard Somali", "Af-Maxaad Tiri", "Af-Soomaali", "Soomaaliga", "Wardei", "Af-Ashraaf (Ashraaf)", "Issa"],
  cc: ["DJ", "ER", "ET", "KE", "GB", "NL", "SA", "SD", "TZ", "US", "YE", "CA", "IT", "SO", "AE"]
}, {
  pk: 5750,
  ang: "Thai Song",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Thai Song",
  lc: "soa",
  ld: "ltr",
  alt: ["Lao Song", "Song"],
  cc: ["TH"]
}, {
  pk: 5751,
  ang: "Sobei",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sobei",
  lc: "sob",
  ld: "ltr",
  alt: ["Imasi", "Liki"],
  cc: ["ID"]
}, {
  pk: 5752,
  ang: "So",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "So (Democratic Republic of Congo)",
  lc: "soc",
  ld: "ltr",
  alt: ["Eso", "Gesogo", "Soa", "Soko"],
  cc: ["CD"]
}, {
  pk: 5753,
  ang: "Songoora",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Songoora",
  lc: "sod",
  ld: "ltr",
  alt: ["Binja", "Kesongola", "Songola", "Gengele (Kegengele)"],
  cc: ["CD"]
}, {
  pk: 5754,
  ang: "Songomeno",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Songomeno",
  lc: "soe",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 5755,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "UZ",
  ln: "Sogdian",
  lc: "sog",
  ld: "ltr",
  alt: [],
  cc: ["UZ"]
}, {
  pk: 5756,
  ang: "Aka",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Aka",
  lc: "soh",
  ld: "ltr",
  alt: ["Jebel Silak", "Jebels Sillok", "Sillok"],
  cc: ["SD"]
}, {
  pk: 5757,
  ang: "Sonha",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Sonha",
  lc: "soi",
  ld: "ltr",
  alt: ["Sonahaa", "Sunah", "Sunha"],
  cc: ["NP"]
}, {
  pk: 5758,
  ang: "Soi",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u0632\u0628\u0627\u0646 \u0633\u0648\u06CC",
  lc: "soj",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 5759,
  ang: "Sokoro",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Sokoro",
  lc: "sok",
  ld: "ltr",
  alt: [],
  cc: ["SD", "TD"]
}, {
  pk: 5760,
  ang: "Solos",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Solos",
  lc: "sol",
  ld: "ltr",
  alt: ["Toros", "Nora Solos", "Peit Solos", "Pokai Tung", "Mainland Solos", "Kahule", "Coastal Solos (Hetal)"],
  cc: ["PG"]
}, {
  pk: 5761,
  ang: "Songo",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Songo",
  lc: "soo",
  ld: "ltr",
  alt: ["Itsong"],
  cc: ["CD"]
}, {
  pk: 5762,
  ang: "Songe",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Songe",
  lc: "sop",
  ld: "ltr",
  alt: ["Kalebwe", "Kisongi", "Kisongye", "Luba-Songi", "Lusonge", "Northeast Luba", "Songye", "Yembe", "Eastern Kalebwe (Ikalebwe)", "Kilombeno Kibya", "Western Kalebwe (Esambi Kipya)"],
  cc: ["CD"]
}, {
  pk: 5763,
  ang: "Kanasi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kanasi",
  lc: "soq",
  ld: "ltr",
  alt: ["Sona"],
  cc: ["PG"]
}, {
  pk: 5764,
  ang: "Somrai",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Somrai",
  lc: "sor",
  ld: "ltr",
  alt: ["Sibine", "Somray", "Somre", "Somrei", "Soumray", "Sounrai", "Sumrai"],
  cc: ["TD"]
}, {
  pk: 5765,
  ang: "Seenku",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Seenku",
  lc: "sos",
  ld: "ltr",
  alt: ["Sambla", "Samogho", "Southern Samo", "Southern Seeku (Gbeneku)", "Northern Seeku (Timiku)"],
  cc: ["BF"]
}, {
  pk: 7776,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Sambla",
  lc: "sos-x-sambla",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5766,
  ang: "Thai, Southern",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Southern Thai",
  lc: "sou",
  ld: "ltr",
  alt: ["Dambro", "Pak Tai", "Pak Thai", "Paktay", "Tak Bai (Tai Tak Bai)", "Thai Malay (Tai Islam)"],
  cc: ["TH"]
}, {
  pk: 5767,
  ang: "Sonsorol",
  lr: "Pacific",
  gw: false,
  hc: "PW",
  ln: "Sonsorol",
  lc: "sov",
  ld: "ltr",
  alt: ["Merir"],
  cc: ["PW"]
}, {
  pk: 5768,
  ang: "Sowanda",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sowanda",
  lc: "sow",
  ld: "ltr",
  alt: ["Waina-Sowanda", "Wanja", "Wanya", "Wina", "Punda-Umeda (Umada)"],
  cc: ["ID", "PG"]
}, {
  pk: 5769,
  ang: "Swo",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Swo",
  lc: "sox",
  ld: "ltr",
  alt: ["Fo", "Shwo", "S\xF4", "Sso"],
  cc: ["CM"]
}, {
  pk: 5770,
  ang: "Miyobe",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Miyobe",
  lc: "soy",
  ld: "ltr",
  alt: ["Bijobe", "Biyobe", "Kayobe", "Kuyobe", "Meyobe", "Solamba", "Solla", "Sorouba", "Soruba", "Uyobe", "Kyobe"],
  cc: ["BJ", "TG"]
}, {
  pk: 5771,
  ang: "Temi",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Temi",
  lc: "soz",
  ld: "ltr",
  alt: ["GiTemi", "Kisonjo", "Kitemi", "Wasonjo", "Watemi"],
  cc: ["TZ"]
}, {
  pk: 5772,
  ang: "Sepa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sepa (Indonesia)",
  lc: "spb",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 5773,
  ang: "Sap\xE9",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "Sap\xE9",
  lc: "spc",
  ld: "ltr",
  alt: ["Caliana", "Chirichano", "Kali\xE1na", "Kariana"],
  cc: ["VE"]
}, {
  pk: 5774,
  ang: "Saep",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Saep",
  lc: "spd",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5775,
  ang: "Sepa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sepa (Papua New Guinea)",
  lc: "spe",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5776,
  ang: "Sian",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Sian",
  lc: "spg",
  ld: "ltr",
  alt: ["Sihan"],
  cc: ["MY"]
}, {
  pk: 8225,
  ang: "Punan Rian",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Punan Rian",
  lc: "spg-x-punanrian",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5777,
  ang: "Sengo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sengo",
  lc: "spk",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5778,
  ang: "Selepet",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Selepet",
  lc: "spl",
  ld: "ltr",
  alt: ["Selepe"],
  cc: ["PG"]
}, {
  pk: 5779,
  ang: "Akukem",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Akukem",
  lc: "spm",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5780,
  ang: "Sanapan\xE1",
  lr: "Americas",
  gw: false,
  hc: "PY",
  ln: "Sanapan\xE1",
  lc: "spn",
  ld: "ltr",
  alt: [],
  cc: ["PY"]
}, {
  pk: 5781,
  ang: "Spokane",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Spokane",
  lc: "spo",
  ld: "ltr",
  alt: ["Spokan"],
  cc: ["US"]
}, {
  pk: 5782,
  ang: "S\xE9noufo, Supyire",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Supyire Senoufo",
  lc: "spp",
  ld: "ltr",
  alt: ["Sup'ide", "Suppire", "Supyire", "Kampwo", "Kadi", "Fanywohoshin", "Nyana nyuni"],
  cc: ["ML"]
}, {
  pk: 5783,
  ang: "Spanish, Loreto-Ucayali",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Loreto-Ucayali Spanish",
  lc: "spq",
  ld: "ltr",
  alt: ["Jungle Spanish"],
  cc: ["PE"]
}, {
  pk: 5784,
  ang: "Saparua",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Saparua",
  lc: "spr",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 5785,
  ang: "Saposa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Saposa",
  lc: "sps",
  ld: "ltr",
  alt: ["Saposa (Fa Saposa)"],
  cc: ["PG"]
}, {
  pk: 7744,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Boubouka",
  lc: "sps-x-bubuka",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5786,
  ang: "Spiti Bhoti",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Spiti Bhoti",
  lc: "spt",
  ld: "ltr",
  alt: ["Nyam", "Piti Bhoti"],
  cc: ["IN"]
}, {
  pk: 5787,
  ang: "Sapuan",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Sapuan",
  lc: "spu",
  ld: "ltr",
  alt: ["Sapouan"],
  cc: ["LA"]
}, {
  pk: 5788,
  ang: "Sambalpuri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Sambalpuri",
  lc: "spv",
  ld: "ltr",
  alt: ["Dom", "Kosali", "Koshal", "Koshali", "Western Oriya"],
  cc: ["IN"]
}, {
  pk: 5789,
  ang: "",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "South Picene",
  lc: "spx",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 5790,
  ang: "Sabaot",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Sabaot",
  lc: "spy",
  ld: "ltr",
  alt: ["Sebei", "Mt. Elgon Maasai", "Pok", "Soomeek", "Pong'om", "Mosoop", "Koony (Kony)", "Book (Bok)", "Bong'omeek (Bong'om)", "Sabiiny"],
  cc: ["KE"]
}, {
  pk: 5792,
  ang: "Shama-Sambuga",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Shama-Sambuga",
  lc: "sqa",
  ld: "ltr",
  alt: ["Tushama", "Ushama"],
  cc: ["NG"]
}, {
  pk: 5793,
  ang: "Shau",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Shau",
  lc: "sqh",
  ld: "ltr",
  alt: ["L\xECsh\xE1\xF9", "Sho"],
  cc: ["NG"]
}, {
  pk: 5791,
  ang: "Albanian",
  lr: "Europe",
  gw: false,
  hc: "AL",
  ln: "Shqip",
  lc: "sqi",
  ld: "ltr",
  alt: [],
  cc: ["AL"]
}, {
  pk: 5794,
  ang: "Albanian Sign Language",
  lr: "Europe",
  gw: false,
  hc: "AL",
  ln: "Albanian Sign Language",
  lc: "sqk",
  ld: "ltr",
  alt: ["AlbSL"],
  cc: ["AL"]
}, {
  pk: 5795,
  ang: "Suma",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Suma",
  lc: "sqm",
  ld: "ltr",
  alt: ["Souma"],
  cc: ["CF"]
}, {
  pk: 5796,
  ang: "Susquehannock",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Susquehannock",
  lc: "sqn",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 5797,
  ang: "Sorkhei",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Sorkhei",
  lc: "sqo",
  ld: "ltr",
  alt: ["Aftari"],
  cc: ["IR"]
}, {
  pk: 5798,
  ang: "Sou",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Sou",
  lc: "sqq",
  ld: "ltr",
  alt: ["Sawk", "Souk", "Su", "Su'", "Suq"],
  cc: ["LA"]
}, {
  pk: 5799,
  ang: "",
  lr: "Europe",
  gw: false,
  hc: "MT",
  ln: "Siculo Arabic",
  lc: "sqr",
  ld: "rtl",
  alt: [],
  cc: ["MT"]
}, {
  pk: 5800,
  ang: "Sri Lankan Sign Language",
  lr: "Asia",
  gw: false,
  hc: "LK",
  ln: "Sri Lankan Sign Language",
  lc: "sqs",
  ld: "ltr",
  alt: [],
  cc: ["LK"]
}, {
  pk: 5801,
  ang: "Soqotri",
  lr: "Asia",
  gw: false,
  hc: "YE",
  ln: "\u0627\u0644\u0644\u063A\u0629 \u0627\u0644\u0633\u0642\u0637\u0631\u064A\u0629",
  lc: "sqt",
  ld: "ltr",
  alt: ["Saqatri", "Socotri", "Sokotri", "Suqutri", "Abd Al-Kuri"],
  cc: ["YE"]
}, {
  pk: 5802,
  ang: "Squamish",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Squamish",
  lc: "squ",
  ld: "ltr",
  alt: ["Skwxwu'mesh snichim"],
  cc: ["CA"]
}, {
  pk: 5803,
  ang: "Serbian",
  lr: "Europe",
  gw: false,
  hc: "RS",
  ln: "\u0441\u0440\u043F\u0441\u043A\u0438 \u0458\u0435\u0437\u0438\u043A",
  lc: "sr",
  ld: "ltr",
  alt: ["Montenegrin", "Bosnian", "Shtokavski (Stokavian)", "Torlakian"],
  cc: ["BE", "CL", "BA", "HR", "GR", "AR", "FR", "DE", "ME", "GB", "RS", "MK", "TR", "US", "ZM", "AU", "CA"]
}, {
  pk: 5804,
  ang: "Saruga",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Saruga",
  lc: "sra",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5805,
  ang: "Sora",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Sora",
  lc: "srb",
  ld: "ltr",
  alt: ["Sabara", "Saonras", "Saora", "Saura", "Savara", "Sawaria", "Shabari", "Soura", "Swara"],
  cc: ["IN"]
}, {
  pk: 5806,
  ang: "Sardinian, Logudorese",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Logudorese Sardinian",
  lc: "src",
  ld: "ltr",
  alt: ["Central Sardinian", "Logudorese", "Sard", "Sardarese"],
  cc: ["IT"]
}, {
  pk: 5807,
  ang: "Bakati\u2019, Sara",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sara",
  lc: "sre",
  ld: "ltr",
  alt: ["Riok"],
  cc: ["ID"]
}, {
  pk: 5808,
  ang: "Nafi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nafi",
  lc: "srf",
  ld: "ltr",
  alt: ["Sirak"],
  cc: ["PG"]
}, {
  pk: 5809,
  ang: "Sulod",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Sulod",
  lc: "srg",
  ld: "ltr",
  alt: ["Bukidnon", "Mondo"],
  cc: ["PH"]
}, {
  pk: 5810,
  ang: "Sarikoli",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5854\u5409\u514B\u8BED",
  lc: "srh",
  ld: "ltr",
  alt: ["Saliku'er", "Salikur", "Sarikuli", "Sariqul", "Sarykoly", "Tadzik", "Tajik", "Tajiki"],
  cc: ["CN"]
}, {
  pk: 5811,
  ang: "Siriano",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Siriano",
  lc: "sri",
  ld: "ltr",
  alt: ["Sarir\xE1", "Siriana", "Siriane", "Surian\xE1", "Surir\xE1", "Suryana", "Chiranga", "Cirnga", "Si-Ra", "Sura Masa"],
  cc: ["BR", "CO"]
}, {
  pk: 5812,
  ang: "Serudung Murut",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Serudung Murut",
  lc: "srk",
  ld: "ltr",
  alt: ["Serudong", "Tawau Murut", "Tidung"],
  cc: ["MY"]
}, {
  pk: 5813,
  ang: "Isirawa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Isirawa",
  lc: "srl",
  ld: "ltr",
  alt: ["Okwasar", "Saberi", "Saweri"],
  cc: ["ID"]
}, {
  pk: 7560,
  ang: "",
  lr: "Europe",
  gw: false,
  hc: "RS",
  ln: "Serbian",
  lc: "sr-Latn",
  ld: "ltr",
  alt: [],
  cc: ["RS"]
}, {
  pk: 5814,
  ang: "Saramaccan",
  lr: "Americas",
  gw: false,
  hc: "SR",
  ln: "Saramaccan",
  lc: "srm",
  ld: "ltr",
  alt: ["Matuari", "Matawari (Matawai)", "Matoewari"],
  cc: ["GF", "SR"]
}, {
  pk: 5815,
  ang: "Sranan",
  lr: "Americas",
  gw: false,
  hc: "SR",
  ln: "Sranan Tongo",
  lc: "srn",
  ld: "ltr",
  alt: ["Surinaams", "Suriname Creole English", "Surinamese", "Taki-Taki"],
  cc: ["GF", "US", "SR"]
}, {
  pk: 5816,
  ang: "Sardinian, Campidanese",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Campidanese Sardinian",
  lc: "sro",
  ld: "ltr",
  alt: ["Campidanese", "Campidese", "Sardu", "South Sardinian", "Cagliare (Cagliari)", "Cagliaritan"],
  cc: ["IT"]
}, {
  pk: 5817,
  ang: "Sirion\xF3",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Sirion\xF3",
  lc: "srq",
  ld: "ltr",
  alt: ["Mbia Chee", "Mbya"],
  cc: ["BO"]
}, {
  pk: 5818,
  ang: "Serer-Sine",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Serer",
  lc: "srr",
  ld: "ltr",
  alt: ["Seereer", "Serer", "Serer-Sin", "Serrer", "Sine-Saloum", "Seex", "Sereer", "S\xE9r\xE8re-Sine", "Sine-Sine", "Dyegueme (Gyegem)"],
  cc: ["GM", "SN"]
}, {
  pk: 5819,
  ang: "Sarsi",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Sarsi",
  lc: "srs",
  ld: "ltr",
  alt: ["Sarcee", "Tsuu T'ina"],
  cc: ["CA"]
}, {
  pk: 5820,
  ang: "Sauri",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sauri",
  lc: "srt",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 5821,
  ang: "Suru\xED",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Suru\xED",
  lc: "sru",
  ld: "ltr",
  alt: ["Paiter", "Suru\xED de Rond\xF4nia", "Suru\xED do Jiparan\xE1"],
  cc: ["BR"]
}, {
  pk: 5822,
  ang: "Sorsoganon, Southern",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Southern Sorsoganon",
  lc: "srv",
  ld: "ltr",
  alt: ["Bikol Sorsogon", "Gubat", "Southern Sorsogon", "Sorsogon", "Waray"],
  cc: ["PH"]
}, {
  pk: 5823,
  ang: "Sirmauri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Sirmauri",
  lc: "srx",
  ld: "ltr",
  alt: ["Himachali", "Pahari", "Sirmouri", "Sirmuri", "Dharthi (Giriwari)"],
  cc: ["IN"]
}, {
  pk: 5824,
  ang: "Sera",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sera",
  lc: "sry",
  ld: "ltr",
  alt: ["Serra", "Ssia"],
  cc: ["PG"]
}, {
  pk: 5825,
  ang: "Shahmirzadi",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Shahmirzadi",
  lc: "srz",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 5826,
  ang: "Swati",
  lr: "Africa",
  gw: false,
  hc: "SZ",
  ln: "SiSwati",
  lc: "ss",
  ld: "ltr",
  alt: ["Sephuthi", "Siswati", "Siswazi", "Swazi", "Tekela", "Tekeza", "Isiswazi", "Thithiza", "Yeyeza", "Phuthi (Sephuthi)"],
  cc: ["MZ", "ZA", "US", "ZW", "SZ"]
}, {
  pk: 5827,
  ang: "Sama, Southern",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Southern Sama",
  lc: "ssb",
  ld: "ltr",
  alt: ["Southern Bajau", "Sama Tawi-Tawi", "Southern Sinama", "Sitangkai", "Sama Sibutu", "Samah", "Samal", "Samar", "Sapa-Sapa", "Sea Bajau", "Sibutu' (Sibutu)", "Sama Mandelaut", "Sama Laut", "Sea Gypsies", "Kubang", "Sama Pala'au", "Bajau Semporna (Bajau Asli)", "Bongao", "Laminusa (Laminusa Sinama)", "Languyan", "Pala'au", "Sama'", "Sama (A'a Sama)", "Bajau Laut (Mandelaut)", "Sama Kubang", "Balimbing"],
  cc: ["MY", "PH"]
}, {
  pk: 5828,
  ang: "Suba-Simbiti",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Suba-Simbiti",
  lc: "ssc",
  ld: "ltr",
  alt: ["Kisimbiti", "Kisuba", "Simbiti", "Kikine", "Kironi (Kikirone)", "Sweta (Kisweta)", "Surwa (Kisurwa)", "Ryeri", "Rieri (Rieri)", "Kine (Kiine)", "Hacha (Haacha)", "Kiiryege", "Kihacha", "Iryege (Iregi)", "Kiroba"],
  cc: ["TZ"]
}, {
  pk: 5829,
  ang: "Siroi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Siroi",
  lc: "ssd",
  ld: "ltr",
  alt: ["Suroi"],
  cc: ["PG"]
}, {
  pk: 5830,
  ang: "Sama, Balangingih",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Balangingi",
  lc: "sse",
  ld: "ltr",
  alt: ["Baangingi'", "Balagnini", "Balangingi Bajau", "Balanian", "Balanini", "Balignini", "Banadan", "Bangingih Sama", "Binadan", "Northern Sinama", "Sama", "Sama Bangingih", "Balanguingui", "Bangingi", "Northern Sama", "Samal", "Sibuco-Vitali (Sibuku)", "Sibuguey (Batuan)", "Lutangan (Lutango)"],
  cc: ["MY", "PH"]
}, {
  pk: 5831,
  ang: "Thao",
  lr: "Asia",
  gw: false,
  hc: "TW",
  ln: "Thao",
  lc: "ssf",
  ld: "ltr",
  alt: ["Chui-Huan", "Chuihwan", "Sao", "Sau", "Shao", "Suihwan", "Vulung"],
  cc: ["TW"]
}, {
  pk: 5832,
  ang: "Seimat",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Seimat",
  lc: "ssg",
  ld: "ltr",
  alt: ["Ninigo"],
  cc: ["PG"]
}, {
  pk: 5833,
  ang: "Arabic, Shihhi Spoken",
  lr: "Asia",
  gw: false,
  hc: "AE",
  ln: "\u0644\u0647\u062C\u0629 \u0642\u0628\u064A\u0644\u0629 \u0627\u0644\u0634\u062D\u0648\u062D",
  lc: "ssh",
  ld: "rtl",
  alt: ["Al-Shihuh", "Shihhi", "Shihu", "Shihuh"],
  cc: ["OM", "AE"]
}, {
  pk: 5834,
  ang: "Sansi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Sansi",
  lc: "ssi",
  ld: "ltr",
  alt: ["Bhilki", "Sansiboli"],
  cc: ["PK", "IN"]
}, {
  pk: 5835,
  ang: "Sausi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sausi",
  lc: "ssj",
  ld: "ltr",
  alt: ["Uya"],
  cc: ["PG"]
}, {
  pk: 5836,
  ang: "Sunam",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Sunam",
  lc: "ssk",
  ld: "ltr",
  alt: ["Central Kinnauri", "Sangnaur", "Sungam", "Sungnam", "Sunnam", "Thebarshad", "Thebor", "Theb\xF6r Skadd"],
  cc: ["IN"]
}, {
  pk: 5837,
  ang: "Sisaala, Western",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Western Sisaala",
  lc: "ssl",
  ld: "ltr",
  alt: ["Busillu Sisala", "Hissala", "Issala", "Sisai"],
  cc: ["GH"]
}, {
  pk: 5838,
  ang: "Semnam",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Semnam",
  lc: "ssm",
  ld: "ltr",
  alt: [],
  cc: ["MY"]
}, {
  pk: 5839,
  ang: "Waata",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Waata",
  lc: "ssn",
  ld: "ltr",
  alt: ["Ariangulu", "Langulo", "Sanye", "Waat", "Wasanye"],
  cc: ["KE"]
}, {
  pk: 5840,
  ang: "Sissano",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sissano",
  lc: "sso",
  ld: "ltr",
  alt: ["Sinama", "Sinano", "Sisano"],
  cc: ["PG"]
}, {
  pk: 5841,
  ang: "Spanish Sign Language",
  lr: "Europe",
  gw: false,
  hc: "ES",
  ln: "Spanish Sign Language",
  lc: "ssp",
  ld: "ltr",
  alt: ["M\xEDmica"],
  cc: ["ES", "HN"]
}, {
  pk: 5842,
  ang: "So\u2019a",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "So'a",
  lc: "ssq",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 5843,
  ang: "Swiss-French Sign Language",
  lr: "Europe",
  gw: false,
  hc: "CH",
  ln: "Swiss-French Sign Language",
  lc: "ssr",
  ld: "ltr",
  alt: ["Langage Gestuelle"],
  cc: ["CH"]
}, {
  pk: 5844,
  ang: "S\xF4",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "S\xF4",
  lc: "sss",
  ld: "ltr",
  alt: ["Bru", "Kah So", "Mang Cong", "Mangkong", "Mang-Koong", "Mankoong", "Thro", "Kha So"],
  cc: ["LA", "TH"]
}, {
  pk: 5845,
  ang: "Sinasina",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sinasina",
  lc: "sst",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5846,
  ang: "Susuami",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Susuami",
  lc: "ssu",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5847,
  ang: "Shark Bay",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Shark Bay",
  lc: "ssv",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 5848,
  ang: "Samberigi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Samberigi",
  lc: "ssx",
  ld: "ltr",
  alt: ["Sanaberigi", "Sau"],
  cc: ["PG"]
}, {
  pk: 5849,
  ang: "Saho",
  lr: "Africa",
  gw: false,
  hc: "ER",
  ln: "Saho",
  lc: "ssy",
  ld: "ltr",
  alt: ["Sao", "Shaho", "Shiho", "Shoho"],
  cc: ["ER", "ET"]
}, {
  pk: 7714,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Irob Saho",
  lc: "ssy-x-irob",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5850,
  ang: "Sengseng",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sengseng",
  lc: "ssz",
  ld: "ltr",
  alt: ["Asengseng"],
  cc: ["PG"]
}, {
  pk: 5851,
  ang: "Southern Sotho",
  lr: "Africa",
  gw: false,
  hc: "LS",
  ln: "Sesotho",
  lc: "st",
  ld: "ltr",
  alt: ["Sisutho", "Souto", "Suthu", "Suto"],
  cc: ["ZA", "US", "LS", "SZ", "BW"]
}, {
  pk: 5852,
  ang: "Settla",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Settla",
  lc: "sta",
  ld: "ltr",
  alt: ["Kisetla", "Kisettla"],
  cc: ["ZM"]
}, {
  pk: 5853,
  ang: "Subanen, Northern",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Northern Subanen",
  lc: "stb",
  ld: "ltr",
  alt: ["Tuboy Subanon", "Miatan", "Piyau", "Salog (Salug)"],
  cc: ["PH"]
}, {
  pk: 5854,
  ang: "Sentinel",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Sentinel",
  lc: "std",
  ld: "ltr",
  alt: ["Sentinelese"],
  cc: ["IN"]
}, {
  pk: 5855,
  ang: "Liana-Seti",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Liana-Seti",
  lc: "ste",
  ld: "ltr",
  alt: ["Liambata-Kobi", "Liana", "Lianan", "Teula", "Uhei Kachlakan", "Uhei Kaclakin", "Uhei Kahlakim"],
  cc: ["ID"]
}, {
  pk: 5856,
  ang: "Seta",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Seta",
  lc: "stf",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5857,
  ang: "Trieng",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Trieng",
  lc: "stg",
  ld: "ltr",
  alt: ["Dgi\xE9h", "Giang Ray", "Gie-Trieng", "Pin", "Strieng", "Talieng", "Tareh", "Ta-Rieng", "Treng"],
  cc: ["VN"]
}, {
  pk: 5858,
  ang: "Shelta",
  lr: "Europe",
  gw: false,
  hc: "IE",
  ln: "Shelta",
  lc: "sth",
  ld: "ltr",
  alt: ["Cant", "Gammon", "Irish Traveler Cant", "Sheldru", "The Cant"],
  cc: ["GB", "IE"]
}, {
  pk: 5859,
  ang: "Stieng, Bulo",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Bulo Stieng",
  lc: "sti",
  ld: "ltr",
  alt: ["Kajiang", "Bud\xEDp", "Northern Stieng", "Rangah", "Upper Stieng", "Xa-Dieng", "Xtieng", "Bulo"],
  cc: ["KH", "VN"]
}, {
  pk: 5860,
  ang: "Samo, Matya",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Matya Samo",
  lc: "stj",
  ld: "ltr",
  alt: ["Northwestern Samo", "San", "Sane", "Tougan", "West Central Goe", "S\xE3"],
  cc: ["BF"]
}, {
  pk: 5861,
  ang: "Arammba",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Arammba",
  lc: "stk",
  ld: "ltr",
  alt: ["Serki", "Serkisetavi", "Upper Morehead"],
  cc: ["PG"]
}, {
  pk: 5862,
  ang: "Stellingwerfs",
  lr: "Europe",
  gw: false,
  hc: "NL",
  ln: "Stellingwerfs",
  lc: "stl",
  ld: "ltr",
  alt: ["Stellingwarfs", "Stellingwerf"],
  cc: ["NL"]
}, {
  pk: 5863,
  ang: "Setaman",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Setaman",
  lc: "stm",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5864,
  ang: "Owa",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Owa",
  lc: "stn",
  ld: "ltr",
  alt: ["Anganiwai", "Anganiwei", "Narihua", "Santa Anna", "Wanoni", "Tawarafa (Star Harbour)", "Santa Catalina (Owa Riki)", "Santa Anna (Owa Raha)"],
  cc: ["SB"]
}, {
  pk: 8215,
  ang: "Owa Santa Catalina",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Owa Santa Catalina",
  lc: "stn-x-owariki",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8216,
  ang: "Tawarafa",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Tawarafa",
  lc: "stn-x-tawarafa",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5865,
  ang: "Stoney",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Stoney",
  lc: "sto",
  ld: "ltr",
  alt: ["Nakoda", "Stony", "Southern Stoney", "Northern Stoney"],
  cc: ["CA"]
}, {
  pk: 5866,
  ang: "Tepehuan, Southeastern",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Southeastern Tepehuan",
  lc: "stp",
  ld: "ltr",
  alt: ["Tepehu\xE1n del Sureste", "Tepehuano"],
  cc: ["MX"]
}, {
  pk: 5867,
  ang: "Saterfriesisch",
  lr: "Europe",
  gw: false,
  hc: "DE",
  ln: "Saterfriesisch",
  lc: "stq",
  ld: "ltr",
  alt: ["Saterfriesiesch", "Saterlandic", "Saterlandic Frisian", "Saterl\xE4ndisch"],
  cc: ["DE"]
}, {
  pk: 5868,
  ang: "Salish, Straits",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Straits Salish",
  lc: "str",
  ld: "ltr",
  alt: ["Northern Straits Salish", "Straits", "Semiahmoo", "Ts'ooke"],
  cc: ["CA"]
}, {
  pk: 5869,
  ang: "Shumashti",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Shumashti",
  lc: "sts",
  ld: "ltr",
  alt: ["Shumasht"],
  cc: ["AF", "PK"]
}, {
  pk: 5870,
  ang: "Stieng, Budeh",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Xti\xEAng",
  lc: "stt",
  ld: "ltr",
  alt: ["Lower Stieng", "Southern Stieng"],
  cc: ["VN"]
}, {
  pk: 5871,
  ang: "Samtao",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Samtao",
  lc: "stu",
  ld: "ltr",
  alt: ["Samtau", "Samtuan"],
  cc: ["LA", "MM"]
}, {
  pk: 5872,
  ang: "Silt\u2019e",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Silt'e",
  lc: "stv",
  ld: "ltr",
  alt: ["East Gurage", "Selti", "Silti", "Enneqor (Inneqor)", "Ulbarag (Urbareg)"],
  cc: ["ET"]
}, {
  pk: 5873,
  ang: "Satawalese",
  lr: "Pacific",
  gw: false,
  hc: "FM",
  ln: "Satawalese",
  lc: "stw",
  ld: "ltr",
  alt: [],
  cc: ["FM"]
}, {
  pk: 5874,
  ang: "Tatar, Siberian",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0421\u0438\u0431\u0438\u0440\u0441\u043A\u043E-\u0442\u0430\u0442\u0430\u0440\u0441\u043A\u0438\u0439",
  lc: "sty",
  ld: "ltr",
  alt: [],
  cc: ["RU"]
}, {
  pk: 5875,
  ang: "Sundanese",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Basa Sunda",
  lc: "su",
  ld: "ltr",
  alt: ["Priangan", "Sundanese", "Bogor (Krawang)"],
  cc: ["ID"]
}, {
  pk: 5876,
  ang: "Sulka",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sulka",
  lc: "sua",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5877,
  ang: "Suku",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Suku",
  lc: "sub",
  ld: "ltr",
  alt: ["Kisuku"],
  cc: ["CD", "AO"]
}, {
  pk: 5878,
  ang: "Subanon, Western",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Western Subanon",
  lc: "suc",
  ld: "ltr",
  alt: ["Siocon", "Western Kolibugan (Western Kalibugan)"],
  cc: ["PH"]
}, {
  pk: 7628,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "South Sudan Sign Language",
  lc: "sud-x-sosudansl",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5879,
  ang: "Suena",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Suena",
  lc: "sue",
  ld: "ltr",
  alt: ["Yarawe", "Yarawi", "Yema"],
  cc: ["PG"]
}, {
  pk: 5880,
  ang: "Suganga",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Suganga",
  lc: "sug",
  ld: "ltr",
  alt: ["North Mianmin", "Wagarabai"],
  cc: ["PG"]
}, {
  pk: 5881,
  ang: "Suki",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Suki",
  lc: "sui",
  ld: "ltr",
  alt: ["Wiram"],
  cc: ["PG"]
}, {
  pk: 5882,
  ang: "Shubi",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Shubi",
  lc: "suj",
  ld: "ltr",
  alt: ["Kishubi", "Sinja", "Subi", "Urushubi"],
  cc: ["TZ"]
}, {
  pk: 5883,
  ang: "Sukuma",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Sukuma",
  lc: "suk",
  ld: "ltr",
  alt: ["Gwe (Kigwe)"],
  cc: ["TZ", "CA"]
}, {
  pk: 7840,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Brebes",
  lc: "sun-x-brebes",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5884,
  ang: "Suri",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Suri",
  lc: "suq",
  ld: "ltr",
  alt: ["Churi", "Dhuri", "Eastern Suri", "Shuri", "Shuro", "Tid", "Tirmagi", "Tirima", "Terna", "Tirmaga (Cirma)", "Dirma", "Chai (Caci)", "Cai", "Terema"],
  cc: ["ET", "SS"]
}, {
  pk: 5885,
  ang: "Mwaghavul",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Mwaghavul",
  lc: "sur",
  ld: "ltr",
  alt: ["Sura", "Mapun", "Mupun (Mapan)"],
  cc: ["NG"]
}, {
  pk: 5886,
  ang: "Susu",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Susu",
  lc: "sus",
  ld: "ltr",
  alt: ["Sose", "Soso", "Soussou", "Susoo", "Sosu", "Sousou"],
  cc: ["SN", "GN", "GW", "SL"]
}, {
  pk: 5887,
  ang: "Subtiaba",
  lr: "Americas",
  gw: false,
  hc: "NI",
  ln: "Subtiaba",
  lc: "sut",
  ld: "ltr",
  alt: [],
  cc: ["NI"]
}, {
  pk: 5888,
  ang: "Puroik",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Puroik",
  lc: "suv",
  ld: "ltr",
  alt: [],
  cc: ["CN", "IN"]
}, {
  pk: 5889,
  ang: "Sumbwa",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Sumbwa",
  lc: "suw",
  ld: "ltr",
  alt: ["Kisumbwa"],
  cc: ["TZ"]
}, {
  pk: 5890,
  ang: "Sumerian",
  lr: "Asia",
  gw: false,
  hc: "IQ",
  ln: "Sumerian",
  lc: "sux",
  ld: "ltr",
  alt: [],
  cc: ["IQ"]
}, {
  pk: 5891,
  ang: "Suy\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Suy\xE1",
  lc: "suy",
  ld: "ltr",
  alt: ["Kis\xEAdj\xEA", "Waiku", "Yaruma (Jarum\xE1)", "Bei\xE7o de Pau (Tapay\xFAna)"],
  cc: ["BR"]
}, {
  pk: 5892,
  ang: "Sunuwar",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u0938\u0941\u0928\u0941\u0935\u093E\u0930",
  lc: "suz",
  ld: "ltr",
  alt: ["Bhujuwar", "Kirati-Koits", "Koits Lo", "Mukhiya", "Pirthwar", "Sunwari"],
  cc: ["NP"]
}, {
  pk: 5893,
  ang: "Swedish",
  lr: "Europe",
  gw: false,
  hc: "SE",
  ln: "svenska",
  lc: "sv",
  ld: "ltr",
  alt: ["Ruotsi", "Svenska", "Eastern Swedish (Estonian Swedish)", "Standard Swedish", "Southern Swedish", "Southern Swedish (Scanian)", "Scanian (Eastern Danish)", "Sk\xE5nska", "Sk\xE5ne", "Uusimaa Swedish (Nyland Swedish)", "\xD6sterbotten (Ostrobothnian)", "Northern Swedish (Norrland)", "Jamska", "Gutniska (Gotlandic)", "Gutnic", "Finland Swedish", "Gutamal", "Dalecarlian", "\xC5land Islands Swedish"],
  cc: ["AT", "FR", "GB", "NO", "SE", "CH", "US", "FI", "CA", "DK"]
}, {
  pk: 5894,
  ang: "Svan",
  lr: "Asia",
  gw: false,
  hc: "GE",
  ln: "\u10DA\u10E3\u10E8\u10DC\u10E3 \u10DC\u10D8\u10DC",
  lc: "sva",
  ld: "ltr",
  alt: ["Svanuri"],
  cc: ["GE"]
}, {
  pk: 5895,
  ang: "Ulau-Suain",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ulau-Suain",
  lc: "svb",
  ld: "ltr",
  alt: ["Suain"],
  cc: ["PG"]
}, {
  pk: 5896,
  ang: "Vincentian Creole English",
  lr: "Americas",
  gw: false,
  hc: "VC",
  ln: "Vincentian Creole English",
  lc: "svc",
  ld: "ltr",
  alt: ["Vincy Twang"],
  cc: ["VC"]
}, {
  pk: 5897,
  ang: "Serili",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Serili",
  lc: "sve",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 5898,
  ang: "Slovakian Sign Language",
  lr: "Europe",
  gw: false,
  hc: "SK",
  ln: "Slovakian Sign Language",
  lc: "svk",
  ld: "ltr",
  alt: [],
  cc: ["SK"]
}, {
  pk: 5899,
  ang: "Slavomolisano",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Slavomolisano",
  lc: "svm",
  ld: "ltr",
  alt: ["Croato molisano", "Molise Slavic", "Na\u0161 jezik", "Slavic of Molise"],
  cc: ["IT"]
}, {
  pk: 5900,
  ang: "Savara",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Savara",
  lc: "svr",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 5901,
  ang: "Savosavo",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Savosavo",
  lc: "svs",
  ld: "ltr",
  alt: ["Savo", "Savo Island"],
  cc: ["SB"]
}, {
  pk: 5902,
  ang: "Slalvian",
  lr: "Europe",
  gw: false,
  hc: "LT",
  ln: "Skalvian",
  lc: "svx",
  ld: "ltr",
  alt: [],
  cc: ["LT"]
}, {
  pk: 5903,
  ang: "Swahili",
  lr: "Africa",
  gw: true,
  hc: "TZ",
  ln: "Kiswahili",
  lc: "sw",
  ld: "ltr",
  alt: [],
  cc: ["TZ"]
}, {
  pk: 5904,
  ang: "Comorian, Maore",
  lr: "Africa",
  gw: false,
  hc: "YT",
  ln: "Maore Comorian",
  lc: "swb",
  ld: "ltr",
  alt: ["Comores Swahili", "Comoro", "Komoro", "Maore", "Comorian"],
  cc: ["FR", "MG", "TZ", "CA", "YT"]
}, {
  pk: 5905,
  ang: "Swahili, Congo",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Congo Swahili",
  lc: "swc",
  ld: "ltr",
  alt: ["Za\xEFre Swahili"],
  cc: ["CD"]
}, {
  pk: 5906,
  ang: "Sere",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Sere",
  lc: "swf",
  ld: "ltr",
  alt: ["Basili", "Basiri", "Chere", "Serre", "Shaire", "Shere", "Sheri", "Sili", "Siri"],
  cc: ["CD"]
}, {
  pk: 5907,
  ang: "Swabian",
  lr: "Europe",
  gw: false,
  hc: "DE",
  ln: "Swabian",
  lc: "swg",
  ld: "ltr",
  alt: ["Schw\xE4bisch", "Schwaebisch", "Suabian"],
  cc: ["DE"]
}, {
  pk: 5908,
  ang: "Swahili",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Swahili (individual language)",
  lc: "swh",
  ld: "ltr",
  alt: ["Arab-Swahili", "Kisuahili", "Kiswaheli", "Suahili", "Kisuaheli", "Kiswahili", "Mwiini", "Mwini (Af-Chimwiini)", "Pemba (Hadimu)", "Phemba", "Shamba (Kishamba)", "Tambatu", "Tikulu", "Mvita (Kimvita)", "Zanzibar", "T'ik'uu", "Tukulu", "Barwaani", "Bajun", "Bajuni (Af-Bajuun)", "Mombasa", "Unguja (Kiunguja)", "Bravanese", "Chimbalazi", "Chimwiini", "Gunya", "Kibajuni", "Mbalazi", "Bajuni (Bajun)"],
  cc: ["KM", "KE", "MZ", "OM", "RW", "SA", "SC", "SD", "ZA", "TZ", "US", "ZM", "CA", "SO", "UG", "BI", "YT", "AE"]
}, {
  pk: 5909,
  ang: "Sui",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6C34\u8BED",
  lc: "swi",
  ld: "ltr",
  alt: ["Ai Sui", "Sui Li", "Suipo", "Sandong (Central Sui)", "Southern Sui"],
  cc: ["CN"]
}, {
  pk: 5910,
  ang: "Sira",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Sira",
  lc: "swj",
  ld: "ltr",
  alt: ["Gisira", "Ichira", "Ishira", "Isira", "Shira", "Shire", "Yichira"],
  cc: ["GA"]
}, {
  pk: 5911,
  ang: "Sena, Malawi",
  lr: "Africa",
  gw: false,
  hc: "MW",
  ln: "Malawi Sena",
  lc: "swk",
  ld: "ltr",
  alt: ["Chisena", "Cisena", "Chimanganja"],
  cc: ["MW"]
}, {
  pk: 5912,
  ang: "Swedish Sign Language",
  lr: "Europe",
  gw: false,
  hc: "SE",
  ln: "Swedish Sign Language",
  lc: "swl",
  ld: "ltr",
  alt: [],
  cc: ["SE"]
}, {
  pk: 5913,
  ang: "Samosa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Samosa",
  lc: "swm",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5914,
  ang: "Shanenawa",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Shanenawa",
  lc: "swo",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 5915,
  ang: "Suau",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Suau",
  lc: "swp",
  ld: "ltr",
  alt: ["Sinaki (Gadaisu)", "Gaidasu", "Fife Bay", "Lausaha (Daui)"],
  cc: ["PG"]
}, {
  pk: 8345,
  ang: "Bonalua",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bonalua",
  lc: "swp-x-bonalua",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8248,
  ang: "Lausaha",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Lausaha",
  lc: "swp-x-lausaha",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7548,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sinaki",
  lc: "swp-x-sinaki",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5916,
  ang: "Sharwa",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Sharwa",
  lc: "swq",
  ld: "ltr",
  alt: ["Sarwaye", "Sherwin", "Tchevi"],
  cc: ["CM"]
}, {
  pk: 5917,
  ang: "Saweru",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Saweru",
  lc: "swr",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 5918,
  ang: "Seluwasan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Seluwasan",
  lc: "sws",
  ld: "ltr",
  alt: ["Selvasa", "Selwasa"],
  cc: ["ID"]
}, {
  pk: 8419,
  ang: "Makatian",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Makatian",
  lc: "sws-x-makatian",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5919,
  ang: "Sawila",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sawila",
  lc: "swt",
  ld: "ltr",
  alt: ["Tanglapui"],
  cc: ["ID"]
}, {
  pk: 5920,
  ang: "Suwawa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Suwawa",
  lc: "swu",
  ld: "ltr",
  alt: ["Bonda", "Bone", "Bune", "Suvava", "Toewawa"],
  cc: ["ID"]
}, {
  pk: 5921,
  ang: "Shekhawati",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Shekhawati",
  lc: "swv",
  ld: "ltr",
  alt: ["Shekhawati-Marwari", "Jhunjhunu-Churu", "Sikar"],
  cc: ["IN"]
}, {
  pk: 5922,
  ang: "Sowa",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Sowa",
  lc: "sww",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 5923,
  ang: "Suruah\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Suruah\xE1",
  lc: "swx",
  ld: "ltr",
  alt: ["Indios do Coxodo\xE1", "Suruwah\xE1", "Zuruah\xE1"],
  cc: ["BR"]
}, {
  pk: 5924,
  ang: "Sarua",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Sarua",
  lc: "swy",
  ld: "ltr",
  alt: ["Saroua", "Sarwa"],
  cc: ["CM", "TD"]
}, {
  pk: 5925,
  ang: "Suba",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Suba",
  lc: "sxb",
  ld: "ltr",
  alt: ["Luo AbaSuba", "EgiSuba"],
  cc: ["KE"]
}, {
  pk: 5926,
  ang: "Sicanian",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Sicanian",
  lc: "sxc",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 5927,
  ang: "Sighu",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Sighu",
  lc: "sxe",
  ld: "ltr",
  alt: ["Lesighu", "Mississiou"],
  cc: ["GA"]
}, {
  pk: 5928,
  ang: "Shixing",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u65ED\u7C73",
  lc: "sxg",
  ld: "ltr",
  alt: ["Xumi"],
  cc: ["CN"]
}, {
  pk: 5929,
  ang: "Southern Kalapuya",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Southern Kalapuya",
  lc: "sxk",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 5930,
  ang: "Selian",
  lr: "Europe",
  gw: false,
  hc: "LV",
  ln: "Selian",
  lc: "sxl",
  ld: "ltr",
  alt: [],
  cc: ["LV"]
}, {
  pk: 5931,
  ang: "Samre",
  lr: "Asia",
  gw: false,
  hc: "KH",
  ln: "Samre",
  lc: "sxm",
  ld: "ltr",
  alt: [],
  cc: ["KH"]
}, {
  pk: 5932,
  ang: "Sangir",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sangir",
  lc: "sxn",
  ld: "ltr",
  alt: ["Sangi", "Sangih", "Sangih\xE9", "Sangirese", "Taruna (Tahuna)", "Manganitu (Tamako)", "Siau (Sjauw)", "Tabukang (Tabukan)", "Tagulandang (Tahulandang)"],
  cc: ["ID"]
}, {
  pk: 7691,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tagulandang",
  lc: "sxn-x-tagula",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5933,
  ang: "Sorothaptic",
  lr: "Europe",
  gw: false,
  hc: "ES",
  ln: "Sorothaptic",
  lc: "sxo",
  ld: "ltr",
  alt: [],
  cc: ["ES"]
}, {
  pk: 5934,
  ang: "Saaroa",
  lr: "Asia",
  gw: false,
  hc: "TW",
  ln: "Saaroa",
  lc: "sxr",
  ld: "ltr",
  alt: ["Hla'alua", "La'alua", "La'arua", "Lha'alua", "Pachien", "Paichien", "Rarua", "Saarua", "Saroa", "Shishaban", "Sisyaban"],
  cc: ["TW"]
}, {
  pk: 5935,
  ang: "Sasaru",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Sasaru",
  lc: "sxs",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 5936,
  ang: "Saxon, Upper",
  lr: "Europe",
  gw: false,
  hc: "DE",
  ln: "Upper Saxon",
  lc: "sxu",
  ld: "ltr",
  alt: ["Erzgebirgisch", "Hessian (Hessisch)"],
  cc: ["DE"]
}, {
  pk: 5937,
  ang: "Gbe, Saxwe",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Saxwe Gbe",
  lc: "sxw",
  ld: "ltr",
  alt: ["Sahou\xE8", "Sahou\xE8gbe", "Saxwe", "Saxwegbe", "Tsaph?", "Tsaph? -Gbe", "Daxe", "Se"],
  cc: ["BJ"]
}, {
  pk: 5938,
  ang: "Siang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Siang",
  lc: "sya",
  ld: "ltr",
  alt: ["Ot Siang"],
  cc: ["ID"]
}, {
  pk: 8084,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Sisang",
  lc: "sya-x-dayaksisang",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5939,
  ang: "Subanen, Central",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Central Subanen",
  lc: "syb",
  ld: "ltr",
  alt: ["Sindangan Subanun", "Eastern Kolibugan (Eastern Kalibugan)"],
  cc: ["PH"]
}, {
  pk: 5940,
  ang: "Syriac",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Classical Syriac",
  lc: "syc",
  ld: "ltr",
  alt: ["Ancient Syriac", "Classical Syriac", "Lishana Atiga", "Suryaya", "Suryoyo"],
  cc: ["TR"]
}, {
  pk: 5941,
  ang: "Seki",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Seki",
  lc: "syi",
  ld: "ltr",
  alt: ["Seke", "Sekiana", "Sekiani", "Sekiyani", "Sekyani", "Seseki", "Sheke", "Shekiyana"],
  cc: ["GQ", "GA"]
}, {
  pk: 5942,
  ang: "Sukur",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Sukur",
  lc: "syk",
  ld: "ltr",
  alt: ["Adikimmu Sukur", "Gemasakun", "Sakul", "Sugur"],
  cc: ["NG"]
}, {
  pk: 5943,
  ang: "Sylheti",
  lr: "Asia",
  gw: false,
  hc: "BD",
  ln: "Sylheti",
  lc: "syl",
  ld: "ltr",
  alt: ["Sileti", "Siloti", "Srihattia", "Sylhetti", "Sylhetti Bangla", "Syloti", "Syloty", "Bengali of Cachar", "Sylheti Bangla", "Sylheti Bengali"],
  cc: ["BD"]
}, {
  pk: 5944,
  ang: "Samo, Maya",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Maya Samo",
  lc: "sym",
  ld: "ltr",
  alt: ["Northeastern Samo", "Sa", "San", "Kiembara (Northeastern Goe)"],
  cc: ["BF"]
}, {
  pk: 5945,
  ang: "Senaya",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u0632\u0628\u0627\u0646 \u0633\u0646\u0627\u06CC\u0627",
  lc: "syn",
  ld: "ltr",
  alt: ["Christian Neo-Aramaic", "Lshan Sray", "Senaaya", "Shan Gyanan", "Shan Sray", "Soray", "Sray"],
  cc: ["IR", "US"]
}, {
  pk: 5946,
  ang: "Suoy",
  lr: "Asia",
  gw: false,
  hc: "KH",
  ln: "Suoy",
  lc: "syo",
  ld: "ltr",
  alt: ["Su'ung"],
  cc: ["KH"]
}, {
  pk: 5947,
  ang: "Syriac",
  lr: "Asia",
  gw: false,
  hc: "IQ",
  ln: "\u0720\u072B\u0722\u0710 \u0723\u0718\u072A\u071D\u071D\u0710",
  lc: "syr",
  ld: "ltr",
  alt: [],
  cc: ["IQ"]
}, {
  pk: 5948,
  ang: "Sinyar",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Sinyar",
  lc: "sys",
  ld: "ltr",
  alt: ["Shamya", "Shamyan", "Shemya", "Sinya", "Symiarta", "Taar Shamyan", "Zimirra"],
  cc: ["SD", "TD"]
}, {
  pk: 5949,
  ang: "Syuba",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u0938\u094D\u092F\u0941\u092C\u093E",
  lc: "syw",
  ld: "ltr",
  alt: ["Shuuba", "Shyuuba", "Syuuba", "Syuwa", "Yholmo", "Yholmoli", "Yholmu", "Kagate Bhote"],
  cc: ["NP"]
}, {
  pk: 5950,
  ang: "Samay",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Samay",
  lc: "syx",
  ld: "ltr",
  alt: [],
  cc: ["GA"]
}, {
  pk: 5951,
  ang: "Al-Sayyid Bedouin Sign Language",
  lr: "Asia",
  gw: false,
  hc: "IL",
  ln: "\u05E9\u05E4\u05EA \u05D4\u05E1\u05D9\u05DE\u05E0\u05D9\u05DD \u05E9\u05DC \u05E9\u05D1\u05D8 \u05D0-\u05E1\u05D9\u05D9\u05D3",
  lc: "syy",
  ld: "ltr",
  alt: ["ABSL"],
  cc: ["IL"]
}, {
  pk: 5952,
  ang: "Semelai",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Semelai",
  lc: "sza",
  ld: "ltr",
  alt: [],
  cc: ["MY"]
}, {
  pk: 5953,
  ang: "Ngalum",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ngalum",
  lc: "szb",
  ld: "ltr",
  alt: [],
  cc: ["ID", "PG"]
}, {
  pk: 5954,
  ang: "Semaq Beri",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Semaq Beri",
  lc: "szc",
  ld: "ltr",
  alt: ["Semaq Bri", "Semoq Beri"],
  cc: ["MY"]
}, {
  pk: 5955,
  ang: "Seze",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Seze",
  lc: "sze",
  ld: "ltr",
  alt: ["Sezo"],
  cc: ["ET"]
}, {
  pk: 5956,
  ang: "Kesengele",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kesengele",
  lc: "szg",
  ld: "ltr",
  alt: ["Kesengele", "Sengere"],
  cc: ["CD"]
}, {
  pk: 5957,
  ang: "Silesian",
  lr: "Europe",
  gw: false,
  hc: "PL",
  ln: "Silesian",
  lc: "szl",
  ld: "ltr",
  alt: ["Szlonzokian"],
  cc: ["PL"]
}, {
  pk: 5958,
  ang: "Sula",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sula",
  lc: "szn",
  ld: "ltr",
  alt: ["Sanana", "Facei (Fac\xE9)"],
  cc: ["ID"]
}, {
  pk: 5959,
  ang: "Suabo",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Suabo",
  lc: "szp",
  ld: "ltr",
  alt: ["Iagu", "Inanwatan", "Mirabo", "Suabau"],
  cc: ["ID"]
}, {
  pk: 5960,
  ang: "Isu",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Isu (Fako Division)",
  lc: "szv",
  ld: "ltr",
  alt: ["Isubu", "Isuwu", "Su", "Subu"],
  cc: ["CM"]
}, {
  pk: 5961,
  ang: "Sawai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sawai",
  lc: "szw",
  ld: "ltr",
  alt: ["Weda-Sawai", "Were", "Faya-Mafa", "Messa-Dote"],
  cc: ["ID"]
}, {
  pk: 5962,
  ang: "Tamil",
  lr: "Asia",
  gw: true,
  hc: "IN",
  ln: "\u0BA4\u0BAE\u0BBF\u0BB4\u0BCD",
  lc: "ta",
  ld: "ltr",
  alt: ["Damulian", "Tamal", "Tamalsan", "Tambul", "Tamili", "Madurai"],
  cc: ["FR", "DE", "LK", "GB", "CX", "MY", "OM", "NL", "SC", "TH", "US", "KH", "CA", "KW", "MV", "IN", "SG", "MM", "BH", "QA"]
}, {
  pk: 5963,
  ang: "Tanana, Lower",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Lower Tanana",
  lc: "taa",
  ld: "ltr",
  alt: ["Tanana"],
  cc: ["US"]
}, {
  pk: 5964,
  ang: "Tabassaran",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0422\u0430\u0431\u0430\u0441\u0430\u0440\u0430\u043D\u0441\u043A\u0438\u0439",
  lc: "tab",
  ld: "ltr",
  alt: ["Ghumghum", "Tabasaran", "Tabasarantsy", "North Tabasaran (Khanag)"],
  cc: ["AZ", "RU", "TM"]
}, {
  pk: 5965,
  ang: "Tarahumara, Western",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Lowland Tarahumara",
  lc: "tac",
  ld: "ltr",
  alt: ["Baja Tarahumara", "Lowland Tarahumara", "Ral\xE1muli de la Baja Tarahumara", "Rar\xE1muri", "Rocoroibo", "Tarahumara del Oeste", "Tarahumara del Poniente"],
  cc: ["MX"]
}, {
  pk: 5966,
  ang: "Tause",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tause",
  lc: "tad",
  ld: "ltr",
  alt: ["Darha", "Doa"],
  cc: ["ID"]
}, {
  pk: 5967,
  ang: "Tariana",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Tariana",
  lc: "tae",
  ld: "ltr",
  alt: ["Tali\xE1seri", "Tariano", "Tari\xE1no", "Tar\xEEna", "Tari\xE1na"],
  cc: ["BR", "CO"]
}, {
  pk: 5968,
  ang: "Tapirap\xE9",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Tapirap\xE9",
  lc: "taf",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 5969,
  ang: "Tagoi",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Tagoi",
  lc: "tag",
  ld: "ltr",
  alt: ["Tagoy"],
  cc: ["SD"]
}, {
  pk: 5970,
  ang: "Tamang, Eastern",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Eastern Tamang",
  lc: "taj",
  ld: "ltr",
  alt: ["Ishang", "Murmi", "Sei", "Bhotia", "Central-Eastern Tamang (Temal Tamang)", "Outer-Eastern Tamang (Sailung Tamang)"],
  cc: ["BT", "NP"]
}, {
  pk: 5971,
  ang: "Tala",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Tala",
  lc: "tak",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 5972,
  ang: "Tal",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Tal",
  lc: "tal",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 7979,
  ang: "Telungu",
  lr: "Asia",
  gw: false,
  hc: "LK",
  ln: "\u0915\u0941\u0930\u0935\u093E\u0901",
  lc: "tam-x-ahikunthakayo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5973,
  ang: "Tangale",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Tangale",
  lc: "tan",
  ld: "ltr",
  alt: ["Tangle"],
  cc: ["NG"]
}, {
  pk: 5974,
  ang: "Yami",
  lr: "Asia",
  gw: false,
  hc: "TW",
  ln: "Yami",
  lc: "tao",
  ld: "ltr",
  alt: ["Botel Tabago", "Botel Tobago", "Lanyu", "Tao", "Tawu"],
  cc: ["TW"]
}, {
  pk: 5975,
  ang: "Taabwa",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Taabwa",
  lc: "tap",
  ld: "ltr",
  alt: ["Ichitaabwa", "Rungu", "Taabua", "Tabwa"],
  cc: ["ZM", "CD"]
}, {
  pk: 5976,
  ang: "Tamasheq",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Tamasheq",
  lc: "taq",
  ld: "ltr",
  alt: ["Tamashekin", "Tomacheck", "Tuareg", "Kidal", "Kidal Tamasheq", "Tadghaq (Kidal)", "Tadhaq (Kidal)", "Timbuktu (Tanaslamt)", "Tombouctou"],
  cc: ["BF", "ML", "MR"]
}, {
  pk: 5977,
  ang: "Tarahumara, Central",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Central Tarahumara",
  lc: "tar",
  ld: "ltr",
  alt: ["Alta Tarahumara", "Ral\xE1muli de la Tarahumara Alta", "Samachique Tarahumara", "Tarahumara de Cumbres", "Tarahumara del Centro"],
  cc: ["MX"]
}, {
  pk: 5978,
  ang: "Tanana, Upper",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Upper Tanana",
  lc: "tau",
  ld: "ltr",
  alt: ["Nabesna"],
  cc: ["US", "CA"]
}, {
  pk: 5979,
  ang: "Tatuyo",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Tatuyo",
  lc: "tav",
  ld: "ltr",
  alt: ["Juna", "Oa", "Pamoa", "Sina", "Sura", "Tatutapuyo"],
  cc: ["CO"]
}, {
  pk: 5980,
  ang: "Tai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tai",
  lc: "taw",
  ld: "ltr",
  alt: ["Tay"],
  cc: ["PG", "IN"]
}, {
  pk: 5981,
  ang: "Tamki",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Tamki",
  lc: "tax",
  ld: "ltr",
  alt: ["Temki"],
  cc: ["TD"]
}, {
  pk: 5982,
  ang: "Atayal",
  lr: "Asia",
  gw: false,
  hc: "TW",
  ln: "Atayal",
  lc: "tay",
  ld: "ltr",
  alt: ["Ataiyal", "Attayal", "Bonotsek", "Shabogala", "Taijyal", "Taiyal", "Takonan", "Tangao", "Tyal", "Yukan", "Sqoleq (Squliq)", "Ts'ole' (Ci'uli')"],
  cc: ["TW"]
}, {
  pk: 5983,
  ang: "Tocho",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Tocho",
  lc: "taz",
  ld: "ltr",
  alt: ["Tacho", "Toicho"],
  cc: ["SD"]
}, {
  pk: 5984,
  ang: "Aikan\xE3",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Aikan\xE3",
  lc: "tba",
  ld: "ltr",
  alt: ["Corumbiara", "Huari", "Kasup\xE1", "Kolumbiara", "Mond\xE9", "Tubar\xE3o", "Uari", "Wari", "Masak\xE1 (Massaca)", "Tubanao"],
  cc: ["BR"]
}, {
  pk: 5985,
  ang: "Tapeba",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Tapeba",
  lc: "tbb",
  ld: "ltr",
  alt: ["Tabeba"],
  cc: ["BR"]
}, {
  pk: 5986,
  ang: "Takia",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Takia",
  lc: "tbc",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7657,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ruw",
  lc: "tbc-x-ruw",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5987,
  ang: "Kaki Ae",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kaki Ae",
  lc: "tbd",
  ld: "ltr",
  alt: ["Lorabada", "Lou", "Raepa Tati", "Tate", "Tati"],
  cc: ["PG"]
}, {
  pk: 5988,
  ang: "Tanibili",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Tanimbili",
  lc: "tbe",
  ld: "ltr",
  alt: ["Nyisunggu"],
  cc: ["SB"]
}, {
  pk: 5989,
  ang: "Mandara",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mandara",
  lc: "tbf",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 5990,
  ang: "Tairora, North",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "North Tairora",
  lc: "tbg",
  ld: "ltr",
  alt: ["Tairora", "Aantantara (Andandara)", "Saiqora (Sai'ora)", "Arau-Varosia (Arau-Barosia)", "Arokaara (Arokara)"],
  cc: ["PG"]
}, {
  pk: 8277,
  ang: "Abuhaina",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Abuhaina",
  lc: "tbg-x-abuhaina",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8278,
  ang: "Nanta",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Nanta",
  lc: "tbg-x-nanta",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5991,
  ang: "Gaam",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Gaam",
  lc: "tbi",
  ld: "ltr",
  alt: ["Gaahmg", "Ingassana", "Ingessana", "Kamanidi", "Mamedja", "Mamidza", "Metabi", "Muntabi", "Tabi", "Buwahg (Buek)", "Kukur (Gor)", "Kulang (Bau)", "Kulelek", "Soda (Tao)"],
  cc: ["ET", "SD"]
}, {
  pk: 5992,
  ang: "Tiang",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tiang",
  lc: "tbj",
  ld: "ltr",
  alt: ["Djaul"],
  cc: ["PG"]
}, {
  pk: 5993,
  ang: "Tagbanwa, Calamian",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Calamian Tagbanwa",
  lc: "tbk",
  ld: "ltr",
  alt: ["Unggoy", "Tinalaanen", "Binatuanen", "Binuswanganen", "Inawanwaanen", "Kinalamiananen (Kinaramiananen)", "Lininipaknen"],
  cc: ["PH"]
}, {
  pk: 5994,
  ang: "Tboli",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Tboli",
  lc: "tbl",
  ld: "ltr",
  alt: ["T'boli", "Tiboli", "Tagabili", "Western Tboli", "Southern Tboli", "Central Tboli"],
  cc: ["PH"]
}, {
  pk: 8266,
  ang: "Southern Tboli",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Southern Tboli",
  lc: "tbl-x-southtboli",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8265,
  ang: "Ubo",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Ubo",
  lc: "tbl-x-ubo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5995,
  ang: "Tagbu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Tagbu",
  lc: "tbm",
  ld: "ltr",
  alt: ["Tagba", "Tagbo"],
  cc: ["CD"]
}, {
  pk: 5996,
  ang: "Tunebo, Barro Negro",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Barro Negro Tunebo",
  lc: "tbn",
  ld: "ltr",
  alt: ["Eastern Tunebo"],
  cc: ["CO"]
}, {
  pk: 5997,
  ang: "Tawala",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tawala",
  lc: "tbo",
  ld: "ltr",
  alt: ["Tavara", "Tawara", "Awalama", "Awayama (Awaiama)", "Bohilai (Basilaki)", "Bohira'i", "Diwinai (Divinai)", "Gwavili", "Gwawili", "Kehelala (East Cape)", "Labe (Rabe)", "Sideya (Sideia)", "Wagawaga", "Yaleba (Ealeba)"],
  cc: ["PG"]
}, {
  pk: 5998,
  ang: "Diebroud",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Taworta",
  lc: "tbp",
  ld: "ltr",
  alt: ["Bok", "Dabra", "Taburta", "Taria", "Taworta-Aero"],
  cc: ["ID"]
}, {
  pk: 5999,
  ang: "Tumtum",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Tumtum",
  lc: "tbr",
  ld: "ltr",
  alt: ["Karondi (Korindi)", "Kurondi", "Talassa (Talasa)"],
  cc: ["SD"]
}, {
  pk: 6000,
  ang: "Tanguat",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tanguat",
  lc: "tbs",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6001,
  ang: "Tembo",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Tembo (Kitembo)",
  lc: "tbt",
  ld: "ltr",
  alt: ["Chitembo", "Nyabungu", "Tembo (Kitembo)"],
  cc: ["CD"]
}, {
  pk: 7894,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kirhinyihinyi",
  lc: "tbt-x-kirhinyihinyi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6002,
  ang: "Tobo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tobo",
  lc: "tbv",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6003,
  ang: "Tagbanwa",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Tagbanwa",
  lc: "tbw",
  ld: "ltr",
  alt: ["Aborlan Tagbanwa", "Apurawnon", "Tagbanua"],
  cc: ["PH"]
}, {
  pk: 6004,
  ang: "Kapin",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kapin",
  lc: "tbx",
  ld: "ltr",
  alt: ["Katumene", "Sambio", "Taiak", "Tayek", "Garawa (Gawawa)"],
  cc: ["PG"]
}, {
  pk: 6005,
  ang: "Tabaru",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tabaru",
  lc: "tby",
  ld: "ltr",
  alt: ["Tobaru"],
  cc: ["ID"]
}, {
  pk: 6006,
  ang: "Ditammari",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Ditammari",
  lc: "tbz",
  ld: "ltr",
  alt: ["Tamari", "Somba", "Soma", "Some", "Eastern Ditammari", "Western Ditammari (Tamberma)"],
  cc: ["BJ", "TG"]
}, {
  pk: 6007,
  ang: "Ticuna",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Ticuna",
  lc: "tca",
  ld: "ltr",
  alt: ["Mag\xFCta", "Tikuna", "Tukuna", "Tucuna", "Tuk\xFAna"],
  cc: ["BR", "PE", "CO"]
}, {
  pk: 6008,
  ang: "Tanacross",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Tanacross",
  lc: "tcb",
  ld: "ltr",
  alt: ["Healy Lake", "Mansfield-Ketchumstuck"],
  cc: ["US"]
}, {
  pk: 6009,
  ang: "Datooga",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Datooga",
  lc: "tcc",
  ld: "ltr",
  alt: ["Datog", "Datoga", "Tatog", "Tatoga", "Taturu", "Mangati", "Bianjiida (Biyanjiida)", "Tsimajeega (Isimijeega)", "Rotigenga", "Rootigaanga (Rotigeenga)", "Kisamajeng", "Gisamjanga (Gisamjang)", "Utatu", "Barbaig", "Barabayiiga (Barabaig)", "Barabayga", "Barabaik", "Bajuta (Bajuuta)", "Bureadiga", "Buraadiiga (Buradiga)"],
  cc: ["TZ"]
}, {
  pk: 6010,
  ang: "Tafi",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Tafi",
  lc: "tcd",
  ld: "ltr",
  alt: ["Tegbo"],
  cc: ["GH"]
}, {
  pk: 6011,
  ang: "Tutchone, Southern",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Southern Tutchone",
  lc: "tce",
  ld: "ltr",
  alt: [],
  cc: ["CA"]
}, {
  pk: 6012,
  ang: "Me\u2019phaa, Malinaltepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Malinaltepec Me'phaa",
  lc: "tcf",
  ld: "ltr",
  alt: ["Malinaltepec Tlapanec", "Me'phaa", "Tlapaneco", "Tlapaneco Central Bajo", "Tlapaneco de Malinaltepec", "Zilacayotitl\xE1n", "Zilacayotitl\xE1n Tlapanec", "Tlapaneco del este", "Tlapaneco de Huehuetepec", "Huehuetepec (M\xE8'ph\xE0\xE0 B\xE1th\xE1\xE1)", "Sm\xE1j\xED\xEDn", "Tlapaneco de Zilacayotitl\xE1n"],
  cc: ["MX"]
}, {
  pk: 6013,
  ang: "Tamagario",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tamagario",
  lc: "tcg",
  ld: "ltr",
  alt: ["Buru", "Tamaraw", "Wagow", "Wiyagar"],
  cc: ["ID"]
}, {
  pk: 6014,
  ang: "Turks and Caicos Creole English",
  lr: "Americas",
  gw: false,
  hc: "TC",
  ln: "Turks And Caicos Creole English",
  lc: "tch",
  ld: "ltr",
  alt: [],
  cc: ["TC"]
}, {
  pk: 6015,
  ang: "W\xE1ra",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "W\xE1ra",
  lc: "tci",
  ld: "ltr",
  alt: ["Ara", "Kamindjo", "Rouku", "Tjokwai", "Tokwasa", "Upper Morehead", "Vara", "W\xE4r\xE4", "Yumbar", "W\xE8r\xE9", "K\xF3mnjo", "W\xE1ra", "Anta"],
  cc: ["PG"]
}, {
  pk: 6016,
  ang: "Tchitchege",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Tchitchege",
  lc: "tck",
  ld: "ltr",
  alt: [],
  cc: ["GA"]
}, {
  pk: 6017,
  ang: "Taman",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Taman (Myanmar)",
  lc: "tcl",
  ld: "ltr",
  alt: [],
  cc: ["MM"]
}, {
  pk: 6018,
  ang: "Tanahmerah",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tanahmerah",
  lc: "tcm",
  ld: "ltr",
  alt: ["Sumeri", "Sumerine"],
  cc: ["ID"]
}, {
  pk: 6019,
  ang: "Tichurong",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Tichurong",
  lc: "tcn",
  ld: "ltr",
  alt: ["Ticherong"],
  cc: ["NP"]
}, {
  pk: 6020,
  ang: "Taungyo",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Taungyo",
  lc: "tco",
  ld: "ltr",
  alt: ["Taru", "Taung-yo", "Toru", "Twing Reu", "Twinreu"],
  cc: ["MM"]
}, {
  pk: 6021,
  ang: "Chin, Tawr",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Tawr Chin",
  lc: "tcp",
  ld: "ltr",
  alt: ["Tawr", "Torr"],
  cc: ["MM"]
}, {
  pk: 6022,
  ang: "Kaiy",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kaiy",
  lc: "tcq",
  ld: "ltr",
  alt: ["Kai", "Taori-Kaiy", "Taori-Kei", "Todi"],
  cc: ["ID"]
}, {
  pk: 6023,
  ang: "Torres Strait Creole",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Torres Strait Creole",
  lc: "tcs",
  ld: "ltr",
  alt: ["Blaik", "Creole", "Torres Strait Broken", "West Torres", "Yumplatok"],
  cc: ["AU"]
}, {
  pk: 6024,
  ang: "T\u2019en",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4F6F\u50D9\u8BED",
  lc: "tct",
  ld: "ltr",
  alt: ["Rao", "Rau", "Then", "Yang Hwang", "Yanghuang", "Huishui", "Hedong", "Hexi"],
  cc: ["CN", "LA"]
}, {
  pk: 6025,
  ang: "Tarahumara, Southeastern",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Southeastern Tarahumara",
  lc: "tcu",
  ld: "ltr",
  alt: ["Balleza", "Chinat\xFA", "Tarahumara de Chinat\xFA", "Tarahumara del Sur", "Tarahumara del Sureste", "Turuachi"],
  cc: ["MX"]
}, {
  pk: 6026,
  ang: "Totonac, Tecpatl\xE1n",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tecpatl\xE1n Totonac",
  lc: "tcw",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 6027,
  ang: "Toda",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Toda",
  lc: "tcx",
  ld: "ltr",
  alt: ["Todi", "Tuda"],
  cc: ["IN"]
}, {
  pk: 6028,
  ang: "Tulu",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Tulu",
  lc: "tcy",
  ld: "ltr",
  alt: ["Tal", "Tallu", "Thalu", "Thulu", "Tilu", "Tullu", "Tuluva Bhasa", "Puttur", "Southwest Tulu (Kasaragod)", "Udipi", "Southeast Tulu (Sullia Subrahmanya)", "South Central Tulu (Bantwal)", "Northeast Tulu (Belthangadi)", "Manjeswara", "Kerala", "Brahmin Tulu", "Common Tulu", "Northwest Tulu (Mangalore)"],
  cc: ["IN"]
}, {
  pk: 7620,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Koracha",
  lc: "tcy-x-koracha",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7605,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mavilan Tulu",
  lc: "tcy-x-mavilan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6029,
  ang: "Chin, Thado",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Thado Chin",
  lc: "tcz",
  ld: "ltr",
  alt: ["Kuki", "Kuki-Thado", "Thaadou Kuki", "Thado-Pao", "Thadou", "Thado-Ubiphei", "Singson (Shingsol)", "Paite"],
  cc: ["IN", "MM"]
}, {
  pk: 6030,
  ang: "Tagdal",
  lr: "Africa",
  gw: false,
  hc: "NE",
  ln: "Tagdal",
  lc: "tda",
  ld: "ltr",
  alt: ["Air (Northern Tagdal)", "Azawagh (Southern Tagdal)"],
  cc: ["NE"]
}, {
  pk: 6031,
  ang: "Panchpargania",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Panchpargania",
  lc: "tdb",
  ld: "ltr",
  alt: ["Bedia", "Chik Barik", "Pan", "Pan Sawasi", "Tair", "Tamara", "Tamaria", "Tanti", "Temoral", "Tumariya"],
  cc: ["IN"]
}, {
  pk: 6032,
  ang: "Ember\xE1-Tad\xF3",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Ember\xE1-Tad\xF3",
  lc: "tdc",
  ld: "ltr",
  alt: ["Cholo", "\xCAp\xEAra"],
  cc: ["CO"]
}, {
  pk: 6033,
  ang: "Tai N\xFCa",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u50A3\u90A3\u8BED",
  lc: "tdd",
  ld: "ltr",
  alt: ["Chinese Shan", "Chinese Tai", "Dai Kong", "Dai Na", "Dai Nuea", "Daide", "Dehong Dai", "Tai Dehong", "Tai Le", "Tai Mao", "Tai Neua", "Tai n\xF6", "Tai N\xFC", "Tai Nue", "Tai ta\xFC", "Tai-Kong", "Tai-Le", "Yunannese Shan", "Yunnan Shant'ou", "Tai Nuea", "Tai Kong", "Tai Man", "Tai Pong (Ka)", "You", "Taile", "Tai Ka", "Sai", "Menggeng (Taita)", "Mangshi (Debao)", "Mang Shi", "La", "Ruili (Meng Mao)", "Ya"],
  cc: ["CN", "LA", "MM"]
}, {
  pk: 6034,
  ang: "Dogon, Tiranige Diga",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Tiranige Diga Dogon",
  lc: "tde",
  ld: "ltr",
  alt: ["Duleri", "Duleri Dom"],
  cc: ["ML"]
}, {
  pk: 6035,
  ang: "Talieng",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Talieng",
  lc: "tdf",
  ld: "ltr",
  alt: ["Taliang", "Tariang", "Triang"],
  cc: ["LA"]
}, {
  pk: 6036,
  ang: "Tamang, Western",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Western Tamang",
  lc: "tdg",
  ld: "ltr",
  alt: ["Murmi", "Sain", "Northwestern dialect of Western Tamang (Dhading)", "Rasuwa", "Southwestern dialect of Western Tamang", "Trisuli (Nuwakot)"],
  cc: ["NP"]
}, {
  pk: 6037,
  ang: "Thulung",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Thulung",
  lc: "tdh",
  ld: "ltr",
  alt: ["Thulunge Rai", "Tholong Lo", "Thulu Luwa", "Thululoa", "Thulung Jemu", "Thulung La", "Toaku Lwa", "Central Thulung (Mukli Lwa)", "Southern Thulung (Necha Lwa)", "Northern Thulung (Deusa Lwa)", "Eastern Thulung (Jubu Lwa)", "Lokhim Lwa"],
  cc: ["NP"]
}, {
  pk: 6038,
  ang: "Tomadino",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tomadino",
  lc: "tdi",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 6039,
  ang: "Tajio",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tajio",
  lc: "tdj",
  ld: "ltr",
  alt: ["Adjio", "Kasimbar", "Ta'adjio", "Tadjio", "Central Tajio", "Northern Tajio", "Western Tajio"],
  cc: ["ID"]
}, {
  pk: 6040,
  ang: "Tambas",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Tambas",
  lc: "tdk",
  ld: "ltr",
  alt: ["Tambes"],
  cc: ["NG"]
}, {
  pk: 6041,
  ang: "Sur",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Sur",
  lc: "tdl",
  ld: "ltr",
  alt: ["Dishili", "Nsur", "Suru", "Tapshin", "Tapshinawa"],
  cc: ["NG"]
}, {
  pk: 6042,
  ang: "Tondano",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tondano",
  lc: "tdn",
  ld: "ltr",
  alt: ["Tolou", "Tolour", "Tondanou", "Kakas (Ka'kas)"],
  cc: ["ID"]
}, {
  pk: 7633,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kakas",
  lc: "tdn-x-kakas",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7690,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Remboken",
  lc: "tdn-x-remboken",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6043,
  ang: "Teme",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Teme",
  lc: "tdo",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 6044,
  ang: "Tita",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Tita",
  lc: "tdq",
  ld: "ltr",
  alt: ["Hoai Petel"],
  cc: ["NG"]
}, {
  pk: 6045,
  ang: "Todrah",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "T\u01A1-\u0111r\xE1",
  lc: "tdr",
  ld: "ltr",
  alt: ["Didra", "Didrah", "Kodra", "Modra", "Podra", "Todr\xE1"],
  cc: ["VN"]
}, {
  pk: 6046,
  ang: "Doutai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Doutai",
  lc: "tds",
  ld: "ltr",
  alt: ["Taori", "Taori-So", "Tolitai"],
  cc: ["ID"]
}, {
  pk: 6047,
  ang: "Tetun Dili",
  lr: "Asia",
  gw: false,
  hc: "TL",
  ln: "Tetun Dili",
  lc: "tdt",
  ld: "ltr",
  alt: ["Dili Tetum", "Tetum", "Tetum Dili", "Tetum Pra\xE7a", "Tetun"],
  cc: ["ID", "TL"]
}, {
  pk: 6048,
  ang: "Dusun, Tempasuk",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Tempasuk Dusun",
  lc: "tdu",
  ld: "ltr",
  alt: ["Kedamaian Dusun", "Tampasok", "Tampassuk", "Tampasuk", "Tempasok", "Tindal"],
  cc: ["MY"]
}, {
  pk: 6049,
  ang: "Toro",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Toro",
  lc: "tdv",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 6050,
  ang: "Malagasy, Tandroy-Mahafaly",
  lr: "Africa",
  gw: false,
  hc: "MG",
  ln: "Tandroy-Mahafaly Malagasy",
  lc: "tdx",
  ld: "ltr",
  alt: ["Tandroy"],
  cc: ["MG"]
}, {
  pk: 6051,
  ang: "Tadyawan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Tadyawan",
  lc: "tdy",
  ld: "ltr",
  alt: ["Balaban", "Pula", "Tadianan"],
  cc: ["PH"]
}, {
  pk: 6052,
  ang: "Telugu",
  lr: "Asia",
  gw: true,
  hc: "IN",
  ln: "\u0C24\u0C46\u0C32\u0C41\u0C17\u0C41",
  lc: "te",
  ld: "ltr",
  alt: ["Andhra", "Gentoo", "Tailangi", "Telangire", "Telegu", "Telgi", "Tengu", "Terangi", "Tolangan", "Vishakhapatnam", "Yanadi (Yenadi)"],
  cc: ["BD", "LK", "MY", "US", "CA", "KW", "IN", "SG", "MM", "BH", "AE"]
}, {
  pk: 6053,
  ang: "Temiar",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Temiar",
  lc: "tea",
  ld: "ltr",
  alt: ["Northern Sakai", "Pie", "Seroq", "Temer", "Ulu Kinta (Kinta Sakai)", "Tembe' (Tembi)", "Po-Klo (Sakai Bukit of Temongoh)"],
  cc: ["MY"]
}, {
  pk: 6054,
  ang: "Terik",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Terik",
  lc: "tec",
  ld: "ltr",
  alt: ["Nyang'ori"],
  cc: ["KE"]
}, {
  pk: 6055,
  ang: "Krumen, Tepo",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Tepo Krumen",
  lc: "ted",
  ld: "ltr",
  alt: ["Kroumen", "Kru", "Krumen", "Southern Krumen", "Southwestern Kroumen", "Yrepo (Kapo)", "Wlopo (Ropo)"],
  cc: ["CI", "LR"]
}, {
  pk: 6056,
  ang: "Tepehua, Huehuetla",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Huehuetla Tepehua",
  lc: "tee",
  ld: "ltr",
  alt: ["Tepehua de Hidalgo", "Tepehua de Huehuetla"],
  cc: ["MX"]
}, {
  pk: 6057,
  ang: "Teressa",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Teressa",
  lc: "tef",
  ld: "ltr",
  alt: ["Taih-Long", "Bompoka (Bompaka)", "Pauhut"],
  cc: ["IN"]
}, {
  pk: 6058,
  ang: "Teke-Tege",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Teke-Tege",
  lc: "teg",
  ld: "ltr",
  alt: ["Iteghe", "Northern Teke", "Teghe", "Teke Alima", "Teke Kali", "Katege", "Ketego", "Latege", "Teke", "Kateghe (Nzikini)"],
  cc: ["GA", "CG"]
}, {
  pk: 6059,
  ang: "Tehuelche",
  lr: "Americas",
  gw: false,
  hc: "AR",
  ln: "Tehuelche",
  lc: "teh",
  ld: "ltr",
  alt: ["Aoniken", "Gunua-Kena", "G\xFCn\xFCna K\xFCne", "G\xFCn\xFCna Yajich", "Gununa-Kena", "Inaquen"],
  cc: ["AR"]
}, {
  pk: 6060,
  ang: "Torricelli",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Torricelli",
  lc: "tei",
  ld: "ltr",
  alt: ["Lou"],
  cc: ["PG"]
}, {
  pk: 6061,
  ang: "Teke, Ibali",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Ibali Teke",
  lc: "tek",
  ld: "ltr",
  alt: ["Eastern Teke", "Ibali", "Teke-Ibali", "Bali (Ambali)", "Ngee (Esingee)", "Teo", "Tio", "Tyo"],
  cc: ["CG", "CD"]
}, {
  pk: 7854,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Teke Mbankana",
  lc: "tek-x-mbankana",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8038,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Ade Basha Arya",
  lc: "tel-x-adebashaarya",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8397,
  ang: "Alba",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Alba",
  lc: "tel-x-alba",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8398,
  ang: "Allami",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Allami",
  lc: "tel-x-allami",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8400,
  ang: "Ardhan",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Ardhan",
  lc: "tel-x-ardhan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8401,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Ardhi",
  lc: "tel-x-ardhi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8402,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Arttap",
  lc: "tel-x-arttap",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8039,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bagata",
  lc: "tel-x-bagata",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8260,
  ang: "Barda",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Barda",
  lc: "tel-x-barda",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7578,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bestalu/Bastalu",
  lc: "tel-x-bestalu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8333,
  ang: "Bheel",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bheel",
  lc: "tel-x-bheel",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8404,
  ang: "Bommala",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bommala",
  lc: "tel-x-bommala",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8335,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Chamari (Telugu)",
  lc: "tel-x-chamari",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8065,
  ang: "Dasari",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Dasari",
  lc: "tel-x-dasari",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8406,
  ang: "Dhaba",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Dhaba",
  lc: "tel-x-dhaba",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8332,
  ang: "Dudekula",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Dudekula",
  lc: "tel-x-dudekula",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8125,
  ang: "Gamperukula",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Gamperukula",
  lc: "tel-x-gamperukula",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8126,
  ang: "Ghani Bhasha",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Ghani Bhasha",
  lc: "tel-x-ganibasha",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8127,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Gusavu",
  lc: "tel-x-gusavu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8409,
  ang: "Kovi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kovi",
  lc: "tel-x-kovi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8407,
  ang: "Onda",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Onda",
  lc: "tel-x-onda",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8410,
  ang: "Orku",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Orku",
  lc: "tel-x-orku",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8411,
  ang: "Osti",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Osti",
  lc: "tel-x-osti",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8413,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Otiya",
  lc: "tel-x-otiya",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8375,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Pardhi (Telugu script)",
  lc: "tel-x-pardhi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8412,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Phichiguntala",
  lc: "tel-x-pichigunta",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8414,
  ang: "Piya",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Piya",
  lc: "tel-x-piya",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8415,
  ang: "Pusala",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Pusala",
  lc: "tel-x-pusala",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7772,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Sikaari",
  lc: "tel-x-sikaari",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7987,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "LK",
  ln: "Telingu",
  lc: "tel-x-telingu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8417,
  ang: "Thakan",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Thakan",
  lc: "tel-x-thakan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8130,
  ang: "Thalaboomi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Thalaboomi",
  lc: "tel-x-thalaboomi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8263,
  ang: "Vadi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Vadi",
  lc: "tel-x-vadi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7590,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Yauedhi",
  lc: "tel-x-yauedhi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6062,
  ang: "Themne",
  lr: "Africa",
  gw: false,
  hc: "SL",
  ln: "Timne",
  lc: "tem",
  ld: "ltr",
  alt: ["Temen", "Timene", "Timmannee", "Timne", "Western Temne (Pil)"],
  cc: ["GN", "SL"]
}, {
  pk: 6063,
  ang: "Teso",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Teso",
  lc: "teo",
  ld: "ltr",
  alt: ["Bakedi", "Bakidi", "Elgumi", "Etossio", "Ikumama", "Wamia", "Orom (Rom)"],
  cc: ["KE", "UG"]
}, {
  pk: 6064,
  ang: "Temein",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Temein",
  lc: "teq",
  ld: "ltr",
  alt: ["Rone", "Ronge", "Temainian"],
  cc: ["SD"]
}, {
  pk: 6065,
  ang: "Ter\xEAna",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Tereno",
  lc: "ter",
  ld: "ltr",
  alt: ["Etelena", "Tereno"],
  cc: ["BR"]
}, {
  pk: 6066,
  ang: "Tengger",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tengger",
  lc: "tes",
  ld: "ltr",
  alt: ["Tenggerese"],
  cc: ["ID"]
}, {
  pk: 6067,
  ang: "Tetun",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tetum",
  lc: "tet",
  ld: "ltr",
  alt: ["Belo", "Belu", "Fehan", "Teto", "Tettum", "Tetu", "Tetum", "Tetun Belu", "Tetung", "Tetun Loos", "Soibada", "Tetun Therik", "Tetun Los", "Southern Tetun (Belu Selatan)", "Tasi Feto", "South Tetun", "South Belu", "South", "Lia Fehan", "Eastern Tetun (Lakluta)", "Plains Tetun", "Hill Tetun", "Lia Foho", "Tasi Ma", "Natarbora", "North Belu", "Northern Tetun (Belu Utara)", "Plain Tetun", "Foho"],
  cc: ["ID"]
}, {
  pk: 6068,
  ang: "Soo",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Soo",
  lc: "teu",
  ld: "ltr",
  alt: ["So", "Tepes", "Tepeth", "Kadam", "Moroto", "Napak (Mount Napak)"],
  cc: ["UG"]
}, {
  pk: 6069,
  ang: "Teor",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Teor",
  lc: "tev",
  ld: "ltr",
  alt: ["Tio'or"],
  cc: ["ID"]
}, {
  pk: 6070,
  ang: "Tewa",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Tewa (USA)",
  lc: "tew",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 6071,
  ang: "Tennet",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Tennet",
  lc: "tex",
  ld: "ltr",
  alt: ["Tenet"],
  cc: ["SS"]
}, {
  pk: 7693,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Bairag",
  lc: "te-x-bairag",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7712,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Telugu Buduga Jangam",
  lc: "te-x-budugaja",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7681,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Dhongri",
  lc: "te-x-dhongri",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7609,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Dokka",
  lc: "te-x-dokkalig",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8205,
  ang: "Dommara",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Dommara",
  lc: "te-x-dommara",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8070,
  ang: "Gangireddula",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Gangireddula",
  lc: "te-x-gangireddula",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7680,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Telugu Jangalu",
  lc: "te-x-jangalu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8048,
  ang: "Kabasha",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kabasha",
  lc: "te-x-kabasha",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8050,
  ang: "Kapalollu",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kapalollu",
  lc: "te-x-kappalollu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8051,
  ang: "Katipapalu",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Katipapalu",
  lc: "te-x-katipapalu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8052,
  ang: "Muthrasi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Muthrasi",
  lc: "te-x-muthrasi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7618,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Nakkalollu",
  lc: "te-x-nakkalol",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7716,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Nethakani",
  lc: "te-x-netaka",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7576,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Paidi",
  lc: "te-x-paidi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7619,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Pamulollu",
  lc: "te-x-pamuloll",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8053,
  ang: "Yeloru",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Yeloru",
  lc: "te-x-yeloru",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6072,
  ang: "Tulishi",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Tulishi",
  lc: "tey",
  ld: "ltr",
  alt: ["Kuntulishi", "Thulishi", "Tulesh", "Truj", "Turuj", "Kamda (Kamdang)", "Dar El Kabira (Logoke)", "Minjimmina"],
  cc: ["SD"]
}, {
  pk: 6073,
  ang: "Gbe, Tofin",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Tofin Gbe",
  lc: "tfi",
  ld: "ltr",
  alt: ["Tofi", "Tofin", "Tofingbe"],
  cc: ["BJ"]
}, {
  pk: 6074,
  ang: "Tanaina",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Tanaina",
  lc: "tfn",
  ld: "ltr",
  alt: ["Dena'ina", "Kinayskiy"],
  cc: ["US"]
}, {
  pk: 6075,
  ang: "Tefaro",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tefaro",
  lc: "tfo",
  ld: "ltr",
  alt: ["Demba"],
  cc: ["ID"]
}, {
  pk: 6076,
  ang: "Teribe",
  lr: "Americas",
  gw: false,
  hc: "PA",
  ln: "Teribe",
  lc: "tfr",
  ld: "ltr",
  alt: ["Terraba", "Naso", "Nortenyo", "Quequexque", "Tiribi", "Tirribi"],
  cc: ["PA"]
}, {
  pk: 6077,
  ang: "Ternate",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ternate",
  lc: "tft",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 6078,
  ang: "Tajik",
  lr: "Asia",
  gw: false,
  hc: "TJ",
  ln: "\u0442\u043E\u04B7\u0438\u043A\u04E3, to\xE7ik\u012B, \u062A\u0627\u062C\u06CC\u06A9\u06CC\u200E",
  lc: "tg",
  ld: "ltr",
  alt: ["Galcha", "Tadzhik", "Tajik", "Tajiki Persian", "Tojiki"],
  cc: ["AZ", "IR", "KZ", "TJ", "PK", "US", "CA", "KG", "TM", "UZ"]
}, {
  pk: 6079,
  ang: "Sagalla",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Sagalla",
  lc: "tga",
  ld: "ltr",
  alt: ["Kisagala", "Kisagalla", "Sagala", "Saghala"],
  cc: ["KE"]
}, {
  pk: 6080,
  ang: "Tobilung",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Tobilung",
  lc: "tgb",
  ld: "ltr",
  alt: ["Tabilong", "Tobilang"],
  cc: ["MY"]
}, {
  pk: 6081,
  ang: "Tigak",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tigak",
  lc: "tgc",
  ld: "ltr",
  alt: ["Omo"],
  cc: ["PG"]
}, {
  pk: 6082,
  ang: "Ciwogai",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ciwogai",
  lc: "tgd",
  ld: "ltr",
  alt: ["Sago"],
  cc: ["NG"]
}, {
  pk: 6083,
  ang: "Tamang, Eastern Gorkha",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Eastern Gorkha Tamang",
  lc: "tge",
  ld: "ltr",
  alt: [],
  cc: ["NP"]
}, {
  pk: 6084,
  ang: "Chalikha",
  lr: "Asia",
  gw: false,
  hc: "BT",
  ln: "Chalikha",
  lc: "tgf",
  ld: "ltr",
  alt: ["Chali", "Chalipkha", "Tshali", "Tshalingpa"],
  cc: ["BT"]
}, {
  pk: 6085,
  ang: "Tobagonian Creole English",
  lr: "Americas",
  gw: false,
  hc: "TT",
  ln: "Tobagonian Creole English",
  lc: "tgh",
  ld: "ltr",
  alt: ["Tobagonian Dialect"],
  cc: ["TT"]
}, {
  pk: 6086,
  ang: "Lawunuia",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Lawunuia",
  lc: "tgi",
  ld: "ltr",
  alt: ["Nagarege", "Nagarige", "Naghareghe"],
  cc: ["PG"]
}, {
  pk: 6087,
  ang: "Tagin",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Tagin",
  lc: "tgj",
  ld: "ltr",
  alt: ["Nil"],
  cc: ["IN"]
}, {
  pk: 8270,
  ang: "Lyuli",
  lr: "Asia",
  gw: false,
  hc: "UZ",
  ln: "Lyuli",
  lc: "tgk-UZ-lyuli",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6088,
  ang: "Tandaganon",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Tandaganon",
  lc: "tgn",
  ld: "ltr",
  alt: ["Naturalis", "Tagon-on"],
  cc: ["PH"]
}, {
  pk: 8492,
  ang: "Kadi",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Kadi",
  lc: "tgn-x-kadi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6089,
  ang: "Sudest",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sudest",
  lc: "tgo",
  ld: "ltr",
  alt: ["Sud-Est", "Tagula", "Vanatina", "Vanga", "Central Sudest (Araetha)", "Eastern Sudest (Rambuso)", "Rambuso (Rewa)", "Rehuwo", "Western Sudest (Dtelha)"],
  cc: ["PG"]
}, {
  pk: 6090,
  ang: "Tangoa",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Tangoa",
  lc: "tgp",
  ld: "ltr",
  alt: ["Santo", "South Santo"],
  cc: ["VU"]
}, {
  pk: 6091,
  ang: "Tring",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Tring",
  lc: "tgq",
  ld: "ltr",
  alt: [],
  cc: ["MY"]
}, {
  pk: 6092,
  ang: "Tareng",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Tareng",
  lc: "tgr",
  ld: "ltr",
  alt: ["Tariang"],
  cc: ["LA"]
}, {
  pk: 6093,
  ang: "Nume",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Nume",
  lc: "tgs",
  ld: "ltr",
  alt: ["Gog", "North-East Gaua", "Tarasag"],
  cc: ["VU"]
}, {
  pk: 6094,
  ang: "Tagbanwa, Central",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Central Tagbanwa",
  lc: "tgt",
  ld: "ltr",
  alt: [],
  cc: ["PH"]
}, {
  pk: 6095,
  ang: "Tanggu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tanggu",
  lc: "tgu",
  ld: "ltr",
  alt: ["Tanggum", "Tangu"],
  cc: ["PG"]
}, {
  pk: 6096,
  ang: "Tingui-Boto",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Tingui-Boto",
  lc: "tgv",
  ld: "ltr",
  alt: ["Carapat\xF3", "Dzboku'a", "Dzubuku\xE1", "Karapat\xF3", "Tingui"],
  cc: ["BR"]
}, {
  pk: 6097,
  ang: "S\xE9noufo, Tagwana",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Tagwana Senoufo",
  lc: "tgw",
  ld: "ltr",
  alt: ["Tagbana", "Tagouna", "Tagwana", "Gbo (Zoro)"],
  cc: ["CI"]
}, {
  pk: 6098,
  ang: "Tagish",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Tagish",
  lc: "tgx",
  ld: "ltr",
  alt: [],
  cc: ["CA"]
}, {
  pk: 6099,
  ang: "Tagalaka",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Tagalaka",
  lc: "tgz",
  ld: "ltr",
  alt: ["Da:galag", "Dagalang", "Takalak", "Targa-lag", "Tarkalag"],
  cc: ["AU"]
}, {
  pk: 6100,
  ang: "Thai",
  lr: "Asia",
  gw: true,
  hc: "TH",
  ln: "\u0E44\u0E17\u0E22",
  lc: "th",
  ld: "ltr",
  alt: ["Central Tai", "Siamese", "Standard Thai", "Thaiklang", "Thaikorat", "Thai Norkor Raja (Siam Nokor)", "Thai Koh Kong", "Khorat Thai (Korat)", "Siam Trang"],
  cc: ["FR", "DE", "MY", "TH", "US", "AU", "KH", "CA", "SG", "MM"]
}, {
  pk: 6101,
  ang: "Tai Hang Tong",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Tai Hang Tong",
  lc: "thc",
  ld: "ltr",
  alt: ["H\xE0ng Tong", "T\xE0y Mu\xF2ng"],
  cc: ["VN"]
}, {
  pk: 6102,
  ang: "Thayore",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Thayore",
  lc: "thd",
  ld: "ltr",
  alt: ["Behran", "Gugudayor", "Kuktayor", "Kukudayore", "Kuuk Thaayoore", "Kuuk Thaayorre", "Taior", "Thayorre", "Kuuk-Yak"],
  cc: ["AU"]
}, {
  pk: 6103,
  ang: "Madhya Ksetriya Tharu",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u092E\u0927\u094D\u092F \u0915\u094D\u0937\u0947\u0924\u094D\u0930\u0940\u092F \u0925\u093E\u0930\u0942",
  lc: "the",
  ld: "ltr",
  alt: ["Chitoniya Tharu", "Chitwan Tharu", "Chitwaniya", "Nawalpuriya Tharu (Laulpuriya Tharu)"],
  cc: ["NP"]
}, {
  pk: 6104,
  ang: "Thangmi",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Thangmi",
  lc: "thf",
  ld: "ltr",
  alt: ["Dolakha", "Thangmi Kham", "Thangmi Wakhe", "Thani", "Eastern Thangmi (Dolakha)", "Western Thangmi (Sindhupalchok)"],
  cc: ["CN", "NP"]
}, {
  pk: 6105,
  ang: "Tarahumara, Northern",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Northern Tarahumara",
  lc: "thh",
  ld: "ltr",
  alt: ["Arisiachi Tarahumara", "Tarahumara del Norte"],
  cc: ["MX"]
}, {
  pk: 6106,
  ang: "Tai Long",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Tai Long",
  lc: "thi",
  ld: "ltr",
  alt: [],
  cc: ["LA", "MM"]
}, {
  pk: 6107,
  ang: "Kitharaka",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Tharaka",
  lc: "thk",
  ld: "ltr",
  alt: ["Saraka", "Sharoka", "Ntugi (Central Tharaka)", "Thagicu", "Gatue (North Tharaka)", "Igoki"],
  cc: ["KE"]
}, {
  pk: 6108,
  ang: "Tharu, Dangaura",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Dangaura Tharu",
  lc: "thl",
  ld: "ltr",
  alt: ["Chaudary", "Chaudhari", "Chaudhuri", "Dang", "Dangora", "Dangura", "Dangaha", "Dangauli", "Dangaha (Dang)"],
  cc: ["NP"]
}, {
  pk: 6109,
  ang: "Aheu",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "\u0E20\u0E32\u0E29\u0E32\u0E02\u0E48\u0E32\u0E15\u0E2D\u0E07\u0E40\u0E2B\u0E25\u0E37\u0E2D\u0E07",
  lc: "thm",
  ld: "ltr",
  alt: ["Kha Tong Luang", "Phon Soung", "Phonsung", "So", "Thavung", "Sotawueng"],
  cc: ["TH"]
}, {
  pk: 6110,
  ang: "Thachanadan",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Thachanadan",
  lc: "thn",
  ld: "ltr",
  alt: ["Moopan", "Thacchanadens", "Thachanad Muppans"],
  cc: ["IN"]
}, {
  pk: 6111,
  ang: "Thompson",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Thompson",
  lc: "thp",
  ld: "ltr",
  alt: ["Nklapmx", "Ntlakapamux", "Ntlakapmuk"],
  cc: ["CA"]
}, {
  pk: 6112,
  ang: "Tharu, Kochila",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u092E\u0927\u094D\u092F-\u092A\u0942\u0930\u094D\u0935\u093F\u092F\u093E \u0925\u093E\u0930\u0942",
  lc: "thq",
  ld: "ltr",
  alt: ["Saptariya Tharu", "Sunsari", "Udayapur", "Siraha", "Sarlahi", "Morangiya", "Mahottari", "Dhanusa"],
  cc: ["NP"]
}, {
  pk: 6113,
  ang: "Tharu, Rana",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Rana Tharu",
  lc: "thr",
  ld: "ltr",
  alt: ["Rana Thakur"],
  cc: ["NP"]
}, {
  pk: 6114,
  ang: "Thakali",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Thakali",
  lc: "ths",
  ld: "ltr",
  alt: ["Barhagaule", "Panchgaunle", "Thaksya", "Syang (Yhulkasom)", "Thaksaatsaye", "Thaksatsae", "Tukuche (Tamhang Thakali)", "Marpha (Puntan Thakali)"],
  cc: ["NP"]
}, {
  pk: 6115,
  ang: "Tahltan",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Tahltan",
  lc: "tht",
  ld: "ltr",
  alt: [],
  cc: ["CA"]
}, {
  pk: 6116,
  ang: "Thuri",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Thuri",
  lc: "thu",
  ld: "ltr",
  alt: ["Dhe Thuri", "Jo Thuri", "Shatt", "Wada Thuri", "Colo (Dhe Colo)", "Manangeer (Jur Manangeer)", "Jur Shol", "Jo Colo", "Dombo", "Demen", "Bodho (Dembo)", "Dhe Boodho"],
  cc: ["SS"]
}, {
  pk: 6117,
  ang: "Tamahaq, Tahaggart",
  lr: "Africa",
  gw: false,
  hc: "DZ",
  ln: "\u062A\u0645\u0627\u0647\u0642",
  lc: "thv",
  ld: "ltr",
  alt: ["Tamachek", "Tamashekin", "Tomachek", "Touareg", "Tourage", "Tuareg", "Toureg", "Tamasheq", "Ajjer", "Ganet", "Ghat (Djanet)", "Hoggar (Ahaggaren)", "Tahaggart"],
  cc: ["DZ", "NE", "LY"]
}, {
  pk: 6118,
  ang: "Thudam",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Thudam",
  lc: "thw",
  ld: "ltr",
  alt: [],
  cc: ["NP"]
}, {
  pk: 6119,
  ang: "Tha",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Tha",
  lc: "thy",
  ld: "ltr",
  alt: ["Joole Manga", "Kapawa"],
  cc: ["NG"]
}, {
  pk: 6120,
  ang: "Tamajeq, Tayart",
  lr: "Africa",
  gw: false,
  hc: "NE",
  ln: "Tayart Tamajeq",
  lc: "thz",
  ld: "ltr",
  alt: ["Amazigh", "Tamachek", "Tomacheck", "Touareg", "Tuareg", "Tayert", "Air (Agadez)", "Tamestayert", "Tanassfarwat (Tamagarast)", "Tayart"],
  cc: ["NE"]
}, {
  pk: 6121,
  ang: "Tigrinya",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "\u1275\u130D\u122D\u129B",
  lc: "ti",
  ld: "ltr",
  alt: ["Habashi", "Tigray", "Falashas"],
  cc: ["DJ", "ER", "ET", "SD", "CA"]
}, {
  pk: 6122,
  ang: "Tamazight, Tidikelt",
  lr: "Africa",
  gw: false,
  hc: "DZ",
  ln: "Tidikelt Tamazight",
  lc: "tia",
  ld: "ltr",
  alt: [],
  cc: ["DZ"]
}, {
  pk: 6123,
  ang: "Tira",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Tira",
  lc: "tic",
  ld: "ltr",
  alt: ["Lithiro", "Thiro", "Tiro", "Tira Lumum (Luman)", "Tira El Akhdar (Tira Dagig)", "Kinderma (Kanderma)"],
  cc: ["SD"]
}, {
  pk: 6124,
  ang: "Tidong",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tidong",
  lc: "tid",
  ld: "ltr",
  alt: ["Camucones", "Tedong", "Tidoeng", "Tiran", "Tirones", "Tiroon", "Zedong", "Nonukan (Nunukan)", "Salalir", "Saralir", "Sedalir (Sadalir)", "Selalir", "Sesayap (Sesajap)", "Tarakan (Terakan)"],
  cc: ["ID", "MY"]
}, {
  pk: 8055,
  ang: "Menabur Semido",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Menabur Semido",
  lc: "tid-x-menabursemido",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8057,
  ang: "Punan Mabung",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Punan Mabung",
  lc: "tid-x-punanmabung",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8054,
  ang: "Punan Semolon",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Punan Semolon",
  lc: "tid-x-punansemolon",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8058,
  ang: "Punan Tarau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Punan Tarau",
  lc: "tid-x-punantarau",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8056,
  ang: "Punan Tebunyau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Punan Tebunyau",
  lc: "tid-x-punantebunyau",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6125,
  ang: "Tifal",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tifal",
  lc: "tif",
  ld: "ltr",
  alt: ["Tifalmin", "Asbalmin"],
  cc: ["PG"]
}, {
  pk: 6126,
  ang: "Tigr\xE9",
  lr: "Africa",
  gw: false,
  hc: "ER",
  ln: "Tigre",
  lc: "tig",
  ld: "ltr",
  alt: ["Khasa", "Xasa", "Habab", "Senhit (Ad-Tekleis)", "Semhar", "Mensa", "Mansa' (Mensa)", "Bet-Juk", "Beni-Amir", "Algeden", "Ad-Temariam", "Marya Kayah", "Dahalik"],
  cc: ["ER", "GB", "US"]
}, {
  pk: 6127,
  ang: "Timugon Murut",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Timugon Murut",
  lc: "tih",
  ld: "ltr",
  alt: ["Temogun", "Tenom Murut", "Timigan", "Timigun", "Timogon", "Timogun", "Tumugun", "Bukau (Bukow)", "Murut Padas", "Beaufort Murut (Binta')", "Sandiwar (Sandewar)"],
  cc: ["MY"]
}, {
  pk: 6128,
  ang: "Tiene",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Tiene",
  lc: "tii",
  ld: "ltr",
  alt: ["Kitiini", "Tende"],
  cc: ["CD"]
}, {
  pk: 6129,
  ang: "Tilung",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Tilung",
  lc: "tij",
  ld: "ltr",
  alt: ["Tiling", "Tilling", "Tilung Blama"],
  cc: ["NP"]
}, {
  pk: 6130,
  ang: "Tikar",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Tikar",
  lc: "tik",
  ld: "ltr",
  alt: ["Ndob", "Ndome", "Tikali", "Tikar-East", "Tikari", "Tingkala", "Tige (Tikar de Ngambe)", "Tumu", "Twumwu (Tikar de Bankim)"],
  cc: ["CM"]
}, {
  pk: 6131,
  ang: "Timbe",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Timbe",
  lc: "tim",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6132,
  ang: "Tindi",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0422\u0438\u043D\u0434\u0438\u043D\u0441\u043A\u0438\u0439",
  lc: "tin",
  ld: "ltr",
  alt: ["Tindal", "Tindin", "Tindin-Echendin", "Angidin-Aknadin"],
  cc: ["RU"]
}, {
  pk: 6133,
  ang: "Teop",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Teop",
  lc: "tio",
  ld: "ltr",
  alt: ["Teapu", "Rausara (Rausiara)", "Manava", "Kosina Mohina", "Coastal Teop"],
  cc: ["PG"]
}, {
  pk: 6134,
  ang: "Trimuris",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Trimuris",
  lc: "tip",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 6135,
  ang: "Ti\xE9fo",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Ti\xE9fo",
  lc: "tiq",
  ld: "ltr",
  alt: ["Kiefo", "Tyefo", "Tyeforo"],
  cc: ["BF"]
}, {
  pk: 6136,
  ang: "Itneg, Masadiit",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Masadiit Itneg",
  lc: "tis",
  ld: "ltr",
  alt: ["Masadiit Boliney", "Masadiit Sallapadan"],
  cc: ["PH"]
}, {
  pk: 7746,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Abra Mabaka",
  lc: "tis-x-abra",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6137,
  ang: "Tinigua",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Tinigua",
  lc: "tit",
  ld: "ltr",
  alt: ["Tiniguas"],
  cc: ["CO"]
}, {
  pk: 6138,
  ang: "Adasen",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Adasen",
  lc: "tiu",
  ld: "ltr",
  alt: ["Addasen", "Addasen Tinguian", "Itneg Adasen"],
  cc: ["PH"]
}, {
  pk: 6139,
  ang: "Tiv",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Tiv",
  lc: "tiv",
  ld: "ltr",
  alt: ["Munshi"],
  cc: ["CM", "NG"]
}, {
  pk: 6140,
  ang: "Tiwi",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Tiwi",
  lc: "tiw",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 6141,
  ang: "Tiwa, Southern",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Southern Tiwa",
  lc: "tix",
  ld: "ltr",
  alt: ["Isleta (Isleta Pueblo)"],
  cc: ["US"]
}, {
  pk: 7711,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Eritrean Tigrinya",
  lc: "ti-x-eritra",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6142,
  ang: "Tiruray",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Tiruray",
  lc: "tiy",
  ld: "ltr",
  alt: ["Teduray"],
  cc: ["PH"]
}, {
  pk: 6143,
  ang: "Tai Hongjin",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u7EA2\u91D1\u50A3\u8BED",
  lc: "tiz",
  ld: "ltr",
  alt: ["L\xFCshi", "Maguan", "Yongwu", "Yuanjiang (Shui Dai)"],
  cc: ["CN", "MM"]
}, {
  pk: 6144,
  ang: "Tajuasohn",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Tajuasohn",
  lc: "tja",
  ld: "ltr",
  alt: ["Tajuason", "Tajuoso", "Tajuosohn"],
  cc: ["LR"]
}, {
  pk: 6145,
  ang: "Tunjung",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tunjung",
  lc: "tjg",
  ld: "ltr",
  alt: ["Tunjung Dayak", "Tunjung (Tunjung Tengah)"],
  cc: ["ID"]
}, {
  pk: 6146,
  ang: "Tujia, Northern",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u571F\u5BB6\u8BED",
  lc: "tji",
  ld: "ltr",
  alt: ["Tuchia", "Tudja"],
  cc: ["CN"]
}, {
  pk: 6147,
  ang: "Tai Laing",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Tai Laing",
  lc: "tjl",
  ld: "ltr",
  alt: ["Red Tai", "Shan Bamar", "Shan Kalee", "Shan Ni", "Tai Laeng", "Tai Lang", "Tai Naing"],
  cc: ["MM"]
}, {
  pk: 6148,
  ang: "Timucua",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Timucua",
  lc: "tjm",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 6149,
  ang: "Tamazight, Temacine",
  lr: "Africa",
  gw: false,
  hc: "DZ",
  ln: "\u062A\u0627\u0634\u0644\u062D\u064A\u062A",
  lc: "tjo",
  ld: "ltr",
  alt: ["Touggourt", "Tougourt", "Tugurt"],
  cc: ["DZ"]
}, {
  pk: 6150,
  ang: "Tujia, Southern",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u571F\u5BB6\u8BED",
  lc: "tjs",
  ld: "ltr",
  alt: ["Tuchia"],
  cc: ["CN"]
}, {
  pk: 6151,
  ang: "Djabwurrung",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Djabwurrung",
  lc: "tjw",
  ld: "ltr",
  alt: ["Chaa wuurong", "Chaap Wuurong", "Chaap-Warrong", "Chaapwurra", "Chaapwurru", "Chaapwuurong", "Chap wurong", "Chap wurrung", "Chap-wurong", "Djab Wurrung", "Djab wurung", "Djabwuru", "Djabwurung", "Dyabwurung", "Dyapwurong", "Jab Wurrong", "Jab wurrung", "Kolor", "Kolorer", "Kooloor", "Pirtkopannoot", "Punoinjon", "Purteetchally", "Tchapwurong", "Thapwurong", "Tjap", "Tjapwuron", "Tjapwurong", "Tjap-wurong", "Tjapwurun", "Tjapwurung", "Tjapwuurong", "Tyapawurru", "Tyapwurru", "Tyapwuru", "Pirtkopan"],
  cc: ["AU"]
}, {
  pk: 6152,
  ang: "Turkmen",
  lr: "Asia",
  gw: false,
  hc: "TM",
  ln: "T\xFCrkmen, \u0422\u04AF\u0440\u043A\u043C\u0435\u043D",
  lc: "tk",
  ld: "rtl",
  alt: ["Turkman", "Turkmencha", "Turkmeni", "Torkomani", "Trukhmen", "Trukhmeny", "Turkmani", "Turkmanian", "Turkmenler", "Turkomans", "\xC4rsare (Arsariy)", "Bayat", "Esari (Esary)", "Goklen (Goklan)", "Nokhurli (Nohur)", "Shirik", "Teke (Taka)", "Teke (Tekke)", "Xatap", "Yomud (Yomut)"],
  cc: ["AF", "IR", "KZ", "TJ", "PK", "US", "CA", "KG", "TM", "UZ"]
}, {
  pk: 6153,
  ang: "Truk\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Truk\xE1",
  lc: "tka",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 6154,
  ang: "Buksa",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Buksa",
  lc: "tkb",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 6155,
  ang: "Tukudede",
  lr: "Asia",
  gw: false,
  hc: "TL",
  ln: "Tukudede",
  lc: "tkd",
  ld: "ltr",
  alt: ["Tocod", "Tokod\xE9", "Tokodede", "Tukude", "Keha (Keia)"],
  cc: ["TL"]
}, {
  pk: 6156,
  ang: "Takwane",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Takwane",
  lc: "tke",
  ld: "ltr",
  alt: ["Thakwani"],
  cc: ["MZ"]
}, {
  pk: 6157,
  ang: "Malagasy, Tesaka",
  lr: "Africa",
  gw: false,
  hc: "MG",
  ln: "Tesaka Malagasy",
  lc: "tkg",
  ld: "ltr",
  alt: ["Antaisaka", "Antesaka", "Atesaka"],
  cc: ["MG"]
}, {
  pk: 6158,
  ang: "Tokelauan",
  lr: "Pacific",
  gw: false,
  hc: "TK",
  ln: "Tokelau",
  lc: "tkl",
  ld: "ltr",
  alt: ["Tokelau"],
  cc: ["NZ", "TK", "US"]
}, {
  pk: 6159,
  ang: "Takelma",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Takelma",
  lc: "tkm",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 6160,
  ang: "Toku-No-Shima",
  lr: "Asia",
  gw: false,
  hc: "JP",
  ln: "\u30B7\u30DE\u30B0\u30C1",
  lc: "tkn",
  ld: "ltr",
  alt: [],
  cc: ["JP"]
}, {
  pk: 6161,
  ang: "Tikopia",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Tikopia",
  lc: "tkp",
  ld: "ltr",
  alt: [],
  cc: ["SB"]
}, {
  pk: 6162,
  ang: "Tee",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Tee",
  lc: "tkq",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 6163,
  ang: "Tsakhur",
  lr: "Asia",
  gw: false,
  hc: "AZ",
  ln: "Saxur dili",
  lc: "tkr",
  ld: "ltr",
  alt: ["Caxur", "Sakhur", "Tsakhury", "Tsaxur", "Yiqny Miz", "Muslakh", "Tsakh-Qum", "Suvagil", "Mukhakh-Sabunchi", "Mishkesh", "Gelmets-Mikik (Gelmets-kurdul)", "Tsakh (Jinagh)"],
  cc: ["AZ"]
}, {
  pk: 6164,
  ang: "Takestani",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Takestani",
  lc: "tks",
  ld: "rtl",
  alt: ["Takistani", "Kharaqan", "Ramand (Takestan)"],
  cc: ["IR"]
}, {
  pk: 6165,
  ang: "Tharu, Kathariya",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Kathoriya Tharu",
  lc: "tkt",
  ld: "ltr",
  alt: ["Kathoriya Tharu", "Khatima Tharu", "Kathariya"],
  cc: ["NP"]
}, {
  pk: 6166,
  ang: "Totonac, Upper Necaxa",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Upper Necaxa Totonac",
  lc: "tku",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 6167,
  ang: "Mur Pano",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mur Pano",
  lc: "tkv",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6168,
  ang: "Teanu",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Teanu",
  lc: "tkw",
  ld: "ltr",
  alt: ["Buma", "Puma"],
  cc: ["SB"]
}, {
  pk: 6169,
  ang: "Tangko",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tangko",
  lc: "tkx",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 6170,
  ang: "Takua",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Takua",
  lc: "tkz",
  ld: "ltr",
  alt: ["Langya", "Quang Tin Katu"],
  cc: ["VN"]
}, {
  pk: 6171,
  ang: "Tagalog",
  lr: "Asia",
  gw: true,
  hc: "PH",
  ln: "Wikang Tagalog",
  lc: "tl",
  ld: "ltr",
  alt: ["Puray"],
  cc: ["DE", "ES", "GB", "MY", "OM", "PH", "US", "AU", "CA", "IT", "KW", "SG", "QA"]
}, {
  pk: 6172,
  ang: "Tepehuan, Southwestern",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Southwestern Tepehuan",
  lc: "tla",
  ld: "ltr",
  alt: ["Tepehu\xE1n del Suroeste"],
  cc: ["MX"]
}, {
  pk: 6173,
  ang: "Tobelo",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tobelo",
  lc: "tlb",
  ld: "ltr",
  alt: ["Tobelo (Heleworuru)"],
  cc: ["ID"]
}, {
  pk: 6174,
  ang: "Totonac, Yecuatla",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Yecuatla Totonac",
  lc: "tlc",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 6175,
  ang: "Talaud",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Talaud",
  lc: "tld",
  ld: "ltr",
  alt: ["Talaur", "Talaut", "Talodda", "Dapalan (Riung)", "South Karakelong (Karakelang)", "Salibabu", "Karakelong", "Lirang (Salebabu)"],
  cc: ["ID"]
}, {
  pk: 6176,
  ang: "Telefol",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Telefol",
  lc: "tlf",
  ld: "ltr",
  alt: ["Teleefool", "Telefolmin", "Telefomin"],
  cc: ["PG"]
}, {
  pk: 6177,
  ang: "Tofanma",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tofanma",
  lc: "tlg",
  ld: "ltr",
  alt: ["Tofamna"],
  cc: ["ID"]
}, {
  pk: 6178,
  ang: "Klingon",
  lr: "",
  gw: false,
  hc: "",
  ln: "Klingon",
  lc: "tlh",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6179,
  ang: "Tlingit",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Tlingit",
  lc: "tli",
  ld: "ltr",
  alt: ["Kolosch", "Kolosh", "Tlinkit"],
  cc: ["US", "CA"]
}, {
  pk: 6180,
  ang: "Talinga-Bwisi",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Talinga-Bwisi",
  lc: "tlj",
  ld: "ltr",
  alt: ["Bwisi", "Lubwisi", "Lubwissi", "Mawissi", "Olubwisi", "Bwissi"],
  cc: ["UG"]
}, {
  pk: 6181,
  ang: "Taloki",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Taloki",
  lc: "tlk",
  ld: "ltr",
  alt: ["Talloki", "Taluki"],
  cc: ["ID"]
}, {
  pk: 6182,
  ang: "Tetela",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Tetela",
  lc: "tll",
  ld: "ltr",
  alt: ["Sungu"],
  cc: ["CD"]
}, {
  pk: 6183,
  ang: "Tolomako",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Tolomako",
  lc: "tlm",
  ld: "ltr",
  alt: ["Big Bay", "Marina", "Tolomako-Jereviu"],
  cc: ["VU"]
}, {
  pk: 6184,
  ang: "Talondo\u2019",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Talondo'",
  lc: "tln",
  ld: "ltr",
  alt: ["Talondo Kondo"],
  cc: ["ID"]
}, {
  pk: 6185,
  ang: "Talodi",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Talodi",
  lc: "tlo",
  ld: "ltr",
  alt: ["Ajomang", "Gajomang", "Jomang"],
  cc: ["SD"]
}, {
  pk: 6186,
  ang: "Totonac, Filomena Mata-Coahuitl\xE1n",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Filomena Mata-Coahuitl\xE1n Totonac",
  lc: "tlp",
  ld: "ltr",
  alt: ["Santo Domingo Totonac", "Totonaco de Filomena Mata-Coahuitl\xE1n"],
  cc: ["MX"]
}, {
  pk: 6187,
  ang: "Tai Loi",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Tai Loi",
  lc: "tlq",
  ld: "ltr",
  alt: ["Loi", "Monglwe", "Tailoi", "Wakut", "Aw-aak", "Bulang-Su", "Khabe", "Kon Doi", "Kon Loi", "Muak Sa-aak", "Saneung Muak"],
  cc: ["LA", "MM"]
}, {
  pk: 6188,
  ang: "Talise",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Talise",
  lc: "tlr",
  ld: "ltr",
  alt: ["Talisi", "Koo (Inakona)"],
  cc: ["SB"]
}, {
  pk: 6189,
  ang: "Tambotalo",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Tambotalo",
  lc: "tls",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 6190,
  ang: "Teluti",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Teluti",
  lc: "tlt",
  ld: "ltr",
  alt: ["Silen", "Taluti", "Tehoru", "Tihoru", "Wolu", "Tehua", "West Teluti (Haya)"],
  cc: ["ID"]
}, {
  pk: 6191,
  ang: "Tulehu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tulehu",
  lc: "tlu",
  ld: "ltr",
  alt: ["Northeast Ambon"],
  cc: ["ID"]
}, {
  pk: 6192,
  ang: "Taliabu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Taliabu",
  lc: "tlv",
  ld: "ltr",
  alt: ["Taliabo", "Soboyo", "Mange", "Mange'e", "Mangei (Mang)", "Padang (Samada)", "Sobojo"],
  cc: ["ID"]
}, {
  pk: 6193,
  ang: "Khehek",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Khehek",
  lc: "tlx",
  ld: "ltr",
  alt: ["Levei-Drehet", "Levei-Ndrehet", "Levei (Lebei)", "Lebej", "Chehek", "Drehet (Chechek)"],
  cc: ["PG"]
}, {
  pk: 6194,
  ang: "Talysh",
  lr: "Asia",
  gw: false,
  hc: "AZ",
  ln: "Tal\u0131\u015F dili",
  lc: "tly",
  ld: "ltr",
  alt: ["Talesh", "Talish", "Talyshi", "Taleshi", "Talishi"],
  cc: ["AZ", "IR"]
}, {
  pk: 6195,
  ang: "Tama",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Tama (Chad)",
  lc: "tma",
  ld: "ltr",
  alt: ["Tamok", "Tamongobo", "Tamot", "Mileere (Milerinka)"],
  cc: ["SD", "TD"]
}, {
  pk: 6196,
  ang: "Avava",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Katbol",
  lc: "tmb",
  ld: "ltr",
  alt: ["Navava", "Taremp", "Tembimbe-Katbol", "Tisvel", "Vava", "Bangasa", "Timbembe", "Nevaar", "Nevat"],
  cc: ["VU"]
}, {
  pk: 6197,
  ang: "Tumak",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Tumak",
  lc: "tmc",
  ld: "ltr",
  alt: ["Dije", "Sara Toumak", "Toumak", "Tumac", "Tumag", "Tummok", "Mod", "Moden", "Modin", "Mot", "Motin", "Motun (Mawer)"],
  cc: ["TD"]
}, {
  pk: 6198,
  ang: "Haruai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Haruai",
  lc: "tmd",
  ld: "ltr",
  alt: ["Harway", "Taman", "Waibuk", "Wiyau", "Wiyaw", "Wovan", "Central Waibuk (Mambar)", "North Waibuk (Hamil)", "South Waibuk (Arama)"],
  cc: ["PG"]
}, {
  pk: 6199,
  ang: "Trememb\xE9",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Trememb\xE9",
  lc: "tme",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 6200,
  ang: "Toba-Maskoy",
  lr: "Americas",
  gw: false,
  hc: "PY",
  ln: "Toba-Maskoy",
  lc: "tmf",
  ld: "ltr",
  alt: ["Cabanatit", "Enenxet", "Machicui", "Quilyilhrayrom", "Toba of Paraguay"],
  cc: ["PY"]
}, {
  pk: 6201,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Tamashek",
  lc: "tmh",
  ld: "ltr",
  alt: [],
  cc: ["ML", "NE"]
}, {
  pk: 6202,
  ang: "Tutuba",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Tutuba",
  lc: "tmi",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 6203,
  ang: "Samarokena",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Samarokena",
  lc: "tmj",
  ld: "ltr",
  alt: ["Karfasia", "Samarkena", "Tamaja", "Tamaya"],
  cc: ["ID"]
}, {
  pk: 6204,
  ang: "Tamang, Northwestern",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Northwestern Tamang",
  lc: "tmk",
  ld: "ltr",
  alt: ["Kath-Bhotiya", "Lama Bhote", "Murmi", "Rongba", "Sain", "Tamang Gyoi", "Tamang Lengmo", "Tamang Tam"],
  cc: ["NP"]
}, {
  pk: 6205,
  ang: "Citak, Tamnim",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tamnim Citak",
  lc: "tml",
  ld: "ltr",
  alt: ["Asmat Darat", "Tamnim"],
  cc: ["ID"]
}, {
  pk: 6206,
  ang: "Tai Thanh",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Tai Thanh",
  lc: "tmm",
  ld: "ltr",
  alt: ["T\xE1y Thanh", "Thanh"],
  cc: ["VN"]
}, {
  pk: 6207,
  ang: "Dayak Taman Kapuas",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Taman Kapuas",
  lc: "tmn",
  ld: "ltr",
  alt: ["Dayak Taman", "Taman Dayak"],
  cc: ["ID"]
}, {
  pk: 8068,
  ang: "Dayak Tamambaloh",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Tamambaloh",
  lc: "tmn-x-dayaktamambaloh",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7966,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Nanga Taman",
  lc: "tmn-x-nangataman",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7891,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Taman Sesat",
  lc: "tmn-x-tamansesat",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6208,
  ang: "Temoq",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Temoq",
  lc: "tmo",
  ld: "ltr",
  alt: [],
  cc: ["MY"]
}, {
  pk: 6209,
  ang: "Tai M\xE8ne",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Tai M\xE8ne",
  lc: "tmp",
  ld: "ltr",
  alt: ["Tai Maen", "Tai Man", "Tai Men", "Tai-Maen", "Tay M\xE8n\xE8"],
  cc: ["LA"]
}, {
  pk: 6210,
  ang: "Tumleo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tumleo",
  lc: "tmq",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6211,
  ang: "Jewish Babylonian Aramaic",
  lr: "Asia",
  gw: false,
  hc: "IL",
  ln: "\u05D0\u05E8\u05DE\u05D9\u05EA \u05D1\u05D1\u05DC\u05D9\u05EA (ca. 200-1200 CE)",
  lc: "tmr",
  ld: "ltr",
  alt: ["Babylonian Talmudic Aramaic"],
  cc: ["IL"]
}, {
  pk: 6212,
  ang: "Tima",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Tima",
  lc: "tms",
  ld: "ltr",
  alt: ["Lomorik", "Lomuriki", "Tamanik", "Yibwa"],
  cc: ["SD"]
}, {
  pk: 6213,
  ang: "Tasmate",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Tasmate",
  lc: "tmt",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 6214,
  ang: "Iau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Iau",
  lc: "tmu",
  ld: "ltr",
  alt: ["Iaw", "Urundi", "Ururi", "Yau"],
  cc: ["ID"]
}, {
  pk: 6215,
  ang: "Tembo",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Tembo (Motembo)",
  lc: "tmv",
  ld: "ltr",
  alt: ["Litembo", "Motembo"],
  cc: ["CD"]
}, {
  pk: 6216,
  ang: "Temuan",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Temuan",
  lc: "tmw",
  ld: "ltr",
  alt: ["Benua", "Niap", "Belandas", "Mantra (Mentera)", "Landa", "Mintra", "Belanda (Belana)", "Belanas", "Beduanda (Biduanda)", "Blanda", "Berembun (Birmun)"],
  cc: ["MY"]
}, {
  pk: 6217,
  ang: "Tami",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tami",
  lc: "tmy",
  ld: "ltr",
  alt: ["Taemi"],
  cc: ["PG"]
}, {
  pk: 6218,
  ang: "Tswana",
  lr: "Africa",
  gw: false,
  hc: "BW",
  ln: "Setswana",
  lc: "tn",
  ld: "ltr",
  alt: ["Beetjuans", "Chuana", "Coana", "Cuana", "Sechuana", "Setswana", "Tsiwaha", "Chwana", "Tshwana", "Thlaping (Tlapi)", "Sehurutshe", "Ngwatu (Mangwato)", "Tlahaping (Tlapi)", "Ngwatu (Ngwato)"],
  cc: ["ZA", "US", "ZW", "BW", "NA"]
}, {
  pk: 6219,
  ang: "Tacana",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Tacana",
  lc: "tna",
  ld: "ltr",
  alt: ["Takana"],
  cc: ["BO"]
}, {
  pk: 6220,
  ang: "Tunebo, Western",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Western Tunebo",
  lc: "tnb",
  ld: "ltr",
  alt: ["Aguas Blancas", "U'wa"],
  cc: ["CO"]
}, {
  pk: 6221,
  ang: "Tanimuca-Retuar\xE3",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Tanimuca-Retuar\xE3",
  lc: "tnc",
  ld: "ltr",
  alt: ["Letuama", "Letuhama", "Oha\xF1ara", "Opaima", "Retuama", "Retuar\xE3", "Tanimboka", "Tanimuca-Letuama", "Uair\xE3", "Ufaina"],
  cc: ["CO"]
}, {
  pk: 6222,
  ang: "Tunebo, Angosturas",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Angosturas Tunebo",
  lc: "tnd",
  ld: "ltr",
  alt: [],
  cc: ["CO"]
}, {
  pk: 6223,
  ang: "Kallahan, Tinoc",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Tinoc Kallahan",
  lc: "tne",
  ld: "ltr",
  alt: ["Tinoc Kalangoya"],
  cc: ["PH"]
}, {
  pk: 6224,
  ang: "Tobanga",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Tobanga",
  lc: "tng",
  ld: "ltr",
  alt: ["Gabri", "Gabri-Nord", "Gabri-North", "Northern Gabri", "Mande", "Tobanga (Deressia)"],
  cc: ["TD"]
}, {
  pk: 6225,
  ang: "Maiani",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Maiani",
  lc: "tnh",
  ld: "ltr",
  alt: ["Banara", "Miani South", "Tani", "Wagimuda"],
  cc: ["PG"]
}, {
  pk: 6226,
  ang: "Tandia",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tandia",
  lc: "tni",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 6227,
  ang: "Kwamera",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Kwamera",
  lc: "tnk",
  ld: "ltr",
  alt: ["Ncfe", "Nxnincfe"],
  cc: ["VU"]
}, {
  pk: 6228,
  ang: "Lenakel",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Lenakel",
  lc: "tnl",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 6229,
  ang: "Tabla",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tabla",
  lc: "tnm",
  ld: "ltr",
  alt: ["Jakari", "Tabi", "Tanah Merah", "Tanahmerah 2", "Yokari"],
  cc: ["ID"]
}, {
  pk: 8445,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Yewena",
  lc: "tnm-x-yewena",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8446,
  ang: "Yokari",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Yokari",
  lc: "tnm-x-yokari",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6230,
  ang: "Tanna, North",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "North Tanna",
  lc: "tnn",
  ld: "ltr",
  alt: ["East Tanna"],
  cc: ["VU"]
}, {
  pk: 6231,
  ang: "Toromono",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Toromono",
  lc: "tno",
  ld: "ltr",
  alt: [],
  cc: ["BO"]
}, {
  pk: 6232,
  ang: "Whitesands",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Whitesands",
  lc: "tnp",
  ld: "ltr",
  alt: ["Napuanmen", "Whitsands", "Weasisi (Wassisi)"],
  cc: ["VU"]
}, {
  pk: 6233,
  ang: "Ta\xEDno",
  lr: "Americas",
  gw: false,
  hc: "PR",
  ln: "Taino",
  lc: "tnq",
  ld: "ltr",
  alt: [],
  cc: ["PR"]
}, {
  pk: 6234,
  ang: "M\xE9nik",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "M\xE9nik",
  lc: "tnr",
  ld: "ltr",
  alt: ["Bande", "Basari du Bandemba", "Bedik", "Tandanke", "Tenda", "Tendanke"],
  cc: ["SN"]
}, {
  pk: 6235,
  ang: "Tenis",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tenis",
  lc: "tns",
  ld: "ltr",
  alt: ["Tench"],
  cc: ["PG"]
}, {
  pk: 6236,
  ang: "Tontemboan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tontemboan",
  lc: "tnt",
  ld: "ltr",
  alt: ["Pakewa", "Tompakewa", "Sonder (Matanai)", "Tompaso (Makelai)", "Matana'i-Maore'", "Makela'i-Maotow"],
  cc: ["ID"]
}, {
  pk: 6237,
  ang: "Tay Khang",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Tay Khang",
  lc: "tnu",
  ld: "ltr",
  alt: [],
  cc: ["LA"]
}, {
  pk: 6238,
  ang: "Tangchangya",
  lr: "Asia",
  gw: false,
  hc: "BD",
  ln: "Tangchangya",
  lc: "tnv",
  ld: "ltr",
  alt: ["Tanchangya"],
  cc: ["BD"]
}, {
  pk: 6239,
  ang: "Tonsawang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tonsawang",
  lc: "tnw",
  ld: "ltr",
  alt: ["Tombatu"],
  cc: ["ID"]
}, {
  pk: 6240,
  ang: "Tanema",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Tanema",
  lc: "tnx",
  ld: "ltr",
  alt: ["Tetau", "Tetawo"],
  cc: ["SB"]
}, {
  pk: 6241,
  ang: "Tongwe",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Tongwe",
  lc: "tny",
  ld: "ltr",
  alt: ["Kitongwe", "Sitongwe"],
  cc: ["TZ"]
}, {
  pk: 6242,
  ang: "Tonga",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Ten'edn",
  lc: "tnz",
  ld: "ltr",
  alt: ["Mos Tean-ean", "Mos"],
  cc: ["TH"]
}, {
  pk: 6243,
  ang: "Tonga (Tonga Islands)",
  lr: "Pacific",
  gw: false,
  hc: "TO",
  ln: "faka Tonga",
  lc: "to",
  ld: "ltr",
  alt: ["Tonga"],
  cc: ["FJ", "NZ", "TO", "US", "CA"]
}, {
  pk: 6244,
  ang: "Toba",
  lr: "Americas",
  gw: false,
  hc: "AR",
  ln: "Toba",
  lc: "tob",
  ld: "ltr",
  alt: ["Chaco Sur", "Namqom", "Qom", "Toba Sur", "Emok-Lik", "Takshika", "Toba-Qom"],
  cc: ["AR", "PY", "BO"]
}, {
  pk: 6245,
  ang: "Totonac, Coyutla",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Coyutla Totonac",
  lc: "toc",
  ld: "ltr",
  alt: ["Totonaco de Coyutla", "Cerro Grande Totonac"],
  cc: ["MX"]
}, {
  pk: 6246,
  ang: "Toma",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Toma",
  lc: "tod",
  ld: "ltr",
  alt: ["Toa", "Toale", "Toali", "Tooma", "Manyaka", "Yala", "Vekema", "Lulama", "Konokoro", "Koima", "Gizima", "Weima"],
  cc: ["GN"]
}, {
  pk: 6247,
  ang: "Gizrra",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Gizrra",
  lc: "tof",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6248,
  ang: "Tonga",
  lr: "Africa",
  gw: false,
  hc: "MW",
  ln: "Tonga (Nyasa)",
  lc: "tog",
  ld: "ltr",
  alt: ["Chitonga", "Kitonga", "Siska", "Sisya", "Western Nyasa"],
  cc: ["MW"]
}, {
  pk: 6249,
  ang: "Tonga",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Gitonga",
  lc: "toh",
  ld: "ltr",
  alt: ["Bitonga", "Inhambane", "Shengwe", "Tonga-Inhambane", "Nyambe (Cinyambe)", "Sewi (Gisewi)"],
  cc: ["MZ"]
}, {
  pk: 6250,
  ang: "Tonga",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Tonga (Zambia)",
  lc: "toi",
  ld: "ltr",
  alt: ["Plateau Tonga", "Zambezi", "We (Valley Tonga)", "Shanjo (Sanjo)", "Toka (Southern Tonga)", "We"],
  cc: ["ZM", "ZW"]
}, {
  pk: 8123,
  ang: "Toka-Leya Tonga",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Toka-Leya",
  lc: "toi-x-tokaleya",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6251,
  ang: "Tojolabal",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tojolabal",
  lc: "toj",
  ld: "ltr",
  alt: ["Cha\xF1abal", "Comiteco"],
  cc: ["MX"]
}, {
  pk: 6252,
  ang: "Tolowa",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Tolowa",
  lc: "tol",
  ld: "ltr",
  alt: ["Smith River"],
  cc: ["US"]
}, {
  pk: 6253,
  ang: "Tombulu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tombulu",
  lc: "tom",
  ld: "ltr",
  alt: ["Minahasa", "Minhasa", "Tombalu", "Tombula", "Tombulu'", "Toumbulu"],
  cc: ["ID"]
}, {
  pk: 7686,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Borgo Bahuntehu",
  lc: "tom-x-bahunt",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7685,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Borgo",
  lc: "tom-x-borgo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6254,
  ang: "Totonac, Xicotepec de Ju\xE1rez",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Xicotepec De Ju\xE1rez Totonac",
  lc: "too",
  ld: "ltr",
  alt: ["Northern Totonac", "Totonaco de Villa Ju\xE1rez", "Zihuateutla Totonac"],
  cc: ["MX"]
}, {
  pk: 6255,
  ang: "Totonac, Papantla",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Papantla Totonac",
  lc: "top",
  ld: "ltr",
  alt: ["Lowland Totonaca", "Totonaco de Papantla"],
  cc: ["MX"]
}, {
  pk: 6256,
  ang: "Toposa",
  lr: "Africa",
  gw: false,
  hc: "SS",
  ln: "Toposa",
  lc: "toq",
  ld: "ltr",
  alt: ["Akara", "Kare", "Kumi", "Taposa", "Topotha"],
  cc: ["ET", "SS", "UG"]
}, {
  pk: 6257,
  ang: "Banda, Togbo-Vara",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Togbo-Vara Banda",
  lc: "tor",
  ld: "ltr",
  alt: ["Tagbwali", "Togbo (Tagbo)", "Tohgboh", "Vara (Vera)", "Vora"],
  cc: ["CF", "SS", "CD"]
}, {
  pk: 6258,
  ang: "Totonac, Highland",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Highland Totonac",
  lc: "tos",
  ld: "ltr",
  alt: ["Sierra Totonac", "Totonaco de la Sierra"],
  cc: ["MX"]
}, {
  pk: 6259,
  ang: "Tho",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Th\u1ED5",
  lc: "tou",
  ld: "ltr",
  alt: ["Cuoi", "Ho Muong Meridional", "Keo", "Cuoi Cham (Uy Lo)"],
  cc: ["LA", "VN"]
}, {
  pk: 6260,
  ang: "Taromi, Upper",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Upper Taromi",
  lc: "tov",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 6261,
  ang: "Jemez",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Jemez",
  lc: "tow",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 6262,
  ang: "Tobian",
  lr: "Pacific",
  gw: false,
  hc: "PW",
  ln: "Tobian",
  lc: "tox",
  ld: "ltr",
  alt: ["Hatohobei", "Tobi"],
  cc: ["PW"]
}, {
  pk: 6263,
  ang: "Topoiyo",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Topoiyo",
  lc: "toy",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 6264,
  ang: "To",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "To",
  lc: "toz",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 6265,
  ang: "Taupota",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Taupota",
  lc: "tpa",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6266,
  ang: "Me\u2019phaa, Azoy\xFA",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Azoy\xFA Me'phaa",
  lc: "tpc",
  ld: "ltr",
  alt: ["Azoy\xFA Tlapanec", "Me'phaa", "M\xE8'ph\xE0\xE0", "Tlapaneco de Azoy\xFA", "Tlapaneco del Sur"],
  cc: ["MX"]
}, {
  pk: 6267,
  ang: "Tippera",
  lr: "Asia",
  gw: false,
  hc: "BD",
  ln: "Tippera",
  lc: "tpe",
  ld: "ltr",
  alt: ["Kok Borok", "Tipperah", "Tippurah", "Tipra", "Tipura", "Triperah", "Naitong", "Phatung", "Khali", "Kewa", "Gabing", "Dendak", "Aslong", "Anok", "Kema", "Tongpai"],
  cc: ["BD"]
}, {
  pk: 6268,
  ang: "Tarpia",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tarpia",
  lc: "tpf",
  ld: "ltr",
  alt: ["Sufrai", "Tarfia"],
  cc: ["ID"]
}, {
  pk: 6269,
  ang: "Kula",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kula",
  lc: "tpg",
  ld: "ltr",
  alt: ["Kola", "Lamtoka", "Lantoka", "Tanglapui"],
  cc: ["ID"]
}, {
  pk: 6270,
  ang: "Tok Pisin",
  lr: "Pacific",
  gw: true,
  hc: "PG",
  ln: "Tok Pisin",
  lc: "tpi",
  ld: "ltr",
  alt: ["Melanesian English", "Neomelanesian", "New Guinea Pidgin English", "Pidgin", "Pisin"],
  cc: ["SB", "US", "AU", "PG"]
}, {
  pk: 7627,
  ang: "",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Papua New Guinea Sign Language",
  lc: "tpi-x-pngsl",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6271,
  ang: "\xD1andeva",
  lr: "Americas",
  gw: false,
  hc: "PY",
  ln: "Tapiet\xE9",
  lc: "tpj",
  ld: "ltr",
  alt: ["Guarayo", "Guasurangue", "\xD1anagua", "Tirumbae", "Yanaigua", "Guasurango"],
  cc: ["PY"]
}, {
  pk: 6272,
  ang: "Tupinikin",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Tupinikin",
  lc: "tpk",
  ld: "ltr",
  alt: ["Tupinaki", "Tupinikim", "Tupiniquim"],
  cc: ["BR"]
}, {
  pk: 6273,
  ang: "Me\u2019phaa, Tlacoapa",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tlacoapa Me'phaa",
  lc: "tpl",
  ld: "ltr",
  alt: ["Me'phaa", "Me'phaa de Tlacoapa", "Mi'phaa", "Tlacoapa Tlapanec", "Tlapaneco", "Tlapaneco de Tlacoapa", "Tlapaneco del Centro", "Tenamazapa", "Tlacoapa"],
  cc: ["MX"]
}, {
  pk: 6274,
  ang: "Tampulma",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Tampulma",
  lc: "tpm",
  ld: "ltr",
  alt: ["Tampele", "Tamplima", "Tampole", "Tampolem", "Tampolense", "Tamprusi"],
  cc: ["GH"]
}, {
  pk: 6275,
  ang: "Tupi",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Tupinamb\xE1",
  lc: "tpn",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 6276,
  ang: "Tai Pao",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Tai Pao",
  lc: "tpo",
  ld: "ltr",
  alt: [],
  cc: ["LA"]
}, {
  pk: 6277,
  ang: "Tepehua, Pisaflores",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Pisaflores Tepehua",
  lc: "tpp",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 6278,
  ang: "Tukpa",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Tukpa",
  lc: "tpq",
  ld: "ltr",
  alt: ["Nesang", "Nyam-kat"],
  cc: ["IN"]
}, {
  pk: 6279,
  ang: "Tupar\xED",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Tupar\xED",
  lc: "tpr",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 6280,
  ang: "Tepehua, Tlachichilco",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tlachichilco Tepehua",
  lc: "tpt",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 6281,
  ang: "Tampuan",
  lr: "Asia",
  gw: false,
  hc: "KH",
  ln: "Tampuan",
  lc: "tpu",
  ld: "ltr",
  alt: ["Campuon", "Kha Tampuon", "Proon", "Proons", "Tamphuan", "Tampuen", "Tampuon"],
  cc: ["KH"]
}, {
  pk: 6282,
  ang: "Tanapag",
  lr: "Pacific",
  gw: false,
  hc: "MP",
  ln: "Tanapag",
  lc: "tpv",
  ld: "ltr",
  alt: ["Northern Carolinian", "Talaabwogh"],
  cc: ["MP"]
}, {
  pk: 6283,
  ang: "Tupi",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Tup\xED",
  lc: "tpw",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 6284,
  ang: "Me\u2019phaa, Acatepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Acatepec Me'phaa",
  lc: "tpx",
  ld: "ltr",
  alt: ["Acatepec Tlapanec", "Me'pa", "Me'pa W\xED'\xECn", "Me'phaa", "Tlapaneco de Acatepec", "Tlapaneco del Suroeste", "Western Tlapanec", "Nanzintla (Me'ph\xE0\xE0 Mur\xFAx\xEC\xEC)", "Tlapaneco del oeste", "Tlapaneco del noroeste alto", "Tlapaneco de Zoquitl\xE1n", "Tlapaneco de Teocuitlapa", "Tlapaneco de Nanzintla", "Tlapaneco de Huitzapula", "Teocuitlapa (Me'phaa Xma'\xED\xEDn)", "Huitzapula (Me'ph\xE0\xE0 \xC0gu\xE0\xE0)", "Tlapaneco"],
  cc: ["MX"]
}, {
  pk: 6285,
  ang: "Trumai",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Trumai",
  lc: "tpy",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 6286,
  ang: "Tinputz",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tinputz",
  lc: "tpz",
  ld: "ltr",
  alt: ["Timputs", "Vasuii", "Wasoi", "Vado"],
  cc: ["PG"]
}, {
  pk: 6287,
  ang: "Temb\xE9",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Temb\xE9",
  lc: "tqb",
  ld: "ltr",
  alt: ["Tenetehara"],
  cc: ["BR"]
}, {
  pk: 6288,
  ang: "Lehali",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Lehali",
  lc: "tql",
  ld: "ltr",
  alt: ["Teqel"],
  cc: ["VU"]
}, {
  pk: 6289,
  ang: "Turumsa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Turumsa",
  lc: "tqm",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6290,
  ang: "Tenino",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Tenino",
  lc: "tqn",
  ld: "ltr",
  alt: ["Warm Springs"],
  cc: ["US"]
}, {
  pk: 6291,
  ang: "Toaripi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Toaripi",
  lc: "tqo",
  ld: "ltr",
  alt: ["East Elema", "Motumotu", "Kaipi (Melaripi)", "Toaripi (Moripi-Iokea)", "Moveave"],
  cc: ["PG"]
}, {
  pk: 6292,
  ang: "Tomoip",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tomoip",
  lc: "tqp",
  ld: "ltr",
  alt: ["Tomoive", "Tomoyp", "Tumie", "Tumuip"],
  cc: ["PG"]
}, {
  pk: 6293,
  ang: "Tunni",
  lr: "Africa",
  gw: false,
  hc: "SO",
  ln: "Tunni",
  lc: "tqq",
  ld: "ltr",
  alt: ["Af-Tunni"],
  cc: ["SO"]
}, {
  pk: 6294,
  ang: "Torona",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Torona",
  lc: "tqr",
  ld: "ltr",
  alt: [],
  cc: ["SD"]
}, {
  pk: 6295,
  ang: "Totonac, Ozumatl\xE1n",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Western Totonac",
  lc: "tqt",
  ld: "ltr",
  alt: ["Totonaco de Ozomatl\xE1n", "Totonaco del cerro Xinolate\xB4petl", "Totonaco Norte de Huauchinango", "Xinolate\xB4petl Totonac", "Xinulajgsipij Tutunaku"],
  cc: ["MX"]
}, {
  pk: 6296,
  ang: "Touo",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Touo",
  lc: "tqu",
  ld: "ltr",
  alt: ["Baniata", "Lokuru", "Mbaniata"],
  cc: ["SB"]
}, {
  pk: 6297,
  ang: "Tonkawa",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Tonkawa",
  lc: "tqw",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 6298,
  ang: "Turkish",
  lr: "Asia",
  gw: true,
  hc: "TR",
  ln: "T\xFCrk\xE7e",
  lc: "tr",
  ld: "ltr",
  alt: ["Osmanli", "Turki", "Anatolian", "T\xFCrk\xE7e", "T\xFCrkisch"],
  cc: ["AZ", "AT", "BE", "BA", "CY", "GR", "FR", "DE", "IQ", "IL", "KZ", "LB", "GB", "TJ", "MK", "NL", "PK", "RO", "SA", "SY", "SE", "CH", "TR", "US", "AU", "CA", "KG", "DK", "UZ", "BG", "UA", "EG", "AE"]
}, {
  pk: 6299,
  ang: "Tirahi",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Tirahi",
  lc: "tra",
  ld: "ltr",
  alt: [],
  cc: ["AF"]
}, {
  pk: 6300,
  ang: "Terebu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Terebu",
  lc: "trb",
  ld: "ltr",
  alt: ["Terepu", "Turubu", "Turupu"],
  cc: ["PG"]
}, {
  pk: 6301,
  ang: "Triqui, Copala",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Copala Triqui",
  lc: "trc",
  ld: "ltr",
  alt: ["Copala Trique", "Triqui Bajo", "Triqui de San Juan Copala"],
  cc: ["MX"]
}, {
  pk: 6302,
  ang: "Turi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Turi",
  lc: "trd",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 6303,
  ang: "Tarangan, East",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "East Tarangan",
  lc: "tre",
  ld: "ltr",
  alt: ["East Trangan", "Tarangan Timur", "North East Tarangan", "South East Tarangan"],
  cc: ["ID"]
}, {
  pk: 6304,
  ang: "Trinidadian Creole English",
  lr: "Americas",
  gw: false,
  hc: "TT",
  ln: "Trinidadian Creole English",
  lc: "trf",
  ld: "ltr",
  alt: [],
  cc: ["TT"]
}, {
  pk: 6305,
  ang: "Lish\xE1n Did\xE1n",
  lr: "Asia",
  gw: false,
  hc: "IL",
  ln: "\u05D9\u05D4\u05D5\u05D3\u05D9\u05EA-\u05EA\u05D9\u05DE\u05E0\u05D9\u05EA",
  lc: "trg",
  ld: "rtl",
  alt: ["Galihalu", "Lakhlokhi", "Lishan\xE1n", "Lishanid Nash Did\xE1n", "Persian Azerbaijan Jewish Aramaic", "Naghada", "Northern Cluster Lish\xE1n Did\xE1n (Anatolia)", "Salmas", "Southern Cluster Lish\xE1n Did\xE1n (Mahabad)", "Urmi", "Ushno"],
  cc: ["IL"]
}, {
  pk: 6306,
  ang: "Turaka",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Turaka",
  lc: "trh",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6307,
  ang: "Tri\xF3",
  lr: "Americas",
  gw: false,
  hc: "SR",
  ln: "Tri\xF3",
  lc: "tri",
  ld: "ltr",
  alt: ["Tiri\xF3", "Tiriy\xF3"],
  cc: ["BR", "SR"]
}, {
  pk: 6308,
  ang: "Toram",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Toram",
  lc: "trj",
  ld: "ltr",
  alt: ["Torom", "Torum"],
  cc: ["TD"]
}, {
  pk: 6309,
  ang: "Traveller Scottish",
  lr: "Europe",
  gw: false,
  hc: "GB",
  ln: "Traveller Scottish",
  lc: "trl",
  ld: "ltr",
  alt: ["Scottish Cant", "Scottish Traveller Cant"],
  cc: ["GB"]
}, {
  pk: 6310,
  ang: "Tregami",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Tregami",
  lc: "trm",
  ld: "ltr",
  alt: ["Katar Gambir", "Trigami"],
  cc: ["AF"]
}, {
  pk: 6311,
  ang: "Trinitario",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Trinitario",
  lc: "trn",
  ld: "ltr",
  alt: ["Mojos", "Moxos", "Loreto (Loretano)"],
  cc: ["BO"]
}, {
  pk: 6312,
  ang: "Naga, Tarao",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Tarao Naga",
  lc: "tro",
  ld: "ltr",
  alt: ["Taraotrong", "Tarau"],
  cc: ["IN"]
}, {
  pk: 6313,
  ang: "Kok Borok",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kok Borok",
  lc: "trp",
  ld: "ltr",
  alt: ["Tipura", "Kakbarak", "Kokbarak", "Usipi Mrung", "Noatia (Tipra)"],
  cc: ["BD", "IN"]
}, {
  pk: 7598,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Molsom",
  lc: "trp-x-molsom",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6314,
  ang: "Triqui, San Mart\xEDn Itunyoso",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "San Mart\xEDn Itunyoso Triqui",
  lc: "trq",
  ld: "ltr",
  alt: ["San Mart\xEDn Itunyoso Trique", "Triqui Alto", "Triqui de San Mart\xEDn Itunyoso"],
  cc: ["MX"]
}, {
  pk: 6315,
  ang: "Taushiro",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Taushiro",
  lc: "trr",
  ld: "ltr",
  alt: ["Pinche", "Pinchi"],
  cc: ["PE"]
}, {
  pk: 6316,
  ang: "Triqui, Chicahuaxtla",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Chicahuaxtla Triqui",
  lc: "trs",
  ld: "ltr",
  alt: ["Chicahuaxtla Trique", "Triqui Alto", "Triqui de San Andr\xE9s Chicahuaxtla", "San Jos\xE9 Xochistl\xE1", "Santo Domingo del Estado"],
  cc: ["MX"]
}, {
  pk: 6317,
  ang: "Tunggare",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tunggare",
  lc: "trt",
  ld: "ltr",
  alt: ["Turunggare"],
  cc: ["ID"]
}, {
  pk: 6318,
  ang: "Turoyo",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "\u071B\u0718\u072A\u071D\u0710",
  lc: "tru",
  ld: "ltr",
  alt: ["Surayt", "Suryoyo", "Syryoyo", "Turani", "S\xFCryani"],
  cc: ["DE", "IQ", "GB", "NL", "SY", "TR", "KW"]
}, {
  pk: 6319,
  ang: "Taroko",
  lr: "Asia",
  gw: false,
  hc: "TW",
  ln: "Taroko",
  lc: "trv",
  ld: "ltr",
  alt: ["Bu-Hwan", "Che-Hwan", "Daiya-Ataiyal", "Hogo", "Iboho", "Paran", "Saediq", "Sazek", "Sedek", "Sedeq", "Sediakk", "Sedik", "Seedek", "Seedeq", "Seedik", "Sejiq", "Shedekka", "Taruku", "Toda", "Toroko", "Truku", "Teruku (Truku)", "Te'uda (Tuuda)", "Tkdaya", "Tekedaya (Paran)"],
  cc: ["TW"]
}, {
  pk: 6320,
  ang: "Torwali",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u062A\u0648\u0631\u0648\u0627\u0644\u06CC",
  lc: "trw",
  ld: "ltr",
  alt: ["Turvali"],
  cc: ["PK"]
}, {
  pk: 6321,
  ang: "Bidayuh, Tringgus-Sembaan",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Tringgus-Sembaan Bidayuh",
  lc: "trx",
  ld: "ltr",
  alt: ["Tringus", "Mbaan (Bimbaan)", "Sembaan"],
  cc: ["MY"]
}, {
  pk: 6322,
  ang: "Tor\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Tor\xE1",
  lc: "trz",
  ld: "ltr",
  alt: ["Toraz"],
  cc: ["BR"]
}, {
  pk: 6323,
  ang: "Tsonga",
  lr: "Africa",
  gw: false,
  hc: "ZA",
  ln: "Xitsonga",
  lc: "ts",
  ld: "ltr",
  alt: ["Shitsonga", "Thonga", "Tonga", "Xitsonga", "Xichangana", "Shangaan", "Shangana", "Luleke (Xiluleke)", "Shilanganu", "N'walungu (Shingwalungu)", "Nhlanganu (Shihlanganu)", "Ngwalungu (Shingwalungu)", "Langanu", "Jonga (Dzonga)", "Jonga (Djonga)", "Hlanganu", "Hanganu", "Gwamba (Gwapa)", "Dzonga", "Bila (Vila)", "Changana (Changa)"],
  cc: ["MZ", "ZA", "ZW", "SZ"]
}, {
  pk: 6324,
  ang: "Tsaangi",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Tsaangi",
  lc: "tsa",
  ld: "ltr",
  alt: ["Icaangi", "Itsangi", "Tcengui", "Tchangui", "Batsangui", "Icaangui", "Itsaangi", "Tsangi"],
  cc: ["GA", "CG"]
}, {
  pk: 6325,
  ang: "Tsamai",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Tsamai",
  lc: "tsb",
  ld: "ltr",
  alt: ["Bago S'aamakk-Ulo", "Cule", "Kuile", "Kule", "S'amai", "Tamaha", "Tsamakko", "Tsamako", "Ts'amay"],
  cc: ["ET"]
}, {
  pk: 6326,
  ang: "Tswa",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Tswa",
  lc: "tsc",
  ld: "ltr",
  alt: ["Kitshwa", "Sheetshwa", "Shitshwa", "Xitshwa", "Lengwe", "Tshwa (Dzibi-Dzonga)", "Shilengwe", "Makwakwe-Khambana", "Lhengwe", "Hlengwe (Makawe-Khambana)", "Hlengwe (Makakwe-Khambana)", "Hlengwe (Khambana-Makwakwe)", "Dzonga-Dzibi", "Dzivi", "Xidzivi", "Khambani"],
  cc: ["MZ", "ZA", "ZW"]
}, {
  pk: 6327,
  ang: "Tsakonian",
  lr: "Europe",
  gw: false,
  hc: "GR",
  ln: "Tsakonian",
  lc: "tsd",
  ld: "ltr",
  alt: ["Tsakonia", "Northern Tsakonian (Kastanista-Sitena)", "Propontis Tsakonian (Vatka-Havoutsi)", "Southern Tsakonian (Leonidio-Prastos)"],
  cc: ["GR"]
}, {
  pk: 6328,
  ang: "Tunisian Sign Language",
  lr: "Africa",
  gw: false,
  hc: "TN",
  ln: "Tunisian Sign Language",
  lc: "tse",
  ld: "ltr",
  alt: [],
  cc: ["TN"]
}, {
  pk: 6329,
  ang: "Tausug",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Tausug",
  lc: "tsg",
  ld: "ltr",
  alt: ["Joloano Sulu", "Moro Joloano", "Sooloo", "Sulu", "Suluk", "Taosug", "Tausog", "Taw Sug", "Joloano", "Moro", "Bahasa Sug", "Sinug"],
  cc: ["MY", "PH"]
}, {
  pk: 6330,
  ang: "Tsuvan",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Tsuvan",
  lc: "tsh",
  ld: "ltr",
  alt: ["Matsuvan", "Motsuvan", "Tchede", "Telaki", "Teleki", "Terki"],
  cc: ["CM"]
}, {
  pk: 6331,
  ang: "Tsimshian",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Tsimshian",
  lc: "tsi",
  ld: "ltr",
  alt: ["Chimmezyan", "Maritime Tsimshianic", "Zimshian", "Sm'algyax", "Tsimshean", "Southern Tsimshian (Old Klemtu)", "Coast Tsimshian (Sm'algyax)", "Sguxs"],
  cc: ["US", "CA"]
}, {
  pk: 6332,
  ang: "Tshangla",
  lr: "Asia",
  gw: false,
  hc: "BT",
  ln: "Tshangla",
  lc: "tsj",
  ld: "ltr",
  alt: ["Menba", "Monpa", "Sangla", "Sarchapkkha", "Shachobiikha", "Shachopkha", "Sharchagpakha", "Sharchhop-kha", "Tshalingpa", "Canglo Monba", "Cangluo Menba", "Cangluo Monba", "Central Monpa", "Monba", "Motuo Menba", "Tsangla Monba", "Tsanglo", "Motuo", "Sharchopkha"],
  cc: ["CN", "BT"]
}, {
  pk: 6333,
  ang: "Tseku",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Tseku",
  lc: "tsk",
  ld: "ltr",
  alt: ["Tsuku", "Tzuku"],
  cc: ["CN", "BT", "NP"]
}, {
  pk: 6334,
  ang: "Ts\u2019\xFCn-Lao",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Ts'\xFCn-Lao",
  lc: "tsl",
  ld: "ltr",
  alt: ["Lao"],
  cc: ["VN"]
}, {
  pk: 6335,
  ang: "Turkish Sign Language",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Turkish Sign Language",
  lc: "tsm",
  ld: "ltr",
  alt: ["Tid", "T\xFCrk Isaret Dili", "T\xFCrk \xDD\xFEaret Dili"],
  cc: ["AZ", "TR"]
}, {
  pk: 6336,
  ang: "Toussian, Northern",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Northern Toussian",
  lc: "tsp",
  ld: "ltr",
  alt: ["Tusia", "Tusian", "Tru", "Ter"],
  cc: ["BF"]
}, {
  pk: 6337,
  ang: "Thai Sign Language",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Thai Sign Language",
  lc: "tsq",
  ld: "ltr",
  alt: [],
  cc: ["TH"]
}, {
  pk: 6338,
  ang: "Akei",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Akei",
  lc: "tsr",
  ld: "ltr",
  alt: ["Tasiriki"],
  cc: ["VU"]
}, {
  pk: 6339,
  ang: "Taiwan Sign Language",
  lr: "Asia",
  gw: false,
  hc: "TW",
  ln: "Taiwan Sign Language",
  lc: "tss",
  ld: "ltr",
  alt: ["Taiwan Ziran Shouyu", "Kaohsiung"],
  cc: ["TW"]
}, {
  pk: 6340,
  ang: "Tondi Songway Kiini",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Tondi Songway Kiini",
  lc: "tst",
  ld: "ltr",
  alt: ["TSK"],
  cc: ["ML"]
}, {
  pk: 6341,
  ang: "Tsou",
  lr: "Asia",
  gw: false,
  hc: "TW",
  ln: "Tsou",
  lc: "tsu",
  ld: "ltr",
  alt: ["Namakaban", "Niitaka", "Tibola", "Tibolah", "Tibolak", "Tibolal", "Tso", "Tsoo", "Tsuou", "Tsu-U", "Tsu-Wo", "Tzo"],
  cc: ["TW"]
}, {
  pk: 6342,
  ang: "Tsogo",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Tsogo",
  lc: "tsv",
  ld: "ltr",
  alt: ["Getsogo", "Ghetsogo"],
  cc: ["GA"]
}, {
  pk: 6343,
  ang: "Tsishingini",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Tsishingini",
  lc: "tsw",
  ld: "ltr",
  alt: ["Ashingini", "Kambari", "Kamberchi", "Kamberri"],
  cc: ["NG"]
}, {
  pk: 6344,
  ang: "Mubami",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mubami",
  lc: "tsx",
  ld: "ltr",
  alt: ["Ta", "Tao-Suamato", "Tao-Suame"],
  cc: ["PG"]
}, {
  pk: 6345,
  ang: "Tebul Sign Language",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Tebul Sign Language",
  lc: "tsy",
  ld: "ltr",
  alt: [],
  cc: ["ML"]
}, {
  pk: 6346,
  ang: "Purepecha",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Purepecha",
  lc: "tsz",
  ld: "ltr",
  alt: ["Eastern Lake Purepecha", "P\u2019orhe", "P\u2019orh\xE9pecha", "P\u2019urhe", "P\u2019urh\xE9pecha", "Phorh\xE9pecha", "Porh\xE9", "Pur\xE9pecha de la Zona Lacustre", "Tarascan", "Tarasco", "Cienega de Zacapu", "Cuanajo", "Ihuatzio", "Isla Janitzio", "Puacuaro", "San Jeronimo"],
  cc: ["MX", "US"]
}, {
  pk: 6347,
  ang: "Tatar",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0442\u0430\u0442\u0430\u0440 \u0442\u0435\u043B\u0435, tatar tele",
  lc: "tt",
  ld: "ltr",
  alt: ["Tartar", "Tata'er", "Eastern Tatar (Siberian Tatar)", "Middle Tatar (Kazan)", "Western Tatar (Misher)"],
  cc: ["AZ", "CN", "TJ", "RU", "TR", "US", "KG", "TM", "UZ"]
}, {
  pk: 6348,
  ang: "",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Tutelo",
  lc: "tta",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 6349,
  ang: "Gaa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Gaa",
  lc: "ttb",
  ld: "ltr",
  alt: ["Tiba"],
  cc: ["NG"]
}, {
  pk: 6350,
  ang: "Tektiteko",
  lr: "Americas",
  gw: false,
  hc: "GT",
  ln: "Tektiteko",
  lc: "ttc",
  ld: "ltr",
  alt: ["Maya-Tekiteko", "Teco", "Tectit\xE1n Mam", "Tectitec", "Tectiteco", "Teko", "Tectit\xE1n Mame"],
  cc: ["GT"]
}, {
  pk: 6351,
  ang: "Tauade",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tauade",
  lc: "ttd",
  ld: "ltr",
  alt: ["Tauata"],
  cc: ["PG"]
}, {
  pk: 6352,
  ang: "Bwanabwana",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Bwanabwana",
  lc: "tte",
  ld: "ltr",
  alt: ["Tubetube", "Anagusa", "Kitai", "Koyagaugau", "Naluwaluwali", "Ole", "Tewatewa", "Wale (Ware)"],
  cc: ["PG"]
}, {
  pk: 6353,
  ang: "Tuotomb",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Tuotomb",
  lc: "ttf",
  ld: "ltr",
  alt: ["Bonek", "Ponek", "Tuotom"],
  cc: ["CM"]
}, {
  pk: 6354,
  ang: "Tutong",
  lr: "Asia",
  gw: false,
  hc: "BN",
  ln: "Tutong",
  lc: "ttg",
  ld: "ltr",
  alt: ["Tutung"],
  cc: ["BN"]
}, {
  pk: 6355,
  ang: "Ta\u2019oih, Upper",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Upper Ta'oih",
  lc: "tth",
  ld: "ltr",
  alt: ["Kantua", "Ta Hoi", "Ta-Oi", "Ta-Oy", "Tau Oi", "T\xE0-Oi", "Toi-Oi", "T-Oy", "Ha'aang (Sa'ang)"],
  cc: ["LA"]
}, {
  pk: 6356,
  ang: "Tobati",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tobati",
  lc: "tti",
  ld: "ltr",
  alt: ["Enggros", "Humboldt Jotafa", "Jayapura", "Jotafa", "Tobwadic", "Yautefa", "Yotafa"],
  cc: ["ID"]
}, {
  pk: 6357,
  ang: "Tooro",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Tooro",
  lc: "ttj",
  ld: "ltr",
  alt: ["Orutoro", "Rutooro", "Toro", "Rutuku"],
  cc: ["UG"]
}, {
  pk: 6358,
  ang: "Totoro",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Totoro",
  lc: "ttk",
  ld: "ltr",
  alt: [],
  cc: ["CO"]
}, {
  pk: 6359,
  ang: "Totela",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Totela",
  lc: "ttl",
  ld: "ltr",
  alt: ["Echitotela"],
  cc: ["ZM"]
}, {
  pk: 6360,
  ang: "Tutchone, Northern",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Northern Tutchone",
  lc: "ttm",
  ld: "ltr",
  alt: ["Selkirk"],
  cc: ["CA"]
}, {
  pk: 6361,
  ang: "Towei",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Towei",
  lc: "ttn",
  ld: "ltr",
  alt: ["Towe"],
  cc: ["ID"]
}, {
  pk: 6362,
  ang: "Ta\u2019oih, Lower",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Lower Ta'oih",
  lc: "tto",
  ld: "ltr",
  alt: [],
  cc: ["LA"]
}, {
  pk: 6363,
  ang: "Tombelala",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tombelala",
  lc: "ttp",
  ld: "ltr",
  alt: ["Baria", "Belala", "Mbelala"],
  cc: ["ID"]
}, {
  pk: 6364,
  ang: "Tamajaq, Tawallammat",
  lr: "Africa",
  gw: false,
  hc: "NE",
  ln: "Tawallammat Tamajaq",
  lc: "ttq",
  ld: "ltr",
  alt: ["Tahoua", "Tajag", "Tamajeq", "Tamashekin", "Tamasheq", "Tomacheck", "Tourage", "Tuareg", "Amazigh", "Tahoua Tamajeq", "Tamachek", "Tewellemet", "Touareg", "Azbinawa", "Buzu", "Tawallammat Tan Dannag (Ioullemmeden)", "Tawallammet Tan Dannag (Ioullemmeden)", "Ioullemmeden"],
  cc: ["ML", "NE", "NG"]
}, {
  pk: 8113,
  ang: "Tawellemet",
  lr: "Africa",
  gw: false,
  hc: "NE",
  ln: "Tawellemmet",
  lc: "ttq-x-ttwestniger",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6365,
  ang: "Tera",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Tera",
  lc: "ttr",
  ld: "ltr",
  alt: ["Nyemathi", "Yamaltu", "Pidlimdi (Ghena)", "Nyimatali", "Hinna", "Hina", "Ghuna", "Nyimatli (Nimalto)"],
  cc: ["NG"]
}, {
  pk: 6366,
  ang: "Thai, Northeastern",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Northeastern Thai",
  lc: "tts",
  ld: "ltr",
  alt: ["Isaan", "Isan", "Issan", "Thai Isaan", "Central Isan (Kalerng)", "Kaleung", "Kaloeng"],
  cc: ["LA", "TH"]
}, {
  pk: 6367,
  ang: "Tat, Muslim",
  lr: "Asia",
  gw: false,
  hc: "AZ",
  ln: "Tat dili",
  lc: "ttt",
  ld: "ltr",
  alt: ["Muslim Tat", "Mussulman Tati", "Tati", "Aruskush-Daqqushchu (Khyzy)", "Northern Tats"],
  cc: ["AZ", "IR"]
}, {
  pk: 1,
  ang: "Ismaili",
  lr: "Asia",
  gw: false,
  hc: "AZ",
  ln: "Ismaili",
  lc: "ttt-x-ismai",
  ld: "ltr",
  alt: [],
  cc: ["AZ"]
}, {
  pk: 3,
  ang: "Chichi",
  lr: "Asia",
  gw: false,
  hc: "AZ",
  ln: "Xizi",
  lc: "ttt-x-txizi",
  ld: "ltr",
  alt: [],
  cc: ["AZ"]
}, {
  pk: 6368,
  ang: "Torau",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Torau",
  lc: "ttu",
  ld: "ltr",
  alt: ["Rorovana"],
  cc: ["PG"]
}, {
  pk: 6369,
  ang: "Titan",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Titan",
  lc: "ttv",
  ld: "ltr",
  alt: ["Manus", "M'bunai", "Moanus", "Tito"],
  cc: ["PG"]
}, {
  pk: 6370,
  ang: "Long Wat",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Long Wat",
  lc: "ttw",
  ld: "ltr",
  alt: ["Tutoh Kenya", "Tutoh Kenyah"],
  cc: ["MY"]
}, {
  pk: 6371,
  ang: "Sikaritai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sikaritai",
  lc: "tty",
  ld: "ltr",
  alt: ["Aikwakai", "Araikurioko", "Ati", "Sikari", "Tori", "Tori Aikwakai"],
  cc: ["ID"]
}, {
  pk: 6372,
  ang: "Tsum",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Tsum",
  lc: "ttz",
  ld: "ltr",
  alt: ["Tsumge"],
  cc: ["NP"]
}, {
  pk: 6373,
  ang: "Wiarumus",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wiarumus",
  lc: "tua",
  ld: "ltr",
  alt: ["Imandi"],
  cc: ["PG"]
}, {
  pk: 6374,
  ang: "T\xFCbatulabal",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "T\xFCbatulabal",
  lc: "tub",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 6375,
  ang: "Mutu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mutu",
  lc: "tuc",
  ld: "ltr",
  alt: ["Saveeng", "Sisi", "Tuam-Mutu", "Tuom", "Oov/Mutu"],
  cc: ["PG"]
}, {
  pk: 6376,
  ang: "Tux\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Tux\xE1",
  lc: "tud",
  ld: "ltr",
  alt: ["Todela", "Tusha"],
  cc: ["BR"]
}, {
  pk: 6377,
  ang: "Tuyuca",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Tuyuca",
  lc: "tue",
  ld: "ltr",
  alt: ["Dochkafuara", "Doka-Poara", "Doxk\xE1-Po\xE1r\xE1", "Tuiuca", "Tuyuka", "Tejuca"],
  cc: ["BR", "CO"]
}, {
  pk: 6378,
  ang: "Tunebo, Central",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Central Tunebo",
  lc: "tuf",
  ld: "ltr",
  alt: ["Cobar\xEDa Tunebo", "Lache", "U'wa", "Uwa-Tunebo"],
  cc: ["CO"]
}, {
  pk: 6379,
  ang: "Tunia",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Tunia",
  lc: "tug",
  ld: "ltr",
  alt: ["Tun"],
  cc: ["CF", "TD"]
}, {
  pk: 6380,
  ang: "Taulil",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Taulil",
  lc: "tuh",
  ld: "ltr",
  alt: ["Tulil"],
  cc: ["PG"]
}, {
  pk: 6381,
  ang: "Tupuri",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Tupuri",
  lc: "tui",
  ld: "ltr",
  alt: ["Dema", "Honya", "Ndoore", "Ndore", "Tongoyna", "Toubouri", "Tuburi", "Wina"],
  cc: ["CM", "TD"]
}, {
  pk: 6382,
  ang: "Tugutil",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tugutil",
  lc: "tuj",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 7658,
  ang: "Levantine Turkmen",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Levantine Turkmen",
  lc: "tuk-x-levantin",
  ld: "rtl",
  alt: [],
  cc: []
}, {
  pk: 6383,
  ang: "Tula",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Tula",
  lc: "tul",
  ld: "ltr",
  alt: ["Kotule"],
  cc: ["NG"]
}, {
  pk: 6384,
  ang: "Tumbuka",
  lr: "Africa",
  gw: false,
  hc: "MW",
  ln: "Tumbuka",
  lc: "tum",
  ld: "ltr",
  alt: ["Tamboka", "Tambuka", "Timbuka", "Tombucas", "Tumboka", "Tew", "Hewe (Hewa)", "Poka (Chipoka)", "Kamanga", "Chipoka", "Chikamanga (Henga)", "Ngoni (Magodi)", "Fililwa (Filirwa)"],
  cc: ["TZ", "ZM", "ZW", "MW"]
}, {
  pk: 6385,
  ang: "Tunica",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Tunica",
  lc: "tun",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 6386,
  ang: "Tucano",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Tucano",
  lc: "tuo",
  ld: "ltr",
  alt: ["Daxsea", "Takuna", "Tuk\xE1na", "Tukano", "Betaya", "Betoya", "Dachsea", "Dasea", "Tukana", "Pisatapuyo", "Yohoraa (Curaua)", "Pisa-tapuyo", "Pisamira", "Papiwa", "Papihua", "Wasona (Uasona)"],
  cc: ["BR", "CO"]
}, {
  pk: 6387,
  ang: "Tedaga",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Tedaga",
  lc: "tuq",
  ld: "ltr",
  alt: ["Tebu", "Tibbu", "Toubou", "Tebou", "Toda", "Todaga", "Todga", "Tuda", "Tudaga"],
  cc: ["SD", "TD", "LY"]
}, {
  pk: 6388,
  ang: "Tuscarora",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Tuscarora",
  lc: "tus",
  ld: "ltr",
  alt: ["Skarohreh"],
  cc: ["CA"]
}, {
  pk: 6389,
  ang: "Turkana",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Turkana",
  lc: "tuv",
  ld: "ltr",
  alt: ["Buma", "Bume", "Turkwana"],
  cc: ["KE", "SS"]
}, {
  pk: 6390,
  ang: "Tugen",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Tugen",
  lc: "tuy",
  ld: "ltr",
  alt: [],
  cc: ["KE"]
}, {
  pk: 6391,
  ang: "Turka",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Turka",
  lc: "tuz",
  ld: "ltr",
  alt: ["Curama", "Cuuram\xE3", "Tchourama", "Tourka", "Turuka", "Tyurama"],
  cc: ["BF"]
}, {
  pk: 6392,
  ang: "Vaghua",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Vaghua",
  lc: "tva",
  ld: "ltr",
  alt: ["Tavola", "Tavula", "Vagua"],
  cc: ["SB"]
}, {
  pk: 6393,
  ang: "Tsuvadi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Tsuvadi",
  lc: "tvd",
  ld: "ltr",
  alt: ["Abadi", "Avadi", "Evadi", "Ibeto", "Kamberi", "Tsuvadi-Agadi", "Tsuvadi-Azozolo"],
  cc: ["NG"]
}, {
  pk: 6394,
  ang: "Ambrym, Southeast",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Southeast Ambrym",
  lc: "tvk",
  ld: "ltr",
  alt: ["Taveak (Taviak)"],
  cc: ["VU"]
}, {
  pk: 6395,
  ang: "Tuvaluan",
  lr: "Pacific",
  gw: false,
  hc: "TV",
  ln: "Tuvalu",
  lc: "tvl",
  ld: "ltr",
  alt: ["Ellice", "Ellicean", "North Tuvaluan (Nanumanga)", "South Tuvaluan (Funafuti)", "Vaitupu", "Niutao", "Nanumea", "Nukulaelae", "Nukufetau"],
  cc: ["FJ", "KI", "NZ", "TV", "NR"]
}, {
  pk: 6396,
  ang: "Tela-Masbuar",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tela-Masbuar",
  lc: "tvm",
  ld: "ltr",
  alt: ["Masbuar-Tela", "Tela'a"],
  cc: ["ID"]
}, {
  pk: 6397,
  ang: "Tavoyan",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Tavoyan",
  lc: "tvn",
  ld: "ltr",
  alt: ["Dawai", "Dawe", "Tavoya", "Tawe-Tavoy"],
  cc: ["MM"]
}, {
  pk: 6398,
  ang: "Tidore",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tidore",
  lc: "tvo",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 6399,
  ang: "Taveta",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Taveta",
  lc: "tvs",
  ld: "ltr",
  alt: ["Kitaveta", "Kitubeta", "Tubeta"],
  cc: ["KE", "TZ"]
}, {
  pk: 6400,
  ang: "Naga, Tutsa",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Tutsa Naga",
  lc: "tvt",
  ld: "ltr",
  alt: ["Totcha"],
  cc: ["IN"]
}, {
  pk: 6401,
  ang: "Tunen",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Tunen",
  lc: "tvu",
  ld: "ltr",
  alt: ["Banen", "Banend", "Nen", "Penin", "Penyin", "Alinga (Eling)", "Ndogbang", "Ndokbiakat", "Niguessen (Mese)", "Paningesen", "Sese", "Toboany (Itundu)", "Tufombo (Logananga)", "Tuling"],
  cc: ["CM"]
}, {
  pk: 6402,
  ang: "Sedoa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sedoa",
  lc: "tvw",
  ld: "ltr",
  alt: ["Baria", "Tawaelia", "Tawailia", "Topobaria"],
  cc: ["ID"]
}, {
  pk: 6403,
  ang: "Twi",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Twi",
  lc: "tw",
  ld: "ltr",
  alt: [],
  cc: ["GH", "LR", "GB", "TG"]
}, {
  pk: 6404,
  ang: "Twana",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Twana",
  lc: "twa",
  ld: "ltr",
  alt: ["Skokomish", "Quilcene"],
  cc: ["US"]
}, {
  pk: 6405,
  ang: "Tawbuid, Western",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Western Tawbuid",
  lc: "twb",
  ld: "ltr",
  alt: ["Batangan Taubuid", "Fanawbuid", "Western Taubuid"],
  cc: ["PH"]
}, {
  pk: 6406,
  ang: "Teshenawa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Teshenawa",
  lc: "twc",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 6407,
  ang: "Twents",
  lr: "Europe",
  gw: false,
  hc: "NL",
  ln: "Twents",
  lc: "twd",
  ld: "ltr",
  alt: ["Twente"],
  cc: ["NL"]
}, {
  pk: 6408,
  ang: "Teiwa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tewa (Indonesia)",
  lc: "twe",
  ld: "ltr",
  alt: ["Tewa", "Lebang"],
  cc: ["ID"]
}, {
  pk: 7967,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Lebang",
  lc: "twe-x-lebang",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6409,
  ang: "Tiwa, Northern",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Northern Tiwa",
  lc: "twf",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 6410,
  ang: "Tereweng",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tereweng",
  lc: "twg",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 6411,
  ang: "Tai D\xF3n",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Tai D\xF3n",
  lc: "twh",
  ld: "ltr",
  alt: ["Bai Dai", "Tai Jinping", "White Tai", "Tai Blanc", "Tai Kao", "Tai Lai", "Th\xE1i Tr\xE1ng", "T\xE1y Khao"],
  cc: ["CN", "LA", "US", "VN"]
}, {
  pk: 6412,
  ang: "Tawara",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Tawara",
  lc: "twl",
  ld: "ltr",
  alt: ["Tawala", "Tawara-Chioco", "Tawara-Daque"],
  cc: ["MZ"]
}, {
  pk: 6413,
  ang: "Monpa, Tawang",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Tawang Monpa",
  lc: "twm",
  ld: "ltr",
  alt: ["Buruomi", "Buruomiba", "Cona Monba", "Cuona Menba", "Cuona Monpa", "Dakpa", "Dwags", "Menba", "Menpa", "Moinba", "Momba", "Mompa", "Monba", "Monpa", "Pramipa", "Takpa", "Tawan Monba", "Brahmi", "Monkit", "Northern Monpa", "Northern Cuona", "Southern Cuona"],
  cc: ["CN", "IN"]
}, {
  pk: 7596,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Memba",
  lc: "twm-x-memba",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7599,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mompa",
  lc: "twm-x-mompa",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6414,
  ang: "Twendi",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Twendi",
  lc: "twn",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 6415,
  ang: "Tswapong",
  lr: "Africa",
  gw: false,
  hc: "BW",
  ln: "Tswapong",
  lc: "two",
  ld: "ltr",
  alt: ["Setswapong"],
  cc: ["BW"]
}, {
  pk: 6416,
  ang: "Ere",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ere",
  lc: "twp",
  ld: "ltr",
  alt: ["Nane"],
  cc: ["PG"]
}, {
  pk: 6417,
  ang: "Tasawaq",
  lr: "Africa",
  gw: false,
  hc: "NE",
  ln: "Tasawaq",
  lc: "twq",
  ld: "ltr",
  alt: ["Ingelshi"],
  cc: ["NE"]
}, {
  pk: 6418,
  ang: "Tarahumara, Southwestern",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Southwestern Tarahumara",
  lc: "twr",
  ld: "ltr",
  alt: ["Tarahumara del Suroeste", "Tubare"],
  cc: ["MX"]
}, {
  pk: 6419,
  ang: "Turiw\xE1ra",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Turiw\xE1ra",
  lc: "twt",
  ld: "ltr",
  alt: ["Turiuara"],
  cc: ["BR"]
}, {
  pk: 6420,
  ang: "Termanu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Termanu",
  lc: "twu",
  ld: "ltr",
  alt: ["Central Rote", "Pa'da", "Rote", "Rote Tengah", "Roti", "Rotinese", "Pa'da (Termanu)", "Pa'da Kona (Keka-Talae)", "Korbafo (Korbaffo)", "Bokai", "Southern Termanu"],
  cc: ["ID"]
}, {
  pk: 6421,
  ang: "Tuwari",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tuwari",
  lc: "tww",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6422,
  ang: "Tewe",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Tewe",
  lc: "twx",
  ld: "ltr",
  alt: ["Chiute", "Ciute", "Teve", "Vateve", "Wateve"],
  cc: ["MZ"]
}, {
  pk: 6423,
  ang: "Tawoyan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tawoyan",
  lc: "twy",
  ld: "ltr",
  alt: ["Tabojan", "Tabojan Tongka", "Taboyan", "Tabuyan", "Tawoyan Dayak", "Tewoyan"],
  cc: ["ID"]
}, {
  pk: 6424,
  ang: "Tombonuo",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Tombonuo",
  lc: "txa",
  ld: "ltr",
  alt: ["Lobu", "Paitan", "Sungai", "Sungei", "Tambanua", "Tambanuo", "Tambanuva", "Tambanwas", "Tambenua", "Tambunwas", "Tembenua", "Tombonuva", "Tombonuwo", "Tumbunwha", "Tunbumohas", "Lingkabau Sugut (Linkabau)"],
  cc: ["MY"]
}, {
  pk: 6425,
  ang: "Tokharian B",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Tokharian B",
  lc: "txb",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 6426,
  ang: "Tsetsaut",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Tsetsaut",
  lc: "txc",
  ld: "ltr",
  alt: [],
  cc: ["CA"]
}, {
  pk: 6427,
  ang: "Totoli",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Totoli",
  lc: "txe",
  ld: "ltr",
  alt: ["Gage", "Tontoli"],
  cc: ["ID"]
}, {
  pk: 6428,
  ang: "Tangut",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Tangut",
  lc: "txg",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 6429,
  ang: "Thracian",
  lr: "Europe",
  gw: false,
  hc: "BG",
  ln: "Thracian",
  lc: "txh",
  ld: "ltr",
  alt: [],
  cc: ["BG"]
}, {
  pk: 6430,
  ang: "Ikpeng",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Ikpeng",
  lc: "txi",
  ld: "ltr",
  alt: ["Chicao", "Tonore", "Tunuli", "Txik\xE2n", "Txik\xE3o"],
  cc: ["BR"]
}, {
  pk: 6431,
  ang: "Tarjumo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Tarjumo",
  lc: "txj",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 6432,
  ang: "Tomini",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tomini",
  lc: "txm",
  ld: "ltr",
  alt: ["Mouton", "Moutong", "Tiadje", "Tialo"],
  cc: ["ID"]
}, {
  pk: 6433,
  ang: "Tarangan, West",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "West Tarangan",
  lc: "txn",
  ld: "ltr",
  alt: ["Tarangan Barat", "West Trangan"],
  cc: ["ID"]
}, {
  pk: 6434,
  ang: "Toto",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Toto",
  lc: "txo",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 6435,
  ang: "Tii",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tii",
  lc: "txq",
  ld: "ltr",
  alt: ["Rote", "Rote Barat", "Roti", "Rotinese", "Thie", "Ti", "Western Rote"],
  cc: ["ID"]
}, {
  pk: 6436,
  ang: "Tartessian",
  lr: "Europe",
  gw: false,
  hc: "ES",
  ln: "Tartessian",
  lc: "txr",
  ld: "ltr",
  alt: [],
  cc: ["ES"]
}, {
  pk: 6437,
  ang: "Tonsea",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tonsea",
  lc: "txs",
  ld: "ltr",
  alt: ["Tonsea'"],
  cc: ["ID"]
}, {
  pk: 6438,
  ang: "Citak",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Citak",
  lc: "txt",
  ld: "ltr",
  alt: ["Asmat Darat", "Cicak", "Kaunak", "Tjitak", "Tjitjak"],
  cc: ["ID"]
}, {
  pk: 6439,
  ang: "Kayap\xF3",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Kayap\xF3",
  lc: "txu",
  ld: "ltr",
  alt: ["Kokraimoro", "Xikrin (Diore)", "Xukru"],
  cc: ["BR"]
}, {
  pk: 6440,
  ang: "Tatana",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Tatana",
  lc: "txx",
  ld: "ltr",
  alt: ["Tatana'", "Tatanaq"],
  cc: ["MY"]
}, {
  pk: 6441,
  ang: "Malagasy, Tanosy",
  lr: "Africa",
  gw: false,
  hc: "MG",
  ln: "Tanosy Malagasy",
  lc: "txy",
  ld: "ltr",
  alt: [],
  cc: ["MG"]
}, {
  pk: 6442,
  ang: "Tahitian",
  lr: "Pacific",
  gw: false,
  hc: "PF",
  ln: "Reo Tahiti",
  lc: "ty",
  ld: "ltr",
  alt: [],
  cc: ["NC", "NZ", "US", "PF", "VU"]
}, {
  pk: 6443,
  ang: "Tauya",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tauya",
  lc: "tya",
  ld: "ltr",
  alt: ["Inafosa"],
  cc: ["PG"]
}, {
  pk: 6444,
  ang: "Kyanga",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Kyanga",
  lc: "tye",
  ld: "ltr",
  alt: ["Cenka", "Tyenga", "Canga", "Changa", "K\xE3", "Kenga", "Kyangawa", "Tienga", "Tyanga"],
  cc: ["BJ", "NG"]
}, {
  pk: 6445,
  ang: "O\u2019du",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "\u01A0 \u0110u",
  lc: "tyh",
  ld: "ltr",
  alt: ["Iduh", "Oedou", "Haat", "Hat", "Tay Hat", "O Du"],
  cc: ["LA", "VN"]
}, {
  pk: 6446,
  ang: "Teke-Tsaayi",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Teke-Tsaayi",
  lc: "tyi",
  ld: "ltr",
  alt: ["Getsaayi", "Tsaya", "Tsaye", "Tsayi"],
  cc: ["CG"]
}, {
  pk: 6447,
  ang: "Tai Do",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Tai Do",
  lc: "tyj",
  ld: "ltr",
  alt: ["Tay Muoi", "Tay Quy Chau", "Tay Yo", "Tay-Jo"],
  cc: ["VN"]
}, {
  pk: 6448,
  ang: "Thu Lao",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Thu Lao",
  lc: "tyl",
  ld: "ltr",
  alt: [],
  cc: ["VN"]
}, {
  pk: 6449,
  ang: "Kombai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kombai",
  lc: "tyn",
  ld: "ltr",
  alt: ["Komboy"],
  cc: ["ID"]
}, {
  pk: 6450,
  ang: "Tai Daeng",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "T\xE1y-M\xF4c-Ch\xE2u",
  lc: "tyr",
  ld: "ltr",
  alt: ["Daeng", "Red Thai", "Tai Deng", "Thai Dang", "Thai Do", "M\xF4c-Ch\xE2u", "Red Tai", "Tai Rouge", "T\xE1y-M\xF4c-Ch\xE2u"],
  cc: ["LA", "VN"]
}, {
  pk: 6451,
  ang: "T\xE0y Sa Pa",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "T\xE0y Sa Pa",
  lc: "tys",
  ld: "ltr",
  alt: ["Tai Sa Pa"],
  cc: ["VN"]
}, {
  pk: 6452,
  ang: "Tay Tac",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "T\xE0y T\u1EA5c",
  lc: "tyt",
  ld: "ltr",
  alt: [],
  cc: ["VN"]
}, {
  pk: 6453,
  ang: "Kua",
  lr: "Africa",
  gw: false,
  hc: "BW",
  ln: "Kua",
  lc: "tyu",
  ld: "ltr",
  alt: ["Basarwa", "Cua", "Masarwa", "Tyhua", "Tyua"],
  cc: ["BW"]
}, {
  pk: 6454,
  ang: "Tuva",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0422\u0443\u0432\u0438\u043D\u0441\u043A\u0438\u0439",
  lc: "tyv",
  ld: "ltr",
  alt: ["Diba", "K\xF6k Mungak", "Tuwa", "Soyod", "Soyon", "Soyot", "Tannu-Tuva", "Tuba", "Tuvan", "Tuva-Uriankhai", "Tuvia", "Tuvinian", "Tuwa-Uriankhai", "Uriankhai", "Uryankhai-Monchak", "Tofa", "Tokha", "Tyva", "Uriankhai-Monchak", "Uryankhai", "Northeastern Tuvin (Todzhin)"],
  cc: ["RU"]
}, {
  pk: 6455,
  ang: "Teke-Tyee",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Teke-Tyee",
  lc: "tyx",
  ld: "ltr",
  alt: ["West Teke"],
  cc: ["CG"]
}, {
  pk: 6456,
  ang: "T\xE0y",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Ti\u1EBFng T\xE0y",
  lc: "tyz",
  ld: "ltr",
  alt: ["Ngan", "Phen", "Tai Tho", "Thu Lao", "T'o", "Th\xF4", "T\xE0y Trung Khanh", "T\xE0y Bao Lac"],
  cc: ["US", "VN"]
}, {
  pk: 6457,
  ang: "Tanzanian Sign Language",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Tanzanian Sign Language",
  lc: "tza",
  ld: "ltr",
  alt: ["Lugha Ya Alama", "Lugha Ya Bubu"],
  cc: ["TZ"]
}, {
  pk: 8072,
  ang: "Chamula Tzotzil",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "tsotzil",
  lc: "tzc",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6458,
  ang: "Tzeltal",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tzeltal",
  lc: "tzh",
  ld: "ltr",
  alt: ["Cancuc", "Chanal", "Highland Tzeltal", "Oxchuc Tzeltal", "Tseltal", "Tzeltal del sur", "Bachajon Tzeltal (Lowland Tzeltal)", "Chanal Cancuc", "Tzeltal de Ocosingo", "Tzeltal del norte", "Tzeltal del occidente", "Tzeltal del oriente", "Amatenango del Valle"],
  cc: ["MX"]
}, {
  pk: 8071,
  ang: "Tzeltal de Oxchuc",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tzeltal de Oxchuc",
  lc: "tzh-x-oxchuctzeltal",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8074,
  ang: "Tzeltal de Tenejapa",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tzeltal de Tenejapa",
  lc: "tzh-x-tenejapa",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6459,
  ang: "Tz\u2019utujil",
  lr: "Americas",
  gw: false,
  hc: "GT",
  ln: "Tz'utujil",
  lc: "tzj",
  ld: "ltr",
  alt: ["Eastern Tzutujil", "Santiago Atitl\xE1n Tzutujil", "Tzutuhil", "Tzutujil Oriental"],
  cc: ["GT"]
}, {
  pk: 6460,
  ang: "",
  lr: "",
  gw: false,
  hc: "",
  ln: "Talossan",
  lc: "tzl",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6461,
  ang: "Tamazight, Central Atlas",
  lr: "Africa",
  gw: false,
  hc: "MA",
  ln: "\u2D5C\u2D30\u2D4E\u2D30\u2D63\u2D49\u2D56\u2D5C",
  lc: "tzm",
  ld: "ltr",
  alt: ["Central Shilha", "Middle Atlas Berber", "Shilha", "Tachelhit"],
  cc: ["DZ", "FR", "MA", "GB", "NL"]
}, {
  pk: 6462,
  ang: "Tugun",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tugun",
  lc: "tzn",
  ld: "ltr",
  alt: ["Mahuan", "Tutunohan", "Tomliapat", "Masapua", "Ilpokil", "Kahailin Ilway"],
  cc: ["ID"]
}, {
  pk: 6463,
  ang: "Tzotzil",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tzotzil",
  lc: "tzo",
  ld: "ltr",
  alt: ["San Bartolom\xE9 Venustiano Carranza Tzotzil", "Tsotsil", "Chenalho Tzotzil (San Miguel Mitontic)", "San Pedro Chenalh\xF3", "Zinacant\xE1n Tzotzil", "San Andr\xE9s Larrainzar Tzotzil", "Huixt\xE1n", "Chamula Tzotzil", "Huixt\xE1n Tzotzil (Angel Albino Corzo)"],
  cc: ["MX"]
}, {
  pk: 8073,
  ang: "Tzotzil de Chalchihuitan",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tzotzil de Chalchihuitan",
  lc: "tzo-x-chalchihuitan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8076,
  ang: "Tzotzil de Chenalho",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tzotzil de Chenalh\xF3",
  lc: "tzo-x-chenalho",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8075,
  ang: "Tzotzil de Huixtan",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tzotzil de Huixtan",
  lc: "tzo-x-huixtan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6464,
  ang: "Tabriak",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tabriak",
  lc: "tzx",
  ld: "ltr",
  alt: ["Karawari"],
  cc: ["PG"]
}, {
  pk: 6465,
  ang: "Uamu\xE9",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Uamu\xE9",
  lc: "uam",
  ld: "ltr",
  alt: ["Aticum", "Atikum", "Huamu\xEA"],
  cc: ["BR"]
}, {
  pk: 6466,
  ang: "Kuan",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Kuan",
  lc: "uan",
  ld: "ltr",
  alt: [],
  cc: ["LA"]
}, {
  pk: 6467,
  ang: "Tairuma",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tairuma",
  lc: "uar",
  ld: "ltr",
  alt: ["Kerema", "Tairuma'a", "Uaripi"],
  cc: ["PG"]
}, {
  pk: 6468,
  ang: "Ubang",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ubang",
  lc: "uba",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 6469,
  ang: "Ubi",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Ubi",
  lc: "ubi",
  ld: "ltr",
  alt: ["Oubi"],
  cc: ["TD"]
}, {
  pk: 6470,
  ang: "Bikol, Buhi\u2019non",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Buhi'non Bikol",
  lc: "ubl",
  ld: "ltr",
  alt: ["Bikol Buhi", "Bo\xEEn?n", "Buhi", "Buhi'non", "Buhi-non"],
  cc: ["PH"]
}, {
  pk: 6471,
  ang: "Ubir",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ubir",
  lc: "ubr",
  ld: "ltr",
  alt: ["Kubiri", "Ubiri"],
  cc: ["PG"]
}, {
  pk: 6472,
  ang: "Umbu-Ungu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Umbu-Ungu",
  lc: "ubu",
  ld: "ltr",
  alt: ["Gawigl", "Gawil", "Imbo-Ungu", "Kakoli", "Kaugel", "Kauil", "Ubu Ugu", "Umbongu", "Umbu Ungu", "Kala (Mendo-Kala)"],
  cc: ["PG"]
}, {
  pk: 6473,
  ang: "Uda",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Uda",
  lc: "uda",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 6474,
  ang: "Udihe",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0423\u0434\u044D\u0433\u0435\u0439\u0441\u043A\u0438\u0439",
  lc: "ude",
  ld: "ltr",
  alt: ["Kiakala", "Tazy", "Ude", "Udegeis", "Udeghe", "Udehe", "Aniuy", "Kur-Urmi", "Samarga"],
  cc: ["RU"]
}, {
  pk: 6475,
  ang: "Muduga",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Muduga",
  lc: "udg",
  ld: "ltr",
  alt: ["Mudugar"],
  cc: ["IN"]
}, {
  pk: 6476,
  ang: "Udi",
  lr: "Asia",
  gw: false,
  hc: "AZ",
  ln: "Udi dili",
  lc: "udi",
  ld: "ltr",
  alt: ["Udin", "Uti", "Nidzh (Nic)", "Nij", "Nizh", "Oghuz (Vartashen)"],
  cc: ["AZ"]
}, {
  pk: 6477,
  ang: "Ujir",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ujir",
  lc: "udj",
  ld: "ltr",
  alt: ["Udjir"],
  cc: ["ID"]
}, {
  pk: 6478,
  ang: "Wuzlam",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Wuzlam",
  lc: "udl",
  ld: "ltr",
  alt: ["Mizlime", "Udlam", "Uldeme", "Uzam", "Uzlam"],
  cc: ["CM"]
}, {
  pk: 6479,
  ang: "Udmurt",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0423\u0434\u043C\u0443\u0440\u0442\u0441\u043A\u0438\u0439",
  lc: "udm",
  ld: "ltr",
  alt: ["Votiak", "Votyak", "North Udmurt (Besermyan)", "South Udmurt (Southwestern Udmurt)"],
  cc: ["KZ", "TJ", "RU", "UZ"]
}, {
  pk: 6480,
  ang: "Uduk",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Uduk",
  lc: "udu",
  ld: "ltr",
  alt: ["Kebeirka", "Korara", "Kumus", "Kwanim Pa", "Othan", "Twampa"],
  cc: ["ET", "SD", "US"]
}, {
  pk: 6481,
  ang: "Kioko",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kioko",
  lc: "ues",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 6482,
  ang: "Ufim",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ufim",
  lc: "ufi",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6483,
  ang: "Uyghur",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u0626\u06C7\u064A\u063A\u06C7\u0631\u0686\u06D5\u200E, \u7EF4\u543E\u5C14\u8BED, \u0423\u0439\u0433\u0443\u0440\u0441\u043A\u0438\u0439 \u044F\u0437\u044B\u043A",
  lc: "ug",
  ld: "ltr",
  alt: ["Uighuir", "Uighur", "Uiguir", "Uigur", "Uygur", "Weiwu'er", "Wiga", "Novouygur", "Hotan (Hetian)", "Kashgar-Yarkand", "Kashgar-Yarkand (Yarkandi)", "Lop (Luobu)", "Taranchi (Kulja)", "Uighor", "Uyghuri", "Wighor"],
  cc: ["CN", "KZ", "PK", "SA", "TR", "US", "KG", "TM", "UZ"]
}, {
  pk: 6484,
  ang: "Ugaritic",
  lr: "Asia",
  gw: false,
  hc: "SY",
  ln: "Ugaritic",
  lc: "uga",
  ld: "ltr",
  alt: [],
  cc: ["SY"]
}, {
  pk: 6485,
  ang: "Ughele",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Ughele",
  lc: "uge",
  ld: "ltr",
  alt: ["Ugele"],
  cc: ["SB"]
}, {
  pk: 6486,
  ang: "Ugandan Sign Language",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Ugandan Sign Language",
  lc: "ugn",
  ld: "ltr",
  alt: ["USL"],
  cc: ["UG"]
}, {
  pk: 8279,
  ang: "Rwandan Sign Language",
  lr: "Africa",
  gw: false,
  hc: "RW",
  ln: "Rwandan Sign Language",
  lc: "ugn-x-rwandansl",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6487,
  ang: "Ugong",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Ugong",
  lc: "ugo",
  ld: "ltr",
  alt: ["Gong", "Lawa", "Ugawng", "Ugong", "Suphanburi"],
  cc: ["TH"]
}, {
  pk: 6488,
  ang: "Uruguayan Sign Language",
  lr: "Americas",
  gw: false,
  hc: "UY",
  ln: "Uruguayan Sign Language",
  lc: "ugy",
  ld: "ltr",
  alt: ["Lengua de Se\xF1as Uruguaya", "LSU"],
  cc: ["UY"]
}, {
  pk: 6489,
  ang: "Uhami",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Uhami",
  lc: "uha",
  ld: "ltr",
  alt: ["Ishua"],
  cc: ["NG"]
}, {
  pk: 6490,
  ang: "Damal",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Damal",
  lc: "uhn",
  ld: "ltr",
  alt: ["Amung Kal", "Amungme", "Amuy", "Enggipiloe", "Hamung", "Oehoendoeni", "Uhunduni", "Amongme"],
  cc: ["ID"]
}, {
  pk: 6491,
  ang: "Uisai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Uisai",
  lc: "uis",
  ld: "ltr",
  alt: ["Reuno", "Iuno", "Kugala", "Kukuinu"],
  cc: ["PG"]
}, {
  pk: 6492,
  ang: "Iyive",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Iyive",
  lc: "uiv",
  ld: "ltr",
  alt: ["Uive", "Yiive", "Asumbo"],
  cc: ["CM"]
}, {
  pk: 6493,
  ang: "Tanjijili",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Tanjijili",
  lc: "uji",
  ld: "ltr",
  alt: ["Jijili", "Koro", "Koro Funtu of Kafin Koro", "Koro Funtu of Minna", "Koro Funtu of Shakoyi", "Ujijili"],
  cc: ["NG"]
}, {
  pk: 6494,
  ang: "Ukrainian",
  lr: "Europe",
  gw: false,
  hc: "UA",
  ln: "\u0443\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430 \u043C\u043E\u0432\u0430",
  lc: "uk",
  ld: "ltr",
  alt: [],
  cc: ["AZ", "BY", "AR", "FR", "DE", "VE", "KZ", "GB", "TJ", "LV", "RO", "PL", "SK", "US", "AU", "CA", "GE", "IT", "KG", "TM", "UZ", "UA"]
}, {
  pk: 6495,
  ang: "Kaburi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kaburi",
  lc: "uka",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 6496,
  ang: "Ukuriguma",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ukuriguma",
  lc: "ukg",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6497,
  ang: "Ukhwejo",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Ukhwejo",
  lc: "ukh",
  ld: "ltr",
  alt: ["Benkonjo", "Kamsili (Ngamsile)"],
  cc: ["CF"]
}, {
  pk: 6498,
  ang: "Ukrainian Sign Language",
  lr: "Europe",
  gw: false,
  hc: "UA",
  ln: "Ukrainian Sign Language",
  lc: "ukl",
  ld: "ltr",
  alt: [],
  cc: ["UA"]
}, {
  pk: 6499,
  ang: "Ukpe-Bayobiri",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ukpe-Bayobiri",
  lc: "ukp",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 6500,
  ang: "Ukwa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ukwa",
  lc: "ukq",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 6501,
  ang: "Kaapor Sign Language",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Urub\xFA-Kaapor Sign Language",
  lc: "uks",
  ld: "ltr",
  alt: ["Urub\xFA Sign Language"],
  cc: ["BR"]
}, {
  pk: 6502,
  ang: "Ukue",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ukue",
  lc: "uku",
  ld: "ltr",
  alt: ["Ekpenmen", "Ekpenmi", "Epinmi", "Ukpe"],
  cc: ["NG"]
}, {
  pk: 6503,
  ang: "Ukwuani-Aboh-Ndoni",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ukwuani-Aboh-Ndoni",
  lc: "ukw",
  ld: "ltr",
  alt: ["Eboh", "Ndoni", "Ukwali", "Ukwani", "Ukwuani (Kwale)", "Abo (Aboh)"],
  cc: ["NG"]
}, {
  pk: 6504,
  ang: "Fungwa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Fungwa",
  lc: "ula",
  ld: "ltr",
  alt: ["Afungwa", "Tufungwa", "Ula", "Ura"],
  cc: ["NG"]
}, {
  pk: 6505,
  ang: "Ulukwumi",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ulukwumi",
  lc: "ulb",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 6506,
  ang: "Ulch",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0423\u043B\u044C\u0447\u0441\u043A\u0438\u0439",
  lc: "ulc",
  ld: "ltr",
  alt: ["Hoche", "Hol-Chih", "Olch", "Olcha", "Olchis", "Ulcha", "Ulchi", "Ulych"],
  cc: ["RU"]
}, {
  pk: 6507,
  ang: "Lule",
  lr: "Americas",
  gw: false,
  hc: "AR",
  ln: "Lule",
  lc: "ule",
  ld: "ltr",
  alt: [],
  cc: ["AR"]
}, {
  pk: 6508,
  ang: "Usku",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Usku",
  lc: "ulf",
  ld: "ltr",
  alt: ["Afra"],
  cc: ["ID"]
}, {
  pk: 6509,
  ang: "Ulithian",
  lr: "Pacific",
  gw: false,
  hc: "FM",
  ln: "Ulithian",
  lc: "uli",
  ld: "ltr",
  alt: [],
  cc: ["US", "FM"]
}, {
  pk: 6510,
  ang: "Meriam",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Meriam",
  lc: "ulk",
  ld: "ltr",
  alt: ["East Torres", "Mer", "Meriam Mir", "Mir", "Miriam", "Miriam-Mir"],
  cc: ["AU", "PG"]
}, {
  pk: 6511,
  ang: "Ullatan",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Ullatan",
  lc: "ull",
  ld: "ltr",
  alt: ["Katan", "Kattalan", "Kochuvelan", "Ulladan"],
  cc: ["IN"]
}, {
  pk: 6512,
  ang: "Ulumanda\u2019",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ulumanda'",
  lc: "ulm",
  ld: "ltr",
  alt: ["Awo-Sumakuyu", "Botteng-Tappalang", "Kado", "Oeloemanda", "Tubbi", "Ulumandak", "Ulunda"],
  cc: ["ID"]
}, {
  pk: 6513,
  ang: "Unserdeutsch",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Unserdeutsch",
  lc: "uln",
  ld: "ltr",
  alt: ["Rabaul Creole German"],
  cc: ["PG"]
}, {
  pk: 6514,
  ang: "Uma\u2019 Lung",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Uma' Lung",
  lc: "ulu",
  ld: "ltr",
  alt: ["Oma Longh"],
  cc: ["ID"]
}, {
  pk: 6515,
  ang: "Ulwa",
  lr: "Americas",
  gw: false,
  hc: "NI",
  ln: "Ulwa",
  lc: "ulw",
  ld: "ltr",
  alt: ["Ul\xFAa", "Woolwa"],
  cc: ["NI"]
}, {
  pk: 6516,
  ang: "Umatilla",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Umatilla",
  lc: "uma",
  ld: "ltr",
  alt: ["Columbia River Sahaptin", "Ichishk\xEDin"],
  cc: ["US"]
}, {
  pk: 6517,
  ang: "Umbundu",
  lr: "Africa",
  gw: false,
  hc: "AO",
  ln: "Umbundu",
  lc: "umb",
  ld: "ltr",
  alt: ["Mbali", "Mbari", "M'bundo", "Mbundu Benguella", "Nano", "Ovimbundu", "South Mbundu", "Umbundo"],
  cc: ["AO"]
}, {
  pk: 6518,
  ang: "",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Marrucinian",
  lc: "umc",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 6519,
  ang: "Ukit",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Ukit",
  lc: "umi",
  ld: "ltr",
  alt: [],
  cc: ["MY"]
}, {
  pk: 6520,
  ang: "Umon",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Umon",
  lc: "umm",
  ld: "ltr",
  alt: ["Amon"],
  cc: ["NG"]
}, {
  pk: 6521,
  ang: "Naga, Makyan",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Makyan Naga",
  lc: "umn",
  ld: "ltr",
  alt: ["Macham Naga", "Makyam", "Pongnyun"],
  cc: ["MM"]
}, {
  pk: 6522,
  ang: "Umot\xEDna",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Umot\xEDna",
  lc: "umo",
  ld: "ltr",
  alt: ["Barbados", "Umutina"],
  cc: ["BR"]
}, {
  pk: 6523,
  ang: "Umpila",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Umpila",
  lc: "ump",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 6524,
  ang: "Pendau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Pendau",
  lc: "ums",
  ld: "ltr",
  alt: ["Ndaoe", "Ndau", "Umalasa"],
  cc: ["ID"]
}, {
  pk: 6525,
  ang: "Munsee",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "Munsee",
  lc: "umu",
  ld: "ltr",
  alt: ["Delaware", "Ontario Delaware"],
  cc: ["CA"]
}, {
  pk: 6526,
  ang: "Watut, North",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "North Watut",
  lc: "una",
  ld: "ltr",
  alt: ["Onank", "Unangg", "Unank", "Watut"],
  cc: ["PG"]
}, {
  pk: 6527,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "GW",
  ln: "Undetermined",
  lc: "und",
  ld: "ltr",
  alt: [],
  cc: ["BS", "BN", "BJ", "BA", "CM", "BR", "BF", "CF", "BB", "CN", "BZ", "BT", "KM", "CY", "DJ", "GQ", "ER", "FJ", "AF", "GF", "GA", "GM", "HT", "ID", "IQ", "LA", "LB", "LR", "MR", "PE", "AL", "MK", "OM", "NG", "RW", "SD", "SY", "ZA", "SN", "YE", "ZM", "CG", "KH", "AO", "GE", "GN", "GW", "KP", "KW", "LS", "WS", "LU", "MW", "MV", "PG", "LC", "SO", "SZ", "VU", "MM", "BH", "BI", "BW", "QA", "SR", "AE"]
}, {
  pk: 6528,
  ang: "Uneme",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Uneme",
  lc: "une",
  ld: "ltr",
  alt: ["Ileme", "Ineme", "Uleme"],
  cc: ["NG"]
}, {
  pk: 6529,
  ang: "Ngarinyin",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Ngarinyin",
  lc: "ung",
  ld: "ltr",
  alt: ["Ungarinjin", "Ungarinyin", "Wuladjangari", "Worla", "Wurla (Ola)", "Wula", "Worlaja", "Wuladja"],
  cc: ["AU"]
}, {
  pk: 6530,
  ang: "Enawen\xE9-Naw\xE9",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Enawen\xE9-Naw\xE9",
  lc: "unk",
  ld: "ltr",
  alt: ["Eneuene-Mare", "Salum\xE3"],
  cc: ["BR"]
}, {
  pk: 6531,
  ang: "Unami",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Unami",
  lc: "unm",
  ld: "ltr",
  alt: ["Delaware", "Lenape", "Lenni-Lenape"],
  cc: ["US"]
}, {
  pk: 6532,
  ang: "Kurnai",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Kurnai",
  lc: "unn",
  ld: "ltr",
  alt: ["Cunni", "Ganai", "Gooni", "Gunna", "Gunnai", "Kunnai"],
  cc: ["AU"]
}, {
  pk: 6533,
  ang: "Mundari",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mundari",
  lc: "unr",
  ld: "ltr",
  alt: ["Colh", "Horo", "Mandari", "Mondari", "Munari", "Santhali", "Satar", "Sadar Bhumij", "Santhai", "Kera'", "Hasada", "Bhumij Thar", "Bhumij (Bhumij Munda)"],
  cc: ["IN"]
}, {
  pk: 6534,
  ang: "Unubahe",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Unubahe",
  lc: "unu",
  ld: "ltr",
  alt: ["Unoba'i"],
  cc: ["PG"]
}, {
  pk: 6535,
  ang: "Munda",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Munda",
  lc: "unx",
  ld: "ltr",
  alt: ["Heriki", "Killi"],
  cc: ["BD", "NP", "US", "IN"]
}, {
  pk: 6536,
  ang: "Kaili, Unde",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Unde Kaili",
  lc: "unz",
  ld: "ltr",
  alt: ["Banava", "Banawa", "Ganti", "Lole"],
  cc: ["ID"]
}, {
  pk: 6537,
  ang: "Umeda",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Umeda",
  lc: "upi",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6538,
  ang: "Uripiv-Wala-Rano-Atchin",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Uripiv-Wala-Rano-Atchin",
  lc: "upv",
  ld: "ltr",
  alt: ["Northeast Malakula", "Atchin (Nale)"],
  cc: ["VU"]
}, {
  pk: 6539,
  ang: "Urdu",
  lr: "Asia",
  gw: true,
  hc: "PK",
  ln: "\u0627\u0631\u062F\u0648",
  lc: "ur",
  ld: "rtl",
  alt: ["Islami", "Undri", "Urudu", "Bihari", "Desia", "Rekhta (Rekhti)", "Mirgan", "Dakkhini", "Dakhini (Dakani)", "Deccan"],
  cc: ["BE", "AF", "FR", "DE", "GY", "IQ", "MU", "ES", "GB", "MY", "OM", "NP", "PK", "SA", "TH", "TR", "US", "CA", "KW", "DK", "IN", "BH", "IE", "QA", "AE"]
}, {
  pk: 6540,
  ang: "Urarina",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Urarina",
  lc: "ura",
  ld: "ltr",
  alt: ["Itucali", "Shimacu", "Simacu"],
  cc: ["PE"]
}, {
  pk: 6541,
  ang: "Kaapor",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Urub\xFA-Kaapor",
  lc: "urb",
  ld: "ltr",
  alt: ["Caapor", "Ka'apor", "Kaaport\xE9", "Urub\xFA-Kaapor", "Urub\xFA"],
  cc: ["BR"]
}, {
  pk: 7510,
  ang: "Urdu Devanagari script",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Urdu Devanagari script",
  lc: "ur-Deva",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 6542,
  ang: "Uru",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Uru",
  lc: "ure",
  ld: "ltr",
  alt: ["Iru-Itu", "Morato", "Muratu"],
  cc: ["BO"]
}, {
  pk: 6543,
  ang: "Urigina",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Urigina",
  lc: "urg",
  ld: "ltr",
  alt: ["Origanau", "Uriginau"],
  cc: ["PG"]
}, {
  pk: 6544,
  ang: "Urhobo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Urhobo",
  lc: "urh",
  ld: "ltr",
  alt: ["Sobo", "Agbon", "Udu", "Ujevwe"],
  cc: ["NG"]
}, {
  pk: 6545,
  ang: "Urim",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Urim",
  lc: "uri",
  ld: "ltr",
  alt: ["Kalp", "Kurom", "Tayon", "Wan", "Kukwo (Kalpm)"],
  cc: ["PG"]
}, {
  pk: 6546,
  ang: "Urak Lawoi\u2019",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Urak Lawoi'",
  lc: "urk",
  ld: "ltr",
  alt: ["Chaw Talay", "Chawnam", "Lawoi", "Lawta", "Orak Lawoi'"],
  cc: ["TH"]
}, {
  pk: 6547,
  ang: "Urali",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Urali",
  lc: "url",
  ld: "ltr",
  alt: ["Oorazhi", "Urli"],
  cc: ["IN"]
}, {
  pk: 6548,
  ang: "Urapmin",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Urapmin",
  lc: "urm",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6549,
  ang: "Uruangnirin",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Uruangnirin",
  lc: "urn",
  ld: "ltr",
  alt: ["Faur", "Tubiruasa"],
  cc: ["ID"]
}, {
  pk: 6550,
  ang: "Ura",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Ura (Papua New Guinea)",
  lc: "uro",
  ld: "ltr",
  alt: ["Auramot", "Uram\xE4t", "Uramit", "Uramot"],
  cc: ["PG"]
}, {
  pk: 6551,
  ang: "Uru-Pa-In",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Uru-Pa-In",
  lc: "urp",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 6552,
  ang: "L\xF6y\xF6p",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Lehalurup",
  lc: "urr",
  ld: "ltr",
  alt: ["Divers Bay"],
  cc: ["VU"]
}, {
  pk: 6553,
  ang: "Urat",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Urat",
  lc: "urt",
  ld: "ltr",
  alt: ["Wasep Yam (South Urat)", "Wusyep Tep (East Urat)", "Wasep Ngau (North Urat)", "Wusyep Yihre (Central Urat)"],
  cc: ["PG"]
}, {
  pk: 6554,
  ang: "Sop",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sop",
  lc: "urw",
  ld: "ltr",
  alt: ["Kari", "Usino"],
  cc: ["PG"]
}, {
  pk: 6555,
  ang: "Urimo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Urimo",
  lc: "urx",
  ld: "ltr",
  alt: ["Yaugiba"],
  cc: ["PG"]
}, {
  pk: 7514,
  ang: "Urdu - Dominant Culture Variant",
  lr: "Asia",
  gw: true,
  hc: "PK",
  ln: "\u0627\u0631\u062F\u0648 - Dominant Culture Variant",
  lc: "ur-x-dcv",
  ld: "rtl",
  alt: [],
  cc: ["PK"]
}, {
  pk: 6556,
  ang: "Orya",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Orya",
  lc: "ury",
  ld: "ltr",
  alt: ["Oria", "Uria", "Warpok", "Warpu", "Barat (West Orya)", "Timur (East Orya)"],
  cc: ["ID"]
}, {
  pk: 6557,
  ang: "Uru-Eu-Wau-Wau",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Uru-Eu-Wau-Wau",
  lc: "urz",
  ld: "ltr",
  alt: ["Eru-Eu-Wau-Wau", "Jupa\xFA", "Kagwahiva", "Uruewawau"],
  cc: ["BR"]
}, {
  pk: 6558,
  ang: "Usarufa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Usarufa",
  lc: "usa",
  ld: "ltr",
  alt: ["Usurufa", "Uturupa"],
  cc: ["PG"]
}, {
  pk: 6559,
  ang: "Ushojo",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u0627\u0634\u0648\u062C\u06CC",
  lc: "ush",
  ld: "ltr",
  alt: ["Ushuji"],
  cc: ["PK"]
}, {
  pk: 6560,
  ang: "Usoi",
  lr: "Asia",
  gw: false,
  hc: "BD",
  ln: "Usui",
  lc: "usi",
  ld: "ltr",
  alt: ["Kau Brung", "Unshoi", "Unsuiy", "Ushoi", "Panji", "Joloi"],
  cc: ["BD"]
}, {
  pk: 6561,
  ang: "Usaghade",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Usaghade",
  lc: "usk",
  ld: "ltr",
  alt: ["Isangele", "Usakade", "Usakedet"],
  cc: ["CM", "NG"]
}, {
  pk: 6562,
  ang: "Uspanteko",
  lr: "Americas",
  gw: false,
  hc: "GT",
  ln: "Uspanteco",
  lc: "usp",
  ld: "ltr",
  alt: [],
  cc: ["GT"]
}, {
  pk: 6563,
  ang: "Uya",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Uya",
  lc: "usu",
  ld: "ltr",
  alt: ["Usu"],
  cc: ["PG"]
}, {
  pk: 6564,
  ang: "Otank",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Otank",
  lc: "uta",
  ld: "ltr",
  alt: ["Itang", "Itank", "Otang", "Otanga", "Utanga", "Utank"],
  cc: ["NG"]
}, {
  pk: 6565,
  ang: "Ute-Southern Paiute",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Ute-Southern Paiute",
  lc: "ute",
  ld: "ltr",
  alt: ["Ute-Chemehuevi"],
  cc: ["US"]
}, {
  pk: 6566,
  ang: "Amba",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Amba (Solomon Islands)",
  lc: "utp",
  ld: "ltr",
  alt: ["Aba", "Nembao", "Utupua"],
  cc: ["SB"]
}, {
  pk: 6567,
  ang: "Etulo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Etulo",
  lc: "utr",
  ld: "ltr",
  alt: ["Eturo", "Turumawa", "Utur"],
  cc: ["NG"]
}, {
  pk: 6568,
  ang: "Utu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Utu",
  lc: "utu",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6569,
  ang: "Urum",
  lr: "Asia",
  gw: false,
  hc: "GE",
  ln: "\u0423\u0440\u0443\u043C\u0441\u043A\u0438\u0439 \u044F\u0437\u044B\u043A",
  lc: "uum",
  ld: "ltr",
  alt: [],
  cc: ["GE"]
}, {
  pk: 6570,
  ang: "Ura",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Ura (Vanuatu)",
  lc: "uur",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 6571,
  ang: "U",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6FEE\u6EE1",
  lc: "uuu",
  ld: "ltr",
  alt: ["A'erwa", "Awa Blang", "P'uman", "Wa", "Wu", "Wu Blang"],
  cc: ["CN"]
}, {
  pk: 6572,
  ang: "Fagauvea",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "West Uvean",
  lc: "uve",
  ld: "ltr",
  alt: ["Faga Uvea", "Faga-Uvea", "West Uvean"],
  cc: ["NC"]
}, {
  pk: 6573,
  ang: "Uri",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Uri",
  lc: "uvh",
  ld: "ltr",
  alt: ["Erap", "Uri Vehees", "Urii"],
  cc: ["PG"]
}, {
  pk: 6574,
  ang: "Lote",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Lote",
  lc: "uvl",
  ld: "ltr",
  alt: ["Uvol"],
  cc: ["PG"]
}, {
  pk: 6575,
  ang: "Kuku-Uwanh",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Kuku-Uwanh",
  lc: "uwa",
  ld: "ltr",
  alt: ["Kugu-Uwanh"],
  cc: ["AU"]
}, {
  pk: 6576,
  ang: "Doko-Uyanga",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Doko-Uyanga",
  lc: "uya",
  ld: "ltr",
  alt: ["Basanga", "Dosanga", "Iko", "Uyanga"],
  cc: ["NG"]
}, {
  pk: 6577,
  ang: "Uzbek",
  lr: "Asia",
  gw: false,
  hc: "UZ",
  ln: "O\u02BBzbek, \u040E\u0437\u0431\u0435\u043A, \u0623\u06C7\u0632\u0628\u06D0\u0643\u200E",
  lc: "uz",
  ld: "ltr",
  alt: [],
  cc: ["UZ"]
}, {
  pk: 6578,
  ang: "Uzbek, Northern",
  lr: "Asia",
  gw: false,
  hc: "UZ",
  ln: "Northern Uzbek",
  lc: "uzn",
  ld: "ltr",
  alt: ["Ouzbek", "Ozbek", "Usbaki", "Usbeki", "\xD6zbek", "Kipchak (Kypchak)", "Samarkand", "Tashkent", "Karluk (Qarlug)", "Andizhan", "Fergana"],
  cc: ["CN", "KZ", "TJ", "CA", "KG", "TM", "UZ"]
}, {
  pk: 6579,
  ang: "Uzbek, Southern",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "\u0627\u0632\u0628\u06D0\u06A9 \u062A\u06CC\u0644\u06CC",
  lc: "uzs",
  ld: "ltr",
  alt: ["Usbeki", "Uzbak", "Uzbeki"],
  cc: ["AZ", "AF", "PK", "TR", "US"]
}, {
  pk: 6580,
  ang: "Vaagri Booli",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Vaagri Booli",
  lc: "vaa",
  ld: "ltr",
  alt: ["Guvvalollu", "Haki Piki", "Hakkipikkaru", "Karikkorava", "Kuruvikkaran", "Marattiyan", "Narakureavar", "Narikkorava", "Rattiyan", "Shikarijanam", "Wagri Vel", "Wogri Boli"],
  cc: ["IN"]
}, {
  pk: 8399,
  ang: "Akki Pikki",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Akki Pikki",
  lc: "vaa-x-akkipikki",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7584,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kona-Akki Pikki",
  lc: "vaa-x-konaakki",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6581,
  ang: "Vale",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Vale",
  lc: "vae",
  ld: "ltr",
  alt: ["Tana (Tane)", "Tele"],
  cc: ["CF", "TD"]
}, {
  pk: 6582,
  ang: "Vafsi",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u06AF\u0648\u06CC\u0634 \u0648\u0641\u0633\u06CC",
  lc: "vaf",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 6583,
  ang: "Vagla",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Vagla",
  lc: "vag",
  ld: "ltr",
  alt: ["Konosarola", "Paxala", "Vagala"],
  cc: ["GH"]
}, {
  pk: 6584,
  ang: "Varhadi-Nagpuri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Varhadi-Nagpuri",
  lc: "vah",
  ld: "ltr",
  alt: ["Berar Marathi", "Berari", "Dhanagari", "Kumbhari", "Madhya Pradesh Marathi", "Kosti (Rangari)", "Kunban (Kohli)", "Mahari (Dhedi)"],
  cc: ["IN"]
}, {
  pk: 6585,
  ang: "Vai",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Vai",
  lc: "vai",
  ld: "ltr",
  alt: ["Gallinas", "Gallines", "Vei", "Vy"],
  cc: ["LR", "SL"]
}, {
  pk: 6586,
  ang: "Northwestern !Kung",
  lr: "Africa",
  gw: false,
  hc: "NA",
  ln: "Sekele",
  lc: "vaj",
  ld: "ltr",
  alt: ["!'O-!Khung"],
  cc: ["NA"]
}, {
  pk: 6587,
  ang: "Vehes",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Vehes",
  lc: "val",
  ld: "ltr",
  alt: ["Buasi", "Vehees"],
  cc: ["PG"]
}, {
  pk: 6588,
  ang: "Vanimo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Vanimo",
  lc: "vam",
  ld: "ltr",
  alt: ["Duso", "Manimo", "Wanimo"],
  cc: ["PG"]
}, {
  pk: 6589,
  ang: "Valman",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Valman",
  lc: "van",
  ld: "ltr",
  alt: ["Koroko"],
  cc: ["PG"]
}, {
  pk: 6590,
  ang: "Vao",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Vao",
  lc: "vao",
  ld: "ltr",
  alt: ["Fooa"],
  cc: ["VU"]
}, {
  pk: 6591,
  ang: "Vaiphei",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Vaiphei",
  lc: "vap",
  ld: "ltr",
  alt: ["Bhaipei", "Vaipei", "Veiphei"],
  cc: ["IN"]
}, {
  pk: 6592,
  ang: "Huarij\xEDo",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Huarijio",
  lc: "var",
  ld: "ltr",
  alt: ["Guarij\xEDo", "Macul\xE1i", "Macur\xE1i", "Macurawe", "Varih\xEDo", "Varij\xEDo", "Vorij\xEDo", "Highland Guarij\xEDo", "Lowland Huarij\xEDo"],
  cc: ["MX"]
}, {
  pk: 6593,
  ang: "Vasavi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Vasavi",
  lc: "vas",
  ld: "ltr",
  alt: ["Adiwasi Bhil", "Ambodia Bhil", "Bhilori", "Dhogri Bhil", "Keski Bhil", "Padwi Bhilori", "Vasava", "Vasava Bhil", "Vasave", "Khatalia", "Kot", "Dogri (Dhogri)", "Ambodi (Ambodia)", "Dehvali (Kolche)"],
  cc: ["IN"]
}, {
  pk: 6594,
  ang: "Vanuma",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Vanuma",
  lc: "vau",
  ld: "ltr",
  alt: ["Bambutuku", "Bvanuma", "Livanuma", "Nyali-Tchabi"],
  cc: ["CD"]
}, {
  pk: 6595,
  ang: "Varli",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Varli",
  lc: "vav",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 6596,
  ang: "Vayu",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u0935\u093E\u092F\u0941",
  lc: "vay",
  ld: "ltr",
  alt: ["Bayu", "Vayu", "Wayo", "Marin Khola", "Sindhuli"],
  cc: ["NP"]
}, {
  pk: 6597,
  ang: "Babar, Southeast",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Southeast Babar",
  lc: "vbb",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 6598,
  ang: "Bontok, Southwestern",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Southwestern Bontok",
  lc: "vbk",
  ld: "ltr",
  alt: ["Bontoc"],
  cc: ["PH"]
}, {
  pk: 6599,
  ang: "Venda",
  lr: "Africa",
  gw: false,
  hc: "ZA",
  ln: "Tshiven\u1E13a",
  lc: "ve",
  ld: "ltr",
  alt: ["Chivenda", "Cevenda", "Tshivenda", "Ilafuri", "Mbedzi", "Lembetu", "Guvhu", "Manda"],
  cc: ["ZA", "ZW"]
}, {
  pk: 6600,
  ang: "Venetian",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Venetian",
  lc: "vec",
  ld: "ltr",
  alt: ["Taliano", "Veneto", "V\xE8neto", "Talian", "Venet", "Chipile\xF1o"],
  cc: ["IT"]
}, {
  pk: 6601,
  ang: "Veddah",
  lr: "Asia",
  gw: false,
  hc: "LK",
  ln: "Veddah",
  lc: "ved",
  ld: "ltr",
  alt: ["Beda", "Bedda", "Vaedda", "Veda", "Veddha", "Weda", "Weddo"],
  cc: ["LK"]
}, {
  pk: 6602,
  ang: "Veluws",
  lr: "Europe",
  gw: false,
  hc: "NL",
  ln: "Veluws",
  lc: "vel",
  ld: "ltr",
  alt: ["Veluwe"],
  cc: ["NL"]
}, {
  pk: 6603,
  ang: "Vemgo-Mabas",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Vemgo-Mabas",
  lc: "vem",
  ld: "ltr",
  alt: ["Visik (Vizik)"],
  cc: ["CM", "NG"]
}, {
  pk: 6604,
  ang: "Venture\xF1o",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Venture\xF1o",
  lc: "veo",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 6605,
  ang: "Veps",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0412\u0435\u043F\u0441\u0441\u043A\u0438\u0439",
  lc: "vep",
  ld: "ltr",
  alt: ["Vepsian", "Chudy", "Chuhari", "Chukhari", "Prionezh (North Veps)"],
  cc: ["RU"]
}, {
  pk: 6606,
  ang: "Mom Jango",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Mom Jango",
  lc: "ver",
  ld: "ltr",
  alt: ["Kobo", "Verre", "Were", "Momi (Ziri)"],
  cc: ["CM", "NG"]
}, {
  pk: 7866,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Vere",
  lc: "ver-x-vere",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6607,
  ang: "Vaghri",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "Vaghri",
  lc: "vgr",
  ld: "ltr",
  alt: ["Bavri", "Salavta", "Vaghri Koli"],
  cc: ["PK", "IN"]
}, {
  pk: 6608,
  ang: "Flemish Sign Language",
  lr: "Europe",
  gw: false,
  hc: "BE",
  ln: "Vlaamse Gebarentaal",
  lc: "vgt",
  ld: "ltr",
  alt: ["VGT", "Vlaams-Brabant (Flemish Brabant)", "West-Vlaanderen (West Flanders)", "Oost-Vlaanderen (East Flanders)", "Antwerpen (Antwerp)", "Limburg (Limburg)"],
  cc: ["BE"]
}, {
  pk: 6609,
  ang: "Vietnamese",
  lr: "Asia",
  gw: true,
  hc: "VN",
  ln: "Ti\u1EBFng Vi\u1EC7t",
  lc: "vi",
  ld: "ltr",
  alt: ["Annamese", "Ching", "Gin", "Jing", "Kinh", "Viet", "Central Vietnamese (Hue)", "Northern Vietnamese (Hanoi)", "Southern Vietnamese"],
  cc: ["CN", "FR", "DE", "LA", "GB", "CZ", "MY", "NL", "NC", "NZ", "TH", "US", "AU", "KH", "CA", "VU", "UZ", "MQ", "VN"]
}, {
  pk: 6610,
  ang: "Virgin Islands Creole English",
  lr: "Americas",
  gw: false,
  hc: "VI",
  ln: "Virgin Islands Creole English",
  lc: "vic",
  ld: "ltr",
  alt: ["Saba Creole English", "Statia Creole English"],
  cc: ["AI", "DM", "TT", "VC", "KN", "SX", "US", "VI", "CA", "LC", "GP", "VG"]
}, {
  pk: 6611,
  ang: "Vidunda",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Vidunda",
  lc: "vid",
  ld: "ltr",
  alt: ["Chividunda", "Kividunda", "Ndunda"],
  cc: ["TZ"]
}, {
  pk: 6612,
  ang: "Vili",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Vili",
  lc: "vif",
  ld: "ltr",
  alt: ["Civili", "Fiot", "Fiote", "Tshivili", "Tsivili", "Lindji", "Woyo", "Yombe", "Yoombe (Ciyoombe)", "Civili ci Yombe", "Civili ci Waanda", "Civili ci Moongo", "Civili ci Loango", "Kotchi"],
  cc: ["GA", "CG"]
}, {
  pk: 6613,
  ang: "Viemo",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Viemo",
  lc: "vig",
  ld: "ltr",
  alt: ["Vige", "Vigu\xE9", "Vigye"],
  cc: ["BF"]
}, {
  pk: 6614,
  ang: "Vinza",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Vinza",
  lc: "vin",
  ld: "ltr",
  alt: ["Kivinza"],
  cc: ["TZ"]
}, {
  pk: 6615,
  ang: "Vishavan",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Vishavan",
  lc: "vis",
  ld: "ltr",
  alt: ["Malankudi", "Malarkuti"],
  cc: ["IN"]
}, {
  pk: 6616,
  ang: "Viti",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Viti",
  lc: "vit",
  ld: "ltr",
  alt: ["V\xF6t\xF6"],
  cc: ["NG"]
}, {
  pk: 6617,
  ang: "Iduna",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Iduna",
  lc: "viv",
  ld: "ltr",
  alt: ["Vivigana", "Vivigani", "Belebele", "Ufufu", "Waibula"],
  cc: ["PG"]
}, {
  pk: 6618,
  ang: "Ija-Zuba",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ija-Zuba",
  lc: "vki",
  ld: "ltr",
  alt: ["Koro Afiki"],
  cc: ["NG"]
}, {
  pk: 6619,
  ang: "Kujarg\xE9",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Kujarg\xE9",
  lc: "vkj",
  ld: "ltr",
  alt: [],
  cc: ["TD"]
}, {
  pk: 6620,
  ang: "Kaur",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kaur",
  lc: "vkk",
  ld: "ltr",
  alt: ["Bintuhan", "Ka'ur", "Mulak"],
  cc: ["ID"]
}, {
  pk: 6621,
  ang: "Kulisusu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kulisusu",
  lc: "vkl",
  ld: "ltr",
  alt: ["Kalisusu", "Kolensusu", "Kolinsusu"],
  cc: ["ID"]
}, {
  pk: 6622,
  ang: "Kodeoha",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kodeoha",
  lc: "vko",
  ld: "ltr",
  alt: ["Kondea", "Kondeha"],
  cc: ["ID"]
}, {
  pk: 6623,
  ang: "Korlai Creole Portuguese",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Korlai Creole Portuguese",
  lc: "vkp",
  ld: "ltr",
  alt: ["Creole Portuguese"],
  cc: ["IN"]
}, {
  pk: 6624,
  ang: "Malay, Tenggarong Kutai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tenggarong Kutai Malay",
  lc: "vkt",
  ld: "ltr",
  alt: ["Kutai", "Tenggarong", "Tenggarong Kutai"],
  cc: ["ID"]
}, {
  pk: 6625,
  ang: "Kurrama",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Kurrama",
  lc: "vku",
  ld: "ltr",
  alt: ["Gurama", "Karama", "Korama", "Kurama"],
  cc: ["AU"]
}, {
  pk: 6626,
  ang: "Valpei",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Valpei",
  lc: "vlp",
  ld: "ltr",
  alt: ["Valpay", "Valpei-Hukua"],
  cc: ["VU"]
}, {
  pk: 6627,
  ang: "Vlaams",
  lr: "Europe",
  gw: false,
  hc: "BE",
  ln: "Vlaams",
  lc: "vls",
  ld: "ltr",
  alt: ["Vlaemsch", "Frans Vlaams (Vlaemsch)"],
  cc: ["BE", "US", "CA"]
}, {
  pk: 6628,
  ang: "Martuyhunira",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Martuyhunira",
  lc: "vma",
  ld: "ltr",
  alt: ["Martuthunira"],
  cc: ["AU"]
}, {
  pk: 6629,
  ang: "Mixtec, Juxtlahuaca",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Juxtlahuaca Mixtec",
  lc: "vmc",
  ld: "ltr",
  alt: ["Central Juxtlahuaca Mixtec", "Mixteco de Juxtlahuaca"],
  cc: ["MX"]
}, {
  pk: 6630,
  ang: "Koraga, Mudu",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mudu Koraga",
  lc: "vmd",
  ld: "ltr",
  alt: ["Muudu"],
  cc: ["IN"]
}, {
  pk: 6631,
  ang: "Masela, East",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "East Masela",
  lc: "vme",
  ld: "ltr",
  alt: ["East Marsela"],
  cc: ["ID"]
}, {
  pk: 6632,
  ang: "Mainfr\xE4nkisch",
  lr: "Europe",
  gw: false,
  hc: "DE",
  ln: "Mainfr\xE4nkisch",
  lc: "vmf",
  ld: "ltr",
  alt: ["Franconian, Eastern", "Ostfr\xE4nkisch", "Upper Franconian", "Eastern", "Franconian"],
  cc: ["DE"]
}, {
  pk: 6633,
  ang: "Lungalunga",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Lungalunga",
  lc: "vmg",
  ld: "ltr",
  alt: ["Tavue", "Vinitiri"],
  cc: ["PG"]
}, {
  pk: 6634,
  ang: "Maraghei",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Maraghei",
  lc: "vmh",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 6635,
  ang: "Mixtec, Ixtayutla",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Ixtayutla Mixtec",
  lc: "vmj",
  ld: "ltr",
  alt: ["Mixteco de Santiago Ixtayutla", "Northeastern Jamiltepec Mixtec"],
  cc: ["MX"]
}, {
  pk: 6636,
  ang: "Makhuwa-Shirima",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Makhuwa-Shirima",
  lc: "vmk",
  ld: "ltr",
  alt: ["Chirima", "Eshirima", "Makhuwa-Exirima", "Makhuwa-Niassa", "Makhuwa-Xirima", "Shirima", "West Makua"],
  cc: ["MZ"]
}, {
  pk: 6637,
  ang: "Mixtec, Mitlatongo",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Mitlatongo Mixtec",
  lc: "vmm",
  ld: "ltr",
  alt: ["Mixteco de Mitlatongo"],
  cc: ["MX"]
}, {
  pk: 6638,
  ang: "Mazatec, Soyaltepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Soyaltepec Mazatec",
  lc: "vmp",
  ld: "ltr",
  alt: ["Mazateco de San Miguel Soyaltepec", "Mazateco de Temascal", "Mazateco del Noreste"],
  cc: ["MX"]
}, {
  pk: 6639,
  ang: "Mixtec, Soyaltepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Soyaltepec Mixtec",
  lc: "vmq",
  ld: "ltr",
  alt: ["Mixteco de San Bartolo Soyaltepec", "Mixteco del Noreste Bajo"],
  cc: ["MX"]
}, {
  pk: 6640,
  ang: "Marenje",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Marenje",
  lc: "vmr",
  ld: "ltr",
  alt: ["Emarendje", "Marendje"],
  cc: ["MZ"]
}, {
  pk: 6641,
  ang: "Makhuwa",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Makhuwa",
  lc: "vmw",
  ld: "ltr",
  alt: ["Central Makhuwa", "Emakhuwa", "Emakua", "Makhuwa-Makhuwana", "Makhuwwa of Nampula", "Makoane", "Makua", "Maquoua", "Enyara", "Nahara", "Makuana", "Maharra", "Enaharra (Emathipane)", "Emwaja", "Empamela (Nampamela)", "Central Makua (Emakhuwana)", "Makhuwana", "Enlai (Mulai)"],
  cc: ["MZ"]
}, {
  pk: 6642,
  ang: "Mixtec, Tamazola",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tamazola Mixtec",
  lc: "vmx",
  ld: "ltr",
  alt: ["Mixteco de San Juan Tamazola"],
  cc: ["MX"]
}, {
  pk: 6643,
  ang: "Mazatec, Ayautla",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Ayautla Mazatec",
  lc: "vmy",
  ld: "ltr",
  alt: ["Mazateco del Sureste"],
  cc: ["MX"]
}, {
  pk: 6644,
  ang: "Mazatec, Mazatl\xE1n",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Mazatl\xE1n Mazatec",
  lc: "vmz",
  ld: "ltr",
  alt: ["Mazateco de Mazatl\xE1n Villa de Flores", "Mazateco del Suroeste", "San Jer\xF3nimo Tec\xF3atl Mazatec", "Santa Ana Ateixtlahuaca Mazatec", "San Pedro Ocopetatillo Mazatec", "San Lorenzo Cuanecuiltitla Mazatec", "San Francisco Huehuetl\xE1n Mazatec", "San Antonio Eloxochitl\xE1n Mazatec (Mazateco de Eloxochitl\xE1n)", "San Lucas Zoquiapan Mazatec"],
  cc: ["MX"]
}, {
  pk: 6645,
  ang: "Lovono",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Vano",
  lc: "vnk",
  ld: "ltr",
  alt: ["Alavana", "Alavano", "Vanikolo", "Vano"],
  cc: ["SB"]
}, {
  pk: 6646,
  ang: "Neve\u2019ei",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Vinmavis",
  lc: "vnm",
  ld: "ltr",
  alt: ["Banggor", "Lambumbu", "Nefe'ei", "Telag"],
  cc: ["VU"]
}, {
  pk: 6647,
  ang: "Vunapu",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Vunapu",
  lc: "vnp",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 6648,
  ang: "Volap\xFCk",
  lr: "",
  gw: false,
  hc: "",
  ln: "Volap\xFCk",
  lc: "vo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6649,
  ang: "Voro",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Voro",
  lc: "vor",
  ld: "ltr",
  alt: ["Bena", "Buna", "Ebina", "Ebuna", "Woro", "Yungur"],
  cc: ["NG"]
}, {
  pk: 6650,
  ang: "Vod",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0412\u043E\u0434\u0441\u043A\u0438\u0439",
  lc: "vot",
  ld: "ltr",
  alt: ["Vodian", "Vote", "Votian", "Votic", "Votish"],
  cc: ["RU"]
}, {
  pk: 6651,
  ang: "Vera\u2019a",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Vera'a",
  lc: "vra",
  ld: "ltr",
  alt: ["Vatrata", "Vetrat"],
  cc: ["VU"]
}, {
  pk: 6652,
  ang: "V\xF5ro",
  lr: "Europe",
  gw: false,
  hc: "EE",
  ln: "V\xF5ro",
  lc: "vro",
  ld: "ltr",
  alt: ["V\xF5ro-Seto", "Voru", "V\xF5ru"],
  cc: ["EE"]
}, {
  pk: 6653,
  ang: "Varisi",
  lr: "Pacific",
  gw: false,
  hc: "SB",
  ln: "Varisi",
  lc: "vrs",
  ld: "ltr",
  alt: ["Varese"],
  cc: ["SB"]
}, {
  pk: 6654,
  ang: "Banam Bay",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Burmbar",
  lc: "vrt",
  ld: "ltr",
  alt: ["Banan Bay", "Vartavo"],
  cc: ["VU"]
}, {
  pk: 6655,
  ang: "Moldova Sign Language",
  lr: "Europe",
  gw: false,
  hc: "MD",
  ln: "Moldova Sign Language",
  lc: "vsi",
  ld: "ltr",
  alt: [],
  cc: ["MD"]
}, {
  pk: 6656,
  ang: "Venezuelan Sign Language",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "Venezuelan Sign Language",
  lc: "vsl",
  ld: "ltr",
  alt: ["Lengua de Se\xF1as Venezolana"],
  cc: ["VE"]
}, {
  pk: 6657,
  ang: "Valencian Sign Language",
  lr: "Europe",
  gw: false,
  hc: "ES",
  ln: "Valencian Sign Language",
  lc: "vsv",
  ld: "ltr",
  alt: [],
  cc: ["ES"]
}, {
  pk: 6658,
  ang: "Vitou",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Vitou",
  lc: "vto",
  ld: "ltr",
  alt: ["Takar"],
  cc: ["ID"]
}, {
  pk: 6659,
  ang: "Vumbu",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Vumbu",
  lc: "vum",
  ld: "ltr",
  alt: ["Yivoumbou"],
  cc: ["GA"]
}, {
  pk: 6660,
  ang: "Vunjo",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Vunjo",
  lc: "vun",
  ld: "ltr",
  alt: ["Kivunjo", "Kiwunjo", "Wunjo", "Lema (Kilema)", "Marangu"],
  cc: ["TZ"]
}, {
  pk: 6661,
  ang: "Vute",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Vute",
  lc: "vut",
  ld: "ltr",
  alt: ["Abotee", "Abwetee", "Baboute", "Bamboute", "Boute", "Bubure", "Bule", "Bute", "Foute", "Luvure", "Nbule", "Pute", "Voute", "Voutere", "Woute", "Wute", "Babute", "Buti", "Fute", "Mbute", "Mbutere", "Mfuti", "Vutere", "Wetere", "Nudoo (Vute de Yangba)", "Nujum (Vute de Linte)", "Vute Mbanjo (Vute de Mbandjok)", "Nugane (Vute de Doume)", "Nduvum (Vute de Tibati)", "Bute Bamnyo (Vute de Banyo)", "Ngoro (Vute de Ngorro)", "Kumbere (Vute de Sangbe)"],
  cc: ["CM", "NG"]
}, {
  pk: 6662,
  ang: "Awa",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u963F\u4F64\u65B9\u8A00 (China)",
  lc: "vwa",
  ld: "ltr",
  alt: ["Ava", "Awa Wa", "Va", "Vo'", "Xiyun (Shixi)", "Va'", "Ro via'", "Mangnuo", "La via'", "Awalai", "Dawangnuo (Damangnuo)", "Wangnuo", "Awalei ('A vo' loi)", "Masan ('A Vo')"],
  cc: ["CN"]
}, {
  pk: 6663,
  ang: "Walloon",
  lr: "Europe",
  gw: false,
  hc: "BE",
  ln: "walon",
  lc: "wa",
  ld: "ltr",
  alt: ["Wallon", "Western Walloon", "Southern Walloon", "Central Walloon", "Eastern Walloon"],
  cc: ["BE"]
}, {
  pk: 6664,
  ang: "Walla Walla",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Walla Walla",
  lc: "waa",
  ld: "ltr",
  alt: ["Ichishk\xEDin", "Northeast Sahaptin"],
  cc: ["US"]
}, {
  pk: 6665,
  ang: "Wab",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wab",
  lc: "wab",
  ld: "ltr",
  alt: ["Som"],
  cc: ["PG"]
}, {
  pk: 6666,
  ang: "Wasco-Wishram",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Wasco-Wishram",
  lc: "wac",
  ld: "ltr",
  alt: ["Upper Chinook"],
  cc: ["US"]
}, {
  pk: 6667,
  ang: "Wandamen",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Wandamen",
  lc: "wad",
  ld: "ltr",
  alt: ["Bentoeni", "Bentuni", "Wandamen-Windesi", "Windessi", "Wamesa (Ubu)"],
  cc: ["ID"]
}, {
  pk: 6668,
  ang: "Walser",
  lr: "Europe",
  gw: false,
  hc: "CH",
  ln: "Walser",
  lc: "wae",
  ld: "ltr",
  alt: ["Walscher", "Titsch", "T\xF6itschu"],
  cc: ["CH", "IT"]
}, {
  pk: 6669,
  ang: "Wakon\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Wakon\xE1",
  lc: "waf",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 6670,
  ang: "Wa\u2019ema",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wa'ema",
  lc: "wag",
  ld: "ltr",
  alt: ["Waiema"],
  cc: ["PG"]
}, {
  pk: 6671,
  ang: "Watubela",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Watubela",
  lc: "wah",
  ld: "ltr",
  alt: ["Esiriun", "Kasiui", "Kasui", "Kesui", "Matabello", "Snabi Watubela", "Wesi"],
  cc: ["ID"]
}, {
  pk: 6672,
  ang: "Wares",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Wares",
  lc: "wai",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 6673,
  ang: "Waffa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Waffa",
  lc: "waj",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6674,
  ang: "Wolaytta",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Wolaytta",
  lc: "wal",
  ld: "ltr",
  alt: ["Borodda", "Ometo", "Ualamo", "Uba", "Uollamo", "Wallamo", "Welamo", "Wellamo", "Wolaita", "Wolaitta", "Wolataita", "Wollamo", "Walamo"],
  cc: ["ET"]
}, {
  pk: 6675,
  ang: "Wampanoag",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Wampanoag",
  lc: "wam",
  ld: "ltr",
  alt: ["Massachusett", "Massachusetts", "Natick"],
  cc: ["US"]
}, {
  pk: 6676,
  ang: "Wan",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Wan",
  lc: "wan",
  ld: "ltr",
  alt: ["Nwa"],
  cc: ["CI"]
}, {
  pk: 6677,
  ang: "Wappo",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Wappo",
  lc: "wao",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 6678,
  ang: "Wapishana",
  lr: "Americas",
  gw: false,
  hc: "GY",
  ln: "Wapishana",
  lc: "wap",
  ld: "ltr",
  alt: ["Aruma", "Uapixana", "Vapidiana", "Wapishiana", "Wapisiana", "Wapix\xE1na", "Wapixiana", "Wapixi\xE1na", "Wapichan", "Wapichana", "Wapisana", "Wapishshiana", "Wapitxana", "Wapixana"],
  cc: ["BR", "GY"]
}, {
  pk: 6679,
  ang: "Wageman",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Wageman",
  lc: "waq",
  ld: "ltr",
  alt: ["Wagiman", "Wogeman"],
  cc: ["AU"]
}, {
  pk: 6680,
  ang: "Waray-Waray",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Waray (Philippines)",
  lc: "war",
  ld: "ltr",
  alt: ["Binisaya", "Samaran", "Samare\xF1o", "Waray"],
  cc: ["PH"]
}, {
  pk: 6681,
  ang: "Washo",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Washo",
  lc: "was",
  ld: "ltr",
  alt: ["Washoe"],
  cc: ["US"]
}, {
  pk: 6682,
  ang: "Kaninuwa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kaninuwa",
  lc: "wat",
  ld: "ltr",
  alt: ["Kaokao", "Wataluma"],
  cc: ["PG"]
}, {
  pk: 6683,
  ang: "Waur\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Waur\xE1",
  lc: "wau",
  ld: "ltr",
  alt: ["Aura", "Uaura", "Wauja"],
  cc: ["BR"]
}, {
  pk: 6684,
  ang: "Waka",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Waka",
  lc: "wav",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 6685,
  ang: "Waiwai",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Waiwai",
  lc: "waw",
  ld: "ltr",
  alt: ["Ouayeone", "Uaieue", "Uaiuai", "Parukota", "Katwena", "Tonayana", "Tunayana", "Parukutu", "Parucutu", "Katawina", "Katawian (Katawina)", "Katawian (Cachuena)", "Katuena", "Catawian", "Catauian"],
  cc: ["BR", "GY"]
}, {
  pk: 6686,
  ang: "Marangis",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Watam",
  lc: "wax",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6687,
  ang: "Wayana",
  lr: "Americas",
  gw: false,
  hc: "SR",
  ln: "Wayana",
  lc: "way",
  ld: "ltr",
  alt: ["Alukuyana", "Oayana", "Oiana", "Oyana", "Uaiana", "Upurui", "Way\xE2na", "Guayana", "Roucouyenne", "Wajana", "Rucuyen (Roucouyenne)", "Urucuiana (Urucena)"],
  cc: ["BR", "GF", "SR"]
}, {
  pk: 6688,
  ang: "Wampur",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wampur",
  lc: "waz",
  ld: "ltr",
  alt: ["Wampul"],
  cc: ["PG"]
}, {
  pk: 6689,
  ang: "Warao",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "Warao",
  lc: "wba",
  ld: "ltr",
  alt: ["Guarauno", "Warau", "Warrau"],
  cc: ["VE", "GY"]
}, {
  pk: 6690,
  ang: "Wabo",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Wabo",
  lc: "wbb",
  ld: "ltr",
  alt: ["Nusari", "Woriasi"],
  cc: ["ID"]
}, {
  pk: 6691,
  ang: "Waritai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Waritai",
  lc: "wbe",
  ld: "ltr",
  alt: ["Wari", "Weretai"],
  cc: ["ID"]
}, {
  pk: 6692,
  ang: "Wara",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Wara",
  lc: "wbf",
  ld: "ltr",
  alt: ["Ouala", "Ouara", "Samoe"],
  cc: ["BF"]
}, {
  pk: 6693,
  ang: "Wanda",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Wanda",
  lc: "wbh",
  ld: "ltr",
  alt: ["Ichiwanda", "Iciwanda", "Kiwanda", "Vanda", "Wandia", "Sichela"],
  cc: ["TZ"]
}, {
  pk: 6694,
  ang: "Vwanji",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Vwanji",
  lc: "wbi",
  ld: "ltr",
  alt: ["Kivwanji", "Kiwanji"],
  cc: ["TZ"]
}, {
  pk: 6695,
  ang: "Alagwa",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Alagwa",
  lc: "wbj",
  ld: "ltr",
  alt: ["Alagwaisa", "Alagwase", "Alawa", "Asi", "Chasi", "Hhagiree", "Kialagwa", "Kichase"],
  cc: ["TZ"]
}, {
  pk: 6696,
  ang: "Waigali",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Kala\u1E63a-al\xE2",
  lc: "wbk",
  ld: "ltr",
  alt: ["Suki", "Wai", "Wai-Ala", "Waigala", "Waigalii", "Waigeli", "Zhonjigali"],
  cc: ["AF"]
}, {
  pk: 6697,
  ang: "Wakhi",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Khikwor",
  lc: "wbl",
  ld: "ltr",
  alt: ["Khik", "Khikwar", "Vakhan", "Wakhani", "Wakhigi", "Guhjali"],
  cc: ["CN", "AF", "TJ", "PK"]
}, {
  pk: 6698,
  ang: "Wa, Vo",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4F64\u65B9\u8A00",
  lc: "wbm",
  ld: "ltr",
  alt: ["Awa", "Kawa", "K'awa", "Va", "Wa Proper", "Wa Pwi", "Wakut"],
  cc: ["CN", "MM"]
}, {
  pk: 6699,
  ang: "Warlpiri",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Warlpiri",
  lc: "wbp",
  ld: "ltr",
  alt: ["Elpira", "Ilpara", "Ngaliya", "Ngardilpa", "Wailbri", "Walbiri", "Walmama", "Walpiri"],
  cc: ["AU"]
}, {
  pk: 6700,
  ang: "Waddar",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Waddar",
  lc: "wbq",
  ld: "ltr",
  alt: ["Od", "Orh", "Vadda Beldar", "Werders", "Wodde"],
  cc: ["IN"]
}, {
  pk: 7586,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kusbur Vadar",
  lc: "wbq-x-kusburva",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6701,
  ang: "Wagdi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Wagdi",
  lc: "wbr",
  ld: "ltr",
  alt: ["Bhili", "Bhilodi", "Mina Bhil", "Vagadi", "Vagari", "Vagdi", "Vaged", "Vageri", "Vagi", "Wagari", "Waghari", "Wagholi", "Wagri"],
  cc: ["IN"]
}, {
  pk: 6702,
  ang: "Wanman",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Wanman",
  lc: "wbt",
  ld: "ltr",
  alt: ["Nanidjara", "Nyaani", "Warnman"],
  cc: ["AU"]
}, {
  pk: 6703,
  ang: "Wajarri",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Wajarri",
  lc: "wbv",
  ld: "ltr",
  alt: ["Wadjari", "Wadjeri", "Watjari", "Watjarri"],
  cc: ["AU"]
}, {
  pk: 6704,
  ang: "Woi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Woi",
  lc: "wbw",
  ld: "ltr",
  alt: ["Wo'oi"],
  cc: ["ID"]
}, {
  pk: 8343,
  ang: "Woinap",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Woinap",
  lc: "wbw-x-woinap",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6705,
  ang: "Yanom\xE1mi",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Yanom\xE1mi",
  lc: "wca",
  ld: "ltr",
  alt: ["Parahuri", "Surara", "Waic\xE1", "Waik\xE1", "Xurima", "Yanoam", "Yanomam\xE9", "Waika", "Yanomay (Toototobi)", "Yanomam (Guadema)", "Warema", "Xamatari", "Yoari", "Naomam", "Nanomam (Karime)", "Kohoroxitari", "Joari", "Jauari (Aica)", "Yanamam (Patimitheri)", "Wadema"],
  cc: ["BR"]
}, {
  pk: 6706,
  ang: "Gbe, Waci",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Waci Gbe",
  lc: "wci",
  ld: "ltr",
  alt: ["Waci", "Waci-Gbe", "Watyu", "Wachi", "Watyi"],
  cc: ["BJ", "TG"]
}, {
  pk: 6707,
  ang: "Wandji",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Wandji",
  lc: "wdd",
  ld: "ltr",
  alt: [],
  cc: ["GA"]
}, {
  pk: 6708,
  ang: "Wadaginam",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wadaginam",
  lc: "wdg",
  ld: "ltr",
  alt: ["Wadaginamb"],
  cc: ["PG"]
}, {
  pk: 6709,
  ang: "Wadjiginy",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Wadjiginy",
  lc: "wdj",
  ld: "ltr",
  alt: ["Wagaydy", "Wogaity", "Patjtjamalh", "Pungupungu (Kandjerramal)"],
  cc: ["AU"]
}, {
  pk: 6710,
  ang: "W\xE8 Western",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "W\xE8 Western",
  lc: "wec",
  ld: "ltr",
  alt: ["Gere", "Gu\xE9r\xE9", "Neyo", "Kaoro (Kaawlu)", "Kaowlu", "Nidrou (Nidru)"],
  cc: ["CI"]
}, {
  pk: 6711,
  ang: "Wedau",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wedau",
  lc: "wed",
  ld: "ltr",
  alt: ["Wedaun", "Wedawan"],
  cc: ["PG"]
}, {
  pk: 6712,
  ang: "Wergaia",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Wergaia",
  lc: "weg",
  ld: "ltr",
  alt: ["Wergaya", "Werkaya", "Wimmera", "Worgaia"],
  cc: ["AU"]
}, {
  pk: 6713,
  ang: "Weh",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Weh",
  lc: "weh",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 6714,
  ang: "Kiunum",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kiunum",
  lc: "wei",
  ld: "ltr",
  alt: ["Weredai"],
  cc: ["PG"]
}, {
  pk: 6715,
  ang: "Gbe, Weme",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Weme Gbe",
  lc: "wem",
  ld: "ltr",
  alt: ["Weme"],
  cc: ["BJ"]
}, {
  pk: 6716,
  ang: "Wemale",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Wemale",
  lc: "weo",
  ld: "ltr",
  alt: ["Honitetu", "Tala", "East Wemale", "South Wemale", "West Wemale", "West-Central Wemale"],
  cc: ["ID"]
}, {
  pk: 6717,
  ang: "Westphalien",
  lr: "Europe",
  gw: false,
  hc: "DE",
  ln: "Westphalien",
  lc: "wep",
  ld: "ltr",
  alt: ["Westfaelisch", "Westf\xE4lisch"],
  cc: ["DE"]
}, {
  pk: 6718,
  ang: "Weri",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Weri",
  lc: "wer",
  ld: "ltr",
  alt: ["Wele", "Weli", "Sim"],
  cc: ["PG"]
}, {
  pk: 6719,
  ang: "Pidgin, Cameroon",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Cameroon Pidgin",
  lc: "wes",
  ld: "ltr",
  alt: ["Cameroon Creole English", "Wes Cos"],
  cc: ["CM"]
}, {
  pk: 6720,
  ang: "Perai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Perai",
  lc: "wet",
  ld: "ltr",
  alt: ["Tutunohan", "Uhak", "Moning"],
  cc: ["ID"]
}, {
  pk: 6721,
  ang: "Chin, Rawngtu",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Rawngtu Chin",
  lc: "weu",
  ld: "ltr",
  alt: ["Rongtu", "Shimi", "Shitwanu", "Kyonnam", "Boishi"],
  cc: ["MM"]
}, {
  pk: 7762,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Lawng Tu",
  lc: "weu-x-lawngtu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6722,
  ang: "Wejewa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Wejewa",
  lc: "wew",
  ld: "ltr",
  alt: ["Veveva", "Waidjewa", "Wajewa", "West Sumbanese", "Wewewa", "Wewjewa", "Weyewa", "Lauli (Loli)"],
  cc: ["ID"]
}, {
  pk: 6723,
  ang: "Zorop",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Yafi",
  lc: "wfg",
  ld: "ltr",
  alt: ["Jafi", "Jafi Wagarindem", "Wagarindem", "Wargarindem", "Warlef", "Yaffi"],
  cc: ["ID"]
}, {
  pk: 6724,
  ang: "Wagawaga",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wagawaga",
  lc: "wgb",
  ld: "ltr",
  alt: ["Baeaula", "Beauli", "Ealeba", "Gibara", "Kilikilana"],
  cc: ["PG"]
}, {
  pk: 6725,
  ang: "Wahgi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wahgi",
  lc: "wgi",
  ld: "ltr",
  alt: ["Kup-Minj (Kumai)", "Mid-Wahgi"],
  cc: ["PG"]
}, {
  pk: 6726,
  ang: "Waigeo",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Waigeo",
  lc: "wgo",
  ld: "ltr",
  alt: ["Ambel", "Amberi", "Waigiu", "Metsam", "Metnyo"],
  cc: ["ID"]
}, {
  pk: 6727,
  ang: "Wirangu",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Wirangu",
  lc: "wgu",
  ld: "ltr",
  alt: ["Jilbara", "Naljara", "Ngoleiadjara", "Nhawu", "Njangga", "Nonga", "Nyangga", "Tidni", "Tidnie", "Titnie", "Wanbiri", "Wangon", "Warrangoo", "Willeuroo", "Windakan", "Wirangga", "Wirongu", "Wironguwongga", "Wirrongu", "Wirrung", "Wirrunga", "Yilrea"],
  cc: ["AU"]
}, {
  pk: 6728,
  ang: "Warrgamay",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Warrgamay",
  lc: "wgy",
  ld: "ltr",
  alt: ["Biyay"],
  cc: ["AU"]
}, {
  pk: 6729,
  ang: "Manusela",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Manusela",
  lc: "wha",
  ld: "ltr",
  alt: ["Wahai", "Wahinama"],
  cc: ["ID"]
}, {
  pk: 6730,
  ang: "Wahgi, North",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "North Wahgi",
  lc: "whg",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6731,
  ang: "Kenyah, Wahau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Wahau Kenyah",
  lc: "whk",
  ld: "ltr",
  alt: ["Lebu' Kulit", "Wahau Kenya", "Uma' Ujok"],
  cc: ["ID"]
}, {
  pk: 7837,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kenyah Amak Ti Mei",
  lc: "whk-x-amaktimei",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8062,
  ang: "Long Pulung",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Long Pulung",
  lc: "whk-x-longpulung",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6732,
  ang: "Kayan, Wahau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Wahau Kayan",
  lc: "whu",
  ld: "ltr",
  alt: ["Wahau Kajan"],
  cc: ["ID"]
}, {
  pk: 6733,
  ang: "Toussian, Southern",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Southern Toussian",
  lc: "wib",
  ld: "ltr",
  alt: ["Tusia", "Tusian", "Win"],
  cc: ["BF", "TG"]
}, {
  pk: 6734,
  ang: "Wichita",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Wichita",
  lc: "wic",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 6735,
  ang: "Wik-Ngathana",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Wik-Ngathana",
  lc: "wig",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 6736,
  ang: "Wik-Me\u2019anha",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Wik-Me'anha",
  lc: "wih",
  ld: "ltr",
  alt: ["Wik-Em'an"],
  cc: ["AU"]
}, {
  pk: 6737,
  ang: "Minidien",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Minidien",
  lc: "wii",
  ld: "ltr",
  alt: ["Miniden", "Wiakei"],
  cc: ["PG"]
}, {
  pk: 6738,
  ang: "Wik-Iiyanh",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Wik-Iiyanh",
  lc: "wij",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 6739,
  ang: "Wikalkan",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Wikalkan",
  lc: "wik",
  ld: "ltr",
  alt: ["Wikngatara", "Wik-Ngathara", "Wik-Ngatharra", "Wik-Ngathrr", "Wik-Ngandjara (Ngandjara)"],
  cc: ["AU"]
}, {
  pk: 6740,
  ang: "Wik-Mungkan",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Wik-Mungkan",
  lc: "wim",
  ld: "ltr",
  alt: ["Munkan", "Wik-Mungkhn", "Wik-Munkan"],
  cc: ["AU"]
}, {
  pk: 6741,
  ang: "Ho-Chunk",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Ho-Chunk",
  lc: "win",
  ld: "ltr",
  alt: ["Hoc\xE1k", "Hocak Wazijaci", "Hocank", "Hochank"],
  cc: ["US"]
}, {
  pk: 6742,
  ang: "Wiru",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wiru",
  lc: "wiu",
  ld: "ltr",
  alt: ["Witu"],
  cc: ["PG"]
}, {
  pk: 6743,
  ang: "Vitu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Vitu",
  lc: "wiv",
  ld: "ltr",
  alt: ["Witu"],
  cc: ["PG"]
}, {
  pk: 6744,
  ang: "Wiyot",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Wiyot",
  lc: "wiy",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 6745,
  ang: "Waja",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Waja",
  lc: "wja",
  ld: "ltr",
  alt: ["Nyan Wiyau", "Wiyaa", "Wuya", "Deruwo (Wajan Dutse)", "Waja (Wajan Kasa)"],
  cc: ["NG"]
}, {
  pk: 6746,
  ang: "Warji",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Warji",
  lc: "wji",
  ld: "ltr",
  alt: ["Sar", "Sarawa", "Warja", "Warjawa"],
  cc: ["NG"]
}, {
  pk: 6747,
  ang: "Kumbaran",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kumbaran",
  lc: "wkb",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 6748,
  ang: "Mo",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Wakde",
  lc: "wkd",
  ld: "ltr",
  alt: ["Wakde"],
  cc: ["ID"]
}, {
  pk: 6749,
  ang: "Kalanadi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kalanadi",
  lc: "wkl",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 6750,
  ang: "Kunduvadi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kunduvadi",
  lc: "wku",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 6751,
  ang: "Wakawaka",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Wakawaka",
  lc: "wkw",
  ld: "ltr",
  alt: ["Wagawaga", "Duungidjawu", "Enibura", "Nukunukubara", "Waga", "Waga-Waga", "Wakka"],
  cc: ["AU"]
}, {
  pk: 6752,
  ang: "Walio",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Walio",
  lc: "wla",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6753,
  ang: "Comorian, Mwali",
  lr: "Africa",
  gw: false,
  hc: "KM",
  ln: "Mwali Comorian",
  lc: "wlc",
  ld: "ltr",
  alt: ["Comores Swahili", "Comoro", "Komoro"],
  cc: ["KM"]
}, {
  pk: 6754,
  ang: "Wolane",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Wolane",
  lc: "wle",
  ld: "ltr",
  alt: ["Olane", "Walane", "W\xE4l\xE4ne", "Welene"],
  cc: ["ET"]
}, {
  pk: 6755,
  ang: "Kunbarlang",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Kunbarlang",
  lc: "wlg",
  ld: "ltr",
  alt: ["Gunbalang", "Gunbarlang", "Gungalang", "Walang"],
  cc: ["AU"]
}, {
  pk: 6756,
  ang: "Waioli",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Waioli",
  lc: "wli",
  ld: "ltr",
  alt: ["Wajoli", "Wayoli"],
  cc: ["ID"]
}, {
  pk: 6757,
  ang: "Wali",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Wali (Sudan)",
  lc: "wll",
  ld: "ltr",
  alt: ["Walarishe"],
  cc: ["SD"]
}, {
  pk: 6758,
  ang: "Middle Welsh",
  lr: "Europe",
  gw: false,
  hc: "GB",
  ln: "Middle Welsh",
  lc: "wlm",
  ld: "ltr",
  alt: [],
  cc: ["GB"]
}, {
  pk: 6759,
  ang: "Wolio",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Wolio",
  lc: "wlo",
  ld: "ltr",
  alt: ["Baubau", "Buton", "Butonese", "Butung"],
  cc: ["ID", "MY"]
}, {
  pk: 6760,
  ang: "Wailapa",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Wailapa",
  lc: "wlr",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 6761,
  ang: "Wallisian",
  lr: "Pacific",
  gw: false,
  hc: "WF",
  ln: "Wallisian",
  lc: "wls",
  ld: "ltr",
  alt: ["East Uvean", "Uvean", "Wallisien"],
  cc: ["FJ", "NC", "WF", "VU"]
}, {
  pk: 6762,
  ang: "Wich\xED Lhamt\xE9s Vejoz",
  lr: "Americas",
  gw: false,
  hc: "AR",
  ln: "Wich\xED Lhamt\xE9s Vejoz",
  lc: "wlv",
  ld: "ltr",
  alt: ["Vejos", "Vejoz", "Mataco Vejoz", "Bermejo Vejoz"],
  cc: ["AR"]
}, {
  pk: 6763,
  ang: "Walak",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Walak",
  lc: "wlw",
  ld: "ltr",
  alt: ["Lower Pyramid", "Wodo"],
  cc: ["ID"]
}, {
  pk: 6764,
  ang: "Wali",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Wali (Ghana)",
  lc: "wlx",
  ld: "ltr",
  alt: ["Ala", "Ouala", "Waali", "Wala"],
  cc: ["GH"]
}, {
  pk: 6765,
  ang: "Wambaya",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Wambaya",
  lc: "wmb",
  ld: "ltr",
  alt: ["Umbaia", "Wambaia", "Wambaja", "Wombya", "Wom-By-A", "Yumpia", "Binbinga (Binbinka)"],
  cc: ["AU"]
}, {
  pk: 6766,
  ang: "Wamas",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wamas",
  lc: "wmc",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6767,
  ang: "Mamaind\xE9",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Mamaind\xE9",
  lc: "wmd",
  ld: "ltr",
  alt: ["Negarot\xE9", "Tawende"],
  cc: ["BR"]
}, {
  pk: 6768,
  ang: "Wambule",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u0935\u093E\u092E\u094D\u092C\u0941\u0932\u0947",
  lc: "wme",
  ld: "ltr",
  alt: ["Ambule", "Caurasia", "Chaurasia", "Chaurasya", "Chourase", "Chourasia", "Ombule", "Tsaurasya", "Umbule", "Vambucauras Raduyor", "Vambule", "Hilepane", "Jhappali", "Udaipure", "Wamdyal"],
  cc: ["NP"]
}, {
  pk: 6769,
  ang: "Waima\u2019a",
  lr: "Asia",
  gw: false,
  hc: "TL",
  ln: "Waima'a",
  lc: "wmh",
  ld: "ltr",
  alt: ["Uai Ma'a", "Uaimo'a", "Waimaha", "Waimoa"],
  cc: ["TL"]
}, {
  pk: 6770,
  ang: "Maiwa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Maiwa (Indonesia)",
  lc: "wmm",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 6771,
  ang: "Wom",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wom (Papua New Guinea)",
  lc: "wmo",
  ld: "ltr",
  alt: ["Wam"],
  cc: ["PG"]
}, {
  pk: 6772,
  ang: "Wambon",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Wambon",
  lc: "wms",
  ld: "ltr",
  alt: ["Kenon", "Kenyam"],
  cc: ["ID"]
}, {
  pk: 6773,
  ang: "Walmajarri",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Walmajarri",
  lc: "wmt",
  ld: "ltr",
  alt: ["Pililuna", "Walmajiri", "Walmatjari", "Walmatjiri", "Wolmeri", "Djuwarliny (Juwaliny)", "Tjuwalinj"],
  cc: ["AU"]
}, {
  pk: 6774,
  ang: "Mwani",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Mwani",
  lc: "wmw",
  ld: "ltr",
  alt: ["Kimwani", "Muane", "Mwane", "Quimuane", "Kisanga (Kikisanga)", "Nkojo (Kinkojo)", "Nsimbwa (Kinsimbwa)", "Quissanga", "Wibo (Kiwibo)"],
  cc: ["MZ"]
}, {
  pk: 6775,
  ang: "Womo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Womo",
  lc: "wmx",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6776,
  ang: "Wanambre",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wanambre",
  lc: "wnb",
  ld: "ltr",
  alt: ["Vanambere"],
  cc: ["PG"]
}, {
  pk: 6777,
  ang: "Wantoat",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wantoat",
  lc: "wnc",
  ld: "ltr",
  alt: ["Wapu (Leron)", "Yagawak (Kandomin)"],
  cc: ["PG"]
}, {
  pk: 6778,
  ang: "Waneci",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u0648\u0646\u06CC\u0633\u06CC",
  lc: "wne",
  ld: "ltr",
  alt: ["Chalgari", "Tarino", "Vanechi", "Wanechi", "Wanetsi"],
  cc: ["PK"]
}, {
  pk: 6779,
  ang: "Wanggom",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Wanggom",
  lc: "wng",
  ld: "ltr",
  alt: ["Wanggo", "Wangom"],
  cc: ["ID"]
}, {
  pk: 6780,
  ang: "Comorian, Ndzwani",
  lr: "Africa",
  gw: false,
  hc: "KM",
  ln: "Ndzwani Comorian",
  lc: "wni",
  ld: "ltr",
  alt: ["Shindzwani", "Comores Swahili", "Comoro", "Komoro"],
  cc: ["KM", "YT"]
}, {
  pk: 6781,
  ang: "Wanukaka",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Wanukaka",
  lc: "wnk",
  ld: "ltr",
  alt: ["Wanokaka"],
  cc: ["ID"]
}, {
  pk: 6782,
  ang: "Wano",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Wano",
  lc: "wno",
  ld: "ltr",
  alt: ["Waano", "Central Wano", "East Wano", "West Wano"],
  cc: ["ID"]
}, {
  pk: 6783,
  ang: "Wanap",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wanap",
  lc: "wnp",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6784,
  ang: "Usan",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Usan",
  lc: "wnu",
  ld: "ltr",
  alt: ["Wanuma"],
  cc: ["PG"]
}, {
  pk: 6785,
  ang: "Wintu",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Wintu",
  lc: "wnw",
  ld: "ltr",
  alt: ["Northern Wintun", "Wintun"],
  cc: ["US"]
}, {
  pk: 6786,
  ang: "Wanyi",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Wanyi",
  lc: "wny",
  ld: "ltr",
  alt: ["Waangyee", "Waanyi", "Wainyi", "Wanee", "Wanji", "Wanyee", "Wonyee"],
  cc: ["AU"]
}, {
  pk: 6787,
  ang: "Wolof",
  lr: "Africa",
  gw: false,
  hc: "SN",
  ln: "Wollof",
  lc: "wo",
  ld: "ltr",
  alt: ["Ouolof", "Volof", "Walaf", "Yallof", "Waro-Waro", "Dyolof (Djolof)", "Jolof", "Lebou (Lebu)"],
  cc: ["GA", "ML", "MR", "SN", "US", "CA", "GW", "IT"]
}, {
  pk: 6788,
  ang: "Tyaraity",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Tyaraity",
  lc: "woa",
  ld: "ltr",
  alt: ["Daktjerat", "Djeradj", "Djerag", "Dyeraidy", "Kuwema", "Tjerait"],
  cc: ["AU"]
}, {
  pk: 6789,
  ang: "W\xE8 Northern",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "W\xE8 Northern",
  lc: "wob",
  ld: "ltr",
  alt: ["Ouobe", "W\xE8\xE8", "Wob\xE9", "S\xE9mien (Gb\xE9an)"],
  cc: ["CI"]
}, {
  pk: 6790,
  ang: "Wogeo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wogeo",
  lc: "woc",
  ld: "ltr",
  alt: ["Uageo"],
  cc: ["PG"]
}, {
  pk: 6791,
  ang: "Wolani",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Wolani",
  lc: "wod",
  ld: "ltr",
  alt: ["Woda", "Woda-Mo", "Wodani"],
  cc: ["ID"]
}, {
  pk: 6792,
  ang: "Woleaian",
  lr: "Pacific",
  gw: false,
  hc: "FM",
  ln: "Woleaian",
  lc: "woe",
  ld: "ltr",
  alt: [],
  cc: ["FM"]
}, {
  pk: 6793,
  ang: "Wolof, Gambian",
  lr: "Africa",
  gw: false,
  hc: "GM",
  ln: "Gambian Wolof",
  lc: "wof",
  ld: "ltr",
  alt: [],
  cc: ["GM"]
}, {
  pk: 6794,
  ang: "Wogamusin",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wogamusin",
  lc: "wog",
  ld: "ltr",
  alt: ["Wongamusin"],
  cc: ["PG"]
}, {
  pk: 6795,
  ang: "Kamang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kamang",
  lc: "woi",
  ld: "ltr",
  alt: ["Waisika", "Woisika", "Suboo", "Takailubui", "Manetaa", "Moo", "Tiee"],
  cc: ["ID"]
}, {
  pk: 6796,
  ang: "Longto",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Longto",
  lc: "wok",
  ld: "ltr",
  alt: ["Boko", "Gobeyo", "Longa", "Longbo", "Lonto", "Voko", "Woko"],
  cc: ["CM"]
}, {
  pk: 6797,
  ang: "Wom",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Wom (Nigeria)",
  lc: "wom",
  ld: "ltr",
  alt: ["Pere", "Pereba", "Perema"],
  cc: ["CM", "NG"]
}, {
  pk: 6798,
  ang: "Wongo",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Wongo",
  lc: "won",
  ld: "ltr",
  alt: ["Bakong", "Gongo", "Ndjembe", "Tukkongo", "Tukongo"],
  cc: ["CD"]
}, {
  pk: 7941,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Logondjo",
  lc: "won-x-logondjo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6799,
  ang: "Manombai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Manombai",
  lc: "woo",
  ld: "ltr",
  alt: ["Manobai", "Wamar", "Wokam"],
  cc: ["ID"]
}, {
  pk: 6800,
  ang: "Woria",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Woria",
  lc: "wor",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 6801,
  ang: "Hanga Hundi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Hanga Hundi",
  lc: "wos",
  ld: "ltr",
  alt: ["Kwasengen", "West Wosera"],
  cc: ["PG"]
}, {
  pk: 6802,
  ang: "Wawonii",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Wawonii",
  lc: "wow",
  ld: "ltr",
  alt: ["Wowonii", "Menui (Manoei)"],
  cc: ["ID"]
}, {
  pk: 6803,
  ang: "Weyto",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Weyto",
  lc: "woy",
  ld: "ltr",
  alt: ["Wayto", "Weyt'o"],
  cc: ["ET"]
}, {
  pk: 6804,
  ang: "Maco",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "Maco",
  lc: "wpc",
  ld: "ltr",
  alt: ["Itoto", "Jojod", "Mako", "Wotuja"],
  cc: ["VE"]
}, {
  pk: 6805,
  ang: "Warapu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Warapu",
  lc: "wra",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6806,
  ang: "Warduji",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Warduji",
  lc: "wrd",
  ld: "ltr",
  alt: [],
  cc: ["AF"]
}, {
  pk: 6807,
  ang: "Warungu",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Warungu",
  lc: "wrg",
  ld: "ltr",
  alt: ["Gudjala", "Gugu-Badhun", "Warrungu"],
  cc: ["AU"]
}, {
  pk: 6808,
  ang: "Wiradhuri",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Wiradhuri",
  lc: "wrh",
  ld: "ltr",
  alt: ["Berrembeel", "Warandgeri", "Werogery", "Wiiratheri", "Wira-Athoree", "Wiradhurri", "Wiradjuri", "Wiraduri", "Wiraidyuri", "Wirajeree", "Wirashuri", "Wiratheri", "Wirracharee", "Wirrai'yarrai", "Wordjerg"],
  cc: ["AU"]
}, {
  pk: 6809,
  ang: "Garrwa",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Garrwa",
  lc: "wrk",
  ld: "ltr",
  alt: ["Gaarwa", "Garawa", "Garrawa", "Grawa", "Karawa", "Kariwa", "Karrawar", "Karrwa", "Korrawa", "Kurrawar", "Leearawa", "Leearrawa", "Wollongorang", "Wulungwara"],
  cc: ["AU"]
}, {
  pk: 6810,
  ang: "Warlmanpa",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Warlmanpa",
  lc: "wrl",
  ld: "ltr",
  alt: ["Walmala"],
  cc: ["AU"]
}, {
  pk: 6811,
  ang: "Warumungu",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Warumungu",
  lc: "wrm",
  ld: "ltr",
  alt: ["Warramunga"],
  cc: ["AU"]
}, {
  pk: 6812,
  ang: "Warnang",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Warnang",
  lc: "wrn",
  ld: "ltr",
  alt: ["Werni"],
  cc: ["SD"]
}, {
  pk: 6813,
  ang: "Worrorra",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Worrorra",
  lc: "wro",
  ld: "ltr",
  alt: ["Maialnga", "Ong Komi", "Worora", "Wororra", "Worrara", "Worrora", "Wurara", "Wurora", "Yangibaia"],
  cc: ["AU"]
}, {
  pk: 6814,
  ang: "Waropen",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Waropen",
  lc: "wrp",
  ld: "ltr",
  alt: ["Aropen", "Wonti", "Worpen"],
  cc: ["ID"]
}, {
  pk: 6815,
  ang: "Wardaman",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Wardaman",
  lc: "wrr",
  ld: "ltr",
  alt: ["Waderman", "Waduman", "Warda'man", "Wardman", "Warduman", "Wartaman", "Wordaman"],
  cc: ["AU"]
}, {
  pk: 6816,
  ang: "Waris",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Waris",
  lc: "wrs",
  ld: "ltr",
  alt: ["Walsa"],
  cc: ["ID", "PG"]
}, {
  pk: 6817,
  ang: "Waru",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Waru",
  lc: "wru",
  ld: "ltr",
  alt: ["Mapute", "Mopute"],
  cc: ["ID"]
}, {
  pk: 6818,
  ang: "Waruna",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Waruna",
  lc: "wrv",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6819,
  ang: "Wae Rana",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Wae Rana",
  lc: "wrx",
  ld: "ltr",
  alt: ["Waerana"],
  cc: ["ID"]
}, {
  pk: 6820,
  ang: "Merwari",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Merwari",
  lc: "wry",
  ld: "ltr",
  alt: ["Ajmeri"],
  cc: ["IN"]
}, {
  pk: 6821,
  ang: "Warembori",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Warembori",
  lc: "wsa",
  ld: "ltr",
  alt: ["Waremboivoro", "Warenbori", "Bonoi Buroro"],
  cc: ["ID"]
}, {
  pk: 6822,
  ang: "Wusi",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Wusi",
  lc: "wsi",
  ld: "ltr",
  alt: ["Wusi-Kerepua"],
  cc: ["VU"]
}, {
  pk: 6823,
  ang: "Waskia",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Waskia",
  lc: "wsk",
  ld: "ltr",
  alt: ["Vaskia", "Woskia"],
  cc: ["PG"]
}, {
  pk: 6824,
  ang: "Owenia",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Owenia",
  lc: "wsr",
  ld: "ltr",
  alt: ["Owena", "Owenda", "Waijara", "Waisara"],
  cc: ["PG"]
}, {
  pk: 6825,
  ang: "Wasa",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Wasa",
  lc: "wss",
  ld: "ltr",
  alt: ["Wasaw"],
  cc: ["GH"]
}, {
  pk: 6826,
  ang: "Wasu",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Wasu",
  lc: "wsu",
  ld: "ltr",
  alt: ["Wa\xE7u"],
  cc: ["BR"]
}, {
  pk: 6827,
  ang: "Watiwa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Watiwa",
  lc: "wtf",
  ld: "ltr",
  alt: ["Watifa"],
  cc: ["PG"]
}, {
  pk: 6828,
  ang: "Berta",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Berta",
  lc: "wti",
  ld: "ltr",
  alt: ["Barta", "Beni Shangul", "Bertha", "Burta", "Jebelawi", "Wetawit", "Gwami"],
  cc: ["ET", "SD"]
}, {
  pk: 6829,
  ang: "Watakataui",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Watakataui",
  lc: "wtk",
  ld: "ltr",
  alt: ["Waxe"],
  cc: ["PG"]
}, {
  pk: 6830,
  ang: "Mewati",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mewati",
  lc: "wtm",
  ld: "ltr",
  alt: ["Mewathi"],
  cc: ["IN"]
}, {
  pk: 6831,
  ang: "Wotu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Wotu",
  lc: "wtw",
  ld: "ltr",
  alt: ["Wadu"],
  cc: ["ID"]
}, {
  pk: 6832,
  ang: "Wikngenchera",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Wikngenchera",
  lc: "wua",
  ld: "ltr",
  alt: ["Nantjara", "Ngandjara", "Ngantjeri", "Njinturawik-Nganhcara", "Wik", "Wik-Nantjara"],
  cc: ["AU"]
}, {
  pk: 6833,
  ang: "Wunambal",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Wunambal",
  lc: "wub",
  ld: "ltr",
  alt: ["Jeidji", "Jeithi", "Unambal", "Wumnabal", "Wunambullu", "Yeidji", "Yeithi"],
  cc: ["AU"]
}, {
  pk: 6834,
  ang: "Wudu",
  lr: "Africa",
  gw: false,
  hc: "TG",
  ln: "Wudu",
  lc: "wud",
  ld: "ltr",
  alt: [],
  cc: ["TG"]
}, {
  pk: 6835,
  ang: "Wutunhua",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4E94\u5C6F\u8BDD",
  lc: "wuh",
  ld: "ltr",
  alt: ["Wutong", "Wutun"],
  cc: ["CN"]
}, {
  pk: 6836,
  ang: "Silimo",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Silimo",
  lc: "wul",
  ld: "ltr",
  alt: ["Paiyage", "South Ngalik", "Usak", "Wulik"],
  cc: ["ID"]
}, {
  pk: 6837,
  ang: "Wumbvu",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Wumbvu",
  lc: "wum",
  ld: "ltr",
  alt: ["Aka", "Baaka", "Babinga", "Bambendjele", "Bambenga", "Beka", "Biaka", "Pygmy", "Wumvu"],
  cc: ["GA", "CG"]
}, {
  pk: 6838,
  ang: "Bungu",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Bungu",
  lc: "wun",
  ld: "ltr",
  alt: ["Iciwungu", "Kibungu", "Ungu", "Wungu", "Udinde", "Maleza", "Mwambani"],
  cc: ["TZ"]
}, {
  pk: 6839,
  ang: "Wutung",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wutung",
  lc: "wut",
  ld: "ltr",
  alt: ["Udung"],
  cc: ["PG"]
}, {
  pk: 6840,
  ang: "Chinese, Wu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5433\u8A9E",
  lc: "wuu",
  ld: "ltr",
  alt: ["Jiangnan hua", "Jiangsu-Zhujiang hua", "Jiangzhe hua", "Wu", "Wuyue", "Suzhou", "Youngkang", "Wenzhou", "Wenling", "Tangxi", "Quzhou", "Jinhua (Kinhwa)", "Hangzhou", "Danyang", "Chongming", "Shaoxing", "Zhenhai"],
  cc: ["CN", "JP", "US", "CA"]
}, {
  pk: 6841,
  ang: "Wuvulu-Aua",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Wuvulu-Aua",
  lc: "wuv",
  ld: "ltr",
  alt: ["Aua-Viwulu", "Viwulu-Aua", "Wuvulu (Wuu)"],
  cc: ["PG"]
}, {
  pk: 6842,
  ang: "Wulna",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Wulna",
  lc: "wux",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 6843,
  ang: "Wauyai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Wauyai",
  lc: "wuy",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 6844,
  ang: "Waama",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Waama",
  lc: "wwa",
  ld: "ltr",
  alt: ["Yoabu"],
  cc: ["BJ", "TG"]
}, {
  pk: 6845,
  ang: "Dorig",
  lr: "Pacific",
  gw: false,
  hc: "VU",
  ln: "Wetamut",
  lc: "wwo",
  ld: "ltr",
  alt: [],
  cc: ["VU"]
}, {
  pk: 6846,
  ang: "Wawa",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Wawa",
  lc: "www",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 6847,
  ang: "Waxianghua",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u74E6\u4E61\u8BDD",
  lc: "wxa",
  ld: "ltr",
  alt: ["Wogang", "Xianghua"],
  cc: ["CN"]
}, {
  pk: 6848,
  ang: "Wyandot",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Wyandot",
  lc: "wya",
  ld: "ltr",
  alt: ["Wendat", "Wyandotte", "Wyendat", "Huron"],
  cc: ["US"]
}, {
  pk: 6849,
  ang: "Wangaaybuwan-Ngiyambaa",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Wangaaybuwan-Ngiyambaa",
  lc: "wyb",
  ld: "ltr",
  alt: ["Noongaburrah", "Wayilwan (Waljwan)", "Wonjhibon", "Wonghibon", "Wonghi", "Wongagibun", "Wangaaybuwan (Wombungee)", "Ngjamba", "Narran", "Ngiyambaa (Giamba)", "Ngiumba", "Ngiamba", "Ngeumba", "Wongaibon", "Ngumbarr"],
  cc: ["AU"]
}, {
  pk: 6850,
  ang: "Wymysorys",
  lr: "Europe",
  gw: false,
  hc: "PL",
  ln: "Wymysorys",
  lc: "wym",
  ld: "ltr",
  alt: ["Wilamowicean"],
  cc: ["PL"]
}, {
  pk: 6851,
  ang: "Wayor\xF3",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Wayor\xF3",
  lc: "wyr",
  ld: "ltr",
  alt: ["Ajur\xFA", "Ayur\xFA", "Uaiora", "Wajaru", "Wayur\xFA"],
  cc: ["BR"]
}, {
  pk: 6852,
  ang: "Fijian, Western",
  lr: "Pacific",
  gw: false,
  hc: "FJ",
  ln: "Western Fijian",
  lc: "wyy",
  ld: "ltr",
  alt: ["Fiji", "Nadrogaa", "Noikoro", "Waya (Magodro)", "Nuclear Western Fijian (Baaravi)", "Nakoroboya", "Tubaniwai"],
  cc: ["FJ"]
}, {
  pk: 8276,
  ang: "Rwandan Sign Language",
  lr: "Africa",
  gw: false,
  hc: "RW",
  ln: "Amarenga y'Ikinyarwanda",
  lc: "-x-",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6853,
  ang: "",
  lr: "Europe",
  gw: false,
  hc: "ES",
  ln: "Andalusian Arabic",
  lc: "xaa",
  ld: "ltr",
  alt: [],
  cc: ["ES"]
}, {
  pk: 6854,
  ang: "Sambe",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Sambe",
  lc: "xab",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 6855,
  ang: "Kachari",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kachari",
  lc: "xac",
  ld: "ltr",
  alt: ["Cachari", "Plains Kachari"],
  cc: ["IN"]
}, {
  pk: 6856,
  ang: "Adai",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Adai",
  lc: "xad",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 6857,
  ang: "Aequian",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Aequian",
  lc: "xae",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 6858,
  ang: "Old Udi",
  lr: "Asia",
  gw: false,
  hc: "AZ",
  ln: "Aghwan",
  lc: "xag",
  ld: "ltr",
  alt: [],
  cc: ["AZ"]
}, {
  pk: 6859,
  ang: "Kaimb\xE9",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Kaimb\xE9",
  lc: "xai",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 6860,
  ang: "Kalmyk-Oirat",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041A\u0430\u043B\u043C\u044B\u0446\u043A\u0438\u0439",
  lc: "xal",
  ld: "ltr",
  alt: ["Weilate", "Western Mongol", "Xinjiang Mongolian", "European Oirat", "Kalmack", "Kalmuck", "Kalmuk", "Kalmytskii Jazyk", "Khalli", "Qalmaq", "Volga Oirat", "Western Mongolian", "Olot (Eleuth)", "D\xF6rbet", "Tu'erhute", "Torguut", "Torguud", "Torgut (Torghut)", "Torgut (Torghoud)", "Torghud", "\xD6\xF6ld", "Oirat (Oyrat)", "K\xF6k Nur (Qinghai)", "Khoton (Hoton)", "Khoshut (Khoshuud)", "Elyut", "D\xF6rb\xF6t (Derbet)", "Dorbot", "D\xF6rb\xF6d", "Oirat (Sart Qalmaq)"],
  cc: ["CN", "RU", "US", "KG", "UZ"]
}, {
  pk: 6861,
  ang: "Xamtanga",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Xamtanga",
  lc: "xan",
  ld: "ltr",
  alt: ["Agawinya", "Khamtanga", "Simt'anga", "Xamir", "Xamta"],
  cc: ["ET"]
}, {
  pk: 7929,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "MG",
  ln: "Antambahoaka",
  lc: "-x-antambahoaka",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6862,
  ang: "Khao",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Khao",
  lc: "xao",
  ld: "ltr",
  alt: [],
  cc: ["VN"]
}, {
  pk: 6863,
  ang: "Apalachee",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Apalachee",
  lc: "xap",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 6864,
  ang: "Aquitanian",
  lr: "Europe",
  gw: false,
  hc: "ES",
  ln: "Aquitanian",
  lc: "xaq",
  ld: "ltr",
  alt: [],
  cc: ["ES"]
}, {
  pk: 6865,
  ang: "Katawixi",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Katawixi",
  lc: "xat",
  ld: "ltr",
  alt: ["Catauichi", "Catauixi", "Catawishi", "Catawixi", "Jacare\xFAba"],
  cc: ["BR"]
}, {
  pk: 6866,
  ang: "Kauwera",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kauwera",
  lc: "xau",
  ld: "ltr",
  alt: ["Kabera", "Kaowerawedj", "Kauwerawec", "Kauwerawetj", "Kawera", "Koassa", "Tekutameso"],
  cc: ["ID"]
}, {
  pk: 6867,
  ang: "Xav\xE1nte",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Xav\xE1nte",
  lc: "xav",
  ld: "ltr",
  alt: ["Aku\xEAn", "Akwen", "A'uwe Uptabi", "A'we", "Chavante", "Crisca", "Pusciti", "Shavante", "Tapacua"],
  cc: ["BR"]
}, {
  pk: 6868,
  ang: "Kawaiisu",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Kawaiisu",
  lc: "xaw",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 6869,
  ang: "Kayan Mahakam",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kayan Mahakam",
  lc: "xay",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 6870,
  ang: "Kamba",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Kamba (Brazil)",
  lc: "xba",
  ld: "ltr",
  alt: ["Camba"],
  cc: ["BR"]
}, {
  pk: 6871,
  ang: "Lower Burdekin",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Lower Burdekin",
  lc: "xbb",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 6872,
  ang: "Bactrian",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "Bactrian",
  lc: "xbc",
  ld: "ltr",
  alt: [],
  cc: ["AF"]
}, {
  pk: 6873,
  ang: "Kombio",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kombio",
  lc: "xbi",
  ld: "ltr",
  alt: ["Endangen", "South Kombio (Yanimoi)", "West-Central Kombio (Wampukuamp)", "North Kombio (Mwi)", "East Kombio (Wampurun)"],
  cc: ["PG"]
}, {
  pk: 6874,
  ang: "Middle Breton",
  lr: "Europe",
  gw: false,
  hc: "FR",
  ln: "Middle Breton",
  lc: "xbm",
  ld: "ltr",
  alt: [],
  cc: ["FR"]
}, {
  pk: 6875,
  ang: "Kenaboi",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Kenaboi",
  lc: "xbn",
  ld: "ltr",
  alt: [],
  cc: ["MY"]
}, {
  pk: 6876,
  ang: "Bolgarian",
  lr: "Europe",
  gw: false,
  hc: "BG",
  ln: "Bolgarian",
  lc: "xbo",
  ld: "ltr",
  alt: [],
  cc: ["BG"]
}, {
  pk: 6877,
  ang: "Kambera",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kambera",
  lc: "xbr",
  ld: "ltr",
  alt: ["East Sumba", "East Sumbanese", "Hilu Humba", "Humba", "Oost-Sumbaas", "Sumba", "Sumbanese", "Uma Ratu Nggai (Umbu Ratu Nggai)", "Wai Jilu", "Waidjelu", "Waijelo", "Mangili-Waijelo (Rindi)"],
  cc: ["ID"]
}, {
  pk: 6878,
  ang: "Kambiw\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Kambiw\xE1",
  lc: "xbw",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 6879,
  ang: "Batyala",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Batyala",
  lc: "xby",
  ld: "ltr",
  alt: ["Badjela", "Badtala", "Badtjala", "Badyala", "Batjala", "Bidhala", "Butchulla", "Dulingbara", "Gnoolongbara", "Koolaburra", "Ngulungbara", "Olungbura", "Patyala", "Thoorgine"],
  cc: ["AU"]
}, {
  pk: 6880,
  ang: "Cumbric",
  lr: "Europe",
  gw: false,
  hc: "GB",
  ln: "Cumbric",
  lc: "xcb",
  ld: "ltr",
  alt: [],
  cc: ["GB", "AL"]
}, {
  pk: 6881,
  ang: "Camunic",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Camunic",
  lc: "xcc",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 6882,
  ang: "Celtiberian",
  lr: "Europe",
  gw: false,
  hc: "ES",
  ln: "Celtiberian",
  lc: "xce",
  ld: "ltr",
  alt: [],
  cc: ["ES"]
}, {
  pk: 6883,
  ang: "Cisalpine Gaulish",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Cisalpine Gaulish",
  lc: "xcg",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 6884,
  ang: "Chemakum",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Chemakum",
  lc: "xch",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 6885,
  ang: "Classical Armenian",
  lr: "",
  gw: false,
  hc: "",
  ln: "Classical Armenian",
  lc: "xcl",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6886,
  ang: "Comecrudo",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Comecrudo",
  lc: "xcm",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 6887,
  ang: "Cotoname",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Cotoname",
  lc: "xcn",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 6888,
  ang: "Chorasmian",
  lr: "Asia",
  gw: false,
  hc: "UZ",
  ln: "Chorasmian",
  lc: "xco",
  ld: "ltr",
  alt: [],
  cc: ["UZ"]
}, {
  pk: 6889,
  ang: "Carian",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Carian",
  lc: "xcr",
  ld: "ltr",
  alt: [],
  cc: ["TR"]
}, {
  pk: 6890,
  ang: "Classical Tibetan",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Classical Tibetan",
  lc: "xct",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 6891,
  ang: "Curonian",
  lr: "Europe",
  gw: false,
  hc: "LV",
  ln: "Curonian",
  lc: "xcu",
  ld: "ltr",
  alt: [],
  cc: ["LV"]
}, {
  pk: 6892,
  ang: "Chuvantsy",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "Chuvantsy",
  lc: "xcv",
  ld: "ltr",
  alt: [],
  cc: ["RU"]
}, {
  pk: 6893,
  ang: "Coahuilteco",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Coahuilteco",
  lc: "xcw",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 6894,
  ang: "Cayuse",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Cayuse",
  lc: "xcy",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 6895,
  ang: "Darkinyung",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Darkinyung",
  lc: "xda",
  ld: "ltr",
  alt: ["Darginjang", "Darginyung", "Darkinjang", "Darkinoong", "Darkinung", "Darknung"],
  cc: ["AU"]
}, {
  pk: 6896,
  ang: "Dacian",
  lr: "Europe",
  gw: false,
  hc: "RO",
  ln: "Dacian",
  lc: "xdc",
  ld: "ltr",
  alt: [],
  cc: ["RO"]
}, {
  pk: 6897,
  ang: "Edomite",
  lr: "Asia",
  gw: false,
  hc: "JO",
  ln: "Edomite",
  lc: "xdm",
  ld: "ltr",
  alt: [],
  cc: ["JO"]
}, {
  pk: 6898,
  ang: "Malayic Dayak",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Malayic Dayak",
  lc: "xdy",
  ld: "ltr",
  alt: ["Bumayoh", "Riam (Nibung Terjung)", "Lamandau (Landau Kantu)", "Tom", "Tebidah", "Tamuan", "Sukamara (Kerta Mulya)", "Serawai", "Melahui", "Arut (Sukarame)", "Kayung (Kayong)", "Belantikan (Sungkup)", "Banana'", "Payak"],
  cc: ["ID"]
}, {
  pk: 8207,
  ang: "Dayak Pengancing",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Pengancing",
  lc: "xdy-x-",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8135,
  ang: "Dayak Air Durian",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Air Durian",
  lc: "xdy-x-airdurian",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8146,
  ang: "Dayak Bangae' Moro",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Bangae' Moro",
  lc: "xdy-x-bangaemoro",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8211,
  ang: "Dayak Batang Belian",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Batang Belian",
  lc: "xdy-x-batangbelian",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8337,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Batang Kawa",
  lc: "xdy-x-batangkawa",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8138,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Batu Payung",
  lc: "xdy-x-batupayung",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8304,
  ang: "Belantikan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Belantikan",
  lc: "xdy-x-belantika",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8199,
  ang: "Dayak Belantikan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Belantikan",
  lc: "xdy-x-belantikan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7888,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Benawas",
  lc: "xdy-x-benawas",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8136,
  ang: "Dayak Air Upas",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Air Upas",
  lc: "xdy-x-dayakayrupas",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8157,
  ang: "Dayak Baya",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Baya",
  lc: "xdy-x-dayakbaya",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8027,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Dayak Buket",
  lc: "xdy-x-dayakbuket",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8200,
  ang: "Dayak Delang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Delang",
  lc: "xdy-x-dayakdelang",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8069,
  ang: "Dayak Ensilat",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Ensilat",
  lc: "xdy-x-dayakensilat",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8133,
  ang: "Dayak Kayung",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Kayung",
  lc: "xdy-x-dayakkayung",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8147,
  ang: "Dayak Krio",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Krio",
  lc: "xdy-x-dayakkrio",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8024,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Lau",
  lc: "xdy-x-dayaklau",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8154,
  ang: "Dayak Laur",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Laur",
  lc: "xdy-x-dayaklaur",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8201,
  ang: "Dayak Loksado",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Loksado",
  lc: "xdy-x-dayakloksado",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8134,
  ang: "Dayak Membulu",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Membulu'",
  lc: "xdy-x-dayakmembulu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8197,
  ang: "Dayak Mentobi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Mentobi",
  lc: "xdy-x-dayakmentobi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8132,
  ang: "Dayak Mongko",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Mongko",
  lc: "xdy-x-dayakmongko",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8018,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Pangin",
  lc: "xdy-x-dayakpangin",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8148,
  ang: "Dayak Pawatn",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Pawatn",
  lc: "xdy-x-dayakpawatn",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8029,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Payak",
  lc: "xdy-x-dayakpayak",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8087,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Punti",
  lc: "xdy-x-dayakpunti",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8208,
  ang: "Dayak Punuk",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Punuk",
  lc: "xdy-x-dayakpunuk",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8141,
  ang: "Dayak Riam",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Riam",
  lc: "xdy-x-dayakriam",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8021,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Serawai",
  lc: "xdy-x-dayakserawai",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7948,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Suruk",
  lc: "xdy-x-dayaksuruk",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8019,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Tebidah",
  lc: "xdy-x-dayaktebidah",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8152,
  ang: "Dayak Tola",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Tola",
  lc: "xdy-x-dayaktola",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8305,
  ang: "Delang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Delang",
  lc: "xdy-x-delang",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8143,
  ang: "Dayak Gerungang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Gerungang",
  lc: "xdy-x-gerungang",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7961,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Ingar Silat",
  lc: "xdy-x-ingarsilat",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8179,
  ang: "Dayak Jungkal",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Jungkal",
  lc: "xdy-x-jungkal",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7846,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Kantu",
  lc: "xdy-x-kantu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7851,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Karabat",
  lc: "xdy-x-karabat",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8167,
  ang: "Dayak Kayong",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Kayong",
  lc: "xdy-x-kayong",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8162,
  ang: "Dayak Kebuai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Kebuai",
  lc: "xdy-x-kebuai",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8210,
  ang: "Dayak Kemuning",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Kemuning",
  lc: "xdy-x-kemuning",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8140,
  ang: "Dayak Kengkubang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Kengkubang",
  lc: "xdy-x-kengkubang",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8310,
  ang: "Malayic Dayak",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lemandau",
  lc: "xdy-x-lamandau",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8156,
  ang: "Dayak Lemandau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Lemandau",
  lc: "xdy-x-lemandau",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8003,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Maamp",
  lc: "xdy-x-maamp",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8177,
  ang: "Dayak Mahawa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Mahawa",
  lc: "xdy-x-mahawa",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8137,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Manggaling",
  lc: "xdy-x-manggaling",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8184,
  ang: "Dayak Marau Sinar Bulan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Marau Sinar Bulan",
  lc: "xdy-x-marausinar",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8175,
  ang: "Dayak Marau Temparak",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Marau Tempayak",
  lc: "xdy-x-marautempay",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7906,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Melahui",
  lc: "xdy-x-melahui",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7908,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Mentebah",
  lc: "xdy-x-mentebah",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8309,
  ang: "Mentebah Suruk",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mentobi",
  lc: "xdy-x-mentobi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7969,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Olla Melahui",
  lc: "xdy-x-ollamelahui",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8142,
  ang: "Dayak Parangkunyit",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Parangkunyit",
  lc: "xdy-x-parangkunyit",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8382,
  ang: "Parenggean",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Parenggean",
  lc: "xdy-x-parenggean",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7970,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Payak Papak",
  lc: "xdy-x-payakpapak",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8213,
  ang: "Dayak Pelanyau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Pelanjau",
  lc: "xdy-x-pelanjau",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8176,
  ang: "Dayak Pengatapan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Pengatapan",
  lc: "xdy-x-pengatapan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8144,
  ang: "Dayak Perigiq",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Perigiq",
  lc: "xdy-x-perigiq",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8187,
  ang: "Dayak Peringkunyit",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Peringkunyit",
  lc: "xdy-x-peringkunyit",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8212,
  ang: "Dayak Pesangaran",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Pesangaran",
  lc: "xdy-x-pesangaran",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8209,
  ang: "Dayak Petebang",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Petebang",
  lc: "xdy-x-petebang",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8214,
  ang: "Dayak Putaran",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Putaran",
  lc: "xdy-x-putaran",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8151,
  ang: "Dayak Randau Joka",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Randau Joka",
  lc: "xdy-x-randaujoka",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7852,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Sawe",
  lc: "xdy-x-sawe",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8185,
  ang: "Dayak Sekakai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Sekakai",
  lc: "xdy-x-sekakai",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8150,
  ang: "Dayak Semanak",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Semanak",
  lc: "xdy-x-semanak",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8149,
  ang: "Dayak Senduruhan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Senduruhan",
  lc: "xdy-x-senduruhan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8178,
  ang: "Dayak Sepauhan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Sepauhan",
  lc: "xdy-x-sepauhan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8163,
  ang: "Dayak Serengkah",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Serengkah",
  lc: "xdy-x-serengkah",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8181,
  ang: "Dayak Songkap",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Songkap",
  lc: "xdy-x-songkap",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8020,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Suang Ensilat",
  lc: "xdy-x-suangensilat",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7974,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Suhaid",
  lc: "xdy-x-suhaid",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8188,
  ang: "Dayak Suka,ara",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Sukamara",
  lc: "xdy-x-sukamara",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8153,
  ang: "Dayak Sumanjawat",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Sumanjawat",
  lc: "xdy-x-sumanjawat",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7992,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Tamuan",
  lc: "xdy-x-tamuan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7911,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Undau",
  lc: "xdy-x-undau",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6899,
  ang: "Eblan",
  lr: "Asia",
  gw: false,
  hc: "SY",
  ln: "Eblan",
  lc: "xeb",
  ld: "ltr",
  alt: [],
  cc: ["SY"]
}, {
  pk: 6900,
  ang: "Hdi",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Hdi",
  lc: "xed",
  ld: "ltr",
  alt: ["Hide", "Turu-Hide", "Xedi", "Ftour", "Tourou", "Turu", "Tur (Ftour)"],
  cc: ["CM", "NG"]
}, {
  pk: 6901,
  ang: "Kelo",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Kelo",
  lc: "xel",
  ld: "ltr",
  alt: ["Kelo-Beni Sheko", "Ndu-Faa-Keelo", "Tornasi"],
  cc: ["SD"]
}, {
  pk: 6902,
  ang: "Kembayan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kembayan",
  lc: "xem",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 7855,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Baope",
  lc: "xem-x-baope",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8080,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Golik",
  lc: "xem-x-dayakgolik",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8103,
  ang: "Hibun",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Hibun",
  lc: "xem-x-hibun",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8005,
  ang: "Kembayan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Karambai",
  lc: "xem-x-karambai",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7973,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Sekayam",
  lc: "xem-x-sekayam",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6903,
  ang: "Epi-Olmec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Epi-Olmec",
  lc: "xep",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 6904,
  ang: "Xer\xE9nte",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Xer\xE9nte",
  lc: "xer",
  ld: "ltr",
  alt: ["Sherent\xE9"],
  cc: ["BR"]
}, {
  pk: 6905,
  ang: "Kesawai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kesawai",
  lc: "xes",
  ld: "ltr",
  alt: ["Kesawi", "Namuya"],
  cc: ["PG"]
}, {
  pk: 6906,
  ang: "Xet\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Xet\xE1",
  lc: "xet",
  ld: "ltr",
  alt: ["Ar\xE9", "Cheta", "Seta", "Sheta"],
  cc: ["BR"]
}, {
  pk: 6907,
  ang: "Keoru-Ahia",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Keoru-Ahia",
  lc: "xeu",
  ld: "ltr",
  alt: ["Ahia", "Ahiave", "Haura", "Haura Haela", "Horo", "Houro", "Hovoiroro", "Hovoyo", "Ke'oru", "Keuro", "Keuru", "Kouri", "Lavau", "Lower Ahia", "O'o Moko", "Pairi", "Velepa", "Ahia (Aheave)", "Keoru"],
  cc: ["PG"]
}, {
  pk: 6908,
  ang: "Faliscan",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Faliscan",
  lc: "xfa",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 6909,
  ang: "Galatian",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Galatian",
  lc: "xga",
  ld: "ltr",
  alt: [],
  cc: ["TR"]
}, {
  pk: 6910,
  ang: "Gbin",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Gbin",
  lc: "xgb",
  ld: "ltr",
  alt: [],
  cc: ["CI"]
}, {
  pk: 6911,
  ang: "Gabrielino-Fernande\xF1o",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Gabrielino-Fernande\xF1o",
  lc: "xgf",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 6912,
  ang: "Galindan",
  lr: "Europe",
  gw: false,
  hc: "PL",
  ln: "Galindan",
  lc: "xgl",
  ld: "ltr",
  alt: [],
  cc: ["PL"]
}, {
  pk: 6913,
  ang: "Garza",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Garza",
  lc: "xgr",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 6914,
  ang: "Unggumi",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Unggumi",
  lc: "xgu",
  ld: "ltr",
  alt: ["Ngarangari", "Ong Komi", "Ongaranjan", "Ungami", "Ungumi", "Wongkomi"],
  cc: ["AU"]
}, {
  pk: 6915,
  ang: "Xhosa",
  lr: "Africa",
  gw: false,
  hc: "ZA",
  ln: "isiXhosa",
  lc: "xh",
  ld: "ltr",
  alt: ["Isixhosa", "Koosa", "Xosa", "Cauzuh"],
  cc: ["ZA", "ZW", "LS", "BW"]
}, {
  pk: 6916,
  ang: "Harami",
  lr: "Asia",
  gw: false,
  hc: "YE",
  ln: "Harami",
  lc: "xha",
  ld: "ltr",
  alt: [],
  cc: ["YE"]
}, {
  pk: 6917,
  ang: "Hunnic",
  lr: "Asia",
  gw: false,
  hc: "KZ",
  ln: "Hunnic",
  lc: "xhc",
  ld: "ltr",
  alt: [],
  cc: ["KZ"]
}, {
  pk: 6918,
  ang: "Hadrami",
  lr: "Asia",
  gw: false,
  hc: "YE",
  ln: "Hadrami",
  lc: "xhd",
  ld: "ltr",
  alt: [],
  cc: ["YE"]
}, {
  pk: 6919,
  ang: "Khetrani",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "Khetrani",
  lc: "xhe",
  ld: "ltr",
  alt: [],
  cc: ["PK"]
}, {
  pk: 6920,
  ang: "Hernican",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Hernican",
  lc: "xhr",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 6921,
  ang: "Hattic",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Hattic",
  lc: "xht",
  ld: "ltr",
  alt: [],
  cc: ["TR"]
}, {
  pk: 6922,
  ang: "Hurrian",
  lr: "Asia",
  gw: false,
  hc: "SY",
  ln: "Hurrian",
  lc: "xhu",
  ld: "ltr",
  alt: [],
  cc: ["SY"]
}, {
  pk: 6923,
  ang: "Khua",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Khua",
  lc: "xhv",
  ld: "ltr",
  alt: [],
  cc: ["LA", "VN"]
}, {
  pk: 6924,
  ang: "Iberian",
  lr: "Europe",
  gw: false,
  hc: "ES",
  ln: "Iberian",
  lc: "xib",
  ld: "ltr",
  alt: [],
  cc: ["ES"]
}, {
  pk: 6925,
  ang: "Xiri",
  lr: "Africa",
  gw: false,
  hc: "ZA",
  ln: "Xiri",
  lc: "xii",
  ld: "ltr",
  alt: ["Cape Hottentot", "Gri", "Grikwa", "Griqua", "Gry", "Xirikwa", "Xrikwa"],
  cc: ["ZA"]
}, {
  pk: 6926,
  ang: "Illyrian",
  lr: "Europe",
  gw: false,
  hc: "AL",
  ln: "Illyrian",
  lc: "xil",
  ld: "ltr",
  alt: [],
  cc: ["AL"]
}, {
  pk: 6927,
  ang: "Xiri\xE2na",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Xiri\xE2na",
  lc: "xir",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 6928,
  ang: "Kisan",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kisan",
  lc: "xis",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 6929,
  ang: "Indus Valley Language",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Indus Valley Language",
  lc: "xiv",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 6930,
  ang: "Xipaya",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Xipaya",
  lc: "xiy",
  ld: "ltr",
  alt: ["Shipaja", "Xipaia"],
  cc: ["BR"]
}, {
  pk: 6931,
  ang: "Kalkoti",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u06A9\u0644\u06A9\u0648\u0679\u06CC",
  lc: "xka",
  ld: "ltr",
  alt: [],
  cc: ["PK"]
}, {
  pk: 6932,
  ang: "Nago, Northern",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Northern Nago",
  lc: "xkb",
  ld: "ltr",
  alt: ["Ana", "Ede Nago, Manigri-Kambol\xE9", "Manigri", "Kambol\xE9", "Southwest Ede", "Ede Nago", "Manigri-Kambol\xE9"],
  cc: ["BJ", "TG"]
}, {
  pk: 6933,
  ang: "Kho\u2019ini",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "\u06AF\u0648\u06CC\u0634 \u062E\u0648\u0626\u06CC\u0646\u06CC",
  lc: "xkc",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 6934,
  ang: "Kayan, Mendalam",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mendalam Kayan",
  lc: "xkd",
  ld: "ltr",
  alt: ["Mendalam Kajan"],
  cc: ["ID"]
}, {
  pk: 6935,
  ang: "Kereho",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kereho",
  lc: "xke",
  ld: "ltr",
  alt: ["Keriau Punan", "Seputan", "Uheng (Kereho-Uheng)"],
  cc: ["ID"]
}, {
  pk: 6936,
  ang: "Khengkha",
  lr: "Asia",
  gw: false,
  hc: "BT",
  ln: "Khengkha",
  lc: "xkf",
  ld: "ltr",
  alt: ["Ken", "Keng", "Kenkha", "Khen", "Khenkha", "Kyengkha", "Lower Kheng", "Upper Kheng", "Middle Kheng"],
  cc: ["BT"]
}, {
  pk: 6937,
  ang: "Kagoro",
  lr: "Africa",
  gw: false,
  hc: "ML",
  ln: "Gworog",
  lc: "xkg",
  ld: "ltr",
  alt: ["Kakolo", "S\xE9b\xE9koro", "S\xE9f\xE9to", "Mogola", "Kamiko", "Jumara", "Guissimbin\xE9", "Di\xE9ma"],
  cc: ["ML"]
}, {
  pk: 6938,
  ang: "Karahawyana",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Karahawyana",
  lc: "xkh",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 6939,
  ang: "Kenyan Sign Language",
  lr: "Africa",
  gw: false,
  hc: "KE",
  ln: "Kenyan Sign Language",
  lc: "xki",
  ld: "ltr",
  alt: ["KSL"],
  cc: ["KE"]
}, {
  pk: 6940,
  ang: "Kajali",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Kajali",
  lc: "xkj",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 6941,
  ang: "Kaco\u2019",
  lr: "Asia",
  gw: false,
  hc: "KH",
  ln: "Kaco'",
  lc: "xkk",
  ld: "ltr",
  alt: ["Kachah'"],
  cc: ["KH"]
}, {
  pk: 6942,
  ang: "Kenyah, Mainstream",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mainstream Kenyah",
  lc: "xkl",
  ld: "ltr",
  alt: ["Highland Kenyah", "Usun Apau Kenyah", "Bakong", "Bakung Kenya", "Bakung Kenyah", "Leppo' Jengan", "Uma' Jalan", "Uma' Ake", "Sambup", "Leppo' Teppu'", "Leppo' Tau", "Uma' Tukung", "Leppo' Jamok", "Leppo' Ga", "Leppo' Aga", "Lepo' Tepu'", "Badeng (Madeng)", "Leppo' La'ang", "Leppo' Ke'"],
  cc: ["ID", "MY"]
}, {
  pk: 7883,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Badeng",
  lc: "xkl-x-badeng",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7920,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Agabag",
  lc: "xkl-x-dayakagabag",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7833,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lepok Bakung",
  lc: "xkl-x-lepokbakung",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7834,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lepok Bemi",
  lc: "xkl-x-lepokbemi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8061,
  ang: "Lepo' Ke",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lepo' Ke",
  lc: "xkl-x-lepoke",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7835,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lepok Jalan",
  lc: "xkl-x-lepokjalan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7836,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lepok Kulit",
  lc: "xkl-x-lepokkulit",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7859,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lepok Tou",
  lc: "xkl-x-lepoktou",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7913,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lepo Ma'ut",
  lc: "xkl-x-lepomaut",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7858,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lepo Tepu",
  lc: "xkl-x-lepotepu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8227,
  ang: "Long Jalan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Long Jalan",
  lc: "xkl-x-longjalan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8228,
  ang: "Long Lake",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Long Lake",
  lc: "xkl-x-longlake",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7915,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Lepo Ndang",
  lc: "xkl-x-ndang",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7838,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kenya Uma Tukung",
  lc: "xkl-x-umatukung",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6943,
  ang: "Kayan, Kayan River",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kayan River Kayan",
  lc: "xkn",
  ld: "ltr",
  alt: ["Kajang", "Kayan River Kajan", "Uma Laran", "Uma Leken"],
  cc: ["ID"]
}, {
  pk: 8028,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Dayak Kayaan",
  lc: "xkn-x-dayakkayaan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7849,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Kayan",
  lc: "xkn-x-kayan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8063,
  ang: "Kayan Uma Apan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kayan Uma Apan",
  lc: "xkn-x-umaapan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8059,
  ang: "Kayan Uma Lekan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kayan Uma Lekan",
  lc: "xkn-x-umalekan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6944,
  ang: "Kiorr",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Kiorr",
  lc: "xko",
  ld: "ltr",
  alt: ["Col", "Con", "Saamtaav", "Samtao", "Samtao 2"],
  cc: ["LA"]
}, {
  pk: 6945,
  ang: "Kabatei",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Kabatei",
  lc: "xkp",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 6946,
  ang: "Koroni",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Koroni",
  lc: "xkq",
  ld: "ltr",
  alt: ["Oengsongi"],
  cc: ["ID"]
}, {
  pk: 6947,
  ang: "Xakriab\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Xakriab\xE1",
  lc: "xkr",
  ld: "ltr",
  alt: ["Chakriaba", "Chikriaba", "Shacriaba"],
  cc: ["BR"]
}, {
  pk: 6948,
  ang: "Kumbewaha",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kumbewaha",
  lc: "xks",
  ld: "ltr",
  alt: ["Kumberaha", "Umbewaha"],
  cc: ["ID"]
}, {
  pk: 6949,
  ang: "Kantosi",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Kantosi",
  lc: "xkt",
  ld: "ltr",
  alt: ["Dagaare-Dioula", "Kantonsi", "Yare", "Yarsi"],
  cc: ["GH"]
}, {
  pk: 6950,
  ang: "Kaamba",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Kaamba",
  lc: "xku",
  ld: "ltr",
  alt: ["Kikaamba"],
  cc: ["CG"]
}, {
  pk: 6951,
  ang: "Shekgalagari",
  lr: "Africa",
  gw: false,
  hc: "BW",
  ln: "Shekgalagari",
  lc: "xkv",
  ld: "ltr",
  alt: ["Kgalagarhi", "Kgalagari", "Khalagari", "Khalakadi", "Kxhalaxadi", "Qhalaxarzi", "Shekgalagadi", "Shekgalagari", "Koma", "Tjhauba", "Siwane (Gyegwana)", "Rhiti", "Kgwatheng", "Kgalagadi (Kgalagari)", "Kenyi (Khena)", "Balaongwe (Boloongwe)", "Shelala", "Khakhae"],
  cc: ["BW"]
}, {
  pk: 6952,
  ang: "Kembra",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kembra",
  lc: "xkw",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 6953,
  ang: "Karore",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Karore",
  lc: "xkx",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 6954,
  ang: "Uma\u2019 Lasan",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Uma' Lasan",
  lc: "xky",
  ld: "ltr",
  alt: ["Western Kenyah", "Kanyay", "Kenja", "Kindjin", "Kinjin", "Western Kenya", "Uma' Baka"],
  cc: ["MY"]
}, {
  pk: 8232,
  ang: "Long Nyau",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Long Nyau",
  lc: "xky-x-longnyau",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6955,
  ang: "Kurtokha",
  lr: "Asia",
  gw: false,
  hc: "BT",
  ln: "Kurtokha",
  lc: "xkz",
  ld: "ltr",
  alt: ["Gurt\xFC", "Kurteopkha", "K\xFCrth\xF6pka", "Kurthopkha", "Kurtobikha", "Kurtopakha"],
  cc: ["BT"]
}, {
  pk: 6956,
  ang: "Kamula",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kamula",
  lc: "xla",
  ld: "ltr",
  alt: ["Wawoi"],
  cc: ["PG"]
}, {
  pk: 6957,
  ang: "Loup B",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Loup B",
  lc: "xlb",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 6958,
  ang: "Lycian",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Lycian",
  lc: "xlc",
  ld: "ltr",
  alt: [],
  cc: ["TR"]
}, {
  pk: 6959,
  ang: "Lydian",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Lydian",
  lc: "xld",
  ld: "ltr",
  alt: [],
  cc: ["TR"]
}, {
  pk: 6960,
  ang: "Lemnian",
  lr: "Europe",
  gw: false,
  hc: "GR",
  ln: "Lemnian",
  lc: "xle",
  ld: "ltr",
  alt: [],
  cc: ["GR"]
}, {
  pk: 6961,
  ang: "Ligurian",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Ligurian (Ancient)",
  lc: "xlg",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 6962,
  ang: "Liburnian",
  lr: "Europe",
  gw: false,
  hc: "HR",
  ln: "Liburnian",
  lc: "xli",
  ld: "ltr",
  alt: [],
  cc: ["HR"]
}, {
  pk: 6963,
  ang: "Alanic",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Alanic",
  lc: "xln",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 6964,
  ang: "Loup A",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Loup A",
  lc: "xlo",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 6965,
  ang: "Lepontic",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Lepontic",
  lc: "xlp",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 6966,
  ang: "Lusitanian",
  lr: "Europe",
  gw: false,
  hc: "PT",
  ln: "Lusitanian",
  lc: "xls",
  ld: "ltr",
  alt: [],
  cc: ["PT"]
}, {
  pk: 6967,
  ang: "Cuneiform Luwian",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Cuneiform Luwian",
  lc: "xlu",
  ld: "ltr",
  alt: [],
  cc: ["TR"]
}, {
  pk: 6968,
  ang: "Elymian",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Elymian",
  lc: "xly",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 6969,
  ang: "Mushungulu",
  lr: "Africa",
  gw: false,
  hc: "SO",
  ln: "Mushungulu",
  lc: "xma",
  ld: "ltr",
  alt: ["Kimushungulu", "Mushunguli"],
  cc: ["SO"]
}, {
  pk: 6970,
  ang: "Mbonga",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mbonga",
  lc: "xmb",
  ld: "ltr",
  alt: ["Mboa"],
  cc: ["CM", "NG"]
}, {
  pk: 6971,
  ang: "Makhuwa-Marrevone",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Makhuwa-Marrevone",
  lc: "xmc",
  ld: "ltr",
  alt: ["Coastal Makhuwa", "Emaka", "Maca", "Maka", "Marevone", "Marrevone", "South Maca", "Makhuwana (Emakhuwana)", "Naharra (Enaharra)", "Nampamela (Empamela)"],
  cc: ["MZ"]
}, {
  pk: 6972,
  ang: "Mbudum",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mbudum",
  lc: "xmd",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 6973,
  ang: "Median",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Median",
  lc: "xme",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 6974,
  ang: "Mingrelian",
  lr: "Asia",
  gw: false,
  hc: "GE",
  ln: "\u10DB\u10D0\u10E0\u10D2\u10D0\u10DA\u10E3\u10E0\u10D8 \u10DC\u10D8\u10DC\u10D0",
  lc: "xmf",
  ld: "ltr",
  alt: ["Margaluri", "Megrel", "Megruli"],
  cc: ["GE"]
}, {
  pk: 6975,
  ang: "Mengaka",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Mengaka",
  lc: "xmg",
  ld: "ltr",
  alt: ["Bamileke-Mengaka", "Benzing", "Ghap", "Megaka", "Bamendjing (Bamendjin)"],
  cc: ["CM"]
}, {
  pk: 6976,
  ang: "Kuku-Muminh",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Kuku-Muminh",
  lc: "xmh",
  ld: "ltr",
  alt: ["Kugu", "Kugu-Muminh", "Wik Muminh", "Wik-Mumin"],
  cc: ["AU"]
}, {
  pk: 6977,
  ang: "Majera",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Majera",
  lc: "xmj",
  ld: "ltr",
  alt: ["Mazera", "Da'a", "Mida'a", "Midah", "Hwalem (Holom)", "Majera (Mazra)"],
  cc: ["CM", "TD"]
}, {
  pk: 6978,
  ang: "Ancient Macedonian",
  lr: "Europe",
  gw: false,
  hc: "MK",
  ln: "Ancient Macedonian",
  lc: "xmk",
  ld: "ltr",
  alt: [],
  cc: ["MK"]
}, {
  pk: 6979,
  ang: "Malaysian Sign Language",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Malaysian Sign Language",
  lc: "xml",
  ld: "ltr",
  alt: ["Bahasa Isyarat Malaysia"],
  cc: ["MY"]
}, {
  pk: 6980,
  ang: "Malay, Manado",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Manado Malay",
  lc: "xmm",
  ld: "ltr",
  alt: ["Manadonese Malay", "Minahasan Malay"],
  cc: ["ID"]
}, {
  pk: 7689,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Borgo Malay",
  lc: "xmm-x-borgo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 6981,
  ang: "Manichaean Middle Persian",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Manichaean Middle Persian",
  lc: "xmn",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 6982,
  ang: "Morerebi",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Morerebi",
  lc: "xmo",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 6983,
  ang: "Meroitic",
  lr: "Africa",
  gw: false,
  hc: "EG",
  ln: "Meroitic",
  lc: "xmr",
  ld: "ltr",
  alt: [],
  cc: ["EG"]
}, {
  pk: 6984,
  ang: "Moroccan Sign Language",
  lr: "Africa",
  gw: false,
  hc: "MA",
  ln: "Moroccan Sign Language",
  lc: "xms",
  ld: "ltr",
  alt: ["MSL"],
  cc: ["MA"]
}, {
  pk: 6985,
  ang: "Matbat",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Matbat",
  lc: "xmt",
  ld: "ltr",
  alt: ["Me"],
  cc: ["ID"]
}, {
  pk: 6986,
  ang: "Malagasy, Antankarana",
  lr: "Africa",
  gw: false,
  hc: "MG",
  ln: "Antankarana Malagasy",
  lc: "xmv",
  ld: "ltr",
  alt: ["Antakarana", "Antakarana Malagasy", "Antekarana", "Antekarana Malagasy", "Tankarana", "Tankarana Malagasy"],
  cc: ["MG"]
}, {
  pk: 6987,
  ang: "Malagasy, Tsimihety",
  lr: "Africa",
  gw: false,
  hc: "MG",
  ln: "Tsimihety Malagasy",
  lc: "xmw",
  ld: "ltr",
  alt: ["Tsimihety"],
  cc: ["MG"]
}, {
  pk: 6988,
  ang: "Maden",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Maden",
  lc: "xmx",
  ld: "ltr",
  alt: ["Saparan", "Sapran", "Kawait"],
  cc: ["ID"]
}, {
  pk: 6989,
  ang: "Mori Bawah",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mori Bawah",
  lc: "xmz",
  ld: "ltr",
  alt: ["Beneden-Tomori", "East Mori", "Lower Mori", "Oost-Mori", "Tinompo (Mokole)", "Watu (Towatoe)", "Sinongko", "Tiu (Tioe)", "Moiki (Tomoiki)", "Korongsi", "Karunsi'e (Karonsie)", "Nuha (Soroako)"],
  cc: ["ID"]
}, {
  pk: 6990,
  ang: "Ancient North Arabian",
  lr: "Asia",
  gw: false,
  hc: "SA",
  ln: "Ancient North Arabian",
  lc: "xna",
  ld: "ltr",
  alt: [],
  cc: ["SA"]
}, {
  pk: 6991,
  ang: "Kanakanabu",
  lr: "Asia",
  gw: false,
  hc: "TW",
  ln: "Kanakanabu",
  lc: "xnb",
  ld: "ltr",
  alt: ["Kanabu", "Kanakanavu"],
  cc: ["TW"]
}, {
  pk: 6992,
  ang: "Middle Mongolian",
  lr: "Asia",
  gw: false,
  hc: "MN",
  ln: "Middle Mongolian",
  lc: "xng",
  ld: "ltr",
  alt: [],
  cc: ["MN"]
}, {
  pk: 6993,
  ang: "Kuanhua",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5BBD\u8BED",
  lc: "xnh",
  ld: "ltr",
  alt: ["Damai"],
  cc: ["CN"]
}, {
  pk: 6994,
  ang: "Ngarigu",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Ngarigu",
  lc: "xni",
  ld: "ltr",
  alt: ["Bemeringal", "Bradjerak", "Brajerak", "Brajerang", "Currak-da-bidgee", "Garego", "Guramal", "Gur-mal", "Murring", "Ngarago", "Ngarego", "Ngarico", "Ngarigo", "Ngarroogoo", "Ngarrugu", "Ngaryo", "Nguramal"],
  cc: ["AU"]
}, {
  pk: 6995,
  ang: "Kankanay, Northern",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Northern Kankanay",
  lc: "xnn",
  ld: "ltr",
  alt: ["Sagada Igorot", "Western Bontoc"],
  cc: ["PH"]
}, {
  pk: 6996,
  ang: "Anglo-Norman",
  lr: "Europe",
  gw: false,
  hc: "GB",
  ln: "Anglo-Norman",
  lc: "xno",
  ld: "ltr",
  alt: [],
  cc: ["GB"]
}, {
  pk: 6997,
  ang: "Kangri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kangri",
  lc: "xnr",
  ld: "ltr",
  alt: ["Kangra-Dogri", "Pahari", "Pahari Kangri", "Hamirpuri", "Palampuri"],
  cc: ["IN"]
}, {
  pk: 6998,
  ang: "Kanashi",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kanashi",
  lc: "xns",
  ld: "ltr",
  alt: ["Kanasi", "Malani"],
  cc: ["IN"]
}, {
  pk: 6999,
  ang: "Narragansett",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Narragansett",
  lc: "xnt",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 7000,
  ang: "Nyiyaparli",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Nyiyaparli",
  lc: "xny",
  ld: "ltr",
  alt: ["Iabali", "Jana", "Janari", "Niabali", "Njiabadi", "Njiabali", "Njijabadi", "Njijabali", "Njijapali", "Nyiyabali", "Nyiyapali", "Nyiypali"],
  cc: ["AU"]
}, {
  pk: 7001,
  ang: "Mattokki",
  lr: "Africa",
  gw: false,
  hc: "EG",
  ln: "Kenzi",
  lc: "xnz",
  ld: "ltr",
  alt: ["Kenuz", "Kenuzi", "Kunuz", "Kunuz Nubian", "Kunuzi", "Mattokki"],
  cc: ["SD", "EG"]
}, {
  pk: 7002,
  ang: "Kokoda",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kokoda",
  lc: "xod",
  ld: "ltr",
  alt: ["Komudago", "Nebes", "Oderago", "Samalek", "Kasuweri (Komudago)", "Negri Besar (Negeri Besar)"],
  cc: ["ID"]
}, {
  pk: 7003,
  ang: "Soga",
  lr: "Africa",
  gw: false,
  hc: "UG",
  ln: "Soga",
  lc: "xog",
  ld: "ltr",
  alt: ["Olusoga", "Nholo (Lunholo)", "Tenga (Lutenga)", "Temb\xE9 (Lutembe)", "Siginyi", "Luuka", "Lulamoogi", "Lukono", "Lamogi (Lamoogi)", "Diope (Ludiope)", "Kigulu (Lukigulu)", "Gweri (Lugweri)", "Gabula (Lugabula)", "Lulamogi", "Siki (Lusiginyi)"],
  cc: ["TZ", "UG"]
}, {
  pk: 7004,
  ang: "Kominimung",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kominimung",
  lc: "xoi",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7005,
  ang: "Xokleng",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Xokleng",
  lc: "xok",
  ld: "ltr",
  alt: ["Aweikoma", "Botocudos", "Bugre"],
  cc: ["BR"]
}, {
  pk: 7006,
  ang: "Komo",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Komo (Sudan)",
  lc: "xom",
  ld: "ltr",
  alt: ["Central Koma", "Koma", "Madiin", "South Koma", "Como", "Gokwom", "Hayahaya", "Aru"],
  cc: ["ET", "SD"]
}, {
  pk: 7007,
  ang: "Konkomba",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Konkomba",
  lc: "xon",
  ld: "ltr",
  alt: ["Kpankpamba", "Nalong", "Lichabool", "Likoonli (Likonl)", "Liquan"],
  cc: ["GH", "TG"]
}, {
  pk: 7008,
  ang: "Xukur\xFA",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Xukur\xFA",
  lc: "xoo",
  ld: "ltr",
  alt: ["Kirir\xED", "Kirir\xED-Xok\xF3"],
  cc: ["BR"]
}, {
  pk: 7009,
  ang: "Kopar",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kopar",
  lc: "xop",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7010,
  ang: "Korubo",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Korubo",
  lc: "xor",
  ld: "ltr",
  alt: ["Caceteiros"],
  cc: ["BR"]
}, {
  pk: 7011,
  ang: "Kowaki",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kowaki",
  lc: "xow",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7012,
  ang: "Pecheneg",
  lr: "Europe",
  gw: false,
  hc: "UA",
  ln: "Pecheneg",
  lc: "xpc",
  ld: "ltr",
  alt: [],
  cc: ["UA"]
}, {
  pk: 7013,
  ang: "Kpelle, Liberia",
  lr: "Africa",
  gw: false,
  hc: "LR",
  ln: "Liberia Kpelle",
  lc: "xpe",
  ld: "ltr",
  alt: ["Gbese", "Kpele", "Kpwessi", "Pessa", "Pessy", "Nyawokole", "Boopolu", "Fuama"],
  cc: ["LR"]
}, {
  pk: 7014,
  ang: "Phrygian",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Phrygian",
  lc: "xpg",
  ld: "ltr",
  alt: [],
  cc: ["TR"]
}, {
  pk: 7015,
  ang: "Pictish",
  lr: "Europe",
  gw: false,
  hc: "GB",
  ln: "Pictish",
  lc: "xpi",
  ld: "ltr",
  alt: [],
  cc: ["GB"]
}, {
  pk: 7016,
  ang: "Kulina Pano",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Kulina Pano",
  lc: "xpk",
  ld: "ltr",
  alt: ["Culina Pano", "Kulina do Acre"],
  cc: ["BR"]
}, {
  pk: 7017,
  ang: "Pumpokol",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "Pumpokol",
  lc: "xpm",
  ld: "ltr",
  alt: [],
  cc: ["RU"]
}, {
  pk: 7018,
  ang: "Kapinaw\xE1",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Kapinaw\xE1",
  lc: "xpn",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 7019,
  ang: "Pochutec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Pochutec",
  lc: "xpo",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 7020,
  ang: "Puyo-Paekche",
  lr: "Asia",
  gw: false,
  hc: "KR",
  ln: "Puyo-Paekche",
  lc: "xpp",
  ld: "ltr",
  alt: [],
  cc: ["KR"]
}, {
  pk: 7021,
  ang: "Mohegan-Pequot",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Mohegan-Pequot",
  lc: "xpq",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 7022,
  ang: "Parthian",
  lr: "Asia",
  gw: false,
  hc: "IR",
  ln: "Parthian",
  lc: "xpr",
  ld: "ltr",
  alt: [],
  cc: ["IR"]
}, {
  pk: 7023,
  ang: "Pisidian",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Pisidian",
  lc: "xps",
  ld: "ltr",
  alt: [],
  cc: ["TR"]
}, {
  pk: 7024,
  ang: "Punic",
  lr: "Africa",
  gw: false,
  hc: "TN",
  ln: "Punic",
  lc: "xpu",
  ld: "ltr",
  alt: [],
  cc: ["TN"]
}, {
  pk: 7025,
  ang: "Puyo",
  lr: "Asia",
  gw: false,
  hc: "KP",
  ln: "Puyo",
  lc: "xpy",
  ld: "ltr",
  alt: [],
  cc: ["KP"]
}, {
  pk: 7026,
  ang: "Karakhanid",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Karakhanid",
  lc: "xqa",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7027,
  ang: "Qatabanian",
  lr: "Asia",
  gw: false,
  hc: "YE",
  ln: "Qatabanian",
  lc: "xqt",
  ld: "ltr",
  alt: [],
  cc: ["YE"]
}, {
  pk: 7028,
  ang: "Krah\xF4",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Krah\xF4",
  lc: "xra",
  ld: "ltr",
  alt: ["Cra\xF4", "Kra\xF4"],
  cc: ["BR"]
}, {
  pk: 7029,
  ang: "Karaboro, Eastern",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Eastern Karaboro",
  lc: "xrb",
  ld: "ltr",
  alt: ["Kar", "Ker", "Kler"],
  cc: ["BF", "TG"]
}, {
  pk: 7030,
  ang: "Krikati-Timbira",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Krikati-Timbira",
  lc: "xri",
  ld: "ltr",
  alt: ["Krikati-Gaviao", "Krinkati-Gaviao", "Krinkati-Timbira", "Krinkati (Karakati)"],
  cc: ["BR"]
}, {
  pk: 7031,
  ang: "Armazic",
  lr: "Asia",
  gw: false,
  hc: "GE",
  ln: "Armazic",
  lc: "xrm",
  ld: "ltr",
  alt: [],
  cc: ["GE"]
}, {
  pk: 7032,
  ang: "Arin",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "Arin",
  lc: "xrn",
  ld: "ltr",
  alt: [],
  cc: ["RU"]
}, {
  pk: 7033,
  ang: "Raetic",
  lr: "Europe",
  gw: false,
  hc: "CH",
  ln: "Raetic",
  lc: "xrr",
  ld: "ltr",
  alt: [],
  cc: ["CH"]
}, {
  pk: 7034,
  ang: "Aranama-Tamique",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Aranama-Tamique",
  lc: "xrt",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 7035,
  ang: "Marriammu",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Marriammu",
  lc: "xru",
  ld: "ltr",
  alt: ["Mareammu"],
  cc: ["AU"]
}, {
  pk: 7036,
  ang: "Karawa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Karawa",
  lc: "xrw",
  ld: "ltr",
  alt: ["Bulawa"],
  cc: ["PG"]
}, {
  pk: 7037,
  ang: "Sabaean",
  lr: "Asia",
  gw: false,
  hc: "YE",
  ln: "Sabaean",
  lc: "xsa",
  ld: "ltr",
  alt: [],
  cc: ["YE"]
}, {
  pk: 7038,
  ang: "Sambal",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Sambal",
  lc: "xsb",
  ld: "ltr",
  alt: ["Sambali", "Tina", "Tina Sambal", "Iba", "Masinloc", "Santa Cruz"],
  cc: ["PH"]
}, {
  pk: 7039,
  ang: "Scythian",
  lr: "Asia",
  gw: false,
  hc: "KZ",
  ln: "Scythian",
  lc: "xsc",
  ld: "ltr",
  alt: [],
  cc: ["KZ"]
}, {
  pk: 7040,
  ang: "Sidetic",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Sidetic",
  lc: "xsd",
  ld: "ltr",
  alt: [],
  cc: ["TR"]
}, {
  pk: 7041,
  ang: "Sempan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sempan",
  lc: "xse",
  ld: "ltr",
  alt: ["Nararapi"],
  cc: ["ID"]
}, {
  pk: 7042,
  ang: "Shamang",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Shamang",
  lc: "xsh",
  ld: "ltr",
  alt: ["Samang", "Samban"],
  cc: ["MY", "NG"]
}, {
  pk: 7043,
  ang: "Sio",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sio",
  lc: "xsi",
  ld: "ltr",
  alt: ["Sigawa"],
  cc: ["PG"]
}, {
  pk: 7044,
  ang: "Slavey, South",
  lr: "Americas",
  gw: false,
  hc: "CA",
  ln: "South Slavey",
  lc: "xsl",
  ld: "ltr",
  alt: ["Dene", "Den\xE9", "Denetha", "Mackenzian", "Slave", "Slavi"],
  cc: ["CA"]
}, {
  pk: 7045,
  ang: "Kasem",
  lr: "Africa",
  gw: false,
  hc: "BF",
  ln: "Kasem",
  lc: "xsm",
  ld: "ltr",
  alt: ["Kasena", "Kasim", "Kassem", "Kassena", "Kassene"],
  cc: ["BF", "GH"]
}, {
  pk: 7046,
  ang: "Sanga",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Sanga (Nigeria)",
  lc: "xsn",
  ld: "ltr",
  alt: ["Asanga", "Isanga"],
  cc: ["NG"]
}, {
  pk: 7047,
  ang: "Solano",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Solano",
  lc: "xso",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 7048,
  ang: "Silopi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Silopi",
  lc: "xsp",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7049,
  ang: "Makhuwa-Saka",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Makhuwa-Saka",
  lc: "xsq",
  ld: "ltr",
  alt: ["Esaaka", "Isaanga", "Ishanga", "Saanga", "Saka", "Sanga", "Rati (Erati)", "Saka (Esaaka)"],
  cc: ["MZ"]
}, {
  pk: 7050,
  ang: "Sherpa",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "\u0936\u0947\u0930\u094D\u092A\u093E",
  lc: "xsr",
  ld: "ltr",
  alt: ["Serwa", "Sharpa", "Sharpa Bhotia", "Xiaerba", "Xarba", "Ramechhap", "West Sherpa", "South Sherpa", "Central Sherpa (Solu)", "East Sherpa (Dolakha)", "North Sherpa (Khumbu)"],
  cc: ["BT", "NP", "IN"]
}, {
  pk: 7051,
  ang: "Assan",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "Assan",
  lc: "xss",
  ld: "ltr",
  alt: [],
  cc: ["RU"]
}, {
  pk: 7052,
  ang: "Sanum\xE1",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "Sanum\xE1",
  lc: "xsu",
  ld: "ltr",
  alt: ["Sanema", "Tsanuma", "Chirichano", "Guaika", "Samatali", "Samatari", "Sanima", "Xamatari", "Cobari (Cobariwa)", "Kobali", "Yanoma (Kohoroxitari)", "Yanoma (Samatali)"],
  cc: ["BR", "VE"]
}, {
  pk: 7053,
  ang: "Sudovian",
  lr: "Europe",
  gw: false,
  hc: "PL",
  ln: "Sudovian",
  lc: "xsv",
  ld: "ltr",
  alt: [],
  cc: ["PL"]
}, {
  pk: 7054,
  ang: "Saisiyat",
  lr: "Asia",
  gw: false,
  hc: "TW",
  ln: "Saisiyat",
  lc: "xsy",
  ld: "ltr",
  alt: ["Amutoura", "Bouiok", "Saisett", "Saisiat", "Saisiett", "Saisirat", "Saisyet", "Saisyett", "Seisirat", "Taai (North Saiset)", "Tungho (South Saiset)"],
  cc: ["TW"]
}, {
  pk: 7055,
  ang: "Mixtec, Alcozauca",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Alcozauca Mixtec",
  lc: "xta",
  ld: "ltr",
  alt: ["Mixteco de Alocozauca", "Mixteco de Xochapa", "Petlacalancingo Mixtec", "Xochapa Mixtec"],
  cc: ["MX", "US"]
}, {
  pk: 7056,
  ang: "Mixtec, Chazumba",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Chazumba Mixtec",
  lc: "xtb",
  ld: "ltr",
  alt: ["Mixteco de Chazumba", "Mixteco de la Frontera Puebla-Oaxaca", "Northern Oaxaca Mixtec"],
  cc: ["MX"]
}, {
  pk: 7057,
  ang: "Katcha-Kadugli-Miri",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Katcha-Kadugli-Miri",
  lc: "xtc",
  ld: "ltr",
  alt: ["Kudugli", "Toma Ma Dalla", "Talla", "Kadugli (Dakalla)", "Dhalla", "Tolubi", "Katcha (Dholubi)"],
  cc: ["SD"]
}, {
  pk: 7058,
  ang: "Mixtec, Diuxi-Tilantongo",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Diuxi-Tilantongo Mixtec",
  lc: "xtd",
  ld: "ltr",
  alt: ["Central Nochistl\xE1n Mixtec", "Mixteco de Diuxi-Tilantongo", "Mixteco del Este Central"],
  cc: ["MX"]
}, {
  pk: 7059,
  ang: "Ketengban",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ketengban",
  lc: "xte",
  ld: "ltr",
  alt: ["Kupel", "Oktengban"],
  cc: ["ID"]
}, {
  pk: 7060,
  ang: "Transalpine Gaulish",
  lr: "Europe",
  gw: false,
  hc: "FR",
  ln: "Transalpine Gaulish",
  lc: "xtg",
  ld: "ltr",
  alt: [],
  cc: ["FR"]
}, {
  pk: 7061,
  ang: "Yitha Yitha",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yitha Yitha",
  lc: "xth",
  ld: "ltr",
  alt: ["Eetha-eetha", "Eethee Eethee", "Eethie-eethie", "Ita-ita", "Ithi-ithi", "Iti-iti", "Tjuop", "Yetho", "Yitsa", "Yit-tha"],
  cc: ["AU"]
}, {
  pk: 7062,
  ang: "Mixtec, Sinicahua",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Sinicahua Mixtec",
  lc: "xti",
  ld: "ltr",
  alt: ["Mixteco de San Antonio Sinicahua"],
  cc: ["MX"]
}, {
  pk: 7063,
  ang: "Mixtec, San Juan Teita",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "San Juan Teita Mixtec",
  lc: "xtj",
  ld: "ltr",
  alt: ["Mixteco de San Juan Teita", "Teita Mixtec"],
  cc: ["MX"]
}, {
  pk: 7064,
  ang: "Mixtec, Tijaltepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tijaltepec Mixtec",
  lc: "xtl",
  ld: "ltr",
  alt: ["Mixteco de San Pablo Tijaltepec", "Mixteco de Santa Mar\xEDa Yosoy\xFAa"],
  cc: ["MX", "US"]
}, {
  pk: 7065,
  ang: "Mixtec, Magdalena Pe\xF1asco",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Magdalena Pe\xF1asco Mixtec",
  lc: "xtm",
  ld: "ltr",
  alt: ["San Agust\xEDn Tlacotepec Mixtec", "San Crist\xF3bal Amoltepec Mixtec", "San Mateo Pe\xF1asco Mixtec"],
  cc: ["MX"]
}, {
  pk: 7066,
  ang: "Mixtec, Northern Tlaxiaco",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Northern Tlaxiaco Mixtec",
  lc: "xtn",
  ld: "ltr",
  alt: ["Mixteco de San Juan \xD1um\xED", "Mixteco del Norte de Tlaxiaco", "\xD1um\xED Mixtec", "San Antonio Nduaxico", "San Sebastian Nicananduta", "San Antonio Monte Verde", "Santiago Nundiche"],
  cc: ["MX"]
}, {
  pk: 7067,
  ang: "Tokharian A",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Tokharian A",
  lc: "xto",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7068,
  ang: "Mixtec, San Miguel Piedras",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "San Miguel Piedras Mixtec",
  lc: "xtp",
  ld: "ltr",
  alt: ["Mixteco de San Miguel Piedras"],
  cc: ["MX"]
}, {
  pk: 7069,
  ang: "Tumshuqese",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Tumshuqese",
  lc: "xtq",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7070,
  ang: "Early Tripuri",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Early Tripuri",
  lc: "xtr",
  ld: "ltr",
  alt: [],
  cc: ["IN"]
}, {
  pk: 7071,
  ang: "Mixtec, Sindihui",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Sindihui Mixtec",
  lc: "xts",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 7072,
  ang: "Mixtec, Tacahua",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tacahua Mixtec",
  lc: "xtt",
  ld: "ltr",
  alt: ["Mixteco de Santa Cruz Tacahua", "Mixteco del Sur Medio"],
  cc: ["MX"]
}, {
  pk: 7073,
  ang: "Mixtec, Cuyamecalco",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Cuyamecalco Mixtec",
  lc: "xtu",
  ld: "ltr",
  alt: ["Cuicatl\xE1n Mixtec", "Mixteco de Ca\xF1ada central", "Mixteco de Cuyamecalco"],
  cc: ["MX"]
}, {
  pk: 7074,
  ang: "Tawand\xEA",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Tawand\xEA",
  lc: "xtw",
  ld: "ltr",
  alt: ["Da'wan'du", "Tawaind\xEA"],
  cc: ["BR"]
}, {
  pk: 7075,
  ang: "Mixtec, Yolox\xF3chitl",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Yoloxochitl Mixtec",
  lc: "xty",
  ld: "ltr",
  alt: ["Mixteco de Yolox\xF3chitl"],
  cc: ["MX"]
}, {
  pk: 7076,
  ang: "Tasmanian",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Tasmanian",
  lc: "xtz",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 7077,
  ang: "Kurumba, Alu",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Alu Kurumba",
  lc: "xua",
  ld: "ltr",
  alt: ["Alu Kurumba Nonstandard Kannada", "Hal Kurumba", "Pal Kurumba"],
  cc: ["IN"]
}, {
  pk: 7078,
  ang: "Kurumba, Betta",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Betta Kurumba",
  lc: "xub",
  ld: "ltr",
  alt: ["Kadu Kurumba", "Urali Kurumba"],
  cc: ["IN"]
}, {
  pk: 7079,
  ang: "Umiida",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Umiida",
  lc: "xud",
  ld: "ltr",
  alt: ["Aobidai of Ongkarango", "O:ka:ta", "O:kada", "Okat", "Oken", "Okwata", "Oomida", "Umeda", "Umede", "Umida", "Umidi", "Wumide"],
  cc: ["AU"]
}, {
  pk: 7080,
  ang: "Kunigami",
  lr: "Asia",
  gw: false,
  hc: "JP",
  ln: "\u5C71\u539F\u8A00\u8449",
  lc: "xug",
  ld: "ltr",
  alt: [],
  cc: ["JP"]
}, {
  pk: 7081,
  ang: "Kurumba, Jennu",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Jennu Kurumba",
  lc: "xuj",
  ld: "ltr",
  alt: ["Jen Kurumba", "Jennu Kurumba", "Jennu Nudi", "Kattu Nayaka", "Naik Kurumba", "Nonstandard Kannada", "Shola Nayakan", "Ten Kurumba"],
  cc: ["IN"]
}, {
  pk: 7082,
  ang: "Umbrian",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Umbrian",
  lc: "xum",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 7083,
  ang: "Kuo",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Kuo",
  lc: "xuo",
  ld: "ltr",
  alt: ["Ko", "Koh"],
  cc: ["CM", "TD"]
}, {
  pk: 7084,
  ang: "Upper Umpqua",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Upper Umpqua",
  lc: "xup",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 7085,
  ang: "Urartian",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Urartian",
  lc: "xur",
  ld: "ltr",
  alt: [],
  cc: ["TR"]
}, {
  pk: 7086,
  ang: "Khwe",
  lr: "Africa",
  gw: false,
  hc: "NA",
  ln: "Kxoe",
  lc: "xuu",
  ld: "ltr",
  alt: ["!Hukwe", "Black Bushman", "Cazama", "Glanda-Khwe", "Kxoe", "Kxoedam", "Schekere", "Vazama", "Water Bushmen", "Xu", "Xuhwe", "Zama", "Mbarakwena", "Mbarakwengo", "Basarwa", "Khoe", "Barakwena", "Barakwengo", "Mbara Kwengo", "Buga-Khwe", "Tannekwe", "Gani-Khwe", "Bukakhwe", "Buga-Kxoe (||Ani-Khoe)", "Buga-Kxoe", "||Xom-Kxoe", "||Xo-Kxoe", "||Anikxoe", "||Anikhwe", "\"River Bushman\"", "||Ani", "Boga"],
  cc: ["ZM", "NA"]
}, {
  pk: 7805,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "BW",
  ln: "Kwedam",
  lc: "xuu-x-kwedam",
  ld: "ltr",
  alt: [],
  cc: ["BW"]
}, {
  pk: 7087,
  ang: "Venetic",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Venetic",
  lc: "xve",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 7088,
  ang: "Kamviri",
  lr: "Asia",
  gw: false,
  hc: "AF",
  ln: "\u06A9\u0627\u0645\u0648\u064A\u0631\u064A",
  lc: "xvi",
  ld: "ltr",
  alt: ["Kamik", "Lamertiviri"],
  cc: ["AF"]
}, {
  pk: 7089,
  ang: "Vandalic",
  lr: "Europe",
  gw: false,
  hc: "ES",
  ln: "Vandalic",
  lc: "xvn",
  ld: "ltr",
  alt: [],
  cc: ["ES"]
}, {
  pk: 7090,
  ang: "Volscian",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Volscian",
  lc: "xvo",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 7091,
  ang: "Vestinian",
  lr: "Europe",
  gw: false,
  hc: "IT",
  ln: "Vestinian",
  lc: "xvs",
  ld: "ltr",
  alt: [],
  cc: ["IT"]
}, {
  pk: 7092,
  ang: "Kwaza",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Kwaza",
  lc: "xwa",
  ld: "ltr",
  alt: ["Coaia", "Koai\xE1", "Koaya", "Quai\xE1"],
  cc: ["BR"]
}, {
  pk: 7093,
  ang: "Woccon",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Woccon",
  lc: "xwc",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 7094,
  ang: "Wadi Wadi",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Wadi Wadi",
  lc: "xwd",
  ld: "ltr",
  alt: ["Biangil", "Dacournditch", "Wathiwathi", "Wattewatte", "Watthiwatthi", "Watty-watty", "Withaija", "Woani", "Wohdi Wohdi", "Woonyi", "Wotti-wotti"],
  cc: ["AU"]
}, {
  pk: 7095,
  ang: "Gbe, Xwela",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Xwela Gbe",
  lc: "xwe",
  ld: "ltr",
  alt: ["Houeda", "Peda", "Phera", "Xwela", "Xwela-Gba"],
  cc: ["BJ"]
}, {
  pk: 7096,
  ang: "Kwegu",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Kwegu",
  lc: "xwg",
  ld: "ltr",
  alt: ["Bacha", "Koegu", "Kwegi", "Menja", "Nidi", "Yidinich (Yidi)", "Yidinit"],
  cc: ["ET"]
}, {
  pk: 7097,
  ang: "Wangkumara",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Wangkumara",
  lc: "xwk",
  ld: "ltr",
  alt: ["Wangumarra", "Wongkumara"],
  cc: ["AU"]
}, {
  pk: 7098,
  ang: "Gbe, Western Xwla",
  lr: "Africa",
  gw: false,
  hc: "BJ",
  ln: "Western Xwla Gbe",
  lc: "xwl",
  ld: "ltr",
  alt: ["Phla", "Xwla", "Xwla-Gbe"],
  cc: ["BJ", "TG"]
}, {
  pk: 7099,
  ang: "Written Oirat",
  lr: "Asia",
  gw: false,
  hc: "MN",
  ln: "Written Oirat",
  lc: "xwo",
  ld: "ltr",
  alt: [],
  cc: ["MN"]
}, {
  pk: 7100,
  ang: "Kwerba Mamberamo",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kwerba Mamberamo",
  lc: "xwr",
  ld: "ltr",
  alt: ["Napok", "Nobuk", "Nogukwabai", "Nopuk", "Nopukw", "Tatsewalem"],
  cc: ["ID"]
}, {
  pk: 7101,
  ang: "Boro",
  lr: "Africa",
  gw: false,
  hc: "GH",
  ln: "Boro (Ghana)",
  lc: "xxb",
  ld: "ltr",
  alt: [],
  cc: ["GH"]
}, {
  pk: 7102,
  ang: "Ke\u2019o",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Ke'o",
  lc: "xxk",
  ld: "ltr",
  alt: ["Nage-Keo"],
  cc: ["ID"]
}, {
  pk: 7103,
  ang: "Minkin",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Minkin",
  lc: "xxm",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 7104,
  ang: "Tambora",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tambora",
  lc: "xxt",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 7105,
  ang: "Yalakalore",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Yalakalore",
  lc: "xyl",
  ld: "ltr",
  alt: [],
  cc: ["BR"]
}, {
  pk: 7106,
  ang: "Yorta Yorta",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yorta Yorta",
  lc: "xyy",
  ld: "ltr",
  alt: ["Arramouro", "Bangerang", "Gunbowerooranditchgoole", "Gunbowers", "Jotijota", "Kwart Kwart", "Moira", "Ngarrimouro", "Ngarrimowro", "Unungun", "Wol-Lithiga", "Woollathura", "Yoorta", "Yota Yota"],
  cc: ["AU"]
}, {
  pk: 7107,
  ang: "Zhang-Zhung",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Zhang-Zhung",
  lc: "xzh",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7108,
  ang: "Zemgalian",
  lr: "Europe",
  gw: false,
  hc: "LV",
  ln: "Zemgalian",
  lc: "xzm",
  ld: "ltr",
  alt: [],
  cc: ["LV"]
}, {
  pk: 7109,
  ang: "Ancient Zapotec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Ancient Zapotec",
  lc: "xzp",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 7110,
  ang: "Yaminahua",
  lr: "Americas",
  gw: false,
  hc: "PE",
  ln: "Yaminahua",
  lc: "yaa",
  ld: "ltr",
  alt: ["Jaminawa", "Yamanawa", "Yaminawa", "Jaminaw\xE1", "Yamin\xE1wa", "Yuminahua", "Morunahua", "Chitonahua (Foredafa)", "Horudahua", "Horunahua", "Moronahua"],
  cc: ["BR", "PE", "BO"]
}, {
  pk: 7111,
  ang: "Yuhup",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Yuhup",
  lc: "yab",
  ld: "ltr",
  alt: ["Mak\xFA-Yahup", "Yahup", "Yahup Mak\xFA", "Y\xEBhup", "Maku"],
  cc: ["BR"]
}, {
  pk: 7112,
  ang: "Yali, Pass Valley",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Pass Valley Yali",
  lc: "yac",
  ld: "ltr",
  alt: ["Abendago", "North Ngalik", "Pass Valley", "Western Yali", "Yaly"],
  cc: ["ID"]
}, {
  pk: 7113,
  ang: "Yagua",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Yagua",
  lc: "yad",
  ld: "ltr",
  alt: ["Llagua", "Nijyam\xEF\xEF Nikyejaada", "Yahua", "Yava", "Yegua"],
  cc: ["BR", "PE", "CO"]
}, {
  pk: 7114,
  ang: "Pum\xE9",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "Pum\xE9",
  lc: "yae",
  ld: "ltr",
  alt: ["Llaruro", "Yaruru", "Yuap\xEDn"],
  cc: ["VE"]
}, {
  pk: 7115,
  ang: "Yaka",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Yaka (Democratic Republic of Congo)",
  lc: "yaf",
  ld: "ltr",
  alt: ["Iaca", "Iaka", "Iyaka"],
  cc: ["CD"]
}, {
  pk: 7953,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Mikagnya",
  lc: "yaf-x-mikagnya",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7116,
  ang: "Y\xE1mana",
  lr: "Americas",
  gw: false,
  hc: "CL",
  ln: "Y\xE1mana",
  lc: "yag",
  ld: "ltr",
  alt: ["Yahgan", "Tequenica", "Yag\xE1n", "Yaghan"],
  cc: ["CL"]
}, {
  pk: 7117,
  ang: "Yazgulyam",
  lr: "Asia",
  gw: false,
  hc: "TJ",
  ln: "Yazgulyam",
  lc: "yah",
  ld: "ltr",
  alt: ["Iazgulem", "Yazghulomi", "Yazgulam", "Yazgulyami"],
  cc: ["TJ"]
}, {
  pk: 7118,
  ang: "Yagnobi",
  lr: "Asia",
  gw: false,
  hc: "TJ",
  ln: "Yagnobi",
  lc: "yai",
  ld: "ltr",
  alt: ["Yaghnabi", "Yaghnobi", "Yaghnubi", "Yagnabi", "Yagnob", "Yagnubi"],
  cc: ["TJ"]
}, {
  pk: 7119,
  ang: "Banda-Yangere",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Banda-Yangere",
  lc: "yaj",
  ld: "ltr",
  alt: ["Yangere", "Yanguere"],
  cc: ["CF"]
}, {
  pk: 7120,
  ang: "Yakama",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Yakama",
  lc: "yak",
  ld: "ltr",
  alt: ["Ichishk\xEDin"],
  cc: ["US"]
}, {
  pk: 7121,
  ang: "Yalunka",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Yalunka",
  lc: "yal",
  ld: "ltr",
  alt: ["Dialonke", "Djallonke", "Dyalonke", "Jalonke", "Jalunga", "Yalunke", "Kjalonke", "Dialonk\xE9", "Jalonk\xE9", "Bafing"],
  cc: ["ML", "SN", "GN", "SL"]
}, {
  pk: 7122,
  ang: "Yamba",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Yamba",
  lc: "yam",
  ld: "ltr",
  alt: ["Bebaroe", "Boenga Ko", "Kakayamba", "Mbubem", "Muzok", "Swe'nga", "Yang", "Bom", "Fam", "Gamfe", "Gom", "Gwembe", "Ngung", "Ntim", "Nwa", "Rom", "Saam", "Sih"],
  cc: ["CM", "NG"]
}, {
  pk: 7123,
  ang: "Mayangna",
  lr: "Americas",
  gw: false,
  hc: "NI",
  ln: "Mayangna",
  lc: "yan",
  ld: "ltr",
  alt: ["Sumu", "Panamahka (Panamaca)", "Tuahka (Taguasca)"],
  cc: ["HN", "NI"]
}, {
  pk: 7124,
  ang: "Yao",
  lr: "Africa",
  gw: false,
  hc: "MW",
  ln: "Yao",
  lc: "yao",
  ld: "ltr",
  alt: ["Achawa", "Adsawa", "Adsoa", "Ajawa", "Ayao", "Ayawa", "Ayo", "Chiyao", "Djao", "Haiao", "Hiao", "Hyao", "Jao", "Veiao", "Wajao", "Ciyao", "Hajao", "Kiyao", "Chichawa", "Tunduru Yao", "Chikonono (Cikonono)", "Machinga", "Makale (Cimakale)", "Mangochi", "Massaninga (Cimassaninga)"],
  cc: ["MZ", "TZ", "ZW", "MW"]
}, {
  pk: 7125,
  ang: "Yapese",
  lr: "Pacific",
  gw: false,
  hc: "FM",
  ln: "Yapese",
  lc: "yap",
  ld: "ltr",
  alt: [],
  cc: ["US", "FM"]
}, {
  pk: 7126,
  ang: "Yaqui",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Yaqui",
  lc: "yaq",
  ld: "ltr",
  alt: [],
  cc: ["MX", "US"]
}, {
  pk: 7127,
  ang: "Yabarana",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "Yabarana",
  lc: "yar",
  ld: "ltr",
  alt: ["Yauarana", "Yawarana", "Wokiare (Guaiquiare)", "Uaiquiare", "Curasicana (Orechicano)", "Guayqueri"],
  cc: ["VE"]
}, {
  pk: 7128,
  ang: "Nugunu",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Nugunu (Cameroon)",
  lc: "yas",
  ld: "ltr",
  alt: ["Behie", "Beke", "Gounou", "Gunu", "Nu Gunu", "Ombessa", "Yambasa", "Yambassa"],
  cc: ["CM"]
}, {
  pk: 7129,
  ang: "Yambeta",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Yambeta",
  lc: "yat",
  ld: "ltr",
  alt: ["Njambeta", "Yambetta", "Nigii (Nigi)", "Kibum", "Nedek (Begi-Nibum)"],
  cc: ["CM"]
}, {
  pk: 7130,
  ang: "Yuwana",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "Yuwana",
  lc: "yau",
  ld: "ltr",
  alt: ["Chicano", "Chikano", "Hoti", "Jodi", "Joti", "Waruwaru", "Yoana", "Yuana"],
  cc: ["VE"]
}, {
  pk: 7131,
  ang: "Yangben",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Yangben",
  lc: "yav",
  ld: "ltr",
  alt: ["Central Yambassa", "Kalong", "Nuasue", "Nukalonge", "Nutanga", "Numende"],
  cc: ["CM"]
}, {
  pk: 7132,
  ang: "Yawalapit\xED",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Yawalapit\xED",
  lc: "yaw",
  ld: "ltr",
  alt: ["Jaulapiti", "Yaulapiti"],
  cc: ["BR"]
}, {
  pk: 7133,
  ang: "Yauma",
  lr: "Africa",
  gw: false,
  hc: "AO",
  ln: "Yauma",
  lc: "yax",
  ld: "ltr",
  alt: [],
  cc: ["ZM", "AO"]
}, {
  pk: 7134,
  ang: "Agwagwune",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Agwagwune",
  lc: "yay",
  ld: "ltr",
  alt: ["Agwaguna", "Akurakura", "Gwune", "Okurikan", "Akunakuna", "Abayongo (Bayino)", "Abini (Abiri)", "Adim (Dim)", "Bayono", "Erei (\"Enna\")", "Etono (Etuno)", "Ezei", "Obini", "Odim"],
  cc: ["NG"]
}, {
  pk: 7135,
  ang: "Lokaa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Lokaa",
  lc: "yaz",
  ld: "ltr",
  alt: ["Loke", "Loko", "Luko", "Yak\xF6"],
  cc: ["NG"]
}, {
  pk: 7136,
  ang: "Yala",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Yala",
  lc: "yba",
  ld: "ltr",
  alt: ["Iyala", "Nkum Akpambe (Yala Obubra)", "Nkum (Yala Ikom)"],
  cc: ["NG"]
}, {
  pk: 7137,
  ang: "Yemba",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Yemba",
  lc: "ybb",
  ld: "ltr",
  alt: ["Atsang-Bangwa", "Bafou", "Bamileke-Yemba", "Dschang", "Tchang", "Foreke Dschang (Dschang)"],
  cc: ["CM"]
}, {
  pk: 7138,
  ang: "Yugur, West",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u897F\u90E8\u88D5\u56FA\u8BED",
  lc: "ybe",
  ld: "ltr",
  alt: ["Sari Yogur", "Sarig", "Sarygh Uygur", "Sary-Uighur", "Ya Lu", "Yellow Uighur", "Yugu", "Yuku"],
  cc: ["CN"]
}, {
  pk: 7139,
  ang: "Yakkha",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Yakha",
  lc: "ybh",
  ld: "ltr",
  alt: ["Yakkhaba", "Dewansala", "Yakkhaba Cea", "Yakkhaba Sala", "Yakthomba", "Eastern Yakkha (Ilam)", "Northern Yakkha (Sankhuwasabha)", "Panchthar", "Southern Yakkha (Dhankuta)"],
  cc: ["NP"]
}, {
  pk: 7140,
  ang: "Yamphu",
  lr: "Asia",
  gw: false,
  hc: "NP",
  ln: "Yamphu",
  lc: "ybi",
  ld: "ltr",
  alt: ["Yamphe", "Yamphu Kha", "Yamphu Rai"],
  cc: ["NP"]
}, {
  pk: 7141,
  ang: "Hasha",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Hasha",
  lc: "ybj",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 7142,
  ang: "Bokha",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Bokha",
  lc: "ybk",
  ld: "ltr",
  alt: ["Akapa", "Aphu", "Black Muji", "Bokho", "Flowery Phula", "Hei Muji", "Hua Phula", "Lao Phula", "Pao Tle"],
  cc: ["CN"]
}, {
  pk: 7143,
  ang: "Yukuben",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Yukuben",
  lc: "ybl",
  ld: "ltr",
  alt: ["Ayikiben", "Balaabe", "Balaaben", "Boritsu", "Gohum", "Nyikobe", "Nyikuben", "Uuhum", "Uuhum-Gigi", "Oohum", "Uhumkhegi"],
  cc: ["CM", "NG"]
}, {
  pk: 7144,
  ang: "Yaben",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yaben",
  lc: "ybm",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7145,
  ang: "Yaba\xE2na",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Yaba\xE2na",
  lc: "ybn",
  ld: "ltr",
  alt: ["Jabaana", "Yabarana"],
  cc: ["BR"]
}, {
  pk: 7146,
  ang: "Yabong",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yabong",
  lc: "ybo",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7147,
  ang: "Yawiyo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yawiyo",
  lc: "ybx",
  ld: "ltr",
  alt: ["Yabio"],
  cc: ["PG"]
}, {
  pk: 7148,
  ang: "Yaweyuha",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yaweyuha",
  lc: "yby",
  ld: "ltr",
  alt: ["Yabiyufa", "Yawiyuha"],
  cc: ["PG"]
}, {
  pk: 7149,
  ang: "Chesu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u8F66\u82CF",
  lc: "ych",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7150,
  ang: "Lolopo",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u502E\u502E\u6CFC",
  lc: "ycl",
  ld: "ltr",
  alt: ["Bai Yi", "Central Yi", "Gaoshanzu", "Hei Yi", "Lolopho", "Lulupu", "Luolu", "Shuangbai Lolopo", "Yao'an Lolopo", "Nanhua Lolopo"],
  cc: ["CN"]
}, {
  pk: 7151,
  ang: "Yucuna",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Yucuna",
  lc: "ycn",
  ld: "ltr",
  alt: ["Matapi", "Yucuna-Matapi", "Yukuna"],
  cc: ["CO"]
}, {
  pk: 7152,
  ang: "Chepya",
  lr: "Asia",
  gw: false,
  hc: "LA",
  ln: "Chepya",
  lc: "ycp",
  ld: "ltr",
  alt: [],
  cc: ["LA"]
}, {
  pk: 7153,
  ang: "Yanda",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yanda",
  lc: "yda",
  ld: "ltr",
  alt: ["Janda", "Yunda"],
  cc: ["AU"]
}, {
  pk: 7154,
  ang: "Yiddish, Eastern",
  lr: "Asia",
  gw: false,
  hc: "IL",
  ln: "\u05D9\u05D9\u05D3\u05D9\u05E9 \u05D4\u05DE\u05D6\u05E8\u05D7\u05D9",
  lc: "ydd",
  ld: "ltr",
  alt: ["Judeo-German"],
  cc: ["AZ", "DE", "HU", "IL", "KZ", "CZ", "PL", "CH", "US", "CA", "GE", "KG", "MD", "TM"]
}, {
  pk: 7155,
  ang: "Yangum Dey",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yangum Dey",
  lc: "yde",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7156,
  ang: "Yidgha",
  lr: "Asia",
  gw: false,
  hc: "PK",
  ln: "\u06CC\u062F\u063A\u06C1",
  lc: "ydg",
  ld: "ltr",
  alt: ["Lutkuhwar", "Yidga", "Yudga", "Yudgha"],
  cc: ["PK"]
}, {
  pk: 7157,
  ang: "Yoidik",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yoidik",
  lc: "ydk",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7158,
  ang: "Ravula",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Ravula",
  lc: "yea",
  ld: "ltr",
  alt: ["Adiya", "Adiyan", "Iryavula", "Panjiri Yerava", "Yerava", "Yoruba", "Pani Yerava"],
  cc: ["IN"]
}, {
  pk: 7159,
  ang: "Yeniche",
  lr: "Europe",
  gw: false,
  hc: "DE",
  ln: "Yeniche",
  lc: "yec",
  ld: "ltr",
  alt: ["German Travellers", "Jenisch", "Yenishe"],
  cc: ["DE"]
}, {
  pk: 7160,
  ang: "Yimas",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yimas",
  lc: "yee",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7161,
  ang: "Yevanic",
  lr: "Asia",
  gw: false,
  hc: "IL",
  ln: "\u05D9\u05D5\u05D5\u05E0\u05D9\u05D8\u05D9\u05E7\u05D4",
  lc: "yej",
  ld: "rtl",
  alt: ["Judeo-Greek", "Yevanitika"],
  cc: ["IL"]
}, {
  pk: 7162,
  ang: "Yela",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Yela",
  lc: "yel",
  ld: "ltr",
  alt: ["Boyela", "Kutu"],
  cc: ["CD"]
}, {
  pk: 7163,
  ang: "Tarok",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Tarok",
  lc: "yer",
  ld: "ltr",
  alt: ["Appa", "Yergam", "Yergum", "Itarok (Plain Tarok)", "Izini (Hill Tarok)"],
  cc: ["NG"]
}, {
  pk: 7164,
  ang: "Nyankpa",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Nyankpa",
  lc: "yes",
  ld: "ltr",
  alt: ["Nyenkpa", "Yasgua", "Engbe (Barde)", "Gitata", "Bede", "Ejira (Tattara)", "Ogbom (Buzi)", "Ejung (Panda)"],
  cc: ["NG"]
}, {
  pk: 7165,
  ang: "Yetfa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Yetfa",
  lc: "yet",
  ld: "ltr",
  alt: ["Biaksi", "Inisine"],
  cc: ["ID", "PG"]
}, {
  pk: 7166,
  ang: "Yerukula",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Yerukula",
  lc: "yeu",
  ld: "ltr",
  alt: ["Erukala", "Eruku Bhasha", "Korava", "Korchi", "Kurru Bhasha", "Kurutha", "Yarukula", "Yerkula", "Yerukala", "Yerukala-Korava", "Yerukla", "Yerukula-Bhasha"],
  cc: ["IN"]
}, {
  pk: 7700,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Kuncherukala",
  lc: "yeu-x-kunche",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7167,
  ang: "Yapunda",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yapunda",
  lc: "yev",
  ld: "ltr",
  alt: ["Reiwo"],
  cc: ["PG"]
}, {
  pk: 7168,
  ang: "Yeyi",
  lr: "Africa",
  gw: false,
  hc: "BW",
  ln: "Yeyi",
  lc: "yey",
  ld: "ltr",
  alt: ["Ciyei", "Seyeyi", "Shiyeyi", "Yeei", "Koba", "Kuba", "Sekoba"],
  cc: ["BW", "NA"]
}, {
  pk: 7169,
  ang: "Yangum Gel",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yangum Gel",
  lc: "ygl",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7170,
  ang: "Yagomi",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yagomi",
  lc: "ygm",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7171,
  ang: "Gepo",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u845B\u6CFC\u8BED",
  lc: "ygp",
  ld: "ltr",
  alt: ["Baiyi", "Gepu", "Guo", "Gupu", "Guzu", "Jiantouyi", "K\xF6pu", "Nasu", "Pingtouyi"],
  cc: ["CN"]
}, {
  pk: 7172,
  ang: "Yagaria",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yagaria",
  lc: "ygr",
  ld: "ltr",
  alt: ["Hira", "Hua (Huva)"],
  cc: ["PG"]
}, {
  pk: 8481,
  ang: "Iyau",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Iyau",
  lc: "ygr-x-iyau",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7173,
  ang: "Yolngu Sign Language",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yol\u014Bu Sign Language",
  lc: "ygs",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 7174,
  ang: "Yugul",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yugul",
  lc: "ygu",
  ld: "ltr",
  alt: ["Jokul", "Yikil", "Yikul", "Yookala", "Yookil", "Yookull", "Yukul"],
  cc: ["AU"]
}, {
  pk: 7175,
  ang: "Yagwoia",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yagwoia",
  lc: "ygw",
  ld: "ltr",
  alt: ["Kokwaiyakwa", "Yeghuye", "Iwalaqamalje", "Yeqwangilje", "Hiqwaye", "Hiqwase", "Gwase"],
  cc: ["PG"]
}, {
  pk: 7176,
  ang: "Buyang, Baha",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5DF4\u54C8\u8BED",
  lc: "yha",
  ld: "ltr",
  alt: ["Buyang", "Buyang Zhuang", "Guangnan Buyang", "Western Buyang"],
  cc: ["CN"]
}, {
  pk: 7177,
  ang: "Arabic, Judeo-Iraqi",
  lr: "Asia",
  gw: false,
  hc: "IL",
  ln: "\u05E2\u05D9\u05E8\u05D0\u05E7\u05D9\u05EA \u05D9\u05D4\u05D5\u05D3\u05D9\u05EA",
  lc: "yhd",
  ld: "rtl",
  alt: ["Arabi", "Iraqi Judeo-Arabic", "Jewish Iraqi-Baghdadi Arabic", "Yahudic"],
  cc: ["IQ", "IL", "GB"]
}, {
  pk: 7791,
  ang: "Judeo Arabic",
  lr: "Asia",
  gw: false,
  hc: "IQ",
  ln: "\u0639\u0631\u0628\u064A\u0629 \u064A\u0647\u0648\u062F\u064A\u0629",
  lc: "yhd-x-judeoarabic",
  ld: "rtl",
  alt: [],
  cc: []
}, {
  pk: 7178,
  ang: "Phowa, Hlepho",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Hlepho Phowa",
  lc: "yhl",
  ld: "ltr",
  alt: ["Abo", "Boren", "Bozi", "Conehead Phula", "Cowtail Phula", "Daizhanpho", "Digaopho", "Flowery Phula", "Hua Phula", "Jiantou Phula", "Minjia", "Niuweiba Phula", "Paola", "Pho", "Phula", "Sandaohong Phula", "Shaoji Phula", "Sifter Basket Phula", "Thrice Striped Red Phula", "Xiuba"],
  cc: ["CN"]
}, {
  pk: 7512,
  ang: "Yan-nha\u014Bu Sign Language",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yan-nha\u014Bu Sign Language",
  lc: "yhs",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 7179,
  ang: "Yiddish",
  lr: "",
  gw: false,
  hc: "",
  ln: "\u05D9\u05D9\u05B4\u05D3\u05D9\u05E9",
  lc: "yi",
  ld: "rtl",
  alt: [],
  cc: []
}, {
  pk: 7180,
  ang: "Yinggarda",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yinggarda",
  lc: "yia",
  ld: "ltr",
  alt: ["Ingara", "Ingarda", "Ingarra", "Ingarrah", "Inggarda", "Inparra", "Jinggarda", "Kakarakala", "Yingkarta"],
  cc: ["AU"]
}, {
  pk: 7181,
  ang: "Ache",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u963F\u8F66",
  lc: "yif",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7182,
  ang: "Nasu, Wusa",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4E4C\u6492\u7EB3\u82CF\u8BED",
  lc: "yig",
  ld: "ltr",
  alt: ["Eastern Yi", "Dafang"],
  cc: ["CN"]
}, {
  pk: 7183,
  ang: "Yiddish, Western",
  lr: "Europe",
  gw: false,
  hc: "DE",
  ln: "Western Yiddish",
  lc: "yih",
  ld: "ltr",
  alt: ["Judeo-German", "Yiddish", "Yidish"],
  cc: ["DE"]
}, {
  pk: 7184,
  ang: "Yidiny",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yidiny",
  lc: "yii",
  ld: "ltr",
  alt: ["Boolboora", "Deba", "Eneby", "Gerrah", "Gijow", "Gillah", "Guwamal", "Idin Idindji", "Idinji", "Idin-Wudjar", "Indindji", "Jidindji", "Kitba", "Maimbie", "Mungera Ohalo", "Pegullo-Bura", "Warra-Warra", "Warryboora", "Woggil", "Yetinji", "Yiddinji", "Yidin", "Yidindji", "Yidini", "Yitintyi", "Yukkaburra"],
  cc: ["AU"]
}, {
  pk: 7185,
  ang: "Yindjibarndi",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yindjibarndi",
  lc: "yij",
  ld: "ltr",
  alt: ["Jindjibandi", "Yinjtjipartnti"],
  cc: ["AU"]
}, {
  pk: 7186,
  ang: "Lalo, Dongshanba",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4E1C\u5C71\u575D\u814A\u7F57\u8BED",
  lc: "yik",
  ld: "ltr",
  alt: ["Lalu", "Lalupa", "Lalupu"],
  cc: ["CN"]
}, {
  pk: 7187,
  ang: "Naga, Yimchungru",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Yimchungru Naga",
  lc: "yim",
  ld: "ltr",
  alt: ["Tozhuma", "Yachumi", "Yanchunger", "Yimchunger", "Yimchungre", "Yimchungru"],
  cc: ["IN", "MM"]
}, {
  pk: 7188,
  ang: "Yinchia",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Yinchia",
  lc: "yin",
  ld: "ltr",
  alt: ["Black Riang", "Ranei", "Striped Karen", "Yin Kya"],
  cc: ["MM"]
}, {
  pk: 7189,
  ang: "Pholo",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Pholo",
  lc: "yip",
  ld: "ltr",
  alt: ["Black Phula", "Flowery Phula", "Phu", "Phula"],
  cc: ["CN"]
}, {
  pk: 7190,
  ang: "Miqie",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5BC6\u5BDF",
  lc: "yiq",
  ld: "ltr",
  alt: ["Micha", "Mielang", "Minqi"],
  cc: ["CN"]
}, {
  pk: 7191,
  ang: "Awyu, North",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "North Awyu",
  lc: "yir",
  ld: "ltr",
  alt: ["Awyu", "Djair", "Dyair", "Yair"],
  cc: ["ID"]
}, {
  pk: 7192,
  ang: "Yis",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yis",
  lc: "yis",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7193,
  ang: "Lalu, Eastern",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4E1C\u814A\u9C81\u8BED",
  lc: "yit",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7194,
  ang: "Awu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u963F\u9C81",
  lc: "yiu",
  ld: "ltr",
  alt: ["Luowu", "Luwu", "Northern Awu", "Southern Awu"],
  cc: ["CN"]
}, {
  pk: 8012,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Long",
  lc: "yiu-x-long",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7195,
  ang: "Nisu, Northern",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5317\u5C3C\u82CF\u8BED",
  lc: "yiv",
  ld: "ltr",
  alt: ["E-Xin Yi", "Nasu", "Nisu"],
  cc: ["CN"]
}, {
  pk: 7196,
  ang: "Axi",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u963F\u7EC6",
  lc: "yix",
  ld: "ltr",
  alt: ["Ahi", "Axibo", "Axipo"],
  cc: ["CN"]
}, {
  pk: 7197,
  ang: "Azhe",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u963F\u54F2",
  lc: "yiz",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7198,
  ang: "Yakan",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Yakan",
  lc: "yka",
  ld: "ltr",
  alt: ["Yacan"],
  cc: ["MY", "PH"]
}, {
  pk: 7199,
  ang: "Yukaghir, Northern",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u0421\u0435\u0432\u0435\u0440\u043D\u043E\u044E\u043A\u0430\u0433\u0438\u0440\u0441\u043A\u0438\u0439",
  lc: "ykg",
  ld: "ltr",
  alt: ["Jukagir", "Northern Yukagir", "Odul", "Tundra", "Tundre", "Wadul", "Yukagir"],
  cc: ["RU"]
}, {
  pk: 7200,
  ang: "Yoke",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Yoke",
  lc: "yki",
  ld: "ltr",
  alt: ["Jauke", "Pauwi", "Yauke", "Yoki"],
  cc: ["ID"]
}, {
  pk: 7201,
  ang: "Yakaikeke",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yakaikeke",
  lc: "ykk",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7202,
  ang: "Khlula",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Khlula",
  lc: "ykl",
  ld: "ltr",
  alt: ["Alapha", "Black Phula", "Black Zokhuo", "Hei Phula", "Mo", "Namupha", "Pao", "Phulapha", "Shaoji Phula", "Sifter Basket Phula", "Tula", "Zokhuo Na", "Muchang", "Dalishu", "Liujing"],
  cc: ["CN"]
}, {
  pk: 7203,
  ang: "Kap",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kap",
  lc: "ykm",
  ld: "ltr",
  alt: ["Ali"],
  cc: ["PG"]
}, {
  pk: 7204,
  ang: "Kua-nsi",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u8DE8\u6069\u65AF\u8BDD",
  lc: "ykn",
  ld: "ltr",
  alt: ["Baiyi ren", "Kua'ensi", "Kua'eshi"],
  cc: ["CN"]
}, {
  pk: 7205,
  ang: "Yasa",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Yasa",
  lc: "yko",
  ld: "ltr",
  alt: ["Bongwe", "Lyaasa", "Maasa", "Yassa", "Lyassa", "Iyassa", "Avandje"],
  cc: ["CM", "GQ"]
}, {
  pk: 7206,
  ang: "Yekora",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yekora",
  lc: "ykr",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7207,
  ang: "Kathu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u560E\u82CF\u8BDD",
  lc: "ykt",
  ld: "ltr",
  alt: ["Gasu"],
  cc: ["CN"]
}, {
  pk: 7208,
  ang: "Kuamasi",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u8DE8\u739B\u65AF\u8BDD",
  lc: "yku",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7209,
  ang: "Yakoma",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Yakoma",
  lc: "yky",
  ld: "ltr",
  alt: [],
  cc: ["CF"]
}, {
  pk: 7210,
  ang: "Yaul",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yaul",
  lc: "yla",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7211,
  ang: "Yaleba",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yaleba",
  lc: "ylb",
  ld: "ltr",
  alt: ["Aisana"],
  cc: ["PG"]
}, {
  pk: 7212,
  ang: "Yele",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yele",
  lc: "yle",
  ld: "ltr",
  alt: ["Rossel", "Yela", "Yelejong", "Yeletnye", "Yelidnye", "Daminyu"],
  cc: ["PG"]
}, {
  pk: 7213,
  ang: "Yelogu",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yelogu",
  lc: "ylg",
  ld: "ltr",
  alt: ["Buiamanambu", "Kaunga"],
  cc: ["PG"]
}, {
  pk: 7214,
  ang: "Yali, Angguruk",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Angguruk Yali",
  lc: "yli",
  ld: "ltr",
  alt: ["Angguruk", "Northern Yali", "Yalimo"],
  cc: ["ID"]
}, {
  pk: 7215,
  ang: "Yil",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yil",
  lc: "yll",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7216,
  ang: "Limi",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Limi",
  lc: "ylm",
  ld: "ltr",
  alt: ["Liumi"],
  cc: ["CN"]
}, {
  pk: 7217,
  ang: "Buyang, Langnian",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u90CE\u5FF5\u5E03\u592E\u8BED",
  lc: "yln",
  ld: "ltr",
  alt: ["Buozaang", "Buyang Zhuang", "Eastern Buyang", "E'cun Buyang"],
  cc: ["CN"]
}, {
  pk: 7218,
  ang: "Naluo",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u7EB3\u7F57",
  lc: "ylo",
  ld: "ltr",
  alt: ["Gan Yi", "Laluo", "Naruo", "Shui Yi", "Shuitian"],
  cc: ["CN"]
}, {
  pk: 7219,
  ang: "Aribwaung",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Aribwaung",
  lc: "ylu",
  ld: "ltr",
  alt: ["Aribwaungg", "Jaloc", "Yalu"],
  cc: ["PG"]
}, {
  pk: 7220,
  ang: "Nyel\xE2yu",
  lr: "Pacific",
  gw: false,
  hc: "NC",
  ln: "Ny\xE2layu",
  lc: "yly",
  ld: "ltr",
  alt: ["Nielaiou", "Nielaiu", "Ny\xE2layu", "Puma", "Yalasu", "Arama", "Tiari-Balade"],
  cc: ["NC"]
}, {
  pk: 7221,
  ang: "Yambes",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yambes",
  lc: "ymb",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7222,
  ang: "Muji, Southern",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Southern Muji",
  lc: "ymc",
  ld: "ltr",
  alt: ["Aga", "Khlaka", "Lahi", "Muzi", "Phula", "Tjeki", "Tshebu", "Tshibu", "Ma'andi", "Tongchang", "Yingpan", "Jinhe", "Dazhai", "Gamadi"],
  cc: ["CN"]
}, {
  pk: 7638,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Hua Muji",
  lc: "ymc-x-huamuji",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7223,
  ang: "Muda",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6728\u8FBE",
  lc: "ymd",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7224,
  ang: "Yamongeri",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Yamongeri",
  lc: "ymg",
  ld: "ltr",
  alt: ["Yamongiri"],
  cc: ["CD"]
}, {
  pk: 7225,
  ang: "Mili",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Mili",
  lc: "ymh",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7226,
  ang: "Moji",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Moji",
  lc: "ymi",
  ld: "ltr",
  alt: ["Flathead Phulai", "Muji", "Phula", "Phulawa", "Pingtou Phula", "Luchaichong"],
  cc: ["CN"]
}, {
  pk: 7227,
  ang: "Makwe",
  lr: "Africa",
  gw: false,
  hc: "MZ",
  ln: "Makwe",
  lc: "ymk",
  ld: "ltr",
  alt: ["Kimakwe", "Macue", "Palma", "Coastal Makwe (Palma)"],
  cc: ["MZ", "TZ"]
}, {
  pk: 7228,
  ang: "Iamalele",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Iamalele",
  lc: "yml",
  ld: "ltr",
  alt: ["Yamalele"],
  cc: ["PG"]
}, {
  pk: 7229,
  ang: "Maay",
  lr: "Africa",
  gw: false,
  hc: "SO",
  ln: "Maay",
  lc: "ymm",
  ld: "ltr",
  alt: ["Af-Maay", "Af-Maay Tiri", "Af-May", "Af-Maymay", "Rahanween", "Rahanweyn"],
  cc: ["SO"]
}, {
  pk: 7230,
  ang: "Sunum",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Yamna",
  lc: "ymn",
  ld: "ltr",
  alt: ["Yamna"],
  cc: ["ID"]
}, {
  pk: 7231,
  ang: "Yangum Mon",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yangum Mon",
  lc: "ymo",
  ld: "ltr",
  alt: ["Aiku", "Malek", "Menandon", "Minendon"],
  cc: ["PG"]
}, {
  pk: 7232,
  ang: "Yamap",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yamap",
  lc: "ymp",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7233,
  ang: "Muji, Qila",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Qila Muji",
  lc: "ymq",
  ld: "ltr",
  alt: ["Doka", "Mujitsu", "Phutsu"],
  cc: ["CN"]
}, {
  pk: 7713,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Midi Qi Muji",
  lc: "ymq-x-midiqi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7234,
  ang: "Malasar",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Malasar",
  lc: "ymr",
  ld: "ltr",
  alt: ["Malayar"],
  cc: ["IN"]
}, {
  pk: 7235,
  ang: "Mysian",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Mysian",
  lc: "yms",
  ld: "ltr",
  alt: [],
  cc: ["TR"]
}, {
  pk: 7236,
  ang: "Muji, Northern",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Northern Muji",
  lc: "ymx",
  ld: "ltr",
  alt: ["Bokha", "Hlaka Mujima", "Phula"],
  cc: ["CN"]
}, {
  pk: 7237,
  ang: "Muzi",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Muzi",
  lc: "ymz",
  ld: "ltr",
  alt: ["Mogeha", "Muji"],
  cc: ["CN"]
}, {
  pk: 7238,
  ang: "Aluo",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u963F\u7F57\u8BED",
  lc: "yna",
  ld: "ltr",
  alt: ["Gan Yi", "Laka", "Lila", "Niluo", "Yala"],
  cc: ["CN"]
}, {
  pk: 7239,
  ang: "Lang\u2019e",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u62C9\u4E4C",
  lc: "yne",
  ld: "ltr",
  alt: ["La'u"],
  cc: ["CN"]
}, {
  pk: 7240,
  ang: "Yango",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Yango",
  lc: "yng",
  ld: "ltr",
  alt: ["Gbendere"],
  cc: ["CD"]
}, {
  pk: 7241,
  ang: "Yupik, Naukan",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041D\u0430\u0443\u043A\u0430\u0301\u043D\u0441\u043A\u0438\u0439",
  lc: "ynk",
  ld: "ltr",
  alt: ["Naukan", "Naukanski"],
  cc: ["RU"]
}, {
  pk: 7242,
  ang: "Yangulam",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yangulam",
  lc: "ynl",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7243,
  ang: "Yana",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Yana",
  lc: "ynn",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 7244,
  ang: "Yong",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Yong",
  lc: "yno",
  ld: "ltr",
  alt: ["Nyong"],
  cc: ["TH"]
}, {
  pk: 7245,
  ang: "Yendang",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Yendang",
  lc: "ynq",
  ld: "ltr",
  alt: ["Kuseki", "Nyandang", "Yadang", "Yandang", "Yendam", "Yundum"],
  cc: ["NG"]
}, {
  pk: 7246,
  ang: "Yansi",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Yansi",
  lc: "yns",
  ld: "ltr",
  alt: ["Eyansi", "Eyanzi", "Kiyanzi", "Yans", "Yanzi", "Yeei (Yey)"],
  cc: ["CD"]
}, {
  pk: 7558,
  ang: "Kiangi",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Kiangi",
  lc: "yns-x-kiangi",
  ld: "ltr",
  alt: [],
  cc: ["CD"]
}, {
  pk: 7247,
  ang: "Yahuna",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Yahuna",
  lc: "ynu",
  ld: "ltr",
  alt: ["Datuana", "Opaina", "Ya\xFAna", "Yayuna"],
  cc: ["CO"]
}, {
  pk: 7248,
  ang: "Yoruba",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Yor\xF9b\xE1",
  lc: "yo",
  ld: "ltr",
  alt: ["Ede-Yoruba", "Yariba", "Yooba", "\xC0o", "Bunu (Bini)", "Igbonna"],
  cc: ["BJ", "BF", "GQ", "GH", "NE", "NG", "US", "TG", "SL"]
}, {
  pk: 7249,
  ang: "Yogad",
  lr: "Asia",
  gw: false,
  hc: "PH",
  ln: "Yogad",
  lc: "yog",
  ld: "ltr",
  alt: [],
  cc: ["PH"]
}, {
  pk: 7250,
  ang: "Yonaguni",
  lr: "Asia",
  gw: false,
  hc: "JP",
  ln: "\u4E0E\u90A3\u56FD\u7269\u8A00",
  lc: "yoi",
  ld: "ltr",
  alt: [],
  cc: ["JP"]
}, {
  pk: 7251,
  ang: "Yokuts",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Yokuts",
  lc: "yok",
  ld: "ltr",
  alt: ["Choynumne", "Yowlumne", "Wukchumne", "Tachi", "Chukchansi (Northern Foothill Yokuts)", "Gashowu", "Choinumne (Choinimne)", "Dumna"],
  cc: ["US"]
}, {
  pk: 7252,
  ang: "Yola",
  lr: "Europe",
  gw: false,
  hc: "IE",
  ln: "Yola",
  lc: "yol",
  ld: "ltr",
  alt: [],
  cc: ["IE"]
}, {
  pk: 7253,
  ang: "Yombe",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Yombe",
  lc: "yom",
  ld: "ltr",
  alt: ["Ibinda", "Iombe", "Kiombi", "Kiyombe", "Mbala (Mumbala)", "Vungunya (Kivungunya)", "Yombe Classique"],
  cc: ["CG", "CD", "AO"]
}, {
  pk: 7254,
  ang: "Yongkom",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yongkom",
  lc: "yon",
  ld: "ltr",
  alt: ["Yonggom", "Yongom"],
  cc: ["PG"]
}, {
  pk: 7984,
  ang: "Ilaje",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ilaje",
  lc: "yor-x-ilaje",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7985,
  ang: "Ondo",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ondo",
  lc: "yor-x-ondo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7255,
  ang: "Yotti",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Yotti",
  lc: "yot",
  ld: "ltr",
  alt: ["Yoti"],
  cc: ["NG"]
}, {
  pk: 7256,
  ang: "Yoron",
  lr: "Asia",
  gw: false,
  hc: "JP",
  ln: "\u30E6\u30F3\u30CC\u30D5\u30C8\u30A5\u30D0",
  lc: "yox",
  ld: "ltr",
  alt: [],
  cc: ["JP"]
}, {
  pk: 7257,
  ang: "Yoy",
  lr: "Asia",
  gw: false,
  hc: "TH",
  ln: "Yoy",
  lc: "yoy",
  ld: "ltr",
  alt: ["Dioi", "Jui", "Yoi", "Yooi", "Yooy"],
  cc: ["LA", "TH"]
}, {
  pk: 7258,
  ang: "Phala",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Phala",
  lc: "ypa",
  ld: "ltr",
  alt: ["Black Phula", "Bola", "Hei Phula", "Khapho", "Phula", "Phulepho"],
  cc: ["CN"]
}, {
  pk: 7259,
  ang: "Phowa, Labo",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Labo Phowa",
  lc: "ypb",
  ld: "ltr",
  alt: ["Asaheipho", "Asahopho", "Ekhepho", "Labopho", "Pho", "Phula", "White Phu", "Zemapho"],
  cc: ["CN"]
}, {
  pk: 7260,
  ang: "Phola",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Phola",
  lc: "ypg",
  ld: "ltr",
  alt: ["Bola", "Flowery Phula", "Hua Phula", "Phula", "Phulepho", "Tsha Phula"],
  cc: ["CN"]
}, {
  pk: 7261,
  ang: "Phupha",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Phupha",
  lc: "yph",
  ld: "ltr",
  alt: ["Phula", "Phupho", "Tsapho"],
  cc: ["CN"]
}, {
  pk: 7262,
  ang: "Phuma",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Phuma",
  lc: "ypm",
  ld: "ltr",
  alt: ["Black Muji", "Hei Muji", "Muji", "Paotlo", "Phula", "Phuli", "Shaoji Phula", "Sifter Basket Phula"],
  cc: ["CN"]
}, {
  pk: 7263,
  ang: "Phowa, Ani",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Ani Phowa",
  lc: "ypn",
  ld: "ltr",
  alt: ["Anipho", "Flowery Phu", "Hua Phu", "Laotshipu", "Pho", "Phula", "Daheineng", "Dayongsheng", "Xibeile"],
  cc: ["CN"]
}, {
  pk: 7264,
  ang: "Phola, Alo",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Alo Phola",
  lc: "ypo",
  ld: "ltr",
  alt: ["Bola", "Pula"],
  cc: ["CN"]
}, {
  pk: 7265,
  ang: "Phupa",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Phupa",
  lc: "ypp",
  ld: "ltr",
  alt: ["Hlagho", "Lagh\xEF", "Lala", "Lamu", "La'ou", "Lapa", "Larhwo", "Muzi", "Phula", "Phupha", "Tshebu", "Jiangnanbo", "Xiao Fengkou", "Gamadi", "Da Fengkou", "Baiwushan", "Nuogumi"],
  cc: ["CN"]
}, {
  pk: 7266,
  ang: "Phuza",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Phuza",
  lc: "ypz",
  ld: "ltr",
  alt: ["Hei Phu", "Phu'a", "Phujitsu", "Phula", "Bujibai", "Dabaqi"],
  cc: ["CN"]
}, {
  pk: 7267,
  ang: "Yerakai",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yerakai",
  lc: "yra",
  ld: "ltr",
  alt: ["Yerekai"],
  cc: ["PG"]
}, {
  pk: 7268,
  ang: "Yareba",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yareba",
  lc: "yrb",
  ld: "ltr",
  alt: ["Middle Musa"],
  cc: ["PG"]
}, {
  pk: 7269,
  ang: "Yaour\xE9",
  lr: "Africa",
  gw: false,
  hc: "CI",
  ln: "Yaour\xE9",
  lc: "yre",
  ld: "ltr",
  alt: ["Yaure", "Yohowr\xE9", "Your\xE9"],
  cc: ["CI"]
}, {
  pk: 7270,
  ang: "Yar\xED",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Yar\xED",
  lc: "yri",
  ld: "ltr",
  alt: [],
  cc: ["CO"]
}, {
  pk: 7271,
  ang: "Nenets",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u041D\u0435\u043D\u0435\u0446\u043A\u0438\u0439",
  lc: "yrk",
  ld: "ltr",
  alt: ["Nenec", "Nenetsy", "Nentse", "Yurak", "Yurak Samoyed"],
  cc: ["RU"]
}, {
  pk: 7272,
  ang: "Nhengatu",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Nhengatu",
  lc: "yrl",
  ld: "ltr",
  alt: ["Coastal Tupian", "Geral", "L\xEDngua Geral", "Modern Tup\xED", "\xD1eegat\xFA", "Nheengatu", "Nyengato", "Nyengat\xFA", "Waengatu", "Yeral", "Modern Tupi"],
  cc: ["BR"]
}, {
  pk: 7273,
  ang: "Yirrk-Mel",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yirrk-Mel",
  lc: "yrm",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 7274,
  ang: "Yerong",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u96C5\u90CE\u5E03\u592E\u8BED",
  lc: "yrn",
  ld: "ltr",
  alt: ["Ban Yao", "Da Ia", "Daban Yao", "Eastern Buyang", "Guangxi Buyang", "Ia Hrong", "Iron Yao", "Khyung Buyang", "Liu Yao", "Napo Buyang", "Six Yao", "Tie Yao", "Tu Yao Indigenous Yao", "Yalang", "Yang Khyung", "Yerong Buyang"],
  cc: ["CN"]
}, {
  pk: 7275,
  ang: "Yarsun",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Yarsun",
  lc: "yrs",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 7276,
  ang: "Yarawata",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yarawata",
  lc: "yrw",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7277,
  ang: "Yarluyandi",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yarluyandi",
  lc: "yry",
  ld: "ltr",
  alt: ["Jeljujendi", "Yarleeyandee", "Yelyuyendi"],
  cc: ["AU"]
}, {
  pk: 7278,
  ang: "Yassic",
  lr: "Europe",
  gw: false,
  hc: "HU",
  ln: "Yassic",
  lc: "ysc",
  ld: "ltr",
  alt: [],
  cc: ["HU"]
}, {
  pk: 7279,
  ang: "Samatao",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6492\u6155",
  lc: "ysd",
  ld: "ltr",
  alt: ["Samadu", "Samaduo", "Samou"],
  cc: ["CN"]
}, {
  pk: 7280,
  ang: "Sonaga",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u9501\u5185\u560E\u8BDD",
  lc: "ysg",
  ld: "ltr",
  alt: ["Suoneiga"],
  cc: ["CN"]
}, {
  pk: 7281,
  ang: "Yugoslavian Sign Language",
  lr: "Europe",
  gw: false,
  hc: "RS",
  ln: "Yugoslavian Sign Language",
  lc: "ysl",
  ld: "ltr",
  alt: [],
  cc: ["RS", "SI"]
}, {
  pk: 7282,
  ang: "Sani",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6492\u5C3C",
  lc: "ysn",
  ld: "ltr",
  alt: ["Northern Sani", "Southern Sani"],
  cc: ["CN"]
}, {
  pk: 7283,
  ang: "Nisi",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u57FA\u8AFE\u8A9E (China)",
  lc: "yso",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 8169,
  ang: "Lo Lo",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Lo Lo",
  lc: "yso-x-lolo",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7284,
  ang: "Lolopo, Southern",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5357\u502E\u502E\u6CFC\u8BED",
  lc: "ysp",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7285,
  ang: "Yessan-Mayo",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yessan-Mayo",
  lc: "yss",
  ld: "ltr",
  alt: ["Maio-Yesan", "Mayo-Yesan", "Yasyin", "Yesan", "Yau", "Yaw", "Yawu (Warasai)"],
  cc: ["PG"]
}, {
  pk: 7286,
  ang: "Sanie",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u767D\u5F5D",
  lc: "ysy",
  ld: "ltr",
  alt: ["Bai Lolo", "Bai Yi", "Sa'nguie", "Sanyie", "Shanie", "Shaniepu", "White Yi"],
  cc: ["CN"]
}, {
  pk: 7287,
  ang: "Talu",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4ED6\u9C81",
  lc: "yta",
  ld: "ltr",
  alt: ["Tagu", "Taliu", "Tazhi"],
  cc: ["CN"]
}, {
  pk: 7288,
  ang: "Tanglang",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5802\u90CE\u8BED",
  lc: "ytl",
  ld: "ltr",
  alt: ["Tholo"],
  cc: ["CN"]
}, {
  pk: 7289,
  ang: "Thopho",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Thopho",
  lc: "ytp",
  ld: "ltr",
  alt: ["Black Hat Folk", "Black Phula", "Hei Mao Ren", "Phula"],
  cc: ["CN"]
}, {
  pk: 7290,
  ang: "Yout Wam",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yout Wam",
  lc: "ytw",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7291,
  ang: "Yatay",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yatay",
  lc: "yty",
  ld: "ltr",
  alt: ["Iataj"],
  cc: ["AU"]
}, {
  pk: 7292,
  ang: "Maya, Yucatec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Yucateco",
  lc: "yua",
  ld: "ltr",
  alt: ["Maya", "Yucant\xE1n Maya", "Peninsular Maya", "Yucatan Maya"],
  cc: ["BZ", "MX", "US"]
}, {
  pk: 7293,
  ang: "Yuchi",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Yuchi",
  lc: "yuc",
  ld: "ltr",
  alt: ["Uchean"],
  cc: ["US"]
}, {
  pk: 7294,
  ang: "Arabic, Judeo-Tripolitanian",
  lr: "Asia",
  gw: false,
  hc: "IL",
  ln: "\u05D8\u05E8\u05D9\u05E4\u05D5\u05DC\u05D9\u05D8\u05D0\u05D9\u05EA \u05D9\u05D4\u05D5\u05D3\u05D9\u05EA",
  lc: "yud",
  ld: "rtl",
  alt: ["Jewish Tripolitanian-Libyan Arabic", "Tripolita'it", "Tripolitanian Judeo-Arabic", "Yudi"],
  cc: ["IL"]
}, {
  pk: 7295,
  ang: "Chinese, Yue",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u7CB5\u8A9E",
  lc: "yue",
  ld: "ltr",
  alt: ["Yue", "Yueh", "Gwong Dung Waa", "Yuet Yue", "Yueyu", "Guangfu", "Hong Kong Cantonese", "Shatou", "Shiqi", "Wancheng", "Macau Cantonese", "Chinese Nung", "Ha Xa Phang", "Hai Nam", "Han", "Hoa", "Ki\xE9n", "Liem Chau", "Lowland Nung", "Minh Huong", "Nung", "Ph\xFAc", "Quang Dong", "Samg Phang", "Su\xF2ng Ph\xF3ng", "Tri\xE8u Chau", "Ping", "Yangjiang", "Toishanese", "Toisan", "Tengxian", "Zhongshan", "Taishan", "Schleiyip", "Guangzhou", "Gaolei (Gaoyang)", "Cangwu", "Bobai", "Seiyap", "Siyi (Hoisan)"],
  cc: ["BN", "BE", "CL", "CN", "AR", "TT", "VE", "GY", "HT", "JP", "LA", "MU", "PE", "GB", "MY", "HN", "US", "ZW", "CA", "EC", "SG", "DO", "SR"]
}, {
  pk: 7296,
  ang: "Havasupai-Walapai-Yavapai",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Havasupai-Walapai-Yavapai",
  lc: "yuf",
  ld: "ltr",
  alt: ["Upland Yuman", "Upper Colorado River Yuman", "Hualpai", "Hwalb\xE1y", "Walapai (Hualapai)"],
  cc: ["US"]
}, {
  pk: 7297,
  ang: "Yug",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u042E\u0433\u0441\u043A\u0438\u0439",
  lc: "yug",
  ld: "ltr",
  alt: [],
  cc: ["RU"]
}, {
  pk: 7298,
  ang: "Wajiara",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Yurut\xED",
  lc: "yui",
  ld: "ltr",
  alt: ["Juruti", "Juruti-Tapuia", "Luruty-Tapuya", "Yuriti-Tapuia", "Juriti", "Juriti-Tapuia", "Patsoka", "Totsoca", "Wadzana", "Waijiara masa-wadyana", "Waikana", "Waimas\xE1", "Wayhara", "Yuriti", "Yuruti-Tapuya", "Yurutiye"],
  cc: ["BR", "CO"]
}, {
  pk: 7299,
  ang: "Karkar-Yuri",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Karkar-Yuri",
  lc: "yuj",
  ld: "ltr",
  alt: ["Karkar"],
  cc: ["PG"]
}, {
  pk: 7300,
  ang: "Yuki",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Yuki",
  lc: "yuk",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 7301,
  ang: "Yulu",
  lr: "Africa",
  gw: false,
  hc: "CF",
  ln: "Yulu",
  lc: "yul",
  ld: "ltr",
  alt: ["Youlou"],
  cc: ["CF", "SD"]
}, {
  pk: 7302,
  ang: "Quechan",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Quechan",
  lc: "yum",
  ld: "ltr",
  alt: ["Kechan", "Quecl", "Yuma"],
  cc: ["US"]
}, {
  pk: 7303,
  ang: "Bena",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "\u0181\u0259na (Nigeria)",
  lc: "yun",
  ld: "ltr",
  alt: ["Binna", "Buna", "Ebina", "Ebuna", "Gbinna", "Purra", "Yangeru", "Yongor", "Yungur", "Lala"],
  cc: ["NG", "TZ"]
}, {
  pk: 7304,
  ang: "Yukpa",
  lr: "Americas",
  gw: false,
  hc: "CO",
  ln: "Yukpa",
  lc: "yup",
  ld: "ltr",
  alt: ["Carib Motil\xF3n", "Maco\xEDta", "Northern Motil\xF3n", "Yuco", "Yucpa", "Yuko", "Yupa", "Manso", "Pariri (Yukpa central)", "Yukpa sur (Ca\xF1o Padilla-La Laguna)", "Yikta", "R\xEDo Casacar\xE1 (Iroka)", "Iroka", "Irapa (Yukpa sur)", "Atapshi (Yukpa norte)", "Wasama"],
  cc: ["VE", "CO", "US"]
}, {
  pk: 7305,
  ang: "Yuqui",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Yuqui",
  lc: "yuq",
  ld: "ltr",
  alt: ["Bia", "Yuki"],
  cc: ["BO"]
}, {
  pk: 7306,
  ang: "Yurok",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Yurok",
  lc: "yur",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 7307,
  ang: "Yopno",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yopno",
  lc: "yut",
  ld: "ltr",
  alt: ["Yupna"],
  cc: ["PG"]
}, {
  pk: 7308,
  ang: "Yau",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yau (Morobe Province)",
  lc: "yuw",
  ld: "ltr",
  alt: ["Uruwa"],
  cc: ["PG"]
}, {
  pk: 7309,
  ang: "Yukaghir, Southern",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "\u042E\u0436\u043D\u043E\u044E\u043A\u0430\u0433\u0438\u0440\u0441\u043A\u0438\u0439",
  lc: "yux",
  ld: "ltr",
  alt: ["Forest Yukagir", "Jukagir", "Kolym", "Kolyma", "Odul", "Southern Yukagir", "Yukagir"],
  cc: ["RU"]
}, {
  pk: 7310,
  ang: "Yugur, East",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4E1C\u90E8\u88D5\u56FA\u8BED",
  lc: "yuy",
  ld: "ltr",
  alt: ["Eastern Yogor", "Enge'er", "Enger", "Shera Yogur", "Shira Yugur", "Yogor", "Y\xF6gur", "Yugar", "Yugu"],
  cc: ["CN"]
}, {
  pk: 7311,
  ang: "Yuracare",
  lr: "Americas",
  gw: false,
  hc: "BO",
  ln: "Yuracare",
  lc: "yuz",
  ld: "ltr",
  alt: ["Yura"],
  cc: ["BO"]
}, {
  pk: 7312,
  ang: "Yawa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Yawa",
  lc: "yva",
  ld: "ltr",
  alt: ["Mantembu", "Mora", "Turu", "Unat", "Yapanani", "Yava", "Yawa Unat", "Central Yawa (Mora)"],
  cc: ["ID"]
}, {
  pk: 7313,
  ang: "Yavitero",
  lr: "Americas",
  gw: false,
  hc: "VE",
  ln: "Yavitero",
  lc: "yvt",
  ld: "ltr",
  alt: ["Paraene"],
  cc: ["VE"]
}, {
  pk: 7314,
  ang: "Kalou",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Kalou",
  lc: "ywa",
  ld: "ltr",
  alt: ["Yawa"],
  cc: ["PG"]
}, {
  pk: 7315,
  ang: "Yinhawangka",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yinhawangka",
  lc: "ywg",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 7316,
  ang: "Lalu, Western",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u814A\u7F57",
  lc: "ywl",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7317,
  ang: "Yawanawa",
  lr: "Americas",
  gw: false,
  hc: "BR",
  ln: "Yawanawa",
  lc: "ywn",
  ld: "ltr",
  alt: ["Iauanau\xE1", "Jawanaua", "Yahuanahua"],
  cc: ["BR"]
}, {
  pk: 7318,
  ang: "Yi, Wuding-Luquan",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6B66\u7984\u5F5D\u8BED",
  lc: "ywq",
  ld: "ltr",
  alt: ["Black Yi", "Dian Dongbei Yi", "Hei Yi", "Nasu", "Wu-Lu Yi"],
  cc: ["CN"]
}, {
  pk: 7645,
  ang: "Hong Yi",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Hong Yi",
  lc: "ywq-x-hongyi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7553,
  ang: "Nasunan Yi",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Nasunan Yi",
  lc: "ywq-x-nasunan",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7639,
  ang: "Tusi Yi",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Tusi Yi",
  lc: "ywq-x-tusiyi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7319,
  ang: "Yawuru",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yawuru",
  lc: "ywr",
  ld: "ltr",
  alt: ["Northern Yawuru", "Southern Coastal Yawuru", "Eastern Inland Yawuru"],
  cc: ["AU"]
}, {
  pk: 7320,
  ang: "Lalo, Central",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4E2D\u814A\u7F57\u8BED",
  lc: "ywt",
  ld: "ltr",
  alt: ["Lalo", "Lalopa", "Laluo", "Misapa", "Xishanba Lalo"],
  cc: ["CN"]
}, {
  pk: 8217,
  ang: "Datusi Yi",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Datusi Yi",
  lc: "ywt-x-datusiyi",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7321,
  ang: "Nasu, Wumeng",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4E4C\u8499\u7EB3\u82CF\u8BED",
  lc: "ywu",
  ld: "ltr",
  alt: ["Wumeng Yi", "Wusa Yi", "Yuan-Mo Yi", "Weining Yi", "Hen-Ke Yi"],
  cc: ["CN"]
}, {
  pk: 7322,
  ang: "Yardliyawarra",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yardliyawarra",
  lc: "yxl",
  ld: "ltr",
  alt: ["Aluri", "Alury", "Arabatura", "Arkabatura", "Jadliaura", "Jadlijawara", "Jadloori", "Yadliaura", "Yadlikowera", "Yadliura", "Yadliyawarra", "Yadlouri", "Yaldikowera", "Yardliwarra"],
  cc: ["AU"]
}, {
  pk: 7323,
  ang: "Yinwum",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yinwum",
  lc: "yxm",
  ld: "ltr",
  alt: ["Yeemwoom"],
  cc: ["AU"]
}, {
  pk: 7324,
  ang: "Yuyu",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yuyu",
  lc: "yxu",
  ld: "ltr",
  alt: ["Eramwir-rangu", "Eraweerung", "Erawiruck", "Jeraruk", "Jirau", "Juju", "Meru", "Pomp-malkie", "Rankbirit", "Willoo", "Wilu", "Yerraruck", "Yiran", "Yirau", "You-you"],
  cc: ["AU"]
}, {
  pk: 7325,
  ang: "Yir Yoront",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Yir Yoront",
  lc: "yyr",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 7326,
  ang: "Yau",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Yau (Sandaun Province)",
  lc: "yyu",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7327,
  ang: "Ayizi",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u963F\u5937\u5B50",
  lc: "yyz",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7328,
  ang: "Buyang, E\u2019ma",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5CE8\u9A6C\u5E03\u592E\u8BED",
  lc: "yzg",
  ld: "ltr",
  alt: ["Buozaang", "Buyang Zhuang", "Eastern Buyang", "Funing Buyang", "Langjia Buyang"],
  cc: ["CN"]
}, {
  pk: 7329,
  ang: "Zokhuo",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Zokhuo",
  lc: "yzk",
  ld: "ltr",
  alt: ["Cowtail Phula", "Nimitso", "Niuweiba Phula", "Phula", "Ruoke", "Tshokha", "Zekhe", "Zuoke", "Daxingzhai", "Longle"],
  cc: ["CN"]
}, {
  pk: 7330,
  ang: "Zhuang, Chuang",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Sa\u026F cue\u014B\u0185, Saw cuengh",
  lc: "za",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7331,
  ang: "Zapotec, Sierra de Ju\xE1rez",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Sierra de Ju\xE1rez Zapotec",
  lc: "zaa",
  ld: "ltr",
  alt: ["Ixtl\xE1n Zapoteco", "Zapoteco de Atepec", "Macuiltianguis Zapotec", "Atepec"],
  cc: ["MX"]
}, {
  pk: 7332,
  ang: "Zapotec, San Juan Guelav\xEDa",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "San Juan Guelav\xEDa Zapotec",
  lc: "zab",
  ld: "ltr",
  alt: ["Guelav\xEDa", "Western Tlacolula Zapotec", "Zapoteco de San Juan", "Teotitl\xE1n del Valle Zapotec", "San Mart\xEDn Tilcajete Zapotec", "San Lucas Quiavini Zapotec"],
  cc: ["MX", "US"]
}, {
  pk: 7333,
  ang: "Zapotec, Ocotl\xE1n",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Ocotl\xE1n Zapotec",
  lc: "zac",
  ld: "ltr",
  alt: ["Ocotl\xE1n Oeste Zapotec", "Zapoteco del Poniente de Ocotl\xE1n"],
  cc: ["MX"]
}, {
  pk: 7334,
  ang: "Zapotec, Cajonos",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Cajonos Zapotec",
  lc: "zad",
  ld: "ltr",
  alt: ["Southern Villa Alta Zapotec", "Yaganiza Zapotec", "Zapoteco de San Pedro Cajonos", "Cajonos Zapotec", "San Mateo Zapotec", "Xagac\xEDa Zapotec", "Yaganiza"],
  cc: ["MX"]
}, {
  pk: 7335,
  ang: "Zapotec, Yareni",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Yareni Zapotec",
  lc: "zae",
  ld: "ltr",
  alt: ["Etla Zapotec", "Western Ixtl\xE1n Zapotec", "Zapoteco de Santa Ana Yareni", "Zapoteco de Teococuilco de Marcos P\xE9rez"],
  cc: ["MX"]
}, {
  pk: 7336,
  ang: "Zapotec, Ayoquesco",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Ayoquesco Zapotec",
  lc: "zaf",
  ld: "ltr",
  alt: ["Western Ejutla Zapotec", "Zapoteco de Santa Mar\xEDa Ayoquesco"],
  cc: ["MX"]
}, {
  pk: 7337,
  ang: "Zaghawa",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Zaghawa",
  lc: "zag",
  ld: "ltr",
  alt: ["Beri", "Beri-Aa", "Berri", "Kebadi", "Kuyuk", "Merida", "Soghaua", "Zagaoua", "Zagawa", "Zauge", "Zeggaoua", "Zorhaua", "Beria", "Baele", "Wagi (Twer)", "Tuer-Gala (Anna)", "Tuba (Bideyat)", "Terawia", "Awe", "Kube"],
  cc: ["SD", "TD", "LY"]
}, {
  pk: 7338,
  ang: "Zangwal",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Zangwal",
  lc: "zah",
  ld: "ltr",
  alt: ["Twar", "Zwangal"],
  cc: ["NG"]
}, {
  pk: 7339,
  ang: "Zapotec, Isthmus",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Isthmus Zapotec",
  lc: "zai",
  ld: "ltr",
  alt: ["Zapoteco del Istmo"],
  cc: ["MX"]
}, {
  pk: 7340,
  ang: "Zaramo",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Zaramo",
  lc: "zaj",
  ld: "ltr",
  alt: ["Dzalamo", "Kizaramo", "Myagatwa", "Saramo", "Zalamo", "Zaramu"],
  cc: ["TZ"]
}, {
  pk: 7341,
  ang: "Zanaki",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Zanaki",
  lc: "zak",
  ld: "ltr",
  alt: ["Ekizanaki", "Ikizanaki", "Kizanaki"],
  cc: ["TZ"]
}, {
  pk: 7342,
  ang: "Zauzou",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u67D4\u82E5",
  lc: "zal",
  ld: "ltr",
  alt: ["Jaojo", "Raorou", "Rourou", "Wupijiang", "Bijilan"],
  cc: ["CN"]
}, {
  pk: 7343,
  ang: "Zapotec, Miahuatl\xE1n",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Miahuatl\xE1n Zapotec",
  lc: "zam",
  ld: "ltr",
  alt: ["Zapoteco de Miahuatl\xE1n"],
  cc: ["MX"]
}, {
  pk: 7344,
  ang: "Zapotec, Ozolotepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Ozolotepec Zapotec",
  lc: "zao",
  ld: "ltr",
  alt: ["Zapoteco de Ozolotepec", "San Marcial Ozolotepec Zapotec", "San Gregorio Ozolotepec Zapotec"],
  cc: ["MX"]
}, {
  pk: 7345,
  ang: "Zapotec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Zapotec",
  lc: "zap",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 7346,
  ang: "Zapotec, Alo\xE1pam",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Alo\xE1pam Zapotec",
  lc: "zaq",
  ld: "ltr",
  alt: ["Zapoteco de Alo\xE1pam"],
  cc: ["MX"]
}, {
  pk: 7347,
  ang: "Zapotec, Rinc\xF3n",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Rinc\xF3n Zapotec",
  lc: "zar",
  ld: "ltr",
  alt: ["Northern Villa Alta Zapotec", "Zapoteco de Yagallo", "Zapoteco del Rinc\xF3n"],
  cc: ["MX"]
}, {
  pk: 7348,
  ang: "Zapotec, Santo Domingo Albarradas",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Santo Domingo Albarradas Zapotec",
  lc: "zas",
  ld: "ltr",
  alt: ["Albarradas Zapotec", "Zapoteco de Santo Domingo Albarradas"],
  cc: ["MX"]
}, {
  pk: 7349,
  ang: "Zapotec, Tabaa",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tabaa Zapotec",
  lc: "zat",
  ld: "ltr",
  alt: ["Central Villa Alta Zapotec", "Zapoteco de Tabaa"],
  cc: ["MX"]
}, {
  pk: 7350,
  ang: "Zangskari",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Zangskari",
  lc: "zau",
  ld: "ltr",
  alt: ["Zanskari", "Zaskari"],
  cc: ["PK", "IN"]
}, {
  pk: 7351,
  ang: "Zapotec, Yatzachi",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Yatzachi Zapotec",
  lc: "zav",
  ld: "ltr",
  alt: ["Villa Alta Zapotec", "Zapoteco de Yatzachi"],
  cc: ["MX"]
}, {
  pk: 7352,
  ang: "Zapotec, Mitla",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Mitla Zapotec",
  lc: "zaw",
  ld: "ltr",
  alt: ["Didxsaj", "East Central Tlacolula Zapotec", "East Valley Zapotec", "Santiago Matatl\xE1n Zapotec (Matatl\xE1n Zapotec)"],
  cc: ["MX"]
}, {
  pk: 7353,
  ang: "Zapotec, Xadani",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Xadani Zapotec",
  lc: "zax",
  ld: "ltr",
  alt: ["Eastern Pochutla Zapotec", "Zapoteco de Santa Mar\xEDa Xadani"],
  cc: ["MX"]
}, {
  pk: 7354,
  ang: "Zaysete",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Zayse-Zergulla",
  lc: "zay",
  ld: "ltr",
  alt: ["Zaisse", "Zayse-Zergulla", "Zaysit\xE8", "Zaysse", "Zergula", "Zergulla (Zargulla)", "Zergullinya"],
  cc: ["ET"]
}, {
  pk: 7823,
  ang: "",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Zergulla",
  lc: "zay-x-zergulla",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7355,
  ang: "Zari",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Zari",
  lc: "zaz",
  ld: "ltr",
  alt: ["Zariwa", "Kwapm", "Zakshi (Zaksa)", "Boto (Bibot)", "Boot", "Zari (Kopti)"],
  cc: ["NG"]
}, {
  pk: 7356,
  ang: "Berawan, Central",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Central Berawan",
  lc: "zbc",
  ld: "ltr",
  alt: ["Long Teru", "Batu Belah Berawan", "Long Teru Berawan"],
  cc: ["MY"]
}, {
  pk: 7357,
  ang: "Berawan, East",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "East Berawan",
  lc: "zbe",
  ld: "ltr",
  alt: ["Long Jegan Berawan"],
  cc: ["MY"]
}, {
  pk: 7917,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Benawas",
  lc: "zbe-x-dayakbenawas",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7358,
  ang: "",
  lr: "",
  gw: false,
  hc: "",
  ln: "Blissymbols",
  lc: "zbl",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7359,
  ang: "Batui",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Batui",
  lc: "zbt",
  ld: "ltr",
  alt: ["Baha"],
  cc: ["ID"]
}, {
  pk: 7360,
  ang: "Berawan, West",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "West Berawan",
  lc: "zbw",
  ld: "ltr",
  alt: ["Berawan", "Long Terawan"],
  cc: ["MY"]
}, {
  pk: 7361,
  ang: "Zapotec, Coatecas Altas",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Coatecas Altas Zapotec",
  lc: "zca",
  ld: "ltr",
  alt: ["Zapoteco de San Juan Coatecas Altas"],
  cc: ["MX"]
}, {
  pk: 7362,
  ang: "Zhuang, Central Hongshuihe",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4E2D\u7D05\u6C34\u6CB3\u58EF\u8A9E",
  lc: "zch",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7363,
  ang: "Comorian, Ngazidja",
  lr: "Africa",
  gw: false,
  hc: "KM",
  ln: "Ngazidja Comorian",
  lc: "zdj",
  ld: "ltr",
  alt: ["Ngazidja", "Comores Swahili", "Comoro", "Komoro"],
  cc: ["KM", "SZ", "YT"]
}, {
  pk: 7364,
  ang: "Zeeuws",
  lr: "Europe",
  gw: false,
  hc: "NL",
  ln: "Zeeuws",
  lc: "zea",
  ld: "ltr",
  alt: ["Zeaws", "Fluplands", "Goerees", "Walchers", "Kezands", "Axels", "Duvelands", "Schouws", "Bevelands", "Flakkees"],
  cc: ["NL"]
}, {
  pk: 7365,
  ang: "Zenag",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Zenag",
  lc: "zeg",
  ld: "ltr",
  alt: ["Zenang", "Latep"],
  cc: ["PG"]
}, {
  pk: 7366,
  ang: "Zhuang, Eastern Hongshuihe",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u7EA2\u6C34\u6CB3",
  lc: "zeh",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7367,
  ang: "Zenaga",
  lr: "Africa",
  gw: false,
  hc: "MR",
  ln: "Zenaga",
  lc: "zen",
  ld: "ltr",
  alt: [],
  cc: ["MR"]
}, {
  pk: 7368,
  ang: "Kinga",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Kinga",
  lc: "zga",
  ld: "ltr",
  alt: ["Ekikinga", "Mahanji"],
  cc: ["TZ"]
}, {
  pk: 7369,
  ang: "Zhuang, Guibei",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6842\u5317",
  lc: "zgb",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7370,
  ang: "Tamazight, Standard Moroccan",
  lr: "Africa",
  gw: false,
  hc: "MA",
  ln: "\u2D5C\u2D30\u2D4E\u2D30\u2D63\u2D49\u2D56\u2D5C \u2D5C\u2D30\u2D4F\u2D30\u2D61\u2D30\u2D62\u2D5C",
  lc: "zgh",
  ld: "ltr",
  alt: ["Amazighe standard marocain"],
  cc: ["MA"]
}, {
  pk: 7371,
  ang: "Zhuang, Minz",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6C11\u8BB2",
  lc: "zgm",
  ld: "ltr",
  alt: ["Black Zhuang", "Bu Xiong", "Heiyi Zhuang", "Kon Min", "Sung", "Zong Zhuang", "Cuengh (Zong)", "Minz (Min)"],
  cc: ["CN"]
}, {
  pk: 7372,
  ang: "Zhuang, Guibian",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6842\u8FB9",
  lc: "zgn",
  ld: "ltr",
  alt: ["Buyei", "Buyoi", "Kang Yei", "Northern Zhuang"],
  cc: ["CN"]
}, {
  pk: 7373,
  ang: "Magori",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Magori",
  lc: "zgr",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7374,
  ang: "Chinese",
  lr: "Asia",
  gw: true,
  hc: "CN",
  ln: "\u4E2D\u6587 (Zh\u014Dngw\xE9n), \u6C49\u8BED, \u6F22\u8A9E",
  lc: "zh",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 8111,
  ang: "Chinese Oral Version",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Chinese Oral Version",
  lc: "zha-x-chineseoralversion",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7375,
  ang: "Zhaba",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u624E\u575D\u8BED",
  lc: "zhb",
  ld: "ltr",
  alt: ["Bazi", "Bozi", "Draba", "nDrapa", "Zaba", "Zha", "Drate (Zhaba/Northern nDrapa)", "Drame (Zhami/Southern nDrapa)"],
  cc: ["CN"]
}, {
  pk: 7376,
  ang: "Zhuang, Dai",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u6587\u9A6C",
  lc: "zhd",
  ld: "ltr",
  alt: ["Bu Dai", "Kau Ndae", "Khaau Daai", "Thu Lao", "Tu", "Tuliao", "Tuzu", "Wen-Ma Southern Zhuang", "Zhuangyu Nanbu fangyan Dejing tuyu", "Zhuangyu Nanbu Fangyan Wen-Ma Tuyu", "Central Wenshan (Ping Tou Tu)", "Guangnan (Pian Tou Tu)", "Maguan-Malipo (Jian Tou Tu)", "Western Yanshan-Northern Wenshan (Da Tou Tu)"],
  cc: ["CN"]
}, {
  pk: 7377,
  ang: "Zhire",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Zhire",
  lc: "zhi",
  ld: "ltr",
  alt: ["Kenyi"],
  cc: ["NG"]
}, {
  pk: 7378,
  ang: "Zhuang, Nong",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u781A\u5E7F",
  lc: "zhn",
  ld: "ltr",
  alt: ["Daez", "Kau Nong", "Khaau Nong", "Noangx", "Nong hua", "Phu Nong", "Phu Tei", "Yan-Guang Southern Zhuang", "Zhuangyu Nanbu fanyan Yan-Guang tuyu", "Liancheng", "Southern Zhuang", "Central Zhuang", "Western Guangnan"],
  cc: ["CN"]
}, {
  pk: 8117,
  ang: "Oral Chinese",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Oral Chinese",
  lc: "zho-x-chinoral",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 5,
  ang: "Traditional Chinese (Characters)",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u7E41\u9AD4\u4E2D\u6587",
  lc: "zh-tw",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7379,
  ang: "Zhoa",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Zhoa",
  lc: "zhw",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 7380,
  ang: "Zia",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Zia",
  lc: "zia",
  ld: "ltr",
  alt: ["Lower Waria", "Ziya"],
  cc: ["PG"]
}, {
  pk: 8347,
  ang: "Mawae Nage",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mawai Nage",
  lc: "zia-x-mawainage",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7381,
  ang: "Zimbabwe Sign Language",
  lr: "Africa",
  gw: false,
  hc: "ZW",
  ln: "Zimbabwe Sign Language",
  lc: "zib",
  ld: "ltr",
  alt: ["Zimsign"],
  cc: ["ZW"]
}, {
  pk: 7382,
  ang: "Zimakani",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Zimakani",
  lc: "zik",
  ld: "ltr",
  alt: ["Baegwa", "Bagwa Zimakani", "Bagwa (Begua)", "Mbegu"],
  cc: ["PG"]
}, {
  pk: 7383,
  ang: "Zialo",
  lr: "Africa",
  gw: false,
  hc: "GN",
  ln: "Zialo",
  lc: "zil",
  ld: "ltr",
  alt: ["Shialu", "Ziolo", "Ziyolo"],
  cc: ["GN"]
}, {
  pk: 7384,
  ang: "Mesme",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Mesme",
  lc: "zim",
  ld: "ltr",
  alt: ["Djime", "Djiwe", "Zime of K\xE9lo"],
  cc: ["TD"]
}, {
  pk: 7385,
  ang: "Zinza",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Zinza",
  lc: "zin",
  ld: "ltr",
  alt: ["Dzinda", "Dzindza", "Echidzindza", "Echijinja", "Ecizinza", "Jinja", "Kizinza", "Omuchizinza", "Zinja", "Kula", "Longo"],
  cc: ["TZ"]
}, {
  pk: 7386,
  ang: "Ziriya",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Ziriya",
  lc: "zir",
  ld: "ltr",
  alt: ["Jiriya"],
  cc: ["NG"]
}, {
  pk: 7387,
  ang: "Zigula",
  lr: "Africa",
  gw: false,
  hc: "TZ",
  ln: "Zigula",
  lc: "ziw",
  ld: "ltr",
  alt: ["Kizigula", "Seguha", "Wayombo", "Wazegua", "Zeguha", "Zegura", "Zigoua", "Zigwa"],
  cc: ["TZ"]
}, {
  pk: 7388,
  ang: "Zizilivakan",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Zizilivakan",
  lc: "ziz",
  ld: "ltr",
  alt: ["\xC0mz\xEDr\xEDv", "Fali of Jilbu", "Ziliva", "Ziziliveken", "Jilvu", "Zhilvu"],
  cc: ["CM", "NG"]
}, {
  pk: 7389,
  ang: "Kaimbulawa",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kaimbulawa",
  lc: "zka",
  ld: "ltr",
  alt: ["Kaimbulawa (Lontoi)"],
  cc: ["ID"]
}, {
  pk: 7390,
  ang: "Koibal",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "Koibal",
  lc: "zkb",
  ld: "ltr",
  alt: [],
  cc: ["RU"]
}, {
  pk: 7391,
  ang: "Kadu",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Kadu",
  lc: "zkd",
  ld: "ltr",
  alt: ["Gadu", "Ka'do", "Kadu-Ganaan", "Kantu'", "Kato", "Kudo", "Maw", "Puteik"],
  cc: ["MM"]
}, {
  pk: 7392,
  ang: "Koguryo",
  lr: "Asia",
  gw: false,
  hc: "KP",
  ln: "Koguryo",
  lc: "zkg",
  ld: "ltr",
  alt: [],
  cc: ["KP"]
}, {
  pk: 7393,
  ang: "Khorezmian",
  lr: "Asia",
  gw: false,
  hc: "MN",
  ln: "Khorezmian",
  lc: "zkh",
  ld: "ltr",
  alt: [],
  cc: ["MN"]
}, {
  pk: 7394,
  ang: "Karankawa",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Karankawa",
  lc: "zkk",
  ld: "ltr",
  alt: [],
  cc: ["US"]
}, {
  pk: 7395,
  ang: "Kanan",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Kanan",
  lc: "zkn",
  ld: "ltr",
  alt: ["Ganaan", "Ganan", "Ganon", "Genan", "Kana"],
  cc: ["MM"]
}, {
  pk: 7396,
  ang: "Kott",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "Kott",
  lc: "zko",
  ld: "ltr",
  alt: [],
  cc: ["RU"]
}, {
  pk: 7397,
  ang: "Zakhring",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Zakhring",
  lc: "zkr",
  ld: "ltr",
  alt: ["Zaiwa", "Zha", "Eastern Mishmi", "Meyor"],
  cc: ["CN"]
}, {
  pk: 7398,
  ang: "Kitan",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "Kitan",
  lc: "zkt",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7399,
  ang: "Kaurna",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Kaurna",
  lc: "zku",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 7400,
  ang: "Krevinian",
  lr: "Europe",
  gw: false,
  hc: "LV",
  ln: "Krevinian",
  lc: "zkv",
  ld: "ltr",
  alt: [],
  cc: ["LV"]
}, {
  pk: 7401,
  ang: "Khazar",
  lr: "Europe",
  gw: false,
  hc: "RU",
  ln: "Khazar",
  lc: "zkz",
  ld: "ltr",
  alt: [],
  cc: ["RU"]
}, {
  pk: 7402,
  ang: "Zhuang, Liujiang",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u67F3\u6C5F",
  lc: "zlj",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7403,
  ang: "Malay",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Malay (individual language)",
  lc: "zlm",
  ld: "ltr",
  alt: ["Bahasa Daerah", "Bahasa Melayu", "Malayu", "Bahasa Malayu", "Colloquial Malay", "Informal Malay", "Local Malay", "Southeast Island", "Riau Mainland", "S", "Sakai", "Tamiang", "Sanggau", "Kapuas Hulu", "Sarawak (Sarawak Malay)", "Sintang", "Riau islands (Sea Tribe dialects)", "Sekadau", "Pahang", "Orang Kuala", "Orang Hulu", "Northwestern Kalimantan", "Landak", "Jugra-Muar-Melaka-Johor", "Coastal Terengganu", "coastal Jambi", "Akit", "Lubu", "Riau islands"],
  cc: ["ID", "MY", "MM"]
}, {
  pk: 7544,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Akit",
  lc: "zlm-x-akit",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 8097,
  ang: "Datay",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Datay Malay",
  lc: "zlm-x-dataymalay",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7546,
  ang: "Deli",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Deli",
  lc: "zlm-x-deli",
  ld: "ltr",
  alt: [],
  cc: ["ID"]
}, {
  pk: 7993,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Kapuas Hulu",
  lc: "zlm-x-kapuashulu",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8183,
  ang: "Melayu Kendawangan",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Melayu Kendawangan",
  lc: "zlm-x-kendawangan",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8120,
  ang: "Coastal Malay",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Melayu Pesisir",
  lc: "zlm-x-melaypesisir",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7916,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Melayu Sambas",
  lc: "zlm-x-melayusambas",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8186,
  ang: "Dayak Perimping",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Dayak Perimping",
  lc: "zlm-x-perimping",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7907,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Melayu Pontianak",
  lc: "zlm-x-pontianak",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7701,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Sakai",
  lc: "zlm-x-sakai",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 8165,
  ang: "Melayu Sandai",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Melayu Sandai",
  lc: "zlm-x-sandai",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7847,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Kentungau Sintang",
  lc: "zlm-x-sintang",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7705,
  ang: "",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Tionghoa Kwek",
  lc: "zlm-x-tiong",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7404,
  ang: "Zhuang, Lianshan",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u8FDE\u5C71",
  lc: "zln",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7405,
  ang: "Zhuang, Liuqian",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u67F3\u9ED4\u58EF\u8A9E",
  lc: "zlq",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7406,
  ang: "Manda",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Manda (Australia)",
  lc: "zma",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 7407,
  ang: "Zimba",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Zimba",
  lc: "zmb",
  ld: "ltr",
  alt: ["Nyembombo", "Sole", "Semolo", "Mamba (Kyenyemamba)", "Binja (Soe)", "Semulu (Kisembombo)"],
  cc: ["MZ", "CD"]
}, {
  pk: 7408,
  ang: "Maridan",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Maridan",
  lc: "zmd",
  ld: "ltr",
  alt: ["Meradan"],
  cc: ["AU"]
}, {
  pk: 7409,
  ang: "Mfinu",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Mfinu",
  lc: "zmf",
  ld: "ltr",
  alt: ["Emfinu", "Funika", "Mfununga"],
  cc: ["CD"]
}, {
  pk: 7410,
  ang: "Marti Ke",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Marti Ke",
  lc: "zmg",
  ld: "ltr",
  alt: ["Magati Gair", "Magati-Ge", "Mati Ke"],
  cc: ["AU"]
}, {
  pk: 7411,
  ang: "Negeri Sembilan Malay",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Negeri Sembilan Malay",
  lc: "zmi",
  ld: "ltr",
  alt: ["Malaysian Minangkabau", "Ulu Muar Malay"],
  cc: ["MY"]
}, {
  pk: 7412,
  ang: "Maridjabin",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Maridjabin",
  lc: "zmj",
  ld: "ltr",
  alt: ["Maredyerbin", "Maretyabin", "Maridyerbin", "Maritjabin"],
  cc: ["AU"]
}, {
  pk: 7413,
  ang: "Madngele",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Madngele",
  lc: "zml",
  ld: "ltr",
  alt: ["Maangella", "Madngela", "Mandella", "Matngala", "Matngele", "Muttangulla", "Warat"],
  cc: ["AU"]
}, {
  pk: 7414,
  ang: "Marimanindji",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Marimanindji",
  lc: "zmm",
  ld: "ltr",
  alt: ["Maramanandji", "Maramarandji", "Marimanindu", "Marramaninjsji", "Murinmanindji"],
  cc: ["AU"]
}, {
  pk: 7415,
  ang: "Mbangwe",
  lr: "Africa",
  gw: false,
  hc: "GA",
  ln: "Mbangwe",
  lc: "zmn",
  ld: "ltr",
  alt: ["M'bahouin"],
  cc: ["GA", "CG"]
}, {
  pk: 7416,
  ang: "Molo",
  lr: "Africa",
  gw: false,
  hc: "SD",
  ln: "Molo",
  lc: "zmo",
  ld: "ltr",
  alt: ["Malkan"],
  cc: ["SD"]
}, {
  pk: 7417,
  ang: "Mpuono",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Mpuono",
  lc: "zmp",
  ld: "ltr",
  alt: ["Kimbuun", "Mbunda", "Mbuun", "Mpuun (Gimbunda)"],
  cc: ["CD"]
}, {
  pk: 7418,
  ang: "Mituku",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Mituku",
  lc: "zmq",
  ld: "ltr",
  alt: ["Kinya-Mituku", "Metoko"],
  cc: ["CD"]
}, {
  pk: 7419,
  ang: "Maranunggu",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Maranunggu",
  lc: "zmr",
  ld: "ltr",
  alt: ["Emmi", "Merranunggu", "Warrgat"],
  cc: ["AU"]
}, {
  pk: 7420,
  ang: "Mbesa",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Mbesa",
  lc: "zms",
  ld: "ltr",
  alt: ["Mobesa"],
  cc: ["CD"]
}, {
  pk: 7421,
  ang: "Maringarr",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Maringarr",
  lc: "zmt",
  ld: "ltr",
  alt: ["Marenggar", "Maringa", "Maranunggu (Maramanunggu)", "Marranunga", "Merranunggu", "Warrgat"],
  cc: ["AU"]
}, {
  pk: 7422,
  ang: "Mbo",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Mbo (Democratic Republic of Congo)",
  lc: "zmw",
  ld: "ltr",
  alt: ["Kimbo"],
  cc: ["CD"]
}, {
  pk: 7423,
  ang: "Bomitaba",
  lr: "Africa",
  gw: false,
  hc: "CG",
  ln: "Bomitaba",
  lc: "zmx",
  ld: "ltr",
  alt: ["Bamitaba", "Leke", "Mbomitaba", "Mbomotaba", "Central Bomitaba (Epena)", "Northern Bomitaba (Matoki)"],
  cc: ["CG"]
}, {
  pk: 7424,
  ang: "Mariyedi",
  lr: "Pacific",
  gw: false,
  hc: "AU",
  ln: "Mariyedi",
  lc: "zmy",
  ld: "ltr",
  alt: [],
  cc: ["AU"]
}, {
  pk: 7425,
  ang: "Mbandja",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Mbandja",
  lc: "zmz",
  ld: "ltr",
  alt: ["Mbandza", "Mbanja", "Mbanza", "Banja"],
  cc: ["CF", "CG", "CD"]
}, {
  pk: 7426,
  ang: "Zan Gula",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Zan Gula",
  lc: "zna",
  ld: "ltr",
  alt: ["Goula", "Gula Guera", "More", "Moriil", "Morre"],
  cc: ["TD"]
}, {
  pk: 7427,
  ang: "Zande",
  lr: "Africa",
  gw: false,
  hc: "CD",
  ln: "Zande (individual language)",
  lc: "zne",
  ld: "ltr",
  alt: ["Asande", "Azande", "Badjande", "Bazenda", "Pazande", "Sande", "Zandi", "Makaraka (Odio)"],
  cc: ["CF", "SS", "US", "CD"]
}, {
  pk: 7428,
  ang: "Mang",
  lr: "Asia",
  gw: false,
  hc: "VN",
  ln: "Mang",
  lc: "zng",
  ld: "ltr",
  alt: ["Ba'e", "Manbu", "Mang U", "Nieng \xD3", "X\xE1 L\xE1 V\xE0ng", "X\xE1 Mang", "X\xE1 \xD3", "Xamang", "L\xE1 V\xE0ng", "X\xE1"],
  cc: ["CN", "VN"]
}, {
  pk: 7429,
  ang: "Mangas",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Mangas",
  lc: "zns",
  ld: "ltr",
  alt: [],
  cc: ["NG"]
}, {
  pk: 7430,
  ang: "Zoque, Copainal\xE1",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Copainal\xE1 Zoque",
  lc: "zoc",
  ld: "ltr",
  alt: ["Zoque de Copainal\xE1"],
  cc: ["MX"]
}, {
  pk: 7431,
  ang: "Zoque, Chimalapa",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Chimalapa Zoque",
  lc: "zoh",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 7432,
  ang: "Zo",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Zou",
  lc: "zom",
  ld: "ltr",
  alt: ["Jou", "Zoh\xE2m", "Zokam", "Zoukamz", "Kuki Chin", "Yo", "Yos", "Yote", "Zau", "Zome", "Zomi"],
  cc: ["IN", "MM"]
}, {
  pk: 7433,
  ang: "Zapotec, Asunci\xF3n Mixtepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Asunci\xF3n Mixtepec Zapotec",
  lc: "zoo",
  ld: "ltr",
  alt: ["North Central Zimatlan Zapotec", "Zapoteco de Asunci\xF3n Mixtepec"],
  cc: ["MX"]
}, {
  pk: 7434,
  ang: "Zoque, Tabasco",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tabasco Zoque",
  lc: "zoq",
  ld: "ltr",
  alt: ["Ayapanec", "Zoque de Ayapanec", "Zoque de Tabasco"],
  cc: ["MX"]
}, {
  pk: 7435,
  ang: "Zoque, Ray\xF3n",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Ray\xF3n Zoque",
  lc: "zor",
  ld: "ltr",
  alt: ["Zoque de Ray\xF3n"],
  cc: ["MX"]
}, {
  pk: 7436,
  ang: "Zoque, Francisco Le\xF3n",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Francisco Le\xF3n Zoque",
  lc: "zos",
  ld: "ltr",
  alt: ["Santa Magdalena Zoque", "Zoque de Francisco Le\xF3n"],
  cc: ["MX"]
}, {
  pk: 7437,
  ang: "Zapotec, Lachiguiri",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Lachiguiri Zapotec",
  lc: "zpa",
  ld: "ltr",
  alt: ["Northwestern Tehuantepec Zapotec", "Zapoteco de Santiago Lachiguiri"],
  cc: ["MX"]
}, {
  pk: 7438,
  ang: "Zapotec, Yautepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Yautepec Zapotec",
  lc: "zpb",
  ld: "ltr",
  alt: ["Northwestern Yautepec Zapotec", "Zapoteco de San Bartolo Yautepec"],
  cc: ["MX"]
}, {
  pk: 7439,
  ang: "Zapotec, Choapan",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Choapan Zapotec",
  lc: "zpc",
  ld: "ltr",
  alt: ["Zapoteco de Choapan", "Zapoteco de San Juan Comaltepec"],
  cc: ["MX"]
}, {
  pk: 7440,
  ang: "Zapotec, Southeastern Ixtl\xE1n",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Southeastern Ixtl\xE1n Zapotec",
  lc: "zpd",
  ld: "ltr",
  alt: ["Latuvi Zapotec", "Yaves\xEDa Zapotec", "Zapoteco del Sureste de Ixtl\xE1n"],
  cc: ["MX"]
}, {
  pk: 7441,
  ang: "Zapotec, Petapa",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Petapa Zapotec",
  lc: "zpe",
  ld: "ltr",
  alt: ["Zapoteco de Santa Mar\xEDa Petapa"],
  cc: ["MX"]
}, {
  pk: 7442,
  ang: "Zapotec, San Pedro Quiatoni",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "San Pedro Quiatoni Zapotec",
  lc: "zpf",
  ld: "ltr",
  alt: ["Eastern Tlacolula Zapotec", "Quiatoni Zapotec", "Zapoteco de San Pedro Quiatoni"],
  cc: ["MX"]
}, {
  pk: 7443,
  ang: "Zapotec, Guevea de Humboldt",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Guevea De Humboldt Zapotec",
  lc: "zpg",
  ld: "ltr",
  alt: ["Northern Isthmus Zapotec", "Zapoteco de Guevea de Humboldt"],
  cc: ["MX"]
}, {
  pk: 7444,
  ang: "Zapotec, Totomachapan",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Totomachapan Zapotec",
  lc: "zph",
  ld: "ltr",
  alt: ["Western Zimatl\xE1n Zapotec", "Zapoteco de San Pedro Totomachapan"],
  cc: ["MX"]
}, {
  pk: 7445,
  ang: "Zapotec, Santa Mar\xEDa Quiegolani",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Santa Mar\xEDa Quiegolani Zapotec",
  lc: "zpi",
  ld: "ltr",
  alt: ["Quiegolani Zapotec", "Western Yautepec Zapotec", "Zapoteco de Santa Mar\xEDa Quiegolani"],
  cc: ["MX"]
}, {
  pk: 7446,
  ang: "Zapotec, Quiavicuzas",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Quiavicuzas Zapotec",
  lc: "zpj",
  ld: "ltr",
  alt: ["Northeastern Yautepec Zapotec", "Zapoteco de Quiavicuzas", "Zapoteco de San Juan Lachixila", "Zapoteco de San Juan Lachixila O"],
  cc: ["MX"]
}, {
  pk: 7447,
  ang: "Zapotec, Tlacolulita",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tlacolulita Zapotec",
  lc: "zpk",
  ld: "ltr",
  alt: ["Southeastern Yautepec Zapotec", "Zapoteco de Asunci\xF3n Tlacolulita"],
  cc: ["MX"]
}, {
  pk: 7448,
  ang: "Zapotec, Lachix\xEDo",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Lachix\xEDo Zapotec",
  lc: "zpl",
  ld: "ltr",
  alt: ["Dialu", "Eastern Sola de Vega Zapotec", "Zapoteco de Lachix\xEDo"],
  cc: ["MX"]
}, {
  pk: 7449,
  ang: "Zapotec, Mixtepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Mixtepec Zapotec",
  lc: "zpm",
  ld: "ltr",
  alt: ["Eastern Miahuatl\xE1n Zapotec", "Zapoteco de San Juan Mixtepec"],
  cc: ["MX"]
}, {
  pk: 7450,
  ang: "Zapotec, Santa In\xE9s Yatzechi",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Santa In\xE9s Yatzechi Zapotec",
  lc: "zpn",
  ld: "ltr",
  alt: ["Southeastern Zimatl\xE1n Zapotec", "Zapoteco de Santa In\xE9s Yatzechi", "Zapoteco de Zegache"],
  cc: ["MX"]
}, {
  pk: 7451,
  ang: "Zapotec, Amatl\xE1n",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Amatl\xE1n Zapotec",
  lc: "zpo",
  ld: "ltr",
  alt: ["Dizhze", "Zapoteco de San Crist\xF3bal Amatl\xE1n", "Zapoteco del Noreste de Miahuatl\xE1n", "San Crist\xF3bal Amatl\xE1n", "San Francisco Logueche"],
  cc: ["MX"]
}, {
  pk: 7452,
  ang: "Zapotec, El Alto",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "El Alto Zapotec",
  lc: "zpp",
  ld: "ltr",
  alt: ["South Central Zimatlan Zapotec", "Zapoteco de San Pedro el Alto"],
  cc: ["MX"]
}, {
  pk: 7453,
  ang: "Zapotec, Zoogocho",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Zoogocho Zapotec",
  lc: "zpq",
  ld: "ltr",
  alt: ["Zapoteco de San Bartolom\xE9 Zoogocho"],
  cc: ["MX"]
}, {
  pk: 7454,
  ang: "Zapotec, Santiago Xanica",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Santiago Xanica Zapotec",
  lc: "zpr",
  ld: "ltr",
  alt: ["Xanica Zapotec"],
  cc: ["MX"]
}, {
  pk: 7455,
  ang: "Zapotec, Coatl\xE1n",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Coatl\xE1n Zapotec",
  lc: "zps",
  ld: "ltr",
  alt: ["San Miguel Zapotec", "Western Miahuatl\xE1n Zapotec", "Zapoteco de Santa Mar\xEDa Coatl\xE1n"],
  cc: ["MX"]
}, {
  pk: 7456,
  ang: "Zapotec, San Vicente Coatl\xE1n",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "San Vicente Coatl\xE1n Zapotec",
  lc: "zpt",
  ld: "ltr",
  alt: ["Coatl\xE1n Zapotec", "Southern Ejutla Zapotec", "Zapoteco de San Vicente Coatl\xE1n"],
  cc: ["MX"]
}, {
  pk: 7457,
  ang: "Zapotec, Yal\xE1lag",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Yal\xE1lag Zapotec",
  lc: "zpu",
  ld: "ltr",
  alt: ["Zapoteco de Yal\xE1lag"],
  cc: ["MX"]
}, {
  pk: 7458,
  ang: "Zapotec, Chichicapan",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Chichicapan Zapotec",
  lc: "zpv",
  ld: "ltr",
  alt: ["Eastern Ocotl\xE1n Zapotec", "Zapoteco de San Baltazar Chichicapan"],
  cc: ["MX"]
}, {
  pk: 7459,
  ang: "Zapotec, Zaniza",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Zaniza Zapotec",
  lc: "zpw",
  ld: "ltr",
  alt: ["Papabuco", "Western Sola de Vega Zapotec", "Zapoteco de Santa Mar\xEDa Zaniza"],
  cc: ["MX"]
}, {
  pk: 7460,
  ang: "Zapotec, San Baltazar Loxicha",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "San Baltazar Loxicha Zapotec",
  lc: "zpx",
  ld: "ltr",
  alt: ["Northwestern Pochutla Zapotec", "San Balt\xE1zar Loxicha Zapotec", "Zapoteco de San Balt\xE1zar Loxicha"],
  cc: ["MX"]
}, {
  pk: 7461,
  ang: "Zapotec, Mazaltepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Mazaltepec Zapotec",
  lc: "zpy",
  ld: "ltr",
  alt: ["Etla Zapotec", "Zapoteco de Santo Tom\xE1s Mazaltepec"],
  cc: ["MX"]
}, {
  pk: 7462,
  ang: "Zapotec, Texmelucan",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Texmelucan Zapotec",
  lc: "zpz",
  ld: "ltr",
  alt: ["Central Sola de Vega Zapotec", "Papabuco", "Zapoteco de San Lorenzo Texmelucan"],
  cc: ["MX"]
}, {
  pk: 7463,
  ang: "Zhuang, Qiubei",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u4E18\u5317",
  lc: "zqe",
  ld: "ltr",
  alt: ["Bau i", "Bui", "Buyi", "Northern Zhuang", "Qiubei Sha"],
  cc: ["CN"]
}, {
  pk: 7464,
  ang: "Kara",
  lr: "Asia",
  gw: false,
  hc: "KR",
  ln: "Kara (Korea)",
  lc: "zra",
  ld: "ltr",
  alt: [],
  cc: ["KR"]
}, {
  pk: 7465,
  ang: "Mirgan",
  lr: "Asia",
  gw: false,
  hc: "IN",
  ln: "Mirgan",
  lc: "zrg",
  ld: "ltr",
  alt: ["Mirgami", "Mirkan", "Panika", "Panka", "Batasuna", "Jagdal Pur", "Kosagumuda", "Kotpad", "Nabarang Pur", "Umerkote"],
  cc: ["IN"]
}, {
  pk: 7466,
  ang: "Zerenkel",
  lr: "Africa",
  gw: false,
  hc: "TD",
  ln: "Zerenkel",
  lc: "zrn",
  ld: "ltr",
  alt: [],
  cc: ["TD"]
}, {
  pk: 7467,
  ang: "Z\xE1paro",
  lr: "Americas",
  gw: false,
  hc: "EC",
  ln: "Z\xE1paro",
  lc: "zro",
  ld: "ltr",
  alt: ["Kayapwe", "S\xE1para", "Z\xE1para"],
  cc: ["EC"]
}, {
  pk: 7468,
  ang: "Mairasi",
  lr: "Asia",
  gw: false,
  hc: "ID",
  ln: "Mairasi",
  lc: "zrs",
  ld: "ltr",
  alt: ["Faranyao", "Kaniran"],
  cc: ["ID"]
}, {
  pk: 7469,
  ang: "Sarasira",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sarasira",
  lc: "zsa",
  ld: "ltr",
  alt: ["Sirasira"],
  cc: ["PG"]
}, {
  pk: 7470,
  ang: "Kaskean",
  lr: "Asia",
  gw: false,
  hc: "TR",
  ln: "Kaskean",
  lc: "zsk",
  ld: "ltr",
  alt: [],
  cc: ["TR"]
}, {
  pk: 7471,
  ang: "Zambian Sign Language",
  lr: "Africa",
  gw: false,
  hc: "ZM",
  ln: "Zambian Sign Language",
  lc: "zsl",
  ld: "ltr",
  alt: [],
  cc: ["ZM"]
}, {
  pk: 7472,
  ang: "Malay, Standard",
  lr: "Asia",
  gw: false,
  hc: "MY",
  ln: "Standard Malay",
  lc: "zsm",
  ld: "ltr",
  alt: ["Formal Malay", "Malayu", "Melayu", "Melayu Baku", "Bahasa Malayu", "Informal Malay"],
  cc: ["KM", "ID", "GB", "MY", "US", "AU", "CA", "SG", "YT"]
}, {
  pk: 7473,
  ang: "Zapotec, Southern Rincon",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Southern Rincon Zapotec",
  lc: "zsr",
  ld: "ltr",
  alt: ["Zapoteco de Rinc\xF3n Sur"],
  cc: ["MX"]
}, {
  pk: 7474,
  ang: "Sukurum",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Sukurum",
  lc: "zsu",
  ld: "ltr",
  alt: [],
  cc: ["PG"]
}, {
  pk: 7475,
  ang: "Zapotec, Elotepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Elotepec Zapotec",
  lc: "zte",
  ld: "ltr",
  alt: ["Papabuco", "Zapoteco de San Juan Elotepec"],
  cc: ["MX"]
}, {
  pk: 7476,
  ang: "Zapotec, Xanagu\xEDa",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Xanagu\xEDa Zapotec",
  lc: "ztg",
  ld: "ltr",
  alt: ["Diidz Z\xEB", "Zapoteco de Santa Catarina Xanagu\xEDa"],
  cc: ["MX"]
}, {
  pk: 7477,
  ang: "Zapotec, Lapagu\xEDa-Guivini",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Lapagu\xEDa-Guivini Zapotec",
  lc: "ztl",
  ld: "ltr",
  alt: ["Santiago Lapaguia Zapotec", "Zapoteco de Lapagu\xEDa-Guivini", "Zapoteco de Santiago Lapagu\xEDa", "Guivini", "Lapagu\xEDa"],
  cc: ["MX"]
}, {
  pk: 7478,
  ang: "Zapotec, San Agust\xEDn Mixtepec",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "San Agust\xEDn Mixtepec Zapotec",
  lc: "ztm",
  ld: "ltr",
  alt: [],
  cc: ["MX"]
}, {
  pk: 7479,
  ang: "Zapotec, Santa Catarina Albarradas",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Santa Catarina Albarradas Zapotec",
  lc: "ztn",
  ld: "ltr",
  alt: ["Zapoteco de Santa Catarina Albarradas"],
  cc: ["MX"]
}, {
  pk: 7480,
  ang: "Zapotec, Loxicha",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Loxicha Zapotec",
  lc: "ztp",
  ld: "ltr",
  alt: ["Diste", "Western Pochutla Zapotec", "Zapoteco de Loxicha", "San Bartolom\xE9 Loxicha", "and San Miguel Suchixtepec", "San Agust\xEDn Loxicha", "San Andr\xE9s Paxtl\xE1n"],
  cc: ["MX"]
}, {
  pk: 7481,
  ang: "Zapotec, Quioquitani-Quier\xED",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Quioquitani-Quier\xED Zapotec",
  lc: "ztq",
  ld: "ltr",
  alt: ["Zapoteco de Quioquitani y Quier\xED"],
  cc: ["MX"]
}, {
  pk: 7482,
  ang: "Zapotec, Tilquiapan",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tilquiapan Zapotec",
  lc: "zts",
  ld: "ltr",
  alt: ["Zapoteco de San Miguel Tilquiapan"],
  cc: ["MX"]
}, {
  pk: 7483,
  ang: "Zapotec, Tejalapan",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Tejalapan Zapotec",
  lc: "ztt",
  ld: "ltr",
  alt: ["Zapoteco de San Felipe Tejalapan", "Zapoteco de Tejal\xE1pam"],
  cc: ["MX"]
}, {
  pk: 7484,
  ang: "Zapotec, G\xFCil\xE1",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "G\xFCil\xE1 Zapotec",
  lc: "ztu",
  ld: "ltr",
  alt: ["Zapoteco de San Dionisio Ocotepec", "Zapoteco de San Pablo G\xFCil\xE1"],
  cc: ["MX"]
}, {
  pk: 7485,
  ang: "Zapotec, Zaachila",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Zaachila Zapotec",
  lc: "ztx",
  ld: "ltr",
  alt: ["San Raymundo Jalpan Zapotec"],
  cc: ["MX"]
}, {
  pk: 7486,
  ang: "Zapotec, Yatee",
  lr: "Americas",
  gw: false,
  hc: "MX",
  ln: "Yatee Zapotec",
  lc: "zty",
  ld: "ltr",
  alt: ["Zapoteco de Yatee", "Yatee Zapotec (Zapoteco de Yatee)", "Lachirioag Zapotec (Lachiruaj Zapotec)", "San Crist\xF3bal Lachiruaj Zapotec"],
  cc: ["MX"]
}, {
  pk: 7487,
  ang: "Zulu",
  lr: "Africa",
  gw: false,
  hc: "ZA",
  ln: "isiZulu",
  lc: "zu",
  ld: "ltr",
  alt: ["Isizulu", "Kingoni", "Ngoni", "Zunda"],
  cc: ["MZ", "ZA", "ZW", "LS", "SZ", "BW"]
}, {
  pk: 7488,
  ang: "Zeem",
  lr: "Africa",
  gw: false,
  hc: "NG",
  ln: "Zeem",
  lc: "zua",
  ld: "ltr",
  alt: ["Chaari", "Dyarum (Kaiwari)", "Kaiyorawa", "Lushi (Dokshi)", "Tulai"],
  cc: ["NG"]
}, {
  pk: 7489,
  ang: "Tokano",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Tokano",
  lc: "zuh",
  ld: "ltr",
  alt: ["Gamuso", "Tokama", "Yufiyufa", "Zaka", "Zuhozuho"],
  cc: ["PG"]
}, {
  pk: 8489,
  ang: "Mando Ifiyufa",
  lr: "Pacific",
  gw: false,
  hc: "PG",
  ln: "Mando Ifiyufa",
  lc: "zuh-x-ifiyufa",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7490,
  ang: "Kumzari",
  lr: "Asia",
  gw: false,
  hc: "OM",
  ln: "\u06A9\u0645\u0632\u0627\u0631\u06CC",
  lc: "zum",
  ld: "ltr",
  alt: ["Kumzai"],
  cc: ["OM"]
}, {
  pk: 7491,
  ang: "Zuni",
  lr: "Americas",
  gw: false,
  hc: "US",
  ln: "Zuni",
  lc: "zun",
  ld: "ltr",
  alt: ["Zu\xF1i"],
  cc: ["US"]
}, {
  pk: 7492,
  ang: "Zumaya",
  lr: "Africa",
  gw: false,
  hc: "CM",
  ln: "Zumaya",
  lc: "zuy",
  ld: "ltr",
  alt: [],
  cc: ["CM"]
}, {
  pk: 7493,
  ang: "Zay",
  lr: "Africa",
  gw: false,
  hc: "ET",
  ln: "Zay",
  lc: "zwa",
  ld: "ltr",
  alt: ["Gelilla", "Lak'i", "Zway"],
  cc: ["ET"]
}, {
  pk: 7494,
  ang: "",
  lr: "",
  gw: false,
  hc: "",
  ln: "No linguistic content",
  lc: "zxx",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7495,
  ang: "Zhuang, Yongbei",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u9095\u5317",
  lc: "zyb",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7496,
  ang: "Zhuang, Yang",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5F97\u9756",
  lc: "zyg",
  ld: "ltr",
  alt: ["De-Jing Vernacular of the Southern Dialect of the Zhuang Language", "Dejing Zhuang", "Gen Yang", "Jingxi Zhuang", "Lang", "Nong", "Nung Giang", "Tianbao", "Tuhua", "Yangyu", "Yangzhou", "Zhuangyu Nanbu fangyan Dejing tuyu", "Thu Lao", "Tu", "Tuliao", "Tuzu", "Wen-Ma Southern Zhuang", "Zouzhou", "Caj coux (Jiazhou)", "Fouh (Fu)", "Sengh (Sheng)", "Tianbao (Dianbao)", "Tianpao", "Yang (Tuhua)"],
  cc: ["CN"]
}, {
  pk: 7497,
  ang: "Zhuang, Youjiang",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u53F3\u6C5F",
  lc: "zyj",
  ld: "ltr",
  alt: [],
  cc: ["CN"]
}, {
  pk: 7498,
  ang: "Zhuang, Yongnan",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u9095\u5357",
  lc: "zyn",
  ld: "ltr",
  alt: ["Bou Rau", "Long An", "Long'an", "Nung An", "Southern Zhuang", "Yongnan Vernacular of the Southern Dialect of the Zhuang Language", "Zhuangyu nanbu fangyan Yongnan tuyu", "The Yongnan Vernacular of the Southern Dialect of the Zhuang Language"],
  cc: ["CN"]
}, {
  pk: 7499,
  ang: "Chin, Zyphe",
  lr: "Asia",
  gw: false,
  hc: "MM",
  ln: "Zyphe Chin",
  lc: "zyp",
  ld: "ltr",
  alt: ["Vawngtu", "Zophei", "Zoptei", "Zyphe", "Zo-pe"],
  cc: ["MM"]
}, {
  pk: 7500,
  ang: "",
  lr: "",
  gw: false,
  hc: "",
  ln: "Zaza",
  lc: "zza",
  ld: "ltr",
  alt: [],
  cc: []
}, {
  pk: 7501,
  ang: "Zhuang, Zuojiang",
  lr: "Asia",
  gw: false,
  hc: "CN",
  ln: "\u5DE6\u6C5F",
  lc: "zzj",
  ld: "ltr",
  alt: ["Ken Tho", "Longyin", "Longzhou", "Pho Thai", "Pu Tho", "Southern Zhuang", "Zhuangyu nanbu fangyan Zuojiang tuyu", "Nung Chao"],
  cc: ["CN"]
}];
cov_18skq7nj67.s[0]++;

var getLanguage = function getLanguage(_ref) {
  var languageId = _ref.languageId;
  cov_18skq7nj67.f[0]++;
  var language;
  var langname = (cov_18skq7nj67.s[1]++, langnames.filter(function (object) {
    cov_18skq7nj67.f[1]++;
    cov_18skq7nj67.s[2]++;
    return object.lc === languageId;
  })[0]);
  cov_18skq7nj67.s[3]++;

  if (langname) {
    cov_18skq7nj67.b[0][0]++;
    cov_18skq7nj67.s[4]++;
    language = {
      id: langname.pk,
      languageName: langname.ang,
      region: langname.lr,
      gateway: langname.gw,
      country: langname.hc,
      localized: langname.ln,
      languageId: langname.lc,
      direction: langname.ld,
      aliases: langname.alt,
      countries: langname.cc
    };
  } else {
    cov_18skq7nj67.b[0][1]++;
  }

  cov_18skq7nj67.s[5]++;
  return language;
};

exports.getLanguage = getLanguage;
cov_18skq7nj67.s[6]++;

var getLanguageName = function getLanguageName(_ref2) {
  var languageId = _ref2.languageId;
  cov_18skq7nj67.f[2]++;
  var language = (cov_18skq7nj67.s[7]++, getLanguage({
    languageId: languageId
  }));
  var languageName = (cov_18skq7nj67.s[8]++, language ? (cov_18skq7nj67.b[1][0]++, language.ln) : (cov_18skq7nj67.b[1][1]++, null));
  cov_18skq7nj67.s[9]++;
  return languageName;
};

exports.getLanguageName = getLanguageName;